import { computed as Or, openBlock as Dn, createElementBlock as ir, normalizeStyle as Bd, unref as Mt, toDisplayString as Eo, withDirectives as Hf, createElementVNode as Rt, normalizeClass as Hr, withModifiers as Ro, renderSlot as Cu, vShow as Dd, watch as Wi, ref as ja, reactive as Um, resolveComponent as h1, createBlock as Mo, withCtx as ka, createVNode as Ja, mergeProps as BC, pushScopeId as NC, popScopeId as IC, onMounted as Xc, Fragment as Is, createCommentVNode as ba, createTextVNode as Zu, renderList as ak, readonly as UX, getCurrentScope as jX, onScopeDispose as vV, getCurrentInstance as Pp, nextTick as Vl, defineComponent as _o, warn as WX, watchEffect as qX, onBeforeUnmount as lk, inject as Rd, isRef as aR, shallowRef as WB, provide as Y9, toRef as ZB, onUnmounted as GX, useAttrs as KX, useSlots as Z9, resolveDynamicComponent as Od, Transition as oR, Text as XX, h as R9, Teleport as YX, shallowReactive as ZX, isVNode as iR, render as JB, toRefs as dV, withKeys as FB, vModelText as tH, onActivated as JX, onDeactivated as QX } from "vue";
const Md = (m, y) => {
  const w = m.__vccOpts || m;
  for (const [E, P] of y)
    w[E] = P;
  return w;
}, eY = {
  __name: "btn",
  props: {
    btnWidth: {
      type: String,
      default: "auto"
    },
    txt: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      default: "#fff"
    },
    btnColor: {
      type: String,
      default: "#00C4A1"
    },
    borderWidth: {
      type: String,
      default: "1px"
    },
    borderStyle: {
      type: String,
      default: "solid"
    },
    borderColor: {
      type: String,
      default: "#00C4A1"
    },
    btnMargin: {
      type: String,
      default: "0"
    },
    btnPadding: {
      type: String,
      default: "0"
    }
  },
  emits: ["btnCallback"],
  setup(m, { emit: y }) {
    const w = m, E = () => {
      y("btnCallback");
    }, P = Or(() => ({
      width: w.btnWidth,
      color: w.color,
      backgroundColor: w.btnColor,
      borderWidth: w.borderWidth,
      borderStyle: w.borderStyle,
      borderColor: w.borderColor,
      margin: w.btnMargin,
      padding: w.btnPadding
    }));
    return (H, X) => (Dn(), ir("div", {
      class: "primary_btn",
      style: Bd(Mt(P)),
      onClick: E
    }, Eo(m.txt), 5));
  }
}, Qb = /* @__PURE__ */ Md(eY, [["__scopeId", "data-v-06f9f76f"]]);
const tY = { class: "dialog" }, nY = ["onClick"], rY = { class: "cont" }, aY = {
  __name: "tDialog",
  props: {
    isCrop: {
      type: Boolean,
      default: !1
    },
    isShow: {
      type: Boolean,
      default: !0
    },
    fixHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close"],
  setup(m, { emit: y }) {
    const w = m, E = () => {
      y("close");
    };
    return (P, H) => Hf((Dn(), ir("div", tY, [
      Rt("div", {
        class: Hr(["content", { fix: w.fixHeight }, { normal: !w.fixHeight }, { isCrop: w.isCrop }])
      }, [
        Rt("i", {
          class: "close",
          onClick: Ro(E, ["stop"])
        }, null, 8, nY),
        Rt("div", rY, [
          Cu(P.$slots, "title", {}, void 0, !0),
          Rt("div", {
            class: Hr(["inner", { fix: w.fixHeight }])
          }, [
            Cu(P.$slots, "content", {}, void 0, !0),
            Cu(P.$slots, "btn_list", {}, void 0, !0)
          ], 2)
        ])
      ], 2)
    ], 512)), [
      [Dd, w.isShow]
    ]);
  }
}, y5 = /* @__PURE__ */ Md(aY, [["__scopeId", "data-v-b633146b"]]);
/*! js-cookie v3.0.1 | MIT */
function $B(m) {
  for (var y = 1; y < arguments.length; y++) {
    var w = arguments[y];
    for (var E in w)
      m[E] = w[E];
  }
  return m;
}
var oY = {
  read: function(m) {
    return m[0] === '"' && (m = m.slice(1, -1)), m.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(m) {
    return encodeURIComponent(m).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function M9(m, y) {
  function w(P, H, X) {
    if (!(typeof document > "u")) {
      X = $B({}, y, X), typeof X.expires == "number" && (X.expires = new Date(Date.now() + X.expires * 864e5)), X.expires && (X.expires = X.expires.toUTCString()), P = encodeURIComponent(P).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var j = "";
      for (var le in X)
        !X[le] || (j += "; " + le, X[le] !== !0 && (j += "=" + X[le].split(";")[0]));
      return document.cookie = P + "=" + m.write(H, P) + j;
    }
  }
  function E(P) {
    if (!(typeof document > "u" || arguments.length && !P)) {
      for (var H = document.cookie ? document.cookie.split("; ") : [], X = {}, j = 0; j < H.length; j++) {
        var le = H[j].split("="), Q = le.slice(1).join("=");
        try {
          var pe = decodeURIComponent(le[0]);
          if (X[pe] = m.read(Q, pe), P === pe)
            break;
        } catch {
        }
      }
      return P ? X[P] : X;
    }
  }
  return Object.create(
    {
      set: w,
      get: E,
      remove: function(P, H) {
        w(
          P,
          "",
          $B({}, H, {
            expires: -1
          })
        );
      },
      withAttributes: function(P) {
        return M9(this.converter, $B({}, this.attributes, P));
      },
      withConverter: function(P) {
        return M9($B({}, this.converter, P), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(y) },
      converter: { value: Object.freeze(m) }
    }
  );
}
var b1 = M9(oY, { path: "/" }), QB = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function iY(m) {
  return m && m.__esModule && Object.prototype.hasOwnProperty.call(m, "default") ? m.default : m;
}
var mV = { exports: {} }, J9 = { exports: {} }, gV = function(y, w) {
  return function() {
    for (var P = new Array(arguments.length), H = 0; H < P.length; H++)
      P[H] = arguments[H];
    return y.apply(w, P);
  };
}, uY = gV, FC = Object.prototype.toString;
function Q9(m) {
  return FC.call(m) === "[object Array]";
}
function P9(m) {
  return typeof m > "u";
}
function sY(m) {
  return m !== null && !P9(m) && m.constructor !== null && !P9(m.constructor) && typeof m.constructor.isBuffer == "function" && m.constructor.isBuffer(m);
}
function lY(m) {
  return FC.call(m) === "[object ArrayBuffer]";
}
function cY(m) {
  return typeof FormData < "u" && m instanceof FormData;
}
function fY(m) {
  var y;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? y = ArrayBuffer.isView(m) : y = m && m.buffer && m.buffer instanceof ArrayBuffer, y;
}
function vY(m) {
  return typeof m == "string";
}
function dY(m) {
  return typeof m == "number";
}
function pV(m) {
  return m !== null && typeof m == "object";
}
function qB(m) {
  if (FC.call(m) !== "[object Object]")
    return !1;
  var y = Object.getPrototypeOf(m);
  return y === null || y === Object.prototype;
}
function mY(m) {
  return FC.call(m) === "[object Date]";
}
function gY(m) {
  return FC.call(m) === "[object File]";
}
function pY(m) {
  return FC.call(m) === "[object Blob]";
}
function hV(m) {
  return FC.call(m) === "[object Function]";
}
function hY(m) {
  return pV(m) && hV(m.pipe);
}
function bY(m) {
  return typeof URLSearchParams < "u" && m instanceof URLSearchParams;
}
function yY(m) {
  return m.replace(/^\s*/, "").replace(/\s*$/, "");
}
function wY() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function eL(m, y) {
  if (!(m === null || typeof m > "u"))
    if (typeof m != "object" && (m = [m]), Q9(m))
      for (var w = 0, E = m.length; w < E; w++)
        y.call(null, m[w], w, m);
    else
      for (var P in m)
        Object.prototype.hasOwnProperty.call(m, P) && y.call(null, m[P], P, m);
}
function N9() {
  var m = {};
  function y(P, H) {
    qB(m[H]) && qB(P) ? m[H] = N9(m[H], P) : qB(P) ? m[H] = N9({}, P) : Q9(P) ? m[H] = P.slice() : m[H] = P;
  }
  for (var w = 0, E = arguments.length; w < E; w++)
    eL(arguments[w], y);
  return m;
}
function CY(m, y, w) {
  return eL(y, function(P, H) {
    w && typeof P == "function" ? m[H] = uY(P, w) : m[H] = P;
  }), m;
}
function SY(m) {
  return m.charCodeAt(0) === 65279 && (m = m.slice(1)), m;
}
var Pv = {
  isArray: Q9,
  isArrayBuffer: lY,
  isBuffer: sY,
  isFormData: cY,
  isArrayBufferView: fY,
  isString: vY,
  isNumber: dY,
  isObject: pV,
  isPlainObject: qB,
  isUndefined: P9,
  isDate: mY,
  isFile: gY,
  isBlob: pY,
  isFunction: hV,
  isStream: hY,
  isURLSearchParams: bY,
  isStandardBrowserEnv: wY,
  forEach: eL,
  merge: N9,
  extend: CY,
  trim: yY,
  stripBOM: SY
}, ek = Pv;
function nH(m) {
  return encodeURIComponent(m).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var bV = function(y, w, E) {
  if (!w)
    return y;
  var P;
  if (E)
    P = E(w);
  else if (ek.isURLSearchParams(w))
    P = w.toString();
  else {
    var H = [];
    ek.forEach(w, function(le, Q) {
      le === null || typeof le > "u" || (ek.isArray(le) ? Q = Q + "[]" : le = [le], ek.forEach(le, function(Y) {
        ek.isDate(Y) ? Y = Y.toISOString() : ek.isObject(Y) && (Y = JSON.stringify(Y)), H.push(nH(Q) + "=" + nH(Y));
      }));
    }), P = H.join("&");
  }
  if (P) {
    var X = y.indexOf("#");
    X !== -1 && (y = y.slice(0, X)), y += (y.indexOf("?") === -1 ? "?" : "&") + P;
  }
  return y;
}, xY = Pv;
function uR() {
  this.handlers = [];
}
uR.prototype.use = function(y, w) {
  return this.handlers.push({
    fulfilled: y,
    rejected: w
  }), this.handlers.length - 1;
};
uR.prototype.eject = function(y) {
  this.handlers[y] && (this.handlers[y] = null);
};
uR.prototype.forEach = function(y) {
  xY.forEach(this.handlers, function(E) {
    E !== null && y(E);
  });
};
var kY = uR, TY = Pv, EY = function(y, w, E) {
  return TY.forEach(E, function(H) {
    y = H(y, w);
  }), y;
}, u9, rH;
function yV() {
  return rH || (rH = 1, u9 = function(y) {
    return !!(y && y.__CANCEL__);
  }), u9;
}
var _Y = Pv, AY = function(y, w) {
  _Y.forEach(y, function(P, H) {
    H !== w && H.toUpperCase() === w.toUpperCase() && (y[w] = P, delete y[H]);
  });
}, s9, aH;
function OY() {
  return aH || (aH = 1, s9 = function(y, w, E, P, H) {
    return y.config = w, E && (y.code = E), y.request = P, y.response = H, y.isAxiosError = !0, y.toJSON = function() {
      return {
        message: this.message,
        name: this.name,
        description: this.description,
        number: this.number,
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        config: this.config,
        code: this.code
      };
    }, y;
  }), s9;
}
var l9, oH;
function wV() {
  if (oH)
    return l9;
  oH = 1;
  var m = OY();
  return l9 = function(w, E, P, H, X) {
    var j = new Error(w);
    return m(j, E, P, H, X);
  }, l9;
}
var c9, iH;
function DY() {
  if (iH)
    return c9;
  iH = 1;
  var m = wV();
  return c9 = function(w, E, P) {
    var H = P.config.validateStatus;
    !P.status || !H || H(P.status) ? w(P) : E(m(
      "Request failed with status code " + P.status,
      P.config,
      null,
      P.request,
      P
    ));
  }, c9;
}
var f9, uH;
function BY() {
  if (uH)
    return f9;
  uH = 1;
  var m = Pv;
  return f9 = m.isStandardBrowserEnv() ? function() {
    return {
      write: function(E, P, H, X, j, le) {
        var Q = [];
        Q.push(E + "=" + encodeURIComponent(P)), m.isNumber(H) && Q.push("expires=" + new Date(H).toGMTString()), m.isString(X) && Q.push("path=" + X), m.isString(j) && Q.push("domain=" + j), le === !0 && Q.push("secure"), document.cookie = Q.join("; ");
      },
      read: function(E) {
        var P = document.cookie.match(new RegExp("(^|;\\s*)(" + E + ")=([^;]*)"));
        return P ? decodeURIComponent(P[3]) : null;
      },
      remove: function(E) {
        this.write(E, "", Date.now() - 864e5);
      }
    };
  }() : function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }(), f9;
}
var v9, sH;
function RY() {
  return sH || (sH = 1, v9 = function(y) {
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(y);
  }), v9;
}
var d9, lH;
function MY() {
  return lH || (lH = 1, d9 = function(y, w) {
    return w ? y.replace(/\/+$/, "") + "/" + w.replace(/^\/+/, "") : y;
  }), d9;
}
var m9, cH;
function PY() {
  if (cH)
    return m9;
  cH = 1;
  var m = RY(), y = MY();
  return m9 = function(E, P) {
    return E && !m(P) ? y(E, P) : P;
  }, m9;
}
var g9, fH;
function NY() {
  if (fH)
    return g9;
  fH = 1;
  var m = Pv, y = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return g9 = function(E) {
    var P = {}, H, X, j;
    return E && m.forEach(E.split(`
`), function(Q) {
      if (j = Q.indexOf(":"), H = m.trim(Q.substr(0, j)).toLowerCase(), X = m.trim(Q.substr(j + 1)), H) {
        if (P[H] && y.indexOf(H) >= 0)
          return;
        H === "set-cookie" ? P[H] = (P[H] ? P[H] : []).concat([X]) : P[H] = P[H] ? P[H] + ", " + X : X;
      }
    }), P;
  }, g9;
}
var p9, vH;
function IY() {
  if (vH)
    return p9;
  vH = 1;
  var m = Pv;
  return p9 = m.isStandardBrowserEnv() ? function() {
    var w = /(msie|trident)/i.test(navigator.userAgent), E = document.createElement("a"), P;
    function H(X) {
      var j = X;
      return w && (E.setAttribute("href", j), j = E.href), E.setAttribute("href", j), {
        href: E.href,
        protocol: E.protocol ? E.protocol.replace(/:$/, "") : "",
        host: E.host,
        search: E.search ? E.search.replace(/^\?/, "") : "",
        hash: E.hash ? E.hash.replace(/^#/, "") : "",
        hostname: E.hostname,
        port: E.port,
        pathname: E.pathname.charAt(0) === "/" ? E.pathname : "/" + E.pathname
      };
    }
    return P = H(window.location.href), function(j) {
      var le = m.isString(j) ? H(j) : j;
      return le.protocol === P.protocol && le.host === P.host;
    };
  }() : function() {
    return function() {
      return !0;
    };
  }(), p9;
}
var h9, dH;
function mH() {
  if (dH)
    return h9;
  dH = 1;
  var m = Pv, y = DY(), w = BY(), E = bV, P = PY(), H = NY(), X = IY(), j = wV();
  return h9 = function(Q) {
    return new Promise(function(Y, D) {
      var J = Q.data, ue = Q.headers;
      m.isFormData(J) && delete ue["Content-Type"];
      var ee = new XMLHttpRequest();
      if (Q.auth) {
        var Ge = Q.auth.username || "", ze = Q.auth.password ? unescape(encodeURIComponent(Q.auth.password)) : "";
        ue.Authorization = "Basic " + btoa(Ge + ":" + ze);
      }
      var ht = P(Q.baseURL, Q.url);
      if (ee.open(Q.method.toUpperCase(), E(ht, Q.params, Q.paramsSerializer), !0), ee.timeout = Q.timeout, ee.onreadystatechange = function() {
        if (!(!ee || ee.readyState !== 4) && !(ee.status === 0 && !(ee.responseURL && ee.responseURL.indexOf("file:") === 0))) {
          var De = "getAllResponseHeaders" in ee ? H(ee.getAllResponseHeaders()) : null, Pt = !Q.responseType || Q.responseType === "text" ? ee.responseText : ee.response, Ct = {
            data: Pt,
            status: ee.status,
            statusText: ee.statusText,
            headers: De,
            config: Q,
            request: ee
          };
          y(Y, D, Ct), ee = null;
        }
      }, ee.onabort = function() {
        !ee || (D(j("Request aborted", Q, "ECONNABORTED", ee)), ee = null);
      }, ee.onerror = function() {
        D(j("Network Error", Q, null, ee)), ee = null;
      }, ee.ontimeout = function() {
        var De = "timeout of " + Q.timeout + "ms exceeded";
        Q.timeoutErrorMessage && (De = Q.timeoutErrorMessage), D(j(
          De,
          Q,
          "ECONNABORTED",
          ee
        )), ee = null;
      }, m.isStandardBrowserEnv()) {
        var ie = (Q.withCredentials || X(ht)) && Q.xsrfCookieName ? w.read(Q.xsrfCookieName) : void 0;
        ie && (ue[Q.xsrfHeaderName] = ie);
      }
      if ("setRequestHeader" in ee && m.forEach(ue, function(De, Pt) {
        typeof J > "u" && Pt.toLowerCase() === "content-type" ? delete ue[Pt] : ee.setRequestHeader(Pt, De);
      }), m.isUndefined(Q.withCredentials) || (ee.withCredentials = !!Q.withCredentials), Q.responseType)
        try {
          ee.responseType = Q.responseType;
        } catch (Ze) {
          if (Q.responseType !== "json")
            throw Ze;
        }
      typeof Q.onDownloadProgress == "function" && ee.addEventListener("progress", Q.onDownloadProgress), typeof Q.onUploadProgress == "function" && ee.upload && ee.upload.addEventListener("progress", Q.onUploadProgress), Q.cancelToken && Q.cancelToken.promise.then(function(De) {
        !ee || (ee.abort(), D(De), ee = null);
      }), J || (J = null), ee.send(J);
    });
  }, h9;
}
var zf = Pv, gH = AY, FY = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function pH(m, y) {
  !zf.isUndefined(m) && zf.isUndefined(m["Content-Type"]) && (m["Content-Type"] = y);
}
function $Y() {
  var m;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (m = mH()), m;
}
var sR = {
  adapter: $Y(),
  transformRequest: [function(y, w) {
    return gH(w, "Accept"), gH(w, "Content-Type"), zf.isFormData(y) || zf.isArrayBuffer(y) || zf.isBuffer(y) || zf.isStream(y) || zf.isFile(y) || zf.isBlob(y) ? y : zf.isArrayBufferView(y) ? y.buffer : zf.isURLSearchParams(y) ? (pH(w, "application/x-www-form-urlencoded;charset=utf-8"), y.toString()) : zf.isObject(y) ? (pH(w, "application/json;charset=utf-8"), JSON.stringify(y)) : y;
  }],
  transformResponse: [function(y) {
    if (typeof y == "string")
      try {
        y = JSON.parse(y);
      } catch {
      }
    return y;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function(y) {
    return y >= 200 && y < 300;
  }
};
sR.headers = {
  common: {
    Accept: "application/json, text/plain, */*"
  }
};
zf.forEach(["delete", "get", "head"], function(y) {
  sR.headers[y] = {};
});
zf.forEach(["post", "put", "patch"], function(y) {
  sR.headers[y] = zf.merge(FY);
});
var CV = sR, hH = Pv, b9 = EY, LY = yV(), zY = CV;
function y9(m) {
  m.cancelToken && m.cancelToken.throwIfRequested();
}
var HY = function(y) {
  y9(y), y.headers = y.headers || {}, y.data = b9(
    y.data,
    y.headers,
    y.transformRequest
  ), y.headers = hH.merge(
    y.headers.common || {},
    y.headers[y.method] || {},
    y.headers
  ), hH.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(P) {
      delete y.headers[P];
    }
  );
  var w = y.adapter || zY.adapter;
  return w(y).then(function(P) {
    return y9(y), P.data = b9(
      P.data,
      P.headers,
      y.transformResponse
    ), P;
  }, function(P) {
    return LY(P) || (y9(y), P && P.response && (P.response.data = b9(
      P.response.data,
      P.response.headers,
      y.transformResponse
    ))), Promise.reject(P);
  });
}, pc = Pv, SV = function(y, w) {
  w = w || {};
  var E = {}, P = ["url", "method", "data"], H = ["headers", "auth", "proxy", "params"], X = [
    "baseURL",
    "transformRequest",
    "transformResponse",
    "paramsSerializer",
    "timeout",
    "timeoutMessage",
    "withCredentials",
    "adapter",
    "responseType",
    "xsrfCookieName",
    "xsrfHeaderName",
    "onUploadProgress",
    "onDownloadProgress",
    "decompress",
    "maxContentLength",
    "maxBodyLength",
    "maxRedirects",
    "transport",
    "httpAgent",
    "httpsAgent",
    "cancelToken",
    "socketPath",
    "responseEncoding"
  ], j = ["validateStatus"];
  function le(D, J) {
    return pc.isPlainObject(D) && pc.isPlainObject(J) ? pc.merge(D, J) : pc.isPlainObject(J) ? pc.merge({}, J) : pc.isArray(J) ? J.slice() : J;
  }
  function Q(D) {
    pc.isUndefined(w[D]) ? pc.isUndefined(y[D]) || (E[D] = le(void 0, y[D])) : E[D] = le(y[D], w[D]);
  }
  pc.forEach(P, function(J) {
    pc.isUndefined(w[J]) || (E[J] = le(void 0, w[J]));
  }), pc.forEach(H, Q), pc.forEach(X, function(J) {
    pc.isUndefined(w[J]) ? pc.isUndefined(y[J]) || (E[J] = le(void 0, y[J])) : E[J] = le(void 0, w[J]);
  }), pc.forEach(j, function(J) {
    J in w ? E[J] = le(y[J], w[J]) : J in y && (E[J] = le(void 0, y[J]));
  });
  var pe = P.concat(H).concat(X).concat(j), Y = Object.keys(y).concat(Object.keys(w)).filter(function(J) {
    return pe.indexOf(J) === -1;
  });
  return pc.forEach(Y, Q), E;
}, xV = Pv, VY = bV, bH = kY, UY = HY, lR = SV;
function w5(m) {
  this.defaults = m, this.interceptors = {
    request: new bH(),
    response: new bH()
  };
}
w5.prototype.request = function(y) {
  typeof y == "string" ? (y = arguments[1] || {}, y.url = arguments[0]) : y = y || {}, y = lR(this.defaults, y), y.method ? y.method = y.method.toLowerCase() : this.defaults.method ? y.method = this.defaults.method.toLowerCase() : y.method = "get";
  var w = [UY, void 0], E = Promise.resolve(y);
  for (this.interceptors.request.forEach(function(H) {
    w.unshift(H.fulfilled, H.rejected);
  }), this.interceptors.response.forEach(function(H) {
    w.push(H.fulfilled, H.rejected);
  }); w.length; )
    E = E.then(w.shift(), w.shift());
  return E;
};
w5.prototype.getUri = function(y) {
  return y = lR(this.defaults, y), VY(y.url, y.params, y.paramsSerializer).replace(/^\?/, "");
};
xV.forEach(["delete", "get", "head", "options"], function(y) {
  w5.prototype[y] = function(w, E) {
    return this.request(lR(E || {}, {
      method: y,
      url: w,
      data: (E || {}).data
    }));
  };
});
xV.forEach(["post", "put", "patch"], function(y) {
  w5.prototype[y] = function(w, E, P) {
    return this.request(lR(P || {}, {
      method: y,
      url: w,
      data: E
    }));
  };
});
var jY = w5, w9, yH;
function kV() {
  if (yH)
    return w9;
  yH = 1;
  function m(y) {
    this.message = y;
  }
  return m.prototype.toString = function() {
    return "Cancel" + (this.message ? ": " + this.message : "");
  }, m.prototype.__CANCEL__ = !0, w9 = m, w9;
}
var C9, wH;
function WY() {
  if (wH)
    return C9;
  wH = 1;
  var m = kV();
  function y(w) {
    if (typeof w != "function")
      throw new TypeError("executor must be a function.");
    var E;
    this.promise = new Promise(function(X) {
      E = X;
    });
    var P = this;
    w(function(X) {
      P.reason || (P.reason = new m(X), E(P.reason));
    });
  }
  return y.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, y.source = function() {
    var E, P = new y(function(X) {
      E = X;
    });
    return {
      token: P,
      cancel: E
    };
  }, C9 = y, C9;
}
var S9, CH;
function qY() {
  return CH || (CH = 1, S9 = function(y) {
    return function(E) {
      return y.apply(null, E);
    };
  }), S9;
}
var x9, SH;
function GY() {
  return SH || (SH = 1, x9 = function(y) {
    return typeof y == "object" && y.isAxiosError === !0;
  }), x9;
}
var xH = Pv, KY = gV, GB = jY, XY = SV, YY = CV;
function TV(m) {
  var y = new GB(m), w = KY(GB.prototype.request, y);
  return xH.extend(w, GB.prototype, y), xH.extend(w, y), w;
}
var Hm = TV(YY);
Hm.Axios = GB;
Hm.create = function(y) {
  return TV(XY(Hm.defaults, y));
};
Hm.Cancel = kV();
Hm.CancelToken = WY();
Hm.isCancel = yV();
Hm.all = function(y) {
  return Promise.all(y);
};
Hm.spread = qY();
Hm.isAxiosError = GY();
J9.exports = Hm;
J9.exports.default = Hm;
(function(m) {
  m.exports = J9.exports;
})(mV);
const ZY = /* @__PURE__ */ iY(mV.exports);
var I9 = { exports: {} }, EV = { exports: {} };
(function() {
  var m = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", y = {
    rotl: function(w, E) {
      return w << E | w >>> 32 - E;
    },
    rotr: function(w, E) {
      return w << 32 - E | w >>> E;
    },
    endian: function(w) {
      if (w.constructor == Number)
        return y.rotl(w, 8) & 16711935 | y.rotl(w, 24) & 4278255360;
      for (var E = 0; E < w.length; E++)
        w[E] = y.endian(w[E]);
      return w;
    },
    randomBytes: function(w) {
      for (var E = []; w > 0; w--)
        E.push(Math.floor(Math.random() * 256));
      return E;
    },
    bytesToWords: function(w) {
      for (var E = [], P = 0, H = 0; P < w.length; P++, H += 8)
        E[H >>> 5] |= w[P] << 24 - H % 32;
      return E;
    },
    wordsToBytes: function(w) {
      for (var E = [], P = 0; P < w.length * 32; P += 8)
        E.push(w[P >>> 5] >>> 24 - P % 32 & 255);
      return E;
    },
    bytesToHex: function(w) {
      for (var E = [], P = 0; P < w.length; P++)
        E.push((w[P] >>> 4).toString(16)), E.push((w[P] & 15).toString(16));
      return E.join("");
    },
    hexToBytes: function(w) {
      for (var E = [], P = 0; P < w.length; P += 2)
        E.push(parseInt(w.substr(P, 2), 16));
      return E;
    },
    bytesToBase64: function(w) {
      for (var E = [], P = 0; P < w.length; P += 3)
        for (var H = w[P] << 16 | w[P + 1] << 8 | w[P + 2], X = 0; X < 4; X++)
          P * 8 + X * 6 <= w.length * 8 ? E.push(m.charAt(H >>> 6 * (3 - X) & 63)) : E.push("=");
      return E.join("");
    },
    base64ToBytes: function(w) {
      w = w.replace(/[^A-Z0-9+\/]/ig, "");
      for (var E = [], P = 0, H = 0; P < w.length; H = ++P % 4)
        H != 0 && E.push((m.indexOf(w.charAt(P - 1)) & Math.pow(2, -2 * H + 8) - 1) << H * 2 | m.indexOf(w.charAt(P)) >>> 6 - H * 2);
      return E;
    }
  };
  EV.exports = y;
})();
var F9 = {
  utf8: {
    stringToBytes: function(m) {
      return F9.bin.stringToBytes(unescape(encodeURIComponent(m)));
    },
    bytesToString: function(m) {
      return decodeURIComponent(escape(F9.bin.bytesToString(m)));
    }
  },
  bin: {
    stringToBytes: function(m) {
      for (var y = [], w = 0; w < m.length; w++)
        y.push(m.charCodeAt(w) & 255);
      return y;
    },
    bytesToString: function(m) {
      for (var y = [], w = 0; w < m.length; w++)
        y.push(String.fromCharCode(m[w]));
      return y.join("");
    }
  }
}, kH = F9;
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var JY = function(m) {
  return m != null && (_V(m) || QY(m) || !!m._isBuffer);
};
function _V(m) {
  return !!m.constructor && typeof m.constructor.isBuffer == "function" && m.constructor.isBuffer(m);
}
function QY(m) {
  return typeof m.readFloatLE == "function" && typeof m.slice == "function" && _V(m.slice(0, 0));
}
(function() {
  var m = EV.exports, y = kH.utf8, w = JY, E = kH.bin, P = function(H, X) {
    H.constructor == String ? X && X.encoding === "binary" ? H = E.stringToBytes(H) : H = y.stringToBytes(H) : w(H) ? H = Array.prototype.slice.call(H, 0) : !Array.isArray(H) && H.constructor !== Uint8Array && (H = H.toString());
    for (var j = m.bytesToWords(H), le = H.length * 8, Q = 1732584193, pe = -271733879, Y = -1732584194, D = 271733878, J = 0; J < j.length; J++)
      j[J] = (j[J] << 8 | j[J] >>> 24) & 16711935 | (j[J] << 24 | j[J] >>> 8) & 4278255360;
    j[le >>> 5] |= 128 << le % 32, j[(le + 64 >>> 9 << 4) + 14] = le;
    for (var ue = P._ff, ee = P._gg, Ge = P._hh, ze = P._ii, J = 0; J < j.length; J += 16) {
      var ht = Q, ie = pe, Ze = Y, De = D;
      Q = ue(Q, pe, Y, D, j[J + 0], 7, -680876936), D = ue(D, Q, pe, Y, j[J + 1], 12, -389564586), Y = ue(Y, D, Q, pe, j[J + 2], 17, 606105819), pe = ue(pe, Y, D, Q, j[J + 3], 22, -1044525330), Q = ue(Q, pe, Y, D, j[J + 4], 7, -176418897), D = ue(D, Q, pe, Y, j[J + 5], 12, 1200080426), Y = ue(Y, D, Q, pe, j[J + 6], 17, -1473231341), pe = ue(pe, Y, D, Q, j[J + 7], 22, -45705983), Q = ue(Q, pe, Y, D, j[J + 8], 7, 1770035416), D = ue(D, Q, pe, Y, j[J + 9], 12, -1958414417), Y = ue(Y, D, Q, pe, j[J + 10], 17, -42063), pe = ue(pe, Y, D, Q, j[J + 11], 22, -1990404162), Q = ue(Q, pe, Y, D, j[J + 12], 7, 1804603682), D = ue(D, Q, pe, Y, j[J + 13], 12, -40341101), Y = ue(Y, D, Q, pe, j[J + 14], 17, -1502002290), pe = ue(pe, Y, D, Q, j[J + 15], 22, 1236535329), Q = ee(Q, pe, Y, D, j[J + 1], 5, -165796510), D = ee(D, Q, pe, Y, j[J + 6], 9, -1069501632), Y = ee(Y, D, Q, pe, j[J + 11], 14, 643717713), pe = ee(pe, Y, D, Q, j[J + 0], 20, -373897302), Q = ee(Q, pe, Y, D, j[J + 5], 5, -701558691), D = ee(D, Q, pe, Y, j[J + 10], 9, 38016083), Y = ee(Y, D, Q, pe, j[J + 15], 14, -660478335), pe = ee(pe, Y, D, Q, j[J + 4], 20, -405537848), Q = ee(Q, pe, Y, D, j[J + 9], 5, 568446438), D = ee(D, Q, pe, Y, j[J + 14], 9, -1019803690), Y = ee(Y, D, Q, pe, j[J + 3], 14, -187363961), pe = ee(pe, Y, D, Q, j[J + 8], 20, 1163531501), Q = ee(Q, pe, Y, D, j[J + 13], 5, -1444681467), D = ee(D, Q, pe, Y, j[J + 2], 9, -51403784), Y = ee(Y, D, Q, pe, j[J + 7], 14, 1735328473), pe = ee(pe, Y, D, Q, j[J + 12], 20, -1926607734), Q = Ge(Q, pe, Y, D, j[J + 5], 4, -378558), D = Ge(D, Q, pe, Y, j[J + 8], 11, -2022574463), Y = Ge(Y, D, Q, pe, j[J + 11], 16, 1839030562), pe = Ge(pe, Y, D, Q, j[J + 14], 23, -35309556), Q = Ge(Q, pe, Y, D, j[J + 1], 4, -1530992060), D = Ge(D, Q, pe, Y, j[J + 4], 11, 1272893353), Y = Ge(Y, D, Q, pe, j[J + 7], 16, -155497632), pe = Ge(pe, Y, D, Q, j[J + 10], 23, -1094730640), Q = Ge(Q, pe, Y, D, j[J + 13], 4, 681279174), D = Ge(D, Q, pe, Y, j[J + 0], 11, -358537222), Y = Ge(Y, D, Q, pe, j[J + 3], 16, -722521979), pe = Ge(pe, Y, D, Q, j[J + 6], 23, 76029189), Q = Ge(Q, pe, Y, D, j[J + 9], 4, -640364487), D = Ge(D, Q, pe, Y, j[J + 12], 11, -421815835), Y = Ge(Y, D, Q, pe, j[J + 15], 16, 530742520), pe = Ge(pe, Y, D, Q, j[J + 2], 23, -995338651), Q = ze(Q, pe, Y, D, j[J + 0], 6, -198630844), D = ze(D, Q, pe, Y, j[J + 7], 10, 1126891415), Y = ze(Y, D, Q, pe, j[J + 14], 15, -1416354905), pe = ze(pe, Y, D, Q, j[J + 5], 21, -57434055), Q = ze(Q, pe, Y, D, j[J + 12], 6, 1700485571), D = ze(D, Q, pe, Y, j[J + 3], 10, -1894986606), Y = ze(Y, D, Q, pe, j[J + 10], 15, -1051523), pe = ze(pe, Y, D, Q, j[J + 1], 21, -2054922799), Q = ze(Q, pe, Y, D, j[J + 8], 6, 1873313359), D = ze(D, Q, pe, Y, j[J + 15], 10, -30611744), Y = ze(Y, D, Q, pe, j[J + 6], 15, -1560198380), pe = ze(pe, Y, D, Q, j[J + 13], 21, 1309151649), Q = ze(Q, pe, Y, D, j[J + 4], 6, -145523070), D = ze(D, Q, pe, Y, j[J + 11], 10, -1120210379), Y = ze(Y, D, Q, pe, j[J + 2], 15, 718787259), pe = ze(pe, Y, D, Q, j[J + 9], 21, -343485551), Q = Q + ht >>> 0, pe = pe + ie >>> 0, Y = Y + Ze >>> 0, D = D + De >>> 0;
    }
    return m.endian([Q, pe, Y, D]);
  };
  P._ff = function(H, X, j, le, Q, pe, Y) {
    var D = H + (X & j | ~X & le) + (Q >>> 0) + Y;
    return (D << pe | D >>> 32 - pe) + X;
  }, P._gg = function(H, X, j, le, Q, pe, Y) {
    var D = H + (X & le | j & ~le) + (Q >>> 0) + Y;
    return (D << pe | D >>> 32 - pe) + X;
  }, P._hh = function(H, X, j, le, Q, pe, Y) {
    var D = H + (X ^ j ^ le) + (Q >>> 0) + Y;
    return (D << pe | D >>> 32 - pe) + X;
  }, P._ii = function(H, X, j, le, Q, pe, Y) {
    var D = H + (j ^ (X | ~le)) + (Q >>> 0) + Y;
    return (D << pe | D >>> 32 - pe) + X;
  }, P._blocksize = 16, P._digestsize = 16, I9.exports = function(H, X) {
    if (H == null)
      throw new Error("Illegal argument " + H);
    var j = m.wordsToBytes(P(H, X));
    return X && X.asBytes ? j : X && X.asString ? E.bytesToString(j) : m.bytesToHex(j);
  };
})();
var eZ = String.prototype.replace, tZ = /%20/g, k9 = {
  RFC1738: "RFC1738",
  RFC3986: "RFC3986"
}, tL = {
  default: k9.RFC3986,
  formatters: {
    RFC1738: function(m) {
      return eZ.call(m, tZ, "+");
    },
    RFC3986: function(m) {
      return String(m);
    }
  },
  RFC1738: k9.RFC1738,
  RFC3986: k9.RFC3986
}, nZ = tL, T9 = Object.prototype.hasOwnProperty, EC = Array.isArray, Rp = function() {
  for (var m = [], y = 0; y < 256; ++y)
    m.push("%" + ((y < 16 ? "0" : "") + y.toString(16)).toUpperCase());
  return m;
}(), rZ = function(y) {
  for (; y.length > 1; ) {
    var w = y.pop(), E = w.obj[w.prop];
    if (EC(E)) {
      for (var P = [], H = 0; H < E.length; ++H)
        typeof E[H] < "u" && P.push(E[H]);
      w.obj[w.prop] = P;
    }
  }
}, AV = function(y, w) {
  for (var E = w && w.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, P = 0; P < y.length; ++P)
    typeof y[P] < "u" && (E[P] = y[P]);
  return E;
}, aZ = function m(y, w, E) {
  if (!w)
    return y;
  if (typeof w != "object") {
    if (EC(y))
      y.push(w);
    else if (y && typeof y == "object")
      (E && (E.plainObjects || E.allowPrototypes) || !T9.call(Object.prototype, w)) && (y[w] = !0);
    else
      return [y, w];
    return y;
  }
  if (!y || typeof y != "object")
    return [y].concat(w);
  var P = y;
  return EC(y) && !EC(w) && (P = AV(y, E)), EC(y) && EC(w) ? (w.forEach(function(H, X) {
    if (T9.call(y, X)) {
      var j = y[X];
      j && typeof j == "object" && H && typeof H == "object" ? y[X] = m(j, H, E) : y.push(H);
    } else
      y[X] = H;
  }), y) : Object.keys(w).reduce(function(H, X) {
    var j = w[X];
    return T9.call(H, X) ? H[X] = m(H[X], j, E) : H[X] = j, H;
  }, P);
}, oZ = function(y, w) {
  return Object.keys(w).reduce(function(E, P) {
    return E[P] = w[P], E;
  }, y);
}, iZ = function(m, y, w) {
  var E = m.replace(/\+/g, " ");
  if (w === "iso-8859-1")
    return E.replace(/%[0-9a-f]{2}/gi, unescape);
  try {
    return decodeURIComponent(E);
  } catch {
    return E;
  }
}, uZ = function(y, w, E, P, H) {
  if (y.length === 0)
    return y;
  var X = y;
  if (typeof y == "symbol" ? X = Symbol.prototype.toString.call(y) : typeof y != "string" && (X = String(y)), E === "iso-8859-1")
    return escape(X).replace(/%u[0-9a-f]{4}/gi, function(pe) {
      return "%26%23" + parseInt(pe.slice(2), 16) + "%3B";
    });
  for (var j = "", le = 0; le < X.length; ++le) {
    var Q = X.charCodeAt(le);
    if (Q === 45 || Q === 46 || Q === 95 || Q === 126 || Q >= 48 && Q <= 57 || Q >= 65 && Q <= 90 || Q >= 97 && Q <= 122 || H === nZ.RFC1738 && (Q === 40 || Q === 41)) {
      j += X.charAt(le);
      continue;
    }
    if (Q < 128) {
      j = j + Rp[Q];
      continue;
    }
    if (Q < 2048) {
      j = j + (Rp[192 | Q >> 6] + Rp[128 | Q & 63]);
      continue;
    }
    if (Q < 55296 || Q >= 57344) {
      j = j + (Rp[224 | Q >> 12] + Rp[128 | Q >> 6 & 63] + Rp[128 | Q & 63]);
      continue;
    }
    le += 1, Q = 65536 + ((Q & 1023) << 10 | X.charCodeAt(le) & 1023), j += Rp[240 | Q >> 18] + Rp[128 | Q >> 12 & 63] + Rp[128 | Q >> 6 & 63] + Rp[128 | Q & 63];
  }
  return j;
}, sZ = function(y) {
  for (var w = [{ obj: { o: y }, prop: "o" }], E = [], P = 0; P < w.length; ++P)
    for (var H = w[P], X = H.obj[H.prop], j = Object.keys(X), le = 0; le < j.length; ++le) {
      var Q = j[le], pe = X[Q];
      typeof pe == "object" && pe !== null && E.indexOf(pe) === -1 && (w.push({ obj: X, prop: Q }), E.push(pe));
    }
  return rZ(w), y;
}, lZ = function(y) {
  return Object.prototype.toString.call(y) === "[object RegExp]";
}, cZ = function(y) {
  return !y || typeof y != "object" ? !1 : !!(y.constructor && y.constructor.isBuffer && y.constructor.isBuffer(y));
}, fZ = function(y, w) {
  return [].concat(y, w);
}, vZ = function(y, w) {
  if (EC(y)) {
    for (var E = [], P = 0; P < y.length; P += 1)
      E.push(w(y[P]));
    return E;
  }
  return w(y);
}, OV = {
  arrayToObject: AV,
  assign: oZ,
  combine: fZ,
  compact: sZ,
  decode: iZ,
  encode: uZ,
  isBuffer: cZ,
  isRegExp: lZ,
  maybeMap: vZ,
  merge: aZ
}, $9 = OV, f5 = tL, dZ = Object.prototype.hasOwnProperty, TH = {
  brackets: function(y) {
    return y + "[]";
  },
  comma: "comma",
  indices: function(y, w) {
    return y + "[" + w + "]";
  },
  repeat: function(y) {
    return y;
  }
}, AC = Array.isArray, mZ = String.prototype.split, gZ = Array.prototype.push, DV = function(m, y) {
  gZ.apply(m, AC(y) ? y : [y]);
}, pZ = Date.prototype.toISOString, EH = f5.default, Hl = {
  addQueryPrefix: !1,
  allowDots: !1,
  charset: "utf-8",
  charsetSentinel: !1,
  delimiter: "&",
  encode: !0,
  encoder: $9.encode,
  encodeValuesOnly: !1,
  format: EH,
  formatter: f5.formatters[EH],
  indices: !1,
  serializeDate: function(y) {
    return pZ.call(y);
  },
  skipNulls: !1,
  strictNullHandling: !1
}, hZ = function(y) {
  return typeof y == "string" || typeof y == "number" || typeof y == "boolean" || typeof y == "symbol" || typeof y == "bigint";
}, bZ = function m(y, w, E, P, H, X, j, le, Q, pe, Y, D, J, ue) {
  var ee = y;
  if (typeof j == "function" ? ee = j(w, ee) : ee instanceof Date ? ee = pe(ee) : E === "comma" && AC(ee) && (ee = $9.maybeMap(ee, function(_e) {
    return _e instanceof Date ? pe(_e) : _e;
  })), ee === null) {
    if (P)
      return X && !J ? X(w, Hl.encoder, ue, "key", Y) : w;
    ee = "";
  }
  if (hZ(ee) || $9.isBuffer(ee)) {
    if (X) {
      var Ge = J ? w : X(w, Hl.encoder, ue, "key", Y);
      if (E === "comma" && J) {
        for (var ze = mZ.call(String(ee), ","), ht = "", ie = 0; ie < ze.length; ++ie)
          ht += (ie === 0 ? "" : ",") + D(X(ze[ie], Hl.encoder, ue, "value", Y));
        return [D(Ge) + "=" + ht];
      }
      return [D(Ge) + "=" + D(X(ee, Hl.encoder, ue, "value", Y))];
    }
    return [D(w) + "=" + D(String(ee))];
  }
  var Ze = [];
  if (typeof ee > "u")
    return Ze;
  var De;
  if (E === "comma" && AC(ee))
    De = [{ value: ee.length > 0 ? ee.join(",") || null : void 0 }];
  else if (AC(j))
    De = j;
  else {
    var Pt = Object.keys(ee);
    De = le ? Pt.sort(le) : Pt;
  }
  for (var Ct = 0; Ct < De.length; ++Ct) {
    var Be = De[Ct], ge = typeof Be == "object" && typeof Be.value < "u" ? Be.value : ee[Be];
    if (!(H && ge === null)) {
      var xe = AC(ee) ? typeof E == "function" ? E(w, Be) : w : w + (Q ? "." + Be : "[" + Be + "]");
      DV(Ze, m(
        ge,
        xe,
        E,
        P,
        H,
        X,
        j,
        le,
        Q,
        pe,
        Y,
        D,
        J,
        ue
      ));
    }
  }
  return Ze;
}, yZ = function(y) {
  if (!y)
    return Hl;
  if (y.encoder !== null && typeof y.encoder < "u" && typeof y.encoder != "function")
    throw new TypeError("Encoder has to be a function.");
  var w = y.charset || Hl.charset;
  if (typeof y.charset < "u" && y.charset !== "utf-8" && y.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var E = f5.default;
  if (typeof y.format < "u") {
    if (!dZ.call(f5.formatters, y.format))
      throw new TypeError("Unknown format option provided.");
    E = y.format;
  }
  var P = f5.formatters[E], H = Hl.filter;
  return (typeof y.filter == "function" || AC(y.filter)) && (H = y.filter), {
    addQueryPrefix: typeof y.addQueryPrefix == "boolean" ? y.addQueryPrefix : Hl.addQueryPrefix,
    allowDots: typeof y.allowDots > "u" ? Hl.allowDots : !!y.allowDots,
    charset: w,
    charsetSentinel: typeof y.charsetSentinel == "boolean" ? y.charsetSentinel : Hl.charsetSentinel,
    delimiter: typeof y.delimiter > "u" ? Hl.delimiter : y.delimiter,
    encode: typeof y.encode == "boolean" ? y.encode : Hl.encode,
    encoder: typeof y.encoder == "function" ? y.encoder : Hl.encoder,
    encodeValuesOnly: typeof y.encodeValuesOnly == "boolean" ? y.encodeValuesOnly : Hl.encodeValuesOnly,
    filter: H,
    format: E,
    formatter: P,
    serializeDate: typeof y.serializeDate == "function" ? y.serializeDate : Hl.serializeDate,
    skipNulls: typeof y.skipNulls == "boolean" ? y.skipNulls : Hl.skipNulls,
    sort: typeof y.sort == "function" ? y.sort : null,
    strictNullHandling: typeof y.strictNullHandling == "boolean" ? y.strictNullHandling : Hl.strictNullHandling
  };
}, wZ = function(m, y) {
  var w = m, E = yZ(y), P, H;
  typeof E.filter == "function" ? (H = E.filter, w = H("", w)) : AC(E.filter) && (H = E.filter, P = H);
  var X = [];
  if (typeof w != "object" || w === null)
    return "";
  var j;
  y && y.arrayFormat in TH ? j = y.arrayFormat : y && "indices" in y ? j = y.indices ? "indices" : "repeat" : j = "indices";
  var le = TH[j];
  P || (P = Object.keys(w)), E.sort && P.sort(E.sort);
  for (var Q = 0; Q < P.length; ++Q) {
    var pe = P[Q];
    E.skipNulls && w[pe] === null || DV(X, bZ(
      w[pe],
      pe,
      le,
      E.strictNullHandling,
      E.skipNulls,
      E.encode ? E.encoder : null,
      E.filter,
      E.sort,
      E.allowDots,
      E.serializeDate,
      E.format,
      E.formatter,
      E.encodeValuesOnly,
      E.charset
    ));
  }
  var Y = X.join(E.delimiter), D = E.addQueryPrefix === !0 ? "?" : "";
  return E.charsetSentinel && (E.charset === "iso-8859-1" ? D += "utf8=%26%2310003%3B&" : D += "utf8=%E2%9C%93&"), Y.length > 0 ? D + Y : "";
}, ok = OV, L9 = Object.prototype.hasOwnProperty, CZ = Array.isArray, zl = {
  allowDots: !1,
  allowPrototypes: !1,
  arrayLimit: 20,
  charset: "utf-8",
  charsetSentinel: !1,
  comma: !1,
  decoder: ok.decode,
  delimiter: "&",
  depth: 5,
  ignoreQueryPrefix: !1,
  interpretNumericEntities: !1,
  parameterLimit: 1e3,
  parseArrays: !0,
  plainObjects: !1,
  strictNullHandling: !1
}, SZ = function(m) {
  return m.replace(/&#(\d+);/g, function(y, w) {
    return String.fromCharCode(parseInt(w, 10));
  });
}, BV = function(m, y) {
  return m && typeof m == "string" && y.comma && m.indexOf(",") > -1 ? m.split(",") : m;
}, xZ = "utf8=%26%2310003%3B", kZ = "utf8=%E2%9C%93", TZ = function(y, w) {
  var E = {}, P = w.ignoreQueryPrefix ? y.replace(/^\?/, "") : y, H = w.parameterLimit === 1 / 0 ? void 0 : w.parameterLimit, X = P.split(w.delimiter, H), j = -1, le, Q = w.charset;
  if (w.charsetSentinel)
    for (le = 0; le < X.length; ++le)
      X[le].indexOf("utf8=") === 0 && (X[le] === kZ ? Q = "utf-8" : X[le] === xZ && (Q = "iso-8859-1"), j = le, le = X.length);
  for (le = 0; le < X.length; ++le)
    if (le !== j) {
      var pe = X[le], Y = pe.indexOf("]="), D = Y === -1 ? pe.indexOf("=") : Y + 1, J, ue;
      D === -1 ? (J = w.decoder(pe, zl.decoder, Q, "key"), ue = w.strictNullHandling ? null : "") : (J = w.decoder(pe.slice(0, D), zl.decoder, Q, "key"), ue = ok.maybeMap(
        BV(pe.slice(D + 1), w),
        function(ee) {
          return w.decoder(ee, zl.decoder, Q, "value");
        }
      )), ue && w.interpretNumericEntities && Q === "iso-8859-1" && (ue = SZ(ue)), pe.indexOf("[]=") > -1 && (ue = CZ(ue) ? [ue] : ue), L9.call(E, J) ? E[J] = ok.combine(E[J], ue) : E[J] = ue;
    }
  return E;
}, EZ = function(m, y, w, E) {
  for (var P = E ? y : BV(y, w), H = m.length - 1; H >= 0; --H) {
    var X, j = m[H];
    if (j === "[]" && w.parseArrays)
      X = [].concat(P);
    else {
      X = w.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
      var le = j.charAt(0) === "[" && j.charAt(j.length - 1) === "]" ? j.slice(1, -1) : j, Q = parseInt(le, 10);
      !w.parseArrays && le === "" ? X = { 0: P } : !isNaN(Q) && j !== le && String(Q) === le && Q >= 0 && w.parseArrays && Q <= w.arrayLimit ? (X = [], X[Q] = P) : le !== "__proto__" && (X[le] = P);
    }
    P = X;
  }
  return P;
}, _Z = function(y, w, E, P) {
  if (!!y) {
    var H = E.allowDots ? y.replace(/\.([^.[]+)/g, "[$1]") : y, X = /(\[[^[\]]*])/, j = /(\[[^[\]]*])/g, le = E.depth > 0 && X.exec(H), Q = le ? H.slice(0, le.index) : H, pe = [];
    if (Q) {
      if (!E.plainObjects && L9.call(Object.prototype, Q) && !E.allowPrototypes)
        return;
      pe.push(Q);
    }
    for (var Y = 0; E.depth > 0 && (le = j.exec(H)) !== null && Y < E.depth; ) {
      if (Y += 1, !E.plainObjects && L9.call(Object.prototype, le[1].slice(1, -1)) && !E.allowPrototypes)
        return;
      pe.push(le[1]);
    }
    return le && pe.push("[" + H.slice(le.index) + "]"), EZ(pe, w, E, P);
  }
}, AZ = function(y) {
  if (!y)
    return zl;
  if (y.decoder !== null && y.decoder !== void 0 && typeof y.decoder != "function")
    throw new TypeError("Decoder has to be a function.");
  if (typeof y.charset < "u" && y.charset !== "utf-8" && y.charset !== "iso-8859-1")
    throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
  var w = typeof y.charset > "u" ? zl.charset : y.charset;
  return {
    allowDots: typeof y.allowDots > "u" ? zl.allowDots : !!y.allowDots,
    allowPrototypes: typeof y.allowPrototypes == "boolean" ? y.allowPrototypes : zl.allowPrototypes,
    arrayLimit: typeof y.arrayLimit == "number" ? y.arrayLimit : zl.arrayLimit,
    charset: w,
    charsetSentinel: typeof y.charsetSentinel == "boolean" ? y.charsetSentinel : zl.charsetSentinel,
    comma: typeof y.comma == "boolean" ? y.comma : zl.comma,
    decoder: typeof y.decoder == "function" ? y.decoder : zl.decoder,
    delimiter: typeof y.delimiter == "string" || ok.isRegExp(y.delimiter) ? y.delimiter : zl.delimiter,
    depth: typeof y.depth == "number" || y.depth === !1 ? +y.depth : zl.depth,
    ignoreQueryPrefix: y.ignoreQueryPrefix === !0,
    interpretNumericEntities: typeof y.interpretNumericEntities == "boolean" ? y.interpretNumericEntities : zl.interpretNumericEntities,
    parameterLimit: typeof y.parameterLimit == "number" ? y.parameterLimit : zl.parameterLimit,
    parseArrays: y.parseArrays !== !1,
    plainObjects: typeof y.plainObjects == "boolean" ? y.plainObjects : zl.plainObjects,
    strictNullHandling: typeof y.strictNullHandling == "boolean" ? y.strictNullHandling : zl.strictNullHandling
  };
}, OZ = function(m, y) {
  var w = AZ(y);
  if (m === "" || m === null || typeof m > "u")
    return w.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
  for (var E = typeof m == "string" ? TZ(m, w) : m, P = w.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, H = Object.keys(E), X = 0; X < H.length; ++X) {
    var j = H[X], le = _Z(j, E[j], w, typeof m == "string");
    P = ok.merge(P, le, w);
  }
  return ok.compact(P);
}, DZ = wZ, BZ = OZ, RZ = tL, tk = {
  formats: RZ,
  parse: BZ,
  stringify: DZ
};
const TC = {
  isWeibo() {
    return /weibo/.test(navigator.userAgent.toLowerCase());
  },
  isWxApp() {
    return /miniprogram/.test(navigator.userAgent.toLowerCase());
  },
  isWeixin() {
    return /micromessenger/.test(navigator.userAgent.toLowerCase());
  },
  isToutiao() {
    return /toutiaomicroapp/.test(navigator.userAgent.toLowerCase());
  },
  isIos() {
    return /ipad|ipod|iphone/.test(navigator.userAgent.toLowerCase());
  },
  isMobile() {
    return /android|symbianos|windows phone|ipad|ipod|iphone/.test(navigator.userAgent.toLowerCase());
  },
  isIphoneX() {
    return /iphone/.test(navigator.userAgent.toLowerCase()) && (screen.height === 812 && screen.width === 375 || screen.height === 896 && screen.width === 414);
  },
  isSafari() {
    return /iphone/.test(navigator.userAgent.toLowerCase()) && /safari/.test(navigator.userAgent.toLowerCase());
  },
  isModianIos() {
    return /ios-modian/.test(navigator.userAgent.toLowerCase());
  },
  isModianAndroid() {
    return /android-modian/.test(navigator.userAgent.toLowerCase());
  },
  isModianIosNew() {
    return /ios-modian-wk/.test(navigator.userAgent.toLowerCase());
  }
}, _H = (() => {
  let m = 3, y = "wap", w = "other", E = "";
  return TC.isMobile() && (m = 3, TC.isModianIos() ? (y = "ios", E = "ios") : TC.isModianAndroid() ? (y = "android", E = "android") : TC.isWeibo() ? (w = "weibo", y = "weibo", E = "weibo") : sessionStorage.getItem("miniProgram") || TC.isWxApp() ? sessionStorage.getItem("miniProgram") == "toutiao" ? (y = "toutiao_mina", E = "tt-mina") : (w = "weixin", y = "mina", E = "wx-mina") : TC.isWeixin() && (w = "weixin", E = "wx-browser")), {
    client: m,
    md_client: y,
    platform_type: w,
    channel: E,
    build: 993322221
  };
})(), KB = {
  client: _H.client,
  channel: _H.channel
}, MZ = function(m) {
  if (typeof m == "object")
    for (let y in m)
      KB[y] = m[y] ? m[y] : "";
};
window.graft = window.graft ? window.graft : {};
window.graft.isModianIos = () => /ios-modian/.test(navigator.userAgent.toLowerCase());
window.graft.isModianAndroid = () => /android-modian/.test(navigator.userAgent.toLowerCase());
window.graft.client_code = 0;
window.graft.isModianIos() && (window.graft.client_code = 1);
window.graft.isModianAndroid() && (window.graft.client_code = 2);
window.graft.app = ({ functionName: m, functionParams: y, webFun: w, callBack: E, showAlert: P = !1 }) => {
  E && typeof E == "function" && (m == "playAudio" ? window.graft[m] = E : graft[m] = E), P && (window.graft.showAlert = P), graft.onSendToNativeRequest({ functionName: m, functionParams: y, webFun: w });
};
window.graft.onSendToNativeRequest = ({ functionName: m, functionParams: y, webFun: w }) => {
  let E = {
    functionName: m,
    functionParams: y
  };
  [1, 2].includes(window.graft.client_code) ? window.graft.client_code === 1 ? window.webkit.messageHandlers.onSendToNativeRequest.postMessage(E) : window.appInterface.onSendToNativeRequest(JSON.stringify(E)) : w && typeof w == "function" && w();
};
window.onCallBackToJsResponse = (m, y) => {
  window.graft[m] && typeof window.graft[m] == "function" && (window.graft.client_code === 1 ? window.graft[m](y) : window.graft[m](JSON.parse(y)));
};
const SC = {
  id: 1,
  title: "\u5FEB\u6765\u548C\u6211\u4E00\u8D77\u73A9\u5427!",
  img: "",
  wx_title: "\u5FEB\u6765\u548C\u6211\u4E00\u8D77\u73A9\u5427!''",
  wx_des: "'https://www.modian.com/'",
  weixin_share_url: "https://www.modian.com/",
  wxTimeline_title: "\u5FEB\u6765\u548C\u6211\u4E00\u8D77\u73A9\u5427!''",
  wxTimeline_des: "'https://www.modian.com/'",
  wxTimeline_share_url: "https://www.modian.com/",
  qq_title: "\u5FEB\u6765\u548C\u6211\u4E00\u8D77\u73A9\u5427!",
  qq_des: "'https://www.modian.com/'",
  qq_share_url: "https://www.modian.com/",
  qzone_title: "\u5FEB\u6765\u548C\u6211\u4E00\u8D77\u73A9\u5427!",
  qzone_des: "'https://www.modian.com/'",
  qzone_share_url: "https://www.modian.com/",
  weibo_title: "https://www.modian.com/",
  weibo_des: "\u5FEB\u6765\u548C\u6211\u4E00\u8D77\u73A9\u5427!''",
  weibo_share_url: "https://www.modian.com/",
  msg_des: "\u5FEB\u6765\u548C\u6211\u4E00\u8D77\u73A9\u5427!''",
  sharelink_url: "https://www.modian.com/"
}, PZ = [
  {
    functionName: "onGetUserInfo",
    functionData: null,
    prompt: "\u83B7\u53D6\u7528\u6237\u4FE1\u606F"
  },
  {
    functionName: "onGetPushState",
    functionData: null,
    prompt: "\u83B7\u53D6\u63A8\u9001\u6743\u9650\u72B6\u6001 1\u6253\u5F00 0\u5173\u95ED"
  },
  {
    functionName: "webShareEnabled",
    functionData: { shareEnabled: 1, shareInfo: SC },
    prompt: "\u8BE5Web\u9875\u662F\u5426\u53EF\u5206\u4EAB<1\u53EF\u5206\u4EAB 0\u4E0D\u53EF>"
  },
  {
    functionName: "isWXAppInstalled",
    functionData: null,
    prompt: "\u68C0\u6D4B\u5FAE\u4FE1\u662F\u5426\u5B89\u88C5<1\u662F 0\u5426>"
  },
  {
    functionName: "isWeiboAppInstalled",
    functionData: null,
    prompt: "\u68C0\u6D4B\u5FAE\u535A\u662F\u5426\u5B89\u88C5<1\u662F 0\u5426>"
  },
  {
    functionName: "isQQInstalled",
    functionData: null,
    prompt: "\u68C0\u6D4BQQ\u662F\u5426\u5B89\u88C5 <1\u662F 0\u5426>"
  },
  {
    functionName: "openShareTool",
    functionData: SC,
    prompt: "\u6253\u5F00Native\u5206\u4EAB\u7EC4\u4EF6"
  },
  {
    functionName: "shareToWeChat",
    functionData: SC,
    prompt: "\u5206\u4EAB\u81F3\u5FAE\u4FE1\u597D\u53CB"
  },
  {
    functionName: "shareToWeChatTimeLine",
    functionData: SC,
    prompt: "\u5206\u4EAB\u81F3\u5FAE\u4FE1\u670B\u53CB\u5708"
  },
  {
    functionName: "shareToSina",
    functionData: SC,
    prompt: "\u5206\u4EAB\u81F3\u65B0\u6D6A\u5FAE\u535A"
  },
  {
    functionName: "shareToQQ",
    functionData: SC,
    prompt: "\u5206\u4EAB\u81F3QQ\u597D\u53CB"
  },
  {
    functionName: "shareToQzone",
    functionData: SC,
    prompt: "\u5206\u4EAB\u81F3QQ\u7A7A\u95F4"
  },
  {
    functionName: "onImageClicked",
    functionData: {
      imageUrls: [
        "https://testupload.modianinc.com/path/dst_kuji/202104/0212/1617/4jrnKmB2kYNJENY3bvXpM5GQ9q6RdA.png",
        "https://testupload.modianinc.com/path/dst_kuji/202103/3009/5747/Y13ADGjKOZgVy65xMEx4pe5an8lRQw.jpg"
      ],
      imageIndex: 1
    },
    prompt: "\u70B9\u51FB\u67E5\u770B\u5927\u56FE <\u53C2\u6570\u4E3AH5\u9875\u9762\u5185\u56FE\u7247\u94FE\u63A5\u6570\u7EC4>"
  },
  {
    functionName: "webNavColor",
    functionData: { alpha: 0.5, bgColor: "#cabe14", titleColor: "#156bba" },
    prompt: "\u4FEE\u6539\u6C89\u6D78\u5F0Fweb\u9876\u90E8\u89C6\u56FE<\u5BFC\u822A\u680F/\u6807\u9898/\u8FD4\u56DE\u6309\u94AE"
  },
  {
    functionName: "openController",
    functionData: "https://www.modian.com/",
    prompt: "\u6253\u5F00\u65B0\u7684\u9875\u9762,\u53C2\u6570\u4E3Amd://\u5185\u94FE\u6216H5\u94FE\u63A5"
  },
  {
    functionName: "closeController",
    functionData: "",
    prompt: "\u5173\u95ED\u5F53\u524D\u7684web\u9875\u9762\u63A7\u5236\u5668"
  },
  {
    functionName: "login",
    functionData: "",
    prompt: "\u767B\u5F55"
  },
  {
    functionName: "preparyPlayMedia",
    functionData: "",
    prompt: "H5\u5185\u5D4C\u89C6\u9891/\u97F3\u9891\u64AD\u653E\u65F6\u4E2D\u6B62Native\u5F53\u524D\u64AD\u653E"
  }
];
window.graft.help = () => {
  document.body.innerHTML = "", PZ.map((y, w) => {
    let E = document.createElement("div");
    E.innerHTML = y.prompt + "--" + y.functionName, E.style.cssText = "border:1px solid", E.onclick = function() {
      console.log(y.functionName, y.functionData), window.graft.app({ functionName: y.functionName, functionParams: y.functionData, showAlert: !0 });
    }, document.body.appendChild(E);
  });
  let m = document.createElement("div");
  m.id = "tip", document.body.appendChild(m), m = `<div style='margin-top:20px'>\u793A\u4F8B:</div><div style='border:1px solid'>graft.app({ functionName:'onGetUserInfo',functionParams: [],<br/> callBack:(e)=>{
        alert(e.data.build)
    },<br/> webFun:()=>{
        console.log(this.client_code)
    }<br/> ,showAlert:false })</div><div style='border:1px solid'> \u8C03\u7528\u6469\u70B9app\u539F\u751F\u65B9\u6CD5: <br/>graft.app({functionName,functionParams,callBack,webFun,showAlert})</div>
    <div>functionName : (String)\u8C03\u7528\u7684\u65B9\u6CD5\u540D\u2191</div><div>functionParams : \u4F20\u9012\u53C2\u6570(String,Array,Object)</div><div>callBack : (Function)\u56DE\u8C03\u65B9\u6CD5</div>
    <div>webFun :(Function)\u4E0D\u5728app\u73AF\u5883\u4E2D\u89E6\u53D1\u65B9\u6CD5</div><div>showAlert : (true,false)\u663E\u793Aapp\u4F20\u56DE\u53C2\u6570</div>`, document.querySelectorAll("#tip")[0].innerHTML = m;
};
const NZ = function(m, y) {
  window.graft.app({
    functionName: "login",
    webFun: (w) => {
      let E = `http://${y}${m}.modian${m === "m" && !y ? "" : "inc"}.com/u/login?`, P = "/mainPages/login/login?", H = "/ucenter/login/index", X = encodeURIComponent(location.href);
      TC.isWxApp() ? (P = "/pages" + P, wx.miniProgram.navigateTo({
        url: P + "&redirect_url=" + X
      })) : sessionStorage.getItem("miniProgram") == "qq" ? (H = "/pages" + H, qq.miniProgram.navigateTo({
        url: H + "&redirect_url=" + X
      })) : location.href = E + "&redirect_url=" + X;
    }
  });
}, Ul = function(m) {
  const y = m.hasOwnProperty("needLogin") ? m.needLogin : !0, w = m.hasOwnProperty("responseType") ? m.responseType : "json";
  m.header && Object.getOwnPropertyNames(m.header).length > 0 && MZ(m.header);
  const E = ZY.create({
    timeout: 6e4,
    withCredentials: !0,
    responseType: w
  }), P = (le) => {
    Object.keys(le).forEach((pe) => {
      typeof le[pe] > "u" && delete le[pe];
    });
    const Q = "{#_#}";
    return tk.parse(tk.stringify(le, { delimiter: Q }).split(Q).sort().join(Q), {
      delimiter: Q
    });
  };
  let H = "m", X = "";
  const j = (le, Q) => {
    if (Q.indexOf("http") === 0)
      return Q;
    X = m.env ? m.env : "", H = le.host ? le.host : m.host ? m.host : "m";
    let pe = "inc";
    return (H === "m" && !X || X == "pre") && (pe = ""), `https://${X}${le.headers.apiShow == !1 ? "" : "api"}${H}.modian${pe}.com${Q}`;
  };
  return E.interceptors.request.use(
    (le) => {
      const Q = "MzgxOTg3ZDMZTgxO";
      if (KB)
        for (let ht in KB)
          le.headers[ht] = le.headers[ht] ? le.headers[ht] : KB[ht];
      if (le.header)
        for (let ht in le.header)
          le.headers[ht] = le.headers[ht] ? le.headers[ht] : le.header[ht];
      const pe = le.url.indexOf("?") ? le.url.split("?") : le.url, Y = pe[0];
      let D = pe[1] ? tk.parse(pe[1]) : {};
      le.url = j(le, Y);
      const J = le.url.replace("http://", "").replace("https://", ""), ue = Date.parse(new Date()) / 1e3;
      le.headers.mt = ue;
      let ee = le.props || {}, Ge, ze;
      return le.method === "get" ? (Object.assign(D, ee), Ge = tk.stringify(P(D), { encode: !1 }), ee = "") : le.headers["Content-Type"] === "multipart/form-data" ? (Ge = "", ze = ee, ee = "") : (Ge = "", ze = tk.stringify(P(ee)), ee = tk.stringify(P(ee), { encode: !1 })), le.params = D, le.data = ze, le.headers.sign = I9.exports(J + Q + ue + Ge + I9.exports(ee)), le;
    },
    (le) => (m.callback && typeof m.callback == "object" && m.callback(le), Promise.reject(le))
  ), E.interceptors.response.use(
    (le) => {
      const { data: Q } = le, { status: pe } = Q;
      if ((pe === 1e4 || pe == 1 && Q.data == 1e4) && !y)
        NZ(H, X);
      else
        return Promise.resolve(Q);
    },
    (le) => (console.log("[ERROR]", le), Promise.resolve({
      status: "999999"
    }))
  ), E;
};
let Im = {
  img_list: [],
  img_list_true: []
};
function bc(m, y) {
  async function w(P, H, X) {
    let j;
    switch (console.log("option.status" + P.status), P.status) {
      case 1:
        j = "video";
        break;
      case 3:
        j = "music";
        break;
      case 4:
        j = "gif";
        break;
      default:
        j = "file";
    }
    let le = {
      file_info: "",
      file_type: j,
      channel: P.channel ? P.channel : "project"
    };
    le.file_info = await FZ(H, P.status), P.extraParams && (le = Object.assign(le, P.extraParams)), console.log(le.file_info);
    let Q = $Z(H);
    HZ("aliyun-oss-sdk.min.js") ? E(le, Q, P, X) : zZ("https://s.moimg.net/js/web4.0/alioss/aliyun-oss-sdk.min.js", function() {
      E(le, Q, P, X);
    });
  }
  function E(P, H, X, j) {
    let le = P.channel == "sale" ? "/apis/upload/drp/get_upload_token_new" : "/apis/upload/mdmedia/get_upload_token_new", Q = P.channel == "sale" ? "/apis/upload/drp/get_file_path" : "/apis/upload/mdmedia/get_file_path";
    if (Im = {
      img_list: [],
      img_list_true: []
    }, X.project != "acp")
      try {
        m({
          url: le,
          method: "post",
          props: P
        }).then((pe) => {
          let Y = pe;
          m({
            url: Q,
            method: "post",
            props: P
          }).then((D) => {
            let J = D.data, ue = {
              accessKeyId: Y.AccessKeyId,
              accessKeySecret: Y.AccessKeySecret,
              bucket: J.bucket_name,
              stsToken: Y.SecurityToken,
              region: "oss-cn-beijing"
            }, ee = {
              accesskeyid: Y.AccessKeyId,
              accesskeysecret: Y.AccessKeySecret,
              bucket_name: J.bucket_name,
              call_back_url: J.call_back_url,
              err_info: "",
              file: J.file,
              retry_times: J.retry_times,
              securitytoken: Y.SecurityToken
            };
            AH(ee, H, ue, X, P, j);
          });
        });
      } catch (pe) {
        throw X.error(pe), pe;
      }
    else
      try {
        m({
          url: "/upload/rpc_media/get_sts_token",
          host: "acp",
          method: "post",
          props: P,
          headers: {
            user_id: "-" + y,
            userid: "-" + y
          }
        }).then((pe) => {
          let Y = pe.data, D = {
            accessKeyId: Y.accesskeyid,
            accessKeySecret: Y.accesskeysecret,
            bucket: Y.bucket_name,
            stsToken: Y.securitytoken,
            region: "oss-cn-beijing"
          };
          AH(Y, H, D, X, P, j);
        });
      } catch (pe) {
        throw X.error(pe), pe;
      }
  }
  return w;
}
function AH(m, y, w, E, P, H) {
  try {
    m.file.forEach((X, j) => {
      const le = OSS(w);
      let Q = X.path, pe;
      switch (console.log("option.status" + E.status), E.status) {
        case 1:
          pe = "video";
          break;
        case 3:
          pe = "music";
          break;
        case 4:
          pe = "gif";
          break;
        default:
          pe = "file";
      }
      console.log("file_type\uFF1A" + pe);
      let Y = {
        id: X.id,
        size: y[j].size,
        file_type: pe
      };
      E.extraParams && (Y = Object.assign(Y, E.extraParams));
      const D = {
        callback: {
          url: m.call_back_url,
          body: JSON.stringify({ file_info: Y }),
          contentType: "application/json",
          customValue: {
            var1: "value1",
            var2: "value2"
          }
        }
      };
      E.status == 1 || E.status == 3 ? (console.log("media || audio"), le.multipartUpload(
        Q,
        y[j].file,
        Object.assign(D, {
          progress: (J) => {
            H.call(this, J);
          }
        })
      ).then((J) => {
        Im.img_list.unshift(y[j].path);
        let ue = "", ee = "";
        if (J.sys_msg == "FAIL" || J.data.sys_msg == "FAIL")
          return E.error(1, J.message ? J.message : J.data.message), !1;
        J.url ? ue = J.url : J.bucket ? ue = "http://" + J.bucket + ".oss-cn-beijing.aliyuncs.com/" + J.name : J.data && J.data.data && (ue = J.data.data.target_url);
        var Ge = JSON.parse(OH(J.res.data));
        Ge && Ge.data && Ge.data.target_url && (ue = Ge.data.target_url, console.log("\u8F6C\u6362\u540E\u7684target_url\uFF1A" + ue), ee = Ge.data.video_cover), Im.img_list_true.unshift(ue);
        let ze = JSON.parse(P.file_info)[j];
        Im.img_list_true.length == m.file.length ? E.success(ue, ee, j, !0, Im.img_list, ze) : E.success(ue, ee, j, !1, Im.img_list, ze);
      }).catch((J) => {
        E.error(J), console.log("\u9519\u8BEF\u4FE1\u606F:", J);
      })) : le.put(Q, y[j].file, D).then(async (J) => {
        Im.img_list.unshift(y[j].path);
        let ue = "";
        if (J.sys_msg == "FAIL" || J.data.sys_msg == "FAIL")
          return E.error(1, J.message ? J.message : J.data.message), !1;
        J.url ? ue = J.url : J.bucket ? ue = "http://" + J.bucket + ".oss-cn-beijing.aliyuncs.com/" + J.name : J.data && J.data.data && (ue = J.data.data.target_url);
        var ee = JSON.parse(OH(J.res.data));
        ee && ee.data && ee.data.target_url && (ue = ee.data.target_url, console.log("translateTarget_url\uFF1A" + ue)), Im.img_list_true.unshift(ue);
        let Ge = JSON.parse(P.file_info)[j];
        (!Ge.width || Ge.width == "undefined" || Ge.width == null) && (Ge = await IZ(ue), console.log("\u4E8C\u6B21\u8BFB\u53D6\u5BBD\u9AD8"), console.log(Ge)), E.status == 4 && (Ge.video_url = ee.data.origin_url || "", Ge.video_cover = ee.data.video_cover || ""), Im.img_list_true.length == m.file.length ? E.success(ue, j, !0, Im.img_list, Ge) : E.success(ue, j, !1, Im.img_list, Ge);
      }).catch((J) => {
        E.error(J), console.log("\u9519\u8BEF\u4FE1\u606F:", J);
      });
    });
  } catch (X) {
    throw E.error(X), console.log("\u9519\u8BEF\u4FE1\u606F:", X), X;
  }
}
async function IZ(m) {
  return new Promise(function(y, w) {
    var E = new Image();
    E.src = m, E.onload = function() {
      let P = {
        width: E.width,
        height: E.height
      };
      y(P);
    }, E.onerror = w;
  });
}
function OH(m) {
  if (typeof m == "string")
    return m;
  let y = "", w = m;
  for (let E = 0; E < w.length; E++) {
    let P = w[E].toString(2), H = P.match(/^1+?(?=0)/);
    if (H && P.length == 8) {
      let X = H[0].length, j = w[E].toString(2).slice(7 - X);
      for (let le = 1; le < X; le++)
        j += w[le + E].toString(2).slice(2);
      y += String.fromCharCode(parseInt(j, 2)), E += X - 1;
    } else
      y += String.fromCharCode(w[E]);
  }
  return y;
}
async function FZ(m, y) {
  let w = [];
  return await new Promise(function(E, P) {
    for (let Q = 0; Q < m.length; Q++)
      if (y == 1 || y == 3) {
        var H = URL.createObjectURL(m[Q]);
        if (y == 3) {
          var X = new Audio(H);
          X.addEventListener("loadedmetadata", (pe) => {
            w.push({
              file_name: m[Q].name,
              width: 100,
              height: 100,
              biz_type: "project",
              duration: DH(Math.ceil(X.duration))
            }), E();
          });
        } else {
          var j = document.createElement("video");
          j.onloadedmetadata = function(pe) {
            URL.revokeObjectURL(H), w.push({
              file_name: m[Q].name,
              width: j.videoWidth,
              height: j.videoHeight,
              biz_type: "project",
              duration: DH(Math.ceil(j.duration)),
              realTime: j.duration
            }), E();
          }, j.src = H, j.load();
        }
      } else if (y == 2)
        w.push({
          file_name: m[Q].name,
          width: 100,
          height: 100,
          biz_type: "project"
        }), E();
      else {
        var le = new FileReader();
        le.readAsDataURL(m[Q]), le.onload = function(pe) {
          var Y = pe.target.result, D = new Image();
          D.src = Y, D.onload = function() {
            w.push({
              file_name: m[Q].name,
              width: D.width,
              height: D.height,
              biz_type: "project"
            }), Q == m.length - 1 && E();
          };
        };
      }
  }), JSON.stringify(w);
}
function $Z(m) {
  let y = [];
  for (let w = 0; w < m.length; w++)
    y.push({
      size: m[w].size,
      file: m[w],
      path: LZ(m[w])
    });
  return y;
}
function LZ(m) {
  var y = null;
  return window.createObjectURL != null ? y = window.createObjectURL(m) : window.URL != null ? y = window.URL.createObjectURL(m) : window.webkitURL != null && (y = window.webkitURL.createObjectURL(m)), y;
}
function zZ(m, y) {
  let w = document.createElement("script"), E = document.getElementsByTagName("head")[0];
  w.type = "text/javascript", w.defer = !0, w.async = !0, w.src = m, E.appendChild(w), typeof y == "function" && (w.readyState ? w.onreadystatechange = () => {
    /complete|loaded/.test(w.readyState) && (w.onreadystatechange = null, y());
  } : w.onload = () => {
    y();
  });
}
function HZ(m) {
  let y = /js$/i.test(m), w = document.getElementsByTagName(y ? "script" : "link");
  for (var E = 0; E < w.length; E++)
    if (w[E][y ? "src" : "href"].indexOf(m) != -1)
      return !0;
  return !1;
}
function DH(m) {
  if (!!m) {
    if (m < 60)
      return "00:" + ((w = m) < 10 ? "0" + w : w);
    if (m < 3600)
      return "" + ((y = parseInt(m / 60)) < 10 ? "0" + y : y) + ":" + ((w = m % 60) < 10 ? "0" + w : w);
    if (3600 <= m) {
      var y, w, E = parseInt(m / 3600);
      return (E < 10 ? "0" + E : E) + ":" + ((y = parseInt(m % 3600 / 60)) < 10 ? "0" + y : y) + ":" + ((w = m % 60) < 10 ? "0" + w : w);
    }
  }
}
const VZ = (m) => (NC("data-v-8aff2d4e"), m = m(), IC(), m), UZ = /* @__PURE__ */ VZ(() => /* @__PURE__ */ Rt("h2", null, "\u56FE\u7247\u88C1\u526A", -1)), jZ = { class: "cropper" }, WZ = { class: "btn_list end" }, qZ = {
  __name: "cropper",
  props: {
    cropUrl: {
      type: String,
      default: ""
    },
    isShow: {
      type: Boolean,
      default: !1
    },
    autoCropWidth: {
      type: Number,
      default: 500
    },
    autoCropHeight: {
      type: Number,
      default: 500
    },
    fixedNumber: {
      type: Array,
      default: [1, 1]
    },
    info: {
      type: Boolean,
      default: !0
    },
    env: {
      type: String,
      default: ""
    },
    acpToken: {
      type: String,
      default: ""
    },
    sourceTop: {
      type: String,
      default: "m"
    },
    channel: {
      type: String,
      default: "project"
    }
  },
  emits: ["close", "confirm", "showLoading"],
  setup(m, { emit: y }) {
    const w = m, E = () => b1.get("MDUSERTOKEN"), P = function(Ge) {
      console.log("err", Ge);
    }, H = !1, X = /test/.test(location.host) ? "test" : "", j = w.acpToken, le = {
      client: 4,
      user_id: E() ? E().split("#")[0] : "",
      userid: E() ? E().split("#")[0] : "",
      token: E() ? E().split("#")[1] : ""
    };
    let Q = {};
    w.sourceTop == "acp" ? Q = Ul({
      host: "acp",
      env: X,
      header: {
        client: 4,
        user_id: j ? j.split(":")[0] : "",
        userid: j ? j.split(":")[0] : "",
        token: j ? j.split(":")[1] : ""
      },
      needLogin: H,
      callback: P
    }) : Q = Ul({
      env: X,
      header: le,
      acpneedLogin: H,
      acpcallback: P
    });
    const pe = bc(Q, j ? j.split(":")[0] : ""), Y = bc(Q, E() ? E().split("#")[0] : "");
    Wi(
      () => w.cropUrl,
      () => {
        J.option.img = w.cropUrl, J.option.autoCropWidth = w.autoCropWidth, J.option.autoCropHeight = w.autoCropHeight, J.option.fixedNumber = w.fixedNumber;
      }
    );
    const D = ja(null), J = Um({
      cancelTxt: "\u53D6\u6D88",
      confirmTxt: "\u786E\u5B9A",
      color: "#7A8087",
      borderColor: "#BCBFC3",
      btnColor: "#fff",
      btnMargin: "0 20px 0 0",
      option: {
        img: w.cropUrl,
        size: 1,
        canScale: !1,
        full: !0,
        outputType: "png",
        canMove: !1,
        fixedBox: !0,
        original: !1,
        canMoveBox: !0,
        autoCrop: !0,
        autoCropWidth: 3e3,
        autoCropHeight: 3e3,
        centerBox: !0,
        high: !0,
        cropData: {},
        enlarge: 1,
        mode: "contain",
        maxImgSize: 3e3,
        limitMinSize: [1080, null],
        fixed: !0,
        fixedNumber: [1, 1],
        infoTrue: !0
      }
    }), ue = () => {
      y("close");
    }, ee = () => {
      y("showLoading", !0);
      let Ge = [];
      D.value.getCropBlob((ze) => {
        let ht = new File([ze], Date.now() + ".png", { type: "png" }), ie = {
          channel: w.channel,
          success: function(Ze, De, Pt, Ct, Be) {
            y("confirm", Ze);
          },
          error: function(Ze, De) {
            console.log(Ze, De), alert(De), y("confirm", null);
          }
        };
        Ge.push(ht), w.sourceTop == "acp" ? pe(ie, Ge, 0) : Y(ie, Ge, 0);
      });
    };
    return (Ge, ze) => {
      const ht = h1("vue-cropper");
      return Dn(), Mo(y5, {
        isShow: w.isShow,
        isCrop: !0,
        onClose: ue
      }, {
        title: ka(() => [
          UZ
        ]),
        content: ka(() => [
          Rt("div", jZ, [
            Ja(ht, BC({
              ref_key: "cropper",
              ref: D
            }, J.option), null, 16)
          ])
        ]),
        btn_list: ka(() => [
          Rt("div", WZ, [
            Ja(Qb, {
              txt: J.cancelTxt,
              btnColor: J.btnColor,
              color: J.color,
              borderColor: J.borderColor,
              btnMargin: J.btnMargin,
              onBtnCallback: ue
            }, null, 8, ["txt", "btnColor", "color", "borderColor", "btnMargin"]),
            Ja(Qb, {
              txt: J.confirmTxt,
              onBtnCallback: ee
            }, null, 8, ["txt"])
          ])
        ]),
        _: 1
      }, 8, ["isShow"]);
    };
  }
}, cR = /* @__PURE__ */ Md(qZ, [["__scopeId", "data-v-8aff2d4e"]]);
const $C = (m) => (NC("data-v-1ca7f98c"), m = m(), IC(), m), GZ = /* @__PURE__ */ $C(() => /* @__PURE__ */ Rt("input", {
  type: "file",
  id: "media_editor_input",
  style: { display: "none" }
}, null, -1)), KZ = /* @__PURE__ */ $C(() => /* @__PURE__ */ Rt("h2", null, "\u5A92\u4F53\u6587\u4EF6\u4E0A\u4F20", -1)), XZ = ["onClick"], YZ = {
  key: 0,
  class: "loading"
}, ZZ = { class: "cover" }, JZ = ["src"], QZ = { class: "video_info" }, eJ = { class: "title" }, tJ = {
  key: 0,
  class: "edit_cover"
}, nJ = ["onClick"], rJ = /* @__PURE__ */ $C(() => /* @__PURE__ */ Rt("i", { class: "edit" }, null, -1)), aJ = /* @__PURE__ */ Zu("\u7F16\u8F91\u5C01\u9762"), oJ = [
  rJ,
  aJ
], iJ = {
  key: 1,
  class: "line"
}, uJ = { class: "title" }, sJ = { class: "line" }, lJ = { class: "tab" }, cJ = ["onClick"], fJ = { class: "video_preview" }, vJ = ["src"], dJ = /* @__PURE__ */ $C(() => /* @__PURE__ */ Rt("div", { class: "cover_cutter" }, null, -1)), mJ = {
  key: 0,
  class: "cover_list"
}, gJ = ["onClick"], pJ = ["src"], hJ = ["src"], bJ = /* @__PURE__ */ $C(() => /* @__PURE__ */ Rt("p", { class: "cover_tips" }, "\u53EF\u5DE6\u53F3\u62D6\u52A8\u81EA\u5B9A\u4E49\u5C01\u9762", -1)), yJ = ["onClick"], wJ = ["src"], CJ = { key: 1 }, SJ = /* @__PURE__ */ $C(() => /* @__PURE__ */ Rt("p", null, [
  /* @__PURE__ */ Rt("i", { class: "plus" }),
  /* @__PURE__ */ Zu("\u70B9\u51FB\u4E0A\u4F20\u5C01\u9762")
], -1)), xJ = /* @__PURE__ */ $C(() => /* @__PURE__ */ Rt("p", null, "\u5C01\u9762\u56FE\u652F\u6301jpg\u3001jpeg\u3001png\u3001gif", -1)), kJ = [
  SJ,
  xJ
], TJ = { class: "btn_list" }, EJ = {
  __name: "media",
  props: {
    env: {
      type: String,
      default: ""
    },
    acpToken: {
      type: String,
      default: ""
    },
    sourceTop: {
      type: String,
      default: "m"
    },
    isShow: {
      type: Boolean,
      default: !1
    },
    mediaType: {
      type: Number,
      default: 2
    },
    channel: {
      type: String,
      default: "project"
    }
  },
  emits: ["close", "btnCallback"],
  setup(m, { emit: y }) {
    const w = m, E = () => b1.get("MDUSERTOKEN"), P = function(_e) {
      console.log("err", _e);
    }, H = !1, X = w.env, j = w.acpToken, le = {
      client: 4,
      user_id: E() ? E().split("#")[0] : "",
      userid: E() ? E().split("#")[0] : "",
      token: E() ? E().split("#")[1] : ""
    };
    let Q = {};
    w.sourceTop == "acp" ? Q = Ul({
      host: "acp",
      env: X,
      header: {
        client: 4,
        user_id: j ? j.split(":")[0] : "",
        userid: j ? j.split(":")[0] : "",
        token: j ? j.split(":")[1] : ""
      },
      needLogin: H,
      callback: P
    }) : Q = Ul({
      env: X,
      header: le,
      acpneedLogin: H,
      acpcallback: P
    });
    const pe = bc(Q, j ? j.split(":")[0] : ""), Y = bc(Q, E() ? E().split("#")[0] : "");
    Xc(() => {
    });
    const D = Um({
      confirmTxt: "\u786E\u5B9A",
      fileProgressVisible: !1,
      fileUploadName: "",
      file_progress: 0,
      isEditVideoCover: !1,
      videoUrl: "",
      videoCover: [],
      videoObj: {
        width: 1,
        height: 1
      },
      tempVideoCover: "",
      editCoverIndex: 0,
      editVideoTab: ["\u622A\u53D6\u5C01\u9762", "\u4E0A\u4F20\u5C01\u9762"],
      canvansLoading: !1,
      uploadVideoCover: "",
      cropperShow: !1,
      cropperUrl: "",
      autoCropWidth: 336,
      autoCropHeight: 189,
      fixedNumber: [1, 1],
      tinymceContent: ""
    }), J = Or(
      () => D.file_progress == 100 ? "\u4E0A\u4F20\u5B8C\u6210 100%" : "\u4E0A\u4F20\u4E2D..." + D.file_progress + "%"
    ), ue = () => {
      if (D.file_progress == 100 || D.file_progress == 0)
        D.fileProgressVisible = !1, D.fileUploadName = "", D.file_progress = 0, D.videoCover = [], D.uploadVideoCover = "", D.editCoverIndex = 0, D.tempVideoCover = "", D.isEditVideoCover = !1, y("close");
      else
        return alert("\u6587\u4EF6\u4E0A\u4F20\u4E2D\uFF0C\u8BF7\u52FF\u64CD\u4F5C\u3002"), !1;
    }, ee = (_e) => {
      let $ = 70;
      var N = document.getElementById("dragPreview");
      let ae = N.parentElement.clientWidth, ce = $ * _e;
      N.style.left = ce + "px";
      let ne = ce / ae;
      const Ce = document.getElementById("video");
      Ce.currentTime = Ce.duration * ne, document.getElementById("videoPreview").currentTime = Ce.duration * ne;
    }, Ge = (_e) => {
      _e && (D.uploadVideoCover = _e, D.cropperShow = !1);
    }, ze = () => {
      let _e = document.createElement("input");
      _e.setAttribute("type", "file"), _e.setAttribute("accept", "image/*"), _e.click(), _e.onchange = function($) {
        let N = $.target.files[0];
        if (N.size / 1024 / 1024 > 3) {
          alert("\u6587\u4EF6" + N.name + "\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC73M");
          return;
        }
        Ct(N).then((ce) => {
          if (console.log(ce), ce)
            ce.type == 0 && (D.videoObj.width <= D.videoObj.height ? (D.autoCropWidth = D.videoObj.width, D.autoCropHeight = D.videoObj.width, D.fixedNumber = [1, 1]) : (D.autoCropWidth = D.videoObj.width, D.autoCropHeight = D.videoObj.height, D.fixedNumber = [D.videoObj.width, D.videoObj.height]), D.cropperUrl = ce.url, D.cropperShow = !0);
          else {
            let ne = {
              success: function(Te, _, je, Me, Je) {
                D.uploadVideoCover = Te;
              },
              error: function(Te, _) {
                alert(_);
              }
            }, Ce = [];
            Ce.push(N), w.sourceTop == "acp" ? pe(ne, Ce, 0) : Y(ne, Ce, 0);
          }
        });
      };
    }, ht = () => {
      D.canvansLoading = !0;
      let _e = null;
      _e = setInterval(function() {
        if (D.videoCover.length > 6) {
          D.canvansLoading = !1, clearInterval(_e), D.isEditVideoCover = !D.isEditVideoCover;
          var $ = document.getElementById("dragPreview"), N = 0, ae = 0, ce = !1;
          $.onmousedown = function(ne) {
            ce = !0, N = $.offsetLeft, $.offsetTop, ae = ne.clientX, ne.clientY, $.style.cursor = "move";
          }, window.onmousemove = function(ne) {
            if (ce) {
              let Ce = $.parentElement.clientWidth - $.clientWidth, Te = ne.clientX - (ae - N);
              (Te < 0 || Te > Ce) && (ce = !1, $.style.cursor = "default"), Te > Ce && (Te = Ce), $.style.left = Te < 0 ? 0 : Te + "px";
              const _ = document.getElementById("video");
              let je = Te / Ce;
              _.currentTime = _.duration * je, document.getElementById("videoPreview").currentTime = _.duration * je;
            }
          }, $.onmouseup = function(ne) {
            ce = !1, $.style.cursor = "default";
          };
        }
      }, 300);
    }, ie = async () => {
      if (D.file_progress != 100 && D.file_progress != 0)
        return alert("\u6587\u4EF6\u4E0A\u4F20\u4E2D\uFF0C\u8BF7\u52FF\u64CD\u4F5C\u3002"), !1;
      if (D.file_progress == 0)
        return ue(), !1;
      if (D.isEditVideoCover)
        if (D.editCoverIndex == 0) {
          let _e = document.getElementById("video").currentTime, $ = await ge(D.videoUrl, D.videoObj.editorWidth, D.videoObj.editorHeight, _e), N = xe($, "img.png"), ae = {
            success: function(ne, Ce, Te, _, je) {
              console.log(ne), D.tempVideoCover = ne, D.tinymceContent = '<video class="edui-faked-video" src="' + D.videoObj.src + '" controls="controls" controlslist="nodownload" poster="' + ne + '" width="' + D.videoObj.editorWidth + '" height="' + D.videoObj.editorHeight + '" data-url="' + D.videoObj.src + '"></video><p>&nbsp;</p>', D.isEditVideoCover = !1;
            },
            error: function(ne, Ce) {
              alert(Ce);
            }
          }, ce = [];
          ce.push(N), w.sourceTop == "acp" ? pe(ae, ce, 0) : Y(ae, ce, 0);
        } else {
          if (!D.uploadVideoCover)
            return alert("\u8BF7\u624B\u52A8\u4E0A\u4F20\u5C01\u9762"), !1;
          D.tempVideoCover = D.uploadVideoCover, D.tinymceContent = '<video class="edui-faked-video" src="' + D.videoObj.src + '" controls="controls" controlslist="nodownload" poster="' + D.uploadVideoCover + '" width="' + D.videoObj.editorWidth + '" height="' + D.videoObj.editorHeight + '" data-url="' + D.videoObj.src + '"></video><p>&nbsp;</p>', D.isEditVideoCover = !1;
        }
      else
        y("btnCallback", D.tinymceContent), ue();
    }, Ze = () => {
      De(w.mediaType);
    }, De = (_e) => {
      let $;
      switch (_e) {
        case 3:
          $ = ".mp3, .m4a";
          break;
        case 2:
          $ = ".mp4";
          break;
      }
      var N = document.getElementById("media_editor_input");
      N.setAttribute("accept", $), N.click(), N.onchange = function(ae) {
        var ce = ae.target.files[0];
        if (/(mp3|m4a|audio)/gi.test(ce.type) && ce.size > 200 * Math.pow(1024, 2))
          return alert({ msg: "\u4E0A\u4F20\u97F3\u9891\u5927\u5C0F\u4E0D\u8D85\u8FC7200M" }), !1;
        if (ce.type.match(/mp4/gi) && ce.size > 5 * Math.pow(1024, 3))
          return alert({ msg: "\u4E0A\u4F20\u89C6\u9891\u5927\u5C0F\u4E0D\u8D85\u8FC75GB" }), !1;
        if (_e == 3) {
          let ne = {
            status: 3,
            channel: w.channel,
            success: function(Te, _, je, Me, Je, Lt) {
              D.tinymceContent = '<audio class="edui-faked-audio" src="' + Te + '" controls="controls" controlslist="nodownload" data-url="' + Te + '" data-name="' + Lt.file_name + '" data-duration="' + Lt.duration + '"></audio><p>&nbsp;</p>', ae.target.value = "";
            },
            error: function(Te, _) {
              alert(_);
            }
          };
          console.log(ne);
          let Ce = [];
          Ce.push(ce), w.sourceTop == "acp" ? pe(ne, Ce, function(Te) {
            console.log(Te), D.fileUploadName = ce.name, D.fileProgressVisible = !0, D.file_progress = (Te * 100).toFixed(2);
          }) : Y(ne, Ce, function(Te) {
            console.log(Te), D.fileUploadName = ce.name, D.fileProgressVisible = !0, D.file_progress = (Te * 100).toFixed(2);
          });
        } else {
          let ne = {
            status: 1,
            channel: w.channel,
            success: async function(Te, _, je, Me, Je, Lt) {
              console.log(Lt);
              let dt = Lt.width, Tt = Lt.height;
              D.tempVideoCover = await Pt(_) || "", console.log("tempVideoCover:" + D.tempVideoCover), D.videoObj = {
                src: Te,
                width: Lt.width,
                height: Lt.height,
                cover: _
              }, Be(Te, dt, Tt, Lt.realTime), dt >= 690 && (dt = 690, Tt = parseInt(Lt.height / Lt.width * 690)), dt == 0 && (dt = 690, Tt = 388), D.videoObj.editorWidth = dt, D.videoObj.editorHeight = Tt, w.mediaType == 2 && (D.tinymceContent = '<video class="edui-faked-video" src="' + Te + '" controls="controls" controlslist="nodownload" poster="' + _ + '" width="' + dt + '" height="' + Tt + '" data-url="' + Te + '"></video><p>&nbsp;</p>'), ae.target.value = "";
            },
            error: function(Te, _) {
              alert(_);
            }
          };
          console.log(ne);
          let Ce = [];
          Ce.push(ce), w.sourceTop == "acp" ? pe(ne, Ce, function(Te) {
            console.log(Te), D.fileUploadName = ce.name, D.fileProgressVisible = !0, D.file_progress = (Te * 100).toFixed(2);
          }) : Y(ne, Ce, function(Te) {
            console.log(Te), D.fileUploadName = ce.name, D.fileProgressVisible = !0, D.file_progress = (Te * 100).toFixed(2);
          });
        }
      };
    }, Pt = async (_e) => new Promise(function($, N) {
      var ae = new Image();
      ae.src = _e, ae.onload = function(ce) {
        this.complete == !0 && $(_e);
      }, ae.onerror = function(ce) {
        $("");
      };
    }), Ct = (_e) => new Promise(($, N) => {
      const ae = new FileReader();
      let ce = "";
      ae.readAsDataURL(_e), ae.onload = () => {
        ce = ae.result;
      }, ae.onerror = (ne) => {
        N(ne);
      }, ae.onloadend = () => {
        const ne = new Image();
        ne.onload = () => {
          event.target.width / event.target.height == D.videoObj.width / D.videoObj.height ? $(null) : event.target.width > 6e3 || event.target.height > 3e4 ? (alert("\u56FE\u7247\u5EFA\u8BAE\u5C3A\u5BF8\u5C0F\u4E8E6000px*30000px"), $({ type: 1 })) : $({
            type: 0,
            url: ce
          });
        }, ne.src = ce;
      };
    }), Be = (_e, $, N, ae) => {
      w.sourceTop == "acp" ? Q({
        url: "/apis/upload/mdmedia/show_video_list",
        method: "post",
        props: { url: _e }
      }).then(async (ce) => {
        if (ce.data) {
          if (ce.data.list) {
            D.videoUrl = ce.data.list[ce.data.default];
            let ne = ae / 8;
            for (let Ce = 1, Te = ae; Ce <= Te; Ce += ne)
              D.videoCover.push(await ge(D.videoUrl, $, N, Ce, "small"));
          }
        } else
          alert(ce.message);
      }) : Q({
        url: "/api/v1/show_video_list",
        method: "post",
        props: { url: _e }
      }).then(async (ce) => {
        if (ce.data) {
          if (ce.data.list) {
            D.videoUrl = ce.data.list[ce.data.default], console.log(D.videoUrl);
            let ne = ae / 8;
            for (let Ce = 1, Te = ae; Ce <= Te; Ce += ne)
              D.videoCover.push(await ge(D.videoUrl, $, N, Ce, "small"));
          }
        } else
          alert(ce.message);
      });
    }, ge = async (_e, $, N, ae, ce) => new Promise(function(ne, Ce) {
      let Te = $, _ = N;
      ce == "small" && (Te = 140, _ = 78, $ < N && (Te = 78, _ = 140)), console.log(Te + _), console.log(ae);
      const je = document.createElement("video");
      je.setAttribute("crossOrigin", "anonymous"), je.setAttribute("src", _e), je.setAttribute("muted", "muted"), je.setAttribute("width", Te), je.setAttribute("height", _), je.currentTime = ae == 0 ? 0.1 : ae, je.addEventListener("loadeddata", async () => {
        const Me = document.createElement("canvas");
        Me.width = Te, Me.height = _, Me.getContext("2d").drawImage(je, 0, 0, Te, _);
        let Je = Me.toDataURL("image/jpeg");
        console.log(Je), ae == 1 && !D.tempVideoCover && (D.tempVideoCover = Je), ne(Je);
      });
    }), xe = (_e, $, N) => {
      let ae = _e.split(","), ce = ae[0].match(/:(.*?);/)[1], ne = atob(ae[1]), Ce = ne.length, Te = new Uint8Array(Ce);
      for (; Ce--; )
        Te[Ce] = ne.charCodeAt(Ce);
      return new File([Te], $, { type: ce });
    };
    return (_e, $) => (Dn(), ir(Is, null, [
      GZ,
      Ja(y5, {
        isShow: m.isShow,
        onClose: ue
      }, {
        title: ka(() => [
          KZ
        ]),
        content: ka(() => [
          !D.fileProgressVisible && !D.isEditVideoCover ? (Dn(), ir("div", {
            key: 0,
            class: "upload-video",
            onClick: Ro(Ze, ["stop"])
          }, [
            Rt("p", null, [
              Rt("span", null, "\u672C\u5730" + Eo(m.mediaType == 2 ? "\u89C6\u9891" : "\u97F3\u9891"), 1),
              Rt("span", null, Eo(m.mediaType == 2 ? "\u63A8\u8350\u6BD4\u4F8B 16\uFF1A9\uFF0C\u683C\u5F0F mp4\uFF0C\u4E0D\u5927\u4E8E 2GB" : "\u652F\u6301mp3,m4a\u683C\u5F0F\uFF0C\u5927\u5C0F\u4E0D\u8D85\u8FC7200MB\uFF0C\u8BF7\u5C3D\u91CF\u4E0A\u4F20\u9AD8\u97F3\u8D28\u97F3\u9891\u3002"), 1)
            ])
          ], 8, XZ)) : ba("", !0),
          D.fileProgressVisible && !D.isEditVideoCover ? (Dn(), ir("div", {
            key: 1,
            class: Hr(["progress", { video: m.mediaType == 2 }])
          }, [
            m.mediaType == 2 ? (Dn(), ir(Is, { key: 0 }, [
              D.canvansLoading ? (Dn(), ir("div", YZ)) : ba("", !0),
              Rt("div", ZZ, [
                Rt("img", {
                  class: Hr([{ horizontal: D.videoObj.width >= D.videoObj.height }, { erect: D.videoObj.width < D.videoObj.height }]),
                  src: D.tempVideoCover
                }, null, 10, JZ)
              ]),
              Rt("div", QZ, [
                Rt("div", eJ, Eo(D.fileUploadName), 1),
                Rt("span", null, Eo(Mt(J)), 1),
                D.file_progress == 100 ? (Dn(), ir("div", tJ, [
                  Rt("p", {
                    onClick: Ro(ht, ["stop"])
                  }, oJ, 8, nJ)
                ])) : (Dn(), ir("div", iJ, [
                  Rt("div", {
                    class: "line-inner",
                    style: Bd({ width: D.file_progress + "%" })
                  }, null, 4)
                ]))
              ])
            ], 64)) : (Dn(), ir(Is, { key: 1 }, [
              Rt("div", uJ, [
                Zu(Eo(D.fileUploadName), 1),
                Rt("span", null, Eo(Mt(J)), 1)
              ]),
              Rt("div", sJ, [
                Rt("div", {
                  class: "line-inner",
                  style: Bd({ width: D.file_progress + "%" })
                }, null, 4)
              ])
            ], 64))
          ], 2)) : ba("", !0),
          Hf(Rt("div", {
            class: Hr(["isEditVideoCover", { horizontal: D.videoObj.width >= D.videoObj.height }, { erect: D.videoObj.width < D.videoObj.height }])
          }, [
            Rt("div", lJ, [
              (Dn(!0), ir(Is, null, ak(D.editVideoTab, (N, ae) => (Dn(), ir("div", {
                class: Hr(["item", { active: D.editCoverIndex == ae }]),
                key: ae,
                onClick: Ro((ce) => D.editCoverIndex = ae, ["stop"])
              }, Eo(N), 11, cJ))), 128))
            ]),
            Hf(Rt("div", null, [
              Rt("div", fJ, [
                Rt("video", {
                  id: "video",
                  crossOrigin: "anonymous",
                  src: D.videoUrl
                }, null, 8, vJ),
                dJ
              ]),
              D.videoCover.length > 0 ? (Dn(), ir("div", mJ, [
                (Dn(!0), ir(Is, null, ak(D.videoCover, (N, ae) => (Dn(), ir("div", {
                  key: ae,
                  onClick: Ro((ce) => ee(ae), ["stop"])
                }, [
                  Rt("img", { src: N }, null, 8, pJ)
                ], 8, gJ))), 128)),
                Rt("div", {
                  id: "dragPreview",
                  class: Hr(["video_preview", { horizontal: D.videoObj.width >= D.videoObj.height }, { erect: D.videoObj.width < D.videoObj.height }])
                }, [
                  Rt("video", {
                    id: "videoPreview",
                    crossOrigin: "anonymous",
                    src: D.videoUrl
                  }, null, 8, hJ)
                ], 2)
              ])) : ba("", !0),
              bJ
            ], 512), [
              [Dd, D.editCoverIndex == 0]
            ]),
            D.editCoverIndex == 1 ? (Dn(), ir("div", {
              key: 0,
              class: "upload_video_cover",
              onClick: Ro(ze, ["stop"])
            }, [
              D.uploadVideoCover ? (Dn(), ir("img", {
                key: 0,
                class: Hr([{ horizontal: D.videoObj.width >= D.videoObj.height }, { erect: D.videoObj.width < D.videoObj.height }]),
                src: D.uploadVideoCover
              }, null, 10, wJ)) : (Dn(), ir("div", CJ, kJ))
            ], 8, yJ)) : ba("", !0)
          ], 2), [
            [Dd, D.isEditVideoCover]
          ])
        ]),
        btn_list: ka(() => [
          Rt("div", TJ, [
            Ja(Qb, {
              txt: D.confirmTxt,
              onBtnCallback: ie
            }, null, 8, ["txt"])
          ])
        ]),
        _: 1
      }, 8, ["isShow"]),
      Ja(cR, {
        acpToken: w.acpToken,
        env: w.env,
        sourceTop: w.sourceTop,
        channel: w.channel,
        isShow: D.cropperShow,
        cropUrl: D.cropperUrl,
        autoCropWidth: D.autoCropWidth,
        autoCropHeight: D.autoCropHeight,
        fixedNumber: D.fixedNumber,
        onClose: $[0] || ($[0] = (N) => D.cropperShow = !1),
        onConfirm: Ge
      }, null, 8, ["acpToken", "env", "sourceTop", "channel", "isShow", "cropUrl", "autoCropWidth", "autoCropHeight", "fixedNumber"])
    ], 64));
  }
}, _J = /* @__PURE__ */ Md(EJ, [["__scopeId", "data-v-1ca7f98c"]]);
const jm = (m) => (NC("data-v-73efcc5a"), m = m(), IC(), m), AJ = /* @__PURE__ */ Zu(" \u201C\u6A2A\u5411\u6ED1\u52A8\u201D\u56FE\u7247\u4E0A\u4F20 "), OJ = ["onClick"], DJ = /* @__PURE__ */ jm(() => /* @__PURE__ */ Rt("i", { class: "addImg" }, null, -1)), BJ = /* @__PURE__ */ Zu("\u6DFB\u52A0\u56FE\u7247"), RJ = [
  DJ,
  BJ
], MJ = {
  key: 0,
  class: "loading"
}, PJ = { class: "top" }, NJ = { class: "item" }, IJ = /* @__PURE__ */ jm(() => /* @__PURE__ */ Rt("label", null, "\u56FE\u7247\u5C55\u793A\u8303\u56F4", -1)), FJ = { class: "itemRight" }, $J = /* @__PURE__ */ Zu("\u56FE\u7247\u5C55\u793A\u9AD8\u5EA6\u56FA\u5B9A 780px\uFF0C\u5BBD\u5EA6\u4E0D\u9650\uFF0C"), LJ = /* @__PURE__ */ jm(() => /* @__PURE__ */ Rt("p", { class: "tips" }, "\u53EF\u4E0A\u4F20\u591A\u5F20\u56FE\u7247\uFF0C\u5355\u56FE\u5C3A\u5BF8\u5EFA\u8BAE\u4E3A 4000*780px\uFF0C\u4E0D\u5927\u4E8E3mb\uFF0C\u56FE\u7247\u683C\u5F0F jpg\u3001jpeg\u3001png\u3001gif\uFF0C\u5206\u8FA8\u7387 72 \u50CF\u7D20\uFF0F\u82F1\u5BF8\u3002", -1)), zJ = { class: "showTips" }, HJ = /* @__PURE__ */ jm(() => /* @__PURE__ */ Rt("canvas", {
  class: "canvas",
  id: "pag"
}, null, -1)), VJ = [
  HJ
], UJ = { class: "item" }, jJ = /* @__PURE__ */ jm(() => /* @__PURE__ */ Rt("label", null, "\u591A\u56FE\u95F4\u9699\u8BBE\u7F6E", -1)), WJ = { class: "itemRight" }, qJ = { class: "checkInput" }, GJ = {
  key: 0,
  class: "singleselect"
}, KJ = {
  key: 1,
  class: "singleunselected"
}, XJ = /* @__PURE__ */ Zu(" \u65E0\u7F1D\u62FC\u63A5 "), YJ = {
  key: 0,
  class: "singleselect"
}, ZJ = {
  key: 1,
  class: "singleunselected"
}, JJ = /* @__PURE__ */ Zu(" \u5E26\u95F4\u8DDD "), QJ = { class: "item" }, eQ = {
  key: 0,
  class: "upload"
}, tQ = ["onClick"], nQ = /* @__PURE__ */ jm(() => /* @__PURE__ */ Rt("div", { class: "logo" }, [
  /* @__PURE__ */ Rt("i", { class: "plus" })
], -1)), rQ = /* @__PURE__ */ jm(() => /* @__PURE__ */ Rt("p", null, "\u6DFB\u52A0\u56FE\u7247", -1)), aQ = [
  nQ,
  rQ
], oQ = ["onClick"], iQ = ["src"], uQ = { class: "cover_op" }, sQ = ["onClick"], lQ = /* @__PURE__ */ jm(() => /* @__PURE__ */ Rt("i", { class: "refresh" }, null, -1)), cQ = [
  lQ
], fQ = ["onClick"], vQ = /* @__PURE__ */ jm(() => /* @__PURE__ */ Rt("i", { class: "trash" }, null, -1)), dQ = [
  vQ
], mQ = { key: 0 }, gQ = /* @__PURE__ */ jm(() => /* @__PURE__ */ Rt("i", { class: "back" }, null, -1)), pQ = /* @__PURE__ */ Zu("\u5DE6\u53F3\u6ED1\u52A8\u67E5\u770B\u66F4\u591A"), hQ = /* @__PURE__ */ jm(() => /* @__PURE__ */ Rt("i", { class: "next" }, null, -1)), bQ = [
  gQ,
  pQ,
  hQ
], yQ = { class: "btn_list end" }, wQ = {
  __name: "scroImage",
  props: {
    env: {
      type: String,
      default: ""
    },
    acpToken: {
      type: String,
      default: ""
    },
    sourceTop: {
      type: String,
      default: "m"
    },
    isShow: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close", "btnCallback"],
  setup(m, { emit: y }) {
    const w = m, E = () => b1.get("MDUSERTOKEN"), P = function(Be) {
      console.log("err", Be);
    }, H = !1, X = w.env, j = w.acpToken, le = {
      client: 4,
      user_id: E() ? E().split("#")[0] : "",
      userid: E() ? E().split("#")[0] : "",
      token: E() ? E().split("#")[1] : ""
    };
    let Q = {};
    w.sourceTop == "acp" ? Q = Ul({
      host: "acp",
      env: X,
      header: {
        client: 4,
        user_id: j ? j.split(":")[0] : "",
        userid: j ? j.split(":")[0] : "",
        token: j ? j.split(":")[1] : ""
      },
      needLogin: H,
      callback: P
    }) : Q = Ul({
      env: X,
      header: le,
      acpneedLogin: H,
      acpcallback: P
    });
    const pe = bc(Q, j ? j.split(":")[0] : ""), Y = bc(Q, E() ? E().split("#")[0] : "");
    Xc(() => {
      D("https://s.moimg.net/js/libpag.min.js", (Be) => {
        window.libpag.PAGInit().then((ge) => {
          window.PAG = ge;
          const xe = "https://p6.moimg.net/md/editor/libpag.pag";
          fetch(xe).then((_e) => _e.blob()).then(async (_e) => {
            const $ = new window.File([_e], xe.replace(/(.*\/)*([^.]+)/i, "$2")), N = await ge.PAGFile.load($);
            document.getElementById("pag").width = N.width(), document.getElementById("pag").height = N.height();
            const ae = await ge.PAGView.init(N, "#pag");
            ae.setRepeatCount(0), await ae.play(), console.log("play");
          });
        });
      });
    });
    const D = (Be, ge) => {
      var xe = document.createElement("script");
      xe.type = "text/javascript", xe.defer = !0, xe.async = !0, xe.src = Be, document.getElementsByTagName("head")[0].appendChild(xe), typeof ge == "function" && (xe.readyState ? xe.onreadystatechange = function() {
        /complete|loaded/.test(xe.readyState) && (xe.onreadystatechange = null, ge());
      } : xe.onload = function() {
        ge();
      });
    }, J = Um({
      cancelTxt: "\u53D6\u6D88",
      confirmTxt: "\u786E\u5B9A",
      color: "#7A8087",
      borderColor: "#BCBFC3",
      btnColor: "#fff",
      btnMargin: "0 20px 0 0",
      loading: !1,
      showTips: !1,
      clearance: !1,
      coverIndex: 0,
      isReplace: !1,
      activeIndex: -1,
      list: []
    }), ue = () => {
      J.list = [], y("close");
    }, ee = () => {
      J.showTips = !1;
    }, Ge = () => {
      if (J.showTips = !1, J.list && J.list.length == 0)
        return alert("\u8BF7\u4E0A\u4F20\u56FE\u7247"), !1;
      let Be = '<nav class="nav_img';
      J.clearance ? Be += ' clearance">' : Be += '">', J.list.forEach((ge) => {
        Be += '<img class="long-img-box', J.clearance ? Be += ' clearance" ' : Be += '" ', Be += 'src="' + ge.src + '">';
      }), Be += "</nav><p>&nbsp;</p>", y("btnCallback", Be), ue();
    }, ze = () => {
      J.showTips = !1;
      var Be = document.createElement("input");
      Be.setAttribute("type", "file"), Be.setAttribute("accept", "image/*"), J.isReplace || Be.setAttribute("multiple", "multiple"), Be.click();
      let ge = J.list.length;
      Be.onchange = function(xe) {
        for (var _e = 0, $ = xe.target.files.length; _e < $; _e++) {
          let N = xe.target.files[_e];
          if (N.size / 1024 / 1024 > 10) {
            alert("\u6587\u4EF6" + N.name + "\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC710M"), J.loading = !1;
            return;
          }
          J.loading = !0, setTimeout(function() {
            console.log("500 time out"), De(N, 6e3, 3e4).then((ce) => {
              if (ce) {
                let ne = {
                  success: function(Te, _, je, Me, Je) {
                    let Lt = 260, dt = parseInt(Je.width / Je.height * 260), Tt = { src: Te, width: dt, height: Lt };
                    J.isReplace ? (J.loading = !1, J.list.splice(J.coverIndex, 1, Tt)) : J.list.push(Tt);
                  },
                  error: function(Te, _) {
                    alert(_), J.loading = !1, console.log(_);
                  }
                }, Ce = [];
                Ce.push(N), w.sourceTop == "acp" ? pe(ne, Ce, 0) : Y(ne, Ce, 0);
              }
            });
          }, 500);
        }
        if (!J.isReplace) {
          ge += xe.target.files.length;
          let N = null;
          N = setInterval(function() {
            J.loading && J.list.length == ge && (clearInterval(N), J.loading = !1);
          }, 300);
        }
      };
    }, ht = () => {
      J.isReplace = !1, ze();
    }, ie = (Be) => {
      J.isReplace = !0, J.coverIndex = Be, ze();
    }, Ze = (Be) => {
      J.list.splice(Be, 1);
    }, De = (Be, ge, xe) => new Promise((_e, $) => {
      const N = new FileReader();
      let ae = "";
      N.readAsDataURL(Be), N.onload = () => {
        ae = N.result;
      }, N.onerror = (ce) => {
        $(ce);
      }, N.onloadend = () => {
        const ce = new Image();
        ce.onload = () => {
          event.target.width > ge ? (alert("\u5EFA\u8BAE\u56FE\u7247\u5BBD\u5EA6\u5C3A\u5BF8\u5C0F\u4E8E" + ge + "px"), J.loading = !1, _e(null)) : event.target.height > xe ? (alert("\u5EFA\u8BAE\u56FE\u7247\u9AD8\u5EA6\u5C3A\u5BF8\u5C0F\u4E8E" + xe + "px"), J.loading = !1, _e(null)) : _e(ae);
        }, ce.src = ae;
      };
    }).catch((_e) => {
      console.log(_e);
    }), Pt = (Be) => {
      J.showTips = !1, J.activeIndex = Be, setTimeout(function() {
        document.getElementsByClassName("show")[0].scrollLeft + 580 > document.getElementsByClassName("activeScrollImage")[0].offsetLeft && document.getElementsByClassName("show")[0].scrollLeft + 600 - document.getElementsByClassName("activeScrollImage")[0].offsetLeft < document.getElementsByClassName("activeScrollImage")[0].scrollLeft + document.getElementsByClassName("activeScrollImage")[0].offsetWidth ? (document.getElementsByClassName("activeScrollImage")[0].lastElementChild.childNodes[0].style.left = document.getElementsByClassName("show")[0].scrollLeft + 580 - document.getElementsByClassName("activeScrollImage")[0].offsetLeft + "px", document.getElementsByClassName("activeScrollImage")[0].lastElementChild.childNodes[1].style.left = document.getElementsByClassName("show")[0].scrollLeft + 620 - document.getElementsByClassName("activeScrollImage")[0].offsetLeft + "px") : (console.log("normal"), document.getElementsByClassName("activeScrollImage")[0].lastElementChild.childNodes[0].style.left = "", document.getElementsByClassName("activeScrollImage")[0].lastElementChild.childNodes[1].style.left = "");
      }, 50);
    }, Ct = (Be) => {
      document.getElementsByClassName("activeScrollImage")[0] && (Be.target.scrollLeft + 580 > document.getElementsByClassName("activeScrollImage")[0].offsetLeft && Be.target.scrollLeft + 600 - document.getElementsByClassName("activeScrollImage")[0].offsetLeft < document.getElementsByClassName("activeScrollImage")[0].scrollLeft + document.getElementsByClassName("activeScrollImage")[0].offsetWidth ? (document.getElementsByClassName("activeScrollImage")[0].lastElementChild.childNodes[0].style.left = Be.target.scrollLeft + 580 - document.getElementsByClassName("activeScrollImage")[0].offsetLeft + "px", document.getElementsByClassName("activeScrollImage")[0].lastElementChild.childNodes[1].style.left = Be.target.scrollLeft + 620 - document.getElementsByClassName("activeScrollImage")[0].offsetLeft + "px") : (console.log("normal"), document.getElementsByClassName("activeScrollImage")[0].lastElementChild.childNodes[0].style.left = "", document.getElementsByClassName("activeScrollImage")[0].lastElementChild.childNodes[1].style.left = ""));
    };
    return (Be, ge) => (Dn(), Mo(y5, {
      isShow: m.isShow,
      onClose: ue,
      onClick: Ro(ee, ["stop"])
    }, {
      title: ka(() => [
        Rt("h2", null, [
          AJ,
          Rt("a", {
            class: "flex",
            onClick: Ro(ht, ["stop"])
          }, RJ, 8, OJ)
        ])
      ]),
      content: ka(() => [
        J.loading ? (Dn(), ir("div", MJ)) : ba("", !0),
        Rt("div", PJ, [
          Rt("div", NJ, [
            IJ,
            Rt("div", FJ, [
              Rt("p", null, [
                $J,
                Rt("a", {
                  onClick: ge[0] || (ge[0] = Ro((xe) => J.showTips = !J.showTips, ["stop"]))
                }, "\u67E5\u770B\u793A\u610F\u56FE")
              ]),
              LJ,
              Hf(Rt("div", zJ, VJ, 512), [
                [Dd, J.showTips]
              ])
            ])
          ]),
          Rt("div", UJ, [
            jJ,
            Rt("div", WJ, [
              Rt("div", qJ, [
                Rt("p", {
                  class: Hr({ checked: !J.clearance }),
                  onClick: ge[1] || (ge[1] = Ro((xe) => J.clearance = !J.clearance, ["stop"]))
                }, [
                  J.clearance ? (Dn(), ir("i", KJ)) : (Dn(), ir("i", GJ)),
                  XJ
                ], 2),
                Rt("p", {
                  class: Hr({ checked: J.clearance }),
                  onClick: ge[2] || (ge[2] = Ro((xe) => J.clearance = !J.clearance, ["stop"]))
                }, [
                  J.clearance ? (Dn(), ir("i", YJ)) : (Dn(), ir("i", ZJ)),
                  JJ
                ], 2)
              ])
            ])
          ]),
          Rt("div", QJ, [
            J.list.length == 0 ? (Dn(), ir("div", eQ, [
              Rt("div", {
                class: "upload_btn",
                onClick: Ro(ht, ["stop"])
              }, aQ, 8, tQ)
            ])) : (Dn(), ir("div", {
              key: 1,
              class: "show",
              onScroll: Ct
            }, [
              (Dn(!0), ir(Is, null, ak(J.list, (xe, _e) => (Dn(), ir("div", {
                class: Hr(["cover", { clearance: Be.clearance }, { activeScrollImage: J.activeIndex == _e }]),
                key: _e,
                style: Bd({ width: xe.width + "px" }),
                onClick: Ro(($) => Pt(_e), ["stop"])
              }, [
                Rt("img", {
                  src: xe.src
                }, null, 8, iQ),
                Rt("div", uQ, [
                  Rt("label", {
                    class: "op replace",
                    onClick: Ro(($) => ie(_e), ["stop"])
                  }, cQ, 8, sQ),
                  Rt("div", {
                    class: "op del",
                    onClick: Ro(($) => Ze(_e), ["stop"])
                  }, dQ, 8, fQ)
                ])
              ], 14, oQ))), 128))
            ], 32))
          ]),
          J.list.length > 0 ? (Dn(), ir("p", mQ, bQ)) : ba("", !0)
        ])
      ]),
      btn_list: ka(() => [
        Rt("div", yQ, [
          Ja(Qb, {
            txt: J.cancelTxt,
            btnColor: J.btnColor,
            color: J.color,
            borderColor: J.borderColor,
            btnMargin: J.btnMargin,
            onBtnCallback: ue
          }, null, 8, ["txt", "btnColor", "color", "borderColor", "btnMargin"]),
          Ja(Qb, {
            txt: J.confirmTxt,
            onBtnCallback: Ge
          }, null, 8, ["txt"])
        ])
      ]),
      _: 1
    }, 8, ["isShow", "onClick"]));
  }
}, CQ = /* @__PURE__ */ Md(wQ, [["__scopeId", "data-v-73efcc5a"]]), SQ = 'a[href],button:not([disabled]),button:not([hidden]),:not([tabindex="-1"]),input:not([disabled]),input:not([type="hidden"]),select:not([disabled]),textarea:not([disabled])', xQ = (m) => process.env.NODE_ENV === "test" ? !0 : getComputedStyle(m).position === "fixed" ? !1 : m.offsetParent !== null, BH = (m) => Array.from(m.querySelectorAll(SQ)).filter((y) => kQ(y) && xQ(y)), kQ = (m) => {
  if (m.tabIndex > 0 || m.tabIndex === 0 && m.getAttribute("tabIndex") !== null)
    return !0;
  if (m.disabled)
    return !1;
  switch (m.nodeName) {
    case "A":
      return !!m.href && m.rel !== "ignore";
    case "INPUT":
      return !(m.type === "hidden" || m.type === "file");
    case "BUTTON":
    case "SELECT":
    case "TEXTAREA":
      return !0;
    default:
      return !1;
  }
};
var RH;
const Kc = typeof window < "u", TQ = (m) => typeof m == "string", EQ = () => {
};
Kc && ((RH = window == null ? void 0 : window.navigator) == null ? void 0 : RH.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function nL(m) {
  return typeof m == "function" ? m() : Mt(m);
}
function _Q(m) {
  return m;
}
function rL(m) {
  return jX() ? (vV(m), !0) : !1;
}
function AQ(m, y = !0) {
  Pp() ? Xc(m) : y ? m() : Vl(m);
}
function z9(m, y, w = {}) {
  const {
    immediate: E = !0
  } = w, P = ja(!1);
  let H = null;
  function X() {
    H && (clearTimeout(H), H = null);
  }
  function j() {
    P.value = !1, X();
  }
  function le(...Q) {
    X(), P.value = !0, H = setTimeout(() => {
      P.value = !1, H = null, m(...Q);
    }, nL(y));
  }
  return E && (P.value = !0, Kc && le()), rL(j), {
    isPending: UX(P),
    start: le,
    stop: j
  };
}
function RV(m) {
  var y;
  const w = nL(m);
  return (y = w == null ? void 0 : w.$el) != null ? y : w;
}
const MV = Kc ? window : void 0;
function PV(...m) {
  let y, w, E, P;
  if (TQ(m[0]) || Array.isArray(m[0]) ? ([w, E, P] = m, y = MV) : [y, w, E, P] = m, !y)
    return EQ;
  Array.isArray(w) || (w = [w]), Array.isArray(E) || (E = [E]);
  const H = [], X = () => {
    H.forEach((pe) => pe()), H.length = 0;
  }, j = (pe, Y, D, J) => (pe.addEventListener(Y, D, J), () => pe.removeEventListener(Y, D, J)), le = Wi(() => [RV(y), nL(P)], ([pe, Y]) => {
    X(), pe && H.push(...w.flatMap((D) => E.map((J) => j(pe, D, J, Y))));
  }, { immediate: !0, flush: "post" }), Q = () => {
    le(), X();
  };
  return rL(Q), Q;
}
function OQ(m, y = !1) {
  const w = ja(), E = () => w.value = Boolean(m());
  return E(), AQ(E, y), w;
}
const H9 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, V9 = "__vueuse_ssr_handlers__";
H9[V9] = H9[V9] || {};
H9[V9];
var MH = Object.getOwnPropertySymbols, DQ = Object.prototype.hasOwnProperty, BQ = Object.prototype.propertyIsEnumerable, RQ = (m, y) => {
  var w = {};
  for (var E in m)
    DQ.call(m, E) && y.indexOf(E) < 0 && (w[E] = m[E]);
  if (m != null && MH)
    for (var E of MH(m))
      y.indexOf(E) < 0 && BQ.call(m, E) && (w[E] = m[E]);
  return w;
};
function NV(m, y, w = {}) {
  const E = w, { window: P = MV } = E, H = RQ(E, ["window"]);
  let X;
  const j = OQ(() => P && "ResizeObserver" in P), le = () => {
    X && (X.disconnect(), X = void 0);
  }, Q = Wi(() => RV(m), (Y) => {
    le(), j.value && P && Y && (X = new ResizeObserver(y), X.observe(Y, H));
  }, { immediate: !0, flush: "post" }), pe = () => {
    le(), Q();
  };
  return rL(pe), {
    isSupported: j,
    stop: pe
  };
}
var PH;
(function(m) {
  m.UP = "UP", m.RIGHT = "RIGHT", m.DOWN = "DOWN", m.LEFT = "LEFT", m.NONE = "NONE";
})(PH || (PH = {}));
var MQ = Object.defineProperty, NH = Object.getOwnPropertySymbols, PQ = Object.prototype.hasOwnProperty, NQ = Object.prototype.propertyIsEnumerable, IH = (m, y, w) => y in m ? MQ(m, y, { enumerable: !0, configurable: !0, writable: !0, value: w }) : m[y] = w, IQ = (m, y) => {
  for (var w in y || (y = {}))
    PQ.call(y, w) && IH(m, w, y[w]);
  if (NH)
    for (var w of NH(y))
      NQ.call(y, w) && IH(m, w, y[w]);
  return m;
};
const FQ = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
IQ({
  linear: _Q
}, FQ);
const $Q = () => Kc && /firefox/i.test(window.navigator.userAgent);
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const rk = () => {
}, LQ = Object.assign, zQ = Object.prototype.hasOwnProperty, eR = (m, y) => zQ.call(m, y), HQ = Array.isArray, RC = (m) => typeof m == "function", zm = (m) => typeof m == "string", d5 = (m) => m !== null && typeof m == "object", VQ = (m) => {
  const y = /* @__PURE__ */ Object.create(null);
  return (w) => y[w] || (y[w] = m(w));
}, UQ = /-(\w)/g, jQ = VQ((m) => m.replace(UQ, (y, w) => w ? w.toUpperCase() : ""));
var WQ = typeof global == "object" && global && global.Object === Object && global;
const qQ = WQ;
var GQ = typeof self == "object" && self && self.Object === Object && self, KQ = qQ || GQ || Function("return this")();
const aL = KQ;
var XQ = aL.Symbol;
const ik = XQ;
var IV = Object.prototype, YQ = IV.hasOwnProperty, ZQ = IV.toString, l5 = ik ? ik.toStringTag : void 0;
function JQ(m) {
  var y = YQ.call(m, l5), w = m[l5];
  try {
    m[l5] = void 0;
    var E = !0;
  } catch {
  }
  var P = ZQ.call(m);
  return E && (y ? m[l5] = w : delete m[l5]), P;
}
var QQ = Object.prototype, eee = QQ.toString;
function tee(m) {
  return eee.call(m);
}
var nee = "[object Null]", ree = "[object Undefined]", FH = ik ? ik.toStringTag : void 0;
function FV(m) {
  return m == null ? m === void 0 ? ree : nee : FH && FH in Object(m) ? JQ(m) : tee(m);
}
function aee(m) {
  return m != null && typeof m == "object";
}
var oee = "[object Symbol]";
function oL(m) {
  return typeof m == "symbol" || aee(m) && FV(m) == oee;
}
function iee(m, y) {
  for (var w = -1, E = m == null ? 0 : m.length, P = Array(E); ++w < E; )
    P[w] = y(m[w], w, m);
  return P;
}
var uee = Array.isArray;
const iL = uee;
var see = 1 / 0, $H = ik ? ik.prototype : void 0, LH = $H ? $H.toString : void 0;
function $V(m) {
  if (typeof m == "string")
    return m;
  if (iL(m))
    return iee(m, $V) + "";
  if (oL(m))
    return LH ? LH.call(m) : "";
  var y = m + "";
  return y == "0" && 1 / m == -see ? "-0" : y;
}
function LV(m) {
  var y = typeof m;
  return m != null && (y == "object" || y == "function");
}
var lee = "[object AsyncFunction]", cee = "[object Function]", fee = "[object GeneratorFunction]", vee = "[object Proxy]";
function dee(m) {
  if (!LV(m))
    return !1;
  var y = FV(m);
  return y == cee || y == fee || y == lee || y == vee;
}
var mee = aL["__core-js_shared__"];
const E9 = mee;
var zH = function() {
  var m = /[^.]+$/.exec(E9 && E9.keys && E9.keys.IE_PROTO || "");
  return m ? "Symbol(src)_1." + m : "";
}();
function gee(m) {
  return !!zH && zH in m;
}
var pee = Function.prototype, hee = pee.toString;
function bee(m) {
  if (m != null) {
    try {
      return hee.call(m);
    } catch {
    }
    try {
      return m + "";
    } catch {
    }
  }
  return "";
}
var yee = /[\\^$.*+?()[\]{}|]/g, wee = /^\[object .+?Constructor\]$/, Cee = Function.prototype, See = Object.prototype, xee = Cee.toString, kee = See.hasOwnProperty, Tee = RegExp(
  "^" + xee.call(kee).replace(yee, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Eee(m) {
  if (!LV(m) || gee(m))
    return !1;
  var y = dee(m) ? Tee : wee;
  return y.test(bee(m));
}
function _ee(m, y) {
  return m == null ? void 0 : m[y];
}
function zV(m, y) {
  var w = _ee(m, y);
  return Eee(w) ? w : void 0;
}
function Aee(m, y) {
  return m === y || m !== m && y !== y;
}
var Oee = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Dee = /^\w*$/;
function Bee(m, y) {
  if (iL(m))
    return !1;
  var w = typeof m;
  return w == "number" || w == "symbol" || w == "boolean" || m == null || oL(m) ? !0 : Dee.test(m) || !Oee.test(m) || y != null && m in Object(y);
}
var Ree = zV(Object, "create");
const m5 = Ree;
function Mee() {
  this.__data__ = m5 ? m5(null) : {}, this.size = 0;
}
function Pee(m) {
  var y = this.has(m) && delete this.__data__[m];
  return this.size -= y ? 1 : 0, y;
}
var Nee = "__lodash_hash_undefined__", Iee = Object.prototype, Fee = Iee.hasOwnProperty;
function $ee(m) {
  var y = this.__data__;
  if (m5) {
    var w = y[m];
    return w === Nee ? void 0 : w;
  }
  return Fee.call(y, m) ? y[m] : void 0;
}
var Lee = Object.prototype, zee = Lee.hasOwnProperty;
function Hee(m) {
  var y = this.__data__;
  return m5 ? y[m] !== void 0 : zee.call(y, m);
}
var Vee = "__lodash_hash_undefined__";
function Uee(m, y) {
  var w = this.__data__;
  return this.size += this.has(m) ? 0 : 1, w[m] = m5 && y === void 0 ? Vee : y, this;
}
function MC(m) {
  var y = -1, w = m == null ? 0 : m.length;
  for (this.clear(); ++y < w; ) {
    var E = m[y];
    this.set(E[0], E[1]);
  }
}
MC.prototype.clear = Mee;
MC.prototype.delete = Pee;
MC.prototype.get = $ee;
MC.prototype.has = Hee;
MC.prototype.set = Uee;
function jee() {
  this.__data__ = [], this.size = 0;
}
function fR(m, y) {
  for (var w = m.length; w--; )
    if (Aee(m[w][0], y))
      return w;
  return -1;
}
var Wee = Array.prototype, qee = Wee.splice;
function Gee(m) {
  var y = this.__data__, w = fR(y, m);
  if (w < 0)
    return !1;
  var E = y.length - 1;
  return w == E ? y.pop() : qee.call(y, w, 1), --this.size, !0;
}
function Kee(m) {
  var y = this.__data__, w = fR(y, m);
  return w < 0 ? void 0 : y[w][1];
}
function Xee(m) {
  return fR(this.__data__, m) > -1;
}
function Yee(m, y) {
  var w = this.__data__, E = fR(w, m);
  return E < 0 ? (++this.size, w.push([m, y])) : w[E][1] = y, this;
}
function ck(m) {
  var y = -1, w = m == null ? 0 : m.length;
  for (this.clear(); ++y < w; ) {
    var E = m[y];
    this.set(E[0], E[1]);
  }
}
ck.prototype.clear = jee;
ck.prototype.delete = Gee;
ck.prototype.get = Kee;
ck.prototype.has = Xee;
ck.prototype.set = Yee;
var Zee = zV(aL, "Map");
const Jee = Zee;
function Qee() {
  this.size = 0, this.__data__ = {
    hash: new MC(),
    map: new (Jee || ck)(),
    string: new MC()
  };
}
function ete(m) {
  var y = typeof m;
  return y == "string" || y == "number" || y == "symbol" || y == "boolean" ? m !== "__proto__" : m === null;
}
function vR(m, y) {
  var w = m.__data__;
  return ete(y) ? w[typeof y == "string" ? "string" : "hash"] : w.map;
}
function tte(m) {
  var y = vR(this, m).delete(m);
  return this.size -= y ? 1 : 0, y;
}
function nte(m) {
  return vR(this, m).get(m);
}
function rte(m) {
  return vR(this, m).has(m);
}
function ate(m, y) {
  var w = vR(this, m), E = w.size;
  return w.set(m, y), this.size += w.size == E ? 0 : 1, this;
}
function LC(m) {
  var y = -1, w = m == null ? 0 : m.length;
  for (this.clear(); ++y < w; ) {
    var E = m[y];
    this.set(E[0], E[1]);
  }
}
LC.prototype.clear = Qee;
LC.prototype.delete = tte;
LC.prototype.get = nte;
LC.prototype.has = rte;
LC.prototype.set = ate;
var ote = "Expected a function";
function uL(m, y) {
  if (typeof m != "function" || y != null && typeof y != "function")
    throw new TypeError(ote);
  var w = function() {
    var E = arguments, P = y ? y.apply(this, E) : E[0], H = w.cache;
    if (H.has(P))
      return H.get(P);
    var X = m.apply(this, E);
    return w.cache = H.set(P, X) || H, X;
  };
  return w.cache = new (uL.Cache || LC)(), w;
}
uL.Cache = LC;
var ite = 500;
function ute(m) {
  var y = uL(m, function(E) {
    return w.size === ite && w.clear(), E;
  }), w = y.cache;
  return y;
}
var ste = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, lte = /\\(\\)?/g, cte = ute(function(m) {
  var y = [];
  return m.charCodeAt(0) === 46 && y.push(""), m.replace(ste, function(w, E, P, H) {
    y.push(P ? H.replace(lte, "$1") : E || w);
  }), y;
});
const fte = cte;
function vte(m) {
  return m == null ? "" : $V(m);
}
function dte(m, y) {
  return iL(m) ? m : Bee(m, y) ? [m] : fte(vte(m));
}
var mte = 1 / 0;
function gte(m) {
  if (typeof m == "string" || oL(m))
    return m;
  var y = m + "";
  return y == "0" && 1 / m == -mte ? "-0" : y;
}
function pte(m, y) {
  y = dte(y, m);
  for (var w = 0, E = y.length; m != null && w < E; )
    m = m[gte(y[w++])];
  return w && w == E ? m : void 0;
}
function hte(m, y, w) {
  var E = m == null ? void 0 : pte(m, y);
  return E === void 0 ? w : E;
}
function HV(m) {
  for (var y = -1, w = m == null ? 0 : m.length, E = {}; ++y < w; ) {
    var P = m[y];
    E[P[0]] = P[1];
  }
  return E;
}
function VV(m) {
  return m == null;
}
function bte(m) {
  return m === void 0;
}
const UV = (m) => m === void 0, yte = (m) => typeof m == "boolean", PC = (m) => typeof m == "number", U9 = (m) => typeof Element > "u" ? !1 : m instanceof Element, wte = (m) => zm(m) ? !Number.isNaN(Number(m)) : !1, HH = (m) => Object.keys(m);
class jV extends Error {
  constructor(y) {
    super(y), this.name = "ElementPlusError";
  }
}
function Cte(m, y) {
  throw new jV(`[${m}] ${y}`);
}
function Mp(m, y) {
  if (process.env.NODE_ENV !== "production") {
    const w = zm(m) ? new jV(`[${m}] ${y}`) : m;
    console.warn(w);
  }
}
const Ste = "utils/dom/style", WV = (m = "") => m.split(" ").filter((y) => !!y.trim()), VH = (m, y) => {
  if (!m || !y)
    return !1;
  if (y.includes(" "))
    throw new Error("className should not contain space.");
  return m.classList.contains(y);
}, xte = (m, y) => {
  !m || !y.trim() || m.classList.add(...WV(y));
}, kte = (m, y) => {
  !m || !y.trim() || m.classList.remove(...WV(y));
}, Tte = (m, y) => {
  var w;
  if (!Kc || !m || !y)
    return "";
  let E = jQ(y);
  E === "float" && (E = "cssFloat");
  try {
    const P = m.style[E];
    if (P)
      return P;
    const H = (w = document.defaultView) == null ? void 0 : w.getComputedStyle(m, "");
    return H ? H[E] : "";
  } catch {
    return m.style[E];
  }
};
function g5(m, y = "px") {
  if (!m)
    return "";
  if (PC(m) || wte(m))
    return `${m}${y}`;
  if (zm(m))
    return m;
  Mp(Ste, "binding value must be a string or number");
}
let LB;
const Ete = (m) => {
  var y;
  if (!Kc)
    return 0;
  if (LB !== void 0)
    return LB;
  const w = document.createElement("div");
  w.className = `${m}-scrollbar__wrap`, w.style.visibility = "hidden", w.style.width = "100px", w.style.position = "absolute", w.style.top = "-9999px", document.body.appendChild(w);
  const E = w.offsetWidth;
  w.style.overflow = "scroll";
  const P = document.createElement("div");
  P.style.width = "100%", w.appendChild(P);
  const H = P.offsetWidth;
  return (y = w.parentNode) == null || y.removeChild(w), LB = E - H, LB;
};
/*! Element Plus Icons Vue v2.3.1 */
var _te = /* @__PURE__ */ _o({
  name: "CircleCheck",
  __name: "circle-check",
  setup(m) {
    return (y, w) => (Dn(), ir("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      Rt("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      }),
      Rt("path", {
        fill: "currentColor",
        d: "M745.344 361.344a32 32 0 0 1 45.312 45.312l-288 288a32 32 0 0 1-45.312 0l-160-160a32 32 0 1 1 45.312-45.312L480 626.752l265.344-265.408z"
      })
    ]));
  }
}), Ate = _te, Ote = /* @__PURE__ */ _o({
  name: "CircleCloseFilled",
  __name: "circle-close-filled",
  setup(m) {
    return (y, w) => (Dn(), ir("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      Rt("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 393.664L407.936 353.6a38.4 38.4 0 1 0-54.336 54.336L457.664 512 353.6 616.064a38.4 38.4 0 1 0 54.336 54.336L512 566.336 616.064 670.4a38.4 38.4 0 1 0 54.336-54.336L566.336 512 670.4 407.936a38.4 38.4 0 1 0-54.336-54.336z"
      })
    ]));
  }
}), qV = Ote, Dte = /* @__PURE__ */ _o({
  name: "CircleClose",
  __name: "circle-close",
  setup(m) {
    return (y, w) => (Dn(), ir("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      Rt("path", {
        fill: "currentColor",
        d: "m466.752 512-90.496-90.496a32 32 0 0 1 45.248-45.248L512 466.752l90.496-90.496a32 32 0 1 1 45.248 45.248L557.248 512l90.496 90.496a32 32 0 1 1-45.248 45.248L512 557.248l-90.496 90.496a32 32 0 0 1-45.248-45.248z"
      }),
      Rt("path", {
        fill: "currentColor",
        d: "M512 896a384 384 0 1 0 0-768 384 384 0 0 0 0 768m0 64a448 448 0 1 1 0-896 448 448 0 0 1 0 896"
      })
    ]));
  }
}), GV = Dte, Bte = /* @__PURE__ */ _o({
  name: "Close",
  __name: "close",
  setup(m) {
    return (y, w) => (Dn(), ir("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      Rt("path", {
        fill: "currentColor",
        d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
      })
    ]));
  }
}), KV = Bte, Rte = /* @__PURE__ */ _o({
  name: "Hide",
  __name: "hide",
  setup(m) {
    return (y, w) => (Dn(), ir("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      Rt("path", {
        fill: "currentColor",
        d: "M876.8 156.8c0-9.6-3.2-16-9.6-22.4-6.4-6.4-12.8-9.6-22.4-9.6-9.6 0-16 3.2-22.4 9.6L736 220.8c-64-32-137.6-51.2-224-60.8-160 16-288 73.6-377.6 176C44.8 438.4 0 496 0 512s48 73.6 134.4 176c22.4 25.6 44.8 48 73.6 67.2l-86.4 89.6c-6.4 6.4-9.6 12.8-9.6 22.4 0 9.6 3.2 16 9.6 22.4 6.4 6.4 12.8 9.6 22.4 9.6 9.6 0 16-3.2 22.4-9.6l704-710.4c3.2-6.4 6.4-12.8 6.4-22.4Zm-646.4 528c-76.8-70.4-128-128-153.6-172.8 28.8-48 80-105.6 153.6-172.8C304 272 400 230.4 512 224c64 3.2 124.8 19.2 176 44.8l-54.4 54.4C598.4 300.8 560 288 512 288c-64 0-115.2 22.4-160 64s-64 96-64 160c0 48 12.8 89.6 35.2 124.8L256 707.2c-9.6-6.4-19.2-16-25.6-22.4Zm140.8-96c-12.8-22.4-19.2-48-19.2-76.8 0-44.8 16-83.2 48-112 32-28.8 67.2-48 112-48 28.8 0 54.4 6.4 73.6 19.2zM889.599 336c-12.8-16-28.8-28.8-41.6-41.6l-48 48c73.6 67.2 124.8 124.8 150.4 169.6-28.8 48-80 105.6-153.6 172.8-73.6 67.2-172.8 108.8-284.8 115.2-51.2-3.2-99.2-12.8-140.8-28.8l-48 48c57.6 22.4 118.4 38.4 188.8 44.8 160-16 288-73.6 377.6-176C979.199 585.6 1024 528 1024 512s-48.001-73.6-134.401-176Z"
      }),
      Rt("path", {
        fill: "currentColor",
        d: "M511.998 672c-12.8 0-25.6-3.2-38.4-6.4l-51.2 51.2c28.8 12.8 57.6 19.2 89.6 19.2 64 0 115.2-22.4 160-64 41.6-41.6 64-96 64-160 0-32-6.4-64-19.2-89.6l-51.2 51.2c3.2 12.8 6.4 25.6 6.4 38.4 0 44.8-16 83.2-48 112-32 28.8-67.2 48-112 48Z"
      })
    ]));
  }
}), Mte = Rte, Pte = /* @__PURE__ */ _o({
  name: "InfoFilled",
  __name: "info-filled",
  setup(m) {
    return (y, w) => (Dn(), ir("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      Rt("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896.064A448 448 0 0 1 512 64m67.2 275.072c33.28 0 60.288-23.104 60.288-57.344s-27.072-57.344-60.288-57.344c-33.28 0-60.16 23.104-60.16 57.344s26.88 57.344 60.16 57.344M590.912 699.2c0-6.848 2.368-24.64 1.024-34.752l-52.608 60.544c-10.88 11.456-24.512 19.392-30.912 17.28a12.992 12.992 0 0 1-8.256-14.72l87.68-276.992c7.168-35.136-12.544-67.2-54.336-71.296-44.096 0-108.992 44.736-148.48 101.504 0 6.784-1.28 23.68.064 33.792l52.544-60.608c10.88-11.328 23.552-19.328 29.952-17.152a12.8 12.8 0 0 1 7.808 16.128L388.48 728.576c-10.048 32.256 8.96 63.872 55.04 71.04 67.84 0 107.904-43.648 147.456-100.416z"
      })
    ]));
  }
}), XV = Pte, Nte = /* @__PURE__ */ _o({
  name: "Loading",
  __name: "loading",
  setup(m) {
    return (y, w) => (Dn(), ir("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      Rt("path", {
        fill: "currentColor",
        d: "M512 64a32 32 0 0 1 32 32v192a32 32 0 0 1-64 0V96a32 32 0 0 1 32-32m0 640a32 32 0 0 1 32 32v192a32 32 0 1 1-64 0V736a32 32 0 0 1 32-32m448-192a32 32 0 0 1-32 32H736a32 32 0 1 1 0-64h192a32 32 0 0 1 32 32m-640 0a32 32 0 0 1-32 32H96a32 32 0 0 1 0-64h192a32 32 0 0 1 32 32M195.2 195.2a32 32 0 0 1 45.248 0L376.32 331.008a32 32 0 0 1-45.248 45.248L195.2 240.448a32 32 0 0 1 0-45.248zm452.544 452.544a32 32 0 0 1 45.248 0L828.8 783.552a32 32 0 0 1-45.248 45.248L647.744 692.992a32 32 0 0 1 0-45.248zM828.8 195.264a32 32 0 0 1 0 45.184L692.992 376.32a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0m-452.544 452.48a32 32 0 0 1 0 45.248L240.448 828.8a32 32 0 0 1-45.248-45.248l135.808-135.808a32 32 0 0 1 45.248 0z"
      })
    ]));
  }
}), YV = Nte, Ite = /* @__PURE__ */ _o({
  name: "SuccessFilled",
  __name: "success-filled",
  setup(m) {
    return (y, w) => (Dn(), ir("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      Rt("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m-55.808 536.384-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.272 38.272 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336z"
      })
    ]));
  }
}), ZV = Ite, Fte = /* @__PURE__ */ _o({
  name: "View",
  __name: "view",
  setup(m) {
    return (y, w) => (Dn(), ir("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      Rt("path", {
        fill: "currentColor",
        d: "M512 160c320 0 512 352 512 352S832 864 512 864 0 512 0 512s192-352 512-352m0 64c-225.28 0-384.128 208.064-436.8 288 52.608 79.872 211.456 288 436.8 288 225.28 0 384.128-208.064 436.8-288-52.608-79.872-211.456-288-436.8-288zm0 64a224 224 0 1 1 0 448 224 224 0 0 1 0-448m0 64a160.192 160.192 0 0 0-160 160c0 88.192 71.744 160 160 160s160-71.808 160-160-71.744-160-160-160"
      })
    ]));
  }
}), $te = Fte, Lte = /* @__PURE__ */ _o({
  name: "WarningFilled",
  __name: "warning-filled",
  setup(m) {
    return (y, w) => (Dn(), ir("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1024 1024"
    }, [
      Rt("path", {
        fill: "currentColor",
        d: "M512 64a448 448 0 1 1 0 896 448 448 0 0 1 0-896m0 192a58.432 58.432 0 0 0-58.24 63.744l23.36 256.384a35.072 35.072 0 0 0 69.76 0l23.296-256.384A58.432 58.432 0 0 0 512 256m0 512a51.2 51.2 0 1 0 0-102.4 51.2 51.2 0 0 0 0 102.4"
      })
    ]));
  }
}), JV = Lte;
const QV = "__epPropKey", hc = (m) => m, zte = (m) => d5(m) && !!m[QV], eU = (m, y) => {
  if (!d5(m) || zte(m))
    return m;
  const { values: w, required: E, default: P, type: H, validator: X } = m, le = {
    type: H,
    required: !!E,
    validator: w || X ? (Q) => {
      let pe = !1, Y = [];
      if (w && (Y = Array.from(w), eR(m, "default") && Y.push(P), pe || (pe = Y.includes(Q))), X && (pe || (pe = X(Q))), !pe && Y.length > 0) {
        const D = [...new Set(Y)].map((J) => JSON.stringify(J)).join(", ");
        WX(`Invalid prop: validation failed${y ? ` for prop "${y}"` : ""}. Expected one of [${D}], got value ${JSON.stringify(Q)}.`);
      }
      return pe;
    } : void 0,
    [QV]: !0
  };
  return eR(m, "default") && (le.default = P), le;
}, Np = (m) => HV(Object.entries(m).map(([y, w]) => [
  y,
  eU(w, y)
])), uk = hc([
  String,
  Object,
  Function
]), tU = {
  Close: KV,
  SuccessFilled: ZV,
  InfoFilled: XV,
  WarningFilled: JV,
  CircleCloseFilled: qV
}, tR = {
  success: ZV,
  warning: JV,
  error: qV,
  info: XV
}, Hte = {
  validating: YV,
  success: Ate,
  error: GV
}, C5 = (m, y) => {
  if (m.install = (w) => {
    for (const E of [m, ...Object.values(y != null ? y : {})])
      w.component(E.name, E);
  }, y)
    for (const [w, E] of Object.entries(y))
      m[w] = E;
  return m;
}, Vte = (m, y) => (m.install = (w) => {
  m._context = w._context, w.config.globalProperties[y] = m;
}, m), Ute = (m) => (m.install = rk, m), dR = {
  tab: "Tab",
  enter: "Enter",
  space: "Space",
  left: "ArrowLeft",
  up: "ArrowUp",
  right: "ArrowRight",
  down: "ArrowDown",
  esc: "Escape",
  delete: "Delete",
  backspace: "Backspace",
  numpadEnter: "NumpadEnter",
  pageUp: "PageUp",
  pageDown: "PageDown",
  home: "Home",
  end: "End"
}, p5 = "update:modelValue", nU = ["", "default", "small", "large"], jte = (m) => ["", ...nU].includes(m);
var XB = /* @__PURE__ */ ((m) => (m[m.TEXT = 1] = "TEXT", m[m.CLASS = 2] = "CLASS", m[m.STYLE = 4] = "STYLE", m[m.PROPS = 8] = "PROPS", m[m.FULL_PROPS = 16] = "FULL_PROPS", m[m.HYDRATE_EVENTS = 32] = "HYDRATE_EVENTS", m[m.STABLE_FRAGMENT = 64] = "STABLE_FRAGMENT", m[m.KEYED_FRAGMENT = 128] = "KEYED_FRAGMENT", m[m.UNKEYED_FRAGMENT = 256] = "UNKEYED_FRAGMENT", m[m.NEED_PATCH = 512] = "NEED_PATCH", m[m.DYNAMIC_SLOTS = 1024] = "DYNAMIC_SLOTS", m[m.HOISTED = -1] = "HOISTED", m[m.BAIL = -2] = "BAIL", m))(XB || {});
const Wte = (m) => /([\uAC00-\uD7AF\u3130-\u318F])+/gi.test(m), rU = (m) => m, qte = ["class", "style"], Gte = /^on[A-Z]/, Kte = (m = {}) => {
  const { excludeListeners: y = !1, excludeKeys: w } = m, E = Or(() => ((w == null ? void 0 : w.value) || []).concat(qte)), P = Pp();
  return P ? Or(() => {
    var H;
    return HV(Object.entries((H = P.proxy) == null ? void 0 : H.$attrs).filter(([X]) => !E.value.includes(X) && !(y && Gte.test(X))));
  }) : (Mp("use-attrs", "getCurrentInstance() returned null. useAttrs() must be called at the top of a setup function"), Or(() => ({})));
}, aU = ({ from: m, replacement: y, scope: w, version: E, ref: P, type: H = "API" }, X) => {
  Wi(() => Mt(X), (j) => {
    j && Mp(w, `[${H}] ${m} is about to be deprecated in version ${E}, please use ${y} instead.
For more detail, please visit: ${P}
`);
  }, {
    immediate: !0
  });
}, Xte = (m, y, w, E) => {
  let P = {
    offsetX: 0,
    offsetY: 0
  };
  const H = (le) => {
    const Q = le.clientX, pe = le.clientY, { offsetX: Y, offsetY: D } = P, J = m.value.getBoundingClientRect(), ue = J.left, ee = J.top, Ge = J.width, ze = J.height, ht = document.documentElement.clientWidth, ie = document.documentElement.clientHeight, Ze = -ue + Y, De = -ee + D, Pt = ht - ue - Ge + Y, Ct = ie - ee - ze + D, Be = (xe) => {
      let _e = Y + xe.clientX - Q, $ = D + xe.clientY - pe;
      E != null && E.value || (_e = Math.min(Math.max(_e, Ze), Pt), $ = Math.min(Math.max($, De), Ct)), P = {
        offsetX: _e,
        offsetY: $
      }, m.value && (m.value.style.transform = `translate(${g5(_e)}, ${g5($)})`);
    }, ge = () => {
      document.removeEventListener("mousemove", Be), document.removeEventListener("mouseup", ge);
    };
    document.addEventListener("mousemove", Be), document.addEventListener("mouseup", ge);
  }, X = () => {
    y.value && m.value && y.value.addEventListener("mousedown", H);
  }, j = () => {
    y.value && m.value && y.value.removeEventListener("mousedown", H);
  };
  Xc(() => {
    qX(() => {
      w.value ? X() : j();
    });
  }), lk(() => {
    j();
  });
};
var Yte = {
  name: "en",
  el: {
    colorpicker: {
      confirm: "OK",
      clear: "Clear",
      defaultLabel: "color picker",
      description: "current color is {color}. press enter to select a new color."
    },
    datepicker: {
      now: "Now",
      today: "Today",
      cancel: "Cancel",
      clear: "Clear",
      confirm: "OK",
      dateTablePrompt: "Use the arrow keys and enter to select the day of the month",
      monthTablePrompt: "Use the arrow keys and enter to select the month",
      yearTablePrompt: "Use the arrow keys and enter to select the year",
      selectedDate: "Selected date",
      selectDate: "Select date",
      selectTime: "Select time",
      startDate: "Start Date",
      startTime: "Start Time",
      endDate: "End Date",
      endTime: "End Time",
      prevYear: "Previous Year",
      nextYear: "Next Year",
      prevMonth: "Previous Month",
      nextMonth: "Next Month",
      year: "",
      month1: "January",
      month2: "February",
      month3: "March",
      month4: "April",
      month5: "May",
      month6: "June",
      month7: "July",
      month8: "August",
      month9: "September",
      month10: "October",
      month11: "November",
      month12: "December",
      week: "week",
      weeks: {
        sun: "Sun",
        mon: "Mon",
        tue: "Tue",
        wed: "Wed",
        thu: "Thu",
        fri: "Fri",
        sat: "Sat"
      },
      weeksFull: {
        sun: "Sunday",
        mon: "Monday",
        tue: "Tuesday",
        wed: "Wednesday",
        thu: "Thursday",
        fri: "Friday",
        sat: "Saturday"
      },
      months: {
        jan: "Jan",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "May",
        jun: "Jun",
        jul: "Jul",
        aug: "Aug",
        sep: "Sep",
        oct: "Oct",
        nov: "Nov",
        dec: "Dec"
      }
    },
    inputNumber: {
      decrease: "decrease number",
      increase: "increase number"
    },
    select: {
      loading: "Loading",
      noMatch: "No matching data",
      noData: "No data",
      placeholder: "Select"
    },
    dropdown: {
      toggleDropdown: "Toggle Dropdown"
    },
    cascader: {
      noMatch: "No matching data",
      loading: "Loading",
      placeholder: "Select",
      noData: "No data"
    },
    pagination: {
      goto: "Go to",
      pagesize: "/page",
      total: "Total {total}",
      pageClassifier: "",
      page: "Page",
      prev: "Go to previous page",
      next: "Go to next page",
      currentPage: "page {pager}",
      prevPages: "Previous {pager} pages",
      nextPages: "Next {pager} pages",
      deprecationWarning: "Deprecated usages detected, please refer to the el-pagination documentation for more details"
    },
    dialog: {
      close: "Close this dialog"
    },
    drawer: {
      close: "Close this dialog"
    },
    messagebox: {
      title: "Message",
      confirm: "OK",
      cancel: "Cancel",
      error: "Illegal input",
      close: "Close this dialog"
    },
    upload: {
      deleteTip: "press delete to remove",
      delete: "Delete",
      preview: "Preview",
      continue: "Continue"
    },
    slider: {
      defaultLabel: "slider between {min} and {max}",
      defaultRangeStartLabel: "pick start value",
      defaultRangeEndLabel: "pick end value"
    },
    table: {
      emptyText: "No Data",
      confirmFilter: "Confirm",
      resetFilter: "Reset",
      clearFilter: "All",
      sumText: "Sum"
    },
    tour: {
      next: "Next",
      previous: "Previous",
      finish: "Finish"
    },
    tree: {
      emptyText: "No Data"
    },
    transfer: {
      noMatch: "No matching data",
      noData: "No data",
      titles: ["List 1", "List 2"],
      filterPlaceholder: "Enter keyword",
      noCheckedFormat: "{total} items",
      hasCheckedFormat: "{checked}/{total} checked"
    },
    image: {
      error: "FAILED"
    },
    pageHeader: {
      title: "Back"
    },
    popconfirm: {
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    },
    carousel: {
      leftArrow: "Carousel arrow left",
      rightArrow: "Carousel arrow right",
      indicator: "Carousel switch to index {index}"
    }
  }
};
const Zte = (m) => (y, w) => Jte(y, w, Mt(m)), Jte = (m, y, w) => hte(w, m, m).replace(/\{(\w+)\}/g, (E, P) => {
  var H;
  return `${(H = y == null ? void 0 : y[P]) != null ? H : `{${P}}`}`;
}), Qte = (m) => {
  const y = Or(() => Mt(m).name), w = aR(m) ? m : ja(m);
  return {
    lang: y,
    locale: w,
    t: Zte(m)
  };
}, oU = Symbol("localeContextKey"), iU = (m) => {
  const y = m || Rd(oU, ja());
  return Qte(Or(() => y.value || Yte));
};
let ene;
function tne(m, y = ene) {
  y && y.active && y.effects.push(m);
}
const UH = (m) => {
  const y = new Set(m);
  return y.w = 0, y.n = 0, y;
}, uU = (m) => (m.w & ey) > 0, sU = (m) => (m.n & ey) > 0, nne = ({ deps: m }) => {
  if (m.length)
    for (let y = 0; y < m.length; y++)
      m[y].w |= ey;
}, rne = (m) => {
  const { deps: y } = m;
  if (y.length) {
    let w = 0;
    for (let E = 0; E < y.length; E++) {
      const P = y[E];
      uU(P) && !sU(P) ? P.delete(m) : y[w++] = P, P.w &= ~ey, P.n &= ~ey;
    }
    y.length = w;
  }
};
let c5 = 0, ey = 1;
const j9 = 30;
let Mv;
Symbol(process.env.NODE_ENV !== "production" ? "iterate" : "");
Symbol(process.env.NODE_ENV !== "production" ? "Map key iterate" : "");
class ane {
  constructor(y, w = null, E) {
    this.fn = y, this.scheduler = w, this.active = !0, this.deps = [], this.parent = void 0, tne(this, E);
  }
  run() {
    if (!this.active)
      return this.fn();
    let y = Mv, w = YB;
    for (; y; ) {
      if (y === this)
        return;
      y = y.parent;
    }
    try {
      return this.parent = Mv, Mv = this, YB = !0, ey = 1 << ++c5, c5 <= j9 ? nne(this) : jH(this), this.fn();
    } finally {
      c5 <= j9 && rne(this), ey = 1 << --c5, Mv = this.parent, YB = w, this.parent = void 0, this.deferStop && this.stop();
    }
  }
  stop() {
    Mv === this ? this.deferStop = !0 : this.active && (jH(this), this.onStop && this.onStop(), this.active = !1);
  }
}
function jH(m) {
  const { deps: y } = m;
  if (y.length) {
    for (let w = 0; w < y.length; w++)
      y[w].delete(m);
    y.length = 0;
  }
}
let YB = !0;
function WH(m, y) {
  let w = !1;
  c5 <= j9 ? sU(m) || (m.n |= ey, w = !uU(m)) : w = !m.has(Mv), w && (m.add(Mv), Mv.deps.push(m), process.env.NODE_ENV !== "production" && Mv.onTrack && Mv.onTrack(Object.assign({ effect: Mv }, y)));
}
function qH(m, y) {
  const w = HQ(m) ? m : [...m];
  for (const E of w)
    E.computed && GH(E, y);
  for (const E of w)
    E.computed || GH(E, y);
}
function GH(m, y) {
  (m !== Mv || m.allowRecurse) && (process.env.NODE_ENV !== "production" && m.onTrigger && m.onTrigger(LQ({ effect: m }, y)), m.scheduler ? m.scheduler() : m.run());
}
function mR(m) {
  const y = m && m.__v_raw;
  return y ? mR(y) : m;
}
function one(m) {
  YB && Mv && (m = mR(m), process.env.NODE_ENV !== "production" ? WH(m.dep || (m.dep = UH()), {
    target: m,
    type: "get",
    key: "value"
  }) : WH(m.dep || (m.dep = UH())));
}
function ine(m, y) {
  m = mR(m), m.dep && (process.env.NODE_ENV !== "production" ? qH(m.dep, {
    target: m,
    type: "set",
    key: "value",
    newValue: y
  }) : qH(m.dep));
}
var lU;
class une {
  constructor(y, w, E, P) {
    this._setter = w, this.dep = void 0, this.__v_isRef = !0, this[lU] = !1, this._dirty = !0, this.effect = new ane(y, () => {
      this._dirty || (this._dirty = !0, ine(this));
    }), this.effect.computed = this, this.effect.active = this._cacheable = !P, this.__v_isReadonly = E;
  }
  get value() {
    const y = mR(this);
    return one(y), (y._dirty || !y._cacheable) && (y._dirty = !1, y._value = y.effect.run()), y._value;
  }
  set value(y) {
    this._setter(y);
  }
}
lU = "__v_isReadonly";
function sne(m, y, w = !1) {
  let E, P;
  const H = RC(m);
  H ? (E = m, P = process.env.NODE_ENV !== "production" ? () => {
    console.warn("Write operation failed: computed value is readonly");
  } : rk) : (E = m.get, P = m.set);
  const X = new une(E, P, H || !P, w);
  return process.env.NODE_ENV !== "production" && y && !w && (X.effect.onTrack = y.onTrack, X.effect.onTrigger = y.onTrigger), X;
}
const v5 = "el", lne = "is-", xC = (m, y, w, E, P) => {
  let H = `${m}-${y}`;
  return w && (H += `-${w}`), E && (H += `__${E}`), P && (H += `--${P}`), H;
}, cU = Symbol("namespaceContextKey"), fU = (m) => {
  const y = m || (Pp() ? Rd(cU, ja(v5)) : ja(v5));
  return Or(() => Mt(y) || v5);
}, Vm = (m, y) => {
  const w = fU(y);
  return {
    namespace: w,
    b: (ee = "") => xC(w.value, m, ee, "", ""),
    e: (ee) => ee ? xC(w.value, m, "", ee, "") : "",
    m: (ee) => ee ? xC(w.value, m, "", "", ee) : "",
    be: (ee, Ge) => ee && Ge ? xC(w.value, m, ee, Ge, "") : "",
    em: (ee, Ge) => ee && Ge ? xC(w.value, m, "", ee, Ge) : "",
    bm: (ee, Ge) => ee && Ge ? xC(w.value, m, ee, "", Ge) : "",
    bem: (ee, Ge, ze) => ee && Ge && ze ? xC(w.value, m, ee, Ge, ze) : "",
    is: (ee, ...Ge) => {
      const ze = Ge.length >= 1 ? Ge[0] : !0;
      return ee && ze ? `${lne}${ee}` : "";
    },
    cssVar: (ee) => {
      const Ge = {};
      for (const ze in ee)
        ee[ze] && (Ge[`--${w.value}-${ze}`] = ee[ze]);
      return Ge;
    },
    cssVarName: (ee) => `--${w.value}-${ee}`,
    cssVarBlock: (ee) => {
      const Ge = {};
      for (const ze in ee)
        ee[ze] && (Ge[`--${w.value}-${m}-${ze}`] = ee[ze]);
      return Ge;
    },
    cssVarBlockName: (ee) => `--${w.value}-${m}-${ee}`
  };
}, vU = (m, y = {}) => {
  aR(m) || Cte("[useLockscreen]", "You need to pass a ref param to this function");
  const w = y.ns || Vm("popup"), E = sne(() => w.bm("parent", "hidden"));
  if (!Kc || VH(document.body, E.value))
    return;
  let P = 0, H = !1, X = "0";
  const j = () => {
    setTimeout(() => {
      kte(document == null ? void 0 : document.body, E.value), H && document && (document.body.style.width = X);
    }, 200);
  };
  Wi(m, (le) => {
    if (!le) {
      j();
      return;
    }
    H = !VH(document.body, E.value), H && (X = document.body.style.width), P = Ete(w.namespace.value);
    const Q = document.documentElement.clientHeight < document.body.scrollHeight, pe = Tte(document.body, "overflowY");
    P > 0 && (Q || pe === "scroll") && H && (document.body.style.width = `calc(100% - ${P}px)`), xte(document.body, E.value);
  }), vV(() => j());
}, dU = (m) => {
  const y = Pp();
  return Or(() => {
    var w, E;
    return (E = (w = y == null ? void 0 : y.proxy) == null ? void 0 : w.$props) == null ? void 0 : E[m];
  });
}, mU = (m) => {
  if (!m)
    return { onClick: rk, onMousedown: rk, onMouseup: rk };
  let y = !1, w = !1;
  return { onClick: (X) => {
    y && w && m(X), y = w = !1;
  }, onMousedown: (X) => {
    y = X.target === X.currentTarget;
  }, onMouseup: (X) => {
    w = X.target === X.currentTarget;
  } };
}, W9 = {
  prefix: Math.floor(Math.random() * 1e4),
  current: 0
}, cne = Symbol("elIdInjection"), fne = () => Pp() ? Rd(cne, W9) : W9, h5 = (m) => {
  const y = fne();
  !Kc && y === W9 && Mp("IdInjection", `Looks like you are using server rendering, you must provide a id provider to ensure the hydration process to be succeed
usage: app.provide(ID_INJECTION_KEY, {
  prefix: number,
  current: number,
})`);
  const w = fU();
  return Or(() => Mt(m) || `${w.value}-id-${y.prefix}-${y.current++}`);
};
let nk = [];
const KH = (m) => {
  const y = m;
  y.key === dR.esc && nk.forEach((w) => w(y));
}, vne = (m) => {
  Xc(() => {
    nk.length === 0 && document.addEventListener("keydown", KH), Kc && nk.push(m);
  }), lk(() => {
    nk = nk.filter((y) => y !== m), nk.length === 0 && Kc && document.removeEventListener("keydown", KH);
  });
}, XH = ja(0), gU = 2e3, pU = Symbol("zIndexContextKey"), hU = (m) => {
  const y = m || (Pp() ? Rd(pU, void 0) : void 0), w = Or(() => {
    const H = Mt(y);
    return PC(H) ? H : gU;
  }), E = Or(() => w.value + XH.value);
  return {
    initialZIndex: w,
    currentZIndex: E,
    nextZIndex: () => (XH.value++, E.value)
  };
};
function dne(m) {
  const y = ja();
  function w() {
    if (m.value == null)
      return;
    const { selectionStart: P, selectionEnd: H, value: X } = m.value;
    if (P == null || H == null)
      return;
    const j = X.slice(0, Math.max(0, P)), le = X.slice(Math.max(0, H));
    y.value = {
      selectionStart: P,
      selectionEnd: H,
      value: X,
      beforeTxt: j,
      afterTxt: le
    };
  }
  function E() {
    if (m.value == null || y.value == null)
      return;
    const { value: P } = m.value, { beforeTxt: H, afterTxt: X, selectionStart: j } = y.value;
    if (H == null || X == null || j == null)
      return;
    let le = P.length;
    if (P.endsWith(X))
      le = P.length - X.length;
    else if (P.startsWith(H))
      le = H.length;
    else {
      const Q = H[j - 1], pe = P.indexOf(Q, j - 1);
      pe !== -1 && (le = pe + 1);
    }
    m.value.setSelectionRange(le, le);
  }
  return [w, E];
}
const sL = eU({
  type: String,
  values: nU,
  required: !1
}), bU = Symbol("size"), mne = () => {
  const m = Rd(bU, {});
  return Or(() => Mt(m.size) || "");
};
function gne(m, { afterFocus: y, beforeBlur: w, afterBlur: E } = {}) {
  const P = Pp(), { emit: H } = P, X = WB(), j = ja(!1), le = (Y) => {
    j.value || (j.value = !0, H("focus", Y), y == null || y());
  }, Q = (Y) => {
    var D;
    (RC(w) ? w(Y) : !1) || Y.relatedTarget && ((D = X.value) == null ? void 0 : D.contains(Y.relatedTarget)) || (j.value = !1, H("blur", Y), E == null || E());
  }, pe = () => {
    var Y;
    (Y = m.value) == null || Y.focus();
  };
  return Wi(X, (Y) => {
    Y && Y.setAttribute("tabindex", "-1");
  }), PV(X, "click", pe), {
    wrapperRef: X,
    isFocused: j,
    handleFocus: le,
    handleBlur: Q
  };
}
const yU = Symbol(), nR = ja();
function gR(m, y = void 0) {
  const w = Pp() ? Rd(yU, nR) : nR;
  return m ? Or(() => {
    var E, P;
    return (P = (E = w.value) == null ? void 0 : E[m]) != null ? P : y;
  }) : w;
}
function wU(m, y) {
  const w = gR(), E = Vm(m, Or(() => {
    var j;
    return ((j = w.value) == null ? void 0 : j.namespace) || v5;
  })), P = iU(Or(() => {
    var j;
    return (j = w.value) == null ? void 0 : j.locale;
  })), H = hU(Or(() => {
    var j;
    return ((j = w.value) == null ? void 0 : j.zIndex) || gU;
  })), X = Or(() => {
    var j;
    return Mt(y) || ((j = w.value) == null ? void 0 : j.size) || "";
  });
  return CU(Or(() => Mt(w) || {})), {
    ns: E,
    locale: P,
    zIndex: H,
    size: X
  };
}
const CU = (m, y, w = !1) => {
  var E;
  const P = !!Pp(), H = P ? gR() : void 0, X = (E = y == null ? void 0 : y.provide) != null ? E : P ? Y9 : void 0;
  if (!X) {
    Mp("provideGlobalConfig", "provideGlobalConfig() can only be used inside setup().");
    return;
  }
  const j = Or(() => {
    const le = Mt(m);
    return H != null && H.value ? pne(H.value, le) : le;
  });
  return X(yU, j), X(oU, Or(() => j.value.locale)), X(cU, Or(() => j.value.namespace)), X(pU, Or(() => j.value.zIndex)), X(bU, {
    size: Or(() => j.value.size || "")
  }), (w || !nR.value) && (nR.value = j.value), j;
}, pne = (m, y) => {
  var w;
  const E = [.../* @__PURE__ */ new Set([...HH(m), ...HH(y)])], P = {};
  for (const H of E)
    P[H] = (w = y[H]) != null ? w : m[H];
  return P;
}, hne = Np({
  a11y: {
    type: Boolean,
    default: !0
  },
  locale: {
    type: hc(Object)
  },
  size: sL,
  button: {
    type: hc(Object)
  },
  experimentalFeatures: {
    type: hc(Object)
  },
  keyboardNavigation: {
    type: Boolean,
    default: !0
  },
  message: {
    type: hc(Object)
  },
  zIndex: Number,
  namespace: {
    type: String,
    default: "el"
  }
}), q9 = {};
_o({
  name: "ElConfigProvider",
  props: hne,
  setup(m, { slots: y }) {
    Wi(() => m.message, (E) => {
      Object.assign(q9, E != null ? E : {});
    }, { immediate: !0, deep: !0 });
    const w = CU(m);
    return () => Cu(y, "default", { config: w == null ? void 0 : w.value });
  }
});
var y1 = (m, y) => {
  const w = m.__vccOpts || m;
  for (const [E, P] of y)
    w[E] = P;
  return w;
};
const bne = Np({
  size: {
    type: hc([Number, String])
  },
  color: {
    type: String
  }
}), yne = _o({
  name: "ElIcon",
  inheritAttrs: !1
}), wne = /* @__PURE__ */ _o({
  ...yne,
  props: bne,
  setup(m) {
    const y = m, w = Vm("icon"), E = Or(() => {
      const { size: P, color: H } = y;
      return !P && !H ? {} : {
        fontSize: UV(P) ? void 0 : g5(P),
        "--color": H
      };
    });
    return (P, H) => (Dn(), ir("i", BC({
      class: Mt(w).b(),
      style: Mt(E)
    }, P.$attrs), [
      Cu(P.$slots, "default")
    ], 16));
  }
});
var Cne = /* @__PURE__ */ y1(wne, [["__file", "icon.vue"]]);
const $m = C5(Cne), lL = Symbol("formContextKey"), SU = Symbol("formItemContextKey"), xU = (m, y = {}) => {
  const w = ja(void 0), E = y.prop ? w : dU("size"), P = y.global ? w : mne(), H = y.form ? { size: void 0 } : Rd(lL, void 0), X = y.formItem ? { size: void 0 } : Rd(SU, void 0);
  return Or(() => E.value || Mt(m) || (X == null ? void 0 : X.size) || (H == null ? void 0 : H.size) || P.value || "");
}, cL = (m) => {
  const y = dU("disabled"), w = Rd(lL, void 0);
  return Or(() => y.value || Mt(m) || (w == null ? void 0 : w.disabled) || !1);
}, kU = () => {
  const m = Rd(lL, void 0), y = Rd(SU, void 0);
  return {
    form: m,
    formItem: y
  };
}, Sne = (m, {
  formItemContext: y,
  disableIdGeneration: w,
  disableIdManagement: E
}) => {
  w || (w = ja(!1)), E || (E = ja(!1));
  const P = ja();
  let H;
  const X = Or(() => {
    var j;
    return !!(!m.label && y && y.inputIds && ((j = y.inputIds) == null ? void 0 : j.length) <= 1);
  });
  return Xc(() => {
    H = Wi([ZB(m, "id"), w], ([j, le]) => {
      const Q = j != null ? j : le ? void 0 : h5().value;
      Q !== P.value && (y != null && y.removeInputId && (P.value && y.removeInputId(P.value), !(E != null && E.value) && !le && Q && y.addInputId(Q)), P.value = Q);
    }, { immediate: !0 });
  }), GX(() => {
    H && H(), y != null && y.removeInputId && P.value && y.removeInputId(P.value);
  }), {
    isLabeledByFormItem: X,
    inputId: P
  };
};
let Nm;
const xne = `
  height:0 !important;
  visibility:hidden !important;
  ${$Q() ? "" : "overflow:hidden !important;"}
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
`, kne = [
  "letter-spacing",
  "line-height",
  "padding-top",
  "padding-bottom",
  "font-family",
  "font-weight",
  "font-size",
  "text-rendering",
  "text-transform",
  "width",
  "text-indent",
  "padding-left",
  "padding-right",
  "border-width",
  "box-sizing"
];
function Tne(m) {
  const y = window.getComputedStyle(m), w = y.getPropertyValue("box-sizing"), E = Number.parseFloat(y.getPropertyValue("padding-bottom")) + Number.parseFloat(y.getPropertyValue("padding-top")), P = Number.parseFloat(y.getPropertyValue("border-bottom-width")) + Number.parseFloat(y.getPropertyValue("border-top-width"));
  return { contextStyle: kne.map((X) => `${X}:${y.getPropertyValue(X)}`).join(";"), paddingSize: E, borderSize: P, boxSizing: w };
}
function YH(m, y = 1, w) {
  var E;
  Nm || (Nm = document.createElement("textarea"), document.body.appendChild(Nm));
  const { paddingSize: P, borderSize: H, boxSizing: X, contextStyle: j } = Tne(m);
  Nm.setAttribute("style", `${j};${xne}`), Nm.value = m.value || m.placeholder || "";
  let le = Nm.scrollHeight;
  const Q = {};
  X === "border-box" ? le = le + H : X === "content-box" && (le = le - P), Nm.value = "";
  const pe = Nm.scrollHeight - P;
  if (PC(y)) {
    let Y = pe * y;
    X === "border-box" && (Y = Y + P + H), le = Math.max(Y, le), Q.minHeight = `${Y}px`;
  }
  if (PC(w)) {
    let Y = pe * w;
    X === "border-box" && (Y = Y + P + H), le = Math.min(Y, le);
  }
  return Q.height = `${le}px`, (E = Nm.parentNode) == null || E.removeChild(Nm), Nm = void 0, Q;
}
const Ene = Np({
  id: {
    type: String,
    default: void 0
  },
  size: sL,
  disabled: Boolean,
  modelValue: {
    type: hc([
      String,
      Number,
      Object
    ]),
    default: ""
  },
  maxlength: {
    type: [String, Number]
  },
  minlength: {
    type: [String, Number]
  },
  type: {
    type: String,
    default: "text"
  },
  resize: {
    type: String,
    values: ["none", "both", "horizontal", "vertical"]
  },
  autosize: {
    type: hc([Boolean, Object]),
    default: !1
  },
  autocomplete: {
    type: String,
    default: "off"
  },
  formatter: {
    type: Function
  },
  parser: {
    type: Function
  },
  placeholder: {
    type: String
  },
  form: {
    type: String
  },
  readonly: {
    type: Boolean,
    default: !1
  },
  clearable: {
    type: Boolean,
    default: !1
  },
  showPassword: {
    type: Boolean,
    default: !1
  },
  showWordLimit: {
    type: Boolean,
    default: !1
  },
  suffixIcon: {
    type: uk
  },
  prefixIcon: {
    type: uk
  },
  containerRole: {
    type: String,
    default: void 0
  },
  label: {
    type: String,
    default: void 0
  },
  tabindex: {
    type: [String, Number],
    default: 0
  },
  validateEvent: {
    type: Boolean,
    default: !0
  },
  inputStyle: {
    type: hc([Object, Array, String]),
    default: () => rU({})
  },
  autofocus: {
    type: Boolean,
    default: !1
  }
}), _ne = {
  [p5]: (m) => zm(m),
  input: (m) => zm(m),
  change: (m) => zm(m),
  focus: (m) => m instanceof FocusEvent,
  blur: (m) => m instanceof FocusEvent,
  clear: () => !0,
  mouseleave: (m) => m instanceof MouseEvent,
  mouseenter: (m) => m instanceof MouseEvent,
  keydown: (m) => m instanceof Event,
  compositionstart: (m) => m instanceof CompositionEvent,
  compositionupdate: (m) => m instanceof CompositionEvent,
  compositionend: (m) => m instanceof CompositionEvent
}, Ane = ["role"], One = ["id", "minlength", "maxlength", "type", "disabled", "readonly", "autocomplete", "tabindex", "aria-label", "placeholder", "form", "autofocus"], Dne = ["id", "minlength", "maxlength", "tabindex", "disabled", "readonly", "autocomplete", "aria-label", "placeholder", "form", "autofocus"], Bne = _o({
  name: "ElInput",
  inheritAttrs: !1
}), Rne = /* @__PURE__ */ _o({
  ...Bne,
  props: Ene,
  emits: _ne,
  setup(m, { expose: y, emit: w }) {
    const E = m, P = KX(), H = Z9(), X = Or(() => {
      const Ye = {};
      return E.containerRole === "combobox" && (Ye["aria-haspopup"] = P["aria-haspopup"], Ye["aria-owns"] = P["aria-owns"], Ye["aria-expanded"] = P["aria-expanded"]), Ye;
    }), j = Or(() => [
      E.type === "textarea" ? Ge.b() : ee.b(),
      ee.m(J.value),
      ee.is("disabled", ue.value),
      ee.is("exceed", dt.value),
      {
        [ee.b("group")]: H.prepend || H.append,
        [ee.bm("group", "append")]: H.append,
        [ee.bm("group", "prepend")]: H.prepend,
        [ee.m("prefix")]: H.prefix || E.prefixIcon,
        [ee.m("suffix")]: H.suffix || E.suffixIcon || E.clearable || E.showPassword,
        [ee.bm("suffix", "password-clear")]: je.value && Me.value,
        [ee.b("hidden")]: E.type === "hidden"
      },
      P.class
    ]), le = Or(() => [
      ee.e("wrapper"),
      ee.is("focus", xe.value)
    ]), Q = Kte({
      excludeKeys: Or(() => Object.keys(X.value))
    }), { form: pe, formItem: Y } = kU(), { inputId: D } = Sne(E, {
      formItemContext: Y
    }), J = xU(), ue = cL(), ee = Vm("input"), Ge = Vm("textarea"), ze = WB(), ht = WB(), ie = ja(!1), Ze = ja(!1), De = ja(!1), Pt = ja(), Ct = WB(E.inputStyle), Be = Or(() => ze.value || ht.value), { wrapperRef: ge, isFocused: xe, handleFocus: _e, handleBlur: $ } = gne(Be, {
      afterBlur() {
        var Ye;
        E.validateEvent && ((Ye = Y == null ? void 0 : Y.validate) == null || Ye.call(Y, "blur").catch((Qt) => Mp(Qt)));
      }
    }), N = Or(() => {
      var Ye;
      return (Ye = pe == null ? void 0 : pe.statusIcon) != null ? Ye : !1;
    }), ae = Or(() => (Y == null ? void 0 : Y.validateState) || ""), ce = Or(() => ae.value && Hte[ae.value]), ne = Or(() => De.value ? $te : Mte), Ce = Or(() => [
      P.style
    ]), Te = Or(() => [
      E.inputStyle,
      Ct.value,
      { resize: E.resize }
    ]), _ = Or(() => VV(E.modelValue) ? "" : String(E.modelValue)), je = Or(() => E.clearable && !ue.value && !E.readonly && !!_.value && (xe.value || ie.value)), Me = Or(() => E.showPassword && !ue.value && !E.readonly && !!_.value && (!!_.value || xe.value)), Je = Or(() => E.showWordLimit && !!E.maxlength && (E.type === "text" || E.type === "textarea") && !ue.value && !E.readonly && !E.showPassword), Lt = Or(() => _.value.length), dt = Or(() => !!Je.value && Lt.value > Number(E.maxlength)), Tt = Or(() => !!H.suffix || !!E.suffixIcon || je.value || E.showPassword || Je.value || !!ae.value && N.value), [Jt, se] = dne(ze);
    NV(ht, (Ye) => {
      if (Pe(), !Je.value || E.resize !== "both")
        return;
      const Qt = Ye[0], { width: In } = Qt.contentRect;
      Pt.value = {
        right: `calc(100% - ${In + 15 + 6}px)`
      };
    });
    const tr = () => {
      const { type: Ye, autosize: Qt } = E;
      if (!(!Kc || Ye !== "textarea" || !ht.value))
        if (Qt) {
          const In = d5(Qt) ? Qt.minRows : void 0, It = d5(Qt) ? Qt.maxRows : void 0, qt = YH(ht.value, In, It);
          Ct.value = {
            overflowY: "hidden",
            ...qt
          }, Vl(() => {
            ht.value.offsetHeight, Ct.value = qt;
          });
        } else
          Ct.value = {
            minHeight: YH(ht.value).minHeight
          };
    }, Pe = ((Ye) => {
      let Qt = !1;
      return () => {
        var In;
        if (Qt || !E.autosize)
          return;
        ((In = ht.value) == null ? void 0 : In.offsetParent) === null || (Ye(), Qt = !0);
      };
    })(tr), kt = () => {
      const Ye = Be.value, Qt = E.formatter ? E.formatter(_.value) : _.value;
      !Ye || Ye.value === Qt || (Ye.value = Qt);
    }, He = async (Ye) => {
      Jt();
      let { value: Qt } = Ye.target;
      if (E.formatter && (Qt = E.parser ? E.parser(Qt) : Qt), !Ze.value) {
        if (Qt === _.value) {
          kt();
          return;
        }
        w(p5, Qt), w("input", Qt), await Vl(), kt(), se();
      }
    }, We = (Ye) => {
      w("change", Ye.target.value);
    }, Ae = (Ye) => {
      w("compositionstart", Ye), Ze.value = !0;
    }, Ke = (Ye) => {
      var Qt;
      w("compositionupdate", Ye);
      const In = (Qt = Ye.target) == null ? void 0 : Qt.value, It = In[In.length - 1] || "";
      Ze.value = !Wte(It);
    }, at = (Ye) => {
      w("compositionend", Ye), Ze.value && (Ze.value = !1, He(Ye));
    }, pt = () => {
      De.value = !De.value, sn();
    }, sn = async () => {
      var Ye;
      await Vl(), (Ye = Be.value) == null || Ye.focus();
    }, Ie = () => {
      var Ye;
      return (Ye = Be.value) == null ? void 0 : Ye.blur();
    }, St = (Ye) => {
      ie.value = !1, w("mouseleave", Ye);
    }, Xe = (Ye) => {
      ie.value = !0, w("mouseenter", Ye);
    }, he = (Ye) => {
      w("keydown", Ye);
    }, tt = () => {
      var Ye;
      (Ye = Be.value) == null || Ye.select();
    }, gt = () => {
      w(p5, ""), w("change", ""), w("clear"), w("input", "");
    };
    return Wi(() => E.modelValue, () => {
      var Ye;
      Vl(() => tr()), E.validateEvent && ((Ye = Y == null ? void 0 : Y.validate) == null || Ye.call(Y, "change").catch((Qt) => Mp(Qt)));
    }), Wi(_, () => kt()), Wi(() => E.type, async () => {
      await Vl(), kt(), tr();
    }), Xc(() => {
      !E.formatter && E.parser && Mp("ElInput", "If you set the parser, you also need to set the formatter."), kt(), Vl(tr);
    }), y({
      input: ze,
      textarea: ht,
      ref: Be,
      textareaStyle: Te,
      autosize: ZB(E, "autosize"),
      focus: sn,
      blur: Ie,
      select: tt,
      clear: gt,
      resizeTextarea: tr
    }), (Ye, Qt) => (Dn(), ir("div", BC(Mt(X), {
      class: Mt(j),
      style: Mt(Ce),
      role: Ye.containerRole,
      onMouseenter: Xe,
      onMouseleave: St
    }), [
      ba(" input "),
      Ye.type !== "textarea" ? (Dn(), ir(Is, { key: 0 }, [
        ba(" prepend slot "),
        Ye.$slots.prepend ? (Dn(), ir("div", {
          key: 0,
          class: Hr(Mt(ee).be("group", "prepend"))
        }, [
          Cu(Ye.$slots, "prepend")
        ], 2)) : ba("v-if", !0),
        Rt("div", {
          ref_key: "wrapperRef",
          ref: ge,
          class: Hr(Mt(le))
        }, [
          ba(" prefix slot "),
          Ye.$slots.prefix || Ye.prefixIcon ? (Dn(), ir("span", {
            key: 0,
            class: Hr(Mt(ee).e("prefix"))
          }, [
            Rt("span", {
              class: Hr(Mt(ee).e("prefix-inner"))
            }, [
              Cu(Ye.$slots, "prefix"),
              Ye.prefixIcon ? (Dn(), Mo(Mt($m), {
                key: 0,
                class: Hr(Mt(ee).e("icon"))
              }, {
                default: ka(() => [
                  (Dn(), Mo(Od(Ye.prefixIcon)))
                ]),
                _: 1
              }, 8, ["class"])) : ba("v-if", !0)
            ], 2)
          ], 2)) : ba("v-if", !0),
          Rt("input", BC({
            id: Mt(D),
            ref_key: "input",
            ref: ze,
            class: Mt(ee).e("inner")
          }, Mt(Q), {
            minlength: Ye.minlength,
            maxlength: Ye.maxlength,
            type: Ye.showPassword ? De.value ? "text" : "password" : Ye.type,
            disabled: Mt(ue),
            readonly: Ye.readonly,
            autocomplete: Ye.autocomplete,
            tabindex: Ye.tabindex,
            "aria-label": Ye.label,
            placeholder: Ye.placeholder,
            style: Ye.inputStyle,
            form: Ye.form,
            autofocus: Ye.autofocus,
            onCompositionstart: Ae,
            onCompositionupdate: Ke,
            onCompositionend: at,
            onInput: He,
            onFocus: Qt[0] || (Qt[0] = (...In) => Mt(_e) && Mt(_e)(...In)),
            onBlur: Qt[1] || (Qt[1] = (...In) => Mt($) && Mt($)(...In)),
            onChange: We,
            onKeydown: he
          }), null, 16, One),
          ba(" suffix slot "),
          Mt(Tt) ? (Dn(), ir("span", {
            key: 1,
            class: Hr(Mt(ee).e("suffix"))
          }, [
            Rt("span", {
              class: Hr(Mt(ee).e("suffix-inner"))
            }, [
              !Mt(je) || !Mt(Me) || !Mt(Je) ? (Dn(), ir(Is, { key: 0 }, [
                Cu(Ye.$slots, "suffix"),
                Ye.suffixIcon ? (Dn(), Mo(Mt($m), {
                  key: 0,
                  class: Hr(Mt(ee).e("icon"))
                }, {
                  default: ka(() => [
                    (Dn(), Mo(Od(Ye.suffixIcon)))
                  ]),
                  _: 1
                }, 8, ["class"])) : ba("v-if", !0)
              ], 64)) : ba("v-if", !0),
              Mt(je) ? (Dn(), Mo(Mt($m), {
                key: 1,
                class: Hr([Mt(ee).e("icon"), Mt(ee).e("clear")]),
                onMousedown: Ro(Mt(rk), ["prevent"]),
                onClick: gt
              }, {
                default: ka(() => [
                  Ja(Mt(GV))
                ]),
                _: 1
              }, 8, ["class", "onMousedown"])) : ba("v-if", !0),
              Mt(Me) ? (Dn(), Mo(Mt($m), {
                key: 2,
                class: Hr([Mt(ee).e("icon"), Mt(ee).e("password")]),
                onClick: pt
              }, {
                default: ka(() => [
                  (Dn(), Mo(Od(Mt(ne))))
                ]),
                _: 1
              }, 8, ["class"])) : ba("v-if", !0),
              Mt(Je) ? (Dn(), ir("span", {
                key: 3,
                class: Hr(Mt(ee).e("count"))
              }, [
                Rt("span", {
                  class: Hr(Mt(ee).e("count-inner"))
                }, Eo(Mt(Lt)) + " / " + Eo(Ye.maxlength), 3)
              ], 2)) : ba("v-if", !0),
              Mt(ae) && Mt(ce) && Mt(N) ? (Dn(), Mo(Mt($m), {
                key: 4,
                class: Hr([
                  Mt(ee).e("icon"),
                  Mt(ee).e("validateIcon"),
                  Mt(ee).is("loading", Mt(ae) === "validating")
                ])
              }, {
                default: ka(() => [
                  (Dn(), Mo(Od(Mt(ce))))
                ]),
                _: 1
              }, 8, ["class"])) : ba("v-if", !0)
            ], 2)
          ], 2)) : ba("v-if", !0)
        ], 2),
        ba(" append slot "),
        Ye.$slots.append ? (Dn(), ir("div", {
          key: 1,
          class: Hr(Mt(ee).be("group", "append"))
        }, [
          Cu(Ye.$slots, "append")
        ], 2)) : ba("v-if", !0)
      ], 64)) : (Dn(), ir(Is, { key: 1 }, [
        ba(" textarea "),
        Rt("textarea", BC({
          id: Mt(D),
          ref_key: "textarea",
          ref: ht,
          class: Mt(Ge).e("inner")
        }, Mt(Q), {
          minlength: Ye.minlength,
          maxlength: Ye.maxlength,
          tabindex: Ye.tabindex,
          disabled: Mt(ue),
          readonly: Ye.readonly,
          autocomplete: Ye.autocomplete,
          style: Mt(Te),
          "aria-label": Ye.label,
          placeholder: Ye.placeholder,
          form: Ye.form,
          autofocus: Ye.autofocus,
          onCompositionstart: Ae,
          onCompositionupdate: Ke,
          onCompositionend: at,
          onInput: He,
          onFocus: Qt[2] || (Qt[2] = (...In) => Mt(_e) && Mt(_e)(...In)),
          onBlur: Qt[3] || (Qt[3] = (...In) => Mt($) && Mt($)(...In)),
          onChange: We,
          onKeydown: he
        }), null, 16, Dne),
        Mt(Je) ? (Dn(), ir("span", {
          key: 0,
          style: Bd(Pt.value),
          class: Hr(Mt(ee).e("count"))
        }, Eo(Mt(Lt)) + " / " + Eo(Ye.maxlength), 7)) : ba("v-if", !0)
      ], 64))
    ], 16, Ane));
  }
});
var Mne = /* @__PURE__ */ y1(Rne, [["__file", "input.vue"]]);
const Pne = C5(Mne), _9 = "focus-trap.focus-after-trapped", A9 = "focus-trap.focus-after-released", Nne = "focus-trap.focusout-prevented", ZH = {
  cancelable: !0,
  bubbles: !1
}, Ine = {
  cancelable: !0,
  bubbles: !1
}, JH = "focusAfterTrapped", QH = "focusAfterReleased", Fne = Symbol("elFocusTrap"), fL = ja(), pR = ja(0), vL = ja(0);
let zB = 0;
const TU = (m) => {
  const y = [], w = document.createTreeWalker(m, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (E) => {
      const P = E.tagName === "INPUT" && E.type === "hidden";
      return E.disabled || E.hidden || P ? NodeFilter.FILTER_SKIP : E.tabIndex >= 0 || E === document.activeElement ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; w.nextNode(); )
    y.push(w.currentNode);
  return y;
}, eV = (m, y) => {
  for (const w of m)
    if (!$ne(w, y))
      return w;
}, $ne = (m, y) => {
  if (process.env.NODE_ENV === "test")
    return !1;
  if (getComputedStyle(m).visibility === "hidden")
    return !0;
  for (; m; ) {
    if (y && m === y)
      return !1;
    if (getComputedStyle(m).display === "none")
      return !0;
    m = m.parentElement;
  }
  return !1;
}, Lne = (m) => {
  const y = TU(m), w = eV(y, m), E = eV(y.reverse(), m);
  return [w, E];
}, zne = (m) => m instanceof HTMLInputElement && "select" in m, Yb = (m, y) => {
  if (m && m.focus) {
    const w = document.activeElement;
    m.focus({ preventScroll: !0 }), vL.value = window.performance.now(), m !== w && zne(m) && y && m.select();
  }
};
function tV(m, y) {
  const w = [...m], E = m.indexOf(y);
  return E !== -1 && w.splice(E, 1), w;
}
const Hne = () => {
  let m = [];
  return {
    push: (E) => {
      const P = m[0];
      P && E !== P && P.pause(), m = tV(m, E), m.unshift(E);
    },
    remove: (E) => {
      var P, H;
      m = tV(m, E), (H = (P = m[0]) == null ? void 0 : P.resume) == null || H.call(P);
    }
  };
}, Vne = (m, y = !1) => {
  const w = document.activeElement;
  for (const E of m)
    if (Yb(E, y), document.activeElement !== w)
      return;
}, nV = Hne(), Une = () => pR.value > vL.value, HB = () => {
  fL.value = "pointer", pR.value = window.performance.now();
}, rV = () => {
  fL.value = "keyboard", pR.value = window.performance.now();
}, jne = () => (Xc(() => {
  zB === 0 && (document.addEventListener("mousedown", HB), document.addEventListener("touchstart", HB), document.addEventListener("keydown", rV)), zB++;
}), lk(() => {
  zB--, zB <= 0 && (document.removeEventListener("mousedown", HB), document.removeEventListener("touchstart", HB), document.removeEventListener("keydown", rV));
}), {
  focusReason: fL,
  lastUserFocusTimestamp: pR,
  lastAutomatedFocusTimestamp: vL
}), VB = (m) => new CustomEvent(Nne, {
  ...Ine,
  detail: m
}), Wne = _o({
  name: "ElFocusTrap",
  inheritAttrs: !1,
  props: {
    loop: Boolean,
    trapped: Boolean,
    focusTrapEl: Object,
    focusStartEl: {
      type: [Object, String],
      default: "first"
    }
  },
  emits: [
    JH,
    QH,
    "focusin",
    "focusout",
    "focusout-prevented",
    "release-requested"
  ],
  setup(m, { emit: y }) {
    const w = ja();
    let E, P;
    const { focusReason: H } = jne();
    vne((ue) => {
      m.trapped && !X.paused && y("release-requested", ue);
    });
    const X = {
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }, j = (ue) => {
      if (!m.loop && !m.trapped || X.paused)
        return;
      const { key: ee, altKey: Ge, ctrlKey: ze, metaKey: ht, currentTarget: ie, shiftKey: Ze } = ue, { loop: De } = m, Pt = ee === dR.tab && !Ge && !ze && !ht, Ct = document.activeElement;
      if (Pt && Ct) {
        const Be = ie, [ge, xe] = Lne(Be);
        if (ge && xe) {
          if (!Ze && Ct === xe) {
            const $ = VB({
              focusReason: H.value
            });
            y("focusout-prevented", $), $.defaultPrevented || (ue.preventDefault(), De && Yb(ge, !0));
          } else if (Ze && [ge, Be].includes(Ct)) {
            const $ = VB({
              focusReason: H.value
            });
            y("focusout-prevented", $), $.defaultPrevented || (ue.preventDefault(), De && Yb(xe, !0));
          }
        } else if (Ct === Be) {
          const $ = VB({
            focusReason: H.value
          });
          y("focusout-prevented", $), $.defaultPrevented || ue.preventDefault();
        }
      }
    };
    Y9(Fne, {
      focusTrapRef: w,
      onKeydown: j
    }), Wi(() => m.focusTrapEl, (ue) => {
      ue && (w.value = ue);
    }, { immediate: !0 }), Wi([w], ([ue], [ee]) => {
      ue && (ue.addEventListener("keydown", j), ue.addEventListener("focusin", pe), ue.addEventListener("focusout", Y)), ee && (ee.removeEventListener("keydown", j), ee.removeEventListener("focusin", pe), ee.removeEventListener("focusout", Y));
    });
    const le = (ue) => {
      y(JH, ue);
    }, Q = (ue) => y(QH, ue), pe = (ue) => {
      const ee = Mt(w);
      if (!ee)
        return;
      const Ge = ue.target, ze = ue.relatedTarget, ht = Ge && ee.contains(Ge);
      m.trapped || ze && ee.contains(ze) || (E = ze), ht && y("focusin", ue), !X.paused && m.trapped && (ht ? P = Ge : Yb(P, !0));
    }, Y = (ue) => {
      const ee = Mt(w);
      if (!(X.paused || !ee))
        if (m.trapped) {
          const Ge = ue.relatedTarget;
          !VV(Ge) && !ee.contains(Ge) && setTimeout(() => {
            if (!X.paused && m.trapped) {
              const ze = VB({
                focusReason: H.value
              });
              y("focusout-prevented", ze), ze.defaultPrevented || Yb(P, !0);
            }
          }, 0);
        } else {
          const Ge = ue.target;
          Ge && ee.contains(Ge) || y("focusout", ue);
        }
    };
    async function D() {
      await Vl();
      const ue = Mt(w);
      if (ue) {
        nV.push(X);
        const ee = ue.contains(document.activeElement) ? E : document.activeElement;
        if (E = ee, !ue.contains(ee)) {
          const ze = new Event(_9, ZH);
          ue.addEventListener(_9, le), ue.dispatchEvent(ze), ze.defaultPrevented || Vl(() => {
            let ht = m.focusStartEl;
            zm(ht) || (Yb(ht), document.activeElement !== ht && (ht = "first")), ht === "first" && Vne(TU(ue), !0), (document.activeElement === ee || ht === "container") && Yb(ue);
          });
        }
      }
    }
    function J() {
      const ue = Mt(w);
      if (ue) {
        ue.removeEventListener(_9, le);
        const ee = new CustomEvent(A9, {
          ...ZH,
          detail: {
            focusReason: H.value
          }
        });
        ue.addEventListener(A9, Q), ue.dispatchEvent(ee), !ee.defaultPrevented && (H.value == "keyboard" || !Une() || ue.contains(document.activeElement)) && Yb(E != null ? E : document.body), ue.removeEventListener(A9, Q), nV.remove(X);
      }
    }
    return Xc(() => {
      m.trapped && D(), Wi(() => m.trapped, (ue) => {
        ue ? D() : J();
      });
    }), lk(() => {
      m.trapped && J();
    }), {
      onKeydown: j
    };
  }
});
function qne(m, y, w, E, P, H) {
  return Cu(m.$slots, "default", { handleKeydown: m.onKeydown });
}
var EU = /* @__PURE__ */ y1(Wne, [["render", qne], ["__file", "focus-trap.vue"]]);
const Gne = Np({
  value: {
    type: [String, Number],
    default: ""
  },
  max: {
    type: Number,
    default: 99
  },
  isDot: Boolean,
  hidden: Boolean,
  type: {
    type: String,
    values: ["primary", "success", "warning", "info", "danger"],
    default: "danger"
  },
  showZero: {
    type: Boolean,
    default: !0
  }
}), Kne = ["textContent"], Xne = _o({
  name: "ElBadge"
}), Yne = /* @__PURE__ */ _o({
  ...Xne,
  props: Gne,
  setup(m, { expose: y }) {
    const w = m, E = Vm("badge"), P = Or(() => w.isDot ? "" : PC(w.value) && PC(w.max) ? w.max < w.value ? `${w.max}+` : w.value === 0 && !w.showZero ? "" : `${w.value}` : `${w.value}`);
    return y({
      content: P
    }), (H, X) => (Dn(), ir("div", {
      class: Hr(Mt(E).b())
    }, [
      Cu(H.$slots, "default"),
      Ja(oR, {
        name: `${Mt(E).namespace.value}-zoom-in-center`,
        persisted: ""
      }, {
        default: ka(() => [
          Hf(Rt("sup", {
            class: Hr([
              Mt(E).e("content"),
              Mt(E).em("content", H.type),
              Mt(E).is("fixed", !!H.$slots.default),
              Mt(E).is("dot", H.isDot)
            ]),
            textContent: Eo(Mt(P))
          }, null, 10, Kne), [
            [Dd, !H.hidden && (Mt(P) || H.isDot)]
          ])
        ]),
        _: 1
      }, 8, ["name"])
    ], 2));
  }
});
var Zne = /* @__PURE__ */ y1(Yne, [["__file", "badge.vue"]]);
const Jne = C5(Zne), _U = Symbol("buttonGroupContextKey"), Qne = (m, y) => {
  aU({
    from: "type.text",
    replacement: "link",
    version: "3.0.0",
    scope: "props",
    ref: "https://element-plus.org/en-US/component/button.html#button-attributes"
  }, Or(() => m.type === "text"));
  const w = Rd(_U, void 0), E = gR("button"), { form: P } = kU(), H = xU(Or(() => w == null ? void 0 : w.size)), X = cL(), j = ja(), le = Z9(), Q = Or(() => m.type || (w == null ? void 0 : w.type) || ""), pe = Or(() => {
    var ue, ee, Ge;
    return (Ge = (ee = m.autoInsertSpace) != null ? ee : (ue = E.value) == null ? void 0 : ue.autoInsertSpace) != null ? Ge : !1;
  }), Y = Or(() => m.tag === "button" ? {
    ariaDisabled: X.value || m.loading,
    disabled: X.value || m.loading,
    autofocus: m.autofocus,
    type: m.nativeType
  } : {}), D = Or(() => {
    var ue;
    const ee = (ue = le.default) == null ? void 0 : ue.call(le);
    if (pe.value && (ee == null ? void 0 : ee.length) === 1) {
      const Ge = ee[0];
      if ((Ge == null ? void 0 : Ge.type) === XX) {
        const ze = Ge.children;
        return /^\p{Unified_Ideograph}{2}$/u.test(ze.trim());
      }
    }
    return !1;
  });
  return {
    _disabled: X,
    _size: H,
    _type: Q,
    _ref: j,
    _props: Y,
    shouldAddSpace: D,
    handleClick: (ue) => {
      m.nativeType === "reset" && (P == null || P.resetFields()), y("click", ue);
    }
  };
}, ere = [
  "default",
  "primary",
  "success",
  "warning",
  "info",
  "danger",
  "text",
  ""
], tre = ["button", "submit", "reset"], G9 = Np({
  size: sL,
  disabled: Boolean,
  type: {
    type: String,
    values: ere,
    default: ""
  },
  icon: {
    type: uk
  },
  nativeType: {
    type: String,
    values: tre,
    default: "button"
  },
  loading: Boolean,
  loadingIcon: {
    type: uk,
    default: () => YV
  },
  plain: Boolean,
  text: Boolean,
  link: Boolean,
  bg: Boolean,
  autofocus: Boolean,
  round: Boolean,
  circle: Boolean,
  color: String,
  dark: Boolean,
  autoInsertSpace: {
    type: Boolean,
    default: void 0
  },
  tag: {
    type: hc([String, Object]),
    default: "button"
  }
}), nre = {
  click: (m) => m instanceof MouseEvent
};
function jl(m, y) {
  rre(m) && (m = "100%");
  var w = are(m);
  return m = y === 360 ? m : Math.min(y, Math.max(0, parseFloat(m))), w && (m = parseInt(String(m * y), 10) / 100), Math.abs(m - y) < 1e-6 ? 1 : (y === 360 ? m = (m < 0 ? m % y + y : m % y) / parseFloat(String(y)) : m = m % y / parseFloat(String(y)), m);
}
function UB(m) {
  return Math.min(1, Math.max(0, m));
}
function rre(m) {
  return typeof m == "string" && m.indexOf(".") !== -1 && parseFloat(m) === 1;
}
function are(m) {
  return typeof m == "string" && m.indexOf("%") !== -1;
}
function AU(m) {
  return m = parseFloat(m), (isNaN(m) || m < 0 || m > 1) && (m = 1), m;
}
function jB(m) {
  return m <= 1 ? "".concat(Number(m) * 100, "%") : m;
}
function OC(m) {
  return m.length === 1 ? "0" + m : String(m);
}
function ore(m, y, w) {
  return {
    r: jl(m, 255) * 255,
    g: jl(y, 255) * 255,
    b: jl(w, 255) * 255
  };
}
function aV(m, y, w) {
  m = jl(m, 255), y = jl(y, 255), w = jl(w, 255);
  var E = Math.max(m, y, w), P = Math.min(m, y, w), H = 0, X = 0, j = (E + P) / 2;
  if (E === P)
    X = 0, H = 0;
  else {
    var le = E - P;
    switch (X = j > 0.5 ? le / (2 - E - P) : le / (E + P), E) {
      case m:
        H = (y - w) / le + (y < w ? 6 : 0);
        break;
      case y:
        H = (w - m) / le + 2;
        break;
      case w:
        H = (m - y) / le + 4;
        break;
    }
    H /= 6;
  }
  return { h: H, s: X, l: j };
}
function O9(m, y, w) {
  return w < 0 && (w += 1), w > 1 && (w -= 1), w < 1 / 6 ? m + (y - m) * (6 * w) : w < 1 / 2 ? y : w < 2 / 3 ? m + (y - m) * (2 / 3 - w) * 6 : m;
}
function ire(m, y, w) {
  var E, P, H;
  if (m = jl(m, 360), y = jl(y, 100), w = jl(w, 100), y === 0)
    P = w, H = w, E = w;
  else {
    var X = w < 0.5 ? w * (1 + y) : w + y - w * y, j = 2 * w - X;
    E = O9(j, X, m + 1 / 3), P = O9(j, X, m), H = O9(j, X, m - 1 / 3);
  }
  return { r: E * 255, g: P * 255, b: H * 255 };
}
function oV(m, y, w) {
  m = jl(m, 255), y = jl(y, 255), w = jl(w, 255);
  var E = Math.max(m, y, w), P = Math.min(m, y, w), H = 0, X = E, j = E - P, le = E === 0 ? 0 : j / E;
  if (E === P)
    H = 0;
  else {
    switch (E) {
      case m:
        H = (y - w) / j + (y < w ? 6 : 0);
        break;
      case y:
        H = (w - m) / j + 2;
        break;
      case w:
        H = (m - y) / j + 4;
        break;
    }
    H /= 6;
  }
  return { h: H, s: le, v: X };
}
function ure(m, y, w) {
  m = jl(m, 360) * 6, y = jl(y, 100), w = jl(w, 100);
  var E = Math.floor(m), P = m - E, H = w * (1 - y), X = w * (1 - P * y), j = w * (1 - (1 - P) * y), le = E % 6, Q = [w, X, H, H, j, w][le], pe = [j, w, w, X, H, H][le], Y = [H, H, j, w, w, X][le];
  return { r: Q * 255, g: pe * 255, b: Y * 255 };
}
function iV(m, y, w, E) {
  var P = [
    OC(Math.round(m).toString(16)),
    OC(Math.round(y).toString(16)),
    OC(Math.round(w).toString(16))
  ];
  return E && P[0].startsWith(P[0].charAt(1)) && P[1].startsWith(P[1].charAt(1)) && P[2].startsWith(P[2].charAt(1)) ? P[0].charAt(0) + P[1].charAt(0) + P[2].charAt(0) : P.join("");
}
function sre(m, y, w, E, P) {
  var H = [
    OC(Math.round(m).toString(16)),
    OC(Math.round(y).toString(16)),
    OC(Math.round(w).toString(16)),
    OC(lre(E))
  ];
  return P && H[0].startsWith(H[0].charAt(1)) && H[1].startsWith(H[1].charAt(1)) && H[2].startsWith(H[2].charAt(1)) && H[3].startsWith(H[3].charAt(1)) ? H[0].charAt(0) + H[1].charAt(0) + H[2].charAt(0) + H[3].charAt(0) : H.join("");
}
function lre(m) {
  return Math.round(parseFloat(m) * 255).toString(16);
}
function uV(m) {
  return Rv(m) / 255;
}
function Rv(m) {
  return parseInt(m, 16);
}
function cre(m) {
  return {
    r: m >> 16,
    g: (m & 65280) >> 8,
    b: m & 255
  };
}
var K9 = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};
function fre(m) {
  var y = { r: 0, g: 0, b: 0 }, w = 1, E = null, P = null, H = null, X = !1, j = !1;
  return typeof m == "string" && (m = mre(m)), typeof m == "object" && (p1(m.r) && p1(m.g) && p1(m.b) ? (y = ore(m.r, m.g, m.b), X = !0, j = String(m.r).substr(-1) === "%" ? "prgb" : "rgb") : p1(m.h) && p1(m.s) && p1(m.v) ? (E = jB(m.s), P = jB(m.v), y = ure(m.h, E, P), X = !0, j = "hsv") : p1(m.h) && p1(m.s) && p1(m.l) && (E = jB(m.s), H = jB(m.l), y = ire(m.h, E, H), X = !0, j = "hsl"), Object.prototype.hasOwnProperty.call(m, "a") && (w = m.a)), w = AU(w), {
    ok: X,
    format: m.format || j,
    r: Math.min(255, Math.max(y.r, 0)),
    g: Math.min(255, Math.max(y.g, 0)),
    b: Math.min(255, Math.max(y.b, 0)),
    a: w
  };
}
var vre = "[-\\+]?\\d+%?", dre = "[-\\+]?\\d*\\.\\d+%?", Jb = "(?:".concat(dre, ")|(?:").concat(vre, ")"), D9 = "[\\s|\\(]+(".concat(Jb, ")[,|\\s]+(").concat(Jb, ")[,|\\s]+(").concat(Jb, ")\\s*\\)?"), B9 = "[\\s|\\(]+(".concat(Jb, ")[,|\\s]+(").concat(Jb, ")[,|\\s]+(").concat(Jb, ")[,|\\s]+(").concat(Jb, ")\\s*\\)?"), Fm = {
  CSS_UNIT: new RegExp(Jb),
  rgb: new RegExp("rgb" + D9),
  rgba: new RegExp("rgba" + B9),
  hsl: new RegExp("hsl" + D9),
  hsla: new RegExp("hsla" + B9),
  hsv: new RegExp("hsv" + D9),
  hsva: new RegExp("hsva" + B9),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function mre(m) {
  if (m = m.trim().toLowerCase(), m.length === 0)
    return !1;
  var y = !1;
  if (K9[m])
    m = K9[m], y = !0;
  else if (m === "transparent")
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  var w = Fm.rgb.exec(m);
  return w ? { r: w[1], g: w[2], b: w[3] } : (w = Fm.rgba.exec(m), w ? { r: w[1], g: w[2], b: w[3], a: w[4] } : (w = Fm.hsl.exec(m), w ? { h: w[1], s: w[2], l: w[3] } : (w = Fm.hsla.exec(m), w ? { h: w[1], s: w[2], l: w[3], a: w[4] } : (w = Fm.hsv.exec(m), w ? { h: w[1], s: w[2], v: w[3] } : (w = Fm.hsva.exec(m), w ? { h: w[1], s: w[2], v: w[3], a: w[4] } : (w = Fm.hex8.exec(m), w ? {
    r: Rv(w[1]),
    g: Rv(w[2]),
    b: Rv(w[3]),
    a: uV(w[4]),
    format: y ? "name" : "hex8"
  } : (w = Fm.hex6.exec(m), w ? {
    r: Rv(w[1]),
    g: Rv(w[2]),
    b: Rv(w[3]),
    format: y ? "name" : "hex"
  } : (w = Fm.hex4.exec(m), w ? {
    r: Rv(w[1] + w[1]),
    g: Rv(w[2] + w[2]),
    b: Rv(w[3] + w[3]),
    a: uV(w[4] + w[4]),
    format: y ? "name" : "hex8"
  } : (w = Fm.hex3.exec(m), w ? {
    r: Rv(w[1] + w[1]),
    g: Rv(w[2] + w[2]),
    b: Rv(w[3] + w[3]),
    format: y ? "name" : "hex"
  } : !1)))))))));
}
function p1(m) {
  return Boolean(Fm.CSS_UNIT.exec(String(m)));
}
var gre = function() {
  function m(y, w) {
    y === void 0 && (y = ""), w === void 0 && (w = {});
    var E;
    if (y instanceof m)
      return y;
    typeof y == "number" && (y = cre(y)), this.originalInput = y;
    var P = fre(y);
    this.originalInput = y, this.r = P.r, this.g = P.g, this.b = P.b, this.a = P.a, this.roundA = Math.round(100 * this.a) / 100, this.format = (E = w.format) !== null && E !== void 0 ? E : P.format, this.gradientType = w.gradientType, this.r < 1 && (this.r = Math.round(this.r)), this.g < 1 && (this.g = Math.round(this.g)), this.b < 1 && (this.b = Math.round(this.b)), this.isValid = P.ok;
  }
  return m.prototype.isDark = function() {
    return this.getBrightness() < 128;
  }, m.prototype.isLight = function() {
    return !this.isDark();
  }, m.prototype.getBrightness = function() {
    var y = this.toRgb();
    return (y.r * 299 + y.g * 587 + y.b * 114) / 1e3;
  }, m.prototype.getLuminance = function() {
    var y = this.toRgb(), w, E, P, H = y.r / 255, X = y.g / 255, j = y.b / 255;
    return H <= 0.03928 ? w = H / 12.92 : w = Math.pow((H + 0.055) / 1.055, 2.4), X <= 0.03928 ? E = X / 12.92 : E = Math.pow((X + 0.055) / 1.055, 2.4), j <= 0.03928 ? P = j / 12.92 : P = Math.pow((j + 0.055) / 1.055, 2.4), 0.2126 * w + 0.7152 * E + 0.0722 * P;
  }, m.prototype.getAlpha = function() {
    return this.a;
  }, m.prototype.setAlpha = function(y) {
    return this.a = AU(y), this.roundA = Math.round(100 * this.a) / 100, this;
  }, m.prototype.isMonochrome = function() {
    var y = this.toHsl().s;
    return y === 0;
  }, m.prototype.toHsv = function() {
    var y = oV(this.r, this.g, this.b);
    return { h: y.h * 360, s: y.s, v: y.v, a: this.a };
  }, m.prototype.toHsvString = function() {
    var y = oV(this.r, this.g, this.b), w = Math.round(y.h * 360), E = Math.round(y.s * 100), P = Math.round(y.v * 100);
    return this.a === 1 ? "hsv(".concat(w, ", ").concat(E, "%, ").concat(P, "%)") : "hsva(".concat(w, ", ").concat(E, "%, ").concat(P, "%, ").concat(this.roundA, ")");
  }, m.prototype.toHsl = function() {
    var y = aV(this.r, this.g, this.b);
    return { h: y.h * 360, s: y.s, l: y.l, a: this.a };
  }, m.prototype.toHslString = function() {
    var y = aV(this.r, this.g, this.b), w = Math.round(y.h * 360), E = Math.round(y.s * 100), P = Math.round(y.l * 100);
    return this.a === 1 ? "hsl(".concat(w, ", ").concat(E, "%, ").concat(P, "%)") : "hsla(".concat(w, ", ").concat(E, "%, ").concat(P, "%, ").concat(this.roundA, ")");
  }, m.prototype.toHex = function(y) {
    return y === void 0 && (y = !1), iV(this.r, this.g, this.b, y);
  }, m.prototype.toHexString = function(y) {
    return y === void 0 && (y = !1), "#" + this.toHex(y);
  }, m.prototype.toHex8 = function(y) {
    return y === void 0 && (y = !1), sre(this.r, this.g, this.b, this.a, y);
  }, m.prototype.toHex8String = function(y) {
    return y === void 0 && (y = !1), "#" + this.toHex8(y);
  }, m.prototype.toHexShortString = function(y) {
    return y === void 0 && (y = !1), this.a === 1 ? this.toHexString(y) : this.toHex8String(y);
  }, m.prototype.toRgb = function() {
    return {
      r: Math.round(this.r),
      g: Math.round(this.g),
      b: Math.round(this.b),
      a: this.a
    };
  }, m.prototype.toRgbString = function() {
    var y = Math.round(this.r), w = Math.round(this.g), E = Math.round(this.b);
    return this.a === 1 ? "rgb(".concat(y, ", ").concat(w, ", ").concat(E, ")") : "rgba(".concat(y, ", ").concat(w, ", ").concat(E, ", ").concat(this.roundA, ")");
  }, m.prototype.toPercentageRgb = function() {
    var y = function(w) {
      return "".concat(Math.round(jl(w, 255) * 100), "%");
    };
    return {
      r: y(this.r),
      g: y(this.g),
      b: y(this.b),
      a: this.a
    };
  }, m.prototype.toPercentageRgbString = function() {
    var y = function(w) {
      return Math.round(jl(w, 255) * 100);
    };
    return this.a === 1 ? "rgb(".concat(y(this.r), "%, ").concat(y(this.g), "%, ").concat(y(this.b), "%)") : "rgba(".concat(y(this.r), "%, ").concat(y(this.g), "%, ").concat(y(this.b), "%, ").concat(this.roundA, ")");
  }, m.prototype.toName = function() {
    if (this.a === 0)
      return "transparent";
    if (this.a < 1)
      return !1;
    for (var y = "#" + iV(this.r, this.g, this.b, !1), w = 0, E = Object.entries(K9); w < E.length; w++) {
      var P = E[w], H = P[0], X = P[1];
      if (y === X)
        return H;
    }
    return !1;
  }, m.prototype.toString = function(y) {
    var w = Boolean(y);
    y = y != null ? y : this.format;
    var E = !1, P = this.a < 1 && this.a >= 0, H = !w && P && (y.startsWith("hex") || y === "name");
    return H ? y === "name" && this.a === 0 ? this.toName() : this.toRgbString() : (y === "rgb" && (E = this.toRgbString()), y === "prgb" && (E = this.toPercentageRgbString()), (y === "hex" || y === "hex6") && (E = this.toHexString()), y === "hex3" && (E = this.toHexString(!0)), y === "hex4" && (E = this.toHex8String(!0)), y === "hex8" && (E = this.toHex8String()), y === "name" && (E = this.toName()), y === "hsl" && (E = this.toHslString()), y === "hsv" && (E = this.toHsvString()), E || this.toHexString());
  }, m.prototype.toNumber = function() {
    return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
  }, m.prototype.clone = function() {
    return new m(this.toString());
  }, m.prototype.lighten = function(y) {
    y === void 0 && (y = 10);
    var w = this.toHsl();
    return w.l += y / 100, w.l = UB(w.l), new m(w);
  }, m.prototype.brighten = function(y) {
    y === void 0 && (y = 10);
    var w = this.toRgb();
    return w.r = Math.max(0, Math.min(255, w.r - Math.round(255 * -(y / 100)))), w.g = Math.max(0, Math.min(255, w.g - Math.round(255 * -(y / 100)))), w.b = Math.max(0, Math.min(255, w.b - Math.round(255 * -(y / 100)))), new m(w);
  }, m.prototype.darken = function(y) {
    y === void 0 && (y = 10);
    var w = this.toHsl();
    return w.l -= y / 100, w.l = UB(w.l), new m(w);
  }, m.prototype.tint = function(y) {
    return y === void 0 && (y = 10), this.mix("white", y);
  }, m.prototype.shade = function(y) {
    return y === void 0 && (y = 10), this.mix("black", y);
  }, m.prototype.desaturate = function(y) {
    y === void 0 && (y = 10);
    var w = this.toHsl();
    return w.s -= y / 100, w.s = UB(w.s), new m(w);
  }, m.prototype.saturate = function(y) {
    y === void 0 && (y = 10);
    var w = this.toHsl();
    return w.s += y / 100, w.s = UB(w.s), new m(w);
  }, m.prototype.greyscale = function() {
    return this.desaturate(100);
  }, m.prototype.spin = function(y) {
    var w = this.toHsl(), E = (w.h + y) % 360;
    return w.h = E < 0 ? 360 + E : E, new m(w);
  }, m.prototype.mix = function(y, w) {
    w === void 0 && (w = 50);
    var E = this.toRgb(), P = new m(y).toRgb(), H = w / 100, X = {
      r: (P.r - E.r) * H + E.r,
      g: (P.g - E.g) * H + E.g,
      b: (P.b - E.b) * H + E.b,
      a: (P.a - E.a) * H + E.a
    };
    return new m(X);
  }, m.prototype.analogous = function(y, w) {
    y === void 0 && (y = 6), w === void 0 && (w = 30);
    var E = this.toHsl(), P = 360 / w, H = [this];
    for (E.h = (E.h - (P * y >> 1) + 720) % 360; --y; )
      E.h = (E.h + P) % 360, H.push(new m(E));
    return H;
  }, m.prototype.complement = function() {
    var y = this.toHsl();
    return y.h = (y.h + 180) % 360, new m(y);
  }, m.prototype.monochromatic = function(y) {
    y === void 0 && (y = 6);
    for (var w = this.toHsv(), E = w.h, P = w.s, H = w.v, X = [], j = 1 / y; y--; )
      X.push(new m({ h: E, s: P, v: H })), H = (H + j) % 1;
    return X;
  }, m.prototype.splitcomplement = function() {
    var y = this.toHsl(), w = y.h;
    return [
      this,
      new m({ h: (w + 72) % 360, s: y.s, l: y.l }),
      new m({ h: (w + 216) % 360, s: y.s, l: y.l })
    ];
  }, m.prototype.onBackground = function(y) {
    var w = this.toRgb(), E = new m(y).toRgb(), P = w.a + E.a * (1 - w.a);
    return new m({
      r: (w.r * w.a + E.r * E.a * (1 - w.a)) / P,
      g: (w.g * w.a + E.g * E.a * (1 - w.a)) / P,
      b: (w.b * w.a + E.b * E.a * (1 - w.a)) / P,
      a: P
    });
  }, m.prototype.triad = function() {
    return this.polyad(3);
  }, m.prototype.tetrad = function() {
    return this.polyad(4);
  }, m.prototype.polyad = function(y) {
    for (var w = this.toHsl(), E = w.h, P = [this], H = 360 / y, X = 1; X < y; X++)
      P.push(new m({ h: (E + X * H) % 360, s: w.s, l: w.l }));
    return P;
  }, m.prototype.equals = function(y) {
    return this.toRgbString() === new m(y).toRgbString();
  }, m;
}();
function Xb(m, y = 20) {
  return m.mix("#141414", y).toString();
}
function pre(m) {
  const y = cL(), w = Vm("button");
  return Or(() => {
    let E = {};
    const P = m.color;
    if (P) {
      const H = new gre(P), X = m.dark ? H.tint(20).toString() : Xb(H, 20);
      if (m.plain)
        E = w.cssVarBlock({
          "bg-color": m.dark ? Xb(H, 90) : H.tint(90).toString(),
          "text-color": P,
          "border-color": m.dark ? Xb(H, 50) : H.tint(50).toString(),
          "hover-text-color": `var(${w.cssVarName("color-white")})`,
          "hover-bg-color": P,
          "hover-border-color": P,
          "active-bg-color": X,
          "active-text-color": `var(${w.cssVarName("color-white")})`,
          "active-border-color": X
        }), y.value && (E[w.cssVarBlockName("disabled-bg-color")] = m.dark ? Xb(H, 90) : H.tint(90).toString(), E[w.cssVarBlockName("disabled-text-color")] = m.dark ? Xb(H, 50) : H.tint(50).toString(), E[w.cssVarBlockName("disabled-border-color")] = m.dark ? Xb(H, 80) : H.tint(80).toString());
      else {
        const j = m.dark ? Xb(H, 30) : H.tint(30).toString(), le = H.isDark() ? `var(${w.cssVarName("color-white")})` : `var(${w.cssVarName("color-black")})`;
        if (E = w.cssVarBlock({
          "bg-color": P,
          "text-color": le,
          "border-color": P,
          "hover-bg-color": j,
          "hover-text-color": le,
          "hover-border-color": j,
          "active-bg-color": X,
          "active-border-color": X
        }), y.value) {
          const Q = m.dark ? Xb(H, 50) : H.tint(50).toString();
          E[w.cssVarBlockName("disabled-bg-color")] = Q, E[w.cssVarBlockName("disabled-text-color")] = m.dark ? "rgba(255, 255, 255, 0.5)" : `var(${w.cssVarName("color-white")})`, E[w.cssVarBlockName("disabled-border-color")] = Q;
        }
      }
    }
    return E;
  });
}
const hre = _o({
  name: "ElButton"
}), bre = /* @__PURE__ */ _o({
  ...hre,
  props: G9,
  emits: nre,
  setup(m, { expose: y, emit: w }) {
    const E = m, P = pre(E), H = Vm("button"), { _ref: X, _size: j, _type: le, _disabled: Q, _props: pe, shouldAddSpace: Y, handleClick: D } = Qne(E, w);
    return y({
      ref: X,
      size: j,
      type: le,
      disabled: Q,
      shouldAddSpace: Y
    }), (J, ue) => (Dn(), Mo(Od(J.tag), BC({
      ref_key: "_ref",
      ref: X
    }, Mt(pe), {
      class: [
        Mt(H).b(),
        Mt(H).m(Mt(le)),
        Mt(H).m(Mt(j)),
        Mt(H).is("disabled", Mt(Q)),
        Mt(H).is("loading", J.loading),
        Mt(H).is("plain", J.plain),
        Mt(H).is("round", J.round),
        Mt(H).is("circle", J.circle),
        Mt(H).is("text", J.text),
        Mt(H).is("link", J.link),
        Mt(H).is("has-bg", J.bg)
      ],
      style: Mt(P),
      onClick: Mt(D)
    }), {
      default: ka(() => [
        J.loading ? (Dn(), ir(Is, { key: 0 }, [
          J.$slots.loading ? Cu(J.$slots, "loading", { key: 0 }) : (Dn(), Mo(Mt($m), {
            key: 1,
            class: Hr(Mt(H).is("loading"))
          }, {
            default: ka(() => [
              (Dn(), Mo(Od(J.loadingIcon)))
            ]),
            _: 1
          }, 8, ["class"]))
        ], 64)) : J.icon || J.$slots.icon ? (Dn(), Mo(Mt($m), { key: 1 }, {
          default: ka(() => [
            J.icon ? (Dn(), Mo(Od(J.icon), { key: 0 })) : Cu(J.$slots, "icon", { key: 1 })
          ]),
          _: 3
        })) : ba("v-if", !0),
        J.$slots.default ? (Dn(), ir("span", {
          key: 2,
          class: Hr({ [Mt(H).em("text", "expand")]: Mt(Y) })
        }, [
          Cu(J.$slots, "default")
        ], 2)) : ba("v-if", !0)
      ]),
      _: 3
    }, 16, ["class", "style", "onClick"]));
  }
});
var yre = /* @__PURE__ */ y1(bre, [["__file", "button.vue"]]);
const wre = {
  size: G9.size,
  type: G9.type
}, Cre = _o({
  name: "ElButtonGroup"
}), Sre = /* @__PURE__ */ _o({
  ...Cre,
  props: wre,
  setup(m) {
    const y = m;
    Y9(_U, Um({
      size: ZB(y, "size"),
      type: ZB(y, "type")
    }));
    const w = Vm("button");
    return (E, P) => (Dn(), ir("div", {
      class: Hr(`${Mt(w).b("group")}`)
    }, [
      Cu(E.$slots, "default")
    ], 2));
  }
});
var OU = /* @__PURE__ */ y1(Sre, [["__file", "button-group.vue"]]);
const rR = C5(yre, {
  ButtonGroup: OU
});
Ute(OU);
const X9 = "_trap-focus-children", DC = [], sV = (m) => {
  var y;
  if (DC.length === 0)
    return;
  const w = DC[DC.length - 1][X9];
  if (w.length > 0 && m.code === dR.tab) {
    if (w.length === 1) {
      m.preventDefault(), document.activeElement !== w[0] && w[0].focus();
      return;
    }
    const E = m.shiftKey, P = m.target === w[0], H = m.target === w[w.length - 1];
    if (P && E && (m.preventDefault(), w[w.length - 1].focus()), H && !E && (m.preventDefault(), w[0].focus()), process.env.NODE_ENV === "test") {
      const X = w.indexOf(m.target);
      X !== -1 && ((y = w[E ? X - 1 : X + 1]) == null || y.focus());
    }
  }
}, xre = {
  beforeMount(m) {
    m[X9] = BH(m), DC.push(m), DC.length <= 1 && document.addEventListener("keydown", sV);
  },
  updated(m) {
    Vl(() => {
      m[X9] = BH(m);
    });
  },
  unmounted() {
    DC.shift(), DC.length === 0 && document.removeEventListener("keydown", sV);
  }
}, kre = Np({
  mask: {
    type: Boolean,
    default: !0
  },
  customMaskEvent: {
    type: Boolean,
    default: !1
  },
  overlayClass: {
    type: hc([
      String,
      Array,
      Object
    ])
  },
  zIndex: {
    type: hc([String, Number])
  }
}), Tre = {
  click: (m) => m instanceof MouseEvent
}, Ere = "overlay";
var _re = _o({
  name: "ElOverlay",
  props: kre,
  emits: Tre,
  setup(m, { slots: y, emit: w }) {
    const E = Vm(Ere), P = (le) => {
      w("click", le);
    }, { onClick: H, onMousedown: X, onMouseup: j } = mU(m.customMaskEvent ? void 0 : P);
    return () => m.mask ? Ja("div", {
      class: [E.b(), m.overlayClass],
      style: {
        zIndex: m.zIndex
      },
      onClick: H,
      onMousedown: X,
      onMouseup: j
    }, [Cu(y, "default")], XB.STYLE | XB.CLASS | XB.PROPS, ["onClick", "onMouseup", "onMousedown"]) : R9("div", {
      class: m.overlayClass,
      style: {
        zIndex: m.zIndex,
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px"
      }
    }, [Cu(y, "default")]);
  }
});
const DU = _re, Are = Np({
  center: Boolean,
  alignCenter: Boolean,
  closeIcon: {
    type: uk
  },
  draggable: Boolean,
  overflow: Boolean,
  fullscreen: Boolean,
  showClose: {
    type: Boolean,
    default: !0
  },
  title: {
    type: String,
    default: ""
  },
  ariaLevel: {
    type: String,
    default: "2"
  }
}), Ore = Np({
  ...Are,
  appendToBody: Boolean,
  appendTo: {
    type: hc(String),
    default: "body"
  },
  beforeClose: {
    type: hc(Function)
  },
  destroyOnClose: Boolean,
  closeOnClickModal: {
    type: Boolean,
    default: !0
  },
  closeOnPressEscape: {
    type: Boolean,
    default: !0
  },
  lockScroll: {
    type: Boolean,
    default: !0
  },
  modal: {
    type: Boolean,
    default: !0
  },
  openDelay: {
    type: Number,
    default: 0
  },
  closeDelay: {
    type: Number,
    default: 0
  },
  top: {
    type: String
  },
  modelValue: Boolean,
  modalClass: String,
  width: {
    type: [String, Number]
  },
  zIndex: {
    type: Number
  },
  trapFocus: {
    type: Boolean,
    default: !1
  },
  headerAriaLevel: {
    type: String,
    default: "2"
  }
}), Dre = {
  open: () => !0,
  opened: () => !0,
  close: () => !0,
  closed: () => !0,
  [p5]: (m) => yte(m),
  openAutoFocus: () => !0,
  closeAutoFocus: () => !0
}, Bre = (m, y) => {
  var w;
  const P = Pp().emit, { nextZIndex: H } = hU();
  let X = "";
  const j = h5(), le = h5(), Q = ja(!1), pe = ja(!1), Y = ja(!1), D = ja((w = m.zIndex) != null ? w : H());
  let J, ue;
  const ee = gR("namespace", v5), Ge = Or(() => {
    const ce = {}, ne = `--${ee.value}-dialog`;
    return m.fullscreen || (m.top && (ce[`${ne}-margin-top`] = m.top), m.width && (ce[`${ne}-width`] = g5(m.width))), ce;
  }), ze = Or(() => m.alignCenter ? { display: "flex" } : {});
  function ht() {
    P("opened");
  }
  function ie() {
    P("closed"), P(p5, !1), m.destroyOnClose && (Y.value = !1);
  }
  function Ze() {
    P("close");
  }
  function De() {
    ue == null || ue(), J == null || J(), m.openDelay && m.openDelay > 0 ? { stop: J } = z9(() => ge(), m.openDelay) : ge();
  }
  function Pt() {
    J == null || J(), ue == null || ue(), m.closeDelay && m.closeDelay > 0 ? { stop: ue } = z9(() => xe(), m.closeDelay) : xe();
  }
  function Ct() {
    function ce(ne) {
      ne || (pe.value = !0, Q.value = !1);
    }
    m.beforeClose ? m.beforeClose(ce) : Pt();
  }
  function Be() {
    m.closeOnClickModal && Ct();
  }
  function ge() {
    !Kc || (Q.value = !0);
  }
  function xe() {
    Q.value = !1;
  }
  function _e() {
    P("openAutoFocus");
  }
  function $() {
    P("closeAutoFocus");
  }
  function N(ce) {
    var ne;
    ((ne = ce.detail) == null ? void 0 : ne.focusReason) === "pointer" && ce.preventDefault();
  }
  m.lockScroll && vU(Q);
  function ae() {
    m.closeOnPressEscape && Ct();
  }
  return Wi(() => m.modelValue, (ce) => {
    ce ? (pe.value = !1, De(), Y.value = !0, D.value = bte(m.zIndex) ? H() : D.value++, Vl(() => {
      P("open"), y.value && (y.value.scrollTop = 0);
    })) : Q.value && Pt();
  }), Wi(() => m.fullscreen, (ce) => {
    !y.value || (ce ? (X = y.value.style.transform, y.value.style.transform = "") : y.value.style.transform = X);
  }), Xc(() => {
    m.modelValue && (Q.value = !0, Y.value = !0, De());
  }), {
    afterEnter: ht,
    afterLeave: ie,
    beforeLeave: Ze,
    handleClose: Ct,
    onModalClick: Be,
    close: Pt,
    doClose: xe,
    onOpenAutoFocus: _e,
    onCloseAutoFocus: $,
    onCloseRequested: ae,
    onFocusoutPrevented: N,
    titleId: j,
    bodyId: le,
    closed: pe,
    style: Ge,
    overlayDialogStyle: ze,
    rendered: Y,
    visible: Q,
    zIndex: D
  };
}, Rre = Np({
  ...Ore,
  direction: {
    type: String,
    default: "rtl",
    values: ["ltr", "rtl", "ttb", "btt"]
  },
  size: {
    type: [String, Number],
    default: "30%"
  },
  withHeader: {
    type: Boolean,
    default: !0
  },
  modalFade: {
    type: Boolean,
    default: !0
  },
  headerAriaLevel: {
    type: String,
    default: "2"
  }
}), Mre = Dre, Pre = ["aria-label", "aria-labelledby", "aria-describedby"], Nre = ["id", "aria-level"], Ire = ["aria-label"], Fre = ["id"], $re = _o({
  name: "ElDrawer",
  inheritAttrs: !1
}), Lre = /* @__PURE__ */ _o({
  ...$re,
  props: Rre,
  emits: Mre,
  setup(m, { expose: y }) {
    const w = m, E = Z9();
    aU({
      scope: "el-drawer",
      from: "the title slot",
      replacement: "the header slot",
      version: "3.0.0",
      ref: "https://element-plus.org/en-US/component/drawer.html#slots"
    }, Or(() => !!E.title));
    const P = ja(), H = ja(), X = Vm("drawer"), { t: j } = iU(), {
      afterEnter: le,
      afterLeave: Q,
      beforeLeave: pe,
      visible: Y,
      rendered: D,
      titleId: J,
      bodyId: ue,
      zIndex: ee,
      onModalClick: Ge,
      onOpenAutoFocus: ze,
      onCloseAutoFocus: ht,
      onFocusoutPrevented: ie,
      onCloseRequested: Ze,
      handleClose: De
    } = Bre(w, P), Pt = Or(() => w.direction === "rtl" || w.direction === "ltr"), Ct = Or(() => g5(w.size));
    return y({
      handleClose: De,
      afterEnter: le,
      afterLeave: Q
    }), (Be, ge) => (Dn(), Mo(YX, {
      to: "body",
      disabled: !Be.appendToBody
    }, [
      Ja(oR, {
        name: Mt(X).b("fade"),
        onAfterEnter: Mt(le),
        onAfterLeave: Mt(Q),
        onBeforeLeave: Mt(pe),
        persisted: ""
      }, {
        default: ka(() => [
          Hf(Ja(Mt(DU), {
            mask: Be.modal,
            "overlay-class": Be.modalClass,
            "z-index": Mt(ee),
            onClick: Mt(Ge)
          }, {
            default: ka(() => [
              Ja(Mt(EU), {
                loop: "",
                trapped: Mt(Y),
                "focus-trap-el": P.value,
                "focus-start-el": H.value,
                onFocusAfterTrapped: Mt(ze),
                onFocusAfterReleased: Mt(ht),
                onFocusoutPrevented: Mt(ie),
                onReleaseRequested: Mt(Ze)
              }, {
                default: ka(() => [
                  Rt("div", BC({
                    ref_key: "drawerRef",
                    ref: P,
                    "aria-modal": "true",
                    "aria-label": Be.title || void 0,
                    "aria-labelledby": Be.title ? void 0 : Mt(J),
                    "aria-describedby": Mt(ue)
                  }, Be.$attrs, {
                    class: [Mt(X).b(), Be.direction, Mt(Y) && "open"],
                    style: Mt(Pt) ? "width: " + Mt(Ct) : "height: " + Mt(Ct),
                    role: "dialog",
                    onClick: ge[1] || (ge[1] = Ro(() => {
                    }, ["stop"]))
                  }), [
                    Rt("span", {
                      ref_key: "focusStartRef",
                      ref: H,
                      class: Hr(Mt(X).e("sr-focus")),
                      tabindex: "-1"
                    }, null, 2),
                    Be.withHeader ? (Dn(), ir("header", {
                      key: 0,
                      class: Hr(Mt(X).e("header"))
                    }, [
                      Be.$slots.title ? Cu(Be.$slots, "title", { key: 1 }, () => [
                        ba(" DEPRECATED SLOT ")
                      ]) : Cu(Be.$slots, "header", {
                        key: 0,
                        close: Mt(De),
                        titleId: Mt(J),
                        titleClass: Mt(X).e("title")
                      }, () => [
                        Be.$slots.title ? ba("v-if", !0) : (Dn(), ir("span", {
                          key: 0,
                          id: Mt(J),
                          role: "heading",
                          "aria-level": Be.headerAriaLevel,
                          class: Hr(Mt(X).e("title"))
                        }, Eo(Be.title), 11, Nre))
                      ]),
                      Be.showClose ? (Dn(), ir("button", {
                        key: 2,
                        "aria-label": Mt(j)("el.drawer.close"),
                        class: Hr(Mt(X).e("close-btn")),
                        type: "button",
                        onClick: ge[0] || (ge[0] = (...xe) => Mt(De) && Mt(De)(...xe))
                      }, [
                        Ja(Mt($m), {
                          class: Hr(Mt(X).e("close"))
                        }, {
                          default: ka(() => [
                            Ja(Mt(KV))
                          ]),
                          _: 1
                        }, 8, ["class"])
                      ], 10, Ire)) : ba("v-if", !0)
                    ], 2)) : ba("v-if", !0),
                    Mt(D) ? (Dn(), ir("div", {
                      key: 1,
                      id: Mt(ue),
                      class: Hr(Mt(X).e("body"))
                    }, [
                      Cu(Be.$slots, "default")
                    ], 10, Fre)) : ba("v-if", !0),
                    Be.$slots.footer ? (Dn(), ir("div", {
                      key: 2,
                      class: Hr(Mt(X).e("footer"))
                    }, [
                      Cu(Be.$slots, "footer")
                    ], 2)) : ba("v-if", !0)
                  ], 16, Pre)
                ]),
                _: 3
              }, 8, ["trapped", "focus-trap-el", "focus-start-el", "onFocusAfterTrapped", "onFocusAfterReleased", "onFocusoutPrevented", "onReleaseRequested"])
            ]),
            _: 3
          }, 8, ["mask", "overlay-class", "z-index", "onClick"]), [
            [Dd, Mt(Y)]
          ])
        ]),
        _: 3
      }, 8, ["name", "onAfterEnter", "onAfterLeave", "onBeforeLeave"])
    ], 8, ["disabled"]));
  }
});
var zre = /* @__PURE__ */ y1(Lre, [["__file", "drawer.vue"]]);
const BU = C5(zre), RU = ["success", "info", "warning", "error"], Lf = rU({
  customClass: "",
  center: !1,
  dangerouslyUseHTMLString: !1,
  duration: 3e3,
  icon: void 0,
  id: "",
  message: "",
  onClose: void 0,
  showClose: !1,
  type: "info",
  offset: 16,
  zIndex: 0,
  grouping: !1,
  repeatNum: 1,
  appendTo: Kc ? document.body : void 0
}), Hre = Np({
  customClass: {
    type: String,
    default: Lf.customClass
  },
  center: {
    type: Boolean,
    default: Lf.center
  },
  dangerouslyUseHTMLString: {
    type: Boolean,
    default: Lf.dangerouslyUseHTMLString
  },
  duration: {
    type: Number,
    default: Lf.duration
  },
  icon: {
    type: uk,
    default: Lf.icon
  },
  id: {
    type: String,
    default: Lf.id
  },
  message: {
    type: hc([
      String,
      Object,
      Function
    ]),
    default: Lf.message
  },
  onClose: {
    type: hc(Function),
    required: !1
  },
  showClose: {
    type: Boolean,
    default: Lf.showClose
  },
  type: {
    type: String,
    values: RU,
    default: Lf.type
  },
  offset: {
    type: Number,
    default: Lf.offset
  },
  zIndex: {
    type: Number,
    default: Lf.zIndex
  },
  grouping: {
    type: Boolean,
    default: Lf.grouping
  },
  repeatNum: {
    type: Number,
    default: Lf.repeatNum
  }
}), Vre = {
  destroy: () => !0
}, Lm = ZX([]), Ure = (m) => {
  const y = Lm.findIndex((P) => P.id === m), w = Lm[y];
  let E;
  return y > 0 && (E = Lm[y - 1]), { current: w, prev: E };
}, jre = (m) => {
  const { prev: y } = Ure(m);
  return y ? y.vm.exposed.bottom.value : 0;
}, Wre = (m, y) => Lm.findIndex((E) => E.id === m) > 0 ? 16 : y, qre = ["id"], Gre = ["innerHTML"], Kre = _o({
  name: "ElMessage"
}), Xre = /* @__PURE__ */ _o({
  ...Kre,
  props: Hre,
  emits: Vre,
  setup(m, { expose: y }) {
    const w = m, { Close: E } = tU, { ns: P, zIndex: H } = wU("message"), { currentZIndex: X, nextZIndex: j } = H, le = ja(), Q = ja(!1), pe = ja(0);
    let Y;
    const D = Or(() => w.type ? w.type === "error" ? "danger" : w.type : "info"), J = Or(() => {
      const Ct = w.type;
      return { [P.bm("icon", Ct)]: Ct && tR[Ct] };
    }), ue = Or(() => w.icon || tR[w.type] || ""), ee = Or(() => jre(w.id)), Ge = Or(() => Wre(w.id, w.offset) + ee.value), ze = Or(() => pe.value + Ge.value), ht = Or(() => ({
      top: `${Ge.value}px`,
      zIndex: X.value
    }));
    function ie() {
      w.duration !== 0 && ({ stop: Y } = z9(() => {
        De();
      }, w.duration));
    }
    function Ze() {
      Y == null || Y();
    }
    function De() {
      Q.value = !1;
    }
    function Pt({ code: Ct }) {
      Ct === dR.esc && De();
    }
    return Xc(() => {
      ie(), j(), Q.value = !0;
    }), Wi(() => w.repeatNum, () => {
      Ze(), ie();
    }), PV(document, "keydown", Pt), NV(le, () => {
      pe.value = le.value.getBoundingClientRect().height;
    }), y({
      visible: Q,
      bottom: ze,
      close: De
    }), (Ct, Be) => (Dn(), Mo(oR, {
      name: Mt(P).b("fade"),
      onBeforeLeave: Ct.onClose,
      onAfterLeave: Be[0] || (Be[0] = (ge) => Ct.$emit("destroy")),
      persisted: ""
    }, {
      default: ka(() => [
        Hf(Rt("div", {
          id: Ct.id,
          ref_key: "messageRef",
          ref: le,
          class: Hr([
            Mt(P).b(),
            { [Mt(P).m(Ct.type)]: Ct.type },
            Mt(P).is("center", Ct.center),
            Mt(P).is("closable", Ct.showClose),
            Ct.customClass
          ]),
          style: Bd(Mt(ht)),
          role: "alert",
          onMouseenter: Ze,
          onMouseleave: ie
        }, [
          Ct.repeatNum > 1 ? (Dn(), Mo(Mt(Jne), {
            key: 0,
            value: Ct.repeatNum,
            type: Mt(D),
            class: Hr(Mt(P).e("badge"))
          }, null, 8, ["value", "type", "class"])) : ba("v-if", !0),
          Mt(ue) ? (Dn(), Mo(Mt($m), {
            key: 1,
            class: Hr([Mt(P).e("icon"), Mt(J)])
          }, {
            default: ka(() => [
              (Dn(), Mo(Od(Mt(ue))))
            ]),
            _: 1
          }, 8, ["class"])) : ba("v-if", !0),
          Cu(Ct.$slots, "default", {}, () => [
            Ct.dangerouslyUseHTMLString ? (Dn(), ir(Is, { key: 1 }, [
              ba(" Caution here, message could've been compromised, never use user's input as message "),
              Rt("p", {
                class: Hr(Mt(P).e("content")),
                innerHTML: Ct.message
              }, null, 10, Gre)
            ], 2112)) : (Dn(), ir("p", {
              key: 0,
              class: Hr(Mt(P).e("content"))
            }, Eo(Ct.message), 3))
          ]),
          Ct.showClose ? (Dn(), Mo(Mt($m), {
            key: 2,
            class: Hr(Mt(P).e("closeBtn")),
            onClick: Ro(De, ["stop"])
          }, {
            default: ka(() => [
              Ja(Mt(E))
            ]),
            _: 1
          }, 8, ["class", "onClick"])) : ba("v-if", !0)
        ], 46, qre), [
          [Dd, Q.value]
        ])
      ]),
      _: 3
    }, 8, ["name", "onBeforeLeave"]));
  }
});
var Yre = /* @__PURE__ */ y1(Xre, [["__file", "message.vue"]]);
let Zre = 1;
const MU = (m) => {
  const y = !m || zm(m) || iR(m) || RC(m) ? { message: m } : m, w = {
    ...Lf,
    ...y
  };
  if (!w.appendTo)
    w.appendTo = document.body;
  else if (zm(w.appendTo)) {
    let E = document.querySelector(w.appendTo);
    U9(E) || (Mp("ElMessage", "the appendTo option is not an HTMLElement. Falling back to document.body."), E = document.body), w.appendTo = E;
  }
  return w;
}, Jre = (m) => {
  const y = Lm.indexOf(m);
  if (y === -1)
    return;
  Lm.splice(y, 1);
  const { handler: w } = m;
  w.close();
}, Qre = ({ appendTo: m, ...y }, w) => {
  const E = `message_${Zre++}`, P = y.onClose, H = document.createElement("div"), X = {
    ...y,
    id: E,
    onClose: () => {
      P == null || P(), Jre(pe);
    },
    onDestroy: () => {
      JB(null, H);
    }
  }, j = Ja(Yre, X, RC(X.message) || iR(X.message) ? {
    default: RC(X.message) ? X.message : () => X.message
  } : null);
  j.appContext = w || sk._context, JB(j, H), m.appendChild(H.firstElementChild);
  const le = j.component, pe = {
    id: E,
    vnode: j,
    vm: le,
    handler: {
      close: () => {
        le.exposed.visible.value = !1;
      }
    },
    props: j.component.props
  };
  return pe;
}, sk = (m = {}, y) => {
  if (!Kc)
    return { close: () => {
    } };
  if (PC(q9.max) && Lm.length >= q9.max)
    return { close: () => {
    } };
  const w = MU(m);
  if (w.grouping && Lm.length) {
    const P = Lm.find(({ vnode: H }) => {
      var X;
      return ((X = H.props) == null ? void 0 : X.message) === w.message;
    });
    if (P)
      return P.props.repeatNum += 1, P.props.type = w.type, P.handler;
  }
  const E = Qre(w, y);
  return Lm.push(E), E.handler;
};
RU.forEach((m) => {
  sk[m] = (y = {}, w) => {
    const E = MU(y);
    return sk({ ...E, type: m }, w);
  };
});
function eae(m) {
  for (const y of Lm)
    (!m || m === y.props.type) && y.handler.close();
}
sk.closeAll = eae;
sk._context = null;
const tae = Vte(sk, "$message"), nae = _o({
  name: "ElMessageBox",
  directives: {
    TrapFocus: xre
  },
  components: {
    ElButton: rR,
    ElFocusTrap: EU,
    ElInput: Pne,
    ElOverlay: DU,
    ElIcon: $m,
    ...tU
  },
  inheritAttrs: !1,
  props: {
    buttonSize: {
      type: String,
      validator: jte
    },
    modal: {
      type: Boolean,
      default: !0
    },
    lockScroll: {
      type: Boolean,
      default: !0
    },
    showClose: {
      type: Boolean,
      default: !0
    },
    closeOnClickModal: {
      type: Boolean,
      default: !0
    },
    closeOnPressEscape: {
      type: Boolean,
      default: !0
    },
    closeOnHashChange: {
      type: Boolean,
      default: !0
    },
    center: Boolean,
    draggable: Boolean,
    overflow: Boolean,
    roundButton: {
      default: !1,
      type: Boolean
    },
    container: {
      type: String,
      default: "body"
    },
    boxType: {
      type: String,
      default: ""
    }
  },
  emits: ["vanish", "action"],
  setup(m, { emit: y }) {
    const {
      locale: w,
      zIndex: E,
      ns: P,
      size: H
    } = wU("message-box", Or(() => m.buttonSize)), { t: X } = w, { nextZIndex: j } = E, le = ja(!1), Q = Um({
      autofocus: !0,
      beforeClose: null,
      callback: null,
      cancelButtonText: "",
      cancelButtonClass: "",
      confirmButtonText: "",
      confirmButtonClass: "",
      customClass: "",
      customStyle: {},
      dangerouslyUseHTMLString: !1,
      distinguishCancelAndClose: !1,
      icon: "",
      inputPattern: null,
      inputPlaceholder: "",
      inputType: "text",
      inputValue: null,
      inputValidator: null,
      inputErrorMessage: "",
      message: null,
      modalFade: !0,
      modalClass: "",
      showCancelButton: !1,
      showConfirmButton: !0,
      type: "",
      title: void 0,
      showInput: !1,
      action: "",
      confirmButtonLoading: !1,
      cancelButtonLoading: !1,
      confirmButtonDisabled: !1,
      editorErrorMessage: "",
      validateError: !1,
      zIndex: j()
    }), pe = Or(() => {
      const ne = Q.type;
      return { [P.bm("icon", ne)]: ne && tR[ne] };
    }), Y = h5(), D = h5(), J = Or(() => Q.icon || tR[Q.type] || ""), ue = Or(() => !!Q.message), ee = ja(), Ge = ja(), ze = ja(), ht = ja(), ie = ja(), Ze = Or(() => Q.confirmButtonClass);
    Wi(() => Q.inputValue, async (ne) => {
      await Vl(), m.boxType === "prompt" && ne !== null && $();
    }, { immediate: !0 }), Wi(() => le.value, (ne) => {
      var Ce, Te;
      ne && (m.boxType !== "prompt" && (Q.autofocus ? ze.value = (Te = (Ce = ie.value) == null ? void 0 : Ce.$el) != null ? Te : ee.value : ze.value = ee.value), Q.zIndex = j()), m.boxType === "prompt" && (ne ? Vl().then(() => {
        var _;
        ht.value && ht.value.$el && (Q.autofocus ? ze.value = (_ = N()) != null ? _ : ee.value : ze.value = ee.value);
      }) : (Q.editorErrorMessage = "", Q.validateError = !1));
    });
    const De = Or(() => m.draggable), Pt = Or(() => m.overflow);
    Xte(ee, Ge, De, Pt), Xc(async () => {
      await Vl(), m.closeOnHashChange && window.addEventListener("hashchange", Ct);
    }), lk(() => {
      m.closeOnHashChange && window.removeEventListener("hashchange", Ct);
    });
    function Ct() {
      !le.value || (le.value = !1, Vl(() => {
        Q.action && y("action", Q.action);
      }));
    }
    const Be = () => {
      m.closeOnClickModal && _e(Q.distinguishCancelAndClose ? "close" : "cancel");
    }, ge = mU(Be), xe = (ne) => {
      if (Q.inputType !== "textarea")
        return ne.preventDefault(), _e("confirm");
    }, _e = (ne) => {
      var Ce;
      m.boxType === "prompt" && ne === "confirm" && !$() || (Q.action = ne, Q.beforeClose ? (Ce = Q.beforeClose) == null || Ce.call(Q, ne, Q, Ct) : Ct());
    }, $ = () => {
      if (m.boxType === "prompt") {
        const ne = Q.inputPattern;
        if (ne && !ne.test(Q.inputValue || ""))
          return Q.editorErrorMessage = Q.inputErrorMessage || X("el.messagebox.error"), Q.validateError = !0, !1;
        const Ce = Q.inputValidator;
        if (typeof Ce == "function") {
          const Te = Ce(Q.inputValue);
          if (Te === !1)
            return Q.editorErrorMessage = Q.inputErrorMessage || X("el.messagebox.error"), Q.validateError = !0, !1;
          if (typeof Te == "string")
            return Q.editorErrorMessage = Te, Q.validateError = !0, !1;
        }
      }
      return Q.editorErrorMessage = "", Q.validateError = !1, !0;
    }, N = () => {
      const ne = ht.value.$refs;
      return ne.input || ne.textarea;
    }, ae = () => {
      _e("close");
    }, ce = () => {
      m.closeOnPressEscape && ae();
    };
    return m.lockScroll && vU(le), {
      ...dV(Q),
      ns: P,
      overlayEvent: ge,
      visible: le,
      hasMessage: ue,
      typeClass: pe,
      contentId: Y,
      inputId: D,
      btnSize: H,
      iconComponent: J,
      confirmButtonClasses: Ze,
      rootRef: ee,
      focusStartRef: ze,
      headerRef: Ge,
      inputRef: ht,
      confirmRef: ie,
      doClose: Ct,
      handleClose: ae,
      onCloseRequested: ce,
      handleWrapperClick: Be,
      handleInputEnter: xe,
      handleAction: _e,
      t: X
    };
  }
}), rae = ["aria-label", "aria-describedby"], aae = ["aria-label"], oae = ["id"];
function iae(m, y, w, E, P, H) {
  const X = h1("el-icon"), j = h1("close"), le = h1("el-input"), Q = h1("el-button"), pe = h1("el-focus-trap"), Y = h1("el-overlay");
  return Dn(), Mo(oR, {
    name: "fade-in-linear",
    onAfterLeave: y[11] || (y[11] = (D) => m.$emit("vanish")),
    persisted: ""
  }, {
    default: ka(() => [
      Hf(Ja(Y, {
        "z-index": m.zIndex,
        "overlay-class": [m.ns.is("message-box"), m.modalClass],
        mask: m.modal
      }, {
        default: ka(() => [
          Rt("div", {
            role: "dialog",
            "aria-label": m.title,
            "aria-modal": "true",
            "aria-describedby": m.showInput ? void 0 : m.contentId,
            class: Hr(`${m.ns.namespace.value}-overlay-message-box`),
            onClick: y[8] || (y[8] = (...D) => m.overlayEvent.onClick && m.overlayEvent.onClick(...D)),
            onMousedown: y[9] || (y[9] = (...D) => m.overlayEvent.onMousedown && m.overlayEvent.onMousedown(...D)),
            onMouseup: y[10] || (y[10] = (...D) => m.overlayEvent.onMouseup && m.overlayEvent.onMouseup(...D))
          }, [
            Ja(pe, {
              loop: "",
              trapped: m.visible,
              "focus-trap-el": m.rootRef,
              "focus-start-el": m.focusStartRef,
              onReleaseRequested: m.onCloseRequested
            }, {
              default: ka(() => [
                Rt("div", {
                  ref: "rootRef",
                  class: Hr([
                    m.ns.b(),
                    m.customClass,
                    m.ns.is("draggable", m.draggable),
                    { [m.ns.m("center")]: m.center }
                  ]),
                  style: Bd(m.customStyle),
                  tabindex: "-1",
                  onClick: y[7] || (y[7] = Ro(() => {
                  }, ["stop"]))
                }, [
                  m.title !== null && m.title !== void 0 ? (Dn(), ir("div", {
                    key: 0,
                    ref: "headerRef",
                    class: Hr([m.ns.e("header"), { "show-close": m.showClose }])
                  }, [
                    Rt("div", {
                      class: Hr(m.ns.e("title"))
                    }, [
                      m.iconComponent && m.center ? (Dn(), Mo(X, {
                        key: 0,
                        class: Hr([m.ns.e("status"), m.typeClass])
                      }, {
                        default: ka(() => [
                          (Dn(), Mo(Od(m.iconComponent)))
                        ]),
                        _: 1
                      }, 8, ["class"])) : ba("v-if", !0),
                      Rt("span", null, Eo(m.title), 1)
                    ], 2),
                    m.showClose ? (Dn(), ir("button", {
                      key: 0,
                      type: "button",
                      class: Hr(m.ns.e("headerbtn")),
                      "aria-label": m.t("el.messagebox.close"),
                      onClick: y[0] || (y[0] = (D) => m.handleAction(m.distinguishCancelAndClose ? "close" : "cancel")),
                      onKeydown: y[1] || (y[1] = FB(Ro((D) => m.handleAction(m.distinguishCancelAndClose ? "close" : "cancel"), ["prevent"]), ["enter"]))
                    }, [
                      Ja(X, {
                        class: Hr(m.ns.e("close"))
                      }, {
                        default: ka(() => [
                          Ja(j)
                        ]),
                        _: 1
                      }, 8, ["class"])
                    ], 42, aae)) : ba("v-if", !0)
                  ], 2)) : ba("v-if", !0),
                  Rt("div", {
                    id: m.contentId,
                    class: Hr(m.ns.e("content"))
                  }, [
                    Rt("div", {
                      class: Hr(m.ns.e("container"))
                    }, [
                      m.iconComponent && !m.center && m.hasMessage ? (Dn(), Mo(X, {
                        key: 0,
                        class: Hr([m.ns.e("status"), m.typeClass])
                      }, {
                        default: ka(() => [
                          (Dn(), Mo(Od(m.iconComponent)))
                        ]),
                        _: 1
                      }, 8, ["class"])) : ba("v-if", !0),
                      m.hasMessage ? (Dn(), ir("div", {
                        key: 1,
                        class: Hr(m.ns.e("message"))
                      }, [
                        Cu(m.$slots, "default", {}, () => [
                          m.dangerouslyUseHTMLString ? (Dn(), Mo(Od(m.showInput ? "label" : "p"), {
                            key: 1,
                            for: m.showInput ? m.inputId : void 0,
                            innerHTML: m.message
                          }, null, 8, ["for", "innerHTML"])) : (Dn(), Mo(Od(m.showInput ? "label" : "p"), {
                            key: 0,
                            for: m.showInput ? m.inputId : void 0
                          }, {
                            default: ka(() => [
                              Zu(Eo(m.dangerouslyUseHTMLString ? "" : m.message), 1)
                            ]),
                            _: 1
                          }, 8, ["for"]))
                        ])
                      ], 2)) : ba("v-if", !0)
                    ], 2),
                    Hf(Rt("div", {
                      class: Hr(m.ns.e("input"))
                    }, [
                      Ja(le, {
                        id: m.inputId,
                        ref: "inputRef",
                        modelValue: m.inputValue,
                        "onUpdate:modelValue": y[2] || (y[2] = (D) => m.inputValue = D),
                        type: m.inputType,
                        placeholder: m.inputPlaceholder,
                        "aria-invalid": m.validateError,
                        class: Hr({ invalid: m.validateError }),
                        onKeydown: FB(m.handleInputEnter, ["enter"])
                      }, null, 8, ["id", "modelValue", "type", "placeholder", "aria-invalid", "class", "onKeydown"]),
                      Rt("div", {
                        class: Hr(m.ns.e("errormsg")),
                        style: Bd({
                          visibility: m.editorErrorMessage ? "visible" : "hidden"
                        })
                      }, Eo(m.editorErrorMessage), 7)
                    ], 2), [
                      [Dd, m.showInput]
                    ])
                  ], 10, oae),
                  Rt("div", {
                    class: Hr(m.ns.e("btns"))
                  }, [
                    m.showCancelButton ? (Dn(), Mo(Q, {
                      key: 0,
                      loading: m.cancelButtonLoading,
                      class: Hr([m.cancelButtonClass]),
                      round: m.roundButton,
                      size: m.btnSize,
                      onClick: y[3] || (y[3] = (D) => m.handleAction("cancel")),
                      onKeydown: y[4] || (y[4] = FB(Ro((D) => m.handleAction("cancel"), ["prevent"]), ["enter"]))
                    }, {
                      default: ka(() => [
                        Zu(Eo(m.cancelButtonText || m.t("el.messagebox.cancel")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "class", "round", "size"])) : ba("v-if", !0),
                    Hf(Ja(Q, {
                      ref: "confirmRef",
                      type: "primary",
                      loading: m.confirmButtonLoading,
                      class: Hr([m.confirmButtonClasses]),
                      round: m.roundButton,
                      disabled: m.confirmButtonDisabled,
                      size: m.btnSize,
                      onClick: y[5] || (y[5] = (D) => m.handleAction("confirm")),
                      onKeydown: y[6] || (y[6] = FB(Ro((D) => m.handleAction("confirm"), ["prevent"]), ["enter"]))
                    }, {
                      default: ka(() => [
                        Zu(Eo(m.confirmButtonText || m.t("el.messagebox.confirm")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "class", "round", "disabled", "size"]), [
                      [Dd, m.showConfirmButton]
                    ])
                  ], 2)
                ], 6)
              ]),
              _: 3
            }, 8, ["trapped", "focus-trap-el", "focus-start-el", "onReleaseRequested"])
          ], 42, rae)
        ]),
        _: 3
      }, 8, ["z-index", "overlay-class", "mask"]), [
        [Dd, m.visible]
      ])
    ]),
    _: 3
  });
}
var uae = /* @__PURE__ */ y1(nae, [["render", iae], ["__file", "index.vue"]]);
const b5 = /* @__PURE__ */ new Map(), sae = (m) => {
  let y = document.body;
  return m.appendTo && (zm(m.appendTo) && (y = document.querySelector(m.appendTo)), U9(m.appendTo) && (y = m.appendTo), U9(y) || (Mp("ElMessageBox", "the appendTo option is not an HTMLElement. Falling back to document.body."), y = document.body)), y;
}, lae = (m, y, w = null) => {
  const E = Ja(uae, m, RC(m.message) || iR(m.message) ? {
    default: RC(m.message) ? m.message : () => m.message
  } : null);
  return E.appContext = w, JB(E, y), sae(m).appendChild(y.firstElementChild), E.component;
}, cae = () => document.createElement("div"), fae = (m, y) => {
  const w = cae();
  m.onVanish = () => {
    JB(null, w), b5.delete(P);
  }, m.onAction = (H) => {
    const X = b5.get(P);
    let j;
    m.showInput ? j = { value: P.inputValue, action: H } : j = H, m.callback ? m.callback(j, E.proxy) : H === "cancel" || H === "close" ? m.distinguishCancelAndClose && H !== "cancel" ? X.reject("close") : X.reject("cancel") : X.resolve(j);
  };
  const E = lae(m, w, y), P = E.proxy;
  for (const H in m)
    eR(m, H) && !eR(P.$props, H) && (P[H] = m[H]);
  return P.visible = !0, P;
};
function fk(m, y = null) {
  if (!Kc)
    return Promise.reject();
  let w;
  return zm(m) || iR(m) ? m = {
    message: m
  } : w = m.callback, new Promise((E, P) => {
    const H = fae(m, y != null ? y : fk._context);
    b5.set(H, {
      options: m,
      callback: w,
      resolve: E,
      reject: P
    });
  });
}
const vae = ["alert", "confirm", "prompt"], dae = {
  alert: { closeOnPressEscape: !1, closeOnClickModal: !1 },
  confirm: { showCancelButton: !0 },
  prompt: { showCancelButton: !0, showInput: !0 }
};
vae.forEach((m) => {
  fk[m] = mae(m);
});
function mae(m) {
  return (y, w, E, P) => {
    let H = "";
    return d5(w) ? (E = w, H = "") : UV(w) ? H = "" : H = w, fk(Object.assign({
      title: H,
      message: y,
      type: "",
      ...dae[m]
    }, E, {
      boxType: m
    }), P);
  };
}
fk.close = () => {
  b5.forEach((m, y) => {
    y.doClose();
  }), b5.clear();
};
fk._context = null;
const Zb = fk;
Zb.install = (m) => {
  Zb._context = m._context, m.config.globalProperties.$msgbox = Zb, m.config.globalProperties.$messageBox = Zb, m.config.globalProperties.$alert = Zb.alert, m.config.globalProperties.$confirm = Zb.confirm, m.config.globalProperties.$prompt = Zb.prompt;
};
const Gc = Zb;
const S5 = (m) => (NC("data-v-986af2ba"), m = m(), IC(), m), gae = /* @__PURE__ */ S5(() => /* @__PURE__ */ Rt("p", null, "\u591A\u56FE\u7247\u4E0A\u4F20", -1)), pae = { class: "op" }, hae = ["onClick"], bae = /* @__PURE__ */ S5(() => /* @__PURE__ */ Rt("i", { class: "plus" }, null, -1)), yae = /* @__PURE__ */ Zu("\u7EE7\u7EED\u6DFB\u52A0"), wae = [
  bae,
  yae
], Cae = ["onClick"], Sae = /* @__PURE__ */ S5(() => /* @__PURE__ */ Rt("i", { class: "trash" }, null, -1)), xae = /* @__PURE__ */ Zu("\u6E05\u7A7A\u6240\u6709\u56FE\u7247"), kae = [
  Sae,
  xae
], Tae = {
  key: 0,
  class: "empty"
}, Eae = /* @__PURE__ */ S5(() => /* @__PURE__ */ Rt("i", { class: "plus" }, null, -1)), _ae = [
  Eae
], Aae = /* @__PURE__ */ S5(() => /* @__PURE__ */ Rt("p", null, "\u6DFB\u52A0\u56FE\u7247\uFF0C\u53EF\u540C\u65F6\u9009\u62E9\u591A\u5F20", -1)), Oae = { class: "picbox" }, Dae = ["src"], Bae = { class: "meng" }, Rae = { class: "tools" }, Mae = ["onClick"], Pae = { class: "namebox" }, Nae = { class: "btn_list end" }, Iae = {
  key: 0,
  class: "tips"
}, Fae = {
  __name: "axupimgs",
  props: {
    cropUrl: {
      type: String,
      default: ""
    },
    isShow: {
      type: Boolean,
      default: !1
    },
    autoCropWidth: {
      type: Number,
      default: 0
    },
    autoCropHeight: {
      type: Number,
      default: 0
    },
    fixedNumber: {
      type: Array,
      default: [1, 1]
    },
    info: {
      type: Boolean,
      default: !0
    },
    env: {
      type: String,
      default: ""
    },
    acpToken: {
      type: String,
      default: ""
    },
    sourceTop: {
      type: String,
      default: "m"
    },
    maxSize: {
      type: Number,
      default: 10
    },
    accept: {
      type: String,
      default: "image/jpg,image/jpeg,image/png,image/gif"
    },
    minWidth: {
      type: Number,
      default: 6e3
    },
    minHeight: {
      type: Number,
      default: 3e4
    }
  },
  emits: ["close", "confirm", "showLoading"],
  setup(m, { emit: y }) {
    const w = m, E = () => b1.get("MDUSERTOKEN"), P = function(ge) {
      console.log("err", ge);
    }, H = !1, X = w.env, j = w.acpToken, le = {
      client: 4,
      user_id: E() ? E().split("#")[0] : "",
      userid: E() ? E().split("#")[0] : "",
      token: E() ? E().split("#")[1] : ""
    };
    let Q = {};
    w.sourceTop == "acp" ? Q = Ul({
      host: "acp",
      env: X,
      header: {
        client: 4,
        user_id: j ? j.split(":")[0] : "",
        userid: j ? j.split(":")[0] : "",
        token: j ? j.split(":")[1] : ""
      },
      needLogin: H,
      callback: P
    }) : Q = Ul({
      env: X,
      header: le,
      acpneedLogin: H,
      acpcallback: P
    });
    const pe = bc(Q, j ? j.split(":")[0] : ""), Y = bc(Q, E() ? E().split("#")[0] : ""), D = Um({
      cancelTxt: "\u53D6\u6D88",
      confirmTxt: "\u5168\u90E8\u4E0A\u4F20",
      color: "#7A8087",
      borderColor: "#BCBFC3",
      btnColor: "#fff",
      btnMargin: "0 20px 0 0",
      axuimgsList: [],
      file_i: 0,
      loading: !1
    }), J = () => {
      let ge = document.createElement("input");
      ge.setAttribute("type", "file"), ge.setAttribute("multiple", "multiple"), ge.setAttribute("accept", w.accept), ge.click(), ge.onchange = function() {
        var xe = this.files;
        let _e = [];
        for (let $ = 0; $ < xe.length; $++) {
          let N = xe[$], ae = window.URL.createObjectURL(N);
          _e.push({
            file: N,
            blobUrl: ae,
            url: "",
            classList: "up-no",
            status: ""
          }), console.log(_e);
        }
        D.axuimgsList.push(..._e), D.axuimgsList.length > 0 && (D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20");
      };
    }, ue = (ge) => {
      D.axuimgsList.splice(ge, 1), D.axuimgsList.length == 0 && (D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20");
    }, ee = () => {
      y("close");
    }, Ge = () => {
      if (D.confirmTxt == "\u4FDD\u5B58") {
        var ge = "", xe = D.axuimgsList, _e = xe.length;
        for (let $ = 0; $ < _e; $++)
          if (xe[$].url) {
            let N = xe[$].width, ae = xe[$].height, ce = 690;
            N > 690 && (ae = parseInt(ae / N * ce), N = 690);
            let ne = (N / ce).toFixed(2);
            xe[$].video_url ? ge += '<img class="editor gif-video" src="' + xe[$].url + '" width="' + N + '" height="' + ae + '" data-video="' + xe[$].video_url + '" data-cover="' + xe[$].video_cover + '" data-rate="' + ne + '">' : ge += '<img class="editor" src="' + xe[$].url + '" width="' + N + '" height="' + ae + '" data-rate="' + ne + '" />';
          }
        ge += "<p>&nbsp;</p>", y("btnCallback", ge), D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20", D.axuimgsList = [];
      } else {
        if (D.axuimgsList.length == 0)
          return alert("\u8BF7\u6279\u91CF\u4E0A\u4F20\u56FE\u7247"), !1;
        if (D.axuimgsList.forEach(($) => {
          $.status || ($.classList = "up-no up-now");
        }), D.loading)
          return console.log(111), !1;
        D.loading = !0, ze(0);
      }
    }, ze = async (ge) => {
      var xe = D.axuimgsList.length;
      if (D.file_i = ge, xe == ge)
        return D.loading = !1, D.file_i = 0, D.confirmTxt = "\u4FDD\u5B58", !0;
      if (D.axuimgsList[ge].url != "" || ["up-error", "up-over"].includes(D.axuimgsList[ge].status))
        ge++, ze(ge);
      else {
        let _e = await Ze(D.axuimgsList[ge].file), $ = ie(_e, D.axuimgsList[ge].file.name), N = $.size / 1024 / 1024, ne = /(?:\.([^.]+))?$/.exec($.name)[1].toLocaleLowerCase(), Ce = await Pt($);
        if (!Ce) {
          Gc.alert("\u62B1\u6B49\uFF0C\u4EC5\u652F\u6301\u4E0A\u4F20\u7279\u5B9A\u7684\u56FE\u7247\u683C\u5F0F\uFF0C\u8BF7\u9009\u62E9\u6B63\u786E\u7684\u56FE\u7247\u6587\u4EF6\u683C\u5F0F\u3002", "\u63D0\u793A", {
            confirmButtonText: "\u786E\u5B9A",
            callback: () => {
              D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error up-real", ge++, ze(ge);
            }
          });
          return;
        }
        if (console.log(Ce), $.type.split("/")[1] != Ce && !Be(w.accept).includes(Ce)) {
          Gc.alert("\u56FE\u7247\u683C\u5F0F\u5F02\u5E38\uFF0C\u62A5\u9519\u56FE\u7247\u540E\u7F00\u4E3A:." + $.type.split("/")[1] + " \u771F\u5B9E\u683C\u5F0F\u4E3A:." + Ce, "\u63D0\u793A", {
            confirmButtonText: "\u786E\u5B9A",
            callback: () => {
              D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error up-real", ge++, ze(ge);
            }
          });
          return;
        }
        if (N > w.maxSize) {
          Gc.alert("\u56FE\u7247" + $.name + "\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7" + w.maxSize + "M", "\u63D0\u793A", {
            confirmButtonText: "\u786E\u5B9A",
            callback: () => {
              D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error up-size", ge++, ze(ge);
            }
          });
          return;
        } else if (!(ne == "jpg" || ne == "png" || ne == "jpeg" || ne == "gif")) {
          Gc.alert("\u56FE\u7247" + $.name + "\u683C\u5F0F\u4EC5\u652F\u6301jpg,png,jpeg,gif\u683C\u5F0F", "\u63D0\u793A", {
            confirmButtonText: "\u786E\u5B9A",
            callback: () => {
              D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error up-real", ge++, ze(ge);
            }
          });
          return;
        }
        De($, w.minWidth, w.minHeight).then((Te) => {
          if (Te) {
            let _ = 0;
            N > 3 && Ce == "gif" && (_ = 4);
            let je = {
              status: _,
              success: function(Je, Lt, dt, Tt, Jt) {
                let se = {
                  url: Je,
                  width: Jt.width,
                  height: Jt.height
                };
                se ? (typeof se == "string" ? D.axuimgsList[D.file_i].url = se : (D.axuimgsList[D.file_i].url = se.url, D.axuimgsList[D.file_i].width = se.width, D.axuimgsList[D.file_i].height = se.height), D.axuimgsList[D.file_i].status = "up-over", D.axuimgsList[D.file_i].classList = "up-over", _ == 4 && (D.axuimgsList[D.file_i].video_url = Jt.video_url || "", D.axuimgsList[D.file_i].video_cover = Jt.video_cover || "")) : (D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error"), ge++, ze(ge);
              },
              error: async (Je, Lt) => {
                Gc.alert(Lt, "\u63D0\u793A", {
                  confirmButtonText: "\u786E\u5B9A",
                  callback: () => {
                    D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error", ge++, ze(ge);
                  }
                });
              }
            }, Me = [];
            Me.push($), w.sourceTop == "acp" ? pe(je, Me, 0) : Y(je, Me, 0);
          } else
            D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error up-base", ge++, ze(ge);
        });
      }
    }, ht = () => {
      D.axuimgsList = [], D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20";
    }, ie = (ge, xe, _e) => {
      let $ = ge.split(","), N = $[0].match(/:(.*?);/)[1], ae = atob($[1]), ce = ae.length, ne = new Uint8Array(ce);
      for (; ce--; )
        ne[ce] = ae.charCodeAt(ce);
      return new File([ne], xe, { type: N });
    }, Ze = async (ge) => {
      let xe = "";
      return await new Promise(function(_e, $) {
        let N = ge, ae = new FileReader();
        ae.readAsDataURL(N), ae.onload = function(ce) {
          xe = ce.target.result, _e();
        };
      }), xe;
    }, De = (ge, xe, _e) => new Promise(($, N) => {
      const ae = new FileReader();
      let ce = "";
      ae.readAsDataURL(ge), ae.onload = () => {
        ce = ae.result;
      }, ae.onerror = (ne) => {
        N(ne);
      }, ae.onloadend = () => {
        const ne = new Image();
        ne.onload = () => {
          event.target.width > xe ? Gc.alert("\u5EFA\u8BAE\u56FE\u7247\u5BBD\u5EA6\u5C3A\u5BF8\u5C0F\u4E8E" + xe + "px", "\u63D0\u793A", {
            confirmButtonText: "\u786E\u5B9A",
            callback: () => {
              $(null);
            }
          }) : event.target.height > _e ? Gc.alert("\u5EFA\u8BAE\u56FE\u7247\u9AD8\u5EA6\u5C3A\u5BF8\u5C0F\u4E8E" + _e + "px", "\u63D0\u793A", {
            confirmButtonText: "\u786E\u5B9A",
            callback: () => {
              $(null);
            }
          }) : $(ce);
        }, ne.src = ce;
      };
    }).catch(($) => {
      console.log($);
    }), Pt = async (ge) => new Promise((xe, _e) => {
      const $ = new FileReader();
      $.onerror = (N) => {
        _e(N);
      }, $.onload = () => {
        let N = null;
        const ae = $.result, ce = new Uint8Array(ae), ne = [
          { ext: "png", data: [137, 80, 78, 71, 13, 10, 26, 10] },
          { ext: "jpeg", data: [255, 216, 255] },
          { ext: "gif", data: [71, 73, 70] },
          { ext: "ico", data: [0, 0, 1, 0] },
          { ext: "bmp", data: [66, 77] },
          { ext: "pdf", data: [37, 80, 68, 70, 45, 49] },
          { ext: "webp", data: [87, 69, 66, 80], offset: 8 },
          { ext: "HEIF", data: [102, 116, 121, 112, 104, 101, 105], offset: 4 }
        ];
        for (let Ce = 0; Ce < ne.length; Ce++) {
          const { data: Te, offset: _, ext: je } = ne[Ce];
          Ct(ce, Te, _) && (N = je);
        }
        N ? xe(N) : _e("\u672A\u77E5\u7684\u6587\u4EF6\u7C7B\u578B");
      }, $.readAsArrayBuffer(ge);
    }).catch((xe) => {
      console.log(xe);
    }), Ct = (ge, xe, _e) => {
      let $ = !0, N = _e || 0;
      for (let ae = 0; ae < xe.length; ae++)
        ge[ae + N] !== xe[ae] && ($ = !1);
      return $;
    }, Be = (ge) => ge.split(",").map(($) => $.split("/")[1]);
    return (ge, xe) => {
      const _e = h1("draggable");
      return Dn(), Mo(y5, {
        isShow: w.isShow,
        onClose: ee
      }, {
        title: ka(() => [
          Rt("h2", null, [
            gae,
            Rt("div", pae, [
              D.axuimgsList.length > 0 ? (Dn(), ir("a", {
                key: 0,
                class: "plus",
                onClick: Ro(J, ["stop"])
              }, wae, 8, hae)) : ba("", !0),
              Rt("a", {
                class: "flex",
                onClick: Ro(ht, ["stop"])
              }, kae, 8, Cae)
            ])
          ])
        ]),
        content: ka(() => [
          D.axuimgsList.length == 0 ? (Dn(), ir("div", Tae, [
            Rt("div", {
              class: "upload",
              onClick: J
            }, _ae),
            Aae
          ])) : (Dn(), Mo(_e, {
            key: 1,
            modelValue: D.axuimgsList,
            "onUpdate:modelValue": xe[0] || (xe[0] = ($) => D.axuimgsList = $),
            "item-key": "index",
            id: "file_list"
          }, {
            item: ka(({ element: $, index: N }) => [
              Rt("li", {
                class: Hr($.classList)
              }, [
                Rt("div", Oae, [
                  Rt("img", {
                    src: $.blobUrl
                  }, null, 8, Dae),
                  Rt("div", Bae, [
                    Rt("div", Rae, [
                      Rt("a", {
                        class: "remove",
                        onClick: (ae) => ue(N)
                      }, null, 8, Mae)
                    ])
                  ])
                ]),
                Rt("div", Pae, [
                  Rt("span", null, Eo($.file.name), 1)
                ])
              ], 2)
            ]),
            _: 1
          }, 8, ["modelValue"]))
        ]),
        btn_list: ka(() => [
          Rt("div", Nae, [
            D.confirmTxt == "\u4FDD\u5B58" ? (Dn(), ir("p", Iae, "\u70B9\u51FB\u201C\u4FDD\u5B58\u201D\u6309\u94AE\uFF0C\u5C06\u56FE\u7247\u6DFB\u52A0\u5230\u6B63\u6587")) : ba("", !0),
            Ja(Qb, {
              txt: D.confirmTxt,
              onBtnCallback: Ge
            }, null, 8, ["txt"])
          ])
        ]),
        _: 1
      }, 8, ["isShow"]);
    };
  }
}, $ae = /* @__PURE__ */ Md(Fae, [["__scopeId", "data-v-986af2ba"]]);
const dL = (m) => (NC("data-v-a4a4ff3d"), m = m(), IC(), m), Lae = /* @__PURE__ */ dL(() => /* @__PURE__ */ Rt("h2", null, "\u63D2\u5165/\u7F16\u8F91\u94FE\u63A5", -1)), zae = { class: "column" }, Hae = /* @__PURE__ */ dL(() => /* @__PURE__ */ Rt("h4", null, "\u5730\u5740", -1)), Vae = { class: "input" }, Uae = {
  key: 0,
  class: "column"
}, jae = /* @__PURE__ */ dL(() => /* @__PURE__ */ Rt("h4", null, "\u663E\u793A\u6587\u5B57", -1)), Wae = { class: "input" }, qae = { class: "btn_list end" }, Gae = {
  __name: "link",
  props: {
    isShow: {
      type: Boolean,
      default: !1
    },
    href: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    isText: {
      type: Boolean,
      default: !0
    },
    html: {
      type: String,
      default: ""
    }
  },
  emits: ["close", "btnCallback"],
  setup(m, { emit: y }) {
    const w = m, E = Um({
      cancelTxt: "\u53D6\u6D88",
      confirmTxt: "\u4FDD\u5B58",
      color: "#7A8087",
      borderColor: "#BCBFC3",
      btnColor: "#fff",
      btnMargin: "0 20px 0 0",
      linkHref: "",
      linkText: "",
      hasInputed: !1
    });
    Wi(
      () => E.linkText,
      () => {
        E.linkText || (E.hasInputed = !1);
      }
    ), Wi(
      () => w.isShow,
      () => {
        E.linkHref = w.href, E.linkText = w.text, w.text && (E.hasInputed = !0);
      }
    ), Xc(() => {
    });
    const P = () => {
      (!E.linkText || !E.hasInputed) && (E.linkText = E.linkHref);
    }, H = (le) => {
      le.target.value && (E.hasInputed = !0);
    }, X = () => {
      E.list = [], y("close");
    }, j = () => {
      if (!E.linkHref && !E.linkText)
        X();
      else {
        var le = /(https?:\/\/[^\s]+)/;
        if (le.test(E.linkHref)) {
          let Q = '<p><a href="' + E.linkHref + '">' + E.linkText + "</a></p>";
          w.isText || (Q = '<p><a href="' + E.linkHref + '">' + w.html + "</a></p>"), y("btnCallback", Q), X();
        } else
          tae.error("\u8BF7\u8F93\u5165\u4E00\u4E2A\u4EE5 http \u6216 https \u5F00\u5934\u7684\u7F51\u5740");
      }
    };
    return (le, Q) => (Dn(), Mo(y5, {
      isShow: m.isShow,
      onClose: X
    }, {
      title: ka(() => [
        Lae
      ]),
      content: ka(() => [
        Rt("div", zae, [
          Hae,
          Rt("div", Vae, [
            Hf(Rt("input", {
              type: "text",
              "onUpdate:modelValue": Q[0] || (Q[0] = (pe) => E.linkHref = pe),
              name: "href",
              placeholder: "\u8BF7\u8F93\u5165\u94FE\u63A5\u5730\u5740",
              onInput: P
            }, null, 544), [
              [tH, E.linkHref]
            ])
          ])
        ]),
        w.isText ? (Dn(), ir("div", Uae, [
          jae,
          Rt("div", Wae, [
            Hf(Rt("input", {
              type: "text",
              "onUpdate:modelValue": Q[1] || (Q[1] = (pe) => E.linkText = pe),
              name: "text",
              placeholder: "\u8BF7\u8F93\u5165\u663E\u793A\u6587\u5B57",
              onInput: H
            }, null, 544), [
              [tH, E.linkText]
            ])
          ])
        ])) : ba("", !0)
      ]),
      btn_list: ka(() => [
        Rt("div", qae, [
          Ja(Qb, {
            txt: E.cancelTxt,
            btnColor: E.btnColor,
            color: E.color,
            borderColor: E.borderColor,
            btnMargin: E.btnMargin,
            onBtnCallback: X
          }, null, 8, ["txt", "btnColor", "color", "borderColor", "btnMargin"]),
          Ja(Qb, {
            txt: E.confirmTxt,
            onBtnCallback: j
          }, null, 8, ["txt"])
        ])
      ]),
      _: 1
    }, 8, ["isShow"]));
  }
}, Kae = /* @__PURE__ */ Md(Gae, [["__scopeId", "data-v-a4a4ff3d"]]);
var Xae = [
  "onActivate",
  "onAddUndo",
  "onBeforeAddUndo",
  "onBeforeExecCommand",
  "onBeforeGetContent",
  "onBeforeRenderUI",
  "onBeforeSetContent",
  "onBeforePaste",
  "onBlur",
  "onChange",
  "onClearUndos",
  "onClick",
  "onContextMenu",
  "onCopy",
  "onCut",
  "onDblclick",
  "onDeactivate",
  "onDirty",
  "onDrag",
  "onDragDrop",
  "onDragEnd",
  "onDragGesture",
  "onDragOver",
  "onDrop",
  "onExecCommand",
  "onFocus",
  "onFocusIn",
  "onFocusOut",
  "onGetContent",
  "onHide",
  "onInit",
  "onKeyDown",
  "onKeyPress",
  "onKeyUp",
  "onLoadContent",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onNodeChange",
  "onObjectResizeStart",
  "onObjectResized",
  "onObjectSelected",
  "onPaste",
  "onPostProcess",
  "onPostRender",
  "onPreProcess",
  "onProgressState",
  "onRedo",
  "onRemove",
  "onReset",
  "onSaveContent",
  "onSelectionChange",
  "onSetAttrib",
  "onSetContent",
  "onShow",
  "onSubmit",
  "onUndo",
  "onVisualAid"
], Yae = function(m) {
  return Xae.map(function(y) {
    return y.toLowerCase();
  }).indexOf(m.toLowerCase()) !== -1;
}, Zae = function(m, y, w) {
  Object.keys(y).filter(Yae).forEach(function(E) {
    var P = y[E];
    typeof P == "function" && (E === "onInit" ? P(m, w) : w.on(E.substring(2), function(H) {
      return P(H, w);
    }));
  });
}, Jae = function(m, y, w, E) {
  var P = m.modelEvents ? m.modelEvents : null, H = Array.isArray(P) ? P.join(" ") : P;
  Wi(E, function(X, j) {
    w && typeof X == "string" && X !== j && X !== w.getContent({ format: m.outputFormat }) && w.setContent(X);
  }), w.on(H || "change input undo redo", function() {
    y.emit("update:modelValue", w.getContent({ format: m.outputFormat }));
  });
}, Qae = function(m, y, w, E, P, H) {
  E.setContent(H()), w.attrs["onUpdate:modelValue"] && Jae(y, w, E, P), Zae(m, w.attrs, E);
}, lV = 0, PU = function(m) {
  var y = Date.now(), w = Math.floor(Math.random() * 1e9);
  return lV++, m + "_" + w + lV + String(y);
}, eoe = function(m) {
  return m !== null && m.tagName.toLowerCase() === "textarea";
}, cV = function(m) {
  return typeof m > "u" || m === "" ? [] : Array.isArray(m) ? m : m.split(" ");
}, toe = function(m, y) {
  return cV(m).concat(cV(y));
}, noe = function(m) {
  return m == null;
}, fV = function() {
  return {
    listeners: [],
    scriptId: PU("tiny-script"),
    scriptLoaded: !1
  };
}, roe = function() {
  var m = fV(), y = function(P, H, X, j) {
    var le = H.createElement("script");
    le.referrerPolicy = "origin", le.type = "application/javascript", le.id = P, le.src = X;
    var Q = function() {
      le.removeEventListener("load", Q), j();
    };
    le.addEventListener("load", Q), H.head && H.head.appendChild(le);
  }, w = function(P, H, X) {
    m.scriptLoaded ? X() : (m.listeners.push(X), P.getElementById(m.scriptId) || y(m.scriptId, P, H, function() {
      m.listeners.forEach(function(j) {
        return j();
      }), m.scriptLoaded = !0;
    }));
  }, E = function() {
    m = fV();
  };
  return {
    load: w,
    reinitialize: E
  };
}, aoe = roe(), ooe = function() {
  return typeof window < "u" ? window : global;
}, kC = function() {
  var m = ooe();
  return m && m.tinymce ? m.tinymce : null;
}, ioe = {
  apiKey: String,
  cloudChannel: String,
  id: String,
  init: Object,
  initialValue: String,
  inline: Boolean,
  modelEvents: [String, Array],
  plugins: [String, Array],
  tagName: String,
  toolbar: [String, Array],
  modelValue: String,
  disabled: Boolean,
  tinymceScriptSrc: String,
  outputFormat: {
    type: String,
    validator: function(m) {
      return m === "html" || m === "text";
    }
  }
}, _C = globalThis && globalThis.__assign || function() {
  return _C = Object.assign || function(m) {
    for (var y, w = 1, E = arguments.length; w < E; w++) {
      y = arguments[w];
      for (var P in y)
        Object.prototype.hasOwnProperty.call(y, P) && (m[P] = y[P]);
    }
    return m;
  }, _C.apply(this, arguments);
}, uoe = function(m, y, w, E) {
  return m(E || "div", {
    id: y,
    ref: w
  });
}, soe = function(m, y, w) {
  return m("textarea", {
    id: y,
    visibility: "hidden",
    ref: w
  });
}, loe = _o({
  props: ioe,
  setup: function(m, y) {
    var w = m.init ? _C({}, m.init) : {}, E = dV(m), P = E.disabled, H = E.modelValue, X = E.tagName, j = ja(null), le = null, Q = m.id || PU("tiny-vue"), pe = m.init && m.init.inline || m.inline, Y = !!y.attrs["onUpdate:modelValue"], D = !0, J = m.initialValue ? m.initialValue : "", ue = "", ee = function(ht) {
      return Y ? function() {
        return H != null && H.value ? H.value : "";
      } : function() {
        return ht ? J : ue;
      };
    }, Ge = function() {
      var ht = ee(D), ie = _C(_C({}, w), { readonly: m.disabled, selector: "#" + Q, plugins: toe(w.plugins, m.plugins), toolbar: m.toolbar || w.toolbar, inline: pe, setup: function(Ze) {
        le = Ze, Ze.on("init", function(De) {
          return Qae(De, m, y, Ze, H, ht);
        }), typeof w.setup == "function" && w.setup(Ze);
      } });
      eoe(j.value) && (j.value.style.visibility = ""), kC().init(ie), D = !1;
    };
    Wi(P, function(ht) {
      var ie;
      le !== null && (typeof ((ie = le.mode) === null || ie === void 0 ? void 0 : ie.set) == "function" ? le.mode.set(ht ? "readonly" : "design") : le.setMode(ht ? "readonly" : "design"));
    }), Wi(X, function(ht) {
      var ie;
      Y || (ue = le.getContent()), (ie = kC()) === null || ie === void 0 || ie.remove(le), Vl(function() {
        return Ge();
      });
    }), Xc(function() {
      if (kC() !== null)
        Ge();
      else if (j.value && j.value.ownerDocument) {
        var ht = m.cloudChannel ? m.cloudChannel : "5", ie = m.apiKey ? m.apiKey : "no-api-key", Ze = noe(m.tinymceScriptSrc) ? "https://cdn.tiny.cloud/1/" + ie + "/tinymce/" + ht + "/tinymce.min.js" : m.tinymceScriptSrc;
        aoe.load(j.value.ownerDocument, Ze, Ge);
      }
    }), lk(function() {
      kC() !== null && kC().remove(le);
    }), pe || (JX(function() {
      D || Ge();
    }), QX(function() {
      var ht;
      Y || (ue = le.getContent()), (ht = kC()) === null || ht === void 0 || ht.remove(le);
    }));
    var ze = function(ht) {
      var ie;
      ue = le.getContent(), (ie = kC()) === null || ie === void 0 || ie.remove(le), w = _C(_C({}, w), ht), Vl(function() {
        return Ge();
      });
    };
    return y.expose({
      rerender: ze
    }), function() {
      return pe ? uoe(R9, Q, j, m.tagName) : soe(R9, Q, j);
    };
  }
}), coe = { exports: {} };
(function(m) {
  (function() {
    var y = function(e) {
      if (e === null)
        return "null";
      if (e === void 0)
        return "undefined";
      var n = typeof e;
      return n === "object" && (Array.prototype.isPrototypeOf(e) || e.constructor && e.constructor.name === "Array") ? "array" : n === "object" && (String.prototype.isPrototypeOf(e) || e.constructor && e.constructor.name === "String") ? "string" : n;
    }, w = function(e) {
      return [
        "undefined",
        "boolean",
        "number",
        "string",
        "function",
        "xml",
        "null"
      ].indexOf(e) !== -1;
    }, E = function(e, n) {
      var a = Array.prototype.slice.call(e);
      return a.sort(n);
    }, P = function(e, n) {
      return H(function(a, i) {
        return e.eq(n(a), n(i));
      });
    }, H = function(e) {
      return { eq: e };
    }, X = H(function(e, n) {
      return e === n;
    }), j = X, le = function(e) {
      return H(function(n, a) {
        if (n.length !== a.length)
          return !1;
        for (var i = n.length, s = 0; s < i; s++)
          if (!e.eq(n[s], a[s]))
            return !1;
        return !0;
      });
    }, Q = function(e, n) {
      return P(le(e), function(a) {
        return E(a, n);
      });
    }, pe = function(e) {
      return H(function(n, a) {
        var i = Object.keys(n), s = Object.keys(a);
        if (!Q(j).eq(i, s))
          return !1;
        for (var f = i.length, p = 0; p < f; p++) {
          var C = i[p];
          if (!e.eq(n[C], a[C]))
            return !1;
        }
        return !0;
      });
    }, Y = H(function(e, n) {
      if (e === n)
        return !0;
      var a = y(e), i = y(n);
      return a !== i ? !1 : w(a) ? e === n : a === "array" ? le(Y).eq(e, n) : a === "object" ? pe(Y).eq(e, n) : !1;
    }), D = function(e) {
      var n = typeof e;
      return e === null ? "null" : n === "object" && (Array.prototype.isPrototypeOf(e) || e.constructor && e.constructor.name === "Array") ? "array" : n === "object" && (String.prototype.isPrototypeOf(e) || e.constructor && e.constructor.name === "String") ? "string" : n;
    }, J = function(e) {
      return function(n) {
        return D(n) === e;
      };
    }, ue = function(e) {
      return function(n) {
        return typeof n === e;
      };
    }, ee = function(e) {
      return function(n) {
        return e === n;
      };
    }, Ge = J("string"), ze = J("object"), ht = J("array"), ie = ee(null), Ze = ue("boolean"), De = ee(void 0), Pt = function(e) {
      return e == null;
    }, Ct = function(e) {
      return !Pt(e);
    }, Be = ue("function"), ge = ue("number"), xe = function() {
    }, _e = function(e, n) {
      return function() {
        for (var a = [], i = 0; i < arguments.length; i++)
          a[i] = arguments[i];
        return e(n.apply(null, a));
      };
    }, $ = function(e, n) {
      return function(a) {
        return e(n(a));
      };
    }, N = function(e) {
      return function() {
        return e;
      };
    }, ae = function(e) {
      return e;
    }, ce = function(e, n) {
      return e === n;
    };
    function ne(e) {
      for (var n = [], a = 1; a < arguments.length; a++)
        n[a - 1] = arguments[a];
      return function() {
        for (var i = [], s = 0; s < arguments.length; s++)
          i[s] = arguments[s];
        var f = n.concat(i);
        return e.apply(null, f);
      };
    }
    var Ce = function(e) {
      return function(n) {
        return !e(n);
      };
    }, Te = function(e) {
      return function() {
        throw new Error(e);
      };
    }, _ = function(e) {
      return e();
    }, je = function(e) {
      e();
    }, Me = N(!1), Je = N(!0), Lt = function() {
      return dt;
    }, dt = function() {
      var e = function(i) {
        return i();
      }, n = ae, a = {
        fold: function(i, s) {
          return i();
        },
        isSome: Me,
        isNone: Je,
        getOr: n,
        getOrThunk: e,
        getOrDie: function(i) {
          throw new Error(i || "error: getOrDie called on none.");
        },
        getOrNull: N(null),
        getOrUndefined: N(void 0),
        or: n,
        orThunk: e,
        map: Lt,
        each: xe,
        bind: Lt,
        exists: Me,
        forall: Je,
        filter: function() {
          return Lt();
        },
        toArray: function() {
          return [];
        },
        toString: N("none()")
      };
      return a;
    }(), Tt = function(e) {
      var n = N(e), a = function() {
        return s;
      }, i = function(f) {
        return f(e);
      }, s = {
        fold: function(f, p) {
          return p(e);
        },
        isSome: Je,
        isNone: Me,
        getOr: n,
        getOrThunk: n,
        getOrDie: n,
        getOrNull: n,
        getOrUndefined: n,
        or: a,
        orThunk: a,
        map: function(f) {
          return Tt(f(e));
        },
        each: function(f) {
          f(e);
        },
        bind: i,
        exists: i,
        forall: i,
        filter: function(f) {
          return f(e) ? s : dt;
        },
        toArray: function() {
          return [e];
        },
        toString: function() {
          return "some(" + e + ")";
        }
      };
      return s;
    }, Jt = function(e) {
      return e == null ? dt : Tt(e);
    }, se = {
      some: Tt,
      none: Lt,
      from: Jt
    }, tr = Array.prototype.slice, _t = Array.prototype.indexOf, Pe = Array.prototype.push, kt = function(e, n) {
      return _t.call(e, n);
    }, He = function(e, n) {
      var a = kt(e, n);
      return a === -1 ? se.none() : se.some(a);
    }, We = function(e, n) {
      return kt(e, n) > -1;
    }, Ae = function(e, n) {
      for (var a = 0, i = e.length; a < i; a++) {
        var s = e[a];
        if (n(s, a))
          return !0;
      }
      return !1;
    }, Ke = function(e, n) {
      for (var a = e.length, i = new Array(a), s = 0; s < a; s++) {
        var f = e[s];
        i[s] = n(f, s);
      }
      return i;
    }, at = function(e, n) {
      for (var a = 0, i = e.length; a < i; a++) {
        var s = e[a];
        n(s, a);
      }
    }, pt = function(e, n) {
      for (var a = e.length - 1; a >= 0; a--) {
        var i = e[a];
        n(i, a);
      }
    }, sn = function(e, n) {
      for (var a = [], i = [], s = 0, f = e.length; s < f; s++) {
        var p = e[s], C = n(p, s) ? a : i;
        C.push(p);
      }
      return {
        pass: a,
        fail: i
      };
    }, Ie = function(e, n) {
      for (var a = [], i = 0, s = e.length; i < s; i++) {
        var f = e[i];
        n(f, i) && a.push(f);
      }
      return a;
    }, St = function(e, n, a) {
      return pt(e, function(i, s) {
        a = n(a, i, s);
      }), a;
    }, Xe = function(e, n, a) {
      return at(e, function(i, s) {
        a = n(a, i, s);
      }), a;
    }, he = function(e, n, a) {
      for (var i = 0, s = e.length; i < s; i++) {
        var f = e[i];
        if (n(f, i))
          return se.some(f);
        if (a(f, i))
          break;
      }
      return se.none();
    }, tt = function(e, n) {
      return he(e, n, Me);
    }, gt = function(e, n) {
      for (var a = 0, i = e.length; a < i; a++) {
        var s = e[a];
        if (n(s, a))
          return se.some(a);
      }
      return se.none();
    }, Ye = function(e) {
      for (var n = [], a = 0, i = e.length; a < i; ++a) {
        if (!ht(e[a]))
          throw new Error("Arr.flatten item " + a + " was not an array, input: " + e);
        Pe.apply(n, e[a]);
      }
      return n;
    }, Qt = function(e, n) {
      return Ye(Ke(e, n));
    }, In = function(e, n) {
      for (var a = 0, i = e.length; a < i; ++a) {
        var s = e[a];
        if (n(s, a) !== !0)
          return !1;
      }
      return !0;
    }, It = function(e) {
      var n = tr.call(e, 0);
      return n.reverse(), n;
    }, qt = function(e, n) {
      return Ie(e, function(a) {
        return !We(n, a);
      });
    }, Vt = function(e, n) {
      for (var a = {}, i = 0, s = e.length; i < s; i++) {
        var f = e[i];
        a[String(f)] = n(f, i);
      }
      return a;
    }, Xt = function(e, n) {
      var a = tr.call(e, 0);
      return a.sort(n), a;
    }, on = function(e, n) {
      return n >= 0 && n < e.length ? se.some(e[n]) : se.none();
    }, Vn = function(e) {
      return on(e, 0);
    }, Un = function(e) {
      return on(e, e.length - 1);
    }, Tn = Be(Array.from) ? Array.from : function(e) {
      return tr.call(e);
    }, yt = function(e, n) {
      for (var a = 0; a < e.length; a++) {
        var i = n(e[a], a);
        if (i.isSome())
          return i;
      }
      return se.none();
    }, mn = Object.keys, zn = Object.hasOwnProperty, _n = function(e, n) {
      for (var a = mn(e), i = 0, s = a.length; i < s; i++) {
        var f = a[i], p = e[f];
        n(p, f);
      }
    }, Kr = function(e, n) {
      return ot(e, function(a, i) {
        return {
          k: i,
          v: n(a, i)
        };
      });
    }, ot = function(e, n) {
      var a = {};
      return _n(e, function(i, s) {
        var f = n(i, s);
        a[f.k] = f.v;
      }), a;
    }, Yt = function(e) {
      return function(n, a) {
        e[a] = n;
      };
    }, Ft = function(e, n, a, i) {
      var s = {};
      return _n(e, function(f, p) {
        (n(f, p) ? a : i)(f, p);
      }), s;
    }, yn = function(e, n) {
      var a = {}, i = {};
      return Ft(e, n, Yt(a), Yt(i)), {
        t: a,
        f: i
      };
    }, Yn = function(e, n) {
      var a = {};
      return Ft(e, n, Yt(a), xe), a;
    }, Ir = function(e, n) {
      var a = [];
      return _n(e, function(i, s) {
        a.push(n(i, s));
      }), a;
    }, Wa = function(e) {
      return Ir(e, ae);
    }, Mr = function(e, n) {
      return Fr(e, n) ? se.from(e[n]) : se.none();
    }, Fr = function(e, n) {
      return zn.call(e, n);
    }, Va = function(e, n) {
      return Fr(e, n) && e[n] !== void 0 && e[n] !== null;
    }, Qo = function(e, n, a) {
      return a === void 0 && (a = Y), pe(a).eq(e, n);
    }, Go = Array.isArray, so = function(e) {
      if (Go(e))
        return e;
      for (var n = [], a = 0, i = e.length; a < i; a++)
        n[a] = e[a];
      return n;
    }, bo = function(e, n, a) {
      var i, s;
      if (!e)
        return !1;
      if (a = a || e, e.length !== void 0) {
        for (i = 0, s = e.length; i < s; i++)
          if (n.call(a, e[i], i, e) === !1)
            return !1;
      } else
        for (i in e)
          if (Fr(e, i) && n.call(a, e[i], i, e) === !1)
            return !1;
      return !0;
    }, mi = function(e, n) {
      var a = [];
      return bo(e, function(i, s) {
        a.push(n(i, s, e));
      }), a;
    }, Ao = function(e, n) {
      var a = [];
      return bo(e, function(i, s) {
        (!n || n(i, s, e)) && a.push(i);
      }), a;
    }, go = function(e, n) {
      if (e) {
        for (var a = 0, i = e.length; a < i; a++)
          if (e[a] === n)
            return a;
      }
      return -1;
    }, gi = function(e, n, a, i) {
      for (var s = De(a) ? e[0] : a, f = 0; f < e.length; f++)
        s = n.call(i, s, e[f], f);
      return s;
    }, na = function(e, n, a) {
      var i, s;
      for (i = 0, s = e.length; i < s; i++)
        if (n.call(a, e[i], i, e))
          return i;
      return -1;
    }, ei = function(e) {
      return e[e.length - 1];
    }, sr = function() {
      return sr = Object.assign || function(n) {
        for (var a, i = 1, s = arguments.length; i < s; i++) {
          a = arguments[i];
          for (var f in a)
            Object.prototype.hasOwnProperty.call(a, f) && (n[f] = a[f]);
        }
        return n;
      }, sr.apply(this, arguments);
    };
    function $u(e, n) {
      var a = {};
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && n.indexOf(i) < 0 && (a[i] = e[i]);
      if (e != null && typeof Object.getOwnPropertySymbols == "function")
        for (var s = 0, i = Object.getOwnPropertySymbols(e); s < i.length; s++)
          n.indexOf(i[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[s]) && (a[i[s]] = e[i[s]]);
      return a;
    }
    function Ko(e, n, a) {
      if (a || arguments.length === 2)
        for (var i = 0, s = n.length, f; i < s; i++)
          (f || !(i in n)) && (f || (f = Array.prototype.slice.call(n, 0, i)), f[i] = n[i]);
      return e.concat(f || Array.prototype.slice.call(n));
    }
    var pi = function(e) {
      var n = !1, a;
      return function() {
        for (var i = [], s = 0; s < arguments.length; s++)
          i[s] = arguments[s];
        return n || (n = !0, a = e.apply(null, i)), a;
      };
    }, Po = function(e, n, a, i) {
      var s = e.isiOS() && /ipad/i.test(a) === !0, f = e.isiOS() && !s, p = e.isiOS() || e.isAndroid(), C = p || i("(pointer:coarse)"), k = s || !f && p && i("(min-device-width:768px)"), F = f || p && !k, q = n.isSafari() && e.isiOS() && /safari/i.test(a) === !1, K = !F && !k && !q;
      return {
        isiPad: N(s),
        isiPhone: N(f),
        isTablet: N(k),
        isPhone: N(F),
        isTouch: N(C),
        isAndroid: e.isAndroid,
        isiOS: e.isiOS,
        isWebView: N(q),
        isDesktop: N(K)
      };
    }, Si = function(e, n) {
      for (var a = 0; a < e.length; a++) {
        var i = e[a];
        if (i.test(n))
          return i;
      }
    }, Su = function(e, n) {
      var a = Si(e, n);
      if (!a)
        return {
          major: 0,
          minor: 0
        };
      var i = function(s) {
        return Number(n.replace(a, "$" + s));
      };
      return Lo(i(1), i(2));
    }, xi = function(e, n) {
      var a = String(n).toLowerCase();
      return e.length === 0 ? Ju() : Su(e, a);
    }, Ju = function() {
      return Lo(0, 0);
    }, Lo = function(e, n) {
      return {
        major: e,
        minor: n
      };
    }, yo = {
      nu: Lo,
      detect: xi,
      unknown: Ju
    }, Bn = function(e, n) {
      return yt(n.brands, function(a) {
        var i = a.brand.toLowerCase();
        return tt(e, function(s) {
          var f;
          return i === ((f = s.brand) === null || f === void 0 ? void 0 : f.toLowerCase());
        }).map(function(s) {
          return {
            current: s.name,
            version: yo.nu(parseInt(a.version, 10), 0)
          };
        });
      });
    }, xu = function(e, n) {
      var a = String(n).toLowerCase();
      return tt(e, function(i) {
        return i.search(a);
      });
    }, ku = function(e, n) {
      return xu(e, n).map(function(a) {
        var i = yo.detect(a.versionRegexes, n);
        return {
          current: a.name,
          version: i
        };
      });
    }, Tu = function(e, n) {
      return xu(e, n).map(function(a) {
        var i = yo.detect(a.versionRegexes, n);
        return {
          current: a.name,
          version: i
        };
      });
    }, Ue = function(e, n) {
      return e.substring(n);
    }, et = function(e, n, a) {
      return n === "" || e.length >= n.length && e.substr(a, a + n.length) === n;
    }, en = function(e, n) {
      return Z(e, n) ? Ue(e, n.length) : e;
    }, gn = function(e, n) {
      return e.indexOf(n) !== -1;
    }, Z = function(e, n) {
      return et(e, n, 0);
    }, ye = function(e) {
      return function(n) {
        return n.replace(e, "");
      };
    }, Ve = ye(/^\s+|\s+$/g), lt = ye(/^\s+/g), Et = ye(/\s+$/g), Ot = function(e) {
      return e.length > 0;
    }, Rn = function(e) {
      return !Ot(e);
    }, er = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/, Rr = function(e) {
      return function(n) {
        return gn(n, e);
      };
    }, Nt = [
      {
        name: "Edge",
        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
        search: function(e) {
          return gn(e, "edge/") && gn(e, "chrome") && gn(e, "safari") && gn(e, "applewebkit");
        }
      },
      {
        name: "Chrome",
        brand: "Chromium",
        versionRegexes: [
          /.*?chrome\/([0-9]+)\.([0-9]+).*/,
          er
        ],
        search: function(e) {
          return gn(e, "chrome") && !gn(e, "chromeframe");
        }
      },
      {
        name: "IE",
        versionRegexes: [
          /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
          /.*?rv:([0-9]+)\.([0-9]+).*/
        ],
        search: function(e) {
          return gn(e, "msie") || gn(e, "trident");
        }
      },
      {
        name: "Opera",
        versionRegexes: [
          er,
          /.*?opera\/([0-9]+)\.([0-9]+).*/
        ],
        search: Rr("opera")
      },
      {
        name: "Firefox",
        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
        search: Rr("firefox")
      },
      {
        name: "Safari",
        versionRegexes: [
          er,
          /.*?cpu os ([0-9]+)_([0-9]+).*/
        ],
        search: function(e) {
          return (gn(e, "safari") || gn(e, "mobile/")) && gn(e, "applewebkit");
        }
      }
    ], vr = [
      {
        name: "Windows",
        search: Rr("win"),
        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
      },
      {
        name: "iOS",
        search: function(e) {
          return gn(e, "iphone") || gn(e, "ipad");
        },
        versionRegexes: [
          /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
          /.*cpu os ([0-9]+)_([0-9]+).*/,
          /.*cpu iphone os ([0-9]+)_([0-9]+).*/
        ]
      },
      {
        name: "Android",
        search: Rr("android"),
        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
      },
      {
        name: "OSX",
        search: Rr("mac os x"),
        versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
      },
      {
        name: "Linux",
        search: Rr("linux"),
        versionRegexes: []
      },
      {
        name: "Solaris",
        search: Rr("sunos"),
        versionRegexes: []
      },
      {
        name: "FreeBSD",
        search: Rr("freebsd"),
        versionRegexes: []
      },
      {
        name: "ChromeOS",
        search: Rr("cros"),
        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
      }
    ], Nr = {
      browsers: N(Nt),
      oses: N(vr)
    }, Sa = "Edge", po = "Chrome", Xr = "IE", Lu = "Opera", Eu = "Firefox", vo = "Safari", Fs = function() {
      return ki({
        current: void 0,
        version: yo.unknown()
      });
    }, ki = function(e) {
      var n = e.current, a = e.version, i = function(s) {
        return function() {
          return n === s;
        };
      };
      return {
        current: n,
        version: a,
        isEdge: i(Sa),
        isChrome: i(po),
        isIE: i(Xr),
        isOpera: i(Lu),
        isFirefox: i(Eu),
        isSafari: i(vo)
      };
    }, Fi = {
      unknown: Fs,
      nu: ki,
      edge: N(Sa),
      chrome: N(po),
      ie: N(Xr),
      opera: N(Lu),
      firefox: N(Eu),
      safari: N(vo)
    }, za = "Windows", $s = "iOS", Qu = "Android", hs = "Linux", rl = "OSX", $i = "Solaris", au = "FreeBSD", al = "ChromeOS", qi = function() {
      return Li({
        current: void 0,
        version: yo.unknown()
      });
    }, Li = function(e) {
      var n = e.current, a = e.version, i = function(s) {
        return function() {
          return n === s;
        };
      };
      return {
        current: n,
        version: a,
        isWindows: i(za),
        isiOS: i($s),
        isAndroid: i(Qu),
        isOSX: i(rl),
        isLinux: i(hs),
        isSolaris: i($i),
        isFreeBSD: i(au),
        isChromeOS: i(al)
      };
    }, ve = {
      unknown: qi,
      nu: Li,
      windows: N(za),
      ios: N($s),
      android: N(Qu),
      linux: N(hs),
      osx: N(rl),
      solaris: N($i),
      freebsd: N(au),
      chromeos: N(al)
    }, nt = function(e, n, a) {
      var i = Nr.browsers(), s = Nr.oses(), f = n.bind(function(k) {
        return Bn(i, k);
      }).orThunk(function() {
        return ku(i, e);
      }).fold(Fi.unknown, Fi.nu), p = Tu(s, e).fold(ve.unknown, ve.nu), C = Po(p, f, e, a);
      return {
        browser: f,
        os: p,
        deviceType: C
      };
    }, wt = { detect: nt }, Zt = function(e) {
      return window.matchMedia(e).matches;
    }, En = pi(function() {
      return wt.detect(navigator.userAgent, se.from(navigator.userAgentData), Zt);
    }), lr = function() {
      return En();
    }, ya = navigator.userAgent, Aa = lr(), Yr = Aa.browser, qa = Aa.os, ao = Aa.deviceType, es = /WebKit/.test(ya) && !Yr.isEdge(), ti = "FormData" in window && "FileReader" in window && "URL" in window && !!URL.createObjectURL, zu = ya.indexOf("Windows Phone") !== -1, br = {
      opera: Yr.isOpera(),
      webkit: es,
      ie: Yr.isIE() || Yr.isEdge() ? Yr.version.major : !1,
      gecko: Yr.isFirefox(),
      mac: qa.isOSX() || qa.isiOS(),
      iOS: ao.isiPad() || ao.isiPhone(),
      android: qa.isAndroid(),
      contentEditable: !0,
      transparentSrc: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      caretAfter: !0,
      range: window.getSelection && "Range" in window,
      documentMode: Yr.isIE() ? document.documentMode || 7 : 10,
      fileApi: ti,
      ceFalse: !0,
      cacheSuffix: null,
      container: null,
      experimentalShadowDom: !1,
      canHaveCSP: !Yr.isIE(),
      desktop: ao.isDesktop(),
      windowsPhone: zu,
      browser: {
        current: Yr.current,
        version: Yr.version,
        isChrome: Yr.isChrome,
        isEdge: Yr.isEdge,
        isFirefox: Yr.isFirefox,
        isIE: Yr.isIE,
        isOpera: Yr.isOpera,
        isSafari: Yr.isSafari
      },
      os: {
        current: qa.current,
        version: qa.version,
        isAndroid: qa.isAndroid,
        isChromeOS: qa.isChromeOS,
        isFreeBSD: qa.isFreeBSD,
        isiOS: qa.isiOS,
        isLinux: qa.isLinux,
        isOSX: qa.isOSX,
        isSolaris: qa.isSolaris,
        isWindows: qa.isWindows
      },
      deviceType: {
        isDesktop: ao.isDesktop,
        isiPad: ao.isiPad,
        isiPhone: ao.isiPhone,
        isPhone: ao.isPhone,
        isTablet: ao.isTablet,
        isTouch: ao.isTouch,
        isWebView: ao.isWebView
      }
    }, bs = /^\s*|\s*$/g, yc = function(e) {
      return e == null ? "" : ("" + e).replace(bs, "");
    }, va = function(e, n) {
      return n ? n === "array" && Go(e) ? !0 : typeof e === n : e !== void 0;
    }, Wl = function(e, n, a) {
      var i;
      for (e = e || [], n = n || ",", typeof e == "string" && (e = e.split(n)), a = a || {}, i = e.length; i--; )
        a[e[i]] = {};
      return a;
    }, ql = Fr, Yc = function(e, n, a) {
      var i = this, s, f, p, C = 0;
      e = /^((static) )?([\w.]+)(:([\w.]+))?/.exec(e);
      var k = e[3].match(/(^|\.)(\w+)$/i)[2], F = i.createNS(e[3].replace(/\.\w+$/, ""), a);
      if (!F[k]) {
        if (e[2] === "static") {
          F[k] = n, this.onCreate && this.onCreate(e[2], e[3], F[k]);
          return;
        }
        n[k] || (n[k] = function() {
        }, C = 1), F[k] = n[k], i.extend(F[k].prototype, n), e[5] && (s = i.resolve(e[5]).prototype, f = e[5].match(/\.(\w+)$/i)[1], p = F[k], C ? F[k] = function() {
          return s[f].apply(this, arguments);
        } : F[k] = function() {
          return this.parent = s[f], p.apply(this, arguments);
        }, F[k].prototype[k] = F[k], i.each(s, function(q, K) {
          F[k].prototype[K] = s[K];
        }), i.each(n, function(q, K) {
          s[K] ? F[k].prototype[K] = function() {
            return this.parent = s[K], q.apply(this, arguments);
          } : K !== k && (F[k].prototype[K] = q);
        })), i.each(n.static, function(q, K) {
          F[k][K] = q;
        });
      }
    }, Fa = function(e) {
      for (var n = [], a = 1; a < arguments.length; a++)
        n[a - 1] = arguments[a];
      for (var i = 0; i < n.length; i++) {
        var s = n[i];
        for (var f in s)
          if (Fr(s, f)) {
            var p = s[f];
            p !== void 0 && (e[f] = p);
          }
      }
      return e;
    }, ou = function(e, n, a, i) {
      i = i || this, e && (a && (e = e[a]), bo(e, function(s, f) {
        if (n.call(i, s, f, a) === !1)
          return !1;
        ou(s, n, a, i);
      }));
    }, Vf = function(e, n) {
      var a, i;
      for (n = n || window, e = e.split("."), a = 0; a < e.length; a++)
        i = e[a], n[i] || (n[i] = {}), n = n[i];
      return n;
    }, _u = function(e, n) {
      var a, i;
      for (n = n || window, e = e.split("."), a = 0, i = e.length; a < i && (n = n[e[a]], !!n); a++)
        ;
      return n;
    }, wo = function(e, n) {
      return !e || va(e, "array") ? e : mi(e.split(n || ","), yc);
    }, Ls = function(e) {
      var n = br.cacheSuffix;
      return n && (e += (e.indexOf("?") === -1 ? "?" : "&") + n), e;
    }, Ut = {
      trim: yc,
      isArray: Go,
      is: va,
      toArray: so,
      makeMap: Wl,
      each: bo,
      map: mi,
      grep: Ao,
      inArray: go,
      hasOwn: ql,
      extend: Fa,
      create: Yc,
      walk: ou,
      createNS: Vf,
      resolve: _u,
      explode: wo,
      _addCacheSuffix: Ls
    }, ol = function(e, n) {
      var a = n || document, i = a.createElement("div");
      if (i.innerHTML = e, !i.hasChildNodes() || i.childNodes.length > 1)
        throw console.error("HTML does not have a single root node", e), new Error("HTML must have a single root node");
      return ys(i.childNodes[0]);
    }, Co = function(e, n) {
      var a = n || document, i = a.createElement(e);
      return ys(i);
    }, wc = function(e, n) {
      var a = n || document, i = a.createTextNode(e);
      return ys(i);
    }, ys = function(e) {
      if (e == null)
        throw new Error("Node cannot be null or undefined");
      return { dom: e };
    }, V = function(e, n, a) {
      return se.from(e.dom.elementFromPoint(n, a)).map(ys);
    }, O = {
      fromHtml: ol,
      fromTag: Co,
      fromText: wc,
      fromDom: ys,
      fromPoint: V
    }, x = function(e, n) {
      var a = [], i = function(f) {
        return a.push(f), n(f);
      }, s = n(e);
      do
        s = s.bind(i);
      while (s.isSome());
      return a;
    }, I = function(e, n, a) {
      return (e.compareDocumentPosition(n) & a) !== 0;
    }, re = function(e, n) {
      return I(e, n, Node.DOCUMENT_POSITION_CONTAINED_BY);
    }, Oe = 8, vt = 9, rn = 11, or = 1, wr = 3, Nn = function(e, n) {
      var a = e.dom;
      if (a.nodeType !== or)
        return !1;
      var i = a;
      if (i.matches !== void 0)
        return i.matches(n);
      if (i.msMatchesSelector !== void 0)
        return i.msMatchesSelector(n);
      if (i.webkitMatchesSelector !== void 0)
        return i.webkitMatchesSelector(n);
      if (i.mozMatchesSelector !== void 0)
        return i.mozMatchesSelector(n);
      throw new Error("Browser lacks native selectors");
    }, nr = function(e) {
      return e.nodeType !== or && e.nodeType !== vt && e.nodeType !== rn || e.childElementCount === 0;
    }, jr = function(e, n) {
      var a = n === void 0 ? document : n.dom;
      return nr(a) ? [] : Ke(a.querySelectorAll(e), O.fromDom);
    }, Vr = function(e, n) {
      var a = n === void 0 ? document : n.dom;
      return nr(a) ? se.none() : se.from(a.querySelector(e)).map(O.fromDom);
    }, Dr = function(e, n) {
      return e.dom === n.dom;
    }, Qa = function(e, n) {
      var a = e.dom, i = n.dom;
      return a === i ? !1 : a.contains(i);
    }, Tr = function(e, n) {
      return re(e.dom, n.dom);
    }, $a = function(e, n) {
      return lr().browser.isIE() ? Tr(e, n) : Qa(e, n);
    };
    typeof window < "u" || Function("return this;")();
    var Oa = function(e) {
      var n = e.dom.nodeName;
      return n.toLowerCase();
    }, Ti = function(e) {
      return e.dom.nodeType;
    }, Qr = function(e) {
      return function(n) {
        return Ti(n) === e;
      };
    }, zs = function(e) {
      return Ti(e) === Oe || Oa(e) === "#comment";
    }, So = Qr(or), No = Qr(wr), w1 = Qr(vt), Gi = Qr(rn), Ip = function(e) {
      return function(n) {
        return So(n) && Oa(n) === e;
      };
    }, Gl = function(e) {
      return O.fromDom(e.dom.ownerDocument);
    }, Pr = function(e) {
      return w1(e) ? e : Gl(e);
    }, Hs = function(e) {
      return O.fromDom(Pr(e).dom.documentElement);
    }, zo = function(e) {
      return O.fromDom(Pr(e).dom.defaultView);
    }, Ho = function(e) {
      return se.from(e.dom.parentNode).map(O.fromDom);
    }, Ei = function(e, n) {
      for (var a = Be(n) ? n : Me, i = e.dom, s = []; i.parentNode !== null && i.parentNode !== void 0; ) {
        var f = i.parentNode, p = O.fromDom(f);
        if (s.push(p), a(p) === !0)
          break;
        i = f;
      }
      return s;
    }, ui = function(e) {
      var n = function(a) {
        return Ie(a, function(i) {
          return !Dr(e, i);
        });
      };
      return Ho(e).map(Hu).map(n).getOr([]);
    }, Uf = function(e) {
      return se.from(e.dom.previousSibling).map(O.fromDom);
    }, il = function(e) {
      return se.from(e.dom.nextSibling).map(O.fromDom);
    }, Da = function(e) {
      return It(x(e, Uf));
    }, mo = function(e) {
      return x(e, il);
    }, Hu = function(e) {
      return Ke(e.dom.childNodes, O.fromDom);
    }, Cc = function(e, n) {
      var a = e.dom.childNodes;
      return se.from(a[n]).map(O.fromDom);
    }, hi = function(e) {
      return Cc(e, 0);
    }, Vs = function(e) {
      return Cc(e, e.dom.childNodes.length - 1);
    }, C1 = function(e) {
      return e.dom.childNodes.length;
    }, jf = function(e) {
      var n = e.dom.head;
      if (n == null)
        throw new Error("Head is not available yet");
      return O.fromDom(n);
    }, eo = function(e) {
      return Gi(e) && Ct(e.dom.host);
    }, El = Be(Element.prototype.attachShadow) && Be(Node.prototype.getRootNode), Zc = N(El), ts = El ? function(e) {
      return O.fromDom(e.dom.getRootNode());
    } : Pr, Xo = function(e) {
      return eo(e) ? e : jf(Pr(e));
    }, Jc = function(e) {
      var n = ts(e);
      return eo(n) ? se.some(n) : se.none();
    }, Sc = function(e) {
      return O.fromDom(e.dom.host);
    }, Au = function(e) {
      if (Zc() && Ct(e.target)) {
        var n = O.fromDom(e.target);
        if (So(n) && ns(n) && e.composed && e.composedPath) {
          var a = e.composedPath();
          if (a)
            return Vn(a);
        }
      }
      return se.from(e.target);
    }, ns = function(e) {
      return Ct(e.dom.shadowRoot);
    }, iu = function(e, n) {
      var a = Ho(e);
      a.each(function(i) {
        i.dom.insertBefore(n.dom, e.dom);
      });
    }, Nv = function(e, n) {
      var a = il(e);
      a.fold(function() {
        var i = Ho(e);
        i.each(function(s) {
          _i(s, n);
        });
      }, function(i) {
        iu(i, n);
      });
    }, _l = function(e, n) {
      var a = hi(e);
      a.fold(function() {
        _i(e, n);
      }, function(i) {
        e.dom.insertBefore(n.dom, i.dom);
      });
    }, _i = function(e, n) {
      e.dom.appendChild(n.dom);
    }, Pd = function(e, n) {
      iu(e, n), _i(n, e);
    }, S1 = function(e, n) {
      at(n, function(a) {
        iu(e, a);
      });
    }, Wf = function(e, n) {
      at(n, function(a) {
        _i(e, a);
      });
    }, qf = function(e) {
      e.dom.textContent = "", at(Hu(e), function(n) {
        Yo(n);
      });
    }, Yo = function(e) {
      var n = e.dom;
      n.parentNode !== null && n.parentNode.removeChild(n);
    }, Gf = function(e) {
      var n = Hu(e);
      n.length > 0 && S1(e, n), Yo(e);
    }, Kf = function(e) {
      var n = No(e) ? e.dom.parentNode : e.dom;
      if (n == null || n.ownerDocument === null)
        return !1;
      var a = n.ownerDocument;
      return Jc(O.fromDom(n)).fold(function() {
        return a.body.contains(n);
      }, $(Kf, Sc));
    }, Ou = function(e, n) {
      var a = function(i, s) {
        return Ou(e + i, n + s);
      };
      return {
        left: e,
        top: n,
        translate: a
      };
    }, xc = Ou, Xf = function(e) {
      var n = e.getBoundingClientRect();
      return xc(n.left, n.top);
    }, kc = function(e, n) {
      return e !== void 0 ? e : n !== void 0 ? n : 0;
    }, Oo = function(e) {
      var n = e.dom.ownerDocument, a = n.body, i = n.defaultView, s = n.documentElement;
      if (a === e.dom)
        return xc(a.offsetLeft, a.offsetTop);
      var f = kc(i == null ? void 0 : i.pageYOffset, s.scrollTop), p = kc(i == null ? void 0 : i.pageXOffset, s.scrollLeft), C = kc(s.clientTop, a.clientTop), k = kc(s.clientLeft, a.clientLeft);
      return ws(e).translate(p - k, f - C);
    }, ws = function(e) {
      var n = e.dom, a = n.ownerDocument, i = a.body;
      return i === n ? xc(i.offsetLeft, i.offsetTop) : Kf(e) ? Xf(n) : xc(0, 0);
    }, Wm = function(e) {
      var n = e !== void 0 ? e.dom : document, a = n.body.scrollLeft || n.documentElement.scrollLeft, i = n.body.scrollTop || n.documentElement.scrollTop;
      return xc(a, i);
    }, Us = function(e, n, a) {
      var i = a !== void 0 ? a.dom : document, s = i.defaultView;
      s && s.scrollTo(e, n);
    }, qm = function(e, n) {
      var a = lr().browser.isSafari();
      a && Be(e.dom.scrollIntoViewIfNeeded) ? e.dom.scrollIntoViewIfNeeded(!1) : e.dom.scrollIntoView(n);
    }, x1 = function(e) {
      var n = e === void 0 ? window : e;
      return lr().browser.isFirefox() ? se.none() : se.from(n.visualViewport);
    }, Fp = function(e, n, a, i) {
      return {
        x: e,
        y: n,
        width: a,
        height: i,
        right: e + a,
        bottom: n + i
      };
    }, Yf = function(e) {
      var n = e === void 0 ? window : e, a = n.document, i = Wm(O.fromDom(a));
      return x1(n).fold(function() {
        var s = n.document.documentElement, f = s.clientWidth, p = s.clientHeight;
        return Fp(i.left, i.top, f, p);
      }, function(s) {
        return Fp(Math.max(s.pageLeft, i.left), Math.max(s.pageTop, i.top), s.width, s.height);
      });
    }, Zf = function(e) {
      return function(n) {
        return !!n && n.nodeType === e;
      };
    }, Qc = function(e) {
      return !!e && !Object.getPrototypeOf(e);
    }, $r = Zf(1), ul = function(e) {
      var n = e.map(function(a) {
        return a.toLowerCase();
      });
      return function(a) {
        if (a && a.nodeName) {
          var i = a.nodeName.toLowerCase();
          return We(n, i);
        }
        return !1;
      };
    }, rs = function(e, n) {
      var a = n.toLowerCase().split(" ");
      return function(i) {
        if ($r(i))
          for (var s = 0; s < a.length; s++) {
            var f = i.ownerDocument.defaultView.getComputedStyle(i, null), p = f ? f.getPropertyValue(e) : null;
            if (p === a[s])
              return !0;
          }
        return !1;
      };
    }, Du = function(e) {
      return function(n) {
        return $r(n) && n.hasAttribute(e);
      };
    }, sl = function(e, n) {
      return function(a) {
        return $r(a) && a.getAttribute(e) === n;
      };
    }, ni = function(e) {
      return $r(e) && e.hasAttribute("data-mce-bogus");
    }, Ai = function(e) {
      return $r(e) && e.getAttribute("data-mce-bogus") === "all";
    }, si = function(e) {
      return $r(e) && e.tagName === "TABLE";
    }, ef = function(e) {
      return function(n) {
        return !!($r(n) && (n.contentEditable === e || n.getAttribute("data-mce-contenteditable") === e));
      };
    }, uu = ul([
      "textarea",
      "input"
    ]), Qn = Zf(3), Jf = Zf(8), $p = Zf(9), ea = Zf(11), to = ul(["br"]), Gm = ul(["img"]), Kl = ef("true"), xo = ef("false"), Km = ul([
      "td",
      "th"
    ]), Cs = ul([
      "video",
      "audio",
      "object",
      "embed"
    ]), Nd = function(e, n, a) {
      return a === void 0 && (a = ce), e.exists(function(i) {
        return a(i, n);
      });
    }, ra = function(e) {
      for (var n = [], a = function(s) {
        n.push(s);
      }, i = 0; i < e.length; i++)
        e[i].each(a);
      return n;
    }, Vu = function(e, n, a) {
      return e.isSome() && n.isSome() ? se.some(a(e.getOrDie(), n.getOrDie())) : se.none();
    }, ty = function(e, n, a, i) {
      return e.isSome() && n.isSome() && a.isSome() ? se.some(i(e.getOrDie(), n.getOrDie(), a.getOrDie())) : se.none();
    }, ny = function(e, n) {
      return e ? se.some(n) : se.none();
    }, Do = function(e) {
      return e.style !== void 0 && Be(e.style.getPropertyValue);
    }, Xm = function(e, n, a) {
      if (Ge(a) || Ze(a) || ge(a))
        e.setAttribute(n, a + "");
      else
        throw console.error("Invalid call to Attribute.set. Key ", n, ":: Value ", a, ":: Element ", e), new Error("Attribute value was not simple");
    }, M = function(e, n, a) {
      Xm(e.dom, n, a);
    }, G = function(e, n) {
      var a = e.dom;
      _n(n, function(i, s) {
        Xm(a, s, i);
      });
    }, fe = function(e, n) {
      var a = e.dom.getAttribute(n);
      return a === null ? void 0 : a;
    }, Fe = function(e, n) {
      return se.from(fe(e, n));
    }, bt = function(e, n) {
      var a = e.dom;
      return a && a.hasAttribute ? a.hasAttribute(n) : !1;
    }, Gt = function(e, n) {
      e.dom.removeAttribute(n);
    }, fr = function(e) {
      return Xe(e.dom.attributes, function(n, a) {
        return n[a.name] = a.value, n;
      }, {});
    }, Wr = function(e, n, a) {
      if (!Ge(a))
        throw console.error("Invalid call to CSS.set. Property ", n, ":: Value ", a, ":: Element ", e), new Error("CSS value must be a string: " + a);
      Do(e) && e.style.setProperty(n, a);
    }, da = function(e, n) {
      var a = e.dom;
      _n(n, function(i, s) {
        Wr(a, s, i);
      });
    }, aa = function(e, n) {
      var a = e.dom, i = window.getComputedStyle(a), s = i.getPropertyValue(n);
      return s === "" && !Kf(e) ? oo(a, n) : s;
    }, oo = function(e, n) {
      return Do(e) ? e.style.getPropertyValue(n) : "";
    }, su = function(e, n) {
      var a = e.dom, i = oo(a, n);
      return se.from(i).filter(function(s) {
        return s.length > 0;
      });
    }, Vo = function(e) {
      var n = {}, a = e.dom;
      if (Do(a))
        for (var i = 0; i < a.style.length; i++) {
          var s = a.style.item(i);
          n[s] = a.style[s];
        }
      return n;
    }, dk = function(e) {
      return e.dom.offsetWidth;
    }, zC = lr().browser, HC = function(e) {
      return tt(e, So);
    }, mk = function(e) {
      return zC.isFirefox() && Oa(e) === "table" ? HC(Hu(e)).filter(function(n) {
        return Oa(n) === "caption";
      }).bind(function(n) {
        return HC(mo(n)).map(function(a) {
          var i = a.dom.offsetTop, s = n.dom.offsetTop, f = n.dom.offsetHeight;
          return i <= s ? -f : 0;
        });
      }).getOr(0) : 0;
    }, Tc = function(e, n) {
      return e.children && We(e.children, n);
    }, Lp = function(e, n, a) {
      var i = 0, s = 0, f = e.ownerDocument;
      if (a = a || e, n) {
        if (a === e && n.getBoundingClientRect && aa(O.fromDom(e), "position") === "static") {
          var p = n.getBoundingClientRect();
          return i = p.left + (f.documentElement.scrollLeft || e.scrollLeft) - f.documentElement.clientLeft, s = p.top + (f.documentElement.scrollTop || e.scrollTop) - f.documentElement.clientTop, {
            x: i,
            y: s
          };
        }
        for (var C = n; C && C !== a && C.nodeType && !Tc(C, a); ) {
          var k = C;
          i += k.offsetLeft || 0, s += k.offsetTop || 0, C = k.offsetParent;
        }
        for (C = n.parentNode; C && C !== a && C.nodeType && !Tc(C, a); )
          i -= C.scrollLeft || 0, s -= C.scrollTop || 0, C = C.parentNode;
        s += mk(O.fromDom(n));
      }
      return {
        x: i,
        y: s
      };
    }, Ss = {}, Ym = { exports: Ss };
    (function(e, n, a, i) {
      (function(s, f) {
        typeof n == "object" && typeof a < "u" ? a.exports = f() : typeof e == "function" && e.amd ? e(f) : (s = typeof globalThis < "u" ? globalThis : s || self, s.EphoxContactWrapper = f());
      })(this, function() {
        var s = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof QB < "u" ? QB : typeof self < "u" ? self : {}, f = { exports: {} };
        (function(F) {
          (function(q) {
            var K = setTimeout;
            function te() {
            }
            function be(Qe, At) {
              return function() {
                Qe.apply(At, arguments);
              };
            }
            function we(Qe) {
              if (typeof this != "object")
                throw new TypeError("Promises must be constructed via new");
              if (typeof Qe != "function")
                throw new TypeError("not a function");
              this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], mt(Qe, this);
            }
            function ke(Qe, At) {
              for (; Qe._state === 3; )
                Qe = Qe._value;
              if (Qe._state === 0) {
                Qe._deferreds.push(At);
                return;
              }
              Qe._handled = !0, we._immediateFn(function() {
                var tn = Qe._state === 1 ? At.onFulfilled : At.onRejected;
                if (tn === null) {
                  (Qe._state === 1 ? Ee : qe)(At.promise, Qe._value);
                  return;
                }
                var Cn;
                try {
                  Cn = tn(Qe._value);
                } catch (Ar) {
                  qe(At.promise, Ar);
                  return;
                }
                Ee(At.promise, Cn);
              });
            }
            function Ee(Qe, At) {
              try {
                if (At === Qe)
                  throw new TypeError("A promise cannot be resolved with itself.");
                if (At && (typeof At == "object" || typeof At == "function")) {
                  var tn = At.then;
                  if (At instanceof we) {
                    Qe._state = 3, Qe._value = At, Le(Qe);
                    return;
                  } else if (typeof tn == "function") {
                    mt(be(tn, At), Qe);
                    return;
                  }
                }
                Qe._state = 1, Qe._value = At, Le(Qe);
              } catch (Cn) {
                qe(Qe, Cn);
              }
            }
            function qe(Qe, At) {
              Qe._state = 2, Qe._value = At, Le(Qe);
            }
            function Le(Qe) {
              Qe._state === 2 && Qe._deferreds.length === 0 && we._immediateFn(function() {
                Qe._handled || we._unhandledRejectionFn(Qe._value);
              });
              for (var At = 0, tn = Qe._deferreds.length; At < tn; At++)
                ke(Qe, Qe._deferreds[At]);
              Qe._deferreds = null;
            }
            function xt(Qe, At, tn) {
              this.onFulfilled = typeof Qe == "function" ? Qe : null, this.onRejected = typeof At == "function" ? At : null, this.promise = tn;
            }
            function mt(Qe, At) {
              var tn = !1;
              try {
                Qe(function(Cn) {
                  tn || (tn = !0, Ee(At, Cn));
                }, function(Cn) {
                  tn || (tn = !0, qe(At, Cn));
                });
              } catch (Cn) {
                if (tn)
                  return;
                tn = !0, qe(At, Cn);
              }
            }
            we.prototype.catch = function(Qe) {
              return this.then(null, Qe);
            }, we.prototype.then = function(Qe, At) {
              var tn = new this.constructor(te);
              return ke(this, new xt(Qe, At, tn)), tn;
            }, we.all = function(Qe) {
              var At = Array.prototype.slice.call(Qe);
              return new we(function(tn, Cn) {
                if (At.length === 0)
                  return tn([]);
                var Ar = At.length;
                function Xn(_r, kn) {
                  try {
                    if (kn && (typeof kn == "object" || typeof kn == "function")) {
                      var Kn = kn.then;
                      if (typeof Kn == "function") {
                        Kn.call(kn, function(On) {
                          Xn(_r, On);
                        }, Cn);
                        return;
                      }
                    }
                    At[_r] = kn, --Ar === 0 && tn(At);
                  } catch (On) {
                    Cn(On);
                  }
                }
                for (var fn = 0; fn < At.length; fn++)
                  Xn(fn, At[fn]);
              });
            }, we.resolve = function(Qe) {
              return Qe && typeof Qe == "object" && Qe.constructor === we ? Qe : new we(function(At) {
                At(Qe);
              });
            }, we.reject = function(Qe) {
              return new we(function(At, tn) {
                tn(Qe);
              });
            }, we.race = function(Qe) {
              return new we(function(At, tn) {
                for (var Cn = 0, Ar = Qe.length; Cn < Ar; Cn++)
                  Qe[Cn].then(At, tn);
              });
            }, we._immediateFn = typeof setImmediate == "function" ? function(Qe) {
              setImmediate(Qe);
            } : function(Qe) {
              K(Qe, 0);
            }, we._unhandledRejectionFn = function(At) {
              typeof console < "u" && console && console.warn("Possible Unhandled Promise Rejection:", At);
            }, we._setImmediateFn = function(At) {
              we._immediateFn = At;
            }, we._setUnhandledRejectionFn = function(At) {
              we._unhandledRejectionFn = At;
            }, F.exports ? F.exports = we : q.Promise || (q.Promise = we);
          })(s);
        })(f);
        var p = f.exports, C = function() {
          return typeof window < "u" ? window : Function("return this;")();
        }(), k = { boltExport: C.Promise || p };
        return k;
      });
    })(void 0, Ss, Ym);
    var ry = Ym.exports.boltExport, zp = function(e) {
      var n = se.none(), a = [], i = function(F) {
        return zp(function(q) {
          s(function(K) {
            q(F(K));
          });
        });
      }, s = function(F) {
        p() ? k(F) : a.push(F);
      }, f = function(F) {
        p() || (n = se.some(F), C(a), a = []);
      }, p = function() {
        return n.isSome();
      }, C = function(F) {
        at(F, k);
      }, k = function(F) {
        n.each(function(q) {
          setTimeout(function() {
            F(q);
          }, 0);
        });
      };
      return e(f), {
        get: s,
        map: i,
        isReady: p
      };
    }, k1 = function(e) {
      return zp(function(n) {
        n(e);
      });
    }, VC = {
      nu: zp,
      pure: k1
    }, gk = function(e) {
      setTimeout(function() {
        throw e;
      }, 0);
    }, Ec = function(e) {
      var n = function(k) {
        e().then(k, gk);
      }, a = function(k) {
        return Ec(function() {
          return e().then(k);
        });
      }, i = function(k) {
        return Ec(function() {
          return e().then(function(F) {
            return k(F).toPromise();
          });
        });
      }, s = function(k) {
        return Ec(function() {
          return e().then(function() {
            return k.toPromise();
          });
        });
      }, f = function() {
        return VC.nu(n);
      }, p = function() {
        var k = null;
        return Ec(function() {
          return k === null && (k = e()), k;
        });
      }, C = e;
      return {
        map: a,
        bind: i,
        anonBind: s,
        toLazy: f,
        toCached: p,
        toPromise: C,
        get: n
      };
    }, Hp = function(e) {
      return Ec(function() {
        return new ry(e);
      });
    }, pk = function(e) {
      return Ec(function() {
        return ry.resolve(e);
      });
    }, ay = {
      nu: Hp,
      pure: pk
    }, hk = function(e, n) {
      return n(function(a) {
        var i = [], s = 0, f = function(p) {
          return function(C) {
            i[p] = C, s++, s >= e.length && a(i);
          };
        };
        e.length === 0 ? a([]) : at(e, function(p, C) {
          p.get(f(C));
        });
      });
    }, bk = function(e) {
      return hk(e, ay.nu);
    }, Zm = function(e) {
      var n = function(K) {
        return Zm(e);
      }, a = function(K) {
        return Zm(e);
      }, i = function(K) {
        return Zm(K(e));
      }, s = function(K) {
        return Zm(e);
      }, f = function(K) {
        K(e);
      }, p = function(K) {
        return K(e);
      }, C = function(K, te) {
        return te(e);
      }, k = function(K) {
        return K(e);
      }, F = function(K) {
        return K(e);
      }, q = function() {
        return se.some(e);
      };
      return {
        isValue: Je,
        isError: Me,
        getOr: N(e),
        getOrThunk: N(e),
        getOrDie: N(e),
        or: n,
        orThunk: a,
        fold: C,
        map: i,
        mapError: s,
        each: f,
        bind: p,
        exists: k,
        forall: F,
        toOptional: q
      };
    }, Vp = function(e) {
      var n = function(F) {
        return F();
      }, a = function() {
        return Te(String(e))();
      }, i = ae, s = function(F) {
        return F();
      }, f = function(F) {
        return Vp(e);
      }, p = function(F) {
        return Vp(F(e));
      }, C = function(F) {
        return Vp(e);
      }, k = function(F, q) {
        return F(e);
      };
      return {
        isValue: Me,
        isError: Je,
        getOr: ae,
        getOrThunk: n,
        getOrDie: a,
        or: i,
        orThunk: s,
        fold: k,
        map: f,
        mapError: p,
        each: xe,
        bind: C,
        exists: Me,
        forall: Je,
        toOptional: se.none
      };
    }, UC = function(e, n) {
      return e.fold(function() {
        return Vp(n);
      }, Zm);
    }, jC = {
      value: Zm,
      error: Vp,
      fromOption: UC
    }, js = function(e) {
      if (!ht(e))
        throw new Error("cases must be an array");
      if (e.length === 0)
        throw new Error("there must be at least one case");
      var n = [], a = {};
      return at(e, function(i, s) {
        var f = mn(i);
        if (f.length !== 1)
          throw new Error("one and only one name per case");
        var p = f[0], C = i[p];
        if (a[p] !== void 0)
          throw new Error("duplicate key detected:" + p);
        if (p === "cata")
          throw new Error("cannot have a case named cata (sorry)");
        if (!ht(C))
          throw new Error("case arguments must be an array");
        n.push(p), a[p] = function() {
          for (var k = [], F = 0; F < arguments.length; F++)
            k[F] = arguments[F];
          var q = k.length;
          if (q !== C.length)
            throw new Error("Wrong number of arguments to case " + p + ". Expected " + C.length + " (" + C + "), got " + q);
          var K = function(te) {
            var be = mn(te);
            if (n.length !== be.length)
              throw new Error("Wrong number of arguments to match. Expected: " + n.join(",") + `
Actual: ` + be.join(","));
            var we = In(n, function(ke) {
              return We(be, ke);
            });
            if (!we)
              throw new Error("Not all branches were specified when using match. Specified: " + be.join(", ") + `
Required: ` + n.join(", "));
            return te[p].apply(null, k);
          };
          return {
            fold: function() {
              for (var te = [], be = 0; be < arguments.length; be++)
                te[be] = arguments[be];
              if (te.length !== e.length)
                throw new Error("Wrong number of arguments to fold. Expected " + e.length + ", got " + te.length);
              var we = te[s];
              return we.apply(null, k);
            },
            match: K,
            log: function(te) {
              console.log(te, {
                constructors: n,
                constructor: p,
                params: k
              });
            }
          };
        };
      }), a;
    }, hr = { generate: js };
    hr.generate([
      {
        bothErrors: [
          "error1",
          "error2"
        ]
      },
      {
        firstError: [
          "error1",
          "value2"
        ]
      },
      {
        secondError: [
          "value1",
          "error2"
        ]
      },
      {
        bothValues: [
          "value1",
          "value2"
        ]
      }
    ]);
    var Qf = function(e) {
      return e.fold(ae, ae);
    };
    function Up(e, n, a, i, s) {
      return e(a, i) ? se.some(a) : Be(s) && s(a) ? se.none() : n(a, i, s);
    }
    var Iv = function(e, n, a) {
      for (var i = e.dom, s = Be(a) ? a : Me; i.parentNode; ) {
        i = i.parentNode;
        var f = O.fromDom(i);
        if (n(f))
          return se.some(f);
        if (s(f))
          break;
      }
      return se.none();
    }, Jm = function(e, n, a) {
      var i = function(s, f) {
        return f(s);
      };
      return Up(i, Iv, e, n, a);
    }, oy = function(e, n) {
      var a = e.dom;
      return a.parentNode ? Xl(O.fromDom(a.parentNode), function(i) {
        return !Dr(e, i) && n(i);
      }) : se.none();
    }, Xl = function(e, n) {
      var a = function(s) {
        return n(O.fromDom(s));
      }, i = tt(e.dom.childNodes, a);
      return i.map(O.fromDom);
    }, Id = function(e, n, a) {
      return Iv(e, function(i) {
        return Nn(i, n);
      }, a);
    }, Qm = function(e, n) {
      return Vr(n, e);
    }, ri = function(e, n, a) {
      var i = function(s, f) {
        return Nn(s, f);
      };
      return Up(i, Id, e, n, a);
    }, Ki = window.Promise ? window.Promise : ry, jp, tf = function(e, n) {
      for (var a = window.requestAnimationFrame, i = [
        "ms",
        "moz",
        "webkit"
      ], s = function(p) {
        window.setTimeout(p, 0);
      }, f = 0; f < i.length && !a; f++)
        a = window[i[f] + "RequestAnimationFrame"];
      a || (a = s), a(e, n);
    }, Wp = function(e, n) {
      return typeof n != "number" && (n = 0), setTimeout(e, n);
    }, T1 = function(e, n) {
      return typeof n != "number" && (n = 1), setInterval(e, n);
    }, E1 = function(e) {
      return clearTimeout(e);
    }, yk = function(e) {
      return clearInterval(e);
    }, eg = function(e, n) {
      var a, i = function() {
        for (var s = [], f = 0; f < arguments.length; f++)
          s[f] = arguments[f];
        clearTimeout(a), a = Wp(function() {
          e.apply(this, s);
        }, n);
      };
      return i.stop = function() {
        clearTimeout(a);
      }, i;
    }, Bu = {
      requestAnimationFrame: function(e, n) {
        if (jp) {
          jp.then(e);
          return;
        }
        jp = new Ki(function(a) {
          n || (n = document.body), tf(a, n);
        }).then(e);
      },
      setTimeout: Wp,
      setInterval: T1,
      setEditorTimeout: function(e, n, a) {
        return Wp(function() {
          e.removed || n();
        }, a);
      },
      setEditorInterval: function(e, n, a) {
        var i = T1(function() {
          e.removed ? clearInterval(i) : n();
        }, a);
        return i;
      },
      debounce: eg,
      throttle: eg,
      clearInterval: yk,
      clearTimeout: E1
    }, WC = function(e, n) {
      n === void 0 && (n = {});
      var a = 0, i = {}, s = O.fromDom(e), f = Pr(s), p = n.maxLoadTime || 5e3, C = function(Ee) {
        n.referrerPolicy = Ee;
      }, k = function(Ee) {
        _i(Xo(s), Ee);
      }, F = function(Ee) {
        var qe = Xo(s);
        Qm(qe, "#" + Ee).each(Yo);
      }, q = function(Ee) {
        return Mr(i, Ee).getOrThunk(function() {
          return {
            id: "mce-u" + a++,
            passed: [],
            failed: [],
            count: 0
          };
        });
      }, K = function(Ee, qe, Le) {
        var xt, mt = Ut._addCacheSuffix(Ee), Qe = q(mt);
        i[mt] = Qe, Qe.count++;
        var At = function(kn, Kn) {
          for (var On = kn.length; On--; )
            kn[On]();
          Qe.status = Kn, Qe.passed = [], Qe.failed = [], xt && (xt.onload = null, xt.onerror = null, xt = null);
        }, tn = function() {
          return At(Qe.passed, 2);
        }, Cn = function() {
          return At(Qe.failed, 3);
        }, Ar = function(kn, Kn) {
          kn() || (Date.now() - _r < p ? Bu.setTimeout(Kn) : Cn());
        }, Xn = function() {
          Ar(function() {
            for (var kn = e.styleSheets, Kn = kn.length; Kn--; ) {
              var On = kn[Kn], $n = On.ownerNode;
              if ($n && $n.id === xt.id)
                return tn(), !0;
            }
            return !1;
          }, Xn);
        };
        if (qe && Qe.passed.push(qe), Le && Qe.failed.push(Le), Qe.status !== 1) {
          if (Qe.status === 2) {
            tn();
            return;
          }
          if (Qe.status === 3) {
            Cn();
            return;
          }
          Qe.status = 1;
          var fn = O.fromTag("link", f.dom);
          G(fn, {
            rel: "stylesheet",
            type: "text/css",
            id: Qe.id
          });
          var _r = Date.now();
          n.contentCssCors && M(fn, "crossOrigin", "anonymous"), n.referrerPolicy && M(fn, "referrerpolicy", n.referrerPolicy), xt = fn.dom, xt.onload = Xn, xt.onerror = Cn, k(fn), M(fn, "href", mt);
        }
      }, te = function(Ee) {
        return ay.nu(function(qe) {
          K(Ee, _e(qe, N(jC.value(Ee))), _e(qe, N(jC.error(Ee))));
        });
      }, be = function(Ee, qe, Le) {
        bk(Ke(Ee, te)).get(function(xt) {
          var mt = sn(xt, function(Qe) {
            return Qe.isValue();
          });
          mt.fail.length > 0 ? Le(mt.fail.map(Qf)) : qe(mt.pass.map(Qf));
        });
      }, we = function(Ee) {
        var qe = Ut._addCacheSuffix(Ee);
        Mr(i, qe).each(function(Le) {
          var xt = --Le.count;
          xt === 0 && (delete i[qe], F(Le.id));
        });
      }, ke = function(Ee) {
        at(Ee, function(qe) {
          we(qe);
        });
      };
      return {
        load: K,
        loadAll: be,
        unload: we,
        unloadAll: ke,
        _setReferrerPolicy: C
      };
    }, Io = function() {
      var e = /* @__PURE__ */ new WeakMap(), n = function(a, i) {
        var s = ts(a), f = s.dom;
        return se.from(e.get(f)).getOrThunk(function() {
          var p = WC(f, i);
          return e.set(f, p), p;
        });
      };
      return { forElement: n };
    }, Yl = Io(), Ha = function() {
      function e(n, a) {
        this.node = n, this.rootNode = a, this.current = this.current.bind(this), this.next = this.next.bind(this), this.prev = this.prev.bind(this), this.prev2 = this.prev2.bind(this);
      }
      return e.prototype.current = function() {
        return this.node;
      }, e.prototype.next = function(n) {
        return this.node = this.findSibling(this.node, "firstChild", "nextSibling", n), this.node;
      }, e.prototype.prev = function(n) {
        return this.node = this.findSibling(this.node, "lastChild", "previousSibling", n), this.node;
      }, e.prototype.prev2 = function(n) {
        return this.node = this.findPreviousNode(this.node, "lastChild", "previousSibling", n), this.node;
      }, e.prototype.findSibling = function(n, a, i, s) {
        var f, p;
        if (n) {
          if (!s && n[a])
            return n[a];
          if (n !== this.rootNode) {
            if (f = n[i], f)
              return f;
            for (p = n.parentNode; p && p !== this.rootNode; p = p.parentNode)
              if (f = p[i], f)
                return f;
          }
        }
      }, e.prototype.findPreviousNode = function(n, a, i, s) {
        var f, p, C;
        if (n) {
          if (f = n[i], this.rootNode && f === this.rootNode)
            return;
          if (f) {
            if (!s) {
              for (C = f[a]; C; C = C[a])
                if (!C[a])
                  return C;
            }
            return f;
          }
          if (p = n.parentNode, p && p !== this.rootNode)
            return p;
        }
      }, e;
    }(), Fv = [
      "article",
      "aside",
      "details",
      "div",
      "dt",
      "figcaption",
      "footer",
      "form",
      "fieldset",
      "header",
      "hgroup",
      "html",
      "main",
      "nav",
      "section",
      "summary",
      "body",
      "p",
      "dl",
      "multicol",
      "dd",
      "figure",
      "address",
      "center",
      "blockquote",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "listing",
      "xmp",
      "pre",
      "plaintext",
      "menu",
      "dir",
      "ul",
      "ol",
      "li",
      "hr",
      "table",
      "tbody",
      "thead",
      "tfoot",
      "th",
      "tr",
      "td",
      "caption"
    ], Al = [
      "td",
      "th"
    ], wk = [
      "thead",
      "tbody",
      "tfoot"
    ], Oi = [
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "p",
      "div",
      "address",
      "pre",
      "form",
      "blockquote",
      "center",
      "dir",
      "fieldset",
      "header",
      "footer",
      "article",
      "section",
      "hgroup",
      "aside",
      "nav",
      "figure"
    ], as = [
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6"
    ], qC = [
      "li",
      "dd",
      "dt"
    ], un = [
      "ul",
      "ol",
      "dl"
    ], xs = [
      "pre",
      "script",
      "textarea",
      "style"
    ], ev = function(e) {
      var n;
      return function(a) {
        return n = n || Vt(e, Je), Fr(n, Oa(a));
      };
    }, Lr = ev(as), ll = ev(Fv), Ck = function(e) {
      return Oa(e) === "table";
    }, Uu = function(e) {
      return So(e) && !ll(e);
    }, tg = function(e) {
      return So(e) && Oa(e) === "br";
    }, nf = ev(Oi), Zl = ev(un), Ru = ev(qC), Ba = ev(wk), _c = ev(Al), Fd = ev(xs), lo = function(e, n, a) {
      return Id(e, n, a).isSome();
    }, $v = "\uFEFF", Ws = "\xA0", qs = function(e) {
      return e === $v;
    }, Sk = function(e) {
      return e.replace(/\uFEFF/g, "");
    }, ct = $v, os = qs, Ac = Sk, ng = $r, cl = Qn, no = function(e) {
      return cl(e) && (e = e.parentNode), ng(e) && e.hasAttribute("data-mce-caret");
    }, co = function(e) {
      return cl(e) && os(e.data);
    }, ks = function(e) {
      return no(e) || co(e);
    }, tv = function(e) {
      return e.firstChild !== e.lastChild || !to(e.firstChild);
    }, iy = function(e, n) {
      var a = e.ownerDocument, i = a.createTextNode(ct), s = e.parentNode;
      if (n) {
        var f = e.previousSibling;
        if (cl(f)) {
          if (ks(f))
            return f;
          if (Gp(f))
            return f.splitText(f.data.length - 1);
        }
        s.insertBefore(i, e);
      } else {
        var f = e.nextSibling;
        if (cl(f)) {
          if (ks(f))
            return f;
          if (qp(f))
            return f.splitText(1), f;
        }
        e.nextSibling ? s.insertBefore(i, e.nextSibling) : s.appendChild(i);
      }
      return i;
    }, Sr = function(e) {
      var n = e.container();
      return Qn(n) ? n.data.charAt(e.offset()) === ct || e.isAtStart() && co(n.previousSibling) : !1;
    }, _1 = function(e) {
      var n = e.container();
      return Qn(n) ? n.data.charAt(e.offset() - 1) === ct || e.isAtEnd() && co(n.nextSibling) : !1;
    }, fl = function() {
      var e = document.createElement("br");
      return e.setAttribute("data-mce-bogus", "1"), e;
    }, GC = function(e, n, a) {
      var i = n.ownerDocument, s = i.createElement(e);
      s.setAttribute("data-mce-caret", a ? "before" : "after"), s.setAttribute("data-mce-bogus", "all"), s.appendChild(fl());
      var f = n.parentNode;
      return a ? f.insertBefore(s, n) : n.nextSibling ? f.insertBefore(s, n.nextSibling) : f.appendChild(s), s;
    }, qp = function(e) {
      return cl(e) && e.data[0] === ct;
    }, Gp = function(e) {
      return cl(e) && e.data[e.data.length - 1] === ct;
    }, uy = function(e) {
      var n = e.getElementsByTagName("br"), a = n[n.length - 1];
      ni(a) && a.parentNode.removeChild(a);
    }, sy = function(e) {
      return e && e.hasAttribute("data-mce-caret") ? (uy(e), e.removeAttribute("data-mce-caret"), e.removeAttribute("data-mce-bogus"), e.removeAttribute("style"), e.removeAttribute("_moz_abspos"), e) : null;
    }, rf = function(e) {
      return no(e.startContainer);
    }, nv = Kl, xk = xo, ly = to, kk = Qn, KC = ul([
      "script",
      "style",
      "textarea"
    ]), Kp = ul([
      "img",
      "input",
      "textarea",
      "hr",
      "iframe",
      "video",
      "audio",
      "object",
      "embed"
    ]), rg = ul(["table"]), XC = ks, af = function(e) {
      return XC(e) ? !1 : kk(e) ? !KC(e.parentNode) : Kp(e) || ly(e) || rg(e) || cy(e);
    }, ag = function(e) {
      return $r(e) && e.getAttribute("unselectable") === "true";
    }, cy = function(e) {
      return ag(e) === !1 && xk(e);
    }, YC = function(e, n) {
      for (e = e.parentNode; e && e !== n; e = e.parentNode) {
        if (cy(e))
          return !1;
        if (nv(e))
          return !0;
      }
      return !0;
    }, Tk = function(e) {
      return cy(e) ? Xe(Tn(e.getElementsByTagName("*")), function(n, a) {
        return n || nv(a);
      }, !1) !== !0 : !1;
    }, Ek = function(e) {
      return Kp(e) || Tk(e);
    }, bi = function(e, n) {
      return af(e) && YC(e, n);
    }, of = /^[ \t\r\n]*$/, Jl = function(e) {
      return of.test(e);
    }, Lv = function(e, n) {
      var a = O.fromDom(n), i = O.fromDom(e);
      return lo(i, "pre,code", ne(Dr, a));
    }, ZC = function(e, n) {
      return Qn(e) && Jl(e.data) && Lv(e, n) === !1;
    }, Ql = function(e) {
      return $r(e) && e.nodeName === "A" && !e.hasAttribute("href") && (e.hasAttribute("name") || e.hasAttribute("id"));
    }, $d = function(e, n) {
      return af(e) && ZC(e, n) === !1 || Ql(e) || fy(e);
    }, fy = Du("data-mce-bookmark"), vy = Du("data-mce-bogus"), rv = sl("data-mce-bogus", "all"), Ol = function(e, n) {
      var a = 0;
      if ($d(e, e))
        return !1;
      var i = e.firstChild;
      if (!i)
        return !0;
      var s = new Ha(i, e);
      do {
        if (n) {
          if (rv(i)) {
            i = s.next(!0);
            continue;
          }
          if (vy(i)) {
            i = s.next();
            continue;
          }
        }
        if (to(i)) {
          a++, i = s.next();
          continue;
        }
        if ($d(i, e))
          return !1;
        i = s.next();
      } while (i);
      return a <= 1;
    }, lu = function(e, n) {
      return n === void 0 && (n = !0), Ol(e.dom, n);
    }, A1 = function(e) {
      return e.nodeName.toLowerCase() === "span";
    }, dy = function(e, n) {
      return Ct(e) && ($d(e, n) || Uu(O.fromDom(e)));
    }, Ld = function(e, n) {
      var a = new Ha(e, n).prev(!1), i = new Ha(e, n).next(!1), s = De(a) || dy(a, n), f = De(i) || dy(i, n);
      return s && f;
    }, og = function(e) {
      return A1(e) && e.getAttribute("data-mce-type") === "bookmark";
    }, ig = function(e, n) {
      return Qn(e) && e.data.length > 0 && Ld(e, n);
    }, _k = function(e) {
      return $r(e) ? e.childNodes.length > 0 : !1;
    }, ug = function(e) {
      return ea(e) || $p(e);
    }, my = function(e, n, a) {
      var i = a || n;
      if ($r(n) && og(n))
        return n;
      for (var s = n.childNodes, f = s.length - 1; f >= 0; f--)
        my(e, s[f], i);
      if ($r(n)) {
        var p = n.childNodes;
        p.length === 1 && og(p[0]) && n.parentNode.insertBefore(p[0], n);
      }
      return !ug(n) && !$d(n, i) && !_k(n) && !ig(n, i) && e.remove(n), n;
    }, Ak = Ut.makeMap, Uo = /[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g, O1 = /[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g, zv = /[<>&\"\']/g, gy = /&#([a-z0-9]+);?|&([a-z0-9]+);/gi, py = {
      128: "\u20AC",
      130: "\u201A",
      131: "\u0192",
      132: "\u201E",
      133: "\u2026",
      134: "\u2020",
      135: "\u2021",
      136: "\u02C6",
      137: "\u2030",
      138: "\u0160",
      139: "\u2039",
      140: "\u0152",
      142: "\u017D",
      145: "\u2018",
      146: "\u2019",
      147: "\u201C",
      148: "\u201D",
      149: "\u2022",
      150: "\u2013",
      151: "\u2014",
      152: "\u02DC",
      153: "\u2122",
      154: "\u0161",
      155: "\u203A",
      156: "\u0153",
      158: "\u017E",
      159: "\u0178"
    }, Dl = {
      '"': "&quot;",
      "'": "&#39;",
      "<": "&lt;",
      ">": "&gt;",
      "&": "&amp;",
      "`": "&#96;"
    }, vl = {
      "&lt;": "<",
      "&gt;": ">",
      "&amp;": "&",
      "&quot;": '"',
      "&apos;": "'"
    }, zd = function(e) {
      var n = O.fromTag("div").dom;
      return n.innerHTML = e, n.textContent || n.innerText || e;
    }, Hv = function(e, n) {
      var a, i, s, f = {};
      if (e) {
        for (e = e.split(","), n = n || 10, a = 0; a < e.length; a += 2)
          i = String.fromCharCode(parseInt(e[a], n)), Dl[i] || (s = "&" + e[a + 1] + ";", f[i] = s, f[s] = i);
        return f;
      }
    }, D1 = Hv("50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,t9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro", 32), Xp = function(e, n) {
      return e.replace(n ? Uo : O1, function(a) {
        return Dl[a] || a;
      });
    }, hy = function(e) {
      return ("" + e).replace(zv, function(n) {
        return Dl[n] || n;
      });
    }, Hd = function(e, n) {
      return e.replace(n ? Uo : O1, function(a) {
        return a.length > 1 ? "&#" + ((a.charCodeAt(0) - 55296) * 1024 + (a.charCodeAt(1) - 56320) + 65536) + ";" : Dl[a] || "&#" + a.charCodeAt(0) + ";";
      });
    }, B1 = function(e, n, a) {
      return a = a || D1, e.replace(n ? Uo : O1, function(i) {
        return Dl[i] || a[i] || i;
      });
    }, Ok = function(e, n) {
      var a = Hv(n) || D1, i = function(p, C) {
        return p.replace(C ? Uo : O1, function(k) {
          return Dl[k] !== void 0 ? Dl[k] : a[k] !== void 0 ? a[k] : k.length > 1 ? "&#" + ((k.charCodeAt(0) - 55296) * 1024 + (k.charCodeAt(1) - 56320) + 65536) + ";" : "&#" + k.charCodeAt(0) + ";";
        });
      }, s = function(p, C) {
        return B1(p, C, a);
      }, f = Ak(e.replace(/\+/g, ","));
      return f.named && f.numeric ? i : f.named ? n ? s : B1 : f.numeric ? Hd : Xp;
    }, by = function(e) {
      return e.replace(gy, function(n, a) {
        return a ? (a.charAt(0).toLowerCase() === "x" ? a = parseInt(a.substr(1), 16) : a = parseInt(a, 10), a > 65535 ? (a -= 65536, String.fromCharCode(55296 + (a >> 10), 56320 + (a & 1023))) : py[a] || String.fromCharCode(a)) : vl[n] || D1[n] || zd(n);
      });
    }, dl = {
      encodeRaw: Xp,
      encodeAllRaw: hy,
      encodeNumeric: Hd,
      encodeNamed: B1,
      getEncodeFunc: Ok,
      decode: by
    }, Gs = {}, sg = {}, ec = Ut.makeMap, Mu = Ut.each, R1 = Ut.extend, av = Ut.explode, JC = Ut.inArray, cu = function(e, n) {
      return e = Ut.trim(e), e ? e.split(n || " ") : [];
    }, yy = function(e, n) {
      var a = ec(e, " ", ec(e.toUpperCase(), " "));
      return R1(a, n);
    }, M1 = function(e) {
      return yy("td th li dt dd figcaption caption details summary", e.getTextBlockElements());
    }, Ta = function(e) {
      var n = {}, a, i, s, f, p, C, k = function(q, K, te) {
        var be, we, ke, Ee = function(Le, xt) {
          var mt = {}, Qe, At;
          for (Qe = 0, At = Le.length; Qe < At; Qe++)
            mt[Le[Qe]] = xt || {};
          return mt;
        };
        te = te || [], K = K || "", typeof te == "string" && (te = cu(te));
        var qe = cu(q);
        for (be = qe.length; be--; )
          we = cu([
            a,
            K
          ].join(" ")), ke = {
            attributes: Ee(we),
            attributesOrder: we,
            children: Ee(te, sg)
          }, n[qe[be]] = ke;
      }, F = function(q, K) {
        var te, be, we, ke, Ee = cu(q);
        te = Ee.length;
        for (var qe = cu(K); te--; )
          for (be = n[Ee[te]], we = 0, ke = qe.length; we < ke; we++)
            be.attributes[qe[we]] = {}, be.attributesOrder.push(qe[we]);
      };
      return Gs[e] ? Gs[e] : (a = "id accesskey class dir lang style tabindex title role", i = "address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul", s = "a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd label map noscript object q s samp script select small span strong sub sup textarea u var #text #comment", e !== "html4" && (a += " contenteditable contextmenu draggable dropzone hidden spellcheck translate", i += " article aside details dialog figure main header footer hgroup section nav", s += " audio canvas command datalist mark meter output picture progress time wbr video ruby bdi keygen"), e !== "html5-strict" && (a += " xml:lang", C = "acronym applet basefont big font strike tt", s = [
        s,
        C
      ].join(" "), Mu(cu(C), function(q) {
        k(q, "", s);
      }), p = "center dir isindex noframes", i = [
        i,
        p
      ].join(" "), f = [
        i,
        s
      ].join(" "), Mu(cu(p), function(q) {
        k(q, "", f);
      })), f = f || [
        i,
        s
      ].join(" "), k("html", "manifest", "head body"), k("head", "", "base command link meta noscript script style title"), k("title hr noscript br"), k("base", "href target"), k("link", "href rel media hreflang type sizes hreflang"), k("meta", "name http-equiv content charset"), k("style", "media type scoped"), k("script", "src async defer type charset"), k("body", "onafterprint onbeforeprint onbeforeunload onblur onerror onfocus onhashchange onload onmessage onoffline ononline onpagehide onpageshow onpopstate onresize onscroll onstorage onunload", f), k("address dt dd div caption", "", f), k("h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn", "", s), k("blockquote", "cite", f), k("ol", "reversed start type", "li"), k("ul", "", "li"), k("li", "value", f), k("dl", "", "dt dd"), k("a", "href target rel media hreflang type", s), k("q", "cite", s), k("ins del", "cite datetime", f), k("img", "src sizes srcset alt usemap ismap width height"), k("iframe", "src name width height", f), k("embed", "src type width height"), k("object", "data type typemustmatch name usemap form width height", [
        f,
        "param"
      ].join(" ")), k("param", "name value"), k("map", "name", [
        f,
        "area"
      ].join(" ")), k("area", "alt coords shape href target rel media hreflang type"), k("table", "border", "caption colgroup thead tfoot tbody tr" + (e === "html4" ? " col" : "")), k("colgroup", "span", "col"), k("col", "span"), k("tbody thead tfoot", "", "tr"), k("tr", "", "td th"), k("td", "colspan rowspan headers", f), k("th", "colspan rowspan headers scope abbr", f), k("form", "accept-charset action autocomplete enctype method name novalidate target", f), k("fieldset", "disabled form name", [
        f,
        "legend"
      ].join(" ")), k("label", "form for", s), k("input", "accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate formtarget height list max maxlength min multiple name pattern readonly required size src step type value width"), k("button", "disabled form formaction formenctype formmethod formnovalidate formtarget name type value", e === "html4" ? f : s), k("select", "disabled form multiple name required size", "option optgroup"), k("optgroup", "disabled label", "option"), k("option", "disabled label selected value"), k("textarea", "cols dirname disabled form maxlength name readonly required rows wrap"), k("menu", "type label", [
        f,
        "li"
      ].join(" ")), k("noscript", "", f), e !== "html4" && (k("wbr"), k("ruby", "", [
        s,
        "rt rp"
      ].join(" ")), k("figcaption", "", f), k("mark rt rp summary bdi", "", s), k("canvas", "width height", f), k("video", "src crossorigin poster preload autoplay mediagroup loop muted controls width height buffered", [
        f,
        "track source"
      ].join(" ")), k("audio", "src crossorigin preload autoplay mediagroup loop muted controls buffered volume", [
        f,
        "track source"
      ].join(" ")), k("picture", "", "img source"), k("source", "src srcset type media sizes"), k("track", "kind src srclang label default"), k("datalist", "", [
        s,
        "option"
      ].join(" ")), k("article section nav aside main header footer", "", f), k("hgroup", "", "h1 h2 h3 h4 h5 h6"), k("figure", "", [
        f,
        "figcaption"
      ].join(" ")), k("time", "datetime", s), k("dialog", "open", f), k("command", "type label icon disabled checked radiogroup command"), k("output", "for form name", s), k("progress", "value max", s), k("meter", "value min max low high optimum", s), k("details", "open", [
        f,
        "summary"
      ].join(" ")), k("keygen", "autofocus challenge disabled form keytype name")), e !== "html5-strict" && (F("script", "language xml:space"), F("style", "xml:space"), F("object", "declare classid code codebase codetype archive standby align border hspace vspace"), F("embed", "align name hspace vspace"), F("param", "valuetype type"), F("a", "charset name rev shape coords"), F("br", "clear"), F("applet", "codebase archive code object alt name width height align hspace vspace"), F("img", "name longdesc align border hspace vspace"), F("iframe", "longdesc frameborder marginwidth marginheight scrolling align"), F("font basefont", "size color face"), F("input", "usemap align"), F("select"), F("textarea"), F("h1 h2 h3 h4 h5 h6 div p legend caption", "align"), F("ul", "type compact"), F("li", "type"), F("ol dl menu dir", "compact"), F("pre", "width xml:space"), F("hr", "align noshade size width"), F("isindex", "prompt"), F("table", "summary width frame rules cellspacing cellpadding align bgcolor"), F("col", "width align char charoff valign"), F("colgroup", "width align char charoff valign"), F("thead", "align char charoff valign"), F("tr", "align char charoff valign bgcolor"), F("th", "axis align char charoff valign nowrap bgcolor width height"), F("form", "accept"), F("td", "abbr axis scope align char charoff valign nowrap bgcolor width height"), F("tfoot", "align char charoff valign"), F("tbody", "align char charoff valign"), F("area", "nohref"), F("body", "background bgcolor text link vlink alink")), e !== "html4" && (F("input button select textarea", "autofocus"), F("input textarea", "placeholder"), F("a", "download"), F("link script img", "crossorigin"), F("img", "loading"), F("iframe", "sandbox seamless allowfullscreen loading")), Mu(cu("a form meter progress dfn"), function(q) {
        n[q] && delete n[q].children[q];
      }), delete n.caption.children.table, delete n.script, Gs[e] = n, n);
    }, xr = function(e, n) {
      var a;
      return e && (a = {}, typeof e == "string" && (e = { "*": e }), Mu(e, function(i, s) {
        a[s] = a[s.toUpperCase()] = n === "map" ? ec(i, /[, ]/) : av(i, /[, ]/);
      })), a;
    }, ml = function(e) {
      var n = {}, a = {}, i = [], s = {}, f = {}, p = function(bn, Mn, gr) {
        var Dt = e[bn];
        return Dt ? Dt = ec(Dt, /[, ]/, ec(Dt.toUpperCase(), /[, ]/)) : (Dt = Gs[bn], Dt || (Dt = yy(Mn, gr), Gs[bn] = Dt)), Dt;
      };
      e = e || {};
      var C = Ta(e.schema);
      e.verify_html === !1 && (e.valid_elements = "*[*]");
      var k = xr(e.valid_styles), F = xr(e.invalid_styles, "map"), q = xr(e.valid_classes, "map"), K = p("whitespace_elements", "pre script noscript style textarea video audio iframe object code"), te = p("self_closing_elements", "colgroup dd dt li option p td tfoot th thead tr"), be = p("short_ended_elements", "area base basefont br col frame hr img input isindex link meta param embed source wbr track"), we = p("boolean_attributes", "checked compact declare defer disabled ismap multiple nohref noresize noshade nowrap readonly selected autoplay loop controls"), ke = "td th iframe video audio object script code", Ee = p("non_empty_elements", ke + " pre", be), qe = p("move_caret_before_on_enter_elements", ke + " table", be), Le = p("text_block_elements", "h1 h2 h3 h4 h5 h6 p div address pre form blockquote center dir fieldset header footer article section hgroup aside main nav figure"), xt = p("block_elements", "hr table tbody thead tfoot th tr td li ol ul caption dl dt dd noscript menu isindex option datalist select optgroup figcaption details summary", Le), mt = p("text_inline_elements", "span strong b em i font s strike u var cite dfn code mark q sup sub samp");
      Mu((e.special || "script noscript iframe noframes noembed title style textarea xmp").split(" "), function(bn) {
        f[bn] = new RegExp("</" + bn + "[^>]*>", "gi");
      });
      var Qe = function(bn) {
        return new RegExp("^" + bn.replace(/([?+*])/g, ".$1") + "$");
      }, At = function(bn) {
        var Mn, gr, Dt, xn, wn, yr, kr, uo, ji, Ii, Mm, Ms, ps, nu, vc, Ps, Ff, fo, To = /^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)])?$/, ru = /^([!\-])?(\w+[\\:]:\w+|[^=:<]+)?(?:([=:<])(.*))?$/, nl = /[*?+]/;
        if (bn) {
          var _v = cu(bn, ",");
          for (n["@"] && (Ps = n["@"].attributes, Ff = n["@"].attributesOrder), Mn = 0, gr = _v.length; Mn < gr; Mn++)
            if (wn = To.exec(_v[Mn]), wn) {
              if (nu = wn[1], ji = wn[2], vc = wn[3], uo = wn[5], Ms = {}, ps = [], yr = {
                attributes: Ms,
                attributesOrder: ps
              }, nu === "#" && (yr.paddEmpty = !0), nu === "-" && (yr.removeEmpty = !0), wn[4] === "!" && (yr.removeEmptyAttrs = !0), Ps && (_n(Ps, function(Av, Dp) {
                Ms[Dp] = Av;
              }), ps.push.apply(ps, Ff)), uo) {
                for (uo = cu(uo, "|"), Dt = 0, xn = uo.length; Dt < xn; Dt++)
                  if (wn = ru.exec(uo[Dt]), wn) {
                    if (kr = {}, Mm = wn[1], Ii = wn[2].replace(/[\\:]:/g, ":"), nu = wn[3], fo = wn[4], Mm === "!" && (yr.attributesRequired = yr.attributesRequired || [], yr.attributesRequired.push(Ii), kr.required = !0), Mm === "-") {
                      delete Ms[Ii], ps.splice(JC(ps, Ii), 1);
                      continue;
                    }
                    nu && (nu === "=" && (yr.attributesDefault = yr.attributesDefault || [], yr.attributesDefault.push({
                      name: Ii,
                      value: fo
                    }), kr.defaultValue = fo), nu === ":" && (yr.attributesForced = yr.attributesForced || [], yr.attributesForced.push({
                      name: Ii,
                      value: fo
                    }), kr.forcedValue = fo), nu === "<" && (kr.validValues = ec(fo, "?"))), nl.test(Ii) ? (yr.attributePatterns = yr.attributePatterns || [], kr.pattern = Qe(Ii), yr.attributePatterns.push(kr)) : (Ms[Ii] || ps.push(Ii), Ms[Ii] = kr);
                  }
              }
              !Ps && ji === "@" && (Ps = Ms, Ff = ps), vc && (yr.outputName = ji, n[vc] = yr), nl.test(ji) ? (yr.pattern = Qe(ji), i.push(yr)) : n[ji] = yr;
            }
        }
      }, tn = function(bn) {
        n = {}, i = [], At(bn), Mu(C, function(Mn, gr) {
          a[gr] = Mn.children;
        });
      }, Cn = function(bn) {
        var Mn = /^(~)?(.+)$/;
        bn && (Gs.text_block_elements = Gs.block_elements = null, Mu(cu(bn, ","), function(gr) {
          var Dt = Mn.exec(gr), xn = Dt[1] === "~", wn = xn ? "span" : "div", yr = Dt[2];
          if (a[yr] = a[wn], s[yr] = wn, xn || (xt[yr.toUpperCase()] = {}, xt[yr] = {}), !n[yr]) {
            var kr = n[wn];
            kr = R1({}, kr), delete kr.removeEmptyAttrs, delete kr.removeEmpty, n[yr] = kr;
          }
          Mu(a, function(uo, ji) {
            uo[wn] && (a[ji] = uo = R1({}, a[ji]), uo[yr] = uo[wn]);
          });
        }));
      }, Ar = function(bn) {
        var Mn = /^([+\-]?)([A-Za-z0-9_\-.\u00b7\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u037d\u037f-\u1fff\u200c-\u200d\u203f-\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]+)\[([^\]]+)]$/;
        Gs[e.schema] = null, bn && Mu(cu(bn, ","), function(gr) {
          var Dt = Mn.exec(gr), xn, wn;
          Dt && (wn = Dt[1], wn ? xn = a[Dt[2]] : xn = a[Dt[2]] = { "#comment": {} }, xn = a[Dt[2]], Mu(cu(Dt[3], "|"), function(yr) {
            wn === "-" ? delete xn[yr] : xn[yr] = {};
          }));
        });
      }, Xn = function(bn) {
        var Mn = n[bn], gr;
        if (Mn)
          return Mn;
        for (gr = i.length; gr--; )
          if (Mn = i[gr], Mn.pattern.test(bn))
            return Mn;
      };
      e.valid_elements ? tn(e.valid_elements) : (Mu(C, function(bn, Mn) {
        n[Mn] = {
          attributes: bn.attributes,
          attributesOrder: bn.attributesOrder
        }, a[Mn] = bn.children;
      }), e.schema !== "html5" && Mu(cu("strong/b em/i"), function(bn) {
        var Mn = cu(bn, "/");
        n[Mn[1]].outputName = Mn[0];
      }), Mu(mt, function(bn, Mn) {
        n[Mn] && (e.padd_empty_block_inline_children && (n[Mn].paddInEmptyBlock = !0), n[Mn].removeEmpty = !0);
      }), Mu(cu("ol ul blockquote a table tbody"), function(bn) {
        n[bn] && (n[bn].removeEmpty = !0);
      }), Mu(cu("p h1 h2 h3 h4 h5 h6 th td pre div address caption li"), function(bn) {
        n[bn].paddEmpty = !0;
      }), Mu(cu("span"), function(bn) {
        n[bn].removeEmptyAttrs = !0;
      })), Cn(e.custom_elements), Ar(e.valid_children), At(e.extended_valid_elements), Ar("+ol[ul|ol],+ul[ul|ol]"), Mu({
        dd: "dl",
        dt: "dl",
        li: "ul ol",
        td: "tr",
        th: "tr",
        tr: "tbody thead tfoot",
        tbody: "table",
        thead: "table",
        tfoot: "table",
        legend: "fieldset",
        area: "map",
        param: "video audio object"
      }, function(bn, Mn) {
        n[Mn] && (n[Mn].parentsRequired = cu(bn));
      }), e.invalid_elements && Mu(av(e.invalid_elements), function(bn) {
        n[bn] && delete n[bn];
      }), Xn("span") || At("span[!data-mce-type|*]");
      var fn = N(k), _r = N(F), kn = N(q), Kn = N(we), On = N(xt), $n = N(Le), rr = N(mt), hn = N(be), Zn = N(te), fa = N(Ee), Ia = N(qe), Pa = N(K), yu = N(f), Wo = function(bn, Mn) {
        var gr = a[bn.toLowerCase()];
        return !!(gr && gr[Mn.toLowerCase()]);
      }, Rs = function(bn, Mn) {
        var gr, Dt, xn = Xn(bn);
        if (xn)
          if (Mn) {
            if (xn.attributes[Mn])
              return !0;
            if (gr = xn.attributePatterns, gr) {
              for (Dt = gr.length; Dt--; )
                if (gr[Dt].pattern.test(bn))
                  return !0;
            }
          } else
            return !0;
        return !1;
      }, tl = N(s);
      return {
        children: a,
        elements: n,
        getValidStyles: fn,
        getValidClasses: kn,
        getBlockElements: On,
        getInvalidStyles: _r,
        getShortEndedElements: hn,
        getTextBlockElements: $n,
        getTextInlineElements: rr,
        getBoolAttrs: Kn,
        getElementRule: Xn,
        getSelfClosingElements: Zn,
        getNonEmptyElements: fa,
        getMoveCaretBeforeOnEnterElements: Ia,
        getWhiteSpaceElements: Pa,
        getSpecialElements: yu,
        isValidChild: Wo,
        isValid: Rs,
        getCustomElements: tl,
        addValidElements: At,
        setValidElements: tn,
        addCustomElements: Cn,
        addValidChildren: Ar
      };
    }, P1 = function(e, n, a, i) {
      var s = function(f) {
        return f = parseInt(f, 10).toString(16), f.length > 1 ? f : "0" + f;
      };
      return "#" + s(n) + s(a) + s(i);
    }, tc = function(e, n) {
      var a = this, i = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi, s = /(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi, f = /\s*([^:]+):\s*([^;]+);?/g, p = /\s+$/, C, k = {}, F, q, K = $v;
      e = e || {}, n && (F = n.getValidStyles(), q = n.getInvalidStyles());
      var te = (`\\" \\' \\; \\: ; : ` + K).split(" ");
      for (C = 0; C < te.length; C++)
        k[te[C]] = K + C, k[K + C] = te[C];
      return {
        toHex: function(be) {
          return be.replace(i, P1);
        },
        parse: function(be) {
          var we = {}, ke, Ee, qe, Le, xt = e.url_converter, mt = e.url_converter_scope || a, Qe = function(kn, Kn, On) {
            var $n = we[kn + "-top" + Kn];
            if (!!$n) {
              var rr = we[kn + "-right" + Kn];
              if (!!rr) {
                var hn = we[kn + "-bottom" + Kn];
                if (!!hn) {
                  var Zn = we[kn + "-left" + Kn];
                  if (!!Zn) {
                    var fa = [
                      $n,
                      rr,
                      hn,
                      Zn
                    ];
                    for (C = fa.length - 1; C-- && fa[C] === fa[C + 1]; )
                      ;
                    C > -1 && On || (we[kn + Kn] = C === -1 ? fa[0] : fa.join(" "), delete we[kn + "-top" + Kn], delete we[kn + "-right" + Kn], delete we[kn + "-bottom" + Kn], delete we[kn + "-left" + Kn]);
                  }
                }
              }
            }
          }, At = function(kn) {
            var Kn = we[kn], On;
            if (!!Kn) {
              for (Kn = Kn.split(" "), On = Kn.length; On--; )
                if (Kn[On] !== Kn[0])
                  return !1;
              return we[kn] = Kn[0], !0;
            }
          }, tn = function(kn, Kn, On, $n) {
            !At(Kn) || !At(On) || !At($n) || (we[kn] = we[Kn] + " " + we[On] + " " + we[$n], delete we[Kn], delete we[On], delete we[$n]);
          }, Cn = function(kn) {
            return Le = !0, k[kn];
          }, Ar = function(kn, Kn) {
            return Le && (kn = kn.replace(/\uFEFF[0-9]/g, function(On) {
              return k[On];
            })), Kn || (kn = kn.replace(/\\([\'\";:])/g, "$1")), kn;
          }, Xn = function(kn) {
            return String.fromCharCode(parseInt(kn.slice(1), 16));
          }, fn = function(kn) {
            return kn.replace(/\\[0-9a-f]+/gi, Xn);
          }, _r = function(kn, Kn, On, $n, rr, hn) {
            if (rr = rr || hn, rr)
              return rr = Ar(rr), "'" + rr.replace(/\'/g, "\\'") + "'";
            if (Kn = Ar(Kn || On || $n), !e.allow_script_urls) {
              var Zn = Kn.replace(/[\s\r\n]+/g, "");
              if (/(java|vb)script:/i.test(Zn) || !e.allow_svg_data_urls && /^data:image\/svg/i.test(Zn))
                return "";
            }
            return xt && (Kn = xt.call(mt, Kn, "style")), "url('" + Kn.replace(/\'/g, "\\'") + "')";
          };
          if (be) {
            for (be = be.replace(/[\u0000-\u001F]/g, ""), be = be.replace(/\\[\"\';:\uFEFF]/g, Cn).replace(/\"[^\"]+\"|\'[^\']+\'/g, function(kn) {
              return kn.replace(/[;:]/g, Cn);
            }); ke = f.exec(be); )
              if (f.lastIndex = ke.index + ke[0].length, Ee = ke[1].replace(p, "").toLowerCase(), qe = ke[2].replace(p, ""), Ee && qe) {
                if (Ee = fn(Ee), qe = fn(qe), Ee.indexOf(K) !== -1 || Ee.indexOf('"') !== -1 || !e.allow_script_urls && (Ee === "behavior" || /expression\s*\(|\/\*|\*\//.test(qe)))
                  continue;
                Ee === "font-weight" && qe === "700" ? qe = "bold" : (Ee === "color" || Ee === "background-color") && (qe = qe.toLowerCase()), qe = qe.replace(i, P1), qe = qe.replace(s, _r), we[Ee] = Le ? Ar(qe, !0) : qe;
              }
            Qe("border", "", !0), Qe("border", "-width"), Qe("border", "-color"), Qe("border", "-style"), Qe("padding", ""), Qe("margin", ""), tn("border", "border-width", "border-style", "border-color"), we.border === "medium none" && delete we.border, we["border-image"] === "none" && delete we["border-image"];
          }
          return we;
        },
        serialize: function(be, we) {
          var ke = "", Ee = function(Le) {
            var xt, mt = F[Le];
            if (mt)
              for (var Qe = 0, At = mt.length; Qe < At; Qe++)
                Le = mt[Qe], xt = be[Le], xt && (ke += (ke.length > 0 ? " " : "") + Le + ": " + xt + ";");
          }, qe = function(Le, xt) {
            var mt = q["*"];
            return mt && mt[Le] ? !1 : (mt = q[xt], !(mt && mt[Le]));
          };
          return we && F ? (Ee("*"), Ee(we)) : _n(be, function(Le, xt) {
            Le && (!q || qe(xt, we)) && (ke += (ke.length > 0 ? " " : "") + xt + ": " + Le + ";");
          }), ke;
        }
      };
    }, QC = {
      keyLocation: !0,
      layerX: !0,
      layerY: !0,
      returnValue: !0,
      webkitMovementX: !0,
      webkitMovementY: !0,
      keyIdentifier: !0,
      mozPressure: !0
    }, ro = function(e) {
      return e instanceof Event || Be(e.initEvent);
    }, wy = function(e) {
      return e.isDefaultPrevented === Je || e.isDefaultPrevented === Me;
    }, N1 = function(e) {
      return Pt(e.preventDefault) || ro(e);
    }, I1 = function(e, n) {
      var a = n != null ? n : {};
      for (var i in e)
        Fr(QC, i) || (a[i] = e[i]);
      return Ct(a.composedPath) && (a.composedPath = function() {
        return e.composedPath();
      }), a;
    }, cn = function(e, n, a, i) {
      var s, f = I1(n, i);
      return f.type = e, Pt(f.target) && (f.target = (s = f.srcElement) !== null && s !== void 0 ? s : a), N1(n) && (f.preventDefault = function() {
        f.defaultPrevented = !0, f.isDefaultPrevented = Je, Be(n.preventDefault) ? n.preventDefault() : ro(n) && (n.returnValue = !1);
      }, f.stopPropagation = function() {
        f.cancelBubble = !0, f.isPropagationStopped = Je, Be(n.stopPropagation) ? n.stopPropagation() : ro(n) && (n.cancelBubble = !0);
      }, f.stopImmediatePropagation = function() {
        f.isImmediatePropagationStopped = Je, f.stopPropagation();
      }, wy(f) || (f.isDefaultPrevented = f.defaultPrevented === !0 ? Je : Me, f.isPropagationStopped = f.cancelBubble === !0 ? Je : Me, f.isImmediatePropagationStopped = Me)), f;
    }, Cy = "mce-data-", Sy = /^(?:mouse|contextmenu)|click/, Vv = function(e, n, a, i) {
      e.addEventListener ? e.addEventListener(n, a, i || !1) : e.attachEvent && e.attachEvent("on" + n, a);
    }, Yp = function(e, n, a, i) {
      e.removeEventListener ? e.removeEventListener(n, a, i || !1) : e.detachEvent && e.detachEvent("on" + n, a);
    }, Vd = function(e) {
      return Ct(e) && Sy.test(e.type);
    }, Uv = function(e, n) {
      var a = cn(e.type, e, document, n);
      if (Vd(e) && De(e.pageX) && !De(e.clientX)) {
        var i = a.target.ownerDocument || document, s = i.documentElement, f = i.body, p = a;
        p.pageX = e.clientX + (s && s.scrollLeft || f && f.scrollLeft || 0) - (s && s.clientLeft || f && f.clientLeft || 0), p.pageY = e.clientY + (s && s.scrollTop || f && f.scrollTop || 0) - (s && s.clientTop || f && f.clientTop || 0);
      }
      return De(a.metaKey) && (a.metaKey = !1), a;
    }, Ud = function(e, n, a) {
      var i = e.document, s = { type: "ready" };
      if (a.domLoaded) {
        n(s);
        return;
      }
      var f = function() {
        return i.readyState === "complete" || i.readyState === "interactive" && i.body;
      }, p = function() {
        Yp(e, "DOMContentLoaded", p), Yp(e, "load", p), a.domLoaded || (a.domLoaded = !0, n(s)), e = null;
      };
      f() ? p() : Vv(e, "DOMContentLoaded", p), a.domLoaded || Vv(e, "load", p);
    }, lg = function() {
      function e() {
        this.domLoaded = !1, this.events = {}, this.count = 1, this.expando = Cy + (+new Date()).toString(32), this.hasMouseEnterLeave = "onmouseenter" in document.documentElement, this.hasFocusIn = "onfocusin" in document.documentElement, this.count = 1;
      }
      return e.prototype.bind = function(n, a, i, s) {
        var f = this, p, C, k, F, q, K, te, be = window, we = function(Ee) {
          f.executeHandlers(Uv(Ee || be.event), p);
        };
        if (!(!n || n.nodeType === 3 || n.nodeType === 8)) {
          n[f.expando] ? p = n[f.expando] : (p = f.count++, n[f.expando] = p, f.events[p] = {}), s = s || n;
          var ke = a.split(" ");
          for (k = ke.length; k--; ) {
            if (F = ke[k], K = we, q = te = !1, F === "DOMContentLoaded" && (F = "ready"), f.domLoaded && F === "ready" && n.readyState === "complete") {
              i.call(s, Uv({ type: F }));
              continue;
            }
            f.hasMouseEnterLeave || (q = f.mouseEnterLeave[F], q && (K = function(Ee) {
              var qe = Ee.currentTarget, Le = Ee.relatedTarget;
              if (Le && qe.contains)
                Le = qe.contains(Le);
              else
                for (; Le && Le !== qe; )
                  Le = Le.parentNode;
              Le || (Ee = Uv(Ee || be.event), Ee.type = Ee.type === "mouseout" ? "mouseleave" : "mouseenter", Ee.target = qe, f.executeHandlers(Ee, p));
            })), !f.hasFocusIn && (F === "focusin" || F === "focusout") && (te = !0, q = F === "focusin" ? "focus" : "blur", K = function(Ee) {
              Ee = Uv(Ee || be.event), Ee.type = Ee.type === "focus" ? "focusin" : "focusout", f.executeHandlers(Ee, p);
            }), C = f.events[p][F], C ? F === "ready" && f.domLoaded ? i(Uv({ type: F })) : C.push({
              func: i,
              scope: s
            }) : (f.events[p][F] = C = [{
              func: i,
              scope: s
            }], C.fakeName = q, C.capture = te, C.nativeHandler = K, F === "ready" ? Ud(n, K, f) : Vv(n, q || F, K, te));
          }
          return n = C = null, i;
        }
      }, e.prototype.unbind = function(n, a, i) {
        var s, f, p, C, k;
        if (!n || n.nodeType === 3 || n.nodeType === 8)
          return this;
        var F = n[this.expando];
        if (F) {
          if (k = this.events[F], a) {
            var q = a.split(" ");
            for (f = q.length; f--; )
              if (C = q[f], s = k[C], s) {
                if (i) {
                  for (p = s.length; p--; )
                    if (s[p].func === i) {
                      var K = s.nativeHandler, te = s.fakeName, be = s.capture;
                      s = s.slice(0, p).concat(s.slice(p + 1)), s.nativeHandler = K, s.fakeName = te, s.capture = be, k[C] = s;
                    }
                }
                (!i || s.length === 0) && (delete k[C], Yp(n, s.fakeName || C, s.nativeHandler, s.capture));
              }
          } else
            _n(k, function(we, ke) {
              Yp(n, we.fakeName || ke, we.nativeHandler, we.capture);
            }), k = {};
          for (C in k)
            if (Fr(k, C))
              return this;
          delete this.events[F];
          try {
            delete n[this.expando];
          } catch {
            n[this.expando] = null;
          }
        }
        return this;
      }, e.prototype.fire = function(n, a, i) {
        var s;
        if (!n || n.nodeType === 3 || n.nodeType === 8)
          return this;
        var f = Uv({
          type: a,
          target: n
        }, i);
        do
          s = n[this.expando], s && this.executeHandlers(f, s), n = n.parentNode || n.ownerDocument || n.defaultView || n.parentWindow;
        while (n && !f.isPropagationStopped());
        return this;
      }, e.prototype.clean = function(n) {
        var a, i;
        if (!n || n.nodeType === 3 || n.nodeType === 8)
          return this;
        if (n[this.expando] && this.unbind(n), n.getElementsByTagName || (n = n.document), n && n.getElementsByTagName)
          for (this.unbind(n), i = n.getElementsByTagName("*"), a = i.length; a--; )
            n = i[a], n[this.expando] && this.unbind(n);
        return this;
      }, e.prototype.destroy = function() {
        this.events = {};
      }, e.prototype.cancel = function(n) {
        return n && (n.preventDefault(), n.stopImmediatePropagation()), !1;
      }, e.prototype.executeHandlers = function(n, a) {
        var i = this.events[a], s = i && i[n.type];
        if (s)
          for (var f = 0, p = s.length; f < p; f++) {
            var C = s[f];
            if (C && C.func.call(C.scope, n) === !1 && n.preventDefault(), n.isImmediatePropagationStopped())
              return;
          }
      }, e.Event = new e(), e;
    }(), li, Zr, gl, eS, Ks, xy, uf, ov, iv, pl, jv, zi, is, sf, Wv, cg, jd, ur, Xi = "sizzle" + -new Date(), Oc = window.document, lf = 0, Zp = 0, tS = z1(), F1 = z1(), qv = z1(), Gv = function(e, n) {
      return e === n && (pl = !0), 0;
    }, fg = "undefined", Jp = 1 << 31, Dk = {}.hasOwnProperty, hl = [], ky = hl.pop, Wd = hl.push, Kv = hl.push, Ty = hl.slice, Xv = hl.indexOf || function(e) {
      for (var n = 0, a = this.length; n < a; n++)
        if (this[n] === e)
          return n;
      return -1;
    }, nS = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", Fo = "[\\x20\\t\\r\\n\\f]", fu = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+", Pu = "\\[" + Fo + "*(" + fu + ")(?:" + Fo + "*([*^$|!~]?=)" + Fo + `*(?:'((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)"|(` + fu + "))|)" + Fo + "*\\]", rS = ":(" + fu + `)(?:\\((('((?:\\\\.|[^\\\\'])*)'|"((?:\\\\.|[^\\\\"])*)")|((?:\\\\.|[^\\\\()[\\]]|` + Pu + ")*)|.*)\\)|)", $1 = new RegExp("^" + Fo + "+|((?:^|[^\\\\])(?:\\\\.)*)" + Fo + "+$", "g"), Bk = new RegExp("^" + Fo + "*," + Fo + "*"), aS = new RegExp("^" + Fo + "*([>+~]|" + Fo + ")" + Fo + "*"), nc = new RegExp("=" + Fo + `*([^\\]'"]*?)` + Fo + "*\\]", "g"), Rk = new RegExp(rS), vg = new RegExp("^" + fu + "$"), L1 = {
      ID: new RegExp("^#(" + fu + ")"),
      CLASS: new RegExp("^\\.(" + fu + ")"),
      TAG: new RegExp("^(" + fu + "|[*])"),
      ATTR: new RegExp("^" + Pu),
      PSEUDO: new RegExp("^" + rS),
      CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + Fo + "*(even|odd|(([+-]|)(\\d*)n|)" + Fo + "*(?:([+-]|)" + Fo + "*(\\d+)|))" + Fo + "*\\)|)", "i"),
      bool: new RegExp("^(?:" + nS + ")$", "i"),
      needsContext: new RegExp("^" + Fo + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + Fo + "*((?:-\\d)?\\d*)" + Fo + "*\\)|)(?=[^-]|$)", "i")
    }, Mk = /^(?:input|select|textarea|button)$/i, oS = /^h\d$/i, Ey = /^[^{]+\{\s*\[native \w/, _y = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, Ay = /[+~]/, Pk = /'|\\/g, Yv = new RegExp("\\\\([\\da-f]{1,6}" + Fo + "?|(" + Fo + ")|.)", "ig"), Zv = function(e, n, a) {
      var i = "0x" + n - 65536;
      return i !== i || a ? n : i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, i & 1023 | 56320);
    };
    try {
      Kv.apply(hl = Ty.call(Oc.childNodes), Oc.childNodes), hl[Oc.childNodes.length].nodeType;
    } catch {
      Kv = {
        apply: hl.length ? function(n, a) {
          Wd.apply(n, Ty.call(a));
        } : function(n, a) {
          for (var i = n.length, s = 0; n[i++] = a[s++]; )
            ;
          n.length = i - 1;
        }
      };
    }
    var Xa = function(e, n, a, i) {
      var s, f, p, C, k, F, q, K, te, be;
      if ((n ? n.ownerDocument || n : Oc) !== zi && jv(n), n = n || zi, a = a || [], !e || typeof e != "string")
        return a;
      if ((C = n.nodeType) !== 1 && C !== 9)
        return [];
      if (sf && !i) {
        if (s = _y.exec(e))
          if (p = s[1]) {
            if (C === 9)
              if (f = n.getElementById(p), f && f.parentNode) {
                if (f.id === p)
                  return a.push(f), a;
              } else
                return a;
            else if (n.ownerDocument && (f = n.ownerDocument.getElementById(p)) && ur(n, f) && f.id === p)
              return a.push(f), a;
          } else {
            if (s[2])
              return Kv.apply(a, n.getElementsByTagName(e)), a;
            if ((p = s[3]) && li.getElementsByClassName)
              return Kv.apply(a, n.getElementsByClassName(p)), a;
          }
        if (li.qsa && (!Wv || !Wv.test(e))) {
          if (K = q = Xi, te = n, be = C === 9 && e, C === 1 && n.nodeName.toLowerCase() !== "object") {
            for (F = Ks(e), (q = n.getAttribute("id")) ? K = q.replace(Pk, "\\$&") : n.setAttribute("id", K), K = "[id='" + K + "'] ", k = F.length; k--; )
              F[k] = K + V1(F[k]);
            te = Ay.test(e) && H1(n.parentNode) || n, be = F.join(",");
          }
          if (be)
            try {
              return Kv.apply(a, te.querySelectorAll(be)), a;
            } catch {
            } finally {
              q || n.removeAttribute("id");
            }
        }
      }
      return uf(e.replace($1, "$1"), n, a, i);
    };
    function z1() {
      var e = [];
      function n(a, i) {
        return e.push(a + " ") > Zr.cacheLength && delete n[e.shift()], n[a + " "] = i;
      }
      return n;
    }
    function Dc(e) {
      return e[Xi] = !0, e;
    }
    function iS(e, n) {
      var a = n && e, i = a && e.nodeType === 1 && n.nodeType === 1 && (~n.sourceIndex || Jp) - (~e.sourceIndex || Jp);
      if (i)
        return i;
      if (a) {
        for (; a = a.nextSibling; )
          if (a === n)
            return -1;
      }
      return e ? 1 : -1;
    }
    function Bc(e) {
      return function(n) {
        var a = n.nodeName.toLowerCase();
        return a === "input" && n.type === e;
      };
    }
    function cf(e) {
      return function(n) {
        var a = n.nodeName.toLowerCase();
        return (a === "input" || a === "button") && n.type === e;
      };
    }
    function Jv(e) {
      return Dc(function(n) {
        return n = +n, Dc(function(a, i) {
          for (var s, f = e([], a.length, n), p = f.length; p--; )
            a[s = f[p]] && (a[s] = !(i[s] = a[s]));
        });
      });
    }
    function H1(e) {
      return e && typeof e.getElementsByTagName !== fg && e;
    }
    li = Xa.support = {}, eS = Xa.isXML = function(e) {
      var n = e && (e.ownerDocument || e).documentElement;
      return n ? n.nodeName !== "HTML" : !1;
    }, jv = Xa.setDocument = function(e) {
      var n, a = e ? e.ownerDocument || e : Oc, i = a.defaultView;
      function s(f) {
        try {
          return f.top;
        } catch {
        }
        return null;
      }
      return a === zi || a.nodeType !== 9 || !a.documentElement ? zi : (zi = a, is = a.documentElement, sf = !eS(a), i && i !== s(i) && (i.addEventListener ? i.addEventListener("unload", function() {
        jv();
      }, !1) : i.attachEvent && i.attachEvent("onunload", function() {
        jv();
      })), li.attributes = !0, li.getElementsByTagName = !0, li.getElementsByClassName = Ey.test(a.getElementsByClassName), li.getById = !0, Zr.find.ID = function(f, p) {
        if (typeof p.getElementById !== fg && sf) {
          var C = p.getElementById(f);
          return C && C.parentNode ? [C] : [];
        }
      }, Zr.filter.ID = function(f) {
        var p = f.replace(Yv, Zv);
        return function(C) {
          return C.getAttribute("id") === p;
        };
      }, Zr.find.TAG = li.getElementsByTagName ? function(f, p) {
        if (typeof p.getElementsByTagName !== fg)
          return p.getElementsByTagName(f);
      } : function(f, p) {
        var C, k = [], F = 0, q = p.getElementsByTagName(f);
        if (f === "*") {
          for (; C = q[F++]; )
            C.nodeType === 1 && k.push(C);
          return k;
        }
        return q;
      }, Zr.find.CLASS = li.getElementsByClassName && function(f, p) {
        if (sf)
          return p.getElementsByClassName(f);
      }, cg = [], Wv = [], li.disconnectedMatch = !0, Wv = Wv.length && new RegExp(Wv.join("|")), cg = cg.length && new RegExp(cg.join("|")), n = Ey.test(is.compareDocumentPosition), ur = n || Ey.test(is.contains) ? function(f, p) {
        var C = f.nodeType === 9 ? f.documentElement : f, k = p && p.parentNode;
        return f === k || !!(k && k.nodeType === 1 && (C.contains ? C.contains(k) : f.compareDocumentPosition && f.compareDocumentPosition(k) & 16));
      } : function(f, p) {
        if (p) {
          for (; p = p.parentNode; )
            if (p === f)
              return !0;
        }
        return !1;
      }, Gv = n ? function(f, p) {
        if (f === p)
          return pl = !0, 0;
        var C = !f.compareDocumentPosition - !p.compareDocumentPosition;
        return C || (C = (f.ownerDocument || f) === (p.ownerDocument || p) ? f.compareDocumentPosition(p) : 1, C & 1 || !li.sortDetached && p.compareDocumentPosition(f) === C ? f === a || f.ownerDocument === Oc && ur(Oc, f) ? -1 : p === a || p.ownerDocument === Oc && ur(Oc, p) ? 1 : iv ? Xv.call(iv, f) - Xv.call(iv, p) : 0 : C & 4 ? -1 : 1);
      } : function(f, p) {
        if (f === p)
          return pl = !0, 0;
        var C, k = 0, F = f.parentNode, q = p.parentNode, K = [f], te = [p];
        if (!F || !q)
          return f === a ? -1 : p === a ? 1 : F ? -1 : q ? 1 : iv ? Xv.call(iv, f) - Xv.call(iv, p) : 0;
        if (F === q)
          return iS(f, p);
        for (C = f; C = C.parentNode; )
          K.unshift(C);
        for (C = p; C = C.parentNode; )
          te.unshift(C);
        for (; K[k] === te[k]; )
          k++;
        return k ? iS(K[k], te[k]) : K[k] === Oc ? -1 : te[k] === Oc ? 1 : 0;
      }, a);
    }, Xa.matches = function(e, n) {
      return Xa(e, null, null, n);
    }, Xa.matchesSelector = function(e, n) {
      if ((e.ownerDocument || e) !== zi && jv(e), n = n.replace(nc, "='$1']"), li.matchesSelector && sf && (!cg || !cg.test(n)) && (!Wv || !Wv.test(n)))
        try {
          var a = jd.call(e, n);
          if (a || li.disconnectedMatch || e.document && e.document.nodeType !== 11)
            return a;
        } catch {
        }
      return Xa(n, zi, null, [e]).length > 0;
    }, Xa.contains = function(e, n) {
      return (e.ownerDocument || e) !== zi && jv(e), ur(e, n);
    }, Xa.attr = function(e, n) {
      (e.ownerDocument || e) !== zi && jv(e);
      var a = Zr.attrHandle[n.toLowerCase()], i = a && Dk.call(Zr.attrHandle, n.toLowerCase()) ? a(e, n, !sf) : void 0;
      return i !== void 0 ? i : li.attributes || !sf ? e.getAttribute(n) : (i = e.getAttributeNode(n)) && i.specified ? i.value : null;
    }, Xa.error = function(e) {
      throw new Error("Syntax error, unrecognized expression: " + e);
    }, Xa.uniqueSort = function(e) {
      var n, a = [], i = 0, s = 0;
      if (pl = !li.detectDuplicates, iv = !li.sortStable && e.slice(0), e.sort(Gv), pl) {
        for (; n = e[s++]; )
          n === e[s] && (i = a.push(s));
        for (; i--; )
          e.splice(a[i], 1);
      }
      return iv = null, e;
    }, gl = Xa.getText = function(e) {
      var n, a = "", i = 0, s = e.nodeType;
      if (s) {
        if (s === 1 || s === 9 || s === 11) {
          if (typeof e.textContent == "string")
            return e.textContent;
          for (e = e.firstChild; e; e = e.nextSibling)
            a += gl(e);
        } else if (s === 3 || s === 4)
          return e.nodeValue;
      } else
        for (; n = e[i++]; )
          a += gl(n);
      return a;
    }, Zr = Xa.selectors = {
      cacheLength: 50,
      createPseudo: Dc,
      match: L1,
      attrHandle: {},
      find: {},
      relative: {
        ">": {
          dir: "parentNode",
          first: !0
        },
        " ": { dir: "parentNode" },
        "+": {
          dir: "previousSibling",
          first: !0
        },
        "~": { dir: "previousSibling" }
      },
      preFilter: {
        ATTR: function(e) {
          return e[1] = e[1].replace(Yv, Zv), e[3] = (e[3] || e[4] || e[5] || "").replace(Yv, Zv), e[2] === "~=" && (e[3] = " " + e[3] + " "), e.slice(0, 4);
        },
        CHILD: function(e) {
          return e[1] = e[1].toLowerCase(), e[1].slice(0, 3) === "nth" ? (e[3] || Xa.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * (e[3] === "even" || e[3] === "odd")), e[5] = +(e[7] + e[8] || e[3] === "odd")) : e[3] && Xa.error(e[0]), e;
        },
        PSEUDO: function(e) {
          var n, a = !e[6] && e[2];
          return L1.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : a && Rk.test(a) && (n = Ks(a, !0)) && (n = a.indexOf(")", a.length - n) - a.length) && (e[0] = e[0].slice(0, n), e[2] = a.slice(0, n)), e.slice(0, 3));
        }
      },
      filter: {
        TAG: function(e) {
          var n = e.replace(Yv, Zv).toLowerCase();
          return e === "*" ? function() {
            return !0;
          } : function(a) {
            return a.nodeName && a.nodeName.toLowerCase() === n;
          };
        },
        CLASS: function(e) {
          var n = tS[e + " "];
          return n || (n = new RegExp("(^|" + Fo + ")" + e + "(" + Fo + "|$)")) && tS(e, function(a) {
            return n.test(typeof a.className == "string" && a.className || typeof a.getAttribute !== fg && a.getAttribute("class") || "");
          });
        },
        ATTR: function(e, n, a) {
          return function(i) {
            var s = Xa.attr(i, e);
            return s == null ? n === "!=" : n ? (s += "", n === "=" ? s === a : n === "!=" ? s !== a : n === "^=" ? a && s.indexOf(a) === 0 : n === "*=" ? a && s.indexOf(a) > -1 : n === "$=" ? a && s.slice(-a.length) === a : n === "~=" ? (" " + s + " ").indexOf(a) > -1 : n === "|=" ? s === a || s.slice(0, a.length + 1) === a + "-" : !1) : !0;
          };
        },
        CHILD: function(e, n, a, i, s) {
          var f = e.slice(0, 3) !== "nth", p = e.slice(-4) !== "last", C = n === "of-type";
          return i === 1 && s === 0 ? function(k) {
            return !!k.parentNode;
          } : function(k, F, q) {
            var K, te, be, we, ke, Ee, qe = f !== p ? "nextSibling" : "previousSibling", Le = k.parentNode, xt = C && k.nodeName.toLowerCase(), mt = !q && !C;
            if (Le) {
              if (f) {
                for (; qe; ) {
                  for (be = k; be = be[qe]; )
                    if (C ? be.nodeName.toLowerCase() === xt : be.nodeType === 1)
                      return !1;
                  Ee = qe = e === "only" && !Ee && "nextSibling";
                }
                return !0;
              }
              if (Ee = [p ? Le.firstChild : Le.lastChild], p && mt) {
                for (te = Le[Xi] || (Le[Xi] = {}), K = te[e] || [], ke = K[0] === lf && K[1], we = K[0] === lf && K[2], be = ke && Le.childNodes[ke]; be = ++ke && be && be[qe] || (we = ke = 0) || Ee.pop(); )
                  if (be.nodeType === 1 && ++we && be === k) {
                    te[e] = [
                      lf,
                      ke,
                      we
                    ];
                    break;
                  }
              } else if (mt && (K = (k[Xi] || (k[Xi] = {}))[e]) && K[0] === lf)
                we = K[1];
              else
                for (; (be = ++ke && be && be[qe] || (we = ke = 0) || Ee.pop()) && !((C ? be.nodeName.toLowerCase() === xt : be.nodeType === 1) && ++we && (mt && ((be[Xi] || (be[Xi] = {}))[e] = [
                  lf,
                  we
                ]), be === k)); )
                  ;
              return we -= s, we === i || we % i === 0 && we / i >= 0;
            }
          };
        },
        PSEUDO: function(e, n) {
          var a, i = Zr.pseudos[e] || Zr.setFilters[e.toLowerCase()] || Xa.error("unsupported pseudo: " + e);
          return i[Xi] ? i(n) : i.length > 1 ? (a = [
            e,
            e,
            "",
            n
          ], Zr.setFilters.hasOwnProperty(e.toLowerCase()) ? Dc(function(s, f) {
            for (var p, C = i(s, n), k = C.length; k--; )
              p = Xv.call(s, C[k]), s[p] = !(f[p] = C[k]);
          }) : function(s) {
            return i(s, 0, a);
          }) : i;
        }
      },
      pseudos: {
        not: Dc(function(e) {
          var n = [], a = [], i = xy(e.replace($1, "$1"));
          return i[Xi] ? Dc(function(s, f, p, C) {
            for (var k, F = i(s, null, C, []), q = s.length; q--; )
              (k = F[q]) && (s[q] = !(f[q] = k));
          }) : function(s, f, p) {
            return n[0] = s, i(n, null, p, a), n[0] = null, !a.pop();
          };
        }),
        has: Dc(function(e) {
          return function(n) {
            return Xa(e, n).length > 0;
          };
        }),
        contains: Dc(function(e) {
          return e = e.replace(Yv, Zv), function(n) {
            return (n.textContent || n.innerText || gl(n)).indexOf(e) > -1;
          };
        }),
        lang: Dc(function(e) {
          return vg.test(e || "") || Xa.error("unsupported lang: " + e), e = e.replace(Yv, Zv).toLowerCase(), function(n) {
            var a;
            do
              if (a = sf ? n.lang : n.getAttribute("xml:lang") || n.getAttribute("lang"))
                return a = a.toLowerCase(), a === e || a.indexOf(e + "-") === 0;
            while ((n = n.parentNode) && n.nodeType === 1);
            return !1;
          };
        }),
        target: function(e) {
          var n = window.location && window.location.hash;
          return n && n.slice(1) === e.id;
        },
        root: function(e) {
          return e === is;
        },
        focus: function(e) {
          return e === zi.activeElement && (!zi.hasFocus || zi.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
        },
        enabled: function(e) {
          return e.disabled === !1;
        },
        disabled: function(e) {
          return e.disabled === !0;
        },
        checked: function(e) {
          var n = e.nodeName.toLowerCase();
          return n === "input" && !!e.checked || n === "option" && !!e.selected;
        },
        selected: function(e) {
          return e.parentNode && e.parentNode.selectedIndex, e.selected === !0;
        },
        empty: function(e) {
          for (e = e.firstChild; e; e = e.nextSibling)
            if (e.nodeType < 6)
              return !1;
          return !0;
        },
        parent: function(e) {
          return !Zr.pseudos.empty(e);
        },
        header: function(e) {
          return oS.test(e.nodeName);
        },
        input: function(e) {
          return Mk.test(e.nodeName);
        },
        button: function(e) {
          var n = e.nodeName.toLowerCase();
          return n === "input" && e.type === "button" || n === "button";
        },
        text: function(e) {
          var n;
          return e.nodeName.toLowerCase() === "input" && e.type === "text" && ((n = e.getAttribute("type")) == null || n.toLowerCase() === "text");
        },
        first: Jv(function() {
          return [0];
        }),
        last: Jv(function(e, n) {
          return [n - 1];
        }),
        eq: Jv(function(e, n, a) {
          return [a < 0 ? a + n : a];
        }),
        even: Jv(function(e, n) {
          for (var a = 0; a < n; a += 2)
            e.push(a);
          return e;
        }),
        odd: Jv(function(e, n) {
          for (var a = 1; a < n; a += 2)
            e.push(a);
          return e;
        }),
        lt: Jv(function(e, n, a) {
          for (var i = a < 0 ? a + n : a; --i >= 0; )
            e.push(i);
          return e;
        }),
        gt: Jv(function(e, n, a) {
          for (var i = a < 0 ? a + n : a; ++i < n; )
            e.push(i);
          return e;
        })
      }
    }, Zr.pseudos.nth = Zr.pseudos.eq, at([
      "radio",
      "checkbox",
      "file",
      "password",
      "image"
    ], function(e) {
      Zr.pseudos[e] = Bc(e);
    }), at([
      "submit",
      "reset"
    ], function(e) {
      Zr.pseudos[e] = cf(e);
    });
    function Qp() {
    }
    Qp.prototype = Zr.filters = Zr.pseudos, Zr.setFilters = new Qp(), Ks = Xa.tokenize = function(e, n) {
      var a, i, s, f, p, C, k, F = F1[e + " "];
      if (F)
        return n ? 0 : F.slice(0);
      for (p = e, C = [], k = Zr.preFilter; p; ) {
        (!a || (i = Bk.exec(p))) && (i && (p = p.slice(i[0].length) || p), C.push(s = [])), a = !1, (i = aS.exec(p)) && (a = i.shift(), s.push({
          value: a,
          type: i[0].replace($1, " ")
        }), p = p.slice(a.length));
        for (f in Zr.filter)
          !Zr.filter.hasOwnProperty(f) || (i = L1[f].exec(p)) && (!k[f] || (i = k[f](i))) && (a = i.shift(), s.push({
            value: a,
            type: f,
            matches: i
          }), p = p.slice(a.length));
        if (!a)
          break;
      }
      return n ? p.length : p ? Xa.error(e) : F1(e, C).slice(0);
    };
    function V1(e) {
      for (var n = 0, a = e.length, i = ""; n < a; n++)
        i += e[n].value;
      return i;
    }
    function U1(e, n, a) {
      var i = n.dir, s = a && i === "parentNode", f = Zp++;
      return n.first ? function(p, C, k) {
        for (; p = p[i]; )
          if (p.nodeType === 1 || s)
            return e(p, C, k);
      } : function(p, C, k) {
        var F, q, K = [
          lf,
          f
        ];
        if (k) {
          for (; p = p[i]; )
            if ((p.nodeType === 1 || s) && e(p, C, k))
              return !0;
        } else
          for (; p = p[i]; )
            if (p.nodeType === 1 || s) {
              if (q = p[Xi] || (p[Xi] = {}), (F = q[i]) && F[0] === lf && F[1] === f)
                return K[2] = F[2];
              if (q[i] = K, K[2] = e(p, C, k))
                return !0;
            }
      };
    }
    function qd(e) {
      return e.length > 1 ? function(n, a, i) {
        for (var s = e.length; s--; )
          if (!e[s](n, a, i))
            return !1;
        return !0;
      } : e[0];
    }
    function Nk(e, n, a) {
      for (var i = 0, s = n.length; i < s; i++)
        Xa(e, n[i], a);
      return a;
    }
    function j1(e, n, a, i, s) {
      for (var f, p = [], C = 0, k = e.length, F = n != null; C < k; C++)
        (f = e[C]) && (!a || a(f, i, s)) && (p.push(f), F && n.push(C));
      return p;
    }
    function dg(e, n, a, i, s, f) {
      return i && !i[Xi] && (i = dg(i)), s && !s[Xi] && (s = dg(s, f)), Dc(function(p, C, k, F) {
        var q, K, te, be = [], we = [], ke = C.length, Ee = p || Nk(n || "*", k.nodeType ? [k] : k, []), qe = e && (p || !n) ? j1(Ee, be, e, k, F) : Ee, Le = a ? s || (p ? e : ke || i) ? [] : C : qe;
        if (a && a(qe, Le, k, F), i)
          for (q = j1(Le, we), i(q, [], k, F), K = q.length; K--; )
            (te = q[K]) && (Le[we[K]] = !(qe[we[K]] = te));
        if (p) {
          if (s || e) {
            if (s) {
              for (q = [], K = Le.length; K--; )
                (te = Le[K]) && q.push(qe[K] = te);
              s(null, Le = [], q, F);
            }
            for (K = Le.length; K--; )
              (te = Le[K]) && (q = s ? Xv.call(p, te) : be[K]) > -1 && (p[q] = !(C[q] = te));
          }
        } else
          Le = j1(Le === C ? Le.splice(ke, Le.length) : Le), s ? s(null, C, Le, F) : Kv.apply(C, Le);
      });
    }
    function eh(e) {
      for (var n, a, i, s = e.length, f = Zr.relative[e[0].type], p = f || Zr.relative[" "], C = f ? 1 : 0, k = U1(function(K) {
        return K === n;
      }, p, !0), F = U1(function(K) {
        return Xv.call(n, K) > -1;
      }, p, !0), q = [function(K, te, be) {
        var we = !f && (be || te !== ov) || ((n = te).nodeType ? k(K, te, be) : F(K, te, be));
        return n = null, we;
      }]; C < s; C++)
        if (a = Zr.relative[e[C].type])
          q = [U1(qd(q), a)];
        else {
          if (a = Zr.filter[e[C].type].apply(null, e[C].matches), a[Xi]) {
            for (i = ++C; i < s && !Zr.relative[e[i].type]; i++)
              ;
            return dg(C > 1 && qd(q), C > 1 && V1(e.slice(0, C - 1).concat({ value: e[C - 2].type === " " ? "*" : "" })).replace($1, "$1"), a, C < i && eh(e.slice(C, i)), i < s && eh(e = e.slice(i)), i < s && V1(e));
          }
          q.push(a);
        }
      return qd(q);
    }
    function th(e, n) {
      var a = n.length > 0, i = e.length > 0, s = function(f, p, C, k, F) {
        var q, K, te, be = 0, we = "0", ke = f && [], Ee = [], qe = ov, Le = f || i && Zr.find.TAG("*", F), xt = lf += qe == null ? 1 : Math.random() || 0.1, mt = Le.length;
        for (F && (ov = p !== zi && p); we !== mt && (q = Le[we]) != null; we++) {
          if (i && q) {
            for (K = 0; te = e[K++]; )
              if (te(q, p, C)) {
                k.push(q);
                break;
              }
            F && (lf = xt);
          }
          a && ((q = !te && q) && be--, f && ke.push(q));
        }
        if (be += we, a && we !== be) {
          for (K = 0; te = n[K++]; )
            te(ke, Ee, p, C);
          if (f) {
            if (be > 0)
              for (; we--; )
                ke[we] || Ee[we] || (Ee[we] = ky.call(k));
            Ee = j1(Ee);
          }
          Kv.apply(k, Ee), F && !f && Ee.length > 0 && be + n.length > 1 && Xa.uniqueSort(k);
        }
        return F && (lf = xt, ov = qe), ke;
      };
      return a ? Dc(s) : s;
    }
    xy = Xa.compile = function(e, n) {
      var a, i = [], s = [], f = qv[e + " "];
      if (!f) {
        for (n || (n = Ks(e)), a = n.length; a--; )
          f = eh(n[a]), f[Xi] ? i.push(f) : s.push(f);
        f = qv(e, th(s, i)), f.selector = e;
      }
      return f;
    }, uf = Xa.select = function(e, n, a, i) {
      var s, f, p, C, k, F = typeof e == "function" && e, q = !i && Ks(e = F.selector || e);
      if (a = a || [], q.length === 1) {
        if (f = q[0] = q[0].slice(0), f.length > 2 && (p = f[0]).type === "ID" && li.getById && n.nodeType === 9 && sf && Zr.relative[f[1].type]) {
          if (n = (Zr.find.ID(p.matches[0].replace(Yv, Zv), n) || [])[0], n)
            F && (n = n.parentNode);
          else
            return a;
          e = e.slice(f.shift().value.length);
        }
        for (s = L1.needsContext.test(e) ? 0 : f.length; s-- && (p = f[s], !Zr.relative[C = p.type]); )
          if ((k = Zr.find[C]) && (i = k(p.matches[0].replace(Yv, Zv), Ay.test(f[0].type) && H1(n.parentNode) || n))) {
            if (f.splice(s, 1), e = i.length && V1(f), !e)
              return Kv.apply(a, i), a;
            break;
          }
      }
      return (F || xy(e, q))(i, n, !sf, a, Ay.test(e) && H1(n.parentNode) || n), a;
    }, li.sortStable = Xi.split("").sort(Gv).join("") === Xi, li.detectDuplicates = !!pl, jv(), li.sortDetached = !0;
    var Oy = document, Di = Array.prototype.push, Gd = Array.prototype.slice, yi = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/, us = lg.Event, Kd = Ut.makeMap("children,contents,next,prev"), bl = function(e) {
      return typeof e < "u";
    }, W1 = function(e) {
      return typeof e == "string";
    }, ff = function(e) {
      return e && e === e.window;
    }, mg = function(e, n) {
      n = n || Oy;
      var a = n.createElement("div"), i = n.createDocumentFragment();
      a.innerHTML = e;
      for (var s; s = a.firstChild; )
        i.appendChild(s);
      return i;
    }, gg = function(e, n, a, i) {
      var s;
      if (W1(n))
        n = mg(n, Qv(e[0]));
      else if (n.length && !n.nodeType) {
        if (n = ta.makeArray(n), i)
          for (s = n.length - 1; s >= 0; s--)
            gg(e, n[s], a, i);
        else
          for (s = 0; s < n.length; s++)
            gg(e, n[s], a, i);
        return e;
      }
      if (n.nodeType)
        for (s = e.length; s--; )
          a.call(e[s], n);
      return e;
    }, uS = function(e, n) {
      return e && n && (" " + e.className + " ").indexOf(" " + n + " ") !== -1;
    }, sS = function(e, n, a) {
      var i, s;
      return n = ta(n)[0], e.each(function() {
        var f = this;
        (!a || i !== f.parentNode) && (i = f.parentNode, s = n.cloneNode(!1), f.parentNode.insertBefore(s, f)), s.appendChild(f);
      }), e;
    }, Ik = Ut.makeMap("fillOpacity fontWeight lineHeight opacity orphans widows zIndex zoom", " "), Fk = Ut.makeMap("checked compact declare defer disabled ismap multiple nohref noshade nowrap readonly selected", " "), $k = {
      for: "htmlFor",
      class: "className",
      readonly: "readOnly"
    }, lS = { float: "cssFloat" }, q1 = {}, G1 = {}, vu = function(e, n) {
      return new ta.fn.init(e, n);
    }, K1 = function(e, n) {
      var a;
      if (n.indexOf)
        return n.indexOf(e);
      for (a = n.length; a--; )
        if (n[a] === e)
          return a;
      return -1;
    }, Dy = /^\s*|\s*$/g, Bl = function(e) {
      return e == null ? "" : ("" + e).replace(Dy, "");
    }, ko = function(e, n) {
      var a, i, s, f;
      if (e)
        if (a = e.length, a === void 0) {
          for (i in e)
            if (e.hasOwnProperty(i) && (f = e[i], n.call(f, i, f) === !1))
              break;
        } else
          for (s = 0; s < a && (f = e[s], n.call(f, s, f) !== !1); s++)
            ;
      return e;
    }, yl = function(e, n) {
      var a = [];
      return ko(e, function(i, s) {
        n(s, i) && a.push(s);
      }), a;
    }, Qv = function(e) {
      return e ? e.nodeType === 9 ? e : e.ownerDocument : Oy;
    };
    vu.fn = vu.prototype = {
      constructor: vu,
      selector: "",
      context: null,
      length: 0,
      init: function(e, n) {
        var a = this, i, s;
        if (!e)
          return a;
        if (e.nodeType)
          return a.context = a[0] = e, a.length = 1, a;
        if (n && n.nodeType)
          a.context = n;
        else {
          if (n)
            return ta(e).attr(n);
          a.context = n = document;
        }
        if (W1(e))
          if (a.selector = e, e.charAt(0) === "<" && e.charAt(e.length - 1) === ">" && e.length >= 3 ? i = [
            null,
            e,
            null
          ] : i = yi.exec(e), i)
            if (i[1])
              for (s = mg(e, Qv(n)).firstChild; s; )
                Di.call(a, s), s = s.nextSibling;
            else {
              if (s = Qv(n).getElementById(i[2]), !s)
                return a;
              if (s.id !== i[2])
                return a.find(e);
              a.length = 1, a[0] = s;
            }
          else
            return ta(n).find(e);
        else
          this.add(e, !1);
        return a;
      },
      toArray: function() {
        return Ut.toArray(this);
      },
      add: function(e, n) {
        var a = this, i, s;
        if (W1(e))
          return a.add(ta(e));
        if (n !== !1)
          for (i = ta.unique(a.toArray().concat(ta.makeArray(e))), a.length = i.length, s = 0; s < i.length; s++)
            a[s] = i[s];
        else
          Di.apply(a, ta.makeArray(e));
        return a;
      },
      attr: function(e, n) {
        var a = this, i;
        if (typeof e == "object")
          ko(e, function(s, f) {
            a.attr(s, f);
          });
        else if (bl(n))
          this.each(function() {
            var s;
            if (this.nodeType === 1) {
              if (s = q1[e], s && s.set) {
                s.set(this, n);
                return;
              }
              n === null ? this.removeAttribute(e, 2) : this.setAttribute(e, n, 2);
            }
          });
        else {
          if (a[0] && a[0].nodeType === 1) {
            if (i = q1[e], i && i.get)
              return i.get(a[0], e);
            if (Fk[e])
              return a.prop(e) ? e : void 0;
            n = a[0].getAttribute(e, 2), n === null && (n = void 0);
          }
          return n;
        }
        return a;
      },
      removeAttr: function(e) {
        return this.attr(e, null);
      },
      prop: function(e, n) {
        var a = this;
        if (e = $k[e] || e, typeof e == "object")
          ko(e, function(i, s) {
            a.prop(i, s);
          });
        else if (bl(n))
          this.each(function() {
            this.nodeType === 1 && (this[e] = n);
          });
        else
          return a[0] && a[0].nodeType && e in a[0] ? a[0][e] : n;
        return a;
      },
      css: function(e, n) {
        var a = this, i, s, f = function(C) {
          return C.replace(/-(\D)/g, function(k, F) {
            return F.toUpperCase();
          });
        }, p = function(C) {
          return C.replace(/[A-Z]/g, function(k) {
            return "-" + k;
          });
        };
        if (typeof e == "object")
          ko(e, function(C, k) {
            a.css(C, k);
          });
        else if (bl(n))
          e = f(e), typeof n == "number" && !Ik[e] && (n = n.toString() + "px"), a.each(function() {
            var C = this.style;
            if (s = G1[e], s && s.set) {
              s.set(this, n);
              return;
            }
            try {
              this.style[lS[e] || e] = n;
            } catch {
            }
            (n === null || n === "") && (C.removeProperty ? C.removeProperty(p(e)) : C.removeAttribute(e));
          });
        else {
          if (i = a[0], s = G1[e], s && s.get)
            return s.get(i);
          if (i.ownerDocument.defaultView)
            try {
              return i.ownerDocument.defaultView.getComputedStyle(i, null).getPropertyValue(p(e));
            } catch {
              return;
            }
          else
            return i.currentStyle ? i.currentStyle[f(e)] : "";
        }
        return a;
      },
      remove: function() {
        for (var e = this, n, a = this.length; a--; )
          n = e[a], us.clean(n), n.parentNode && n.parentNode.removeChild(n);
        return this;
      },
      empty: function() {
        for (var e = this, n, a = this.length; a--; )
          for (n = e[a]; n.firstChild; )
            n.removeChild(n.firstChild);
        return this;
      },
      html: function(e) {
        var n = this, a;
        if (bl(e)) {
          a = n.length;
          try {
            for (; a--; )
              n[a].innerHTML = e;
          } catch {
            ta(n[a]).empty().append(e);
          }
          return n;
        }
        return n[0] ? n[0].innerHTML : "";
      },
      text: function(e) {
        var n = this, a;
        if (bl(e)) {
          for (a = n.length; a--; )
            "innerText" in n[a] ? n[a].innerText = e : n[0].textContent = e;
          return n;
        }
        return n[0] ? n[0].innerText || n[0].textContent : "";
      },
      append: function() {
        return gg(this, arguments, function(e) {
          (this.nodeType === 1 || this.host && this.host.nodeType === 1) && this.appendChild(e);
        });
      },
      prepend: function() {
        return gg(this, arguments, function(e) {
          (this.nodeType === 1 || this.host && this.host.nodeType === 1) && this.insertBefore(e, this.firstChild);
        }, !0);
      },
      before: function() {
        var e = this;
        return e[0] && e[0].parentNode ? gg(e, arguments, function(n) {
          this.parentNode.insertBefore(n, this);
        }) : e;
      },
      after: function() {
        var e = this;
        return e[0] && e[0].parentNode ? gg(e, arguments, function(n) {
          this.parentNode.insertBefore(n, this.nextSibling);
        }, !0) : e;
      },
      appendTo: function(e) {
        return ta(e).append(this), this;
      },
      prependTo: function(e) {
        return ta(e).prepend(this), this;
      },
      replaceWith: function(e) {
        return this.before(e).remove();
      },
      wrap: function(e) {
        return sS(this, e);
      },
      wrapAll: function(e) {
        return sS(this, e, !0);
      },
      wrapInner: function(e) {
        return this.each(function() {
          ta(this).contents().wrapAll(e);
        }), this;
      },
      unwrap: function() {
        return this.parent().each(function() {
          ta(this).replaceWith(this.childNodes);
        });
      },
      clone: function() {
        var e = [];
        return this.each(function() {
          e.push(this.cloneNode(!0));
        }), ta(e);
      },
      addClass: function(e) {
        return this.toggleClass(e, !0);
      },
      removeClass: function(e) {
        return this.toggleClass(e, !1);
      },
      toggleClass: function(e, n) {
        var a = this;
        return typeof e != "string" || (e.indexOf(" ") !== -1 ? ko(e.split(" "), function() {
          a.toggleClass(this, n);
        }) : a.each(function(i, s) {
          var f = uS(s, e);
          if (f !== n) {
            var p = s.className;
            f ? s.className = Bl((" " + p + " ").replace(" " + e + " ", " ")) : s.className += p ? " " + e : e;
          }
        })), a;
      },
      hasClass: function(e) {
        return uS(this[0], e);
      },
      each: function(e) {
        return ko(this, e);
      },
      on: function(e, n) {
        return this.each(function() {
          us.bind(this, e, n);
        });
      },
      off: function(e, n) {
        return this.each(function() {
          us.unbind(this, e, n);
        });
      },
      trigger: function(e) {
        return this.each(function() {
          typeof e == "object" ? us.fire(this, e.type, e) : us.fire(this, e);
        });
      },
      show: function() {
        return this.css("display", "");
      },
      hide: function() {
        return this.css("display", "none");
      },
      slice: function() {
        return ta(Gd.apply(this, arguments));
      },
      eq: function(e) {
        return e === -1 ? this.slice(e) : this.slice(e, +e + 1);
      },
      first: function() {
        return this.eq(0);
      },
      last: function() {
        return this.eq(-1);
      },
      find: function(e) {
        var n, a, i = [];
        for (n = 0, a = this.length; n < a; n++)
          ta.find(e, this[n], i);
        return ta(i);
      },
      filter: function(e) {
        return ta(typeof e == "function" ? yl(this.toArray(), function(n, a) {
          return e(a, n);
        }) : ta.filter(e, this.toArray()));
      },
      closest: function(e) {
        var n = [];
        return e instanceof ta && (e = e[0]), this.each(function(a, i) {
          for (; i; ) {
            if (typeof e == "string" && ta(i).is(e)) {
              n.push(i);
              break;
            } else if (i === e) {
              n.push(i);
              break;
            }
            i = i.parentNode;
          }
        }), ta(n);
      },
      offset: function(e) {
        var n, a, i, s = 0, f = 0, p;
        return e ? this.css(e) : (n = this[0], n && (a = n.ownerDocument, i = a.documentElement, n.getBoundingClientRect && (p = n.getBoundingClientRect(), s = p.left + (i.scrollLeft || a.body.scrollLeft) - i.clientLeft, f = p.top + (i.scrollTop || a.body.scrollTop) - i.clientTop)), {
          left: s,
          top: f
        });
      },
      push: Di,
      sort: Array.prototype.sort,
      splice: Array.prototype.splice
    }, Ut.extend(vu, {
      extend: Ut.extend,
      makeArray: function(e) {
        return ff(e) || e.nodeType ? [e] : Ut.toArray(e);
      },
      inArray: K1,
      isArray: Ut.isArray,
      each: ko,
      trim: Bl,
      grep: yl,
      find: Xa,
      expr: Xa.selectors,
      unique: Xa.uniqueSort,
      text: Xa.getText,
      contains: Xa.contains,
      filter: function(e, n, a) {
        var i = n.length;
        for (a && (e = ":not(" + e + ")"); i--; )
          n[i].nodeType !== 1 && n.splice(i, 1);
        return n.length === 1 ? n = ta.find.matchesSelector(n[0], e) ? [n[0]] : [] : n = ta.find.matches(e, n), n;
      }
    });
    var By = function(e, n, a) {
      var i = [], s = e[n];
      for (typeof a != "string" && a instanceof ta && (a = a[0]); s && s.nodeType !== 9 && !(a !== void 0 && (s === a || typeof a == "string" && ta(s).is(a))); )
        s.nodeType === 1 && i.push(s), s = s[n];
      return i;
    }, X1 = function(e, n, a, i) {
      var s = [];
      for (i instanceof ta && (i = i[0]); e; e = e[n])
        if (!(a && e.nodeType !== a)) {
          if (i !== void 0 && (e === i || typeof i == "string" && ta(e).is(i)))
            break;
          s.push(e);
        }
      return s;
    }, cS = function(e, n, a) {
      for (e = e[n]; e; e = e[n])
        if (e.nodeType === a)
          return e;
      return null;
    };
    ko({
      parent: function(e) {
        var n = e.parentNode;
        return n && n.nodeType !== 11 ? n : null;
      },
      parents: function(e) {
        return By(e, "parentNode");
      },
      next: function(e) {
        return cS(e, "nextSibling", 1);
      },
      prev: function(e) {
        return cS(e, "previousSibling", 1);
      },
      children: function(e) {
        return X1(e.firstChild, "nextSibling", 1);
      },
      contents: function(e) {
        return Ut.toArray((e.nodeName === "iframe" ? e.contentDocument || e.contentWindow.document : e).childNodes);
      }
    }, function(e, n) {
      vu.fn[e] = function(a) {
        var i = this, s = [];
        i.each(function() {
          var p = n.call(s, this, a, s);
          p && (ta.isArray(p) ? s.push.apply(s, p) : s.push(p));
        }), this.length > 1 && (Kd[e] || (s = ta.unique(s)), e.indexOf("parents") === 0 && (s = s.reverse()));
        var f = ta(s);
        return a ? f.filter(a) : f;
      };
    }), ko({
      parentsUntil: function(e, n) {
        return By(e, "parentNode", n);
      },
      nextUntil: function(e, n) {
        return X1(e, "nextSibling", 1, n).slice(1);
      },
      prevUntil: function(e, n) {
        return X1(e, "previousSibling", 1, n).slice(1);
      }
    }, function(e, n) {
      vu.fn[e] = function(a, i) {
        var s = this, f = [];
        s.each(function() {
          var C = n.call(f, this, a, f);
          C && (ta.isArray(C) ? f.push.apply(f, C) : f.push(C));
        }), this.length > 1 && (f = ta.unique(f), (e.indexOf("parents") === 0 || e === "prevUntil") && (f = f.reverse()));
        var p = ta(f);
        return i ? p.filter(i) : p;
      };
    }), vu.fn.is = function(e) {
      return !!e && this.filter(e).length > 0;
    }, vu.fn.init.prototype = vu.fn, vu.overrideDefaults = function(e) {
      var n, a = function(i, s) {
        return n = n || e(), arguments.length === 0 && (i = n.element), s || (s = n.context), new a.fn.init(i, s);
      };
      return ta.extend(a, this), a;
    }, vu.attrHooks = q1, vu.cssHooks = G1;
    var ta = vu, pg = Ut.each, Y1 = Ut.grep, Ry = br.ie, Bi = /^([a-z0-9],?)+$/i, Rl = function(e, n, a) {
      var i = n.keep_values, s = {
        set: function(p, C, k) {
          n.url_converter && C !== null && (C = n.url_converter.call(n.url_converter_scope || a(), C, k, p[0])), p.attr("data-mce-" + k, C).attr(k, C);
        },
        get: function(p, C) {
          return p.attr("data-mce-" + C) || p.attr(C);
        }
      }, f = {
        style: {
          set: function(p, C) {
            if (C !== null && typeof C == "object") {
              p.css(C);
              return;
            }
            i && p.attr("data-mce-style", C), C !== null && typeof C == "string" ? (p.removeAttr("style"), p.css(e.parse(C))) : p.attr("style", C);
          },
          get: function(p) {
            var C = p.attr("data-mce-style") || p.attr("style");
            return C = e.serialize(e.parse(C), p[0].nodeName), C;
          }
        }
      };
      return i && (f.href = f.src = s), f;
    }, fS = function(e, n) {
      var a = n.attr("style"), i = e.serialize(e.parse(a), n[0].nodeName);
      i || (i = null), n.attr("data-mce-style", i);
    }, Xd = function(e, n) {
      var a = 0, i, s;
      if (e)
        for (i = e.nodeType, e = e.previousSibling; e; e = e.previousSibling)
          s = e.nodeType, !(n && s === 3 && (s === i || !e.nodeValue.length)) && (a++, i = s);
      return a;
    }, ho = function(e, n) {
      n === void 0 && (n = {});
      var a = {}, i = window, s = {}, f = 0, p = !0, C = !0, k = Yl.forElement(O.fromDom(e), {
        contentCssCors: n.contentCssCors,
        referrerPolicy: n.referrerPolicy
      }), F = [], q = n.schema ? n.schema : ml({}), K = tc({
        url_converter: n.url_converter,
        url_converter_scope: n.url_converter_scope
      }, n.schema), te = n.ownEvents ? new lg() : lg.Event, be = q.getBlockElements(), we = ta.overrideDefaults(function() {
        return {
          context: e,
          element: Pm.getRoot()
        };
      }), ke = function(it) {
        if (typeof it == "string")
          return !!be[it];
        if (it) {
          var $t = it.nodeType;
          if ($t)
            return !!($t === 1 && be[it.nodeName]);
        }
        return !1;
      }, Ee = function(it) {
        return it && e && Ge(it) ? e.getElementById(it) : it;
      }, qe = function(it) {
        return we(typeof it == "string" ? Ee(it) : it);
      }, Le = function(it, $t, An) {
        var Hn, oa, _a = qe(it);
        return _a.length && (Hn = t5[$t], Hn && Hn.get ? oa = Hn.get(_a, $t) : oa = _a.attr($t)), typeof oa > "u" && (oa = An || ""), oa;
      }, xt = function(it) {
        var $t = Ee(it);
        return $t ? $t.attributes : [];
      }, mt = function(it, $t, An) {
        An === "" && (An = null);
        var Hn = qe(it), oa = Hn.attr($t);
        if (!!Hn.length) {
          var _a = t5[$t];
          _a && _a.set ? _a.set(Hn, An, $t) : Hn.attr($t, An), oa !== An && n.onSetAttrib && n.onSetAttrib({
            attrElm: Hn,
            attrName: $t,
            attrValue: An
          });
        }
      }, Qe = function(it, $t) {
        if (!Ry || it.nodeType !== 1 || $t)
          return it.cloneNode($t);
        var An = e.createElement(it.nodeName);
        return pg(xt(it), function(Hn) {
          mt(An, Hn.nodeName, Le(it, Hn.nodeName));
        }), An;
      }, At = function() {
        return n.root_element || e.body;
      }, tn = function(it) {
        var $t = Yf(it);
        return {
          x: $t.x,
          y: $t.y,
          w: $t.width,
          h: $t.height
        };
      }, Cn = function(it, $t) {
        return Lp(e.body, Ee(it), $t);
      }, Ar = function(it, $t, An) {
        var Hn = Ge($t) ? qe(it).css($t, An) : qe(it).css($t);
        n.update_styles && fS(K, Hn);
      }, Xn = function(it, $t) {
        var An = qe(it).css($t);
        n.update_styles && fS(K, An);
      }, fn = function(it, $t, An) {
        var Hn = qe(it);
        return An ? Hn.css($t) : ($t = $t.replace(/-(\D)/g, function(oa, _a) {
          return _a.toUpperCase();
        }), $t === "float" && ($t = br.browser.isIE() ? "styleFloat" : "cssFloat"), Hn[0] && Hn[0].style ? Hn[0].style[$t] : void 0);
      }, _r = function(it) {
        var $t, An;
        return it = Ee(it), $t = fn(it, "width"), An = fn(it, "height"), $t.indexOf("px") === -1 && ($t = 0), An.indexOf("px") === -1 && (An = 0), {
          w: parseInt($t, 10) || it.offsetWidth || it.clientWidth,
          h: parseInt(An, 10) || it.offsetHeight || it.clientHeight
        };
      }, kn = function(it) {
        it = Ee(it);
        var $t = Cn(it), An = _r(it);
        return {
          x: $t.x,
          y: $t.y,
          w: An.w,
          h: An.h
        };
      }, Kn = function(it, $t) {
        var An;
        if (!it)
          return !1;
        if (!Array.isArray(it)) {
          if ($t === "*")
            return it.nodeType === 1;
          if (Bi.test($t)) {
            var Hn = $t.toLowerCase().split(/,/), oa = it.nodeName.toLowerCase();
            for (An = Hn.length - 1; An >= 0; An--)
              if (Hn[An] === oa)
                return !0;
            return !1;
          }
          if (it.nodeType && it.nodeType !== 1)
            return !1;
        }
        var _a = Array.isArray(it) ? it : [it];
        return Xa($t, _a[0].ownerDocument || _a[0], null, _a).length > 0;
      }, On = function(it, $t, An, Hn) {
        var oa = [], _a, $o = Ee(it);
        for (Hn = Hn === void 0, An = An || (At().nodeName !== "BODY" ? At().parentNode : null), Ut.is($t, "string") && (_a = $t, $t === "*" ? $t = function(Bp) {
          return Bp.nodeType === 1;
        } : $t = function(Bp) {
          return Kn(Bp, _a);
        }); $o && !($o === An || Pt($o.nodeType) || $p($o) || ea($o)); ) {
          if (!$t || typeof $t == "function" && $t($o))
            if (Hn)
              oa.push($o);
            else
              return [$o];
          $o = $o.parentNode;
        }
        return Hn ? oa : null;
      }, $n = function(it, $t, An) {
        var Hn = On(it, $t, An, !1);
        return Hn && Hn.length > 0 ? Hn[0] : null;
      }, rr = function(it, $t, An) {
        var Hn = $t;
        if (it) {
          for (typeof $t == "string" && (Hn = function(oa) {
            return Kn(oa, $t);
          }), it = it[An]; it; it = it[An])
            if (typeof Hn == "function" && Hn(it))
              return it;
        }
        return null;
      }, hn = function(it, $t) {
        return rr(it, $t, "nextSibling");
      }, Zn = function(it, $t) {
        return rr(it, $t, "previousSibling");
      }, fa = function(it, $t) {
        return Xa(it, Ee($t) || n.root_element || e, []);
      }, Ia = function(it, $t, An) {
        var Hn, oa = typeof it == "string" ? Ee(it) : it;
        if (!oa)
          return !1;
        if (Ut.isArray(oa) && (oa.length || oa.length === 0))
          return Hn = [], pg(oa, function($o, Bp) {
            $o && Hn.push($t.call(An, typeof $o == "string" ? Ee($o) : $o, Bp));
          }), Hn;
        var _a = An || this;
        return $t.call(_a, oa);
      }, Pa = function(it, $t) {
        qe(it).each(function(An, Hn) {
          pg($t, function(oa, _a) {
            mt(Hn, _a, oa);
          });
        });
      }, yu = function(it, $t) {
        var An = qe(it);
        Ry ? An.each(function(Hn, oa) {
          if (oa.canHaveHTML !== !1) {
            for (; oa.firstChild; )
              oa.removeChild(oa.firstChild);
            try {
              oa.innerHTML = "<br>" + $t, oa.removeChild(oa.firstChild);
            } catch {
              ta("<div></div>").html("<br>" + $t).contents().slice(1).appendTo(oa);
            }
            return $t;
          }
        }) : An.html($t);
      }, Wo = function(it, $t, An, Hn, oa) {
        return Ia(it, function(_a) {
          var $o = typeof $t == "string" ? e.createElement($t) : $t;
          return Pa($o, An), Hn && (typeof Hn != "string" && Hn.nodeType ? $o.appendChild(Hn) : typeof Hn == "string" && yu($o, Hn)), oa ? $o : _a.appendChild($o);
        });
      }, Rs = function(it, $t, An) {
        return Wo(e.createElement(it), it, $t, An, !0);
      }, tl = dl.decode, bn = dl.encodeAllRaw, Mn = function(it, $t, An) {
        var Hn = "", oa;
        Hn += "<" + it;
        for (oa in $t)
          Va($t, oa) && (Hn += " " + oa + '="' + bn($t[oa]) + '"');
        return typeof An < "u" ? Hn + ">" + An + "</" + it + ">" : Hn + " />";
      }, gr = function(it) {
        var $t, An = e.createElement("div"), Hn = e.createDocumentFragment();
        for (Hn.appendChild(An), it && (An.innerHTML = it); $t = An.firstChild; )
          Hn.appendChild($t);
        return Hn.removeChild(An), Hn;
      }, Dt = function(it, $t) {
        var An = qe(it);
        return $t ? An.each(function() {
          for (var Hn; Hn = this.firstChild; )
            Hn.nodeType === 3 && Hn.data.length === 0 ? this.removeChild(Hn) : this.parentNode.insertBefore(Hn, this);
        }).remove() : An.remove(), An.length > 1 ? An.toArray() : An[0];
      }, xn = function(it) {
        return Ia(it, function($t) {
          var An, Hn = $t.attributes;
          for (An = Hn.length - 1; An >= 0; An--)
            $t.removeAttributeNode(Hn.item(An));
        });
      }, wn = function(it) {
        return K.parse(it);
      }, yr = function(it, $t) {
        return K.serialize(it, $t);
      }, kr = function(it) {
        var $t, An;
        if (Pm !== ho.DOM && e === document) {
          if (a[it])
            return;
          a[it] = !0;
        }
        An = e.getElementById("mceDefaultStyles"), An || (An = e.createElement("style"), An.id = "mceDefaultStyles", An.type = "text/css", $t = e.getElementsByTagName("head")[0], $t.firstChild ? $t.insertBefore(An, $t.firstChild) : $t.appendChild(An)), An.styleSheet ? An.styleSheet.cssText += it : An.appendChild(e.createTextNode(it));
      }, uo = function(it) {
        it || (it = ""), at(it.split(","), function($t) {
          s[$t] = !0, k.load($t, xe);
        });
      }, ji = function(it, $t, An) {
        qe(it).toggleClass($t, An).each(function() {
          this.className === "" && ta(this).attr("class", null);
        });
      }, Ii = function(it, $t) {
        qe(it).addClass($t);
      }, Mm = function(it, $t) {
        ji(it, $t, !1);
      }, Ms = function(it, $t) {
        return qe(it).hasClass($t);
      }, ps = function(it) {
        qe(it).show();
      }, nu = function(it) {
        qe(it).hide();
      }, vc = function(it) {
        return qe(it).css("display") === "none";
      }, Ps = function(it) {
        return (it || "mce_") + f++;
      }, Ff = function(it) {
        var $t = typeof it == "string" ? Ee(it) : it;
        return $r($t) ? $t.outerHTML : ta("<div></div>").append(ta($t).clone()).html();
      }, fo = function(it, $t) {
        qe(it).each(function() {
          try {
            if ("outerHTML" in this) {
              this.outerHTML = $t;
              return;
            }
          } catch {
          }
          Dt(ta(this).html($t), !0);
        });
      }, To = function(it, $t) {
        var An = Ee($t);
        return Ia(it, function(Hn) {
          var oa = An.parentNode, _a = An.nextSibling;
          return _a ? oa.insertBefore(Hn, _a) : oa.appendChild(Hn), Hn;
        });
      }, ru = function(it, $t, An) {
        return Ia($t, function(Hn) {
          return Ut.is(Hn, "array") && (it = it.cloneNode(!0)), An && pg(Y1(Hn.childNodes), function(oa) {
            it.appendChild(oa);
          }), Hn.parentNode.replaceChild(it, Hn);
        });
      }, nl = function(it, $t) {
        var An;
        return it.nodeName !== $t.toUpperCase() && (An = Rs($t), pg(xt(it), function(Hn) {
          mt(An, Hn.nodeName, Le(it, Hn.nodeName));
        }), ru(An, it, !0)), An || it;
      }, _v = function(it, $t) {
        for (var An = it, Hn; An; ) {
          for (Hn = $t; Hn && An !== Hn; )
            Hn = Hn.parentNode;
          if (An === Hn)
            break;
          An = An.parentNode;
        }
        return !An && it.ownerDocument ? it.ownerDocument.documentElement : An;
      }, Av = function(it) {
        return K.toHex(Ut.trim(it));
      }, Dp = function(it) {
        if ($r(it)) {
          var $t = it.nodeName.toLowerCase() === "a" && !Le(it, "href") && Le(it, "id");
          if (Le(it, "name") || Le(it, "data-mce-bookmark") || $t)
            return !0;
        }
        return !1;
      }, qb = function(it, $t) {
        var An, Hn, oa = 0;
        if (Dp(it))
          return !1;
        if (it = it.firstChild, it) {
          var _a = new Ha(it, it.parentNode), $o = q ? q.getWhiteSpaceElements() : {};
          $t = $t || (q ? q.getNonEmptyElements() : null);
          do {
            if (An = it.nodeType, $r(it)) {
              var Bp = it.getAttribute("data-mce-bogus");
              if (Bp) {
                it = _a.next(Bp === "all");
                continue;
              }
              if (Hn = it.nodeName.toLowerCase(), $t && $t[Hn]) {
                if (Hn === "br") {
                  oa++, it = _a.next();
                  continue;
                }
                return !1;
              }
              if (Dp(it))
                return !1;
            }
            if (An === 8 || An === 3 && !Jl(it.nodeValue) || An === 3 && it.parentNode && $o[it.parentNode.nodeName] && Jl(it.nodeValue))
              return !1;
            it = _a.next();
          } while (it);
        }
        return oa <= 1;
      }, W3 = function() {
        return e.createRange();
      }, pB = function(it, $t, An) {
        var Hn = W3(), oa, _a, $o;
        if (it && $t)
          return Hn.setStart(it.parentNode, Xd(it)), Hn.setEnd($t.parentNode, Xd($t)), oa = Hn.extractContents(), Hn = W3(), Hn.setStart($t.parentNode, Xd($t) + 1), Hn.setEnd(it.parentNode, Xd(it) + 1), _a = Hn.extractContents(), $o = it.parentNode, $o.insertBefore(my(Pm, oa), it), An ? $o.insertBefore(An, it) : $o.insertBefore($t, it), $o.insertBefore(my(Pm, _a), it), Dt(it), An || $t;
      }, hB = function(it, $t, An, Hn) {
        if (Ut.isArray(it)) {
          for (var oa = it.length, _a = []; oa--; )
            _a[oa] = hB(it[oa], $t, An, Hn);
          return _a;
        }
        n.collect && (it === e || it === i) && F.push([
          it,
          $t,
          An,
          Hn
        ]);
        var $o = te.bind(it, $t, An, Hn || Pm);
        return $o;
      }, QA = function(it, $t, An) {
        if (Ut.isArray(it)) {
          for (var Hn = it.length, oa = []; Hn--; )
            oa[Hn] = QA(it[Hn], $t, An);
          return oa;
        } else {
          if (F.length > 0 && (it === e || it === i))
            for (var Hn = F.length; Hn--; ) {
              var _a = F[Hn];
              it === _a[0] && (!$t || $t === _a[1]) && (!An || An === _a[2]) && te.unbind(_a[0], _a[1], _a[2]);
            }
          return te.unbind(it, $t, An);
        }
      }, p$ = function(it, $t, An) {
        return te.fire(it, $t, An);
      }, bB = function(it) {
        if (it && $r(it)) {
          var $t = it.getAttribute("data-mce-contenteditable");
          return $t && $t !== "inherit" ? $t : it.contentEditable !== "inherit" ? it.contentEditable : null;
        } else
          return null;
      }, h$ = function(it) {
        for (var $t = At(), An = null; it && it !== $t && (An = bB(it), An === null); it = it.parentNode)
          ;
        return An;
      }, yB = function() {
        if (F.length > 0)
          for (var it = F.length; it--; ) {
            var $t = F[it];
            te.unbind($t[0], $t[1], $t[2]);
          }
        _n(s, function(An, Hn) {
          k.unload(Hn), delete s[Hn];
        }), Xa.setDocument && Xa.setDocument();
      }, e5 = function(it, $t) {
        if (Ry) {
          for (; it; ) {
            if ($t === it)
              return !0;
            it = it.parentNode;
          }
          return !1;
        } else
          return it === $t || $t.contains(it);
      }, b$ = function(it) {
        return "startContainer: " + it.startContainer.nodeName + ", startOffset: " + it.startOffset + ", endContainer: " + it.endContainer.nodeName + ", endOffset: " + it.endOffset;
      }, Pm = {
        doc: e,
        settings: n,
        win: i,
        files: s,
        stdMode: p,
        boxModel: C,
        styleSheetLoader: k,
        boundEvents: F,
        styles: K,
        schema: q,
        events: te,
        isBlock: ke,
        $: we,
        $$: qe,
        root: null,
        clone: Qe,
        getRoot: At,
        getViewPort: tn,
        getRect: kn,
        getSize: _r,
        getParent: $n,
        getParents: On,
        get: Ee,
        getNext: hn,
        getPrev: Zn,
        select: fa,
        is: Kn,
        add: Wo,
        create: Rs,
        createHTML: Mn,
        createFragment: gr,
        remove: Dt,
        setStyle: Ar,
        getStyle: fn,
        setStyles: Xn,
        removeAllAttribs: xn,
        setAttrib: mt,
        setAttribs: Pa,
        getAttrib: Le,
        getPos: Cn,
        parseStyle: wn,
        serializeStyle: yr,
        addStyle: kr,
        loadCSS: uo,
        addClass: Ii,
        removeClass: Mm,
        hasClass: Ms,
        toggleClass: ji,
        show: ps,
        hide: nu,
        isHidden: vc,
        uniqueId: Ps,
        setHTML: yu,
        getOuterHTML: Ff,
        setOuterHTML: fo,
        decode: tl,
        encode: bn,
        insertAfter: To,
        replace: ru,
        rename: nl,
        findCommonAncestor: _v,
        toHex: Av,
        run: Ia,
        getAttribs: xt,
        isEmpty: qb,
        createRng: W3,
        nodeIndex: Xd,
        split: pB,
        bind: hB,
        unbind: QA,
        fire: p$,
        getContentEditable: bB,
        getContentEditableParent: h$,
        destroy: yB,
        isChildOf: e5,
        dumpRng: b$
      }, t5 = Rl(K, n, N(Pm));
      return Pm;
    };
    ho.DOM = ho(document), ho.nodeIndex = Xd;
    var Yd = ho.DOM, Z1 = Ut.each, hg = Ut.grep, My = 0, vS = 1, nh = 2, dS = 3, uv = function() {
      function e(n) {
        n === void 0 && (n = {}), this.states = {}, this.queue = [], this.scriptLoadedCallbacks = {}, this.queueLoadedCallbacks = [], this.loading = 0, this.settings = n;
      }
      return e.prototype._setReferrerPolicy = function(n) {
        this.settings.referrerPolicy = n;
      }, e.prototype.loadScript = function(n, a, i) {
        var s = Yd, f, p = function() {
          s.remove(F), f && (f.onerror = f.onload = f = null);
        }, C = function() {
          p(), a();
        }, k = function() {
          p(), Be(i) ? i() : typeof console < "u" && console.log && console.log("Failed to load script: " + n);
        }, F = s.uniqueId();
        f = document.createElement("script"), f.id = F, f.type = "text/javascript", f.src = Ut._addCacheSuffix(n), this.settings.referrerPolicy && s.setAttrib(f, "referrerpolicy", this.settings.referrerPolicy), f.onload = C, f.onerror = k, (document.getElementsByTagName("head")[0] || document.body).appendChild(f);
      }, e.prototype.isDone = function(n) {
        return this.states[n] === nh;
      }, e.prototype.markDone = function(n) {
        this.states[n] = nh;
      }, e.prototype.add = function(n, a, i, s) {
        var f = this.states[n];
        this.queue.push(n), f === void 0 && (this.states[n] = My), a && (this.scriptLoadedCallbacks[n] || (this.scriptLoadedCallbacks[n] = []), this.scriptLoadedCallbacks[n].push({
          success: a,
          failure: s,
          scope: i || this
        }));
      }, e.prototype.load = function(n, a, i, s) {
        return this.add(n, a, i, s);
      }, e.prototype.remove = function(n) {
        delete this.states[n], delete this.scriptLoadedCallbacks[n];
      }, e.prototype.loadQueue = function(n, a, i) {
        this.loadScripts(this.queue, n, a, i);
      }, e.prototype.loadScripts = function(n, a, i, s) {
        var f = this, p = [], C = function(F, q) {
          Z1(f.scriptLoadedCallbacks[q], function(K) {
            Be(K[F]) && K[F].call(K.scope);
          }), f.scriptLoadedCallbacks[q] = void 0;
        };
        f.queueLoadedCallbacks.push({
          success: a,
          failure: s,
          scope: i || this
        });
        var k = function() {
          var F = hg(n);
          if (n.length = 0, Z1(F, function(K) {
            if (f.states[K] === nh) {
              C("success", K);
              return;
            }
            if (f.states[K] === dS) {
              C("failure", K);
              return;
            }
            f.states[K] !== vS && (f.states[K] = vS, f.loading++, f.loadScript(K, function() {
              f.states[K] = nh, f.loading--, C("success", K), k();
            }, function() {
              f.states[K] = dS, f.loading--, p.push(K), C("failure", K), k();
            }));
          }), !f.loading) {
            var q = f.queueLoadedCallbacks.slice(0);
            f.queueLoadedCallbacks.length = 0, Z1(q, function(K) {
              p.length === 0 ? Be(K.success) && K.success.call(K.scope) : Be(K.failure) && K.failure.call(K.scope, p);
            });
          }
        };
        k();
      }, e.ScriptLoader = new e(), e;
    }(), ss = function(e) {
      var n = e, a = function() {
        return n;
      }, i = function(s) {
        n = s;
      };
      return {
        get: a,
        set: i
      };
    }, Py = function(e) {
      return ze(e) && Fr(e, "raw");
    }, Lk = function(e) {
      return ht(e) && e.length > 1;
    }, Rc = {}, sv = ss("en"), J1 = function() {
      return Mr(Rc, sv.get());
    }, zk = function() {
      return Kr(Rc, function(e) {
        return sr({}, e);
      });
    }, Hk = function(e) {
      e && sv.set(e);
    }, Zd = function() {
      return sv.get();
    }, Jd = function(e, n) {
      var a = Rc[e];
      a || (Rc[e] = a = {}), _n(n, function(i, s) {
        a[s.toLowerCase()] = i;
      });
    }, Q1 = function(e) {
      var n = J1().getOr({}), a = function(k) {
        return Be(k) ? Object.prototype.toString.call(k) : i(k) ? "" : "" + k;
      }, i = function(k) {
        return k === "" || k === null || k === void 0;
      }, s = function(k) {
        var F = a(k);
        return Mr(n, F.toLowerCase()).map(a).getOr(F);
      }, f = function(k) {
        return k.replace(/{context:\w+}$/, "");
      };
      if (i(e))
        return "";
      if (Py(e))
        return a(e.raw);
      if (Lk(e)) {
        var p = e.slice(1), C = s(e[0]).replace(/\{([0-9]+)\}/g, function(k, F) {
          return Fr(p, F) ? a(p[F]) : k;
        });
        return f(C);
      }
      return f(s(e));
    }, Ra = function() {
      return J1().bind(function(e) {
        return Mr(e, "_dir");
      }).exists(function(e) {
        return e === "rtl";
      });
    }, Ri = function(e) {
      return Fr(Rc, e);
    }, ls = {
      getData: zk,
      setCode: Hk,
      getCode: Zd,
      add: Jd,
      translate: Q1,
      isRtl: Ra,
      hasCode: Ri
    }, Ts = function() {
      var e = [], n = {}, a = {}, i = [], s = function(ke, Ee) {
        var qe = Ie(i, function(Le) {
          return Le.name === ke && Le.state === Ee;
        });
        at(qe, function(Le) {
          return Le.callback();
        });
      }, f = function(ke) {
        if (a[ke])
          return a[ke].instance;
      }, p = function(ke) {
        var Ee;
        return a[ke] && (Ee = a[ke].dependencies), Ee || [];
      }, C = function(ke, Ee) {
        Ts.languageLoad !== !1 && we(ke, function() {
          var qe = ls.getCode(), Le = "," + (Ee || "") + ",";
          !qe || Ee && Le.indexOf("," + qe + ",") === -1 || uv.ScriptLoader.add(n[ke] + "/langs/" + qe + ".js");
        }, "loaded");
      }, k = function(ke, Ee, qe) {
        var Le = Ee;
        return e.push(Le), a[ke] = {
          instance: Le,
          dependencies: qe
        }, s(ke, "added"), Le;
      }, F = function(ke) {
        delete n[ke], delete a[ke];
      }, q = function(ke, Ee) {
        return typeof Ee == "object" ? Ee : typeof ke == "string" ? {
          prefix: "",
          resource: Ee,
          suffix: ""
        } : {
          prefix: ke.prefix,
          resource: Ee,
          suffix: ke.suffix
        };
      }, K = function(ke, Ee) {
        var qe = n[ke];
        at(Ee, function(Le) {
          uv.ScriptLoader.add(qe + "/" + Le);
        });
      }, te = function(ke, Ee, qe, Le) {
        var xt = p(ke);
        at(xt, function(mt) {
          var Qe = q(Ee, mt);
          be(Qe.resource, Qe, void 0, void 0);
        }), qe && (Le ? qe.call(Le) : qe.call(uv));
      }, be = function(ke, Ee, qe, Le, xt) {
        if (!n[ke]) {
          var mt = typeof Ee == "string" ? Ee : Ee.prefix + Ee.resource + Ee.suffix;
          mt.indexOf("/") !== 0 && mt.indexOf("://") === -1 && (mt = Ts.baseURL + "/" + mt), n[ke] = mt.substring(0, mt.lastIndexOf("/"));
          var Qe = function() {
            s(ke, "loaded"), te(ke, Ee, qe, Le);
          };
          a[ke] ? Qe() : uv.ScriptLoader.add(mt, Qe, Le, xt);
        }
      }, we = function(ke, Ee, qe) {
        qe === void 0 && (qe = "added"), Fr(a, ke) && qe === "added" || Fr(n, ke) && qe === "loaded" ? Ee() : i.push({
          name: ke,
          state: qe,
          callback: Ee
        });
      };
      return {
        items: e,
        urls: n,
        lookup: a,
        _listeners: i,
        get: f,
        dependencies: p,
        requireLangPack: C,
        add: k,
        remove: F,
        createUrl: q,
        addComponents: K,
        load: be,
        waitFor: we
      };
    };
    Ts.languageLoad = !0, Ts.baseURL = "", Ts.PluginManager = Ts(), Ts.ThemeManager = Ts();
    var io = function(e) {
      var n = ss(se.none()), a = function() {
        return n.get().each(e);
      }, i = function() {
        a(), n.set(se.none());
      }, s = function() {
        return n.get().isSome();
      }, f = function() {
        return n.get();
      }, p = function(C) {
        a(), n.set(se.some(C));
      };
      return {
        clear: i,
        isSet: s,
        get: f,
        set: p
      };
    }, ed = function() {
      var e = io(xe), n = function(a) {
        return e.get().each(a);
      };
      return sr(sr({}, e), { on: n });
    }, e0 = function(e, n) {
      var a = null, i = function() {
        ie(a) || (clearTimeout(a), a = null);
      }, s = function() {
        for (var f = [], p = 0; p < arguments.length; p++)
          f[p] = arguments[p];
        ie(a) && (a = setTimeout(function() {
          a = null, e.apply(null, f);
        }, n));
      };
      return {
        cancel: i,
        throttle: s
      };
    }, Hi = function(e, n) {
      var a = null, i = function() {
        ie(a) || (clearTimeout(a), a = null);
      }, s = function() {
        for (var f = [], p = 0; p < arguments.length; p++)
          f[p] = arguments[p];
        i(), a = setTimeout(function() {
          a = null, e.apply(null, f);
        }, n);
      };
      return {
        cancel: i,
        throttle: s
      };
    }, vf = function(e, n) {
      var a = fe(e, n);
      return a === void 0 || a === "" ? [] : a.split(" ");
    }, Vk = function(e, n, a) {
      var i = vf(e, n), s = i.concat([a]);
      return M(e, n, s.join(" ")), !0;
    }, Uk = function(e, n, a) {
      var i = Ie(vf(e, n), function(s) {
        return s !== a;
      });
      return i.length > 0 ? M(e, n, i.join(" ")) : Gt(e, n), !1;
    }, t0 = function(e) {
      return e.dom.classList !== void 0;
    }, n0 = function(e) {
      return vf(e, "class");
    }, Ny = function(e, n) {
      return Vk(e, "class", n);
    }, Iy = function(e, n) {
      return Uk(e, "class", n);
    }, Qd = function(e, n) {
      t0(e) ? e.dom.classList.add(n) : Ny(e, n);
    }, rh = function(e) {
      var n = t0(e) ? e.dom.classList : n0(e);
      n.length === 0 && Gt(e, "class");
    }, Fy = function(e, n) {
      if (t0(e)) {
        var a = e.dom.classList;
        a.remove(n);
      } else
        Iy(e, n);
      rh(e);
    }, $y = function(e, n) {
      return t0(e) && e.dom.classList.contains(n);
    }, bg = function(e, n) {
      var a = [];
      return at(Hu(e), function(i) {
        n(i) && (a = a.concat([i])), a = a.concat(bg(i, n));
      }), a;
    }, du = function(e, n) {
      return jr(n, e);
    }, Xs = N("mce-annotation"), ah = N("data-mce-annotation"), Mi = N("data-mce-annotation-uid"), r0 = function(e, n) {
      var a = e.selection.getRng(), i = O.fromDom(a.startContainer), s = O.fromDom(e.getBody()), f = n.fold(function() {
        return "." + Xs();
      }, function(F) {
        return "[" + ah() + '="' + F + '"]';
      }), p = Cc(i, a.startOffset).getOr(i), C = ri(p, f, function(F) {
        return Dr(F, s);
      }), k = function(F, q) {
        return bt(F, q) ? se.some(fe(F, q)) : se.none();
      };
      return C.bind(function(F) {
        return k(F, "" + Mi()).bind(function(q) {
          return k(F, "" + ah()).map(function(K) {
            var te = Ly(e, q);
            return {
              uid: q,
              name: K,
              elements: te
            };
          });
        });
      });
    }, lv = function(e) {
      return So(e) && $y(e, Xs());
    }, Ly = function(e, n) {
      var a = O.fromDom(e.getBody());
      return du(a, "[" + Mi() + '="' + n + '"]');
    }, zy = function(e, n) {
      var a = O.fromDom(e.getBody()), i = du(a, "[" + ah() + '="' + n + '"]'), s = {};
      return at(i, function(f) {
        var p = fe(f, Mi()), C = Mr(s, p).getOr([]);
        s[p] = C.concat([f]);
      }), s;
    }, mS = function(e, n) {
      var a = ss({}), i = function() {
        return {
          listeners: [],
          previous: ed()
        };
      }, s = function(q, K) {
        f(q, function(te) {
          return K(te), te;
        });
      }, f = function(q, K) {
        var te = a.get(), be = Mr(te, q).getOrThunk(i), we = K(be);
        te[q] = we, a.set(te);
      }, p = function(q, K, te) {
        s(q, function(be) {
          at(be.listeners, function(we) {
            return we(!0, q, {
              uid: K,
              nodes: Ke(te, function(ke) {
                return ke.dom;
              })
            });
          });
        });
      }, C = function(q) {
        s(q, function(K) {
          at(K.listeners, function(te) {
            return te(!1, q);
          });
        });
      }, k = Hi(function() {
        var q = a.get(), K = Xt(mn(q));
        at(K, function(te) {
          f(te, function(be) {
            var we = be.previous.get();
            return r0(e, se.some(te)).fold(function() {
              we.isSome() && (C(te), be.previous.clear());
            }, function(ke) {
              var Ee = ke.uid, qe = ke.name, Le = ke.elements;
              Nd(we, Ee) || (p(qe, Ee, Le), be.previous.set(Ee));
            }), {
              previous: be.previous,
              listeners: be.listeners
            };
          });
        });
      }, 30);
      e.on("remove", function() {
        k.cancel();
      }), e.on("NodeChange", function() {
        k.throttle();
      });
      var F = function(q, K) {
        f(q, function(te) {
          return {
            previous: te.previous,
            listeners: te.listeners.concat([K])
          };
        });
      };
      return { addListener: F };
    }, Hy = function(e, n) {
      var a = function(i) {
        return se.from(i.attr(ah())).bind(n.lookup);
      };
      e.on("init", function() {
        e.serializer.addNodeFilter("span", function(i) {
          at(i, function(s) {
            a(s).each(function(f) {
              f.persistent === !1 && s.unwrap();
            });
          });
        });
      });
    }, oh = function() {
      var e = {}, n = function(i, s) {
        e[i] = {
          name: i,
          settings: s
        };
      }, a = function(i) {
        return Mr(e, i).map(function(s) {
          return s.settings;
        });
      };
      return {
        register: n,
        lookup: a
      };
    }, a0 = 0, gS = function(e) {
      var n = new Date(), a = n.getTime(), i = Math.floor(Math.random() * 1e9);
      return a0++, e + "_" + i + a0 + String(a);
    }, jk = function(e, n) {
      at(n, function(a) {
        Qd(e, a);
      });
    }, Nu = function(e, n) {
      var a = n || document, i = a.createElement("div");
      return i.innerHTML = e, Hu(O.fromDom(i));
    }, Vi = function(e) {
      return Ke(e, O.fromDom);
    }, cs = function(e) {
      return e.dom.innerHTML;
    }, fs = function(e, n) {
      var a = Gl(e), i = a.dom, s = O.fromDom(i.createDocumentFragment()), f = Nu(n, i);
      Wf(s, f), qf(e), _i(e, s);
    }, Es = function(e, n) {
      return O.fromDom(e.dom.cloneNode(n));
    }, wi = function(e) {
      return Es(e, !1);
    }, o0 = function(e) {
      return Es(e, !0);
    }, i0 = function(e, n, a) {
      a === void 0 && (a = Me);
      var i = new Ha(e, n), s = function(f) {
        var p;
        do
          p = i[f]();
        while (p && !Qn(p) && !a(p));
        return se.from(p).filter(Qn);
      };
      return {
        current: function() {
          return se.from(i.current()).filter(Qn);
        },
        next: function() {
          return s("next");
        },
        prev: function() {
          return s("prev");
        },
        prev2: function() {
          return s("prev2");
        }
      };
    }, Vy = function(e, n) {
      var a = n || function(p) {
        return e.isBlock(p) || to(p) || xo(p);
      }, i = function(p, C, k, F) {
        if (Qn(p)) {
          var q = F(p, C, p.data);
          if (q !== -1)
            return se.some({
              container: p,
              offset: q
            });
        }
        return k().bind(function(K) {
          return i(K.container, K.offset, k, F);
        });
      }, s = function(p, C, k, F) {
        var q = i0(p, F, a);
        return i(p, C, function() {
          return q.prev().map(function(K) {
            return {
              container: K,
              offset: K.length
            };
          });
        }, k).getOrNull();
      }, f = function(p, C, k, F) {
        var q = i0(p, F, a);
        return i(p, C, function() {
          return q.next().map(function(K) {
            return {
              container: K,
              offset: 0
            };
          });
        }, k).getOrNull();
      };
      return {
        backwards: s,
        forwards: f
      };
    }, em = Math.round, td = function(e) {
      return e ? {
        left: em(e.left),
        top: em(e.top),
        bottom: em(e.bottom),
        right: em(e.right),
        width: em(e.width),
        height: em(e.height)
      } : {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
        width: 0,
        height: 0
      };
    }, u0 = function(e, n) {
      return e = td(e), n || (e.left = e.left + e.width), e.right = e.left, e.width = 0, e;
    }, s0 = function(e, n) {
      return e.left === n.left && e.top === n.top && e.bottom === n.bottom && e.right === n.right;
    }, l0 = function(e, n, a) {
      return e >= 0 && e <= Math.min(n.height, a.height) / 2;
    }, yg = function(e, n) {
      var a = Math.min(n.height / 2, e.height / 2);
      return e.bottom - a < n.top ? !0 : e.top > n.bottom ? !1 : l0(n.top - e.bottom, e, n);
    }, wg = function(e, n) {
      return e.top > n.bottom ? !0 : e.bottom < n.top ? !1 : l0(n.bottom - e.top, e, n);
    }, pS = function(e, n, a) {
      return n >= e.left && n <= e.right && a >= e.top && a <= e.bottom;
    }, df = function(e, n, a) {
      return Math.min(Math.max(e, n), a);
    }, tm = function(e) {
      var n = e.startContainer, a = e.startOffset;
      return n.hasChildNodes() && e.endOffset === a + 1 ? n.childNodes[a] : null;
    }, Bo = function(e, n) {
      if ($r(e) && e.hasChildNodes()) {
        var a = e.childNodes, i = df(n, 0, a.length - 1);
        return a[i];
      } else
        return e;
    }, Wk = function(e, n) {
      if (!(n < 0 && $r(e) && e.hasChildNodes()))
        return Bo(e, n);
    }, qk = new RegExp("[\u0300-\u036F\u0483-\u0487\u0488-\u0489\u0591-\u05BD\u05BF\u05C1-\u05C2\u05C4-\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7-\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962-\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2-\u09E3\u0A01-\u0A02\u0A3C\u0A41-\u0A42\u0A47-\u0A48\u0A4B-\u0A4D\u0A51\u0A70-\u0A71\u0A75\u0A81-\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7-\u0AC8\u0ACD\u0AE2-\u0AE3\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B57\u0B62-\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55-\u0C56\u0C62-\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC-\u0CCD\u0CD5-\u0CD6\u0CE2-\u0CE3\u0D01\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62-\u0D63\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB-\u0EBC\u0EC8-\u0ECD\u0F18-\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86-\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039-\u103A\u103D-\u103E\u1058-\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085-\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17B4-\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193B\u1A17-\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1ABE\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80-\u1B81\u1BA2-\u1BA5\u1BA8-\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8-\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8-\u1CF9\u1DC0-\u1DF5\u1DFC-\u1DFF\u200C-\u200D\u20D0-\u20DC\u20DD-\u20E0\u20E1\u20E2-\u20E4\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u302E-\u302F\u3099-\u309A\uA66F\uA670-\uA672\uA674-\uA67D\uA69E-\uA69F\uA6F0-\uA6F1\uA802\uA806\uA80B\uA825-\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31-\uAA32\uAA35-\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7-\uAAB8\uAABE-\uAABF\uAAC1\uAAEC-\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E-\uFF9F]"), c0 = function(e) {
      return typeof e == "string" && e.charCodeAt(0) >= 768 && qk.test(e);
    }, Gk = function() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      return function(a) {
        for (var i = 0; i < e.length; i++)
          if (e[i](a))
            return !0;
        return !1;
      };
    }, hS = function() {
      for (var e = [], n = 0; n < arguments.length; n++)
        e[n] = arguments[n];
      return function(a) {
        for (var i = 0; i < e.length; i++)
          if (!e[i](a))
            return !1;
        return !0;
      };
    }, Fn = $r, Kk = af, Pi = rs("display", "block table"), Uy = rs("float", "left right"), nm = hS(Fn, Kk, Ce(Uy)), bS = Ce(rs("white-space", "pre pre-line pre-wrap")), ju = Qn, ih = to, f0 = ho.nodeIndex, uh = Wk, Mc = function(e) {
      return "createRange" in e ? e.createRange() : ho.DOM.createRng();
    }, sh = function(e) {
      return e && /[\r\n\t ]/.test(e);
    }, lh = function(e) {
      return !!e.setStart && !!e.setEnd;
    }, vs = function(e) {
      var n = e.startContainer, a = e.startOffset;
      if (sh(e.toString()) && bS(n.parentNode) && Qn(n)) {
        var i = n.data;
        if (sh(i[a - 1]) || sh(i[a + 1]))
          return !0;
      }
      return !1;
    }, Pc = function(e) {
      var n = e.ownerDocument, a = Mc(n), i = n.createTextNode(Ws), s = e.parentNode;
      s.insertBefore(i, e), a.setStart(i, 0), a.setEnd(i, 1);
      var f = td(a.getBoundingClientRect());
      return s.removeChild(i), f;
    }, yS = function(e) {
      var n = e.startContainer, a = e.endContainer, i = e.startOffset, s = e.endOffset;
      if (n === a && Qn(a) && i === 0 && s === 1) {
        var f = e.cloneRange();
        return f.setEndAfter(a), mf(f);
      } else
        return null;
    }, Wu = function(e) {
      return e.left === 0 && e.right === 0 && e.top === 0 && e.bottom === 0;
    }, mf = function(e) {
      var n, a = e.getClientRects();
      return a.length > 0 ? n = td(a[0]) : n = td(e.getBoundingClientRect()), !lh(e) && ih(e) && Wu(n) ? Pc(e) : Wu(n) && lh(e) ? yS(e) : n;
    }, nd = function(e, n) {
      var a = u0(e, n);
      return a.width = 1, a.right = a.left + 1, a;
    }, ch = function(e) {
      var n = [], a = function(k) {
        k.height !== 0 && (n.length > 0 && s0(k, n[n.length - 1]) || n.push(k));
      }, i = function(k, F) {
        var q = Mc(k.ownerDocument);
        if (F < k.data.length) {
          if (c0(k.data[F]))
            return n;
          if (c0(k.data[F - 1]) && (q.setStart(k, F), q.setEnd(k, F + 1), !vs(q)))
            return a(nd(mf(q), !1)), n;
        }
        F > 0 && (q.setStart(k, F - 1), q.setEnd(k, F), vs(q) || a(nd(mf(q), !1))), F < k.data.length && (q.setStart(k, F), q.setEnd(k, F + 1), vs(q) || a(nd(mf(q), !0)));
      }, s = e.container(), f = e.offset();
      if (ju(s))
        return i(s, f), n;
      if (Fn(s))
        if (e.isAtEnd()) {
          var p = uh(s, f);
          ju(p) && i(p, p.data.length), nm(p) && !ih(p) && a(nd(mf(p), !1));
        } else {
          var p = uh(s, f);
          if (ju(p) && i(p, 0), nm(p) && e.isAtEnd())
            return a(nd(mf(p), !1)), n;
          var C = uh(e.container(), e.offset() - 1);
          nm(C) && !ih(C) && (Pi(C) || Pi(p) || !nm(p)) && a(nd(mf(C), !1)), nm(p) && a(nd(mf(p), !0));
        }
      return n;
    }, zt = function(e, n, a) {
      var i = function() {
        return ju(e), n === 0;
      }, s = function() {
        return ju(e) ? n >= e.data.length : n >= e.childNodes.length;
      }, f = function() {
        var q = Mc(e.ownerDocument);
        return q.setStart(e, n), q.setEnd(e, n), q;
      }, p = function() {
        return a || (a = ch(zt(e, n))), a;
      }, C = function() {
        return p().length > 0;
      }, k = function(q) {
        return q && e === q.container() && n === q.offset();
      }, F = function(q) {
        return uh(e, q ? n - 1 : n);
      };
      return {
        container: N(e),
        offset: N(n),
        toRange: f,
        getClientRects: p,
        isVisible: C,
        isAtStart: i,
        isAtEnd: s,
        isEqual: k,
        getNode: F
      };
    };
    zt.fromRangeStart = function(e) {
      return zt(e.startContainer, e.startOffset);
    }, zt.fromRangeEnd = function(e) {
      return zt(e.endContainer, e.endOffset);
    }, zt.after = function(e) {
      return zt(e.parentNode, f0(e) + 1);
    }, zt.before = function(e) {
      return zt(e.parentNode, f0(e));
    }, zt.isAbove = function(e, n) {
      return Vu(Vn(n.getClientRects()), Un(e.getClientRects()), yg).getOr(!1);
    }, zt.isBelow = function(e, n) {
      return Vu(Un(n.getClientRects()), Vn(e.getClientRects()), wg).getOr(!1);
    }, zt.isAtStart = function(e) {
      return e ? e.isAtStart() : !1;
    }, zt.isAtEnd = function(e) {
      return e ? e.isAtEnd() : !1;
    }, zt.isTextPosition = function(e) {
      return e ? Qn(e.container()) : !1;
    }, zt.isElementPosition = function(e) {
      return zt.isTextPosition(e) === !1;
    };
    var cv = function(e, n) {
      Qn(n) && n.data.length === 0 && e.remove(n);
    }, Cg = function(e, n, a) {
      n.insertNode(a), cv(e, a.previousSibling), cv(e, a.nextSibling);
    }, Xk = function(e, n, a) {
      var i = se.from(a.firstChild), s = se.from(a.lastChild);
      n.insertNode(a), i.each(function(f) {
        return cv(e, f.previousSibling);
      }), s.each(function(f) {
        return cv(e, f.nextSibling);
      });
    }, v0 = function(e, n, a) {
      ea(a) ? Xk(e, n, a) : Cg(e, n, a);
    }, rc = Qn, d0 = ni, jy = ho.nodeIndex, Wy = function(e) {
      var n = e.parentNode;
      return d0(n) ? Wy(n) : n;
    }, m0 = function(e) {
      return e ? gi(e.childNodes, function(n, a) {
        return d0(a) && a.nodeName !== "BR" ? n = n.concat(m0(a)) : n.push(a), n;
      }, []) : [];
    }, qy = function(e, n) {
      for (; (e = e.previousSibling) && rc(e); )
        n += e.data.length;
      return n;
    }, Gy = function(e) {
      return function(n) {
        return e === n;
      };
    }, Ky = function(e) {
      var n, a;
      n = m0(Wy(e)), a = na(n, Gy(e), e), n = n.slice(0, a + 1);
      var i = gi(n, function(s, f, p) {
        return rc(f) && rc(n[p - 1]) && s++, s;
      }, 0);
      return n = Ao(n, ul([e.nodeName])), a = na(n, Gy(e), e), a - i;
    }, Xy = function(e) {
      var n;
      return rc(e) ? n = "text()" : n = e.nodeName.toLowerCase(), n + "[" + Ky(e) + "]";
    }, rm = function(e, n, a) {
      var i = [];
      for (n = n.parentNode; n !== e && !(a && a(n)); n = n.parentNode)
        i.push(n);
      return i;
    }, wS = function(e, n) {
      var a, i, s = [], f, p, C;
      return a = n.container(), i = n.offset(), rc(a) ? f = qy(a, i) : (p = a.childNodes, i >= p.length ? (f = "after", i = p.length - 1) : f = "before", a = p[i]), s.push(Xy(a)), C = rm(e, a), C = Ao(C, Ce(ni)), s = s.concat(mi(C, function(k) {
        return Xy(k);
      })), s.reverse().join("/") + "," + f;
    }, Yk = function(e, n, a) {
      var i = m0(e);
      return i = Ao(i, function(s, f) {
        return !rc(s) || !rc(i[f - 1]);
      }), i = Ao(i, ul([n])), i[a];
    }, Zk = function(e, n) {
      for (var a = e, i = 0, s; rc(a); ) {
        if (s = a.data.length, n >= i && n <= i + s) {
          e = a, n = n - i;
          break;
        }
        if (!rc(a.nextSibling)) {
          e = a, n = s;
          break;
        }
        i += s, a = a.nextSibling;
      }
      return rc(e) && n > e.data.length && (n = e.data.length), zt(e, n);
    }, Sg = function(e, n) {
      var a;
      if (!n)
        return null;
      var i = n.split(","), s = i[0].split("/");
      a = i.length > 1 ? i[1] : "before";
      var f = gi(s, function(p, C) {
        var k = /([\w\-\(\)]+)\[([0-9]+)\]/.exec(C);
        return k ? (k[1] === "text()" && (k[1] = "#text"), Yk(p, k[1], parseInt(k[2], 10))) : null;
      }, e);
      return f ? rc(f) ? Zk(f, parseInt(a, 10)) : (a === "after" ? a = jy(f) + 1 : a = jy(f), zt(f.parentNode, a)) : null;
    }, xg = xo, g0 = function(e, n, a) {
      var i, s;
      for (s = e(n.data.slice(0, a)).length, i = n.previousSibling; i && Qn(i); i = i.previousSibling)
        s += e(i.data).length;
      return s;
    }, Yy = function(e, n, a, i, s) {
      var f = i[s ? "startContainer" : "endContainer"], p = i[s ? "startOffset" : "endOffset"], C = [], k, F = 0, q = e.getRoot();
      for (Qn(f) ? C.push(a ? g0(n, f, p) : p) : (k = f.childNodes, p >= k.length && k.length && (F = 1, p = Math.max(0, k.length - 1)), C.push(e.nodeIndex(k[p], a) + F)); f && f !== q; f = f.parentNode)
        C.push(e.nodeIndex(f, a));
      return C;
    }, kg = function(e, n, a, i) {
      var s = n.dom, f = {};
      return f.start = Yy(s, e, a, i, !0), n.isCollapsed() || (f.end = Yy(s, e, a, i, !1)), rf(i) && (f.isFakeCaret = !0), f;
    }, Zy = function(e, n, a) {
      var i = 0;
      return Ut.each(e.select(n), function(s) {
        if (s.getAttribute("data-mce-bogus") !== "all") {
          if (s === a)
            return !1;
          i++;
        }
      }), i;
    }, Zo = function(e, n) {
      var a, i, s, f = n ? "start" : "end";
      a = e[f + "Container"], i = e[f + "Offset"], $r(a) && a.nodeName === "TR" && (s = a.childNodes, a = s[Math.min(n ? i : i - 1, s.length - 1)], a && (i = n ? 0 : a.childNodes.length, e["set" + (n ? "Start" : "End")](a, i)));
    }, fh = function(e) {
      return Zo(e, !0), Zo(e, !1), e;
    }, ai = function(e, n) {
      var a;
      if ($r(e) && (e = Bo(e, n), xg(e)))
        return e;
      if (ks(e) && (Qn(e) && no(e) && (e = e.parentNode), a = e.previousSibling, xg(a) || (a = e.nextSibling, xg(a))))
        return a;
    }, p0 = function(e) {
      return ai(e.startContainer, e.startOffset) || ai(e.endContainer, e.endOffset);
    }, am = function(e, n, a) {
      var i = a.getNode(), s = i ? i.nodeName : null, f = a.getRng();
      if (xg(i) || s === "IMG")
        return {
          name: s,
          index: Zy(a.dom, s, i)
        };
      var p = p0(f);
      return p ? (s = p.tagName, {
        name: s,
        index: Zy(a.dom, s, p)
      }) : kg(e, a, n, f);
    }, Jy = function(e) {
      var n = e.getRng();
      return {
        start: wS(e.dom.getRoot(), zt.fromRangeStart(n)),
        end: wS(e.dom.getRoot(), zt.fromRangeEnd(n))
      };
    }, vh = function(e) {
      return { rng: e.getRng() };
    }, Qy = function(e, n, a) {
      var i = {
        "data-mce-type": "bookmark",
        id: n,
        style: "overflow:hidden;line-height:0px"
      };
      return a ? e.create("span", i, "&#xFEFF;") : e.create("span", i);
    }, CS = function(e, n) {
      var a = e.dom, i = e.getRng(), s = a.uniqueId(), f = e.isCollapsed(), p = e.getNode(), C = p.nodeName;
      if (C === "IMG")
        return {
          name: C,
          index: Zy(a, C, p)
        };
      var k = fh(i.cloneRange());
      if (!f) {
        k.collapse(!1);
        var F = Qy(a, s + "_end", n);
        v0(a, k, F);
      }
      i = fh(i), i.collapse(!0);
      var q = Qy(a, s + "_start", n);
      return v0(a, i, q), e.moveToBookmark({
        id: s,
        keep: !0
      }), { id: s };
    }, Jk = function(e, n, a) {
      return n === 2 ? am(Ac, a, e) : n === 3 ? Jy(e) : n ? vh(e) : CS(e, !1);
    }, SS = ne(am, ae, !0), Qk = ho.DOM, h0 = "font-family font-size font-weight font-style text-decoration text-transform color background-color border border-radius outline text-shadow", dh = function(e, n, a) {
      var i = e.getParam(n, a);
      if (i.indexOf("=") !== -1) {
        var s = e.getParam(n, "", "hash");
        return Mr(s, e.id).getOr(a);
      } else
        return i;
    }, eT = function(e) {
      return e.getParam("iframe_attrs", {});
    }, xS = function(e) {
      return e.getParam("doctype", "<!DOCTYPE html>");
    }, e2 = function(e) {
      return e.getParam("document_base_url", "");
    }, tT = function(e) {
      return dh(e, "body_id", "tinymce");
    }, nT = function(e) {
      return dh(e, "body_class", "");
    }, b0 = function(e) {
      return e.getParam("content_security_policy", "");
    }, t2 = function(e) {
      return e.getParam("br_in_pre", !0);
    }, mu = function(e) {
      if (e.getParam("force_p_newlines", !1))
        return "p";
      var n = e.getParam("forced_root_block", "p");
      return n === !1 ? "" : n === !0 ? "p" : n;
    }, Tg = function(e) {
      return e.getParam("forced_root_block_attrs", {});
    }, Eg = function(e) {
      return e.getParam("br_newline_selector", ".mce-toc h2,figcaption,caption");
    }, kS = function(e) {
      return e.getParam("no_newline_selector", "");
    }, rT = function(e) {
      return e.getParam("keep_styles", !0);
    }, mh = function(e) {
      return e.getParam("end_container_on_empty_block", !1);
    }, gh = function(e) {
      return Ut.explode(e.getParam("font_size_style_values", "xx-small,x-small,small,medium,large,x-large,xx-large"));
    }, om = function(e) {
      return Ut.explode(e.getParam("font_size_classes", ""));
    }, y0 = function(e) {
      return e.getParam("images_dataimg_filter", Je, "function");
    }, ph = function(e) {
      return e.getParam("automatic_uploads", !0, "boolean");
    }, n2 = function(e) {
      return e.getParam("images_reuse_filename", !1, "boolean");
    }, aT = function(e) {
      return e.getParam("images_replace_blob_uris", !0, "boolean");
    }, gf = function(e) {
      return e.getParam("icons", "", "string");
    }, w0 = function(e) {
      return e.getParam("icons_url", "", "string");
    }, oT = function(e) {
      return e.getParam("images_upload_url", "", "string");
    }, rd = function(e) {
      return e.getParam("images_upload_base_path", "", "string");
    }, ad = function(e) {
      return e.getParam("images_upload_credentials", !1, "boolean");
    }, iT = function(e) {
      return e.getParam("images_upload_handler", null, "function");
    }, C0 = function(e) {
      return e.getParam("content_css_cors", !1, "boolean");
    }, S0 = function(e) {
      return e.getParam("referrer_policy", "", "string");
    }, x0 = function(e) {
      return e.getParam("language", "en", "string");
    }, Yi = function(e) {
      return e.getParam("language_url", "", "string");
    }, TS = function(e) {
      return e.getParam("indent_use_margin", !1);
    }, r2 = function(e) {
      return e.getParam("indentation", "40px", "string");
    }, ES = function(e) {
      var n = e.getParam("content_css");
      return Ge(n) ? Ke(n.split(","), Ve) : ht(n) ? n : n === !1 || e.inline ? [] : ["default"];
    }, _S = function(e) {
      var n = e.getParam("font_css", []);
      return ht(n) ? n : Ke(n.split(","), Ve);
    }, Nc = function(e) {
      return e.getParam("directionality", ls.isRtl() ? "rtl" : void 0);
    }, fv = function(e) {
      return e.getParam("inline_boundaries_selector", "a[href],code,.mce-annotation", "string");
    }, AS = function(e) {
      var n = e.getParam("object_resizing");
      return n === !1 || br.iOS ? !1 : Ge(n) ? n : "table,img,figure.image,div,video,iframe";
    }, OS = function(e) {
      return e.getParam("resize_img_proportional", !0, "boolean");
    }, a2 = function(e) {
      return e.getParam("placeholder", Qk.getAttrib(e.getElement(), "placeholder"), "string");
    }, k0 = function(e) {
      return e.getParam("event_root");
    }, DS = function(e) {
      return e.getParam("service_message");
    }, _g = function(e) {
      return e.getParam("theme");
    }, uT = function(e) {
      return e.getParam("validate");
    }, hh = function(e) {
      return e.getParam("inline_boundaries") !== !1;
    }, sT = function(e) {
      return e.getParam("formats");
    }, Ag = function(e) {
      var n = e.getParam("preview_styles", h0);
      return Ge(n) ? n : "";
    }, im = function(e) {
      return e.getParam("format_empty_lines", !1, "boolean");
    }, o2 = function(e) {
      return e.getParam("custom_ui_selector", "", "string");
    }, BS = function(e) {
      return e.getParam("theme_url");
    }, lT = function(e) {
      return e.getParam("inline");
    }, RS = function(e) {
      return e.getParam("hidden_input");
    }, MS = function(e) {
      return e.getParam("submit_patch");
    }, i2 = function(e) {
      return e.getParam("encoding") === "xml";
    }, cT = function(e) {
      return e.getParam("add_form_submit_trigger");
    }, T0 = function(e) {
      return e.getParam("add_unload_trigger");
    }, fT = function(e) {
      return mu(e) !== "";
    }, bh = function(e) {
      return e.getParam("custom_undo_redo_levels", 0, "number");
    }, vT = function(e) {
      return e.getParam("disable_nodechange");
    }, dT = function(e) {
      return e.getParam("readonly");
    }, mT = function(e) {
      return e.getParam("content_css_cors");
    }, E0 = function(e) {
      return e.getParam("plugins", "", "string");
    }, gT = function(e) {
      return e.getParam("external_plugins");
    }, Og = function(e) {
      return e.getParam("block_unsupported_drop", !0, "boolean");
    }, PS = function(e) {
      return e.getParam("visual", !0, "boolean");
    }, pT = function(e) {
      return e.getParam("visual_table_class", "mce-item-table", "string");
    }, u2 = function(e) {
      return e.getParam("visual_anchor_class", "mce-item-anchor", "string");
    }, NS = function(e) {
      return e.getParam("iframe_aria_text", "Rich Text Area. Press ALT-0 for help.", "string");
    }, s2 = $r, IS = Qn, FS = function(e) {
      var n = e.parentNode;
      n && n.removeChild(e);
    }, Dg = function(e) {
      var n = Ac(e);
      return {
        count: e.length - n.length,
        text: n
      };
    }, l2 = function(e) {
      for (var n; (n = e.data.lastIndexOf(ct)) !== -1; )
        e.deleteData(n, 1);
    }, c2 = function(e, n) {
      return od(e), n;
    }, hT = function(e, n) {
      var a = Dg(e.data.substr(0, n.offset())), i = Dg(e.data.substr(n.offset())), s = a.text + i.text;
      return s.length > 0 ? (l2(e), zt(e, n.offset() - a.count)) : n;
    }, bT = function(e, n) {
      var a = n.container(), i = He(Tn(a.childNodes), e).map(function(s) {
        return s < n.offset() ? zt(a, n.offset() - 1) : n;
      }).getOr(n);
      return od(e), i;
    }, f2 = function(e, n) {
      return IS(e) && n.container() === e ? hT(e, n) : c2(e, n);
    }, yT = function(e, n) {
      return n.container() === e.parentNode ? bT(e, n) : c2(e, n);
    }, $S = function(e, n) {
      return zt.isTextPosition(n) ? f2(e, n) : yT(e, n);
    }, od = function(e) {
      s2(e) && ks(e) && (tv(e) ? e.removeAttribute("data-mce-caret") : FS(e)), IS(e) && (l2(e), e.data.length === 0 && FS(e));
    }, Bg = lr().browser, LS = xo, wT = Cs, zS = Km, CT = "*[contentEditable=false],video,audio,embed,object", v2 = function(e, n, a) {
      var i = u0(n.getBoundingClientRect(), a), s, f;
      if (e.tagName === "BODY") {
        var p = e.ownerDocument.documentElement;
        s = e.scrollLeft || p.scrollLeft, f = e.scrollTop || p.scrollTop;
      } else {
        var C = e.getBoundingClientRect();
        s = e.scrollLeft - C.left, f = e.scrollTop - C.top;
      }
      i.left += s, i.right += s, i.top += f, i.bottom += f, i.width = 1;
      var k = n.offsetWidth - n.clientWidth;
      return k > 0 && (a && (k *= -1), i.left += k, i.right += k), i;
    }, Rg = function(e) {
      for (var n = du(O.fromDom(e), CT), a = 0; a < n.length; a++) {
        var i = n[a].dom, s = i.previousSibling;
        if (Gp(s)) {
          var f = s.data;
          f.length === 1 ? s.parentNode.removeChild(s) : s.deleteData(f.length - 1, 1);
        }
        if (s = i.nextSibling, qp(s)) {
          var f = s.data;
          f.length === 1 ? s.parentNode.removeChild(s) : s.deleteData(0, 1);
        }
      }
    }, qu = function(e, n, a, i) {
      var s = ed(), f, p, C = mu(e), k = C.length > 0 ? C : "p", F = function(ke, Ee) {
        var qe;
        if (q(), zS(Ee))
          return null;
        if (a(Ee)) {
          p = GC(k, Ee, ke);
          var Le = v2(n, Ee, ke);
          ta(p).css("top", Le.top);
          var xt = ta('<div class="mce-visual-caret" data-mce-bogus="all"></div>').css(sr({}, Le)).appendTo(n)[0];
          s.set({
            caret: xt,
            element: Ee,
            before: ke
          }), ke && ta(xt).addClass("mce-visual-caret-before"), K(), qe = Ee.ownerDocument.createRange(), qe.setStart(p, 0), qe.setEnd(p, 0);
        } else
          return p = iy(Ee, ke), qe = Ee.ownerDocument.createRange(), Mg(p.nextSibling) ? (qe.setStart(p, 0), qe.setEnd(p, 0)) : (qe.setStart(p, 1), qe.setEnd(p, 1)), qe;
        return qe;
      }, q = function() {
        Rg(n), p && (od(p), p = null), s.on(function(ke) {
          ta(ke.caret).remove(), s.clear();
        }), f && (Bu.clearInterval(f), f = void 0);
      }, K = function() {
        f = Bu.setInterval(function() {
          i() ? ta("div.mce-visual-caret", n).toggleClass("mce-visual-caret-hidden") : ta("div.mce-visual-caret", n).addClass("mce-visual-caret-hidden");
        }, 500);
      }, te = function() {
        s.on(function(ke) {
          var Ee = v2(n, ke.element, ke.before);
          ta(ke.caret).css(sr({}, Ee));
        });
      }, be = function() {
        return Bu.clearInterval(f);
      }, we = function() {
        return ".mce-visual-caret {position: absolute;background-color: black;background-color: currentcolor;}.mce-visual-caret-hidden {display: none;}*[data-mce-caret] {position: absolute;left: -1000px;right: auto;top: 0;margin: 0;padding: 0;}";
      };
      return {
        show: F,
        hide: q,
        getCss: we,
        reposition: te,
        destroy: be
      };
    }, d2 = function() {
      return Bg.isIE() || Bg.isEdge() || Bg.isFirefox();
    }, Mg = function(e) {
      return LS(e) || wT(e);
    }, um = function(e) {
      return Mg(e) || si(e) && d2();
    }, _0 = xo, ST = Cs, HS = rs("display", "block table table-cell table-caption list-item"), m2 = ks, _s = no, yh = $r, xT = af, sm = function(e) {
      return e > 0;
    }, id = function(e) {
      return e < 0;
    }, Pg = function(e, n) {
      for (var a; a = e(n); )
        if (!_s(a))
          return a;
      return null;
    }, ud = function(e, n, a, i, s) {
      var f = new Ha(e, i), p = _0(e) || _s(e);
      if (id(n)) {
        if (p && (e = Pg(f.prev.bind(f), !0), a(e)))
          return e;
        for (; e = Pg(f.prev.bind(f), s); )
          if (a(e))
            return e;
      }
      if (sm(n)) {
        if (p && (e = Pg(f.next.bind(f), !0), a(e)))
          return e;
        for (; e = Pg(f.next.bind(f), s); )
          if (a(e))
            return e;
      }
      return null;
    }, Ic = function(e, n) {
      for (; e && e !== n; ) {
        if (HS(e))
          return e;
        e = e.parentNode;
      }
      return null;
    }, Fc = function(e, n, a) {
      return Ic(e.container(), a) === Ic(n.container(), a);
    }, A0 = function(e, n) {
      if (!n)
        return null;
      var a = n.container(), i = n.offset();
      return yh(a) ? a.childNodes[i + e] : null;
    }, O0 = function(e, n) {
      var a = n.ownerDocument.createRange();
      return e ? (a.setStartBefore(n), a.setEndBefore(n)) : (a.setStartAfter(n), a.setEndAfter(n)), a;
    }, g2 = function(e, n, a) {
      return Ic(n, e) === Ic(a, e);
    }, Ng = function(e, n, a) {
      for (var i = e ? "previousSibling" : "nextSibling"; a && a !== n; ) {
        var s = a[i];
        if (m2(s) && (s = s[i]), _0(s) || ST(s)) {
          if (g2(n, s, a))
            return s;
          break;
        }
        if (xT(s))
          break;
        a = a.parentNode;
      }
      return null;
    }, Ig = ne(O0, !0), Fg = ne(O0, !1), Iu = function(e, n, a) {
      var i, s = ne(Ng, !0, n), f = ne(Ng, !1, n), p = a.startContainer, C = a.startOffset;
      if (no(p)) {
        yh(p) || (p = p.parentNode);
        var k = p.getAttribute("data-mce-caret");
        if (k === "before" && (i = p.nextSibling, um(i)))
          return Ig(i);
        if (k === "after" && (i = p.previousSibling, um(i)))
          return Fg(i);
      }
      if (!a.collapsed)
        return a;
      if (Qn(p)) {
        if (m2(p)) {
          if (e === 1) {
            if (i = f(p), i)
              return Ig(i);
            if (i = s(p), i)
              return Fg(i);
          }
          if (e === -1) {
            if (i = s(p), i)
              return Fg(i);
            if (i = f(p), i)
              return Ig(i);
          }
          return a;
        }
        if (Gp(p) && C >= p.data.length - 1)
          return e === 1 && (i = f(p), i) ? Ig(i) : a;
        if (qp(p) && C <= 1)
          return e === -1 && (i = s(p), i) ? Fg(i) : a;
        if (C === p.data.length)
          return i = f(p), i ? Ig(i) : a;
        if (C === 0)
          return i = s(p), i ? Fg(i) : a;
      }
      return a;
    }, $g = function(e, n) {
      return se.from(A0(e ? 0 : -1, n)).filter(_0);
    }, Lg = function(e, n, a) {
      var i = Iu(e, n, a);
      return e === -1 ? zt.fromRangeStart(i) : zt.fromRangeEnd(i);
    }, D0 = function(e) {
      return se.from(e.getNode()).map(O.fromDom);
    }, kT = function(e) {
      return se.from(e.getNode(!0)).map(O.fromDom);
    }, p2 = function(e, n) {
      for (; n = e(n); )
        if (n.isVisible())
          return n;
      return n;
    }, B0 = function(e, n) {
      var a = Fc(e, n);
      return !a && to(e.getNode()) ? !0 : a;
    }, gu;
    (function(e) {
      e[e.Backwards = -1] = "Backwards", e[e.Forwards = 1] = "Forwards";
    })(gu || (gu = {}));
    var TT = xo, pf = Qn, R0 = $r, h2 = to, zg = af, b2 = Ek, wh = bi, ET = function(e, n) {
      for (var a = []; e && e !== n; )
        a.push(e), e = e.parentNode;
      return a;
    }, VS = function(e, n) {
      return e.hasChildNodes() && n < e.childNodes.length ? e.childNodes[n] : null;
    }, US = function(e, n) {
      if (sm(e)) {
        if (zg(n.previousSibling) && !pf(n.previousSibling))
          return zt.before(n);
        if (pf(n))
          return zt(n, 0);
      }
      if (id(e)) {
        if (zg(n.nextSibling) && !pf(n.nextSibling))
          return zt.after(n);
        if (pf(n))
          return zt(n, n.data.length);
      }
      return id(e) ? h2(n) ? zt.before(n) : zt.after(n) : zt.before(n);
    }, _T = function(e, n) {
      var a = n.nextSibling;
      return a && zg(a) ? pf(a) ? zt(a, 0) : zt.before(a) : Hg(gu.Forwards, zt.after(n), e);
    }, Hg = function(e, n, a) {
      var i, s, f, p;
      if (!R0(a) || !n)
        return null;
      if (n.isEqual(zt.after(a)) && a.lastChild) {
        if (p = zt.after(a.lastChild), id(e) && zg(a.lastChild) && R0(a.lastChild))
          return h2(a.lastChild) ? zt.before(a.lastChild) : p;
      } else
        p = n;
      var C = p.container(), k = p.offset();
      if (pf(C)) {
        if (id(e) && k > 0)
          return zt(C, --k);
        if (sm(e) && k < C.length)
          return zt(C, ++k);
        i = C;
      } else {
        if (id(e) && k > 0 && (s = VS(C, k - 1), zg(s)))
          return !b2(s) && (f = ud(s, e, wh, s), f) ? pf(f) ? zt(f, f.data.length) : zt.after(f) : pf(s) ? zt(s, s.data.length) : zt.before(s);
        if (sm(e) && k < C.childNodes.length && (s = VS(C, k), zg(s)))
          return h2(s) ? _T(a, s) : !b2(s) && (f = ud(s, e, wh, s), f) ? pf(f) ? zt(f, 0) : zt.before(f) : pf(s) ? zt(s, 0) : zt.after(s);
        i = s || p.getNode();
      }
      if ((sm(e) && p.isAtEnd() || id(e) && p.isAtStart()) && (i = ud(i, e, Je, a, !0), wh(i, a)))
        return US(e, i);
      s = ud(i, e, wh, a);
      var F = ei(Ie(ET(C, a), TT));
      return F && (!s || !F.contains(s)) ? (sm(e) ? p = zt.after(F) : p = zt.before(F), p) : s ? US(e, s) : null;
    }, Jo = function(e) {
      return {
        next: function(n) {
          return Hg(gu.Forwards, n, e);
        },
        prev: function(n) {
          return Hg(gu.Backwards, n, e);
        }
      };
    }, M0 = function(e, n, a) {
      var i = e ? zt.before(a) : zt.after(a);
      return As(e, n, i);
    }, P0 = function(e) {
      return to(e) ? zt.before(e) : zt.after(e);
    }, y2 = function(e) {
      return zt.isTextPosition(e) ? e.offset() === 0 : af(e.getNode());
    }, jS = function(e) {
      if (zt.isTextPosition(e)) {
        var n = e.container();
        return e.offset() === n.data.length;
      } else
        return af(e.getNode(!0));
    }, w2 = function(e, n) {
      return !zt.isTextPosition(e) && !zt.isTextPosition(n) && e.getNode() === n.getNode(!0);
    }, lm = function(e) {
      return !zt.isTextPosition(e) && to(e.getNode());
    }, N0 = function(e, n, a) {
      return e ? !w2(n, a) && !lm(n) && jS(n) && y2(a) : !w2(a, n) && y2(n) && jS(a);
    }, As = function(e, n, a) {
      var i = Jo(n);
      return se.from(e ? i.next(a) : i.prev(a));
    }, $c = function(e, n, a) {
      return As(e, n, a).bind(function(i) {
        return Fc(a, i, n) && N0(e, a, i) ? As(e, n, i) : se.some(i);
      });
    }, I0 = function(e, n, a, i) {
      return $c(e, n, a).bind(function(s) {
        return i(s) ? I0(e, n, s, i) : se.some(s);
      });
    }, vv = function(e, n) {
      var a = e ? n.firstChild : n.lastChild;
      return Qn(a) ? se.some(zt(a, e ? 0 : a.data.length)) : a ? af(a) ? se.some(e ? zt.before(a) : P0(a)) : M0(e, n, a) : se.none();
    }, ac = ne(As, !0), Lc = ne(As, !1), Gu = ne(vv, !0), Ml = ne(vv, !1), Vg = "_mce_caret", hf = function(e) {
      return $r(e) && e.id === Vg;
    }, cm = function(e, n) {
      for (; n && n !== e; ) {
        if (n.id === Vg)
          return n;
        n = n.parentNode;
      }
      return null;
    }, WS = function(e) {
      return Ge(e.start);
    }, qS = function(e) {
      return Fr(e, "rng");
    }, AT = function(e) {
      return Fr(e, "id");
    }, OT = function(e) {
      return Fr(e, "name");
    }, GS = function(e) {
      return Ut.isArray(e.start);
    }, KS = function(e, n) {
      return $r(n) && e.isBlock(n) && !n.innerHTML && !br.ie && (n.innerHTML = '<br data-mce-bogus="1" />'), n;
    }, XS = function(e, n) {
      var a, i = e.createRng();
      return a = Sg(e.getRoot(), n.start), i.setStart(a.container(), a.offset()), a = Sg(e.getRoot(), n.end), i.setEnd(a.container(), a.offset()), i;
    }, DT = function(e, n) {
      var a = e.ownerDocument.createTextNode(ct);
      e.appendChild(a), n.setStart(a, 0), n.setEnd(a, 0);
    }, YS = function(e) {
      return e.hasChildNodes() === !1;
    }, BT = function(e, n) {
      return Ml(e).fold(Me, function(a) {
        return n.setStart(a.container(), a.offset()), n.setEnd(a.container(), a.offset()), !0;
      });
    }, ZS = function(e, n, a) {
      return YS(n) && cm(e, n) ? (DT(n, a), !0) : !1;
    }, JS = function(e, n, a, i) {
      var s = a[n ? "start" : "end"], f, p, C, k, F = e.getRoot();
      if (s) {
        for (C = s[0], p = F, f = s.length - 1; f >= 1; f--) {
          if (k = p.childNodes, ZS(F, p, i))
            return !0;
          if (s[f] > k.length - 1)
            return ZS(F, p, i) ? !0 : BT(p, i);
          p = k[s[f]];
        }
        p.nodeType === 3 && (C = Math.min(s[0], p.nodeValue.length)), p.nodeType === 1 && (C = Math.min(s[0], p.childNodes.length)), n ? i.setStart(p, C) : i.setEnd(p, C);
      }
      return !0;
    }, C2 = function(e) {
      return Qn(e) && e.data.length > 0;
    }, QS = function(e, n, a) {
      var i = e.get(a.id + "_" + n), s, f, p, C, k = a.keep, F, q;
      if (i) {
        if (s = i.parentNode, n === "start" ? (k ? i.hasChildNodes() ? (s = i.firstChild, f = 1) : C2(i.nextSibling) ? (s = i.nextSibling, f = 0) : C2(i.previousSibling) ? (s = i.previousSibling, f = i.previousSibling.data.length) : (s = i.parentNode, f = e.nodeIndex(i) + 1) : f = e.nodeIndex(i), F = s, q = f) : (k ? i.hasChildNodes() ? (s = i.firstChild, f = 1) : C2(i.previousSibling) ? (s = i.previousSibling, f = i.previousSibling.data.length) : (s = i.parentNode, f = e.nodeIndex(i)) : f = e.nodeIndex(i), F = s, q = f), !k) {
          for (C = i.previousSibling, p = i.nextSibling, Ut.each(Ut.grep(i.childNodes), function(K) {
            Qn(K) && (K.nodeValue = K.nodeValue.replace(/\uFEFF/g, ""));
          }); i = e.get(a.id + "_" + n); )
            e.remove(i, !0);
          C && p && C.nodeType === p.nodeType && Qn(C) && !br.opera && (f = C.nodeValue.length, C.appendData(p.nodeValue), e.remove(p), F = C, q = f);
        }
        return se.some(zt(F, q));
      } else
        return se.none();
    }, RT = function(e, n) {
      var a = e.createRng();
      return JS(e, !0, n, a) && JS(e, !1, n, a) ? se.some(a) : se.none();
    }, ga = function(e, n) {
      var a = QS(e, "start", n), i = QS(e, "end", n);
      return Vu(a, i.or(a), function(s, f) {
        var p = e.createRng();
        return p.setStart(KS(e, s.container()), s.offset()), p.setEnd(KS(e, f.container()), f.offset()), p;
      });
    }, fm = function(e, n) {
      return se.from(e.select(n.name)[n.index]).map(function(a) {
        var i = e.createRng();
        return i.selectNode(a), i;
      });
    }, Ug = function(e, n) {
      var a = e.dom;
      if (n) {
        if (GS(n))
          return RT(a, n);
        if (WS(n))
          return se.some(XS(a, n));
        if (AT(n))
          return ga(a, n);
        if (OT(n))
          return fm(a, n);
        if (qS(n))
          return se.some(n.rng);
      }
      return se.none();
    }, S2 = function(e, n, a) {
      return Jk(e, n, a);
    }, MT = function(e, n) {
      Ug(e, n).each(function(a) {
        e.setRng(a);
      });
    }, Os = function(e) {
      return $r(e) && e.tagName === "SPAN" && e.getAttribute("data-mce-type") === "bookmark";
    }, PT = function(e) {
      return function(n) {
        return e === n;
      };
    }, vm = PT(Ws), sd = function(e) {
      return e !== "" && ` \f
\r	\v`.indexOf(e) !== -1;
    }, F0 = function(e) {
      return !sd(e) && !vm(e);
    }, $0 = function(e) {
      return !!e.nodeType;
    }, NT = function(e) {
      return e && /^(IMG)$/.test(e.nodeName);
    }, ex = function(e, n, a) {
      var i = a.startOffset, s = a.startContainer;
      if (!(s === a.endContainer && NT(s.childNodes[i])) && $r(s)) {
        var f = s.childNodes, p = void 0;
        i < f.length ? (s = f[i], p = new Ha(s, e.getParent(s, e.isBlock))) : (s = f[f.length - 1], p = new Ha(s, e.getParent(s, e.isBlock)), p.next(!0));
        for (var C = p.current(); C; C = p.next())
          if (Qn(C) && !z0(C)) {
            a.setStart(C, 0), n.setRng(a);
            return;
          }
      }
    }, L0 = function(e, n, a) {
      if (e) {
        var i = n ? "nextSibling" : "previousSibling";
        for (e = a ? e : e[i]; e; e = e[i])
          if ($r(e) || !z0(e))
            return e;
      }
    }, x2 = function(e, n) {
      return $0(n) && (n = n.nodeName), !!e.schema.getTextBlockElements()[n.toLowerCase()];
    }, jg = function(e, n, a) {
      return e.schema.isValidChild(n, a);
    }, z0 = function(e, n) {
      if (n === void 0 && (n = !1), Ct(e) && Qn(e)) {
        var a = n ? e.data.replace(/ /g, "\xA0") : e.data;
        return Jl(a);
      } else
        return !1;
    }, IT = function(e) {
      return Ct(e) && Qn(e) && e.length === 0;
    }, bf = function(e, n) {
      return Be(e) ? e = e(n) : Ct(n) && (e = e.replace(/%(\w+)/g, function(a, i) {
        return n[i] || a;
      })), e;
    }, k2 = function(e, n) {
      return e = e || "", n = n || "", e = "" + (e.nodeName || e), n = "" + (n.nodeName || n), e.toLowerCase() === n.toLowerCase();
    }, T2 = function(e, n, a) {
      return (a === "color" || a === "backgroundColor") && (n = e.toHex(n)), a === "fontWeight" && n === 700 && (n = "bold"), a === "fontFamily" && (n = n.replace(/[\'\"]/g, "").replace(/,\s+/g, ",")), "" + n;
    }, Wg = function(e, n, a) {
      return T2(e, e.getStyle(n, a), a);
    }, E2 = function(e, n) {
      var a;
      return e.getParent(n, function(i) {
        return a = e.getStyle(i, "text-decoration"), a && a !== "none";
      }), a;
    }, Ch = function(e, n, a) {
      return e.getParents(n, a, e.getRoot());
    }, tx = function(e, n) {
      var a = function(i) {
        var s = function(f) {
          return f.length > 1 && f.charAt(0) === "%";
        };
        return Ae([
          "styles",
          "attributes"
        ], function(f) {
          return Mr(i, f).exists(function(p) {
            var C = ht(p) ? p : Wa(p);
            return Ae(C, s);
          });
        });
      };
      return Ae(e.formatter.get(n), a);
    }, FT = function(e, n, a) {
      var i = [
        "inline",
        "block",
        "selector",
        "attributes",
        "styles",
        "classes"
      ], s = function(f) {
        return Yn(f, function(p, C) {
          return Ae(i, function(k) {
            return k === C;
          });
        });
      };
      return Ae(e.formatter.get(n), function(f) {
        var p = s(f);
        return Ae(e.formatter.get(a), function(C) {
          var k = s(C);
          return Qo(p, k);
        });
      });
    }, yf = function(e) {
      return Va(e, "block");
    }, Ys = function(e) {
      return Va(e, "selector");
    }, pu = function(e) {
      return Va(e, "inline");
    }, $T = function(e) {
      return Ys(e) && pu(e) && Nd(Mr(e, "mixed"), !0);
    }, _2 = function(e) {
      return Ys(e) && e.expand !== !1 && !pu(e);
    }, qg = Os, A2 = Ch, Sh = z0, O2 = x2, LT = function(e) {
      return to(e) && e.getAttribute("data-mce-bogus") && !e.nextSibling;
    }, jn = function(e, n) {
      for (var a = n; a; ) {
        if ($r(a) && e.getContentEditable(a))
          return e.getContentEditable(a) === "false" ? a : n;
        a = a.parentNode;
      }
      return n;
    }, Ni = function(e, n, a, i) {
      for (var s = n.data, f = a; e ? f >= 0 : f < s.length; e ? f-- : f++)
        if (i(s.charAt(f)))
          return e ? f + 1 : f;
      return -1;
    }, Gg = function(e, n, a) {
      return Ni(e, n, a, function(i) {
        return vm(i) || sd(i);
      });
    }, Zi = function(e, n, a) {
      return Ni(e, n, a, F0);
    }, Pl = function(e, n, a, i, s, f) {
      var p, C = e.getParent(a, e.isBlock) || n, k = function(q, K, te) {
        var be = Vy(e), we = s ? be.backwards : be.forwards;
        return se.from(we(q, K, function(ke, Ee) {
          return qg(ke.parentNode) ? -1 : (p = ke, te(s, ke, Ee));
        }, C));
      }, F = k(a, i, Gg);
      return F.bind(function(q) {
        return f ? k(q.container, q.offset + (s ? -1 : 0), Zi) : se.some(q);
      }).orThunk(function() {
        return p ? se.some({
          container: p,
          offset: s ? 0 : p.length
        }) : se.none();
      });
    }, D2 = function(e, n, a, i, s) {
      Qn(i) && Rn(i.data) && i[s] && (i = i[s]);
      for (var f = A2(e, i), p = 0; p < f.length; p++)
        for (var C = 0; C < n.length; C++) {
          var k = n[C];
          if (!(Ct(k.collapsed) && k.collapsed !== a.collapsed) && Ys(k) && e.is(f[p], k.selector))
            return f[p];
        }
      return i;
    }, xh = function(e, n, a, i) {
      var s = a, f = e.dom, p = f.getRoot(), C = n[0];
      if (yf(C) && (s = C.wrapper ? null : f.getParent(a, C.block, p)), !s) {
        var k = f.getParent(a, "LI,TD,TH");
        s = f.getParent(Qn(a) ? a.parentNode : a, function(F) {
          return F !== p && O2(e, F);
        }, k);
      }
      if (s && yf(C) && C.wrapper && (s = A2(f, s, "ul,ol").reverse()[0] || s), !s)
        for (s = a; s[i] && !f.isBlock(s[i]) && (s = s[i], !k2(s, "br")); )
          ;
      return s || a;
    }, H0 = function(e, n, a, i) {
      var s = a.parentNode;
      return Ct(a[i]) ? !1 : s === n || Pt(s) || e.isBlock(s) ? !0 : H0(e, n, s, i);
    }, V0 = function(e, n, a, i, s) {
      var f = a, p = s ? "previousSibling" : "nextSibling", C = e.getRoot();
      if (Qn(a) && !Sh(a) && (s ? i > 0 : i < a.data.length))
        return a;
      for (; ; ) {
        if (!n[0].block_expand && e.isBlock(f))
          return f;
        for (var k = f[p]; k; k = k[p]) {
          var F = Qn(k) && !H0(e, C, k, p);
          if (!qg(k) && !LT(k) && !Sh(k, F))
            return f;
        }
        if (f === C || f.parentNode === C) {
          a = f;
          break;
        }
        f = f.parentNode;
      }
      return a;
    }, U0 = function(e) {
      return qg(e.parentNode) || qg(e);
    }, ld = function(e, n, a, i) {
      i === void 0 && (i = !1);
      var s = n.startContainer, f = n.startOffset, p = n.endContainer, C = n.endOffset, k = e.dom, F = a[0];
      if ($r(s) && s.hasChildNodes() && (s = Bo(s, f), Qn(s) && (f = 0)), $r(p) && p.hasChildNodes() && (p = Bo(p, n.collapsed ? C : C - 1), Qn(p) && (C = p.nodeValue.length)), s = jn(k, s), p = jn(k, p), U0(s) && (s = qg(s) ? s : s.parentNode, n.collapsed ? s = s.previousSibling || s : s = s.nextSibling || s, Qn(s) && (f = n.collapsed ? s.length : 0)), U0(p) && (p = qg(p) ? p : p.parentNode, n.collapsed ? p = p.nextSibling || p : p = p.previousSibling || p, Qn(p) && (C = n.collapsed ? 0 : p.length)), n.collapsed) {
        var q = Pl(k, e.getBody(), s, f, !0, i);
        q.each(function(te) {
          var be = te.container, we = te.offset;
          s = be, f = we;
        });
        var K = Pl(k, e.getBody(), p, C, !1, i);
        K.each(function(te) {
          var be = te.container, we = te.offset;
          p = be, C = we;
        });
      }
      return (pu(F) || F.block_expand) && ((!pu(F) || !Qn(s) || f === 0) && (s = V0(k, a, s, f, !0)), (!pu(F) || !Qn(p) || C === p.nodeValue.length) && (p = V0(k, a, p, C, !1))), _2(F) && (s = D2(k, a, n, s, "previousSibling"), p = D2(k, a, n, p, "nextSibling")), (yf(F) || Ys(F)) && (s = xh(e, a, s, "previousSibling"), p = xh(e, a, p, "nextSibling"), yf(F) && (k.isBlock(s) || (s = V0(k, a, s, f, !0)), k.isBlock(p) || (p = V0(k, a, p, C, !1)))), $r(s) && (f = k.nodeIndex(s), s = s.parentNode), $r(p) && (C = k.nodeIndex(p) + 1, p = p.parentNode), {
        startContainer: s,
        startOffset: f,
        endContainer: p,
        endOffset: C
      };
    }, kh = function(e, n, a) {
      var i = n.startOffset, s = Bo(n.startContainer, i), f = n.endOffset, p = Bo(n.endContainer, f - 1), C = function(ke) {
        var Ee = ke[0];
        Qn(Ee) && Ee === s && i >= Ee.data.length && ke.splice(0, 1);
        var qe = ke[ke.length - 1];
        return f === 0 && ke.length > 0 && qe === p && Qn(qe) && ke.splice(ke.length - 1, 1), ke;
      }, k = function(ke, Ee, qe) {
        for (var Le = []; ke && ke !== qe; ke = ke[Ee])
          Le.push(ke);
        return Le;
      }, F = function(ke, Ee) {
        return e.getParent(ke, function(qe) {
          return qe.parentNode === Ee;
        }, Ee);
      }, q = function(ke, Ee, qe) {
        for (var Le = qe ? "nextSibling" : "previousSibling", xt = ke, mt = xt.parentNode; xt && xt !== Ee; xt = mt) {
          mt = xt.parentNode;
          var Qe = k(xt === ke ? xt : xt[Le], Le);
          Qe.length && (qe || Qe.reverse(), a(C(Qe)));
        }
      };
      if (s === p)
        return a(C([s]));
      var K = e.findCommonAncestor(s, p);
      if (e.isChildOf(s, p))
        return q(s, K, !0);
      if (e.isChildOf(p, s))
        return q(p, K);
      var te = F(s, K) || s, be = F(p, K) || p;
      q(s, te, !0);
      var we = k(te === s ? te : te.nextSibling, "nextSibling", be === p ? be.nextSibling : be);
      we.length && a(C(we)), q(p, be);
    }, B2 = function(e) {
      var n = [];
      if (e)
        for (var a = 0; a < e.rangeCount; a++)
          n.push(e.getRangeAt(a));
      return n;
    }, R2 = function(e) {
      return Qt(e, function(n) {
        var a = tm(n);
        return a ? [O.fromDom(a)] : [];
      });
    }, M2 = function(e) {
      return B2(e).length > 1;
    }, zT = function(e) {
      return Ie(R2(e), _c);
    }, nx = function(e) {
      return du(e, "td[data-mce-selected],th[data-mce-selected]");
    }, dv = function(e, n) {
      var a = nx(n);
      return a.length > 0 ? a : zT(e);
    }, wf = function(e) {
      return dv(B2(e.selection.getSel()), O.fromDom(e.getBody()));
    }, dm = function(e, n) {
      return Id(e, "table", n);
    }, Kg = function(e) {
      var n = e.startContainer, a = e.startOffset;
      return Qn(n) ? a === 0 ? se.some(O.fromDom(n)) : se.none() : se.from(n.childNodes[a]).map(O.fromDom);
    }, P2 = function(e) {
      var n = e.endContainer, a = e.endOffset;
      return Qn(n) ? a === n.data.length ? se.some(O.fromDom(n)) : se.none() : se.from(n.childNodes[a - 1]).map(O.fromDom);
    }, j0 = function(e) {
      return hi(e).fold(N([e]), function(n) {
        return [e].concat(j0(n));
      });
    }, Cf = function(e) {
      return Vs(e).fold(N([e]), function(n) {
        return Oa(n) === "br" ? Uf(n).map(function(a) {
          return [e].concat(Cf(a));
        }).getOr([]) : [e].concat(Cf(n));
      });
    }, oc = function(e, n) {
      return Vu(Kg(n), P2(n), function(a, i) {
        var s = tt(j0(e), ne(Dr, a)), f = tt(Cf(e), ne(Dr, i));
        return s.isSome() && f.isSome();
      }).getOr(!1);
    }, cd = function(e, n, a, i) {
      var s = a, f = new Ha(a, s), p = Yn(e.schema.getMoveCaretBeforeOnEnterElements(), function(C, k) {
        return !We([
          "td",
          "th",
          "table"
        ], k.toLowerCase());
      });
      do {
        if (Qn(a) && Ut.trim(a.nodeValue).length !== 0) {
          i ? n.setStart(a, 0) : n.setEnd(a, a.nodeValue.length);
          return;
        }
        if (p[a.nodeName]) {
          i ? n.setStartBefore(a) : a.nodeName === "BR" ? n.setEndBefore(a) : n.setEndAfter(a);
          return;
        }
      } while (a = i ? f.next() : f.prev());
      s.nodeName === "BODY" && (i ? n.setStart(s, 0) : n.setEnd(s, s.childNodes.length));
    }, fd = function(e) {
      var n = e.selection.getSel();
      return n && n.rangeCount > 0;
    }, mm = function(e, n) {
      var a = wf(e);
      a.length > 0 ? at(a, function(i) {
        var s = i.dom, f = e.dom.createRng();
        f.setStartBefore(s), f.setEndAfter(s), n(f, !0);
      }) : n(e.selection.getRng(), !1);
    }, Xg = function(e, n, a) {
      var i = CS(e, n);
      a(i), e.moveToBookmark(i);
    }, N2 = function(e, n) {
      var a = function(f) {
        if (!e(f))
          throw new Error("Can only get " + n + " value of a " + n + " node");
        return i(f).getOr("");
      }, i = function(f) {
        return e(f) ? se.from(f.dom.nodeValue) : se.none();
      }, s = function(f, p) {
        if (!e(f))
          throw new Error("Can only set raw " + n + " value of a " + n + " node");
        f.dom.nodeValue = p;
      };
      return {
        get: a,
        getOption: i,
        set: s
      };
    }, I2 = N2(No, "text"), F2 = function(e) {
      return I2.get(e);
    }, W0 = function(e) {
      return No(e) && F2(e) === ct;
    }, hu = function(e, n, a, i) {
      return Ho(n).fold(function() {
        return "skipping";
      }, function(s) {
        return i === "br" || W0(n) ? "valid" : lv(n) ? "existing" : hf(n.dom) ? "caret" : !jg(e, a, i) || !jg(e, Oa(s), a) ? "invalid-child" : "valid";
      });
    }, wl = function(e, n) {
      var a = ld(e, n, [{ inline: "span" }]);
      n.setStart(a.startContainer, a.startOffset), n.setEnd(a.endContainer, a.endOffset), e.selection.setRng(n);
    }, Nl = function(e, n, a, i) {
      var s = n.uid, f = s === void 0 ? gS("mce-annotation") : s, p = $u(n, ["uid"]), C = O.fromTag("span", e);
      Qd(C, Xs()), M(C, "" + Mi(), f), M(C, "" + ah(), a);
      var k = i(f, p), F = k.attributes, q = F === void 0 ? {} : F, K = k.classes, te = K === void 0 ? [] : K;
      return G(C, q), jk(C, te), C;
    }, Sf = function(e, n, a, i, s) {
      var f = [], p = Nl(e.getDoc(), s, a, i), C = ed(), k = function() {
        C.clear();
      }, F = function() {
        return C.get().getOrThunk(function() {
          var be = wi(p);
          return f.push(be), C.set(be), be;
        });
      }, q = function(be) {
        at(be, K);
      }, K = function(be) {
        var we = hu(e, be, "span", Oa(be));
        switch (we) {
          case "invalid-child": {
            k();
            var ke = Hu(be);
            q(ke), k();
            break;
          }
          case "valid": {
            var Ee = F();
            Pd(be, Ee);
            break;
          }
        }
      }, te = function(be) {
        var we = Ke(be, O.fromDom);
        q(we);
      };
      return kh(e.dom, n, function(be) {
        k(), te(be);
      }), f;
    }, Yg = function(e, n, a, i) {
      e.undoManager.transact(function() {
        var s = e.selection, f = s.getRng(), p = wf(e).length > 0;
        if (f.collapsed && !p && wl(e, f), s.getRng().collapsed && !p) {
          var C = Nl(e.getDoc(), i, n, a.decorate);
          fs(C, Ws), s.getRng().insertNode(C.dom), s.select(C.dom);
        } else
          Xg(s, !1, function() {
            mm(e, function(k) {
              Sf(e, k, n, a.decorate, i);
            });
          });
      });
    }, q0 = function(e) {
      var n = oh();
      Hy(e, n);
      var a = mS(e);
      return {
        register: function(i, s) {
          n.register(i, s);
        },
        annotate: function(i, s) {
          n.lookup(i).each(function(f) {
            Yg(e, i, f, s);
          });
        },
        annotationChanged: function(i, s) {
          a.addListener(i, s);
        },
        remove: function(i) {
          r0(e, se.some(i)).each(function(s) {
            var f = s.elements;
            at(f, Gf);
          });
        },
        getAll: function(i) {
          var s = zy(e, i);
          return Kr(s, function(f) {
            return Ke(f, function(p) {
              return p.dom;
            });
          });
        }
      };
    }, vd = function(e) {
      return {
        getBookmark: ne(S2, e),
        moveToBookmark: ne(MT, e)
      };
    };
    vd.isBookmarkNode = Os;
    var gm = function(e, n) {
      for (; n && n !== e; ) {
        if (Kl(n) || xo(n))
          return n;
        n = n.parentNode;
      }
      return null;
    }, pm = function(e, n, a) {
      if (a.collapsed)
        return !1;
      if (br.browser.isIE() && a.startOffset === a.endOffset - 1 && a.startContainer === a.endContainer) {
        var i = a.startContainer.childNodes[a.startOffset];
        if ($r(i))
          return Ae(i.getClientRects(), function(s) {
            return pS(s, e, n);
          });
      }
      return Ae(a.getClientRects(), function(s) {
        return pS(s, e, n);
      });
    }, HT = function(e, n) {
      return e.fire("PreProcess", n);
    }, $2 = function(e, n) {
      return e.fire("PostProcess", n);
    }, rx = function(e) {
      return e.fire("remove");
    }, ax = function(e) {
      return e.fire("detach");
    }, L2 = function(e, n) {
      return e.fire("SwitchMode", { mode: n });
    }, z2 = function(e, n, a, i, s) {
      e.fire("ObjectResizeStart", {
        target: n,
        width: a,
        height: i,
        origin: s
      });
    }, Ya = function(e, n, a, i, s) {
      e.fire("ObjectResized", {
        target: n,
        width: a,
        height: i,
        origin: s
      });
    }, xf = function(e) {
      return e.fire("PreInit");
    }, ox = function(e) {
      return e.fire("PostRender");
    }, ix = function(e) {
      return e.fire("Init");
    }, ux = function(e, n) {
      return e.fire("PlaceholderToggle", { state: n });
    }, G0 = function(e, n, a) {
      return e.fire(n, a);
    }, H2 = function(e, n, a, i) {
      return e.fire("FormatApply", {
        format: n,
        node: a,
        vars: i
      });
    }, Th = function(e, n, a, i) {
      return e.fire("FormatRemove", {
        format: n,
        node: a,
        vars: i
      });
    }, Br = {
      BACKSPACE: 8,
      DELETE: 46,
      DOWN: 40,
      ENTER: 13,
      ESC: 27,
      LEFT: 37,
      RIGHT: 39,
      SPACEBAR: 32,
      TAB: 9,
      UP: 38,
      PAGE_UP: 33,
      PAGE_DOWN: 34,
      END: 35,
      HOME: 36,
      modifierPressed: function(e) {
        return e.shiftKey || e.ctrlKey || e.altKey || Br.metaKeyPressed(e);
      },
      metaKeyPressed: function(e) {
        return br.mac ? e.metaKey : e.ctrlKey && !e.altKey;
      }
    }, VT = xo, V2 = function(e, n) {
      var a = "data-mce-selected", i = n.dom, s = Ut.each, f, p, C, k, F, q, K, te, be, we, ke, Ee, qe, Le, xt, mt = n.getDoc(), Qe = document, At = Math.abs, tn = Math.round, Cn = n.getBody(), Ar, Xn, fn = {
        nw: [
          0,
          0,
          -1,
          -1
        ],
        ne: [
          1,
          0,
          1,
          -1
        ],
        se: [
          1,
          1,
          1,
          1
        ],
        sw: [
          0,
          1,
          -1,
          1
        ]
      }, _r = function(Dt) {
        return Dt && (Dt.nodeName === "IMG" || n.dom.is(Dt, "figure.image"));
      }, kn = function(Dt) {
        return Cs(Dt) || i.hasClass(Dt, "mce-preview-object");
      }, Kn = function(Dt, xn) {
        if (Dt.type === "longpress" || Dt.type.indexOf("touch") === 0) {
          var wn = Dt.touches[0];
          return _r(Dt.target) && !pm(wn.clientX, wn.clientY, xn);
        } else
          return _r(Dt.target) && !pm(Dt.clientX, Dt.clientY, xn);
      }, On = function(Dt) {
        var xn = Dt.target;
        Kn(Dt, n.selection.getRng()) && !Dt.isDefaultPrevented() && n.selection.select(xn);
      }, $n = function(Dt) {
        return i.is(Dt, "figure.image") ? [Dt.querySelector("img")] : i.hasClass(Dt, "mce-preview-object") && Ct(Dt.firstElementChild) ? [
          Dt,
          Dt.firstElementChild
        ] : [Dt];
      }, rr = function(Dt) {
        var xn = AS(n);
        return !xn || Dt.getAttribute("data-mce-resize") === "false" || Dt === n.getBody() ? !1 : i.hasClass(Dt, "mce-preview-object") ? Nn(O.fromDom(Dt.firstElementChild), xn) : Nn(O.fromDom(Dt), xn);
      }, hn = function(Dt) {
        return kn(Dt) ? i.create("img", { src: br.transparentSrc }) : Dt.cloneNode(!0);
      }, Zn = function(Dt, xn, wn) {
        if (Ct(wn)) {
          var yr = $n(Dt);
          at(yr, function(kr) {
            kr.style[xn] || !n.schema.isValid(kr.nodeName.toLowerCase(), xn) ? i.setStyle(kr, xn, wn) : i.setAttrib(kr, xn, "" + wn);
          });
        }
      }, fa = function(Dt, xn, wn) {
        Zn(Dt, "width", xn), Zn(Dt, "height", wn);
      }, Ia = function(Dt) {
        var xn, wn, yr, kr, uo;
        xn = Dt.screenX - q, wn = Dt.screenY - K, Le = xn * k[2] + we, xt = wn * k[3] + ke, Le = Le < 5 ? 5 : Le, xt = xt < 5 ? 5 : xt, (_r(f) || kn(f)) && OS(n) !== !1 ? yr = !Br.modifierPressed(Dt) : yr = Br.modifierPressed(Dt), yr && (At(xn) > At(wn) ? (xt = tn(Le * Ee), Le = tn(xt / Ee)) : (Le = tn(xt / Ee), xt = tn(Le * Ee))), fa(p, Le, xt), kr = k.startPos.x + xn, uo = k.startPos.y + wn, kr = kr > 0 ? kr : 0, uo = uo > 0 ? uo : 0, i.setStyles(C, {
          left: kr,
          top: uo,
          display: "block"
        }), C.innerHTML = Le + " &times; " + xt, k[2] < 0 && p.clientWidth <= Le && i.setStyle(p, "left", te + (we - Le)), k[3] < 0 && p.clientHeight <= xt && i.setStyle(p, "top", be + (ke - xt)), xn = Cn.scrollWidth - Ar, wn = Cn.scrollHeight - Xn, xn + wn !== 0 && i.setStyles(C, {
          left: kr - xn,
          top: uo - wn
        }), qe || (z2(n, f, we, ke, "corner-" + k.name), qe = !0);
      }, Pa = function() {
        var Dt = qe;
        qe = !1, Dt && (Zn(f, "width", Le), Zn(f, "height", xt)), i.unbind(mt, "mousemove", Ia), i.unbind(mt, "mouseup", Pa), Qe !== mt && (i.unbind(Qe, "mousemove", Ia), i.unbind(Qe, "mouseup", Pa)), i.remove(p), i.remove(C), i.remove(F), yu(f), Dt && (Ya(n, f, Le, xt, "corner-" + k.name), i.setAttrib(f, "style", i.getAttrib(f, "style"))), n.nodeChanged();
      }, yu = function(Dt) {
        bn();
        var xn = i.getPos(Dt, Cn), wn = xn.x, yr = xn.y, kr = Dt.getBoundingClientRect(), uo = kr.width || kr.right - kr.left, ji = kr.height || kr.bottom - kr.top;
        f !== Dt && (Wo(), f = Dt, Le = xt = 0);
        var Ii = n.fire("ObjectSelected", { target: Dt }), Mm = i.getAttrib(f, a, "1");
        rr(Dt) && !Ii.isDefaultPrevented() ? s(fn, function(Ms, ps) {
          var nu, vc = function(Ps) {
            var Ff = $n(f)[0];
            q = Ps.screenX, K = Ps.screenY, we = Ff.clientWidth, ke = Ff.clientHeight, Ee = ke / we, k = Ms, k.name = ps, k.startPos = {
              x: uo * Ms[0] + wn,
              y: ji * Ms[1] + yr
            }, Ar = Cn.scrollWidth, Xn = Cn.scrollHeight, F = i.add(Cn, "div", {
              class: "mce-resize-backdrop",
              "data-mce-bogus": "all"
            }), i.setStyles(F, {
              position: "fixed",
              left: "0",
              top: "0",
              width: "100%",
              height: "100%"
            }), p = hn(f), i.addClass(p, "mce-clonedresizable"), i.setAttrib(p, "data-mce-bogus", "all"), p.contentEditable = "false", i.setStyles(p, {
              left: wn,
              top: yr,
              margin: 0
            }), fa(p, uo, ji), p.removeAttribute(a), Cn.appendChild(p), i.bind(mt, "mousemove", Ia), i.bind(mt, "mouseup", Pa), Qe !== mt && (i.bind(Qe, "mousemove", Ia), i.bind(Qe, "mouseup", Pa)), C = i.add(Cn, "div", {
              class: "mce-resize-helper",
              "data-mce-bogus": "all"
            }, we + " &times; " + ke);
          };
          nu = i.get("mceResizeHandle" + ps), nu && i.remove(nu), nu = i.add(Cn, "div", {
            id: "mceResizeHandle" + ps,
            "data-mce-bogus": "all",
            class: "mce-resizehandle",
            unselectable: !0,
            style: "cursor:" + ps + "-resize; margin:0; padding:0"
          }), br.ie === 11 && (nu.contentEditable = !1), i.bind(nu, "mousedown", function(Ps) {
            Ps.stopImmediatePropagation(), Ps.preventDefault(), vc(Ps);
          }), Ms.elm = nu, i.setStyles(nu, {
            left: uo * Ms[0] + wn - nu.offsetWidth / 2,
            top: ji * Ms[1] + yr - nu.offsetHeight / 2
          });
        }) : Wo(), i.getAttrib(f, a) || f.setAttribute(a, Mm);
      }, Wo = function() {
        bn(), f && f.removeAttribute(a), _n(fn, function(Dt, xn) {
          var wn = i.get("mceResizeHandle" + xn);
          wn && (i.unbind(wn), i.remove(wn));
        });
      }, Rs = function(Dt) {
        var xn, wn, yr = function(kr, uo) {
          if (kr)
            do
              if (kr === uo)
                return !0;
            while (kr = kr.parentNode);
        };
        if (!(qe || n.removed)) {
          if (s(i.select("img[data-mce-selected],hr[data-mce-selected]"), function(kr) {
            kr.removeAttribute(a);
          }), wn = Dt.type === "mousedown" ? Dt.target : e.getNode(), wn = i.$(wn).closest("table,img,figure.image,hr,video,span.mce-preview-object")[0], yr(wn, Cn) && (Mn(), xn = e.getStart(!0), yr(xn, wn) && yr(e.getEnd(!0), wn))) {
            yu(wn);
            return;
          }
          Wo();
        }
      }, tl = function(Dt) {
        return VT(gm(n.getBody(), Dt));
      }, bn = function() {
        _n(fn, function(Dt) {
          Dt.elm && (i.unbind(Dt.elm), delete Dt.elm);
        });
      }, Mn = function() {
        try {
          n.getDoc().execCommand("enableObjectResizing", !1, "false");
        } catch {
        }
      };
      n.on("init", function() {
        if (Mn(), br.browser.isIE() || br.browser.isEdge()) {
          n.on("mousedown click", function(wn) {
            var yr = wn.target, kr = yr.nodeName;
            !qe && /^(TABLE|IMG|HR)$/.test(kr) && !tl(yr) && (wn.button !== 2 && n.selection.select(yr, kr === "TABLE"), wn.type === "mousedown" && n.nodeChanged());
          });
          var Dt = function(wn) {
            var yr = function(kr) {
              Bu.setEditorTimeout(n, function() {
                return n.selection.select(kr);
              });
            };
            if (tl(wn.target) || Cs(wn.target)) {
              wn.preventDefault(), yr(wn.target);
              return;
            }
            /^(TABLE|IMG|HR)$/.test(wn.target.nodeName) && (wn.preventDefault(), wn.target.tagName === "IMG" && yr(wn.target));
          };
          i.bind(Cn, "mscontrolselect", Dt), n.on("remove", function() {
            return i.unbind(Cn, "mscontrolselect", Dt);
          });
        }
        var xn = Bu.throttle(function(wn) {
          n.composing || Rs(wn);
        });
        n.on("NodeChange ResizeEditor ResizeWindow ResizeContent drop", xn), n.on("keyup compositionend", function(wn) {
          f && f.nodeName === "TABLE" && xn(wn);
        }), n.on("hide blur", Wo), n.on("contextmenu longpress", On, !0);
      }), n.on("remove", bn);
      var gr = function() {
        f = p = F = null;
      };
      return {
        isResizable: rr,
        showResizeRect: yu,
        hideResizeRect: Wo,
        updateResizeRect: Rs,
        destroy: gr
      };
    }, sx = function(e) {
      return Kl(e) || xo(e);
    }, U2 = function(e, n, a) {
      for (; e && e !== n; ) {
        if (a(e))
          return e;
        e = e.parentNode;
      }
      return null;
    }, UT = function(e, n, a) {
      var i, s = a.elementFromPoint(e, n), f = a.body.createTextRange();
      if ((!s || s.tagName === "HTML") && (s = a.body), f.moveToElementText(s), i = Ut.toArray(f.getClientRects()), i = i.sort(function(p, C) {
        return p = Math.abs(Math.max(p.top - n, p.bottom - n)), C = Math.abs(Math.max(C.top - n, C.bottom - n)), p - C;
      }), i.length > 0) {
        n = (i[0].bottom + i[0].top) / 2;
        try {
          return f.moveToPoint(e, n), f.collapse(!0), f;
        } catch {
        }
      }
      return null;
    }, lx = function(e, n) {
      var a = e && e.parentElement ? e.parentElement() : null;
      return xo(U2(a, n, sx)) ? null : e;
    }, j2 = function(e, n, a) {
      var i, s, f = a;
      if (f.caretPositionFromPoint)
        s = f.caretPositionFromPoint(e, n), s && (i = a.createRange(), i.setStart(s.offsetNode, s.offset), i.collapse(!0));
      else if (f.caretRangeFromPoint)
        i = f.caretRangeFromPoint(e, n);
      else if (f.body.createTextRange) {
        i = f.body.createTextRange();
        try {
          i.moveToPoint(e, n), i.collapse(!0);
        } catch {
          i = UT(e, n, a);
        }
        return lx(i, a.body);
      }
      return i;
    }, W2 = function(e, n) {
      return e && n && e.startContainer === n.startContainer && e.startOffset === n.startOffset && e.endContainer === n.endContainer && e.endOffset === n.endOffset;
    }, jT = function(e, n, a) {
      for (; e && e !== n; ) {
        if (a(e))
          return e;
        e = e.parentNode;
      }
      return null;
    }, Cl = function(e, n, a) {
      return jT(e, n, a) !== null;
    }, ds = function(e, n, a) {
      return Cl(e, n, function(i) {
        return i.nodeName === a;
      });
    }, kf = function(e) {
      return e && e.nodeName === "TABLE";
    }, WT = function(e) {
      return e && /^(TD|TH|CAPTION)$/.test(e.nodeName);
    }, qT = function(e, n) {
      return ks(e) && Cl(e, n, hf) === !1;
    }, q2 = function(e, n, a) {
      for (var i = new Ha(n, e.getParent(n.parentNode, e.isBlock) || e.getRoot()); n = i[a ? "prev" : "next"](); )
        if (to(n))
          return !0;
    }, la = function(e, n) {
      return e.previousSibling && e.previousSibling.nodeName === n;
    }, GT = function(e, n) {
      for (; n && n !== e; ) {
        if (xo(n))
          return !0;
        n = n.parentNode;
      }
      return !1;
    }, K0 = function(e, n, a, i, s) {
      var f, p = e.getRoot(), C, k = e.schema.getNonEmptyElements(), F = e.getParent(s.parentNode, e.isBlock) || p;
      if (i && to(s) && n && e.isEmpty(F))
        return se.some(zt(s.parentNode, e.nodeIndex(s)));
      for (var q = new Ha(s, F); C = q[i ? "prev" : "next"](); ) {
        if (e.getContentEditableParent(C) === "false" || qT(C, p))
          return se.none();
        if (Qn(C) && C.nodeValue.length > 0)
          return ds(C, p, "A") === !1 ? se.some(zt(C, i ? C.nodeValue.length : 0)) : se.none();
        if (e.isBlock(C) || k[C.nodeName.toLowerCase()])
          return se.none();
        f = C;
      }
      return a && f ? se.some(zt(f, 0)) : se.none();
    }, X0 = function(e, n, a, i) {
      var s, f, p = e.getRoot(), C, k, F = !1;
      s = i[(a ? "start" : "end") + "Container"], f = i[(a ? "start" : "end") + "Offset"];
      var q = $r(s) && f === s.childNodes.length, K = e.schema.getNonEmptyElements();
      if (k = a, ks(s))
        return se.none();
      if ($r(s) && f > s.childNodes.length - 1 && (k = !1), $p(s) && (s = p, f = 0), s === p) {
        if (k && (C = s.childNodes[f > 0 ? f - 1 : 0], C && (ks(C) || K[C.nodeName] || kf(C))))
          return se.none();
        if (s.hasChildNodes()) {
          if (f = Math.min(!k && f > 0 ? f - 1 : f, s.childNodes.length - 1), s = s.childNodes[f], f = Qn(s) && q ? s.data.length : 0, !n && s === p.lastChild && kf(s) || GT(p, s) || ks(s))
            return se.none();
          if (s.hasChildNodes() && kf(s) === !1) {
            C = s;
            var te = new Ha(s, p);
            do {
              if (xo(C) || ks(C)) {
                F = !1;
                break;
              }
              if (Qn(C) && C.nodeValue.length > 0) {
                f = k ? 0 : C.nodeValue.length, s = C, F = !0;
                break;
              }
              if (K[C.nodeName.toLowerCase()] && !WT(C)) {
                f = e.nodeIndex(C), s = C.parentNode, k || f++, F = !0;
                break;
              }
            } while (C = k ? te.next() : te.prev());
          }
        }
      }
      return n && (Qn(s) && f === 0 && K0(e, q, n, !0, s).each(function(be) {
        s = be.container(), f = be.offset(), F = !0;
      }), $r(s) && (C = s.childNodes[f], C || (C = s.childNodes[f - 1]), C && to(C) && !la(C, "A") && !q2(e, C, !1) && !q2(e, C, !0) && K0(e, q, n, !0, C).each(function(be) {
        s = be.container(), f = be.offset(), F = !0;
      }))), k && !n && Qn(s) && f === s.nodeValue.length && K0(e, q, n, !1, s).each(function(be) {
        s = be.container(), f = be.offset(), F = !0;
      }), F ? se.some(zt(s, f)) : se.none();
    }, Y0 = function(e, n) {
      var a = n.collapsed, i = n.cloneRange(), s = zt.fromRangeStart(n);
      return X0(e, a, !0, i).each(function(f) {
        (!a || !zt.isAbove(s, f)) && i.setStart(f.container(), f.offset());
      }), a || X0(e, a, !1, i).each(function(f) {
        i.setEnd(f.container(), f.offset());
      }), a && i.collapse(!0), W2(n, i) ? se.none() : se.some(i);
    }, Eh = function(e, n) {
      return e.splitText(n);
    }, mv = function(e) {
      var n = e.startContainer, a = e.startOffset, i = e.endContainer, s = e.endOffset;
      return n === i && Qn(n) ? a > 0 && a < n.nodeValue.length && (i = Eh(n, a), n = i.previousSibling, s > a ? (s = s - a, n = i = Eh(i, s).previousSibling, s = i.nodeValue.length, a = 0) : s = 0) : (Qn(n) && a > 0 && a < n.nodeValue.length && (n = Eh(n, a), a = 0), Qn(i) && s > 0 && s < i.nodeValue.length && (i = Eh(i, s).previousSibling, s = i.nodeValue.length)), {
        startContainer: n,
        startOffset: a,
        endContainer: i,
        endOffset: s
      };
    }, _h = function(e) {
      var n = function(s, f) {
        return kh(e, s, f);
      }, a = mv, i = function(s) {
        return Y0(e, s).fold(Me, function(f) {
          return s.setStart(f.startContainer, f.startOffset), s.setEnd(f.endContainer, f.endOffset), !0;
        });
      };
      return {
        walk: n,
        split: a,
        normalize: i
      };
    };
    _h.compareRanges = W2, _h.getCaretRangeFromPoint = j2, _h.getSelectedNode = tm, _h.getNode = Bo;
    var KT = function(e, n) {
      var a = function(C, k) {
        if (!ge(k) && !k.match(/^[0-9]+$/))
          throw new Error(e + ".set accepts only positive integer values. Value was " + k);
        var F = C.dom;
        Do(F) && (F.style[e] = k + "px");
      }, i = function(C) {
        var k = n(C);
        if (k <= 0 || k === null) {
          var F = aa(C, e);
          return parseFloat(F) || 0;
        }
        return k;
      }, s = i, f = function(C, k) {
        return Xe(k, function(F, q) {
          var K = aa(C, q), te = K === void 0 ? 0 : parseInt(K, 10);
          return isNaN(te) ? F : F + te;
        }, 0);
      }, p = function(C, k, F) {
        var q = f(C, F), K = k > q ? k - q : 0;
        return K;
      };
      return {
        set: a,
        get: i,
        getOuter: s,
        aggregate: f,
        max: p
      };
    }, cx = KT("height", function(e) {
      var n = e.dom;
      return Kf(e) ? n.getBoundingClientRect().height : n.offsetHeight;
    }), G2 = function(e) {
      return cx.get(e);
    }, dd = function(e, n) {
      var a = e.view(n);
      return a.fold(N([]), function(i) {
        var s = e.owner(i), f = dd(e, s);
        return [i].concat(f);
      });
    }, Z0 = function(e, n) {
      var a = n.owner(e);
      return dd(n, a);
    }, fx = function(e) {
      var n, a = e.dom === document ? se.none() : se.from((n = e.dom.defaultView) === null || n === void 0 ? void 0 : n.frameElement);
      return a.map(O.fromDom);
    }, XT = function(e) {
      return Pr(e);
    }, YT = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      view: fx,
      owner: XT
    }), ZT = function(e) {
      var n = O.fromDom(document), a = Wm(n), i = Z0(e, YT), s = ws(e), f = St(i, function(p, C) {
        var k = ws(C);
        return {
          left: p.left + k.left,
          top: p.top + k.top
        };
      }, {
        left: 0,
        top: 0
      });
      return xc(f.left + s.left + a.left, f.top + s.top + a.top);
    }, hm = function(e) {
      return Oa(e) === "textarea";
    }, K2 = function(e, n) {
      var a = e.fire("ScrollIntoView", n);
      return a.isDefaultPrevented();
    }, Cr = function(e, n) {
      e.fire("AfterScrollIntoView", n);
    }, vx = function(e, n) {
      var a = Hu(e);
      if (a.length === 0 || hm(e))
        return {
          element: e,
          offset: n
        };
      if (n < a.length && !hm(a[n]))
        return {
          element: a[n],
          offset: 0
        };
      var i = a[a.length - 1];
      return hm(i) ? {
        element: e,
        offset: n
      } : Oa(i) === "img" ? {
        element: i,
        offset: 1
      } : No(i) ? {
        element: i,
        offset: F2(i).length
      } : {
        element: i,
        offset: Hu(i).length
      };
    }, dx = function(e, n) {
      var a = Oo(e), i = G2(e);
      return {
        element: e,
        bottom: a.top + i,
        height: i,
        pos: a,
        cleanup: n
      };
    }, JT = function(e, n) {
      var a = vx(e, n), i = O.fromHtml('<span data-mce-bogus="all" style="display: inline-block;">' + ct + "</span>");
      return iu(a.element, i), dx(i, function() {
        return Yo(i);
      });
    }, Ah = function(e) {
      return dx(O.fromDom(e), xe);
    }, Ku = function(e, n, a, i) {
      X2(e, function(s, f) {
        return QT(e, n, a, i);
      }, a);
    }, Oh = function(e, n, a, i, s) {
      var f = {
        elm: i.element.dom,
        alignToTop: s
      };
      if (!K2(e, f)) {
        var p = Wm(n).top;
        a(n, p, i, s), Cr(e, f);
      }
    }, QT = function(e, n, a, i) {
      var s = O.fromDom(e.getBody()), f = O.fromDom(e.getDoc());
      dk(s);
      var p = JT(O.fromDom(a.startContainer), a.startOffset);
      Oh(e, f, n, p, i), p.cleanup();
    }, mx = function(e, n, a, i) {
      var s = O.fromDom(e.getDoc());
      Oh(e, s, a, Ah(n), i);
    }, X2 = function(e, n, a) {
      var i = a.startContainer, s = a.startOffset, f = a.endContainer, p = a.endOffset;
      n(O.fromDom(i), O.fromDom(f));
      var C = e.dom.createRng();
      C.setStart(i, s), C.setEnd(f, p), e.selection.setRng(a);
    }, Y2 = function(e, n, a, i) {
      var s = e.pos;
      if (a)
        Us(s.left, s.top, i);
      else {
        var f = s.top - n + e.height;
        Us(s.left, f, i);
      }
    }, gx = function(e, n, a, i, s) {
      var f = a + n, p = i.pos.top, C = i.bottom, k = C - p >= a;
      if (p < n)
        Y2(i, a, s !== !1, e);
      else if (p > f) {
        var F = k ? s !== !1 : s === !0;
        Y2(i, a, F, e);
      } else
        C > f && !k && Y2(i, a, s === !0, e);
    }, Z2 = function(e, n, a, i) {
      var s = e.dom.defaultView.innerHeight;
      gx(e, n, s, a, i);
    }, J2 = function(e, n, a, i) {
      var s = e.dom.defaultView.innerHeight;
      gx(e, n, s, a, i);
      var f = ZT(a.element), p = Yf(window);
      f.top < p.y ? qm(a.element, i !== !1) : f.top > p.bottom && qm(a.element, i === !0);
    }, gv = function(e, n, a) {
      return Ku(e, Z2, n, a);
    }, eE = function(e, n, a) {
      return mx(e, n, Z2, a);
    }, tE = function(e, n, a) {
      return Ku(e, J2, n, a);
    }, px = function(e, n, a) {
      return mx(e, n, J2, a);
    }, nE = function(e, n, a) {
      var i = e.inline ? eE : px;
      i(e, n, a);
    }, Dh = function(e, n, a) {
      var i = e.inline ? gv : tE;
      i(e, n, a);
    }, Na = function() {
      return O.fromDom(document);
    }, J0 = function(e) {
      return e.dom.focus();
    }, pv = function(e) {
      var n = ts(e).dom;
      return e.dom === n.activeElement;
    }, ic = function(e) {
      return e === void 0 && (e = Na()), se.from(e.dom.activeElement).map(O.fromDom);
    }, md = function(e) {
      return ic(ts(e)).filter(function(n) {
        return e.dom.contains(n.dom);
      });
    }, Ds = function(e, n, a, i) {
      return {
        start: e,
        soffset: n,
        finish: a,
        foffset: i
      };
    }, Q0 = { create: Ds }, bm = hr.generate([
      { before: ["element"] },
      {
        on: [
          "element",
          "offset"
        ]
      },
      { after: ["element"] }
    ]), Zg = function(e, n, a, i) {
      return e.fold(n, a, i);
    }, gd = function(e) {
      return e.fold(ae, ae, ae);
    }, rE = bm.before, hx = bm.on, aE = bm.after, oE = {
      before: rE,
      on: hx,
      after: aE,
      cata: Zg,
      getStart: gd
    }, ua = hr.generate([
      { domRange: ["rng"] },
      {
        relative: [
          "startSitu",
          "finishSitu"
        ]
      },
      {
        exact: [
          "start",
          "soffset",
          "finish",
          "foffset"
        ]
      }
    ]), uc = function(e) {
      return ua.exact(e.start, e.soffset, e.finish, e.foffset);
    }, Jg = function(e) {
      return e.match({
        domRange: function(n) {
          return O.fromDom(n.startContainer);
        },
        relative: function(n, a) {
          return oE.getStart(n);
        },
        exact: function(n, a, i, s) {
          return n;
        }
      });
    }, bx = ua.domRange, Bh = ua.relative, pa = ua.exact, yx = function(e) {
      var n = Jg(e);
      return zo(n);
    }, Cx = Q0.create, Rh = {
      domRange: bx,
      relative: Bh,
      exact: pa,
      exactFromRange: uc,
      getWin: yx,
      range: Cx
    }, Sx = lr().browser, Mh = function(e, n) {
      var a = No(n) ? F2(n).length : Hu(n).length + 1;
      return e > a ? a : e < 0 ? 0 : e;
    }, ym = function(e) {
      return Rh.range(e.start, Mh(e.soffset, e.start), e.finish, Mh(e.foffset, e.finish));
    }, Q2 = function(e, n) {
      return !Qc(n.dom) && ($a(e, n) || Dr(e, n));
    }, ew = function(e) {
      return function(n) {
        return Q2(e, n.start) && Q2(e, n.finish);
      };
    }, xx = function(e) {
      return e.inline === !0 || Sx.isIE();
    }, kx = function(e) {
      return Rh.range(O.fromDom(e.startContainer), e.startOffset, O.fromDom(e.endContainer), e.endOffset);
    }, pd = function(e) {
      var n = e.getSelection(), a = !n || n.rangeCount === 0 ? se.none() : se.from(n.getRangeAt(0));
      return a.map(kx);
    }, wm = function(e) {
      var n = zo(e);
      return pd(n.dom).filter(ew(e));
    }, tw = function(e, n) {
      return se.from(n).filter(ew(e)).map(ym);
    }, Tx = function(e) {
      var n = document.createRange();
      try {
        return n.setStart(e.start.dom, e.soffset), n.setEnd(e.finish.dom, e.foffset), se.some(n);
      } catch {
        return se.none();
      }
    }, eb = function(e) {
      var n = xx(e) ? wm(O.fromDom(e.getBody())) : se.none();
      e.bookmark = n.isSome() ? n : e.bookmark;
    }, iE = function(e, n) {
      var a = O.fromDom(e.getBody()), i = xx(e) ? se.from(n) : se.none(), s = i.map(kx).filter(ew(a));
      e.bookmark = s.isSome() ? s : e.bookmark;
    }, Qg = function(e) {
      var n = e.bookmark ? e.bookmark : se.none();
      return n.bind(function(a) {
        return tw(O.fromDom(e.getBody()), a);
      }).bind(Tx);
    }, nw = function(e) {
      Qg(e).each(function(n) {
        return e.selection.setRng(n);
      });
    }, rw = function(e) {
      var n = e.className.toString();
      return n.indexOf("tox-") !== -1 || n.indexOf("mce-") !== -1;
    }, Ex = { isEditorUIElement: rw }, aw = function(e) {
      return e.type === "nodechange" && e.selectionChange;
    }, tb = function(e, n) {
      var a = function() {
        n.throttle();
      };
      ho.DOM.bind(document, "mouseup", a), e.on("remove", function() {
        ho.DOM.unbind(document, "mouseup", a);
      });
    }, nb = function(e) {
      e.on("focusout", function() {
        eb(e);
      });
    }, ow = function(e, n) {
      e.on("mouseup touchend", function(a) {
        n.throttle();
      });
    }, iw = function(e, n) {
      var a = lr().browser;
      a.isIE() ? nb(e) : ow(e, n), e.on("keyup NodeChange", function(i) {
        aw(i) || eb(e);
      });
    }, _x = function(e) {
      var n = e0(function() {
        eb(e);
      }, 0);
      e.on("init", function() {
        e.inline && tb(e, n), iw(e, n);
      }), e.on("remove", function() {
        n.cancel();
      });
    }, Cm, ep = ho.DOM, Ax = function(e) {
      return Ex.isEditorUIElement(e);
    }, Ox = function(e) {
      var n = e.classList;
      return n !== void 0 ? n.contains("tox-edit-area") || n.contains("tox-edit-area__iframe") || n.contains("mce-content-body") : !1;
    }, rb = function(e, n) {
      var a = o2(e), i = ep.getParent(n, function(s) {
        return Ax(s) || (a ? e.dom.is(s, a) : !1);
      });
      return i !== null;
    }, Dx = function(e) {
      try {
        var n = ts(O.fromDom(e.getElement()));
        return ic(n).fold(function() {
          return document.body;
        }, function(a) {
          return a.dom;
        });
      } catch {
        return document.body;
      }
    }, Bx = function(e, n) {
      var a = n.editor;
      _x(a), a.on("focusin", function() {
        var i = e.focusedEditor;
        i !== a && (i && i.fire("blur", { focusedEditor: a }), e.setActive(a), e.focusedEditor = a, a.fire("focus", { blurredEditor: i }), a.focus(!0));
      }), a.on("focusout", function() {
        Bu.setEditorTimeout(a, function() {
          var i = e.focusedEditor;
          !rb(a, Dx(a)) && i === a && (a.fire("blur", { focusedEditor: null }), e.focusedEditor = null);
        });
      }), Cm || (Cm = function(i) {
        var s = e.activeEditor;
        s && Au(i).each(function(f) {
          f.ownerDocument === document && f !== document.body && !rb(s, f) && e.focusedEditor === s && (s.fire("blur", { focusedEditor: null }), e.focusedEditor = null);
        });
      }, ep.bind(document, "focusin", Cm));
    }, uw = function(e, n) {
      e.focusedEditor === n.editor && (e.focusedEditor = null), e.activeEditor || (ep.unbind(document, "focusin", Cm), Cm = null);
    }, Rx = function(e) {
      e.on("AddEditor", ne(Bx, e)), e.on("RemoveEditor", ne(uw, e));
    }, Mx = function(e, n) {
      return e.dom.getParent(n, function(a) {
        return e.dom.getContentEditable(a) === "true";
      });
    }, Px = function(e) {
      return e.collapsed ? se.from(Bo(e.startContainer, e.startOffset)).map(O.fromDom) : se.none();
    }, uE = function(e, n) {
      return Px(n).bind(function(a) {
        return Ba(a) ? se.some(a) : $a(e, a) === !1 ? se.some(e) : se.none();
      });
    }, Nx = function(e, n) {
      uE(O.fromDom(e.getBody()), n).bind(function(a) {
        return Gu(a.dom);
      }).fold(function() {
        e.selection.normalize();
      }, function(a) {
        return e.selection.setRng(a.toRange());
      });
    }, sw = function(e) {
      if (e.setActive)
        try {
          e.setActive();
        } catch {
          e.focus();
        }
      else
        e.focus();
    }, tp = function(e) {
      return pv(e) || md(e).isSome();
    }, sE = function(e) {
      return e.iframeElement && pv(O.fromDom(e.iframeElement));
    }, Ix = function(e) {
      var n = e.getBody();
      return n && tp(O.fromDom(n));
    }, Fx = function(e) {
      var n = ts(O.fromDom(e.getElement()));
      return ic(n).filter(function(a) {
        return !Ox(a.dom) && rb(e, a.dom);
      }).isSome();
    }, Il = function(e) {
      return e.inline ? Ix(e) : sE(e);
    }, $x = function(e) {
      return Il(e) || Fx(e);
    }, Lx = function(e) {
      var n = e.selection, a = e.getBody(), i = n.getRng();
      e.quirks.refreshContentEditable(), e.bookmark !== void 0 && Il(e) === !1 && Qg(e).each(function(f) {
        e.selection.setRng(f), i = f;
      });
      var s = Mx(e, n.getNode());
      if (e.$.contains(a, s)) {
        sw(s), Nx(e, i), ab(e);
        return;
      }
      e.inline || (br.opera || sw(a), e.getWin().focus()), (br.gecko || e.inline) && (sw(a), Nx(e, i)), ab(e);
    }, ab = function(e) {
      return e.editorManager.setActive(e);
    }, ob = function(e, n) {
      e.removed || (n ? ab(e) : Lx(e));
    }, lw = function(e, n, a, i, s) {
      var f = a ? n.startContainer : n.endContainer, p = a ? n.startOffset : n.endOffset;
      return se.from(f).map(O.fromDom).map(function(C) {
        return !i || !n.collapsed ? Cc(C, s(C, p)).getOr(C) : C;
      }).bind(function(C) {
        return So(C) ? se.some(C) : Ho(C).filter(So);
      }).map(function(C) {
        return C.dom;
      }).getOr(e);
    }, Sm = function(e, n, a) {
      return lw(e, n, !0, a, function(i, s) {
        return Math.min(C1(i), s);
      });
    }, np = function(e, n, a) {
      return lw(e, n, !1, a, function(i, s) {
        return s > 0 ? s - 1 : s;
      });
    }, zx = function(e, n) {
      for (var a = e; e && Qn(e) && e.length === 0; )
        e = n ? e.nextSibling : e.previousSibling;
      return e || a;
    }, Hx = function(e, n) {
      var a, i, s;
      if (!n)
        return e;
      i = n.startContainer, s = n.endContainer;
      var f = n.startOffset, p = n.endOffset;
      return a = n.commonAncestorContainer, !n.collapsed && (i === s && p - f < 2 && i.hasChildNodes() && (a = i.childNodes[f]), i.nodeType === 3 && s.nodeType === 3 && (i.length === f ? i = zx(i.nextSibling, !0) : i = i.parentNode, p === 0 ? s = zx(s.previousSibling, !1) : s = s.parentNode, i && i === s)) ? i : a && a.nodeType === 3 ? a.parentNode : a;
    }, ib = function(e, n, a, i) {
      var s, f = [], p = e.getRoot();
      if (a = e.getParent(a || Sm(p, n, n.collapsed), e.isBlock), i = e.getParent(i || np(p, n, n.collapsed), e.isBlock), a && a !== p && f.push(a), a && i && a !== i) {
        s = a;
        for (var C = new Ha(a, p); (s = C.next()) && s !== i; )
          e.isBlock(s) && f.push(s);
      }
      return i && a !== i && i !== p && f.push(i), f;
    }, lE = function(e, n, a) {
      return se.from(n).map(function(i) {
        var s = e.nodeIndex(i), f = e.createRng();
        return f.setStart(i.parentNode, s), f.setEnd(i.parentNode, s + 1), a && (cd(e, f, i, !0), cd(e, f, i, !1)), f;
      });
    }, ub = function(e, n) {
      return Ke(n, function(a) {
        var i = e.fire("GetSelectionRange", { range: a });
        return i.range !== a ? i.range : a;
      });
    }, Ph = {
      "#text": 3,
      "#comment": 8,
      "#cdata": 4,
      "#pi": 7,
      "#doctype": 10,
      "#document-fragment": 11
    }, sb = function(e, n, a) {
      var i = a ? "lastChild" : "firstChild", s = a ? "prev" : "next";
      if (e[i])
        return e[i];
      if (e !== n) {
        var f = e[s];
        if (f)
          return f;
        for (var p = e.parent; p && p !== n; p = p.parent)
          if (f = p[s], f)
            return f;
      }
    }, Vx = function(e) {
      if (!Jl(e.value))
        return !1;
      var n = e.parent;
      return !(n && (n.name !== "span" || n.attr("style")) && /^[ ]+$/.test(e.value));
    }, lb = function(e) {
      var n = e.name === "a" && !e.attr("href") && e.attr("id");
      return e.attr("name") || e.attr("id") && !e.firstChild || e.attr("data-mce-bookmark") || n;
    }, Fl = function() {
      function e(n, a) {
        this.name = n, this.type = a, a === 1 && (this.attributes = [], this.attributes.map = {});
      }
      return e.create = function(n, a) {
        var i = new e(n, Ph[n] || 1);
        return a && _n(a, function(s, f) {
          i.attr(f, s);
        }), i;
      }, e.prototype.replace = function(n) {
        var a = this;
        return n.parent && n.remove(), a.insert(n, a), a.remove(), a;
      }, e.prototype.attr = function(n, a) {
        var i = this, s;
        if (typeof n != "string")
          return n != null && _n(n, function(p, C) {
            i.attr(C, p);
          }), i;
        if (s = i.attributes) {
          if (a !== void 0) {
            if (a === null) {
              if (n in s.map) {
                delete s.map[n];
                for (var f = s.length; f--; )
                  if (s[f].name === n)
                    return s.splice(f, 1), i;
              }
              return i;
            }
            if (n in s.map) {
              for (var f = s.length; f--; )
                if (s[f].name === n) {
                  s[f].value = a;
                  break;
                }
            } else
              s.push({
                name: n,
                value: a
              });
            return s.map[n] = a, i;
          }
          return s.map[n];
        }
      }, e.prototype.clone = function() {
        var n = this, a = new e(n.name, n.type), i;
        if (i = n.attributes) {
          var s = [];
          s.map = {};
          for (var f = 0, p = i.length; f < p; f++) {
            var C = i[f];
            C.name !== "id" && (s[s.length] = {
              name: C.name,
              value: C.value
            }, s.map[C.name] = C.value);
          }
          a.attributes = s;
        }
        return a.value = n.value, a.shortEnded = n.shortEnded, a;
      }, e.prototype.wrap = function(n) {
        var a = this;
        return a.parent.insert(n, a), n.append(a), a;
      }, e.prototype.unwrap = function() {
        for (var n = this, a = n.firstChild; a; ) {
          var i = a.next;
          n.insert(a, n, !0), a = i;
        }
        n.remove();
      }, e.prototype.remove = function() {
        var n = this, a = n.parent, i = n.next, s = n.prev;
        return a && (a.firstChild === n ? (a.firstChild = i, i && (i.prev = null)) : s.next = i, a.lastChild === n ? (a.lastChild = s, s && (s.next = null)) : i.prev = s, n.parent = n.next = n.prev = null), n;
      }, e.prototype.append = function(n) {
        var a = this;
        n.parent && n.remove();
        var i = a.lastChild;
        return i ? (i.next = n, n.prev = i, a.lastChild = n) : a.lastChild = a.firstChild = n, n.parent = a, n;
      }, e.prototype.insert = function(n, a, i) {
        n.parent && n.remove();
        var s = a.parent || this;
        return i ? (a === s.firstChild ? s.firstChild = n : a.prev.next = n, n.prev = a.prev, n.next = a, a.prev = n) : (a === s.lastChild ? s.lastChild = n : a.next.prev = n, n.next = a.next, n.prev = a, a.next = n), n.parent = s, n;
      }, e.prototype.getAll = function(n) {
        for (var a = this, i = [], s = a.firstChild; s; s = sb(s, a))
          s.name === n && i.push(s);
        return i;
      }, e.prototype.children = function() {
        for (var n = this, a = [], i = n.firstChild; i; i = i.next)
          a.push(i);
        return a;
      }, e.prototype.empty = function() {
        var n = this;
        if (n.firstChild) {
          for (var a = [], i = n.firstChild; i; i = sb(i, n))
            a.push(i);
          for (var s = a.length; s--; ) {
            var i = a[s];
            i.parent = i.firstChild = i.lastChild = i.next = i.prev = null;
          }
        }
        return n.firstChild = n.lastChild = null, n;
      }, e.prototype.isEmpty = function(n, a, i) {
        a === void 0 && (a = {});
        var s = this, f = s.firstChild;
        if (lb(s))
          return !1;
        if (f)
          do {
            if (f.type === 1) {
              if (f.attr("data-mce-bogus"))
                continue;
              if (n[f.name] || lb(f))
                return !1;
            }
            if (f.type === 8 || f.type === 3 && !Vx(f) || f.type === 3 && f.parent && a[f.parent.name] && Jl(f.value) || i && i(f))
              return !1;
          } while (f = sb(f, s));
        return !0;
      }, e.prototype.walk = function(n) {
        return sb(this, null, n);
      }, e;
    }(), cE = function(e) {
      for (var n = /data:[^;<"'\s]+;base64,([a-z0-9\+\/=\s]+)/gi, a = [], i = {}, s = gS("img"), f, p = 0, C = 0; f = n.exec(e); ) {
        var k = f[0], F = s + "_" + C++;
        i[F] = k, p < f.index && a.push(e.substr(p, f.index - p)), a.push(F), p = f.index + k.length;
      }
      var q = new RegExp(s + "_[0-9]+", "g");
      return p === 0 ? {
        prefix: s,
        uris: i,
        html: e,
        re: q
      } : (p < e.length && a.push(e.substr(p)), {
        prefix: s,
        uris: i,
        html: a.join(""),
        re: q
      });
    }, cb = function(e, n) {
      return e.replace(n.re, function(a) {
        return Mr(n.uris, a).getOr(a);
      });
    }, Ux = function(e) {
      var n = /data:([^;]+);base64,([a-z0-9\+\/=\s]+)/i.exec(e);
      return n ? se.some({
        type: n[1],
        data: decodeURIComponent(n[2])
      }) : se.none();
    }, Nh = Ut.each, Ih = Ut.trim, cw = "source protocol authority userInfo user password host port relative path directory file query anchor".split(" "), jx = {
      ftp: 21,
      http: 80,
      https: 443,
      mailto: 25
    }, Wx = [
      "img",
      "video"
    ], qx = function(e, n) {
      return Ct(e) ? !e : Ct(n) ? !We(Wx, n) : !0;
    }, fb = function(e, n, a) {
      return e.allow_html_data_urls ? !1 : /^data:image\//i.test(n) ? qx(e.allow_svg_data_urls, a) && /^data:image\/svg\+xml/i.test(n) : /^data:/i.test(n);
    }, hd = function() {
      function e(n, a) {
        n = Ih(n), this.settings = a || {};
        var i = this.settings.base_uri, s = this;
        if (/^([\w\-]+):([^\/]{2})/i.test(n) || /^\s*#/.test(n)) {
          s.source = n;
          return;
        }
        var f = n.indexOf("//") === 0;
        if (n.indexOf("/") === 0 && !f && (n = (i && i.protocol || "http") + "://mce_host" + n), !/^[\w\-]*:?\/\//.test(n)) {
          var p = this.settings.base_uri ? this.settings.base_uri.path : new e(document.location.href).directory;
          if (this.settings.base_uri && this.settings.base_uri.protocol == "")
            n = "//mce_host" + s.toAbsPath(p, n);
          else {
            var C = /([^#?]*)([#?]?.*)/.exec(n);
            n = (i && i.protocol || "http") + "://mce_host" + s.toAbsPath(p, C[1]) + C[2];
          }
        }
        n = n.replace(/@@/g, "(mce_at)");
        var k = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?(\[[a-zA-Z0-9:.%]+\]|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(n);
        Nh(cw, function(F, q) {
          var K = k[q];
          K && (K = K.replace(/\(mce_at\)/g, "@@")), s[F] = K;
        }), i && (s.protocol || (s.protocol = i.protocol), s.userInfo || (s.userInfo = i.userInfo), !s.port && s.host === "mce_host" && (s.port = i.port), (!s.host || s.host === "mce_host") && (s.host = i.host), s.source = ""), f && (s.protocol = "");
      }
      return e.parseDataUri = function(n) {
        var a, i = decodeURIComponent(n).split(","), s = /data:([^;]+)/.exec(i[0]);
        return s && (a = s[1]), {
          type: a,
          data: i[1]
        };
      }, e.isDomSafe = function(n, a, i) {
        if (i === void 0 && (i = {}), i.allow_script_urls)
          return !0;
        var s = dl.decode(n).replace(/[\s\u0000-\u001F]+/g, "");
        try {
          s = decodeURIComponent(s);
        } catch {
          s = unescape(s);
        }
        return /((java|vb)script|mhtml):/i.test(s) ? !1 : !fb(i, s, a);
      }, e.getDocumentBaseUrl = function(n) {
        var a;
        return n.protocol.indexOf("http") !== 0 && n.protocol !== "file:" ? a = n.href : a = n.protocol + "//" + n.host + n.pathname, /^[^:]+:\/\/\/?[^\/]+\//.test(a) && (a = a.replace(/[\?#].*$/, "").replace(/[\/\\][^\/]+$/, ""), /[\/\\]$/.test(a) || (a += "/")), a;
      }, e.prototype.setPath = function(n) {
        var a = /^(.*?)\/?(\w+)?$/.exec(n);
        this.path = a[0], this.directory = a[1], this.file = a[2], this.source = "", this.getURI();
      }, e.prototype.toRelative = function(n) {
        var a;
        if (n === "./")
          return n;
        var i = new e(n, { base_uri: this });
        if (i.host !== "mce_host" && this.host !== i.host && i.host || this.port !== i.port || this.protocol !== i.protocol && i.protocol !== "")
          return i.getURI();
        var s = this.getURI(), f = i.getURI();
        return s === f || s.charAt(s.length - 1) === "/" && s.substr(0, s.length - 1) === f ? s : (a = this.toRelPath(this.path, i.path), i.query && (a += "?" + i.query), i.anchor && (a += "#" + i.anchor), a);
      }, e.prototype.toAbsolute = function(n, a) {
        var i = new e(n, { base_uri: this });
        return i.getURI(a && this.isSameOrigin(i));
      }, e.prototype.isSameOrigin = function(n) {
        if (this.host == n.host && this.protocol == n.protocol) {
          if (this.port == n.port)
            return !0;
          var a = jx[this.protocol];
          if (a && (this.port || a) == (n.port || a))
            return !0;
        }
        return !1;
      }, e.prototype.toRelPath = function(n, a) {
        var i = 0, s = "", f, p, C = n.substring(0, n.lastIndexOf("/")).split("/"), k = a.split("/");
        if (C.length >= k.length) {
          for (f = 0, p = C.length; f < p; f++)
            if (f >= k.length || C[f] !== k[f]) {
              i = f + 1;
              break;
            }
        }
        if (C.length < k.length) {
          for (f = 0, p = k.length; f < p; f++)
            if (f >= C.length || C[f] !== k[f]) {
              i = f + 1;
              break;
            }
        }
        if (i === 1)
          return a;
        for (f = 0, p = C.length - (i - 1); f < p; f++)
          s += "../";
        for (f = i - 1, p = k.length; f < p; f++)
          f !== i - 1 ? s += "/" + k[f] : s += k[f];
        return s;
      }, e.prototype.toAbsPath = function(n, a) {
        var i, s = 0, f = [], p, C = /\/$/.test(a) ? "/" : "", k = n.split("/"), F = a.split("/");
        for (Nh(k, function(q) {
          q && f.push(q);
        }), k = f, i = F.length - 1, f = []; i >= 0; i--)
          if (!(F[i].length === 0 || F[i] === ".")) {
            if (F[i] === "..") {
              s++;
              continue;
            }
            if (s > 0) {
              s--;
              continue;
            }
            f.push(F[i]);
          }
        return i = k.length - s, i <= 0 ? p = It(f).join("/") : p = k.slice(0, i).join("/") + "/" + It(f).join("/"), p.indexOf("/") !== 0 && (p = "/" + p), C && p.lastIndexOf("/") !== p.length - 1 && (p += C), p;
      }, e.prototype.getURI = function(n) {
        n === void 0 && (n = !1);
        var a;
        return (!this.source || n) && (a = "", n || (this.protocol ? a += this.protocol + "://" : a += "//", this.userInfo && (a += this.userInfo + "@"), this.host && (a += this.host), this.port && (a += ":" + this.port)), this.path && (a += this.path), this.query && (a += "?" + this.query), this.anchor && (a += "#" + this.anchor), this.source = a), this.source;
      }, e;
    }(), fE = Ut.makeMap("button,fieldset,form,iframe,img,image,input,object,output,select,textarea"), vE = function(e) {
      return e.indexOf("data-") === 0 || e.indexOf("aria-") === 0;
    }, dE = pi(function() {
      return document.implementation.createHTMLDocument("parser");
    }), bd = function(e, n, a) {
      for (var i = /<([!?\/])?([A-Za-z0-9\-_:.]+)/g, s = /(?:\s(?:[^'">]+(?:"[^"]*"|'[^']*'))*[^"'>]*(?:"[^">]*|'[^'>]*)?|\s*|\/)>/g, f = e.getShortEndedElements(), p = 1, C = a; p !== 0; )
        for (i.lastIndex = C; ; ) {
          var k = i.exec(n);
          if (k === null)
            return C;
          if (k[1] === "!") {
            Z(k[2], "--") ? C = fw(n, !1, k.index + 3) : C = fw(n, !0, k.index + 1);
            break;
          } else {
            s.lastIndex = i.lastIndex;
            var F = s.exec(n);
            if (ie(F) || F.index !== i.lastIndex)
              continue;
            k[1] === "/" ? p -= 1 : Fr(f, k[2]) || (p += 1), C = i.lastIndex + F[0].length;
            break;
          }
        }
      return C;
    }, mE = function(e, n) {
      return /^\s*\[if [\w\W]+\]>.*<!\[endif\](--!?)?>/.test(e.substr(n));
    }, fw = function(e, n, a) {
      a === void 0 && (a = 0);
      var i = e.toLowerCase();
      if (i.indexOf("[if ", a) !== -1 && mE(i, a)) {
        var s = i.indexOf("[endif]", a);
        return i.indexOf(">", s);
      } else if (n) {
        var f = i.indexOf(">", a);
        return f !== -1 ? f : i.length;
      } else {
        var p = /--!?>/g;
        p.lastIndex = a;
        var C = p.exec(e);
        return C ? C.index + C[0].length : i.length;
      }
    }, gE = function(e, n) {
      var a = e.exec(n);
      if (a) {
        var i = a[1], s = a[2];
        return typeof i == "string" && i.toLowerCase() === "data-mce-bogus" ? s : null;
      } else
        return null;
    }, rp = function(e, n) {
      n === void 0 && (n = ml()), e = e || {};
      var a = dE(), i = a.createElement("form");
      e.fix_self_closing !== !1 && (e.fix_self_closing = !0);
      var s = e.comment ? e.comment : xe, f = e.cdata ? e.cdata : xe, p = e.text ? e.text : xe, C = e.start ? e.start : xe, k = e.end ? e.end : xe, F = e.pi ? e.pi : xe, q = e.doctype ? e.doctype : xe, K = function(be, we) {
        we === void 0 && (we = "html");
        for (var ke = be.html, Ee, qe = 0, Le, xt, mt = [], Qe, At, tn, Cn, Ar, Xn, fn, _r, kn, Kn, On, $n, rr, hn, Zn, fa, Ia, Pa = 0, yu = dl.decode, Wo = Ut.makeMap("src,href,data,background,action,formaction,poster,xlink:href"), Rs = we === "html" ? 0 : 1, tl = function(fo) {
          var To, ru;
          for (To = mt.length; To-- && mt[To].name !== fo; )
            ;
          if (To >= 0) {
            for (ru = mt.length - 1; ru >= To; ru--)
              fo = mt[ru], fo.valid && k(fo.name);
            mt.length = To;
          }
        }, bn = function(fo, To) {
          return p(cb(fo, be), To);
        }, Mn = function(fo) {
          fo !== "" && (fo.charAt(0) === ">" && (fo = " " + fo), !e.allow_conditional_comments && fo.substr(0, 3).toLowerCase() === "[if" && (fo = " " + fo), s(cb(fo, be)));
        }, gr = function(fo) {
          return cb(fo, be);
        }, Dt = function(fo, To) {
          var ru = fo || "", nl = !Z(ru, "--"), _v = fw(ke, nl, To);
          return fo = ke.substr(To, _v - To), Mn(nl ? ru + fo : fo), _v + 1;
        }, xn = function(fo, To, ru, nl, _v) {
          if (To = To.toLowerCase(), ru = gr(To in ji ? To : yu(ru || nl || _v || "")), Ii && !Ar && vE(To) === !1) {
            var Av = On[To];
            if (!Av && $n) {
              for (var Dp = $n.length; Dp-- && (Av = $n[Dp], !Av.pattern.test(To)); )
                ;
              Dp === -1 && (Av = null);
            }
            if (!Av || Av.validValues && !(ru in Av.validValues))
              return;
          }
          var qb = To === "name" || To === "id";
          qb && fo in fE && (ru in a || ru in i) || Wo[To] && !hd.isDomSafe(ru, fo, e) || Ar && (To in Wo || To.indexOf("on") === 0) || (Qe.map[To] = ru, Qe.push({
            name: To,
            value: ru
          }));
        }, wn = new RegExp(`<(?:(?:!--([\\w\\W]*?)--!?>)|(?:!\\[CDATA\\[([\\w\\W]*?)\\]\\]>)|(?:![Dd][Oo][Cc][Tt][Yy][Pp][Ee]([\\w\\W]*?)>)|(?:!(--)?)|(?:\\?([^\\s\\/<>]+) ?([\\w\\W]*?)[?/]>)|(?:\\/([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)>)|(?:([A-Za-z][A-Za-z0-9\\-_:.]*)(\\s(?:[^'">]+(?:"[^"]*"|'[^']*'))*[^"'>]*(?:"[^">]*|'[^'>]*)?|\\s*|\\/)>))`, "g"), yr = /([\w:\-]+)(?:\s*=\s*(?:(?:\"((?:[^\"])*)\")|(?:\'((?:[^\'])*)\')|([^>\s]+)))?/g, kr = n.getShortEndedElements(), uo = e.self_closing_elements || n.getSelfClosingElements(), ji = n.getBoolAttrs(), Ii = e.validate, Mm = e.remove_internals, Ms = e.fix_self_closing, ps = n.getSpecialElements(), nu = ke + ">"; Ee = wn.exec(nu); ) {
          var vc = Ee[0];
          if (qe < Ee.index && bn(yu(ke.substr(qe, Ee.index - qe))), Le = Ee[7])
            Le = Le.toLowerCase(), Le.charAt(0) === ":" && (Le = Le.substr(1)), tl(Le);
          else if (Le = Ee[8]) {
            if (Ee.index + vc.length > ke.length) {
              bn(yu(ke.substr(Ee.index))), qe = Ee.index + vc.length;
              continue;
            }
            Le = Le.toLowerCase(), Le.charAt(0) === ":" && (Le = Le.substr(1)), Xn = Le in kr, Ms && uo[Le] && mt.length > 0 && mt[mt.length - 1].name === Le && tl(Le);
            var Ps = gE(yr, Ee[9]);
            if (Ps !== null) {
              if (Ps === "all") {
                qe = bd(n, ke, wn.lastIndex), wn.lastIndex = qe;
                continue;
              }
              _r = !1;
            }
            if (!Ii || (fn = n.getElementRule(Le))) {
              if (_r = !0, Ii && (On = fn.attributes, $n = fn.attributePatterns), (Kn = Ee[9]) ? (Ar = Kn.indexOf("data-mce-type") !== -1, Ar && Mm && (_r = !1), Qe = [], Qe.map = {}, Kn.replace(yr, function(fo, To, ru, nl, _v) {
                return xn(Le, To, ru, nl, _v), "";
              })) : (Qe = [], Qe.map = {}), Ii && !Ar) {
                if (rr = fn.attributesRequired, hn = fn.attributesDefault, Zn = fn.attributesForced, fa = fn.removeEmptyAttrs, fa && !Qe.length && (_r = !1), Zn)
                  for (At = Zn.length; At--; )
                    kn = Zn[At], Cn = kn.name, Ia = kn.value, Ia === "{$uid}" && (Ia = "mce_" + Pa++), Qe.map[Cn] = Ia, Qe.push({
                      name: Cn,
                      value: Ia
                    });
                if (hn)
                  for (At = hn.length; At--; )
                    kn = hn[At], Cn = kn.name, Cn in Qe.map || (Ia = kn.value, Ia === "{$uid}" && (Ia = "mce_" + Pa++), Qe.map[Cn] = Ia, Qe.push({
                      name: Cn,
                      value: Ia
                    }));
                if (rr) {
                  for (At = rr.length; At-- && !(rr[At] in Qe.map); )
                    ;
                  At === -1 && (_r = !1);
                }
                if (kn = Qe.map["data-mce-bogus"]) {
                  if (kn === "all") {
                    qe = bd(n, ke, wn.lastIndex), wn.lastIndex = qe;
                    continue;
                  }
                  _r = !1;
                }
              }
              _r && C(Le, Qe, Xn);
            } else
              _r = !1;
            if (xt = ps[Le]) {
              xt.lastIndex = qe = Ee.index + vc.length, (Ee = xt.exec(ke)) ? (_r && (tn = ke.substr(qe, Ee.index - qe)), qe = Ee.index + Ee[0].length) : (tn = ke.substr(qe), qe = ke.length), _r && (tn.length > 0 && bn(tn, !0), k(Le)), wn.lastIndex = qe;
              continue;
            }
            Xn || (!Kn || Kn.indexOf("/") !== Kn.length - 1 ? mt.push({
              name: Le,
              valid: _r
            }) : _r && k(Le));
          } else if (Le = Ee[1])
            Mn(Le);
          else if (Le = Ee[2]) {
            var Ff = Rs === 1 || e.preserve_cdata || mt.length > 0 && n.isValidChild(mt[mt.length - 1].name, "#cdata");
            if (Ff)
              f(Le);
            else {
              qe = Dt("", Ee.index + 2), wn.lastIndex = qe;
              continue;
            }
          } else if (Le = Ee[3])
            q(Le);
          else if ((Le = Ee[4]) || vc === "<!") {
            qe = Dt(Le, Ee.index + vc.length), wn.lastIndex = qe;
            continue;
          } else if (Le = Ee[5])
            if (Rs === 1)
              F(Le, Ee[6]);
            else {
              qe = Dt("?", Ee.index + 2), wn.lastIndex = qe;
              continue;
            }
          qe = Ee.index + vc.length;
        }
        for (qe < ke.length && bn(yu(ke.substr(qe))), At = mt.length - 1; At >= 0; At--)
          Le = mt[At], Le.valid && k(Le.name);
      }, te = function(be, we) {
        we === void 0 && (we = "html"), K(cE(be), we);
      };
      return { parse: te };
    };
    rp.findEndTag = bd;
    var vw = function(e, n) {
      var a = new RegExp(["\\s?(" + e.join("|") + ')="[^"]+"'].join("|"), "gi");
      return n.replace(a, "");
    }, Gx = function(e, n) {
      for (var a = /<(\w+) [^>]*data-mce-bogus="all"[^>]*>/g, i = e.schema, s = vw(e.getTempAttrs(), n), f = i.getShortEndedElements(), p; p = a.exec(s); ) {
        var C = a.lastIndex, k = p[0].length, F = void 0;
        f[p[1]] ? F = C : F = rp.findEndTag(i, s, C), s = s.substring(0, C - k) + s.substring(F), a.lastIndex = C - k;
      }
      return Ac(s);
    }, vb = Gx, Kx = function(e, n) {
      var a = mu(e), i = new RegExp("^(<" + a + "[^>]*>(&nbsp;|&#160;|\\s|\xA0|<br \\/>|)<\\/" + a + `>[\r
]*|<br \\/>[\r
]*)$`);
      return n.replace(i, "");
    }, Xx = function(e, n) {
      return sr(sr({}, e), {
        format: n,
        get: !0,
        getInner: !0
      });
    }, pE = function(e, n, a, i) {
      var s = Xx(n, a), f = n.no_events ? s : e.fire("BeforeGetContent", s), p;
      return f.format === "raw" ? p = Ut.trim(vb(e.serializer, i.innerHTML)) : f.format === "text" ? p = e.dom.isEmpty(i) ? "" : Ac(i.innerText || i.textContent) : f.format === "tree" ? p = e.serializer.serialize(i, f) : p = Kx(e, e.serializer.serialize(i, f)), !We([
        "text",
        "tree"
      ], f.format) && !Fd(O.fromDom(i)) ? f.content = Ut.trim(p) : f.content = p, f.no_events ? f.content : e.fire("GetContent", f).content;
    }, db = function(e, n, a) {
      return se.from(e.getBody()).fold(N(n.format === "tree" ? new Fl("body", 11) : ""), function(i) {
        return pE(e, n, a, i);
      });
    }, mb = Ut.each, dw = function(e) {
      var n = function(a, i) {
        if (a.nodeName !== i.nodeName)
          return !1;
        var s = function(p) {
          var C = {};
          return mb(e.getAttribs(p), function(k) {
            var F = k.nodeName.toLowerCase();
            F.indexOf("_") !== 0 && F !== "style" && F.indexOf("data-") !== 0 && (C[F] = e.getAttrib(p, F));
          }), C;
        }, f = function(p, C) {
          var k, F;
          for (F in p)
            if (Fr(p, F)) {
              if (k = C[F], typeof k > "u" || p[F] !== k)
                return !1;
              delete C[F];
            }
          for (F in C)
            if (Fr(C, F))
              return !1;
          return !0;
        };
        return !f(s(a), s(i)) || !f(e.parseStyle(e.getAttrib(a, "style")), e.parseStyle(e.getAttrib(i, "style"))) ? !1 : !Os(a) && !Os(i);
      };
      return { compare: n };
    }, Yx = Ut.makeMap, Zx = function(e) {
      var n = [];
      e = e || {};
      var a = e.indent, i = Yx(e.indent_before || ""), s = Yx(e.indent_after || ""), f = dl.getEncodeFunc(e.entity_encoding || "raw", e.entities), p = e.element_format === "html";
      return {
        start: function(C, k, F) {
          var q, K, te, be;
          if (a && i[C] && n.length > 0 && (be = n[n.length - 1], be.length > 0 && be !== `
` && n.push(`
`)), n.push("<", C), k)
            for (q = 0, K = k.length; q < K; q++)
              te = k[q], n.push(" ", te.name, '="', f(te.value, !0), '"');
          !F || p ? n[n.length] = ">" : n[n.length] = " />", F && a && s[C] && n.length > 0 && (be = n[n.length - 1], be.length > 0 && be !== `
` && n.push(`
`));
        },
        end: function(C) {
          var k;
          n.push("</", C, ">"), a && s[C] && n.length > 0 && (k = n[n.length - 1], k.length > 0 && k !== `
` && n.push(`
`));
        },
        text: function(C, k) {
          C.length > 0 && (n[n.length] = k ? C : f(C));
        },
        cdata: function(C) {
          n.push("<![CDATA[", C, "]]>");
        },
        comment: function(C) {
          n.push("<!--", C, "-->");
        },
        pi: function(C, k) {
          k ? n.push("<?", C, " ", f(k), "?>") : n.push("<?", C, "?>"), a && n.push(`
`);
        },
        doctype: function(C) {
          n.push("<!DOCTYPE", C, ">", a ? `
` : "");
        },
        reset: function() {
          n.length = 0;
        },
        getContent: function() {
          return n.join("").replace(/\n$/, "");
        }
      };
    }, xm = function(e, n) {
      n === void 0 && (n = ml());
      var a = Zx(e);
      e = e || {}, e.validate = "validate" in e ? e.validate : !0;
      var i = function(s) {
        var f = e.validate, p = {
          3: function(k) {
            a.text(k.value, k.raw);
          },
          8: function(k) {
            a.comment(k.value);
          },
          7: function(k) {
            a.pi(k.name, k.value);
          },
          10: function(k) {
            a.doctype(k.value);
          },
          4: function(k) {
            a.cdata(k.value);
          },
          11: function(k) {
            if (k = k.firstChild)
              do
                C(k);
              while (k = k.next);
          }
        };
        a.reset();
        var C = function(k) {
          var F = p[k.type];
          if (F)
            F(k);
          else {
            var q = k.name, K = k.shortEnded, te = k.attributes;
            if (f && te && te.length > 1) {
              var be = [];
              be.map = {};
              var we = n.getElementRule(k.name);
              if (we) {
                for (var ke = 0, Ee = we.attributesOrder.length; ke < Ee; ke++) {
                  var qe = we.attributesOrder[ke];
                  if (qe in te.map) {
                    var Le = te.map[qe];
                    be.map[qe] = Le, be.push({
                      name: qe,
                      value: Le
                    });
                  }
                }
                for (var ke = 0, Ee = te.length; ke < Ee; ke++) {
                  var qe = te[ke].name;
                  if (!(qe in be.map)) {
                    var Le = te.map[qe];
                    be.map[qe] = Le, be.push({
                      name: qe,
                      value: Le
                    });
                  }
                }
                te = be;
              }
            }
            if (a.start(k.name, te, K), !K) {
              if (k = k.firstChild)
                do
                  C(k);
                while (k = k.next);
              a.end(q);
            }
          }
        };
        return s.type === 1 && !e.inner ? C(s) : p[11](s), a.getContent();
      };
      return { serialize: i };
    }, Fh = /* @__PURE__ */ new Set();
    (function() {
      var e = [
        "margin",
        "margin-left",
        "margin-right",
        "margin-top",
        "margin-bottom",
        "padding",
        "padding-left",
        "padding-right",
        "padding-top",
        "padding-bottom",
        "border",
        "border-width",
        "border-style",
        "border-color",
        "background",
        "background-attachment",
        "background-clip",
        "background-color",
        "background-image",
        "background-origin",
        "background-position",
        "background-repeat",
        "background-size",
        "float",
        "position",
        "left",
        "right",
        "top",
        "bottom",
        "z-index",
        "display",
        "transform",
        "width",
        "max-width",
        "min-width",
        "height",
        "max-height",
        "min-height",
        "overflow",
        "overflow-x",
        "overflow-y",
        "text-overflow",
        "vertical-align",
        "transition",
        "transition-delay",
        "transition-duration",
        "transition-property",
        "transition-timing-function"
      ];
      at(e, function(n) {
        Fh.add(n);
      });
    })();
    var gb = [
      "font",
      "text-decoration",
      "text-emphasis"
    ], $h = function(e, n) {
      return mn(e.parseStyle(e.getAttrib(n, "style")));
    }, Jx = function(e) {
      return Fh.has(e);
    }, hv = function(e, n) {
      return In($h(e, n), function(a) {
        return !Jx(a);
      });
    }, hE = function(e) {
      return Ie(e, function(n) {
        return Ae(gb, function(a) {
          return Z(n, a);
        });
      });
    }, Tf = function(e, n, a) {
      var i = $h(e, n), s = $h(e, a), f = function(p) {
        var C = e.getStyle(n, p), k = e.getStyle(a, p);
        return Ot(C) && Ot(k) && C !== k;
      };
      return Ae(i, function(p) {
        var C = function(F) {
          return Ae(F, function(q) {
            return q === p;
          });
        };
        if (!C(s) && C(gb)) {
          var k = hE(s);
          return Ae(k, f);
        } else
          return f(p);
      });
    }, Qx = function(e, n, a) {
      return se.from(a.container()).filter(Qn).exists(function(i) {
        var s = e ? 0 : -1;
        return n(i.data.charAt(a.offset() + s));
      });
    }, pb = ne(Qx, !0, sd), mw = ne(Qx, !1, sd), bE = function(e) {
      var n = e.container();
      return Qn(n) && (n.data.length === 0 || os(n.data) && vd.isBookmarkNode(n.parentNode));
    }, yd = function(e, n) {
      return function(a) {
        return se.from(A0(e ? 0 : -1, a)).filter(n).isSome();
      };
    }, e4 = function(e) {
      return Gm(e) && aa(O.fromDom(e), "display") === "block";
    }, t4 = function(e) {
      return xo(e) && !Ai(e);
    }, yE = yd(!0, e4), gw = yd(!1, e4), ap = yd(!0, Cs), op = yd(!1, Cs), n4 = yd(!0, si), pw = yd(!1, si), sc = yd(!0, t4), wd = yd(!1, t4), Er = function(e) {
      for (var n = [], a = e.dom; a; )
        n.push(O.fromDom(a)), a = a.lastChild;
      return n;
    }, hw = function(e) {
      var n = du(e, "br"), a = Ie(Er(e).slice(-1), tg);
      n.length === a.length && at(a, Yo);
    }, Ef = function(e) {
      qf(e), _i(e, O.fromHtml('<br data-mce-bogus="1">'));
    }, r4 = function(e) {
      Vs(e).each(function(n) {
        Uf(n).each(function(a) {
          ll(e) && tg(n) && ll(a) && Yo(n);
        });
      });
    }, wE = function(e) {
      return e.slice(0, -1);
    }, a4 = function(e, n, a) {
      return $a(n, e) ? wE(Ei(e, function(i) {
        return a(i) || Dr(i, n);
      })) : [];
    }, Lh = function(e, n) {
      return a4(e, n, Me);
    }, zc = function(e, n) {
      return [e].concat(Lh(e, n));
    }, hb = function(e, n, a) {
      return I0(e, n, a, bE);
    }, o4 = function(e, n) {
      return tt(zc(O.fromDom(n.container()), e), ll);
    }, qr = function(e, n, a) {
      return hb(e, n.dom, a).forall(function(i) {
        return o4(n, a).fold(function() {
          return Fc(i, a, n.dom) === !1;
        }, function(s) {
          return Fc(i, a, n.dom) === !1 && $a(s, O.fromDom(i.container()));
        });
      });
    }, bw = function(e, n, a) {
      return o4(n, a).fold(function() {
        return hb(e, n.dom, a).forall(function(i) {
          return Fc(i, a, n.dom) === !1;
        });
      }, function(i) {
        return hb(e, i.dom, a).isNone();
      });
    }, Jr = ne(bw, !1), yw = ne(bw, !0), i4 = ne(qr, !1), u4 = ne(qr, !0), ip = function(e) {
      return D0(e).exists(tg);
    }, up = function(e, n, a) {
      var i = Ie(zc(O.fromDom(a.container()), n), ll), s = Vn(i).getOr(n);
      return As(e, s.dom, a).filter(ip);
    }, sp = function(e, n) {
      return D0(n).exists(tg) || up(!0, e, n).isSome();
    }, lp = function(e, n) {
      return kT(n).exists(tg) || up(!1, e, n).isSome();
    }, CE = ne(up, !1), zr = ne(up, !0), s4 = function(e) {
      return zt.isTextPosition(e) && !e.isAtStart() && !e.isAtEnd();
    }, ww = function(e, n) {
      var a = Ie(zc(O.fromDom(n.container()), e), ll);
      return Vn(a).getOr(e);
    }, zh = function(e, n) {
      return s4(n) ? mw(n) : mw(n) || Lc(ww(e, n).dom, n).exists(mw);
    }, Cd = function(e, n) {
      return s4(n) ? pb(n) : pb(n) || ac(ww(e, n).dom, n).exists(pb);
    }, l4 = function(e) {
      return We([
        "pre",
        "pre-wrap"
      ], e);
    }, bb = function(e) {
      return D0(e).bind(function(n) {
        return Jm(n, So);
      }).exists(function(n) {
        return l4(aa(n, "white-space"));
      });
    }, Cw = function(e, n) {
      return Lc(e.dom, n).isNone();
    }, SE = function(e, n) {
      return ac(e.dom, n).isNone();
    }, c4 = function(e, n) {
      return Cw(e, n) || SE(e, n) || Jr(e, n) || yw(e, n) || lp(e, n) || sp(e, n);
    }, xE = function(e, n) {
      return bb(n) ? !1 : c4(e, n) || zh(e, n) || Cd(e, n);
    }, yb = function(e, n) {
      return bb(n) ? !1 : Jr(e, n) || i4(e, n) || lp(e, n) || zh(e, n);
    }, kE = function(e) {
      var n = e.container(), a = e.offset();
      return Qn(n) && a < n.data.length ? zt(n, a + 1) : e;
    }, wb = function(e, n) {
      return bb(n) ? !1 : yw(e, n) || u4(e, n) || sp(e, n) || Cd(e, n);
    }, f4 = function(e, n) {
      return yb(e, n) || wb(e, kE(n));
    }, v4 = function(e, n) {
      return vm(e.charAt(n));
    }, TE = function(e) {
      var n = e.container();
      return Qn(n) && gn(n.data, Ws);
    }, d4 = function(e) {
      var n = e.split("");
      return Ke(n, function(a, i) {
        return vm(a) && i > 0 && i < n.length - 1 && F0(n[i - 1]) && F0(n[i + 1]) ? " " : a;
      }).join("");
    }, Sw = function(e, n) {
      var a = n.data, i = zt(n, 0);
      return v4(a, 0) && !f4(e, i) ? (n.data = " " + a.slice(1), !0) : !1;
    }, wa = function(e) {
      var n = e.data, a = d4(n);
      return a !== n ? (e.data = a, !0) : !1;
    }, m4 = function(e, n) {
      var a = n.data, i = zt(n, a.length - 1);
      return v4(a, a.length - 1) && !f4(e, i) ? (n.data = a.slice(0, -1) + " ", !0) : !1;
    }, Cb = function(e, n) {
      return se.some(n).filter(TE).bind(function(a) {
        var i = a.container(), s = Sw(e, i) || wa(i) || m4(e, i);
        return s ? se.some(a) : se.none();
      });
    }, xw = function(e) {
      var n = O.fromDom(e.getBody());
      e.selection.isCollapsed() && Cb(n, zt.fromRangeStart(e.selection.getRng())).each(function(a) {
        e.selection.setRng(a.toRange());
      });
    }, g4 = function(e, n, a) {
      var i = Xe(e, function(s, f) {
        return sd(f) || vm(f) ? s.previousCharIsSpace || s.str === "" && n || s.str.length === e.length - 1 && a ? {
          previousCharIsSpace: !1,
          str: s.str + Ws
        } : {
          previousCharIsSpace: !0,
          str: s.str + " "
        } : {
          previousCharIsSpace: !1,
          str: s.str + f
        };
      }, {
        previousCharIsSpace: !1,
        str: ""
      });
      return i.str;
    }, kw = function(e, n, a) {
      if (a !== 0) {
        var i = O.fromDom(e), s = Iv(i, ll).getOr(i), f = e.data.slice(n, n + a), p = n + a >= e.data.length && wb(s, zt(e, e.data.length)), C = n === 0 && yb(s, zt(e, 0));
        e.replaceData(n, a, g4(f, C, p));
      }
    }, Hh = function(e, n) {
      var a = e.data.slice(n), i = a.length - lt(a).length;
      kw(e, n, i);
    }, Sb = function(e, n) {
      var a = e.data.slice(0, n), i = a.length - Et(a).length;
      kw(e, n - i, i);
    }, u = function(e, n, a, i) {
      i === void 0 && (i = !0);
      var s = Et(e.data).length, f = i ? e : n, p = i ? n : e;
      return i ? f.appendData(p.data) : f.insertData(0, p.data), Yo(O.fromDom(p)), a && Hh(f, s), f;
    }, c = function(e, n) {
      var a = e.container(), i = e.offset();
      return zt.isTextPosition(e) === !1 && a === n.parentNode && i > zt.before(n).offset();
    }, d = function(e, n) {
      return c(n, e) ? zt(n.container(), n.offset() - 1) : n;
    }, h = function(e) {
      return Qn(e) ? zt(e, 0) : zt.before(e);
    }, S = function(e) {
      return Qn(e) ? zt(e, e.data.length) : zt.after(e);
    }, B = function(e) {
      return af(e.previousSibling) ? se.some(S(e.previousSibling)) : e.previousSibling ? Ml(e.previousSibling) : se.none();
    }, L = function(e) {
      return af(e.nextSibling) ? se.some(h(e.nextSibling)) : e.nextSibling ? Gu(e.nextSibling) : se.none();
    }, W = function(e, n) {
      var a = zt.before(n.previousSibling ? n.previousSibling : n.parentNode);
      return Lc(e, a).fold(function() {
        return ac(e, zt.after(n));
      }, se.some);
    }, me = function(e, n) {
      return ac(e, zt.after(n)).fold(function() {
        return Lc(e, zt.before(n));
      }, se.some);
    }, Re = function(e, n) {
      return B(n).orThunk(function() {
        return L(n);
      }).orThunk(function() {
        return W(e, n);
      });
    }, rt = function(e, n) {
      return L(n).orThunk(function() {
        return B(n);
      }).orThunk(function() {
        return me(e, n);
      });
    }, jt = function(e, n, a) {
      return e ? rt(n, a) : Re(n, a);
    }, Sn = function(e, n, a) {
      return jt(e, n, a).map(ne(d, a));
    }, ln = function(e, n, a) {
      a.fold(function() {
        e.focus();
      }, function(i) {
        e.selection.setRng(i.toRange(), n);
      });
    }, Wt = function(e) {
      return function(n) {
        return n.dom === e;
      };
    }, Pn = function(e, n) {
      return n && Fr(e.schema.getBlockElements(), Oa(n));
    }, Ln = function(e) {
      if (lu(e)) {
        var n = O.fromHtml('<br data-mce-bogus="1">');
        return qf(e), _i(e, n), se.some(zt.before(n.dom));
      } else
        return se.none();
    }, mr = function(e, n, a) {
      var i = Uf(e).filter(No), s = il(e).filter(No);
      return Yo(e), ty(i, s, n, function(f, p, C) {
        var k = f.dom, F = p.dom, q = k.data.length;
        return u(k, F, a), C.container() === F ? zt(k, q) : C;
      }).orThunk(function() {
        return a && (i.each(function(f) {
          return Sb(f.dom, f.dom.length);
        }), s.each(function(f) {
          return Hh(f.dom, 0);
        })), n;
      });
    }, Ea = function(e, n) {
      return Fr(e.schema.getTextInlineElements(), Oa(n));
    }, dr = function(e, n, a, i) {
      i === void 0 && (i = !0);
      var s = Sn(n, e.getBody(), a.dom), f = Iv(a, ne(Pn, e), Wt(e.getBody())), p = mr(a, s, Ea(e, a));
      e.dom.isEmpty(e.getBody()) ? (e.setContent(""), e.selection.setCursorLocation()) : f.bind(Ln).fold(function() {
        i && ln(e, n, p);
      }, function(C) {
        i && ln(e, n, se.some(C));
      });
    }, Ur = function(e) {
      return function(n) {
        return Dr(e, n);
      };
    }, ca = function(e) {
      return du(e, "td,th");
    }, sa = function(e, n) {
      var a = function(F) {
        return dm(O.fromDom(F), n);
      }, i = a(e.startContainer), s = a(e.endContainer), f = i.isSome(), p = s.isSome(), C = Vu(i, s, Dr).getOr(!1), k = !C && f && p;
      return {
        startTable: i,
        endTable: s,
        isStartInTable: f,
        isEndInTable: p,
        isSameTable: C,
        isMultiTable: k
      };
    }, oi = function(e, n) {
      return {
        start: e,
        end: n
      };
    }, Ji = function(e, n, a) {
      return {
        rng: e,
        table: n,
        cells: a
      };
    }, Qi = hr.generate([
      {
        singleCellTable: [
          "rng",
          "cell"
        ]
      },
      { fullTable: ["table"] },
      {
        partialTable: [
          "cells",
          "outsideDetails"
        ]
      },
      {
        multiTable: [
          "startTableCells",
          "endTableCells",
          "betweenRng"
        ]
      }
    ]), Ca = function(e, n) {
      return ri(O.fromDom(e), "td,th", n);
    }, Gr = function(e) {
      return !Dr(e.start, e.end);
    }, ma = function(e, n) {
      return dm(e.start, n).bind(function(a) {
        return dm(e.end, n).bind(function(i) {
          return ny(Dr(a, i), a);
        });
      });
    }, Ga = function(e, n) {
      return !Gr(e) && ma(e, n).exists(function(a) {
        var i = a.dom.rows;
        return i.length === 1 && i[0].cells.length === 1;
      });
    }, jo = function(e, n) {
      var a = Ca(e.startContainer, n), i = Ca(e.endContainer, n);
      return Vu(a, i, oi);
    }, bv = function(e) {
      return function(n) {
        return dm(n, e).bind(function(a) {
          return Un(ca(a)).map(function(i) {
            return oi(n, i);
          });
        });
      };
    }, Ua = function(e) {
      return function(n) {
        return dm(n, e).bind(function(a) {
          return Vn(ca(a)).map(function(i) {
            return oi(i, n);
          });
        });
      };
    }, Zs = function(e) {
      return function(n) {
        return ma(n, e).map(function(a) {
          return Ji(n, a, ca(a));
        });
      };
    }, eu = function(e, n, a, i) {
      if (a.collapsed || !e.forall(Gr))
        return se.none();
      if (n.isSameTable) {
        var s = e.bind(Zs(i));
        return se.some({
          start: s,
          end: s
        });
      } else {
        var f = Ca(a.startContainer, i), p = Ca(a.endContainer, i), C = f.bind(bv(i)).bind(Zs(i)), k = p.bind(Ua(i)).bind(Zs(i));
        return se.some({
          start: C,
          end: k
        });
      }
    }, Vh = function(e, n) {
      return gt(e, function(a) {
        return Dr(a, n);
      });
    }, yv = function(e) {
      return Vu(Vh(e.cells, e.rng.start), Vh(e.cells, e.rng.end), function(n, a) {
        return e.cells.slice(n, a + 1);
      });
    }, Hc = function(e, n, a) {
      return e.exists(function(i) {
        return Ga(i, a) && oc(i.start, n);
      });
    }, Sl = function(e, n) {
      var a = n.startTable, i = n.endTable, s = e.cloneRange();
      return a.each(function(f) {
        return s.setStartAfter(f.dom);
      }), i.each(function(f) {
        return s.setEndBefore(f.dom);
      }), s;
    }, _f = function(e, n, a, i) {
      return eu(e, n, a, i).bind(function(s) {
        var f = s.start, p = s.end;
        return f.or(p);
      }).bind(function(s) {
        var f = n.isSameTable, p = yv(s).getOr([]);
        if (f && s.cells.length === p.length)
          return se.some(Qi.fullTable(s.table));
        if (p.length > 0) {
          if (f)
            return se.some(Qi.partialTable(p, se.none()));
          var C = Sl(a, n);
          return se.some(Qi.partialTable(p, se.some(sr(sr({}, n), { rng: C }))));
        } else
          return se.none();
      });
    }, xb = function(e, n, a, i) {
      return eu(e, n, a, i).bind(function(s) {
        var f = s.start, p = s.end, C = f.bind(yv).getOr([]), k = p.bind(yv).getOr([]);
        if (C.length > 0 && k.length > 0) {
          var F = Sl(a, n);
          return se.some(Qi.multiTable(C, k, F));
        } else
          return se.none();
      });
    }, cp = function(e, n) {
      var a = Ur(e), i = jo(n, a), s = sa(n, a);
      return Hc(i, n, a) ? i.map(function(f) {
        return Qi.singleCellTable(n, f.start);
      }) : s.isMultiTable ? xb(i, s, n, a) : _f(i, s, n, a);
    }, fp = function(e) {
      var n = zs(e) ? Uf(e) : Vs(e);
      return n.bind(fp).orThunk(function() {
        return se.some(e);
      });
    }, vp = function(e) {
      return at(e, function(n) {
        Gt(n, "contenteditable"), Ef(n);
      });
    }, Vc = function(e, n) {
      return se.from(e.dom.getParent(n, e.dom.isBlock)).map(O.fromDom);
    }, dp = function(e, n, a) {
      a.each(function(i) {
        n ? Yo(i) : (Ef(i), e.selection.setCursorLocation(i.dom, 0));
      });
    }, mp = function(e, n, a, i) {
      var s = a.cloneRange();
      i ? (s.setStart(a.startContainer, a.startOffset), s.setEndAfter(n.dom.lastChild)) : (s.setStartBefore(n.dom.firstChild), s.setEnd(a.endContainer, a.endOffset)), EE(e, s, n, !1);
    }, Tw = function(e) {
      var n = wf(e), a = O.fromDom(e.selection.getNode());
      Km(a.dom) && lu(a) ? e.selection.setCursorLocation(a.dom, 0) : e.selection.collapse(!0), n.length > 1 && Ae(n, function(i) {
        return Dr(i, a);
      }) && M(a, "data-mce-selected", "1");
    }, gp = function(e, n, a) {
      var i = e.selection.getRng(), s = a.bind(function(f) {
        var p = f.rng, C = f.isStartInTable, k = Vc(e, C ? p.endContainer : p.startContainer);
        p.deleteContents(), dp(e, C, k.filter(lu));
        var F = C ? n[0] : n[n.length - 1];
        return mp(e, F, i, C), lu(F) ? se.none() : se.some(C ? n.slice(1) : n.slice(0, -1));
      }).getOr(n);
      return vp(s), Tw(e), !0;
    }, k5 = function(e, n, a, i) {
      var s = e.selection.getRng(), f = n[0], p = a[a.length - 1];
      mp(e, f, s, !0), mp(e, p, s, !1);
      var C = lu(f) ? n : n.slice(1), k = lu(p) ? a : a.slice(0, -1);
      return vp(C.concat(k)), i.deleteContents(), Tw(e), !0;
    }, EE = function(e, n, a, i) {
      i === void 0 && (i = !0), n.deleteContents();
      var s = fp(a).getOr(a), f = O.fromDom(e.dom.getParent(s.dom, e.dom.isBlock));
      if (lu(f) && (Ef(f), i && e.selection.setCursorLocation(f.dom, 0)), !Dr(a, f)) {
        var p = Nd(Ho(f), a) ? [] : ui(f);
        at(p.concat(Hu(a)), function(C) {
          !Dr(C, f) && !$a(C, f) && lu(C) && Yo(C);
        });
      }
      return !0;
    }, hR = function(e, n) {
      return dr(e, !1, n), !0;
    }, pp = function(e, n, a) {
      return cp(n, a).map(function(i) {
        return i.fold(ne(EE, e), ne(hR, e), ne(gp, e), ne(k5, e));
      });
    }, bR = function(e, n) {
      return kb(e, n);
    }, Js = function(e, n, a, i) {
      return _E(n, i).fold(function() {
        return pp(e, n, a);
      }, function(s) {
        return bR(e, s);
      }).getOr(!1);
    }, La = function(e, n, a) {
      var i = O.fromDom(e.getBody()), s = e.selection.getRng();
      return a.length !== 0 ? gp(e, a, se.none()) : Js(e, i, s, n);
    }, Af = function(e, n) {
      return tt(zc(n, e), _c);
    }, _E = function(e, n) {
      return tt(zc(n, e), Ip("caption"));
    }, T5 = function(e, n, a, i, s) {
      return $c(a, e.getBody(), s).bind(function(f) {
        return Af(n, O.fromDom(f.getNode())).map(function(p) {
          return Dr(p, i) === !1;
        });
      });
    }, kb = function(e, n) {
      return Ef(n), e.selection.setCursorLocation(n.dom, 0), se.some(!0);
    }, AE = function(e, n, a, i) {
      return Gu(e.dom).bind(function(s) {
        return Ml(e.dom).map(function(f) {
          return n ? a.isEqual(s) && i.isEqual(f) : a.isEqual(f) && i.isEqual(s);
        });
      }).getOr(!0);
    }, E5 = function(e, n) {
      return kb(e, n);
    }, _5 = function(e, n, a) {
      return _E(e, O.fromDom(a.getNode())).map(function(i) {
        return Dr(i, n) === !1;
      });
    }, yR = function(e, n, a, i, s) {
      return $c(a, e.getBody(), s).bind(function(f) {
        return AE(i, a, s, f) ? E5(e, i) : _5(n, i, f);
      }).or(se.some(!0));
    }, wR = function(e, n, a, i) {
      var s = zt.fromRangeStart(e.selection.getRng());
      return Af(a, i).bind(function(f) {
        return lu(f) ? kb(e, f) : T5(e, a, n, f, s);
      }).getOr(!1);
    }, OE = function(e, n, a, i) {
      var s = zt.fromRangeStart(e.selection.getRng());
      return lu(i) ? kb(e, i) : yR(e, a, n, i, s);
    }, DE = function(e, n) {
      return e ? n4(n) : pw(n);
    }, wv = function(e, n) {
      var a = zt.fromRangeStart(e.selection.getRng());
      return DE(n, a) || As(n, e.getBody(), a).exists(function(i) {
        return DE(n, i);
      });
    }, CR = function(e, n, a) {
      var i = O.fromDom(e.getBody());
      return _E(i, a).fold(function() {
        return wR(e, n, i, a) || wv(e, n);
      }, function(s) {
        return OE(e, n, i, s).getOr(!1);
      });
    }, p4 = function(e, n) {
      var a = O.fromDom(e.selection.getStart(!0)), i = wf(e);
      return e.selection.isCollapsed() && i.length === 0 ? CR(e, n, a) : La(e, a, i);
    }, SR = function(e, n, a, i) {
      var s = document.createRange();
      return s.setStart(e, n), s.setEnd(a, i), s;
    }, BE = function(e) {
      var n = zt.fromRangeStart(e), a = zt.fromRangeEnd(e), i = e.commonAncestorContainer;
      return As(!1, i, a).map(function(s) {
        return !Fc(n, a, i) && Fc(n, s, i) ? SR(n.container(), n.offset(), s.container(), s.offset()) : e;
      }).getOr(e);
    }, RE = function(e) {
      return e.collapsed ? e : BE(e);
    }, xR = function(e) {
      return e.firstChild && e.firstChild === e.lastChild;
    }, ME = function(e) {
      return e.name === "br" || e.value === Ws;
    }, kR = function(e, n) {
      var a = e.getBlockElements();
      return a[n.name] && xR(n) && ME(n.firstChild);
    }, TR = function(e, n) {
      var a = e.getNonEmptyElements();
      return n && (n.isEmpty(a) || kR(e, n));
    }, A5 = function(e, n) {
      var a = n.firstChild, i = n.lastChild;
      return a && a.name === "meta" && (a = a.next), i && i.attr("id") === "mce_marker" && (i = i.prev), TR(e, i) && (i = i.prev), !a || a !== i ? !1 : a.name === "ul" || a.name === "ol";
    }, ER = function(e) {
      var n = e.firstChild, a = e.lastChild;
      return n && n.nodeName === "META" && n.parentNode.removeChild(n), a && a.id === "mce_marker" && a.parentNode.removeChild(a), e;
    }, _R = function(e, n, a) {
      var i = n.serialize(a), s = e.createFragment(i);
      return ER(s);
    }, h4 = function(e) {
      return Ie(e.childNodes, function(n) {
        return n.nodeName === "LI";
      });
    }, AR = function(e) {
      return e.data === Ws || to(e);
    }, O5 = function(e) {
      return e && e.firstChild && e.firstChild === e.lastChild && AR(e.firstChild);
    }, D5 = function(e) {
      return !e.firstChild || O5(e);
    }, PE = function(e) {
      return e.length > 0 && D5(e[e.length - 1]) ? e.slice(0, -1) : e;
    }, NE = function(e, n) {
      var a = e.getParent(n, e.isBlock);
      return a && a.nodeName === "LI" ? a : null;
    }, OR = function(e, n) {
      return !!NE(e, n);
    }, IE = function(e, n) {
      var a = n.cloneRange(), i = n.cloneRange();
      return a.setStartBefore(e), i.setEndAfter(e), [
        a.cloneContents(),
        i.cloneContents()
      ];
    }, DR = function(e, n) {
      var a = zt.before(e), i = Jo(n), s = i.next(a);
      return s ? s.toRange() : null;
    }, B5 = function(e, n) {
      var a = zt.after(e), i = Jo(n), s = i.prev(a);
      return s ? s.toRange() : null;
    }, Ew = function(e, n, a, i) {
      var s = IE(e, i), f = e.parentNode;
      return f.insertBefore(s[0], e), Ut.each(n, function(p) {
        f.insertBefore(p, e);
      }), f.insertBefore(s[1], e), f.removeChild(e), B5(n[n.length - 1], a);
    }, FE = function(e, n, a) {
      var i = e.parentNode;
      return Ut.each(n, function(s) {
        i.insertBefore(s, e);
      }), DR(e, a);
    }, BR = function(e, n, a, i) {
      return i.insertAfter(n.reverse(), e), B5(n[0], a);
    }, RR = function(e, n, a, i) {
      var s = _R(n, e, i), f = NE(n, a.startContainer), p = PE(h4(s.firstChild)), C = 1, k = 2, F = n.getRoot(), q = function(K) {
        var te = zt.fromRangeStart(a), be = Jo(n.getRoot()), we = K === C ? be.prev(te) : be.next(te);
        return we ? NE(n, we.getNode()) !== f : !0;
      };
      return q(C) ? FE(f, p, F) : q(k) ? BR(f, p, F, n) : Ew(f, p, F, a);
    }, R5 = function(e, n, a) {
      var i = O.fromDom(e.getRoot());
      return yb(i, zt.fromRangeStart(n)) ? a = a.replace(/^ /, "&nbsp;") : a = a.replace(/^&nbsp;/, " "), wb(i, zt.fromRangeEnd(n)) ? a = a.replace(/(&nbsp;| )(<br( \/)>)?$/, "&nbsp;") : a = a.replace(/&nbsp;(<br( \/)?>)?$/, " "), a;
    }, b4 = Km, MR = function(e, n, a) {
      if (a !== null) {
        var i = e.getParent(n.endContainer, b4);
        return a === i && oc(O.fromDom(a), n);
      } else
        return !1;
    }, PR = function(e, n, a) {
      if (a.getAttribute("data-mce-bogus") === "all")
        a.parentNode.insertBefore(e.dom.createFragment(n), a);
      else {
        var i = a.firstChild, s = a.lastChild;
        !i || i === s && i.nodeName === "BR" ? e.dom.setHTML(a, n) : e.selection.setContent(n);
      }
    }, NR = function(e, n) {
      se.from(e.getParent(n, "td,th")).map(O.fromDom).each(r4);
    }, IR = function(e, n) {
      var a = e.schema.getTextInlineElements(), i = e.dom;
      if (n) {
        var s = e.getBody(), f = dw(i);
        Ut.each(i.select("*[data-mce-fragment]"), function(p) {
          var C = Ct(a[p.nodeName.toLowerCase()]);
          if (C && hv(i, p))
            for (var k = p.parentNode; Ct(k) && k !== s; k = k.parentNode) {
              var F = Tf(i, p, k);
              if (F)
                break;
              if (f.compare(k, p)) {
                i.remove(p, !0);
                break;
              }
            }
        });
      }
    }, M5 = function(e) {
      for (var n = e; n = n.walk(); )
        n.type === 1 && n.attr("data-mce-fragment", "1");
    }, P5 = function(e) {
      Ut.each(e.getElementsByTagName("*"), function(n) {
        n.removeAttribute("data-mce-fragment");
      });
    }, FR = function(e) {
      return !!e.getAttribute("data-mce-fragment");
    }, $R = function(e, n) {
      return n && !e.schema.getShortEndedElements()[n.nodeName];
    }, LR = function(e, n) {
      var a, i = e.dom, s = e.selection;
      if (!!n) {
        s.scrollIntoView(n);
        var f = gm(e.getBody(), n);
        if (i.getContentEditable(f) === "false") {
          i.remove(n), s.select(f);
          return;
        }
        var p = i.createRng(), C = n.previousSibling;
        if (Qn(C)) {
          if (p.setStart(C, C.nodeValue.length), !br.ie) {
            var k = n.nextSibling;
            Qn(k) && (C.appendData(k.data), k.parentNode.removeChild(k));
          }
        } else
          p.setStartBefore(n), p.setEndBefore(n);
        var F = function(K) {
          var te = zt.fromRangeStart(K), be = Jo(e.getBody());
          if (te = be.next(te), te)
            return te.toRange();
        }, q = i.getParent(n, i.isBlock);
        i.remove(n), q && i.isEmpty(q) && (e.$(q).empty(), p.setStart(q, 0), p.setEnd(q, 0), !b4(q) && !FR(q) && (a = F(p)) ? (p = a, i.remove(q)) : i.add(q, i.create("br", { "data-mce-bogus": "1" }))), s.setRng(p);
      }
    }, zR = function(e) {
      var n = e.dom, a = RE(e.selection.getRng());
      e.selection.setRng(a);
      var i = n.getParent(a.startContainer, b4);
      MR(n, a, i) ? EE(e, a, O.fromDom(i)) : e.getDoc().execCommand("Delete", !1, null);
    }, HR = function(e, n, a) {
      var i, s, f, p = e.selection, C = e.dom;
      /^ | $/.test(n) && (n = R5(C, p.getRng(), n));
      var k = e.parser, F = a.merge, q = xm({ validate: uT(e) }, e.schema), K = '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;</span>', te = e.fire("BeforeSetContent", {
        content: n,
        format: "html",
        selection: !0,
        paste: a.paste
      });
      if (te.isDefaultPrevented()) {
        e.fire("SetContent", {
          content: te.content,
          format: "html",
          selection: !0,
          paste: a.paste
        });
        return;
      }
      n = te.content, n.indexOf("{$caret}") === -1 && (n += "{$caret}"), n = n.replace(/\{\$caret\}/, K), s = p.getRng();
      var be = s.startContainer || (s.parentElement ? s.parentElement() : null), we = e.getBody();
      be === we && p.isCollapsed() && C.isBlock(we.firstChild) && $R(e, we.firstChild) && C.isEmpty(we.firstChild) && (s = C.createRng(), s.setStart(we.firstChild, 0), s.setEnd(we.firstChild, 0), p.setRng(s)), p.isCollapsed() || zR(e), i = p.getNode();
      var ke = {
        context: i.nodeName.toLowerCase(),
        data: a.data,
        insert: !0
      }, Ee = k.parse(n, ke);
      if (a.paste === !0 && A5(e.schema, Ee) && OR(C, i)) {
        s = RR(q, C, p.getRng(), Ee), p.setRng(s), e.fire("SetContent", te);
        return;
      }
      if (M5(Ee), f = Ee.lastChild, f.attr("id") === "mce_marker") {
        var qe = f;
        for (f = f.prev; f; f = f.walk(!0))
          if (f.type === 3 || !C.isBlock(f.name)) {
            e.schema.isValidChild(f.parent.name, "span") && f.parent.insert(qe, f, f.name === "br");
            break;
          }
      }
      if (e._selectionOverrides.showBlockCaretContainer(i), !ke.invalid)
        n = q.serialize(Ee), PR(e, n, i);
      else {
        e.selection.setContent(K), i = p.getNode();
        var Le = e.getBody();
        for (i.nodeType === 9 ? i = f = Le : f = i; f !== Le; )
          i = f, f = f.parentNode;
        n = i === Le ? Le.innerHTML : C.getOuterHTML(i), n = q.serialize(k.parse(n.replace(/<span (id="mce_marker"|id=mce_marker).+?<\/span>/i, function() {
          return q.serialize(Ee);
        }))), i === Le ? C.setHTML(Le, n) : C.setOuterHTML(i, n);
      }
      IR(e, F), LR(e, C.get("mce_marker")), P5(e.getBody()), NR(C, p.getStart()), e.fire("SetContent", te), e.addVisual();
    }, $E = function(e, n) {
      n(e), e.firstChild && $E(e.firstChild, n), e.next && $E(e.next, n);
    }, _w = function(e, n, a) {
      var i = {}, s = {}, f = [];
      a.firstChild && $E(a.firstChild, function(k) {
        at(e, function(F) {
          F.name === k.name && (i[F.name] ? i[F.name].nodes.push(k) : i[F.name] = {
            filter: F,
            nodes: [k]
          });
        }), at(n, function(F) {
          typeof k.attr(F.name) == "string" && (s[F.name] ? s[F.name].nodes.push(k) : s[F.name] = {
            filter: F,
            nodes: [k]
          });
        });
      });
      for (var p in i)
        Fr(i, p) && f.push(i[p]);
      for (var C in s)
        Fr(s, C) && f.push(s[C]);
      return f;
    }, VR = function(e, n, a) {
      var i = _w(e, n, a);
      at(i, function(s) {
        at(s.filter.callbacks, function(f) {
          f(s.nodes, s.filter.name, {});
        });
      });
    }, N5 = "html", Aw = function(e) {
      return e instanceof Fl;
    }, UR = function(e) {
      Il(e) && Gu(e.getBody()).each(function(n) {
        var a = n.getNode(), i = si(a) ? Gu(a).getOr(n) : n;
        e.selection.setRng(i.toRange());
      });
    }, y4 = function(e, n, a) {
      e.dom.setHTML(e.getBody(), n), a !== !0 && UR(e);
    }, I5 = function(e, n, a, i) {
      if (a.length === 0 || /^\s+$/.test(a)) {
        var s = '<br data-mce-bogus="1">';
        n.nodeName === "TABLE" ? a = "<tr><td>" + s + "</td></tr>" : /^(UL|OL)$/.test(n.nodeName) && (a = "<li>" + s + "</li>");
        var f = mu(e);
        f && e.schema.isValidChild(n.nodeName.toLowerCase(), f.toLowerCase()) ? (a = s, a = e.dom.createHTML(f, Tg(e), a)) : a || (a = '<br data-mce-bogus="1">'), y4(e, a, i.no_selection), e.fire("SetContent", i);
      } else
        i.format !== "raw" && (a = xm({ validate: e.validate }, e.schema).serialize(e.parser.parse(a, {
          isRootContent: !0,
          insert: !0
        }))), i.content = Fd(O.fromDom(n)) ? a : Ut.trim(a), y4(e, i.content, i.no_selection), i.no_events || e.fire("SetContent", i);
      return i.content;
    }, jR = function(e, n, a, i) {
      VR(e.parser.getNodeFilters(), e.parser.getAttributeFilters(), a);
      var s = xm({ validate: e.validate }, e.schema).serialize(a);
      return i.content = Fd(O.fromDom(n)) ? s : Ut.trim(s), y4(e, i.content, i.no_selection), i.no_events || e.fire("SetContent", i), a;
    }, WR = function(e, n) {
      return sr(sr({ format: N5 }, e), {
        set: !0,
        content: Aw(n) ? "" : n
      });
    }, qR = function(e, n, a) {
      var i = WR(a, n), s = a.no_events ? i : e.fire("BeforeSetContent", i);
      return Aw(n) || (n = s.content), se.from(e.getBody()).fold(N(n), function(f) {
        return Aw(n) ? jR(e, f, n, s) : I5(e, f, n, s);
      });
    }, GR = function(e, n) {
      return oy(e, n).isSome();
    }, F5 = function(e) {
      return Be(e) ? e : Me;
    }, KR = function(e, n, a) {
      for (var i = e.dom, s = F5(a); i.parentNode; ) {
        i = i.parentNode;
        var f = O.fromDom(i), p = n(f);
        if (p.isSome())
          return p;
        if (s(f))
          break;
      }
      return se.none();
    }, LE = function(e, n, a) {
      var i = n(e), s = F5(a);
      return i.orThunk(function() {
        return s(e) ? se.none() : KR(e, n, s);
      });
    }, zE = k2, $5 = function(e, n, a) {
      var i = e.formatter.get(a);
      if (i)
        for (var s = 0; s < i.length; s++) {
          var f = i[s];
          if (Ys(f) && f.inherit === !1 && e.dom.is(n, f.selector))
            return !0;
        }
      return !1;
    }, HE = function(e, n, a, i, s) {
      var f = e.dom.getRoot();
      return n === f ? !1 : (n = e.dom.getParent(n, function(p) {
        return $5(e, p, a) ? !0 : p.parentNode === f || !!Xu(e, p, a, i, !0);
      }), !!Xu(e, n, a, i, s));
    }, VE = function(e, n, a) {
      if (zE(n, a.inline) || zE(n, a.block))
        return !0;
      if (a.selector)
        return n.nodeType === 1 && e.is(n, a.selector);
    }, w4 = function(e, n, a, i, s, f) {
      var p = a[i];
      if (Be(a.onmatch))
        return a.onmatch(n, a, i);
      if (p) {
        if (De(p.length)) {
          for (var C in p)
            if (Fr(p, C)) {
              var k = i === "attributes" ? e.getAttrib(n, C) : Wg(e, n, C), F = bf(p[C], f), q = Pt(k) || Rn(k);
              if (q && Pt(F))
                continue;
              if (s && q && !a.exact || (!s || a.exact) && !zE(k, T2(e, F, C)))
                return !1;
            }
        } else
          for (var K = 0; K < p.length; K++)
            if (i === "attributes" ? e.getAttrib(n, p[K]) : Wg(e, n, p[K]))
              return !0;
      }
      return !0;
    }, Xu = function(e, n, a, i, s) {
      var f = e.formatter.get(a), p = e.dom;
      if (f && n)
        for (var C = 0; C < f.length; C++) {
          var k = f[C];
          if (VE(e.dom, n, k) && w4(p, n, k, "attributes", s, i) && w4(p, n, k, "styles", s, i)) {
            var F = k.classes;
            if (F) {
              for (var q = 0; q < F.length; q++)
                if (!e.dom.hasClass(n, bf(F[q], i)))
                  return;
            }
            return k;
          }
        }
    }, Ow = function(e, n, a, i, s) {
      if (i)
        return HE(e, i, n, a, s);
      if (i = e.selection.getNode(), HE(e, i, n, a, s))
        return !0;
      var f = e.selection.getStart();
      return !!(f !== i && HE(e, f, n, a, s));
    }, UE = function(e, n, a) {
      var i = [], s = {}, f = e.selection.getStart();
      return e.dom.getParent(f, function(p) {
        for (var C = 0; C < n.length; C++) {
          var k = n[C];
          !s[k] && Xu(e, p, k, a) && (s[k] = !0, i.push(k));
        }
      }, e.dom.getRoot()), i;
    }, jE = function(e, n) {
      var a = function(s) {
        return Dr(s, O.fromDom(e.getBody()));
      }, i = function(s, f) {
        return Xu(e, s.dom, f) ? se.some(f) : se.none();
      };
      return se.from(e.selection.getStart(!0)).bind(function(s) {
        return LE(O.fromDom(s), function(f) {
          return yt(n, function(p) {
            return i(f, p);
          });
        }, a);
      }).getOrNull();
    }, XR = function(e, n) {
      var a = e.formatter.get(n), i = e.dom;
      if (a)
        for (var s = e.selection.getStart(), f = Ch(i, s), p = a.length - 1; p >= 0; p--) {
          var C = a[p];
          if (!Ys(C) || Ct(C.defaultBlock))
            return !0;
          for (var k = f.length - 1; k >= 0; k--)
            if (i.is(f[k], C.selector))
              return !0;
        }
      return !1;
    }, L5 = function(e, n, a) {
      return Xe(a, function(i, s) {
        var f = tx(e, s);
        return e.formatter.matchNode(n, s, {}, f) ? i.concat([s]) : i;
      }, []);
    }, Tb = ct, WE = "_mce_caret", qE = function(e, n) {
      return e.importNode(n, !0);
    }, YR = function(e) {
      for (var n = []; e; ) {
        if (e.nodeType === 3 && e.nodeValue !== Tb || e.childNodes.length > 1)
          return [];
        e.nodeType === 1 && n.push(e), e = e.firstChild;
      }
      return n;
    }, GE = function(e) {
      return YR(e).length > 0;
    }, z5 = function(e) {
      if (e) {
        var n = new Ha(e, e);
        for (e = n.current(); e; e = n.next())
          if (Qn(e))
            return e;
      }
      return null;
    }, Uh = function(e) {
      var n = O.fromTag("span");
      return G(n, {
        id: WE,
        "data-mce-bogus": "1",
        "data-mce-type": "format-caret"
      }), e && _i(n, O.fromText(Tb)), n;
    }, H5 = function(e) {
      var n = z5(e);
      return n && n.nodeValue.charAt(0) === Tb && n.deleteData(0, 1), n;
    }, KE = function(e, n, a) {
      a === void 0 && (a = !0);
      var i = e.dom, s = e.selection;
      if (GE(n))
        dr(e, !1, O.fromDom(n), a);
      else {
        var f = s.getRng(), p = i.getParent(n, i.isBlock), C = f.startContainer, k = f.startOffset, F = f.endContainer, q = f.endOffset, K = H5(n);
        i.remove(n, !0), C === K && k > 0 && f.setStart(K, k - 1), F === K && q > 0 && f.setEnd(K, q - 1), p && i.isEmpty(p) && Ef(O.fromDom(p)), s.setRng(f);
      }
    }, C4 = function(e, n, a) {
      a === void 0 && (a = !0);
      var i = e.dom, s = e.selection;
      if (n)
        KE(e, n, a);
      else if (n = cm(e.getBody(), s.getStart()), !n)
        for (; n = i.get(WE); )
          KE(e, n, !1);
    }, ZR = function(e, n, a) {
      var i = e.dom, s = i.getParent(a, ne(x2, e));
      s && i.isEmpty(s) ? a.parentNode.replaceChild(n, a) : (hw(O.fromDom(a)), i.isEmpty(a) ? a.parentNode.replaceChild(n, a) : i.insertAfter(n, a));
    }, V5 = function(e, n) {
      return e.appendChild(n), n;
    }, U5 = function(e, n) {
      var a = St(e, function(i, s) {
        return V5(i, s.cloneNode(!1));
      }, n);
      return V5(a, a.ownerDocument.createTextNode(Tb));
    }, JR = function(e, n, a, i, s, f) {
      var p = e.formatter, C = e.dom, k = Ie(mn(p.get()), function(te) {
        return te !== i && !gn(te, "removeformat");
      }), F = L5(e, a, k), q = Ie(F, function(te) {
        return !FT(e, te, i);
      });
      if (q.length > 0) {
        var K = a.cloneNode(!1);
        return C.add(n, K), p.remove(i, s, K, f), C.remove(K), se.some(K);
      } else
        return se.none();
    }, QR = function(e, n, a) {
      var i, s, f = e.selection, p = f.getRng(), C = p.startOffset, k = p.startContainer, F = k.nodeValue;
      i = cm(e.getBody(), f.getStart()), i && (s = z5(i));
      var q = /[^\s\u00a0\u00ad\u200b\ufeff]/;
      if (F && C > 0 && C < F.length && q.test(F.charAt(C)) && q.test(F.charAt(C - 1))) {
        var K = f.getBookmark();
        p.collapse(!0);
        var te = ld(e, p, e.formatter.get(n));
        te = mv(te), e.formatter.apply(n, a, te), f.moveToBookmark(K);
      } else
        (!i || s.nodeValue !== Tb) && (i = qE(e.getDoc(), Uh(!0).dom), s = i.firstChild, p.insertNode(i), C = 1), e.formatter.apply(n, a, i), f.setCursorLocation(s, C);
    }, j5 = function(e, n, a, i) {
      var s = e.dom, f = e.selection, p, C, k, F = [], q = f.getRng(), K = q.startContainer, te = q.startOffset;
      for (C = K, K.nodeType === 3 && (te !== K.nodeValue.length && (p = !0), C = C.parentNode); C; ) {
        if (Xu(e, C, n, a, i)) {
          k = C;
          break;
        }
        C.nextSibling && (p = !0), F.push(C), C = C.parentNode;
      }
      if (!!k)
        if (p) {
          var be = f.getBookmark();
          q.collapse(!0);
          var we = ld(e, q, e.formatter.get(n), !0);
          we = mv(we), e.formatter.remove(n, a, we, i), f.moveToBookmark(be);
        } else {
          var ke = cm(e.getBody(), k), Ee = Uh(!1).dom;
          ZR(e, Ee, ke !== null ? ke : k);
          var qe = JR(e, Ee, k, n, a, i), Le = U5(F.concat(qe.toArray()), Ee);
          KE(e, ke, !1), f.setCursorLocation(Le, 1), s.isEmpty(k) && s.remove(k);
        }
    }, eM = function(e, n) {
      var a = e.selection, i = e.getBody();
      C4(e, null, !1), (n === 8 || n === 46) && a.isCollapsed() && a.getStart().innerHTML === Tb && C4(e, cm(i, a.getStart())), (n === 37 || n === 39) && C4(e, cm(i, a.getStart()));
    }, XE = function(e) {
      e.on("mouseup keydown", function(n) {
        eM(e, n.keyCode);
      });
    }, Eb = function(e, n) {
      var a = Uh(!1), i = U5(n, a.dom);
      return iu(O.fromDom(e), a), Yo(O.fromDom(e)), zt(i, 0);
    }, tM = function(e, n) {
      var a = e.schema.getTextInlineElements();
      return Fr(a, Oa(n)) && !hf(n.dom) && !ni(n.dom);
    }, nM = function(e) {
      return hf(e.dom) && GE(e.dom);
    }, jh = {}, S4 = Ao, W5 = bo, rM = function(e, n) {
      var a = jh[e];
      a || (jh[e] = []), jh[e].push(n);
    }, q5 = function(e, n) {
      W5(jh[e], function(a) {
        a(n);
      });
    };
    rM("pre", function(e) {
      var n = e.selection.getRng(), a, i = function(p) {
        return f(p.previousSibling) && go(a, p.previousSibling) !== -1;
      }, s = function(p, C) {
        ta(C).remove(), ta(p).append("<br><br>").append(C.childNodes);
      }, f = ul(["pre"]);
      n.collapsed || (a = e.selection.getSelectedBlocks(), W5(S4(S4(a, f), i), function(p) {
        s(p.previousSibling, p);
      }));
    });
    var Dw = Ut.each, YE = function(e) {
      return $r(e) && !Os(e) && !hf(e) && !ni(e);
    }, Bw = function(e, n) {
      for (var a = e; a; a = a[n]) {
        if (Qn(a) && Ot(a.data))
          return e;
        if ($r(a) && !Os(a))
          return a;
      }
      return e;
    }, Sd = function(e, n, a) {
      var i = dw(e);
      if (n && a && (n = Bw(n, "previousSibling"), a = Bw(a, "nextSibling"), i.compare(n, a))) {
        for (var s = n.nextSibling; s && s !== a; ) {
          var f = s;
          s = s.nextSibling, n.appendChild(f);
        }
        return e.remove(a), Ut.each(Ut.grep(a.childNodes), function(p) {
          n.appendChild(p);
        }), n;
      }
      return a;
    }, G5 = function(e, n, a, i) {
      if (i && n.merge_siblings !== !1) {
        var s = Sd(e, L0(i), i);
        Sd(e, s, L0(s, !0));
      }
    }, ZE = function(e, n, a) {
      if (n.clear_child_styles) {
        var i = n.links ? "*:not(a)" : "*";
        Dw(e.select(i, a), function(s) {
          YE(s) && Dw(n.styles, function(f, p) {
            e.setStyle(s, p, "");
          });
        });
      }
    }, JE = function(e, n, a) {
      Dw(e.childNodes, function(i) {
        YE(i) && (n(i) && a(i), i.hasChildNodes() && JE(i, n, a));
      });
    }, aM = function(e, n) {
      n.nodeName === "SPAN" && e.getAttribs(n).length === 0 && e.remove(n, !0);
    }, K5 = function(e, n) {
      return function(a) {
        return !!(a && Wg(e, a, n));
      };
    }, X5 = function(e, n, a) {
      return function(i) {
        e.setStyle(i, n, a), i.getAttribute("style") === "" && i.removeAttribute("style"), aM(e, i);
      };
    }, _b = hr.generate([
      { keep: [] },
      { rename: ["name"] },
      { removed: [] }
    ]), oM = /^(src|href|style)$/, hp = Ut.each, Ab = k2, iM = function(e) {
      return /^(TR|TH|TD)$/.test(e.nodeName);
    }, Y5 = function(e, n, a) {
      return e.isChildOf(n, a) && n !== a && !e.isBlock(a);
    }, Z5 = function(e, n, a) {
      var i = n[a ? "startContainer" : "endContainer"], s = n[a ? "startOffset" : "endOffset"];
      if ($r(i)) {
        var f = i.childNodes.length - 1;
        !a && s && s--, i = i.childNodes[s > f ? f : s];
      }
      return Qn(i) && a && s >= i.nodeValue.length && (i = new Ha(i, e.getBody()).next() || i), Qn(i) && !a && s === 0 && (i = new Ha(i, e.getBody()).prev() || i), i;
    }, QE = function(e, n) {
      var a = n ? "firstChild" : "lastChild";
      if (iM(e) && e[a]) {
        var i = e[a];
        return e.nodeName === "TR" && i[a] || i;
      }
      return e;
    }, e_ = function(e, n, a, i) {
      var s = e.create(a, i);
      return n.parentNode.insertBefore(s, n), s.appendChild(n), s;
    }, J5 = function(e, n, a, i, s) {
      var f = O.fromDom(n), p = O.fromDom(e.create(i, s)), C = a ? mo(f) : Da(f);
      return Wf(p, C), a ? (iu(f, p), _l(p, f)) : (Nv(f, p), _i(p, f)), p.dom;
    }, uM = function(e, n, a) {
      if (pu(a) && Ab(n, a.inline) || yf(a) && Ab(n, a.block))
        return !0;
      if (Ys(a))
        return $r(n) && e.is(n, a.selector);
    }, sM = function(e, n) {
      return n.links && e.nodeName === "A";
    }, x4 = function(e, n, a, i) {
      var s = L0(n, a, i);
      return Pt(s) || s.nodeName === "BR" || e.isBlock(s);
    }, lM = function(e, n, a) {
      var i = n.parentNode, s, f = e.dom, p = mu(e);
      yf(a) && (p ? i === f.getRoot() && (!a.list_block || !Ab(n, a.list_block)) && at(Tn(n.childNodes), function(C) {
        jg(e, p, C.nodeName.toLowerCase()) ? s ? s.appendChild(C) : (s = e_(f, C, p), f.setAttribs(s, e.settings.forced_root_block_attrs)) : s = null;
      }) : f.isBlock(n) && !f.isBlock(i) && (!x4(f, n, !1) && !x4(f, n.firstChild, !0, !0) && n.insertBefore(f.create("br"), n.firstChild), !x4(f, n, !0) && !x4(f, n.lastChild, !1, !0) && n.appendChild(f.create("br")))), !($T(a) && !Ab(a.inline, n)) && f.remove(n, !0);
    }, Q5 = function(e, n, a, i, s) {
      var f, p = e.dom;
      if (!uM(p, i, n) && !sM(i, n))
        return _b.keep();
      var C = i;
      if (pu(n) && n.remove === "all" && ht(n.preserve_attributes)) {
        var k = Ie(p.getAttribs(C), function(te) {
          return We(n.preserve_attributes, te.name.toLowerCase());
        });
        if (p.removeAllAttribs(C), at(k, function(te) {
          return p.setAttrib(C, te.name, te.value);
        }), k.length > 0)
          return _b.rename("span");
      }
      if (n.remove !== "all") {
        hp(n.styles, function(te, be) {
          te = T2(p, bf(te, a), be + ""), ge(be) && (be = te, s = null), (n.remove_similar || !s || Ab(Wg(p, s, be), te)) && p.setStyle(C, be, ""), f = !0;
        }), f && p.getAttrib(C, "style") === "" && (C.removeAttribute("style"), C.removeAttribute("data-mce-style")), hp(n.attributes, function(te, be) {
          var we;
          if (te = bf(te, a), ge(be) && (be = te, s = null), n.remove_similar || !s || Ab(p.getAttrib(s, be), te)) {
            if (be === "class" && (te = p.getAttrib(C, be), te && (we = "", at(te.split(/\s+/), function(ke) {
              /mce\-\w+/.test(ke) && (we += (we ? " " : "") + ke);
            }), we))) {
              p.setAttrib(C, be, we);
              return;
            }
            if (oM.test(be) && C.removeAttribute("data-mce-" + be), be === "style" && ul(["li"])(C) && p.getStyle(C, "list-style-type") === "none") {
              C.removeAttribute(be), p.setStyle(C, "list-style-type", "none");
              return;
            }
            be === "class" && C.removeAttribute("className"), C.removeAttribute(be);
          }
        }), hp(n.classes, function(te) {
          te = bf(te, a), (!s || p.hasClass(s, te)) && p.removeClass(C, te);
        });
        for (var F = p.getAttribs(C), q = 0; q < F.length; q++) {
          var K = F[q].nodeName;
          if (K.indexOf("_") !== 0 && K.indexOf("data-") !== 0)
            return _b.keep();
        }
      }
      return n.remove !== "none" ? (lM(e, C, n), _b.removed()) : _b.keep();
    }, Ob = function(e, n, a, i, s) {
      return Q5(e, n, a, i, s).fold(Me, function(f) {
        return e.dom.rename(i, f), !0;
      }, Je);
    }, cM = function(e, n, a, i, s) {
      var f;
      return at(Ch(e.dom, n.parentNode).reverse(), function(p) {
        if (!f && p.id !== "_start" && p.id !== "_end") {
          var C = Xu(e, p, a, i, s);
          C && C.split !== !1 && (f = p);
        }
      }), f;
    }, fM = function(e, n, a, i) {
      return Q5(e, n, a, i, i).fold(N(i), function(s) {
        var f = e.dom.createFragment();
        return f.appendChild(i), e.dom.rename(i, s);
      }, N(null));
    }, t_ = function(e, n, a, i, s, f, p, C) {
      var k, F, q, K = e.dom;
      if (a) {
        for (var te = a.parentNode, be = i.parentNode; be && be !== te; be = be.parentNode) {
          k = K.clone(be, !1);
          for (var we = 0; we < n.length && (k = fM(e, n[we], C, k), k !== null); we++)
            ;
          k && (F && k.appendChild(F), q || (q = k), F = k);
        }
        f && (!p.mixed || !K.isBlock(a)) && (i = K.split(a, i)), F && (s.parentNode.insertBefore(F, s), q.appendChild(s), pu(p) && G5(K, p, C, F));
      }
      return i;
    }, n_ = function(e, n, a, i, s) {
      var f = e.formatter.get(n), p = f[0], C = !0, k = e.dom, F = e.selection, q = function(Le) {
        var xt = cM(e, Le, n, a, s);
        return t_(e, f, xt, Le, Le, !0, p, a);
      }, K = function(Le) {
        return Os(Le) && $r(Le) && (Le.id === "_start" || Le.id === "_end");
      }, te = function(Le) {
        return Ae(f, function(xt) {
          return Ob(e, xt, a, Le, Le);
        });
      }, be = function(Le) {
        var xt = !0, mt = !1;
        $r(Le) && k.getContentEditable(Le) && (xt = C, C = k.getContentEditable(Le) === "true", mt = !0);
        var Qe = Tn(Le.childNodes);
        if (C && !mt) {
          var At = te(Le), tn = At || Ae(f, function(fn) {
            return VE(k, Le, fn);
          }), Cn = Le.parentNode;
          !tn && Ct(Cn) && _2(p) && te(Cn);
        }
        if (p.deep && Qe.length) {
          for (var Ar = 0; Ar < Qe.length; Ar++)
            be(Qe[Ar]);
          mt && (C = xt);
        }
        var Xn = [
          "underline",
          "line-through",
          "overline"
        ];
        at(Xn, function(fn) {
          $r(Le) && e.dom.getStyle(Le, "text-decoration") === fn && Le.parentNode && E2(k, Le.parentNode) === fn && Ob(e, {
            deep: !1,
            exact: !0,
            inline: "span",
            styles: { textDecoration: fn }
          }, null, Le);
        });
      }, we = function(Le) {
        var xt = k.get(Le ? "_start" : "_end"), mt = xt[Le ? "firstChild" : "lastChild"];
        return K(mt) && (mt = mt[Le ? "firstChild" : "lastChild"]), Qn(mt) && mt.data.length === 0 && (mt = Le ? xt.previousSibling || xt.nextSibling : xt.nextSibling || xt.previousSibling), k.remove(xt, !0), mt;
      }, ke = function(Le) {
        var xt, mt, Qe = ld(e, Le, f, Le.collapsed);
        if (p.split) {
          if (Qe = mv(Qe), xt = Z5(e, Qe, !0), mt = Z5(e, Qe), xt !== mt) {
            if (xt = QE(xt, !0), mt = QE(mt, !1), Y5(k, xt, mt)) {
              var At = se.from(xt.firstChild).getOr(xt);
              q(J5(k, At, !0, "span", {
                id: "_start",
                "data-mce-type": "bookmark"
              })), we(!0);
              return;
            }
            if (Y5(k, mt, xt)) {
              var At = se.from(mt.lastChild).getOr(mt);
              q(J5(k, At, !1, "span", {
                id: "_end",
                "data-mce-type": "bookmark"
              })), we(!1);
              return;
            }
            xt = e_(k, xt, "span", {
              id: "_start",
              "data-mce-type": "bookmark"
            }), mt = e_(k, mt, "span", {
              id: "_end",
              "data-mce-type": "bookmark"
            });
            var tn = k.createRng();
            tn.setStartAfter(xt), tn.setEndBefore(mt), kh(k, tn, function(Cn) {
              at(Cn, function(Ar) {
                !Os(Ar) && !Os(Ar.parentNode) && q(Ar);
              });
            }), q(xt), q(mt), xt = we(!0), mt = we();
          } else
            xt = mt = q(xt);
          Qe.startContainer = xt.parentNode ? xt.parentNode : xt, Qe.startOffset = k.nodeIndex(xt), Qe.endContainer = mt.parentNode ? mt.parentNode : mt, Qe.endOffset = k.nodeIndex(mt) + 1;
        }
        kh(k, Qe, function(Cn) {
          at(Cn, be);
        });
      };
      if (i) {
        if ($0(i)) {
          var Ee = k.createRng();
          Ee.setStartBefore(i), Ee.setEndAfter(i), ke(Ee);
        } else
          ke(i);
        Th(e, n, i, a);
        return;
      }
      if (k.getContentEditable(F.getNode()) === "false") {
        i = F.getNode();
        for (var qe = 0; qe < f.length && !(f[qe].ceFalseOverride && Ob(e, f[qe], a, i, i)); qe++)
          ;
        Th(e, n, i, a);
        return;
      }
      !F.isCollapsed() || !pu(p) || wf(e).length ? (Xg(F, !0, function() {
        mm(e, ke);
      }), pu(p) && Ow(e, n, a, F.getStart()) && ex(k, F, F.getRng()), e.nodeChanged()) : j5(e, n, a, s), Th(e, n, i, a);
    }, eO = Ut.each, k4 = function(e, n, a, i) {
      var s = function(f) {
        if (f.nodeType === 1 && f.parentNode && f.parentNode.nodeType === 1) {
          var p = E2(e, f.parentNode);
          e.getStyle(f, "color") && p ? e.setStyle(f, "text-decoration", p) : e.getStyle(f, "text-decoration") === p && e.setStyle(f, "text-decoration", null);
        }
      };
      n.styles && (n.styles.color || n.styles.textDecoration) && (Ut.walk(i, s, "childNodes"), s(i));
    }, tO = function(e, n, a, i) {
      n.styles && n.styles.backgroundColor && JE(i, K5(e, "fontSize"), X5(e, "backgroundColor", bf(n.styles.backgroundColor, a)));
    }, Rw = function(e, n, a, i) {
      pu(n) && (n.inline === "sub" || n.inline === "sup") && (JE(i, K5(e, "fontSize"), X5(e, "fontSize", "")), e.remove(e.select(n.inline === "sup" ? "sub" : "sup", i), !0));
    }, Mw = function(e, n, a, i) {
      eO(n, function(s) {
        pu(s) && eO(e.dom.select(s.inline, i), function(f) {
          !YE(f) || Ob(e, s, a, f, s.exact ? f : null);
        }), ZE(e.dom, s, i);
      });
    }, nO = function(e, n, a, i, s) {
      Xu(e, s.parentNode, a, i) && Ob(e, n, i, s) || n.merge_with_parents && e.dom.getParent(s.parentNode, function(f) {
        if (Xu(e, f, a, i))
          return Ob(e, n, i, s), !0;
      });
    }, T4 = Ut.each, vM = function(e) {
      return $r(e) && !Os(e) && !hf(e) && !ni(e);
    }, dM = function(e, n, a, i) {
      if (im(e) && pu(n)) {
        var s = M1(e.schema), f = GR(O.fromDom(a), function(p) {
          return hf(p.dom);
        });
        return Va(s, i) && lu(O.fromDom(a.parentNode), !1) && !f;
      } else
        return !1;
    }, r_ = function(e, n, a, i) {
      var s = e.formatter.get(n), f = s[0], p = !i && e.selection.isCollapsed(), C = e.dom, k = e.selection, F = function(xt, mt) {
        if (mt === void 0 && (mt = f), Be(mt.onformat) && mt.onformat(xt, mt, a, i), T4(mt.styles, function(At, tn) {
          C.setStyle(xt, tn, bf(At, a));
        }), mt.styles) {
          var Qe = C.getAttrib(xt, "style");
          Qe && C.setAttrib(xt, "data-mce-style", Qe);
        }
        T4(mt.attributes, function(At, tn) {
          C.setAttrib(xt, tn, bf(At, a));
        }), T4(mt.classes, function(At) {
          At = bf(At, a), C.hasClass(xt, At) || C.addClass(xt, At);
        });
      }, q = function(xt, mt) {
        var Qe = !1;
        return T4(xt, function(At) {
          if (!Ys(At))
            return !1;
          if (!(Ct(At.collapsed) && At.collapsed !== p) && C.is(mt, At.selector) && !hf(mt))
            return F(mt, At), Qe = !0, !1;
        }), Qe;
      }, K = function(xt) {
        if (Ge(xt)) {
          var mt = C.create(xt);
          return F(mt), mt;
        } else
          return null;
      }, te = function(xt, mt, Qe) {
        var At = [], tn = !0, Cn = f.inline || f.block, Ar = K(Cn);
        kh(xt, mt, function(Xn) {
          var fn, _r = function(kn) {
            var Kn = !1, On = tn, $n = kn.nodeName.toLowerCase(), rr = kn.parentNode, hn = rr.nodeName.toLowerCase();
            if ($r(kn) && xt.getContentEditable(kn) && (On = tn, tn = xt.getContentEditable(kn) === "true", Kn = !0), to(kn) && !dM(e, f, kn, hn)) {
              fn = null, yf(f) && xt.remove(kn);
              return;
            }
            if (yf(f) && f.wrapper && Xu(e, kn, n, a)) {
              fn = null;
              return;
            }
            if (tn && !Kn && yf(f) && !f.wrapper && x2(e, $n) && jg(e, hn, Cn)) {
              var Zn = xt.rename(kn, Cn);
              F(Zn), At.push(Zn), fn = null;
              return;
            }
            if (Ys(f)) {
              var fa = q(s, kn);
              if (!fa && Ct(rr) && _2(f) && (fa = q(s, rr)), !pu(f) || fa) {
                fn = null;
                return;
              }
            }
            tn && !Kn && jg(e, Cn, $n) && jg(e, hn, Cn) && !(!Qe && Qn(kn) && os(kn.data)) && !hf(kn) && (!pu(f) || !xt.isBlock(kn)) ? (fn || (fn = xt.clone(Ar, !1), kn.parentNode.insertBefore(fn, kn), At.push(fn)), fn.appendChild(kn)) : (fn = null, at(Tn(kn.childNodes), _r), Kn && (tn = On), fn = null);
          };
          at(Xn, _r);
        }), f.links === !0 && at(At, function(Xn) {
          var fn = function(_r) {
            _r.nodeName === "A" && F(_r, f), at(Tn(_r.childNodes), fn);
          };
          fn(Xn);
        }), at(At, function(Xn) {
          var fn = function(Kn) {
            var On = 0;
            return at(Kn.childNodes, function($n) {
              !IT($n) && !Os($n) && On++;
            }), On;
          }, _r = function(Kn) {
            var On = tt(Kn.childNodes, vM).filter(function($n) {
              return VE(xt, $n, f);
            });
            return On.map(function($n) {
              var rr = xt.clone($n, !1);
              return F(rr), xt.replace(rr, Kn, !0), xt.remove($n, !0), rr;
            }).getOr(Kn);
          }, kn = fn(Xn);
          if ((At.length > 1 || !xt.isBlock(Xn)) && kn === 0) {
            xt.remove(Xn, !0);
            return;
          }
          (pu(f) || yf(f) && f.wrapper) && (!f.exact && kn === 1 && (Xn = _r(Xn)), Mw(e, s, a, Xn), nO(e, f, n, a, Xn), tO(xt, f, a, Xn), k4(xt, f, a, Xn), Rw(xt, f, a, Xn), G5(xt, f, a, Xn));
        });
      };
      if (C.getContentEditable(k.getNode()) === "false") {
        i = k.getNode();
        for (var be = 0, we = s.length; be < we; be++) {
          var ke = s[be];
          if (ke.ceFalseOverride && Ys(ke) && C.is(i, ke.selector)) {
            F(i, ke);
            break;
          }
        }
        H2(e, n, i, a);
        return;
      }
      if (f) {
        if (i)
          if ($0(i)) {
            if (!q(s, i)) {
              var Ee = C.createRng();
              Ee.setStartBefore(i), Ee.setEndAfter(i), te(C, ld(e, Ee, s), !0);
            }
          } else
            te(C, i, !0);
        else if (!p || !pu(f) || wf(e).length) {
          var qe = k.getNode(), Le = s[0];
          !e.settings.forced_root_block && Le.defaultBlock && !C.getParent(qe, C.isBlock) && r_(e, Le.defaultBlock), k.setRng(RE(k.getRng())), Xg(k, !0, function() {
            mm(e, function(xt, mt) {
              var Qe = mt ? xt : ld(e, xt, s);
              te(C, Qe, !1);
            });
          }), ex(C, k, k.getRng()), e.nodeChanged();
        } else
          QR(e, n, a);
        q5(n, e);
      }
      H2(e, n, i, a);
    }, rO = function(e) {
      return Fr(e, "vars");
    }, mM = function(e, n) {
      e.set({}), n.on("NodeChange", function(a) {
        Db(n, a.element, e.get());
      }), n.on("FormatApply FormatRemove", function(a) {
        var i = se.from(a.node).map(function(s) {
          return $0(s) ? s : s.startContainer;
        }).bind(function(s) {
          return $r(s) ? se.some(s) : se.from(s.parentElement);
        }).getOrThunk(function() {
          return aO(n);
        });
        Db(n, i, e.get());
      });
    }, aO = function(e) {
      return e.selection.getStart();
    }, a_ = function(e, n, a, i, s) {
      var f = function(C) {
        var k = e.formatter.matchNode(C, a, s != null ? s : {}, i);
        return !De(k);
      }, p = function(C) {
        return $5(e, C, a) ? !0 : i ? !1 : Ct(e.formatter.matchNode(C, a, s, !0));
      };
      return he(n, f, p);
    }, oO = function(e, n) {
      var a = n != null ? n : aO(e);
      return Ie(Ch(e.dom, a), function(i) {
        return $r(i) && !ni(i);
      });
    }, Db = function(e, n, a) {
      var i = oO(e, n);
      _n(a, function(s, f) {
        var p = function(C) {
          var k = a_(e, i, f, C.similar, rO(C) ? C.vars : void 0), F = k.isSome();
          if (C.state.get() !== F) {
            C.state.set(F);
            var q = k.getOr(n);
            rO(C) ? C.callback(F, {
              node: q,
              format: f,
              parents: i
            }) : at(C.callbacks, function(K) {
              return K(F, {
                node: q,
                format: f,
                parents: i
              });
            });
          }
        };
        at([
          s.withSimilar,
          s.withoutSimilar
        ], p), at(s.withVars, p);
      });
    }, gM = function(e, n, a, i, s, f) {
      var p = n.get();
      at(a.split(","), function(C) {
        var k = Mr(p, C).getOrThunk(function() {
          var K = {
            withSimilar: {
              state: ss(!1),
              similar: !0,
              callbacks: []
            },
            withoutSimilar: {
              state: ss(!1),
              similar: !1,
              callbacks: []
            },
            withVars: []
          };
          return p[C] = K, K;
        }), F = function() {
          var K = oO(e);
          return a_(e, K, C, s, f).isSome();
        };
        if (De(f)) {
          var q = s ? k.withSimilar : k.withoutSimilar;
          q.callbacks.push(i), q.callbacks.length === 1 && q.state.set(F());
        } else
          k.withVars.push({
            state: ss(F()),
            similar: s,
            vars: f,
            callback: i
          });
      }), n.set(p);
    }, pM = function(e, n, a) {
      var i = e.get();
      at(n.split(","), function(s) {
        return Mr(i, s).each(function(f) {
          i[s] = {
            withSimilar: sr(sr({}, f.withSimilar), {
              callbacks: Ie(f.withSimilar.callbacks, function(p) {
                return p !== a;
              })
            }),
            withoutSimilar: sr(sr({}, f.withoutSimilar), {
              callbacks: Ie(f.withoutSimilar.callbacks, function(p) {
                return p !== a;
              })
            }),
            withVars: Ie(f.withVars, function(p) {
              return p.callback !== a;
            })
          };
        });
      }), e.set(i);
    }, hM = function(e, n, a, i, s, f) {
      return n.get() === null && mM(n, e), gM(e, n, a, i, s, f), {
        unbind: function() {
          return pM(n, a, i);
        }
      };
    }, bM = function(e, n, a, i) {
      var s = e.formatter.get(n);
      Ow(e, n, a, i) && (!("toggle" in s[0]) || s[0].toggle) ? n_(e, n, a, i) : r_(e, n, a, i);
    }, E4 = function(e, n) {
      var a = n || document, i = a.createDocumentFragment();
      return at(e, function(s) {
        i.appendChild(s.dom);
      }), O.fromDom(i);
    }, _4 = function(e, n, a) {
      return {
        element: e,
        width: n,
        rows: a
      };
    }, o_ = function(e, n) {
      return {
        element: e,
        cells: n
      };
    }, iO = function(e, n) {
      return {
        x: e,
        y: n
      };
    }, A4 = function(e, n) {
      var a = parseInt(fe(e, n), 10);
      return isNaN(a) ? 1 : a;
    }, uO = function(e, n, a, i, s) {
      for (var f = A4(s, "rowspan"), p = A4(s, "colspan"), C = e.rows, k = a; k < a + f; k++) {
        C[k] || (C[k] = o_(o0(i), []));
        for (var F = n; F < n + p; F++) {
          var q = C[k].cells;
          q[F] = k === a && F === n ? s : wi(s);
        }
      }
    }, yM = function(e, n, a) {
      var i = e.rows, s = i[a] ? i[a].cells : [];
      return !!s[n];
    }, wM = function(e, n, a) {
      for (; yM(e, n, a); )
        n++;
      return n;
    }, sO = function(e) {
      return Xe(e, function(n, a) {
        return a.cells.length > n ? a.cells.length : n;
      }, 0);
    }, lO = function(e, n) {
      for (var a = e.rows, i = 0; i < a.length; i++)
        for (var s = a[i].cells, f = 0; f < s.length; f++)
          if (Dr(s[f], n))
            return se.some(iO(f, i));
      return se.none();
    }, cO = function(e, n, a, i, s) {
      for (var f = [], p = e.rows, C = a; C <= s; C++) {
        var k = p[C].cells, F = n < i ? k.slice(n, i + 1) : k.slice(i, n + 1);
        f.push(o_(p[C].element, F));
      }
      return f;
    }, i_ = function(e, n, a) {
      var i = n.x, s = n.y, f = a.x, p = a.y, C = s < p ? cO(e, i, s, f, p) : cO(e, i, p, f, s);
      return _4(e.element, sO(C), C);
    }, u_ = function(e, n) {
      var a = wi(e.element), i = O.fromTag("tbody");
      return Wf(i, n), _i(a, i), a;
    }, fO = function(e) {
      return Ke(e.rows, function(n) {
        var a = Ke(n.cells, function(s) {
          var f = o0(s);
          return Gt(f, "colspan"), Gt(f, "rowspan"), f;
        }), i = wi(n.element);
        return Wf(i, a), i;
      });
    }, O4 = function(e) {
      var n = _4(wi(e), 0, []);
      return at(du(e, "tr"), function(a, i) {
        at(du(a, "td,th"), function(s, f) {
          uO(n, wM(n, f, i), i, a, s);
        });
      }), _4(n.element, sO(n.rows), n.rows);
    }, lc = function(e) {
      return u_(e, fO(e));
    }, Pw = function(e, n, a) {
      return lO(e, n).bind(function(i) {
        return lO(e, a).map(function(s) {
          return i_(e, i, s);
        });
      });
    }, Wh = function(e) {
      return tt(e, function(n) {
        return Oa(n) === "ul" || Oa(n) === "ol";
      });
    }, CM = function(e, n) {
      return tt(e, function(a) {
        return Oa(a) === "li" && oc(a, n);
      }).fold(N([]), function(a) {
        return Wh(e).map(function(i) {
          var s = O.fromTag(Oa(i)), f = Yn(Vo(i), function(p, C) {
            return Z(C, "list-style");
          });
          return da(s, f), [
            O.fromTag("li"),
            s
          ];
        }).getOr([]);
      });
    }, vO = function(e, n) {
      var a = Xe(n, function(i, s) {
        return _i(s, i), s;
      }, e);
      return n.length > 0 ? E4([a]) : a;
    }, dO = function(e) {
      return Ru(e) ? Ho(e).filter(Zl).fold(N([]), function(n) {
        return [
          e,
          n
        ];
      }) : Zl(e) ? [e] : [];
    }, SM = function(e, n) {
      var a = O.fromDom(n.commonAncestorContainer), i = zc(a, e), s = Ie(i, function(C) {
        return Uu(C) || Lr(C);
      }), f = CM(i, n), p = s.concat(f.length ? f : dO(a));
      return Ke(p, wi);
    }, mO = function() {
      return E4([]);
    }, xM = function(e, n) {
      return vO(O.fromDom(n.cloneContents()), SM(e, n));
    }, gO = function(e, n) {
      return Id(n, "table", ne(Dr, e));
    }, D4 = function(e, n) {
      return gO(e, n[0]).bind(function(a) {
        var i = n[0], s = n[n.length - 1], f = O4(a);
        return Pw(f, i, s).map(function(p) {
          return E4([lc(p)]);
        });
      }).getOrThunk(mO);
    }, pO = function(e, n) {
      return n.length > 0 && n[0].collapsed ? mO() : xM(e, n[0]);
    }, hO = function(e, n) {
      var a = dv(n, e);
      return a.length > 0 ? D4(e, a) : pO(e, n);
    }, B4 = function(e) {
      return e.replace(/^[ \f\n\r\t\v]+/, "");
    }, R4 = function(e, n) {
      return n >= 0 && n < e.length && sd(e.charAt(n));
    }, bO = function(e, n) {
      var a = Ac(e.innerText);
      return n ? B4(a) : a;
    }, kM = function(e) {
      return e.map(function(n) {
        return n.nodeName;
      }).getOr("div").toLowerCase();
    }, TM = function(e) {
      return se.from(e.selection.getRng()).map(function(n) {
        var a = se.from(e.dom.getParent(n.commonAncestorContainer, e.dom.isBlock)), i = e.getBody(), s = kM(a), f = br.browser.isIE() && s !== "pre", p = e.dom.add(i, s, {
          "data-mce-bogus": "all",
          style: "overflow: hidden; opacity: 0;"
        }, n.cloneContents()), C = bO(p, f), k = Ac(p.textContent);
        if (e.dom.remove(p), R4(k, 0) || R4(k, k.length - 1)) {
          var F = a.getOr(i), q = bO(F, f), K = q.indexOf(C);
          if (K === -1)
            return C;
          var te = R4(q, K - 1), be = R4(q, K + C.length);
          return (te ? " " : "") + C + (be ? " " : "");
        } else
          return C;
      }).getOr("");
    }, EM = function(e, n) {
      var a = e.selection.getRng(), i = e.dom.create("body"), s = e.selection.getSel(), f = ub(e, B2(s)), p = n.contextual ? hO(O.fromDom(e.getBody()), f).dom : a.cloneContents();
      return p && i.appendChild(p), e.selection.serializer.serialize(i, n);
    }, _M = function(e, n) {
      return sr(sr({}, e), {
        format: n,
        get: !0,
        selection: !0
      });
    }, AM = function(e, n, a) {
      a === void 0 && (a = {});
      var i = _M(a, n), s = e.fire("BeforeGetContent", i);
      if (s.isDefaultPrevented())
        return e.fire("GetContent", s), s.content;
      if (s.format === "text")
        return TM(e);
      s.getInner = !0;
      var f = EM(e, s);
      return s.format === "tree" ? f : (s.content = e.selection.isCollapsed() ? "" : f, e.fire("GetContent", s), s.content);
    }, s_ = 0, yO = 1, wO = 2, OM = function(e, n) {
      var a = e.length + n.length + 2, i = new Array(a), s = new Array(a), f = function(q, K, te) {
        return {
          start: q,
          end: K,
          diag: te
        };
      }, p = function(q, K, te, be, we) {
        var ke = k(q, K, te, be);
        if (ke === null || ke.start === K && ke.diag === K - be || ke.end === q && ke.diag === q - te)
          for (var Ee = q, qe = te; Ee < K || qe < be; )
            Ee < K && qe < be && e[Ee] === n[qe] ? (we.push([
              s_,
              e[Ee]
            ]), ++Ee, ++qe) : K - q > be - te ? (we.push([
              wO,
              e[Ee]
            ]), ++Ee) : (we.push([
              yO,
              n[qe]
            ]), ++qe);
        else {
          p(q, ke.start, te, ke.start - ke.diag, we);
          for (var Le = ke.start; Le < ke.end; ++Le)
            we.push([
              s_,
              e[Le]
            ]);
          p(ke.end, K, ke.end - ke.diag, be, we);
        }
      }, C = function(q, K, te, be) {
        for (var we = q; we - K < be && we < te && e[we] === n[we - K]; )
          ++we;
        return f(q, we, K);
      }, k = function(q, K, te, be) {
        var we = K - q, ke = be - te;
        if (we === 0 || ke === 0)
          return null;
        var Ee = we - ke, qe = ke + we, Le = (qe % 2 === 0 ? qe : qe + 1) / 2;
        i[1 + Le] = q, s[1 + Le] = K + 1;
        var xt, mt, Qe, At, tn;
        for (xt = 0; xt <= Le; ++xt) {
          for (mt = -xt; mt <= xt; mt += 2) {
            for (Qe = mt + Le, mt === -xt || mt !== xt && i[Qe - 1] < i[Qe + 1] ? i[Qe] = i[Qe + 1] : i[Qe] = i[Qe - 1] + 1, At = i[Qe], tn = At - q + te - mt; At < K && tn < be && e[At] === n[tn]; )
              i[Qe] = ++At, ++tn;
            if (Ee % 2 !== 0 && Ee - xt <= mt && mt <= Ee + xt && s[Qe - Ee] <= i[Qe])
              return C(s[Qe - Ee], mt + q - te, K, be);
          }
          for (mt = Ee - xt; mt <= Ee + xt; mt += 2) {
            for (Qe = mt + Le - Ee, mt === Ee - xt || mt !== Ee + xt && s[Qe + 1] <= s[Qe - 1] ? s[Qe] = s[Qe + 1] - 1 : s[Qe] = s[Qe - 1], At = s[Qe] - 1, tn = At - q + te - mt; At >= q && tn >= te && e[At] === n[tn]; )
              s[Qe] = At--, tn--;
            if (Ee % 2 === 0 && -xt <= mt && mt <= xt && s[Qe] <= i[Qe + Ee])
              return C(s[Qe], mt + q - te, K, be);
          }
        }
      }, F = [];
      return p(0, e.length, 0, n.length, F), F;
    }, CO = function(e) {
      return $r(e) ? e.outerHTML : Qn(e) ? dl.encodeRaw(e.data, !1) : Jf(e) ? "<!--" + e.data + "-->" : "";
    }, l_ = function(e) {
      var n, a = document.createElement("div"), i = document.createDocumentFragment();
      for (e && (a.innerHTML = e); n = a.firstChild; )
        i.appendChild(n);
      return i;
    }, DM = function(e, n, a) {
      var i = l_(n);
      if (e.hasChildNodes() && a < e.childNodes.length) {
        var s = e.childNodes[a];
        s.parentNode.insertBefore(i, s);
      } else
        e.appendChild(i);
    }, Bb = function(e, n) {
      if (e.hasChildNodes() && n < e.childNodes.length) {
        var a = e.childNodes[n];
        a.parentNode.removeChild(a);
      }
    }, SO = function(e, n) {
      var a = 0;
      at(e, function(i) {
        i[0] === s_ ? a++ : i[0] === yO ? (DM(n, i[1], a), a++) : i[0] === wO && Bb(n, a);
      });
    }, Ui = function(e) {
      return Ie(Ke(Tn(e.childNodes), CO), function(n) {
        return n.length > 0;
      });
    }, BM = function(e, n) {
      var a = Ke(Tn(n.childNodes), CO);
      return SO(OM(a, e), n), n;
    }, RM = pi(function() {
      return document.implementation.createHTMLDocument("undo");
    }), MM = function(e) {
      return e.indexOf("</iframe>") !== -1;
    }, PM = function(e) {
      return {
        type: "fragmented",
        fragments: e,
        content: "",
        bookmark: null,
        beforeBookmark: null
      };
    }, Of = function(e) {
      return {
        type: "complete",
        fragments: null,
        content: e,
        bookmark: null,
        beforeBookmark: null
      };
    }, Rb = function(e) {
      var n = Ui(e.getBody()), a = Qt(n, function(s) {
        var f = Gx(e.serializer, s);
        return f.length > 0 ? [f] : [];
      }), i = a.join("");
      return MM(i) ? PM(a) : Of(i);
    }, qh = function(e, n, a) {
      var i = a ? n.beforeBookmark : n.bookmark;
      n.type === "fragmented" ? BM(n.fragments, e.getBody()) : e.setContent(n.content, {
        format: "raw",
        no_selection: Ct(i) && GS(i) ? !i.isFakeCaret : !0
      }), e.selection.moveToBookmark(i);
    }, Gh = function(e) {
      return e.type === "fragmented" ? e.fragments.join("") : e.content;
    }, M4 = function(e) {
      var n = O.fromTag("body", RM());
      return fs(n, Gh(e)), at(du(n, "*[data-mce-bogus]"), Gf), cs(n);
    }, NM = function(e, n) {
      return Gh(e) === Gh(n);
    }, IM = function(e, n) {
      return M4(e) === M4(n);
    }, km = function(e, n) {
      return !e || !n ? !1 : NM(e, n) ? !0 : IM(e, n);
    }, bp = function(e) {
      return e.get() === 0;
    }, Tm = function(e, n, a) {
      bp(a) && (e.typing = n);
    }, P4 = function(e, n) {
      e.typing && (Tm(e, !1, n), e.add());
    }, FM = function(e) {
      e.typing && (e.typing = !1, e.add());
    }, c_ = function(e, n, a) {
      bp(n) && a.set(SS(e.selection));
    }, xO = function(e, n, a, i, s, f, p) {
      var C = Rb(e);
      if (f = f || {}, f = Ut.extend(f, C), bp(i) === !1 || e.removed)
        return null;
      var k = n.data[a.get()];
      if (e.fire("BeforeAddUndo", {
        level: f,
        lastLevel: k,
        originalEvent: p
      }).isDefaultPrevented() || k && km(k, f))
        return null;
      n.data[a.get()] && s.get().each(function(te) {
        n.data[a.get()].beforeBookmark = te;
      });
      var F = bh(e);
      if (F && n.data.length > F) {
        for (var q = 0; q < n.data.length - 1; q++)
          n.data[q] = n.data[q + 1];
        n.data.length--, a.set(n.data.length);
      }
      f.bookmark = SS(e.selection), a.get() < n.data.length - 1 && (n.data.length = a.get() + 1), n.data.push(f), a.set(n.data.length - 1);
      var K = {
        level: f,
        lastLevel: k,
        originalEvent: p
      };
      return a.get() > 0 ? (e.setDirty(!0), e.fire("AddUndo", K), e.fire("change", K)) : e.fire("AddUndo", K), f;
    }, kO = function(e, n, a) {
      n.data = [], a.set(0), n.typing = !1, e.fire("ClearUndos");
    }, $M = function(e, n, a, i, s) {
      if (n.transact(i)) {
        var f = n.data[a.get()].bookmark, p = n.data[a.get() - 1];
        qh(e, p, !0), n.transact(s) && (n.data[a.get() - 1].beforeBookmark = f);
      }
    }, LM = function(e, n, a) {
      var i;
      return n.get() < a.length - 1 && (n.set(n.get() + 1), i = a[n.get()], qh(e, i, !1), e.setDirty(!0), e.fire("Redo", { level: i })), i;
    }, TO = function(e, n, a, i) {
      var s;
      return n.typing && (n.add(), n.typing = !1, Tm(n, !1, a)), i.get() > 0 && (i.set(i.get() - 1), s = n.data[i.get()], qh(e, s, !0), e.setDirty(!0), e.fire("Undo", { level: s })), s;
    }, zM = function(e) {
      e.clear(), e.add();
    }, HM = function(e, n, a) {
      return a.get() > 0 || n.typing && n.data[0] && !km(Rb(e), n.data[0]);
    }, VM = function(e, n) {
      return n.get() < e.data.length - 1 && !e.typing;
    }, UM = function(e, n, a) {
      return P4(e, n), e.beforeChange(), e.ignore(a), e.add();
    }, jM = function(e, n) {
      try {
        e.set(e.get() + 1), n();
      } finally {
        e.set(e.get() - 1);
      }
    }, EO = function(e, n) {
      var a = e.dom, i = Ct(n) ? n : e.getBody();
      De(e.hasVisual) && (e.hasVisual = PS(e)), at(a.select("table,a", i), function(s) {
        switch (s.nodeName) {
          case "TABLE":
            var f = pT(e), p = a.getAttrib(s, "border");
            (!p || p === "0") && e.hasVisual ? a.addClass(s, f) : a.removeClass(s, f);
            break;
          case "A":
            if (!a.getAttrib(s, "href")) {
              var C = a.getAttrib(s, "name") || s.id, k = u2(e);
              C && e.hasVisual ? a.addClass(s, k) : a.removeClass(s, k);
            }
            break;
        }
      }), e.fire("VisualAid", {
        element: n,
        hasVisual: e.hasVisual
      });
    }, _O = function(e) {
      return {
        undoManager: {
          beforeChange: function(n, a) {
            return c_(e, n, a);
          },
          add: function(n, a, i, s, f, p) {
            return xO(e, n, a, i, s, f, p);
          },
          undo: function(n, a, i) {
            return TO(e, n, a, i);
          },
          redo: function(n, a) {
            return LM(e, n, a);
          },
          clear: function(n, a) {
            return kO(e, n, a);
          },
          reset: function(n) {
            return zM(n);
          },
          hasUndo: function(n, a) {
            return HM(e, n, a);
          },
          hasRedo: function(n, a) {
            return VM(n, a);
          },
          transact: function(n, a, i) {
            return UM(n, a, i);
          },
          ignore: function(n, a) {
            return jM(n, a);
          },
          extra: function(n, a, i, s) {
            return $M(e, n, a, i, s);
          }
        },
        formatter: {
          match: function(n, a, i, s) {
            return Ow(e, n, a, i, s);
          },
          matchAll: function(n, a) {
            return UE(e, n, a);
          },
          matchNode: function(n, a, i, s) {
            return Xu(e, n, a, i, s);
          },
          canApply: function(n) {
            return XR(e, n);
          },
          closest: function(n) {
            return jE(e, n);
          },
          apply: function(n, a, i) {
            return r_(e, n, a, i);
          },
          remove: function(n, a, i, s) {
            return n_(e, n, a, i, s);
          },
          toggle: function(n, a, i) {
            return bM(e, n, a, i);
          },
          formatChanged: function(n, a, i, s, f) {
            return hM(e, n, a, i, s, f);
          }
        },
        editor: {
          getContent: function(n, a) {
            return db(e, n, a);
          },
          setContent: function(n, a) {
            return qR(e, n, a);
          },
          insertContent: function(n, a) {
            return HR(e, n, a);
          },
          addVisual: function(n) {
            return EO(e, n);
          }
        },
        selection: {
          getContent: function(n, a) {
            return AM(e, n, a);
          }
        },
        raw: {
          getModel: function() {
            return se.none();
          }
        }
      };
    }, Nw = function(e) {
      var n = function(C) {
        return ze(C) ? C : {};
      }, a = e.undoManager, i = e.formatter, s = e.editor, f = e.selection, p = e.raw;
      return {
        undoManager: {
          beforeChange: a.beforeChange,
          add: a.add,
          undo: a.undo,
          redo: a.redo,
          clear: a.clear,
          reset: a.reset,
          hasUndo: a.hasUndo,
          hasRedo: a.hasRedo,
          transact: function(C, k, F) {
            return a.transact(F);
          },
          ignore: function(C, k) {
            return a.ignore(k);
          },
          extra: function(C, k, F, q) {
            return a.extra(F, q);
          }
        },
        formatter: {
          match: function(C, k, F, q) {
            return i.match(C, n(k), q);
          },
          matchAll: i.matchAll,
          matchNode: i.matchNode,
          canApply: function(C) {
            return i.canApply(C);
          },
          closest: function(C) {
            return i.closest(C);
          },
          apply: function(C, k, F) {
            return i.apply(C, n(k));
          },
          remove: function(C, k, F, q) {
            return i.remove(C, n(k));
          },
          toggle: function(C, k, F) {
            return i.toggle(C, n(k));
          },
          formatChanged: function(C, k, F, q, K) {
            return i.formatChanged(k, F, q, K);
          }
        },
        editor: {
          getContent: function(C, k) {
            return s.getContent(C);
          },
          setContent: function(C, k) {
            return s.setContent(C, k);
          },
          insertContent: function(C, k) {
            return s.insertContent(C);
          },
          addVisual: s.addVisual
        },
        selection: {
          getContent: function(C, k) {
            return f.getContent(k);
          }
        },
        raw: {
          getModel: function() {
            return se.some(p.getRawModel());
          }
        }
      };
    }, AO = function() {
      var e = N(null), n = N("");
      return {
        undoManager: {
          beforeChange: xe,
          add: e,
          undo: e,
          redo: e,
          clear: xe,
          reset: xe,
          hasUndo: Me,
          hasRedo: Me,
          transact: e,
          ignore: xe,
          extra: xe
        },
        formatter: {
          match: Me,
          matchAll: N([]),
          matchNode: N(void 0),
          canApply: Me,
          closest: n,
          apply: xe,
          remove: xe,
          toggle: xe,
          formatChanged: N({ unbind: xe })
        },
        editor: {
          getContent: n,
          setContent: n,
          insertContent: xe,
          addVisual: xe
        },
        selection: { getContent: n },
        raw: { getModel: N(se.none()) }
      };
    }, Em = function(e) {
      return Fr(e.plugins, "rtc");
    }, OO = function(e) {
      return Mr(e.plugins, "rtc").bind(function(n) {
        return se.from(n.setup);
      });
    }, WM = function(e) {
      var n = e;
      return OO(e).fold(function() {
        return n.rtcInstance = _O(e), se.none();
      }, function(a) {
        return n.rtcInstance = AO(), se.some(function() {
          return a().then(function(i) {
            return n.rtcInstance = Nw(i), i.rtc.isRemote;
          });
        });
      });
    }, N4 = function(e) {
      return e.rtcInstance ? e.rtcInstance : _O(e);
    }, bu = function(e) {
      var n = e.rtcInstance;
      if (n)
        return n;
      throw new Error("Failed to get RTC instance not yet initialized.");
    }, qM = function(e, n, a) {
      bu(e).undoManager.beforeChange(n, a);
    }, DO = function(e, n, a, i, s, f, p) {
      return bu(e).undoManager.add(n, a, i, s, f, p);
    }, BO = function(e, n, a, i) {
      return bu(e).undoManager.undo(n, a, i);
    }, RO = function(e, n, a) {
      return bu(e).undoManager.redo(n, a);
    }, MO = function(e, n, a) {
      bu(e).undoManager.clear(n, a);
    }, PO = function(e, n) {
      bu(e).undoManager.reset(n);
    }, GM = function(e, n, a) {
      return bu(e).undoManager.hasUndo(n, a);
    }, KM = function(e, n, a) {
      return bu(e).undoManager.hasRedo(n, a);
    }, XM = function(e, n, a, i) {
      return bu(e).undoManager.transact(n, a, i);
    }, YM = function(e, n, a) {
      bu(e).undoManager.ignore(n, a);
    }, f_ = function(e, n, a, i, s) {
      bu(e).undoManager.extra(n, a, i, s);
    }, Iw = function(e, n, a, i, s) {
      return bu(e).formatter.match(n, a, i, s);
    }, NO = function(e, n, a) {
      return bu(e).formatter.matchAll(n, a);
    }, IO = function(e, n, a, i, s) {
      return bu(e).formatter.matchNode(n, a, i, s);
    }, I4 = function(e, n) {
      return bu(e).formatter.canApply(n);
    }, ZM = function(e, n) {
      return bu(e).formatter.closest(n);
    }, JM = function(e, n, a, i) {
      bu(e).formatter.apply(n, a, i);
    }, yp = function(e, n, a, i, s) {
      bu(e).formatter.remove(n, a, i, s);
    }, v_ = function(e, n, a, i) {
      bu(e).formatter.toggle(n, a, i);
    }, FO = function(e, n, a, i, s, f) {
      return bu(e).formatter.formatChanged(n, a, i, s, f);
    }, Fw = function(e, n, a) {
      return N4(e).editor.getContent(n, a);
    }, $O = function(e, n, a) {
      return N4(e).editor.setContent(n, a);
    }, LO = function(e, n, a) {
      return N4(e).editor.insertContent(n, a);
    }, zO = function(e, n, a) {
      return bu(e).selection.getContent(n, a);
    }, HO = function(e, n) {
      return bu(e).editor.addVisual(n);
    }, QM = function(e, n) {
      n === void 0 && (n = {});
      var a = n.format ? n.format : "html";
      return zO(e, a, n);
    }, VO = function(e) {
      return e.dom.length === 0 ? (Yo(e), se.none()) : se.some(e);
    }, e7 = function(e, n) {
      return e.filter(function(a) {
        return vd.isBookmarkNode(a.dom);
      }).bind(n ? il : Uf);
    }, d_ = function(e, n, a, i) {
      var s = e.dom, f = n.dom, p = i ? s.length : f.length;
      i ? (u(s, f, !1, !i), a.setStart(f, p)) : (u(f, s, !1, !i), a.setEnd(f, p));
    }, t7 = function(e, n) {
      Ho(e).each(function(a) {
        var i = e.dom;
        n && yb(a, zt(i, 0)) ? Hh(i, 0) : !n && wb(a, zt(i, i.length)) && Sb(i, i.length);
      });
    }, UO = function(e, n, a, i) {
      e.bind(function(s) {
        var f = i ? Sb : Hh;
        return f(s.dom, i ? s.dom.length : 0), n.filter(No).map(function(p) {
          return d_(s, p, a, i);
        });
      }).orThunk(function() {
        var s = e7(n, i).or(n).filter(No);
        return s.map(function(f) {
          return t7(f, i);
        });
      });
    }, $w = function(e, n) {
      var a = se.from(n.firstChild).map(O.fromDom), i = se.from(n.lastChild).map(O.fromDom);
      e.deleteContents(), e.insertNode(n);
      var s = a.bind(Uf).filter(No).bind(VO), f = i.bind(il).filter(No).bind(VO);
      UO(s, a, e, !0), UO(f, i, e, !1), e.collapse(!1);
    }, m_ = function(e, n) {
      return sr(sr({ format: "html" }, e), {
        set: !0,
        selection: !0,
        content: n
      });
    }, n7 = function(e, n) {
      if (n.format !== "raw") {
        var a = e.selection.getRng(), i = e.dom.getParent(a.commonAncestorContainer, e.dom.isBlock), s = i ? { context: i.nodeName.toLowerCase() } : {}, f = e.parser.parse(n.content, sr(sr({
          isRootContent: !0,
          forced_root_block: !1
        }, s), n));
        return xm({ validate: e.validate }, e.schema).serialize(f);
      } else
        return n.content;
    }, jO = function(e, n, a) {
      a === void 0 && (a = {});
      var i = m_(a, n), s = i;
      if (!i.no_events) {
        var f = e.fire("BeforeSetContent", i);
        if (f.isDefaultPrevented()) {
          e.fire("SetContent", f);
          return;
        } else
          s = f;
      }
      s.content = n7(e, s);
      var p = e.selection.getRng();
      $w(p, p.createContextualFragment(s.content)), e.selection.setRng(p), Dh(e, p), s.no_events || e.fire("SetContent", s);
    }, WO = function(e, n, a) {
      if (e && Fr(e, n)) {
        var i = Ie(e[n], function(s) {
          return s !== a;
        });
        i.length === 0 ? delete e[n] : e[n] = i;
      }
    };
    function F4(e, n) {
      var a, i, s = function(p, C) {
        return tt(C, function(k) {
          return e.is(k, p);
        });
      }, f = function(p) {
        return e.getParents(p, null, e.getRoot());
      };
      return {
        selectorChangedWithUnbind: function(p, C) {
          return a || (a = {}, i = {}, n.on("NodeChange", function(k) {
            var F = k.element, q = f(F), K = {};
            Ut.each(a, function(te, be) {
              s(be, q).each(function(we) {
                i[be] || (at(te, function(ke) {
                  ke(!0, {
                    node: we,
                    selector: be,
                    parents: q
                  });
                }), i[be] = te), K[be] = te;
              });
            }), Ut.each(i, function(te, be) {
              K[be] || (delete i[be], Ut.each(te, function(we) {
                we(!1, {
                  node: F,
                  selector: be,
                  parents: q
                });
              }));
            });
          })), a[p] || (a[p] = []), a[p].push(C), s(p, f(n.selection.getStart())).each(function() {
            i[p] = a[p];
          }), {
            unbind: function() {
              WO(a, p, C), WO(i, p, C);
            }
          };
        }
      };
    }
    var g_ = function(e) {
      return !!e.select;
    }, qO = function(e) {
      return !!(e && e.ownerDocument) && $a(O.fromDom(e.ownerDocument), O.fromDom(e));
    }, tu = function(e) {
      return e ? g_(e) ? !0 : qO(e.startContainer) && qO(e.endContainer) : !1;
    }, GO = function(e, n, a, i) {
      var s, f, p = F4(e, i).selectorChangedWithUnbind, C = function(hn, Zn) {
        var fa = e.createRng();
        Ct(hn) && Ct(Zn) ? (fa.setStart(hn, Zn), fa.setEnd(hn, Zn), xt(fa), Ee(!1)) : (cd(e, fa, i.getBody(), !0), xt(fa));
      }, k = function(hn) {
        return QM(i, hn);
      }, F = function(hn, Zn) {
        return jO(i, hn, Zn);
      }, q = function(hn) {
        return Sm(i.getBody(), Le(), hn);
      }, K = function(hn) {
        return np(i.getBody(), Le(), hn);
      }, te = function(hn, Zn) {
        return $n.getBookmark(hn, Zn);
      }, be = function(hn) {
        return $n.moveToBookmark(hn);
      }, we = function(hn, Zn) {
        return lE(e, hn, Zn).each(xt), hn;
      }, ke = function() {
        var hn = Le(), Zn = qe();
        return !hn || hn.item ? !1 : hn.compareEndPoints ? hn.compareEndPoints("StartToEnd", hn) === 0 : !Zn || hn.collapsed;
      }, Ee = function(hn) {
        var Zn = Le();
        Zn.collapse(!!hn), xt(Zn);
      }, qe = function() {
        return n.getSelection ? n.getSelection() : n.document.selection;
      }, Le = function() {
        var hn, Zn, fa, Ia = function(Wo, Rs, tl) {
          try {
            return Rs.compareBoundaryPoints(Wo, tl);
          } catch {
            return -1;
          }
        }, Pa = n.document;
        if (i.bookmark !== void 0 && Il(i) === !1) {
          var yu = Qg(i);
          if (yu.isSome())
            return yu.map(function(Wo) {
              return ub(i, [Wo])[0];
            }).getOr(Pa.createRange());
        }
        try {
          (hn = qe()) && !Qc(hn.anchorNode) && (hn.rangeCount > 0 ? Zn = hn.getRangeAt(0) : Zn = hn.createRange ? hn.createRange() : Pa.createRange(), Zn = ub(i, [Zn])[0]);
        } catch {
        }
        return Zn || (Zn = Pa.createRange ? Pa.createRange() : Pa.body.createTextRange()), Zn.setStart && Zn.startContainer.nodeType === 9 && Zn.collapsed && (fa = e.getRoot(), Zn.setStart(fa, 0), Zn.setEnd(fa, 0)), s && f && (Ia(Zn.START_TO_START, Zn, s) === 0 && Ia(Zn.END_TO_END, Zn, s) === 0 ? Zn = f : (s = null, f = null)), Zn;
      }, xt = function(hn, Zn) {
        var fa;
        if (!!tu(hn)) {
          var Ia = g_(hn) ? hn : null;
          if (Ia) {
            f = null;
            try {
              Ia.select();
            } catch {
            }
            return;
          }
          var Pa = qe(), yu = i.fire("SetSelectionRange", {
            range: hn,
            forward: Zn
          });
          if (hn = yu.range, Pa) {
            f = hn;
            try {
              Pa.removeAllRanges(), Pa.addRange(hn);
            } catch {
            }
            Zn === !1 && Pa.extend && (Pa.collapse(hn.endContainer, hn.endOffset), Pa.extend(hn.startContainer, hn.startOffset)), s = Pa.rangeCount > 0 ? Pa.getRangeAt(0) : null;
          }
          !hn.collapsed && hn.startContainer === hn.endContainer && Pa.setBaseAndExtent && !br.ie && hn.endOffset - hn.startOffset < 2 && hn.startContainer.hasChildNodes() && (fa = hn.startContainer.childNodes[hn.startOffset], fa && fa.tagName === "IMG" && (Pa.setBaseAndExtent(hn.startContainer, hn.startOffset, hn.endContainer, hn.endOffset), (Pa.anchorNode !== hn.startContainer || Pa.focusNode !== hn.endContainer) && Pa.setBaseAndExtent(fa, 0, fa, 1))), i.fire("AfterSetSelectionRange", {
            range: hn,
            forward: Zn
          });
        }
      }, mt = function(hn) {
        return F(e.getOuterHTML(hn)), hn;
      }, Qe = function() {
        return Hx(i.getBody(), Le());
      }, At = function(hn, Zn) {
        return ib(e, Le(), hn, Zn);
      }, tn = function() {
        var hn = qe(), Zn = hn == null ? void 0 : hn.anchorNode, fa = hn == null ? void 0 : hn.focusNode;
        if (!hn || !Zn || !fa || Qc(Zn) || Qc(fa))
          return !0;
        var Ia = e.createRng();
        Ia.setStart(Zn, hn.anchorOffset), Ia.collapse(!0);
        var Pa = e.createRng();
        return Pa.setStart(fa, hn.focusOffset), Pa.collapse(!0), Ia.compareBoundaryPoints(Ia.START_TO_START, Pa) <= 0;
      }, Cn = function() {
        var hn = Le(), Zn = qe();
        if (!M2(Zn) && fd(i)) {
          var fa = Y0(e, hn);
          return fa.each(function(Ia) {
            xt(Ia, tn());
          }), fa.getOr(hn);
        }
        return hn;
      }, Ar = function(hn, Zn) {
        return p(hn, Zn), On;
      }, Xn = function() {
        for (var hn, Zn = e.getRoot(); Zn && Zn.nodeName !== "BODY"; ) {
          if (Zn.scrollHeight > Zn.clientHeight) {
            hn = Zn;
            break;
          }
          Zn = Zn.parentNode;
        }
        return hn;
      }, fn = function(hn, Zn) {
        Ct(hn) ? nE(i, hn, Zn) : Dh(i, Le(), Zn);
      }, _r = function(hn, Zn) {
        return xt(j2(hn, Zn, i.getDoc()));
      }, kn = function() {
        var hn = Le();
        return hn.collapsed ? zt.fromRangeStart(hn).getClientRects()[0] : hn.getBoundingClientRect();
      }, Kn = function() {
        n = s = f = null, rr.destroy();
      }, On = {
        bookmarkManager: null,
        controlSelection: null,
        dom: e,
        win: n,
        serializer: a,
        editor: i,
        collapse: Ee,
        setCursorLocation: C,
        getContent: k,
        setContent: F,
        getBookmark: te,
        moveToBookmark: be,
        select: we,
        isCollapsed: ke,
        isForward: tn,
        setNode: mt,
        getNode: Qe,
        getSel: qe,
        setRng: xt,
        getRng: Le,
        getStart: q,
        getEnd: K,
        getSelectedBlocks: At,
        normalize: Cn,
        selectorChanged: Ar,
        selectorChangedWithUnbind: p,
        getScrollContainer: Xn,
        scrollIntoView: fn,
        placeCaretAt: _r,
        getBoundingClientRect: kn,
        destroy: Kn
      }, $n = vd(On), rr = V2(On, i);
      return On.bookmarkManager = $n, On.controlSelection = rr, On;
    }, KO = function(e, n) {
      at(n, function(a) {
        e.attr(a, null);
      });
    }, r7 = function(e, n, a) {
      e.addNodeFilter("font", function(i) {
        at(i, function(s) {
          var f = n.parse(s.attr("style")), p = s.attr("color"), C = s.attr("face"), k = s.attr("size");
          p && (f.color = p), C && (f["font-family"] = C), k && (f["font-size"] = a[parseInt(s.attr("size"), 10) - 1]), s.name = "span", s.attr("style", n.serialize(f)), KO(s, [
            "color",
            "face",
            "size"
          ]);
        });
      });
    }, a7 = function(e, n) {
      e.addNodeFilter("strike", function(a) {
        at(a, function(i) {
          var s = n.parse(i.attr("style"));
          s["text-decoration"] = "line-through", i.name = "span", i.attr("style", n.serialize(s));
        });
      });
    }, XO = function(e, n) {
      var a = tc();
      n.convert_fonts_to_spans && r7(e, a, Ut.explode(n.font_size_legacy_values)), a7(e, a);
    }, o7 = function(e, n) {
      n.inline_styles && XO(e, n);
    }, p_ = function(e) {
      return new Ki(function(n, a) {
        var i = function() {
          a("Cannot convert " + e + " to Blob. Resource might not exist or is inaccessible.");
        };
        try {
          var s = new XMLHttpRequest();
          s.open("GET", e, !0), s.responseType = "blob", s.onload = function() {
            s.status === 200 ? n(s.response) : i();
          }, s.onerror = i, s.send();
        } catch {
          i();
        }
      });
    }, h_ = function(e) {
      var n, a = decodeURIComponent(e).split(","), i = /data:([^;]+)/.exec(a[0]);
      return i && (n = i[1]), {
        type: n,
        data: a[1]
      };
    }, b_ = function(e, n) {
      var a;
      try {
        a = atob(n);
      } catch {
        return se.none();
      }
      for (var i = new Uint8Array(a.length), s = 0; s < i.length; s++)
        i[s] = a.charCodeAt(s);
      return se.some(new Blob([i], { type: e }));
    }, y_ = function(e) {
      return new Ki(function(n) {
        var a = h_(e), i = a.type, s = a.data;
        b_(i, s).fold(function() {
          return n(new Blob([]));
        }, n);
      });
    }, YO = function(e) {
      return e.indexOf("blob:") === 0 ? p_(e) : e.indexOf("data:") === 0 ? y_(e) : null;
    }, i7 = function(e) {
      return new Ki(function(n) {
        var a = new FileReader();
        a.onloadend = function() {
          n(a.result);
        }, a.readAsDataURL(e);
      });
    }, u7 = 0, w_ = function(e) {
      return (e || "blobid") + u7++;
    }, s7 = function(e, n, a, i) {
      var s, f;
      if (n.src.indexOf("blob:") === 0) {
        f = e.getByUri(n.src), f ? a({
          image: n,
          blobInfo: f
        }) : YO(n.src).then(function(F) {
          i7(F).then(function(q) {
            s = h_(q).data, f = e.create(w_(), F, s), e.add(f), a({
              image: n,
              blobInfo: f
            });
          });
        }, function(F) {
          i(F);
        });
        return;
      }
      var p = h_(n.src), C = p.data, k = p.type;
      s = C, f = e.getByData(s, k), f ? a({
        image: n,
        blobInfo: f
      }) : YO(n.src).then(function(F) {
        f = e.create(w_(), F, s), e.add(f), a({
          image: n,
          blobInfo: f
        });
      }, function(F) {
        i(F);
      });
    }, ZO = function(e) {
      return e ? Tn(e.getElementsByTagName("img")) : [];
    }, JO = function(e, n) {
      var a = {}, i = function(s, f) {
        f || (f = Je);
        var p = Ie(ZO(s), function(k) {
          var F = k.src;
          return !br.fileApi || k.hasAttribute("data-mce-bogus") || k.hasAttribute("data-mce-placeholder") || !F || F === br.transparentSrc ? !1 : F.indexOf("blob:") === 0 ? !e.isUploaded(F) && f(k) : F.indexOf("data:") === 0 ? f(k) : !1;
        }), C = Ke(p, function(k) {
          if (a[k.src] !== void 0)
            return new Ki(function(q) {
              a[k.src].then(function(K) {
                if (typeof K == "string")
                  return K;
                q({
                  image: k,
                  blobInfo: K.blobInfo
                });
              });
            });
          var F = new Ki(function(q, K) {
            s7(n, k, q, K);
          }).then(function(q) {
            return delete a[q.image.src], q;
          }).catch(function(q) {
            return delete a[k.src], q;
          });
          return a[k.src] = F, F;
        });
        return Ki.all(C);
      };
      return { findAll: i };
    }, Lw = function(e, n, a, i) {
      var s = e.padd_empty_with_br || n.insert;
      s && a[i.name] ? i.empty().append(new Fl("br", 1)).shortEnded = !0 : i.empty().append(new Fl("#text", 3)).value = Ws;
    }, QO = function(e) {
      return C_(e, "#text") && e.firstChild.value === Ws;
    }, C_ = function(e, n) {
      return e && e.firstChild && e.firstChild === e.lastChild && e.firstChild.name === n;
    }, e6 = function(e, n) {
      var a = e.getElementRule(n.name);
      return a && a.paddEmpty;
    }, Mb = function(e, n, a, i) {
      return i.isEmpty(n, a, function(s) {
        return e6(e, s);
      });
    }, t6 = function(e, n) {
      return e && (Fr(n, e.name) || e.name === "br");
    }, n6 = function(e) {
      return Ct(e.attr("data-mce-bogus"));
    }, l7 = function(e) {
      return e.attr("src") === br.transparentSrc || Ct(e.attr("data-mce-placeholder"));
    }, S_ = function(e, n) {
      if (n.images_dataimg_filter) {
        var a = new Image();
        return a.src = e.attr("src"), _n(e.attributes.map, function(i, s) {
          a.setAttribute(s, i);
        }), n.images_dataimg_filter(a);
      } else
        return !0;
    }, c7 = function(e, n) {
      var a = n.blob_cache, i = function(s) {
        var f = s.attr("src");
        l7(s) || n6(s) || Ux(f).filter(function() {
          return S_(s, n);
        }).bind(function(p) {
          var C = p.type, k = p.data;
          return se.from(a.getByData(k, C)).orThunk(function() {
            return b_(C, k).map(function(F) {
              var q = a.create(w_(), F, k);
              return a.add(q), q;
            });
          });
        }).each(function(p) {
          s.attr("src", p.blobUri());
        });
      };
      a && e.addAttributeFilter("src", function(s) {
        return at(s, i);
      });
    }, $4 = function(e, n) {
      var a = e.schema;
      n.remove_trailing_brs && e.addNodeFilter("br", function(i, s, f) {
        var p, C = i.length, k, F = Ut.extend({}, a.getBlockElements()), q = a.getNonEmptyElements(), K, te, be, we, ke = a.getWhiteSpaceElements(), Ee, qe;
        for (F.body = 1, p = 0; p < C; p++)
          if (k = i[p], K = k.parent, F[k.parent.name] && k === K.lastChild) {
            for (be = k.prev; be; ) {
              if (we = be.name, we !== "span" || be.attr("data-mce-type") !== "bookmark") {
                we === "br" && (k = null);
                break;
              }
              be = be.prev;
            }
            k && (k.remove(), Mb(a, q, ke, K) && (Ee = a.getElementRule(K.name), Ee && (Ee.removeEmpty ? K.remove() : Ee.paddEmpty && Lw(n, f, F, K))));
          } else {
            for (te = k; K && K.firstChild === te && K.lastChild === te && (te = K, !F[K.name]); )
              K = K.parent;
            te === K && n.padd_empty_with_br !== !0 && (qe = new Fl("#text", 3), qe.value = Ws, k.replace(qe));
          }
      }), e.addAttributeFilter("href", function(i) {
        var s = i.length, f = function(k) {
          var F = k.split(" ").filter(function(q) {
            return q.length > 0;
          });
          return F.concat(["noopener"]).sort().join(" ");
        }, p = function(k) {
          var F = k ? Ut.trim(k) : "";
          return /\b(noopener)\b/g.test(F) ? F : f(F);
        };
        if (!n.allow_unsafe_link_target)
          for (; s--; ) {
            var C = i[s];
            C.name === "a" && C.attr("target") === "_blank" && C.attr("rel", p(C.attr("rel")));
          }
      }), n.allow_html_in_named_anchor || e.addAttributeFilter("id,name", function(i) {
        for (var s = i.length, f, p, C, k; s--; )
          if (k = i[s], k.name === "a" && k.firstChild && !k.attr("href")) {
            C = k.parent, f = k.lastChild;
            do
              p = f.prev, C.insert(f, k), f = p;
            while (f);
          }
      }), n.fix_list_elements && e.addNodeFilter("ul,ol", function(i) {
        for (var s = i.length, f, p; s--; )
          if (f = i[s], p = f.parent, p.name === "ul" || p.name === "ol")
            if (f.prev && f.prev.name === "li")
              f.prev.append(f);
            else {
              var C = new Fl("li", 1);
              C.attr("style", "list-style-type: none"), f.wrap(C);
            }
      }), n.validate && a.getValidClasses() && e.addAttributeFilter("class", function(i) {
        for (var s = a.getValidClasses(), f = i.length; f--; ) {
          for (var p = i[f], C = p.attr("class").split(" "), k = "", F = 0; F < C.length; F++) {
            var q = C[F], K = !1, te = s["*"];
            te && te[q] && (K = !0), te = s[p.name], !K && te && te[q] && (K = !0), K && (k && (k += " "), k += q);
          }
          k.length || (k = null), p.attr("class", k);
        }
      }), c7(e, n);
    }, r6 = Ut.makeMap, a6 = Ut.each, o6 = Ut.explode, i6 = Ut.extend, L4 = function(e, n) {
      n === void 0 && (n = ml());
      var a = {}, i = [], s = {}, f = {};
      e = e || {}, e.validate = "validate" in e ? e.validate : !0, e.root_name = e.root_name || "body";
      var p = function(we) {
        for (var ke = r6("tr,td,th,tbody,thead,tfoot,table"), Ee = n.getNonEmptyElements(), qe = n.getWhiteSpaceElements(), Le = n.getTextBlockElements(), xt = n.getSpecialElements(), mt = function($n, rr) {
          if (rr === void 0 && (rr = $n.parent), xt[$n.name])
            $n.empty().remove();
          else {
            for (var hn = $n.children(), Zn = 0, fa = hn; Zn < fa.length; Zn++) {
              var Ia = fa[Zn];
              n.isValidChild(rr.name, Ia.name) || mt(Ia, rr);
            }
            $n.unwrap();
          }
        }, Qe = 0; Qe < we.length; Qe++) {
          var At = we[Qe], tn = void 0, Cn = void 0, Ar = void 0;
          if (!(!At.parent || At.fixed)) {
            if (Le[At.name] && At.parent.name === "li") {
              for (var Xn = At.next; Xn && Le[Xn.name]; ) {
                Xn.name = "li", Xn.fixed = !0, At.parent.insert(Xn, At.parent);
                Xn = Xn.next;
              }
              At.unwrap();
              continue;
            }
            var fn = [At];
            for (tn = At.parent; tn && !n.isValidChild(tn.name, At.name) && !ke[tn.name]; tn = tn.parent)
              fn.push(tn);
            if (tn && fn.length > 1)
              if (n.isValidChild(tn.name, At.name)) {
                fn.reverse(), Cn = C(fn[0].clone());
                for (var _r = Cn, kn = 0; kn < fn.length - 1; kn++) {
                  n.isValidChild(_r.name, fn[kn].name) ? (Ar = C(fn[kn].clone()), _r.append(Ar)) : Ar = _r;
                  for (var Kn = fn[kn].firstChild; Kn && Kn !== fn[kn + 1]; ) {
                    var On = Kn.next;
                    Ar.append(Kn), Kn = On;
                  }
                  _r = Ar;
                }
                Mb(n, Ee, qe, Cn) ? tn.insert(At, fn[0], !0) : (tn.insert(Cn, fn[0], !0), tn.insert(At, Cn)), tn = fn[0], (Mb(n, Ee, qe, tn) || C_(tn, "br")) && tn.empty().remove();
              } else
                mt(At);
            else if (At.parent) {
              if (At.name === "li") {
                var Xn = At.prev;
                if (Xn && (Xn.name === "ul" || Xn.name === "ol")) {
                  Xn.append(At);
                  continue;
                }
                if (Xn = At.next, Xn && (Xn.name === "ul" || Xn.name === "ol")) {
                  Xn.insert(At, Xn.firstChild, !0);
                  continue;
                }
                At.wrap(C(new Fl("ul", 1)));
                continue;
              }
              n.isValidChild(At.parent.name, "div") && n.isValidChild("div", At.name) ? At.wrap(C(new Fl("div", 1))) : mt(At);
            }
          }
        }
      }, C = function(we) {
        var ke = we.name;
        if (ke in a) {
          var Ee = s[ke];
          Ee ? Ee.push(we) : s[ke] = [we];
        }
        for (var qe = i.length; qe--; ) {
          var Le = i[qe].name;
          if (Le in we.attributes.map) {
            var Ee = f[Le];
            Ee ? Ee.push(we) : f[Le] = [we];
          }
        }
        return we;
      }, k = function(we, ke) {
        a6(o6(we), function(Ee) {
          var qe = a[Ee];
          qe || (a[Ee] = qe = []), qe.push(ke);
        });
      }, F = function() {
        var we = [];
        for (var ke in a)
          Fr(a, ke) && we.push({
            name: ke,
            callbacks: a[ke]
          });
        return we;
      }, q = function(we, ke) {
        a6(o6(we), function(Ee) {
          var qe;
          for (qe = 0; qe < i.length; qe++)
            if (i[qe].name === Ee) {
              i[qe].callbacks.push(ke);
              return;
            }
          i.push({
            name: Ee,
            callbacks: [ke]
          });
        });
      }, K = function() {
        return [].concat(i);
      }, te = function(we, ke) {
        var Ee, qe, Le, xt, mt, Qe, At, tn = [], Cn, Ar = function(Dt) {
          return Dt === !1 ? "" : Dt === !0 ? "p" : Dt;
        };
        ke = ke || {}, s = {}, f = {};
        var Xn = i6(r6("script,style,head,html,body,title,meta,param"), n.getBlockElements()), fn = M1(n), _r = n.getNonEmptyElements(), kn = n.children, Kn = e.validate, On = "forced_root_block" in ke ? ke.forced_root_block : e.forced_root_block, $n = Ar(On), rr = n.getWhiteSpaceElements(), hn = /^[ \t\r\n]+/, Zn = /[ \t\r\n]+$/, fa = /[ \t\r\n]+/g, Ia = /^[ \t\r\n]+$/, Pa = Fr(rr, ke.context) || Fr(rr, e.root_name), yu = function() {
          var Dt = gr.firstChild, xn = null, wn = function(kr) {
            kr && (Dt = kr.firstChild, Dt && Dt.type === 3 && (Dt.value = Dt.value.replace(hn, "")), Dt = kr.lastChild, Dt && Dt.type === 3 && (Dt.value = Dt.value.replace(Zn, "")));
          };
          if (!!n.isValidChild(gr.name, $n.toLowerCase())) {
            for (; Dt; ) {
              var yr = Dt.next;
              Dt.type === 3 || Dt.type === 1 && Dt.name !== "p" && !Xn[Dt.name] && !Dt.attr("data-mce-type") ? (xn || (xn = Wo($n, 1), xn.attr(e.forced_root_block_attrs), gr.insert(xn, Dt)), xn.append(Dt)) : (wn(xn), xn = null), Dt = yr;
            }
            wn(xn);
          }
        }, Wo = function(Dt, xn) {
          var wn = new Fl(Dt, xn), yr;
          return Dt in a && (yr = s[Dt], yr ? yr.push(wn) : s[Dt] = [wn]), wn;
        }, Rs = function(Dt) {
          for (var xn = n.getBlockElements(), wn = Dt.prev; wn && wn.type === 3; ) {
            var yr = wn.value.replace(Zn, "");
            if (yr.length > 0) {
              wn.value = yr;
              return;
            }
            var kr = wn.next;
            if (kr) {
              if (kr.type === 3 && kr.value.length) {
                wn = wn.prev;
                continue;
              }
              if (!xn[kr.name] && kr.name !== "script" && kr.name !== "style") {
                wn = wn.prev;
                continue;
              }
            }
            var uo = wn.prev;
            wn.remove(), wn = uo;
          }
        }, tl = function(Dt) {
          var xn = {};
          for (var wn in Dt)
            wn !== "li" && wn !== "p" && (xn[wn] = Dt[wn]);
          return xn;
        }, bn = function(Dt) {
          for (var xn = Dt; Ct(xn); ) {
            if (xn.name in fn)
              return Mb(n, _r, rr, xn);
            xn = xn.parent;
          }
          return !1;
        }, Mn = rp({
          validate: Kn,
          document: e.document,
          allow_html_data_urls: e.allow_html_data_urls,
          allow_svg_data_urls: e.allow_svg_data_urls,
          allow_script_urls: e.allow_script_urls,
          allow_conditional_comments: e.allow_conditional_comments,
          preserve_cdata: e.preserve_cdata,
          self_closing_elements: tl(n.getSelfClosingElements()),
          cdata: function(Dt) {
            Cn.append(Wo("#cdata", 4)).value = Dt;
          },
          text: function(Dt, xn) {
            var wn;
            Pa || (Dt = Dt.replace(fa, " "), t6(Cn.lastChild, Xn) && (Dt = Dt.replace(hn, ""))), Dt.length !== 0 && (wn = Wo("#text", 3), wn.raw = !!xn, Cn.append(wn).value = Dt);
          },
          comment: function(Dt) {
            Cn.append(Wo("#comment", 8)).value = Dt;
          },
          pi: function(Dt, xn) {
            Cn.append(Wo(Dt, 7)).value = xn, Rs(Cn);
          },
          doctype: function(Dt) {
            var xn = Cn.append(Wo("#doctype", 10));
            xn.value = Dt, Rs(Cn);
          },
          start: function(Dt, xn, wn) {
            var yr = Kn ? n.getElementRule(Dt) : {};
            if (yr) {
              var kr = Wo(yr.outputName || Dt, 1);
              kr.attributes = xn, kr.shortEnded = wn, Cn.append(kr);
              var uo = kn[Cn.name];
              uo && kn[kr.name] && !uo[kr.name] && tn.push(kr);
              for (var ji = i.length; ji--; ) {
                var Ii = i[ji].name;
                Ii in xn.map && (Qe = f[Ii], Qe ? Qe.push(kr) : f[Ii] = [kr]);
              }
              Xn[Dt] && Rs(kr), wn || (Cn = kr), !Pa && rr[Dt] && (Pa = !0);
            }
          },
          end: function(Dt) {
            var xn, wn, yr, kr = Kn ? n.getElementRule(Dt) : {};
            if (kr) {
              if (Xn[Dt] && !Pa) {
                if (xn = Cn.firstChild, xn && xn.type === 3)
                  if (wn = xn.value.replace(hn, ""), wn.length > 0)
                    xn.value = wn, xn = xn.next;
                  else
                    for (yr = xn.next, xn.remove(), xn = yr; xn && xn.type === 3; )
                      wn = xn.value, yr = xn.next, (wn.length === 0 || Ia.test(wn)) && (xn.remove(), xn = yr), xn = yr;
                if (xn = Cn.lastChild, xn && xn.type === 3)
                  if (wn = xn.value.replace(Zn, ""), wn.length > 0)
                    xn.value = wn, xn = xn.prev;
                  else
                    for (yr = xn.prev, xn.remove(), xn = yr; xn && xn.type === 3; )
                      wn = xn.value, yr = xn.prev, (wn.length === 0 || Ia.test(wn)) && (xn.remove(), xn = yr), xn = yr;
              }
              Pa && rr[Dt] && (Pa = !1);
              var uo = Mb(n, _r, rr, Cn), ji = Cn.parent;
              kr.paddInEmptyBlock && uo && bn(Cn) ? Lw(e, ke, Xn, Cn) : kr.removeEmpty && uo ? Xn[Cn.name] ? Cn.empty().remove() : Cn.unwrap() : kr.paddEmpty && (QO(Cn) || uo) && Lw(e, ke, Xn, Cn), Cn = ji;
            }
          }
        }, n), gr = Cn = new Fl(ke.context || e.root_name, 11);
        if (Mn.parse(we, ke.format), Kn && tn.length && (ke.context ? ke.invalid = !0 : p(tn)), $n && (gr.name === "body" || ke.isRootContent) && yu(), !ke.invalid) {
          for (At in s)
            if (!!Fr(s, At)) {
              for (Qe = a[At], Ee = s[At], xt = Ee.length; xt--; )
                Ee[xt].parent || Ee.splice(xt, 1);
              for (qe = 0, Le = Qe.length; qe < Le; qe++)
                Qe[qe](Ee, At, ke);
            }
          for (qe = 0, Le = i.length; qe < Le; qe++)
            if (Qe = i[qe], Qe.name in f) {
              for (Ee = f[Qe.name], xt = Ee.length; xt--; )
                Ee[xt].parent || Ee.splice(xt, 1);
              for (xt = 0, mt = Qe.callbacks.length; xt < mt; xt++)
                Qe.callbacks[xt](Ee, Qe.name, ke);
            }
        }
        return gr;
      }, be = {
        schema: n,
        addAttributeFilter: q,
        getAttributeFilters: K,
        addNodeFilter: k,
        getNodeFilters: F,
        filterNode: C,
        parse: te
      };
      return $4(be, e), o7(be, e), be;
    }, f7 = function(e, n, a) {
      e.addAttributeFilter("data-mce-tabindex", function(i, s) {
        for (var f = i.length; f--; ) {
          var p = i[f];
          p.attr("tabindex", p.attr("data-mce-tabindex")), p.attr(s, null);
        }
      }), e.addAttributeFilter("src,href,style", function(i, s) {
        for (var f = "data-mce-" + s, p = n.url_converter, C = n.url_converter_scope, k = i.length; k--; ) {
          var F = i[k], q = F.attr(f);
          q !== void 0 ? (F.attr(s, q.length > 0 ? q : null), F.attr(f, null)) : (q = F.attr(s), s === "style" ? q = a.serializeStyle(a.parseStyle(q), F.name) : p && (q = p.call(C, q, s, F.name)), F.attr(s, q.length > 0 ? q : null));
        }
      }), e.addAttributeFilter("class", function(i) {
        for (var s = i.length; s--; ) {
          var f = i[s], p = f.attr("class");
          p && (p = f.attr("class").replace(/(?:^|\s)mce-item-\w+(?!\S)/g, ""), f.attr("class", p.length > 0 ? p : null));
        }
      }), e.addAttributeFilter("data-mce-type", function(i, s, f) {
        for (var p = i.length; p--; ) {
          var C = i[p];
          if (C.attr("data-mce-type") === "bookmark" && !f.cleanup) {
            var k = se.from(C.firstChild).exists(function(F) {
              return !os(F.value);
            });
            k ? C.unwrap() : C.remove();
          }
        }
      }), e.addNodeFilter("noscript", function(i) {
        for (var s = i.length; s--; ) {
          var f = i[s].firstChild;
          f && (f.value = dl.decode(f.value));
        }
      }), e.addNodeFilter("script,style", function(i, s) {
        for (var f = function(q) {
          return q.replace(/(<!--\[CDATA\[|\]\]-->)/g, `
`).replace(/^[\r\n]*|[\r\n]*$/g, "").replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, "").replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, "");
        }, p = i.length; p--; ) {
          var C = i[p], k = C.firstChild ? C.firstChild.value : "";
          if (s === "script") {
            var F = C.attr("type");
            F && C.attr("type", F === "mce-no/type" ? null : F.replace(/^mce\-/, "")), n.element_format === "xhtml" && k.length > 0 && (C.firstChild.value = `// <![CDATA[
` + f(k) + `
// ]]>`);
          } else
            n.element_format === "xhtml" && k.length > 0 && (C.firstChild.value = `<!--
` + f(k) + `
-->`);
        }
      }), e.addNodeFilter("#comment", function(i) {
        for (var s = i.length; s--; ) {
          var f = i[s];
          n.preserve_cdata && f.value.indexOf("[CDATA[") === 0 ? (f.name = "#cdata", f.type = 4, f.value = a.decode(f.value.replace(/^\[CDATA\[|\]\]$/g, ""))) : f.value.indexOf("mce:protected ") === 0 && (f.name = "#text", f.type = 3, f.raw = !0, f.value = unescape(f.value).substr(14));
        }
      }), e.addNodeFilter("xml:namespace,input", function(i, s) {
        for (var f = i.length; f--; ) {
          var p = i[f];
          p.type === 7 ? p.remove() : p.type === 1 && s === "input" && !p.attr("type") && p.attr("type", "text");
        }
      }), e.addAttributeFilter("data-mce-type", function(i) {
        at(i, function(s) {
          s.attr("data-mce-type") === "format-caret" && (s.isEmpty(e.schema.getNonEmptyElements()) ? s.remove() : s.unwrap());
        });
      }), e.addAttributeFilter("data-mce-src,data-mce-href,data-mce-style,data-mce-selected,data-mce-expando,data-mce-type,data-mce-resize,data-mce-placeholder", function(i, s) {
        for (var f = i.length; f--; )
          i[f].attr(s, null);
      });
    }, v7 = function(e) {
      var n = function(s) {
        return s && s.name === "br";
      }, a = e.lastChild;
      if (n(a)) {
        var i = a.prev;
        n(i) && (a.remove(), i.remove());
      }
    }, d7 = function(e, n, a) {
      var i, s = e.dom, f = n.cloneNode(!0), p = document.implementation;
      if (p.createHTMLDocument) {
        var C = p.createHTMLDocument("");
        Ut.each(f.nodeName === "BODY" ? f.childNodes : [f], function(k) {
          C.body.appendChild(C.importNode(k, !0));
        }), f.nodeName !== "BODY" ? f = C.body.firstChild : f = C.body, i = s.doc, s.doc = C;
      }
      return HT(e, sr(sr({}, a), { node: f })), i && (s.doc = i), f;
    }, m7 = function(e, n) {
      return e && e.hasEventListeners("PreProcess") && !n.no_events;
    }, u6 = function(e, n, a) {
      return m7(e, a) ? d7(e, n, a) : n;
    }, g7 = function(e, n, a) {
      Ut.inArray(n, a) === -1 && (e.addAttributeFilter(a, function(i, s) {
        for (var f = i.length; f--; )
          i[f].attr(s, null);
      }), n.push(a));
    }, p7 = function(e, n, a) {
      if (!n.no_events && e) {
        var i = $2(e, sr(sr({}, n), { content: a }));
        return i.content;
      } else
        return a;
    }, h7 = function(e, n, a) {
      var i = Ac(a.getInner ? n.innerHTML : e.getOuterHTML(n));
      return a.selection || Fd(O.fromDom(n)) ? i : Ut.trim(i);
    }, b7 = function(e, n, a) {
      var i = a.selection ? sr({ forced_root_block: !1 }, a) : a, s = e.parse(n, i);
      return v7(s), s;
    }, y7 = function(e, n, a) {
      var i = xm(e, n);
      return i.serialize(a);
    }, w7 = function(e, n, a, i, s) {
      var f = y7(n, a, i);
      return p7(e, s, f);
    }, C7 = function(e, n) {
      var a = ["data-mce-selected"], i = n && n.dom ? n.dom : ho.DOM, s = n && n.schema ? n.schema : ml(e);
      e.entity_encoding = e.entity_encoding || "named", e.remove_trailing_brs = "remove_trailing_brs" in e ? e.remove_trailing_brs : !0;
      var f = L4(e, s);
      f7(f, e, i);
      var p = function(C, k) {
        k === void 0 && (k = {});
        var F = sr({ format: "html" }, k), q = u6(n, C, F), K = h7(i, q, F), te = b7(f, K, F);
        return F.format === "tree" ? te : w7(n, e, s, te, F);
      };
      return {
        schema: s,
        addNodeFilter: f.addNodeFilter,
        addAttributeFilter: f.addAttributeFilter,
        serialize: p,
        addRules: s.addValidElements,
        setRules: s.setValidElements,
        addTempAttr: ne(g7, f, a),
        getTempAttrs: N(a),
        getNodeFilters: f.getNodeFilters,
        getAttributeFilters: f.getAttributeFilters
      };
    }, s6 = function(e, n) {
      var a = C7(e, n);
      return {
        schema: a.schema,
        addNodeFilter: a.addNodeFilter,
        addAttributeFilter: a.addAttributeFilter,
        serialize: a.serialize,
        addRules: a.addRules,
        setRules: a.setRules,
        addTempAttr: a.addTempAttr,
        getTempAttrs: a.getTempAttrs,
        getNodeFilters: a.getNodeFilters,
        getAttributeFilters: a.getAttributeFilters
      };
    }, l6 = "html", S7 = function(e, n) {
      n === void 0 && (n = {});
      var a = n.format ? n.format : l6;
      return Fw(e, n, a);
    }, x_ = function(e, n, a) {
      return a === void 0 && (a = {}), $O(e, n, a);
    }, z4 = ho.DOM, x7 = function(e) {
      z4.setStyle(e.id, "display", e.orgDisplay);
    }, H4 = function(e) {
      return se.from(e).each(function(n) {
        return n.destroy();
      });
    }, zw = function(e) {
      e.contentAreaContainer = e.formElement = e.container = e.editorContainer = null, e.bodyElement = e.contentDocument = e.contentWindow = null, e.iframeElement = e.targetElm = null, e.selection && (e.selection = e.selection.win = e.selection.dom = e.selection.dom.doc = null);
    }, k7 = function(e) {
      var n = e.formElement;
      n && (n._mceOldSubmit && (n.submit = n._mceOldSubmit, n._mceOldSubmit = null), z4.unbind(n, "submit reset", e.formEventDelegate));
    }, T7 = function(e) {
      if (!e.removed) {
        var n = e._selectionOverrides, a = e.editorUpload, i = e.getBody(), s = e.getElement();
        i && e.save({ is_removing: !0 }), e.removed = !0, e.unbindAllNativeEvents(), e.hasHiddenInput && s && z4.remove(s.nextSibling), rx(e), e.editorManager.remove(e), !e.inline && i && x7(e), ax(e), z4.remove(e.getContainer()), H4(n), H4(a), e.destroy();
      }
    }, c6 = function(e, n) {
      var a = e.selection, i = e.dom;
      if (!e.destroyed) {
        if (!n && !e.removed) {
          e.remove();
          return;
        }
        n || (e.editorManager.off("beforeunload", e._beforeUnload), e.theme && e.theme.destroy && e.theme.destroy(), H4(a), H4(i)), k7(e), zw(e), e.destroyed = !0;
      }
    }, f6 = function(e, n) {
      var a = ze(e) && ze(n);
      return a ? v6(e, n) : n;
    }, E7 = function(e) {
      return function() {
        for (var n = [], a = 0; a < arguments.length; a++)
          n[a] = arguments[a];
        if (n.length === 0)
          throw new Error("Can't merge zero objects");
        for (var i = {}, s = 0; s < n.length; s++) {
          var f = n[s];
          for (var p in f)
            Fr(f, p) && (i[p] = e(i[p], f[p]));
        }
        return i;
      };
    }, v6 = E7(f6), _7 = "autoresize_on_init,content_editable_state,convert_fonts_to_spans,inline_styles,padd_empty_with_br,block_elements,boolean_attributes,editor_deselector,editor_selector,elements,file_browser_callback_types,filepicker_validator_handler,force_hex_style_colors,force_p_newlines,gecko_spellcheck,images_dataimg_filter,media_scripts,mode,move_caret_before_on_enter_elements,non_empty_elements,self_closing_elements,short_ended_elements,special,spellchecker_select_languages,spellchecker_whitelist,tab_focus,table_responsive_width,text_block_elements,text_inline_elements,toolbar_drawer,types,validate,whitespace_elements,paste_word_valid_elements,paste_retain_style_properties,paste_convert_word_fake_lists".split(","), Hw = "bbcode,colorpicker,contextmenu,fullpage,legacyoutput,spellchecker,textcolor".split(","), d6 = "imagetools,toc".split(","), m6 = function(e) {
      var n = Ie(_7, function(i) {
        return Fr(e, i);
      }), a = e.forced_root_block;
      return (a === !1 || a === "") && n.push("forced_root_block (false only)"), Xt(n);
    }, A7 = function(e) {
      var n = Ut.makeMap(e.plugins, " "), a = function(s) {
        return Fr(n, s);
      }, i = Ko(Ko([], Ie(Hw, a), !0), Qt(d6, function(s) {
        return a(s) ? [s + " (moving to premium)"] : [];
      }), !0);
      return Xt(i);
    }, g6 = function(e, n) {
      var a = m6(e), i = A7(n), s = i.length > 0, f = a.length > 0, p = n.theme === "mobile";
      if (s || f || p) {
        var C = `
- `, k = p ? `

Themes:` + C + "mobile" : "", F = s ? `

Plugins:` + C + i.join(C) : "", q = f ? `

Settings:` + C + a.join(C) : "";
        console.warn("The following deprecated features are currently enabled, these will be removed in TinyMCE 6.0. See https://www.tiny.cloud/docs/release-notes/6.0-upcoming-changes/ for more information." + k + F + q);
      }
    }, O7 = function(e, n) {
      return {
        sections: N(e),
        settings: N(n)
      };
    }, k_ = lr().deviceType, D7 = k_.isTouch(), T_ = k_.isPhone(), B7 = k_.isTablet(), R7 = [
      "lists",
      "autolink",
      "autosave"
    ], p6 = {
      table_grid: !1,
      object_resizing: !1,
      resize: !1
    }, Pb = function(e) {
      var n = ht(e) ? e.join(" ") : e, a = Ke(Ge(n) ? n.split(" ") : [], Ve);
      return Ie(a, function(i) {
        return i.length > 0;
      });
    }, M7 = function(e) {
      return Ie(e, ne(We, R7));
    }, P7 = function(e, n) {
      var a = yn(n, function(i, s) {
        return We(e, s);
      });
      return O7(a.t, a.f);
    }, Vw = function(e, n, a) {
      a === void 0 && (a = {});
      var i = e.sections(), s = Mr(i, n).getOr({});
      return Ut.extend({}, a, s);
    }, Uw = function(e, n) {
      return Fr(e.sections(), n);
    }, h6 = function(e, n, a) {
      var i = e.sections();
      return Uw(e, n) && i[n].theme === a;
    }, N7 = function(e, n) {
      return Uw(e, n) ? e.sections()[n] : {};
    }, b6 = function(e, n) {
      return Mr(e, "toolbar_mode").orThunk(function() {
        return Mr(e, "toolbar_drawer").map(function(a) {
          return a === !1 ? "wrap" : a;
        });
      }).getOr(n);
    }, I7 = function(e, n, a, i, s) {
      var f = {
        id: n,
        theme: "silver",
        toolbar_mode: b6(e, "floating"),
        plugins: "",
        document_base_url: a,
        add_form_submit_trigger: !0,
        submit_patch: !0,
        add_unload_trigger: !0,
        convert_urls: !0,
        relative_urls: !0,
        remove_script_host: !0,
        object_resizing: !0,
        doctype: "<!DOCTYPE html>",
        visual: !0,
        font_size_legacy_values: "xx-small,small,medium,large,x-large,xx-large,300%",
        forced_root_block: "p",
        hidden_input: !0,
        inline_styles: !0,
        convert_fonts_to_spans: !0,
        indent: !0,
        indent_before: "p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist",
        indent_after: "p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,tfoot,tbody,tr,section,summary,article,hgroup,aside,figure,figcaption,option,optgroup,datalist",
        entity_encoding: "named",
        url_converter: s.convertURL,
        url_converter_scope: s
      };
      return sr(sr({}, f), i ? p6 : {});
    }, y6 = function(e, n) {
      var a = {
        resize: !1,
        toolbar_mode: b6(e, "scrolling"),
        toolbar_sticky: !1
      }, i = { menubar: !1 };
      return sr(sr(sr({}, p6), a), n ? i : {});
    }, F7 = function(e, n) {
      var a = n.external_plugins ? n.external_plugins : {};
      return e && e.external_plugins ? Ut.extend({}, e.external_plugins, a) : a;
    }, $7 = function(e, n) {
      return [].concat(Pb(e)).concat(Pb(n));
    }, L7 = function(e, n, a, i) {
      return e && h6(n, "mobile", "mobile") ? M7(i) : e && Uw(n, "mobile") ? i : a;
    }, z7 = function(e, n, a, i) {
      var s = Pb(a.forced_plugins), f = Pb(i.plugins), p = N7(n, "mobile"), C = p.plugins ? Pb(p.plugins) : f, k = L7(e, n, f, C), F = $7(s, k);
      if (br.browser.isIE() && We(F, "rtc"))
        throw new Error("RTC plugin is not supported on IE 11.");
      return Ut.extend(i, { plugins: F.join(" ") });
    }, H7 = function(e, n) {
      return e && Uw(n, "mobile");
    }, ms = function(e, n, a, i, s) {
      var f = e ? { mobile: y6(s.mobile || {}, n) } : {}, p = P7(["mobile"], v6(f, s)), C = Ut.extend(a, i, p.settings(), H7(e, p) ? Vw(p, "mobile") : {}, {
        validate: !0,
        external_plugins: F7(i, p.settings())
      });
      return z7(e, p, i, C);
    }, w6 = function(e, n, a, i, s) {
      var f = I7(s, n, a, D7, e), p = ms(T_ || B7, T_, f, i, s);
      return p.deprecation_warnings !== !1 && g6(s, p), p;
    }, Kh = function(e, n, a) {
      return se.from(n.settings[a]).filter(e);
    }, V7 = function(e) {
      var n = {};
      return typeof e == "string" ? at(e.indexOf("=") > 0 ? e.split(/[;,](?![^=;,]*(?:[;,]|$))/) : e.split(","), function(a) {
        var i = a.split("=");
        i.length > 1 ? n[Ut.trim(i[0])] = Ut.trim(i[1]) : n[Ut.trim(i[0])] = Ut.trim(i[0]);
      }) : n = e, n;
    }, U7 = function(e) {
      return function(n) {
        return ht(n) && In(n, e);
      };
    }, j7 = function(e, n, a, i) {
      var s = n in e.settings ? e.settings[n] : a;
      return i === "hash" ? V7(s) : i === "string" ? Kh(Ge, e, n).getOr(a) : i === "number" ? Kh(ge, e, n).getOr(a) : i === "boolean" ? Kh(Ze, e, n).getOr(a) : i === "object" ? Kh(ze, e, n).getOr(a) : i === "array" ? Kh(ht, e, n).getOr(a) : i === "string[]" ? Kh(U7(Ge), e, n).getOr(a) : i === "function" ? Kh(Be, e, n).getOr(a) : s;
    }, Ma = function() {
      var e = {}, n = function(s, f) {
        e[s] = f;
      }, a = function(s) {
        return e[s] ? e[s] : { icons: {} };
      }, i = function(s) {
        return Fr(e, s);
      };
      return {
        add: n,
        get: a,
        has: i
      };
    }, V4 = Ma(), C6 = function(e, n) {
      var a = n.dom;
      return a[e];
    }, S6 = function(e, n) {
      return parseInt(aa(n, e), 10);
    }, ci = ne(C6, "clientWidth"), W7 = ne(C6, "clientHeight"), jw = ne(S6, "margin-top"), q7 = ne(S6, "margin-left"), G7 = function(e) {
      return e.dom.getBoundingClientRect();
    }, K7 = function(e, n, a) {
      var i = ci(e), s = W7(e);
      return n >= 0 && a >= 0 && n <= i && a <= s;
    }, x6 = function(e, n, a, i) {
      var s = G7(n), f = e ? s.left + n.dom.clientLeft + q7(n) : 0, p = e ? s.top + n.dom.clientTop + jw(n) : 0, C = a - f, k = i - p;
      return {
        x: C,
        y: k
      };
    }, _m = function(e, n, a) {
      var i = O.fromDom(e.getBody()), s = e.inline ? i : Hs(i), f = x6(e.inline, s, n, a);
      return K7(s, f.x, f.y);
    }, cc = function(e) {
      return se.from(e).map(O.fromDom);
    }, Ww = function(e) {
      var n = e.inline ? e.getBody() : e.getContentAreaContainer();
      return cc(n).map(Kf).getOr(!1);
    }, Xh = function() {
      var e = function() {
        throw new Error("Theme did not provide a NotificationManager implementation.");
      };
      return {
        open: e,
        close: e,
        reposition: e,
        getArgs: e
      };
    }, Cv = function(e) {
      var n = [], a = function() {
        var te = e.theme;
        return te && te.getNotificationManagerImpl ? te.getNotificationManagerImpl() : Xh();
      }, i = function() {
        return se.from(n[0]);
      }, s = function(te, be) {
        return te.type === be.type && te.text === be.text && !te.progressBar && !te.timeout && !be.progressBar && !be.timeout;
      }, f = function() {
        n.length > 0 && a().reposition(n);
      }, p = function(te) {
        n.push(te);
      }, C = function(te) {
        gt(n, function(be) {
          return be === te;
        }).each(function(be) {
          n.splice(be, 1);
        });
      }, k = function(te, be) {
        if (be === void 0 && (be = !0), !(e.removed || !Ww(e)))
          return be && e.fire("BeforeOpenNotification", { notification: te }), tt(n, function(we) {
            return s(a().getArgs(we), te);
          }).getOrThunk(function() {
            e.editorManager.setActive(e);
            var we = a().open(te, function() {
              C(we), f(), i().fold(function() {
                return e.focus();
              }, function(ke) {
                return J0(O.fromDom(ke.getEl()));
              });
            });
            return p(we), f(), e.fire("OpenNotification", { notification: sr({}, we) }), we;
          });
      }, F = function() {
        i().each(function(te) {
          a().close(te), C(te), f();
        });
      }, q = N(n), K = function(te) {
        te.on("SkinLoaded", function() {
          var be = DS(te);
          be && k({
            text: be,
            type: "warning",
            timeout: 0
          }, !1), f();
        }), te.on("show ResizeEditor ResizeWindow NodeChange", function() {
          Bu.requestAnimationFrame(f);
        }), te.on("remove", function() {
          at(n.slice(), function(be) {
            a().close(be);
          });
        });
      };
      return K(e), {
        open: k,
        close: F,
        getNotifications: q
      };
    }, $l = Ts.PluginManager, xd = Ts.ThemeManager;
    function E_() {
      var e = function() {
        throw new Error("Theme did not provide a WindowManager implementation.");
      };
      return {
        open: e,
        openUrl: e,
        alert: e,
        confirm: e,
        close: e,
        getParams: e,
        setParams: e
      };
    }
    var __ = function(e) {
      var n = [], a = function() {
        var ke = e.theme;
        return ke && ke.getWindowManagerImpl ? ke.getWindowManagerImpl() : E_();
      }, i = function(ke, Ee) {
        return function() {
          for (var qe = [], Le = 0; Le < arguments.length; Le++)
            qe[Le] = arguments[Le];
          return Ee ? Ee.apply(ke, qe) : void 0;
        };
      }, s = function(ke) {
        e.fire("OpenWindow", { dialog: ke });
      }, f = function(ke) {
        e.fire("CloseWindow", { dialog: ke });
      }, p = function(ke) {
        n.push(ke), s(ke);
      }, C = function(ke) {
        f(ke), n = Ie(n, function(Ee) {
          return Ee !== ke;
        }), n.length === 0 && e.focus();
      }, k = function() {
        return se.from(n[n.length - 1]);
      }, F = function(ke) {
        e.editorManager.setActive(e), eb(e);
        var Ee = ke();
        return p(Ee), Ee;
      }, q = function(ke, Ee) {
        return F(function() {
          return a().open(ke, Ee, C);
        });
      }, K = function(ke) {
        return F(function() {
          return a().openUrl(ke, C);
        });
      }, te = function(ke, Ee, qe) {
        var Le = a();
        Le.alert(ke, i(qe || Le, Ee));
      }, be = function(ke, Ee, qe) {
        var Le = a();
        Le.confirm(ke, i(qe || Le, Ee));
      }, we = function() {
        k().each(function(ke) {
          a().close(ke), C(ke);
        });
      };
      return e.on("remove", function() {
        at(n, function(ke) {
          a().close(ke);
        });
      }), {
        open: q,
        openUrl: K,
        alert: te,
        confirm: be,
        close: we
      };
    }, A_ = function(e, n) {
      e.notificationManager.open({
        type: "error",
        text: n
      });
    }, U4 = function(e, n) {
      e._skinLoaded ? A_(e, n) : e.on("SkinLoaded", function() {
        A_(e, n);
      });
    }, k6 = function(e, n) {
      U4(e, ls.translate([
        "Failed to upload image: {0}",
        n
      ]));
    }, j4 = function(e, n, a) {
      G0(e, n, { message: a }), console.error(a);
    }, O_ = function(e, n, a) {
      return a ? "Failed to load " + e + ": " + a + " from url " + n : "Failed to load " + e + " url: " + n;
    }, W4 = function(e, n, a) {
      j4(e, "PluginLoadError", O_("plugin", n, a));
    }, X7 = function(e, n, a) {
      j4(e, "IconsLoadError", O_("icons", n, a));
    }, qw = function(e, n, a) {
      j4(e, "LanguageLoadError", O_("language", n, a));
    }, T6 = function(e, n, a) {
      var i = ls.translate([
        "Failed to initialize plugin: {0}",
        n
      ]);
      G0(e, "PluginLoadError", { message: i }), Gw(i, a), U4(e, i);
    }, Gw = function(e) {
      for (var n = [], a = 1; a < arguments.length; a++)
        n[a - 1] = arguments[a];
      var i = window.console;
      i && (i.error ? i.error.apply(i, Ko([e], n, !1)) : i.log.apply(i, Ko([e], n, !1)));
    }, Am = function(e) {
      return /^[a-z0-9\-]+$/i.test(e);
    }, D_ = function(e) {
      return E6(e, ES(e));
    }, Y7 = function(e) {
      return E6(e, _S(e));
    }, E6 = function(e, n) {
      var a = e.editorManager.baseURL + "/skins/content", i = e.editorManager.suffix, s = "content" + i + ".css", f = e.inline === !0;
      return Ke(n, function(p) {
        return Am(p) && !f ? a + "/" + p + "/" + s : e.documentBaseURI.toAbsolute(p);
      });
    }, Z7 = function(e) {
      e.contentCSS = e.contentCSS.concat(D_(e), Y7(e));
    }, Yh = function() {
      var e = 1, n = 2, a = {}, i = function(te, be) {
        return {
          status: te,
          resultUri: be
        };
      }, s = function(te) {
        return te in a;
      }, f = function(te) {
        var be = a[te];
        return be ? be.resultUri : null;
      }, p = function(te) {
        return s(te) ? a[te].status === e : !1;
      }, C = function(te) {
        return s(te) ? a[te].status === n : !1;
      }, k = function(te) {
        a[te] = i(e, null);
      }, F = function(te, be) {
        a[te] = i(n, be);
      }, q = function(te) {
        delete a[te];
      }, K = function() {
        a = {};
      };
      return {
        hasBlobUri: s,
        getResultUri: f,
        isPending: p,
        isUploaded: C,
        markPending: k,
        markUploaded: F,
        removeFailed: q,
        destroy: K
      };
    }, J7 = 0, Q7 = function() {
      var e = function() {
        return Math.round(Math.random() * 4294967295).toString(36);
      }, n = new Date().getTime();
      return "s" + n.toString(36) + e() + e() + e();
    }, Fu = function(e) {
      return e + J7++ + Q7();
    }, eP = function() {
      var e = [], n = function(K) {
        var te = {
          "image/jpeg": "jpg",
          "image/jpg": "jpg",
          "image/gif": "gif",
          "image/png": "png",
          "image/apng": "apng",
          "image/avif": "avif",
          "image/svg+xml": "svg",
          "image/webp": "webp",
          "image/bmp": "bmp",
          "image/tiff": "tiff"
        };
        return te[K.toLowerCase()] || "dat";
      }, a = function(K, te, be, we, ke) {
        if (Ge(K)) {
          var Ee = K;
          return i({
            id: Ee,
            name: we,
            filename: ke,
            blob: te,
            base64: be
          });
        } else {
          if (ze(K))
            return i(K);
          throw new Error("Unknown input type");
        }
      }, i = function(K) {
        if (!K.blob || !K.base64)
          throw new Error("blob and base64 representations of the image are required for BlobInfo to be created");
        var te = K.id || Fu("blobid"), be = K.name || te, we = K.blob;
        return {
          id: N(te),
          name: N(be),
          filename: N(K.filename || be + "." + n(we.type)),
          blob: N(we),
          base64: N(K.base64),
          blobUri: N(K.blobUri || URL.createObjectURL(we)),
          uri: N(K.uri)
        };
      }, s = function(K) {
        p(K.id()) || e.push(K);
      }, f = function(K) {
        return tt(e, K).getOrUndefined();
      }, p = function(K) {
        return f(function(te) {
          return te.id() === K;
        });
      }, C = function(K) {
        return f(function(te) {
          return te.blobUri() === K;
        });
      }, k = function(K, te) {
        return f(function(be) {
          return be.base64() === K && be.blob().type === te;
        });
      }, F = function(K) {
        e = Ie(e, function(te) {
          return te.blobUri() === K ? (URL.revokeObjectURL(te.blobUri()), !1) : !0;
        });
      }, q = function() {
        at(e, function(K) {
          URL.revokeObjectURL(K.blobUri());
        }), e = [];
      };
      return {
        create: a,
        add: s,
        get: p,
        getByUri: C,
        getByData: k,
        findFirst: f,
        removeByUri: F,
        destroy: q
      };
    }, _6 = function(e, n) {
      var a = {}, i = function(we, ke) {
        return we ? we.replace(/\/$/, "") + "/" + ke.replace(/^\//, "") : ke;
      }, s = function(we, ke, Ee, qe) {
        var Le = new XMLHttpRequest();
        Le.open("POST", n.url), Le.withCredentials = n.credentials, Le.upload.onprogress = function(mt) {
          qe(mt.loaded / mt.total * 100);
        }, Le.onerror = function() {
          Ee("Image upload failed due to a XHR Transport error. Code: " + Le.status);
        }, Le.onload = function() {
          if (Le.status < 200 || Le.status >= 300) {
            Ee("HTTP Error: " + Le.status);
            return;
          }
          var mt = JSON.parse(Le.responseText);
          if (!mt || typeof mt.location != "string") {
            Ee("Invalid JSON: " + Le.responseText);
            return;
          }
          ke(i(n.basePath, mt.location));
        };
        var xt = new FormData();
        xt.append("file", we.blob(), we.filename()), Le.send(xt);
      }, f = function() {
        return new Ki(function(we) {
          we([]);
        });
      }, p = function(we, ke) {
        return {
          url: ke,
          blobInfo: we,
          status: !0
        };
      }, C = function(we, ke, Ee) {
        return {
          url: "",
          blobInfo: we,
          status: !1,
          error: {
            message: ke,
            options: Ee
          }
        };
      }, k = function(we, ke) {
        Ut.each(a[we], function(Ee) {
          Ee(ke);
        }), delete a[we];
      }, F = function(we, ke, Ee) {
        return e.markPending(we.blobUri()), new Ki(function(qe) {
          var Le, xt;
          try {
            var mt = function() {
              Le && (Le.close(), xt = xe);
            }, Qe = function(tn) {
              mt(), e.markUploaded(we.blobUri(), tn), k(we.blobUri(), p(we, tn)), qe(p(we, tn));
            }, At = function(tn, Cn) {
              var Ar = Cn || {};
              mt(), e.removeFailed(we.blobUri()), k(we.blobUri(), C(we, tn, Ar)), qe(C(we, tn, Ar));
            };
            xt = function(tn) {
              tn < 0 || tn > 100 || se.from(Le).orThunk(function() {
                return se.from(Ee).map(_);
              }).each(function(Cn) {
                Le = Cn, Cn.progressBar.value(tn);
              });
            }, ke(we, Qe, At, xt);
          } catch (tn) {
            qe(C(we, tn.message, {}));
          }
        });
      }, q = function(we) {
        return we === s;
      }, K = function(we) {
        var ke = we.blobUri();
        return new Ki(function(Ee) {
          a[ke] = a[ke] || [], a[ke].push(Ee);
        });
      }, te = function(we, ke) {
        return we = Ut.grep(we, function(Ee) {
          return !e.isUploaded(Ee.blobUri());
        }), Ki.all(Ut.map(we, function(Ee) {
          return e.isPending(Ee.blobUri()) ? K(Ee) : F(Ee, n.handler, ke);
        }));
      }, be = function(we, ke) {
        return !n.url && q(n.handler) ? f() : te(we, ke);
      };
      return Be(n.handler) === !1 && (n.handler = s), { upload: be };
    }, B_ = function(e) {
      return function() {
        return e.notificationManager.open({
          text: e.translate("Image uploading..."),
          type: "info",
          timeout: -1,
          progressBar: !0
        });
      };
    }, R_ = function(e, n) {
      return _6(n, {
        url: oT(e),
        basePath: rd(e),
        credentials: ad(e),
        handler: iT(e)
      });
    }, A6 = function(e) {
      var n = Yh(), a = R_(e, n);
      return {
        upload: function(i, s) {
          return s === void 0 && (s = !0), a.upload(i, s ? B_(e) : void 0);
        }
      };
    }, M_ = function(e) {
      var n = ss(null);
      e.on("change AddUndo", function(i) {
        n.set(sr({}, i.level));
      });
      var a = function() {
        var i = e.undoManager.data;
        Un(i).filter(function(s) {
          return !km(n.get(), s);
        }).each(function(s) {
          e.setDirty(!0), e.fire("change", {
            level: s,
            lastLevel: on(i, i.length - 2).getOrNull()
          });
        });
      };
      return { fireIfChanged: a };
    }, tP = function(e) {
      var n = eP(), a, i, s = Yh(), f = [], p = M_(e), C = function(mt) {
        return function(Qe) {
          return e.selection ? mt(Qe) : [];
        };
      }, k = function(mt) {
        return mt + (mt.indexOf("?") === -1 ? "?" : "&") + new Date().getTime();
      }, F = function(mt, Qe, At) {
        var tn = 0;
        do
          tn = mt.indexOf(Qe, tn), tn !== -1 && (mt = mt.substring(0, tn) + At + mt.substr(tn + Qe.length), tn += At.length - Qe.length + 1);
        while (tn !== -1);
        return mt;
      }, q = function(mt, Qe, At) {
        var tn = 'src="' + At + '"' + (At === br.transparentSrc ? ' data-mce-placeholder="1"' : "");
        return mt = F(mt, 'src="' + Qe + '"', tn), mt = F(mt, 'data-mce-src="' + Qe + '"', 'data-mce-src="' + At + '"'), mt;
      }, K = function(mt, Qe) {
        at(e.undoManager.data, function(At) {
          At.type === "fragmented" ? At.fragments = Ke(At.fragments, function(tn) {
            return q(tn, mt, Qe);
          }) : At.content = q(At.content, mt, Qe);
        });
      }, te = function(mt, Qe) {
        var At = e.convertURL(Qe, "src");
        K(mt.src, Qe), e.$(mt).attr({
          src: n2(e) ? k(Qe) : Qe,
          "data-mce-src": At
        });
      }, be = function(mt) {
        return a || (a = R_(e, s)), qe().then(C(function(Qe) {
          var At = Ke(Qe, function(tn) {
            return tn.blobInfo;
          });
          return a.upload(At, B_(e)).then(C(function(tn) {
            var Cn = [], Ar = Ke(tn, function(Xn, fn) {
              var _r = Qe[fn].blobInfo, kn = Qe[fn].image;
              return Xn.status && aT(e) ? (n.removeByUri(kn.src), Em(e) || te(kn, Xn.url)) : Xn.error && (Xn.error.options.remove && (K(kn.getAttribute("src"), br.transparentSrc), Cn.push(kn)), k6(e, Xn.error.message)), {
                element: kn,
                status: Xn.status,
                uploadUri: Xn.url,
                blobInfo: _r
              };
            });
            return Ar.length > 0 && p.fireIfChanged(), Cn.length > 0 && (Em(e) ? console.error("Removing images on failed uploads is currently unsupported for RTC") : e.undoManager.transact(function() {
              at(Cn, function(Xn) {
                e.dom.remove(Xn), n.removeByUri(Xn.src);
              });
            })), mt && mt(Ar), Ar;
          }));
        }));
      }, we = function(mt) {
        if (ph(e))
          return be(mt);
      }, ke = function(mt) {
        if (In(f, function(At) {
          return At(mt);
        }) === !1)
          return !1;
        if (mt.getAttribute("src").indexOf("data:") === 0) {
          var Qe = y0(e);
          return Qe(mt);
        }
        return !0;
      }, Ee = function(mt) {
        f.push(mt);
      }, qe = function() {
        return i || (i = JO(s, n)), i.findAll(e.getBody(), ke).then(C(function(mt) {
          return mt = Ie(mt, function(Qe) {
            return typeof Qe == "string" ? (U4(e, Qe), !1) : !0;
          }), Em(e) || at(mt, function(Qe) {
            K(Qe.image.src, Qe.blobInfo.blobUri()), Qe.image.src = Qe.blobInfo.blobUri(), Qe.image.removeAttribute("data-mce-src");
          }), mt;
        }));
      }, Le = function() {
        n.destroy(), s.destroy(), i = a = null;
      }, xt = function(mt) {
        return mt.replace(/src="(blob:[^"]+)"/g, function(Qe, At) {
          var tn = s.getResultUri(At);
          if (tn)
            return 'src="' + tn + '"';
          var Cn = n.getByUri(At);
          if (Cn || (Cn = Xe(e.editorManager.get(), function(Xn, fn) {
            return Xn || fn.editorUpload && fn.editorUpload.blobCache.getByUri(At);
          }, null)), Cn) {
            var Ar = Cn.blob();
            return 'src="data:' + Ar.type + ";base64," + Cn.base64() + '"';
          }
          return Qe;
        });
      };
      return e.on("SetContent", function() {
        ph(e) ? we() : qe();
      }), e.on("RawSaveContent", function(mt) {
        mt.content = xt(mt.content);
      }), e.on("GetContent", function(mt) {
        mt.source_view || mt.format === "raw" || mt.format === "tree" || (mt.content = xt(mt.content));
      }), e.on("PostRender", function() {
        e.parser.addNodeFilter("img", function(mt) {
          at(mt, function(Qe) {
            var At = Qe.attr("src");
            if (!n.getByUri(At)) {
              var tn = s.getResultUri(At);
              tn && Qe.attr("src", tn);
            }
          });
        });
      }), {
        blobCache: n,
        addFilter: Ee,
        uploadImages: be,
        uploadImagesAuto: we,
        scanForImages: qe,
        destroy: Le
      };
    }, nP = function(e) {
      var n = {
        valigntop: [{
          selector: "td,th",
          styles: { verticalAlign: "top" }
        }],
        valignmiddle: [{
          selector: "td,th",
          styles: { verticalAlign: "middle" }
        }],
        valignbottom: [{
          selector: "td,th",
          styles: { verticalAlign: "bottom" }
        }],
        alignleft: [
          {
            selector: "figure.image",
            collapsed: !1,
            classes: "align-left",
            ceFalseOverride: !0,
            preview: "font-family font-size"
          },
          {
            selector: "figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li",
            styles: { textAlign: "left" },
            inherit: !1,
            preview: !1,
            defaultBlock: "div"
          },
          {
            selector: "img,table,audio,video",
            collapsed: !1,
            styles: { float: "left" },
            preview: "font-family font-size"
          }
        ],
        aligncenter: [
          {
            selector: "figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li",
            styles: { textAlign: "center" },
            inherit: !1,
            preview: "font-family font-size",
            defaultBlock: "div"
          },
          {
            selector: "figure.image",
            collapsed: !1,
            classes: "align-center",
            ceFalseOverride: !0,
            preview: "font-family font-size"
          },
          {
            selector: "img,audio,video",
            collapsed: !1,
            styles: {
              display: "block",
              marginLeft: "auto",
              marginRight: "auto"
            },
            preview: !1
          },
          {
            selector: "table",
            collapsed: !1,
            styles: {
              marginLeft: "auto",
              marginRight: "auto"
            },
            preview: "font-family font-size"
          }
        ],
        alignright: [
          {
            selector: "figure.image",
            collapsed: !1,
            classes: "align-right",
            ceFalseOverride: !0,
            preview: "font-family font-size"
          },
          {
            selector: "figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li",
            styles: { textAlign: "right" },
            inherit: !1,
            preview: "font-family font-size",
            defaultBlock: "div"
          },
          {
            selector: "img,table,audio,video",
            collapsed: !1,
            styles: { float: "right" },
            preview: "font-family font-size"
          }
        ],
        alignjustify: [{
          selector: "figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li",
          styles: { textAlign: "justify" },
          inherit: !1,
          defaultBlock: "div",
          preview: "font-family font-size"
        }],
        bold: [
          {
            inline: "strong",
            remove: "all",
            preserve_attributes: [
              "class",
              "style"
            ]
          },
          {
            inline: "span",
            styles: { fontWeight: "bold" }
          },
          {
            inline: "b",
            remove: "all",
            preserve_attributes: [
              "class",
              "style"
            ]
          }
        ],
        italic: [
          {
            inline: "em",
            remove: "all",
            preserve_attributes: [
              "class",
              "style"
            ]
          },
          {
            inline: "span",
            styles: { fontStyle: "italic" }
          },
          {
            inline: "i",
            remove: "all",
            preserve_attributes: [
              "class",
              "style"
            ]
          }
        ],
        underline: [
          {
            inline: "span",
            styles: { textDecoration: "underline" },
            exact: !0
          },
          {
            inline: "u",
            remove: "all",
            preserve_attributes: [
              "class",
              "style"
            ]
          }
        ],
        strikethrough: [
          {
            inline: "span",
            styles: { textDecoration: "line-through" },
            exact: !0
          },
          {
            inline: "strike",
            remove: "all",
            preserve_attributes: [
              "class",
              "style"
            ]
          },
          {
            inline: "s",
            remove: "all",
            preserve_attributes: [
              "class",
              "style"
            ]
          }
        ],
        forecolor: {
          inline: "span",
          styles: { color: "%value" },
          links: !0,
          remove_similar: !0,
          clear_child_styles: !0
        },
        hilitecolor: {
          inline: "span",
          styles: { backgroundColor: "%value" },
          links: !0,
          remove_similar: !0,
          clear_child_styles: !0
        },
        fontname: {
          inline: "span",
          toggle: !1,
          styles: { fontFamily: "%value" },
          clear_child_styles: !0
        },
        fontsize: {
          inline: "span",
          toggle: !1,
          styles: { fontSize: "%value" },
          clear_child_styles: !0
        },
        lineheight: {
          selector: "h1,h2,h3,h4,h5,h6,p,li,td,th,div",
          defaultBlock: "p",
          styles: { lineHeight: "%value" }
        },
        fontsize_class: {
          inline: "span",
          attributes: { class: "%value" }
        },
        blockquote: {
          block: "blockquote",
          wrapper: !0,
          remove: "all"
        },
        subscript: { inline: "sub" },
        superscript: { inline: "sup" },
        code: { inline: "code" },
        link: {
          inline: "a",
          selector: "a",
          remove: "all",
          split: !0,
          deep: !0,
          onmatch: function(a, i, s) {
            return $r(a) && a.hasAttribute("href");
          },
          onformat: function(a, i, s) {
            Ut.each(s, function(f, p) {
              e.setAttrib(a, p, f);
            });
          }
        },
        lang: {
          inline: "span",
          clear_child_styles: !0,
          remove_similar: !0,
          attributes: {
            lang: "%value",
            "data-mce-lang": function(a) {
              var i;
              return (i = a == null ? void 0 : a.customValue) !== null && i !== void 0 ? i : null;
            }
          }
        },
        removeformat: [
          {
            selector: "b,strong,em,i,font,u,strike,s,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins,small",
            remove: "all",
            split: !0,
            expand: !1,
            block_expand: !0,
            deep: !0
          },
          {
            selector: "span",
            attributes: [
              "style",
              "class"
            ],
            remove: "empty",
            split: !0,
            expand: !1,
            deep: !0
          },
          {
            selector: "*",
            attributes: [
              "style",
              "class"
            ],
            split: !1,
            expand: !1,
            deep: !0
          }
        ]
      };
      return Ut.each("p h1 h2 h3 h4 h5 h6 div address pre dt dd samp".split(/\s/), function(a) {
        n[a] = {
          block: a,
          remove: "all"
        };
      }), n;
    }, rP = function(e) {
      var n = {}, a = function(p) {
        return Ct(p) ? n[p] : n;
      }, i = function(p) {
        return Fr(n, p);
      }, s = function(p, C) {
        p && (Ge(p) ? (ht(C) || (C = [C]), at(C, function(k) {
          De(k.deep) && (k.deep = !Ys(k)), De(k.split) && (k.split = !Ys(k) || pu(k)), De(k.remove) && Ys(k) && !pu(k) && (k.remove = "none"), Ys(k) && pu(k) && (k.mixed = !0, k.block_expand = !0), Ge(k.classes) && (k.classes = k.classes.split(/\s+/));
        }), n[p] = C) : _n(p, function(k, F) {
          s(F, k);
        }));
      }, f = function(p) {
        return p && n[p] && delete n[p], n;
      };
      return s(nP(e.dom)), s(sT(e)), {
        get: a,
        has: i,
        register: s,
        unregister: f
      };
    }, q4 = Ut.each, Qs = ho.DOM, Sv = function(e, n) {
      var a, i, s, f = n && n.schema || ml({}), p = function(q, K) {
        K.classes.length && Qs.addClass(q, K.classes.join(" ")), Qs.setAttribs(q, K.attrs);
      }, C = function(q) {
        i = typeof q == "string" ? {
          name: q,
          classes: [],
          attrs: {}
        } : q;
        var K = Qs.create(i.name);
        return p(K, i), K;
      }, k = function(q, K) {
        var te = typeof q != "string" ? q.nodeName.toLowerCase() : q, be = f.getElementRule(te), we = be && be.parentsRequired;
        return we && we.length ? K && Ut.inArray(we, K) !== -1 ? K : we[0] : !1;
      }, F = function(q, K, te) {
        var be, we, ke = K.length > 0 && K[0], Ee = ke && ke.name, qe = k(q, Ee);
        if (qe)
          Ee === qe ? (we = K[0], K = K.slice(1)) : we = qe;
        else if (ke)
          we = K[0], K = K.slice(1);
        else if (!te)
          return q;
        return we && (be = C(we), be.appendChild(q)), te && (be || (be = Qs.create("div"), be.appendChild(q)), Ut.each(te, function(Le) {
          var xt = C(Le);
          be.insertBefore(xt, q);
        })), F(be, K, we && we.siblings);
      };
      return e && e.length ? (i = e[0], a = C(i), s = Qs.create("div"), s.appendChild(F(a, e.slice(1), i.siblings)), s) : "";
    }, aP = function(e) {
      var n, a = {
        classes: [],
        attrs: {}
      };
      return e = a.selector = Ut.trim(e), e !== "*" && (n = e.replace(/(?:([#\.]|::?)([\w\-]+)|(\[)([^\]]+)\]?)/g, function(i, s, f, p, C) {
        switch (s) {
          case "#":
            a.attrs.id = f;
            break;
          case ".":
            a.classes.push(f);
            break;
          case ":":
            Ut.inArray("checked disabled enabled read-only required".split(" "), f) !== -1 && (a.attrs[f] = f);
            break;
        }
        if (p === "[") {
          var k = C.match(/([\w\-]+)(?:\=\"([^\"]+))?/);
          k && (a.attrs[k[1]] = k[2]);
        }
        return "";
      })), a.name = n || "div", a;
    }, oP = function(e) {
      return !e || typeof e != "string" ? [] : (e = e.split(/\s*,\s*/)[0], e = e.replace(/\s*(~\+|~|\+|>)\s*/g, "$1"), Ut.map(e.split(/(?:>|\s+(?![^\[\]]+\]))/), function(n) {
        var a = Ut.map(n.split(/(?:~\+|~|\+)/), aP), i = a.pop();
        return a.length && (i.siblings = a), i;
      }).reverse());
    }, iP = function(e, n) {
      var a, i, s = "", f, p = Ag(e);
      if (p === "")
        return "";
      var C = function(K) {
        return K.replace(/%(\w+)/g, "");
      };
      if (typeof n == "string") {
        if (n = e.formatter.get(n), !n)
          return;
        n = n[0];
      }
      if ("preview" in n) {
        var k = Mr(n, "preview");
        if (Nd(k, !1))
          return "";
        p = k.getOr(p);
      }
      a = n.block || n.inline || "span";
      var F = oP(n.selector);
      F.length ? (F[0].name || (F[0].name = a), a = n.selector, i = Sv(F, e)) : i = Sv([a], e);
      var q = Qs.select(a, i)[0] || i.firstChild;
      return q4(n.styles, function(K, te) {
        var be = C(K);
        be && Qs.setStyle(q, te, be);
      }), q4(n.attributes, function(K, te) {
        var be = C(K);
        be && Qs.setAttrib(q, te, be);
      }), q4(n.classes, function(K) {
        var te = C(K);
        Qs.hasClass(q, te) || Qs.addClass(q, te);
      }), e.fire("PreviewFormats"), Qs.setStyles(i, {
        position: "absolute",
        left: -65535
      }), e.getBody().appendChild(i), f = Qs.getStyle(e.getBody(), "fontSize", !0), f = /px$/.test(f) ? parseInt(f, 10) : 0, q4(p.split(" "), function(K) {
        var te = Qs.getStyle(q, K, !0);
        if (!(K === "background-color" && /transparent|rgba\s*\([^)]+,\s*0\)/.test(te) && (te = Qs.getStyle(e.getBody(), K, !0), Qs.toHex(te).toLowerCase() === "#ffffff")) && !(K === "color" && Qs.toHex(te).toLowerCase() === "#000000")) {
          if (K === "font-size" && /em|%$/.test(te)) {
            if (f === 0)
              return;
            var be = parseFloat(te) / (/%$/.test(te) ? 100 : 1);
            te = be * f + "px";
          }
          K === "border" && te && (s += "padding:0 2px;"), s += K + ":" + te + ";";
        }
      }), e.fire("AfterPreviewFormats"), Qs.remove(i), s;
    }, uP = function(e) {
      e.addShortcut("meta+b", "", "Bold"), e.addShortcut("meta+i", "", "Italic"), e.addShortcut("meta+u", "", "Underline");
      for (var n = 1; n <= 6; n++)
        e.addShortcut("access+" + n, "", [
          "FormatBlock",
          !1,
          "h" + n
        ]);
      e.addShortcut("access+7", "", [
        "FormatBlock",
        !1,
        "p"
      ]), e.addShortcut("access+8", "", [
        "FormatBlock",
        !1,
        "div"
      ]), e.addShortcut("access+9", "", [
        "FormatBlock",
        !1,
        "address"
      ]);
    }, O6 = function(e) {
      var n = rP(e), a = ss(null);
      return uP(e), XE(e), {
        get: n.get,
        has: n.has,
        register: n.register,
        unregister: n.unregister,
        apply: function(i, s, f) {
          JM(e, i, s, f);
        },
        remove: function(i, s, f, p) {
          yp(e, i, s, f, p);
        },
        toggle: function(i, s, f) {
          v_(e, i, s, f);
        },
        match: function(i, s, f, p) {
          return Iw(e, i, s, f, p);
        },
        closest: function(i) {
          return ZM(e, i);
        },
        matchAll: function(i, s) {
          return NO(e, i, s);
        },
        matchNode: function(i, s, f, p) {
          return IO(e, i, s, f, p);
        },
        canApply: function(i) {
          return I4(e, i);
        },
        formatChanged: function(i, s, f, p) {
          return FO(e, a, i, s, f, p);
        },
        getCssText: ne(iP, e)
      };
    }, fi = function(e) {
      switch (e.toLowerCase()) {
        case "undo":
        case "redo":
        case "mcerepaint":
        case "mcefocus":
          return !0;
        default:
          return !1;
      }
    }, D6 = function(e, n, a) {
      var i = ss(!1), s = function(k) {
        Tm(n, !1, a), n.add({}, k);
      };
      e.on("init", function() {
        n.add();
      }), e.on("BeforeExecCommand", function(k) {
        var F = k.command;
        fi(F) || (P4(n, a), n.beforeChange());
      }), e.on("ExecCommand", function(k) {
        var F = k.command;
        fi(F) || s(k);
      }), e.on("ObjectResizeStart cut", function() {
        n.beforeChange();
      }), e.on("SaveContent ObjectResized blur", s), e.on("dragend", s), e.on("keyup", function(k) {
        var F = k.keyCode;
        k.isDefaultPrevented() || ((F >= 33 && F <= 36 || F >= 37 && F <= 40 || F === 45 || k.ctrlKey) && (s(), e.nodeChanged()), (F === 46 || F === 8) && e.nodeChanged(), i.get() && n.typing && km(Rb(e), n.data[0]) === !1 && (e.isDirty() === !1 && (e.setDirty(!0), e.fire("change", {
          level: n.data[0],
          lastLevel: null
        })), e.fire("TypingUndo"), i.set(!1), e.nodeChanged()));
      }), e.on("keydown", function(k) {
        var F = k.keyCode;
        if (!k.isDefaultPrevented()) {
          if (F >= 33 && F <= 36 || F >= 37 && F <= 40 || F === 45) {
            n.typing && s(k);
            return;
          }
          var q = k.ctrlKey && !k.altKey || k.metaKey;
          (F < 16 || F > 20) && F !== 224 && F !== 91 && !n.typing && !q && (n.beforeChange(), Tm(n, !0, a), n.add({}, k), i.set(!0));
        }
      }), e.on("mousedown", function(k) {
        n.typing && s(k);
      });
      var f = function(k) {
        return k.inputType === "insertReplacementText";
      }, p = function(k) {
        return k.inputType === "insertText" && k.data === null;
      }, C = function(k) {
        return k.inputType === "insertFromPaste" || k.inputType === "insertFromDrop";
      };
      e.on("input", function(k) {
        k.inputType && (f(k) || p(k) || C(k)) && s(k);
      }), e.on("AddUndo Undo Redo ClearUndos", function(k) {
        k.isDefaultPrevented() || e.nodeChanged();
      });
    }, B6 = function(e) {
      e.addShortcut("meta+z", "", "Undo"), e.addShortcut("meta+y,meta+shift+z", "", "Redo");
    }, Df = function(e) {
      var n = ed(), a = ss(0), i = ss(0), s = {
        data: [],
        typing: !1,
        beforeChange: function() {
          qM(e, a, n);
        },
        add: function(f, p) {
          return DO(e, s, i, a, n, f, p);
        },
        undo: function() {
          return BO(e, s, a, i);
        },
        redo: function() {
          return RO(e, i, s.data);
        },
        clear: function() {
          MO(e, s, i);
        },
        reset: function() {
          PO(e, s);
        },
        hasUndo: function() {
          return GM(e, s, i);
        },
        hasRedo: function() {
          return KM(e, s, i);
        },
        transact: function(f) {
          return XM(e, s, a, f);
        },
        ignore: function(f) {
          YM(e, a, f);
        },
        extra: function(f, p) {
          f_(e, s, i, f, p);
        }
      };
      return Em(e) || D6(e, s, a), B6(e), s;
    }, R6 = [
      9,
      27,
      Br.HOME,
      Br.END,
      19,
      20,
      44,
      144,
      145,
      33,
      34,
      45,
      16,
      17,
      18,
      91,
      92,
      93,
      Br.DOWN,
      Br.UP,
      Br.LEFT,
      Br.RIGHT
    ].concat(br.browser.isFirefox() ? [224] : []), M6 = "data-mce-placeholder", P6 = function(e) {
      return e.type === "keydown" || e.type === "keyup";
    }, G4 = function(e) {
      var n = e.keyCode;
      return n === Br.BACKSPACE || n === Br.DELETE;
    }, sP = function(e) {
      if (P6(e)) {
        var n = e.keyCode;
        return !G4(e) && (Br.metaKeyPressed(e) || e.altKey || n >= 112 && n <= 123 || We(R6, n));
      } else
        return !1;
    }, Nb = function(e) {
      return P6(e) && !(G4(e) || e.type === "keyup" && e.keyCode === 229);
    }, lP = function(e, n, a) {
      if (lu(O.fromDom(n), !1)) {
        var i = a === "", s = n.firstElementChild;
        return s ? e.getStyle(n.firstElementChild, "padding-left") || e.getStyle(n.firstElementChild, "padding-right") ? !1 : i ? !e.isBlock(s) : a === s.nodeName.toLowerCase() : !0;
      } else
        return !1;
    }, N6 = function(e) {
      var n = e.dom, a = mu(e), i = a2(e), s = function(f, p) {
        if (!sP(f)) {
          var C = e.getBody(), k = Nb(f) ? !1 : lP(n, C, a), F = n.getAttrib(C, M6) !== "";
          (F !== k || p) && (n.setAttrib(C, M6, k ? i : null), n.setAttrib(C, "aria-placeholder", k ? i : null), ux(e, k), e.on(k ? "keydown" : "keyup", s), e.off(k ? "keyup" : "keydown", s));
        }
      };
      i && e.on("init", function(f) {
        s(f, !0), e.on("change SetContent ExecCommand", s), e.on("paste", function(p) {
          return Bu.setEditorTimeout(e, function() {
            return s(p);
          });
        });
      });
    }, I6 = /[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/, P_ = function(e) {
      return I6.test(e);
    }, wp = function(e, n) {
      return Nn(O.fromDom(n), fv(e));
    }, N_ = function(e) {
      return ho.DOM.getStyle(e, "direction", !0) === "rtl" || P_(e.textContent);
    }, cP = function(e, n, a) {
      return Ie(ho.DOM.getParents(a.container(), "*", n), e);
    }, Cp = function(e, n, a) {
      var i = cP(e, n, a);
      return se.from(i[i.length - 1]);
    }, fP = function(e, n, a) {
      var i = Ic(n, e), s = Ic(a, e);
      return i && i === s;
    }, Bf = function(e) {
      return Sr(e) || _1(e);
    }, Uc = function(e, n) {
      if (!n)
        return n;
      var a = n.container(), i = n.offset();
      return e ? co(a) ? Qn(a.nextSibling) ? zt(a.nextSibling, 0) : zt.after(a) : Sr(n) ? zt(a, i + 1) : n : co(a) ? Qn(a.previousSibling) ? zt(a.previousSibling, a.previousSibling.data.length) : zt.before(a) : _1(n) ? zt(a, i - 1) : n;
    }, F6 = ne(Uc, !0), $6 = ne(Uc, !1), Kw = function(e) {
      return function(n) {
        return Dr(e, O.fromDom(n.dom.parentNode));
      };
    }, vP = function(e) {
      return nf(e) || Ru(e);
    }, Xw = function(e, n) {
      return $a(e, n) ? Jm(n, vP, Kw(e)) : se.none();
    }, L6 = function(e) {
      var n = e.getBody(), a = n.firstChild && e.dom.isBlock(n.firstChild) ? n.firstChild : n;
      e.selection.setCursorLocation(a, 0);
    }, I_ = function(e) {
      e.dom.isEmpty(e.getBody()) && (e.setContent(""), L6(e));
    }, dP = function(e, n, a) {
      return Vu(Gu(a), Ml(a), function(i, s) {
        var f = Uc(!0, i), p = Uc(!1, s), C = Uc(!1, n);
        return e ? ac(a, C).exists(function(k) {
          return k.isEqual(p) && n.isEqual(f);
        }) : Lc(a, C).exists(function(k) {
          return k.isEqual(f) && n.isEqual(p);
        });
      }).getOr(!0);
    }, mP = function(e, n) {
      return {
        block: e,
        position: n
      };
    }, Sp = function(e, n) {
      return {
        from: e,
        to: n
      };
    }, F_ = function(e, n) {
      var a = O.fromDom(e), i = O.fromDom(n.container());
      return Xw(a, i).map(function(s) {
        return mP(s, n);
      });
    }, gP = function(e) {
      return Dr(e.from.block, e.to.block) === !1;
    }, pP = function(e) {
      return Ho(e.from.block).bind(function(n) {
        return Ho(e.to.block).filter(function(a) {
          return Dr(n, a);
        });
      }).isSome();
    }, hP = function(e) {
      return xo(e.from.block.dom) === !1 && xo(e.to.block.dom) === !1;
    }, bP = function(e, n, a) {
      return to(a.position.getNode()) && lu(a.block) === !1 ? vv(!1, a.block.dom).bind(function(i) {
        return i.isEqual(a.position) ? As(n, e, i).bind(function(s) {
          return F_(e, s);
        }) : se.some(a);
      }).getOr(a) : a;
    }, yP = function(e, n, a) {
      var i = F_(e, zt.fromRangeStart(a)), s = i.bind(function(f) {
        return As(n, e, f.position).bind(function(p) {
          return F_(e, p).map(function(C) {
            return bP(e, n, C);
          });
        });
      });
      return Vu(i, s, Sp).filter(function(f) {
        return gP(f) && pP(f) && hP(f);
      });
    }, wP = function(e, n, a) {
      return a.collapsed ? yP(e, n, a) : se.none();
    }, CP = function(e) {
      var n = Hu(e);
      return gt(n, ll).fold(N(n), function(a) {
        return n.slice(0, a);
      });
    }, z6 = function(e) {
      var n = CP(e);
      return at(n, Yo), n;
    }, H6 = function(e, n) {
      var a = zc(n, e);
      return tt(a.reverse(), function(i) {
        return lu(i);
      }).each(Yo);
    }, SP = function(e) {
      return Ie(Da(e), function(n) {
        return !lu(n);
      }).length === 0;
    }, xP = function(e, n, a, i) {
      if (lu(a))
        return Ef(a), Gu(a.dom);
      SP(i) && lu(n) && iu(i, O.fromTag("br"));
      var s = Lc(a.dom, zt.before(i.dom));
      return at(z6(n), function(f) {
        iu(i, f);
      }), H6(e, n), s;
    }, Yw = function(e, n, a) {
      if (lu(a))
        return Yo(a), lu(n) && Ef(n), Gu(n.dom);
      var i = Ml(a.dom);
      return at(z6(n), function(s) {
        _i(a, s);
      }), H6(e, n), i;
    }, kP = function(e, n) {
      var a = zc(n, e);
      return se.from(a[a.length - 1]);
    }, $_ = function(e, n) {
      return $a(n, e) ? kP(n, e) : se.none();
    }, V6 = function(e, n) {
      vv(e, n.dom).map(function(a) {
        return a.getNode();
      }).map(O.fromDom).filter(tg).each(Yo);
    }, U6 = function(e, n, a) {
      return V6(!0, n), V6(!1, a), $_(n, a).fold(ne(Yw, e, n, a), ne(xP, e, n, a));
    }, j6 = function(e, n, a, i) {
      return n ? U6(e, i, a) : U6(e, a, i);
    }, K4 = function(e, n) {
      var a = O.fromDom(e.getBody()), i = wP(a.dom, n, e.selection.getRng()).bind(function(s) {
        return j6(a, n, s.from.block, s.to.block);
      });
      return i.each(function(s) {
        e.selection.setRng(s.toRange());
      }), i.isSome();
    }, Zh = function(e, n) {
      var a = n.getRng();
      return Vu(Xw(e, O.fromDom(a.startContainer)), Xw(e, O.fromDom(a.endContainer)), function(i, s) {
        return Dr(i, s) === !1 ? (a.deleteContents(), j6(e, !0, i, s).each(function(f) {
          n.setRng(f.toRange());
        }), !0) : !1;
      }).getOr(!1);
    }, xp = function(e, n) {
      var a = O.fromDom(n), i = ne(Dr, e);
      return Iv(a, _c, i).isSome();
    }, X4 = function(e, n) {
      return xp(e, n.startContainer) || xp(e, n.endContainer);
    }, Y4 = function(e, n) {
      var a = Lc(e.dom, zt.fromRangeStart(n)).isNone(), i = ac(e.dom, zt.fromRangeEnd(n)).isNone();
      return !X4(e, n) && a && i;
    }, Jh = function(e) {
      return e.setContent(""), e.selection.setCursorLocation(), !0;
    }, Qh = function(e) {
      var n = O.fromDom(e.getBody()), a = e.selection.getRng();
      return Y4(n, a) ? Jh(e) : Zh(n, e.selection);
    }, e1 = function(e, n) {
      return e.selection.isCollapsed() ? !1 : Qh(e);
    }, Z4 = Kl, W6 = xo, xv = function(e, n, a, i, s) {
      return se.from(n._selectionOverrides.showCaret(e, a, i, s));
    }, L_ = function(e) {
      var n = e.ownerDocument.createRange();
      return n.selectNode(e), n;
    }, t1 = function(e, n) {
      var a = e.fire("BeforeObjectSelected", { target: n });
      return a.isDefaultPrevented() ? se.none() : se.some(L_(n));
    }, z_ = function(e, n, a) {
      var i = Iu(1, e.getBody(), n), s = zt.fromRangeStart(i), f = s.getNode();
      if (Mg(f))
        return xv(1, e, f, !s.isAtEnd(), !1);
      var p = s.getNode(!0);
      if (Mg(p))
        return xv(1, e, p, !1, !1);
      var C = e.dom.getParent(s.getNode(), function(k) {
        return W6(k) || Z4(k);
      });
      return Mg(C) ? xv(1, e, C, !1, a) : se.none();
    }, kp = function(e, n, a) {
      return n.collapsed ? z_(e, n, a).getOr(n) : n;
    }, q6 = function(e) {
      return sc(e) || ap(e);
    }, G6 = function(e) {
      return wd(e) || op(e);
    }, K6 = function(e, n) {
      Qn(n) && n.data.length === 0 && e.remove(n);
    }, Zw = function(e, n, a, i, s, f) {
      return xv(i, e, f.getNode(!s), s, !0).each(function(p) {
        if (n.collapsed) {
          var C = n.cloneRange();
          s ? C.setEnd(p.startContainer, p.startOffset) : C.setStart(p.endContainer, p.endOffset), C.deleteContents();
        } else
          n.deleteContents();
        e.selection.setRng(p);
      }), K6(e.dom, a), !0;
    }, X6 = function(e, n) {
      var a = e.selection.getRng();
      if (!Qn(a.commonAncestorContainer))
        return !1;
      var i = n ? gu.Forwards : gu.Backwards, s = Jo(e.getBody()), f = ne(p2, n ? s.next : s.prev), p = n ? q6 : G6, C = Lg(i, e.getBody(), a), k = Uc(n, f(C));
      if (!k || !B0(C, k))
        return !1;
      if (p(k))
        return Zw(e, a, C.getNode(), i, n, k);
      var F = f(k);
      return F && p(F) && B0(k, F) ? Zw(e, a, C.getNode(), i, n, F) : !1;
    }, Jw = function(e, n) {
      return X6(e, n);
    }, Y6 = function(e) {
      return _c(O.fromDom(e)) || Ru(O.fromDom(e));
    }, Ll = hr.generate([
      { remove: ["element"] },
      { moveToElement: ["element"] },
      { moveToPosition: ["position"] }
    ]), Om = function(e, n) {
      var a = n.getNode(e === !1), i = e ? "after" : "before";
      return $r(a) && a.getAttribute("data-mce-caret") === i;
    }, Z6 = function(e, n, a, i) {
      var s = function(f) {
        return Uu(O.fromDom(f)) && !Fc(a, i, e);
      };
      return $g(!n, a).fold(function() {
        return $g(n, i).fold(Me, s);
      }, s);
    }, H_ = function(e, n, a, i) {
      var s = i.getNode(n === !1);
      return Xw(O.fromDom(e), O.fromDom(a.getNode())).map(function(f) {
        return lu(f) ? Ll.remove(f.dom) : Ll.moveToElement(s);
      }).orThunk(function() {
        return se.some(Ll.moveToElement(s));
      });
    }, Dm = function(e, n, a) {
      return As(n, e, a).bind(function(i) {
        return Y6(i.getNode()) || Z6(e, n, a, i) ? se.none() : n && xo(i.getNode()) || n === !1 && xo(i.getNode(!0)) ? H_(e, n, a, i) : n && wd(a) || n === !1 && sc(a) ? se.some(Ll.moveToPosition(i)) : se.none();
      });
    }, Rf = function(e, n) {
      return e && xo(n.nextSibling) ? se.some(Ll.moveToElement(n.nextSibling)) : e === !1 && xo(n.previousSibling) ? se.some(Ll.moveToElement(n.previousSibling)) : se.none();
    }, TP = function(e, n, a) {
      return a.fold(function(i) {
        return se.some(Ll.remove(i));
      }, function(i) {
        return se.some(Ll.moveToElement(i));
      }, function(i) {
        return Fc(n, i, e) ? se.none() : se.some(Ll.moveToPosition(i));
      });
    }, EP = function(e, n, a) {
      return Om(n, a) ? Rf(n, a.getNode(n === !1)).fold(function() {
        return Dm(e, n, a);
      }, se.some) : Dm(e, n, a).bind(function(i) {
        return TP(e, a, i);
      });
    }, _P = function(e, n, a) {
      var i = Iu(n ? 1 : -1, e, a), s = zt.fromRangeStart(i), f = O.fromDom(e);
      return n === !1 && wd(s) ? se.some(Ll.remove(s.getNode(!0))) : n && sc(s) ? se.some(Ll.remove(s.getNode())) : n === !1 && sc(s) && lp(f, s) ? CE(f, s).map(function(p) {
        return Ll.remove(p.getNode());
      }) : n && wd(s) && sp(f, s) ? zr(f, s).map(function(p) {
        return Ll.remove(p.getNode());
      }) : EP(e, n, s);
    }, AP = function(e, n) {
      return function(a) {
        return e._selectionOverrides.hideFakeCaret(), dr(e, n, O.fromDom(a)), !0;
      };
    }, OP = function(e, n) {
      return function(a) {
        var i = n ? zt.before(a) : zt.after(a);
        return e.selection.setRng(i.toRange()), !0;
      };
    }, DP = function(e) {
      return function(n) {
        return e.selection.setRng(n.toRange()), !0;
      };
    }, J6 = function(e, n) {
      return se.from(gm(e.getBody(), n));
    }, BP = function(e, n) {
      var a = e.selection.getNode();
      return J6(e, a).filter(xo).fold(function() {
        return _P(e.getBody(), n, e.selection.getRng()).exists(function(i) {
          return i.fold(AP(e, n), OP(e, n), DP(e));
        });
      }, Je);
    }, RP = function(e) {
      at(du(e, ".mce-offscreen-selection"), Yo);
    }, MP = function(e, n) {
      var a = e.selection.getNode();
      if (xo(a) && !Km(a)) {
        var i = J6(e, a.parentNode).filter(xo);
        return i.fold(function() {
          return RP(O.fromDom(e.getBody())), dr(e, n, O.fromDom(e.selection.getNode())), I_(e), !0;
        }, Je);
      }
      return !1;
    }, Q6 = function(e) {
      var n = e.dom, a = e.selection, i = gm(e.getBody(), a.getNode());
      if (Kl(i) && n.isBlock(i) && n.isEmpty(i)) {
        var s = n.create("br", { "data-mce-bogus": "1" });
        n.setHTML(i, ""), i.appendChild(s), a.setRng(zt.before(s).toRange());
      }
      return !0;
    }, J4 = function(e, n) {
      return e.selection.isCollapsed() ? BP(e, n) : MP(e, n);
    }, V_ = function(e, n) {
      var a = zt.fromRangeStart(e.selection.getRng());
      return As(n, e.getBody(), a).filter(function(i) {
        return n ? yE(i) : gw(i);
      }).bind(function(i) {
        return se.from(A0(n ? 0 : -1, i));
      }).exists(function(i) {
        return e.selection.select(i), !0;
      });
    }, Ib = function(e, n) {
      return e.selection.isCollapsed() ? V_(e, n) : !1;
    }, n1 = Qn, e8 = function(e) {
      return n1(e) && e.data[0] === ct;
    }, t8 = function(e) {
      return n1(e) && e.data[e.data.length - 1] === ct;
    }, U_ = function(e) {
      return e.ownerDocument.createTextNode(ct);
    }, n8 = function(e) {
      if (n1(e.previousSibling))
        return t8(e.previousSibling) || e.previousSibling.appendData(ct), e.previousSibling;
      if (n1(e))
        return e8(e) || e.insertData(0, ct), e;
      var n = U_(e);
      return e.parentNode.insertBefore(n, e), n;
    }, j_ = function(e) {
      if (n1(e.nextSibling))
        return e8(e.nextSibling) || e.nextSibling.insertData(0, ct), e.nextSibling;
      if (n1(e))
        return t8(e) || e.appendData(ct), e;
      var n = U_(e);
      return e.nextSibling ? e.parentNode.insertBefore(n, e.nextSibling) : e.parentNode.appendChild(n), n;
    }, Qw = function(e, n) {
      return e ? n8(n) : j_(n);
    }, r8 = ne(Qw, !0), W_ = ne(Qw, !1), a8 = function(e, n) {
      return Qn(e.container()) ? Qw(n, e.container()) : Qw(n, e.getNode());
    }, o8 = function(e, n) {
      var a = n.get();
      return a && e.container() === a && co(a);
    }, Mf = function(e, n) {
      return n.fold(function(a) {
        od(e.get());
        var i = r8(a);
        return e.set(i), se.some(zt(i, i.length - 1));
      }, function(a) {
        return Gu(a).map(function(i) {
          if (o8(i, e))
            return zt(e.get(), 1);
          od(e.get());
          var s = a8(i, !0);
          return e.set(s), zt(s, 1);
        });
      }, function(a) {
        return Ml(a).map(function(i) {
          if (o8(i, e))
            return zt(e.get(), e.get().length - 1);
          od(e.get());
          var s = a8(i, !1);
          return e.set(s), zt(s, s.length - 1);
        });
      }, function(a) {
        od(e.get());
        var i = W_(a);
        return e.set(i), se.some(zt(i, 1));
      });
    }, jc = function(e, n) {
      for (var a = 0; a < e.length; a++) {
        var i = e[a].apply(null, n);
        if (i.isSome())
          return i;
      }
      return se.none();
    }, Yu = hr.generate([
      { before: ["element"] },
      { start: ["element"] },
      { end: ["element"] },
      { after: ["element"] }
    ]), q_ = function(e, n) {
      var a = Ic(n, e);
      return a || e;
    }, Q4 = function(e, n, a) {
      var i = F6(a), s = q_(n, i.container());
      return Cp(e, s, i).fold(function() {
        return ac(s, i).bind(ne(Cp, e, s)).map(function(f) {
          return Yu.before(f);
        });
      }, se.none);
    }, i8 = function(e, n) {
      return cm(e, n) === null;
    }, G_ = function(e, n, a) {
      return Cp(e, n, a).filter(ne(i8, n));
    }, u8 = function(e, n, a) {
      var i = $6(a);
      return G_(e, n, i).bind(function(s) {
        var f = Lc(s, i);
        return f.isNone() ? se.some(Yu.start(s)) : se.none();
      });
    }, s8 = function(e, n, a) {
      var i = F6(a);
      return G_(e, n, i).bind(function(s) {
        var f = ac(s, i);
        return f.isNone() ? se.some(Yu.end(s)) : se.none();
      });
    }, l8 = function(e, n, a) {
      var i = $6(a), s = q_(n, i.container());
      return Cp(e, s, i).fold(function() {
        return Lc(s, i).bind(ne(Cp, e, s)).map(function(f) {
          return Yu.after(f);
        });
      }, se.none);
    }, K_ = function(e) {
      return N_(Fb(e)) === !1;
    }, Wc = function(e, n, a) {
      var i = jc([
        Q4,
        u8,
        s8,
        l8
      ], [
        e,
        n,
        a
      ]);
      return i.filter(K_);
    }, Fb = function(e) {
      return e.fold(ae, ae, ae, ae);
    }, e3 = function(e) {
      return e.fold(N("before"), N("start"), N("end"), N("after"));
    }, t3 = function(e) {
      return e.fold(Yu.before, Yu.before, Yu.after, Yu.after);
    }, X_ = function(e) {
      return e.fold(Yu.start, Yu.start, Yu.end, Yu.end);
    }, PP = function(e, n) {
      return e3(e) === e3(n) && Fb(e) === Fb(n);
    }, NP = function(e, n, a, i, s, f) {
      return Vu(Cp(n, a, i), Cp(n, a, s), function(p, C) {
        return p !== C && fP(a, p, C) ? Yu.after(e ? p : C) : f;
      }).getOr(f);
    }, c8 = function(e, n) {
      return e.fold(Je, function(a) {
        return !PP(a, n);
      });
    }, IP = function(e, n, a, i, s) {
      var f = Uc(e, s), p = As(e, a, f).map(ne(Uc, e)), C = p.fold(function() {
        return i.map(t3);
      }, function(k) {
        return Wc(n, a, k).map(ne(NP, e, n, a, f, k)).filter(ne(c8, i));
      });
      return C.filter(K_);
    }, FP = function(e, n) {
      return e ? n.fold(_e(se.some, Yu.start), se.none, _e(se.some, Yu.after), se.none) : n.fold(se.none, _e(se.some, Yu.before), se.none, _e(se.some, Yu.end));
    }, eC = function(e, n, a, i) {
      var s = Uc(e, i), f = Wc(n, a, s);
      return Wc(n, a, s).bind(ne(FP, e)).orThunk(function() {
        return IP(e, n, a, f, i);
      });
    };
    ne(eC, !1), ne(eC, !0);
    var $P = function(e) {
      return Be(e.selection.getSel().modify);
    }, f8 = function(e, n, a) {
      var i = e ? 1 : -1;
      return n.setRng(zt(a.container(), a.offset() + i).toRange()), n.getSel().modify("move", e ? "forward" : "backward", "word"), !0;
    }, LP = function(e, n) {
      var a = n.selection.getRng(), i = e ? zt.fromRangeEnd(a) : zt.fromRangeStart(a);
      return $P(n) ? e && Sr(i) ? f8(!0, n.selection, i) : !e && _1(i) ? f8(!1, n.selection, i) : !1 : !1;
    }, kd;
    (function(e) {
      e[e.Br = 0] = "Br", e[e.Block = 1] = "Block", e[e.Wrap = 2] = "Wrap", e[e.Eol = 3] = "Eol";
    })(kd || (kd = {}));
    var n3 = function(e, n) {
      return e === gu.Backwards ? It(n) : n;
    }, zP = function(e, n, a) {
      return e === gu.Forwards ? n.next(a) : n.prev(a);
    }, HP = function(e, n, a, i) {
      return to(i.getNode(n === gu.Forwards)) ? kd.Br : Fc(a, i) === !1 ? kd.Block : kd.Wrap;
    }, tC = function(e, n, a, i) {
      for (var s = Jo(a), f = i, p = []; f; ) {
        var C = zP(n, s, f);
        if (!C)
          break;
        if (to(C.getNode(!1)))
          return n === gu.Forwards ? {
            positions: n3(n, p).concat([C]),
            breakType: kd.Br,
            breakAt: se.some(C)
          } : {
            positions: n3(n, p),
            breakType: kd.Br,
            breakAt: se.some(C)
          };
        if (!C.isVisible()) {
          f = C;
          continue;
        }
        if (e(f, C)) {
          var k = HP(a, n, f, C);
          return {
            positions: n3(n, p),
            breakType: k,
            breakAt: se.some(C)
          };
        }
        p.push(C), f = C;
      }
      return {
        positions: n3(n, p),
        breakType: kd.Eol,
        breakAt: se.none()
      };
    }, nC = function(e, n, a, i) {
      return n(a, i).breakAt.map(function(s) {
        var f = n(a, s).positions;
        return e === gu.Backwards ? f.concat(s) : [s].concat(f);
      }).getOr([]);
    }, rC = function(e, n) {
      return Xe(e, function(a, i) {
        return a.fold(function() {
          return se.some(i);
        }, function(s) {
          return Vu(Vn(s.getClientRects()), Vn(i.getClientRects()), function(f, p) {
            var C = Math.abs(n - f.left), k = Math.abs(n - p.left);
            return k <= C ? i : s;
          }).or(a);
        });
      }, se.none());
    }, v8 = function(e, n) {
      return Vn(n.getClientRects()).bind(function(a) {
        return rC(e, a.left);
      });
    }, aC = ne(tC, zt.isAbove, -1), oC = ne(tC, zt.isBelow, 1), VP = ne(nC, -1, aC), d8 = ne(nC, 1, oC), UP = function(e, n) {
      return aC(e, n).breakAt.isNone();
    }, jP = function(e, n) {
      return oC(e, n).breakAt.isNone();
    }, Y_ = function(e) {
      return Gu(e).map(function(n) {
        return [n].concat(oC(e, n).positions);
      }).getOr([]);
    }, WP = function(e) {
      return Ml(e).map(function(n) {
        return aC(e, n).positions.concat(n);
      }).getOr([]);
    }, qP = function(e) {
      var n = function(i) {
        return Ke(i, function(s) {
          var f = td(s);
          return f.node = e, f;
        });
      };
      if ($r(e))
        return n(e.getClientRects());
      if (Qn(e)) {
        var a = e.ownerDocument.createRange();
        return a.setStart(e, 0), a.setEnd(e, e.data.length), n(a.getClientRects());
      }
    }, Z_ = function(e) {
      return Qt(e, qP);
    }, r1;
    (function(e) {
      e[e.Up = -1] = "Up", e[e.Down = 1] = "Down";
    })(r1 || (r1 = {}));
    var GP = function(e, n, a, i) {
      for (; i = ud(i, e, bi, n); )
        if (a(i))
          return;
    }, m8 = function(e, n, a, i, s, f) {
      var p = 0, C = [], k = function(K) {
        var te = Z_([K]);
        e === -1 && (te = te.reverse());
        for (var be = 0; be < te.length; be++) {
          var we = te[be];
          if (!a(we, F)) {
            if (C.length > 0 && n(we, ei(C)) && p++, we.line = p, s(we))
              return !0;
            C.push(we);
          }
        }
      }, F = ei(f.getClientRects());
      if (!F)
        return C;
      var q = f.getNode();
      return k(q), GP(e, i, k, q), C;
    }, KP = function(e, n) {
      return n.line > e;
    }, r3 = function(e, n) {
      return n.line === e;
    }, a3 = ne(m8, r1.Up, yg, wg), XP = ne(m8, r1.Down, wg, yg), YP = function(e, n, a, i) {
      var s = Jo(n), f, p, C, k, F = [], q = 0, K = function(ke) {
        return ei(ke.getClientRects());
      };
      e === 1 ? (f = s.next, p = wg, C = yg, k = zt.after(i)) : (f = s.prev, p = yg, C = wg, k = zt.before(i));
      var te = K(k);
      do
        if (!!k.isVisible()) {
          var be = K(k);
          if (!C(be, te)) {
            F.length > 0 && p(be, ei(F)) && q++;
            var we = td(be);
            if (we.position = k, we.line = q, a(we))
              return F;
            F.push(we);
          }
        }
      while (k = f(k));
      return F;
    }, iC = function(e) {
      return function(n) {
        return KP(e, n);
      };
    }, J_ = function(e) {
      return function(n) {
        return r3(e, n);
      };
    }, ZP = xo, g8 = ud, Q_ = function(e, n) {
      return Math.abs(e.left - n);
    }, eA = function(e, n) {
      return Math.abs(e.right - n);
    }, p8 = function(e, n) {
      return e >= n.left && e <= n.right;
    }, JP = function(e, n) {
      return e >= n.top && e <= n.bottom;
    }, QP = function(e) {
      return Va(e, "node");
    }, o3 = function(e, n, a) {
      return a === void 0 && (a = Je), gi(e, function(i, s) {
        if (p8(n, s))
          return a(s) ? s : i;
        if (p8(n, i))
          return a(i) ? i : s;
        var f = Math.min(Q_(i, n), eA(i, n)), p = Math.min(Q_(s, n), eA(s, n));
        return p === f && QP(s) && ZP(s.node) || p < f ? s : i;
      });
    }, h8 = function(e, n, a, i, s) {
      var f = g8(i, e, bi, n, !s);
      do
        if (!f || a(f))
          return;
      while (f = g8(f, e, bi, n));
    }, eN = function(e, n, a) {
      a === void 0 && (a = !0);
      var i = [], s = function(f, p) {
        var C = Ie(Z_([p]), function(k) {
          return !f(k, n);
        });
        return i = i.concat(C), C.length === 0;
      };
      return i.push(n), h8(r1.Up, e, ne(s, yg), n.node, a), h8(r1.Down, e, ne(s, wg), n.node, a), i;
    }, tN = function(e) {
      return Ie(Tn(e.getElementsByTagName("*")), um);
    }, Pf = function(e, n) {
      return {
        node: e.node,
        before: Q_(e, n) < eA(e, n)
      };
    }, tA = function(e, n, a) {
      var i = Z_(tN(e)), s = Ie(i, ne(JP, a)), f = function(k) {
        return !si(k.node) && !Cs(k.node);
      }, p = o3(s, n, f);
      if (p) {
        var C = f(p);
        if (p = o3(eN(e, p, C), n, f), p && um(p.node))
          return Pf(p, n);
      }
      return null;
    }, Td = function(e, n) {
      e.selection.setRng(n), Dh(e, e.selection.getRng());
    }, i3 = function(e, n, a) {
      return se.some(kp(e, n, a));
    }, b8 = function(e, n, a, i, s, f) {
      var p = n === gu.Forwards, C = Jo(e.getBody()), k = ne(p2, p ? C.next : C.prev), F = p ? i : s;
      if (!a.collapsed) {
        var q = tm(a);
        if (f(q))
          return xv(n, e, q, n === gu.Backwards, !1);
      }
      var K = Lg(n, e.getBody(), a);
      if (F(K))
        return t1(e, K.getNode(!p));
      var te = Uc(p, k(K)), be = rf(a);
      if (!te)
        return be ? se.some(a) : se.none();
      if (F(te))
        return xv(n, e, te.getNode(!p), p, !1);
      var we = k(te);
      return we && F(we) && B0(te, we) ? xv(n, e, we.getNode(!p), p, !1) : be ? i3(e, te.toRange(), !1) : se.none();
    }, nA = function(e, n, a, i, s, f) {
      var p = Lg(n, e.getBody(), a), C = ei(p.getClientRects()), k = n === r1.Down;
      if (!C)
        return se.none();
      var F = k ? XP : a3, q = F(e.getBody(), iC(1), p), K = Ie(q, J_(1)), te = C.left, be = o3(K, te);
      if (be && f(be.node)) {
        var we = Math.abs(te - be.left), ke = Math.abs(te - be.right);
        return xv(n, e, be.node, we < ke, !1);
      }
      var Ee;
      if (i(p) ? Ee = p.getNode() : s(p) ? Ee = p.getNode(!0) : Ee = tm(a), Ee) {
        var qe = YP(n, e.getBody(), iC(1), Ee), Le = o3(Ie(qe, J_(1)), te);
        if (Le || (Le = ei(Ie(qe, J_(0))), Le))
          return i3(e, Le.position.toRange(), !1);
      }
      return K.length === 0 ? rA(e, k).filter(k ? s : i).map(function(xt) {
        return kp(e, xt.toRange(), !1);
      }) : se.none();
    }, rA = function(e, n) {
      var a = e.selection.getRng(), i = e.getBody();
      if (n) {
        var s = zt.fromRangeEnd(a), f = oC(i, s);
        return Un(f.positions);
      } else {
        var s = zt.fromRangeStart(a), f = aC(i, s);
        return Vn(f.positions);
      }
    }, aA = function(e, n, a) {
      return rA(e, n).filter(a).exists(function(i) {
        return e.selection.setRng(i.toRange()), !0;
      });
    }, u3 = function(e, n) {
      var a = e.dom.createRng();
      a.setStart(n.container(), n.offset()), a.setEnd(n.container(), n.offset()), e.selection.setRng(a);
    }, y8 = function(e, n) {
      e ? n.setAttribute("data-mce-selected", "inline-boundary") : n.removeAttribute("data-mce-selected");
    }, w8 = function(e, n, a) {
      return Mf(n, a).map(function(i) {
        return u3(e, i), a;
      });
    }, $b = function(e, n, a) {
      var i = e.getBody(), s = zt.fromRangeStart(e.selection.getRng()), f = ne(wp, e), p = eC(a, f, i, s);
      return p.bind(function(C) {
        return w8(e, n, C);
      });
    }, C8 = function(e, n, a) {
      var i = Ke(du(O.fromDom(n.getRoot()), '*[data-mce-selected="inline-boundary"]'), function(p) {
        return p.dom;
      }), s = Ie(i, e), f = Ie(a, e);
      at(qt(s, f), ne(y8, !1)), at(qt(f, s), ne(y8, !0));
    }, S8 = function(e, n) {
      if (e.selection.isCollapsed() && e.composing !== !0 && n.get()) {
        var a = zt.fromRangeStart(e.selection.getRng());
        zt.isTextPosition(a) && Bf(a) === !1 && (u3(e, $S(n.get(), a)), n.set(null));
      }
    }, x8 = function(e, n, a, i) {
      if (n.selection.isCollapsed()) {
        var s = Ie(i, e);
        at(s, function(f) {
          var p = zt.fromRangeStart(n.selection.getRng());
          Wc(e, n.getBody(), p).bind(function(C) {
            return w8(n, a, C);
          });
        });
      }
    }, s3 = function(e, n, a) {
      return hh(e) ? $b(e, n, a).isSome() : !1;
    }, k8 = function(e, n, a) {
      return hh(n) ? LP(e, n) : !1;
    }, nN = function(e) {
      var n = ss(null), a = ne(wp, e);
      return e.on("NodeChange", function(i) {
        hh(e) && !(br.browser.isIE() && i.initial) && (C8(a, e.dom, i.parents), S8(e, n), x8(a, e, n, i.parents));
      }), n;
    }, rN = ne(k8, !0), aN = ne(k8, !1), l3 = function(e, n, a) {
      if (hh(e)) {
        var i = rA(e, n).getOrThunk(function() {
          var s = e.selection.getRng();
          return n ? zt.fromRangeEnd(s) : zt.fromRangeStart(s);
        });
        return Wc(ne(wp, e), e.getBody(), i).exists(function(s) {
          var f = t3(s);
          return Mf(a, f).exists(function(p) {
            return u3(e, p), !0;
          });
        });
      } else
        return !1;
    }, oN = function(e, n) {
      var a = document.createRange();
      return a.setStart(e.container(), e.offset()), a.setEnd(n.container(), n.offset()), a;
    }, kv = function(e) {
      return Vu(Gu(e), Ml(e), function(n, a) {
        var i = Uc(!0, n), s = Uc(!1, a);
        return ac(e, i).forall(function(f) {
          return f.isEqual(s);
        });
      }).getOr(!0);
    }, T8 = function(e, n) {
      return function(a) {
        return Mf(n, a).exists(function(i) {
          return u3(e, i), !0;
        });
      };
    }, E8 = function(e, n, a, i) {
      var s = e.getBody(), f = ne(wp, e);
      e.undoManager.ignore(function() {
        e.selection.setRng(oN(a, i)), e.execCommand("Delete"), Wc(f, s, zt.fromRangeStart(e.selection.getRng())).map(X_).map(T8(e, n));
      }), e.nodeChanged();
    }, iN = function(e, n) {
      var a = Ic(n, e);
      return a || e;
    }, uN = function(e, n, a, i) {
      var s = iN(e.getBody(), i.container()), f = ne(wp, e), p = Wc(f, s, i);
      return p.bind(function(C) {
        return a ? C.fold(N(se.some(X_(C))), se.none, N(se.some(t3(C))), se.none) : C.fold(se.none, N(se.some(t3(C))), se.none, N(se.some(X_(C))));
      }).map(T8(e, n)).getOrThunk(function() {
        var C = $c(a, s, i), k = C.bind(function(F) {
          return Wc(f, s, F);
        });
        return Vu(p, k, function() {
          return Cp(f, s, i).exists(function(F) {
            return kv(F) ? (dr(e, a, O.fromDom(F)), !0) : !1;
          });
        }).orThunk(function() {
          return k.bind(function(F) {
            return C.map(function(q) {
              return a ? E8(e, n, i, q) : E8(e, n, q, i), !0;
            });
          });
        }).getOr(!1);
      });
    }, c3 = function(e, n, a) {
      if (e.selection.isCollapsed() && hh(e)) {
        var i = zt.fromRangeStart(e.selection.getRng());
        return uN(e, n, a, i);
      }
      return !1;
    }, sN = function(e, n) {
      var a = zc(n, e);
      return gt(a, ll).fold(N(a), function(i) {
        return a.slice(0, i);
      });
    }, lN = function(e) {
      return C1(e) === 1;
    }, Tp = function(e, n, a, i) {
      var s = ne(tM, n), f = Ke(Ie(i, s), function(C) {
        return C.dom;
      });
      if (f.length === 0)
        dr(n, e, a);
      else {
        var p = Eb(a.dom, f);
        n.selection.setRng(p.toRange());
      }
    }, cN = function(e, n) {
      var a = O.fromDom(e.getBody()), i = O.fromDom(e.selection.getStart()), s = Ie(sN(a, i), lN);
      return Un(s).exists(function(f) {
        var p = zt.fromRangeStart(e.selection.getRng());
        return dP(n, p, f.dom) && !nM(f) ? (Tp(n, e, f, s), !0) : !1;
      });
    }, f3 = function(e, n) {
      return e.selection.isCollapsed() ? cN(e, n) : !1;
    }, v3 = function(e, n, a) {
      return e._selectionOverrides.hideFakeCaret(), dr(e, n, O.fromDom(a)), !0;
    }, oA = function(e, n) {
      var a = n ? ap : op, i = n ? gu.Forwards : gu.Backwards, s = Lg(i, e.getBody(), e.selection.getRng());
      return a(s) ? v3(e, n, s.getNode(!n)) : se.from(Uc(n, s)).filter(function(f) {
        return a(f) && B0(s, f);
      }).exists(function(f) {
        return v3(e, n, f.getNode(!n));
      });
    }, fN = function(e, n) {
      var a = e.selection.getNode();
      return Cs(a) ? v3(e, n, a) : !1;
    }, d3 = function(e, n) {
      return e.selection.isCollapsed() ? oA(e, n) : fN(e, n);
    }, vN = function(e) {
      return Jm(e, function(n) {
        return Kl(n.dom) || xo(n.dom);
      }).exists(function(n) {
        return Kl(n.dom);
      });
    }, Bm = function(e) {
      var n = parseInt(e, 10);
      return isNaN(n) ? 0 : n;
    }, _8 = function(e, n) {
      var a = e || Ck(n) ? "margin" : "padding", i = aa(n, "direction") === "rtl" ? "-right" : "-left";
      return a + i;
    }, dN = function(e, n, a, i, s, f) {
      var p = _8(a, O.fromDom(f));
      if (n === "outdent") {
        var C = Math.max(0, Bm(f.style[p]) - i);
        e.setStyle(f, p, C ? C + s : "");
      } else {
        var C = Bm(f.style[p]) + i + s;
        e.setStyle(f, p, C);
      }
    }, mN = function(e, n) {
      return In(n, function(a) {
        var i = _8(TS(e), a), s = su(a, i).map(Bm).getOr(0), f = e.dom.getContentEditable(a.dom);
        return f !== "false" && s > 0;
      });
    }, A8 = function(e) {
      var n = uA(e);
      return !e.mode.isReadOnly() && (n.length > 1 || mN(e, n));
    }, m3 = function(e) {
      return Zl(e) || Ru(e);
    }, iA = function(e) {
      return Ho(e).exists(m3);
    }, uA = function(e) {
      return Ie(Vi(e.selection.getSelectedBlocks()), function(n) {
        return !m3(n) && !iA(n) && vN(n);
      });
    }, sA = function(e, n) {
      var a = e.dom, i = e.selection, s = e.formatter, f = r2(e), p = /[a-z%]+$/i.exec(f)[0], C = parseInt(f, 10), k = TS(e), F = mu(e);
      !e.queryCommandState("InsertUnorderedList") && !e.queryCommandState("InsertOrderedList") && F === "" && !a.getParent(i.getNode(), a.isBlock) && s.apply("div"), at(uA(e), function(q) {
        dN(a, n, k, C, p, q.dom);
      });
    }, lA = function(e, n) {
      if (e.selection.isCollapsed() && A8(e)) {
        var a = e.dom, i = e.selection.getRng(), s = zt.fromRangeStart(i), f = a.getParent(i.startContainer, a.isBlock);
        if (f !== null && Jr(O.fromDom(f), s))
          return sA(e, "outdent"), !0;
      }
      return !1;
    }, O8 = function(e, n) {
      e.getDoc().execCommand(n, !1, null);
    }, uC = function(e, n) {
      if (!lA(e)) {
        if (J4(e, !1))
          return;
        if (Jw(e, !1))
          return;
        if (c3(e, n, !1))
          return;
        if (K4(e, !1))
          return;
        if (p4(e))
          return;
        if (Ib(e, !1))
          return;
        if (d3(e, !1))
          return;
        if (e1(e))
          return;
        if (f3(e, !1))
          return;
        O8(e, "Delete"), I_(e);
      }
    }, gN = function(e, n) {
      if (!J4(e, !0)) {
        if (Jw(e, !0))
          return;
        if (c3(e, n, !0))
          return;
        if (K4(e, !0))
          return;
        if (p4(e))
          return;
        if (Ib(e, !0))
          return;
        if (d3(e, !0))
          return;
        if (e1(e))
          return;
        if (f3(e, !0))
          return;
        O8(e, "ForwardDelete");
      }
    }, pN = function(e, n) {
      e.addCommand("delete", function() {
        uC(e, n);
      }), e.addCommand("forwardDelete", function() {
        gN(e, n);
      });
    }, D8 = 5, Lb = 400, B8 = function(e) {
      return e.touches === void 0 || e.touches.length !== 1 ? se.none() : se.some(e.touches[0]);
    }, Rm = function(e, n) {
      var a = Math.abs(e.clientX - n.x), i = Math.abs(e.clientY - n.y);
      return a > D8 || i > D8;
    }, hN = function(e) {
      var n = ed(), a = ss(!1), i = Hi(function(s) {
        e.fire("longpress", sr(sr({}, s), { type: "longpress" })), a.set(!0);
      }, Lb);
      e.on("touchstart", function(s) {
        B8(s).each(function(f) {
          i.cancel();
          var p = {
            x: f.clientX,
            y: f.clientY,
            target: s.target
          };
          i.throttle(s), a.set(!1), n.set(p);
        });
      }, !0), e.on("touchmove", function(s) {
        i.cancel(), B8(s).each(function(f) {
          n.on(function(p) {
            Rm(f, p) && (n.clear(), a.set(!1), e.fire("longpresscancel"));
          });
        });
      }, !0), e.on("touchend touchcancel", function(s) {
        i.cancel(), s.type !== "touchcancel" && n.get().filter(function(f) {
          return f.target.isEqualNode(s.target);
        }).each(function() {
          a.get() ? s.preventDefault() : e.fire("tap", sr(sr({}, s), { type: "tap" }));
        });
      }, !0);
    }, sC = function(e, n) {
      return Fr(e, n.nodeName);
    }, cA = function(e, n) {
      return Qn(n) ? !0 : $r(n) ? !sC(e, n) && !Os(n) : !1;
    }, bN = function(e, n, a) {
      return Ae(Lh(O.fromDom(a), O.fromDom(n)), function(i) {
        return sC(e, i.dom);
      });
    }, yN = function(e, n) {
      if (Qn(n)) {
        if (n.nodeValue.length === 0)
          return !0;
        if (/^\s+$/.test(n.nodeValue) && (!n.nextSibling || sC(e, n.nextSibling)))
          return !0;
      }
      return !1;
    }, wN = function(e) {
      var n = e.dom, a = e.selection, i = e.schema, s = i.getBlockElements(), f = a.getStart(), p = e.getBody(), C, k, F, q = mu(e);
      if (!(!f || !$r(f) || !q)) {
        var K = p.nodeName.toLowerCase();
        if (!(!i.isValidChild(K, q.toLowerCase()) || bN(s, p, f))) {
          var te = a.getRng(), be = te.startContainer, we = te.startOffset, ke = te.endContainer, Ee = te.endOffset, qe = Il(e);
          for (f = p.firstChild; f; )
            if (cA(s, f)) {
              if (yN(s, f)) {
                k = f, f = f.nextSibling, n.remove(k);
                continue;
              }
              C || (C = n.create(q, Tg(e)), f.parentNode.insertBefore(C, f), F = !0), k = f, f = f.nextSibling, C.appendChild(k);
            } else
              C = null, f = f.nextSibling;
          F && qe && (te.setStart(be, we), te.setEnd(ke, Ee), a.setRng(te), e.nodeChanged());
        }
      }
    }, R8 = function(e) {
      mu(e) && e.on("NodeChange", ne(wN, e));
    }, CN = function(e) {
      return Qm(O.fromDom(e.getBody()), "*[data-mce-caret]").map(function(n) {
        return n.dom;
      }).getOrNull();
    }, SN = function(e) {
      e.selection.setRng(e.selection.getRng());
    }, M8 = function(e, n) {
      n.hasAttribute("data-mce-caret") && (sy(n), SN(e), e.selection.scrollIntoView(n));
    }, xN = function(e, n) {
      var a = CN(e);
      if (!!a) {
        if (n.type === "compositionstart") {
          n.preventDefault(), n.stopPropagation(), M8(e, a);
          return;
        }
        tv(a) && (M8(e, a), e.undoManager.add());
      }
    }, P8 = function(e) {
      e.on("keyup compositionstart", ne(xN, e));
    }, N8 = xo, a1 = function(e, n, a) {
      return b8(n, e, a, sc, wd, N8);
    }, kN = function(e, n, a) {
      var i = function(f) {
        return sc(f) || n4(f);
      }, s = function(f) {
        return wd(f) || pw(f);
      };
      return nA(n, e, a, i, s, N8);
    }, lC = function(e) {
      var n = e.dom.create(mu(e));
      return (!br.ie || br.ie >= 11) && (n.innerHTML = '<br data-mce-bogus="1">'), n;
    }, fA = function(e, n, a) {
      var i = Jo(e.getBody()), s = ne(p2, n === 1 ? i.next : i.prev);
      if (a.collapsed && fT(e)) {
        var f = e.dom.getParent(a.startContainer, "PRE");
        if (!f)
          return;
        var p = s(zt.fromRangeStart(a));
        if (!p) {
          var C = lC(e);
          n === 1 ? e.$(f).after(C) : e.$(f).before(C), e.selection.select(C, !0), e.selection.collapse();
        }
      }
    }, vA = function(e, n) {
      var a = n ? gu.Forwards : gu.Backwards, i = e.selection.getRng();
      return a1(a, e, i).orThunk(function() {
        return fA(e, a, i), se.none();
      });
    }, dA = function(e, n) {
      var a = n ? 1 : -1, i = e.selection.getRng();
      return kN(a, e, i).orThunk(function() {
        return fA(e, a, i), se.none();
      });
    }, I8 = function(e, n) {
      return vA(e, n).exists(function(a) {
        return Td(e, a), !0;
      });
    }, F8 = function(e, n) {
      return dA(e, n).exists(function(a) {
        return Td(e, a), !0;
      });
    }, $8 = function(e, n) {
      var a = n ? wd : sc;
      return aA(e, n, a);
    }, mA = function(e) {
      return We(["figcaption"], Oa(e));
    }, L8 = function(e) {
      var n = document.createRange();
      return n.setStartBefore(e.dom), n.setEndBefore(e.dom), n;
    }, z8 = function(e, n, a) {
      a ? _i(e, n) : _l(e, n);
    }, TN = function(e, n) {
      var a = O.fromTag("br");
      return z8(e, a, n), L8(a);
    }, EN = function(e, n, a, i) {
      var s = O.fromTag(a), f = O.fromTag("br");
      return G(s, i), _i(s, f), z8(e, s, n), L8(f);
    }, H8 = function(e, n, a, i) {
      return n === "" ? TN(e, i) : EN(e, i, n, a);
    }, _N = function(e, n) {
      var a = ne(Dr, n);
      return Jm(O.fromDom(e.container()), ll, a).filter(mA);
    }, AN = function(e, n, a) {
      return n ? jP(e.dom, a) : UP(e.dom, a);
    }, ON = function(e, n) {
      var a = O.fromDom(e.getBody()), i = zt.fromRangeStart(e.selection.getRng()), s = mu(e), f = Tg(e);
      return _N(i, a).exists(function() {
        if (AN(a, n, i)) {
          var p = H8(a, s, f, n);
          return e.selection.setRng(p), !0;
        } else
          return !1;
      });
    }, V8 = function(e, n) {
      return e.selection.isCollapsed() ? ON(e, n) : !1;
    }, DN = function(e) {
      return Ke(e, function(n) {
        return sr({
          shiftKey: !1,
          altKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          keyCode: 0,
          action: xe
        }, n);
      });
    }, BN = function(e, n) {
      return n.keyCode === e.keyCode && n.shiftKey === e.shiftKey && n.altKey === e.altKey && n.ctrlKey === e.ctrlKey && n.metaKey === e.metaKey;
    }, RN = function(e, n) {
      return Qt(DN(e), function(a) {
        return BN(a, n) ? [a] : [];
      });
    }, xa = function(e) {
      for (var n = [], a = 1; a < arguments.length; a++)
        n[a - 1] = arguments[a];
      return function() {
        return e.apply(null, n);
      };
    }, o1 = function(e, n) {
      return tt(RN(e, n), function(a) {
        return a.action();
      });
    }, U8 = function(e, n) {
      var a = n ? gu.Forwards : gu.Backwards, i = e.selection.getRng();
      return b8(e, a, i, ap, op, Cs).exists(function(s) {
        return Td(e, s), !0;
      });
    }, gA = function(e, n) {
      var a = n ? 1 : -1, i = e.selection.getRng();
      return nA(e, a, i, ap, op, Cs).exists(function(s) {
        return Td(e, s), !0;
      });
    }, j8 = function(e, n) {
      var a = n ? op : ap;
      return aA(e, n, a);
    }, MN = function(e, n) {
      return {
        left: e.left - n,
        top: e.top - n,
        right: e.right + n * 2,
        bottom: e.bottom + n * 2,
        width: e.width + n,
        height: e.height + n
      };
    }, PN = function(e, n) {
      return Qt(n, function(a) {
        var i = MN(td(a.getBoundingClientRect()), -1);
        return [
          {
            x: i.left,
            y: e(i),
            cell: a
          },
          {
            x: i.right,
            y: e(i),
            cell: a
          }
        ];
      });
    }, NN = function(e, n, a) {
      return Xe(e, function(i, s) {
        return i.fold(function() {
          return se.some(s);
        }, function(f) {
          var p = Math.sqrt(Math.abs(f.x - n) + Math.abs(f.y - a)), C = Math.sqrt(Math.abs(s.x - n) + Math.abs(s.y - a));
          return se.some(C < p ? s : f);
        });
      }, se.none());
    }, W8 = function(e, n, a, i, s) {
      var f = du(O.fromDom(a), "td,th,caption").map(function(C) {
        return C.dom;
      }), p = Ie(PN(e, f), function(C) {
        return n(C, s);
      });
      return NN(p, i, s).map(function(C) {
        return C.cell;
      });
    }, IN = function(e) {
      return e.bottom;
    }, FN = function(e) {
      return e.top;
    }, $N = function(e, n) {
      return e.y < n;
    }, LN = function(e, n) {
      return e.y > n;
    }, zN = ne(W8, IN, $N), HN = ne(W8, FN, LN), VN = function(e, n) {
      return Vn(n.getClientRects()).bind(function(a) {
        return zN(e, a.left, a.top);
      }).bind(function(a) {
        return v8(WP(a), n);
      });
    }, UN = function(e, n) {
      return Un(n.getClientRects()).bind(function(a) {
        return HN(e, a.left, a.top);
      }).bind(function(a) {
        return v8(Y_(a), n);
      });
    }, q8 = function(e, n, a) {
      return a.breakAt.exists(function(i) {
        return e(n, i).breakAt.isSome();
      });
    }, jN = function(e) {
      return e.breakType === kd.Wrap && e.positions.length === 0;
    }, WN = function(e) {
      return e.breakType === kd.Br && e.positions.length === 1;
    }, pA = function(e, n, a) {
      var i = e(n, a);
      return jN(i) || !to(a.getNode()) && WN(i) ? !q8(e, n, i) : i.breakAt.isNone();
    }, G8 = ne(pA, aC), g3 = ne(pA, oC), K8 = function(e, n, a) {
      var i = zt.fromRangeStart(n);
      return vv(!e, a).exists(function(s) {
        return s.isEqual(i);
      });
    }, hA = function(e, n, a, i) {
      var s = e.selection.getRng(), f = n ? 1 : -1;
      return d2() && K8(n, s, a) ? (xv(f, e, a, !n, !1).each(function(p) {
        Td(e, p);
      }), !0) : !1;
    }, bA = function(e, n, a) {
      return VN(n, a).orThunk(function() {
        return Vn(a.getClientRects()).bind(function(i) {
          return rC(VP(e, zt.before(n)), i.left);
        });
      }).getOr(zt.before(n));
    }, X8 = function(e, n, a) {
      return UN(n, a).orThunk(function() {
        return Vn(a.getClientRects()).bind(function(i) {
          return rC(d8(e, zt.after(n)), i.left);
        });
      }).getOr(zt.after(n));
    }, Y8 = function(e, n) {
      var a = n.getNode(e);
      return $r(a) && a.nodeName === "TABLE" ? se.some(a) : se.none();
    }, Z8 = function(e, n, a, i) {
      var s = mu(n);
      s ? n.undoManager.transact(function() {
        var f = O.fromTag(s);
        G(f, Tg(n)), _i(f, O.fromTag("br")), e ? Nv(O.fromDom(a), f) : iu(O.fromDom(a), f);
        var p = n.dom.createRng();
        p.setStart(f.dom, 0), p.setEnd(f.dom, 0), Td(n, p);
      }) : Td(n, i.toRange());
    }, i1 = function(e, n, a) {
      var i = Y8(!!n, a), s = n === !1;
      i.fold(function() {
        return Td(e, a.toRange());
      }, function(f) {
        return vv(s, e.getBody()).filter(function(p) {
          return p.isEqual(a);
        }).fold(function() {
          return Td(e, a.toRange());
        }, function(p) {
          return Z8(n, e, f, a);
        });
      });
    }, J8 = function(e, n, a, i) {
      var s = e.selection.getRng(), f = zt.fromRangeStart(s), p = e.getBody();
      if (!n && G8(i, f)) {
        var C = bA(p, a, f);
        return i1(e, n, C), !0;
      } else if (n && g3(i, f)) {
        var C = X8(p, a, f);
        return i1(e, n, C), !0;
      } else
        return !1;
    }, p3 = function(e, n, a) {
      return se.from(e.dom.getParent(e.selection.getNode(), "td,th")).bind(function(i) {
        return se.from(e.dom.getParent(i, "table")).map(function(s) {
          return a(e, n, s, i);
        });
      }).getOr(!1);
    }, Q8 = function(e, n) {
      return p3(e, n, hA);
    }, h3 = function(e, n) {
      return p3(e, n, J8);
    }, qN = function(e, n, a) {
      var i = lr().os;
      o1([
        {
          keyCode: Br.RIGHT,
          action: xa(I8, e, !0)
        },
        {
          keyCode: Br.LEFT,
          action: xa(I8, e, !1)
        },
        {
          keyCode: Br.UP,
          action: xa(F8, e, !1)
        },
        {
          keyCode: Br.DOWN,
          action: xa(F8, e, !0)
        },
        {
          keyCode: Br.RIGHT,
          action: xa(Q8, e, !0)
        },
        {
          keyCode: Br.LEFT,
          action: xa(Q8, e, !1)
        },
        {
          keyCode: Br.UP,
          action: xa(h3, e, !1)
        },
        {
          keyCode: Br.DOWN,
          action: xa(h3, e, !0)
        },
        {
          keyCode: Br.RIGHT,
          action: xa(U8, e, !0)
        },
        {
          keyCode: Br.LEFT,
          action: xa(U8, e, !1)
        },
        {
          keyCode: Br.UP,
          action: xa(gA, e, !1)
        },
        {
          keyCode: Br.DOWN,
          action: xa(gA, e, !0)
        },
        {
          keyCode: Br.RIGHT,
          action: xa(s3, e, n, !0)
        },
        {
          keyCode: Br.LEFT,
          action: xa(s3, e, n, !1)
        },
        {
          keyCode: Br.RIGHT,
          ctrlKey: !i.isOSX(),
          altKey: i.isOSX(),
          action: xa(rN, e, n)
        },
        {
          keyCode: Br.LEFT,
          ctrlKey: !i.isOSX(),
          altKey: i.isOSX(),
          action: xa(aN, e, n)
        },
        {
          keyCode: Br.UP,
          action: xa(V8, e, !1)
        },
        {
          keyCode: Br.DOWN,
          action: xa(V8, e, !0)
        }
      ], a).each(function(s) {
        a.preventDefault();
      });
    }, GN = function(e, n) {
      e.on("keydown", function(a) {
        a.isDefaultPrevented() === !1 && qN(e, n, a);
      });
    }, KN = function(e, n, a) {
      o1([
        {
          keyCode: Br.BACKSPACE,
          action: xa(lA, e, !1)
        },
        {
          keyCode: Br.BACKSPACE,
          action: xa(J4, e, !1)
        },
        {
          keyCode: Br.DELETE,
          action: xa(J4, e, !0)
        },
        {
          keyCode: Br.BACKSPACE,
          action: xa(Jw, e, !1)
        },
        {
          keyCode: Br.DELETE,
          action: xa(Jw, e, !0)
        },
        {
          keyCode: Br.BACKSPACE,
          action: xa(c3, e, n, !1)
        },
        {
          keyCode: Br.DELETE,
          action: xa(c3, e, n, !0)
        },
        {
          keyCode: Br.BACKSPACE,
          action: xa(p4, e, !1)
        },
        {
          keyCode: Br.DELETE,
          action: xa(p4, e, !0)
        },
        {
          keyCode: Br.BACKSPACE,
          action: xa(Ib, e, !1)
        },
        {
          keyCode: Br.DELETE,
          action: xa(Ib, e, !0)
        },
        {
          keyCode: Br.BACKSPACE,
          action: xa(d3, e, !1)
        },
        {
          keyCode: Br.DELETE,
          action: xa(d3, e, !0)
        },
        {
          keyCode: Br.BACKSPACE,
          action: xa(e1, e, !1)
        },
        {
          keyCode: Br.DELETE,
          action: xa(e1, e, !0)
        },
        {
          keyCode: Br.BACKSPACE,
          action: xa(K4, e, !1)
        },
        {
          keyCode: Br.DELETE,
          action: xa(K4, e, !0)
        },
        {
          keyCode: Br.BACKSPACE,
          action: xa(f3, e, !1)
        },
        {
          keyCode: Br.DELETE,
          action: xa(f3, e, !0)
        }
      ], a).each(function(i) {
        a.preventDefault();
      });
    }, XN = function(e, n) {
      o1([
        {
          keyCode: Br.BACKSPACE,
          action: xa(Q6, e)
        },
        {
          keyCode: Br.DELETE,
          action: xa(Q6, e)
        }
      ], n);
    }, YN = function(e, n) {
      e.on("keydown", function(a) {
        a.isDefaultPrevented() === !1 && KN(e, n, a);
      }), e.on("keyup", function(a) {
        a.isDefaultPrevented() === !1 && XN(e, a);
      });
    }, ZN = function(e) {
      for (; e; ) {
        if (e.nodeType === 1 || e.nodeType === 3 && e.data && /[\r\n\s]/.test(e.data))
          return e;
        e = e.nextSibling;
      }
    }, zb = function(e, n) {
      var a, i = n, s = e.dom, f = e.schema.getMoveCaretBeforeOnEnterElements();
      if (!!n) {
        if (/^(LI|DT|DD)$/.test(n.nodeName)) {
          var p = ZN(n.firstChild);
          p && /^(UL|OL|DL)$/.test(p.nodeName) && n.insertBefore(s.doc.createTextNode(Ws), n.firstChild);
        }
        var C = s.createRng();
        if (n.normalize(), n.hasChildNodes()) {
          for (var k = new Ha(n, n); a = k.current(); ) {
            if (Qn(a)) {
              C.setStart(a, 0), C.setEnd(a, 0);
              break;
            }
            if (f[a.nodeName.toLowerCase()]) {
              C.setStartBefore(a), C.setEndBefore(a);
              break;
            }
            i = a, a = k.next();
          }
          a || (C.setStart(i, 0), C.setEnd(i, 0));
        } else
          to(n) ? n.nextSibling && s.isBlock(n.nextSibling) ? (C.setStartBefore(n), C.setEndBefore(n)) : (C.setStartAfter(n), C.setEndAfter(n)) : (C.setStart(n, 0), C.setEnd(n, 0));
        e.selection.setRng(C), Dh(e, C);
      }
    }, Hb = function(e, n) {
      var a = e.getRoot(), i, s;
      for (i = n; i !== a && e.getContentEditable(i) !== "false"; )
        e.getContentEditable(i) === "true" && (s = i), i = i.parentNode;
      return i !== a ? s : a;
    }, yA = function(e) {
      return se.from(e.dom.getParent(e.selection.getStart(!0), e.dom.isBlock));
    }, wA = function(e) {
      return yA(e).fold(N(""), function(n) {
        return n.nodeName.toUpperCase();
      });
    }, JN = function(e) {
      return yA(e).filter(function(n) {
        return Ru(O.fromDom(n));
      }).isSome();
    }, eD = function(e, n) {
      return e.firstChild && e.firstChild.nodeName === n;
    }, tD = function(e) {
      var n;
      return ((n = e.parentNode) === null || n === void 0 ? void 0 : n.firstChild) === e;
    }, CA = function(e, n) {
      return e && e.parentNode && e.parentNode.nodeName === n;
    }, SA = function(e) {
      return e && /^(OL|UL|LI)$/.test(e.nodeName);
    }, xA = function(e) {
      return SA(e) && SA(e.parentNode);
    }, cC = function(e) {
      var n = e.parentNode;
      return /^(LI|DT|DD)$/.test(n.nodeName) ? n : e;
    }, b3 = function(e, n, a) {
      for (var i = e[a ? "firstChild" : "lastChild"]; i && !$r(i); )
        i = i[a ? "nextSibling" : "previousSibling"];
      return i === n;
    }, QN = function(e, n, a, i, s) {
      var f = e.dom, p = e.selection.getRng();
      if (a !== e.getBody()) {
        xA(a) && (s = "LI");
        var C = s ? n(s) : f.create("BR");
        if (b3(a, i, !0) && b3(a, i, !1))
          if (CA(a, "LI")) {
            var k = cC(a);
            f.insertAfter(C, k), tD(a) ? f.remove(k) : f.remove(a);
          } else
            f.replace(C, a);
        else if (b3(a, i, !0))
          CA(a, "LI") ? (f.insertAfter(C, cC(a)), C.appendChild(f.doc.createTextNode(" ")), C.appendChild(a)) : a.parentNode.insertBefore(C, a), f.remove(i);
        else if (b3(a, i, !1))
          f.insertAfter(C, cC(a)), f.remove(i);
        else {
          a = cC(a);
          var F = p.cloneRange();
          F.setStartAfter(i), F.setEndAfter(a);
          var q = F.extractContents();
          s === "LI" && eD(q, "LI") ? (C = q.firstChild, f.insertAfter(q, a)) : (f.insertAfter(q, a), f.insertAfter(C, a)), f.remove(i);
        }
        zb(e, C);
      }
    }, y3 = function(e) {
      at(bg(O.fromDom(e), No), function(n) {
        var a = n.dom;
        a.nodeValue = Ac(a.nodeValue);
      });
    }, eI = function(e, n) {
      return n && n.nodeName === "A" && e.isEmpty(n);
    }, tI = function(e) {
      return e && /^(TD|TH|CAPTION)$/.test(e.nodeName);
    }, kA = function(e) {
      e.innerHTML = '<br data-mce-bogus="1">';
    }, w3 = function(e, n) {
      return e.nodeName === n || e.previousSibling && e.previousSibling.nodeName === n;
    }, nD = function(e, n) {
      return n && e.isBlock(n) && !/^(TD|TH|CAPTION|FORM)$/.test(n.nodeName) && !/^(fixed|absolute)/i.test(n.style.position) && e.getContentEditable(n) !== "true";
    }, nI = function(e, n, a) {
      var i = a, s = [], f;
      if (!!i) {
        for (; i = i.firstChild; ) {
          if (e.isBlock(i))
            return;
          $r(i) && !n[i.nodeName.toLowerCase()] && s.push(i);
        }
        for (f = s.length; f--; )
          i = s[f], (!i.hasChildNodes() || i.firstChild === i.lastChild && i.firstChild.nodeValue === "" || eI(e, i)) && e.remove(i);
      }
    }, xl = function(e, n, a) {
      return Qn(n) === !1 ? a : e ? a === 1 && n.data.charAt(a - 1) === ct ? 0 : a : a === n.data.length - 1 && n.data.charAt(a) === ct ? n.data.length : a;
    }, rI = function(e) {
      var n = e.cloneRange();
      return n.setStart(e.startContainer, xl(!0, e.startContainer, e.startOffset)), n.setEnd(e.endContainer, xl(!1, e.endContainer, e.endOffset)), n;
    }, TA = function(e) {
      do
        Qn(e) && (e.nodeValue = e.nodeValue.replace(/^[\r\n]+/, "")), e = e.firstChild;
      while (e);
    }, EA = function(e, n) {
      var a = e.getRoot(), i, s;
      for (i = n; i !== a && e.getContentEditable(i) !== "false"; )
        e.getContentEditable(i) === "true" && (s = i), i = i.parentNode;
      return i !== a ? s : a;
    }, _A = function(e, n, a) {
      var i = e.dom;
      se.from(a.style).map(i.parseStyle).each(function(k) {
        var F = Vo(O.fromDom(n)), q = sr(sr({}, F), k);
        i.setStyles(n, q);
      });
      var s = se.from(a.class).map(function(k) {
        return k.split(/\s+/);
      }), f = se.from(n.className).map(function(k) {
        return Ie(k.split(/\s+/), function(F) {
          return F !== "";
        });
      });
      Vu(s, f, function(k, F) {
        var q = Ie(F, function(te) {
          return !We(k, te);
        }), K = Ko(Ko([], k, !0), q, !0);
        i.setAttrib(n, "class", K.join(" "));
      });
      var p = [
        "style",
        "class"
      ], C = Yn(a, function(k, F) {
        return !We(p, F);
      });
      i.setAttribs(n, C);
    }, fC = function(e, n) {
      var a = mu(e);
      if (a && a.toLowerCase() === n.tagName.toLowerCase()) {
        var i = Tg(e);
        _A(e, n, i);
      }
    }, aI = function(e, n, a, i, s) {
      var f, p, C, k, F, q, K = n || "P", te = e.dom, be = EA(te, i);
      if (p = te.getParent(i, te.isBlock), !p || !nD(te, p)) {
        if (p = p || be, p === e.getBody() || tI(p) ? q = p.nodeName.toLowerCase() : q = p.parentNode.nodeName.toLowerCase(), !p.hasChildNodes())
          return f = te.create(K), fC(e, f), p.appendChild(f), a.setStart(f, 0), a.setEnd(f, 0), f;
        for (k = i; k.parentNode !== p; )
          k = k.parentNode;
        for (; k && !te.isBlock(k); )
          C = k, k = k.previousSibling;
        if (C && e.schema.isValidChild(q, K.toLowerCase())) {
          for (f = te.create(K), fC(e, f), C.parentNode.insertBefore(f, C), k = C; k && !te.isBlock(k); )
            F = k.nextSibling, f.appendChild(k), k = F;
          a.setStart(i, s), a.setEnd(i, s);
        }
      }
      return i;
    }, rD = function(e, n) {
      n.normalize();
      var a = n.lastChild;
      (!a || /^(left|right)$/gi.test(e.getStyle(a, "float", !0))) && e.add(n, "br");
    }, oI = function(e, n) {
      var a, i, s, f, p, C, k, F, q, K, te = e.dom, be = e.schema, we = be.getNonEmptyElements(), ke = e.selection.getRng(), Ee = function(tn) {
        var Cn = i, Ar, Xn, fn, _r = be.getTextInlineElements();
        if (tn || F === "TABLE" || F === "HR" ? Ar = te.create(tn || q) : Ar = f.cloneNode(!1), fn = Ar, rT(e) === !1)
          te.setAttrib(Ar, "style", null), te.setAttrib(Ar, "class", null);
        else
          do
            if (_r[Cn.nodeName]) {
              if (hf(Cn) || Os(Cn))
                continue;
              Xn = Cn.cloneNode(!1), te.setAttrib(Xn, "id", ""), Ar.hasChildNodes() ? (Xn.appendChild(Ar.firstChild), Ar.appendChild(Xn)) : (fn = Xn, Ar.appendChild(Xn));
            }
          while ((Cn = Cn.parentNode) && Cn !== Qe);
        return fC(e, Ar), kA(fn), Ar;
      }, qe = function(tn) {
        var Cn, Ar, Xn = xl(tn, i, s);
        if (Qn(i) && (tn ? Xn > 0 : Xn < i.nodeValue.length))
          return !1;
        if (i.parentNode === f && K && !tn || tn && $r(i) && i === f.firstChild)
          return !0;
        if (w3(i, "TABLE") || w3(i, "HR"))
          return K && !tn || !K && tn;
        var fn = new Ha(i, f);
        for (Qn(i) && (tn && Xn === 0 ? fn.prev() : !tn && Xn === i.nodeValue.length && fn.next()); Cn = fn.current(); ) {
          if ($r(Cn)) {
            if (!Cn.getAttribute("data-mce-bogus") && (Ar = Cn.nodeName.toLowerCase(), we[Ar] && Ar !== "br"))
              return !1;
          } else if (Qn(Cn) && !Jl(Cn.nodeValue))
            return !1;
          tn ? fn.prev() : fn.next();
        }
        return !0;
      }, Le = function() {
        /^(H[1-6]|PRE|FIGURE)$/.test(F) && At !== "HGROUP" ? p = Ee(q) : p = Ee(), mh(e) && nD(te, k) && te.isEmpty(f) ? p = te.split(k, f) : te.insertAfter(p, f), zb(e, p);
      };
      Y0(te, ke).each(function(tn) {
        ke.setStart(tn.startContainer, tn.startOffset), ke.setEnd(tn.endContainer, tn.endOffset);
      }), i = ke.startContainer, s = ke.startOffset, q = mu(e);
      var xt = !!(n && n.shiftKey), mt = !!(n && n.ctrlKey);
      $r(i) && i.hasChildNodes() && (K = s > i.childNodes.length - 1, i = i.childNodes[Math.min(s, i.childNodes.length - 1)] || i, K && Qn(i) ? s = i.nodeValue.length : s = 0);
      var Qe = EA(te, i);
      if (!!Qe) {
        (q && !xt || !q && xt) && (i = aI(e, q, ke, i, s)), f = te.getParent(i, te.isBlock), k = f ? te.getParent(f.parentNode, te.isBlock) : null, F = f ? f.nodeName.toUpperCase() : "";
        var At = k ? k.nodeName.toUpperCase() : "";
        if (At === "LI" && !mt && (f = k, k = k.parentNode, F = At), /^(LI|DT|DD)$/.test(F) && te.isEmpty(f)) {
          QN(e, Ee, k, f, q);
          return;
        }
        q && f === e.getBody() || (q = q || "P", no(f) ? (p = sy(f), te.isEmpty(f) && kA(f), fC(e, p), zb(e, p)) : qe() ? Le() : qe(!0) ? (p = f.parentNode.insertBefore(Ee(), f), zb(e, w3(f, "HR") ? p : f)) : (a = rI(ke).cloneRange(), a.setEndAfter(f), C = a.extractContents(), y3(C), TA(C), p = C.firstChild, te.insertAfter(C, f), nI(te, we, p), rD(te, f), te.isEmpty(f) && kA(f), p.normalize(), te.isEmpty(p) ? (te.remove(p), Le()) : (fC(e, p), zb(e, p))), te.setAttrib(p, "id", ""), e.fire("NewBlock", { newBlock: p }));
      }
    }, iI = function(e, n, a) {
      for (var i = new Ha(n, a), s, f = e.getNonEmptyElements(); s = i.next(); )
        if (f[s.nodeName.toLowerCase()] || s.length > 0)
          return !0;
    }, aD = function(e, n, a) {
      var i = e.dom.createRng();
      a ? (i.setStartBefore(n), i.setEndBefore(n)) : (i.setStartAfter(n), i.setEndAfter(n)), e.selection.setRng(i), Dh(e, i);
    }, uI = function(e, n) {
      var a = e.selection, i = e.dom, s = a.getRng(), f, p;
      Y0(i, s).each(function(we) {
        s.setStart(we.startContainer, we.startOffset), s.setEnd(we.endContainer, we.endOffset);
      });
      var C = s.startOffset, k = s.startContainer;
      if (k.nodeType === 1 && k.hasChildNodes()) {
        var F = C > k.childNodes.length - 1;
        k = k.childNodes[Math.min(C, k.childNodes.length - 1)] || k, F && k.nodeType === 3 ? C = k.nodeValue.length : C = 0;
      }
      var q = i.getParent(k, i.isBlock), K = q ? i.getParent(q.parentNode, i.isBlock) : null, te = K ? K.nodeName.toUpperCase() : "", be = !!(n && n.ctrlKey);
      te === "LI" && !be && (q = K), k && k.nodeType === 3 && C >= k.nodeValue.length && (iI(e.schema, k, q) || (f = i.create("br"), s.insertNode(f), s.setStartAfter(f), s.setEndAfter(f), p = !0)), f = i.create("br"), v0(i, s, f), aD(e, f, p), e.undoManager.add();
    }, sI = function(e, n) {
      var a = O.fromTag("br");
      iu(O.fromDom(n), a), e.undoManager.add();
    }, lI = function(e, n) {
      fI(e.getBody(), n) || Nv(O.fromDom(n), O.fromTag("br"));
      var a = O.fromTag("br");
      Nv(O.fromDom(n), a), aD(e, a.dom, !1), e.undoManager.add();
    }, cI = function(e) {
      return to(e.getNode());
    }, fI = function(e, n) {
      return cI(zt.after(n)) ? !0 : ac(e, zt.after(n)).map(function(a) {
        return to(a.getNode());
      }).getOr(!1);
    }, oD = function(e) {
      return e && e.nodeName === "A" && "href" in e;
    }, gs = function(e) {
      return e.fold(Me, oD, oD, Me);
    }, vI = function(e) {
      var n = ne(wp, e), a = zt.fromRangeStart(e.selection.getRng());
      return Wc(n, e.getBody(), a).filter(gs);
    }, dI = function(e, n) {
      n.fold(xe, ne(sI, e), ne(lI, e), xe);
    }, iD = function(e, n) {
      var a = vI(e);
      a.isSome() ? a.each(ne(dI, e)) : uI(e, n);
    }, el = function(e, n) {
      return yA(e).filter(function(a) {
        return n.length > 0 && Nn(O.fromDom(a), n);
      }).isSome();
    }, mI = function(e) {
      return el(e, Eg(e));
    }, uD = function(e) {
      return el(e, kS(e));
    }, fc = hr.generate([
      { br: [] },
      { block: [] },
      { none: [] }
    ]), Vb = function(e, n) {
      return uD(e);
    }, AA = function(e) {
      return function(n, a) {
        var i = mu(n) === "";
        return i === e;
      };
    }, sD = function(e) {
      return function(n, a) {
        return JN(n) === e;
      };
    }, C3 = function(e, n) {
      return function(a, i) {
        var s = wA(a) === e.toUpperCase();
        return s === n;
      };
    }, S3 = function(e) {
      return C3("pre", e);
    }, gI = function() {
      return C3("summary", !0);
    }, x3 = function(e) {
      return function(n, a) {
        return t2(n) === e;
      };
    }, pI = function(e, n) {
      return mI(e);
    }, vC = function(e, n) {
      return n;
    }, lD = function(e) {
      var n = mu(e), a = Hb(e.dom, e.selection.getStart());
      return a && e.schema.isValidChild(a.nodeName, n || "P");
    }, kl = function(e, n) {
      return function(a, i) {
        var s = Xe(e, function(f, p) {
          return f && p(a, i);
        }, !0);
        return s ? se.some(n) : se.none();
      };
    }, cD = function(e, n) {
      return jc([
        kl([Vb], fc.none()),
        kl([gI()], fc.br()),
        kl([
          S3(!0),
          x3(!1),
          vC
        ], fc.br()),
        kl([
          S3(!0),
          x3(!1)
        ], fc.block()),
        kl([
          S3(!0),
          x3(!0),
          vC
        ], fc.block()),
        kl([
          S3(!0),
          x3(!0)
        ], fc.br()),
        kl([
          sD(!0),
          vC
        ], fc.br()),
        kl([sD(!0)], fc.block()),
        kl([
          AA(!0),
          vC,
          lD
        ], fc.block()),
        kl([AA(!0)], fc.br()),
        kl([pI], fc.br()),
        kl([
          AA(!1),
          vC
        ], fc.br()),
        kl([lD], fc.block())
      ], [
        e,
        !!(n && n.shiftKey)
      ]).getOr(fc.none());
    }, fD = function(e, n) {
      cD(e, n).fold(function() {
        iD(e, n);
      }, function() {
        oI(e, n);
      }, xe);
    }, hI = function(e, n) {
      n.isDefaultPrevented() || (n.preventDefault(), FM(e.undoManager), e.undoManager.transact(function() {
        e.selection.isCollapsed() === !1 && e.execCommand("Delete"), fD(e, n);
      }));
    }, bI = function(e) {
      e.on("keydown", function(n) {
        n.keyCode === Br.ENTER && hI(e, n);
      });
    }, yI = function(e, n, a) {
      o1([
        {
          keyCode: Br.END,
          action: xa($8, e, !0)
        },
        {
          keyCode: Br.HOME,
          action: xa($8, e, !1)
        },
        {
          keyCode: Br.END,
          action: xa(j8, e, !0)
        },
        {
          keyCode: Br.HOME,
          action: xa(j8, e, !1)
        },
        {
          keyCode: Br.END,
          action: xa(l3, e, !0, n)
        },
        {
          keyCode: Br.HOME,
          action: xa(l3, e, !1, n)
        }
      ], a).each(function(i) {
        a.preventDefault();
      });
    }, wI = function(e, n) {
      e.on("keydown", function(a) {
        a.isDefaultPrevented() === !1 && yI(e, n, a);
      });
    }, OA = lr().browser, vD = function(e) {
      var n = e0(function() {
        e.composing || xw(e);
      }, 0);
      OA.isIE() && (e.on("keypress", function(a) {
        n.throttle();
      }), e.on("remove", function(a) {
        n.cancel();
      }));
    }, dD = function(e) {
      vD(e), e.on("input", function(n) {
        n.isComposing === !1 && xw(e);
      });
    }, mD = lr(), CI = function(e, n, a) {
      o1([
        {
          keyCode: Br.PAGE_UP,
          action: xa(l3, e, !1, n)
        },
        {
          keyCode: Br.PAGE_DOWN,
          action: xa(l3, e, !0, n)
        }
      ], a);
    }, gD = function(e) {
      return e.stopImmediatePropagation();
    }, pD = function(e) {
      return e.keyCode === Br.PAGE_UP || e.keyCode === Br.PAGE_DOWN;
    }, hD = function(e, n, a) {
      a && !e.get() ? n.on("NodeChange", gD, !0) : !a && e.get() && n.off("NodeChange", gD), e.set(a);
    }, SI = function(e, n) {
      if (!mD.os.isOSX()) {
        var a = ss(!1);
        e.on("keydown", function(i) {
          pD(i) && hD(a, e, !0);
        }), e.on("keyup", function(i) {
          i.isDefaultPrevented() === !1 && CI(e, n, i), pD(i) && a.get() && (hD(a, e, !1), e.nodeChanged());
        });
      }
    }, bD = function(e, n) {
      var a = n.container(), i = n.offset();
      return Qn(a) ? (a.insertData(i, e), se.some(zt(a, i + e.length))) : D0(n).map(function(s) {
        var f = O.fromText(e);
        return n.isAtEnd() ? Nv(s, f) : iu(s, f), zt(f.dom, e.length);
      });
    }, yD = ne(bD, Ws), xI = ne(bD, " "), kI = function(e) {
      return function(n) {
        return n.fold(function(a) {
          return Lc(e.dom, zt.before(a));
        }, function(a) {
          return Gu(a);
        }, function(a) {
          return Ml(a);
        }, function(a) {
          return ac(e.dom, zt.after(a));
        });
      };
    }, TI = function(e, n) {
      return function(a) {
        return xE(e, a) ? yD(n) : xI(n);
      };
    }, EI = function(e) {
      return function(n) {
        return e.selection.setRng(n.toRange()), e.nodeChanged(), !0;
      };
    }, wD = function(e) {
      var n = zt.fromRangeStart(e.selection.getRng()), a = O.fromDom(e.getBody());
      if (e.selection.isCollapsed()) {
        var i = ne(wp, e), s = zt.fromRangeStart(e.selection.getRng());
        return Wc(i, e.getBody(), s).bind(kI(a)).bind(TI(a, n)).exists(EI(e));
      } else
        return !1;
    }, _I = function(e, n) {
      o1([{
        keyCode: Br.SPACEBAR,
        action: xa(wD, e)
      }], n).each(function(a) {
        n.preventDefault();
      });
    }, AI = function(e) {
      e.on("keydown", function(n) {
        n.isDefaultPrevented() === !1 && _I(e, n);
      });
    }, OI = function(e) {
      var n = nN(e);
      return P8(e), GN(e, n), YN(e, n), bI(e), AI(e), dD(e), wI(e, n), SI(e, n), n;
    }, DI = function(e) {
      return Em(e) ? ss(null) : OI(e);
    }, CD = function() {
      function e(n) {
        this.lastPath = [], this.editor = n;
        var a, i = this;
        "onselectionchange" in n.getDoc() || n.on("NodeChange click mouseup keyup focus", function(s) {
          var f = n.selection.getRng(), p = {
            startContainer: f.startContainer,
            startOffset: f.startOffset,
            endContainer: f.endContainer,
            endOffset: f.endOffset
          };
          (s.type === "nodechange" || !W2(p, a)) && n.fire("SelectionChange"), a = p;
        }), n.on("contextmenu", function() {
          n.fire("SelectionChange");
        }), n.on("SelectionChange", function() {
          var s = n.selection.getStart(!0);
          !s || !br.range && n.selection.isCollapsed() || fd(n) && !i.isSameElementPath(s) && n.dom.isChildOf(s, n.getBody()) && n.nodeChanged({ selectionChange: !0 });
        }), n.on("mouseup", function(s) {
          !s.isDefaultPrevented() && fd(n) && (n.selection.getNode().nodeName === "IMG" ? Bu.setEditorTimeout(n, function() {
            n.nodeChanged();
          }) : n.nodeChanged());
        });
      }
      return e.prototype.nodeChanged = function(n) {
        var a = this.editor.selection, i, s, f;
        this.editor.initialized && a && !vT(this.editor) && !this.editor.mode.isReadOnly() && (f = this.editor.getBody(), i = a.getStart(!0) || f, (i.ownerDocument !== this.editor.getDoc() || !this.editor.dom.isChildOf(i, f)) && (i = f), s = [], this.editor.dom.getParent(i, function(p) {
          if (p === f)
            return !0;
          s.push(p);
        }), n = n || {}, n.element = i, n.parents = s, this.editor.fire("NodeChange", n));
      }, e.prototype.isSameElementPath = function(n) {
        var a, i = this.editor.$(n).parentsUntil(this.editor.getBody()).add(n);
        if (i.length === this.lastPath.length) {
          for (a = i.length; a >= 0 && i[a] === this.lastPath[a]; a--)
            ;
          if (a === -1)
            return this.lastPath = i, !0;
        }
        return this.lastPath = i, !1;
      }, e;
    }(), k3 = function(e) {
      e.on("click", function(n) {
        e.dom.getParent(n.target, "details") && n.preventDefault();
      });
    }, SD = function(e) {
      e.parser.addNodeFilter("details", function(n) {
        at(n, function(a) {
          a.attr("data-mce-open", a.attr("open")), a.attr("open", "open");
        });
      }), e.serializer.addNodeFilter("details", function(n) {
        at(n, function(a) {
          var i = a.attr("data-mce-open");
          a.attr("open", Ge(i) ? i : null), a.attr("data-mce-open", null);
        });
      });
    }, xD = function(e) {
      k3(e), SD(e);
    }, kD = function(e) {
      return $r(e) && nf(O.fromDom(e));
    }, BI = function(e) {
      var n = e.selection.getRng(), a = zt.fromRangeStart(n), i = zt.fromRangeEnd(n);
      if (zt.isElementPosition(a)) {
        var s = a.container();
        kD(s) && Gu(s).each(function(f) {
          return n.setStart(f.container(), f.offset());
        });
      }
      if (zt.isElementPosition(i)) {
        var s = a.container();
        kD(s) && Ml(s).each(function(p) {
          return n.setEnd(p.container(), p.offset());
        });
      }
      e.selection.setRng(RE(n));
    }, DA = function(e) {
      e.on("click", function(n) {
        n.detail >= 3 && BI(e);
      });
    }, TD = function(e) {
      var n = e.getBoundingClientRect(), a = e.ownerDocument, i = a.documentElement, s = a.defaultView;
      return {
        top: n.top + s.pageYOffset - i.clientTop,
        left: n.left + s.pageXOffset - i.clientLeft
      };
    }, RI = function(e) {
      return e.inline ? TD(e.getBody()) : {
        left: 0,
        top: 0
      };
    }, MI = function(e) {
      var n = e.getBody();
      return e.inline ? {
        left: n.scrollLeft,
        top: n.scrollTop
      } : {
        left: 0,
        top: 0
      };
    }, PI = function(e) {
      var n = e.getBody(), a = e.getDoc().documentElement, i = {
        left: n.scrollLeft,
        top: n.scrollTop
      }, s = {
        left: n.scrollLeft || a.scrollLeft,
        top: n.scrollTop || a.scrollTop
      };
      return e.inline ? i : s;
    }, Nf = function(e, n) {
      if (n.target.ownerDocument !== e.getDoc()) {
        var a = TD(e.getContentAreaContainer()), i = PI(e);
        return {
          left: n.pageX - a.left + i.left,
          top: n.pageY - a.top + i.top
        };
      }
      return {
        left: n.pageX,
        top: n.pageY
      };
    }, ED = function(e, n, a) {
      return {
        pageX: a.left - e.left + n.left,
        pageY: a.top - e.top + n.top
      };
    }, _D = function(e, n) {
      return ED(RI(e), MI(e), Nf(e, n));
    }, T3 = xo, NI = Kl, II = function(e, n) {
      return T3(n) && n !== e;
    }, FI = function(e, n, a) {
      return n === a || e.dom.isChildOf(n, a) ? !1 : !T3(n);
    }, $I = function(e) {
      var n = e.cloneNode(!0);
      return n.removeAttribute("data-mce-selected"), n;
    }, LI = function(e, n, a, i) {
      var s = e.dom, f = n.cloneNode(!0);
      s.setStyles(f, {
        width: a,
        height: i
      }), s.setAttrib(f, "data-mce-selected", null);
      var p = s.create("div", {
        class: "mce-drag-container",
        "data-mce-bogus": "all",
        unselectable: "on",
        contenteditable: "false"
      });
      return s.setStyles(p, {
        position: "absolute",
        opacity: 0.5,
        overflow: "hidden",
        border: 0,
        padding: 0,
        margin: 0,
        width: a,
        height: i
      }), s.setStyles(f, {
        margin: 0,
        boxSizing: "border-box"
      }), p.appendChild(f), p;
    }, zI = function(e, n) {
      e.parentNode !== n && n.appendChild(e);
    }, BA = function(e, n, a, i, s, f) {
      var p = 0, C = 0;
      e.style.left = n.pageX + "px", e.style.top = n.pageY + "px", n.pageX + a > s && (p = n.pageX + a - s), n.pageY + i > f && (C = n.pageY + i - f), e.style.width = a - p + "px", e.style.height = i - C + "px";
    }, AD = function(e) {
      e && e.parentNode && e.parentNode.removeChild(e);
    }, HI = function(e) {
      return e.button === 0;
    }, OD = function(e, n) {
      return {
        pageX: n.pageX - e.relX,
        pageY: n.pageY + 5
      };
    }, VI = function(e, n) {
      return function(a) {
        if (HI(a)) {
          var i = tt(n.dom.getParents(a.target), Gk(T3, NI)).getOr(null);
          if (II(n.getBody(), i)) {
            var s = n.dom.getPos(i), f = n.getBody(), p = n.getDoc().documentElement;
            e.set({
              element: i,
              dragging: !1,
              screenX: a.screenX,
              screenY: a.screenY,
              maxX: (n.inline ? f.scrollWidth : p.offsetWidth) - 2,
              maxY: (n.inline ? f.scrollHeight : p.offsetHeight) - 2,
              relX: a.pageX - s.x,
              relY: a.pageY - s.y,
              width: i.offsetWidth,
              height: i.offsetHeight,
              ghost: LI(n, i, i.offsetWidth, i.offsetHeight)
            });
          }
        }
      };
    }, UI = function(e, n) {
      var a = Bu.throttle(function(i, s) {
        n._selectionOverrides.hideFakeCaret(), n.selection.placeCaretAt(i, s);
      }, 0);
      return n.on("remove", a.stop), function(i) {
        return e.on(function(s) {
          var f = Math.max(Math.abs(i.screenX - s.screenX), Math.abs(i.screenY - s.screenY));
          if (!s.dragging && f > 10) {
            var p = n.fire("dragstart", { target: s.element });
            if (p.isDefaultPrevented())
              return;
            s.dragging = !0, n.focus();
          }
          if (s.dragging) {
            var C = OD(s, _D(n, i));
            zI(s.ghost, n.getBody()), BA(s.ghost, C, s.width, s.height, s.maxX, s.maxY), a(i.clientX, i.clientY);
          }
        });
      };
    }, jI = function(e) {
      var n = e.getSel().getRangeAt(0), a = n.startContainer;
      return a.nodeType === 3 ? a.parentNode : a;
    }, WI = function(e, n) {
      return function(a) {
        e.on(function(i) {
          if (i.dragging) {
            if (FI(n, jI(n.selection), i.element)) {
              var s = $I(i.element), f = n.fire("drop", {
                clientX: a.clientX,
                clientY: a.clientY
              });
              f.isDefaultPrevented() || n.undoManager.transact(function() {
                AD(i.element), n.insertContent(n.dom.getOuterHTML(s)), n._selectionOverrides.hideFakeCaret();
              });
            }
            n.fire("dragend");
          }
        }), DD(e);
      };
    }, qI = function(e, n) {
      return function() {
        e.on(function(a) {
          a.dragging && n.fire("dragend");
        }), DD(e);
      };
    }, DD = function(e) {
      e.on(function(n) {
        AD(n.ghost);
      }), e.clear();
    }, RA = function(e) {
      var n = ed(), a = ho.DOM, i = document, s = VI(n, e), f = UI(n, e), p = WI(n, e), C = qI(n, e);
      e.on("mousedown", s), e.on("mousemove", f), e.on("mouseup", p), a.bind(i, "mousemove", f), a.bind(i, "mouseup", C), e.on("remove", function() {
        a.unbind(i, "mousemove", f), a.unbind(i, "mouseup", C);
      }), e.on("keydown", function(k) {
        k.keyCode === Br.ESC && C();
      });
    }, GI = function(e) {
      e.on("drop", function(n) {
        var a = typeof n.clientX < "u" ? e.getDoc().elementFromPoint(n.clientX, n.clientY) : null;
        (T3(a) || e.dom.getContentEditableParent(a) === "false") && n.preventDefault();
      });
    }, BD = function(e) {
      var n = function(s) {
        if (!s.isDefaultPrevented()) {
          var f = s.dataTransfer;
          f && (We(f.types, "Files") || f.files.length > 0) && (s.preventDefault(), s.type === "drop" && U4(e, "Dropped file type is not supported"));
        }
      }, a = function(s) {
        rb(e, s.target) && n(s);
      }, i = function() {
        var s = ho.DOM, f = e.dom, p = document, C = e.inline ? e.getBody() : e.getDoc(), k = [
          "drop",
          "dragover"
        ];
        at(k, function(F) {
          s.bind(p, F, a), f.bind(C, F, n);
        }), e.on("remove", function() {
          at(k, function(F) {
            s.unbind(p, F, a), f.unbind(C, F, n);
          });
        });
      };
      e.on("init", function() {
        Bu.setEditorTimeout(e, i, 0);
      });
    }, KI = function(e) {
      RA(e), GI(e), Og(e) && BD(e);
    }, XI = function(e) {
      var n = e0(function() {
        if (!e.removed && e.getBody().contains(document.activeElement)) {
          var a = e.selection.getRng();
          if (a.collapsed) {
            var i = kp(e, a, !1);
            e.selection.setRng(i);
          }
        }
      }, 0);
      e.on("focus", function() {
        n.throttle();
      }), e.on("blur", function() {
        n.cancel();
      });
    }, YI = function(e) {
      e.on("init", function() {
        e.on("focusin", function(n) {
          var a = n.target;
          if (Cs(a)) {
            var i = gm(e.getBody(), a), s = xo(i) ? i : a;
            e.selection.getNode() !== s && t1(e, s).each(function(f) {
              return e.selection.setRng(f);
            });
          }
        });
      });
    }, RD = Kl, ii = xo, E3 = function(e, n) {
      return gm(e.getBody(), n);
    }, ZI = function(e) {
      var n = e.selection, a = e.dom, i = a.isBlock, s = e.getBody(), f = qu(e, s, i, function() {
        return Il(e);
      }), p = "sel-" + a.uniqueId(), C = "data-mce-selected", k, F = function(fn) {
        return a.hasClass(fn, "mce-offscreen-selection");
      }, q = function(fn) {
        return fn !== s && (ii(fn) || Cs(fn)) && a.isChildOf(fn, s);
      }, K = function(fn) {
        return sc(fn) || wd(fn) || ap(fn) || op(fn);
      }, te = function() {
        var fn = a.get(p);
        return fn && fn.getElementsByTagName("*")[0];
      }, be = function(fn) {
        fn && n.setRng(fn);
      }, we = n.getRng, ke = function(fn, _r, kn, Kn) {
        Kn === void 0 && (Kn = !0);
        var On = e.fire("ShowCaret", {
          target: _r,
          direction: fn,
          before: kn
        });
        return On.isDefaultPrevented() ? null : (Kn && n.scrollIntoView(_r, fn === -1), f.show(kn, _r));
      }, Ee = function(fn) {
        fn.hasAttribute("data-mce-caret") && (sy(fn), be(we()), n.scrollIntoView(fn));
      }, qe = function() {
        e.on("mouseup", function(On) {
          var $n = we();
          $n.collapsed && _m(e, On.clientX, On.clientY) && z_(e, $n, !1).each(be);
        }), e.on("click", function(On) {
          var $n = E3(e, On.target);
          $n && (ii($n) && (On.preventDefault(), e.focus()), RD($n) && a.isChildOf($n, n.getNode()) && Cn());
        }), e.on("blur NewBlock", Cn), e.on("ResizeWindow FullscreenStateChanged", f.reposition);
        var fn = function(On) {
          var $n = On.firstChild;
          if (Pt($n))
            return !1;
          var rr = zt.before($n);
          if (to(rr.getNode()) && On.childNodes.length === 1)
            return !K(rr);
          var hn = Jo(On), Zn = hn.next(rr);
          return Zn && !K(Zn);
        }, _r = function(On, $n) {
          var rr = a.getParent(On, i), hn = a.getParent($n, i);
          return rr === hn;
        }, kn = function(On, $n) {
          var rr = a.getParent(On, i), hn = a.getParent($n, i);
          return Pt(rr) ? !1 : On !== hn && a.isChildOf(rr, hn) && ii(E3(e, rr)) === !1 ? !0 : !a.isChildOf(hn, rr) && !_r(rr, hn) && fn(rr);
        };
        e.on("tap", function(On) {
          var $n = On.target, rr = E3(e, $n);
          ii(rr) ? (On.preventDefault(), t1(e, rr).each(tn)) : q($n) && t1(e, $n).each(tn);
        }, !0), e.on("mousedown", function(On) {
          var $n = On.target;
          if (!($n !== s && $n.nodeName !== "HTML" && !a.isChildOf($n, s)) && _m(e, On.clientX, On.clientY) !== !1) {
            var rr = E3(e, $n);
            if (rr)
              ii(rr) ? (On.preventDefault(), t1(e, rr).each(tn)) : (Cn(), !(RD(rr) && On.shiftKey) && !pm(On.clientX, On.clientY, n.getRng()) && (Xn(), n.placeCaretAt(On.clientX, On.clientY)));
            else if (q($n))
              t1(e, $n).each(tn);
            else if (um($n) === !1) {
              Cn(), Xn();
              var hn = tA(s, On.clientX, On.clientY);
              if (hn && !kn($n, hn.node)) {
                On.preventDefault();
                var Zn = ke(1, hn.node, hn.before, !1);
                be(Zn), e.getBody().focus();
              }
            }
          }
        }), e.on("keypress", function(On) {
          Br.modifierPressed(On) || ii(n.getNode()) && On.preventDefault();
        }), e.on("GetSelectionRange", function(On) {
          var $n = On.range;
          if (k) {
            if (!k.parentNode) {
              k = null;
              return;
            }
            $n = $n.cloneRange(), $n.selectNode(k), On.range = $n;
          }
        }), e.on("SetSelectionRange", function(On) {
          On.range = mt(On.range);
          var $n = tn(On.range, On.forward);
          $n && (On.range = $n);
        });
        var Kn = function(On) {
          return On.id === "mcepastebin";
        };
        e.on("AfterSetSelectionRange", function(On) {
          var $n = On.range, rr = $n.startContainer.parentNode;
          !xt($n) && !Kn(rr) && Xn(), F(rr) || Cn();
        }), e.on("copy", function(On) {
          var $n = On.clipboardData;
          if (!On.isDefaultPrevented() && On.clipboardData && !br.ie) {
            var rr = te();
            rr && (On.preventDefault(), $n.clearData(), $n.setData("text/html", rr.outerHTML), $n.setData("text/plain", rr.outerText || rr.innerText));
          }
        }), KI(e), XI(e), YI(e);
      }, Le = function(fn) {
        return ks(fn) || qp(fn) || Gp(fn);
      }, xt = function(fn) {
        return Le(fn.startContainer) || Le(fn.endContainer);
      }, mt = function(fn) {
        var _r = e.schema.getShortEndedElements(), kn = a.createRng(), Kn = fn.startContainer, On = fn.startOffset, $n = fn.endContainer, rr = fn.endOffset;
        return Fr(_r, Kn.nodeName.toLowerCase()) ? On === 0 ? kn.setStartBefore(Kn) : kn.setStartAfter(Kn) : kn.setStart(Kn, On), Fr(_r, $n.nodeName.toLowerCase()) ? rr === 0 ? kn.setEndBefore($n) : kn.setEndAfter($n) : kn.setEnd($n, rr), kn;
      }, Qe = function(fn, _r, kn) {
        var Kn = e.$, On = Qm(O.fromDom(e.getBody()), "#" + p).fold(function() {
          return Kn([]);
        }, function(hn) {
          return Kn([hn.dom]);
        });
        On.length === 0 && (On = Kn('<div data-mce-bogus="all" class="mce-offscreen-selection"></div>').attr("id", p), On.appendTo(e.getBody()));
        var $n = a.createRng();
        _r === kn && br.ie ? (On.empty().append('<p style="font-size: 0" data-mce-bogus="all">\xA0</p>').append(_r), $n.setStartAfter(On[0].firstChild.firstChild), $n.setEndAfter(_r)) : (On.empty().append(Ws).append(_r).append(Ws), $n.setStart(On[0].firstChild, 1), $n.setEnd(On[0].lastChild, 0)), On.css({ top: a.getPos(fn, e.getBody()).y }), On[0].focus();
        var rr = n.getSel();
        return rr.removeAllRanges(), rr.addRange($n), $n;
      }, At = function(fn) {
        var _r = fn.cloneNode(!0), kn = e.fire("ObjectSelected", {
          target: fn,
          targetClone: _r
        });
        if (kn.isDefaultPrevented())
          return null;
        var Kn = Qe(fn, kn.targetClone, _r), On = O.fromDom(fn);
        return at(du(O.fromDom(e.getBody()), "*[data-mce-selected]"), function($n) {
          Dr(On, $n) || Gt($n, C);
        }), a.getAttrib(fn, C) || fn.setAttribute(C, "1"), k = fn, Xn(), Kn;
      }, tn = function(fn, _r) {
        if (!fn)
          return null;
        if (fn.collapsed) {
          if (!xt(fn)) {
            var kn = _r ? 1 : -1, Kn = Lg(kn, s, fn), On = Kn.getNode(!_r);
            if (um(On))
              return ke(kn, On, _r ? !Kn.isAtEnd() : !1, !1);
            var $n = Kn.getNode(_r);
            if (um($n))
              return ke(kn, $n, _r ? !1 : !Kn.isAtEnd(), !1);
          }
          return null;
        }
        var rr = fn.startContainer, hn = fn.startOffset, Zn = fn.endOffset;
        if (rr.nodeType === 3 && hn === 0 && ii(rr.parentNode) && (rr = rr.parentNode, hn = a.nodeIndex(rr), rr = rr.parentNode), rr.nodeType !== 1)
          return null;
        if (Zn === hn + 1 && rr === fn.endContainer) {
          var fa = rr.childNodes[hn];
          if (q(fa))
            return At(fa);
        }
        return null;
      }, Cn = function() {
        k && k.removeAttribute(C), Qm(O.fromDom(e.getBody()), "#" + p).each(Yo), k = null;
      }, Ar = function() {
        f.destroy(), k = null;
      }, Xn = function() {
        f.hide();
      };
      return br.ceFalse && !Em(e) && qe(), {
        showCaret: ke,
        showBlockCaretContainer: Ee,
        hideFakeCaret: Xn,
        destroy: Ar
      };
    }, JI = function(e) {
      var n = Ut.each, a = Br.BACKSPACE, i = Br.DELETE, s = e.dom, f = e.selection, p = e.parser, C = br.gecko, k = br.ie, F = br.webkit, q = "data:text/mce-internal,", K = k ? "Text" : "URL", te = function(bn, Mn) {
        try {
          e.getDoc().execCommand(bn, !1, Mn);
        } catch {
        }
      }, be = function(bn) {
        return bn.isDefaultPrevented();
      }, we = function(bn) {
        var Mn, gr;
        bn.dataTransfer && (e.selection.isCollapsed() && bn.target.tagName === "IMG" && f.select(bn.target), Mn = e.selection.getContent(), Mn.length > 0 && (gr = q + escape(e.id) + "," + escape(Mn), bn.dataTransfer.setData(K, gr)));
      }, ke = function(bn) {
        var Mn;
        return bn.dataTransfer && (Mn = bn.dataTransfer.getData(K), Mn && Mn.indexOf(q) >= 0) ? (Mn = Mn.substr(q.length).split(","), {
          id: unescape(Mn[0]),
          html: unescape(Mn[1])
        }) : null;
      }, Ee = function(bn, Mn) {
        e.queryCommandSupported("mceInsertClipboardContent") ? e.execCommand("mceInsertClipboardContent", !1, {
          content: bn,
          internal: Mn
        }) : e.execCommand("mceInsertContent", !1, bn);
      }, qe = function() {
        var bn = function(gr) {
          var Dt = s.create("body"), xn = gr.cloneContents();
          return Dt.appendChild(xn), f.serializer.serialize(Dt, { format: "html" });
        }, Mn = function(gr) {
          var Dt = bn(gr), xn = s.createRng();
          xn.selectNode(e.getBody());
          var wn = bn(xn);
          return Dt === wn;
        };
        e.on("keydown", function(gr) {
          var Dt = gr.keyCode, xn, wn;
          if (!be(gr) && (Dt === i || Dt === a)) {
            if (xn = e.selection.isCollapsed(), wn = e.getBody(), xn && !s.isEmpty(wn) || !xn && !Mn(e.selection.getRng()))
              return;
            gr.preventDefault(), e.setContent(""), wn.firstChild && s.isBlock(wn.firstChild) ? e.selection.setCursorLocation(wn.firstChild, 0) : e.selection.setCursorLocation(wn, 0), e.nodeChanged();
          }
        });
      }, Le = function() {
        e.shortcuts.add("meta+a", null, "SelectAll");
      }, xt = function() {
        e.inline || s.bind(e.getDoc(), "mousedown mouseup", function(bn) {
          var Mn;
          if (bn.target === e.getDoc().documentElement)
            if (Mn = f.getRng(), e.getBody().focus(), bn.type === "mousedown") {
              if (ks(Mn.startContainer))
                return;
              f.placeCaretAt(bn.clientX, bn.clientY);
            } else
              f.setRng(Mn);
        });
      }, mt = function() {
        e.on("keydown", function(bn) {
          if (!be(bn) && bn.keyCode === a) {
            if (!e.getBody().getElementsByTagName("hr").length)
              return;
            if (f.isCollapsed() && f.getRng().startOffset === 0) {
              var Mn = f.getNode(), gr = Mn.previousSibling;
              if (Mn.nodeName === "HR") {
                s.remove(Mn), bn.preventDefault();
                return;
              }
              gr && gr.nodeName && gr.nodeName.toLowerCase() === "hr" && (s.remove(gr), bn.preventDefault());
            }
          }
        });
      }, Qe = function() {
        Range.prototype.getClientRects || e.on("mousedown", function(bn) {
          if (!be(bn) && bn.target.nodeName === "HTML") {
            var Mn = e.getBody();
            Mn.blur(), Bu.setEditorTimeout(e, function() {
              Mn.focus();
            });
          }
        });
      }, At = function() {
        e.on("click", function(bn) {
          var Mn = bn.target;
          /^(IMG|HR)$/.test(Mn.nodeName) && s.getContentEditableParent(Mn) !== "false" && (bn.preventDefault(), e.selection.select(Mn), e.nodeChanged()), Mn.nodeName === "A" && s.hasClass(Mn, "mce-item-anchor") && (bn.preventDefault(), f.select(Mn));
        });
      }, tn = function() {
        var bn = function() {
          var gr = s.getAttribs(f.getStart().cloneNode(!1));
          return function() {
            var Dt = f.getStart();
            Dt !== e.getBody() && (s.setAttrib(Dt, "style", null), n(gr, function(xn) {
              Dt.setAttributeNode(xn.cloneNode(!0));
            }));
          };
        }, Mn = function() {
          return !f.isCollapsed() && s.getParent(f.getStart(), s.isBlock) !== s.getParent(f.getEnd(), s.isBlock);
        };
        e.on("keypress", function(gr) {
          var Dt;
          if (!be(gr) && (gr.keyCode === 8 || gr.keyCode === 46) && Mn())
            return Dt = bn(), e.getDoc().execCommand("delete", !1, null), Dt(), gr.preventDefault(), !1;
        }), s.bind(e.getDoc(), "cut", function(gr) {
          var Dt;
          !be(gr) && Mn() && (Dt = bn(), Bu.setEditorTimeout(e, function() {
            Dt();
          }));
        });
      }, Cn = function() {
        e.on("keydown", function(bn) {
          if (!be(bn) && bn.keyCode === a && f.isCollapsed() && f.getRng().startOffset === 0) {
            var Mn = f.getNode().previousSibling;
            if (Mn && Mn.nodeName && Mn.nodeName.toLowerCase() === "table")
              return bn.preventDefault(), !1;
          }
        });
      }, Ar = function() {
        e.on("keydown", function(bn) {
          var Mn, gr;
          if (!(be(bn) || bn.keyCode !== Br.BACKSPACE)) {
            Mn = f.getRng();
            var Dt = Mn.startContainer, xn = Mn.startOffset, wn = s.getRoot();
            if (gr = Dt, !(!Mn.collapsed || xn !== 0)) {
              for (; gr && gr.parentNode && gr.parentNode.firstChild === gr && gr.parentNode !== wn; )
                gr = gr.parentNode;
              gr.tagName === "BLOCKQUOTE" && (e.formatter.toggle("blockquote", null, gr), Mn = s.createRng(), Mn.setStart(Dt, 0), Mn.setEnd(Dt, 0), f.setRng(Mn));
            }
          }
        });
      }, Xn = function() {
        var bn = function() {
          te("StyleWithCSS", !1), te("enableInlineTableEditing", !1), AS(e) || te("enableObjectResizing", !1);
        };
        dT(e) || e.on("BeforeExecCommand mousedown", bn);
      }, fn = function() {
        var bn = function() {
          n(s.select("a"), function(Mn) {
            var gr = Mn.parentNode, Dt = s.getRoot();
            if (gr.lastChild === Mn) {
              for (; gr && !s.isBlock(gr); ) {
                if (gr.parentNode.lastChild !== gr || gr === Dt)
                  return;
                gr = gr.parentNode;
              }
              s.add(gr, "br", { "data-mce-bogus": 1 });
            }
          });
        };
        e.on("SetContent ExecCommand", function(Mn) {
          (Mn.type === "setcontent" || Mn.command === "mceInsertLink") && bn();
        });
      }, _r = function() {
        mu(e) && e.on("init", function() {
          te("DefaultParagraphSeparator", mu(e));
        });
      }, kn = function() {
        e.on("keyup focusin mouseup", function(bn) {
          Br.modifierPressed(bn) || f.normalize();
        }, !0);
      }, Kn = function() {
        e.contentStyles.push("img:-moz-broken {-moz-force-broken-image-icon:1;min-width:24px;min-height:24px}");
      }, On = function() {
        e.inline || e.on("keydown", function() {
          document.activeElement === document.body && e.getWin().focus();
        });
      }, $n = function() {
        e.inline || (e.contentStyles.push("body {min-height: 150px}"), e.on("click", function(bn) {
          var Mn;
          if (bn.target.nodeName === "HTML") {
            if (br.ie > 11) {
              e.getBody().focus();
              return;
            }
            Mn = e.selection.getRng(), e.getBody().focus(), e.selection.setRng(Mn), e.selection.normalize(), e.nodeChanged();
          }
        }));
      }, rr = function() {
        br.mac && e.on("keydown", function(bn) {
          if (Br.metaKeyPressed(bn) && !bn.shiftKey && (bn.keyCode === 37 || bn.keyCode === 39)) {
            bn.preventDefault();
            var Mn = e.selection.getSel();
            Mn.modify("move", bn.keyCode === 37 ? "backward" : "forward", "lineboundary");
          }
        });
      }, hn = function() {
        te("AutoUrlDetect", !1);
      }, Zn = function() {
        e.on("click", function(bn) {
          var Mn = bn.target;
          do
            if (Mn.tagName === "A") {
              bn.preventDefault();
              return;
            }
          while (Mn = Mn.parentNode);
        }), e.contentStyles.push(".mce-content-body {-webkit-touch-callout: none}");
      }, fa = function() {
        e.on("init", function() {
          e.dom.bind(e.getBody(), "submit", function(bn) {
            bn.preventDefault();
          });
        });
      }, Ia = function() {
        p.addNodeFilter("br", function(bn) {
          for (var Mn = bn.length; Mn--; )
            bn[Mn].attr("class") === "Apple-interchange-newline" && bn[Mn].remove();
        });
      }, Pa = function() {
        e.on("dragstart", function(bn) {
          we(bn);
        }), e.on("drop", function(bn) {
          if (!be(bn)) {
            var Mn = ke(bn);
            if (Mn && Mn.id !== e.id) {
              bn.preventDefault();
              var gr = j2(bn.x, bn.y, e.getDoc());
              f.setRng(gr), Ee(Mn.html, !0);
            }
          }
        });
      }, yu = xe, Wo = function() {
        if (!C || e.removed)
          return !1;
        var bn = e.selection.getSel();
        return !bn || !bn.rangeCount || bn.rangeCount === 0;
      }, Rs = function() {
        F && (xt(), At(), fa(), Le(), br.iOS && (On(), $n(), Zn())), C && (Qe(), Xn(), Kn(), rr());
      }, tl = function() {
        Ar(), qe(), br.windowsPhone || kn(), F && (xt(), At(), _r(), fa(), Cn(), Ia(), br.iOS ? (On(), $n(), Zn()) : Le()), br.ie >= 11 && ($n(), Cn()), br.ie && (Le(), hn(), Pa()), C && (mt(), Qe(), tn(), Xn(), fn(), Kn(), rr(), Cn());
      };
      return Em(e) ? Rs() : tl(), {
        refreshContentEditable: yu,
        isHidden: Wo
      };
    }, _3 = ho.DOM, MA = function(e, n) {
      var a = O.fromDom(e.getBody()), i = Xo(ts(a)), s = O.fromTag("style");
      M(s, "type", "text/css"), _i(s, O.fromText(n)), _i(i, s), e.on("remove", function() {
        Yo(s);
      });
    }, QI = function(e) {
      return e.inline ? e.getElement().nodeName.toLowerCase() : void 0;
    }, A3 = function(e) {
      return Yn(e, function(n) {
        return De(n) === !1;
      });
    }, MD = function(e) {
      var n = e.settings;
      return A3({
        block_elements: n.block_elements,
        boolean_attributes: n.boolean_attributes,
        custom_elements: n.custom_elements,
        extended_valid_elements: n.extended_valid_elements,
        invalid_elements: n.invalid_elements,
        invalid_styles: n.invalid_styles,
        move_caret_before_on_enter_elements: n.move_caret_before_on_enter_elements,
        non_empty_elements: n.non_empty_elements,
        schema: n.schema,
        self_closing_elements: n.self_closing_elements,
        short_ended_elements: n.short_ended_elements,
        special: n.special,
        text_block_elements: n.text_block_elements,
        text_inline_elements: n.text_inline_elements,
        valid_children: n.valid_children,
        valid_classes: n.valid_classes,
        valid_elements: n.valid_elements,
        valid_styles: n.valid_styles,
        verify_html: n.verify_html,
        whitespace_elements: n.whitespace_elements,
        padd_empty_block_inline_children: n.format_empty_lines
      });
    }, PD = function(e) {
      var n = e.settings, a = e.editorUpload.blobCache;
      return A3({
        allow_conditional_comments: n.allow_conditional_comments,
        allow_html_data_urls: n.allow_html_data_urls,
        allow_svg_data_urls: n.allow_svg_data_urls,
        allow_html_in_named_anchor: n.allow_html_in_named_anchor,
        allow_script_urls: n.allow_script_urls,
        allow_unsafe_link_target: n.allow_unsafe_link_target,
        convert_fonts_to_spans: n.convert_fonts_to_spans,
        fix_list_elements: n.fix_list_elements,
        font_size_legacy_values: n.font_size_legacy_values,
        forced_root_block: n.forced_root_block,
        forced_root_block_attrs: n.forced_root_block_attrs,
        padd_empty_with_br: n.padd_empty_with_br,
        preserve_cdata: n.preserve_cdata,
        remove_trailing_brs: n.remove_trailing_brs,
        inline_styles: n.inline_styles,
        root_name: QI(e),
        validate: !0,
        blob_cache: a,
        document: e.getDoc(),
        images_dataimg_filter: n.images_dataimg_filter
      });
    }, eF = function(e) {
      var n = e.settings;
      return sr(sr(sr({}, PD(e)), MD(e)), A3({
        url_converter: n.url_converter,
        url_converter_scope: n.url_converter_scope,
        element_format: n.element_format,
        entities: n.entities,
        entity_encoding: n.entity_encoding,
        indent: n.indent,
        indent_after: n.indent_after,
        indent_before: n.indent_before
      }));
    }, tF = function(e) {
      var n = L4(PD(e), e.schema);
      return n.addAttributeFilter("src,href,style,tabindex", function(a, i) {
        for (var s = a.length, f, p, C = e.dom, k = "data-mce-" + i; s--; )
          if (f = a[s], p = f.attr(i), p && !f.attr(k)) {
            if (p.indexOf("data:") === 0 || p.indexOf("blob:") === 0)
              continue;
            i === "style" ? (p = C.serializeStyle(C.parseStyle(p), f.name), p.length || (p = null), f.attr(k, p), f.attr(i, p)) : i === "tabindex" ? (f.attr(k, p), f.attr(i, null)) : f.attr(k, e.convertURL(p, i, f.name));
          }
      }), n.addNodeFilter("script", function(a) {
        for (var i = a.length; i--; ) {
          var s = a[i], f = s.attr("type") || "no/type";
          f.indexOf("mce-") !== 0 && s.attr("type", "mce-" + f);
        }
      }), e.settings.preserve_cdata && n.addNodeFilter("#cdata", function(a) {
        for (var i = a.length; i--; ) {
          var s = a[i];
          s.type = 8, s.name = "#comment", s.value = "[CDATA[" + e.dom.encode(s.value) + "]]";
        }
      }), n.addNodeFilter("p,h1,h2,h3,h4,h5,h6,div", function(a) {
        for (var i = a.length, s = e.schema.getNonEmptyElements(); i--; ) {
          var f = a[i];
          f.isEmpty(s) && f.getAll("br").length === 0 && (f.append(new Fl("br", 1)).shortEnded = !0);
        }
      }), n;
    }, nF = function(e) {
      e.settings.auto_focus && Bu.setEditorTimeout(e, function() {
        var n;
        e.settings.auto_focus === !0 ? n = e : n = e.editorManager.get(e.settings.auto_focus), n.destroyed || n.focus();
      }, 100);
    }, rF = function(e) {
      var n = e.dom.getRoot();
      !e.inline && (!fd(e) || e.selection.getStart(!0) === n) && Gu(n).each(function(a) {
        var i = a.getNode(), s = si(i) ? Gu(i).getOr(a) : a;
        br.browser.isIE() ? iE(e, s.toRange()) : e.selection.setRng(s.toRange());
      });
    }, aF = function(e) {
      e.bindPendingEventDelegates(), e.initialized = !0, ix(e), e.focus(!0), rF(e), e.nodeChanged({ initial: !0 }), e.execCallback("init_instance_callback", e), nF(e);
    }, ND = function(e) {
      return e.inline ? e.ui.styleSheetLoader : e.dom.styleSheetLoader;
    }, oF = function(e, n, a) {
      var i = [new Ki(function(s, f) {
        return ND(e).loadAll(n, s, f);
      })];
      return e.inline ? i : i.concat([new Ki(function(s, f) {
        return e.ui.styleSheetLoader.loadAll(a, s, f);
      })]);
    }, ID = function(e) {
      var n = ND(e), a = _S(e), i = e.contentCSS, s = function() {
        n.unloadAll(i), e.inline || e.ui.styleSheetLoader.unloadAll(a);
      }, f = function() {
        e.removed ? s() : e.on("remove", s);
      };
      if (e.contentStyles.length > 0) {
        var p = "";
        Ut.each(e.contentStyles, function(k) {
          p += k + `\r
`;
        }), e.dom.addStyle(p);
      }
      var C = Ki.all(oF(e, i, a)).then(f).catch(f);
      return e.settings.content_style && MA(e, e.settings.content_style), C;
    }, iF = function(e) {
      var n = e.settings, a = e.getDoc(), i = e.getBody();
      xf(e), !n.browser_spellcheck && !n.gecko_spellcheck && (a.body.spellcheck = !1, _3.setAttrib(i, "spellcheck", "false")), e.quirks = JI(e), ox(e);
      var s = Nc(e);
      s !== void 0 && (i.dir = s), n.protect && e.on("BeforeSetContent", function(f) {
        Ut.each(n.protect, function(p) {
          f.content = f.content.replace(p, function(C) {
            return "<!--mce:protected " + escape(C) + "-->";
          });
        });
      }), e.on("SetContent", function() {
        e.addVisual(e.getBody());
      }), e.on("compositionstart compositionend", function(f) {
        e.composing = f.type === "compositionstart";
      });
    }, uF = function(e) {
      Em(e) || e.load({
        initial: !0,
        format: "html"
      }), e.startContent = e.getContent({ format: "raw" });
    }, PA = function(e) {
      e.removed !== !0 && (uF(e), aF(e));
    }, O3 = function(e, n) {
      var a = e.settings, i = e.getElement(), s = e.getDoc();
      a.inline || (e.getElement().style.visibility = e.orgVisibility), !n && !e.inline && (s.open(), s.write(e.iframeHTML), s.close()), e.inline && (_3.addClass(i, "mce-content-body"), e.contentDocument = s = document, e.contentWindow = window, e.bodyElement = i, e.contentAreaContainer = i);
      var f = e.getBody();
      f.disabled = !0, e.readonly = !!a.readonly, e.readonly || (e.inline && _3.getStyle(f, "position", !0) === "static" && (f.style.position = "relative"), f.contentEditable = e.getParam("content_editable_state", !0)), f.disabled = !1, e.editorUpload = tP(e), e.schema = ml(MD(e)), e.dom = ho(s, {
        keep_values: !0,
        url_converter: e.convertURL,
        url_converter_scope: e,
        hex_colors: a.force_hex_style_colors,
        update_styles: !0,
        root_element: e.inline ? e.getBody() : null,
        collect: function() {
          return e.inline;
        },
        schema: e.schema,
        contentCssCors: C0(e),
        referrerPolicy: S0(e),
        onSetAttrib: function(k) {
          e.fire("SetAttrib", k);
        }
      }), e.parser = tF(e), e.serializer = s6(eF(e), e), e.selection = GO(e.dom, e.getWin(), e.serializer, e), e.annotator = q0(e), e.formatter = O6(e), e.undoManager = Df(e), e._nodeChangeDispatcher = new CD(e), e._selectionOverrides = ZI(e), hN(e), xD(e), Em(e) || DA(e);
      var p = DI(e);
      pN(e, p), R8(e), N6(e);
      var C = WM(e);
      iF(e), C.fold(function() {
        ID(e).then(function() {
          return PA(e);
        });
      }, function(k) {
        e.setProgressState(!0), ID(e).then(function() {
          k().then(function(F) {
            e.setProgressState(!1), PA(e);
          }, function(F) {
            e.notificationManager.open({
              type: "error",
              text: String(F)
            }), PA(e);
          });
        });
      });
    }, dC = ho.DOM, sF = function(e, n) {
      if (document.domain !== window.location.hostname && br.browser.isIE()) {
        var a = Fu("mce");
        e[a] = function() {
          O3(e);
        };
        var i = 'javascript:(function(){document.open();document.domain="' + document.domain + '";var ed = window.parent.tinymce.get("' + e.id + '");document.write(ed.iframeHTML);document.close();ed.' + a + "(true);})()";
        return dC.setAttrib(n, "src", i), !0;
      }
      return !1;
    }, lF = function(e, n, a, i) {
      var s = O.fromTag("iframe");
      return G(s, i), G(s, {
        id: e + "_ifr",
        frameBorder: "0",
        allowTransparency: "true",
        title: n
      }), Qd(s, "tox-edit-area__iframe"), s;
    }, cF = function(e) {
      var n = xS(e) + "<html><head>";
      e2(e) !== e.documentBaseUrl && (n += '<base href="' + e.documentBaseURI.getURI() + '" />'), n += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';
      var a = tT(e), i = nT(e), s = e.translate(NS(e));
      return b0(e) && (n += '<meta http-equiv="Content-Security-Policy" content="' + b0(e) + '" />'), n += "</head>" + ('<body id="' + a + '" class="mce-content-body ' + i + '" data-id="' + e.id + '" aria-label="' + s + '">') + "<br></body></html>", n;
    }, FD = function(e, n) {
      var a = e.translate("Rich Text Area"), i = lF(e.id, a, n.height, eT(e)).dom;
      i.onload = function() {
        i.onload = null, e.fire("load");
      };
      var s = sF(e, i);
      return e.contentAreaContainer = n.iframeContainer, e.iframeElement = i, e.iframeHTML = cF(e), dC.add(n.iframeContainer, i), s;
    }, fF = function(e, n) {
      var a = FD(e, n);
      n.editorContainer && (dC.get(n.editorContainer).style.display = e.orgDisplay, e.hidden = dC.isHidden(n.editorContainer)), e.getElement().style.display = "none", dC.setAttrib(e.id, "aria-hidden", "true"), a || O3(e);
    }, NA = ho.DOM, IA = function(e, n, a) {
      var i = $l.get(a), s = $l.urls[a] || e.documentBaseUrl.replace(/\/$/, "");
      if (a = Ut.trim(a), i && Ut.inArray(n, a) === -1) {
        if (Ut.each($l.dependencies(a), function(p) {
          IA(e, n, p);
        }), e.plugins[a])
          return;
        try {
          var f = new i(e, s, e.$);
          e.plugins[a] = f, f.init && (f.init(e, s), n.push(a));
        } catch (p) {
          T6(e, a, p);
        }
      }
    }, FA = function(e) {
      return e.replace(/^\-/, "");
    }, vF = function(e) {
      var n = [];
      Ut.each(E0(e).split(/[ ,]/), function(a) {
        IA(e, n, FA(a));
      });
    }, dF = function(e) {
      var n = Ut.trim(gf(e)), a = e.ui.registry.getAll().icons, i = sr(sr({}, V4.get("default").icons), V4.get(n).icons);
      _n(i, function(s, f) {
        Fr(a, f) || e.ui.registry.addIcon(f, s);
      });
    }, mF = function(e) {
      var n = _g(e);
      if (Ge(n)) {
        e.settings.theme = FA(n);
        var a = xd.get(n);
        e.theme = new a(e, xd.urls[n]), e.theme.init && e.theme.init(e, xd.urls[n] || e.documentBaseUrl.replace(/\/$/, ""), e.$);
      } else
        e.theme = {};
    }, $D = function(e) {
      return e.theme.renderUI();
    }, gF = function(e) {
      var n = e.getElement(), a = _g(e), i = a(e, n);
      return i.editorContainer.nodeType && (i.editorContainer.id = i.editorContainer.id || e.id + "_parent"), i.iframeContainer && i.iframeContainer.nodeType && (i.iframeContainer.id = i.iframeContainer.id || e.id + "_iframecontainer"), i.height = i.iframeHeight ? i.iframeHeight : n.offsetHeight, i;
    }, LD = function(e) {
      return {
        editorContainer: e,
        iframeContainer: e,
        api: {}
      };
    }, zD = function(e) {
      var n = NA.create("div");
      return NA.insertAfter(n, e), LD(n);
    }, pF = function(e) {
      var n = e.getElement();
      return e.inline ? LD(null) : zD(n);
    }, hF = function(e) {
      var n = e.getElement();
      return e.orgDisplay = n.style.display, Ge(_g(e)) ? $D(e) : Be(_g(e)) ? gF(e) : pF(e);
    }, HD = function(e, n) {
      var a = {
        show: se.from(n.show).getOr(xe),
        hide: se.from(n.hide).getOr(xe),
        disable: se.from(n.disable).getOr(xe),
        isDisabled: se.from(n.isDisabled).getOr(Me),
        enable: function() {
          e.mode.isReadOnly() || se.from(n.enable).map(je);
        }
      };
      e.ui = sr(sr({}, e.ui), a);
    }, VD = function(e) {
      e.fire("ScriptsLoaded"), dF(e), mF(e), vF(e);
      var n = hF(e);
      HD(e, se.from(n.api).getOr({}));
      var a = {
        editorContainer: n.editorContainer,
        iframeContainer: n.iframeContainer
      };
      return e.editorContainer = a.editorContainer ? a.editorContainer : null, Z7(e), e.inline ? O3(e) : fF(e, a);
    }, u1 = ho.DOM, UD = function(e) {
      return e.charAt(0) === "-";
    }, jD = function(e, n) {
      var a = x0(n), i = Yi(n);
      if (ls.hasCode(a) === !1 && a !== "en") {
        var s = i !== "" ? i : n.editorManager.baseURL + "/langs/" + a + ".js";
        e.add(s, xe, void 0, function() {
          qw(n, s, a);
        });
      }
    }, WD = function(e, n, a, i) {
      var s = _g(n);
      if (Ge(s)) {
        if (!UD(s) && !Fr(xd.urls, s)) {
          var f = BS(n);
          f ? xd.load(s, n.documentBaseURI.toAbsolute(f)) : xd.load(s, "themes/" + s + "/theme" + a + ".js");
        }
        e.loadQueue(function() {
          xd.waitFor(s, i);
        });
      } else
        i();
    }, bF = function(e) {
      return se.from(w0(e)).filter(function(n) {
        return n.length > 0;
      }).map(function(n) {
        return {
          url: n,
          name: se.none()
        };
      });
    }, qD = function(e, n, a) {
      return se.from(n).filter(function(i) {
        return i.length > 0 && !V4.has(i);
      }).map(function(i) {
        return {
          url: e.editorManager.baseURL + "/icons/" + i + "/icons" + a + ".js",
          name: se.some(i)
        };
      });
    }, yF = function(e, n, a) {
      var i = qD(n, "default", a), s = bF(n).orThunk(function() {
        return qD(n, gf(n), "");
      });
      at(ra([
        i,
        s
      ]), function(f) {
        e.add(f.url, xe, void 0, function() {
          X7(n, f.url, f.name.getOrUndefined());
        });
      });
    }, wF = function(e, n) {
      Ut.each(gT(e), function(a, i) {
        $l.load(i, a, xe, void 0, function() {
          W4(e, a, i);
        }), e.settings.plugins += " " + i;
      }), Ut.each(E0(e).split(/[ ,]/), function(a) {
        if (a = Ut.trim(a), a && !$l.urls[a])
          if (UD(a)) {
            a = a.substr(1, a.length);
            var i = $l.dependencies(a);
            Ut.each(i, function(f) {
              var p = {
                prefix: "plugins/",
                resource: f,
                suffix: "/plugin" + n + ".js"
              }, C = $l.createUrl(p, f);
              $l.load(C.resource, C, xe, void 0, function() {
                W4(e, C.prefix + C.resource + C.suffix, C.resource);
              });
            });
          } else {
            var s = {
              prefix: "plugins/",
              resource: a,
              suffix: "/plugin" + n + ".js"
            };
            $l.load(a, s, xe, void 0, function() {
              W4(e, s.prefix + s.resource + s.suffix, a);
            });
          }
      });
    }, CF = function(e, n) {
      var a = uv.ScriptLoader;
      WD(a, e, n, function() {
        jD(a, e), yF(a, e, n), wF(e, n), a.loadQueue(function() {
          e.removed || VD(e);
        }, e, function() {
          e.removed || VD(e);
        });
      });
    }, SF = function(e, n) {
      return Yl.forElement(e, {
        contentCssCors: mT(n),
        referrerPolicy: S0(n)
      });
    }, xF = function(e) {
      var n = e.id;
      ls.setCode(x0(e));
      var a = function() {
        u1.unbind(window, "ready", a), e.render();
      };
      if (!lg.Event.domLoaded) {
        u1.bind(window, "ready", a);
        return;
      }
      if (!!e.getElement() && !!br.contentEditable) {
        var i = O.fromDom(e.getElement()), s = fr(i);
        e.on("remove", function() {
          pt(i.dom.attributes, function(p) {
            return Gt(i, p.name);
          }), G(i, s);
        }), e.ui.styleSheetLoader = SF(i, e), lT(e) ? e.inline = !0 : (e.orgVisibility = e.getElement().style.visibility, e.getElement().style.visibility = "hidden");
        var f = e.getElement().form || u1.getParent(n, "form");
        f && (e.formElement = f, RS(e) && !uu(e.getElement()) && (u1.insertAfter(u1.create("input", {
          type: "hidden",
          name: n
        }), n), e.hasHiddenInput = !0), e.formEventDelegate = function(p) {
          e.fire(p.type, p);
        }, u1.bind(f, "submit reset", e.formEventDelegate), e.on("reset", function() {
          e.resetContent();
        }), MS(e) && !f.submit.nodeType && !f.submit.length && !f._mceOldSubmit && (f._mceOldSubmit = f.submit, f.submit = function() {
          return e.editorManager.triggerSave(), e.setDirty(!1), f._mceOldSubmit(f);
        })), e.windowManager = __(e), e.notificationManager = Cv(e), i2(e) && e.on("GetContent", function(p) {
          p.save && (p.content = u1.encode(p.content));
        }), cT(e) && e.on("submit", function() {
          e.initialized && e.save();
        }), T0(e) && (e._beforeUnload = function() {
          e.initialized && !e.destroyed && !e.isHidden() && e.save({
            format: "raw",
            no_events: !0,
            set_dirty: !1
          });
        }, e.editorManager.on("BeforeUnload", e._beforeUnload)), e.editorManager.add(e), CF(e, e.suffix);
      }
    }, kF = function(e, n) {
      return HO(e, n);
    }, TF = {
      "font-size": "size",
      "font-family": "face"
    }, EF = function(e, n, a) {
      var i = function(f) {
        return su(f, e).orThunk(function() {
          return Oa(f) === "font" ? Mr(TF, e).bind(function(p) {
            return Fe(f, p);
          }) : se.none();
        });
      }, s = function(f) {
        return Dr(O.fromDom(n), f);
      };
      return LE(O.fromDom(a), function(f) {
        return i(f);
      }, s);
    }, D3 = function(e) {
      return e.replace(/[\'\"\\]/g, "").replace(/,\s+/g, ",");
    }, GD = function(e, n) {
      return se.from(ho.DOM.getStyle(n, e, !0));
    }, $A = function(e) {
      return function(n, a) {
        return se.from(a).map(O.fromDom).filter(So).bind(function(i) {
          return EF(e, n, i.dom).or(GD(e, i.dom));
        }).getOr("");
      };
    }, _F = $A("font-size"), KD = _e(D3, $A("font-family")), XD = function(e) {
      return Gu(e.getBody()).map(function(n) {
        var a = n.container();
        return Qn(a) ? a.parentNode : a;
      });
    }, AF = function(e) {
      return se.from(e.selection.getRng()).bind(function(n) {
        var a = e.getBody(), i = n.startContainer === a && n.startOffset === 0;
        return i ? se.none() : se.from(e.selection.getStart(!0));
      });
    }, OF = function(e, n) {
      return AF(e).orThunk(ne(XD, e)).map(O.fromDom).filter(So).bind(n);
    }, LA = function(e, n) {
      return OF(e, $(se.some, n));
    }, B3 = function(e, n) {
      if (/^[0-9.]+$/.test(n)) {
        var a = parseInt(n, 10);
        if (a >= 1 && a <= 7) {
          var i = gh(e), s = om(e);
          return s ? s[a - 1] || n : i[a - 1] || n;
        } else
          return n;
      } else
        return n;
    }, DF = function(e) {
      var n = e.split(/\s*,\s*/);
      return Ke(n, function(a) {
        return a.indexOf(" ") !== -1 && !(Z(a, '"') || Z(a, "'")) ? "'" + a + "'" : a;
      }).join(",");
    }, zA = function(e, n) {
      var a = B3(e, n);
      e.formatter.toggle("fontname", { value: DF(a) }), e.nodeChanged();
    }, BF = function(e) {
      return LA(e, function(n) {
        return KD(e.getBody(), n.dom);
      }).getOr("");
    }, RF = function(e, n) {
      e.formatter.toggle("fontsize", { value: B3(e, n) }), e.nodeChanged();
    }, MF = function(e) {
      return LA(e, function(n) {
        return _F(e.getBody(), n.dom);
      }).getOr("");
    }, YD = function(e) {
      return LA(e, function(n) {
        var a = O.fromDom(e.getBody()), i = LE(n, function(f) {
          return su(f, "line-height");
        }, ne(Dr, a)), s = function() {
          var f = parseFloat(aa(n, "line-height")), p = parseFloat(aa(n, "font-size"));
          return String(f / p);
        };
        return i.getOrThunk(s);
      }).getOr("");
    }, PF = function(e, n) {
      e.formatter.toggle("lineheight", { value: String(n) }), e.nodeChanged();
    }, NF = function(e) {
      if (typeof e != "string") {
        var n = Ut.extend({
          paste: e.paste,
          data: { paste: e.paste }
        }, e);
        return {
          content: e.content,
          details: n
        };
      }
      return {
        content: e,
        details: {}
      };
    }, IF = function(e, n) {
      var a = NF(n);
      LO(e, a.content, a.details);
    }, R3 = Ut.each, FF = Ut.map, Tl = Ut.inArray, Ep = function() {
      function e(n) {
        this.commands = {
          state: {},
          exec: {},
          value: {}
        }, this.editor = n, this.setupCommands(n);
      }
      return e.prototype.execCommand = function(n, a, i, s) {
        var f, p = !1, C = this;
        if (!C.editor.removed) {
          if (n.toLowerCase() !== "mcefocus" && (!/^(mceAddUndoLevel|mceEndUndoLevel|mceBeginUndoLevel|mceRepaint)$/.test(n) && (!s || !s.skip_focus) ? C.editor.focus() : nw(C.editor)), s = C.editor.fire("BeforeExecCommand", {
            command: n,
            ui: a,
            value: i
          }), s.isDefaultPrevented())
            return !1;
          var k = n.toLowerCase();
          if (f = C.commands.exec[k])
            return f(k, a, i), C.editor.fire("ExecCommand", {
              command: n,
              ui: a,
              value: i
            }), !0;
          if (R3(this.editor.plugins, function(F) {
            if (F.execCommand && F.execCommand(n, a, i))
              return C.editor.fire("ExecCommand", {
                command: n,
                ui: a,
                value: i
              }), p = !0, !1;
          }), p)
            return p;
          if (C.editor.theme && C.editor.theme.execCommand && C.editor.theme.execCommand(n, a, i))
            return C.editor.fire("ExecCommand", {
              command: n,
              ui: a,
              value: i
            }), !0;
          try {
            p = C.editor.getDoc().execCommand(n, a, i);
          } catch {
          }
          return p ? (C.editor.fire("ExecCommand", {
            command: n,
            ui: a,
            value: i
          }), !0) : !1;
        }
      }, e.prototype.queryCommandState = function(n) {
        var a;
        if (!(this.editor.quirks.isHidden() || this.editor.removed)) {
          if (n = n.toLowerCase(), a = this.commands.state[n])
            return a(n);
          try {
            return this.editor.getDoc().queryCommandState(n);
          } catch {
          }
          return !1;
        }
      }, e.prototype.queryCommandValue = function(n) {
        var a;
        if (!(this.editor.quirks.isHidden() || this.editor.removed)) {
          if (n = n.toLowerCase(), a = this.commands.value[n])
            return a(n);
          try {
            return this.editor.getDoc().queryCommandValue(n);
          } catch {
          }
        }
      }, e.prototype.addCommands = function(n, a) {
        a === void 0 && (a = "exec");
        var i = this;
        R3(n, function(s, f) {
          R3(f.toLowerCase().split(","), function(p) {
            i.commands[a][p] = s;
          });
        });
      }, e.prototype.addCommand = function(n, a, i) {
        var s = this;
        n = n.toLowerCase(), this.commands.exec[n] = function(f, p, C, k) {
          return a.call(i || s.editor, p, C, k);
        };
      }, e.prototype.queryCommandSupported = function(n) {
        if (n = n.toLowerCase(), this.commands.exec[n])
          return !0;
        try {
          return this.editor.getDoc().queryCommandSupported(n);
        } catch {
        }
        return !1;
      }, e.prototype.addQueryStateHandler = function(n, a, i) {
        var s = this;
        n = n.toLowerCase(), this.commands.state[n] = function() {
          return a.call(i || s.editor);
        };
      }, e.prototype.addQueryValueHandler = function(n, a, i) {
        var s = this;
        n = n.toLowerCase(), this.commands.value[n] = function() {
          return a.call(i || s.editor);
        };
      }, e.prototype.hasCustomCommand = function(n) {
        return n = n.toLowerCase(), !!this.commands.exec[n];
      }, e.prototype.execNativeCommand = function(n, a, i) {
        return a === void 0 && (a = !1), i === void 0 && (i = null), this.editor.getDoc().execCommand(n, a, i);
      }, e.prototype.isFormatMatch = function(n) {
        return this.editor.formatter.match(n);
      }, e.prototype.toggleFormat = function(n, a) {
        this.editor.formatter.toggle(n, a), this.editor.nodeChanged();
      }, e.prototype.storeSelection = function(n) {
        this.selectionBookmark = this.editor.selection.getBookmark(n);
      }, e.prototype.restoreSelection = function() {
        this.editor.selection.moveToBookmark(this.selectionBookmark);
      }, e.prototype.setupCommands = function(n) {
        var a = this;
        this.addCommands({
          "mceResetDesignMode,mceBeginUndoLevel": xe,
          "mceEndUndoLevel,mceAddUndoLevel": function() {
            n.undoManager.add();
          },
          mceFocus: function(s, f, p) {
            ob(n, p);
          },
          "Cut,Copy,Paste": function(s) {
            var f = n.getDoc(), p;
            try {
              a.execNativeCommand(s);
            } catch {
              p = !0;
            }
            if (s === "paste" && !f.queryCommandEnabled(s) && (p = !0), p || !f.queryCommandSupported(s)) {
              var C = n.translate("Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.");
              br.mac && (C = C.replace(/Ctrl\+/g, "\u2318+")), n.notificationManager.open({
                text: C,
                type: "error"
              });
            }
          },
          unlink: function() {
            if (n.selection.isCollapsed()) {
              var s = n.dom.getParent(n.selection.getStart(), "a");
              s && n.dom.remove(s, !0);
              return;
            }
            n.formatter.remove("link");
          },
          "JustifyLeft,JustifyCenter,JustifyRight,JustifyFull,JustifyNone": function(s) {
            var f = s.substring(7);
            f === "full" && (f = "justify"), R3("left,center,right,justify".split(","), function(p) {
              f !== p && n.formatter.remove("align" + p);
            }), f !== "none" && a.toggleFormat("align" + f);
          },
          "InsertUnorderedList,InsertOrderedList": function(s) {
            var f;
            a.execNativeCommand(s);
            var p = n.dom.getParent(n.selection.getNode(), "ol,ul");
            p && (f = p.parentNode, /^(H[1-6]|P|ADDRESS|PRE)$/.test(f.nodeName) && (a.storeSelection(), n.dom.split(f, p), a.restoreSelection()));
          },
          "Bold,Italic,Underline,Strikethrough,Superscript,Subscript": function(s) {
            a.toggleFormat(s);
          },
          "ForeColor,HiliteColor": function(s, f, p) {
            a.toggleFormat(s, { value: p });
          },
          FontName: function(s, f, p) {
            zA(n, p);
          },
          FontSize: function(s, f, p) {
            RF(n, p);
          },
          LineHeight: function(s, f, p) {
            PF(n, p);
          },
          Lang: function(s, f, p) {
            a.toggleFormat(s, {
              value: p.code,
              customValue: p.customCode
            });
          },
          RemoveFormat: function(s) {
            n.formatter.remove(s);
          },
          mceBlockQuote: function() {
            a.toggleFormat("blockquote");
          },
          FormatBlock: function(s, f, p) {
            return a.toggleFormat(p || "p");
          },
          mceCleanup: function() {
            var s = n.selection.getBookmark();
            n.setContent(n.getContent()), n.selection.moveToBookmark(s);
          },
          mceRemoveNode: function(s, f, p) {
            var C = p || n.selection.getNode();
            C !== n.getBody() && (a.storeSelection(), n.dom.remove(C, !0), a.restoreSelection());
          },
          mceSelectNodeDepth: function(s, f, p) {
            var C = 0;
            n.dom.getParent(n.selection.getNode(), function(k) {
              if (k.nodeType === 1 && C++ === p)
                return n.selection.select(k), !1;
            }, n.getBody());
          },
          mceSelectNode: function(s, f, p) {
            n.selection.select(p);
          },
          mceInsertContent: function(s, f, p) {
            IF(n, p);
          },
          mceInsertRawHTML: function(s, f, p) {
            n.selection.setContent("tiny_mce_marker");
            var C = n.getContent();
            n.setContent(C.replace(/tiny_mce_marker/g, function() {
              return p;
            }));
          },
          mceInsertNewLine: function(s, f, p) {
            fD(n, p);
          },
          mceToggleFormat: function(s, f, p) {
            a.toggleFormat(p);
          },
          mceSetContent: function(s, f, p) {
            n.setContent(p);
          },
          "Indent,Outdent": function(s) {
            sA(n, s);
          },
          mceRepaint: xe,
          InsertHorizontalRule: function() {
            n.execCommand("mceInsertContent", !1, "<hr />");
          },
          mceToggleVisualAid: function() {
            n.hasVisual = !n.hasVisual, n.addVisual();
          },
          mceReplaceContent: function(s, f, p) {
            n.execCommand("mceInsertContent", !1, p.replace(/\{\$selection\}/g, n.selection.getContent({ format: "text" })));
          },
          mceInsertLink: function(s, f, p) {
            typeof p == "string" && (p = { href: p });
            var C = n.dom.getParent(n.selection.getNode(), "a");
            p.href = p.href.replace(/ /g, "%20"), (!C || !p.href) && n.formatter.remove("link"), p.href && n.formatter.apply("link", p, C);
          },
          selectAll: function() {
            var s = n.dom.getParent(n.selection.getStart(), Kl);
            if (s) {
              var f = n.dom.createRng();
              f.selectNodeContents(s), n.selection.setRng(f);
            }
          },
          mceNewDocument: function() {
            n.setContent("");
          },
          InsertLineBreak: function(s, f, p) {
            return iD(n, p), !0;
          }
        });
        var i = function(s) {
          return function() {
            var f = n.selection, p = f.isCollapsed() ? [n.dom.getParent(f.getNode(), n.dom.isBlock)] : f.getSelectedBlocks(), C = FF(p, function(k) {
              return !!n.formatter.matchNode(k, s);
            });
            return Tl(C, !0) !== -1;
          };
        };
        a.addCommands({
          JustifyLeft: i("alignleft"),
          JustifyCenter: i("aligncenter"),
          JustifyRight: i("alignright"),
          JustifyFull: i("alignjustify"),
          "Bold,Italic,Underline,Strikethrough,Superscript,Subscript": function(s) {
            return a.isFormatMatch(s);
          },
          mceBlockQuote: function() {
            return a.isFormatMatch("blockquote");
          },
          Outdent: function() {
            return A8(n);
          },
          "InsertUnorderedList,InsertOrderedList": function(s) {
            var f = n.dom.getParent(n.selection.getNode(), "ul,ol");
            return f && (s === "insertunorderedlist" && f.tagName === "UL" || s === "insertorderedlist" && f.tagName === "OL");
          }
        }, "state"), a.addCommands({
          Undo: function() {
            n.undoManager.undo();
          },
          Redo: function() {
            n.undoManager.redo();
          }
        }), a.addQueryValueHandler("FontName", function() {
          return BF(n);
        }, this), a.addQueryValueHandler("FontSize", function() {
          return MF(n);
        }, this), a.addQueryValueHandler("LineHeight", function() {
          return YD(n);
        }, this);
      }, e;
    }(), s1 = "data-mce-contenteditable", $F = function(e, n, a) {
      $y(e, n) && a === !1 ? Fy(e, n) : a && Qd(e, n);
    }, HA = function(e, n, a) {
      try {
        e.getDoc().execCommand(n, !1, String(a));
      } catch {
      }
    }, M3 = function(e, n) {
      e.dom.contentEditable = n ? "true" : "false";
    }, LF = function(e) {
      at(du(e, '*[contenteditable="true"]'), function(n) {
        M(n, s1, "true"), M3(n, !1);
      });
    }, zF = function(e) {
      at(du(e, "*[" + s1 + '="true"]'), function(n) {
        Gt(n, s1), M3(n, !0);
      });
    }, ZD = function(e) {
      se.from(e.selection.getNode()).each(function(n) {
        n.removeAttribute("data-mce-selected");
      });
    }, Ub = function(e) {
      e.selection.setRng(e.selection.getRng());
    }, HF = function(e, n) {
      var a = O.fromDom(e.getBody());
      $F(a, "mce-content-readonly", n), n ? (e.selection.controlSelection.hideResizeRect(), e._selectionOverrides.hideFakeCaret(), ZD(e), e.readonly = !0, M3(a, !1), LF(a)) : (e.readonly = !1, M3(a, !0), zF(a), HA(e, "StyleWithCSS", !1), HA(e, "enableInlineTableEditing", !1), HA(e, "enableObjectResizing", !1), $x(e) && e.focus(), Ub(e), e.nodeChanged());
    }, l1 = function(e) {
      return e.readonly;
    }, JD = function(e) {
      e.parser.addAttributeFilter("contenteditable", function(n) {
        l1(e) && at(n, function(a) {
          a.attr(s1, a.attr("contenteditable")), a.attr("contenteditable", "false");
        });
      }), e.serializer.addAttributeFilter(s1, function(n) {
        l1(e) && at(n, function(a) {
          a.attr("contenteditable", a.attr(s1));
        });
      }), e.serializer.addTempAttr(s1);
    }, Tv = function(e) {
      e.serializer ? JD(e) : e.on("PreInit", function() {
        JD(e);
      });
    }, VF = function(e) {
      return e.type === "click";
    }, UF = function(e, n) {
      var a = function(i) {
        return Dr(i, O.fromDom(e.getBody()));
      };
      return ri(n, "a", a).bind(function(i) {
        return Fe(i, "href");
      });
    }, QD = function(e, n) {
      if (VF(n) && !Br.metaKeyPressed(n)) {
        var a = O.fromDom(n.target);
        UF(e, a).each(function(i) {
          if (n.preventDefault(), /^#/.test(i)) {
            var s = e.dom.select(i + ',[name="' + en(i, "#") + '"]');
            s.length && e.selection.scrollIntoView(s[0], !0);
          } else
            window.open(i, "_blank", "rel=noopener noreferrer,menubar=yes,toolbar=yes,location=yes,status=yes,resizable=yes,scrollbars=yes");
        });
      }
    }, jF = function(e) {
      e.on("ShowCaret", function(n) {
        l1(e) && n.preventDefault();
      }), e.on("ObjectSelected", function(n) {
        l1(e) && n.preventDefault();
      });
    }, eB = Ut.makeMap("focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange mouseout mouseenter mouseleave wheel keydown keypress keyup input beforeinput contextmenu dragstart dragend dragover draggesture dragdrop drop drag submit compositionstart compositionend compositionupdate touchstart touchmove touchend touchcancel", " "), P3 = function() {
      function e(n) {
        this.bindings = {}, this.settings = n || {}, this.scope = this.settings.scope || this, this.toggleEvent = this.settings.toggleEvent || Me;
      }
      return e.isNative = function(n) {
        return !!eB[n.toLowerCase()];
      }, e.prototype.fire = function(n, a) {
        var i = n.toLowerCase(), s = cn(i, a || {}, this.scope);
        this.settings.beforeFire && this.settings.beforeFire(s);
        var f = this.bindings[i];
        if (f)
          for (var p = 0, C = f.length; p < C; p++) {
            var k = f[p];
            if (!k.removed) {
              if (k.once && this.off(i, k.func), s.isImmediatePropagationStopped())
                return s;
              if (k.func.call(this.scope, s) === !1)
                return s.preventDefault(), s;
            }
          }
        return s;
      }, e.prototype.on = function(n, a, i, s) {
        if (a === !1 && (a = Me), a) {
          var f = {
            func: a,
            removed: !1
          };
          s && Ut.extend(f, s);
          for (var p = n.toLowerCase().split(" "), C = p.length; C--; ) {
            var k = p[C], F = this.bindings[k];
            F || (F = [], this.toggleEvent(k, !0)), i ? F = Ko([f], F, !0) : F = Ko(Ko([], F, !0), [f], !1), this.bindings[k] = F;
          }
        }
        return this;
      }, e.prototype.off = function(n, a) {
        var i = this;
        if (n)
          for (var s = n.toLowerCase().split(" "), f = s.length; f--; ) {
            var p = s[f], C = this.bindings[p];
            if (!p)
              return _n(this.bindings, function(F, q) {
                i.toggleEvent(q, !1), delete i.bindings[q];
              }), this;
            if (C) {
              if (!a)
                C.length = 0;
              else {
                var k = sn(C, function(F) {
                  return F.func === a;
                });
                C = k.fail, this.bindings[p] = C, at(k.pass, function(F) {
                  F.removed = !0;
                });
              }
              C.length || (this.toggleEvent(n, !1), delete this.bindings[p]);
            }
          }
        else
          _n(this.bindings, function(F, q) {
            i.toggleEvent(q, !1);
          }), this.bindings = {};
        return this;
      }, e.prototype.once = function(n, a, i) {
        return this.on(n, a, i, { once: !0 });
      }, e.prototype.has = function(n) {
        return n = n.toLowerCase(), !(!this.bindings[n] || this.bindings[n].length === 0);
      }, e;
    }(), c1 = function(e) {
      return e._eventDispatcher || (e._eventDispatcher = new P3({
        scope: e,
        toggleEvent: function(n, a) {
          P3.isNative(n) && e.toggleNativeEvent && e.toggleNativeEvent(n, a);
        }
      })), e._eventDispatcher;
    }, N3 = {
      fire: function(e, n, a) {
        var i = this;
        if (i.removed && e !== "remove" && e !== "detach")
          return n;
        var s = c1(i).fire(e, n);
        if (a !== !1 && i.parent)
          for (var f = i.parent(); f && !s.isPropagationStopped(); )
            f.fire(e, s, !1), f = f.parent();
        return s;
      },
      on: function(e, n, a) {
        return c1(this).on(e, n, a);
      },
      off: function(e, n) {
        return c1(this).off(e, n);
      },
      once: function(e, n) {
        return c1(this).once(e, n);
      },
      hasEventListeners: function(e) {
        return c1(this).has(e);
      }
    }, I3 = ho.DOM, f1, F3 = function(e, n) {
      if (n === "selectionchange")
        return e.getDoc();
      if (!e.inline && /^mouse|touch|click|contextmenu|drop|dragover|dragend/.test(n))
        return e.getDoc().documentElement;
      var a = k0(e);
      return a ? (e.eventRoot || (e.eventRoot = I3.select(a)[0]), e.eventRoot) : e.getBody();
    }, WF = function(e) {
      return !e.hidden && !l1(e);
    }, VA = function(e, n, a) {
      WF(e) ? e.fire(n, a) : l1(e) && QD(e, a);
    }, UA = function(e, n) {
      var a;
      if (e.delegates || (e.delegates = {}), !(e.delegates[n] || e.removed)) {
        var i = F3(e, n);
        if (k0(e)) {
          if (f1 || (f1 = {}, e.editorManager.on("removeEditor", function() {
            e.editorManager.activeEditor || f1 && (_n(f1, function(s, f) {
              e.dom.unbind(F3(e, f));
            }), f1 = null);
          })), f1[n])
            return;
          a = function(s) {
            for (var f = s.target, p = e.editorManager.get(), C = p.length; C--; ) {
              var k = p[C].getBody();
              (k === f || I3.isChildOf(f, k)) && VA(p[C], n, s);
            }
          }, f1[n] = a, I3.bind(i, n, a);
        } else
          a = function(s) {
            VA(e, n, s);
          }, I3.bind(i, n, a), e.delegates[n] = a;
      }
    }, tB = sr(sr({}, N3), {
      bindPendingEventDelegates: function() {
        var e = this;
        Ut.each(e._pendingNativeEvents, function(n) {
          UA(e, n);
        });
      },
      toggleNativeEvent: function(e, n) {
        var a = this;
        e === "focus" || e === "blur" || a.removed || (n ? a.initialized ? UA(a, e) : a._pendingNativeEvents ? a._pendingNativeEvents.push(e) : a._pendingNativeEvents = [e] : a.initialized && (a.dom.unbind(F3(a, e), e, a.delegates[e]), delete a.delegates[e]));
      },
      unbindAllNativeEvents: function() {
        var e = this, n = e.getBody(), a = e.dom;
        e.delegates && (_n(e.delegates, function(i, s) {
          e.dom.unbind(F3(e, s), s, i);
        }), delete e.delegates), !e.inline && n && a && (n.onload = null, a.unbind(e.getWin()), a.unbind(e.getDoc())), a && (a.unbind(n), a.unbind(e.getContainer()));
      }
    }), nB = [
      "design",
      "readonly"
    ], rB = function(e, n, a, i) {
      var s = a[n.get()], f = a[i];
      try {
        f.activate();
      } catch (p) {
        console.error("problem while activating editor mode " + i + ":", p);
        return;
      }
      s.deactivate(), s.editorReadOnly !== f.editorReadOnly && HF(e, f.editorReadOnly), n.set(i), L2(e, i);
    }, qF = function(e, n, a, i) {
      if (i !== a.get()) {
        if (!Fr(n, i))
          throw new Error("Editor mode '" + i + "' is invalid");
        e.initialized ? rB(e, a, n, i) : e.on("init", function() {
          return rB(e, a, n, i);
        });
      }
    }, GF = function(e, n, a) {
      var i;
      if (We(nB, n))
        throw new Error("Cannot override default mode " + n);
      return sr(sr({}, e), (i = {}, i[n] = sr(sr({}, a), {
        deactivate: function() {
          try {
            a.deactivate();
          } catch (s) {
            console.error("problem while deactivating editor mode " + n + ":", s);
          }
        }
      }), i));
    }, KF = function(e) {
      var n = ss("design"), a = ss({
        design: {
          activate: xe,
          deactivate: xe,
          editorReadOnly: !1
        },
        readonly: {
          activate: xe,
          deactivate: xe,
          editorReadOnly: !0
        }
      });
      return Tv(e), jF(e), {
        isReadOnly: function() {
          return l1(e);
        },
        set: function(i) {
          return qF(e, a.get(), n, i);
        },
        get: function() {
          return n.get();
        },
        register: function(i, s) {
          a.set(GF(a.get(), i, s));
        }
      };
    }, $3 = Ut.each, mC = Ut.explode, aB = {
      f1: 112,
      f2: 113,
      f3: 114,
      f4: 115,
      f5: 116,
      f6: 117,
      f7: 118,
      f8: 119,
      f9: 120,
      f10: 121,
      f11: 122,
      f12: 123
    }, oB = Ut.makeMap("alt,ctrl,shift,meta,access"), XF = function(e) {
      var n, a = {};
      $3(mC(e.toLowerCase(), "+"), function(s) {
        s in oB ? a[s] = !0 : /^[0-9]{2,}$/.test(s) ? a.keyCode = parseInt(s, 10) : (a.charCode = s.charCodeAt(0), a.keyCode = aB[s] || s.toUpperCase().charCodeAt(0));
      });
      var i = [a.keyCode];
      for (n in oB)
        a[n] ? i.push(n) : a[n] = !1;
      return a.id = i.join(","), a.access && (a.alt = !0, br.mac ? a.ctrl = !0 : a.shift = !0), a.meta && (br.mac ? a.meta = !0 : (a.ctrl = !0, a.meta = !1)), a;
    }, L3 = function() {
      function e(n) {
        this.shortcuts = {}, this.pendingPatterns = [], this.editor = n;
        var a = this;
        n.on("keyup keypress keydown", function(i) {
          (a.hasModifier(i) || a.isFunctionKey(i)) && !i.isDefaultPrevented() && ($3(a.shortcuts, function(s) {
            if (a.matchShortcut(i, s))
              return a.pendingPatterns = s.subpatterns.slice(0), i.type === "keydown" && a.executeShortcutAction(s), !0;
          }), a.matchShortcut(i, a.pendingPatterns[0]) && (a.pendingPatterns.length === 1 && i.type === "keydown" && a.executeShortcutAction(a.pendingPatterns[0]), a.pendingPatterns.shift()));
        });
      }
      return e.prototype.add = function(n, a, i, s) {
        var f = this, p = f.normalizeCommandFunc(i);
        return $3(mC(Ut.trim(n)), function(C) {
          var k = f.createShortcut(C, a, p, s);
          f.shortcuts[k.id] = k;
        }), !0;
      }, e.prototype.remove = function(n) {
        var a = this.createShortcut(n);
        return this.shortcuts[a.id] ? (delete this.shortcuts[a.id], !0) : !1;
      }, e.prototype.normalizeCommandFunc = function(n) {
        var a = this, i = n;
        return typeof i == "string" ? function() {
          a.editor.execCommand(i, !1, null);
        } : Ut.isArray(i) ? function() {
          a.editor.execCommand(i[0], i[1], i[2]);
        } : i;
      }, e.prototype.createShortcut = function(n, a, i, s) {
        var f = Ut.map(mC(n, ">"), XF);
        return f[f.length - 1] = Ut.extend(f[f.length - 1], {
          func: i,
          scope: s || this.editor
        }), Ut.extend(f[0], {
          desc: this.editor.translate(a),
          subpatterns: f.slice(1)
        });
      }, e.prototype.hasModifier = function(n) {
        return n.altKey || n.ctrlKey || n.metaKey;
      }, e.prototype.isFunctionKey = function(n) {
        return n.type === "keydown" && n.keyCode >= 112 && n.keyCode <= 123;
      }, e.prototype.matchShortcut = function(n, a) {
        return !a || a.ctrl !== n.ctrlKey || a.meta !== n.metaKey || a.alt !== n.altKey || a.shift !== n.shiftKey ? !1 : n.keyCode === a.keyCode || n.charCode && n.charCode === a.charCode ? (n.preventDefault(), !0) : !1;
      }, e.prototype.executeShortcutAction = function(n) {
        return n.func ? n.func.call(n.scope) : null;
      }, e;
    }(), iB = function() {
      var e = {}, n = {}, a = {}, i = {}, s = {}, f = {}, p = {}, C = function(F, q) {
        return function(K, te) {
          return F[K.toLowerCase()] = sr(sr({}, te), { type: q });
        };
      }, k = function(F, q) {
        return i[F.toLowerCase()] = q;
      };
      return {
        addButton: C(e, "button"),
        addGroupToolbarButton: C(e, "grouptoolbarbutton"),
        addToggleButton: C(e, "togglebutton"),
        addMenuButton: C(e, "menubutton"),
        addSplitButton: C(e, "splitbutton"),
        addMenuItem: C(n, "menuitem"),
        addNestedMenuItem: C(n, "nestedmenuitem"),
        addToggleMenuItem: C(n, "togglemenuitem"),
        addAutocompleter: C(a, "autocompleter"),
        addContextMenu: C(s, "contextmenu"),
        addContextToolbar: C(f, "contexttoolbar"),
        addContextForm: C(f, "contextform"),
        addSidebar: C(p, "sidebar"),
        addIcon: k,
        getAll: function() {
          return {
            buttons: e,
            menuItems: n,
            icons: i,
            popups: a,
            contextMenus: s,
            contextToolbars: f,
            sidebars: p
          };
        }
      };
    }, YF = function() {
      var e = iB();
      return {
        addAutocompleter: e.addAutocompleter,
        addButton: e.addButton,
        addContextForm: e.addContextForm,
        addContextMenu: e.addContextMenu,
        addContextToolbar: e.addContextToolbar,
        addIcon: e.addIcon,
        addMenuButton: e.addMenuButton,
        addMenuItem: e.addMenuItem,
        addNestedMenuItem: e.addNestedMenuItem,
        addSidebar: e.addSidebar,
        addSplitButton: e.addSplitButton,
        addToggleButton: e.addToggleButton,
        addGroupToolbarButton: e.addGroupToolbarButton,
        addToggleMenuItem: e.addToggleMenuItem,
        getAll: e.getAll
      };
    }, v1 = ho.DOM, uB = Ut.extend, ZF = Ut.each, sB = Ut.resolve, JF = br.ie, z3 = function() {
      function e(n, a, i) {
        var s = this;
        this.plugins = {}, this.contentCSS = [], this.contentStyles = [], this.loadedCSS = {}, this.isNotDirty = !1, this.editorManager = i, this.documentBaseUrl = i.documentBaseURL, uB(this, tB), this.settings = w6(this, n, this.documentBaseUrl, i.defaultSettings, a), this.settings.suffix && (i.suffix = this.settings.suffix), this.suffix = i.suffix, this.settings.base_url && i._setBaseUrl(this.settings.base_url), this.baseUri = i.baseURI, this.settings.referrer_policy && (uv.ScriptLoader._setReferrerPolicy(this.settings.referrer_policy), ho.DOM.styleSheetLoader._setReferrerPolicy(this.settings.referrer_policy)), Ts.languageLoad = this.settings.language_load, Ts.baseURL = i.baseURL, this.id = n, this.setDirty(!1), this.documentBaseURI = new hd(this.settings.document_base_url, { base_uri: this.baseUri }), this.baseURI = this.baseUri, this.inline = !!this.settings.inline, this.shortcuts = new L3(this), this.editorCommands = new Ep(this), this.settings.cache_suffix && (br.cacheSuffix = this.settings.cache_suffix.replace(/^[\?\&]+/, "")), this.ui = {
          registry: YF(),
          styleSheetLoader: void 0,
          show: xe,
          hide: xe,
          enable: xe,
          disable: xe,
          isDisabled: Me
        };
        var f = this, p = KF(f);
        this.mode = p, this.setMode = p.set, i.fire("SetupEditor", { editor: this }), this.execCallback("setup", this), this.$ = ta.overrideDefaults(function() {
          return {
            context: s.inline ? s.getBody() : s.getDoc(),
            element: s.getBody()
          };
        });
      }
      return e.prototype.render = function() {
        xF(this);
      }, e.prototype.focus = function(n) {
        this.execCommand("mceFocus", !1, n);
      }, e.prototype.hasFocus = function() {
        return Il(this);
      }, e.prototype.execCallback = function(n) {
        for (var a = [], i = 1; i < arguments.length; i++)
          a[i - 1] = arguments[i];
        var s = this, f = s.settings[n], p;
        if (!!f)
          return s.callbackLookup && (p = s.callbackLookup[n]) && (f = p.func, p = p.scope), typeof f == "string" && (p = f.replace(/\.\w+$/, ""), p = p ? sB(p) : 0, f = sB(f), s.callbackLookup = s.callbackLookup || {}, s.callbackLookup[n] = {
            func: f,
            scope: p
          }), f.apply(p || s, a);
      }, e.prototype.translate = function(n) {
        return ls.translate(n);
      }, e.prototype.getParam = function(n, a, i) {
        return j7(this, n, a, i);
      }, e.prototype.hasPlugin = function(n, a) {
        var i = We(E0(this).split(/[ ,]/), n);
        return i ? a ? $l.get(n) !== void 0 : !0 : !1;
      }, e.prototype.nodeChanged = function(n) {
        this._nodeChangeDispatcher.nodeChanged(n);
      }, e.prototype.addCommand = function(n, a, i) {
        this.editorCommands.addCommand(n, a, i);
      }, e.prototype.addQueryStateHandler = function(n, a, i) {
        this.editorCommands.addQueryStateHandler(n, a, i);
      }, e.prototype.addQueryValueHandler = function(n, a, i) {
        this.editorCommands.addQueryValueHandler(n, a, i);
      }, e.prototype.addShortcut = function(n, a, i, s) {
        this.shortcuts.add(n, a, i, s);
      }, e.prototype.execCommand = function(n, a, i, s) {
        return this.editorCommands.execCommand(n, a, i, s);
      }, e.prototype.queryCommandState = function(n) {
        return this.editorCommands.queryCommandState(n);
      }, e.prototype.queryCommandValue = function(n) {
        return this.editorCommands.queryCommandValue(n);
      }, e.prototype.queryCommandSupported = function(n) {
        return this.editorCommands.queryCommandSupported(n);
      }, e.prototype.show = function() {
        var n = this;
        n.hidden && (n.hidden = !1, n.inline ? n.getBody().contentEditable = "true" : (v1.show(n.getContainer()), v1.hide(n.id)), n.load(), n.fire("show"));
      }, e.prototype.hide = function() {
        var n = this, a = n.getDoc();
        n.hidden || (JF && a && !n.inline && a.execCommand("SelectAll"), n.save(), n.inline ? (n.getBody().contentEditable = "false", n === n.editorManager.focusedEditor && (n.editorManager.focusedEditor = null)) : (v1.hide(n.getContainer()), v1.setStyle(n.id, "display", n.orgDisplay)), n.hidden = !0, n.fire("hide"));
      }, e.prototype.isHidden = function() {
        return !!this.hidden;
      }, e.prototype.setProgressState = function(n, a) {
        this.fire("ProgressState", {
          state: n,
          time: a
        });
      }, e.prototype.load = function(n) {
        var a = this, i = a.getElement(), s;
        if (a.removed)
          return "";
        if (i) {
          n = n || {}, n.load = !0;
          var f = uu(i) ? i.value : i.innerHTML;
          return s = a.setContent(f, n), n.element = i, n.no_events || a.fire("LoadContent", n), n.element = i = null, s;
        }
      }, e.prototype.save = function(n) {
        var a = this, i = a.getElement(), s, f;
        if (!(!i || !a.initialized || a.removed))
          return n = n || {}, n.save = !0, n.element = i, s = n.content = a.getContent(n), n.no_events || a.fire("SaveContent", n), n.format === "raw" && a.fire("RawSaveContent", n), s = n.content, uu(i) ? i.value = s : ((n.is_removing || !a.inline) && (i.innerHTML = s), (f = v1.getParent(a.id, "form")) && ZF(f.elements, function(p) {
            if (p.name === a.id)
              return p.value = s, !1;
          })), n.element = i = null, n.set_dirty !== !1 && a.setDirty(!1), s;
      }, e.prototype.setContent = function(n, a) {
        return x_(this, n, a);
      }, e.prototype.getContent = function(n) {
        return S7(this, n);
      }, e.prototype.insertContent = function(n, a) {
        a && (n = uB({ content: n }, a)), this.execCommand("mceInsertContent", !1, n);
      }, e.prototype.resetContent = function(n) {
        n === void 0 ? x_(this, this.startContent, { format: "raw" }) : x_(this, n), this.undoManager.reset(), this.setDirty(!1), this.nodeChanged();
      }, e.prototype.isDirty = function() {
        return !this.isNotDirty;
      }, e.prototype.setDirty = function(n) {
        var a = !this.isNotDirty;
        this.isNotDirty = !n, n && n !== a && this.fire("dirty");
      }, e.prototype.getContainer = function() {
        var n = this;
        return n.container || (n.container = v1.get(n.editorContainer || n.id + "_parent")), n.container;
      }, e.prototype.getContentAreaContainer = function() {
        return this.contentAreaContainer;
      }, e.prototype.getElement = function() {
        return this.targetElm || (this.targetElm = v1.get(this.id)), this.targetElm;
      }, e.prototype.getWin = function() {
        var n = this, a;
        return n.contentWindow || (a = n.iframeElement, a && (n.contentWindow = a.contentWindow)), n.contentWindow;
      }, e.prototype.getDoc = function() {
        var n = this, a;
        return n.contentDocument || (a = n.getWin(), a && (n.contentDocument = a.document)), n.contentDocument;
      }, e.prototype.getBody = function() {
        var n = this.getDoc();
        return this.bodyElement || (n ? n.body : null);
      }, e.prototype.convertURL = function(n, a, i) {
        var s = this, f = s.settings;
        return f.urlconverter_callback ? s.execCallback("urlconverter_callback", n, i, !0, a) : !f.convert_urls || i && i.nodeName === "LINK" || n.indexOf("file:") === 0 || n.length === 0 ? n : f.relative_urls ? s.documentBaseURI.toRelative(n) : (n = s.documentBaseURI.toAbsolute(n, f.remove_script_host), n);
      }, e.prototype.addVisual = function(n) {
        kF(this, n);
      }, e.prototype.remove = function() {
        T7(this);
      }, e.prototype.destroy = function(n) {
        c6(this, n);
      }, e.prototype.uploadImages = function(n) {
        return this.editorUpload.uploadImages(n);
      }, e.prototype._scanForImages = function() {
        return this.editorUpload.scanForImages();
      }, e.prototype.addButton = function() {
        throw new Error("editor.addButton has been removed in tinymce 5x, use editor.ui.registry.addButton or editor.ui.registry.addToggleButton or editor.ui.registry.addSplitButton instead");
      }, e.prototype.addSidebar = function() {
        throw new Error("editor.addSidebar has been removed in tinymce 5x, use editor.ui.registry.addSidebar instead");
      }, e.prototype.addMenuItem = function() {
        throw new Error("editor.addMenuItem has been removed in tinymce 5x, use editor.ui.registry.addMenuItem instead");
      }, e.prototype.addContextToolbar = function() {
        throw new Error("editor.addContextToolbar has been removed in tinymce 5x, use editor.ui.registry.addContextToolbar instead");
      }, e;
    }(), If = ho.DOM, QF = Ut.explode, vi = Ut.each, jA = Ut.extend, Ed = 0, WA = !1, gC, _p = [], Bs = [], qA = function(e) {
      return e !== "length";
    }, GA = function(e) {
      var n = e.type;
      vi(Ap.get(), function(a) {
        switch (n) {
          case "scroll":
            a.fire("ScrollWindow", e);
            break;
          case "resize":
            a.fire("ResizeWindow", e);
            break;
        }
      });
    }, KA = function(e) {
      e !== WA && (e ? ta(window).on("resize scroll", GA) : ta(window).off("resize scroll", GA), WA = e);
    }, lB = function(e) {
      var n = Bs;
      delete _p[e.id];
      for (var a = 0; a < _p.length; a++)
        if (_p[a] === e) {
          _p.splice(a, 1);
          break;
        }
      return Bs = Ie(Bs, function(i) {
        return e !== i;
      }), Ap.activeEditor === e && (Ap.activeEditor = Bs.length > 0 ? Bs[0] : null), Ap.focusedEditor === e && (Ap.focusedEditor = null), n.length !== Bs.length;
    }, e$ = function(e) {
      return e && e.initialized && !(e.getContainer() || e.getBody()).parentNode && (lB(e), e.unbindAllNativeEvents(), e.destroy(!0), e.removed = !0, e = null), e;
    }, t$ = document.compatMode !== "CSS1Compat", Ap = sr(sr({}, N3), {
      baseURI: null,
      baseURL: null,
      defaultSettings: {},
      documentBaseURL: null,
      suffix: null,
      $: ta,
      majorVersion: "5",
      minorVersion: "10.6",
      releaseDate: "2022-10-19",
      editors: _p,
      i18n: ls,
      activeEditor: null,
      focusedEditor: null,
      settings: {},
      setup: function() {
        var e = this, n, a, i = "";
        a = hd.getDocumentBaseUrl(document.location), /^[^:]+:\/\/\/?[^\/]+\//.test(a) && (a = a.replace(/[\?#].*$/, "").replace(/[\/\\][^\/]+$/, ""), /[\/\\]$/.test(a) || (a += "/"));
        var s = window.tinymce || window.tinyMCEPreInit;
        if (s)
          n = s.base || s.baseURL, i = s.suffix;
        else {
          for (var f = document.getElementsByTagName("script"), p = 0; p < f.length; p++) {
            var C = f[p].src || "";
            if (C !== "") {
              var k = C.substring(C.lastIndexOf("/"));
              if (/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(C)) {
                k.indexOf(".min") !== -1 && (i = ".min"), n = C.substring(0, C.lastIndexOf("/"));
                break;
              }
            }
          }
          if (!n && document.currentScript) {
            var C = document.currentScript.src;
            C.indexOf(".min") !== -1 && (i = ".min"), n = C.substring(0, C.lastIndexOf("/"));
          }
        }
        e.baseURL = new hd(a).toAbsolute(n), e.documentBaseURL = a, e.baseURI = new hd(e.baseURL), e.suffix = i, Rx(e);
      },
      overrideDefaults: function(e) {
        var n = e.base_url;
        n && this._setBaseUrl(n);
        var a = e.suffix;
        e.suffix && (this.suffix = a), this.defaultSettings = e;
        var i = e.plugin_base_urls;
        i !== void 0 && _n(i, function(s, f) {
          Ts.PluginManager.urls[f] = s;
        });
      },
      init: function(e) {
        var n = this, a, i = Ut.makeMap("area base basefont br col frame hr img input isindex link meta param embed source wbr track colgroup option table tbody tfoot thead tr th td script noscript style textarea video audio iframe object menu", " "), s = function(K, te) {
          return K.inline && te.tagName.toLowerCase() in i;
        }, f = function(K) {
          var te = K.id;
          return te || (te = Mr(K, "name").filter(function(be) {
            return !If.get(be);
          }).getOrThunk(If.uniqueId), K.setAttribute("id", te)), te;
        }, p = function(K) {
          var te = e[K];
          if (!!te)
            return te.apply(n, []);
        }, C = function(K, te) {
          return te.constructor === RegExp ? te.test(K.className) : If.hasClass(K, te);
        }, k = function(K) {
          var te = [];
          if (br.browser.isIE() && br.browser.version.major < 11)
            return Gw("TinyMCE does not support the browser you are using. For a list of supported browsers please see: https://www.tinymce.com/docs/get-started/system-requirements/"), [];
          if (t$)
            return Gw("Failed to initialize the editor as the document is not in standards mode. TinyMCE requires standards mode."), [];
          if (K.types)
            return vi(K.types, function(we) {
              te = te.concat(If.select(we.selector));
            }), te;
          if (K.selector)
            return If.select(K.selector);
          if (K.target)
            return [K.target];
          switch (K.mode) {
            case "exact":
              var be = K.elements || "";
              be.length > 0 && vi(QF(be), function(we) {
                var ke = If.get(we);
                ke ? te.push(ke) : vi(document.forms, function(Ee) {
                  vi(Ee.elements, function(qe) {
                    qe.name === we && (we = "mce_editor_" + Ed++, If.setAttrib(qe, "id", we), te.push(qe));
                  });
                });
              });
              break;
            case "textareas":
            case "specific_textareas":
              vi(If.select("textarea"), function(we) {
                K.editor_deselector && C(we, K.editor_deselector) || (!K.editor_selector || C(we, K.editor_selector)) && te.push(we);
              });
              break;
          }
          return te;
        }, F = function(K) {
          a = K;
        }, q = function() {
          var K = 0, te = [], be, we = function(ke, Ee, qe) {
            var Le = new z3(ke, Ee, n);
            te.push(Le), Le.on("init", function() {
              ++K === be.length && F(te);
            }), Le.targetElm = Le.targetElm || qe, Le.render();
          };
          if (If.unbind(window, "ready", q), p("onpageload"), be = ta.unique(k(e)), e.types) {
            vi(e.types, function(ke) {
              Ut.each(be, function(Ee) {
                return If.is(Ee, ke.selector) ? (we(f(Ee), jA({}, e, ke), Ee), !1) : !0;
              });
            });
            return;
          }
          Ut.each(be, function(ke) {
            e$(n.get(ke.id));
          }), be = Ut.grep(be, function(ke) {
            return !n.get(ke.id);
          }), be.length === 0 ? F([]) : vi(be, function(ke) {
            s(e, ke) ? Gw("Could not initialize inline editor on invalid inline target element", ke) : we(f(ke), e, ke);
          });
        };
        return n.settings = e, If.bind(window, "ready", q), new Ki(function(K) {
          a ? K(a) : F = function(te) {
            K(te);
          };
        });
      },
      get: function(e) {
        return arguments.length === 0 ? Bs.slice(0) : Ge(e) ? tt(Bs, function(n) {
          return n.id === e;
        }).getOr(null) : ge(e) && Bs[e] ? Bs[e] : null;
      },
      add: function(e) {
        var n = this, a = _p[e.id];
        return a === e || (n.get(e.id) === null && (qA(e.id) && (_p[e.id] = e), _p.push(e), Bs.push(e)), KA(!0), n.activeEditor = e, n.fire("AddEditor", { editor: e }), gC || (gC = function(i) {
          var s = n.fire("BeforeUnload");
          if (s.returnValue)
            return i.preventDefault(), i.returnValue = s.returnValue, s.returnValue;
        }, window.addEventListener("beforeunload", gC))), e;
      },
      createEditor: function(e, n) {
        return this.add(new z3(e, n, this));
      },
      remove: function(e) {
        var n = this, a, i;
        if (!e) {
          for (a = Bs.length - 1; a >= 0; a--)
            n.remove(Bs[a]);
          return;
        }
        if (Ge(e)) {
          vi(If.select(e), function(s) {
            i = n.get(s.id), i && n.remove(i);
          });
          return;
        }
        return i = e, ie(n.get(i.id)) ? null : (lB(i) && n.fire("RemoveEditor", { editor: i }), Bs.length === 0 && window.removeEventListener("beforeunload", gC), i.remove(), KA(Bs.length > 0), i);
      },
      execCommand: function(e, n, a) {
        var i = this, s = i.get(a);
        switch (e) {
          case "mceAddEditor":
            return i.get(a) || new z3(a, i.settings, i).render(), !0;
          case "mceRemoveEditor":
            return s && s.remove(), !0;
          case "mceToggleEditor":
            return s ? (s.isHidden() ? s.show() : s.hide(), !0) : (i.execCommand("mceAddEditor", !1, a), !0);
        }
        return i.activeEditor ? i.activeEditor.execCommand(e, n, a) : !1;
      },
      triggerSave: function() {
        vi(Bs, function(e) {
          e.save();
        });
      },
      addI18n: function(e, n) {
        ls.add(e, n);
      },
      translate: function(e) {
        return ls.translate(e);
      },
      setActive: function(e) {
        var n = this.activeEditor;
        this.activeEditor !== e && (n && n.fire("deactivate", { relatedTarget: e }), e.fire("activate", { relatedTarget: n })), this.activeEditor = e;
      },
      _setBaseUrl: function(e) {
        this.baseURL = new hd(this.documentBaseURL).toAbsolute(e.replace(/\/+$/, "")), this.baseURI = new hd(this.baseURL);
      }
    });
    Ap.setup();
    var cB = Math.min, d1 = Math.max, H3 = Math.round, fB = function(e, n, a) {
      var i = n.x, s = n.y, f = e.w, p = e.h, C = n.w, k = n.h, F = (a || "").split("");
      return F[0] === "b" && (s += k), F[1] === "r" && (i += C), F[0] === "c" && (s += H3(k / 2)), F[1] === "c" && (i += H3(C / 2)), F[3] === "b" && (s -= p), F[4] === "r" && (i -= f), F[3] === "c" && (s -= H3(p / 2)), F[4] === "c" && (i -= H3(f / 2)), m1(i, s, f, p);
    }, n$ = function(e, n, a, i) {
      var s, f;
      for (f = 0; f < i.length; f++)
        if (s = fB(e, n, i[f]), s.x >= a.x && s.x + s.w <= a.w + a.x && s.y >= a.y && s.y + s.h <= a.h + a.y)
          return i[f];
      return null;
    }, r$ = function(e, n, a) {
      return m1(e.x - n, e.y - a, e.w + n * 2, e.h + a * 2);
    }, a$ = function(e, n) {
      var a = d1(e.x, n.x), i = d1(e.y, n.y), s = cB(e.x + e.w, n.x + n.w), f = cB(e.y + e.h, n.y + n.h);
      return s - a < 0 || f - i < 0 ? null : m1(a, i, s - a, f - i);
    }, o$ = function(e, n, a) {
      var i = e.x, s = e.y, f = e.x + e.w, p = e.y + e.h, C = n.x + n.w, k = n.y + n.h, F = d1(0, n.x - i), q = d1(0, n.y - s), K = d1(0, f - C), te = d1(0, p - k);
      return i += F, s += q, a && (f += F, p += q, i -= K, s -= te), f -= K, p -= te, m1(i, s, f - i, p - s);
    }, m1 = function(e, n, a, i) {
      return {
        x: e,
        y: n,
        w: a,
        h: i
      };
    }, i$ = function(e) {
      return m1(e.left, e.top, e.width, e.height);
    }, u$ = {
      inflate: r$,
      relativePosition: fB,
      findBestRelativePosition: n$,
      intersect: a$,
      clamp: o$,
      create: m1,
      fromClientRect: i$
    }, s$ = function(e, n, a) {
      a === void 0 && (a = 1e3);
      var i = !1, s = null, f = function(F) {
        return function() {
          for (var q = [], K = 0; K < arguments.length; K++)
            q[K] = arguments[K];
          i || (i = !0, s !== null && (clearTimeout(s), s = null), F.apply(null, q));
        };
      }, p = f(e), C = f(n), k = function() {
        for (var F = [], q = 0; q < arguments.length; q++)
          F[q] = arguments[q];
        !i && s === null && (s = setTimeout(function() {
          return C.apply(null, F);
        }, a));
      };
      return {
        start: k,
        resolve: p,
        reject: C
      };
    }, XA = function() {
      var e = {}, n = {}, a = function(s, f) {
        var p = 'Script at URL "' + f + '" failed to load', C = 'Script at URL "' + f + "\" did not call `tinymce.Resource.add('" + s + "', data)` within 1 second";
        if (e[s] !== void 0)
          return e[s];
        var k = new Ki(function(F, q) {
          var K = s$(F, q);
          n[s] = K.resolve, uv.ScriptLoader.loadScript(f, function() {
            return K.start(C);
          }, function() {
            return K.reject(p);
          });
        });
        return e[s] = k, k;
      }, i = function(s, f) {
        n[s] !== void 0 && (n[s](f), delete n[s]), e[s] = Ki.resolve(f);
      };
      return {
        load: a,
        add: i
      };
    }, pC = XA(), Ev = Ut.each, jb = Ut.extend, V3, hC, YA = function() {
    };
    YA.extend = V3 = function(e) {
      var n = this, a = n.prototype, i = function() {
        var C, k, F, q = this;
        if (!hC && (q.init && q.init.apply(q, arguments), k = q.Mixins, k))
          for (C = k.length; C--; )
            F = k[C], F.init && F.init.apply(q, arguments);
      }, s = function() {
        return this;
      }, f = function(C, k) {
        return function() {
          var F = this, q = F._super;
          F._super = a[C];
          var K = k.apply(F, arguments);
          return F._super = q, K;
        };
      };
      hC = !0;
      var p = new n();
      return hC = !1, e.Mixins && (Ev(e.Mixins, function(C) {
        for (var k in C)
          k !== "init" && (e[k] = C[k]);
      }), a.Mixins && (e.Mixins = a.Mixins.concat(e.Mixins))), e.Methods && Ev(e.Methods.split(","), function(C) {
        e[C] = s;
      }), e.Properties && Ev(e.Properties.split(","), function(C) {
        var k = "_" + C;
        e[C] = function(F) {
          var q = this;
          return F !== void 0 ? (q[k] = F, q) : q[k];
        };
      }), e.Statics && Ev(e.Statics, function(C, k) {
        i[k] = C;
      }), e.Defaults && a.Defaults && (e.Defaults = jb({}, a.Defaults, e.Defaults)), _n(e, function(C, k) {
        typeof C == "function" && a[k] ? p[k] = f(k, C) : p[k] = C;
      }), i.prototype = p, i.constructor = i, i.extend = V3, i;
    };
    var bC = Math.min, U3 = Math.max, Op = Math.round, vB = function(e) {
      var n = {}, a = 0, i = 0, s = 0, f = function(K, te, be) {
        var we, ke, Ee;
        we = 0, ke = 0, Ee = 0, K = K / 255, te = te / 255, be = be / 255;
        var qe = bC(K, bC(te, be)), Le = U3(K, U3(te, be));
        if (qe === Le)
          return Ee = qe, {
            h: 0,
            s: 0,
            v: Ee * 100
          };
        var xt = K === qe ? te - be : be === qe ? K - te : be - K;
        return we = K === qe ? 3 : be === qe ? 1 : 5, we = 60 * (we - xt / (Le - qe)), ke = (Le - qe) / Le, Ee = Le, {
          h: Op(we),
          s: Op(ke * 100),
          v: Op(Ee * 100)
        };
      }, p = function(K, te, be) {
        if (K = (parseInt(K, 10) || 0) % 360, te = parseInt(te, 10) / 100, be = parseInt(be, 10) / 100, te = U3(0, bC(te, 1)), be = U3(0, bC(be, 1)), te === 0) {
          a = i = s = Op(255 * be);
          return;
        }
        var we = K / 60, ke = be * te, Ee = ke * (1 - Math.abs(we % 2 - 1)), qe = be - ke;
        switch (Math.floor(we)) {
          case 0:
            a = ke, i = Ee, s = 0;
            break;
          case 1:
            a = Ee, i = ke, s = 0;
            break;
          case 2:
            a = 0, i = ke, s = Ee;
            break;
          case 3:
            a = 0, i = Ee, s = ke;
            break;
          case 4:
            a = Ee, i = 0, s = ke;
            break;
          case 5:
            a = ke, i = 0, s = Ee;
            break;
          default:
            a = i = s = 0;
        }
        a = Op(255 * (a + qe)), i = Op(255 * (i + qe)), s = Op(255 * (s + qe));
      }, C = function() {
        var K = function(te) {
          return te = parseInt(te, 10).toString(16), te.length > 1 ? te : "0" + te;
        };
        return "#" + K(a) + K(i) + K(s);
      }, k = function() {
        return {
          r: a,
          g: i,
          b: s
        };
      }, F = function() {
        return f(a, i, s);
      }, q = function(K) {
        var te;
        return typeof K == "object" ? "r" in K ? (a = K.r, i = K.g, s = K.b) : "v" in K && p(K.h, K.s, K.v) : (te = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)[^\)]*\)/gi.exec(K)) ? (a = parseInt(te[1], 10), i = parseInt(te[2], 10), s = parseInt(te[3], 10)) : (te = /#([0-F]{2})([0-F]{2})([0-F]{2})/gi.exec(K)) ? (a = parseInt(te[1], 16), i = parseInt(te[2], 16), s = parseInt(te[3], 16)) : (te = /#([0-F])([0-F])([0-F])/gi.exec(K)) && (a = parseInt(te[1] + te[1], 16), i = parseInt(te[2] + te[2], 16), s = parseInt(te[3] + te[3], 16)), a = a < 0 ? 0 : a > 255 ? 255 : a, i = i < 0 ? 0 : i > 255 ? 255 : i, s = s < 0 ? 0 : s > 255 ? 255 : s, n;
      };
      return e && q(e), n.toRgb = k, n.toHsv = F, n.toHex = C, n.parse = q, n;
    }, l$ = function(e) {
      var n = JSON.stringify(e);
      return Ge(n) ? n.replace(/[\u0080-\uFFFF]/g, function(a) {
        var i = a.charCodeAt(0).toString(16);
        return "\\u" + "0000".substring(i.length) + i;
      }) : n;
    }, ZA = {
      serialize: l$,
      parse: function(e) {
        try {
          return JSON.parse(e);
        } catch {
        }
      }
    }, c$ = {
      callbacks: {},
      count: 0,
      send: function(e) {
        var n = this, a = ho.DOM, i = e.count !== void 0 ? e.count : n.count, s = "tinymce_jsonp_" + i;
        n.callbacks[i] = function(f) {
          a.remove(s), delete n.callbacks[i], e.callback(f);
        }, a.add(a.doc.body, "script", {
          id: s,
          src: e.url,
          type: "text/javascript"
        }), n.count++;
      }
    }, j3 = sr(sr({}, N3), {
      send: function(e) {
        var n, a = 0, i = function() {
          !e.async || n.readyState === 4 || a++ > 1e4 ? (e.success && a < 1e4 && n.status === 200 ? e.success.call(e.success_scope, "" + n.responseText, n, e) : e.error && e.error.call(e.error_scope, a > 1e4 ? "TIMED_OUT" : "GENERAL", n, e), n = null) : Bu.setTimeout(i, 10);
        };
        if (e.scope = e.scope || this, e.success_scope = e.success_scope || e.scope, e.error_scope = e.error_scope || e.scope, e.async = e.async !== !1, e.data = e.data || "", j3.fire("beforeInitialize", { settings: e }), n = new XMLHttpRequest(), n.overrideMimeType && n.overrideMimeType(e.content_type), n.open(e.type || (e.data ? "POST" : "GET"), e.url, e.async), e.crossDomain && (n.withCredentials = !0), e.content_type && n.setRequestHeader("Content-Type", e.content_type), e.requestheaders && Ut.each(e.requestheaders, function(s) {
          n.setRequestHeader(s.key, s.value);
        }), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n = j3.fire("beforeSend", {
          xhr: n,
          settings: e
        }).xhr, n.send(e.data), !e.async)
          return i();
        Bu.setTimeout(i, 10);
      }
    }), dB = Ut.extend, f$ = function() {
      function e(n) {
        this.settings = dB({}, n), this.count = 0;
      }
      return e.sendRPC = function(n) {
        return new e().send(n);
      }, e.prototype.send = function(n) {
        var a = n.error, i = n.success, s = dB(this.settings, n);
        s.success = function(f, p) {
          f = ZA.parse(f), typeof f > "u" && (f = { error: "JSON Parse error." }), f.error ? a.call(s.error_scope || s.scope, f.error, p) : i.call(s.success_scope || s.scope, f.result);
        }, s.error = function(f, p) {
          a && a.call(s.error_scope || s.scope, f, p);
        }, s.data = ZA.serialize({
          id: n.id || "c" + this.count++,
          method: n.method,
          params: n.params
        }), s.content_type = "application/json", j3.send(s);
      }, e;
    }(), mB = function() {
      return function() {
        var e = {}, n = [], a = {
          getItem: function(i) {
            var s = e[i];
            return s || null;
          },
          setItem: function(i, s) {
            n.push(i), e[i] = String(s);
          },
          key: function(i) {
            return n[i];
          },
          removeItem: function(i) {
            n = n.filter(function(s) {
              return s === i;
            }), delete e[i];
          },
          clear: function() {
            n = [], e = {};
          },
          length: 0
        };
        return Object.defineProperty(a, "length", {
          get: function() {
            return n.length;
          },
          configurable: !1,
          enumerable: !1
        }), a;
      }();
    }, Wb;
    try {
      var JA = "__storage_test__";
      Wb = window.localStorage, Wb.setItem(JA, JA), Wb.removeItem(JA);
    } catch {
      Wb = mB();
    }
    var v$ = Wb, d$ = {
      geom: { Rect: u$ },
      util: {
        Promise: Ki,
        Delay: Bu,
        Tools: Ut,
        VK: Br,
        URI: hd,
        Class: YA,
        EventDispatcher: P3,
        Observable: N3,
        I18n: ls,
        XHR: j3,
        JSON: ZA,
        JSONRequest: f$,
        JSONP: c$,
        LocalStorage: v$,
        Color: vB,
        ImageUploader: A6
      },
      dom: {
        EventUtils: lg,
        Sizzle: Xa,
        DomQuery: ta,
        TreeWalker: Ha,
        TextSeeker: Vy,
        DOMUtils: ho,
        ScriptLoader: uv,
        RangeUtils: _h,
        Serializer: s6,
        StyleSheetLoader: WC,
        ControlSelection: V2,
        BookmarkManager: vd,
        Selection: GO,
        Event: lg.Event
      },
      html: {
        Styles: tc,
        Entities: dl,
        Node: Fl,
        Schema: ml,
        SaxParser: rp,
        DomParser: L4,
        Writer: Zx,
        Serializer: xm
      },
      Env: br,
      AddOnManager: Ts,
      Annotator: q0,
      Formatter: O6,
      UndoManager: Df,
      EditorCommands: Ep,
      WindowManager: __,
      NotificationManager: Cv,
      EditorObservable: tB,
      Shortcuts: L3,
      Editor: z3,
      FocusManager: Ex,
      EditorManager: Ap,
      DOM: ho.DOM,
      ScriptLoader: uv.ScriptLoader,
      PluginManager: $l,
      ThemeManager: xd,
      IconManager: V4,
      Resource: pC,
      trim: Ut.trim,
      isArray: Ut.isArray,
      is: Ut.is,
      toArray: Ut.toArray,
      makeMap: Ut.makeMap,
      each: Ut.each,
      map: Ut.map,
      grep: Ut.grep,
      inArray: Ut.inArray,
      extend: Ut.extend,
      create: Ut.create,
      walk: Ut.walk,
      createNS: Ut.createNS,
      resolve: Ut.resolve,
      explode: Ut.explode,
      _addCacheSuffix: Ut._addCacheSuffix,
      isOpera: br.opera,
      isWebKit: br.webkit,
      isIE: br.ie,
      isGecko: br.gecko,
      isMac: br.mac
    }, gB = Ut.extend(Ap, d$), m$ = function(e) {
      try {
        m.exports = e;
      } catch {
      }
    }, g$ = function(e) {
      window.tinymce = e, window.tinyMCE = e;
    };
    g$(gB), m$(gB);
  })();
})(coe);
(function() {
  var m = function(t) {
    var r = typeof t;
    return t === null ? "null" : r === "object" && (Array.prototype.isPrototypeOf(t) || t.constructor && t.constructor.name === "Array") ? "array" : r === "object" && (String.prototype.isPrototypeOf(t) || t.constructor && t.constructor.name === "String") ? "string" : r;
  }, y = function(t) {
    return function(r) {
      return m(r) === t;
    };
  }, w = function(t) {
    return function(r) {
      return typeof r === t;
    };
  }, E = function(t) {
    return function(r) {
      return t === r;
    };
  }, P = y("string"), H = y("object"), X = y("array"), j = E(null), le = w("boolean"), Q = E(void 0), pe = function(t) {
    return t == null;
  }, Y = function(t) {
    return !pe(t);
  }, D = w("function"), J = w("number"), ue = function(t, r) {
    if (X(t)) {
      for (var o = 0, l = t.length; o < l; ++o)
        if (!r(t[o]))
          return !1;
      return !0;
    }
    return !1;
  }, ee = function() {
  }, Ge = function(t) {
    return function() {
      return t();
    };
  }, ze = function(t, r) {
    return function() {
      for (var o = [], l = 0; l < arguments.length; l++)
        o[l] = arguments[l];
      return t(r.apply(null, o));
    };
  }, ht = function(t, r) {
    return function(o) {
      return t(r(o));
    };
  }, ie = function(t) {
    return function() {
      return t;
    };
  }, Ze = function(t) {
    return t;
  }, De = function(t, r) {
    return t === r;
  };
  function Pt(t) {
    for (var r = [], o = 1; o < arguments.length; o++)
      r[o - 1] = arguments[o];
    return function() {
      for (var l = [], v = 0; v < arguments.length; v++)
        l[v] = arguments[v];
      var g = r.concat(l);
      return t.apply(null, g);
    };
  }
  var Ct = function(t) {
    return function(r) {
      return !t(r);
    };
  }, Be = function(t) {
    return function() {
      throw new Error(t);
    };
  }, ge = ie(!1), xe = ie(!0), _e = tinymce.util.Tools.resolve("tinymce.ThemeManager"), $ = function() {
    return $ = Object.assign || function(r) {
      for (var o, l = 1, v = arguments.length; l < v; l++) {
        o = arguments[l];
        for (var g in o)
          Object.prototype.hasOwnProperty.call(o, g) && (r[g] = o[g]);
      }
      return r;
    }, $.apply(this, arguments);
  };
  function N(t, r) {
    var o = {};
    for (var l in t)
      Object.prototype.hasOwnProperty.call(t, l) && r.indexOf(l) < 0 && (o[l] = t[l]);
    if (t != null && typeof Object.getOwnPropertySymbols == "function")
      for (var v = 0, l = Object.getOwnPropertySymbols(t); v < l.length; v++)
        r.indexOf(l[v]) < 0 && Object.prototype.propertyIsEnumerable.call(t, l[v]) && (o[l[v]] = t[l[v]]);
    return o;
  }
  function ae(t, r, o) {
    if (o || arguments.length === 2)
      for (var l = 0, v = r.length, g; l < v; l++)
        (g || !(l in r)) && (g || (g = Array.prototype.slice.call(r, 0, l)), g[l] = r[l]);
    return t.concat(g || Array.prototype.slice.call(r));
  }
  var ce = function() {
    return ne;
  }, ne = function() {
    var t = function(l) {
      return l();
    }, r = Ze, o = {
      fold: function(l, v) {
        return l();
      },
      isSome: ge,
      isNone: xe,
      getOr: r,
      getOrThunk: t,
      getOrDie: function(l) {
        throw new Error(l || "error: getOrDie called on none.");
      },
      getOrNull: ie(null),
      getOrUndefined: ie(void 0),
      or: r,
      orThunk: t,
      map: ce,
      each: ee,
      bind: ce,
      exists: ge,
      forall: xe,
      filter: function() {
        return ce();
      },
      toArray: function() {
        return [];
      },
      toString: ie("none()")
    };
    return o;
  }(), Ce = function(t) {
    var r = ie(t), o = function() {
      return v;
    }, l = function(g) {
      return g(t);
    }, v = {
      fold: function(g, b) {
        return b(t);
      },
      isSome: xe,
      isNone: ge,
      getOr: r,
      getOrThunk: r,
      getOrDie: r,
      getOrNull: r,
      getOrUndefined: r,
      or: o,
      orThunk: o,
      map: function(g) {
        return Ce(g(t));
      },
      each: function(g) {
        g(t);
      },
      bind: l,
      exists: l,
      forall: l,
      filter: function(g) {
        return g(t) ? v : ne;
      },
      toArray: function() {
        return [t];
      },
      toString: function() {
        return "some(" + t + ")";
      }
    };
    return v;
  }, Te = function(t) {
    return t == null ? ne : Ce(t);
  }, _ = {
    some: Ce,
    none: ce,
    from: Te
  }, je = Array.prototype.slice, Me = Array.prototype.indexOf, Je = Array.prototype.push, Lt = function(t, r) {
    return Me.call(t, r);
  }, dt = function(t, r) {
    var o = Lt(t, r);
    return o === -1 ? _.none() : _.some(o);
  }, Tt = function(t, r) {
    return Lt(t, r) > -1;
  }, Jt = function(t, r) {
    for (var o = 0, l = t.length; o < l; o++) {
      var v = t[o];
      if (r(v, o))
        return !0;
    }
    return !1;
  }, se = function(t, r) {
    for (var o = [], l = 0; l < t; l++)
      o.push(r(l));
    return o;
  }, tr = function(t, r) {
    for (var o = [], l = 0; l < t.length; l += r) {
      var v = je.call(t, l, l + r);
      o.push(v);
    }
    return o;
  }, _t = function(t, r) {
    for (var o = t.length, l = new Array(o), v = 0; v < o; v++) {
      var g = t[v];
      l[v] = r(g, v);
    }
    return l;
  }, Pe = function(t, r) {
    for (var o = 0, l = t.length; o < l; o++) {
      var v = t[o];
      r(v, o);
    }
  }, kt = function(t, r) {
    for (var o = t.length - 1; o >= 0; o--) {
      var l = t[o];
      r(l, o);
    }
  }, He = function(t, r) {
    for (var o = [], l = [], v = 0, g = t.length; v < g; v++) {
      var b = t[v], T = r(b, v) ? o : l;
      T.push(b);
    }
    return {
      pass: o,
      fail: l
    };
  }, We = function(t, r) {
    for (var o = [], l = 0, v = t.length; l < v; l++) {
      var g = t[l];
      r(g, l) && o.push(g);
    }
    return o;
  }, Ae = function(t, r, o) {
    return kt(t, function(l, v) {
      o = r(o, l, v);
    }), o;
  }, Ke = function(t, r, o) {
    return Pe(t, function(l, v) {
      o = r(o, l, v);
    }), o;
  }, at = function(t, r, o) {
    for (var l = 0, v = t.length; l < v; l++) {
      var g = t[l];
      if (r(g, l))
        return _.some(g);
      if (o(g, l))
        break;
    }
    return _.none();
  }, pt = function(t, r) {
    return at(t, r, ge);
  }, sn = function(t, r) {
    for (var o = 0, l = t.length; o < l; o++) {
      var v = t[o];
      if (r(v, o))
        return _.some(o);
    }
    return _.none();
  }, Ie = function(t) {
    for (var r = [], o = 0, l = t.length; o < l; ++o) {
      if (!X(t[o]))
        throw new Error("Arr.flatten item " + o + " was not an array, input: " + t);
      Je.apply(r, t[o]);
    }
    return r;
  }, St = function(t, r) {
    return Ie(_t(t, r));
  }, Xe = function(t, r) {
    for (var o = 0, l = t.length; o < l; ++o) {
      var v = t[o];
      if (r(v, o) !== !0)
        return !1;
    }
    return !0;
  }, he = function(t) {
    var r = je.call(t, 0);
    return r.reverse(), r;
  }, tt = function(t, r) {
    return We(t, function(o) {
      return !Tt(r, o);
    });
  }, gt = function(t, r) {
    for (var o = {}, l = 0, v = t.length; l < v; l++) {
      var g = t[l];
      o[String(g)] = r(g, l);
    }
    return o;
  }, Ye = function(t) {
    return [t];
  }, Qt = function(t, r) {
    var o = je.call(t, 0);
    return o.sort(r), o;
  }, In = function(t, r) {
    return r >= 0 && r < t.length ? _.some(t[r]) : _.none();
  }, It = function(t) {
    return In(t, 0);
  }, qt = function(t) {
    return In(t, t.length - 1);
  }, Vt = D(Array.from) ? Array.from : function(t) {
    return je.call(t);
  }, Xt = function(t, r) {
    for (var o = 0; o < t.length; o++) {
      var l = r(t[o], o);
      if (l.isSome())
        return l;
    }
    return _.none();
  }, on = Object.keys, Vn = Object.hasOwnProperty, Un = function(t, r) {
    for (var o = on(t), l = 0, v = o.length; l < v; l++) {
      var g = o[l], b = t[g];
      r(b, g);
    }
  }, Tn = function(t, r) {
    return yt(t, function(o, l) {
      return {
        k: l,
        v: r(o, l)
      };
    });
  }, yt = function(t, r) {
    var o = {};
    return Un(t, function(l, v) {
      var g = r(l, v);
      o[g.k] = g.v;
    }), o;
  }, mn = function(t) {
    return function(r, o) {
      t[o] = r;
    };
  }, zn = function(t, r, o, l) {
    var v = {};
    return Un(t, function(g, b) {
      (r(g, b) ? o : l)(g, b);
    }), v;
  }, _n = function(t, r) {
    var o = {};
    return zn(t, r, mn(o), ee), o;
  }, Kr = function(t, r) {
    var o = [];
    return Un(t, function(l, v) {
      o.push(r(l, v));
    }), o;
  }, ot = function(t, r) {
    for (var o = on(t), l = 0, v = o.length; l < v; l++) {
      var g = o[l], b = t[g];
      if (r(b, g, t))
        return _.some(b);
    }
    return _.none();
  }, Yt = function(t) {
    return Kr(t, Ze);
  }, Ft = function(t, r) {
    return yn(t, r) ? _.from(t[r]) : _.none();
  }, yn = function(t, r) {
    return Vn.call(t, r);
  }, Yn = function(t, r) {
    return yn(t, r) && t[r] !== void 0 && t[r] !== null;
  }, Ir = function(t, r, o) {
    return o === void 0 && (o = De), t.exists(function(l) {
      return o(l, r);
    });
  }, Wa = function(t, r, o) {
    return o === void 0 && (o = De), Va(t, r, o).getOr(t.isNone() && r.isNone());
  }, Mr = function(t) {
    for (var r = [], o = function(v) {
      r.push(v);
    }, l = 0; l < t.length; l++)
      t[l].each(o);
    return r;
  }, Fr = function(t) {
    for (var r = [], o = 0; o < t.length; o++) {
      var l = t[o];
      if (l.isSome())
        r.push(l.getOrDie());
      else
        return _.none();
    }
    return _.some(r);
  }, Va = function(t, r, o) {
    return t.isSome() && r.isSome() ? _.some(o(t.getOrDie(), r.getOrDie())) : _.none();
  }, Qo = function(t, r, o, l) {
    return t.isSome() && r.isSome() && o.isSome() ? _.some(l(t.getOrDie(), r.getOrDie(), o.getOrDie())) : _.none();
  }, Go = function(t, r) {
    return t != null ? _.some(r(t)) : _.none();
  }, so = function(t, r) {
    return t ? _.some(r) : _.none();
  }, bo = function(t, r) {
    return t + r;
  }, mi = function(t, r) {
    return t.substring(r);
  }, Ao = function(t, r, o) {
    return r === "" || t.length >= r.length && t.substr(o, o + r.length) === r;
  }, go = function(t, r) {
    return ei(t, r) ? mi(t, r.length) : t;
  }, gi = function(t, r) {
    return sr(t, r) ? t : bo(t, r);
  }, na = function(t, r) {
    return t.indexOf(r) !== -1;
  }, ei = function(t, r) {
    return Ao(t, r, 0);
  }, sr = function(t, r) {
    return Ao(t, r, t.length - r.length);
  }, $u = function(t) {
    return function(r) {
      return r.replace(t, "");
    };
  }, Ko = $u(/^\s+|\s+$/g), pi = function(t) {
    return t.length > 0;
  }, Po = function(t) {
    return !pi(t);
  }, Si = function(t) {
    return t.style !== void 0 && D(t.style.getPropertyValue);
  }, Su = function(t, r) {
    var o = r || document, l = o.createElement("div");
    if (l.innerHTML = t, !l.hasChildNodes() || l.childNodes.length > 1)
      throw console.error("HTML does not have a single root node", t), new Error("HTML must have a single root node");
    return Lo(l.childNodes[0]);
  }, xi = function(t, r) {
    var o = r || document, l = o.createElement(t);
    return Lo(l);
  }, Ju = function(t, r) {
    var o = r || document, l = o.createTextNode(t);
    return Lo(l);
  }, Lo = function(t) {
    if (t == null)
      throw new Error("Node cannot be null or undefined");
    return { dom: t };
  }, yo = function(t, r, o) {
    return _.from(t.dom.elementFromPoint(r, o)).map(Lo);
  }, Bn = {
    fromHtml: Su,
    fromTag: xi,
    fromText: Ju,
    fromDom: Lo,
    fromPoint: yo
  };
  typeof window < "u" || Function("return this;")();
  var xu = 9, ku = 11, Tu = 1, Ue = 3, et = function(t) {
    var r = t.dom.nodeName;
    return r.toLowerCase();
  }, en = function(t) {
    return t.dom.nodeType;
  }, gn = function(t) {
    return function(r) {
      return en(r) === t;
    };
  }, Z = gn(Tu), ye = gn(Ue), Ve = gn(xu), lt = gn(ku), Et = function(t) {
    var r = !1, o;
    return function() {
      for (var l = [], v = 0; v < arguments.length; v++)
        l[v] = arguments[v];
      return r || (r = !0, o = t.apply(null, l)), o;
    };
  }, Ot = function(t, r, o, l) {
    var v = t.isiOS() && /ipad/i.test(o) === !0, g = t.isiOS() && !v, b = t.isiOS() || t.isAndroid(), T = b || l("(pointer:coarse)"), A = v || !g && b && l("(min-device-width:768px)"), R = g || b && !A, z = r.isSafari() && t.isiOS() && /safari/i.test(o) === !1, U = !R && !A && !z;
    return {
      isiPad: ie(v),
      isiPhone: ie(g),
      isTablet: ie(A),
      isPhone: ie(R),
      isTouch: ie(T),
      isAndroid: t.isAndroid,
      isiOS: t.isiOS,
      isWebView: ie(z),
      isDesktop: ie(U)
    };
  }, Rn = function(t, r) {
    for (var o = 0; o < t.length; o++) {
      var l = t[o];
      if (l.test(r))
        return l;
    }
  }, er = function(t, r) {
    var o = Rn(t, r);
    if (!o)
      return {
        major: 0,
        minor: 0
      };
    var l = function(v) {
      return Number(r.replace(o, "$" + v));
    };
    return vr(l(1), l(2));
  }, Rr = function(t, r) {
    var o = String(r).toLowerCase();
    return t.length === 0 ? Nt() : er(t, o);
  }, Nt = function() {
    return vr(0, 0);
  }, vr = function(t, r) {
    return {
      major: t,
      minor: r
    };
  }, Nr = {
    nu: vr,
    detect: Rr,
    unknown: Nt
  }, Sa = function(t, r) {
    return Xt(r.brands, function(o) {
      var l = o.brand.toLowerCase();
      return pt(t, function(v) {
        var g;
        return l === ((g = v.brand) === null || g === void 0 ? void 0 : g.toLowerCase());
      }).map(function(v) {
        return {
          current: v.name,
          version: Nr.nu(parseInt(o.version, 10), 0)
        };
      });
    });
  }, po = function(t, r) {
    var o = String(r).toLowerCase();
    return pt(t, function(l) {
      return l.search(o);
    });
  }, Xr = function(t, r) {
    return po(t, r).map(function(o) {
      var l = Nr.detect(o.versionRegexes, r);
      return {
        current: o.name,
        version: l
      };
    });
  }, Lu = function(t, r) {
    return po(t, r).map(function(o) {
      var l = Nr.detect(o.versionRegexes, r);
      return {
        current: o.name,
        version: l
      };
    });
  }, Eu = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/, vo = function(t) {
    return function(r) {
      return na(r, t);
    };
  }, Fs = [
    {
      name: "Edge",
      versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
      search: function(t) {
        return na(t, "edge/") && na(t, "chrome") && na(t, "safari") && na(t, "applewebkit");
      }
    },
    {
      name: "Chrome",
      brand: "Chromium",
      versionRegexes: [
        /.*?chrome\/([0-9]+)\.([0-9]+).*/,
        Eu
      ],
      search: function(t) {
        return na(t, "chrome") && !na(t, "chromeframe");
      }
    },
    {
      name: "IE",
      versionRegexes: [
        /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
        /.*?rv:([0-9]+)\.([0-9]+).*/
      ],
      search: function(t) {
        return na(t, "msie") || na(t, "trident");
      }
    },
    {
      name: "Opera",
      versionRegexes: [
        Eu,
        /.*?opera\/([0-9]+)\.([0-9]+).*/
      ],
      search: vo("opera")
    },
    {
      name: "Firefox",
      versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
      search: vo("firefox")
    },
    {
      name: "Safari",
      versionRegexes: [
        Eu,
        /.*?cpu os ([0-9]+)_([0-9]+).*/
      ],
      search: function(t) {
        return (na(t, "safari") || na(t, "mobile/")) && na(t, "applewebkit");
      }
    }
  ], ki = [
    {
      name: "Windows",
      search: vo("win"),
      versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
    },
    {
      name: "iOS",
      search: function(t) {
        return na(t, "iphone") || na(t, "ipad");
      },
      versionRegexes: [
        /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
        /.*cpu os ([0-9]+)_([0-9]+).*/,
        /.*cpu iphone os ([0-9]+)_([0-9]+).*/
      ]
    },
    {
      name: "Android",
      search: vo("android"),
      versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
    },
    {
      name: "OSX",
      search: vo("mac os x"),
      versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
    },
    {
      name: "Linux",
      search: vo("linux"),
      versionRegexes: []
    },
    {
      name: "Solaris",
      search: vo("sunos"),
      versionRegexes: []
    },
    {
      name: "FreeBSD",
      search: vo("freebsd"),
      versionRegexes: []
    },
    {
      name: "ChromeOS",
      search: vo("cros"),
      versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
    }
  ], Fi = {
    browsers: ie(Fs),
    oses: ie(ki)
  }, za = "Edge", $s = "Chrome", Qu = "IE", hs = "Opera", rl = "Firefox", $i = "Safari", au = function() {
    return al({
      current: void 0,
      version: Nr.unknown()
    });
  }, al = function(t) {
    var r = t.current, o = t.version, l = function(v) {
      return function() {
        return r === v;
      };
    };
    return {
      current: r,
      version: o,
      isEdge: l(za),
      isChrome: l($s),
      isIE: l(Qu),
      isOpera: l(hs),
      isFirefox: l(rl),
      isSafari: l($i)
    };
  }, qi = {
    unknown: au,
    nu: al,
    edge: ie(za),
    chrome: ie($s),
    ie: ie(Qu),
    opera: ie(hs),
    firefox: ie(rl),
    safari: ie($i)
  }, Li = "Windows", ve = "iOS", nt = "Android", wt = "Linux", Zt = "OSX", En = "Solaris", lr = "FreeBSD", ya = "ChromeOS", Aa = function() {
    return Yr({
      current: void 0,
      version: Nr.unknown()
    });
  }, Yr = function(t) {
    var r = t.current, o = t.version, l = function(v) {
      return function() {
        return r === v;
      };
    };
    return {
      current: r,
      version: o,
      isWindows: l(Li),
      isiOS: l(ve),
      isAndroid: l(nt),
      isOSX: l(Zt),
      isLinux: l(wt),
      isSolaris: l(En),
      isFreeBSD: l(lr),
      isChromeOS: l(ya)
    };
  }, qa = {
    unknown: Aa,
    nu: Yr,
    windows: ie(Li),
    ios: ie(ve),
    android: ie(nt),
    linux: ie(wt),
    osx: ie(Zt),
    solaris: ie(En),
    freebsd: ie(lr),
    chromeos: ie(ya)
  }, ao = function(t, r, o) {
    var l = Fi.browsers(), v = Fi.oses(), g = r.bind(function(A) {
      return Sa(l, A);
    }).orThunk(function() {
      return Xr(l, t);
    }).fold(qi.unknown, qi.nu), b = Lu(v, t).fold(qa.unknown, qa.nu), T = Ot(b, g, t, o);
    return {
      browser: g,
      os: b,
      deviceType: T
    };
  }, es = { detect: ao }, ti = function(t) {
    return window.matchMedia(t).matches;
  }, zu = Et(function() {
    return es.detect(navigator.userAgent, _.from(navigator.userAgentData), ti);
  }), br = function() {
    return zu();
  }, bs = function(t, r, o) {
    return (t.compareDocumentPosition(r) & o) !== 0;
  }, yc = function(t, r) {
    return bs(t, r, Node.DOCUMENT_POSITION_CONTAINED_BY);
  }, va = function(t, r) {
    var o = t.dom;
    if (o.nodeType !== Tu)
      return !1;
    var l = o;
    if (l.matches !== void 0)
      return l.matches(r);
    if (l.msMatchesSelector !== void 0)
      return l.msMatchesSelector(r);
    if (l.webkitMatchesSelector !== void 0)
      return l.webkitMatchesSelector(r);
    if (l.mozMatchesSelector !== void 0)
      return l.mozMatchesSelector(r);
    throw new Error("Browser lacks native selectors");
  }, Wl = function(t) {
    return t.nodeType !== Tu && t.nodeType !== xu && t.nodeType !== ku || t.childElementCount === 0;
  }, ql = function(t, r) {
    var o = r === void 0 ? document : r.dom;
    return Wl(o) ? [] : _t(o.querySelectorAll(t), Bn.fromDom);
  }, Yc = function(t, r) {
    var o = r === void 0 ? document : r.dom;
    return Wl(o) ? _.none() : _.from(o.querySelector(t)).map(Bn.fromDom);
  }, Fa = function(t, r) {
    return t.dom === r.dom;
  }, ou = function(t, r) {
    var o = t.dom, l = r.dom;
    return o === l ? !1 : o.contains(l);
  }, Vf = function(t, r) {
    return yc(t.dom, r.dom);
  }, _u = function(t, r) {
    return br().browser.isIE() ? Vf(t, r) : ou(t, r);
  }, wo = function(t) {
    return Bn.fromDom(t.dom.ownerDocument);
  }, Ls = function(t) {
    return Ve(t) ? t : wo(t);
  }, Ut = function(t) {
    return Bn.fromDom(Ls(t).dom.documentElement);
  }, ol = function(t) {
    return Bn.fromDom(Ls(t).dom.defaultView);
  }, Co = function(t) {
    return _.from(t.dom.parentNode).map(Bn.fromDom);
  }, wc = function(t) {
    return Co(t);
  }, ys = function(t) {
    return _.from(t.dom.offsetParent).map(Bn.fromDom);
  }, V = function(t) {
    return _.from(t.dom.nextSibling).map(Bn.fromDom);
  }, O = function(t) {
    return _t(t.dom.childNodes, Bn.fromDom);
  }, x = function(t, r) {
    var o = t.dom.childNodes;
    return _.from(o[r]).map(Bn.fromDom);
  }, I = function(t) {
    return x(t, 0);
  }, re = function(t, r) {
    return {
      element: t,
      offset: r
    };
  }, Oe = function(t, r) {
    var o = O(t);
    return o.length > 0 && r < o.length ? re(o[r], 0) : re(t, r);
  }, vt = function(t) {
    return lt(t) && Y(t.dom.host);
  }, rn = D(Element.prototype.attachShadow) && D(Node.prototype.getRootNode), or = ie(rn), wr = rn ? function(t) {
    return Bn.fromDom(t.dom.getRootNode());
  } : Ls, Nn = function(t) {
    return vt(t) ? t : Bn.fromDom(Ls(t).dom.body);
  }, nr = function(t) {
    return jr(t).isSome();
  }, jr = function(t) {
    var r = wr(t);
    return vt(r) ? _.some(r) : _.none();
  }, Vr = function(t) {
    return Bn.fromDom(t.dom.host);
  }, Dr = function(t) {
    if (or() && Y(t.target)) {
      var r = Bn.fromDom(t.target);
      if (Z(r) && Qa(r) && t.composed && t.composedPath) {
        var o = t.composedPath();
        if (o)
          return It(o);
      }
    }
    return _.from(t.target);
  }, Qa = function(t) {
    return Y(t.dom.shadowRoot);
  }, Tr = function(t) {
    var r = ye(t) ? t.dom.parentNode : t.dom;
    if (r == null || r.ownerDocument === null)
      return !1;
    var o = r.ownerDocument;
    return jr(Bn.fromDom(r)).fold(function() {
      return o.body.contains(r);
    }, ht(Tr, Vr));
  }, $a = function() {
    return Oa(Bn.fromDom(document));
  }, Oa = function(t) {
    var r = t.dom.body;
    if (r == null)
      throw new Error("Body is not available yet");
    return Bn.fromDom(r);
  }, Ti = function(t, r, o) {
    if (P(o) || le(o) || J(o))
      t.setAttribute(r, o + "");
    else
      throw console.error("Invalid call to Attribute.set. Key ", r, ":: Value ", o, ":: Element ", t), new Error("Attribute value was not simple");
  }, Qr = function(t, r, o) {
    Ti(t.dom, r, o);
  }, zs = function(t, r) {
    var o = t.dom;
    Un(r, function(l, v) {
      Ti(o, v, l);
    });
  }, So = function(t, r) {
    var o = t.dom.getAttribute(r);
    return o === null ? void 0 : o;
  }, No = function(t, r) {
    return _.from(So(t, r));
  }, w1 = function(t, r) {
    var o = t.dom;
    return o && o.hasAttribute ? o.hasAttribute(r) : !1;
  }, Gi = function(t, r) {
    t.dom.removeAttribute(r);
  }, Ip = function(t, r, o) {
    if (!P(o))
      throw console.error("Invalid call to CSS.set. Property ", r, ":: Value ", o, ":: Element ", t), new Error("CSS value must be a string: " + o);
    Si(t) && t.style.setProperty(r, o);
  }, Gl = function(t, r) {
    Si(t) && t.style.removeProperty(r);
  }, Pr = function(t, r, o) {
    var l = t.dom;
    Ip(l, r, o);
  }, Hs = function(t, r) {
    var o = t.dom;
    Un(r, function(l, v) {
      Ip(o, v, l);
    });
  }, zo = function(t, r) {
    var o = t.dom;
    Un(r, function(l, v) {
      l.fold(function() {
        Gl(o, v);
      }, function(g) {
        Ip(o, v, g);
      });
    });
  }, Ho = function(t, r) {
    var o = t.dom, l = window.getComputedStyle(o), v = l.getPropertyValue(r);
    return v === "" && !Tr(t) ? Ei(o, r) : v;
  }, Ei = function(t, r) {
    return Si(t) ? t.style.getPropertyValue(r) : "";
  }, ui = function(t, r) {
    var o = t.dom, l = Ei(o, r);
    return _.from(l).filter(function(v) {
      return v.length > 0;
    });
  }, Uf = function(t) {
    var r = {}, o = t.dom;
    if (Si(o))
      for (var l = 0; l < o.style.length; l++) {
        var v = o.style.item(l);
        r[v] = o.style[v];
      }
    return r;
  }, il = function(t, r, o) {
    var l = Bn.fromTag(t);
    Pr(l, r, o);
    var v = ui(l, r);
    return v.isSome();
  }, Da = function(t, r) {
    var o = t.dom;
    Gl(o, r), Ir(No(t, "style").map(Ko), "") && Gi(t, "style");
  }, mo = function(t) {
    return t.dom.offsetWidth;
  }, Hu = function(t, r) {
    var o = function(T, A) {
      if (!J(A) && !A.match(/^[0-9]+$/))
        throw new Error(t + ".set accepts only positive integer values. Value was " + A);
      var R = T.dom;
      Si(R) && (R.style[t] = A + "px");
    }, l = function(T) {
      var A = r(T);
      if (A <= 0 || A === null) {
        var R = Ho(T, t);
        return parseFloat(R) || 0;
      }
      return A;
    }, v = l, g = function(T, A) {
      return Ke(A, function(R, z) {
        var U = Ho(T, z), oe = U === void 0 ? 0 : parseInt(U, 10);
        return isNaN(oe) ? R : R + oe;
      }, 0);
    }, b = function(T, A, R) {
      var z = g(T, R), U = A > z ? A - z : 0;
      return U;
    };
    return {
      set: o,
      get: l,
      getOuter: v,
      aggregate: g,
      max: b
    };
  }, Cc = Hu("height", function(t) {
    var r = t.dom;
    return Tr(t) ? r.getBoundingClientRect().height : r.offsetHeight;
  }), hi = function(t) {
    return Cc.get(t);
  }, Vs = function(t) {
    return Cc.getOuter(t);
  }, C1 = function(t, r) {
    var o = [
      "margin-top",
      "border-top-width",
      "padding-top",
      "padding-bottom",
      "border-bottom-width",
      "margin-bottom"
    ], l = Cc.max(t, r, o);
    Pr(t, "max-height", l + "px");
  }, jf = function(t, r) {
    var o = function(l, v) {
      return jf(t + l, r + v);
    };
    return {
      left: t,
      top: r,
      translate: o
    };
  }, eo = jf, El = function(t) {
    var r = t.getBoundingClientRect();
    return eo(r.left, r.top);
  }, Zc = function(t, r) {
    return t !== void 0 ? t : r !== void 0 ? r : 0;
  }, ts = function(t) {
    var r = t.dom.ownerDocument, o = r.body, l = r.defaultView, v = r.documentElement;
    if (o === t.dom)
      return eo(o.offsetLeft, o.offsetTop);
    var g = Zc(l == null ? void 0 : l.pageYOffset, v.scrollTop), b = Zc(l == null ? void 0 : l.pageXOffset, v.scrollLeft), T = Zc(v.clientTop, o.clientTop), A = Zc(v.clientLeft, o.clientLeft);
    return Xo(t).translate(b - A, g - T);
  }, Xo = function(t) {
    var r = t.dom, o = r.ownerDocument, l = o.body;
    return l === r ? eo(l.offsetLeft, l.offsetTop) : Tr(t) ? El(r) : eo(0, 0);
  }, Jc = Hu("width", function(t) {
    return t.dom.offsetWidth;
  }), Sc = function(t, r) {
    return Jc.set(t, r);
  }, Au = function(t) {
    return Jc.get(t);
  }, ns = function(t) {
    return Jc.getOuter(t);
  }, iu = function(t, r) {
    var o = [
      "margin-left",
      "border-left-width",
      "padding-left",
      "padding-right",
      "border-right-width",
      "margin-right"
    ], l = Jc.max(t, r, o);
    Pr(t, "max-width", l + "px");
  }, Nv = function(t, r, o, l, v, g, b) {
    return {
      target: t,
      x: r,
      y: o,
      stop: l,
      prevent: v,
      kill: g,
      raw: b
    };
  }, _l = function(t) {
    var r = Bn.fromDom(Dr(t).getOr(t.target)), o = function() {
      return t.stopPropagation();
    }, l = function() {
      return t.preventDefault();
    }, v = ze(l, o);
    return Nv(r, t.clientX, t.clientY, o, l, v, t);
  }, _i = function(t, r) {
    return function(o) {
      t(o) && r(_l(o));
    };
  }, Pd = function(t, r, o, l, v) {
    var g = _i(o, l);
    return t.dom.addEventListener(r, g, v), { unbind: Pt(qf, t, r, g, v) };
  }, S1 = function(t, r, o, l) {
    return Pd(t, r, o, l, !1);
  }, Wf = function(t, r, o, l) {
    return Pd(t, r, o, l, !0);
  }, qf = function(t, r, o, l) {
    t.dom.removeEventListener(r, o, l);
  }, Yo = function(t, r) {
    var o = Co(t);
    o.each(function(l) {
      l.dom.insertBefore(r.dom, t.dom);
    });
  }, Gf = function(t, r) {
    var o = V(t);
    o.fold(function() {
      var l = Co(t);
      l.each(function(v) {
        Ou(v, r);
      });
    }, function(l) {
      Yo(l, r);
    });
  }, Kf = function(t, r) {
    var o = I(t);
    o.fold(function() {
      Ou(t, r);
    }, function(l) {
      t.dom.insertBefore(r.dom, l.dom);
    });
  }, Ou = function(t, r) {
    t.dom.appendChild(r.dom);
  }, xc = function(t, r, o) {
    x(t, o).fold(function() {
      Ou(t, r);
    }, function(l) {
      Yo(l, r);
    });
  }, Xf = function(t, r) {
    Pe(r, function(o) {
      Yo(t, o);
    });
  }, kc = function(t, r) {
    Pe(r, function(o) {
      Ou(t, o);
    });
  }, Oo = function(t) {
    t.dom.textContent = "", Pe(O(t), function(r) {
      ws(r);
    });
  }, ws = function(t) {
    var r = t.dom;
    r.parentNode !== null && r.parentNode.removeChild(r);
  }, Wm = function(t) {
    var r = O(t);
    r.length > 0 && Xf(t, r), ws(t);
  }, Us = function(t) {
    var r = t !== void 0 ? t.dom : document, o = r.body.scrollLeft || r.documentElement.scrollLeft, l = r.body.scrollTop || r.documentElement.scrollTop;
    return eo(o, l);
  }, qm = function(t, r, o) {
    var l = o !== void 0 ? o.dom : document, v = l.defaultView;
    v && v.scrollTo(t, r);
  }, x1 = function(t) {
    var r = t === void 0 ? window : t;
    return br().browser.isFirefox() ? _.none() : _.from(r.visualViewport);
  }, Fp = function(t, r, o, l) {
    return {
      x: t,
      y: r,
      width: o,
      height: l,
      right: t + o,
      bottom: r + l
    };
  }, Yf = function(t) {
    var r = t === void 0 ? window : t, o = r.document, l = Us(Bn.fromDom(o));
    return x1(r).fold(function() {
      var v = r.document.documentElement, g = v.clientWidth, b = v.clientHeight;
      return Fp(l.left, l.top, g, b);
    }, function(v) {
      return Fp(Math.max(v.pageLeft, l.left), Math.max(v.pageTop, l.top), v.width, v.height);
    });
  }, Zf = function(t, r) {
    var o = t.view(r);
    return o.fold(ie([]), function(l) {
      var v = t.owner(l), g = Zf(t, v);
      return [l].concat(g);
    });
  }, Qc = function(t, r) {
    var o = r.owner(t), l = Zf(r, o);
    return _.some(l);
  }, $r = function(t) {
    var r, o = t.dom === document ? _.none() : _.from((r = t.dom.defaultView) === null || r === void 0 ? void 0 : r.frameElement);
    return o.map(Bn.fromDom);
  }, ul = function(t) {
    return wo(t);
  }, rs = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    view: $r,
    owner: ul
  }), Du = function(t) {
    var r = Bn.fromDom(document), o = Us(r), l = Qc(t, rs);
    return l.fold(Pt(ts, t), function(v) {
      var g = Xo(t), b = Ae(v, function(T, A) {
        var R = Xo(A);
        return {
          left: T.left + R.left,
          top: T.top + R.top
        };
      }, {
        left: 0,
        top: 0
      });
      return eo(b.left + g.left + o.left, b.top + g.top + o.top);
    });
  }, sl = function(t, r, o) {
    return {
      point: t,
      width: r,
      height: o
    };
  }, ni = function(t, r, o, l) {
    return {
      x: t,
      y: r,
      width: o,
      height: l
    };
  }, Ai = function(t, r, o, l) {
    return {
      x: t,
      y: r,
      width: o,
      height: l,
      right: t + o,
      bottom: r + l
    };
  }, si = function(t) {
    var r = ts(t), o = ns(t), l = Vs(t);
    return Ai(r.left, r.top, o, l);
  }, ef = function(t) {
    var r = Du(t), o = ns(t), l = Vs(t);
    return Ai(r.left, r.top, o, l);
  }, uu = function() {
    return Yf(window);
  }, Qn = function(t) {
    var r = function(U) {
      return Qn(t);
    }, o = function(U) {
      return Qn(t);
    }, l = function(U) {
      return Qn(U(t));
    }, v = function(U) {
      return Qn(t);
    }, g = function(U) {
      U(t);
    }, b = function(U) {
      return U(t);
    }, T = function(U, oe) {
      return oe(t);
    }, A = function(U) {
      return U(t);
    }, R = function(U) {
      return U(t);
    }, z = function() {
      return _.some(t);
    };
    return {
      isValue: xe,
      isError: ge,
      getOr: ie(t),
      getOrThunk: ie(t),
      getOrDie: ie(t),
      or: r,
      orThunk: o,
      fold: T,
      map: l,
      mapError: v,
      each: g,
      bind: b,
      exists: A,
      forall: R,
      toOptional: z
    };
  }, Jf = function(t) {
    var r = function(R) {
      return R();
    }, o = function() {
      return Be(String(t))();
    }, l = Ze, v = function(R) {
      return R();
    }, g = function(R) {
      return Jf(t);
    }, b = function(R) {
      return Jf(R(t));
    }, T = function(R) {
      return Jf(t);
    }, A = function(R, z) {
      return R(t);
    };
    return {
      isValue: ge,
      isError: xe,
      getOr: Ze,
      getOrThunk: r,
      getOrDie: o,
      or: l,
      orThunk: v,
      fold: A,
      map: g,
      mapError: b,
      each: ee,
      bind: T,
      exists: ge,
      forall: xe,
      toOptional: _.none
    };
  }, $p = function(t, r) {
    return t.fold(function() {
      return Jf(r);
    }, Qn);
  }, ea = {
    value: Qn,
    error: Jf,
    fromOption: $p
  }, to;
  (function(t) {
    t[t.Error = 0] = "Error", t[t.Value = 1] = "Value";
  })(to || (to = {}));
  var Gm = function(t, r, o) {
    return t.stype === to.Error ? r(t.serror) : o(t.svalue);
  }, Kl = function(t) {
    var r = [], o = [];
    return Pe(t, function(l) {
      Gm(l, function(v) {
        return o.push(v);
      }, function(v) {
        return r.push(v);
      });
    }), {
      values: r,
      errors: o
    };
  }, xo = function(t, r) {
    return t.stype === to.Error ? {
      stype: to.Error,
      serror: r(t.serror)
    } : t;
  }, Km = function(t, r) {
    return t.stype === to.Value ? {
      stype: to.Value,
      svalue: r(t.svalue)
    } : t;
  }, Cs = function(t, r) {
    return t.stype === to.Value ? r(t.svalue) : t;
  }, Nd = function(t, r) {
    return t.stype === to.Error ? r(t.serror) : t;
  }, ra = function(t) {
    return {
      stype: to.Value,
      svalue: t
    };
  }, Vu = function(t) {
    return {
      stype: to.Error,
      serror: t
    };
  }, ty = function(t) {
    return Gm(t, ea.error, ea.value);
  }, ny = function(t) {
    return t.fold(Vu, ra);
  }, Do = {
    fromResult: ny,
    toResult: ty,
    svalue: ra,
    partition: Kl,
    serror: Vu,
    bind: Cs,
    bindError: Nd,
    map: Km,
    mapError: xo,
    fold: Gm
  }, Xm = function(t, r, o, l) {
    return {
      tag: "field",
      key: t,
      newKey: r,
      presence: o,
      prop: l
    };
  }, M = function(t, r) {
    return {
      tag: "custom",
      newKey: t,
      instantiator: r
    };
  }, G = function(t, r, o) {
    switch (t.tag) {
      case "field":
        return r(t.key, t.newKey, t.presence, t.prop);
      case "custom":
        return o(t.newKey, t.instantiator);
    }
  }, fe = function(t, r) {
    return r;
  }, Fe = function(t, r) {
    var o = H(t) && H(r);
    return o ? Gt(t, r) : r;
  }, bt = function(t) {
    return function() {
      for (var r = [], o = 0; o < arguments.length; o++)
        r[o] = arguments[o];
      if (r.length === 0)
        throw new Error("Can't merge zero objects");
      for (var l = {}, v = 0; v < r.length; v++) {
        var g = r[v];
        for (var b in g)
          yn(g, b) && (l[b] = t(l[b], g[b]));
      }
      return l;
    };
  }, Gt = bt(Fe), fr = bt(fe), Wr = function() {
    return {
      tag: "required",
      process: {}
    };
  }, da = function(t) {
    return {
      tag: "defaultedThunk",
      process: t
    };
  }, aa = function(t) {
    return da(ie(t));
  }, oo = function() {
    return {
      tag: "option",
      process: {}
    };
  }, su = function(t) {
    return {
      tag: "mergeWithThunk",
      process: t
    };
  }, Vo = function(t) {
    return su(ie(t));
  }, dk = function(t, r) {
    return t.length > 0 ? Do.svalue(Gt(r, fr.apply(void 0, t))) : Do.svalue(r);
  }, zC = function(t) {
    return ze(Do.serror, Ie)(t);
  }, HC = function(t, r) {
    var o = Do.partition(t);
    return o.errors.length > 0 ? zC(o.errors) : dk(o.values, r);
  }, mk = function(t) {
    var r = Do.partition(t);
    return r.errors.length > 0 ? zC(r.errors) : Do.svalue(r.values);
  }, Tc = {
    consolidateObj: HC,
    consolidateArr: mk
  }, Lp = function(t) {
    return H(t) && on(t).length > 100 ? " removed due to size" : JSON.stringify(t, null, 2);
  }, Ss = function(t) {
    var r = t.length > 10 ? t.slice(0, 10).concat([{
      path: [],
      getErrorInfo: ie("... (only showing first ten failures)")
    }]) : t;
    return _t(r, function(o) {
      return "Failed path: (" + o.path.join(" > ") + `)
` + o.getErrorInfo();
    });
  }, Ym = function(t, r) {
    return Do.serror([{
      path: t,
      getErrorInfo: r
    }]);
  }, ry = function(t, r, o) {
    return Ym(t, function() {
      return 'Could not find valid *required* value for "' + r + '" in ' + Lp(o);
    });
  }, zp = function(t, r) {
    return Ym(t, function() {
      return 'Choice schema did not contain choice key: "' + r + '"';
    });
  }, k1 = function(t, r, o) {
    return Ym(t, function() {
      return 'The chosen schema: "' + o + '" did not exist in branches: ' + Lp(r);
    });
  }, VC = function(t, r) {
    return Ym(t, function() {
      return "There are unsupported fields: [" + r.join(", ") + "] specified";
    });
  }, gk = function(t, r) {
    return Ym(t, ie(r));
  }, Ec = function(t) {
    var r = function(l, v) {
      return Do.bindError(t(v), function(g) {
        return gk(l, g);
      });
    }, o = ie("val");
    return {
      extract: r,
      toString: o
    };
  }, Hp = Ec(Do.svalue), pk = function(t, r, o, l) {
    return Ft(r, o).fold(function() {
      return ry(t, o, r);
    }, l);
  }, ay = function(t, r, o, l) {
    var v = Ft(t, r).getOrThunk(function() {
      return o(t);
    });
    return l(v);
  }, hk = function(t, r, o) {
    return o(Ft(t, r));
  }, bk = function(t, r, o, l) {
    var v = Ft(t, r).map(function(g) {
      return g === !0 ? o(t) : g;
    });
    return l(v);
  }, Zm = function(t, r, o, l, v) {
    var g = function(T) {
      return v.extract(r.concat([l]), T);
    }, b = function(T) {
      return T.fold(function() {
        return Do.svalue(_.none());
      }, function(A) {
        var R = v.extract(r.concat([l]), A);
        return Do.map(R, _.some);
      });
    };
    switch (t.tag) {
      case "required":
        return pk(r, o, l, g);
      case "defaultedThunk":
        return ay(o, l, t.process, g);
      case "option":
        return hk(o, l, b);
      case "defaultedOptionThunk":
        return bk(o, l, t.process, b);
      case "mergeWithThunk":
        return ay(o, l, ie({}), function(T) {
          var A = Gt(t.process(o), T);
          return g(A);
        });
    }
  }, Vp = function(t, r, o) {
    for (var l = {}, v = [], g = 0, b = o; g < b.length; g++) {
      var T = b[g];
      G(T, function(A, R, z, U) {
        var oe = Zm(z, t, r, A, U);
        Do.fold(oe, function(de) {
          v.push.apply(v, de);
        }, function(de) {
          l[R] = de;
        });
      }, function(A, R) {
        l[A] = R(r);
      });
    }
    return v.length > 0 ? Do.serror(v) : Do.svalue(l);
  }, UC = function(t) {
    var r = function(l, v) {
      return t().extract(l, v);
    }, o = function() {
      return t().toString();
    };
    return {
      extract: r,
      toString: o
    };
  }, jC = function(t) {
    return on(_n(t, Y));
  }, js = function(t) {
    var r = hr(t), o = Ae(t, function(v, g) {
      return G(g, function(b) {
        var T;
        return Gt(v, (T = {}, T[b] = !0, T));
      }, ie(v));
    }, {}), l = function(v, g) {
      var b = le(g) ? [] : jC(g), T = We(b, function(A) {
        return !Yn(o, A);
      });
      return T.length === 0 ? r.extract(v, g) : VC(v, T);
    };
    return {
      extract: l,
      toString: r.toString
    };
  }, hr = function(t) {
    var r = function(l, v) {
      return Vp(l, v, t);
    }, o = function() {
      var l = _t(t, function(v) {
        return G(v, function(g, b, T, A) {
          return g + " -> " + A.toString();
        }, function(g, b) {
          return "state(" + g + ")";
        });
      });
      return `obj{
` + l.join(`
`) + "}";
    };
    return {
      extract: r,
      toString: o
    };
  }, Qf = function(t) {
    var r = function(l, v) {
      var g = _t(v, function(b, T) {
        return t.extract(l.concat(["[" + T + "]"]), b);
      });
      return Tc.consolidateArr(g);
    }, o = function() {
      return "array(" + t.toString() + ")";
    };
    return {
      extract: r,
      toString: o
    };
  }, Up = function(t) {
    var r = function(l, v) {
      for (var g = [], b = 0, T = t; b < T.length; b++) {
        var A = T[b], R = A.extract(l, v);
        if (R.stype === to.Value)
          return R;
        g.push(R);
      }
      return Tc.consolidateArr(g);
    }, o = function() {
      return "oneOf(" + _t(t, function(l) {
        return l.toString();
      }).join(", ") + ")";
    };
    return {
      extract: r,
      toString: o
    };
  }, Iv = function(t, r) {
    var o = function(g, b) {
      return Qf(Ec(t)).extract(g, b);
    }, l = function(g, b) {
      var T = on(b), A = o(g, T);
      return Do.bind(A, function(R) {
        var z = _t(R, function(U) {
          return Xm(U, U, Wr(), r);
        });
        return hr(z).extract(g, b);
      });
    }, v = function() {
      return "setOf(" + r.toString() + ")";
    };
    return {
      extract: l,
      toString: v
    };
  }, Jm = function(t, r) {
    var o = Et(r), l = function(g, b) {
      return o().extract(g, b);
    }, v = function() {
      return o().toString();
    };
    return {
      extract: l,
      toString: v
    };
  }, oy = ze(Qf, hr), Xl = ie(Hp), Id = function(t, r) {
    return Ec(function(o) {
      var l = typeof o;
      return t(o) ? Do.svalue(o) : Do.serror("Expected type: " + r + " but got: " + l);
    });
  }, Qm = Id(J, "number"), ri = Id(P, "string"), Ki = Id(le, "boolean"), jp = Id(D, "function"), tf = function(t) {
    if (Object(t) !== t)
      return !0;
    switch ({}.toString.call(t).slice(8, -1)) {
      case "Boolean":
      case "Number":
      case "String":
      case "Date":
      case "RegExp":
      case "Blob":
      case "FileList":
      case "ImageData":
      case "ImageBitmap":
      case "ArrayBuffer":
        return !0;
      case "Array":
      case "Object":
        return Object.keys(t).every(function(r) {
          return tf(t[r]);
        });
      default:
        return !1;
    }
  }, Wp = Ec(function(t) {
    return tf(t) ? Do.svalue(t) : Do.serror("Expected value to be acceptable for sending via postMessage");
  }), T1 = function(t, r, o, l) {
    var v = Ft(o, l);
    return v.fold(function() {
      return k1(t, o, l);
    }, function(g) {
      return g.extract(t.concat(["branch: " + l]), r);
    });
  }, E1 = function(t, r) {
    var o = function(v, g) {
      var b = Ft(g, t);
      return b.fold(function() {
        return zp(v, t);
      }, function(T) {
        return T1(v, g, r, T);
      });
    }, l = function() {
      return "chooseOn(" + t + "). Possible values: " + on(r);
    };
    return {
      extract: o,
      toString: l
    };
  }, yk = function() {
    return Qf(Hp);
  }, eg = function(t) {
    return Ec(function(r) {
      return t(r).fold(Do.serror, Do.svalue);
    });
  }, Bu = function(t, r) {
    return Iv(function(o) {
      return Do.fromResult(t(o));
    }, r);
  }, WC = function(t, r, o) {
    var l = r.extract([t], o);
    return Do.mapError(l, function(v) {
      return {
        input: o,
        errors: v
      };
    });
  }, Io = function(t, r, o) {
    return Do.toResult(WC(t, r, o));
  }, Yl = function(t) {
    return t.fold(function(r) {
      throw new Error(Fv(r));
    }, Ze);
  }, Ha = function(t, r, o) {
    return Yl(Io(t, r, o));
  }, Fv = function(t) {
    return `Errors: 
` + Ss(t.errors).join(`
`) + `

Input object: ` + Lp(t.input);
  }, Al = function(t, r) {
    return E1(t, Tn(r, hr));
  }, wk = function(t, r) {
    return Jm(t, r);
  }, Oi = Xm, as = M, qC = function(t) {
    return eg(function(r) {
      return Tt(t, r) ? ea.value(r) : ea.error('Unsupported value: "' + r + '", choose one of "' + t.join(", ") + '".');
    });
  }, un = function(t) {
    return Oi(t, t, Wr(), Xl());
  }, xs = function(t, r) {
    return Oi(t, t, Wr(), r);
  }, ev = function(t) {
    return xs(t, Qm);
  }, Lr = function(t) {
    return xs(t, ri);
  }, ll = function(t, r) {
    return Oi(t, t, Wr(), qC(r));
  }, Ck = function(t) {
    return xs(t, Ki);
  }, Uu = function(t) {
    return xs(t, jp);
  }, tg = function(t, r) {
    return Oi(t, t, oo(), Ec(function(o) {
      return Do.serror("The field: " + t + " is forbidden. " + r);
    }));
  }, nf = function(t, r) {
    return Oi(t, t, Wr(), hr(r));
  }, Zl = function(t, r) {
    return Oi(t, t, Wr(), oy(r));
  }, Ru = function(t, r) {
    return Oi(t, t, Wr(), Qf(r));
  }, Ba = function(t) {
    return Oi(t, t, oo(), Xl());
  }, _c = function(t, r) {
    return Oi(t, t, oo(), r);
  }, Fd = function(t) {
    return _c(t, Qm);
  }, lo = function(t) {
    return _c(t, ri);
  }, $v = function(t) {
    return _c(t, jp);
  }, Ws = function(t, r) {
    return _c(t, Qf(r));
  }, qs = function(t, r) {
    return _c(t, hr(r));
  }, Sk = function(t, r) {
    return _c(t, js(r));
  }, ct = function(t, r) {
    return Oi(t, t, aa(r), Xl());
  }, os = function(t, r, o) {
    return Oi(t, t, aa(r), o);
  }, Ac = function(t, r) {
    return os(t, r, Qm);
  }, ng = function(t, r) {
    return os(t, r, ri);
  }, cl = function(t, r, o) {
    return os(t, r, qC(o));
  }, no = function(t, r) {
    return os(t, r, Ki);
  }, co = function(t, r) {
    return os(t, r, jp);
  }, ks = function(t, r) {
    return os(t, r, Wp);
  }, tv = function(t, r, o) {
    return os(t, r, Qf(o));
  }, iy = function(t, r, o) {
    return os(t, r, hr(o));
  }, Sr = function(t) {
    var r = t, o = function() {
      return r;
    }, l = function(v) {
      r = v;
    };
    return {
      get: o,
      set: l
    };
  }, _1 = function(t) {
    if (!X(t))
      throw new Error("cases must be an array");
    if (t.length === 0)
      throw new Error("there must be at least one case");
    var r = [], o = {};
    return Pe(t, function(l, v) {
      var g = on(l);
      if (g.length !== 1)
        throw new Error("one and only one name per case");
      var b = g[0], T = l[b];
      if (o[b] !== void 0)
        throw new Error("duplicate key detected:" + b);
      if (b === "cata")
        throw new Error("cannot have a case named cata (sorry)");
      if (!X(T))
        throw new Error("case arguments must be an array");
      r.push(b), o[b] = function() {
        for (var A = [], R = 0; R < arguments.length; R++)
          A[R] = arguments[R];
        var z = A.length;
        if (z !== T.length)
          throw new Error("Wrong number of arguments to case " + b + ". Expected " + T.length + " (" + T + "), got " + z);
        var U = function(oe) {
          var de = on(oe);
          if (r.length !== de.length)
            throw new Error("Wrong number of arguments to match. Expected: " + r.join(",") + `
Actual: ` + de.join(","));
          var Se = Xe(r, function($e) {
            return Tt(de, $e);
          });
          if (!Se)
            throw new Error("Not all branches were specified when using match. Specified: " + de.join(", ") + `
Required: ` + r.join(", "));
          return oe[b].apply(null, A);
        };
        return {
          fold: function() {
            for (var oe = [], de = 0; de < arguments.length; de++)
              oe[de] = arguments[de];
            if (oe.length !== t.length)
              throw new Error("Wrong number of arguments to fold. Expected " + t.length + ", got " + oe.length);
            var Se = oe[v];
            return Se.apply(null, A);
          },
          match: U,
          log: function(oe) {
            console.log(oe, {
              constructors: r,
              constructor: b,
              params: A
            });
          }
        };
      };
    }), o;
  }, fl = { generate: _1 };
  fl.generate([
    {
      bothErrors: [
        "error1",
        "error2"
      ]
    },
    {
      firstError: [
        "error1",
        "value2"
      ]
    },
    {
      secondError: [
        "value1",
        "error2"
      ]
    },
    {
      bothValues: [
        "value1",
        "value2"
      ]
    }
  ]);
  var GC = function(t) {
    var r = [], o = [];
    return Pe(t, function(l) {
      l.fold(function(v) {
        r.push(v);
      }, function(v) {
        o.push(v);
      });
    }), {
      errors: r,
      values: o
    };
  }, qp = function(t, r) {
    var o = {};
    return Un(t, function(l, v) {
      Tt(r, v) || (o[v] = l);
    }), o;
  }, Gp = function(t, r) {
    var o;
    return o = {}, o[t] = r, o;
  }, uy = function(t) {
    var r = {};
    return Pe(t, function(o) {
      r[o.key] = o.value;
    }), r;
  }, sy = function(t, r) {
    return qp(t, r);
  }, rf = function(t, r) {
    return Gp(t, r);
  }, nv = function(t) {
    return uy(t);
  }, xk = function(t, r) {
    return t.length === 0 ? ea.value(r) : ea.value(Gt(r, fr.apply(void 0, t)));
  }, ly = function(t) {
    return ea.error(Ie(t));
  }, kk = function(t, r) {
    var o = GC(t);
    return o.errors.length > 0 ? ly(o.errors) : xk(o.values, r);
  }, KC = function(t) {
    return D(t) ? t : ge;
  }, Kp = function(t, r, o) {
    for (var l = t.dom, v = KC(o); l.parentNode; ) {
      l = l.parentNode;
      var g = Bn.fromDom(l), b = r(g);
      if (b.isSome())
        return b;
      if (v(g))
        break;
    }
    return _.none();
  }, rg = function(t, r, o) {
    var l = r(t), v = KC(o);
    return l.orThunk(function() {
      return v(t) ? _.none() : Kp(t, r, v);
    });
  }, XC = function(t, r) {
    return Fa(t.element, r.event.target);
  }, af = {
    can: xe,
    abort: ge,
    run: ee
  }, ag = function(t) {
    if (!Yn(t, "can") && !Yn(t, "abort") && !Yn(t, "run"))
      throw new Error("EventHandler defined by: " + JSON.stringify(t, null, 2) + " does not have can, abort, or run!");
    return $($({}, af), t);
  }, cy = function(t, r) {
    return function() {
      for (var o = [], l = 0; l < arguments.length; l++)
        o[l] = arguments[l];
      return Ke(t, function(v, g) {
        return v && r(g).apply(void 0, o);
      }, !0);
    };
  }, YC = function(t, r) {
    return function() {
      for (var o = [], l = 0; l < arguments.length; l++)
        o[l] = arguments[l];
      return Ke(t, function(v, g) {
        return v || r(g).apply(void 0, o);
      }, !1);
    };
  }, Tk = function(t) {
    return D(t) ? {
      can: xe,
      abort: ge,
      run: t
    } : t;
  }, Ek = function(t) {
    var r = cy(t, function(v) {
      return v.can;
    }), o = YC(t, function(v) {
      return v.abort;
    }), l = function() {
      for (var v = [], g = 0; g < arguments.length; g++)
        v[g] = arguments[g];
      Pe(t, function(b) {
        b.run.apply(void 0, v);
      });
    };
    return {
      can: r,
      abort: o,
      run: l
    };
  }, bi = ie, of = bi("touchstart"), Jl = bi("touchmove"), Lv = bi("touchend"), ZC = bi("touchcancel"), Ql = bi("mousedown"), $d = bi("mousemove"), fy = bi("mouseout"), vy = bi("mouseup"), rv = bi("mouseover"), Ol = bi("focusin"), lu = bi("focusout"), A1 = bi("keydown"), dy = bi("keyup"), Ld = bi("input"), og = bi("change"), ig = bi("click"), _k = bi("transitioncancel"), ug = bi("transitionend"), my = bi("transitionstart"), Ak = bi("selectstart"), Uo = function(t) {
    return ie("alloy." + t);
  }, O1 = { tap: Uo("tap") }, zv = Uo("focus"), gy = Uo("blur.post"), py = Uo("paste.post"), Dl = Uo("receive"), vl = Uo("execute"), zd = Uo("focus.item"), Hv = O1.tap, D1 = Uo("longpress"), Xp = Uo("sandbox.close"), hy = Uo("typeahead.cancel"), Hd = Uo("system.init"), B1 = Uo("system.touchmove"), Ok = Uo("system.touchend"), by = Uo("system.scroll"), dl = Uo("system.resize"), Gs = Uo("system.attached"), sg = Uo("system.detached"), ec = Uo("system.dismissRequested"), Mu = Uo("system.repositionRequested"), R1 = Uo("focusmanager.shifted"), av = Uo("slotcontainer.visibility"), JC = Uo("change.tab"), cu = Uo("dismiss.tab"), yy = Uo("highlight"), M1 = Uo("dehighlight"), Ta = function(t, r) {
    tc(t, t.element, r, {});
  }, xr = function(t, r, o) {
    tc(t, t.element, r, o);
  }, ml = function(t) {
    Ta(t, vl());
  }, P1 = function(t, r, o) {
    tc(t, r, o, {});
  }, tc = function(t, r, o, l) {
    var v = $({ target: r }, l);
    t.getSystem().triggerEvent(o, r, v);
  }, QC = function(t, r, o, l) {
    t.getSystem().triggerEvent(o, r, l.event);
  }, ro = function(t) {
    return nv(t);
  }, wy = function(t, r) {
    return {
      key: t,
      value: ag({ abort: r })
    };
  }, N1 = function(t, r) {
    return {
      key: t,
      value: ag({ can: r })
    };
  }, I1 = function(t) {
    return {
      key: t,
      value: ag({
        run: function(r, o) {
          o.event.prevent();
        }
      })
    };
  }, cn = function(t, r) {
    return {
      key: t,
      value: ag({ run: r })
    };
  }, Cy = function(t, r, o) {
    return {
      key: t,
      value: ag({
        run: function(l, v) {
          r.apply(void 0, [
            l,
            v
          ].concat(o));
        }
      })
    };
  }, Sy = function(t) {
    return function(r) {
      return cn(t, r);
    };
  }, Vv = function(t) {
    return function(r) {
      return {
        key: t,
        value: ag({
          run: function(o, l) {
            XC(o, l) && r(o, l);
          }
        })
      };
    };
  }, Yp = function(t, r) {
    return cn(t, function(o, l) {
      o.getSystem().getByUid(r).each(function(v) {
        QC(v, v.element, t, l);
      });
    });
  }, Vd = function(t, r, o) {
    var l = r.partUids[o];
    return Yp(t, l);
  }, Uv = function(t, r) {
    return cn(t, function(o, l) {
      var v = l.event, g = o.getSystem().getByDom(v.target).getOrThunk(function() {
        var b = rg(v.target, function(T) {
          return o.getSystem().getByDom(T).toOptional();
        }, ge);
        return b.getOr(o);
      });
      r(o, g, l);
    });
  }, Ud = function(t) {
    return cn(t, function(r, o) {
      o.cut();
    });
  }, lg = function(t) {
    return cn(t, function(r, o) {
      o.stop();
    });
  }, li = function(t, r) {
    return Vv(t)(r);
  }, Zr = Vv(Gs()), gl = Vv(sg()), eS = Vv(Hd()), Ks = Sy(vl()), xy = function(t, r) {
    var o = r || document, l = o.createElement("div");
    return l.innerHTML = t, O(Bn.fromDom(l));
  }, uf = function(t) {
    return t.dom.innerHTML;
  }, ov = function(t, r) {
    var o = wo(t), l = o.dom, v = Bn.fromDom(l.createDocumentFragment()), g = xy(r, l);
    kc(v, g), Oo(t), Ou(t, v);
  }, iv = function(t) {
    var r = Bn.fromTag("div"), o = Bn.fromDom(t.dom.cloneNode(!0));
    return Ou(r, o), uf(r);
  }, pl = function(t, r) {
    return Bn.fromDom(t.dom.cloneNode(r));
  }, jv = function(t) {
    return pl(t, !1);
  }, zi = function(t) {
    if (vt(t))
      return "#shadow-root";
    var r = jv(t);
    return iv(r);
  }, is = function(t) {
    return zi(t);
  }, sf = function(t, r, o) {
    return Fa(r, t.element) && !Fa(r, o);
  }, Wv = ro([N1(zv(), function(t, r) {
    var o = r.event, l = o.originator, v = o.target;
    return sf(t, l, v) ? (console.warn(zv() + ` did not get interpreted by the desired target. 
Originator: ` + is(l) + `
Target: ` + is(v) + `
Check the ` + zv() + " event handlers"), !1) : !0;
  })]), cg = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    events: Wv
  }), jd = 0, ur = function(t) {
    var r = new Date(), o = r.getTime(), l = Math.floor(Math.random() * 1e9);
    return jd++, t + "_" + l + jd + String(o);
  }, Xi = ie("alloy-id-"), Oc = ie("data-alloy-id"), lf = Xi(), Zp = Oc(), tS = function(t, r) {
    var o = ur(lf + t);
    return F1(r, o), o;
  }, F1 = function(t, r) {
    Object.defineProperty(t.dom, Zp, {
      value: r,
      writable: !0
    });
  }, qv = function(t) {
    var r = Z(t) ? t.dom[Zp] : null;
    return _.from(r);
  }, Gv = function(t) {
    return ur(t);
  }, fg = Ze, Jp = function(t) {
    var r = function(v) {
      return "The component must be in a context to execute: " + v + (t ? `
` + is(t().element) + " is not in context." : "");
    }, o = function(v) {
      return function() {
        throw new Error(r(v));
      };
    }, l = function(v) {
      return function() {
        console.warn(r(v));
      };
    };
    return {
      debugInfo: ie("fake"),
      triggerEvent: l("triggerEvent"),
      triggerFocus: l("triggerFocus"),
      triggerEscape: l("triggerEscape"),
      broadcast: l("broadcast"),
      broadcastOn: l("broadcastOn"),
      broadcastEvent: l("broadcastEvent"),
      build: o("build"),
      addToWorld: o("addToWorld"),
      removeFromWorld: o("removeFromWorld"),
      addToGui: o("addToGui"),
      removeFromGui: o("removeFromGui"),
      getByUid: o("getByUid"),
      getByDom: o("getByDom"),
      isConnected: ge
    };
  }, Dk = Jp(), hl = function(t, r, o) {
    var l = o.toString(), v = l.indexOf(")") + 1, g = l.indexOf("("), b = l.substring(g + 1, v - 1).split(/,\s*/);
    return t.toFunctionAnnotation = function() {
      return {
        name: r,
        parameters: ky(b.slice(0, 1).concat(b.slice(3)))
      };
    }, t;
  }, ky = function(t) {
    return _t(t, function(r) {
      return sr(r, "/*") ? r.substring(0, r.length - 2) : r;
    });
  }, Wd = function(t, r) {
    var o = t.toString(), l = o.indexOf(")") + 1, v = o.indexOf("("), g = o.substring(v + 1, l - 1).split(/,\s*/);
    return t.toFunctionAnnotation = function() {
      return {
        name: r,
        parameters: ky(g)
      };
    }, t;
  }, Kv = function(t, r) {
    var o = r.toString(), l = o.indexOf(")") + 1, v = o.indexOf("("), g = o.substring(v + 1, l - 1).split(/,\s*/);
    return t.toFunctionAnnotation = function() {
      return {
        name: "OVERRIDE",
        parameters: ky(g.slice(1))
      };
    }, t;
  }, Ty = ur("alloy-premade"), Xv = function(t) {
    return rf(Ty, t);
  }, nS = function(t) {
    return Ft(t, Ty);
  }, Fo = function(t) {
    return Kv(function(r) {
      for (var o = [], l = 1; l < arguments.length; l++)
        o[l - 1] = arguments[l];
      return t.apply(void 0, ae([
        r.getApis(),
        r
      ], o, !1));
    }, t);
  }, fu = {
    init: function() {
      return Pu({ readState: ie("No State required") });
    }
  }, Pu = function(t) {
    return t;
  }, rS = function(t, r) {
    var o = _t(r, function(v) {
      return qs(v.name(), [
        un("config"),
        ct("state", fu)
      ]);
    }), l = Io("component.behaviours", hr(o), t.behaviours).fold(function(v) {
      throw new Error(Fv(v) + `
Complete spec:
` + JSON.stringify(t, null, 2));
    }, Ze);
    return {
      list: r,
      data: Tn(l, function(v) {
        var g = v.map(function(b) {
          return {
            config: b.config,
            state: b.state.init(b.config)
          };
        });
        return ie(g);
      })
    };
  }, $1 = function(t) {
    return t.list;
  }, Bk = function(t) {
    return t.data;
  }, aS = function(t, r) {
    var o = {};
    return Un(t, function(l, v) {
      Un(l, function(g, b) {
        var T = Ft(o, b).getOr([]);
        o[b] = T.concat([r(v, g)]);
      });
    }), o;
  }, nc = function(t) {
    return {
      classes: Q(t.classes) ? [] : t.classes,
      attributes: Q(t.attributes) ? {} : t.attributes,
      styles: Q(t.styles) ? {} : t.styles
    };
  }, Rk = function(t, r) {
    return $($({}, t), {
      attributes: $($({}, t.attributes), r.attributes),
      styles: $($({}, t.styles), r.styles),
      classes: t.classes.concat(r.classes)
    });
  }, vg = function(t, r, o, l) {
    var v = $({}, r);
    Pe(o, function(z) {
      v[z.name()] = z.exhibit(t, l);
    });
    var g = aS(v, function(z, U) {
      return {
        name: z,
        modification: U
      };
    }), b = function(z) {
      return Ae(z, function(U, oe) {
        return $($({}, oe.modification), U);
      }, {});
    }, T = Ae(g.classes, function(z, U) {
      return U.modification.concat(z);
    }, []), A = b(g.attributes), R = b(g.styles);
    return nc({
      classes: T,
      attributes: A,
      styles: R
    });
  }, L1 = function(t, r, o, l) {
    try {
      var v = Qt(o, function(g, b) {
        var T = g[r], A = b[r], R = l.indexOf(T), z = l.indexOf(A);
        if (R === -1)
          throw new Error("The ordering for " + t + " does not have an entry for " + T + `.
Order specified: ` + JSON.stringify(l, null, 2));
        if (z === -1)
          throw new Error("The ordering for " + t + " does not have an entry for " + A + `.
Order specified: ` + JSON.stringify(l, null, 2));
        return R < z ? -1 : z < R ? 1 : 0;
      });
      return ea.value(v);
    } catch (g) {
      return ea.error([g]);
    }
  }, Mk = function(t, r) {
    return {
      handler: t,
      purpose: r
    };
  }, oS = function(t, r) {
    return {
      cHandler: t,
      purpose: r
    };
  }, Ey = function(t, r) {
    return oS(Pt.apply(void 0, [t.handler].concat(r)), t.purpose);
  }, _y = function(t) {
    return t.cHandler;
  }, Ay = function(t, r) {
    return {
      name: t,
      handler: r
    };
  }, Pk = function(t, r) {
    var o = {};
    return Pe(t, function(l) {
      o[l.name()] = l.handlers(r);
    }), o;
  }, Yv = function(t, r, o) {
    var l = $($({}, o), Pk(r, t));
    return aS(l, Ay);
  }, Zv = function(t, r, o, l) {
    var v = Yv(t, o, l);
    return iS(v, r);
  }, Xa = function(t) {
    var r = Tk(t);
    return function(o, l) {
      for (var v = [], g = 2; g < arguments.length; g++)
        v[g - 2] = arguments[g];
      var b = [
        o,
        l
      ].concat(v);
      r.abort.apply(void 0, b) ? l.stop() : r.can.apply(void 0, b) && r.run.apply(void 0, b);
    };
  }, z1 = function(t, r) {
    return ea.error(["The event (" + t + `) has more than one behaviour that listens to it.
When this occurs, you must specify an event ordering for the behaviours in your spec (e.g. [ "listing", "toggling" ]).
The behaviours that can trigger it are: ` + JSON.stringify(_t(r, function(o) {
      return o.name;
    }), null, 2)]);
  }, Dc = function(t, r, o) {
    var l = r[o];
    return l ? L1("Event: " + o, "name", t, l).map(function(v) {
      var g = _t(v, function(b) {
        return b.handler;
      });
      return Ek(g);
    }) : z1(o, t);
  }, iS = function(t, r) {
    var o = Kr(t, function(l, v) {
      var g = l.length === 1 ? ea.value(l[0].handler) : Dc(l, r, v);
      return g.map(function(b) {
        var T = Xa(b), A = l.length > 1 ? We(r[v], function(R) {
          return Jt(l, function(z) {
            return z.name === R;
          });
        }).join(" > ") : l[0].name;
        return rf(v, Mk(T, A));
      });
    });
    return kk(o, {});
  }, Bc, cf = "alloy.base.behaviour", Jv = hr([
    Oi("dom", "dom", Wr(), hr([
      un("tag"),
      ct("styles", {}),
      ct("classes", []),
      ct("attributes", {}),
      Ba("value"),
      Ba("innerHtml")
    ])),
    un("components"),
    un("uid"),
    ct("events", {}),
    ct("apis", {}),
    Oi("eventOrder", "eventOrder", Vo((Bc = {}, Bc[vl()] = [
      "disabling",
      cf,
      "toggling",
      "typeaheadevents"
    ], Bc[zv()] = [
      cf,
      "focusing",
      "keying"
    ], Bc[Hd()] = [
      cf,
      "disabling",
      "toggling",
      "representing"
    ], Bc[Ld()] = [
      cf,
      "representing",
      "streaming",
      "invalidating"
    ], Bc[sg()] = [
      cf,
      "representing",
      "item-events",
      "tooltipping"
    ], Bc[Ql()] = [
      "focusing",
      cf,
      "item-type-events"
    ], Bc[of()] = [
      "focusing",
      cf,
      "item-type-events"
    ], Bc[rv()] = [
      "item-type-events",
      "tooltipping"
    ], Bc[Dl()] = [
      "receiving",
      "reflecting",
      "tooltipping"
    ], Bc)), Xl()),
    Ba("domModification")
  ]), H1 = function(t) {
    return Io("custom.definition", Jv, t);
  }, Qp = function(t) {
    return $($({}, t.dom), {
      uid: t.uid,
      domChildren: _t(t.components, function(r) {
        return r.element;
      })
    });
  }, V1 = function(t) {
    return t.domModification.fold(function() {
      return nc({});
    }, nc);
  }, U1 = function(t) {
    return t.events;
  }, qd = function(t, r) {
    var o = So(t, r);
    return o === void 0 || o === "" ? [] : o.split(" ");
  }, Nk = function(t, r, o) {
    var l = qd(t, r), v = l.concat([o]);
    return Qr(t, r, v.join(" ")), !0;
  }, j1 = function(t, r, o) {
    var l = We(qd(t, r), function(v) {
      return v !== o;
    });
    return l.length > 0 ? Qr(t, r, l.join(" ")) : Gi(t, r), !1;
  }, dg = function(t) {
    return t.dom.classList !== void 0;
  }, eh = function(t) {
    return qd(t, "class");
  }, th = function(t, r) {
    return Nk(t, "class", r);
  }, Oy = function(t, r) {
    return j1(t, "class", r);
  }, Di = function(t, r) {
    dg(t) ? t.dom.classList.add(r) : th(t, r);
  }, Gd = function(t) {
    var r = dg(t) ? t.dom.classList : eh(t);
    r.length === 0 && Gi(t, "class");
  }, yi = function(t, r) {
    if (dg(t)) {
      var o = t.dom.classList;
      o.remove(r);
    } else
      Oy(t, r);
    Gd(t);
  }, us = function(t, r) {
    return dg(t) && t.dom.classList.contains(r);
  }, Kd = function(t, r) {
    Pe(r, function(o) {
      Di(t, o);
    });
  }, bl = function(t, r) {
    Pe(r, function(o) {
      yi(t, o);
    });
  }, W1 = function(t, r) {
    return Xe(r, function(o) {
      return us(t, o);
    });
  }, ff = function(t) {
    return t.dom.value;
  }, mg = function(t, r) {
    if (r === void 0)
      throw new Error("Value.set was undefined");
    t.dom.value = r;
  }, gg = function(t) {
    var r = Bn.fromTag(t.tag);
    zs(r, t.attributes), Kd(r, t.classes), Hs(r, t.styles), t.innerHtml.each(function(l) {
      return ov(r, l);
    });
    var o = t.domChildren;
    if (kc(r, o), t.value.each(function(l) {
      mg(r, l);
    }), !t.uid)
      debugger;
    return F1(r, t.uid), r;
  }, uS = function(t) {
    var r = Ft(t, "behaviours").getOr({});
    return St(on(r), function(o) {
      var l = r[o];
      return Y(l) ? [l.me] : [];
    });
  }, sS = function(t, r) {
    return rS(t, r);
  }, Ik = function(t) {
    var r = uS(t);
    return sS(t, r);
  }, Fk = function(t, r, o) {
    var l = Qp(t), v = V1(t), g = { "alloy.base.modification": v }, b = r.length > 0 ? vg(o, g, r, l) : v;
    return Rk(l, b);
  }, $k = function(t, r, o) {
    var l = { "alloy.base.behaviour": U1(t) };
    return Zv(o, t.eventOrder, r, l).getOrDie();
  }, lS = function(t) {
    var r = function() {
      return ft;
    }, o = Sr(Dk), l = Yl(H1(t)), v = Ik(t), g = $1(v), b = Bk(v), T = Fk(l, g, b), A = gg(T), R = $k(l, g, b), z = Sr(l.components), U = function(Ht) {
      o.set(Ht);
    }, oe = function() {
      o.set(Jp(r));
    }, de = function() {
      var Ht = O(A), Kt = St(Ht, function(st) {
        return o.get().getByDom(st).fold(function() {
          return [];
        }, Ye);
      });
      z.set(Kt);
    }, Se = function(Ht) {
      var Kt = b, st = D(Kt[Ht.name()]) ? Kt[Ht.name()] : function() {
        throw new Error("Could not find " + Ht.name() + " in " + JSON.stringify(t, null, 2));
      };
      return st();
    }, $e = function(Ht) {
      return D(b[Ht.name()]);
    }, ut = function() {
      return l.apis;
    }, Ne = function(Ht) {
      return b[Ht]().map(function(Kt) {
        return Kt.state.readState();
      }).getOr("not enabled");
    }, ft = {
      uid: t.uid,
      getSystem: o.get,
      config: Se,
      hasConfigured: $e,
      spec: t,
      readState: Ne,
      getApis: ut,
      connect: U,
      disconnect: oe,
      element: A,
      syncComponents: de,
      components: z.get,
      events: R
    };
    return ft;
  }, q1 = function(t) {
    var r = Ft(t, "components").getOr([]);
    return _t(r, ko);
  }, G1 = function(t) {
    var r = fg(t), o = r.events, l = N(r, ["events"]), v = q1(l), g = $($({}, l), {
      events: $($({}, cg), o),
      components: v
    });
    return ea.value(lS(g));
  }, vu = function(t) {
    var r = Bn.fromText(t);
    return K1({ element: r });
  }, K1 = function(t) {
    var r = Ha("external.component", js([
      un("element"),
      Ba("uid")
    ]), t), o = Sr(Jp()), l = function(T) {
      o.set(T);
    }, v = function() {
      o.set(Jp(function() {
        return b;
      }));
    }, g = r.uid.getOrThunk(function() {
      return Gv("external");
    });
    F1(r.element, g);
    var b = {
      uid: g,
      getSystem: o.get,
      config: _.none,
      hasConfigured: ge,
      connect: l,
      disconnect: v,
      getApis: function() {
        return {};
      },
      element: r.element,
      spec: t,
      readState: ie("No state"),
      syncComponents: ee,
      components: ie([]),
      events: {}
    };
    return Xv(b);
  }, Dy = Gv, Bl = function(t) {
    return yn(t, "uid");
  }, ko = function(t) {
    return nS(t).getOrThunk(function() {
      var r = Bl(t) ? t : $({ uid: Dy("") }, t);
      return G1(r).getOrDie();
    });
  }, yl = Xv;
  function Qv(t, r, o, l, v) {
    return t(o, l) ? _.some(o) : D(v) && v(o) ? _.none() : r(o, l, v);
  }
  var By = function(t, r, o) {
    for (var l = t.dom, v = D(o) ? o : ge; l.parentNode; ) {
      l = l.parentNode;
      var g = Bn.fromDom(l);
      if (r(g))
        return _.some(g);
      if (v(g))
        break;
    }
    return _.none();
  }, X1 = function(t, r, o) {
    var l = function(v, g) {
      return g(v);
    };
    return Qv(l, By, t, r, o);
  }, cS = function(t, r) {
    var o = function(v) {
      return r(Bn.fromDom(v));
    }, l = pt(t.dom.childNodes, o);
    return l.map(Bn.fromDom);
  }, ta = function(t, r) {
    var o = function(l) {
      for (var v = 0; v < l.childNodes.length; v++) {
        var g = Bn.fromDom(l.childNodes[v]);
        if (r(g))
          return _.some(g);
        var b = o(l.childNodes[v]);
        if (b.isSome())
          return b;
      }
      return _.none();
    };
    return o(t.dom);
  }, pg = function(t, r, o) {
    return X1(t, r, o).isSome();
  }, Y1 = function(t, r, o) {
    return By(t, function(l) {
      return va(l, r);
    }, o);
  }, Ry = function(t, r) {
    return cS(t, function(o) {
      return va(o, r);
    });
  }, Bi = function(t, r) {
    return Yc(r, t);
  }, Rl = function(t, r, o) {
    var l = function(v, g) {
      return va(v, g);
    };
    return Qv(l, Y1, t, r, o);
  }, fS = function(t) {
    var r = X1(t, function(o) {
      if (!Z(o))
        return !1;
      var l = So(o, "id");
      return l !== void 0 && l.indexOf("aria-owns") > -1;
    });
    return r.bind(function(o) {
      var l = So(o, "id"), v = wr(o);
      return Bi(v, '[aria-owns="' + l + '"]');
    });
  }, Xd = function() {
    var t = ur("aria-owns"), r = function(l) {
      Qr(l, "aria-owns", t);
    }, o = function(l) {
      Gi(l, "aria-owns");
    };
    return {
      id: t,
      link: r,
      unlink: o
    };
  }, ho = function(t, r) {
    return fS(r).exists(function(o) {
      return Yd(t, o);
    });
  }, Yd = function(t, r) {
    return pg(r, function(o) {
      return Fa(o, t.element);
    }, ge) || ho(t, r);
  }, Z1 = "unknown", hg;
  (function(t) {
    t[t.STOP = 0] = "STOP", t[t.NORMAL = 1] = "NORMAL", t[t.LOGGING = 2] = "LOGGING";
  })(hg || (hg = {}));
  var My = Sr({}), vS = function(t, r) {
    var o = [], l = new Date().getTime();
    return {
      logEventCut: function(v, g, b) {
        o.push({
          outcome: "cut",
          target: g,
          purpose: b
        });
      },
      logEventStopped: function(v, g, b) {
        o.push({
          outcome: "stopped",
          target: g,
          purpose: b
        });
      },
      logNoParent: function(v, g, b) {
        o.push({
          outcome: "no-parent",
          target: g,
          purpose: b
        });
      },
      logEventNoHandlers: function(v, g) {
        o.push({
          outcome: "no-handlers-left",
          target: g
        });
      },
      logEventResponse: function(v, g, b) {
        o.push({
          outcome: "response",
          purpose: b,
          target: g
        });
      },
      write: function() {
        var v = new Date().getTime();
        Tt([
          "mousemove",
          "mouseover",
          "mouseout",
          Hd()
        ], t) || console.log(t, {
          event: t,
          time: v - l,
          target: r.dom,
          sequence: _t(o, function(g) {
            return Tt([
              "cut",
              "stopped",
              "response"
            ], g.outcome) ? "{" + g.purpose + "} " + g.outcome + " at (" + is(g.target) + ")" : g.outcome;
          })
        });
      }
    };
  }, nh = function(t, r, o) {
    var l = Ft(My.get(), t).orThunk(function() {
      var b = on(My.get());
      return Xt(b, function(T) {
        return t.indexOf(T) > -1 ? _.some(My.get()[T]) : _.none();
      });
    }).getOr(hg.NORMAL);
    switch (l) {
      case hg.NORMAL:
        return o(Lk());
      case hg.LOGGING: {
        var v = vS(t, r), g = o(v);
        return v.write(), g;
      }
      case hg.STOP:
        return !0;
    }
  }, dS = [
    "alloy/data/Fields",
    "alloy/debugging/Debugging"
  ], uv = function() {
    var t = new Error();
    if (t.stack !== void 0) {
      var r = t.stack.split(`
`);
      return pt(r, function(o) {
        return o.indexOf("alloy") > 0 && !Jt(dS, function(l) {
          return o.indexOf(l) > -1;
        });
      }).getOr(Z1);
    } else
      return Z1;
  }, ss = {
    logEventCut: ee,
    logEventStopped: ee,
    logNoParent: ee,
    logEventNoHandlers: ee,
    logEventResponse: ee,
    write: ee
  }, Py = function(t, r, o) {
    return nh(t, r, o);
  }, Lk = ie(ss), Rc = ie([
    un("menu"),
    un("selectedMenu")
  ]), sv = ie([
    un("item"),
    un("selectedItem")
  ]);
  ie(hr(sv().concat(Rc())));
  var J1 = ie(hr(sv())), zk = nf("initSize", [
    un("numColumns"),
    un("numRows")
  ]), Hk = function() {
    return xs("markers", J1());
  }, Zd = function() {
    return nf("markers", [un("backgroundMenu")].concat(Rc()).concat(sv()));
  }, Jd = function(t) {
    return nf("markers", _t(t, un));
  }, Q1 = function(t, r, o) {
    return uv(), Oi(r, r, o, eg(function(l) {
      return ea.value(function() {
        for (var v = [], g = 0; g < arguments.length; g++)
          v[g] = arguments[g];
        return l.apply(void 0, v);
      });
    }));
  }, Ra = function(t) {
    return Q1("onHandler", t, aa(ee));
  }, Ri = function(t) {
    return Q1("onKeyboardHandler", t, aa(_.none));
  }, ls = function(t) {
    return Q1("onHandler", t, Wr());
  }, Ts = function(t) {
    return Q1("onKeyboardHandler", t, Wr());
  }, io = function(t, r) {
    return as(t, ie(r));
  }, ed = function(t) {
    return as(t, Ze);
  }, e0 = ie(zk), Hi = function(t, r, o, l, v, g, b, T) {
    return T === void 0 && (T = !1), {
      x: t,
      y: r,
      bubble: o,
      direction: l,
      placement: v,
      restriction: g,
      label: b + "-" + v,
      alwaysFit: T
    };
  }, vf = fl.generate([
    { southeast: [] },
    { southwest: [] },
    { northeast: [] },
    { northwest: [] },
    { south: [] },
    { north: [] },
    { east: [] },
    { west: [] }
  ]), Vk = function(t, r, o, l, v, g, b, T, A) {
    return t.fold(r, o, l, v, g, b, T, A);
  }, Uk = function(t, r, o, l) {
    return t.fold(r, r, l, l, r, l, o, o);
  }, t0 = function(t, r, o, l) {
    return t.fold(r, l, r, l, o, o, r, l);
  }, n0 = vf.southeast, Ny = vf.southwest, Iy = vf.northeast, Qd = vf.northwest, rh = vf.south, Fy = vf.north, $y = vf.east, bg = vf.west, du = function(t, r, o, l) {
    var v = t + r;
    return v > l ? o : v < o ? l : v;
  }, Xs = function(t, r, o) {
    return Math.min(Math.max(t, r), o);
  }, ah = function(t, r) {
    switch (r) {
      case 1:
        return t.x;
      case 0:
        return t.x + t.width;
      case 2:
        return t.y;
      case 3:
        return t.y + t.height;
    }
  }, Mi = function(t, r) {
    return gt([
      "left",
      "right",
      "top",
      "bottom"
    ], function(o) {
      return Ft(r, o).map(function(l) {
        return ah(t, l);
      });
    });
  }, r0 = function(t, r, o) {
    var l = function(A, R) {
      return r[A].map(function(z) {
        var U = A === "top" || A === "bottom", oe = U ? o.top : o.left, de = A === "left" || A === "top" ? Math.max : Math.min, Se = de(z, R) + oe;
        return U ? Xs(Se, t.y, t.bottom) : Xs(Se, t.x, t.right);
      }).getOr(R);
    }, v = l("left", t.x), g = l("top", t.y), b = l("right", t.right), T = l("bottom", t.bottom);
    return Ai(v, g, b - v, T - g);
  }, lv = "layout", Ly = function(t) {
    return t.x;
  }, zy = function(t, r) {
    return t.x + t.width / 2 - r.width / 2;
  }, mS = function(t, r) {
    return t.x + t.width - r.width;
  }, Hy = function(t, r) {
    return t.y - r.height;
  }, oh = function(t) {
    return t.y + t.height;
  }, a0 = function(t, r) {
    return t.y + t.height / 2 - r.height / 2;
  }, gS = function(t) {
    return t.x + t.width;
  }, jk = function(t, r) {
    return t.x - r.width;
  }, Nu = function(t, r, o) {
    return Hi(Ly(t), oh(t), o.southeast(), n0(), "southeast", Mi(t, {
      left: 1,
      top: 3
    }), lv);
  }, Vi = function(t, r, o) {
    return Hi(mS(t, r), oh(t), o.southwest(), Ny(), "southwest", Mi(t, {
      right: 0,
      top: 3
    }), lv);
  }, cs = function(t, r, o) {
    return Hi(Ly(t), Hy(t, r), o.northeast(), Iy(), "northeast", Mi(t, {
      left: 1,
      bottom: 2
    }), lv);
  }, fs = function(t, r, o) {
    return Hi(mS(t, r), Hy(t, r), o.northwest(), Qd(), "northwest", Mi(t, {
      right: 0,
      bottom: 2
    }), lv);
  }, Es = function(t, r, o) {
    return Hi(zy(t, r), Hy(t, r), o.north(), Fy(), "north", Mi(t, { bottom: 2 }), lv);
  }, wi = function(t, r, o) {
    return Hi(zy(t, r), oh(t), o.south(), rh(), "south", Mi(t, { top: 3 }), lv);
  }, o0 = function(t, r, o) {
    return Hi(gS(t), a0(t, r), o.east(), $y(), "east", Mi(t, { left: 0 }), lv);
  }, i0 = function(t, r, o) {
    return Hi(jk(t, r), a0(t, r), o.west(), bg(), "west", Mi(t, { right: 1 }), lv);
  }, Vy = function() {
    return [
      Nu,
      Vi,
      cs,
      fs,
      wi,
      Es,
      o0,
      i0
    ];
  }, em = function() {
    return [
      Vi,
      Nu,
      fs,
      cs,
      wi,
      Es,
      o0,
      i0
    ];
  }, td = function() {
    return [
      cs,
      fs,
      Nu,
      Vi,
      Es,
      wi
    ];
  }, u0 = function() {
    return [
      fs,
      cs,
      Vi,
      Nu,
      Es,
      wi
    ];
  }, s0 = function() {
    return [
      Nu,
      Vi,
      cs,
      fs,
      wi,
      Es
    ];
  }, l0 = function() {
    return [
      Vi,
      Nu,
      fs,
      cs,
      wi,
      Es
    ];
  }, yg = function(t, r) {
    return r.universal ? t : We(t, function(o) {
      return Tt(r.channels, o);
    });
  }, wg = function(t) {
    return ro([cn(Dl(), function(r, o) {
      var l = t.channels, v = on(l), g = o, b = yg(v, g);
      Pe(b, function(T) {
        var A = l[T], R = A.schema, z = Ha("channel[" + T + `] data
Receiver: ` + is(r.element), R, g.data);
        A.onReceive(r, z);
      });
    })]);
  }, pS = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    events: wg
  }), df = [xs("channels", Bu(ea.value, js([
    ls("onReceive"),
    ct("schema", Xl())
  ])))], tm = function(t, r, o) {
    return Ks(function(l) {
      o(l, t, r);
    });
  }, Bo = function(t, r, o) {
    return eS(function(l, v) {
      o(l, t, r);
    });
  }, Wk = function(t, r, o, l, v, g) {
    var b = js(t), T = qs(r, [Sk("config", t)]);
    return hS(b, T, r, o, l, v, g);
  }, qk = function(t, r, o, l, v, g) {
    var b = t, T = qs(r, [_c("config", t)]);
    return hS(b, T, r, o, l, v, g);
  }, c0 = function(t, r, o) {
    var l = function(v) {
      for (var g = [], b = 1; b < arguments.length; b++)
        g[b - 1] = arguments[b];
      var T = [v].concat(g);
      return v.config({ name: ie(t) }).fold(function() {
        throw new Error("We could not find any behaviour configuration for: " + t + ". Using API: " + o);
      }, function(A) {
        var R = Array.prototype.slice.call(T, 1);
        return r.apply(void 0, [
          v,
          A.config,
          A.state
        ].concat(R));
      });
    };
    return hl(l, o, r);
  }, Gk = function(t) {
    return {
      key: t,
      value: void 0
    };
  }, hS = function(t, r, o, l, v, g, b) {
    var T = function(U) {
      return Yn(U, o) ? U[o]() : _.none();
    }, A = Tn(v, function(U, oe) {
      return c0(o, U, oe);
    }), R = Tn(g, function(U, oe) {
      return Wd(U, oe);
    }), z = $($($({}, R), A), {
      revoke: Pt(Gk, o),
      config: function(U) {
        var oe = Ha(o + "-config", t, U);
        return {
          key: o,
          value: {
            config: oe,
            me: z,
            configAsRaw: Et(function() {
              return Ha(o + "-config", t, U);
            }),
            initialConfig: U,
            state: b
          }
        };
      },
      schema: ie(r),
      exhibit: function(U, oe) {
        return Va(T(U), Ft(l, "exhibit"), function(de, Se) {
          return Se(oe, de.config, de.state);
        }).getOrThunk(function() {
          return nc({});
        });
      },
      name: ie(o),
      handlers: function(U) {
        return T(U).map(function(oe) {
          var de = Ft(l, "events").getOr(function() {
            return {};
          });
          return de(oe.config, oe.state);
        }).getOr({});
      }
    });
    return z;
  }, Fn = function(t) {
    return nv(t);
  }, Kk = js([
    un("fields"),
    un("name"),
    ct("active", {}),
    ct("apis", {}),
    ct("state", fu),
    ct("extra", {})
  ]), Pi = function(t) {
    var r = Ha("Creating behaviour: " + t.name, Kk, t);
    return Wk(r.fields, r.name, r.active, r.apis, r.extra, r.state);
  }, Uy = js([
    un("branchKey"),
    un("branches"),
    un("name"),
    ct("active", {}),
    ct("apis", {}),
    ct("state", fu),
    ct("extra", {})
  ]), nm = function(t) {
    var r = Ha("Creating behaviour: " + t.name, Uy, t);
    return qk(Al(r.branchKey, r.branches), r.name, r.active, r.apis, r.extra, r.state);
  }, bS = ie(void 0), ju = Pi({
    fields: df,
    name: "receiving",
    active: pS
  }), ih = function(t, r) {
    return nc({
      classes: [],
      styles: r.useFixed() ? {} : { position: "relative" }
    });
  }, f0 = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    exhibit: ih
  }), uh = function() {
    return Bn.fromDom(document);
  }, Mc = function(t) {
    return t.dom.focus();
  }, sh = function(t) {
    return t.dom.blur();
  }, lh = function(t) {
    var r = wr(t).dom;
    return t.dom === r.activeElement;
  }, vs = function(t) {
    return t === void 0 && (t = uh()), _.from(t.dom.activeElement).map(Bn.fromDom);
  }, Pc = function(t) {
    return vs(wr(t)).filter(function(r) {
      return t.dom.contains(r.dom);
    });
  }, yS = function(t, r) {
    var o = wr(r), l = vs(o).bind(function(g) {
      var b = function(T) {
        return Fa(g, T);
      };
      return b(r) ? _.some(r) : ta(r, b);
    }), v = t(r);
    return l.each(function(g) {
      vs(o).filter(function(b) {
        return Fa(b, g);
      }).fold(function() {
        Mc(g);
      }, ee);
    }), v;
  }, Wu = function(t, r, o, l, v) {
    var g = function(b) {
      return b + "px";
    };
    return {
      position: t,
      left: r.map(g),
      top: o.map(g),
      right: l.map(g),
      bottom: v.map(g)
    };
  }, mf = function(t) {
    return $($({}, t), { position: _.some(t.position) });
  }, nd = function(t, r) {
    zo(t, mf(r));
  }, ch = fl.generate([
    { none: [] },
    {
      relative: [
        "x",
        "y",
        "width",
        "height"
      ]
    },
    {
      fixed: [
        "x",
        "y",
        "width",
        "height"
      ]
    }
  ]), zt = function(t, r, o, l, v, g) {
    var b = r.rect, T = b.x - o, A = b.y - l, R = b.width, z = b.height, U = v - (T + R), oe = g - (A + z), de = _.some(T), Se = _.some(A), $e = _.some(U), ut = _.some(oe), Ne = _.none();
    return Vk(r.direction, function() {
      return Wu(t, de, Se, Ne, Ne);
    }, function() {
      return Wu(t, Ne, Se, $e, Ne);
    }, function() {
      return Wu(t, de, Ne, Ne, ut);
    }, function() {
      return Wu(t, Ne, Ne, $e, ut);
    }, function() {
      return Wu(t, de, Se, Ne, Ne);
    }, function() {
      return Wu(t, de, Ne, Ne, ut);
    }, function() {
      return Wu(t, de, Se, Ne, Ne);
    }, function() {
      return Wu(t, Ne, Se, $e, Ne);
    });
  }, cv = function(t, r) {
    return t.fold(function() {
      var o = r.rect;
      return Wu("absolute", _.some(o.x), _.some(o.y), _.none(), _.none());
    }, function(o, l, v, g) {
      return zt("absolute", r, o, l, v, g);
    }, function(o, l, v, g) {
      return zt("fixed", r, o, l, v, g);
    });
  }, Cg = function(t, r) {
    var o = Pt(Du, r), l = t.fold(o, o, function() {
      var b = Us();
      return Du(r).translate(-b.left, -b.top);
    }), v = ns(r), g = Vs(r);
    return Ai(l.left, l.top, v, g);
  }, Xk = function(t, r) {
    return r.fold(function() {
      return t.fold(uu, uu, Ai);
    }, function(o) {
      return t.fold(o, o, function() {
        var l = o(), v = v0(t, l.x, l.y);
        return Ai(v.left, v.top, l.width, l.height);
      });
    });
  }, v0 = function(t, r, o) {
    var l = eo(r, o), v = function() {
      var g = Us();
      return l.translate(-g.left, -g.top);
    };
    return t.fold(ie(l), ie(l), v);
  }, rc = function(t, r, o, l) {
    return t.fold(r, o, l);
  };
  ch.none;
  var d0 = ch.relative, jy = ch.fixed, Wy = function(t, r) {
    return {
      anchorBox: t,
      origin: r
    };
  }, m0 = function(t, r) {
    return Wy(t, r);
  }, qy = "data-alloy-placement", Gy = function(t, r) {
    Qr(t, qy, r);
  }, Ky = function(t) {
    return No(t, qy);
  }, Xy = function(t) {
    return Gi(t, qy);
  }, rm = fl.generate([
    { fit: ["reposition"] },
    {
      nofit: [
        "reposition",
        "visibleW",
        "visibleH",
        "isVisible"
      ]
    }
  ]), wS = function(t, r) {
    var o = r.x, l = r.y, v = r.right, g = r.bottom, b = t.x, T = t.y, A = t.right, R = t.bottom, z = t.width, U = t.height, oe = b >= o && b <= v, de = T >= l && T <= g, Se = oe && de, $e = A <= v && A >= o, ut = R <= g && R >= l, Ne = $e && ut, ft = Math.min(z, b >= o ? v - b : A - o), Ht = Math.min(U, T >= l ? g - T : R - l);
    return {
      originInBounds: Se,
      sizeInBounds: Ne,
      visibleW: ft,
      visibleH: Ht
    };
  }, Yk = function(t, r) {
    var o = r.x, l = r.y, v = r.right, g = r.bottom, b = t.x, T = t.y, A = t.width, R = t.height, z = Math.max(o, v - A), U = Math.max(l, g - R), oe = Xs(b, o, z), de = Xs(T, l, U), Se = Math.min(oe + A, v) - oe, $e = Math.min(de + R, g) - de;
    return Ai(oe, de, Se, $e);
  }, Zk = function(t, r, o) {
    var l = ie(r.bottom - o.y), v = ie(o.bottom - r.y), g = Uk(t, v, v, l), b = ie(r.right - o.x), T = ie(o.right - r.x), A = t0(t, T, T, b);
    return {
      maxWidth: A,
      maxHeight: g
    };
  }, Sg = function(t, r, o, l) {
    var v = t.bubble, g = v.offset, b = r0(l, t.restriction, g), T = t.x + g.left, A = t.y + g.top, R = Ai(T, A, r, o), z = wS(R, b), U = z.originInBounds, oe = z.sizeInBounds, de = z.visibleW, Se = z.visibleH, $e = U && oe, ut = $e ? R : Yk(R, b), Ne = ut.width > 0 && ut.height > 0, ft = Zk(t.direction, ut, l), Ht = ft.maxWidth, Kt = ft.maxHeight, st = {
      rect: ut,
      maxHeight: Kt,
      maxWidth: Ht,
      direction: t.direction,
      placement: t.placement,
      classes: {
        on: v.classesOn,
        off: v.classesOff
      },
      layout: t.label,
      testY: A
    };
    return $e || t.alwaysFit ? rm.fit(st) : rm.nofit(st, de, Se, Ne);
  }, xg = function(t, r, o, l, v, g) {
    var b = l.width, T = l.height, A = function(z, U, oe, de, Se) {
      var $e = z(o, l, v, t, g), ut = Sg($e, b, T, g);
      return ut.fold(ie(ut), function(Ne, ft, Ht, Kt) {
        var st = Se === Kt ? Ht > de || ft > oe : !Se && Kt;
        return st ? ut : rm.nofit(U, oe, de, Se);
      });
    }, R = Ke(r, function(z, U) {
      var oe = Pt(A, U);
      return z.fold(ie(z), oe);
    }, rm.nofit({
      rect: o,
      maxHeight: l.height,
      maxWidth: l.width,
      direction: n0(),
      placement: "southeast",
      classes: {
        on: [],
        off: []
      },
      layout: "none",
      testY: o.y
    }, -1, -1, !1));
    return R.fold(Ze, Ze);
  }, g0 = function(t) {
    var r = Sr(_.none()), o = function() {
      return r.get().each(t);
    }, l = function() {
      o(), r.set(_.none());
    }, v = function() {
      return r.get().isSome();
    }, g = function() {
      return r.get();
    }, b = function(T) {
      o(), r.set(_.some(T));
    };
    return {
      clear: l,
      isSet: v,
      get: g,
      set: b
    };
  }, Yy = function() {
    return g0(function(t) {
      return t.destroy();
    });
  }, kg = function() {
    return g0(function(t) {
      return t.unbind();
    });
  }, Zy = function() {
    var t = Yy(), r = function(o) {
      return t.get().each(o);
    };
    return $($({}, t), { run: r });
  }, Zo = function() {
    var t = g0(ee), r = function(o) {
      return t.get().each(o);
    };
    return $($({}, t), { on: r });
  }, fh = xe, ai = function(t, r, o) {
    return S1(t, r, fh, o);
  }, p0 = function(t, r, o) {
    return Wf(t, r, fh, o);
  }, am = _l, Jy = [
    "top",
    "bottom",
    "right",
    "left"
  ], vh = "data-alloy-transition-timer", Qy = function(t, r) {
    return W1(t, r.classes);
  }, CS = function(t, r, o) {
    return o.exists(function(l) {
      var v = t.mode;
      return v === "all" ? !0 : l[v] !== r[v];
    });
  }, Jk = function(t, r) {
    var o = function(l) {
      return parseFloat(l).toFixed(3);
    };
    return ot(r, function(l, v) {
      var g = t[v].map(o), b = l.map(o);
      return !Wa(g, b);
    }).isSome();
  }, SS = function(t) {
    var r = function(g) {
      var b = Ho(t, g), T = P(b) ? b.split(/\s*,\s*/) : [];
      return We(T, pi);
    }, o = function(g) {
      if (P(g) && /^[\d.]+/.test(g)) {
        var b = parseFloat(g);
        return sr(g, "ms") ? b : b * 1e3;
      } else
        return 0;
    }, l = r("transition-delay"), v = r("transition-duration");
    return Ke(v, function(g, b, T) {
      var A = o(l[T]) + o(b);
      return Math.max(g, A);
    }, 0);
  }, Qk = function(t, r) {
    var o = kg(), l = kg(), v, g = function(z) {
      var U, oe = (U = z.raw.pseudoElement) !== null && U !== void 0 ? U : "";
      return Fa(z.target, t) && Po(oe) && Tt(Jy, z.raw.propertyName);
    }, b = function(z) {
      if (pe(z) || g(z)) {
        o.clear(), l.clear();
        var U = z == null ? void 0 : z.raw.type;
        (pe(U) || U === ug()) && (clearTimeout(v), Gi(t, vh), bl(t, r.classes));
      }
    }, T = function() {
      o.set(ai(t, ug(), b)), l.set(ai(t, _k(), b));
    };
    if ("ontransitionstart" in t.dom)
      var A = ai(t, my(), function(z) {
        g(z) && (A.unbind(), T());
      });
    else
      T();
    var R = SS(t);
    requestAnimationFrame(function() {
      v = setTimeout(b, R + 17), Qr(t, vh, v);
    });
  }, h0 = function(t, r) {
    Kd(t, r.classes), No(t, vh).each(function(o) {
      clearTimeout(parseInt(o, 10)), Gi(t, vh);
    }), Qk(t, r);
  }, dh = function(t, r, o, l, v, g) {
    var b = CS(l, v, g);
    if (b || Qy(t, l)) {
      Pr(t, "position", o.position);
      var T = Cg(r, t), A = cv(r, $($({}, v), { rect: T })), R = gt(Jy, function(z) {
        return A[z];
      });
      Jk(o, R) && (zo(t, R), b && h0(t, l), mo(t));
    } else
      bl(t, l.classes);
  }, eT = function(t) {
    return {
      width: ns(t),
      height: Vs(t)
    };
  }, xS = function(t, r, o, l) {
    Da(r, "max-height"), Da(r, "max-width");
    var v = eT(r);
    return xg(r, l.preference, t, v, o, l.bounds);
  }, e2 = function(t, r) {
    var o = r.classes;
    bl(t, o.off), Kd(t, o.on);
  }, tT = function(t, r, o) {
    var l = o.maxHeightFunction;
    l(t, r.maxHeight);
  }, nT = function(t, r, o) {
    var l = o.maxWidthFunction;
    l(t, r.maxWidth);
  }, b0 = function(t, r, o) {
    var l = cv(o.origin, r);
    o.transition.each(function(v) {
      dh(t, o.origin, l, v, r, o.lastPlacement);
    }), nd(t, l);
  }, t2 = function(t, r) {
    Gy(t, r.placement);
  }, mu = function(t, r) {
    C1(t, Math.floor(r));
  }, Tg = ie(function(t, r) {
    mu(t, r), Hs(t, {
      "overflow-x": "hidden",
      "overflow-y": "auto"
    });
  }), Eg = ie(function(t, r) {
    mu(t, r);
  }), kS = function(t, r, o) {
    return t[r] === void 0 ? o : t[r];
  }, rT = function(t, r, o, l, v, g, b, T) {
    var A = kS(b, "maxHeightFunction", Tg()), R = kS(b, "maxWidthFunction", ee), z = t.anchorBox, U = t.origin, oe = {
      bounds: Xk(U, g),
      origin: U,
      preference: l,
      maxHeightFunction: A,
      maxWidthFunction: R,
      lastPlacement: v,
      transition: T
    };
    return mh(z, r, o, oe);
  }, mh = function(t, r, o, l) {
    var v = xS(t, r, o, l);
    return b0(r, v, l), t2(r, v), e2(r, v), tT(r, v, l), nT(r, v, l), {
      layout: v.layout,
      placement: v.placement
    };
  }, gh = [
    "valignCentre",
    "alignLeft",
    "alignRight",
    "alignCentre",
    "top",
    "bottom",
    "left",
    "right",
    "inset"
  ], om = function(t, r, o, l) {
    l === void 0 && (l = 1);
    var v = t * l, g = r * l, b = function(A) {
      return Ft(o, A).getOr([]);
    }, T = function(A, R, z) {
      var U = tt(gh, z);
      return {
        offset: eo(A, R),
        classesOn: St(z, b),
        classesOff: St(U, b)
      };
    };
    return {
      southeast: function() {
        return T(-t, r, [
          "top",
          "alignLeft"
        ]);
      },
      southwest: function() {
        return T(t, r, [
          "top",
          "alignRight"
        ]);
      },
      south: function() {
        return T(-t / 2, r, [
          "top",
          "alignCentre"
        ]);
      },
      northeast: function() {
        return T(-t, -r, [
          "bottom",
          "alignLeft"
        ]);
      },
      northwest: function() {
        return T(t, -r, [
          "bottom",
          "alignRight"
        ]);
      },
      north: function() {
        return T(-t / 2, -r, [
          "bottom",
          "alignCentre"
        ]);
      },
      east: function() {
        return T(t, -r / 2, [
          "valignCentre",
          "left"
        ]);
      },
      west: function() {
        return T(-t, -r / 2, [
          "valignCentre",
          "right"
        ]);
      },
      insetNortheast: function() {
        return T(v, g, [
          "top",
          "alignLeft",
          "inset"
        ]);
      },
      insetNorthwest: function() {
        return T(-v, g, [
          "top",
          "alignRight",
          "inset"
        ]);
      },
      insetNorth: function() {
        return T(-v / 2, g, [
          "top",
          "alignCentre",
          "inset"
        ]);
      },
      insetSoutheast: function() {
        return T(v, -g, [
          "bottom",
          "alignLeft",
          "inset"
        ]);
      },
      insetSouthwest: function() {
        return T(-v, -g, [
          "bottom",
          "alignRight",
          "inset"
        ]);
      },
      insetSouth: function() {
        return T(-v / 2, -g, [
          "bottom",
          "alignCentre",
          "inset"
        ]);
      },
      insetEast: function() {
        return T(-v, -g / 2, [
          "valignCentre",
          "right",
          "inset"
        ]);
      },
      insetWest: function() {
        return T(v, -g / 2, [
          "valignCentre",
          "left",
          "inset"
        ]);
      }
    };
  }, y0 = function() {
    return om(0, 0, {});
  }, ph = Ze, n2 = function(t, r) {
    return function(o) {
      return aT(o) === "rtl" ? r : t;
    };
  }, aT = function(t) {
    return Ho(t, "direction") === "rtl" ? "rtl" : "ltr";
  }, gf;
  (function(t) {
    t.TopToBottom = "toptobottom", t.BottomToTop = "bottomtotop";
  })(gf || (gf = {}));
  var w0 = "data-alloy-vertical-dir", oT = function(t) {
    return pg(t, function(r) {
      return Z(r) && So(r, "data-alloy-vertical-dir") === gf.BottomToTop;
    });
  }, rd = function() {
    return qs("layouts", [
      un("onLtr"),
      un("onRtl"),
      Ba("onBottomLtr"),
      Ba("onBottomRtl")
    ]);
  }, ad = function(t, r, o, l, v, g, b) {
    var T = b.map(oT).getOr(!1), A = r.layouts.map(function(de) {
      return de.onLtr(t);
    }), R = r.layouts.map(function(de) {
      return de.onRtl(t);
    }), z = T ? r.layouts.bind(function(de) {
      return de.onBottomLtr.map(function(Se) {
        return Se(t);
      });
    }).or(A).getOr(v) : A.getOr(o), U = T ? r.layouts.bind(function(de) {
      return de.onBottomRtl.map(function(Se) {
        return Se(t);
      });
    }).or(R).getOr(g) : R.getOr(l), oe = n2(z, U);
    return oe(t);
  }, iT = function(t, r, o) {
    var l = r.hotspot, v = Cg(o, l.element), g = ad(t.element, r, s0(), l0(), td(), u0(), _.some(r.hotspot.element));
    return _.some(ph({
      anchorBox: v,
      bubble: r.bubble.getOr(y0()),
      overrides: r.overrides,
      layouts: g,
      placer: _.none()
    }));
  }, C0 = [
    un("hotspot"),
    Ba("bubble"),
    ct("overrides", {}),
    rd(),
    io("placement", iT)
  ], S0 = function(t, r, o) {
    var l = v0(o, r.x, r.y), v = Ai(l.left, l.top, r.width, r.height), g = ad(t.element, r, Vy(), em(), Vy(), em(), _.none());
    return _.some(ph({
      anchorBox: v,
      bubble: r.bubble,
      overrides: r.overrides,
      layouts: g,
      placer: _.none()
    }));
  }, x0 = [
    un("x"),
    un("y"),
    ct("height", 0),
    ct("width", 0),
    ct("bubble", y0()),
    ct("overrides", {}),
    rd(),
    io("placement", S0)
  ], Yi = fl.generate([
    { screen: ["point"] },
    {
      absolute: [
        "point",
        "scrollLeft",
        "scrollTop"
      ]
    }
  ]), TS = function(t) {
    return t.fold(Ze, function(r, o, l) {
      return r.translate(-o, -l);
    });
  }, r2 = function(t) {
    return t.fold(Ze, Ze);
  }, ES = function(t) {
    return Ke(t, function(r, o) {
      return r.translate(o.left, o.top);
    }, eo(0, 0));
  }, _S = function(t) {
    var r = _t(t, TS);
    return ES(r);
  }, Nc = function(t) {
    var r = _t(t, r2);
    return ES(r);
  }, fv = Yi.screen, AS = Yi.absolute, OS = function(t, r, o) {
    var l = ol(o.root).dom, v = function(g) {
      var b = wo(g), T = wo(t.element);
      return Fa(b, T);
    };
    return _.from(l.frameElement).map(Bn.fromDom).filter(v).map(ts);
  }, a2 = function(t, r, o) {
    var l = wo(t.element), v = Us(l), g = OS(t, r, o).getOr(v);
    return AS(g, v.left, v.top);
  }, k0 = function(t, r, o, l) {
    var v = fv(eo(t, r));
    return _.some(sl(v, o, l));
  }, DS = function(t, r, o, l, v) {
    return t.map(function(g) {
      var b = [
        r,
        g.point
      ], T = rc(l, function() {
        return Nc(b);
      }, function() {
        return Nc(b);
      }, function() {
        return _S(b);
      }), A = ni(T.left, T.top, g.width, g.height), R = o.showAbove ? td() : s0(), z = o.showAbove ? u0() : l0(), U = ad(v, o, R, z, R, z, _.none());
      return ph({
        anchorBox: A,
        bubble: o.bubble.getOr(y0()),
        overrides: o.overrides,
        layouts: U,
        placer: _.none()
      });
    });
  }, _g = function(t, r, o) {
    var l = a2(t, o, r);
    return r.node.filter(Tr).bind(function(v) {
      var g = v.dom.getBoundingClientRect(), b = k0(g.left, g.top, g.width, g.height), T = r.node.getOr(t.element);
      return DS(b, l, r, o, T);
    });
  }, uT = [
    un("node"),
    un("root"),
    Ba("bubble"),
    rd(),
    ct("overrides", {}),
    ct("showAbove", !1),
    io("placement", _g)
  ], hh = "\uFEFF", sT = "\xA0", Ag = function(t, r, o, l) {
    return {
      start: t,
      soffset: r,
      finish: o,
      foffset: l
    };
  }, im = { create: Ag }, o2 = fl.generate([
    { before: ["element"] },
    {
      on: [
        "element",
        "offset"
      ]
    },
    { after: ["element"] }
  ]), BS = function(t, r, o, l) {
    return t.fold(r, o, l);
  }, lT = function(t) {
    return t.fold(Ze, Ze, Ze);
  }, RS = o2.before, MS = o2.on, i2 = o2.after, cT = {
    before: RS,
    on: MS,
    after: i2,
    cata: BS,
    getStart: lT
  }, T0 = fl.generate([
    { domRange: ["rng"] },
    {
      relative: [
        "startSitu",
        "finishSitu"
      ]
    },
    {
      exact: [
        "start",
        "soffset",
        "finish",
        "foffset"
      ]
    }
  ]), fT = function(t) {
    return T0.exact(t.start, t.soffset, t.finish, t.foffset);
  }, bh = function(t) {
    return t.match({
      domRange: function(r) {
        return Bn.fromDom(r.startContainer);
      },
      relative: function(r, o) {
        return cT.getStart(r);
      },
      exact: function(r, o, l, v) {
        return r;
      }
    });
  }, vT = T0.domRange, dT = T0.relative, mT = T0.exact, E0 = function(t) {
    var r = bh(t);
    return ol(r);
  }, gT = im.create, Og = {
    domRange: vT,
    relative: dT,
    exact: mT,
    exactFromRange: fT,
    getWin: E0,
    range: gT
  }, PS = function(t, r) {
    r.fold(function(o) {
      t.setStartBefore(o.dom);
    }, function(o, l) {
      t.setStart(o.dom, l);
    }, function(o) {
      t.setStartAfter(o.dom);
    });
  }, pT = function(t, r) {
    r.fold(function(o) {
      t.setEndBefore(o.dom);
    }, function(o, l) {
      t.setEnd(o.dom, l);
    }, function(o) {
      t.setEndAfter(o.dom);
    });
  }, u2 = function(t, r, o) {
    var l = t.document.createRange();
    return PS(l, r), pT(l, o), l;
  }, NS = function(t, r, o, l, v) {
    var g = t.document.createRange();
    return g.setStart(r.dom, o), g.setEnd(l.dom, v), g;
  }, s2 = function(t) {
    return {
      left: t.left,
      top: t.top,
      right: t.right,
      bottom: t.bottom,
      width: t.width,
      height: t.height
    };
  }, IS = function(t) {
    var r = t.getClientRects(), o = r.length > 0 ? r[0] : t.getBoundingClientRect();
    return o.width > 0 || o.height > 0 ? _.some(o).map(s2) : _.none();
  }, FS = function(t) {
    var r = t.getBoundingClientRect();
    return r.width > 0 || r.height > 0 ? _.some(r).map(s2) : _.none();
  }, Dg = fl.generate([
    {
      ltr: [
        "start",
        "soffset",
        "finish",
        "foffset"
      ]
    },
    {
      rtl: [
        "start",
        "soffset",
        "finish",
        "foffset"
      ]
    }
  ]), l2 = function(t, r, o) {
    return r(Bn.fromDom(o.startContainer), o.startOffset, Bn.fromDom(o.endContainer), o.endOffset);
  }, c2 = function(t, r) {
    return r.match({
      domRange: function(o) {
        return {
          ltr: ie(o),
          rtl: _.none
        };
      },
      relative: function(o, l) {
        return {
          ltr: Et(function() {
            return u2(t, o, l);
          }),
          rtl: Et(function() {
            return _.some(u2(t, l, o));
          })
        };
      },
      exact: function(o, l, v, g) {
        return {
          ltr: Et(function() {
            return NS(t, o, l, v, g);
          }),
          rtl: Et(function() {
            return _.some(NS(t, v, g, o, l));
          })
        };
      }
    });
  }, hT = function(t, r) {
    var o = r.ltr();
    if (o.collapsed) {
      var l = r.rtl().filter(function(v) {
        return v.collapsed === !1;
      });
      return l.map(function(v) {
        return Dg.rtl(Bn.fromDom(v.endContainer), v.endOffset, Bn.fromDom(v.startContainer), v.startOffset);
      }).getOrThunk(function() {
        return l2(t, Dg.ltr, o);
      });
    } else
      return l2(t, Dg.ltr, o);
  }, bT = function(t, r) {
    var o = c2(t, r);
    return hT(t, o);
  }, f2 = function(t, r) {
    var o = bT(t, r);
    return o.match({
      ltr: function(l, v, g, b) {
        var T = t.document.createRange();
        return T.setStart(l.dom, v), T.setEnd(g.dom, b), T;
      },
      rtl: function(l, v, g, b) {
        var T = t.document.createRange();
        return T.setStart(g.dom, b), T.setEnd(l.dom, v), T;
      }
    });
  };
  Dg.ltr, Dg.rtl;
  var yT = function(t, r) {
    var o = function(g) {
      if (!t(g))
        throw new Error("Can only get " + r + " value of a " + r + " node");
      return l(g).getOr("");
    }, l = function(g) {
      return t(g) ? _.from(g.dom.nodeValue) : _.none();
    }, v = function(g, b) {
      if (!t(g))
        throw new Error("Can only set raw " + r + " value of a " + r + " node");
      g.dom.nodeValue = b;
    };
    return {
      get: o,
      getOption: l,
      set: v
    };
  }, $S = yT(ye, "text"), od = function(t) {
    return $S.get(t);
  }, Bg = function(t) {
    return $S.getOption(t);
  }, LS = function(t) {
    return et(t) === "img" ? 1 : Bg(t).fold(function() {
      return O(t).length;
    }, function(r) {
      return r.length;
    });
  }, wT = function(t) {
    return Bg(t).filter(function(r) {
      return r.trim().length !== 0 || r.indexOf(sT) > -1;
    }).isSome();
  }, zS = [
    "img",
    "br"
  ], CT = function(t) {
    var r = wT(t);
    return r || Tt(zS, et(t));
  }, v2 = function(t) {
    return Rg(t, CT);
  }, Rg = function(t, r) {
    var o = function(l) {
      for (var v = O(l), g = v.length - 1; g >= 0; g--) {
        var b = v[g];
        if (r(b))
          return _.some(b);
        var T = o(b);
        if (T.isSome())
          return T;
      }
      return _.none();
    };
    return o(t);
  }, qu = function(t, r) {
    return ql(r, t);
  }, d2 = function(t, r, o, l) {
    var v = wo(t), g = v.dom.createRange();
    return g.setStart(t.dom, r), g.setEnd(o.dom, l), g;
  }, Mg = function(t, r, o, l) {
    var v = d2(t, r, o, l), g = Fa(t, o) && r === l;
    return v.collapsed && !g;
  }, um = function(t) {
    return _.from(t.getSelection());
  }, _0 = function(t) {
    if (t.rangeCount > 0) {
      var r = t.getRangeAt(0), o = t.getRangeAt(t.rangeCount - 1);
      return _.some(im.create(Bn.fromDom(r.startContainer), r.startOffset, Bn.fromDom(o.endContainer), o.endOffset));
    } else
      return _.none();
  }, ST = function(t) {
    if (t.anchorNode === null || t.focusNode === null)
      return _0(t);
    var r = Bn.fromDom(t.anchorNode), o = Bn.fromDom(t.focusNode);
    return Mg(r, t.anchorOffset, o, t.focusOffset) ? _.some(im.create(r, t.anchorOffset, o, t.focusOffset)) : _0(t);
  }, HS = function(t) {
    return um(t).filter(function(r) {
      return r.rangeCount > 0;
    }).bind(ST);
  }, m2 = function(t, r) {
    var o = f2(t, r);
    return IS(o);
  }, _s = function(t, r) {
    var o = f2(t, r);
    return FS(o);
  }, yh = function(t, r) {
    return {
      element: t,
      offset: r
    };
  }, xT = function(t, r) {
    var o = O(t);
    if (o.length === 0)
      return yh(t, r);
    if (r < o.length)
      return yh(o[r], 0);
    var l = o[o.length - 1], v = ye(l) ? od(l).length : O(l).length;
    return yh(l, v);
  }, sm = function(t, r) {
    return ye(t) ? yh(t, r) : xT(t, r);
  }, id = function(t, r) {
    var o = r.getSelection.getOrThunk(function() {
      return function() {
        return HS(t);
      };
    });
    return o().map(function(l) {
      var v = sm(l.start, l.soffset), g = sm(l.finish, l.foffset);
      return Og.range(v.element, v.offset, g.element, g.offset);
    });
  }, Pg = function(t, r, o) {
    var l = ol(r.root).dom, v = a2(t, o, r), g = id(l, r).bind(function(A) {
      var R = _s(l, Og.exactFromRange(A)).orThunk(function() {
        var z = Bn.fromText(hh);
        Yo(A.start, z);
        var U = m2(l, Og.exact(z, 0, z, 1));
        return ws(z), U;
      });
      return R.bind(function(z) {
        return k0(z.left, z.top, z.width, z.height);
      });
    }), b = id(l, r).bind(function(A) {
      return Z(A.start) ? _.some(A.start) : wc(A.start);
    }), T = b.getOr(t.element);
    return DS(g, v, r, o, T);
  }, ud = [
    Ba("getSelection"),
    un("root"),
    Ba("bubble"),
    rd(),
    ct("overrides", {}),
    ct("showAbove", !1),
    io("placement", Pg)
  ], Ic = "link-layout", Fc = function(t) {
    return t.x + t.width;
  }, A0 = function(t, r) {
    return t.x - r.width;
  }, O0 = function(t, r) {
    return t.y - r.height + t.height;
  }, g2 = function(t) {
    return t.y;
  }, Ng = function(t, r, o) {
    return Hi(Fc(t), g2(t), o.southeast(), n0(), "southeast", Mi(t, {
      left: 0,
      top: 2
    }), Ic);
  }, Ig = function(t, r, o) {
    return Hi(A0(t, r), g2(t), o.southwest(), Ny(), "southwest", Mi(t, {
      right: 1,
      top: 2
    }), Ic);
  }, Fg = function(t, r, o) {
    return Hi(Fc(t), O0(t, r), o.northeast(), Iy(), "northeast", Mi(t, {
      left: 0,
      bottom: 3
    }), Ic);
  }, Iu = function(t, r, o) {
    return Hi(A0(t, r), O0(t, r), o.northwest(), Qd(), "northwest", Mi(t, {
      right: 1,
      bottom: 3
    }), Ic);
  }, $g = function() {
    return [
      Ng,
      Ig,
      Fg,
      Iu
    ];
  }, Lg = function() {
    return [
      Ig,
      Ng,
      Iu,
      Fg
    ];
  }, D0 = function(t, r, o) {
    var l = Cg(o, r.item.element), v = ad(t.element, r, $g(), Lg(), $g(), Lg(), _.none());
    return _.some(ph({
      anchorBox: l,
      bubble: y0(),
      overrides: r.overrides,
      layouts: v,
      placer: _.none()
    }));
  }, kT = [
    un("item"),
    rd(),
    ct("overrides", {}),
    io("placement", D0)
  ], p2 = Al("type", {
    selection: ud,
    node: uT,
    hotspot: C0,
    submenu: kT,
    makeshift: x0
  }), B0 = [
    Ru("classes", ri),
    cl("mode", "all", [
      "all",
      "layout",
      "placement"
    ])
  ], gu = [
    ct("useFixed", ge),
    Ba("getBounds")
  ], TT = [
    xs("anchor", p2),
    qs("transition", B0)
  ], pf = function() {
    var t = document.documentElement;
    return jy(0, 0, t.clientWidth, t.clientHeight);
  }, R0 = function(t) {
    var r = ts(t.element), o = t.element.dom.getBoundingClientRect();
    return d0(r.left, r.top, o.width, o.height);
  }, h2 = function(t, r, o, l, v, g, b) {
    var T = m0(o.anchorBox, r);
    return rT(T, v.element, o.bubble, o.layouts, g, l, o.overrides, b);
  }, zg = function(t, r, o, l, v) {
    b2(t, r, o, l, v, _.none());
  }, b2 = function(t, r, o, l, v, g) {
    var b = g.map(si);
    return wh(t, r, o, l, v, b);
  }, wh = function(t, r, o, l, v, g) {
    var b = Ha("placement.info", hr(TT), v), T = b.anchor, A = l.element, R = o.get(l.uid);
    yS(function() {
      Pr(A, "position", "fixed");
      var z = ui(A, "visibility");
      Pr(A, "visibility", "hidden");
      var U = r.useFixed() ? pf() : R0(t), oe = T.placement, de = g.map(ie).or(r.getBounds);
      oe(t, T, U).each(function(Se) {
        var $e = Se.placer.getOr(h2), ut = $e(t, U, Se, de, l, R, b.transition);
        o.set(l.uid, ut);
      }), z.fold(function() {
        Da(A, "visibility");
      }, function(Se) {
        Pr(A, "visibility", Se);
      }), ui(A, "left").isNone() && ui(A, "top").isNone() && ui(A, "right").isNone() && ui(A, "bottom").isNone() && Ir(ui(A, "position"), "fixed") && Da(A, "position");
    }, A);
  }, ET = function(t, r, o) {
    return r.useFixed() ? "fixed" : "absolute";
  }, VS = function(t, r, o, l) {
    var v = l.element;
    Pe([
      "position",
      "left",
      "right",
      "top",
      "bottom"
    ], function(g) {
      return Da(v, g);
    }), Xy(v), o.clear(l.uid);
  }, US = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    position: zg,
    positionWithin: b2,
    positionWithinBounds: wh,
    getMode: ET,
    reset: VS
  }), _T = function() {
    var t = {}, r = function(v, g) {
      t[v] = g;
    }, o = function(v) {
      return Ft(t, v);
    }, l = function(v) {
      Y(v) ? delete t[v] : t = {};
    };
    return Pu({
      readState: function() {
        return t;
      },
      clear: l,
      set: r,
      get: o
    });
  }, Hg = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    init: _T
  }), Jo = Pi({
    fields: gu,
    name: "positioning",
    active: f0,
    apis: US,
    state: Hg
  }), M0 = function(t) {
    Ta(t, sg());
    var r = t.components();
    Pe(r, M0);
  }, P0 = function(t) {
    var r = t.components();
    Pe(r, P0), Ta(t, Gs());
  }, y2 = function(t, r) {
    Ou(t.element, r.element);
  }, jS = function(t) {
    Pe(t.components(), function(r) {
      return ws(r.element);
    }), Oo(t.element), t.syncComponents();
  }, w2 = function(t, r) {
    var o = t.components();
    jS(t);
    var l = tt(o, r);
    Pe(l, function(v) {
      M0(v), t.getSystem().removeFromWorld(v);
    }), Pe(r, function(v) {
      v.getSystem().isConnected() ? y2(t, v) : (t.getSystem().addToWorld(v), y2(t, v), Tr(t.element) && P0(v)), t.syncComponents();
    });
  }, lm = function(t, r) {
    N0(t, r, Ou);
  }, N0 = function(t, r, o) {
    t.getSystem().addToWorld(r), o(t.element, r.element), Tr(t.element) && P0(r), t.syncComponents();
  }, As = function(t) {
    M0(t), ws(t.element), t.getSystem().removeFromWorld(t);
  }, $c = function(t) {
    var r = Co(t.element).bind(function(o) {
      return t.getSystem().getByDom(o).toOptional();
    });
    As(t), r.each(function(o) {
      o.syncComponents();
    });
  }, I0 = function(t) {
    var r = t.components();
    Pe(r, As), Oo(t.element), t.syncComponents();
  }, vv = function(t, r) {
    Lc(t, r, Ou);
  }, ac = function(t, r) {
    Lc(t, r, Gf);
  }, Lc = function(t, r, o) {
    o(t, r.element);
    var l = O(r.element);
    Pe(l, function(v) {
      r.getByDom(v).each(P0);
    });
  }, Gu = function(t) {
    var r = O(t.element);
    Pe(r, function(o) {
      t.getByDom(o).each(M0);
    }), ws(t.element);
  }, Ml = function(t, r, o, l) {
    o.get().each(function(b) {
      I0(t);
    });
    var v = r.getAttachPoint(t);
    lm(v, t);
    var g = t.getSystem().build(l);
    return lm(t, g), o.set(g), g;
  }, Vg = function(t, r, o, l) {
    var v = Ml(t, r, o, l);
    return r.onOpen(t, v), v;
  }, hf = function(t, r, o, l) {
    return o.get().map(function() {
      return Ml(t, r, o, l);
    });
  }, cm = function(t, r, o, l, v) {
    XS(t, r), Vg(t, r, o, l), v(), YS(t, r);
  }, WS = function(t, r, o) {
    o.get().each(function(l) {
      I0(t), $c(t), r.onClose(t, l), o.clear();
    });
  }, qS = function(t, r, o) {
    return o.isOpen();
  }, AT = function(t, r, o, l) {
    return qS(t, r, o) && o.get().exists(function(v) {
      return r.isPartOf(t, v, l);
    });
  }, OT = function(t, r, o) {
    return o.get();
  }, GS = function(t, r, o, l) {
    ui(t.element, r).fold(function() {
      Gi(t.element, o);
    }, function(v) {
      Qr(t.element, o, v);
    }), Pr(t.element, r, l);
  }, KS = function(t, r, o) {
    No(t.element, o).fold(function() {
      return Da(t.element, r);
    }, function(l) {
      return Pr(t.element, r, l);
    });
  }, XS = function(t, r, o) {
    var l = r.getAttachPoint(t);
    Pr(t.element, "position", Jo.getMode(l)), GS(t, "visibility", r.cloakVisibilityAttr, "hidden");
  }, DT = function(t) {
    return Jt([
      "top",
      "left",
      "right",
      "bottom"
    ], function(r) {
      return ui(t, r).isSome();
    });
  }, YS = function(t, r, o) {
    DT(t.element) || Da(t.element, "position"), KS(t, "visibility", r.cloakVisibilityAttr);
  }, BT = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    cloak: XS,
    decloak: YS,
    open: Vg,
    openWhileCloaked: cm,
    close: WS,
    isOpen: qS,
    isPartOf: AT,
    getState: OT,
    setContent: hf
  }), ZS = function(t, r) {
    return ro([cn(Xp(), function(o, l) {
      WS(o, t, r);
    })]);
  }, JS = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    events: ZS
  }), C2 = [
    Ra("onOpen"),
    Ra("onClose"),
    un("isPartOf"),
    un("getAttachPoint"),
    ct("cloakVisibilityAttr", "data-precloak-visibility")
  ], QS = function() {
    var t = Zo(), r = ie("not-implemented");
    return Pu({
      readState: r,
      isOpen: t.isSet,
      clear: t.clear,
      set: t.set,
      get: t.get
    });
  }, RT = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    init: QS
  }), ga = Pi({
    fields: C2,
    name: "sandboxing",
    active: JS,
    apis: BT,
    state: RT
  }), fm = ie("dismiss.popups"), Ug = ie("reposition.popups"), S2 = ie("mouse.released"), MT = js([
    ct("isExtraPart", ge),
    qs("fireEventInstead", [ct("event", ec())])
  ]), Os = function(t) {
    var r, o = Ha("Dismissal", MT, t);
    return r = {}, r[fm()] = {
      schema: js([un("target")]),
      onReceive: function(l, v) {
        if (ga.isOpen(l)) {
          var g = ga.isPartOf(l, v.target) || o.isExtraPart(l, v.target);
          g || o.fireEventInstead.fold(function() {
            return ga.close(l);
          }, function(b) {
            return Ta(l, b.event);
          });
        }
      }
    }, r;
  }, PT = js([
    qs("fireEventInstead", [ct("event", Mu())]),
    Uu("doReposition")
  ]), vm = function(t) {
    var r, o = Ha("Reposition", PT, t);
    return r = {}, r[Ug()] = {
      onReceive: function(l) {
        ga.isOpen(l) && o.fireEventInstead.fold(function() {
          return o.doReposition(l);
        }, function(v) {
          return Ta(l, v.event);
        });
      }
    }, r;
  }, sd = function(t, r, o) {
    r.store.manager.onLoad(t, r, o);
  }, F0 = function(t, r, o) {
    r.store.manager.onUnload(t, r, o);
  }, $0 = function(t, r, o, l) {
    r.store.manager.setValue(t, r, o, l);
  }, NT = function(t, r, o) {
    return r.store.manager.getValue(t, r, o);
  }, ex = function(t, r, o) {
    return o;
  }, L0 = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    onLoad: sd,
    onUnload: F0,
    setValue: $0,
    getValue: NT,
    getState: ex
  }), x2 = function(t, r) {
    var o = t.resetOnDom ? [
      Zr(function(l, v) {
        sd(l, t, r);
      }),
      gl(function(l, v) {
        F0(l, t, r);
      })
    ] : [Bo(t, r, sd)];
    return ro(o);
  }, jg = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    events: x2
  }), z0 = function() {
    var t = Sr(null), r = function() {
      return {
        mode: "memory",
        value: t.get()
      };
    }, o = function() {
      return t.get() === null;
    }, l = function() {
      t.set(null);
    };
    return Pu({
      set: t.set,
      get: t.get,
      isNotSet: o,
      clear: l,
      readState: r
    });
  }, IT = function() {
    var t = ee;
    return Pu({ readState: t });
  }, bf = function() {
    var t = Sr({}), r = Sr({}), o = function() {
      return {
        mode: "dataset",
        dataByValue: t.get(),
        dataByText: r.get()
      };
    }, l = function() {
      t.set({}), r.set({});
    }, v = function(b) {
      return Ft(t.get(), b).orThunk(function() {
        return Ft(r.get(), b);
      });
    }, g = function(b) {
      var T = t.get(), A = r.get(), R = {}, z = {};
      Pe(b, function(U) {
        R[U.value] = U, Ft(U, "meta").each(function(oe) {
          Ft(oe, "text").each(function(de) {
            z[de] = U;
          });
        });
      }), t.set($($({}, T), R)), r.set($($({}, A), z));
    };
    return Pu({
      readState: o,
      lookup: v,
      update: g,
      clear: l
    });
  }, k2 = function(t) {
    return t.store.manager.state(t);
  }, T2 = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    memory: z0,
    dataset: bf,
    manual: IT,
    init: k2
  }), Wg = function(t, r, o, l) {
    var v = r.store;
    o.update([l]), v.setValue(t, l), r.onSetValue(t, l);
  }, E2 = function(t, r, o) {
    var l = r.store, v = l.getDataKey(t);
    return o.lookup(v).getOrThunk(function() {
      return l.getFallbackEntry(v);
    });
  }, Ch = function(t, r, o) {
    var l = r.store;
    l.initialValue.each(function(v) {
      Wg(t, r, o, v);
    });
  }, tx = function(t, r, o) {
    o.clear();
  }, FT = [
    Ba("initialValue"),
    un("getFallbackEntry"),
    un("getDataKey"),
    un("setValue"),
    io("manager", {
      setValue: Wg,
      getValue: E2,
      onLoad: Ch,
      onUnload: tx,
      state: bf
    })
  ], yf = function(t, r, o) {
    return r.store.getValue(t);
  }, Ys = function(t, r, o, l) {
    r.store.setValue(t, l), r.onSetValue(t, l);
  }, pu = function(t, r, o) {
    r.store.initialValue.each(function(l) {
      r.store.setValue(t, l);
    });
  }, $T = [
    un("getValue"),
    ct("setValue", ee),
    Ba("initialValue"),
    io("manager", {
      setValue: Ys,
      getValue: yf,
      onLoad: pu,
      onUnload: ee,
      state: fu.init
    })
  ], _2 = function(t, r, o, l) {
    o.set(l), r.onSetValue(t, l);
  }, qg = function(t, r, o) {
    return o.get();
  }, A2 = function(t, r, o) {
    r.store.initialValue.each(function(l) {
      o.isNotSet() && o.set(l);
    });
  }, Sh = function(t, r, o) {
    o.clear();
  }, O2 = [
    Ba("initialValue"),
    io("manager", {
      setValue: _2,
      getValue: qg,
      onLoad: A2,
      onUnload: Sh,
      state: z0
    })
  ], LT = [
    os("store", { mode: "memory" }, Al("mode", {
      memory: O2,
      manual: $T,
      dataset: FT
    })),
    Ra("onSetValue"),
    ct("resetOnDom", !1)
  ], jn = Pi({
    fields: LT,
    name: "representing",
    active: jg,
    apis: L0,
    extra: {
      setValueFrom: function(t, r) {
        var o = jn.getValue(r);
        jn.setValue(t, o);
      }
    },
    state: T2
  }), Ni = function(t, r) {
    return iy(t, {}, _t(r, function(o) {
      return tg(o.name(), "Cannot configure " + o.name() + " for " + t);
    }).concat([as("dump", Ze)]));
  }, Gg = function(t) {
    return t.dump;
  }, Zi = function(t, r) {
    return $($({}, Fn(r)), t.dump);
  }, Pl = {
    field: Ni,
    augment: Zi,
    get: Gg
  }, D2 = "placeholder", xh = fl.generate([
    {
      single: [
        "required",
        "valueThunk"
      ]
    },
    {
      multiple: [
        "required",
        "valueThunks"
      ]
    }
  ]), H0 = function(t) {
    return yn(t, "uiType");
  }, V0 = function(t, r, o, l) {
    return t.exists(function(v) {
      return v !== o.owner;
    }) ? xh.single(!0, ie(o)) : Ft(l, o.name).fold(function() {
      throw new Error("Unknown placeholder component: " + o.name + `
Known: [` + on(l) + `]
Namespace: ` + t.getOr("none") + `
Spec: ` + JSON.stringify(o, null, 2));
    }, function(v) {
      return v.replace();
    });
  }, U0 = function(t, r, o, l) {
    return H0(o) && o.uiType === D2 ? V0(t, r, o, l) : xh.single(!1, ie(o));
  }, ld = function(t, r, o, l) {
    var v = U0(t, r, o, l);
    return v.fold(function(g, b) {
      var T = H0(o) ? b(r, o.config, o.validated) : b(r), A = Ft(T, "components").getOr([]), R = St(A, function(z) {
        return ld(t, r, z, l);
      });
      return [$($({}, T), { components: R })];
    }, function(g, b) {
      if (H0(o)) {
        var T = b(r, o.config, o.validated), A = o.validated.preprocess.getOr(Ze);
        return A(T);
      } else
        return b(r);
    });
  }, kh = function(t, r, o, l) {
    return St(o, function(v) {
      return ld(t, r, v, l);
    });
  }, B2 = function(t, r) {
    var o = !1, l = function() {
      return o;
    }, v = function() {
      if (o)
        throw new Error("Trying to use the same placeholder more than once: " + t);
      return o = !0, r;
    }, g = function() {
      return r.fold(function(b, T) {
        return b;
      }, function(b, T) {
        return b;
      });
    };
    return {
      name: ie(t),
      required: g,
      used: l,
      replace: v
    };
  }, R2 = function(t, r, o, l) {
    var v = Tn(l, function(b, T) {
      return B2(T, b);
    }), g = kh(t, r, o, v);
    return Un(v, function(b) {
      if (b.used() === !1 && b.required())
        throw new Error("Placeholder: " + b.name() + ` was not found in components list
Namespace: ` + t.getOr("none") + `
Components: ` + JSON.stringify(r.components, null, 2));
    }), g;
  }, M2 = xh.single, zT = xh.multiple, nx = ie(D2), dv = fl.generate([
    { required: ["data"] },
    { external: ["data"] },
    { optional: ["data"] },
    { group: ["data"] }
  ]), wf = ct("factory", { sketch: Ze }), dm = ct("schema", []), Kg = un("name"), P2 = Oi("pname", "pname", da(function(t) {
    return "<alloy." + ur(t.name) + ">";
  }), Xl()), j0 = as("schema", function() {
    return [Ba("preprocess")];
  }), Cf = ct("defaults", ie({})), oc = ct("overrides", ie({})), cd = hr([
    wf,
    dm,
    Kg,
    P2,
    Cf,
    oc
  ]), fd = hr([
    wf,
    dm,
    Kg,
    Cf,
    oc
  ]), mm = hr([
    wf,
    dm,
    Kg,
    P2,
    Cf,
    oc
  ]), Xg = hr([
    wf,
    j0,
    Kg,
    un("unit"),
    P2,
    Cf,
    oc
  ]), N2 = function(t) {
    return t.fold(_.some, _.none, _.some, _.some);
  }, I2 = function(t) {
    var r = function(o) {
      return o.name;
    };
    return t.fold(r, r, r, r);
  }, F2 = function(t) {
    return t.fold(Ze, Ze, Ze, Ze);
  }, W0 = function(t, r) {
    return function(o) {
      var l = Ha("Converting part type", r, o);
      return t(l);
    };
  }, hu = W0(dv.required, cd), wl = W0(dv.external, fd), Nl = W0(dv.optional, mm), Sf = W0(dv.group, Xg), Yg = ie("entirety"), q0 = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    required: hu,
    external: wl,
    optional: Nl,
    group: Sf,
    asNamedPart: N2,
    name: I2,
    asCommon: F2,
    original: Yg
  }), vd = function(t, r, o, l) {
    return Gt(r.defaults(t, o, l), o, { uid: t.partUids[r.name] }, r.overrides(t, o, l));
  }, gm = function(t, r, o) {
    var l = {}, v = {};
    return Pe(o, function(g) {
      g.fold(function(b) {
        l[b.pname] = M2(!0, function(T, A, R) {
          return b.factory.sketch(vd(T, b, A, R));
        });
      }, function(b) {
        var T = r.parts[b.name];
        v[b.name] = ie(b.factory.sketch(vd(r, b, T[Yg()]), T));
      }, function(b) {
        l[b.pname] = M2(!1, function(T, A, R) {
          return b.factory.sketch(vd(T, b, A, R));
        });
      }, function(b) {
        l[b.pname] = zT(!0, function(T, A, R) {
          var z = T[b.name];
          return _t(z, function(U) {
            return b.factory.sketch(Gt(b.defaults(T, U, R), U, b.overrides(T, U)));
          });
        });
      });
    }), {
      internals: ie(l),
      externals: ie(v)
    };
  }, pm = function(t, r) {
    var o = {};
    return Pe(r, function(l) {
      N2(l).each(function(v) {
        var g = HT(t, v.pname);
        o[v.name] = function(b) {
          var T = Ha("Part: " + v.name + " in " + t, hr(v.schema), b);
          return $($({}, g), {
            config: b,
            validated: T
          });
        };
      });
    }), o;
  }, HT = function(t, r) {
    return {
      uiType: nx(),
      owner: t,
      name: r
    };
  }, $2 = function(t, r, o) {
    return {
      uiType: nx(),
      owner: t,
      name: r,
      config: o,
      validated: {}
    };
  }, rx = function(t) {
    return St(t, function(r) {
      return r.fold(_.none, _.some, _.none, _.none).map(function(o) {
        return nf(o.name, o.schema.concat([ed(Yg())]));
      }).toArray();
    });
  }, ax = function(t) {
    return _t(t, I2);
  }, L2 = function(t, r, o) {
    return gm(t, r, o);
  }, z2 = function(t, r, o) {
    return R2(_.some(t), r, r.components, o);
  }, Ya = function(t, r, o) {
    var l = r.partUids[o];
    return t.getSystem().getByUid(l).toOptional();
  }, xf = function(t, r, o) {
    return Ya(t, r, o).getOrDie("Could not find part: " + o);
  }, ox = function(t, r, o) {
    var l = {}, v = r.partUids, g = t.getSystem();
    return Pe(o, function(b) {
      l[b] = ie(g.getByUid(v[b]));
    }), l;
  }, ix = function(t, r) {
    var o = t.getSystem();
    return Tn(r.partUids, function(l, v) {
      return ie(o.getByUid(l));
    });
  }, ux = function(t) {
    return on(t.partUids);
  }, G0 = function(t, r, o) {
    var l = {}, v = r.partUids, g = t.getSystem();
    return Pe(o, function(b) {
      l[b] = ie(g.getByUid(v[b]).getOrDie());
    }), l;
  }, H2 = function(t, r) {
    var o = ax(r);
    return nv(_t(o, function(l) {
      return {
        key: l,
        value: t + "-" + l
      };
    }));
  }, Th = function(t) {
    return Oi("partUids", "partUids", su(function(r) {
      return H2(r.uid, t);
    }), Xl());
  }, Br = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    generate: pm,
    generateOne: $2,
    schemas: rx,
    names: ax,
    substitutes: L2,
    components: z2,
    defaultUids: H2,
    defaultUidsSchema: Th,
    getAllParts: ix,
    getAllPartNames: ux,
    getPart: Ya,
    getPartOrDie: xf,
    getParts: ox,
    getPartsOrDie: G0
  }), VT = function(t, r) {
    var o = t.length > 0 ? [nf("parts", t)] : [];
    return o.concat([
      un("uid"),
      ct("dom", {}),
      ct("components", []),
      ed("originalSpec"),
      ct("debug.sketcher", {})
    ]).concat(r);
  }, V2 = function(t, r, o, l, v) {
    var g = VT(l, v);
    return Ha(t + " [SpecSchema]", js(g.concat(r)), o);
  }, sx = function(t, r, o, l) {
    var v = lx(l), g = V2(t, r, v, [], []);
    return o(g, v);
  }, U2 = function(t, r, o, l, v) {
    var g = lx(v), b = rx(o), T = Th(o), A = V2(t, r, g, b, [T]), R = L2(t, A, o), z = z2(t, A, R.internals());
    return l(A, z, g, R.externals());
  }, UT = function(t) {
    return yn(t, "uid");
  }, lx = function(t) {
    return UT(t) ? t : $($({}, t), { uid: Gv("uid") });
  }, j2 = function(t) {
    return t.uid !== void 0;
  }, W2 = js([
    un("name"),
    un("factory"),
    un("configFields"),
    ct("apis", {}),
    ct("extraApis", {})
  ]), jT = js([
    un("name"),
    un("factory"),
    un("configFields"),
    un("partFields"),
    ct("apis", {}),
    ct("extraApis", {})
  ]), Cl = function(t) {
    var r = Ha("Sketcher for " + t.name, W2, t), o = function(g) {
      return sx(r.name, r.configFields, r.factory, g);
    }, l = Tn(r.apis, Fo), v = Tn(r.extraApis, function(g, b) {
      return Wd(g, b);
    });
    return $($({
      name: r.name,
      configFields: r.configFields,
      sketch: o
    }, l), v);
  }, ds = function(t) {
    var r = Ha("Sketcher for " + t.name, jT, t), o = function(b) {
      return U2(r.name, r.configFields, r.partFields, r.factory, b);
    }, l = pm(r.name, r.partFields), v = Tn(r.apis, Fo), g = Tn(r.extraApis, function(b, T) {
      return Wd(b, T);
    });
    return $($({
      name: r.name,
      partFields: r.partFields,
      configFields: r.configFields,
      sketch: o,
      parts: l
    }, v), g);
  }, kf = function(t) {
    return et(t) === "input" && So(t, "type") !== "radio" || et(t) === "textarea";
  }, WT = function(t, r, o) {
    return r.find(t);
  }, qT = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    getCurrent: WT
  }), q2 = [un("find")], la = Pi({
    fields: q2,
    name: "composing",
    apis: qT
  }), GT = [
    "input",
    "button",
    "textarea",
    "select"
  ], K0 = function(t, r, o) {
    var l = r.disabled() ? G2 : dd;
    l(t, r);
  }, X0 = function(t, r) {
    return r.useNative === !0 && Tt(GT, et(t.element));
  }, Y0 = function(t) {
    return w1(t.element, "disabled");
  }, Eh = function(t) {
    Qr(t.element, "disabled", "disabled");
  }, mv = function(t) {
    Gi(t.element, "disabled");
  }, _h = function(t) {
    return So(t.element, "aria-disabled") === "true";
  }, KT = function(t) {
    Qr(t.element, "aria-disabled", "true");
  }, cx = function(t) {
    Qr(t.element, "aria-disabled", "false");
  }, G2 = function(t, r, o) {
    r.disableClass.each(function(v) {
      Di(t.element, v);
    });
    var l = X0(t, r) ? Eh : KT;
    l(t), r.onDisabled(t);
  }, dd = function(t, r, o) {
    r.disableClass.each(function(v) {
      yi(t.element, v);
    });
    var l = X0(t, r) ? mv : cx;
    l(t), r.onEnabled(t);
  }, Z0 = function(t, r) {
    return X0(t, r) ? Y0(t) : _h(t);
  }, fx = function(t, r, o, l) {
    var v = l ? G2 : dd;
    v(t, r);
  }, XT = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    enable: dd,
    disable: G2,
    isDisabled: Z0,
    onLoad: K0,
    set: fx
  }), YT = function(t, r) {
    return nc({ classes: r.disabled() ? r.disableClass.toArray() : [] });
  }, ZT = function(t, r) {
    return ro([
      wy(vl(), function(o, l) {
        return Z0(o, t);
      }),
      Bo(t, r, K0)
    ]);
  }, hm = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    exhibit: YT,
    events: ZT
  }), K2 = [
    co("disabled", ge),
    ct("useNative", !0),
    Ba("disableClass"),
    Ra("onDisabled"),
    Ra("onEnabled")
  ], Cr = Pi({
    fields: K2,
    name: "disabling",
    active: hm,
    apis: XT
  }), vx = function(t, r, o, l) {
    var v = qu(t.element, "." + r.highlightClass);
    Pe(v, function(g) {
      Jt(l, function(b) {
        return b.element === g;
      }) || (yi(g, r.highlightClass), t.getSystem().getByDom(g).each(function(b) {
        r.onDehighlight(t, b), Ta(b, M1());
      }));
    });
  }, dx = function(t, r, o) {
    return vx(t, r, o, []);
  }, JT = function(t, r, o, l) {
    X2(t, r, o, l) && (yi(l.element, r.highlightClass), r.onDehighlight(t, l), Ta(l, M1()));
  }, Ah = function(t, r, o, l) {
    vx(t, r, o, [l]), X2(t, r, o, l) || (Di(l.element, r.highlightClass), r.onHighlight(t, l), Ta(l, yy()));
  }, Ku = function(t, r, o) {
    Z2(t, r).each(function(l) {
      Ah(t, r, o, l);
    });
  }, Oh = function(t, r, o) {
    J2(t, r).each(function(l) {
      Ah(t, r, o, l);
    });
  }, QT = function(t, r, o, l) {
    gx(t, r, o, l).fold(function(v) {
      throw v;
    }, function(v) {
      Ah(t, r, o, v);
    });
  }, mx = function(t, r, o, l) {
    var v = px(t, r), g = pt(v, l);
    g.each(function(b) {
      Ah(t, r, o, b);
    });
  }, X2 = function(t, r, o, l) {
    return us(l.element, r.highlightClass);
  }, Y2 = function(t, r, o) {
    return Bi(t.element, "." + r.highlightClass).bind(function(l) {
      return t.getSystem().getByDom(l).toOptional();
    });
  }, gx = function(t, r, o, l) {
    var v = qu(t.element, "." + r.itemClass);
    return _.from(v[l]).fold(function() {
      return ea.error(new Error("No element found with index " + l));
    }, t.getSystem().getByDom);
  }, Z2 = function(t, r, o) {
    return Bi(t.element, "." + r.itemClass).bind(function(l) {
      return t.getSystem().getByDom(l).toOptional();
    });
  }, J2 = function(t, r, o) {
    var l = qu(t.element, "." + r.itemClass), v = l.length > 0 ? _.some(l[l.length - 1]) : _.none();
    return v.bind(function(g) {
      return t.getSystem().getByDom(g).toOptional();
    });
  }, gv = function(t, r, o, l) {
    var v = qu(t.element, "." + r.itemClass), g = sn(v, function(b) {
      return us(b, r.highlightClass);
    });
    return g.bind(function(b) {
      var T = du(b, l, 0, v.length - 1);
      return t.getSystem().getByDom(v[T]).toOptional();
    });
  }, eE = function(t, r, o) {
    return gv(t, r, o, -1);
  }, tE = function(t, r, o) {
    return gv(t, r, o, 1);
  }, px = function(t, r, o) {
    var l = qu(t.element, "." + r.itemClass);
    return Mr(_t(l, function(v) {
      return t.getSystem().getByDom(v).toOptional();
    }));
  }, nE = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    dehighlightAll: dx,
    dehighlight: JT,
    highlight: Ah,
    highlightFirst: Ku,
    highlightLast: Oh,
    highlightAt: QT,
    highlightBy: mx,
    isHighlighted: X2,
    getHighlighted: Y2,
    getFirst: Z2,
    getLast: J2,
    getPrevious: eE,
    getNext: tE,
    getCandidates: px
  }), Dh = [
    un("highlightClass"),
    un("itemClass"),
    Ra("onHighlight"),
    Ra("onDehighlight")
  ], Na = Pi({
    fields: Dh,
    name: "highlighting",
    apis: nE
  }), J0 = [8], pv = [9], ic = [13], md = [27], Ds = [32], Q0 = [37], bm = [38], Zg = [39], gd = [40], rE = function(t, r, o) {
    var l = he(t.slice(0, r)), v = he(t.slice(r + 1));
    return pt(l.concat(v), o);
  }, hx = function(t, r, o) {
    var l = he(t.slice(0, r));
    return pt(l, o);
  }, aE = function(t, r, o) {
    var l = t.slice(0, r), v = t.slice(r + 1);
    return pt(v.concat(l), o);
  }, oE = function(t, r, o) {
    var l = t.slice(r + 1);
    return pt(l, o);
  }, ua = function(t) {
    return function(r) {
      var o = r.raw;
      return Tt(t, o.which);
    };
  }, uc = function(t) {
    return function(r) {
      return Xe(t, function(o) {
        return o(r);
      });
    };
  }, Jg = function(t) {
    var r = t.raw;
    return r.shiftKey === !0;
  }, bx = function(t) {
    var r = t.raw;
    return r.ctrlKey === !0;
  }, Bh = Ct(Jg), pa = function(t, r) {
    return {
      matches: t,
      classification: r
    };
  }, yx = function(t, r) {
    var o = pt(t, function(l) {
      return l.matches(r);
    });
    return o.map(function(l) {
      return l.classification;
    });
  }, Cx = function(t, r, o) {
    var l = r.exists(function(v) {
      return o.exists(function(g) {
        return Fa(g, v);
      });
    });
    l || xr(t, R1(), {
      prevFocus: r,
      newFocus: o
    });
  }, Rh = function() {
    var t = function(o) {
      return Pc(o.element);
    }, r = function(o, l) {
      var v = t(o);
      o.getSystem().triggerFocus(l, o.element);
      var g = t(o);
      Cx(o, v, g);
    };
    return {
      get: t,
      set: r
    };
  }, Sx = function() {
    var t = function(o) {
      return Na.getHighlighted(o).map(function(l) {
        return l.element;
      });
    }, r = function(o, l) {
      var v = t(o);
      o.getSystem().getByDom(l).fold(ee, function(b) {
        Na.highlight(o, b);
      });
      var g = t(o);
      Cx(o, v, g);
    };
    return {
      get: t,
      set: r
    };
  }, Mh;
  (function(t) {
    t.OnFocusMode = "onFocus", t.OnEnterOrSpaceMode = "onEnterOrSpace", t.OnApiMode = "onApi";
  })(Mh || (Mh = {}));
  var ym = function(t, r, o, l, v) {
    var g = function() {
      return t.concat([
        ct("focusManager", Rh()),
        os("focusInside", "onFocus", eg(function(R) {
          return Tt([
            "onFocus",
            "onEnterOrSpace",
            "onApi"
          ], R) ? ea.value(R) : ea.error("Invalid value for focusInside");
        })),
        io("handler", A),
        io("state", r),
        io("sendFocusIn", v)
      ]);
    }, b = function(R, z, U, oe, de) {
      var Se = U(R, z, oe, de);
      return yx(Se, z.event).bind(function($e) {
        return $e(R, z, oe, de);
      });
    }, T = function(R, z) {
      var U = R.focusInside !== Mh.OnFocusMode ? _.none() : v(R).map(function(Se) {
        return cn(zv(), function($e, ut) {
          Se($e, R, z), ut.stop();
        });
      }), oe = function(Se, $e) {
        var ut = ua(Ds.concat(ic))($e.event);
        R.focusInside === Mh.OnEnterOrSpaceMode && ut && XC(Se, $e) && v(R).each(function(Ne) {
          Ne(Se, R, z), $e.stop();
        });
      }, de = [
        cn(A1(), function(Se, $e) {
          b(Se, $e, o, R, z).fold(function() {
            oe(Se, $e);
          }, function(ut) {
            $e.stop();
          });
        }),
        cn(dy(), function(Se, $e) {
          b(Se, $e, l, R, z).each(function(ut) {
            $e.stop();
          });
        })
      ];
      return ro(U.toArray().concat(de));
    }, A = {
      schema: g,
      processKey: b,
      toEvents: T
    };
    return A;
  }, Q2 = function(t) {
    var r = [
      Ba("onEscape"),
      Ba("onEnter"),
      ct("selector", '[data-alloy-tabstop="true"]:not(:disabled)'),
      ct("firstTabstop", 0),
      ct("useTabstopAt", xe),
      Ba("visibilitySelector")
    ].concat([t]), o = function($e, ut) {
      var Ne = $e.visibilitySelector.bind(function(ft) {
        return Rl(ut, ft);
      }).getOr(ut);
      return hi(Ne) > 0;
    }, l = function($e, ut) {
      var Ne = qu($e.element, ut.selector), ft = We(Ne, function(Ht) {
        return o(ut, Ht);
      });
      return _.from(ft[ut.firstTabstop]);
    }, v = function($e, ut) {
      return ut.focusManager.get($e).bind(function(Ne) {
        return Rl(Ne, ut.selector);
      });
    }, g = function($e, ut) {
      return o($e, ut) && $e.useTabstopAt(ut);
    }, b = function($e, ut, Ne) {
      l($e, ut).each(function(ft) {
        ut.focusManager.set($e, ft);
      });
    }, T = function($e, ut, Ne, ft, Ht) {
      return Ht(ut, Ne, function(Kt) {
        return g(ft, Kt);
      }).fold(function() {
        return ft.cyclic ? _.some(!0) : _.none();
      }, function(Kt) {
        return ft.focusManager.set($e, Kt), _.some(!0);
      });
    }, A = function($e, ut, Ne, ft) {
      var Ht = qu($e.element, Ne.selector);
      return v($e, Ne).bind(function(Kt) {
        var st = sn(Ht, Pt(Fa, Kt));
        return st.bind(function(Bt) {
          return T($e, Ht, Bt, Ne, ft);
        });
      });
    }, R = function($e, ut, Ne) {
      var ft = Ne.cyclic ? rE : hx;
      return A($e, ut, Ne, ft);
    }, z = function($e, ut, Ne) {
      var ft = Ne.cyclic ? aE : oE;
      return A($e, ut, Ne, ft);
    }, U = function($e, ut, Ne) {
      return Ne.onEnter.bind(function(ft) {
        return ft($e, ut);
      });
    }, oe = function($e, ut, Ne) {
      return Ne.onEscape.bind(function(ft) {
        return ft($e, ut);
      });
    }, de = ie([
      pa(uc([
        Jg,
        ua(pv)
      ]), R),
      pa(ua(pv), z),
      pa(ua(md), oe),
      pa(uc([
        Bh,
        ua(ic)
      ]), U)
    ]), Se = ie([]);
    return ym(r, fu.init, de, Se, function() {
      return _.some(b);
    });
  }, ew = Q2(as("cyclic", ge)), xx = Q2(as("cyclic", xe)), kx = function(t, r, o) {
    return P1(t, o, vl()), _.some(!0);
  }, pd = function(t, r, o) {
    var l = kf(o) && ua(Ds)(r.event);
    return l ? _.none() : kx(t, r, o);
  }, wm = function(t, r) {
    return _.some(!0);
  }, tw = [
    ct("execute", pd),
    ct("useSpace", !1),
    ct("useEnter", !0),
    ct("useControlEnter", !1),
    ct("useDown", !1)
  ], Tx = function(t, r, o) {
    return o.execute(t, r, t.element);
  }, eb = function(t, r, o, l) {
    var v = o.useSpace && !kf(t.element) ? Ds : [], g = o.useEnter ? ic : [], b = o.useDown ? gd : [], T = v.concat(g).concat(b);
    return [pa(ua(T), Tx)].concat(o.useControlEnter ? [pa(uc([
      bx,
      ua(ic)
    ]), Tx)] : []);
  }, iE = function(t, r, o, l) {
    return o.useSpace && !kf(t.element) ? [pa(ua(Ds), wm)] : [];
  }, Qg = ym(tw, fu.init, eb, iE, function() {
    return _.none();
  }), nw = function() {
    var t = Zo(), r = function(v, g) {
      t.set({
        numRows: v,
        numColumns: g
      });
    }, o = function() {
      return t.get().map(function(v) {
        return v.numRows;
      });
    }, l = function() {
      return t.get().map(function(v) {
        return v.numColumns;
      });
    };
    return Pu({
      readState: function() {
        return t.get().map(function(v) {
          return {
            numRows: String(v.numRows),
            numColumns: String(v.numColumns)
          };
        }).getOr({
          numRows: "?",
          numColumns: "?"
        });
      },
      setGridSize: r,
      getNumRows: o,
      getNumColumns: l
    });
  }, rw = function(t) {
    return t.state(t);
  }, Ex = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    flatgrid: nw,
    init: rw
  }), aw = function(t) {
    return function(r, o, l, v) {
      var g = t(r.element);
      return iw(g, r, o, l, v);
    };
  }, tb = function(t, r) {
    var o = n2(t, r);
    return aw(o);
  }, nb = function(t, r) {
    var o = n2(r, t);
    return aw(o);
  }, ow = function(t) {
    return function(r, o, l, v) {
      return iw(t, r, o, l, v);
    };
  }, iw = function(t, r, o, l, v) {
    var g = l.focusManager.get(r).bind(function(b) {
      return t(r.element, b, l, v);
    });
    return g.map(function(b) {
      return l.focusManager.set(r, b), !0;
    });
  }, _x = ow, Cm = ow, ep = ow, Ax = function(t) {
    return t.offsetWidth <= 0 && t.offsetHeight <= 0;
  }, Ox = function(t) {
    return !Ax(t.dom);
  }, rb = function(t, r) {
    return sn(t, r).map(function(o) {
      return {
        index: o,
        candidates: t
      };
    });
  }, Dx = function(t, r, o) {
    var l = function(b) {
      return Fa(b, r);
    }, v = qu(t, o), g = We(v, Ox);
    return rb(g, l);
  }, Bx = function(t, r) {
    return sn(t, function(o) {
      return Fa(r, o);
    });
  }, uw = function(t, r, o, l) {
    var v = Math.floor(r / o), g = r % o;
    return l(v, g).bind(function(b) {
      var T = b.row * o + b.column;
      return T >= 0 && T < t.length ? _.some(t[T]) : _.none();
    });
  }, Rx = function(t, r, o, l, v) {
    return uw(t, r, l, function(g, b) {
      var T = g === o - 1, A = T ? t.length - g * l : l, R = du(b, v, 0, A - 1);
      return _.some({
        row: g,
        column: R
      });
    });
  }, Mx = function(t, r, o, l, v) {
    return uw(t, r, l, function(g, b) {
      var T = du(g, v, 0, o - 1), A = T === o - 1, R = A ? t.length - T * l : l, z = Xs(b, 0, R - 1);
      return _.some({
        row: T,
        column: z
      });
    });
  }, Px = function(t, r, o, l) {
    return Rx(t, r, o, l, 1);
  }, uE = function(t, r, o, l) {
    return Rx(t, r, o, l, -1);
  }, Nx = function(t, r, o, l) {
    return Mx(t, r, o, l, -1);
  }, sw = function(t, r, o, l) {
    return Mx(t, r, o, l, 1);
  }, tp = [
    un("selector"),
    ct("execute", pd),
    Ri("onEscape"),
    ct("captureTab", !1),
    e0()
  ], sE = function(t, r, o) {
    Bi(t.element, r.selector).each(function(l) {
      r.focusManager.set(t, l);
    });
  }, Ix = function(t, r) {
    return r.focusManager.get(t).bind(function(o) {
      return Rl(o, r.selector);
    });
  }, Fx = function(t, r, o, l) {
    return Ix(t, o).bind(function(v) {
      return o.execute(t, r, v);
    });
  }, Il = function(t) {
    return function(r, o, l, v) {
      return Dx(r, o, l.selector).bind(function(g) {
        return t(g.candidates, g.index, v.getNumRows().getOr(l.initSize.numRows), v.getNumColumns().getOr(l.initSize.numColumns));
      });
    };
  }, $x = function(t, r, o) {
    return o.captureTab ? _.some(!0) : _.none();
  }, Lx = function(t, r, o) {
    return o.onEscape(t, r);
  }, ab = Il(uE), ob = Il(Px), lw = Il(Nx), Sm = Il(sw), np = ie([
    pa(ua(Q0), tb(ab, ob)),
    pa(ua(Zg), nb(ab, ob)),
    pa(ua(bm), _x(lw)),
    pa(ua(gd), Cm(Sm)),
    pa(uc([
      Jg,
      ua(pv)
    ]), $x),
    pa(uc([
      Bh,
      ua(pv)
    ]), $x),
    pa(ua(md), Lx),
    pa(ua(Ds.concat(ic)), Fx)
  ]), zx = ie([pa(ua(Ds), wm)]), Hx = ym(tp, nw, np, zx, function() {
    return _.some(sE);
  }), ib = function(t, r, o, l) {
    var v = function(b) {
      return et(b) === "button" && So(b, "disabled") === "disabled";
    }, g = function(b, T, A) {
      var R = du(T, l, 0, A.length - 1);
      return R === b ? _.none() : v(A[R]) ? g(b, R, A) : _.from(A[R]);
    };
    return Dx(t, o, r).bind(function(b) {
      var T = b.index, A = b.candidates;
      return g(T, T, A);
    });
  }, lE = [
    un("selector"),
    ct("getInitial", _.none),
    ct("execute", pd),
    Ri("onEscape"),
    ct("executeOnMove", !1),
    ct("allowVertical", !0)
  ], ub = function(t, r) {
    return r.focusManager.get(t).bind(function(o) {
      return Rl(o, r.selector);
    });
  }, Ph = function(t, r, o) {
    return ub(t, o).bind(function(l) {
      return o.execute(t, r, l);
    });
  }, sb = function(t, r, o) {
    r.getInitial(t).orThunk(function() {
      return Bi(t.element, r.selector);
    }).each(function(l) {
      r.focusManager.set(t, l);
    });
  }, Vx = function(t, r, o) {
    return ib(t, o.selector, r, -1);
  }, lb = function(t, r, o) {
    return ib(t, o.selector, r, 1);
  }, Fl = function(t) {
    return function(r, o, l, v) {
      return t(r, o, l, v).bind(function() {
        return l.executeOnMove ? Ph(r, o, l) : _.some(!0);
      });
    };
  }, cE = function(t, r, o) {
    return o.onEscape(t, r);
  }, cb = function(t, r, o, l) {
    var v = Q0.concat(o.allowVertical ? bm : []), g = Zg.concat(o.allowVertical ? gd : []);
    return [
      pa(ua(v), Fl(tb(Vx, lb))),
      pa(ua(g), Fl(nb(Vx, lb))),
      pa(ua(ic), Ph),
      pa(ua(Ds), Ph),
      pa(ua(md), cE)
    ];
  }, Ux = ie([pa(ua(Ds), wm)]), Nh = ym(lE, fu.init, cb, Ux, function() {
    return _.some(sb);
  }), Ih = function(t, r, o) {
    return _.from(t[r]).bind(function(l) {
      return _.from(l[o]).map(function(v) {
        return {
          rowIndex: r,
          columnIndex: o,
          cell: v
        };
      });
    });
  }, cw = function(t, r, o, l) {
    var v = t[r], g = v.length, b = du(o, l, 0, g - 1);
    return Ih(t, r, b);
  }, jx = function(t, r, o, l) {
    var v = du(o, l, 0, t.length - 1), g = t[v].length, b = Xs(r, 0, g - 1);
    return Ih(t, v, b);
  }, Wx = function(t, r, o, l) {
    var v = t[r], g = v.length, b = Xs(o + l, 0, g - 1);
    return Ih(t, r, b);
  }, qx = function(t, r, o, l) {
    var v = Xs(o + l, 0, t.length - 1), g = t[v].length, b = Xs(r, 0, g - 1);
    return Ih(t, v, b);
  }, fb = function(t, r, o) {
    return cw(t, r, o, 1);
  }, hd = function(t, r, o) {
    return cw(t, r, o, -1);
  }, fE = function(t, r, o) {
    return jx(t, o, r, -1);
  }, vE = function(t, r, o) {
    return jx(t, o, r, 1);
  }, dE = function(t, r, o) {
    return Wx(t, r, o, -1);
  }, bd = function(t, r, o) {
    return Wx(t, r, o, 1);
  }, mE = function(t, r, o) {
    return qx(t, o, r, -1);
  }, fw = function(t, r, o) {
    return qx(t, o, r, 1);
  }, gE = [
    nf("selectors", [
      un("row"),
      un("cell")
    ]),
    ct("cycles", !0),
    ct("previousSelector", _.none),
    ct("execute", pd)
  ], rp = function(t, r, o) {
    var l = r.previousSelector(t).orThunk(function() {
      var v = r.selectors;
      return Bi(t.element, v.cell);
    });
    l.each(function(v) {
      r.focusManager.set(t, v);
    });
  }, vw = function(t, r, o) {
    return Pc(t.element).bind(function(l) {
      return o.execute(t, r, l);
    });
  }, Gx = function(t, r) {
    return _t(t, function(o) {
      return qu(o, r.selectors.cell);
    });
  }, vb = function(t, r) {
    return function(o, l, v) {
      var g = v.cycles ? t : r;
      return Rl(l, v.selectors.row).bind(function(b) {
        var T = qu(b, v.selectors.cell);
        return Bx(T, l).bind(function(A) {
          var R = qu(o, v.selectors.row);
          return Bx(R, b).bind(function(z) {
            var U = Gx(R, v);
            return g(U, z, A).map(function(oe) {
              return oe.cell;
            });
          });
        });
      });
    };
  }, Kx = vb(hd, dE), Xx = vb(fb, bd), pE = vb(fE, mE), db = vb(vE, fw), mb = ie([
    pa(ua(Q0), tb(Kx, Xx)),
    pa(ua(Zg), nb(Kx, Xx)),
    pa(ua(bm), _x(pE)),
    pa(ua(gd), Cm(db)),
    pa(ua(Ds.concat(ic)), vw)
  ]), dw = ie([pa(ua(Ds), wm)]), Yx = ym(gE, fu.init, mb, dw, function() {
    return _.some(rp);
  }), Zx = [
    un("selector"),
    ct("execute", pd),
    ct("moveOnTab", !1)
  ], xm = function(t, r, o) {
    return o.focusManager.get(t).bind(function(l) {
      return o.execute(t, r, l);
    });
  }, Fh = function(t, r, o) {
    Bi(t.element, r.selector).each(function(l) {
      r.focusManager.set(t, l);
    });
  }, gb = function(t, r, o) {
    return ib(t, o.selector, r, -1);
  }, $h = function(t, r, o) {
    return ib(t, o.selector, r, 1);
  }, Jx = function(t, r, o, l) {
    return o.moveOnTab ? ep(gb)(t, r, o, l) : _.none();
  }, hv = function(t, r, o, l) {
    return o.moveOnTab ? ep($h)(t, r, o, l) : _.none();
  }, hE = ie([
    pa(ua(bm), ep(gb)),
    pa(ua(gd), ep($h)),
    pa(uc([
      Jg,
      ua(pv)
    ]), Jx),
    pa(uc([
      Bh,
      ua(pv)
    ]), hv),
    pa(ua(ic), xm),
    pa(ua(Ds), xm)
  ]), Tf = ie([pa(ua(Ds), wm)]), Qx = ym(Zx, fu.init, hE, Tf, function() {
    return _.some(Fh);
  }), pb = [
    Ri("onSpace"),
    Ri("onEnter"),
    Ri("onShiftEnter"),
    Ri("onLeft"),
    Ri("onRight"),
    Ri("onTab"),
    Ri("onShiftTab"),
    Ri("onUp"),
    Ri("onDown"),
    Ri("onEscape"),
    ct("stopSpaceKeyup", !1),
    Ba("focusIn")
  ], mw = function(t, r, o) {
    return [
      pa(ua(Ds), o.onSpace),
      pa(uc([
        Bh,
        ua(ic)
      ]), o.onEnter),
      pa(uc([
        Jg,
        ua(ic)
      ]), o.onShiftEnter),
      pa(uc([
        Jg,
        ua(pv)
      ]), o.onShiftTab),
      pa(uc([
        Bh,
        ua(pv)
      ]), o.onTab),
      pa(ua(bm), o.onUp),
      pa(ua(gd), o.onDown),
      pa(ua(Q0), o.onLeft),
      pa(ua(Zg), o.onRight),
      pa(ua(Ds), o.onSpace),
      pa(ua(md), o.onEscape)
    ];
  }, bE = function(t, r, o) {
    return o.stopSpaceKeyup ? [pa(ua(Ds), wm)] : [];
  }, yd = ym(pb, fu.init, mw, bE, function(t) {
    return t.focusIn;
  }), e4 = ew.schema(), t4 = xx.schema(), yE = Nh.schema(), gw = Hx.schema(), ap = Yx.schema(), op = Qg.schema(), n4 = Qx.schema(), pw = yd.schema(), sc = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    acyclic: e4,
    cyclic: t4,
    flow: yE,
    flatgrid: gw,
    matrix: ap,
    execution: op,
    menu: n4,
    special: pw
  }), wd = function(t) {
    return Yn(t, "setGridSize");
  }, Er = nm({
    branchKey: "mode",
    branches: sc,
    name: "keying",
    active: {
      events: function(t, r) {
        var o = t.handler;
        return o.toEvents(t, r);
      }
    },
    apis: {
      focusIn: function(t, r, o) {
        r.sendFocusIn(r).fold(function() {
          t.getSystem().triggerFocus(t.element, t.element);
        }, function(l) {
          l(t, r, o);
        });
      },
      setGridSize: function(t, r, o, l, v) {
        wd(o) ? o.setGridSize(l, v) : console.error("Layout does not support setGridSize");
      }
    },
    state: Ex
  }), hw = function(t, r, o, l) {
    yS(function() {
      var v = _t(l, t.getSystem().build);
      w2(t, v);
    }, t.element);
  }, Ef = function(t, r, o, l) {
    var v = t.getSystem().build(l);
    N0(t, v, o);
  }, r4 = function(t, r, o, l) {
    Ef(t, r, Ou, l);
  }, wE = function(t, r, o, l) {
    Ef(t, r, Kf, l);
  }, a4 = function(t, r, o, l) {
    var v = Lh(t), g = pt(v, function(b) {
      return Fa(l.element, b.element);
    });
    g.each($c);
  }, Lh = function(t, r) {
    return t.components();
  }, zc = function(t, r, o, l, v) {
    var g = Lh(t);
    return _.from(g[l]).map(function(b) {
      return a4(t, r, o, b), v.each(function(T) {
        Ef(t, r, function(A, R) {
          xc(A, R, l);
        }, T);
      }), b;
    });
  }, hb = function(t, r, o, l, v) {
    var g = Lh(t);
    return sn(g, l).bind(function(b) {
      return zc(t, r, o, b, v);
    });
  }, o4 = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    append: r4,
    prepend: wE,
    remove: a4,
    replaceAt: zc,
    replaceBy: hb,
    set: hw,
    contents: Lh
  }), qr = Pi({
    fields: [],
    name: "replacing",
    apis: o4
  }), bw = function(t, r) {
    var o = ro(r);
    return Pi({
      fields: [un("enabled")],
      name: t,
      active: { events: ie(o) }
    });
  }, Jr = function(t, r) {
    var o = bw(t, r);
    return {
      key: t,
      value: {
        config: {},
        me: o,
        configAsRaw: ie({}),
        initialConfig: {},
        state: fu
      }
    };
  }, yw = function(t, r) {
    r.ignore || (Mc(t.element), r.onFocus(t));
  }, i4 = function(t, r) {
    r.ignore || sh(t.element);
  }, u4 = function(t) {
    return lh(t.element);
  }, ip = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    focus: yw,
    blur: i4,
    isFocused: u4
  }), up = function(t, r) {
    var o = r.ignore ? {} : { attributes: { tabindex: "-1" } };
    return nc(o);
  }, sp = function(t) {
    return ro([cn(zv(), function(r, o) {
      yw(r, t), o.stop();
    })].concat(t.stopMousedown ? [cn(Ql(), function(r, o) {
      o.event.prevent();
    })] : []));
  }, lp = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    exhibit: up,
    events: sp
  }), CE = [
    Ra("onFocus"),
    ct("stopMousedown", !1),
    ct("ignore", !1)
  ], zr = Pi({
    fields: CE,
    name: "focusing",
    active: lp,
    apis: ip
  }), s4 = function(t) {
    var r = function() {
      var o = Sr(t), l = function() {
        return o.get();
      }, v = function(T) {
        return o.set(T);
      }, g = function() {
        return o.set(t);
      }, b = function() {
        return o.get();
      };
      return {
        get: l,
        set: v,
        clear: g,
        readState: b
      };
    };
    return { init: r };
  }, ww = function(t, r, o) {
    var l = r.aria;
    l.update(t, l, o.get());
  }, zh = function(t, r, o) {
    r.toggleClass.each(function(l) {
      o.get() ? Di(t.element, l) : yi(t.element, l);
    });
  }, Cd = function(t, r, o) {
    Cw(t, r, o, !o.get());
  }, l4 = function(t, r, o) {
    o.set(!0), zh(t, r, o), ww(t, r, o);
  }, bb = function(t, r, o) {
    o.set(!1), zh(t, r, o), ww(t, r, o);
  }, Cw = function(t, r, o, l) {
    var v = l ? l4 : bb;
    v(t, r, o);
  }, SE = function(t, r, o) {
    return o.get();
  }, c4 = function(t, r, o) {
    Cw(t, r, o, r.selected);
  }, xE = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    onLoad: c4,
    toggle: Cd,
    isOn: SE,
    on: l4,
    off: bb,
    set: Cw
  }), yb = function() {
    return nc({});
  }, kE = function(t, r) {
    var o = tm(t, r, Cd), l = Bo(t, r, c4);
    return ro(Ie([
      t.toggleOnExecute ? [o] : [],
      [l]
    ]));
  }, wb = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    exhibit: yb,
    events: kE
  }), f4 = function(t, r, o) {
    Qr(t.element, "aria-pressed", o), r.syncWithExpanded && d4(t, r, o);
  }, v4 = function(t, r, o) {
    Qr(t.element, "aria-selected", o);
  }, TE = function(t, r, o) {
    Qr(t.element, "aria-checked", o);
  }, d4 = function(t, r, o) {
    Qr(t.element, "aria-expanded", o);
  }, Sw = [
    ct("selected", !1),
    Ba("toggleClass"),
    ct("toggleOnExecute", !0),
    os("aria", { mode: "none" }, Al("mode", {
      pressed: [
        ct("syncWithExpanded", !1),
        io("update", f4)
      ],
      checked: [io("update", TE)],
      expanded: [io("update", d4)],
      selected: [io("update", v4)],
      none: [io("update", ee)]
    }))
  ], wa = Pi({
    fields: Sw,
    name: "toggling",
    active: wb,
    apis: xE,
    state: s4(!1)
  }), m4 = function() {
    var t = function(r, o) {
      o.stop(), ml(r);
    };
    return [
      cn(ig(), t),
      cn(Hv(), t),
      Ud(of()),
      Ud(Ql())
    ];
  }, Cb = function(t) {
    var r = function(o) {
      return Ks(function(l, v) {
        o(l), v.stop();
      });
    };
    return ro(Ie([
      t.map(r).toArray(),
      m4()
    ]));
  }, xw = "alloy.item-hover", g4 = "alloy.item-focus", kw = function(t) {
    (Pc(t.element).isNone() || zr.isFocused(t)) && (zr.isFocused(t) || zr.focus(t), xr(t, xw, { item: t }));
  }, Hh = function(t) {
    xr(t, g4, { item: t });
  }, Sb = ie(xw), u = ie(g4), c = function(t) {
    return {
      dom: t.dom,
      domModification: $($({}, t.domModification), { attributes: $($($({ role: t.toggling.isSome() ? "menuitemcheckbox" : "menuitem" }, t.domModification.attributes), { "aria-haspopup": t.hasSubmenu }), t.hasSubmenu ? { "aria-expanded": !1 } : {}) }),
      behaviours: Pl.augment(t.itemBehaviours, [
        t.toggling.fold(wa.revoke, function(r) {
          return wa.config($({ aria: { mode: "checked" } }, r));
        }),
        zr.config({
          ignore: t.ignoreFocus,
          stopMousedown: t.ignoreFocus,
          onFocus: function(r) {
            Hh(r);
          }
        }),
        Er.config({ mode: "execution" }),
        jn.config({
          store: {
            mode: "memory",
            initialValue: t.data
          }
        }),
        Jr("item-type-events", ae(ae([], m4(), !0), [
          cn(rv(), kw),
          cn(zd(), zr.focus)
        ], !1))
      ]),
      components: t.components,
      eventOrder: t.eventOrder
    };
  }, d = [
    un("data"),
    un("components"),
    un("dom"),
    ct("hasSubmenu", !1),
    Ba("toggling"),
    Pl.field("itemBehaviours", [
      wa,
      zr,
      Er,
      jn
    ]),
    ct("ignoreFocus", !1),
    ct("domModification", {}),
    io("builder", c),
    ct("eventOrder", {})
  ], h = function(t) {
    return {
      dom: t.dom,
      components: t.components,
      events: ro([lg(zd())])
    };
  }, S = [
    un("dom"),
    un("components"),
    io("builder", h)
  ], B = ie("item-widget"), L = ie([hu({
    name: "widget",
    overrides: function(t) {
      return {
        behaviours: Fn([jn.config({
          store: {
            mode: "manual",
            getValue: function(r) {
              return t.data;
            },
            setValue: ee
          }
        })])
      };
    }
  })]), W = function(t) {
    var r = L2(B(), t, L()), o = z2(B(), t, r.internals()), l = function(g) {
      return Ya(g, t, "widget").map(function(b) {
        return Er.focusIn(b), b;
      });
    }, v = function(g, b) {
      return kf(b.event.target) ? _.none() : function() {
        return t.autofocus && b.setSource(g.element), _.none();
      }();
    };
    return {
      dom: t.dom,
      components: o,
      domModification: t.domModification,
      events: ro([
        Ks(function(g, b) {
          l(g).each(function(T) {
            b.stop();
          });
        }),
        cn(rv(), kw),
        cn(zd(), function(g, b) {
          t.autofocus ? l(g) : zr.focus(g);
        })
      ]),
      behaviours: Pl.augment(t.widgetBehaviours, [
        jn.config({
          store: {
            mode: "memory",
            initialValue: t.data
          }
        }),
        zr.config({
          ignore: t.ignoreFocus,
          onFocus: function(g) {
            Hh(g);
          }
        }),
        Er.config({
          mode: "special",
          focusIn: t.autofocus ? function(g) {
            l(g);
          } : bS(),
          onLeft: v,
          onRight: v,
          onEscape: function(g, b) {
            return !zr.isFocused(g) && !t.autofocus ? (zr.focus(g), _.some(!0)) : (t.autofocus && b.setSource(g.element), _.none());
          }
        })
      ])
    };
  }, me = [
    un("uid"),
    un("data"),
    un("components"),
    un("dom"),
    ct("autofocus", !1),
    ct("ignoreFocus", !1),
    Pl.field("widgetBehaviours", [
      jn,
      zr,
      Er
    ]),
    ct("domModification", {}),
    Th(L()),
    io("builder", W)
  ], Re = Al("type", {
    widget: me,
    item: d,
    separator: S
  }), rt = function(t, r) {
    return {
      mode: "flatgrid",
      selector: "." + t.markers.item,
      initSize: {
        numColumns: r.initSize.numColumns,
        numRows: r.initSize.numRows
      },
      focusManager: t.focusManager
    };
  }, jt = function(t, r) {
    return {
      mode: "matrix",
      selectors: {
        row: r.rowSelector,
        cell: "." + t.markers.item
      },
      focusManager: t.focusManager
    };
  }, Sn = function(t, r) {
    return {
      mode: "menu",
      selector: "." + t.markers.item,
      moveOnTab: r.moveOnTab,
      focusManager: t.focusManager
    };
  }, ln = ie([Sf({
    factory: {
      sketch: function(t) {
        var r = Ha("menu.spec item", Re, t);
        return r.builder(r);
      }
    },
    name: "items",
    unit: "item",
    defaults: function(t, r) {
      return yn(r, "uid") ? r : $($({}, r), { uid: Gv("item") });
    },
    overrides: function(t, r) {
      return {
        type: r.type,
        ignoreFocus: t.fakeFocus,
        domModification: { classes: [t.markers.item] }
      };
    }
  })]), Wt = ie([
    un("value"),
    un("items"),
    un("dom"),
    un("components"),
    ct("eventOrder", {}),
    Ni("menuBehaviours", [
      Na,
      jn,
      la,
      Er
    ]),
    os("movement", {
      mode: "menu",
      moveOnTab: !0
    }, Al("mode", {
      grid: [
        e0(),
        io("config", rt)
      ],
      matrix: [
        io("config", jt),
        un("rowSelector")
      ],
      menu: [
        ct("moveOnTab", !0),
        io("config", Sn)
      ]
    })),
    Hk(),
    ct("fakeFocus", !1),
    ct("focusManager", Rh()),
    Ra("onHighlight")
  ]), Pn = ie("alloy.menu-focus"), Ln = function(t, r, o, l) {
    return {
      uid: t.uid,
      dom: t.dom,
      markers: t.markers,
      behaviours: Zi(t.menuBehaviours, [
        Na.config({
          highlightClass: t.markers.selectedItem,
          itemClass: t.markers.item,
          onHighlight: t.onHighlight
        }),
        jn.config({
          store: {
            mode: "memory",
            initialValue: t.value
          }
        }),
        la.config({ find: _.some }),
        Er.config(t.movement.config(t, t.movement))
      ]),
      events: ro([
        cn(u(), function(v, g) {
          var b = g.event;
          v.getSystem().getByDom(b.target).each(function(T) {
            Na.highlight(v, T), g.stop(), xr(v, Pn(), {
              menu: v,
              item: T
            });
          });
        }),
        cn(Sb(), function(v, g) {
          var b = g.event.item;
          Na.highlight(v, b);
        })
      ]),
      components: r,
      eventOrder: t.eventOrder,
      domModification: { attributes: { role: "menu" } }
    };
  }, mr = ds({
    name: "Menu",
    configFields: Wt(),
    partFields: ln(),
    factory: Ln
  }), Ea = function(t) {
    return yt(t, function(r, o) {
      return {
        k: r,
        v: o
      };
    });
  }, dr = function(t, r, o, l) {
    return Ft(o, l).bind(function(v) {
      return Ft(t, v).bind(function(g) {
        var b = dr(t, r, o, g);
        return _.some([g].concat(b));
      });
    }).getOr([]);
  }, Ur = function(t, r) {
    var o = {};
    Un(t, function(b, T) {
      Pe(b, function(A) {
        o[A] = T;
      });
    });
    var l = r, v = Ea(r), g = Tn(v, function(b, T) {
      return [T].concat(dr(o, l, v, T));
    });
    return Tn(o, function(b) {
      return Ft(g, b).getOr([b]);
    });
  }, ca = function() {
    var t = Sr({}), r = Sr({}), o = Sr({}), l = Zo(), v = Sr({}), g = function() {
      t.set({}), r.set({}), o.set({}), l.clear();
    }, b = function() {
      return l.get().isNone();
    }, T = function(st, Bt) {
      var an;
      r.set($($({}, r.get()), (an = {}, an[st] = {
        type: "prepared",
        menu: Bt
      }, an)));
    }, A = function(st, Bt, an, qn) {
      l.set(st), t.set(an), r.set(Bt), v.set(qn);
      var vn = Ur(qn, an);
      o.set(vn);
    }, R = function(st) {
      return ot(t.get(), function(Bt, an) {
        return Bt === st;
      });
    }, z = function(st, Bt, an) {
      return $e(st).bind(function(qn) {
        return R(st).bind(function(vn) {
          return Bt(vn).map(function(Gn) {
            return {
              triggeredMenu: qn,
              triggeringItem: Gn,
              triggeringPath: an
            };
          });
        });
      });
    }, U = function(st, Bt) {
      var an = We(Ne(st).toArray(), function(qn) {
        return $e(qn).isSome();
      });
      return Ft(o.get(), st).bind(function(qn) {
        var vn = he(an.concat(qn)), Gn = St(vn, function(pn, nn) {
          return z(pn, Bt, vn.slice(0, nn + 1)).fold(function() {
            return Ir(l.get(), pn) ? [] : [_.none()];
          }, function(Wn) {
            return [_.some(Wn)];
          });
        });
        return Fr(Gn);
      });
    }, oe = function(st) {
      return Ft(t.get(), st).map(function(Bt) {
        var an = Ft(o.get(), st).getOr([]);
        return [Bt].concat(an);
      });
    }, de = function(st) {
      return Ft(o.get(), st).bind(function(Bt) {
        return Bt.length > 1 ? _.some(Bt.slice(1)) : _.none();
      });
    }, Se = function(st) {
      return Ft(o.get(), st);
    }, $e = function(st) {
      return ut(st).bind(sa);
    }, ut = function(st) {
      return Ft(r.get(), st);
    }, Ne = function(st) {
      return Ft(t.get(), st);
    }, ft = function(st) {
      var Bt = v.get();
      return tt(on(Bt), st);
    }, Ht = function() {
      return l.get().bind($e);
    }, Kt = function() {
      return r.get();
    };
    return {
      setMenuBuilt: T,
      setContents: A,
      expand: oe,
      refresh: Se,
      collapse: de,
      lookupMenu: ut,
      lookupItem: Ne,
      otherMenus: ft,
      getPrimary: Ht,
      getMenus: Kt,
      clear: g,
      isClear: b,
      getTriggeringPath: U
    };
  }, sa = function(t) {
    return t.type === "prepared" ? _.some(t.menu) : _.none();
  }, oi = {
    init: ca,
    extractPreparedMenu: sa
  }, Ji = function(t, r) {
    var o = Zo(), l = function(dn, ar, pr) {
      return Tn(pr, function(ha, Ka) {
        var qo = function() {
          return mr.sketch($($({}, ha), {
            value: Ka,
            markers: t.markers,
            fakeFocus: t.fakeFocus,
            onHighlight: t.onHighlight,
            focusManager: t.fakeFocus ? Sx() : Rh()
          }));
        };
        return Ka === ar ? {
          type: "prepared",
          menu: dn.getSystem().build(qo())
        } : {
          type: "notbuilt",
          nbMenu: qo
        };
      });
    }, v = oi.init(), g = function(dn) {
      var ar = l(dn, t.data.primary, t.data.menus), pr = A();
      return v.setContents(t.data.primary, ar, t.data.expansions, pr), v.getPrimary();
    }, b = function(dn) {
      return jn.getValue(dn).value;
    }, T = function(dn, ar, pr) {
      return Xt(ar, function(ha) {
        if (!ha.getSystem().isConnected())
          return _.none();
        var Ka = Na.getCandidates(ha);
        return pt(Ka, function(qo) {
          return b(qo) === pr;
        });
      });
    }, A = function(dn) {
      return Tn(t.data.menus, function(ar, pr) {
        return St(ar.items, function(ha) {
          return ha.type === "separator" ? [] : [ha.data.value];
        });
      });
    }, R = function(dn, ar) {
      Na.highlight(dn, ar), Na.getHighlighted(ar).orThunk(function() {
        return Na.getFirst(ar);
      }).each(function(pr) {
        P1(dn, pr.element, zd());
      });
    }, z = function(dn, ar) {
      return Mr(_t(ar, function(pr) {
        return dn.lookupMenu(pr).bind(function(ha) {
          return ha.type === "prepared" ? _.some(ha.menu) : _.none();
        });
      }));
    }, U = function(dn, ar, pr) {
      var ha = z(ar, ar.otherMenus(pr));
      Pe(ha, function(Ka) {
        bl(Ka.element, [t.markers.backgroundMenu]), t.stayInDom || qr.remove(dn, Ka);
      });
    }, oe = function(dn) {
      return o.get().getOrThunk(function() {
        var ar = {}, pr = qu(dn.element, "." + t.markers.item), ha = We(pr, function(Ka) {
          return So(Ka, "aria-haspopup") === "true";
        });
        return Pe(ha, function(Ka) {
          dn.getSystem().getByDom(Ka).each(function(qo) {
            var Dv = b(qo);
            ar[Dv] = qo;
          });
        }), o.set(ar), ar;
      });
    }, de = function(dn, ar) {
      var pr = oe(dn);
      Un(pr, function(ha, Ka) {
        var qo = Tt(ar, Ka);
        Qr(ha.element, "aria-expanded", qo);
      });
    }, Se = function(dn, ar, pr) {
      return _.from(pr[0]).bind(function(ha) {
        return ar.lookupMenu(ha).bind(function(Ka) {
          if (Ka.type === "notbuilt")
            return _.none();
          var qo = Ka.menu, Dv = z(ar, pr.slice(1));
          return Pe(Dv, function($f) {
            Di($f.element, t.markers.backgroundMenu);
          }), Tr(qo.element) || qr.append(dn, yl(qo)), bl(qo.element, [t.markers.backgroundMenu]), R(dn, qo), U(dn, ar, pr), _.some(qo);
        });
      });
    }, $e;
    (function(dn) {
      dn[dn.HighlightSubmenu = 0] = "HighlightSubmenu", dn[dn.HighlightParent = 1] = "HighlightParent";
    })($e || ($e = {}));
    var ut = function(dn, ar, pr) {
      if (pr.type === "notbuilt") {
        var ha = dn.getSystem().build(pr.nbMenu());
        return v.setMenuBuilt(ar, ha), ha;
      } else
        return pr.menu;
    }, Ne = function(dn, ar, pr) {
      if (pr === void 0 && (pr = $e.HighlightSubmenu), ar.hasConfigured(Cr) && Cr.isDisabled(ar))
        return _.some(ar);
      var ha = b(ar);
      return v.expand(ha).bind(function(Ka) {
        return de(dn, Ka), _.from(Ka[0]).bind(function(qo) {
          return v.lookupMenu(qo).bind(function(Dv) {
            var $f = ut(dn, qo, Dv);
            return Tr($f.element) || qr.append(dn, yl($f)), t.onOpenSubmenu(dn, ar, $f, he(Ka)), pr === $e.HighlightSubmenu ? (Na.highlightFirst($f), Se(dn, v, Ka)) : (Na.dehighlightAll($f), _.some(ar));
          });
        });
      });
    }, ft = function(dn, ar) {
      var pr = b(ar);
      return v.collapse(pr).bind(function(ha) {
        return de(dn, ha), Se(dn, v, ha).map(function(Ka) {
          return t.onCollapseMenu(dn, ar, Ka), Ka;
        });
      });
    }, Ht = function(dn, ar) {
      var pr = b(ar);
      return v.refresh(pr).bind(function(ha) {
        return de(dn, ha), Se(dn, v, ha);
      });
    }, Kt = function(dn, ar) {
      return kf(ar.element) ? _.none() : Ne(dn, ar, $e.HighlightSubmenu);
    }, st = function(dn, ar) {
      return kf(ar.element) ? _.none() : ft(dn, ar);
    }, Bt = function(dn, ar) {
      return ft(dn, ar).orThunk(function() {
        return t.onEscape(dn, ar).map(function() {
          return dn;
        });
      });
    }, an = function(dn) {
      return function(ar, pr) {
        return Rl(pr.getSource(), "." + t.markers.item).bind(function(ha) {
          return ar.getSystem().getByDom(ha).toOptional().bind(function(Ka) {
            return dn(ar, Ka).map(xe);
          });
        });
      };
    }, qn = ro([
      cn(Pn(), function(dn, ar) {
        var pr = ar.event.item;
        v.lookupItem(b(pr)).each(function() {
          var ha = ar.event.menu;
          Na.highlight(dn, ha);
          var Ka = b(ar.event.item);
          v.refresh(Ka).each(function(qo) {
            return U(dn, v, qo);
          });
        });
      }),
      Ks(function(dn, ar) {
        var pr = ar.event.target;
        dn.getSystem().getByDom(pr).each(function(ha) {
          var Ka = b(ha);
          Ka.indexOf("collapse-item") === 0 && ft(dn, ha), Ne(dn, ha, $e.HighlightSubmenu).fold(function() {
            t.onExecute(dn, ha);
          }, ee);
        });
      }),
      Zr(function(dn, ar) {
        g(dn).each(function(pr) {
          qr.append(dn, yl(pr)), t.onOpenMenu(dn, pr), t.highlightImmediately && R(dn, pr);
        });
      })
    ].concat(t.navigateOnHover ? [cn(Sb(), function(dn, ar) {
      var pr = ar.event.item;
      Ht(dn, pr), Ne(dn, pr, $e.HighlightParent), t.onHover(dn, pr);
    })] : [])), vn = function(dn) {
      return Na.getHighlighted(dn).bind(Na.getHighlighted);
    }, Gn = function(dn) {
      vn(dn).each(function(ar) {
        ft(dn, ar);
      });
    }, pn = function(dn) {
      v.getPrimary().each(function(ar) {
        R(dn, ar);
      });
    }, nn = function(dn) {
      return _.from(dn.components()[0]).filter(function(ar) {
        return So(ar.element, "role") === "menu";
      });
    }, Wn = function(dn) {
      var ar = v.getPrimary().bind(function(pr) {
        return vn(dn).bind(function(ha) {
          var Ka = b(ha), qo = Yt(v.getMenus()), Dv = Mr(_t(qo, oi.extractPreparedMenu));
          return v.getTriggeringPath(Ka, function($f) {
            return T(dn, Dv, $f);
          });
        }).map(function(ha) {
          return {
            primary: pr,
            triggeringPath: ha
          };
        });
      });
      ar.fold(function() {
        nn(dn).each(function(pr) {
          t.onRepositionMenu(dn, pr, []);
        });
      }, function(pr) {
        var ha = pr.primary, Ka = pr.triggeringPath;
        t.onRepositionMenu(dn, ha, Ka);
      });
    }, cr = {
      collapseMenu: Gn,
      highlightPrimary: pn,
      repositionMenus: Wn
    };
    return {
      uid: t.uid,
      dom: t.dom,
      markers: t.markers,
      behaviours: Zi(t.tmenuBehaviours, [
        Er.config({
          mode: "special",
          onRight: an(Kt),
          onLeft: an(st),
          onEscape: an(Bt),
          focusIn: function(dn, ar) {
            v.getPrimary().each(function(pr) {
              P1(dn, pr.element, zd());
            });
          }
        }),
        Na.config({
          highlightClass: t.markers.selectedMenu,
          itemClass: t.markers.menu
        }),
        la.config({
          find: function(dn) {
            return Na.getHighlighted(dn);
          }
        }),
        qr.config({})
      ]),
      eventOrder: t.eventOrder,
      apis: cr,
      events: qn
    };
  }, Qi = ie("collapse-item"), Ca = function(t, r, o) {
    return {
      primary: t,
      menus: r,
      expansions: o
    };
  }, Gr = function(t, r) {
    return {
      primary: t,
      menus: rf(t, r),
      expansions: {}
    };
  }, ma = function(t) {
    return {
      value: ur(Qi()),
      meta: { text: t }
    };
  }, Ga = Cl({
    name: "TieredMenu",
    configFields: [
      Ts("onExecute"),
      Ts("onEscape"),
      ls("onOpenMenu"),
      ls("onOpenSubmenu"),
      Ra("onRepositionMenu"),
      Ra("onCollapseMenu"),
      ct("highlightImmediately", !0),
      nf("data", [
        un("primary"),
        un("menus"),
        un("expansions")
      ]),
      ct("fakeFocus", !1),
      Ra("onHighlight"),
      Ra("onHover"),
      Zd(),
      un("dom"),
      ct("navigateOnHover", !0),
      ct("stayInDom", !1),
      Ni("tmenuBehaviours", [
        Er,
        Na,
        la,
        qr
      ]),
      ct("eventOrder", {})
    ],
    apis: {
      collapseMenu: function(t, r) {
        t.collapseMenu(r);
      },
      highlightPrimary: function(t, r) {
        t.highlightPrimary(r);
      },
      repositionMenus: function(t, r) {
        t.repositionMenus(r);
      }
    },
    factory: Ji,
    extraApis: {
      tieredData: Ca,
      singleData: Gr,
      collapseItem: ma
    }
  }), jo = function(t, r, o, l, v) {
    var g = function() {
      return t.lazySink(r);
    }, b = l.type === "horizontal" ? {
      layouts: {
        onLtr: function() {
          return s0();
        },
        onRtl: function() {
          return l0();
        }
      }
    } : {}, T = function(R) {
      return R.length === 2;
    }, A = function(R) {
      return T(R) ? b : {};
    };
    return Ga.sketch({
      dom: { tag: "div" },
      data: l.data,
      markers: l.menu.markers,
      highlightImmediately: l.menu.highlightImmediately,
      onEscape: function() {
        return ga.close(r), t.onEscape.map(function(R) {
          return R(r);
        }), _.some(!0);
      },
      onExecute: function() {
        return _.some(!0);
      },
      onOpenMenu: function(R, z) {
        Jo.positionWithinBounds(g().getOrDie(), z, o, v());
      },
      onOpenSubmenu: function(R, z, U, oe) {
        var de = g().getOrDie();
        Jo.position(de, U, {
          anchor: $({
            type: "submenu",
            item: z
          }, A(oe))
        });
      },
      onRepositionMenu: function(R, z, U) {
        var oe = g().getOrDie();
        Jo.positionWithinBounds(oe, z, o, v()), Pe(U, function(de) {
          var Se = A(de.triggeringPath);
          Jo.position(oe, de.triggeredMenu, {
            anchor: $({
              type: "submenu",
              item: de.triggeringItem
            }, Se)
          });
        });
      }
    });
  }, bv = function(t, r) {
    var o = function(de, Se) {
      var $e = t.getRelated(de);
      return $e.exists(function(ut) {
        return Yd(ut, Se);
      });
    }, l = function(de, Se) {
      ga.setContent(de, Se);
    }, v = function(de, Se, $e) {
      g(de, Se, $e, _.none());
    }, g = function(de, Se, $e, ut) {
      b(de, Se, $e, function() {
        return ut.map(function(Ne) {
          return si(Ne);
        });
      });
    }, b = function(de, Se, $e, ut) {
      var Ne = t.lazySink(de).getOrDie();
      ga.openWhileCloaked(de, Se, function() {
        return Jo.positionWithinBounds(Ne, de, $e, ut());
      }), jn.setValue(de, _.some({
        mode: "position",
        config: $e,
        getBounds: ut
      }));
    }, T = function(de, Se, $e) {
      A(de, Se, $e, _.none);
    }, A = function(de, Se, $e, ut) {
      var Ne = jo(t, de, Se, $e, ut);
      ga.open(de, Ne), jn.setValue(de, _.some({
        mode: "menu",
        menu: Ne
      }));
    }, R = function(de) {
      ga.isOpen(de) && (jn.setValue(de, _.none()), ga.close(de));
    }, z = function(de) {
      return ga.getState(de);
    }, U = function(de) {
      ga.isOpen(de) && jn.getValue(de).each(function(Se) {
        switch (Se.mode) {
          case "menu":
            ga.getState(de).each(Ga.repositionMenus);
            break;
          case "position":
            var $e = t.lazySink(de).getOrDie();
            Jo.positionWithinBounds($e, de, Se.config, Se.getBounds());
            break;
        }
      });
    }, oe = {
      setContent: l,
      showAt: v,
      showWithin: g,
      showWithinBounds: b,
      showMenuAt: T,
      showMenuWithinBounds: A,
      hide: R,
      getContent: z,
      reposition: U,
      isOpen: ga.isOpen
    };
    return {
      uid: t.uid,
      dom: t.dom,
      behaviours: Zi(t.inlineBehaviours, [
        ga.config({
          isPartOf: function(de, Se, $e) {
            return Yd(Se, $e) || o(de, $e);
          },
          getAttachPoint: function(de) {
            return t.lazySink(de).getOrDie();
          },
          onOpen: function(de) {
            t.onShow(de);
          },
          onClose: function(de) {
            t.onHide(de);
          }
        }),
        jn.config({
          store: {
            mode: "memory",
            initialValue: _.none()
          }
        }),
        ju.config({
          channels: $($({}, Os($({ isExtraPart: r.isExtraPart }, t.fireDismissalEventInstead.map(function(de) {
            return { fireEventInstead: { event: de.event } };
          }).getOr({})))), vm($($({}, t.fireRepositionEventInstead.map(function(de) {
            return { fireEventInstead: { event: de.event } };
          }).getOr({})), { doReposition: U })))
        })
      ]),
      eventOrder: t.eventOrder,
      apis: oe
    };
  }, Ua = Cl({
    name: "InlineView",
    configFields: [
      un("lazySink"),
      Ra("onShow"),
      Ra("onHide"),
      $v("onEscape"),
      Ni("inlineBehaviours", [
        ga,
        jn,
        ju
      ]),
      qs("fireDismissalEventInstead", [ct("event", ec())]),
      qs("fireRepositionEventInstead", [ct("event", Mu())]),
      ct("getRelated", _.none),
      ct("isExtraPart", ge),
      ct("eventOrder", _.none)
    ],
    factory: bv,
    apis: {
      showAt: function(t, r, o, l) {
        t.showAt(r, o, l);
      },
      showWithin: function(t, r, o, l, v) {
        t.showWithin(r, o, l, v);
      },
      showWithinBounds: function(t, r, o, l, v) {
        t.showWithinBounds(r, o, l, v);
      },
      showMenuAt: function(t, r, o, l) {
        t.showMenuAt(r, o, l);
      },
      showMenuWithinBounds: function(t, r, o, l, v) {
        t.showMenuWithinBounds(r, o, l, v);
      },
      hide: function(t, r) {
        t.hide(r);
      },
      isOpen: function(t, r) {
        return t.isOpen(r);
      },
      getContent: function(t, r) {
        return t.getContent(r);
      },
      setContent: function(t, r, o) {
        t.setContent(r, o);
      },
      reposition: function(t, r) {
        t.reposition(r);
      }
    }
  }), Zs = "layout-inset", eu = function(t) {
    return t.x;
  }, Vh = function(t, r) {
    return t.x + t.width / 2 - r.width / 2;
  }, yv = function(t, r) {
    return t.x + t.width - r.width;
  }, Hc = function(t) {
    return t.y;
  }, Sl = function(t, r) {
    return t.y + t.height - r.height;
  }, _f = function(t, r) {
    return t.y + t.height / 2 - r.height / 2;
  }, xb = function(t, r, o) {
    return Hi(yv(t, r), Sl(t, r), o.insetSouthwest(), Qd(), "southwest", Mi(t, {
      right: 0,
      bottom: 3
    }), Zs);
  }, cp = function(t, r, o) {
    return Hi(eu(t), Sl(t, r), o.insetSoutheast(), Iy(), "southeast", Mi(t, {
      left: 1,
      bottom: 3
    }), Zs);
  }, fp = function(t, r, o) {
    return Hi(yv(t, r), Hc(t), o.insetNorthwest(), Ny(), "northwest", Mi(t, {
      right: 0,
      top: 2
    }), Zs);
  }, vp = function(t, r, o) {
    return Hi(eu(t), Hc(t), o.insetNortheast(), n0(), "northeast", Mi(t, {
      left: 1,
      top: 2
    }), Zs);
  }, Vc = function(t, r, o) {
    return Hi(Vh(t, r), Hc(t), o.insetNorth(), rh(), "north", Mi(t, { top: 2 }), Zs);
  }, dp = function(t, r, o) {
    return Hi(Vh(t, r), Sl(t, r), o.insetSouth(), Fy(), "south", Mi(t, { bottom: 3 }), Zs);
  }, mp = function(t, r, o) {
    return Hi(yv(t, r), _f(t, r), o.insetEast(), bg(), "east", Mi(t, { right: 0 }), Zs);
  }, Tw = function(t, r, o) {
    return Hi(eu(t), _f(t, r), o.insetWest(), $y(), "west", Mi(t, { left: 1 }), Zs);
  }, gp = function(t) {
    switch (t) {
      case "north":
        return Vc;
      case "northeast":
        return vp;
      case "northwest":
        return fp;
      case "south":
        return dp;
      case "southeast":
        return cp;
      case "southwest":
        return xb;
      case "east":
        return mp;
      case "west":
        return Tw;
    }
  }, k5 = function(t, r, o, l, v) {
    var g = Ky(l).map(gp).getOr(Vc);
    return g(t, r, o, l, v);
  }, EE = function(t) {
    switch (t) {
      case "north":
        return dp;
      case "northeast":
        return cp;
      case "northwest":
        return xb;
      case "south":
        return Vc;
      case "southeast":
        return vp;
      case "southwest":
        return fp;
      case "east":
        return Tw;
      case "west":
        return mp;
    }
  }, hR = function(t, r, o, l, v) {
    var g = Ky(l).map(EE).getOr(Vc);
    return g(t, r, o, l, v);
  }, pp = tinymce.util.Tools.resolve("tinymce.util.Delay"), bR = function(t) {
    var r = Cb(t.action), o = t.dom.tag, l = function(g) {
      return Ft(t.dom, "attributes").bind(function(b) {
        return Ft(b, g);
      });
    }, v = function() {
      if (o === "button") {
        var g = l("type").getOr("button"), b = l("role").map(function(A) {
          return { role: A };
        }).getOr({});
        return $({ type: g }, b);
      } else {
        var T = l("role").getOr("button");
        return { role: T };
      }
    };
    return {
      uid: t.uid,
      dom: t.dom,
      components: t.components,
      events: r,
      behaviours: Pl.augment(t.buttonBehaviours, [
        zr.config({}),
        Er.config({
          mode: "execution",
          useSpace: !0,
          useEnter: !0
        })
      ]),
      domModification: { attributes: v() },
      eventOrder: t.eventOrder
    };
  }, Js = Cl({
    name: "Button",
    factory: bR,
    configFields: [
      ct("uid", void 0),
      un("dom"),
      ct("components", []),
      Pl.field("buttonBehaviours", [
        zr,
        Er
      ]),
      Ba("action"),
      Ba("role"),
      ct("eventOrder", {})
    ]
  }), La = function(t) {
    var r = j2(t) && Yn(t, "uid") ? t.uid : Gv("memento"), o = function(g) {
      return g.getSystem().getByUid(r).getOrDie();
    }, l = function(g) {
      return g.getSystem().getByUid(r).toOptional();
    }, v = function() {
      return $($({}, t), { uid: r });
    };
    return {
      get: o,
      getOpt: l,
      asSpec: v
    };
  }, Af = tinymce.util.Tools.resolve("tinymce.util.I18n"), _E = {
    indent: !0,
    outdent: !0,
    "table-insert-column-after": !0,
    "table-insert-column-before": !0,
    "paste-column-after": !0,
    "paste-column-before": !0,
    "unordered-list": !0,
    "list-bull-circle": !0,
    "list-bull-default": !0,
    "list-bull-square": !0
  }, T5 = "temporary-placeholder", kb = function(t) {
    return function() {
      return Ft(t, T5).getOr("!not found!");
    };
  }, AE = function(t, r) {
    var o = t.toLowerCase();
    if (Af.isRtl()) {
      var l = gi(o, "-rtl");
      return yn(r, l) ? l : o;
    } else
      return o;
  }, E5 = function(t, r) {
    return Ft(r, AE(t, r));
  }, _5 = function(t, r) {
    var o = r();
    return E5(t, o).getOrThunk(kb(o));
  }, yR = function(t, r, o) {
    var l = r();
    return E5(t, l).or(o).getOrThunk(kb(l));
  }, wR = function(t) {
    return Af.isRtl() ? yn(_E, t) : !1;
  }, OE = function() {
    return Jr("add-focusable", [Zr(function(t) {
      Ry(t.element, "svg").each(function(r) {
        return Qr(r, "focusable", "false");
      });
    })]);
  }, DE = function(t, r, o, l) {
    var v, g, b = wR(r) ? ["tox-icon--flip"] : [], T = Ft(o, AE(r, o)).or(l).getOrThunk(kb(o));
    return {
      dom: {
        tag: t.tag,
        attributes: (v = t.attributes) !== null && v !== void 0 ? v : {},
        classes: t.classes.concat(b),
        innerHtml: T
      },
      behaviours: Fn(ae(ae([], (g = t.behaviours) !== null && g !== void 0 ? g : [], !0), [OE()], !1))
    };
  }, wv = function(t, r, o, l) {
    return l === void 0 && (l = _.none()), DE(r, t, o(), l);
  }, CR = function(t, r, o) {
    var l = o(), v = pt(t, function(g) {
      return yn(l, AE(g, l));
    });
    return DE(r, v.getOr(T5), l, _.none());
  }, p4 = {
    success: "checkmark",
    error: "warning",
    err: "error",
    warning: "warning",
    warn: "warning",
    info: "info"
  }, SR = function(t) {
    var r = La({
      dom: {
        tag: "p",
        innerHtml: t.translationProvider(t.text)
      },
      behaviours: Fn([qr.config({})])
    }), o = function(de) {
      return {
        dom: {
          tag: "div",
          classes: ["tox-bar"],
          attributes: { style: "width: " + de + "%" }
        }
      };
    }, l = function(de) {
      return {
        dom: {
          tag: "div",
          classes: ["tox-text"],
          innerHtml: de + "%"
        }
      };
    }, v = La({
      dom: {
        tag: "div",
        classes: t.progress ? [
          "tox-progress-bar",
          "tox-progress-indicator"
        ] : ["tox-progress-bar"]
      },
      components: [
        {
          dom: {
            tag: "div",
            classes: ["tox-bar-container"]
          },
          components: [o(0)]
        },
        l(0)
      ],
      behaviours: Fn([qr.config({})])
    }), g = function(de, Se) {
      de.getSystem().isConnected() && v.getOpt(de).each(function($e) {
        qr.set($e, [
          {
            dom: {
              tag: "div",
              classes: ["tox-bar-container"]
            },
            components: [o(Se)]
          },
          l(Se)
        ]);
      });
    }, b = function(de, Se) {
      if (de.getSystem().isConnected()) {
        var $e = r.get(de);
        qr.set($e, [vu(Se)]);
      }
    }, T = {
      updateProgress: g,
      updateText: b
    }, A = Ie([
      t.icon.toArray(),
      t.level.toArray(),
      t.level.bind(function(de) {
        return _.from(p4[de]);
      }).toArray()
    ]), R = La(Js.sketch({
      dom: {
        tag: "button",
        classes: [
          "tox-notification__dismiss",
          "tox-button",
          "tox-button--naked",
          "tox-button--icon"
        ]
      },
      components: [wv("close", {
        tag: "div",
        classes: ["tox-icon"],
        attributes: { "aria-label": t.translationProvider("Close") }
      }, t.iconProvider)],
      action: function(de) {
        t.onAction(de);
      }
    })), z = CR(A, {
      tag: "div",
      classes: ["tox-notification__icon"]
    }, t.iconProvider), U = {
      dom: {
        tag: "div",
        classes: ["tox-notification__body"]
      },
      components: [r.asSpec()],
      behaviours: Fn([qr.config({})])
    }, oe = [
      z,
      U
    ];
    return {
      uid: t.uid,
      dom: {
        tag: "div",
        attributes: { role: "alert" },
        classes: t.level.map(function(de) {
          return [
            "tox-notification",
            "tox-notification--in",
            "tox-notification--" + de
          ];
        }).getOr([
          "tox-notification",
          "tox-notification--in"
        ])
      },
      behaviours: Fn([
        zr.config({}),
        Jr("notification-events", [cn(Ol(), function(de) {
          R.getOpt(de).each(zr.focus);
        })])
      ]),
      components: oe.concat(t.progress ? [v.asSpec()] : []).concat(t.closeButton ? [R.asSpec()] : []),
      apis: T
    };
  }, BE = Cl({
    name: "Notification",
    factory: SR,
    configFields: [
      Ba("level"),
      un("progress"),
      un("icon"),
      un("onAction"),
      un("text"),
      un("iconProvider"),
      un("translationProvider"),
      no("closeButton", !0)
    ],
    apis: {
      updateProgress: function(t, r, o) {
        t.updateProgress(r, o);
      },
      updateText: function(t, r, o) {
        t.updateText(r, o);
      }
    }
  });
  function RE(t, r, o) {
    var l = r.backstage.shared, v = function(R) {
      switch (R) {
        case "bc-bc":
          return dp;
        case "tc-tc":
          return Vc;
        case "tc-bc":
          return Es;
        case "bc-tc":
        default:
          return wi;
      }
    }, g = function(R) {
      R.length > 0 && Pe(R, function(z, U) {
        U === 0 ? z.moveRel(null, "banner") : z.moveRel(R[U - 1].getEl(), "bc-tc");
      });
    }, b = function(R, z) {
      var U = !R.closeButton && R.timeout && (R.timeout > 0 || R.timeout < 0), oe = function() {
        z(), Ua.hide(Se);
      }, de = ko(BE.sketch({
        text: R.text,
        level: Tt([
          "success",
          "error",
          "warning",
          "warn",
          "info"
        ], R.type) ? R.type : void 0,
        progress: R.progressBar === !0,
        icon: _.from(R.icon),
        closeButton: !U,
        onAction: oe,
        iconProvider: l.providers.icons,
        translationProvider: l.providers.translate
      })), Se = ko(Ua.sketch($({
        dom: {
          tag: "div",
          classes: ["tox-notifications-container"]
        },
        lazySink: l.getSink,
        fireDismissalEventInstead: {}
      }, l.header.isPositionedAtTop() ? {} : { fireRepositionEventInstead: {} })));
      o.add(Se), R.timeout > 0 && pp.setTimeout(function() {
        oe();
      }, R.timeout);
      var $e = function() {
        var ut = si(Bn.fromDom(t.getContentAreaContainer())), Ne = uu(), ft = Xs(Ne.x, ut.x, ut.right), Ht = Xs(Ne.y, ut.y, ut.bottom), Kt = Math.max(ut.right, Ne.right), st = Math.max(ut.bottom, Ne.bottom);
        return _.some(Ai(ft, Ht, Kt - ft, st - Ht));
      };
      return {
        close: oe,
        moveTo: function(ut, Ne) {
          Ua.showAt(Se, yl(de), {
            anchor: {
              type: "makeshift",
              x: ut,
              y: Ne
            }
          });
        },
        moveRel: function(ut, Ne) {
          var ft = yl(de), Ht = { maxHeightFunction: Eg() };
          if (Ne !== "banner" && Y(ut)) {
            var Kt = v(Ne), st = {
              type: "node",
              root: $a(),
              node: _.some(Bn.fromDom(ut)),
              overrides: Ht,
              layouts: {
                onRtl: function() {
                  return [Kt];
                },
                onLtr: function() {
                  return [Kt];
                }
              }
            };
            Ua.showWithinBounds(Se, ft, { anchor: st }, $e);
          } else {
            var Bt = $($({}, l.anchors.banner()), { overrides: Ht });
            Ua.showWithinBounds(Se, ft, { anchor: Bt }, $e);
          }
        },
        text: function(ut) {
          BE.updateText(de, ut);
        },
        settings: R,
        getEl: function() {
          return de.element.dom;
        },
        progressBar: {
          value: function(ut) {
            BE.updateProgress(de, ut);
          }
        }
      };
    }, T = function(R) {
      R.close();
    }, A = function(R) {
      return R.settings;
    };
    return {
      open: b,
      close: T,
      reposition: g,
      getArgs: A
    };
  }
  var xR = function(t, r) {
    var o = null, l = function() {
      j(o) || (clearTimeout(o), o = null);
    }, v = function() {
      for (var g = [], b = 0; b < arguments.length; b++)
        g[b] = arguments[b];
      j(o) && (o = setTimeout(function() {
        o = null, t.apply(null, g);
      }, r));
    };
    return {
      cancel: l,
      throttle: v
    };
  }, ME = function(t, r) {
    var o = null, l = function() {
      j(o) || (clearTimeout(o), o = null);
    }, v = function() {
      for (var g = [], b = 0; b < arguments.length; b++)
        g[b] = arguments[b];
      l(), o = setTimeout(function() {
        o = null, t.apply(null, g);
      }, r);
    };
    return {
      cancel: l,
      throttle: v
    };
  }, kR = tinymce.util.Tools.resolve("tinymce.dom.TextSeeker"), TR = function(t, r) {
    return t.isBlock(r) || Tt([
      "BR",
      "IMG",
      "HR",
      "INPUT"
    ], r.nodeName) || t.getContentEditable(r) === "false";
  }, A5 = function(t, r, o, l, v) {
    var g = kR(t, function(b) {
      return TR(t, b);
    });
    return _.from(g.backwards(r, o, l, v));
  }, ER = "[data-mce-autocompleter]", _R = function(t, r) {
    return h4(Bn.fromDom(t.selection.getNode())).getOrThunk(function() {
      var o = Bn.fromHtml('<span data-mce-autocompleter="1" data-mce-bogus="1"></span>', t.getDoc());
      return Ou(o, Bn.fromDom(r.extractContents())), r.insertNode(o.dom), Co(o).each(function(l) {
        return l.dom.normalize();
      }), v2(o).map(function(l) {
        t.selection.setCursorLocation(l.dom, LS(l));
      }), o;
    });
  }, h4 = function(t) {
    return Rl(t, ER);
  }, AR = function(t) {
    return t.collapsed && t.startContainer.nodeType === 3;
  }, O5 = function(t) {
    return t.toString().replace(/\u00A0/g, " ").replace(/\uFEFF/g, "");
  }, D5 = function(t) {
    return t !== "" && ` \xA0\f
\r	\v`.indexOf(t) !== -1;
  }, PE = function(t, r) {
    return t.substring(r.length);
  }, NE = function(t, r, o) {
    var l;
    for (l = r - 1; l >= 0; l--) {
      var v = t.charAt(l);
      if (D5(v))
        return _.none();
      if (v === o)
        break;
    }
    return _.some(l);
  }, OR = function(t, r, o, l) {
    if (l === void 0 && (l = 0), !AR(r))
      return _.none();
    var v = function(b, T, A) {
      return NE(A, T, o).getOr(T);
    }, g = t.getParent(r.startContainer, t.isBlock) || t.getRoot();
    return A5(t, r.startContainer, r.startOffset, v, g).bind(function(b) {
      var T = r.cloneRange();
      if (T.setStart(b.container, b.offset), T.setEnd(r.endContainer, r.endOffset), T.collapsed)
        return _.none();
      var A = O5(T), R = A.lastIndexOf(o);
      return R !== 0 || PE(A, o).length < l ? _.none() : _.some({
        text: PE(A, o),
        range: T,
        triggerChar: o
      });
    });
  }, IE = function(t, r, o, l) {
    return l === void 0 && (l = 0), h4(Bn.fromDom(r.startContainer)).fold(function() {
      return OR(t, r, o, l);
    }, function(v) {
      var g = t.createRng();
      g.selectNode(v.dom);
      var b = O5(g);
      return _.some({
        range: g,
        text: PE(b, o),
        triggerChar: o
      });
    });
  }, DR = function(t, r) {
    r.on("keypress compositionend", t.onKeypress.throttle), r.on("remove", t.onKeypress.cancel);
    var o = function(l, v) {
      xr(l, A1(), { raw: v });
    };
    r.on("keydown", function(l) {
      var v = function() {
        return t.getView().bind(Na.getHighlighted);
      };
      l.which === 8 && t.onKeypress.throttle(l), t.isActive() && (l.which === 27 && t.cancelIfNecessary(), t.isMenuOpen() ? l.which === 13 ? (v().each(ml), l.preventDefault()) : l.which === 40 ? (v().fold(function() {
        t.getView().each(Na.highlightFirst);
      }, function(g) {
        o(g, l);
      }), l.preventDefault(), l.stopImmediatePropagation()) : (l.which === 37 || l.which === 38 || l.which === 39) && v().each(function(g) {
        o(g, l), l.preventDefault(), l.stopImmediatePropagation();
      }) : (l.which === 13 || l.which === 38 || l.which === 40) && t.cancelIfNecessary());
    }), r.on("NodeChange", function(l) {
      t.isActive() && !t.isProcessingAction() && h4(Bn.fromDom(l.element)).isNone() && t.cancelIfNecessary();
    });
  }, B5 = { setup: DR }, Ew = tinymce.util.Tools.resolve("tinymce.util.Promise"), FE = function(t, r) {
    return {
      container: t,
      offset: r
    };
  }, BR = function(t) {
    return t.nodeType === Ue;
  }, RR = function(t) {
    return t.nodeType === Tu;
  }, R5 = function(t) {
    if (BR(t))
      return FE(t, t.data.length);
    var r = t.childNodes;
    return r.length > 0 ? R5(r[r.length - 1]) : FE(t, r.length);
  }, b4 = function(t, r) {
    var o = t.childNodes;
    return o.length > 0 && r < o.length ? b4(o[r], 0) : o.length > 0 && RR(t) && o.length === r ? R5(o[o.length - 1]) : FE(t, r);
  }, MR = function(t, r) {
    return A5(t, r.container, r.offset, function(o, l) {
      return l === 0 ? -1 : l;
    }, t.getRoot()).filter(function(o) {
      var l = o.container.data.charAt(o.offset - 1);
      return !D5(l);
    }).isSome();
  }, PR = function(t) {
    return function(r) {
      var o = b4(r.startContainer, r.startOffset);
      return !MR(t, o);
    };
  }, NR = function(t, r, o) {
    return Xt(o.triggerChars, function(l) {
      return IE(t, r, l);
    });
  }, IR = function(t, r) {
    var o = r(), l = t.selection.getRng();
    return NR(t.dom, l, o).bind(function(v) {
      return M5(t, r, v);
    });
  }, M5 = function(t, r, o, l) {
    l === void 0 && (l = {});
    var v = r(), g = t.selection.getRng(), b = g.startContainer.nodeValue, T = We(v.lookupByChar(o.triggerChar), function(R) {
      return o.text.length >= R.minChars && R.matches.getOrThunk(function() {
        return PR(t.dom);
      })(o.range, b, o.text);
    });
    if (T.length === 0)
      return _.none();
    var A = Ew.all(_t(T, function(R) {
      var z = R.fetch(o.text, R.maxResults, l);
      return z.then(function(U) {
        return {
          matchText: o.text,
          items: U,
          columns: R.columns,
          onAction: R.onAction,
          highlightOn: R.highlightOn
        };
      });
    }));
    return _.some({
      lookupData: A,
      context: o
    });
  }, P5 = hr([
    Lr("type"),
    lo("text")
  ]), FR = function(t) {
    return Io("separatormenuitem", P5, t);
  }, $R = hr([
    ct("type", "autocompleteitem"),
    ct("active", !1),
    ct("disabled", !1),
    ct("meta", {}),
    Lr("value"),
    lo("text"),
    lo("icon")
  ]), LR = hr([
    Lr("type"),
    Lr("ch"),
    Ac("minChars", 1),
    ct("columns", 1),
    Ac("maxResults", 10),
    $v("matches"),
    Uu("fetch"),
    Uu("onAction"),
    tv("highlightOn", [], ri)
  ]), zR = function(t) {
    return Io("Autocompleter.Separator", P5, t);
  }, HR = function(t) {
    return Io("Autocompleter.Item", $R, t);
  }, $E = function(t) {
    return Io("Autocompleter", LR, t);
  }, _w = [
    no("disabled", !1),
    lo("tooltip"),
    lo("icon"),
    lo("text"),
    co("onSetup", function() {
      return ee;
    })
  ], VR = hr([
    Lr("type"),
    Uu("onAction")
  ].concat(_w)), N5 = function(t) {
    return Io("toolbarbutton", VR, t);
  }, Aw = [no("active", !1)].concat(_w), UR = hr(Aw.concat([
    Lr("type"),
    Uu("onAction")
  ])), y4 = function(t) {
    return Io("ToggleButton", UR, t);
  }, I5 = [
    co("predicate", ge),
    cl("scope", "node", [
      "node",
      "editor"
    ]),
    cl("position", "selection", [
      "node",
      "selection",
      "line"
    ])
  ], jR = _w.concat([
    ct("type", "contextformbutton"),
    ct("primary", !1),
    Uu("onAction"),
    as("original", Ze)
  ]), WR = Aw.concat([
    ct("type", "contextformbutton"),
    ct("primary", !1),
    Uu("onAction"),
    as("original", Ze)
  ]), qR = _w.concat([ct("type", "contextformbutton")]), GR = Aw.concat([ct("type", "contextformtogglebutton")]), F5 = Al("type", {
    contextformbutton: jR,
    contextformtogglebutton: WR
  }), KR = hr([
    ct("type", "contextform"),
    co("initValue", ie("")),
    lo("label"),
    Ru("commands", F5),
    _c("launch", Al("type", {
      contextformbutton: qR,
      contextformtogglebutton: GR
    }))
  ].concat(I5)), LE = function(t) {
    return Io("ContextForm", KR, t);
  }, zE = hr([
    ct("type", "contexttoolbar"),
    Lr("items")
  ].concat(I5)), $5 = function(t) {
    return Io("ContextToolbar", zE, t);
  }, HE = function(t) {
    var r = {};
    return Pe(t, function(o) {
      r[o] = {};
    }), on(r);
  }, VE = function(t) {
    var r = t.ui.registry.getAll().popups, o = Tn(r, function(b) {
      return $E(b).fold(function(T) {
        throw new Error(Fv(T));
      }, Ze);
    }), l = HE(Kr(o, function(b) {
      return b.ch;
    })), v = Yt(o), g = function(b) {
      return We(v, function(T) {
        return T.ch === b;
      });
    };
    return {
      dataset: o,
      triggerChars: l,
      lookupByChar: g
    };
  }, w4;
  (function(t) {
    t[t.CLOSE_ON_EXECUTE = 0] = "CLOSE_ON_EXECUTE", t[t.BUBBLE_TO_SANDBOX = 1] = "BUBBLE_TO_SANDBOX";
  })(w4 || (w4 = {}));
  var Xu = w4, Ow = "tox-menu-nav__js", UE = "tox-collection__item", jE = "tox-swatch", XR = {
    normal: Ow,
    color: jE
  }, L5 = "tox-collection__item--enabled", Tb = "tox-collection__group-heading", WE = "tox-collection__item-icon", qE = "tox-collection__item-label", YR = "tox-collection__item-accessory", GE = "tox-collection__item-caret", z5 = "tox-collection__item-checkmark", Uh = "tox-collection__item--active", H5 = "tox-collection__item-container", KE = "tox-collection__item-container--column", C4 = "tox-collection__item-container--row", ZR = "tox-collection__item-container--align-right", V5 = "tox-collection__item-container--align-left", U5 = "tox-collection__item-container--valign-top", JR = "tox-collection__item-container--valign-middle", QR = "tox-collection__item-container--valign-bottom", j5 = function(t) {
    return Ft(XR, t).getOr(Ow);
  }, eM = function(t) {
    return t === "color" ? "tox-swatches" : "tox-menu";
  }, XE = function(t) {
    return {
      backgroundMenu: "tox-background-menu",
      selectedMenu: "tox-selected-menu",
      selectedItem: "tox-collection__item--active",
      hasIcons: "tox-menu--has-icons",
      menu: eM(t),
      tieredMenu: "tox-tiered-menu"
    };
  }, Eb = function(t) {
    var r = XE(t);
    return {
      backgroundMenu: r.backgroundMenu,
      selectedMenu: r.selectedMenu,
      menu: r.menu,
      selectedItem: r.selectedItem,
      item: j5(t)
    };
  }, tM = function(t, r, o) {
    var l = XE(o);
    return {
      tag: "div",
      classes: Ie([
        [
          l.menu,
          "tox-menu-" + r + "-column"
        ],
        t ? [l.hasIcons] : []
      ])
    };
  }, nM = [mr.parts.items({})], jh = function(t, r, o) {
    var l = XE(o), v = {
      tag: "div",
      classes: Ie([[l.tieredMenu]])
    };
    return {
      dom: v,
      markers: Eb(o)
    };
  }, S4 = function(t, r) {
    return function(o) {
      var l = tr(o, r);
      return _t(l, function(v) {
        return {
          dom: t,
          components: v
        };
      });
    };
  }, W5 = function(t) {
    return {
      dom: {
        tag: "div",
        classes: [
          "tox-menu",
          "tox-swatches-menu"
        ]
      },
      components: [{
        dom: {
          tag: "div",
          classes: ["tox-swatches"]
        },
        components: [mr.parts.items({
          preprocess: t !== "auto" ? S4({
            tag: "div",
            classes: ["tox-swatches__row"]
          }, t) : Ze
        })]
      }]
    };
  }, rM = function(t) {
    return {
      dom: {
        tag: "div",
        classes: [
          "tox-menu",
          "tox-collection",
          "tox-collection--toolbar",
          "tox-collection--toolbar-lg"
        ]
      },
      components: [mr.parts.items({
        preprocess: S4({
          tag: "div",
          classes: ["tox-collection__group"]
        }, t)
      })]
    };
  }, q5 = function(t, r) {
    var o = [], l = [];
    return Pe(t, function(v, g) {
      r(v, g) ? (l.length > 0 && o.push(l), l = [], yn(v.dom, "innerHtml") && l.push(v)) : l.push(v);
    }), l.length > 0 && o.push(l), _t(o, function(v) {
      return {
        dom: {
          tag: "div",
          classes: ["tox-collection__group"]
        },
        components: v
      };
    });
  }, Dw = function(t, r, o) {
    return {
      dom: {
        tag: "div",
        classes: [
          "tox-menu",
          "tox-collection"
        ].concat(t === 1 ? ["tox-collection--list"] : ["tox-collection--grid"])
      },
      components: [mr.parts.items({
        preprocess: function(l) {
          return t !== "auto" && t > 1 ? S4({
            tag: "div",
            classes: ["tox-collection__group"]
          }, t)(l) : q5(l, function(v, g) {
            return r[g].type === "separator";
          });
        }
      })]
    };
  }, YE = function(t, r) {
    return {
      dom: {
        tag: "div",
        classes: [
          "tox-collection",
          "tox-collection--horizontal"
        ]
      },
      components: [mr.parts.items({
        preprocess: function(o) {
          return q5(o, function(l, v) {
            return t[v].type === "separator";
          });
        }
      })]
    };
  }, Bw = function(t) {
    return Jt(t, function(r) {
      return "icon" in r && r.icon !== void 0;
    });
  }, Sd = function(t) {
    return console.error(Fv(t)), console.log(t), _.none();
  }, G5 = function(t, r, o, l, v) {
    var g = YE(o);
    return {
      value: t,
      dom: g.dom,
      components: g.components,
      items: o
    };
  }, ZE = function(t, r, o, l, v) {
    if (v === "color") {
      var g = W5(l);
      return {
        value: t,
        dom: g.dom,
        components: g.components,
        items: o
      };
    }
    if (v === "normal" && l === "auto") {
      var g = Dw(l, o);
      return {
        value: t,
        dom: g.dom,
        components: g.components,
        items: o
      };
    }
    if (v === "normal" && l === 1) {
      var g = Dw(1, o);
      return {
        value: t,
        dom: g.dom,
        components: g.components,
        items: o
      };
    }
    if (v === "normal") {
      var g = Dw(l, o);
      return {
        value: t,
        dom: g.dom,
        components: g.components,
        items: o
      };
    }
    if (v === "listpreview" && l !== "auto") {
      var g = rM(l);
      return {
        value: t,
        dom: g.dom,
        components: g.components,
        items: o
      };
    }
    return {
      value: t,
      dom: tM(r, l, v),
      components: nM,
      items: o
    };
  }, JE = [
    Lr("type"),
    Lr("src"),
    lo("alt"),
    tv("classes", [], ri)
  ], aM = hr(JE), K5 = [
    Lr("type"),
    Lr("text"),
    lo("name"),
    tv("classes", ["tox-collection__item-label"], ri)
  ], X5 = hr(K5), _b = UC(function() {
    return E1("type", {
      cardimage: aM,
      cardtext: X5,
      cardcontainer: oM
    });
  }), oM = hr([
    Lr("type"),
    ng("direction", "horizontal"),
    ng("align", "left"),
    ng("valign", "middle"),
    Ru("items", _b)
  ]), hp = [
    no("disabled", !1),
    lo("text"),
    lo("shortcut"),
    Oi("value", "value", da(function() {
      return ur("menuitem-value");
    }), Xl()),
    ct("meta", {})
  ], Ab = hr([
    Lr("type"),
    lo("label"),
    Ru("items", _b),
    co("onSetup", function() {
      return ee;
    }),
    co("onAction", ee)
  ].concat(hp)), iM = function(t) {
    return Io("cardmenuitem", Ab, t);
  }, Y5 = hr([
    Lr("type"),
    no("active", !1),
    lo("icon")
  ].concat(hp)), Z5 = function(t) {
    return Io("choicemenuitem", Y5, t);
  }, QE = [
    Lr("type"),
    Lr("fancytype"),
    co("onAction", ee)
  ], e_ = [ct("initData", {})].concat(QE), J5 = [iy("initData", {}, [
    no("allowCustomColors", !0),
    Ws("colors", Xl())
  ])].concat(QE), uM = Al("fancytype", {
    inserttable: e_,
    colorswatch: J5
  }), sM = function(t) {
    return Io("fancymenuitem", uM, t);
  }, x4 = hr([
    Lr("type"),
    co("onSetup", function() {
      return ee;
    }),
    co("onAction", ee),
    lo("icon")
  ].concat(hp)), lM = function(t) {
    return Io("menuitem", x4, t);
  }, Q5 = hr([
    Lr("type"),
    Uu("getSubmenuItems"),
    co("onSetup", function() {
      return ee;
    }),
    lo("icon")
  ].concat(hp)), Ob = function(t) {
    return Io("nestedmenuitem", Q5, t);
  }, cM = hr([
    Lr("type"),
    lo("icon"),
    no("active", !1),
    co("onSetup", function() {
      return ee;
    }),
    Uu("onAction")
  ].concat(hp)), fM = function(t) {
    return Io("togglemenuitem", cM, t);
  }, t_ = function(t, r, o) {
    var l = qu(t.element, "." + o);
    if (l.length > 0) {
      var v = sn(l, function(g) {
        var b = g.dom.getBoundingClientRect().top, T = l[0].dom.getBoundingClientRect().top;
        return Math.abs(b - T) > r;
      }).getOr(l.length);
      return _.some({
        numColumns: v,
        numRows: Math.ceil(l.length / v)
      });
    } else
      return _.none();
  }, n_ = function(t, r) {
    return Fn([Jr(t, r)]);
  }, eO = function(t) {
    return n_(ur("unnamed-events"), t);
  }, k4 = {
    namedEvents: n_,
    unnamedEvents: eO
  }, tO = ur("tooltip.exclusive"), Rw = ur("tooltip.show"), Mw = ur("tooltip.hide"), nO = function(t, r, o) {
    t.getSystem().broadcastOn([tO], {});
  }, T4 = function(t, r, o, l) {
    o.getTooltip().each(function(v) {
      v.getSystem().isConnected() && qr.set(v, l);
    });
  }, vM = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    hideAllExclusive: nO,
    setComponents: T4
  }), dM = function(t, r) {
    var o = function(v) {
      r.getTooltip().each(function(g) {
        $c(g), t.onHide(v, g), r.clearTooltip();
      }), r.clearTimer();
    }, l = function(v) {
      if (!r.isShowing()) {
        nO(v);
        var g = t.lazySink(v).getOrDie(), b = v.getSystem().build({
          dom: t.tooltipDom,
          components: t.tooltipComponents,
          events: ro(t.mode === "normal" ? [
            cn(rv(), function(T) {
              Ta(v, Rw);
            }),
            cn(fy(), function(T) {
              Ta(v, Mw);
            })
          ] : []),
          behaviours: Fn([qr.config({})])
        });
        r.setTooltip(b), lm(g, b), t.onShow(v, b), Jo.position(g, b, { anchor: t.anchor(v) });
      }
    };
    return ro(Ie([
      [
        cn(Rw, function(v) {
          r.resetTimer(function() {
            l(v);
          }, t.delay);
        }),
        cn(Mw, function(v) {
          r.resetTimer(function() {
            o(v);
          }, t.delay);
        }),
        cn(Dl(), function(v, g) {
          var b = g;
          b.universal || Tt(b.channels, tO) && o(v);
        }),
        gl(function(v) {
          o(v);
        })
      ],
      t.mode === "normal" ? [
        cn(Ol(), function(v) {
          Ta(v, Rw);
        }),
        cn(gy(), function(v) {
          Ta(v, Mw);
        }),
        cn(rv(), function(v) {
          Ta(v, Rw);
        }),
        cn(fy(), function(v) {
          Ta(v, Mw);
        })
      ] : [
        cn(yy(), function(v, g) {
          Ta(v, Rw);
        }),
        cn(M1(), function(v) {
          Ta(v, Mw);
        })
      ]
    ]));
  }, r_ = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    events: dM
  }), rO = [
    un("lazySink"),
    un("tooltipDom"),
    ct("exclusive", !0),
    ct("tooltipComponents", []),
    ct("delay", 300),
    cl("mode", "normal", [
      "normal",
      "follow-highlight"
    ]),
    ct("anchor", function(t) {
      return {
        type: "hotspot",
        hotspot: t,
        layouts: {
          onLtr: ie([
            wi,
            Es,
            Nu,
            cs,
            Vi,
            fs
          ]),
          onRtl: ie([
            wi,
            Es,
            Nu,
            cs,
            Vi,
            fs
          ])
        }
      };
    }),
    Ra("onHide"),
    Ra("onShow")
  ], mM = function() {
    var t = Zo(), r = Zo(), o = function() {
      t.on(clearTimeout);
    }, l = function(g, b) {
      o(), t.set(setTimeout(g, b));
    }, v = ie("not-implemented");
    return Pu({
      getTooltip: r.get,
      isShowing: r.isSet,
      setTooltip: r.set,
      clearTooltip: r.clear,
      clearTimer: o,
      resetTimer: l,
      readState: v
    });
  }, aO = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    init: mM
  }), a_ = Pi({
    fields: rO,
    name: "tooltipping",
    active: r_,
    state: aO,
    apis: vM
  }), oO = function(t) {
    return t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }, Db = tinymce.util.Tools.resolve("tinymce.dom.DOMUtils"), gM = tinymce.util.Tools.resolve("tinymce.EditorManager"), pM = function(t) {
    var r = t.getParam("skin"), o = t.getParam("skin_url");
    if (r !== !1) {
      var l = r || "oxide";
      o ? o = t.documentBaseURI.toAbsolute(o) : o = gM.baseURL + "/skins/ui/" + l;
    }
    return o;
  }, hM = function(t) {
    return t.getParam("readonly", !1, "boolean");
  }, bM = function(t) {
    return t.getParam("skin") === !1;
  }, E4 = function(t) {
    return t.getParam("height", Math.max(t.getElement().offsetHeight, 200));
  }, _4 = function(t) {
    return t.getParam("width", Db.DOM.getStyle(t.getElement(), "width"));
  }, o_ = function(t) {
    return _.from(t.getParam("min_width")).filter(J);
  }, iO = function(t) {
    return _.from(t.getParam("min_height")).filter(J);
  }, A4 = function(t) {
    return _.from(t.getParam("max_width")).filter(J);
  }, uO = function(t) {
    return _.from(t.getParam("max_height")).filter(J);
  }, yM = function(t) {
    return _.from(t.getParam("style_formats")).filter(X);
  }, wM = function(t) {
    return t.getParam("style_formats_merge", !1, "boolean");
  }, sO = function(t) {
    return t.getParam("lineheight_formats", "1 1.1 1.2 1.3 1.4 1.5 2", "string").split(" ");
  }, lO = function(t) {
    return t.getParam("content_langs", void 0, "array");
  }, cO = function(t) {
    return t.getParam("removed_menuitems", "");
  }, i_ = function(t) {
    return t.getParam("menubar", !0, "boolean") !== !1;
  }, u_ = function(t) {
    var r = t.getParam("toolbar", !0), o = r === !0, l = P(r), v = X(r) && r.length > 0;
    return !O4(t) && (v || l || o);
  }, fO = function(t) {
    var r = se(9, function(l) {
      return t.getParam("toolbar" + (l + 1), !1, "string");
    }), o = We(r, function(l) {
      return typeof l == "string";
    });
    return o.length > 0 ? _.some(o) : _.none();
  }, O4 = function(t) {
    return fO(t).fold(function() {
      var r = t.getParam("toolbar", [], "string[]");
      return r.length > 0;
    }, xe);
  }, lc;
  (function(t) {
    t.default = "wrap", t.floating = "floating", t.sliding = "sliding", t.scrolling = "scrolling";
  })(lc || (lc = {}));
  var Pw = function(t) {
    return t.getParam("toolbar_mode", "", "string");
  }, Wh;
  (function(t) {
    t.auto = "auto", t.top = "top", t.bottom = "bottom";
  })(Wh || (Wh = {}));
  var CM = function(t) {
    return t.getParam("toolbar_groups", {}, "object");
  }, vO = function(t) {
    return t.getParam("toolbar_location", Wh.auto, "string");
  }, dO = function(t) {
    return vO(t) === Wh.bottom;
  }, SM = function(t) {
    return t.getParam("fixed_toolbar_container", "", "string");
  }, mO = function(t) {
    return t.getParam("fixed_toolbar_container_target");
  }, xM = function(t) {
    return t.getParam("toolbar_persist", !1, "boolean");
  }, gO = function(t) {
    if (!t.inline)
      return _.none();
    var r = SM(t);
    if (r.length > 0)
      return Bi($a(), r);
    var o = mO(t);
    return Y(o) ? _.some(Bn.fromDom(o)) : _.none();
  }, D4 = function(t) {
    return t.inline && gO(t).isSome();
  }, pO = function(t) {
    var r = gO(t);
    return r.getOrThunk(function() {
      return Nn(wr(Bn.fromDom(t.getElement())));
    });
  }, hO = function(t) {
    return t.inline && !i_(t) && !u_(t) && !O4(t);
  }, B4 = function(t) {
    var r = t.getParam("toolbar_sticky", !1, "boolean");
    return (r || t.inline) && !D4(t) && !hO(t);
  }, R4 = function(t) {
    return t.getParam("toolbar_sticky_offset", 0, "number");
  }, bO = function(t) {
    return t.getParam("draggable_modal", !1, "boolean");
  }, kM = function(t) {
    var r = t.getParam("menu");
    return r ? Tn(r, function(o) {
      return $($({}, o), { items: o.items });
    }) : {};
  }, TM = function(t) {
    return t.getParam("menubar");
  }, EM = function(t) {
    return t.getParam("toolbar", !0);
  }, _M = function(t) {
    return t.getParam("file_picker_callback");
  }, AM = function(t) {
    return t.getParam("file_picker_types");
  }, s_ = function(t) {
    return t.getParam("file_browser_callback_types");
  }, yO = function(t) {
    return t.getParam("typeahead_urls") === !1;
  }, wO = function(t) {
    return t.getParam("anchor_top", "#top");
  }, OM = function(t) {
    return t.getParam("anchor_bottom", "#bottom");
  }, CO = function(t) {
    var r = t.getParam("file_picker_validator_handler", void 0, "function");
    return r === void 0 ? t.getParam("filepicker_validator_handler", void 0, "function") : r;
  }, l_ = "silver.readonly", DM = hr([Ck("readonly")]), Bb = function(t, r) {
    var o = t.outerContainer, l = o.element;
    r && (t.mothership.broadcastOn([fm()], { target: l }), t.uiMothership.broadcastOn([fm()], { target: l })), t.mothership.broadcastOn([l_], { readonly: r }), t.uiMothership.broadcastOn([l_], { readonly: r });
  }, SO = function(t, r) {
    t.on("init", function() {
      t.mode.isReadOnly() && Bb(r, !0);
    }), t.on("SwitchMode", function() {
      return Bb(r, t.mode.isReadOnly());
    }), hM(t) && t.setMode("readonly");
  }, Ui = function() {
    var t;
    return ju.config({
      channels: (t = {}, t[l_] = {
        schema: DM,
        onReceive: function(r, o) {
          Cr.set(r, o.readonly);
        }
      }, t)
    });
  }, BM = function(t) {
    return Cr.config({
      disabled: t,
      disableClass: "tox-collection__item--state-disabled"
    });
  }, RM = function(t) {
    return Cr.config({ disabled: t });
  }, MM = function(t) {
    return Cr.config({
      disabled: t,
      disableClass: "tox-tbtn--disabled"
    });
  }, PM = function(t) {
    return Cr.config({
      disabled: t,
      disableClass: "tox-tbtn--disabled",
      useNative: !1
    });
  }, Of = {
    item: BM,
    button: RM,
    splitButton: MM,
    toolbarButton: PM
  }, Rb = function(t, r) {
    var o = t.getApi(r);
    return function(l) {
      l(o);
    };
  }, qh = function(t, r) {
    return Zr(function(o) {
      var l = Rb(t, o);
      l(function(v) {
        var g = t.onSetup(v);
        D(g) && r.set(g);
      });
    });
  }, Gh = function(t, r) {
    return gl(function(o) {
      return Rb(t, o)(r.get());
    });
  }, M4, NM = function(t, r) {
    return Ks(function(o, l) {
      Rb(t, o)(t.onAction), !t.triggersSubmenu && r === Xu.CLOSE_ON_EXECUTE && (Ta(o, Xp()), l.stop());
    });
  }, IM = (M4 = {}, M4[vl()] = [
    "disabling",
    "alloy.base.behaviour",
    "toggling",
    "item-events"
  ], M4), km = Mr, bp = function(t, r, o, l) {
    var v = Sr(ee);
    return {
      type: "item",
      dom: r.dom,
      components: km(r.optComponents),
      data: t.data,
      eventOrder: IM,
      hasSubmenu: t.triggersSubmenu,
      itemBehaviours: Fn([
        Jr("item-events", [
          NM(t, o),
          qh(t, v),
          Gh(t, v)
        ]),
        Of.item(function() {
          return t.disabled || l.isDisabled();
        }),
        Ui(),
        qr.config({})
      ].concat(t.itemBehaviours))
    };
  }, Tm = function(t) {
    return {
      value: t.value,
      meta: $({ text: t.text.getOr("") }, t.meta)
    };
  }, P4 = tinymce.util.Tools.resolve("tinymce.Env"), FM = function(t) {
    var r = {
      alt: "&#x2325;",
      ctrl: "&#x2303;",
      shift: "&#x21E7;",
      meta: "&#x2318;",
      access: "&#x2303;&#x2325;"
    }, o = {
      meta: "Ctrl",
      access: "Shift+Alt"
    }, l = P4.mac ? r : o, v = t.split("+"), g = _t(v, function(b) {
      var T = b.toLowerCase().trim();
      return yn(l, T) ? l[T] : b;
    });
    return P4.mac ? g.join("") : g.join("+");
  }, c_ = function(t, r, o) {
    return o === void 0 && (o = [WE]), wv(t, {
      tag: "div",
      classes: o
    }, r);
  }, xO = function(t) {
    return {
      dom: {
        tag: "div",
        classes: [qE]
      },
      components: [vu(Af.translate(t))]
    };
  }, kO = function(t, r) {
    return {
      dom: {
        tag: "div",
        classes: r,
        innerHtml: t
      }
    };
  }, $M = function(t, r) {
    return {
      dom: {
        tag: "div",
        classes: [qE]
      },
      components: [{
        dom: {
          tag: t.tag,
          styles: t.styles
        },
        components: [vu(Af.translate(r))]
      }]
    };
  }, LM = function(t) {
    return {
      dom: {
        tag: "div",
        classes: [YR],
        innerHtml: FM(t)
      }
    };
  }, TO = function(t) {
    return c_("checkmark", t, [z5]);
  }, zM = function(t) {
    return c_("chevron-right", t, [GE]);
  }, HM = function(t) {
    return c_("chevron-down", t, [GE]);
  }, VM = function(t, r) {
    var o = t.direction === "vertical" ? KE : C4, l = t.align === "left" ? V5 : ZR, v = function() {
      switch (t.valign) {
        case "top":
          return U5;
        case "middle":
          return JR;
        case "bottom":
          return QR;
      }
    };
    return {
      dom: {
        tag: "div",
        classes: [
          H5,
          o,
          l,
          v()
        ]
      },
      components: r
    };
  }, UM = function(t, r, o) {
    return {
      dom: {
        tag: "img",
        classes: r,
        attributes: {
          src: t,
          alt: o.getOr("")
        }
      }
    };
  }, jM = function(t, r, o) {
    var l = "custom", v = "remove", g = t.ariaLabel, b = t.value, T = t.iconContent.map(function(R) {
      return yR(R, r.icons, o);
    }), A = function() {
      var R = jE, z = T.getOr(""), U = g.map(function(de) {
        return { title: r.translate(de) };
      }).getOr({}), oe = {
        tag: "div",
        attributes: U,
        classes: [R]
      };
      return b === l ? $($({}, oe), {
        tag: "button",
        classes: ae(ae([], oe.classes, !0), ["tox-swatches__picker-btn"], !1),
        innerHtml: z
      }) : b === v ? $($({}, oe), {
        classes: ae(ae([], oe.classes, !0), ["tox-swatch--remove"], !1),
        innerHtml: z
      }) : $($({}, oe), {
        attributes: $($({}, oe.attributes), { "data-mce-color": b }),
        styles: { "background-color": b }
      });
    };
    return {
      dom: A(),
      optComponents: []
    };
  }, EO = function(t) {
    var r = t.map(function(o) {
      return { attributes: { title: Af.translate(o) } };
    }).getOr({});
    return $({
      tag: "div",
      classes: [
        Ow,
        UE
      ]
    }, r);
  }, _O = function(t, r, o, l) {
    var v = {
      tag: "div",
      classes: [WE]
    }, g = function(oe) {
      return wv(oe, v, r.icons, l);
    }, b = function() {
      return _.some({ dom: v });
    }, T = o ? t.iconContent.map(g).orThunk(b) : _.none(), A = t.checkMark, R = _.from(t.meta).fold(function() {
      return xO;
    }, function(oe) {
      return yn(oe, "style") ? Pt($M, oe.style) : xO;
    }), z = t.htmlContent.fold(function() {
      return t.textContent.map(R);
    }, function(oe) {
      return _.some(kO(oe, [qE]));
    }), U = {
      dom: EO(t.ariaLabel),
      optComponents: [
        T,
        z,
        t.shortcutContent.map(LM),
        A,
        t.caret
      ]
    };
    return U;
  }, Nw = function(t, r, o, l) {
    return l === void 0 && (l = _.none()), t.presets === "color" ? jM(t, r, l) : _O(t, r, o, l);
  }, AO = function(t, r) {
    return Ft(t, "tooltipWorker").map(function(o) {
      return [a_.config({
        lazySink: r.getSink,
        tooltipDom: {
          tag: "div",
          classes: ["tox-tooltip-worker-container"]
        },
        tooltipComponents: [],
        anchor: function(l) {
          return {
            type: "submenu",
            item: l,
            overrides: { maxHeightFunction: Eg }
          };
        },
        mode: "follow-highlight",
        onShow: function(l, v) {
          o(function(g) {
            a_.setComponents(l, [K1({ element: Bn.fromDom(g) })]);
          });
        }
      })];
    }).getOr([]);
  }, Em = function(t) {
    return Db.DOM.encode(t);
  }, OO = function(t, r) {
    var o = Af.translate(t), l = Em(o);
    if (r.length > 0) {
      var v = new RegExp(oO(r), "gi");
      return l.replace(v, function(g) {
        return '<span class="tox-autocompleter-highlight">' + g + "</span>";
      });
    } else
      return l;
  }, WM = function(t, r, o, l, v, g, b, T) {
    T === void 0 && (T = !0);
    var A = Nw({
      presets: l,
      textContent: _.none(),
      htmlContent: o ? t.text.map(function(R) {
        return OO(R, r);
      }) : _.none(),
      ariaLabel: t.text,
      iconContent: t.icon,
      shortcutContent: _.none(),
      checkMark: _.none(),
      caret: _.none(),
      value: t.value
    }, b.providers, T, t.icon);
    return bp({
      data: Tm(t),
      disabled: t.disabled,
      getApi: ie({}),
      onAction: function(R) {
        return v(t.value, t.meta);
      },
      onSetup: ie(ee),
      triggersSubmenu: !1,
      itemBehaviours: AO(t.meta, b)
    }, A, g, b.providers);
  }, N4 = function(t, r) {
    return _t(t, function(o) {
      switch (o.type) {
        case "cardcontainer":
          return VM(o, N4(o.items, r));
        case "cardimage":
          return UM(o.src, o.classes, o.alt);
        case "cardtext":
          var l = o.name.exists(function(g) {
            return Tt(r.cardText.highlightOn, g);
          }), v = l ? _.from(r.cardText.matchText).getOr("") : "";
          return kO(OO(o.text, v), o.classes);
      }
    });
  }, bu = function(t, r, o, l) {
    var v = function(b) {
      return {
        isDisabled: function() {
          return Cr.isDisabled(b);
        },
        setDisabled: function(T) {
          Cr.set(b, T), Pe(qu(b.element, "*"), function(A) {
            b.getSystem().getByDom(A).each(function(R) {
              R.hasConfigured(Cr) && Cr.set(R, T);
            });
          });
        }
      };
    }, g = {
      dom: EO(t.label),
      optComponents: [_.some({
        dom: {
          tag: "div",
          classes: [
            H5,
            C4
          ]
        },
        components: N4(t.items, l)
      })]
    };
    return bp({
      data: Tm($({ text: _.none() }, t)),
      disabled: t.disabled,
      getApi: v,
      onAction: t.onAction,
      onSetup: t.onSetup,
      triggersSubmenu: !1,
      itemBehaviours: _.from(l.itemBehaviours).getOr([])
    }, g, r, o.providers);
  }, qM = function(t, r, o, l, v, g, b, T) {
    T === void 0 && (T = !0);
    var A = function(z) {
      return {
        setActive: function(U) {
          wa.set(z, U);
        },
        isActive: function() {
          return wa.isOn(z);
        },
        isDisabled: function() {
          return Cr.isDisabled(z);
        },
        setDisabled: function(U) {
          return Cr.set(z, U);
        }
      };
    }, R = Nw({
      presets: o,
      textContent: r ? t.text : _.none(),
      htmlContent: _.none(),
      ariaLabel: t.text,
      iconContent: t.icon,
      shortcutContent: r ? t.shortcut : _.none(),
      checkMark: r ? _.some(TO(b.icons)) : _.none(),
      caret: _.none(),
      value: t.value
    }, b, T);
    return Gt(bp({
      data: Tm(t),
      disabled: t.disabled,
      getApi: A,
      onAction: function(z) {
        return l(t.value);
      },
      onSetup: function(z) {
        return z.setActive(v), ee;
      },
      triggersSubmenu: !1,
      itemBehaviours: []
    }, R, g, b), {
      toggling: {
        toggleClass: L5,
        toggleOnExecute: !1,
        selected: t.active
      }
    });
  }, DO = pm(B(), L()), BO = function(t) {
    return { value: t };
  }, RO = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, MO = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, PO = function(t) {
    return RO.test(t) || MO.test(t);
  }, GM = function(t) {
    return go(t, "#").toUpperCase();
  }, KM = function(t) {
    return PO(t) ? _.some({ value: GM(t) }) : _.none();
  }, XM = function(t) {
    var r = t.value.replace(RO, function(o, l, v, g) {
      return l + l + v + v + g + g;
    });
    return { value: r };
  }, YM = function(t) {
    var r = XM(t), o = MO.exec(r.value);
    return o === null ? [
      "FFFFFF",
      "FF",
      "FF",
      "FF"
    ] : o;
  }, f_ = function(t) {
    var r = t.toString(16);
    return (r.length === 1 ? "0" + r : r).toUpperCase();
  }, Iw = function(t) {
    var r = f_(t.red) + f_(t.green) + f_(t.blue);
    return BO(r);
  }, NO = Math.min, IO = Math.max, I4 = Math.round, ZM = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)/, JM = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d?(?:\.\d+)?)\)/, yp = function(t, r, o, l) {
    return {
      red: t,
      green: r,
      blue: o,
      alpha: l
    };
  }, v_ = function(t) {
    var r = parseInt(t, 10);
    return r.toString() === t && r >= 0 && r <= 255;
  }, FO = function(t) {
    var r, o, l, v = (t.hue || 0) % 360, g = t.saturation / 100, b = t.value / 100;
    if (g = IO(0, NO(g, 1)), b = IO(0, NO(b, 1)), g === 0)
      return r = o = l = I4(255 * b), yp(r, o, l, 1);
    var T = v / 60, A = b * g, R = A * (1 - Math.abs(T % 2 - 1)), z = b - A;
    switch (Math.floor(T)) {
      case 0:
        r = A, o = R, l = 0;
        break;
      case 1:
        r = R, o = A, l = 0;
        break;
      case 2:
        r = 0, o = A, l = R;
        break;
      case 3:
        r = 0, o = R, l = A;
        break;
      case 4:
        r = R, o = 0, l = A;
        break;
      case 5:
        r = A, o = 0, l = R;
        break;
      default:
        r = o = l = 0;
    }
    return r = I4(255 * (r + z)), o = I4(255 * (o + z)), l = I4(255 * (l + z)), yp(r, o, l, 1);
  }, Fw = function(t) {
    var r = YM(t), o = parseInt(r[1], 16), l = parseInt(r[2], 16), v = parseInt(r[3], 16);
    return yp(o, l, v, 1);
  }, $O = function(t, r, o, l) {
    var v = parseInt(t, 10), g = parseInt(r, 10), b = parseInt(o, 10), T = parseFloat(l);
    return yp(v, g, b, T);
  }, LO = function(t) {
    if (t === "transparent")
      return _.some(yp(0, 0, 0, 0));
    var r = ZM.exec(t);
    if (r !== null)
      return _.some($O(r[1], r[2], r[3], "1"));
    var o = JM.exec(t);
    return o !== null ? _.some($O(o[1], o[2], o[3], o[4])) : _.none();
  }, zO = function(t) {
    return "rgba(" + t.red + "," + t.green + "," + t.blue + "," + t.alpha + ")";
  }, HO = yp(255, 0, 0, 1), QM = function(t) {
    return t.fire("SkinLoaded");
  }, VO = function(t, r) {
    return t.fire("SkinLoadError", r);
  }, e7 = function(t) {
    return t.fire("ResizeEditor");
  }, d_ = function(t, r) {
    return t.fire("ResizeContent", r);
  }, t7 = function(t, r) {
    return t.fire("ScrollContent", r);
  }, UO = function(t, r) {
    return t.fire("TextColorChange", r);
  }, $w = function(t, r, o) {
    return {
      hue: t,
      saturation: r,
      value: o
    };
  }, m_ = function(t) {
    var r = 0, o = 0, l = 0, v = t.red / 255, g = t.green / 255, b = t.blue / 255, T = Math.min(v, Math.min(g, b)), A = Math.max(v, Math.max(g, b));
    if (T === A)
      return l = T, $w(0, 0, l * 100);
    var R = v === T ? g - b : b === T ? v - g : b - v;
    return r = v === T ? 3 : b === T ? 1 : 5, r = 60 * (r - R / (A - T)), o = (A - T) / A, l = A, $w(Math.round(r), Math.round(o * 100), Math.round(l * 100));
  }, n7 = function(t) {
    return m_(Fw(t));
  }, jO = function(t) {
    return Iw(FO(t));
  }, WO = function(t) {
    return KM(t).orThunk(function() {
      return LO(t).map(Iw);
    }).getOrThunk(function() {
      var r = document.createElement("canvas");
      r.height = 1, r.width = 1;
      var o = r.getContext("2d");
      o.clearRect(0, 0, r.width, r.height), o.fillStyle = "#FFFFFF", o.fillStyle = t, o.fillRect(0, 0, 1, 1);
      var l = o.getImageData(0, 0, 1, 1).data, v = l[0], g = l[1], b = l[2], T = l[3];
      return Iw(yp(v, g, b, T));
    });
  }, F4 = tinymce.util.Tools.resolve("tinymce.util.LocalStorage"), g_ = "tinymce-custom-colors";
  function qO(t) {
    t === void 0 && (t = 10);
    var r = F4.getItem(g_), o = P(r) ? JSON.parse(r) : [], l = function(A) {
      var R = t - A.length;
      return R < 0 ? A.slice(0, t) : A;
    }, v = l(o), g = function(A) {
      dt(v, A).each(b), v.unshift(A), v.length > t && v.pop(), F4.setItem(g_, JSON.stringify(v));
    }, b = function(A) {
      v.splice(A, 1);
    }, T = function() {
      return v.slice(0);
    };
    return {
      add: g,
      state: T
    };
  }
  var tu = "choiceitem", GO = [
    {
      type: tu,
      text: "Light Green",
      value: "#BFEDD2"
    },
    {
      type: tu,
      text: "Light Yellow",
      value: "#FBEEB8"
    },
    {
      type: tu,
      text: "Light Red",
      value: "#F8CAC6"
    },
    {
      type: tu,
      text: "Light Purple",
      value: "#ECCAFA"
    },
    {
      type: tu,
      text: "Light Blue",
      value: "#C2E0F4"
    },
    {
      type: tu,
      text: "Green",
      value: "#2DC26B"
    },
    {
      type: tu,
      text: "Yellow",
      value: "#F1C40F"
    },
    {
      type: tu,
      text: "Red",
      value: "#E03E2D"
    },
    {
      type: tu,
      text: "Purple",
      value: "#B96AD9"
    },
    {
      type: tu,
      text: "Blue",
      value: "#3598DB"
    },
    {
      type: tu,
      text: "Dark Turquoise",
      value: "#169179"
    },
    {
      type: tu,
      text: "Orange",
      value: "#E67E23"
    },
    {
      type: tu,
      text: "Dark Red",
      value: "#BA372A"
    },
    {
      type: tu,
      text: "Dark Purple",
      value: "#843FA1"
    },
    {
      type: tu,
      text: "Dark Blue",
      value: "#236FA1"
    },
    {
      type: tu,
      text: "Light Gray",
      value: "#ECF0F1"
    },
    {
      type: tu,
      text: "Medium Gray",
      value: "#CED4D9"
    },
    {
      type: tu,
      text: "Gray",
      value: "#95A5A6"
    },
    {
      type: tu,
      text: "Dark Gray",
      value: "#7E8C8D"
    },
    {
      type: tu,
      text: "Navy Blue",
      value: "#34495E"
    },
    {
      type: tu,
      text: "Black",
      value: "#000000"
    },
    {
      type: tu,
      text: "White",
      value: "#ffffff"
    }
  ], KO = qO(10), r7 = function(t) {
    for (var r = [], o = 0; o < t.length; o += 2)
      r.push({
        text: t[o + 1],
        value: "#" + WO(t[o]).value,
        type: "choiceitem"
      });
    return r;
  }, a7 = function(t, r) {
    return t.getParam("color_cols", r, "number");
  }, XO = function(t) {
    return t.getParam("custom_colors") !== !1;
  }, o7 = function(t) {
    return t.getParam("color_map");
  }, p_ = function(t) {
    var r = o7(t);
    return r !== void 0 ? r7(r) : GO;
  }, h_ = function() {
    return _t(KO.state(), function(t) {
      return {
        type: tu,
        text: t,
        value: t
      };
    });
  }, b_ = function(t) {
    KO.add(t);
  }, y_ = "#000000", YO = function(t, r) {
    var o;
    return t.dom.getParents(t.selection.getStart(), function(l) {
      var v;
      (v = l.style[r === "forecolor" ? "color" : "background-color"]) && (o = o || v);
    }), _.from(o);
  }, i7 = function(t, r, o) {
    t.undoManager.transact(function() {
      t.focus(), t.formatter.apply(r, { value: o }), t.nodeChanged();
    });
  }, u7 = function(t, r) {
    t.undoManager.transact(function() {
      t.focus(), t.formatter.remove(r, { value: null }, null, !0), t.nodeChanged();
    });
  }, w_ = function(t) {
    t.addCommand("mceApplyTextcolor", function(r, o) {
      i7(t, r, o);
    }), t.addCommand("mceRemoveTextcolor", function(r) {
      u7(t, r);
    });
  }, s7 = function(t) {
    return Math.max(5, Math.ceil(Math.sqrt(t)));
  }, ZO = function(t) {
    var r = p_(t), o = s7(r.length);
    return a7(t, o);
  }, JO = function(t) {
    var r = "choiceitem", o = {
      type: r,
      text: "Remove color",
      icon: "color-swatch-remove-color",
      value: "remove"
    }, l = {
      type: r,
      text: "Custom color",
      icon: "color-picker",
      value: "custom"
    };
    return t ? [
      o,
      l
    ] : [o];
  }, Lw = function(t, r, o, l) {
    if (o === "custom") {
      var v = n6(t);
      v(function(g) {
        g.each(function(b) {
          b_(b), t.execCommand("mceApplyTextcolor", r, b), l(b);
        });
      }, y_);
    } else
      o === "remove" ? (l(""), t.execCommand("mceRemoveTextcolor", r)) : (l(o), t.execCommand("mceApplyTextcolor", r, o));
  }, QO = function(t, r) {
    return t.concat(h_().concat(JO(r)));
  }, C_ = function(t, r) {
    return function(o) {
      o(QO(t, r));
    };
  }, e6 = function(t, r, o) {
    var l = r === "forecolor" ? "tox-icon-text-color__color" : "tox-icon-highlight-bg-color__color";
    t.setIconFill(l, o);
  }, Mb = function(t, r, o, l, v) {
    t.ui.registry.addSplitButton(r, {
      tooltip: l,
      presets: "color",
      icon: r === "forecolor" ? "text-color" : "highlight-bg-color",
      select: function(g) {
        var b = YO(t, o);
        return b.bind(function(T) {
          return LO(T).map(function(A) {
            var R = Iw(A).value;
            return na(g.toLowerCase(), R);
          });
        }).getOr(!1);
      },
      columns: ZO(t),
      fetch: C_(p_(t), XO(t)),
      onAction: function(g) {
        Lw(t, o, v.get(), ee);
      },
      onItemAction: function(g, b) {
        Lw(t, o, b, function(T) {
          v.set(T), UO(t, {
            name: r,
            color: T
          });
        });
      },
      onSetup: function(g) {
        e6(g, r, v.get());
        var b = function(T) {
          T.name === r && e6(g, T.name, T.color);
        };
        return t.on("TextColorChange", b), function() {
          t.off("TextColorChange", b);
        };
      }
    });
  }, t6 = function(t, r, o, l) {
    t.ui.registry.addNestedMenuItem(r, {
      text: l,
      icon: r === "forecolor" ? "text-color" : "highlight-bg-color",
      getSubmenuItems: function() {
        return [{
          type: "fancymenuitem",
          fancytype: "colorswatch",
          onAction: function(v) {
            Lw(t, o, v.value, ee);
          }
        }];
      }
    });
  }, n6 = function(t) {
    return function(r, o) {
      var l = !1, v = function(T) {
        var A = T.getData(), R = A.colorpicker;
        l ? (r(_.from(R)), T.close()) : t.windowManager.alert(t.translate([
          "Invalid hex color code: {0}",
          R
        ]));
      }, g = function(T, A) {
        A.name === "hex-valid" && (l = A.value);
      }, b = { colorpicker: o };
      t.windowManager.open({
        title: "Color Picker",
        size: "normal",
        body: {
          type: "panel",
          items: [{
            type: "colorpicker",
            name: "colorpicker",
            label: "Color"
          }]
        },
        buttons: [
          {
            type: "cancel",
            name: "cancel",
            text: "Cancel"
          },
          {
            type: "submit",
            name: "save",
            text: "Save",
            primary: !0
          }
        ],
        initialData: b,
        onAction: g,
        onSubmit: v,
        onClose: ee,
        onCancel: function() {
          r(_.none());
        }
      });
    };
  }, l7 = function(t) {
    w_(t);
    var r = Sr(y_), o = Sr(y_);
    Mb(t, "forecolor", "forecolor", "Text color", r), Mb(t, "backcolor", "hilitecolor", "Background color", o), t6(t, "forecolor", "forecolor", "Text color"), t6(t, "backcolor", "hilitecolor", "Background color");
  }, S_ = function(t, r, o, l, v, g, b, T) {
    var A = Bw(r), R = v !== "color" ? "normal" : "color", z = c7(r, o, l, R, g, b, T);
    return ZE(t, A, z, l, v);
  }, c7 = function(t, r, o, l, v, g, b) {
    return Mr(_t(t, function(T) {
      return T.type === "choiceitem" ? Z5(T).fold(Sd, function(A) {
        return _.some(qM(A, o === 1, l, r, g(T.value), v, b, Bw(t)));
      }) : _.none();
    }));
  }, $4 = function(t, r) {
    var o = Eb(r);
    if (t === 1)
      return {
        mode: "menu",
        moveOnTab: !0
      };
    if (t === "auto")
      return {
        mode: "grid",
        selector: "." + o.item,
        initSize: {
          numColumns: 1,
          numRows: 1
        }
      };
    var l = r === "color" ? "tox-swatches__row" : "tox-collection__group";
    return {
      mode: "matrix",
      rowSelector: "." + l
    };
  }, r6 = function(t, r) {
    return t === 1 ? {
      mode: "menu",
      moveOnTab: !1,
      selector: ".tox-collection__item"
    } : t === "auto" ? {
      mode: "flatgrid",
      selector: ".tox-collection__item",
      initSize: {
        numColumns: 1,
        numRows: 1
      }
    } : {
      mode: "matrix",
      selectors: {
        row: r === "color" ? ".tox-swatches__row" : ".tox-collection__group",
        cell: r === "color" ? "." + jE : "." + UE
      }
    };
  }, a6 = function(t, r) {
    var o = o6(t, r), l = r.colorinput.getColorCols(), v = "color", g = S_(ur("menu-value"), o, function(T) {
      t.onAction({ value: T });
    }, l, v, Xu.CLOSE_ON_EXECUTE, ge, r.shared.providers), b = $($({}, g), {
      markers: Eb(v),
      movement: $4(l, v)
    });
    return {
      type: "widget",
      data: { value: ur("widget-id") },
      dom: {
        tag: "div",
        classes: ["tox-fancymenuitem"]
      },
      autofocus: !0,
      components: [DO.widget(mr.sketch(b))]
    };
  }, o6 = function(t, r) {
    var o = t.initData.allowCustomColors && r.colorinput.hasCustomColors();
    return t.initData.colors.fold(function() {
      return QO(r.colorinput.getColors(), o);
    }, function(l) {
      return l.concat(JO(o));
    });
  }, i6 = ur("cell-over"), L4 = ur("cell-execute"), f7 = function(t, r, o) {
    var l, v = function(T) {
      return xr(T, i6, {
        row: t,
        col: r
      });
    }, g = function(T) {
      return xr(T, L4, {
        row: t,
        col: r
      });
    }, b = function(T, A) {
      A.stop(), g(T);
    };
    return ko({
      dom: {
        tag: "div",
        attributes: (l = { role: "button" }, l["aria-labelledby"] = o, l)
      },
      behaviours: Fn([
        Jr("insert-table-picker-cell", [
          cn(rv(), zr.focus),
          cn(vl(), g),
          cn(ig(), b),
          cn(Hv(), b)
        ]),
        wa.config({
          toggleClass: "tox-insert-table-picker__selected",
          toggleOnExecute: !1
        }),
        zr.config({ onFocus: v })
      ])
    });
  }, v7 = function(t, r, o) {
    for (var l = [], v = 0; v < r; v++) {
      for (var g = [], b = 0; b < o; b++)
        g.push(f7(v, b, t));
      l.push(g);
    }
    return l;
  }, d7 = function(t, r, o, l, v) {
    for (var g = 0; g < l; g++)
      for (var b = 0; b < v; b++)
        wa.set(t[g][b], g <= r && b <= o);
  }, m7 = function(t) {
    return St(t, function(r) {
      return _t(r, yl);
    });
  }, u6 = function(t, r) {
    return vu(r + "x" + t);
  }, g7 = function(t) {
    var r = 10, o = 10, l = ur("size-label"), v = v7(l, r, o), g = u6(0, 0), b = La({
      dom: {
        tag: "span",
        classes: ["tox-insert-table-picker__label"],
        attributes: { id: l }
      },
      components: [g],
      behaviours: Fn([qr.config({})])
    });
    return {
      type: "widget",
      data: { value: ur("widget-id") },
      dom: {
        tag: "div",
        classes: ["tox-fancymenuitem"]
      },
      autofocus: !0,
      components: [DO.widget({
        dom: {
          tag: "div",
          classes: ["tox-insert-table-picker"]
        },
        components: m7(v).concat(b.asSpec()),
        behaviours: Fn([
          Jr("insert-table-picker", [
            Zr(function(T) {
              qr.set(b.get(T), [g]);
            }),
            Uv(i6, function(T, A, R) {
              var z = R.event, U = z.row, oe = z.col;
              d7(v, U, oe, r, o), qr.set(b.get(T), [u6(U + 1, oe + 1)]);
            }),
            Uv(L4, function(T, A, R) {
              var z = R.event, U = z.row, oe = z.col;
              t.onAction({
                numRows: U + 1,
                numColumns: oe + 1
              }), Ta(T, Xp());
            })
          ]),
          Er.config({
            initSize: {
              numRows: r,
              numColumns: o
            },
            mode: "flatgrid",
            selector: '[role="button"]'
          })
        ])
      })]
    };
  }, p7 = {
    inserttable: g7,
    colorswatch: a6
  }, h7 = function(t, r) {
    return Ft(p7, t.fancytype).map(function(o) {
      return o(t, r);
    });
  }, b7 = function(t, r, o, l, v) {
    l === void 0 && (l = !0), v === void 0 && (v = !1);
    var g = v ? HM(o.icons) : zM(o.icons), b = function(A) {
      return {
        isDisabled: function() {
          return Cr.isDisabled(A);
        },
        setDisabled: function(R) {
          return Cr.set(A, R);
        }
      };
    }, T = Nw({
      presets: "normal",
      iconContent: t.icon,
      textContent: t.text,
      htmlContent: _.none(),
      ariaLabel: t.text,
      caret: _.some(g),
      checkMark: _.none(),
      shortcutContent: t.shortcut
    }, o, l);
    return bp({
      data: Tm(t),
      getApi: b,
      disabled: t.disabled,
      onAction: ee,
      onSetup: t.onSetup,
      triggersSubmenu: !0,
      itemBehaviours: []
    }, T, r, o);
  }, y7 = function(t, r, o, l) {
    l === void 0 && (l = !0);
    var v = function(b) {
      return {
        isDisabled: function() {
          return Cr.isDisabled(b);
        },
        setDisabled: function(T) {
          return Cr.set(b, T);
        }
      };
    }, g = Nw({
      presets: "normal",
      iconContent: t.icon,
      textContent: t.text,
      htmlContent: _.none(),
      ariaLabel: t.text,
      caret: _.none(),
      checkMark: _.none(),
      shortcutContent: t.shortcut
    }, o, l);
    return bp({
      data: Tm(t),
      getApi: v,
      disabled: t.disabled,
      onAction: t.onAction,
      onSetup: t.onSetup,
      triggersSubmenu: !1,
      itemBehaviours: []
    }, g, r, o);
  }, w7 = function(t) {
    var r = t.text.fold(function() {
      return {};
    }, function(o) {
      return { innerHtml: o };
    });
    return {
      type: "separator",
      dom: $({
        tag: "div",
        classes: [
          UE,
          Tb
        ]
      }, r),
      components: []
    };
  }, C7 = function(t, r, o, l) {
    l === void 0 && (l = !0);
    var v = function(b) {
      return {
        setActive: function(T) {
          wa.set(b, T);
        },
        isActive: function() {
          return wa.isOn(b);
        },
        isDisabled: function() {
          return Cr.isDisabled(b);
        },
        setDisabled: function(T) {
          return Cr.set(b, T);
        }
      };
    }, g = Nw({
      iconContent: t.icon,
      textContent: t.text,
      htmlContent: _.none(),
      ariaLabel: t.text,
      checkMark: _.some(TO(o.icons)),
      caret: _.none(),
      shortcutContent: t.shortcut,
      presets: "normal",
      meta: t.meta
    }, o, l);
    return Gt(bp({
      data: Tm(t),
      disabled: t.disabled,
      getApi: v,
      onAction: t.onAction,
      onSetup: t.onSetup,
      triggersSubmenu: !1,
      itemBehaviours: []
    }, g, r, o), {
      toggling: {
        toggleClass: L5,
        toggleOnExecute: !1,
        selected: t.active
      }
    });
  }, s6 = WM, l6 = w7, S7 = y7, x_ = b7, z4 = C7, x7 = h7, H4 = bu, zw;
  (function(t) {
    t[t.ContentFocus = 0] = "ContentFocus", t[t.UiFocus = 1] = "UiFocus";
  })(zw || (zw = {}));
  var k7 = function(t, r, o, l, v) {
    var g = o.shared.providers, b = function(T) {
      return v ? $($({}, T), {
        shortcut: _.none(),
        icon: T.text.isSome() ? _.none() : T.icon
      }) : T;
    };
    switch (t.type) {
      case "menuitem":
        return lM(t).fold(Sd, function(T) {
          return _.some(S7(b(T), r, g, l));
        });
      case "nestedmenuitem":
        return Ob(t).fold(Sd, function(T) {
          return _.some(x_(b(T), r, g, l, v));
        });
      case "togglemenuitem":
        return fM(t).fold(Sd, function(T) {
          return _.some(z4(b(T), r, g, l));
        });
      case "separator":
        return FR(t).fold(Sd, function(T) {
          return _.some(l6(T));
        });
      case "fancymenuitem":
        return sM(t).fold(Sd, function(T) {
          return x7(b(T), o);
        });
      default:
        return console.error("Unknown item in general menu", t), _.none();
    }
  }, T7 = function(t, r, o, l, v, g, b) {
    var T = l === 1, A = !T || Bw(t);
    return Mr(_t(t, function(R) {
      switch (R.type) {
        case "separator":
          return zR(R).fold(Sd, function(z) {
            return _.some(l6(z));
          });
        case "cardmenuitem":
          return iM(R).fold(Sd, function(z) {
            return _.some(H4($($({}, z), {
              onAction: function(U) {
                z.onAction(U), o(z.value, z.meta);
              }
            }), v, g, {
              itemBehaviours: AO(z.meta, g),
              cardText: {
                matchText: r,
                highlightOn: b
              }
            }));
          });
        case "autocompleteitem":
        default:
          return HR(R).fold(Sd, function(z) {
            return _.some(s6(z, r, T, "normal", o, v, g, A));
          });
      }
    }));
  }, c6 = function(t, r, o, l, v) {
    var g = Bw(r), b = Mr(_t(r, function(A) {
      var R = function(U) {
        return v ? !yn(U, "text") : g;
      }, z = function(U) {
        return k7(U, o, l, R(U), v);
      };
      return A.type === "nestedmenuitem" && A.getSubmenuItems().length <= 0 ? z($($({}, A), { disabled: !0 })) : z(A);
    })), T = v ? G5 : ZE;
    return T(t, g, b, 1, "normal");
  }, f6 = function(t) {
    return Ga.singleData(t.value, t);
  }, E7 = function(t, r, o, l) {
    var v = o === zw.ContentFocus ? Sx() : Rh(), g = $4(r, l), b = Eb(l);
    return {
      dom: t.dom,
      components: t.components,
      items: t.items,
      value: t.value,
      markers: {
        selectedItem: b.selectedItem,
        item: b.item
      },
      movement: g,
      fakeFocus: o === zw.ContentFocus,
      focusManager: v,
      menuBehaviours: k4.unnamedEvents(r !== "auto" ? [] : [Zr(function(T, A) {
        t_(T, 4, b.item).each(function(R) {
          var z = R.numColumns, U = R.numRows;
          Er.setGridSize(T, U, z);
        });
      })])
    };
  }, v6 = function(t, r) {
    var o = Zo(), l = Sr(!1), v = ko(Ua.sketch({
      dom: {
        tag: "div",
        classes: ["tox-autocompleter"]
      },
      components: [],
      fireDismissalEventInstead: {},
      inlineBehaviours: Fn([Jr("dismissAutocompleter", [cn(ec(), function() {
        return A();
      })])]),
      lazySink: r.getSink
    })), g = function() {
      return Ua.isOpen(v);
    }, b = function() {
      return o.get().isSome();
    }, T = function() {
      b() && Ua.hide(v);
    }, A = function() {
      if (b()) {
        var Ne = o.get().map(function(ft) {
          return ft.element;
        });
        h4(Ne.getOr(Bn.fromDom(t.selection.getNode()))).each(Wm), T(), o.clear(), l.set(!1);
      }
    }, R = Et(function() {
      return VE(t);
    }), z = function(Ne, ft) {
      var Ht = Xt(ft, function(Kt) {
        return _.from(Kt.columns);
      }).getOr(1);
      return St(ft, function(Kt) {
        var st = Kt.items;
        return T7(st, Kt.matchText, function(Bt, an) {
          var qn = t.selection.getRng();
          IE(t.dom, qn, Ne).fold(function() {
            return console.error("Lost context. Cursor probably moved");
          }, function(vn) {
            var Gn = vn.range, pn = {
              hide: function() {
                A();
              },
              reload: function(nn) {
                T(), Se(nn);
              }
            };
            l.set(!0), Kt.onAction(pn, Gn, Bt, an), l.set(!1);
          });
        }, Ht, Xu.BUBBLE_TO_SANDBOX, r, Kt.highlightOn);
      });
    }, U = function(Ne) {
      if (!b()) {
        var ft = _R(t, Ne.range);
        o.set({
          triggerChar: Ne.triggerChar,
          element: ft,
          matchLength: Ne.text.length
        }), l.set(!1);
      }
    }, oe = function(Ne, ft, Ht, Kt) {
      Ne.matchLength = ft.text.length;
      var st = Xt(Ht, function(Bt) {
        return _.from(Bt.columns);
      }).getOr(1);
      Ua.showAt(v, mr.sketch(E7(ZE("autocompleter-value", !0, Kt, st, "normal"), st, zw.ContentFocus, "normal")), {
        anchor: {
          type: "node",
          root: Bn.fromDom(t.getBody()),
          node: _.from(Ne.element)
        }
      }), Ua.getContent(v).each(Na.highlightFirst);
    }, de = function(Ne) {
      return o.get().map(function(ft) {
        return IE(t.dom, t.selection.getRng(), ft.triggerChar).bind(function(Ht) {
          return M5(t, R, Ht, Ne);
        });
      }).getOrThunk(function() {
        return IR(t, R);
      });
    }, Se = function(Ne) {
      de(Ne).fold(A, function(ft) {
        U(ft.context), ft.lookupData.then(function(Ht) {
          o.get().map(function(Kt) {
            var st = ft.context;
            if (Kt.triggerChar === st.triggerChar) {
              var Bt = z(st.triggerChar, Ht);
              Bt.length > 0 ? oe(Kt, st, Ht, Bt) : st.text.length - Kt.matchLength >= 10 ? A() : T();
            }
          });
        });
      });
    }, $e = ME(function(Ne) {
      Ne.which !== 27 && Se();
    }, 50), ut = {
      onKeypress: $e,
      cancelIfNecessary: A,
      isMenuOpen: g,
      isActive: b,
      isProcessingAction: l.get,
      getView: function() {
        return Ua.getContent(v);
      }
    };
    t.hasPlugin("rtc") === !1 && B5.setup(ut, t);
  }, _7 = { register: v6 }, Hw = function(t, r, o) {
    return Rl(t, r, o).isSome();
  }, d6 = function(t, r) {
    var o = null, l = function() {
      for (var g = [], b = 0; b < arguments.length; b++)
        g[b] = arguments[b];
      o = setTimeout(function() {
        t.apply(null, g), o = null;
      }, r);
    }, v = function() {
      o !== null && (clearTimeout(o), o = null);
    };
    return {
      cancel: v,
      schedule: l
    };
  }, m6 = 5, A7 = 400, g6 = function(t) {
    var r = t.raw;
    return r.touches === void 0 || r.touches.length !== 1 ? _.none() : _.some(r.touches[0]);
  }, O7 = function(t, r) {
    var o = Math.abs(t.clientX - r.x), l = Math.abs(t.clientY - r.y);
    return o > m6 || l > m6;
  }, k_ = function(t) {
    var r = Zo(), o = Sr(!1), l = d6(function(R) {
      t.triggerEvent(D1(), R), o.set(!0);
    }, A7), v = function(R) {
      return g6(R).each(function(z) {
        l.cancel();
        var U = {
          x: z.clientX,
          y: z.clientY,
          target: R.target
        };
        l.schedule(R), o.set(!1), r.set(U);
      }), _.none();
    }, g = function(R) {
      return l.cancel(), g6(R).each(function(z) {
        r.on(function(U) {
          O7(z, U) && r.clear();
        });
      }), _.none();
    }, b = function(R) {
      l.cancel();
      var z = function(U) {
        return Fa(U.target, R.target);
      };
      return r.get().filter(z).map(function(U) {
        return o.get() ? (R.prevent(), !1) : t.triggerEvent(Hv(), R);
      });
    }, T = nv([
      {
        key: of(),
        value: v
      },
      {
        key: Jl(),
        value: g
      },
      {
        key: Lv(),
        value: b
      }
    ]), A = function(R, z) {
      return Ft(T, z).bind(function(U) {
        return U(R);
      });
    };
    return { fireIfReady: A };
  }, D7 = function(t) {
    var r = t.raw;
    return r.which === J0[0] && !Tt([
      "input",
      "textarea"
    ], et(t.target)) && !Hw(t.target, '[contenteditable="true"]');
  }, T_ = function() {
    return br().browser.isFirefox();
  }, B7 = function(t, r) {
    return T_() ? p0(t, "focus", r) : ai(t, "focusin", r);
  }, R7 = function(t, r) {
    return T_() ? p0(t, "blur", r) : ai(t, "focusout", r);
  }, p6 = function(t, r) {
    var o = $({ stopBackspace: !0 }, r), l = [
      "touchstart",
      "touchmove",
      "touchend",
      "touchcancel",
      "gesturestart",
      "mousedown",
      "mouseup",
      "mouseover",
      "mousemove",
      "mouseout",
      "click"
    ], v = k_(o), g = _t(l.concat([
      "selectstart",
      "input",
      "contextmenu",
      "change",
      "transitionend",
      "transitioncancel",
      "drag",
      "dragstart",
      "dragend",
      "dragenter",
      "dragleave",
      "dragover",
      "drop",
      "keyup"
    ]), function(de) {
      return ai(t, de, function(Se) {
        v.fireIfReady(Se, de).each(function(ut) {
          ut && Se.kill();
        });
        var $e = o.triggerEvent(de, Se);
        $e && Se.kill();
      });
    }), b = Zo(), T = ai(t, "paste", function(de) {
      v.fireIfReady(de, "paste").each(function($e) {
        $e && de.kill();
      });
      var Se = o.triggerEvent("paste", de);
      Se && de.kill(), b.set(setTimeout(function() {
        o.triggerEvent(py(), de);
      }, 0));
    }), A = ai(t, "keydown", function(de) {
      var Se = o.triggerEvent("keydown", de);
      Se ? de.kill() : o.stopBackspace && D7(de) && de.prevent();
    }), R = B7(t, function(de) {
      var Se = o.triggerEvent("focusin", de);
      Se && de.kill();
    }), z = Zo(), U = R7(t, function(de) {
      var Se = o.triggerEvent("focusout", de);
      Se && de.kill(), z.set(setTimeout(function() {
        o.triggerEvent(gy(), de);
      }, 0));
    }), oe = function() {
      Pe(g, function(de) {
        de.unbind();
      }), A.unbind(), R.unbind(), U.unbind(), T.unbind(), b.on(clearTimeout), z.on(clearTimeout);
    };
    return { unbind: oe };
  }, Pb = function(t, r) {
    var o = Ft(t, "target").getOr(r);
    return Sr(o);
  }, M7 = function(t, r) {
    var o = Sr(!1), l = Sr(!1), v = function() {
      o.set(!0);
    }, g = function() {
      l.set(!0);
    };
    return {
      stop: v,
      cut: g,
      isStopped: o.get,
      isCut: l.get,
      event: t,
      setSource: r.set,
      getSource: r.get
    };
  }, P7 = function(t) {
    var r = Sr(!1), o = function() {
      r.set(!0);
    };
    return {
      stop: o,
      cut: ee,
      isStopped: r.get,
      isCut: ge,
      event: t,
      setSource: Be("Cannot set source of a broadcasted event"),
      getSource: Be("Cannot get source of a broadcasted event")
    };
  }, Vw = fl.generate([
    { stopped: [] },
    { resume: ["element"] },
    { complete: [] }
  ]), Uw = function(t, r, o, l, v, g) {
    var b = t(r, l), T = M7(o, v);
    return b.fold(function() {
      return g.logEventNoHandlers(r, l), Vw.complete();
    }, function(A) {
      var R = A.descHandler, z = _y(R);
      return z(T), T.isStopped() ? (g.logEventStopped(r, A.element, R.purpose), Vw.stopped()) : T.isCut() ? (g.logEventCut(r, A.element, R.purpose), Vw.complete()) : Co(A.element).fold(function() {
        return g.logNoParent(r, A.element, R.purpose), Vw.complete();
      }, function(U) {
        return g.logEventResponse(r, A.element, R.purpose), Vw.resume(U);
      });
    });
  }, h6 = function(t, r, o, l, v, g) {
    return Uw(t, r, o, l, v, g).fold(xe, function(b) {
      return h6(t, r, o, b, v, g);
    }, ge);
  }, N7 = function(t, r, o, l, v) {
    var g = Pb(o, l);
    return Uw(t, r, o, l, g, v);
  }, b6 = function(t, r, o) {
    var l = P7(r);
    return Pe(t, function(v) {
      var g = v.descHandler, b = _y(g);
      b(l);
    }), l.isStopped();
  }, I7 = function(t, r, o, l) {
    return y6(t, r, o, o.target, l);
  }, y6 = function(t, r, o, l, v) {
    var g = Pb(o, l);
    return h6(t, r, o, l, g, v);
  }, F7 = function(t, r) {
    return {
      element: t,
      descHandler: r
    };
  }, $7 = function(t, r) {
    return {
      id: t,
      descHandler: r
    };
  }, L7 = function() {
    var t = {}, r = function(b, T, A) {
      Un(A, function(R, z) {
        var U = t[z] !== void 0 ? t[z] : {};
        U[T] = Ey(R, b), t[z] = U;
      });
    }, o = function(b, T) {
      return qv(T).bind(function(A) {
        return Ft(b, A);
      }).map(function(A) {
        return F7(T, A);
      });
    }, l = function(b) {
      return Ft(t, b).map(function(T) {
        return Kr(T, function(A, R) {
          return $7(R, A);
        });
      }).getOr([]);
    }, v = function(b, T, A) {
      return Ft(t, T).bind(function(R) {
        return rg(A, function(z) {
          return o(R, z);
        }, b);
      });
    }, g = function(b) {
      Un(t, function(T, A) {
        yn(T, b) && delete T[b];
      });
    };
    return {
      registerId: r,
      unregisterId: g,
      filterByType: l,
      find: v
    };
  }, z7 = function() {
    var t = L7(), r = {}, o = function(R) {
      var z = R.element;
      return qv(z).getOrThunk(function() {
        return tS("uid-", R.element);
      });
    }, l = function(R, z) {
      var U = r[z];
      if (U === R)
        g(R);
      else
        throw new Error('The tagId "' + z + '" is already used by: ' + is(U.element) + `
Cannot use it for: ` + is(R.element) + `
The conflicting element is` + (Tr(U.element) ? " " : " not ") + "already in the DOM");
    }, v = function(R) {
      var z = o(R);
      Yn(r, z) && l(R, z);
      var U = [R];
      t.registerId(U, z, R.events), r[z] = R;
    }, g = function(R) {
      qv(R.element).each(function(z) {
        delete r[z], t.unregisterId(z);
      });
    }, b = function(R) {
      return t.filterByType(R);
    }, T = function(R, z, U) {
      return t.find(R, z, U);
    }, A = function(R) {
      return Ft(r, R);
    };
    return {
      find: T,
      filter: b,
      register: v,
      unregister: g,
      getById: A
    };
  }, H7 = function(t) {
    var r = t.dom, o = r.attributes, l = N(r, ["attributes"]);
    return {
      uid: t.uid,
      dom: $({
        tag: "div",
        attributes: $({ role: "presentation" }, o)
      }, l),
      components: t.components,
      behaviours: Gg(t.containerBehaviours),
      events: t.events,
      domModification: t.domModification,
      eventOrder: t.eventOrder
    };
  }, ms = Cl({
    name: "Container",
    factory: H7,
    configFields: [
      ct("components", []),
      Ni("containerBehaviours", []),
      ct("events", {}),
      ct("domModification", {}),
      ct("eventOrder", {})
    ]
  }), w6 = function(t) {
    var r = function(Ne) {
      return Co(t.element).fold(xe, function(ft) {
        return Fa(Ne, ft);
      });
    }, o = z7(), l = function(Ne, ft) {
      return o.find(r, Ne, ft);
    }, v = p6(t.element, {
      triggerEvent: function(Ne, ft) {
        return Py(Ne, ft.target, function(Ht) {
          return I7(l, Ne, ft, Ht);
        });
      }
    }), g = {
      debugInfo: ie("real"),
      triggerEvent: function(Ne, ft, Ht) {
        Py(Ne, ft, function(Kt) {
          return y6(l, Ne, Ht, ft, Kt);
        });
      },
      triggerFocus: function(Ne, ft) {
        qv(Ne).fold(function() {
          Mc(Ne);
        }, function(Ht) {
          Py(zv(), Ne, function(Kt) {
            return N7(l, zv(), {
              originator: ft,
              kill: ee,
              prevent: ee,
              target: Ne
            }, Ne, Kt), !1;
          });
        });
      },
      triggerEscape: function(Ne, ft) {
        g.triggerEvent("keydown", Ne.element, ft.event);
      },
      getByUid: function(Ne) {
        return $e(Ne);
      },
      getByDom: function(Ne) {
        return ut(Ne);
      },
      build: ko,
      addToGui: function(Ne) {
        A(Ne);
      },
      removeFromGui: function(Ne) {
        R(Ne);
      },
      addToWorld: function(Ne) {
        b(Ne);
      },
      removeFromWorld: function(Ne) {
        T(Ne);
      },
      broadcast: function(Ne) {
        oe(Ne);
      },
      broadcastOn: function(Ne, ft) {
        de(Ne, ft);
      },
      broadcastEvent: function(Ne, ft) {
        Se(Ne, ft);
      },
      isConnected: xe
    }, b = function(Ne) {
      Ne.connect(g), ye(Ne.element) || (o.register(Ne), Pe(Ne.components(), b), g.triggerEvent(Hd(), Ne.element, { target: Ne.element }));
    }, T = function(Ne) {
      ye(Ne.element) || (Pe(Ne.components(), T), o.unregister(Ne)), Ne.disconnect();
    }, A = function(Ne) {
      lm(t, Ne);
    }, R = function(Ne) {
      $c(Ne);
    }, z = function() {
      v.unbind(), ws(t.element);
    }, U = function(Ne) {
      var ft = o.filter(Dl());
      Pe(ft, function(Ht) {
        var Kt = Ht.descHandler, st = _y(Kt);
        st(Ne);
      });
    }, oe = function(Ne) {
      U({
        universal: !0,
        data: Ne
      });
    }, de = function(Ne, ft) {
      U({
        universal: !1,
        channels: Ne,
        data: ft
      });
    }, Se = function(Ne, ft) {
      var Ht = o.filter(Ne);
      return b6(Ht, ft);
    }, $e = function(Ne) {
      return o.getById(Ne).fold(function() {
        return ea.error(new Error('Could not find component with uid: "' + Ne + '" in system.'));
      }, ea.value);
    }, ut = function(Ne) {
      var ft = qv(Ne).getOr("not found");
      return $e(ft);
    };
    return b(t), {
      root: t,
      element: t.element,
      destroy: z,
      add: A,
      remove: R,
      getByUid: $e,
      getByDom: ut,
      addToWorld: b,
      removeFromWorld: T,
      broadcast: oe,
      broadcastOn: de,
      broadcastEvent: Se
    };
  }, Kh = function(t, r) {
    return {
      dom: {
        tag: "div",
        classes: [
          "tox-bar",
          "tox-form__controls-h-stack"
        ]
      },
      components: _t(t.items, r.interpreter)
    };
  }, V7 = ie([
    ct("prefix", "form-field"),
    Ni("fieldBehaviours", [
      la,
      jn
    ])
  ]), U7 = ie([
    Nl({
      schema: [un("dom")],
      name: "label"
    }),
    Nl({
      factory: {
        sketch: function(t) {
          return {
            uid: t.uid,
            dom: {
              tag: "span",
              styles: { display: "none" },
              attributes: { "aria-hidden": "true" },
              innerHtml: t.text
            }
          };
        }
      },
      schema: [un("text")],
      name: "aria-descriptor"
    }),
    hu({
      factory: {
        sketch: function(t) {
          var r = sy(t, ["factory"]);
          return t.factory.sketch(r);
        }
      },
      schema: [un("factory")],
      name: "field"
    })
  ]), j7 = function(t, r, o, l) {
    var v = Zi(t.fieldBehaviours, [
      la.config({
        find: function(T) {
          return Ya(T, t, "field");
        }
      }),
      jn.config({
        store: {
          mode: "manual",
          getValue: function(T) {
            return la.getCurrent(T).bind(jn.getValue);
          },
          setValue: function(T, A) {
            la.getCurrent(T).each(function(R) {
              jn.setValue(R, A);
            });
          }
        }
      })
    ]), g = ro([Zr(function(T, A) {
      var R = ox(T, t, [
        "label",
        "field",
        "aria-descriptor"
      ]);
      R.field().each(function(z) {
        var U = ur(t.prefix);
        R.label().each(function(oe) {
          Qr(oe.element, "for", U), Qr(z.element, "id", U);
        }), R["aria-descriptor"]().each(function(oe) {
          var de = ur(t.prefix);
          Qr(oe.element, "id", de), Qr(z.element, "aria-describedby", de);
        });
      });
    })]), b = {
      getField: function(T) {
        return Ya(T, t, "field");
      },
      getLabel: function(T) {
        return Ya(T, t, "label");
      }
    };
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      behaviours: v,
      events: g,
      apis: b
    };
  }, Ma = ds({
    name: "FormField",
    configFields: V7(),
    partFields: U7(),
    factory: j7,
    apis: {
      getField: function(t, r) {
        return t.getField(r);
      },
      getLabel: function(t, r) {
        return t.getLabel(r);
      }
    }
  }), V4 = function(t, r) {
    return nc({
      attributes: nv([{
        key: r.tabAttr,
        value: "true"
      }])
    });
  }, C6 = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    exhibit: V4
  }), S6 = [ct("tabAttr", "data-alloy-tabstop")], ci = Pi({
    fields: S6,
    name: "tabstopping",
    active: C6
  }), W7 = tinymce.util.Tools.resolve("tinymce.html.Entities"), jw = function(t, r, o, l) {
    var v = G7(t, r, o, l);
    return Ma.sketch(v);
  }, q7 = function(t, r) {
    return jw(t, r, [], []);
  }, G7 = function(t, r, o, l) {
    return {
      dom: x6(o),
      components: t.toArray().concat([r]),
      fieldBehaviours: Fn(l)
    };
  }, K7 = function() {
    return x6([]);
  }, x6 = function(t) {
    return {
      tag: "div",
      classes: ["tox-form__group"].concat(t)
    };
  }, _m = function(t, r) {
    return Ma.parts.label({
      dom: {
        tag: "label",
        classes: ["tox-label"],
        innerHtml: r.translate(t)
      }
    });
  }, cc = ur("form-component-change"), Ww = ur("form-close"), Xh = ur("form-cancel"), Cv = ur("form-action"), $l = ur("form-submit"), xd = ur("form-block"), E_ = ur("form-unblock"), __ = ur("form-tabchange"), A_ = ur("form-resize"), U4 = function(t, r) {
    var o, l = t.label.map(function(U) {
      return _m(U, r);
    }), v = function(U) {
      return function(oe, de) {
        Rl(de.event.target, "[data-collection-item-value]").each(function(Se) {
          U(oe, de, Se, So(Se, "data-collection-item-value"));
        });
      };
    }, g = function(U, oe) {
      var de = _t(oe, function(ut) {
        var Ne = Af.translate(ut.text), ft = t.columns === 1 ? '<div class="tox-collection__item-label">' + Ne + "</div>" : "", Ht = '<div class="tox-collection__item-icon">' + ut.icon + "</div>", Kt = {
          _: " ",
          " - ": " ",
          "-": " "
        }, st = Ne.replace(/\_| \- |\-/g, function(an) {
          return Kt[an];
        }), Bt = r.isDisabled() ? " tox-collection__item--state-disabled" : "";
        return '<div class="tox-collection__item' + Bt + '" tabindex="-1" data-collection-item-value="' + W7.encodeAllRaw(ut.value) + '" title="' + st + '" aria-label="' + st + '">' + Ht + ft + "</div>";
      }), Se = t.columns !== "auto" && t.columns > 1 ? tr(de, t.columns) : [de], $e = _t(Se, function(ut) {
        return '<div class="tox-collection__group">' + ut.join("") + "</div>";
      });
      ov(U.element, $e.join(""));
    }, b = v(function(U, oe, de, Se) {
      oe.stop(), r.isDisabled() || xr(U, Cv, {
        name: t.name,
        value: Se
      });
    }), T = [
      cn(rv(), v(function(U, oe, de) {
        Mc(de);
      })),
      cn(ig(), b),
      cn(Hv(), b),
      cn(Ol(), v(function(U, oe, de) {
        Bi(U.element, "." + Uh).each(function(Se) {
          yi(Se, Uh);
        }), Di(de, Uh);
      })),
      cn(lu(), v(function(U) {
        Bi(U.element, "." + Uh).each(function(oe) {
          yi(oe, Uh);
        });
      })),
      Ks(v(function(U, oe, de, Se) {
        xr(U, Cv, {
          name: t.name,
          value: Se
        });
      }))
    ], A = function(U, oe) {
      return _t(qu(U.element, ".tox-collection__item"), oe);
    }, R = Ma.parts.field({
      dom: {
        tag: "div",
        classes: ["tox-collection"].concat(t.columns !== 1 ? ["tox-collection--grid"] : ["tox-collection--list"])
      },
      components: [],
      factory: { sketch: Ze },
      behaviours: Fn([
        Cr.config({
          disabled: r.isDisabled,
          onDisabled: function(U) {
            A(U, function(oe) {
              Di(oe, "tox-collection__item--state-disabled"), Qr(oe, "aria-disabled", !0);
            });
          },
          onEnabled: function(U) {
            A(U, function(oe) {
              yi(oe, "tox-collection__item--state-disabled"), Gi(oe, "aria-disabled");
            });
          }
        }),
        Ui(),
        qr.config({}),
        jn.config({
          store: {
            mode: "memory",
            initialValue: []
          },
          onSetValue: function(U, oe) {
            g(U, oe), t.columns === "auto" && t_(U, 5, "tox-collection__item").each(function(de) {
              var Se = de.numRows, $e = de.numColumns;
              Er.setGridSize(U, Se, $e);
            }), Ta(U, A_);
          }
        }),
        ci.config({}),
        Er.config(r6(t.columns, "normal")),
        Jr("collection-events", T)
      ]),
      eventOrder: (o = {}, o[vl()] = [
        "disabling",
        "alloy.base.behaviour",
        "collection-events"
      ], o)
    }), z = ["tox-form__group--collection"];
    return jw(l, R, z, []);
  }, k6 = ie([
    Ba("data"),
    ct("inputAttributes", {}),
    ct("inputStyles", {}),
    ct("tag", "input"),
    ct("inputClasses", []),
    Ra("onSetValue"),
    ct("styles", {}),
    ct("eventOrder", {}),
    Ni("inputBehaviours", [
      jn,
      zr
    ]),
    ct("selectOnFocus", !0)
  ]), j4 = function(t) {
    return Fn([zr.config({
      onFocus: t.selectOnFocus ? function(r) {
        var o = r.element, l = ff(o);
        o.dom.setSelectionRange(0, l.length);
      } : ee
    })]);
  }, O_ = function(t) {
    return $($({}, j4(t)), Zi(t.inputBehaviours, [jn.config({
      store: $($({ mode: "manual" }, t.data.map(function(r) {
        return { initialValue: r };
      }).getOr({})), {
        getValue: function(r) {
          return ff(r.element);
        },
        setValue: function(r, o) {
          var l = ff(r.element);
          l !== o && mg(r.element, o);
        }
      }),
      onSetValue: t.onSetValue
    })]));
  }, W4 = function(t) {
    return {
      tag: t.tag,
      attributes: $({ type: "text" }, t.inputAttributes),
      styles: t.inputStyles,
      classes: t.inputClasses
    };
  }, X7 = function(t, r) {
    return {
      uid: t.uid,
      dom: W4(t),
      components: [],
      behaviours: O_(t),
      eventOrder: t.eventOrder
    };
  }, qw = Cl({
    name: "Input",
    configFields: k6(),
    factory: X7
  }), T6 = {}, Gw = { exports: T6 };
  (function(t, r, o, l) {
    (function(v, g) {
      typeof r == "object" && typeof o < "u" ? o.exports = g() : typeof t == "function" && t.amd ? t(g) : (v = typeof globalThis < "u" ? globalThis : v || self, v.EphoxContactWrapper = g());
    })(this, function() {
      var v = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof QB < "u" ? QB : typeof self < "u" ? self : {}, g = { exports: {} };
      (function(R) {
        (function(z) {
          var U = setTimeout;
          function oe() {
          }
          function de(st, Bt) {
            return function() {
              st.apply(Bt, arguments);
            };
          }
          function Se(st) {
            if (typeof this != "object")
              throw new TypeError("Promises must be constructed via new");
            if (typeof st != "function")
              throw new TypeError("not a function");
            this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], Kt(st, this);
          }
          function $e(st, Bt) {
            for (; st._state === 3; )
              st = st._value;
            if (st._state === 0) {
              st._deferreds.push(Bt);
              return;
            }
            st._handled = !0, Se._immediateFn(function() {
              var an = st._state === 1 ? Bt.onFulfilled : Bt.onRejected;
              if (an === null) {
                (st._state === 1 ? ut : Ne)(Bt.promise, st._value);
                return;
              }
              var qn;
              try {
                qn = an(st._value);
              } catch (vn) {
                Ne(Bt.promise, vn);
                return;
              }
              ut(Bt.promise, qn);
            });
          }
          function ut(st, Bt) {
            try {
              if (Bt === st)
                throw new TypeError("A promise cannot be resolved with itself.");
              if (Bt && (typeof Bt == "object" || typeof Bt == "function")) {
                var an = Bt.then;
                if (Bt instanceof Se) {
                  st._state = 3, st._value = Bt, ft(st);
                  return;
                } else if (typeof an == "function") {
                  Kt(de(an, Bt), st);
                  return;
                }
              }
              st._state = 1, st._value = Bt, ft(st);
            } catch (qn) {
              Ne(st, qn);
            }
          }
          function Ne(st, Bt) {
            st._state = 2, st._value = Bt, ft(st);
          }
          function ft(st) {
            st._state === 2 && st._deferreds.length === 0 && Se._immediateFn(function() {
              st._handled || Se._unhandledRejectionFn(st._value);
            });
            for (var Bt = 0, an = st._deferreds.length; Bt < an; Bt++)
              $e(st, st._deferreds[Bt]);
            st._deferreds = null;
          }
          function Ht(st, Bt, an) {
            this.onFulfilled = typeof st == "function" ? st : null, this.onRejected = typeof Bt == "function" ? Bt : null, this.promise = an;
          }
          function Kt(st, Bt) {
            var an = !1;
            try {
              st(function(qn) {
                an || (an = !0, ut(Bt, qn));
              }, function(qn) {
                an || (an = !0, Ne(Bt, qn));
              });
            } catch (qn) {
              if (an)
                return;
              an = !0, Ne(Bt, qn);
            }
          }
          Se.prototype.catch = function(st) {
            return this.then(null, st);
          }, Se.prototype.then = function(st, Bt) {
            var an = new this.constructor(oe);
            return $e(this, new Ht(st, Bt, an)), an;
          }, Se.all = function(st) {
            var Bt = Array.prototype.slice.call(st);
            return new Se(function(an, qn) {
              if (Bt.length === 0)
                return an([]);
              var vn = Bt.length;
              function Gn(nn, Wn) {
                try {
                  if (Wn && (typeof Wn == "object" || typeof Wn == "function")) {
                    var cr = Wn.then;
                    if (typeof cr == "function") {
                      cr.call(Wn, function(dn) {
                        Gn(nn, dn);
                      }, qn);
                      return;
                    }
                  }
                  Bt[nn] = Wn, --vn === 0 && an(Bt);
                } catch (dn) {
                  qn(dn);
                }
              }
              for (var pn = 0; pn < Bt.length; pn++)
                Gn(pn, Bt[pn]);
            });
          }, Se.resolve = function(st) {
            return st && typeof st == "object" && st.constructor === Se ? st : new Se(function(Bt) {
              Bt(st);
            });
          }, Se.reject = function(st) {
            return new Se(function(Bt, an) {
              an(st);
            });
          }, Se.race = function(st) {
            return new Se(function(Bt, an) {
              for (var qn = 0, vn = st.length; qn < vn; qn++)
                st[qn].then(Bt, an);
            });
          }, Se._immediateFn = typeof setImmediate == "function" ? function(st) {
            setImmediate(st);
          } : function(st) {
            U(st, 0);
          }, Se._unhandledRejectionFn = function(Bt) {
            typeof console < "u" && console && console.warn("Possible Unhandled Promise Rejection:", Bt);
          }, Se._setImmediateFn = function(Bt) {
            Se._immediateFn = Bt;
          }, Se._setUnhandledRejectionFn = function(Bt) {
            Se._unhandledRejectionFn = Bt;
          }, R.exports ? R.exports = Se : z.Promise || (z.Promise = Se);
        })(v);
      })(g);
      var b = g.exports, T = function() {
        return typeof window < "u" ? window : Function("return this;")();
      }(), A = { boltExport: T.Promise || b };
      return A;
    });
  })(void 0, T6, Gw);
  var Am = Gw.exports.boltExport, D_ = function(t) {
    var r = _.none(), o = [], l = function(R) {
      return D_(function(z) {
        v(function(U) {
          z(R(U));
        });
      });
    }, v = function(R) {
      b() ? A(R) : o.push(R);
    }, g = function(R) {
      b() || (r = _.some(R), T(o), o = []);
    }, b = function() {
      return r.isSome();
    }, T = function(R) {
      Pe(R, A);
    }, A = function(R) {
      r.each(function(z) {
        setTimeout(function() {
          R(z);
        }, 0);
      });
    };
    return t(g), {
      get: v,
      map: l,
      isReady: b
    };
  }, Y7 = function(t) {
    return D_(function(r) {
      r(t);
    });
  }, E6 = {
    nu: D_,
    pure: Y7
  }, Z7 = function(t) {
    setTimeout(function() {
      throw t;
    }, 0);
  }, Yh = function(t) {
    var r = function(A) {
      t().then(A, Z7);
    }, o = function(A) {
      return Yh(function() {
        return t().then(A);
      });
    }, l = function(A) {
      return Yh(function() {
        return t().then(function(R) {
          return A(R).toPromise();
        });
      });
    }, v = function(A) {
      return Yh(function() {
        return t().then(function() {
          return A.toPromise();
        });
      });
    }, g = function() {
      return E6.nu(r);
    }, b = function() {
      var A = null;
      return Yh(function() {
        return A === null && (A = t()), A;
      });
    }, T = t;
    return {
      map: o,
      bind: l,
      anonBind: v,
      toLazy: g,
      toCached: b,
      toPromise: T,
      get: r
    };
  }, J7 = function(t) {
    return Yh(function() {
      return new Am(t);
    });
  }, Q7 = function(t) {
    return Yh(function() {
      return Am.resolve(t);
    });
  }, Fu = {
    nu: J7,
    pure: Q7
  }, eP = [
    "input",
    "textarea"
  ], _6 = function(t) {
    var r = et(t);
    return Tt(eP, r);
  }, B_ = function(t, r) {
    var o = r.getRoot(t).getOr(t.element);
    yi(o, r.invalidClass), r.notify.each(function(l) {
      _6(t.element) && Qr(t.element, "aria-invalid", !1), l.getContainer(t).each(function(v) {
        ov(v, l.validHtml);
      }), l.onValid(t);
    });
  }, R_ = function(t, r, o, l) {
    var v = r.getRoot(t).getOr(t.element);
    Di(v, r.invalidClass), r.notify.each(function(g) {
      _6(t.element) && Qr(t.element, "aria-invalid", !0), g.getContainer(t).each(function(b) {
        ov(b, l);
      }), g.onInvalid(t, l);
    });
  }, A6 = function(t, r, o) {
    return r.validator.fold(function() {
      return Fu.pure(ea.value(!0));
    }, function(l) {
      return l.validate(t);
    });
  }, M_ = function(t, r, o) {
    return r.notify.each(function(l) {
      l.onValidate(t);
    }), A6(t, r).map(function(l) {
      return t.getSystem().isConnected() ? l.fold(function(v) {
        return R_(t, r, o, v), ea.error(v);
      }, function(v) {
        return B_(t, r), ea.value(v);
      }) : ea.error("No longer in system");
    });
  }, tP = function(t, r) {
    var o = r.getRoot(t).getOr(t.element);
    return us(o, r.invalidClass);
  }, nP = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    markValid: B_,
    markInvalid: R_,
    query: A6,
    run: M_,
    isInvalid: tP
  }), rP = function(t, r) {
    return t.validator.map(function(o) {
      return ro([cn(o.onEvent, function(l) {
        M_(l, t, r).get(Ze);
      })].concat(o.validateOnLoad ? [Zr(function(l) {
        M_(l, t, r).get(ee);
      })] : []));
    }).getOr({});
  }, q4 = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    events: rP
  }), Qs = [
    un("invalidClass"),
    ct("getRoot", _.none),
    qs("notify", [
      ct("aria", "alert"),
      ct("getContainer", _.none),
      ct("validHtml", ""),
      Ra("onValid"),
      Ra("onInvalid"),
      Ra("onValidate")
    ]),
    qs("validator", [
      un("validate"),
      ct("onEvent", "input"),
      ct("validateOnLoad", !0)
    ])
  ], Sv = Pi({
    fields: Qs,
    name: "invalidating",
    active: q4,
    apis: nP,
    extra: {
      validation: function(t) {
        return function(r) {
          var o = jn.getValue(r);
          return Fu.pure(t(o));
        };
      }
    }
  }), aP = function(t, r, o, l) {
    return o.getOrCreate(t, r, l);
  }, oP = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    getCoupled: aP
  }), iP = [xs("others", Bu(ea.value, Xl()))], uP = function() {
    var t = {}, r = function(l, v, g) {
      var b = on(v.others);
      if (b)
        return Ft(t, g).getOrThunk(function() {
          var T = Ft(v.others, g).getOrDie("No information found for coupled component: " + g), A = T(l), R = l.getSystem().build(A);
          return t[g] = R, R;
        });
      throw new Error("Cannot find coupled component: " + g + ". Known coupled components: " + JSON.stringify(b, null, 2));
    }, o = ie({});
    return Pu({
      readState: o,
      getOrCreate: r
    });
  }, O6 = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    init: uP
  }), fi = Pi({
    fields: iP,
    name: "coupling",
    apis: oP,
    state: O6
  }), D6 = ie("sink"), B6 = ie(Nl({
    name: D6(),
    overrides: ie({
      dom: { tag: "div" },
      behaviours: Fn([Jo.config({ useFixed: xe })]),
      events: ro([
        Ud(A1()),
        Ud(Ql()),
        Ud(ig())
      ])
    })
  })), Df;
  (function(t) {
    t[t.HighlightFirst = 0] = "HighlightFirst", t[t.HighlightNone = 1] = "HighlightNone";
  })(Df || (Df = {}));
  var R6 = function(t, r) {
    var o = t.getHotspot(r).getOr(r), l = "hotspot", v = t.getAnchorOverrides();
    return t.layouts.fold(function() {
      return {
        type: l,
        hotspot: o,
        overrides: v
      };
    }, function(g) {
      return {
        type: l,
        hotspot: o,
        overrides: v,
        layouts: g
      };
    });
  }, M6 = function(t, r, o) {
    var l = t.fetch;
    return l(o).map(r);
  }, P6 = function(t, r, o, l, v, g, b) {
    var T = M6(t, r, l), A = N6(l, t);
    return T.map(function(R) {
      return R.bind(function(z) {
        return _.from(Ga.sketch($($({}, g.menu()), {
          uid: Gv(""),
          data: z,
          highlightImmediately: b === Df.HighlightFirst,
          onOpenMenu: function(U, oe) {
            var de = A().getOrDie();
            Jo.position(de, oe, { anchor: o }), ga.decloak(v);
          },
          onOpenSubmenu: function(U, oe, de) {
            var Se = A().getOrDie();
            Jo.position(Se, de, {
              anchor: {
                type: "submenu",
                item: oe
              }
            }), ga.decloak(v);
          },
          onRepositionMenu: function(U, oe, de) {
            var Se = A().getOrDie();
            Jo.position(Se, oe, { anchor: o }), Pe(de, function($e) {
              Jo.position(Se, $e.triggeredMenu, {
                anchor: {
                  type: "submenu",
                  item: $e.triggeringItem
                }
              });
            });
          },
          onEscape: function() {
            return zr.focus(l), ga.close(v), _.some(!0);
          }
        })));
      });
    });
  }, G4 = function(t, r, o, l, v, g, b) {
    var T = R6(t, o), A = P6(t, r, T, o, l, v, b);
    return A.map(function(R) {
      return R.fold(function() {
        ga.isOpen(l) && ga.close(l);
      }, function(z) {
        ga.cloak(l), ga.open(l, z), g(l);
      }), l;
    });
  }, sP = function(t, r, o, l, v, g, b) {
    return ga.close(l), Fu.pure(l);
  }, Nb = function(t, r, o, l, v, g) {
    var b = fi.getCoupled(o, "sandbox"), T = ga.isOpen(b), A = T ? sP : G4;
    return A(t, r, o, b, l, v, g);
  }, lP = function(t, r, o) {
    var l = la.getCurrent(r).getOr(r), v = Au(t.element);
    o ? Pr(l.element, "min-width", v + "px") : Sc(l.element, v);
  }, N6 = function(t, r) {
    return t.getSystem().getByUid(r.uid + "-" + D6()).map(function(o) {
      return function() {
        return ea.value(o);
      };
    }).getOrThunk(function() {
      return r.lazySink.fold(function() {
        return function() {
          return ea.error(new Error("No internal sink is specified, nor could an external sink be found"));
        };
      }, function(o) {
        return function() {
          return o(t);
        };
      });
    });
  }, I6 = function(t) {
    ga.getState(t).each(function(r) {
      Ga.repositionMenus(r);
    });
  }, P_ = function(t, r, o) {
    var l = Xd(), v = function(T, A) {
      var R = R6(t, r);
      l.link(r.element), t.matchWidth && lP(R.hotspot, A, t.useMinWidth), t.onOpen(R, T, A), o !== void 0 && o.onOpen !== void 0 && o.onOpen(T, A);
    }, g = function(T, A) {
      l.unlink(r.element), o !== void 0 && o.onClose !== void 0 && o.onClose(T, A);
    }, b = N6(r, t);
    return {
      dom: {
        tag: "div",
        classes: t.sandboxClasses,
        attributes: {
          id: l.id,
          role: "listbox"
        }
      },
      behaviours: Pl.augment(t.sandboxBehaviours, [
        jn.config({
          store: {
            mode: "memory",
            initialValue: r
          }
        }),
        ga.config({
          onOpen: v,
          onClose: g,
          isPartOf: function(T, A, R) {
            return Yd(A, R) || Yd(r, R);
          },
          getAttachPoint: function() {
            return b().getOrDie();
          }
        }),
        la.config({
          find: function(T) {
            return ga.getState(T).bind(function(A) {
              return la.getCurrent(A);
            });
          }
        }),
        ju.config({ channels: $($({}, Os({ isExtraPart: ge })), vm({ doReposition: I6 })) })
      ])
    };
  }, wp = function(t) {
    var r = fi.getCoupled(t, "sandbox");
    I6(r);
  }, N_ = function() {
    return [
      ct("sandboxClasses", []),
      Pl.field("sandboxBehaviours", [
        la,
        ju,
        ga,
        jn
      ])
    ];
  }, cP = ie([
    un("dom"),
    un("fetch"),
    Ra("onOpen"),
    Ri("onExecute"),
    ct("getHotspot", _.some),
    ct("getAnchorOverrides", ie({})),
    rd(),
    Ni("dropdownBehaviours", [
      wa,
      fi,
      Er,
      zr
    ]),
    un("toggleClass"),
    ct("eventOrder", {}),
    Ba("lazySink"),
    ct("matchWidth", !1),
    ct("useMinWidth", !1),
    Ba("role")
  ].concat(N_())), Cp = ie([
    wl({
      schema: [Zd()],
      name: "menu",
      defaults: function(t) {
        return { onExecute: t.onExecute };
      }
    }),
    B6()
  ]), fP = function(t, r, o, l) {
    var v, g = function(z) {
      return Ft(t.dom, "attributes").bind(function(U) {
        return Ft(U, z);
      });
    }, b = function(z) {
      ga.getState(z).each(function(U) {
        Ga.highlightPrimary(U);
      });
    }, T = function(z) {
      var U = b;
      Nb(t, Ze, z, l, U, Df.HighlightFirst).get(ee);
    }, A = {
      expand: function(z) {
        wa.isOn(z) || Nb(t, Ze, z, l, ee, Df.HighlightNone).get(ee);
      },
      open: function(z) {
        wa.isOn(z) || Nb(t, Ze, z, l, ee, Df.HighlightFirst).get(ee);
      },
      isOpen: wa.isOn,
      close: function(z) {
        wa.isOn(z) && Nb(t, Ze, z, l, ee, Df.HighlightFirst).get(ee);
      },
      repositionMenus: function(z) {
        wa.isOn(z) && wp(z);
      }
    }, R = function(z, U) {
      return ml(z), _.some(!0);
    };
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      behaviours: Zi(t.dropdownBehaviours, [
        wa.config({
          toggleClass: t.toggleClass,
          aria: { mode: "expanded" }
        }),
        fi.config({
          others: {
            sandbox: function(z) {
              return P_(t, z, {
                onOpen: function() {
                  return wa.on(z);
                },
                onClose: function() {
                  return wa.off(z);
                }
              });
            }
          }
        }),
        Er.config({
          mode: "special",
          onSpace: R,
          onEnter: R,
          onDown: function(z, U) {
            if (Bf.isOpen(z)) {
              var oe = fi.getCoupled(z, "sandbox");
              b(oe);
            } else
              Bf.open(z);
            return _.some(!0);
          },
          onEscape: function(z, U) {
            return Bf.isOpen(z) ? (Bf.close(z), _.some(!0)) : _.none();
          }
        }),
        zr.config({})
      ]),
      events: Cb(_.some(T)),
      eventOrder: $($({}, t.eventOrder), (v = {}, v[vl()] = [
        "disabling",
        "toggling",
        "alloy.base.behaviour"
      ], v)),
      apis: A,
      domModification: {
        attributes: $($({ "aria-haspopup": "true" }, t.role.fold(function() {
          return {};
        }, function(z) {
          return { role: z };
        })), t.dom.tag === "button" ? { type: g("type").getOr("button") } : {})
      }
    };
  }, Bf = ds({
    name: "Dropdown",
    configFields: cP(),
    partFields: Cp(),
    factory: fP,
    apis: {
      open: function(t, r) {
        return t.open(r);
      },
      expand: function(t, r) {
        return t.expand(r);
      },
      close: function(t, r) {
        return t.close(r);
      },
      isOpen: function(t, r) {
        return t.isOpen(r);
      },
      repositionMenus: function(t, r) {
        return t.repositionMenus(r);
      }
    }
  }), Uc = function() {
    return nc({
      styles: {
        "-webkit-user-select": "none",
        "user-select": "none",
        "-ms-user-select": "none",
        "-moz-user-select": "-moz-none"
      },
      attributes: { unselectable: "on" }
    });
  }, F6 = function() {
    return ro([wy(Ak(), xe)]);
  }, $6 = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    events: F6,
    exhibit: Uc
  }), Kw = Pi({
    fields: [],
    name: "unselecting",
    active: $6
  }), vP = function(t, r) {
    return Bf.sketch({
      dom: t.dom,
      components: t.components,
      toggleClass: "mce-active",
      dropdownBehaviours: Fn([
        Of.button(r.providers.isDisabled),
        Ui(),
        Kw.config({}),
        ci.config({})
      ]),
      layouts: t.layouts,
      sandboxClasses: ["tox-dialog__popups"],
      lazySink: r.getSink,
      fetch: function(o) {
        return Fu.nu(function(l) {
          return t.fetch(l);
        }).map(function(l) {
          return _.from(f6(Gt(S_(ur("menu-value"), l, function(v) {
            t.onItemAction(o, v);
          }, t.columns, t.presets, Xu.CLOSE_ON_EXECUTE, ge, r.providers), { movement: $4(t.columns, t.presets) })));
        });
      },
      parts: { menu: jh(!1, 1, t.presets) }
    });
  }, Xw = ur("color-input-change"), L6 = ur("color-swatch-change"), I_ = ur("color-picker-cancel"), dP = function(t, r, o) {
    var l = Ma.parts.field({
      factory: qw,
      inputClasses: ["tox-textfield"],
      onSetValue: function(A) {
        return Sv.run(A).get(ee);
      },
      inputBehaviours: Fn([
        Cr.config({ disabled: r.providers.isDisabled }),
        Ui(),
        ci.config({}),
        Sv.config({
          invalidClass: "tox-textbox-field-invalid",
          getRoot: function(A) {
            return Co(A.element);
          },
          notify: {
            onValid: function(A) {
              var R = jn.getValue(A);
              xr(A, Xw, { color: R });
            }
          },
          validator: {
            validateOnLoad: !1,
            validate: function(A) {
              var R = jn.getValue(A);
              if (R.length === 0)
                return Fu.pure(ea.value(!0));
              var z = Bn.fromTag("span");
              Pr(z, "background-color", R);
              var U = ui(z, "background-color").fold(function() {
                return ea.error("blah");
              }, function(oe) {
                return ea.value(R);
              });
              return Fu.pure(U);
            }
          }
        })
      ]),
      selectOnFocus: !1
    }), v = t.label.map(function(A) {
      return _m(A, r.providers);
    }), g = function(A, R) {
      xr(A, L6, { value: R });
    }, b = function(A, R) {
      T.getOpt(A).each(function(z) {
        R === "custom" ? o.colorPicker(function(U) {
          U.fold(function() {
            return Ta(z, I_);
          }, function(oe) {
            g(z, oe), b_(oe);
          });
        }, "#ffffff") : R === "remove" ? g(z, "") : g(z, R);
      });
    }, T = La(vP({
      dom: {
        tag: "span",
        attributes: { "aria-label": r.providers.translate("Color swatch") }
      },
      layouts: {
        onRtl: function() {
          return [
            Vi,
            Nu,
            wi
          ];
        },
        onLtr: function() {
          return [
            Nu,
            Vi,
            wi
          ];
        }
      },
      components: [],
      fetch: C_(o.getColors(), o.hasCustomColors()),
      columns: o.getColorCols(),
      presets: "color",
      onItemAction: b
    }, r));
    return Ma.sketch({
      dom: {
        tag: "div",
        classes: ["tox-form__group"]
      },
      components: v.toArray().concat([{
        dom: {
          tag: "div",
          classes: ["tox-color-input"]
        },
        components: [
          l,
          T.asSpec()
        ]
      }]),
      fieldBehaviours: Fn([Jr("form-field-events", [
        cn(Xw, function(A, R) {
          T.getOpt(A).each(function(z) {
            Pr(z.element, "background-color", R.event.color);
          }), xr(A, cc, { name: t.name });
        }),
        cn(L6, function(A, R) {
          Ma.getField(A).each(function(z) {
            jn.setValue(z, R.event.value), la.getCurrent(A).each(zr.focus);
          });
        }),
        cn(I_, function(A, R) {
          Ma.getField(A).each(function(z) {
            la.getCurrent(A).each(zr.focus);
          });
        })
      ])])
    });
  }, mP = Nl({
    schema: [un("dom")],
    name: "label"
  }), Sp = function(t) {
    return Nl({
      name: "" + t + "-edge",
      overrides: function(r) {
        var o = r.model.manager.edgeActions[t];
        return o.fold(function() {
          return {};
        }, function(l) {
          return {
            events: ro([
              Cy(of(), function(v, g, b) {
                return l(v, b);
              }, [r]),
              Cy(Ql(), function(v, g, b) {
                return l(v, b);
              }, [r]),
              Cy($d(), function(v, g, b) {
                b.mouseIsDown.get() && l(v, b);
              }, [r])
            ])
          };
        });
      }
    });
  }, F_ = Sp("top-left"), gP = Sp("top"), pP = Sp("top-right"), hP = Sp("right"), bP = Sp("bottom-right"), yP = Sp("bottom"), wP = Sp("bottom-left"), CP = Sp("left"), z6 = hu({
    name: "thumb",
    defaults: ie({ dom: { styles: { position: "absolute" } } }),
    overrides: function(t) {
      return {
        events: ro([
          Vd(of(), t, "spectrum"),
          Vd(Jl(), t, "spectrum"),
          Vd(Lv(), t, "spectrum"),
          Vd(Ql(), t, "spectrum"),
          Vd($d(), t, "spectrum"),
          Vd(vy(), t, "spectrum")
        ])
      };
    }
  }), H6 = hu({
    schema: [as("mouseIsDown", function() {
      return Sr(!1);
    })],
    name: "spectrum",
    overrides: function(t) {
      var r = t.model, o = r.manager, l = function(v, g) {
        return o.getValueFromEvent(g).map(function(b) {
          return o.setValueFrom(v, t, b);
        });
      };
      return {
        behaviours: Fn([
          Er.config({
            mode: "special",
            onLeft: function(v) {
              return o.onLeft(v, t);
            },
            onRight: function(v) {
              return o.onRight(v, t);
            },
            onUp: function(v) {
              return o.onUp(v, t);
            },
            onDown: function(v) {
              return o.onDown(v, t);
            }
          }),
          zr.config({})
        ]),
        events: ro([
          cn(of(), l),
          cn(Jl(), l),
          cn(Ql(), l),
          cn($d(), function(v, g) {
            t.mouseIsDown.get() && l(v, g);
          })
        ])
      };
    }
  }), SP = [
    mP,
    CP,
    hP,
    gP,
    yP,
    F_,
    pP,
    wP,
    bP,
    z6,
    H6
  ], xP = "slider.change.value", Yw = ie(xP), kP = function(t) {
    return t.type.indexOf("touch") !== -1;
  }, $_ = function(t) {
    var r = t.event.raw;
    if (kP(r)) {
      var o = r;
      return o.touches !== void 0 && o.touches.length === 1 ? _.some(o.touches[0]).map(function(v) {
        return eo(v.clientX, v.clientY);
      }) : _.none();
    } else {
      var l = r;
      return l.clientX !== void 0 ? _.some(l).map(function(v) {
        return eo(v.clientX, v.clientY);
      }) : _.none();
    }
  }, V6 = "top", U6 = "right", j6 = "bottom", K4 = "left", Zh = function(t) {
    return t.model.minX;
  }, xp = function(t) {
    return t.model.minY;
  }, X4 = function(t) {
    return t.model.minX - 1;
  }, Y4 = function(t) {
    return t.model.minY - 1;
  }, Jh = function(t) {
    return t.model.maxX;
  }, Qh = function(t) {
    return t.model.maxY;
  }, e1 = function(t) {
    return t.model.maxX + 1;
  }, Z4 = function(t) {
    return t.model.maxY + 1;
  }, W6 = function(t, r, o) {
    return r(t) - o(t);
  }, xv = function(t) {
    return W6(t, Jh, Zh);
  }, L_ = function(t) {
    return W6(t, Qh, xp);
  }, t1 = function(t) {
    return xv(t) / 2;
  }, z_ = function(t) {
    return L_(t) / 2;
  }, kp = function(t) {
    return t.stepSize;
  }, q6 = function(t) {
    return t.snapToGrid;
  }, G6 = function(t) {
    return t.snapStart;
  }, K6 = function(t) {
    return t.rounded;
  }, Zw = function(t, r) {
    return t[r + "-edge"] !== void 0;
  }, X6 = function(t) {
    return Zw(t, K4);
  }, Jw = function(t) {
    return Zw(t, U6);
  }, Y6 = function(t) {
    return Zw(t, V6);
  }, Ll = function(t) {
    return Zw(t, j6);
  }, Om = function(t) {
    return t.model.value.get();
  }, Z6 = function(t) {
    return { x: t };
  }, H_ = function(t) {
    return { y: t };
  }, Dm = function(t, r) {
    return {
      x: t,
      y: r
    };
  }, Rf = function(t, r) {
    xr(t, Yw(), { value: r });
  }, TP = function(t, r) {
    Rf(t, Dm(X4(r), Y4(r)));
  }, EP = function(t, r) {
    Rf(t, H_(Y4(r)));
  }, _P = function(t, r) {
    Rf(t, Dm(t1(r), Y4(r)));
  }, AP = function(t, r) {
    Rf(t, Dm(e1(r), Y4(r)));
  }, OP = function(t, r) {
    Rf(t, Z6(e1(r)));
  }, DP = function(t, r) {
    Rf(t, Dm(e1(r), z_(r)));
  }, J6 = function(t, r) {
    Rf(t, Dm(e1(r), Z4(r)));
  }, BP = function(t, r) {
    Rf(t, H_(Z4(r)));
  }, RP = function(t, r) {
    Rf(t, Dm(t1(r), Z4(r)));
  }, MP = function(t, r) {
    Rf(t, Dm(X4(r), Z4(r)));
  }, Q6 = function(t, r) {
    Rf(t, Z6(X4(r)));
  }, J4 = function(t, r) {
    Rf(t, Dm(X4(r), z_(r)));
  }, V_ = function(t, r, o, l) {
    return t < r ? t : t > o ? o : t === r ? r - 1 : Math.max(r, t - l);
  }, Ib = function(t, r, o, l) {
    return t > o ? t : t < r ? r : t === o ? o + 1 : Math.min(o, t + l);
  }, n1 = function(t, r, o) {
    return Math.max(r, Math.min(o, t));
  }, e8 = function(t, r, o, l, v) {
    return v.fold(function() {
      var g = t - r, b = Math.round(g / l) * l;
      return n1(r + b, r - 1, o + 1);
    }, function(g) {
      var b = (t - g) % l, T = Math.round(b / l), A = Math.floor((t - g) / l), R = Math.floor((o - g) / l), z = Math.min(R, A + T), U = g + z * l;
      return Math.max(g, U);
    });
  }, t8 = function(t, r, o) {
    return Math.min(o, Math.max(t, r)) - r;
  }, U_ = function(t) {
    var r = t.min, o = t.max, l = t.range, v = t.value, g = t.step, b = t.snap, T = t.snapStart, A = t.rounded, R = t.hasMinEdge, z = t.hasMaxEdge, U = t.minBound, oe = t.maxBound, de = t.screenRange, Se = R ? r - 1 : r, $e = z ? o + 1 : o;
    if (v < U)
      return Se;
    if (v > oe)
      return $e;
    var ut = t8(v, U, oe), Ne = n1(ut / de * l + r, Se, $e);
    return b && Ne >= r && Ne <= o ? e8(Ne, r, o, g, T) : A ? Math.round(Ne) : Ne;
  }, n8 = function(t) {
    var r = t.min, o = t.max, l = t.range, v = t.value, g = t.hasMinEdge, b = t.hasMaxEdge, T = t.maxBound, A = t.maxOffset, R = t.centerMinEdge, z = t.centerMaxEdge;
    return v < r ? g ? 0 : R : v > o ? b ? T : z : (v - r) / l * A;
  }, j_ = "top", Qw = "right", r8 = "bottom", W_ = "left", a8 = "width", o8 = "height", Mf = function(t) {
    return t.element.dom.getBoundingClientRect();
  }, jc = function(t, r) {
    return t[r];
  }, Yu = function(t) {
    var r = Mf(t);
    return jc(r, W_);
  }, q_ = function(t) {
    var r = Mf(t);
    return jc(r, Qw);
  }, Q4 = function(t) {
    var r = Mf(t);
    return jc(r, j_);
  }, i8 = function(t) {
    var r = Mf(t);
    return jc(r, r8);
  }, G_ = function(t) {
    var r = Mf(t);
    return jc(r, a8);
  }, u8 = function(t) {
    var r = Mf(t);
    return jc(r, o8);
  }, s8 = function(t, r, o) {
    return (t + r) / 2 - o;
  }, l8 = function(t, r) {
    var o = Mf(t), l = Mf(r), v = jc(o, W_), g = jc(o, Qw), b = jc(l, W_);
    return s8(v, g, b);
  }, K_ = function(t, r) {
    var o = Mf(t), l = Mf(r), v = jc(o, j_), g = jc(o, r8), b = jc(l, j_);
    return s8(v, g, b);
  }, Wc = function(t, r) {
    xr(t, Yw(), { value: r });
  }, Fb = function(t) {
    return { x: t };
  }, e3 = function(t, r, o) {
    var l = {
      min: Zh(r),
      max: Jh(r),
      range: xv(r),
      value: o,
      step: kp(r),
      snap: q6(r),
      snapStart: G6(r),
      rounded: K6(r),
      hasMinEdge: X6(r),
      hasMaxEdge: Jw(r),
      minBound: Yu(t),
      maxBound: q_(t),
      screenRange: G_(t)
    };
    return U_(l);
  }, t3 = function(t, r, o) {
    var l = e3(t, r, o), v = Fb(l);
    return Wc(t, v), l;
  }, X_ = function(t, r) {
    var o = Zh(r);
    Wc(t, Fb(o));
  }, PP = function(t, r) {
    var o = Jh(r);
    Wc(t, Fb(o));
  }, NP = function(t, r, o) {
    var l = t > 0 ? Ib : V_, v = l(Om(o).x, Zh(o), Jh(o), kp(o));
    return Wc(r, Fb(v)), _.some(v);
  }, c8 = function(t) {
    return function(r, o) {
      return NP(t, r, o).map(xe);
    };
  }, IP = function(t) {
    var r = $_(t);
    return r.map(function(o) {
      return o.left;
    });
  }, FP = function(t, r, o, l, v) {
    var g = 0, b = G_(t), T = l.bind(function(z) {
      return _.some(l8(z, t));
    }).getOr(g), A = v.bind(function(z) {
      return _.some(l8(z, t));
    }).getOr(b), R = {
      min: Zh(r),
      max: Jh(r),
      range: xv(r),
      value: o,
      hasMinEdge: X6(r),
      hasMaxEdge: Jw(r),
      minBound: Yu(t),
      minOffset: g,
      maxBound: q_(t),
      maxOffset: b,
      centerMinEdge: T,
      centerMaxEdge: A
    };
    return n8(R);
  }, eC = function(t, r, o, l, v, g) {
    var b = FP(r, g, o, l, v);
    return Yu(r) - Yu(t) + b;
  }, $P = function(t, r, o, l) {
    var v = Om(o), g = eC(t, l.getSpectrum(t), v.x, l.getLeftEdge(t), l.getRightEdge(t), o), b = Au(r.element) / 2;
    Pr(r.element, "left", g - b + "px");
  }, f8 = c8(-1), LP = c8(1), kd = _.none, n3 = _.none, zP = {
    "top-left": _.none(),
    top: _.none(),
    "top-right": _.none(),
    right: _.some(OP),
    "bottom-right": _.none(),
    bottom: _.none(),
    "bottom-left": _.none(),
    left: _.some(Q6)
  }, HP = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    setValueFrom: t3,
    setToMin: X_,
    setToMax: PP,
    findValueOfOffset: e3,
    getValueFromEvent: IP,
    findPositionOfValue: eC,
    setPositionFromValue: $P,
    onLeft: f8,
    onRight: LP,
    onUp: kd,
    onDown: n3,
    edgeActions: zP
  }), tC = function(t, r) {
    xr(t, Yw(), { value: r });
  }, nC = function(t) {
    return { y: t };
  }, rC = function(t, r, o) {
    var l = {
      min: xp(r),
      max: Qh(r),
      range: L_(r),
      value: o,
      step: kp(r),
      snap: q6(r),
      snapStart: G6(r),
      rounded: K6(r),
      hasMinEdge: Y6(r),
      hasMaxEdge: Ll(r),
      minBound: Q4(t),
      maxBound: i8(t),
      screenRange: u8(t)
    };
    return U_(l);
  }, v8 = function(t, r, o) {
    var l = rC(t, r, o), v = nC(l);
    return tC(t, v), l;
  }, aC = function(t, r) {
    var o = xp(r);
    tC(t, nC(o));
  }, oC = function(t, r) {
    var o = Qh(r);
    tC(t, nC(o));
  }, VP = function(t, r, o) {
    var l = t > 0 ? Ib : V_, v = l(Om(o).y, xp(o), Qh(o), kp(o));
    return tC(r, nC(v)), _.some(v);
  }, d8 = function(t) {
    return function(r, o) {
      return VP(t, r, o).map(xe);
    };
  }, UP = function(t) {
    var r = $_(t);
    return r.map(function(o) {
      return o.top;
    });
  }, jP = function(t, r, o, l, v) {
    var g = 0, b = u8(t), T = l.bind(function(z) {
      return _.some(K_(z, t));
    }).getOr(g), A = v.bind(function(z) {
      return _.some(K_(z, t));
    }).getOr(b), R = {
      min: xp(r),
      max: Qh(r),
      range: L_(r),
      value: o,
      hasMinEdge: Y6(r),
      hasMaxEdge: Ll(r),
      minBound: Q4(t),
      minOffset: g,
      maxBound: i8(t),
      maxOffset: b,
      centerMinEdge: T,
      centerMaxEdge: A
    };
    return n8(R);
  }, Y_ = function(t, r, o, l, v, g) {
    var b = jP(r, g, o, l, v);
    return Q4(r) - Q4(t) + b;
  }, WP = function(t, r, o, l) {
    var v = Om(o), g = Y_(t, l.getSpectrum(t), v.y, l.getTopEdge(t), l.getBottomEdge(t), o), b = hi(r.element) / 2;
    Pr(r.element, "top", g - b + "px");
  }, qP = _.none, Z_ = _.none, r1 = d8(-1), GP = d8(1), m8 = {
    "top-left": _.none(),
    top: _.some(EP),
    "top-right": _.none(),
    right: _.none(),
    "bottom-right": _.none(),
    bottom: _.some(BP),
    "bottom-left": _.none(),
    left: _.none()
  }, KP = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    setValueFrom: v8,
    setToMin: aC,
    setToMax: oC,
    findValueOfOffset: rC,
    getValueFromEvent: UP,
    findPositionOfValue: Y_,
    setPositionFromValue: WP,
    onLeft: qP,
    onRight: Z_,
    onUp: r1,
    onDown: GP,
    edgeActions: m8
  }), r3 = function(t, r) {
    xr(t, Yw(), { value: r });
  }, a3 = function(t, r) {
    return {
      x: t,
      y: r
    };
  }, XP = function(t, r, o) {
    var l = e3(t, r, o.left), v = rC(t, r, o.top), g = a3(l, v);
    return r3(t, g), g;
  }, YP = function(t, r, o, l) {
    var v = t > 0 ? Ib : V_, g = r ? Om(l).x : v(Om(l).x, Zh(l), Jh(l), kp(l)), b = r ? v(Om(l).y, xp(l), Qh(l), kp(l)) : Om(l).y;
    return r3(o, a3(g, b)), _.some(g);
  }, iC = function(t, r) {
    return function(o, l) {
      return YP(t, r, o, l).map(xe);
    };
  }, J_ = function(t, r) {
    var o = Zh(r), l = xp(r);
    r3(t, a3(o, l));
  }, ZP = function(t, r) {
    var o = Jh(r), l = Qh(r);
    r3(t, a3(o, l));
  }, g8 = function(t) {
    return $_(t);
  }, Q_ = function(t, r, o, l) {
    var v = Om(o), g = eC(t, l.getSpectrum(t), v.x, l.getLeftEdge(t), l.getRightEdge(t), o), b = Y_(t, l.getSpectrum(t), v.y, l.getTopEdge(t), l.getBottomEdge(t), o), T = Au(r.element) / 2, A = hi(r.element) / 2;
    Pr(r.element, "left", g - T + "px"), Pr(r.element, "top", b - A + "px");
  }, eA = iC(-1, !1), p8 = iC(1, !1), JP = iC(-1, !0), QP = iC(1, !0), o3 = {
    "top-left": _.some(TP),
    top: _.some(_P),
    "top-right": _.some(AP),
    right: _.some(DP),
    "bottom-right": _.some(J6),
    bottom: _.some(RP),
    "bottom-left": _.some(MP),
    left: _.some(J4)
  }, h8 = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    setValueFrom: XP,
    setToMin: J_,
    setToMax: ZP,
    getValueFromEvent: g8,
    setPositionFromValue: Q_,
    onLeft: eA,
    onRight: p8,
    onUp: JP,
    onDown: QP,
    edgeActions: o3
  }), eN = [
    ct("stepSize", 1),
    ct("onChange", ee),
    ct("onChoose", ee),
    ct("onInit", ee),
    ct("onDragStart", ee),
    ct("onDragEnd", ee),
    ct("snapToGrid", !1),
    ct("rounded", !0),
    Ba("snapStart"),
    xs("model", Al("mode", {
      x: [
        ct("minX", 0),
        ct("maxX", 100),
        as("value", function(t) {
          return Sr(t.mode.minX);
        }),
        un("getInitialValue"),
        io("manager", HP)
      ],
      y: [
        ct("minY", 0),
        ct("maxY", 100),
        as("value", function(t) {
          return Sr(t.mode.minY);
        }),
        un("getInitialValue"),
        io("manager", KP)
      ],
      xy: [
        ct("minX", 0),
        ct("maxX", 100),
        ct("minY", 0),
        ct("maxY", 100),
        as("value", function(t) {
          return Sr({
            x: t.mode.minX,
            y: t.mode.minY
          });
        }),
        un("getInitialValue"),
        io("manager", h8)
      ]
    })),
    Ni("sliderBehaviours", [
      Er,
      jn
    ]),
    as("mouseIsDown", function() {
      return Sr(!1);
    })
  ], tN = function(t, r, o, l) {
    var v, g = function(st) {
      return xf(st, t, "thumb");
    }, b = function(st) {
      return xf(st, t, "spectrum");
    }, T = function(st) {
      return Ya(st, t, "left-edge");
    }, A = function(st) {
      return Ya(st, t, "right-edge");
    }, R = function(st) {
      return Ya(st, t, "top-edge");
    }, z = function(st) {
      return Ya(st, t, "bottom-edge");
    }, U = t.model, oe = U.manager, de = function(st, Bt) {
      oe.setPositionFromValue(st, Bt, t, {
        getLeftEdge: T,
        getRightEdge: A,
        getTopEdge: R,
        getBottomEdge: z,
        getSpectrum: b
      });
    }, Se = function(st, Bt) {
      U.value.set(Bt);
      var an = g(st);
      de(st, an);
    }, $e = function(st, Bt) {
      Se(st, Bt);
      var an = g(st);
      return t.onChange(st, an, Bt), _.some(!0);
    }, ut = function(st) {
      oe.setToMin(st, t);
    }, Ne = function(st) {
      oe.setToMax(st, t);
    }, ft = function(st) {
      var Bt = function() {
        Ya(st, t, "thumb").each(function(qn) {
          var vn = U.value.get();
          t.onChoose(st, qn, vn);
        });
      }, an = t.mouseIsDown.get();
      t.mouseIsDown.set(!1), an && Bt();
    }, Ht = function(st, Bt) {
      Bt.stop(), t.mouseIsDown.set(!0), t.onDragStart(st, g(st));
    }, Kt = function(st, Bt) {
      Bt.stop(), t.onDragEnd(st, g(st)), ft(st);
    };
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      behaviours: Zi(t.sliderBehaviours, [
        Er.config({
          mode: "special",
          focusIn: function(st) {
            return Ya(st, t, "spectrum").map(Er.focusIn).map(xe);
          }
        }),
        jn.config({
          store: {
            mode: "manual",
            getValue: function(st) {
              return U.value.get();
            }
          }
        }),
        ju.config({ channels: (v = {}, v[S2()] = { onReceive: ft }, v) })
      ]),
      events: ro([
        cn(Yw(), function(st, Bt) {
          $e(st, Bt.event.value);
        }),
        Zr(function(st, Bt) {
          var an = U.getInitialValue();
          U.value.set(an);
          var qn = g(st);
          de(st, qn);
          var vn = b(st);
          t.onInit(st, qn, vn, U.value.get());
        }),
        cn(of(), Ht),
        cn(Lv(), Kt),
        cn(Ql(), Ht),
        cn(vy(), Kt)
      ]),
      apis: {
        resetToMin: ut,
        resetToMax: Ne,
        setValue: Se,
        refresh: de
      },
      domModification: { styles: { position: "relative" } }
    };
  }, Pf = ds({
    name: "Slider",
    configFields: eN,
    partFields: SP,
    factory: tN,
    apis: {
      setValue: function(t, r, o) {
        t.setValue(r, o);
      },
      resetToMin: function(t, r) {
        t.resetToMin(r);
      },
      resetToMax: function(t, r) {
        t.resetToMax(r);
      },
      refresh: function(t, r) {
        t.refresh(r);
      }
    }
  }), tA = ur("rgb-hex-update"), Td = ur("slider-update"), i3 = ur("palette-update"), b8 = function(t, r) {
    var o = Pf.parts.spectrum({
      dom: {
        tag: "div",
        classes: [r("hue-slider-spectrum")],
        attributes: { role: "presentation" }
      }
    }), l = Pf.parts.thumb({
      dom: {
        tag: "div",
        classes: [r("hue-slider-thumb")],
        attributes: { role: "presentation" }
      }
    });
    return Pf.sketch({
      dom: {
        tag: "div",
        classes: [r("hue-slider")],
        attributes: { role: "presentation" }
      },
      rounded: !1,
      model: {
        mode: "y",
        getInitialValue: ie({ y: 0 })
      },
      components: [
        o,
        l
      ],
      sliderBehaviours: Fn([zr.config({})]),
      onChange: function(v, g, b) {
        xr(v, Td, { value: b });
      }
    });
  }, nA = "form", rA = [Ni("formBehaviours", [jn])], aA = function(t) {
    return "<alloy.field." + t + ">";
  }, u3 = function(t) {
    var r = function() {
      var g = [], b = function(T, A) {
        return g.push(T), $2(nA, aA(T), A);
      };
      return {
        field: b,
        record: ie(g)
      };
    }(), o = t(r), l = r.record(), v = _t(l, function(g) {
      return hu({
        name: g,
        pname: aA(g)
      });
    });
    return U2(nA, rA, v, w8, o);
  }, y8 = function(t, r) {
    return t.fold(function() {
      return ea.error(r);
    }, ea.value);
  }, w8 = function(t, r) {
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      behaviours: Zi(t.formBehaviours, [jn.config({
        store: {
          mode: "manual",
          getValue: function(o) {
            var l = ix(o, t);
            return Tn(l, function(v, g) {
              return v().bind(function(b) {
                var T = la.getCurrent(b);
                return y8(T, new Error("Cannot find a current component to extract the value from for form part '" + g + "': " + is(b.element)));
              }).map(jn.getValue);
            });
          },
          setValue: function(o, l) {
            Un(l, function(v, g) {
              Ya(o, t, g).each(function(b) {
                la.getCurrent(b).each(function(T) {
                  jn.setValue(T, v);
                });
              });
            });
          }
        }
      })]),
      apis: {
        getField: function(o, l) {
          return Ya(o, t, l).bind(la.getCurrent);
        }
      }
    };
  }, $b = {
    getField: Fo(function(t, r, o) {
      return t.getField(r, o);
    }),
    sketch: u3
  }, C8 = ur("valid-input"), S8 = ur("invalid-input"), x8 = ur("validating-input"), s3 = "colorcustom.rgb.", k8 = function(t, r, o, l) {
    var v = function(oe, de) {
      return Sv.config({
        invalidClass: r("invalid"),
        notify: {
          onValidate: function(Se) {
            xr(Se, x8, { type: oe });
          },
          onValid: function(Se) {
            xr(Se, C8, {
              type: oe,
              value: jn.getValue(Se)
            });
          },
          onInvalid: function(Se) {
            xr(Se, S8, {
              type: oe,
              value: jn.getValue(Se)
            });
          }
        },
        validator: {
          validate: function(Se) {
            var $e = jn.getValue(Se), ut = de($e) ? ea.value(!0) : ea.error(t("aria.input.invalid"));
            return Fu.pure(ut);
          },
          validateOnLoad: !1
        }
      });
    }, g = function(oe, de, Se, $e, ut) {
      var Ne = t(s3 + "range"), ft = Ma.parts.label({
        dom: {
          tag: "label",
          innerHtml: Se,
          attributes: { "aria-label": $e }
        }
      }), Ht = Ma.parts.field({
        data: ut,
        factory: qw,
        inputAttributes: $({ type: "text" }, de === "hex" ? { "aria-live": "polite" } : {}),
        inputClasses: [r("textfield")],
        inputBehaviours: Fn([
          v(de, oe),
          ci.config({})
        ]),
        onSetValue: function(an) {
          if (Sv.isInvalid(an)) {
            var qn = Sv.run(an);
            qn.get(ee);
          }
        }
      }), Kt = [
        ft,
        Ht
      ], st = de !== "hex" ? [Ma.parts["aria-descriptor"]({ text: Ne })] : [], Bt = Kt.concat(st);
      return {
        dom: {
          tag: "div",
          attributes: { role: "presentation" }
        },
        components: Bt
      };
    }, b = function(oe, de) {
      var Se = Iw(de);
      return $b.getField(oe, "hex").each(function($e) {
        zr.isFocused($e) || jn.setValue(oe, { hex: Se.value });
      }), Se;
    }, T = function(oe, de) {
      var Se = de.red, $e = de.green, ut = de.blue;
      jn.setValue(oe, {
        red: Se,
        green: $e,
        blue: ut
      });
    }, A = La({
      dom: {
        tag: "div",
        classes: [r("rgba-preview")],
        styles: { "background-color": "white" },
        attributes: { role: "presentation" }
      }
    }), R = function(oe, de) {
      A.getOpt(oe).each(function(Se) {
        Pr(Se.element, "background-color", "#" + de.value);
      });
    }, z = function() {
      var oe = {
        red: Sr(_.some(255)),
        green: Sr(_.some(255)),
        blue: Sr(_.some(255)),
        hex: Sr(_.some("ffffff"))
      }, de = function(nn, Wn) {
        var cr = Fw(Wn);
        T(nn, cr), Ne(cr);
      }, Se = function(nn) {
        return oe[nn].get();
      }, $e = function(nn, Wn) {
        oe[nn].set(Wn);
      }, ut = function() {
        return Se("red").bind(function(nn) {
          return Se("green").bind(function(Wn) {
            return Se("blue").map(function(cr) {
              return yp(nn, Wn, cr, 1);
            });
          });
        });
      }, Ne = function(nn) {
        var Wn = nn.red, cr = nn.green, dn = nn.blue;
        $e("red", _.some(Wn)), $e("green", _.some(cr)), $e("blue", _.some(dn));
      }, ft = function(nn, Wn) {
        var cr = Wn.event;
        cr.type !== "hex" ? $e(cr.type, _.none()) : l(nn);
      }, Ht = function(nn, Wn) {
        o(nn);
        var cr = BO(Wn);
        $e("hex", _.some(Wn));
        var dn = Fw(cr);
        T(nn, dn), Ne(dn), xr(nn, tA, { hex: cr }), R(nn, cr);
      }, Kt = function(nn, Wn, cr) {
        var dn = parseInt(cr, 10);
        $e(Wn, _.some(dn)), ut().each(function(ar) {
          var pr = b(nn, ar);
          xr(nn, tA, { hex: pr }), R(nn, pr);
        });
      }, st = function(nn) {
        return nn.type === "hex";
      }, Bt = function(nn, Wn) {
        var cr = Wn.event;
        st(cr) ? Ht(nn, cr.value) : Kt(nn, cr.type, cr.value);
      }, an = function(nn) {
        return {
          label: t(s3 + nn + ".label"),
          description: t(s3 + nn + ".description")
        };
      }, qn = an("red"), vn = an("green"), Gn = an("blue"), pn = an("hex");
      return Gt($b.sketch(function(nn) {
        return {
          dom: {
            tag: "form",
            classes: [r("rgb-form")],
            attributes: { "aria-label": t("aria.color.picker") }
          },
          components: [
            nn.field("red", Ma.sketch(g(v_, "red", qn.label, qn.description, 255))),
            nn.field("green", Ma.sketch(g(v_, "green", vn.label, vn.description, 255))),
            nn.field("blue", Ma.sketch(g(v_, "blue", Gn.label, Gn.description, 255))),
            nn.field("hex", Ma.sketch(g(PO, "hex", pn.label, pn.description, "ffffff"))),
            A.asSpec()
          ],
          formBehaviours: Fn([
            Sv.config({ invalidClass: r("form-invalid") }),
            Jr("rgb-form-events", [
              cn(C8, Bt),
              cn(S8, ft),
              cn(x8, ft)
            ])
          ])
        };
      }), {
        apis: {
          updateHex: function(nn, Wn) {
            jn.setValue(nn, { hex: Wn.value }), de(nn, Wn), R(nn, Wn);
          }
        }
      });
    }, U = Cl({
      factory: z,
      name: "RgbForm",
      configFields: [],
      apis: {
        updateHex: function(oe, de, Se) {
          oe.updateHex(de, Se);
        }
      },
      extraApis: {}
    });
    return U;
  }, nN = function(t, r) {
    var o = Pf.parts.spectrum({
      dom: {
        tag: "canvas",
        attributes: { role: "presentation" },
        classes: [r("sv-palette-spectrum")]
      }
    }), l = Pf.parts.thumb({
      dom: {
        tag: "div",
        attributes: { role: "presentation" },
        classes: [r("sv-palette-thumb")],
        innerHtml: "<div class=" + r("sv-palette-inner-thumb") + ' role="presentation"></div>'
      }
    }), v = function(R, z) {
      var U = R.width, oe = R.height, de = R.getContext("2d");
      if (de !== null) {
        de.fillStyle = z, de.fillRect(0, 0, U, oe);
        var Se = de.createLinearGradient(0, 0, U, 0);
        Se.addColorStop(0, "rgba(255,255,255,1)"), Se.addColorStop(1, "rgba(255,255,255,0)"), de.fillStyle = Se, de.fillRect(0, 0, U, oe);
        var $e = de.createLinearGradient(0, 0, 0, oe);
        $e.addColorStop(0, "rgba(0,0,0,0)"), $e.addColorStop(1, "rgba(0,0,0,1)"), de.fillStyle = $e, de.fillRect(0, 0, U, oe);
      }
    }, g = function(R, z) {
      var U = R.components()[0].element.dom, oe = $w(z, 100, 100), de = FO(oe);
      v(U, zO(de));
    }, b = function(R, z) {
      var U = m_(Fw(z));
      Pf.setValue(R, {
        x: U.saturation,
        y: 100 - U.value
      });
    }, T = function(R) {
      var z = ie({
        x: 0,
        y: 0
      }), U = function(Se, $e, ut) {
        xr(Se, i3, { value: ut });
      }, oe = function(Se, $e, ut, Ne) {
        v(ut.element.dom, zO(HO));
      }, de = Fn([
        la.config({ find: _.some }),
        zr.config({})
      ]);
      return Pf.sketch({
        dom: {
          tag: "div",
          attributes: { role: "presentation" },
          classes: [r("sv-palette")]
        },
        model: {
          mode: "xy",
          getInitialValue: z
        },
        rounded: !1,
        components: [
          o,
          l
        ],
        onChange: U,
        onInit: oe,
        sliderBehaviours: de
      });
    }, A = Cl({
      factory: T,
      name: "SaturationBrightnessPalette",
      configFields: [],
      apis: {
        setHue: function(R, z, U) {
          g(z, U);
        },
        setThumb: function(R, z, U) {
          b(z, U);
        }
      },
      extraApis: {}
    });
    return A;
  }, rN = function(t, r) {
    var o = function(v) {
      var g = k8(t, r, v.onValidHex, v.onInvalidHex), b = nN(t, r), T = function(Bt) {
        return (100 - Bt) / 100 * 360;
      }, A = function(Bt) {
        return 100 - Bt / 360 * 100;
      }, R = {
        paletteRgba: Sr(HO),
        paletteHue: Sr(0)
      }, z = La(b8(t, r)), U = La(b.sketch({})), oe = La(g.sketch({})), de = function(Bt, an, qn) {
        U.getOpt(Bt).each(function(vn) {
          b.setHue(vn, qn);
        });
      }, Se = function(Bt, an) {
        oe.getOpt(Bt).each(function(qn) {
          g.updateHex(qn, an);
        });
      }, $e = function(Bt, an, qn) {
        z.getOpt(Bt).each(function(vn) {
          Pf.setValue(vn, { y: A(qn) });
        });
      }, ut = function(Bt, an) {
        U.getOpt(Bt).each(function(qn) {
          b.setThumb(qn, an);
        });
      }, Ne = function(Bt, an) {
        var qn = Fw(Bt);
        R.paletteRgba.set(qn), R.paletteHue.set(an);
      }, ft = function(Bt, an, qn, vn) {
        Ne(an, qn), Pe(vn, function(Gn) {
          Gn(Bt, an, qn);
        });
      }, Ht = function() {
        var Bt = [Se];
        return function(an, qn) {
          var vn = qn.event.value, Gn = R.paletteHue.get(), pn = $w(Gn, vn.x, 100 - vn.y), nn = jO(pn);
          ft(an, nn, Gn, Bt);
        };
      }, Kt = function() {
        var Bt = [
          de,
          Se
        ];
        return function(an, qn) {
          var vn = T(qn.event.value.y), Gn = R.paletteRgba.get(), pn = m_(Gn), nn = $w(vn, pn.saturation, pn.value), Wn = jO(nn);
          ft(an, Wn, vn, Bt);
        };
      }, st = function() {
        var Bt = [
          de,
          $e,
          ut
        ];
        return function(an, qn) {
          var vn = qn.event.hex, Gn = n7(vn);
          ft(an, vn, Gn.hue, Bt);
        };
      };
      return {
        uid: v.uid,
        dom: v.dom,
        components: [
          U.asSpec(),
          z.asSpec(),
          oe.asSpec()
        ],
        behaviours: Fn([
          Jr("colour-picker-events", [
            cn(tA, st()),
            cn(i3, Ht()),
            cn(Td, Kt())
          ]),
          la.config({
            find: function(Bt) {
              return oe.getOpt(Bt);
            }
          }),
          Er.config({ mode: "acyclic" })
        ])
      };
    }, l = Cl({
      name: "ColourPicker",
      configFields: [
        un("dom"),
        ct("onValidHex", ee),
        ct("onInvalidHex", ee)
      ],
      factory: o
    });
    return l;
  }, aN = function() {
    return la.config({ find: _.some });
  }, l3 = function(t) {
    return la.config({ find: t.getOpt });
  }, oN = function(t) {
    return la.config({
      find: function(r) {
        return x(r.element, t).bind(function(o) {
          return r.getSystem().getByDom(o).toOptional();
        });
      }
    });
  }, kv = {
    self: aN,
    memento: l3,
    childAt: oN
  }, T8 = {
    "colorcustom.rgb.red.label": "R",
    "colorcustom.rgb.red.description": "Red component",
    "colorcustom.rgb.green.label": "G",
    "colorcustom.rgb.green.description": "Green component",
    "colorcustom.rgb.blue.label": "B",
    "colorcustom.rgb.blue.description": "Blue component",
    "colorcustom.rgb.hex.label": "#",
    "colorcustom.rgb.hex.description": "Hex color code",
    "colorcustom.rgb.range": "Range 0 to 255",
    "colorcustom.sb.saturation": "Saturation",
    "colorcustom.sb.brightness": "Brightness",
    "colorcustom.sb.picker": "Saturation and Brightness Picker",
    "colorcustom.sb.palette": "Saturation and Brightness Palette",
    "colorcustom.sb.instructions": "Use arrow keys to select saturation and brightness, on x and y axes",
    "colorcustom.hue.hue": "Hue",
    "colorcustom.hue.slider": "Hue Slider",
    "colorcustom.hue.palette": "Hue Palette",
    "colorcustom.hue.instructions": "Use arrow keys to select a hue",
    "aria.color.picker": "Color Picker",
    "aria.input.invalid": "Invalid input"
  }, E8 = function(t) {
    return T8[t];
  }, iN = function(t) {
    return E8(t);
  }, uN = function(t) {
    var r = function(b) {
      return "tox-" + b;
    }, o = rN(iN, r), l = function(b) {
      xr(b, Cv, {
        name: "hex-valid",
        value: !0
      });
    }, v = function(b) {
      xr(b, Cv, {
        name: "hex-valid",
        value: !1
      });
    }, g = La(o.sketch({
      dom: {
        tag: "div",
        classes: [r("color-picker-container")],
        attributes: { role: "presentation" }
      },
      onValidHex: l,
      onInvalidHex: v
    }));
    return {
      dom: { tag: "div" },
      components: [g.asSpec()],
      behaviours: Fn([
        jn.config({
          store: {
            mode: "manual",
            getValue: function(b) {
              var T = g.get(b), A = la.getCurrent(T), R = A.bind(function(z) {
                var U = jn.getValue(z);
                return U.hex;
              });
              return R.map(function(z) {
                return "#" + z;
              }).getOr("");
            },
            setValue: function(b, T) {
              var A = /^#([a-fA-F0-9]{3}(?:[a-fA-F0-9]{3})?)/, R = A.exec(T), z = g.get(b), U = la.getCurrent(z);
              U.fold(function() {
                console.log("Can not find form");
              }, function(oe) {
                jn.setValue(oe, { hex: _.from(R[1]).getOr("") }), $b.getField(oe, "hex").each(function(de) {
                  Ta(de, Ld());
                });
              });
            }
          }
        }),
        kv.self()
      ])
    };
  }, c3 = tinymce.util.Tools.resolve("tinymce.Resource"), sN = function(t) {
    return yn(t, "init");
  }, lN = function(t) {
    var r = Zo(), o = La({ dom: { tag: t.tag } }), l = Zo();
    return {
      dom: {
        tag: "div",
        classes: ["tox-custom-editor"]
      },
      behaviours: Fn([
        Jr("custom-editor-events", [Zr(function(v) {
          o.getOpt(v).each(function(g) {
            (sN(t) ? t.init(g.element.dom) : c3.load(t.scriptId, t.scriptUrl).then(function(b) {
              return b(g.element.dom, t.settings);
            })).then(function(b) {
              l.on(function(T) {
                b.setValue(T);
              }), l.clear(), r.set(b);
            });
          });
        })]),
        jn.config({
          store: {
            mode: "manual",
            getValue: function() {
              return r.get().fold(function() {
                return l.get().getOr("");
              }, function(v) {
                return v.getValue();
              });
            },
            setValue: function(v, g) {
              r.get().fold(function() {
                l.set(g);
              }, function(b) {
                return b.setValue(g);
              });
            }
          }
        }),
        kv.self()
      ]),
      components: [o.asSpec()]
    };
  }, Tp = tinymce.util.Tools.resolve("tinymce.util.Tools"), cN = hr([
    ct("preprocess", Ze),
    ct("postprocess", Ze)
  ]), f3 = function(t, r) {
    var o = Ha("RepresentingConfigs.memento processors", cN, r);
    return jn.config({
      store: {
        mode: "manual",
        getValue: function(l) {
          var v = t.get(l), g = jn.getValue(v);
          return o.postprocess(g);
        },
        setValue: function(l, v) {
          var g = o.preprocess(v), b = t.get(l);
          jn.setValue(b, g);
        }
      }
    });
  }, v3 = function(t, r, o) {
    return jn.config(Gt({
      store: {
        mode: "manual",
        getValue: r,
        setValue: o
      }
    }, t.map(function(l) {
      return { store: { initialValue: l } };
    }).getOr({})));
  }, oA = function(t, r, o) {
    return v3(t, function(l) {
      return r(l.element);
    }, function(l, v) {
      return o(l.element, v);
    });
  }, fN = function(t) {
    return oA(t, ff, mg);
  }, d3 = function(t) {
    return oA(t, uf, ov);
  }, vN = function(t) {
    return jn.config({
      store: {
        mode: "memory",
        initialValue: t
      }
    });
  }, Bm = {
    memento: f3,
    withElement: oA,
    withComp: v3,
    domValue: fN,
    domHtml: d3,
    memory: vN
  }, _8 = "jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp", dN = function(t, r) {
    var o = Tp.explode(r.getSetting("images_file_types", _8, "string")), l = function(v) {
      return Jt(o, function(g) {
        return sr(v.name.toLowerCase(), "." + g.toLowerCase());
      });
    };
    return We(Vt(t), l);
  }, mN = function(t, r) {
    var o = function(U, oe) {
      oe.stop();
    }, l = function(U) {
      return function(oe, de) {
        Pe(U, function(Se) {
          Se(oe, de);
        });
      };
    }, v = function(U, oe) {
      if (!Cr.isDisabled(U)) {
        var de = oe.event.raw;
        b(U, de.dataTransfer.files);
      }
    }, g = function(U, oe) {
      var de = oe.event.raw.target;
      b(U, de.files);
    }, b = function(U, oe) {
      jn.setValue(U, dN(oe, r)), xr(U, cc, { name: t.name });
    }, T = La({
      dom: {
        tag: "input",
        attributes: {
          type: "file",
          accept: "image/*"
        },
        styles: { display: "none" }
      },
      behaviours: Fn([Jr("input-file-events", [
        Ud(ig()),
        Ud(Hv())
      ])])
    }), A = function(U) {
      return {
        uid: U.uid,
        dom: {
          tag: "div",
          classes: ["tox-dropzone-container"]
        },
        behaviours: Fn([
          Bm.memory([]),
          kv.self(),
          Cr.config({}),
          wa.config({
            toggleClass: "dragenter",
            toggleOnExecute: !1
          }),
          Jr("dropzone-events", [
            cn("dragenter", l([
              o,
              wa.toggle
            ])),
            cn("dragleave", l([
              o,
              wa.toggle
            ])),
            cn("dragover", o),
            cn("drop", l([
              o,
              v
            ])),
            cn(og(), g)
          ])
        ]),
        components: [{
          dom: {
            tag: "div",
            classes: ["tox-dropzone"],
            styles: {}
          },
          components: [
            {
              dom: {
                tag: "p",
                innerHtml: r.translate("Drop an image here")
              }
            },
            Js.sketch({
              dom: {
                tag: "button",
                innerHtml: r.translate("Browse for an image"),
                styles: { position: "relative" },
                classes: [
                  "tox-button",
                  "tox-button--secondary"
                ]
              },
              components: [T.asSpec()],
              action: function(oe) {
                var de = T.get(oe);
                de.element.dom.click();
              },
              buttonBehaviours: Fn([
                ci.config({}),
                Of.button(r.isDisabled),
                Ui()
              ])
            })
          ]
        }]
      };
    }, R = t.label.map(function(U) {
      return _m(U, r);
    }), z = Ma.parts.field({ factory: { sketch: A } });
    return jw(R, z, ["tox-form__group--stretched"], []);
  }, A8 = function(t, r) {
    return {
      dom: {
        tag: "div",
        classes: [
          "tox-form__grid",
          "tox-form__grid--" + t.columns + "col"
        ]
      },
      components: _t(t.items, r.interpreter)
    };
  }, m3 = ur("alloy-fake-before-tabstop"), iA = ur("alloy-fake-after-tabstop"), uA = function(t) {
    return {
      dom: {
        tag: "div",
        styles: {
          width: "1px",
          height: "1px",
          outline: "none"
        },
        attributes: { tabindex: "0" },
        classes: t
      },
      behaviours: Fn([
        zr.config({ ignore: !0 }),
        ci.config({})
      ])
    };
  }, sA = function(t) {
    return {
      dom: {
        tag: "div",
        classes: ["tox-navobj"]
      },
      components: [
        uA([m3]),
        t,
        uA([iA])
      ],
      behaviours: Fn([kv.childAt(1)])
    };
  }, lA = function(t, r) {
    xr(t, A1(), {
      raw: {
        which: 9,
        shiftKey: r
      }
    });
  }, O8 = function(t, r) {
    var o = r.element;
    us(o, m3) ? lA(t, !0) : us(o, iA) && lA(t, !1);
  }, uC = function(t) {
    return Hw(t, [
      "." + m3,
      "." + iA
    ].join(","), ge);
  }, gN = !(br().browser.isIE() || br().browser.isEdge()), pN = function(t) {
    var r = Sr("");
    return {
      getValue: function(o) {
        return r.get();
      },
      setValue: function(o, l) {
        if (t)
          Qr(o.element, "srcdoc", l);
        else {
          Qr(o.element, "src", "javascript:''");
          var v = o.element.dom.contentWindow.document;
          v.open(), v.write(l), v.close();
        }
        r.set(l);
      }
    };
  }, D8 = function(t, r) {
    var o = gN && t.sandboxed, l = $($({}, t.label.map(function(A) {
      return { title: A };
    }).getOr({})), o ? { sandbox: "allow-scripts allow-same-origin" } : {}), v = pN(o), g = t.label.map(function(A) {
      return _m(A, r);
    }), b = function(A) {
      return sA({
        uid: A.uid,
        dom: {
          tag: "iframe",
          attributes: l
        },
        behaviours: Fn([
          ci.config({}),
          zr.config({}),
          Bm.withComp(_.none(), v.getValue, v.setValue)
        ])
      });
    }, T = Ma.parts.field({ factory: { sketch: b } });
    return jw(g, T, ["tox-form__group--stretched"], []);
  }, Lb = function(t, r) {
    return hN(document.createElement("canvas"), t, r);
  }, B8 = function(t) {
    var r = Lb(t.width, t.height), o = Rm(r);
    return o.drawImage(t, 0, 0), r;
  }, Rm = function(t) {
    return t.getContext("2d");
  }, hN = function(t, r, o) {
    return t.width = r, t.height = o, t;
  }, sC = function(t) {
    return t.naturalWidth || t.width;
  }, cA = function(t) {
    return t.naturalHeight || t.height;
  }, bN = function(t) {
    return new Am(function(r, o) {
      var l = URL.createObjectURL(t), v = new Image(), g = function() {
        v.removeEventListener("load", b), v.removeEventListener("error", T);
      }, b = function() {
        g(), r(v);
      }, T = function() {
        g(), o("Unable to load data of type " + t.type + ": " + l);
      };
      v.addEventListener("load", b), v.addEventListener("error", T), v.src = l, v.complete && setTimeout(b, 0);
    });
  }, yN = function(t) {
    var r = t.split(","), o = /data:([^;]+)/.exec(r[0]);
    if (!o)
      return _.none();
    for (var l = o[1], v = r[1], g = 1024, b = atob(v), T = b.length, A = Math.ceil(T / g), R = new Array(A), z = 0; z < A; ++z) {
      for (var U = z * g, oe = Math.min(U + g, T), de = new Array(oe - U), Se = U, $e = 0; Se < oe; ++$e, ++Se)
        de[$e] = b[Se].charCodeAt(0);
      R[z] = new Uint8Array(de);
    }
    return _.some(new Blob(R, { type: l }));
  }, wN = function(t) {
    return new Am(function(r, o) {
      yN(t).fold(function() {
        o("uri is not base64: " + t);
      }, r);
    });
  }, R8 = function(t, r, o) {
    return r = r || "image/png", D(HTMLCanvasElement.prototype.toBlob) ? new Am(function(l, v) {
      t.toBlob(function(g) {
        g ? l(g) : v();
      }, r, o);
    }) : wN(t.toDataURL(r, o));
  }, CN = function(t, r, o) {
    return r = r || "image/png", t.toDataURL(r, o);
  }, SN = function(t) {
    return bN(t).then(function(r) {
      xN(r);
      var o = Lb(sC(r), cA(r)), l = Rm(o);
      return l.drawImage(r, 0, 0), o;
    });
  }, M8 = function(t) {
    return new Am(function(r) {
      var o = new FileReader();
      o.onloadend = function() {
        r(o.result);
      }, o.readAsDataURL(t);
    });
  }, xN = function(t) {
    URL.revokeObjectURL(t.src);
  }, P8 = function(t, r, o) {
    var l = r.type, v = ie(l), g = function() {
      return Am.resolve(r);
    }, b = ie(o), T = function() {
      return o.split(",")[1];
    }, A = function(oe, de) {
      return t.then(function(Se) {
        return R8(Se, oe, de);
      });
    }, R = function(oe, de) {
      return t.then(function(Se) {
        return CN(Se, oe, de);
      });
    }, z = function(oe, de) {
      return R(oe, de).then(function(Se) {
        return Se.split(",")[1];
      });
    }, U = function() {
      return t.then(B8);
    };
    return {
      getType: v,
      toBlob: g,
      toDataURL: b,
      toBase64: T,
      toAdjustedBlob: A,
      toAdjustedDataURL: R,
      toAdjustedBase64: z,
      toCanvas: U
    };
  }, N8 = function(t) {
    return M8(t).then(function(r) {
      return P8(SN(t), t, r);
    });
  }, a1 = function(t, r) {
    return R8(t, r).then(function(o) {
      return P8(Am.resolve(t), o, t.toDataURL());
    });
  }, kN = function(t) {
    return N8(t);
  }, lC = function(t, r, o) {
    var l = typeof t == "string" ? parseFloat(t) : t;
    return l > o ? l = o : l < r && (l = r), l;
  }, fA = function() {
    return [
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1
    ];
  }, vA = [
    0,
    0.01,
    0.02,
    0.04,
    0.05,
    0.06,
    0.07,
    0.08,
    0.1,
    0.11,
    0.12,
    0.14,
    0.15,
    0.16,
    0.17,
    0.18,
    0.2,
    0.21,
    0.22,
    0.24,
    0.25,
    0.27,
    0.28,
    0.3,
    0.32,
    0.34,
    0.36,
    0.38,
    0.4,
    0.42,
    0.44,
    0.46,
    0.48,
    0.5,
    0.53,
    0.56,
    0.59,
    0.62,
    0.65,
    0.68,
    0.71,
    0.74,
    0.77,
    0.8,
    0.83,
    0.86,
    0.89,
    0.92,
    0.95,
    0.98,
    1,
    1.06,
    1.12,
    1.18,
    1.24,
    1.3,
    1.36,
    1.42,
    1.48,
    1.54,
    1.6,
    1.66,
    1.72,
    1.78,
    1.84,
    1.9,
    1.96,
    2,
    2.12,
    2.25,
    2.37,
    2.5,
    2.62,
    2.75,
    2.87,
    3,
    3.2,
    3.4,
    3.6,
    3.8,
    4,
    4.3,
    4.7,
    4.9,
    5,
    5.5,
    6,
    6.5,
    6.8,
    7,
    7.3,
    7.5,
    7.8,
    8,
    8.4,
    8.7,
    9,
    9.4,
    9.6,
    9.8,
    10
  ], dA = function(t, r) {
    for (var o = [], l = new Array(25), v, g = 0; g < 5; g++) {
      for (var b = 0; b < 5; b++)
        o[b] = r[b + g * 5];
      for (var b = 0; b < 5; b++) {
        v = 0;
        for (var T = 0; T < 5; T++)
          v += t[b + T * 5] * o[T];
        l[b + g * 5] = v;
      }
    }
    return l;
  }, I8 = function(t, r) {
    var o;
    return r = lC(r, -1, 1), r *= 100, r < 0 ? o = 127 + r / 100 * 127 : (o = r % 1, o === 0 ? o = vA[r] : o = vA[Math.floor(r)] * (1 - o) + vA[Math.floor(r) + 1] * o, o = o * 127 + 127), dA(t, [
      o / 127,
      0,
      0,
      0,
      0.5 * (127 - o),
      0,
      o / 127,
      0,
      0,
      0.5 * (127 - o),
      0,
      0,
      o / 127,
      0,
      0.5 * (127 - o),
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1
    ]);
  }, F8 = function(t, r) {
    return r = lC(255 * r, -255, 255), dA(t, [
      1,
      0,
      0,
      0,
      r,
      0,
      1,
      0,
      0,
      r,
      0,
      0,
      1,
      0,
      r,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1
    ]);
  }, $8 = function(t, r, o, l) {
    return r = lC(r, 0, 2), o = lC(o, 0, 2), l = lC(l, 0, 2), dA(t, [
      r,
      0,
      0,
      0,
      0,
      0,
      o,
      0,
      0,
      0,
      0,
      0,
      l,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      1
    ]);
  }, mA = function(t, r) {
    return t.toCanvas().then(function(o) {
      return L8(o, t.getType(), r);
    });
  }, L8 = function(t, r, o) {
    var l = Rm(t), v = function(b, T) {
      for (var A, R, z, U, oe = b.data, de = T[0], Se = T[1], $e = T[2], ut = T[3], Ne = T[4], ft = T[5], Ht = T[6], Kt = T[7], st = T[8], Bt = T[9], an = T[10], qn = T[11], vn = T[12], Gn = T[13], pn = T[14], nn = T[15], Wn = T[16], cr = T[17], dn = T[18], ar = T[19], pr = 0; pr < oe.length; pr += 4)
        A = oe[pr], R = oe[pr + 1], z = oe[pr + 2], U = oe[pr + 3], oe[pr] = A * de + R * Se + z * $e + U * ut + Ne, oe[pr + 1] = A * ft + R * Ht + z * Kt + U * st + Bt, oe[pr + 2] = A * an + R * qn + z * vn + U * Gn + pn, oe[pr + 3] = A * nn + R * Wn + z * cr + U * dn + ar;
      return b;
    }, g = v(l.getImageData(0, 0, t.width, t.height), o);
    return l.putImageData(g, 0, 0), a1(t, r);
  }, z8 = function(t, r) {
    return t.toCanvas().then(function(o) {
      return TN(o, t.getType(), r);
    });
  }, TN = function(t, r, o) {
    var l = Rm(t), v = function(T, A, R) {
      for (var z = function(Wn, cr, dn) {
        return Wn > dn ? Wn = dn : Wn < cr && (Wn = cr), Wn;
      }, U = Math.round(Math.sqrt(R.length)), oe = Math.floor(U / 2), de = T.data, Se = A.data, $e = T.width, ut = T.height, Ne = 0; Ne < ut; Ne++)
        for (var ft = 0; ft < $e; ft++) {
          for (var Ht = 0, Kt = 0, st = 0, Bt = 0; Bt < U; Bt++)
            for (var an = 0; an < U; an++) {
              var qn = z(ft + an - oe, 0, $e - 1), vn = z(Ne + Bt - oe, 0, ut - 1), Gn = (vn * $e + qn) * 4, pn = R[Bt * U + an];
              Ht += de[Gn] * pn, Kt += de[Gn + 1] * pn, st += de[Gn + 2] * pn;
            }
          var nn = (Ne * $e + ft) * 4;
          Se[nn] = z(Ht, 0, 255), Se[nn + 1] = z(Kt, 0, 255), Se[nn + 2] = z(st, 0, 255);
        }
      return A;
    }, g = l.getImageData(0, 0, t.width, t.height), b = l.getImageData(0, 0, t.width, t.height);
    return b = v(g, b, o), l.putImageData(b, 0, 0), a1(t, r);
  }, EN = function(t) {
    var r = function(o, l, v) {
      for (var g = Rm(o), b = new Array(256), T = function(z, U) {
        for (var oe = z.data, de = 0; de < oe.length; de += 4)
          oe[de] = U[oe[de]], oe[de + 1] = U[oe[de + 1]], oe[de + 2] = U[oe[de + 2]];
        return z;
      }, A = 0; A < b.length; A++)
        b[A] = t(A, v);
      var R = T(g.getImageData(0, 0, o.width, o.height), b);
      return g.putImageData(R, 0, 0), a1(o, l);
    };
    return function(o, l) {
      return o.toCanvas().then(function(v) {
        return r(v, o.getType(), l);
      });
    };
  }, H8 = function(t) {
    return function(r, o) {
      return mA(r, t(fA(), o));
    };
  }, _N = function(t) {
    return function(r) {
      return mA(r, t);
    };
  }, AN = function(t) {
    return function(r) {
      return z8(r, t);
    };
  }, ON = _N([
    -1,
    0,
    0,
    0,
    255,
    0,
    -1,
    0,
    0,
    255,
    0,
    0,
    -1,
    0,
    255,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1
  ]), V8 = H8(F8), DN = H8(I8), BN = function(t, r, o, l) {
    return mA(t, $8(fA(), r, o, l));
  }, RN = AN([
    0,
    -1,
    0,
    -1,
    5,
    -1,
    0,
    -1,
    0
  ]), xa = EN(function(t, r) {
    return Math.pow(t / 255, 1 - r) * 255;
  }), o1 = function(t, r, o) {
    var l = sC(t), v = cA(t), g = r / l, b = o / v, T = !1;
    (g < 0.5 || g > 2) && (g = g < 0.5 ? 0.5 : 2, T = !0), (b < 0.5 || b > 2) && (b = b < 0.5 ? 0.5 : 2, T = !0);
    var A = U8(t, g, b);
    return T ? A.then(function(R) {
      return o1(R, r, o);
    }) : A;
  }, U8 = function(t, r, o) {
    return new Am(function(l) {
      var v = sC(t), g = cA(t), b = Math.floor(v * r), T = Math.floor(g * o), A = Lb(b, T), R = Rm(A);
      R.drawImage(t, 0, 0, v, g, 0, 0, b, T), l(A);
    });
  }, gA = function(t, r) {
    r === void 0 && (r = 2);
    var o = Math.pow(10, r), l = Math.round(t * o);
    return Math.ceil(l / o);
  }, j8 = function(t, r) {
    return t.toCanvas().then(function(o) {
      return MN(o, t.getType(), r);
    });
  }, MN = function(t, r, o) {
    var l = o < 0 ? 360 + o : o, v = l * Math.PI / 180, g = t.width, b = t.height, T = Math.sin(v), A = Math.cos(v), R = gA(Math.abs(g * A) + Math.abs(b * T)), z = gA(Math.abs(g * T) + Math.abs(b * A)), U = Lb(R, z), oe = Rm(U);
    return oe.translate(R / 2, z / 2), oe.rotate(v), oe.drawImage(t, -g / 2, -b / 2), a1(U, r);
  }, PN = function(t, r) {
    return t.toCanvas().then(function(o) {
      return NN(o, t.getType(), r);
    });
  }, NN = function(t, r, o) {
    var l = Lb(t.width, t.height), v = Rm(l);
    return o === "v" ? (v.scale(1, -1), v.drawImage(t, 0, -l.height)) : (v.scale(-1, 1), v.drawImage(t, -l.width, 0)), a1(l, r);
  }, W8 = function(t, r, o, l, v) {
    return t.toCanvas().then(function(g) {
      return IN(g, t.getType(), r, o, l, v);
    });
  }, IN = function(t, r, o, l, v, g) {
    var b = Lb(v, g), T = Rm(b);
    return T.drawImage(t, -o, -l), a1(b, r);
  }, FN = function(t, r, o) {
    return t.toCanvas().then(function(l) {
      return o1(l, r, o).then(function(v) {
        return a1(v, t.getType());
      });
    });
  }, $N = function(t) {
    return ON(t);
  }, LN = function(t) {
    return RN(t);
  }, zN = function(t, r) {
    return xa(t, r);
  }, HN = function(t, r, o, l) {
    return BN(t, r, o, l);
  }, VN = function(t, r) {
    return V8(t, r);
  }, UN = function(t, r) {
    return DN(t, r);
  }, q8 = function(t, r) {
    return PN(t, r);
  }, jN = function(t, r, o, l, v) {
    return W8(t, r, o, l, v);
  }, WN = function(t, r, o) {
    return FN(t, r, o);
  }, pA = function(t, r) {
    return j8(t, r);
  }, G8 = function(t, r, o) {
    return wv(t, {
      tag: "span",
      classes: [
        "tox-icon",
        "tox-tbtn__icon-wrap"
      ],
      behaviours: o
    }, r);
  }, g3 = function(t, r) {
    return G8(t, r, []);
  }, K8 = function(t, r) {
    return G8(t, r, [qr.config({})]);
  }, hA = function(t, r, o) {
    return {
      dom: {
        tag: "span",
        innerHtml: o.translate(t),
        classes: [r + "__select-label"]
      },
      behaviours: Fn([qr.config({})])
    };
  }, bA, X8 = ur("toolbar.button.execute"), Y8 = function(t) {
    return Ks(function(r, o) {
      Rb(t, r)(function(l) {
        xr(r, X8, { buttonApi: l }), t.onAction(l);
      });
    });
  }, Z8 = (bA = {}, bA[vl()] = [
    "disabling",
    "alloy.base.behaviour",
    "toggling",
    "toolbar-button-events"
  ], bA), i1 = ur("update-menu-text"), J8 = ur("update-menu-icon"), p3 = function(t, r, o) {
    var l = Sr(ee), v = t.text.map(function(U) {
      return La(hA(U, r, o.providers));
    }), g = t.icon.map(function(U) {
      return La(K8(U, o.providers.icons));
    }), b = function(U, oe) {
      var de = jn.getValue(U);
      return zr.focus(de), xr(de, "keydown", { raw: oe.event.raw }), Bf.close(de), _.some(!0);
    }, T = t.role.fold(function() {
      return {};
    }, function(U) {
      return { role: U };
    }), A = t.tooltip.fold(function() {
      return {};
    }, function(U) {
      var oe = o.providers.translate(U);
      return {
        title: oe,
        "aria-label": oe
      };
    }), R = wv("chevron-down", {
      tag: "div",
      classes: [r + "__select-chevron"]
    }, o.providers.icons), z = La(Bf.sketch($($($({}, t.uid ? { uid: t.uid } : {}), T), {
      dom: {
        tag: "button",
        classes: [
          r,
          r + "--select"
        ].concat(_t(t.classes, function(U) {
          return r + "--" + U;
        })),
        attributes: $({}, A)
      },
      components: km([
        g.map(function(U) {
          return U.asSpec();
        }),
        v.map(function(U) {
          return U.asSpec();
        }),
        _.some(R)
      ]),
      matchWidth: !0,
      useMinWidth: !0,
      dropdownBehaviours: Fn(ae(ae([], t.dropdownBehaviours, !0), [
        Of.button(function() {
          return t.disabled || o.providers.isDisabled();
        }),
        Ui(),
        Kw.config({}),
        qr.config({}),
        Jr("dropdown-events", [
          qh(t, l),
          Gh(t, l)
        ]),
        Jr("menubutton-update-display-text", [
          cn(i1, function(U, oe) {
            v.bind(function(de) {
              return de.getOpt(U);
            }).each(function(de) {
              qr.set(de, [vu(o.providers.translate(oe.event.text))]);
            });
          }),
          cn(J8, function(U, oe) {
            g.bind(function(de) {
              return de.getOpt(U);
            }).each(function(de) {
              qr.set(de, [K8(oe.event.icon, o.providers.icons)]);
            });
          })
        ])
      ], !1)),
      eventOrder: Gt(Z8, {
        mousedown: [
          "focusing",
          "alloy.base.behaviour",
          "item-type-events",
          "normal-dropdown-events"
        ]
      }),
      sandboxBehaviours: Fn([Er.config({
        mode: "special",
        onLeft: b,
        onRight: b
      })]),
      lazySink: o.getSink,
      toggleClass: r + "--active",
      parts: { menu: jh(!1, t.columns, t.presets) },
      fetch: function(U) {
        return Fu.nu(Pt(t.fetch, U));
      }
    })));
    return z.asSpec();
  }, Q8 = function(t) {
    return P(t);
  }, h3 = function(t) {
    return t.type === "separator";
  }, qN = function(t) {
    return yn(t, "getSubmenuItems");
  }, GN = { type: "separator" }, KN = function(t, r) {
    var o = Ke(t, function(l, v) {
      return Q8(v) ? v === "" ? l : v === "|" ? l.length > 0 && !h3(l[l.length - 1]) ? l.concat([GN]) : l : yn(r, v.toLowerCase()) ? l.concat([r[v.toLowerCase()]]) : l : l.concat([v]);
    }, []);
    return o.length > 0 && h3(o[o.length - 1]) && o.pop(), o;
  }, XN = function(t, r) {
    var o = t.getSubmenuItems(), l = zb(o, r), v = Gt(l.menus, rf(t.value, l.items)), g = Gt(l.expansions, rf(t.value, t.value));
    return {
      item: t,
      menus: v,
      expansions: g
    };
  }, YN = function(t, r) {
    return qN(t) ? XN(t, r) : {
      item: t,
      menus: {},
      expansions: {}
    };
  }, ZN = function(t) {
    if (h3(t))
      return t;
    var r = Ft(t, "value").getOrThunk(function() {
      return ur("generated-menu-item");
    });
    return Gt({ value: r }, t);
  }, zb = function(t, r) {
    var o = KN(P(t) ? t.split(" ") : t, r);
    return Ae(o, function(l, v) {
      var g = ZN(v), b = YN(g, r);
      return {
        menus: Gt(l.menus, b.menus),
        items: [b.item].concat(l.items),
        expansions: Gt(l.expansions, b.expansions)
      };
    }, {
      menus: {},
      expansions: {},
      items: []
    });
  }, Hb = function(t, r, o, l) {
    var v = ur("primary-menu"), g = zb(t, o.shared.providers.menuItems());
    if (g.items.length === 0)
      return _.none();
    var b = c6(v, g.items, r, o, l), T = Tn(g.menus, function(R, z) {
      return c6(z, R, r, o, !1);
    }), A = Gt(T, rf(v, b));
    return _.from(Ga.tieredData(v, A, g.expansions));
  }, yA = function(t) {
    return {
      isDisabled: function() {
        return Cr.isDisabled(t);
      },
      setDisabled: function(r) {
        return Cr.set(t, r);
      },
      setActive: function(r) {
        var o = t.element;
        r ? (Di(o, "tox-tbtn--enabled"), Qr(o, "aria-pressed", !0)) : (yi(o, "tox-tbtn--enabled"), Gi(o, "aria-pressed"));
      },
      isActive: function() {
        return us(t.element, "tox-tbtn--enabled");
      }
    };
  }, wA = function(t, r, o, l) {
    return p3({
      text: t.text,
      icon: t.icon,
      tooltip: t.tooltip,
      role: l,
      fetch: function(v, g) {
        t.fetch(function(b) {
          g(Hb(b, Xu.CLOSE_ON_EXECUTE, o, !1));
        });
      },
      onSetup: t.onSetup,
      getApi: yA,
      columns: 1,
      presets: "normal",
      classes: [],
      dropdownBehaviours: [ci.config({})]
    }, r, o.shared);
  }, JN = function(t, r, o) {
    var l = function(g) {
      return function(b) {
        var T = !b.isActive();
        b.setActive(T), g.storage.set(T), o.shared.getSink().each(function(A) {
          r().getOpt(A).each(function(R) {
            Mc(R.element), xr(R, Cv, {
              name: g.name,
              value: g.storage.get()
            });
          });
        });
      };
    }, v = function(g) {
      return function(b) {
        b.setActive(g.storage.get());
      };
    };
    return function(g) {
      g(_t(t, function(b) {
        var T = b.text.fold(function() {
          return {};
        }, function(A) {
          return { text: A };
        });
        return $($({
          type: b.type,
          active: !1
        }, T), {
          onAction: l(b),
          onSetup: v(b)
        });
      }));
    };
  }, eD = function(t, r, o, l, v, g) {
    o === void 0 && (o = []);
    var b = r.fold(function() {
      return {};
    }, function(R) {
      return { action: R };
    }), T = $({
      buttonBehaviours: Fn([
        Of.button(function() {
          return t.disabled || g.isDisabled();
        }),
        Ui(),
        ci.config({}),
        Jr("button press", [
          I1("click"),
          I1("mousedown")
        ])
      ].concat(o)),
      eventOrder: {
        click: [
          "button press",
          "alloy.base.behaviour"
        ],
        mousedown: [
          "button press",
          "alloy.base.behaviour"
        ]
      }
    }, b), A = Gt(T, { dom: l });
    return Gt(A, { components: v });
  }, tD = function(t, r, o, l) {
    l === void 0 && (l = []);
    var v = t.tooltip.map(function(A) {
      return {
        "aria-label": o.translate(A),
        title: o.translate(A)
      };
    }).getOr({}), g = {
      tag: "button",
      classes: ["tox-tbtn"],
      attributes: v
    }, b = t.icon.map(function(A) {
      return g3(A, o.icons);
    }), T = km([b]);
    return eD(t, r, l, g, T, o);
  }, CA = function(t, r, o, l) {
    l === void 0 && (l = []);
    var v = tD(t, _.some(r), o, l);
    return Js.sketch(v);
  }, SA = function(t, r, o, l, v) {
    l === void 0 && (l = []), v === void 0 && (v = []);
    var g = o.translate(t.text), b = t.icon ? t.icon.map(function(U) {
      return g3(U, o.icons);
    }) : _.none(), T = b.isSome() ? km([b]) : [], A = b.isSome() ? {} : { innerHtml: g }, R = ae(ae(ae(ae([], !t.primary && !t.borderless ? [
      "tox-button",
      "tox-button--secondary"
    ] : ["tox-button"], !0), b.isSome() ? ["tox-button--icon"] : [], !0), t.borderless ? ["tox-button--naked"] : [], !0), v, !0), z = $($({
      tag: "button",
      classes: R
    }, A), { attributes: { title: g } });
    return eD(t, r, l, z, T, o);
  }, xA = function(t, r, o, l, v) {
    l === void 0 && (l = []), v === void 0 && (v = []);
    var g = SA(t, _.some(r), o, l, v);
    return Js.sketch(g);
  }, cC = function(t, r) {
    return function(o) {
      r === "custom" ? xr(o, Cv, {
        name: t,
        value: {}
      }) : r === "submit" ? Ta(o, $l) : r === "cancel" ? Ta(o, Xh) : console.error("Unknown button type: ", r);
    };
  }, b3 = function(t, r) {
    return r === "menu";
  }, QN = function(t, r) {
    return r === "custom" || r === "cancel" || r === "submit";
  }, y3 = function(t, r, o) {
    if (b3(t, r)) {
      var l = function() {
        return b;
      }, v = t, g = $($({}, t), {
        onSetup: function(R) {
          return R.setDisabled(t.disabled), ee;
        },
        fetch: JN(v.items, l, o)
      }), b = La(wA(g, "tox-tbtn", o, _.none()));
      return b.asSpec();
    } else if (QN(t, r)) {
      var T = cC(t.name, r), A = $($({}, t), { borderless: !1 });
      return xA(A, T, o.shared.providers, []);
    } else
      console.error("Unknown footer button type: ", r);
  }, eI = function(t, r) {
    var o = cC(t.name, "custom");
    return q7(_.none(), Ma.parts.field($({ factory: Js }, SA(t, _.some(o), r, [
      Bm.memory(""),
      kv.self()
    ]))));
  }, tI = ie([
    ct("field1Name", "field1"),
    ct("field2Name", "field2"),
    ls("onLockedChange"),
    Jd(["lockClass"]),
    ct("locked", !1),
    Pl.field("coupledFieldBehaviours", [
      la,
      jn
    ])
  ]), kA = function(t, r, o) {
    return Ya(t, r, o).bind(la.getCurrent);
  }, w3 = function(t, r) {
    return hu({
      factory: Ma,
      name: t,
      overrides: function(o) {
        return {
          fieldBehaviours: Fn([Jr("coupled-input-behaviour", [cn(Ld(), function(l) {
            kA(l, o, r).each(function(v) {
              Ya(l, o, "lock").each(function(g) {
                wa.isOn(g) && o.onLockedChange(l, v, g);
              });
            });
          })])])
        };
      }
    });
  }, nD = ie([
    w3("field1", "field2"),
    w3("field2", "field1"),
    hu({
      factory: Js,
      schema: [un("dom")],
      name: "lock",
      overrides: function(t) {
        return {
          buttonBehaviours: Fn([wa.config({
            selected: t.locked,
            toggleClass: t.markers.lockClass,
            aria: { mode: "pressed" }
          })])
        };
      }
    })
  ]), nI = function(t, r, o, l) {
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      behaviours: Pl.augment(t.coupledFieldBehaviours, [
        la.config({ find: _.some }),
        jn.config({
          store: {
            mode: "manual",
            getValue: function(v) {
              var g, b = G0(v, t, [
                "field1",
                "field2"
              ]);
              return g = {}, g[t.field1Name] = jn.getValue(b.field1()), g[t.field2Name] = jn.getValue(b.field2()), g;
            },
            setValue: function(v, g) {
              var b = G0(v, t, [
                "field1",
                "field2"
              ]);
              Yn(g, t.field1Name) && jn.setValue(b.field1(), g[t.field1Name]), Yn(g, t.field2Name) && jn.setValue(b.field2(), g[t.field2Name]);
            }
          }
        })
      ]),
      apis: {
        getField1: function(v) {
          return Ya(v, t, "field1");
        },
        getField2: function(v) {
          return Ya(v, t, "field2");
        },
        getLock: function(v) {
          return Ya(v, t, "lock");
        }
      }
    };
  }, xl = ds({
    name: "FormCoupledInputs",
    configFields: tI(),
    partFields: nD(),
    factory: nI,
    apis: {
      getField1: function(t, r) {
        return t.getField1(r);
      },
      getField2: function(t, r) {
        return t.getField2(r);
      },
      getLock: function(t, r) {
        return t.getLock(r);
      }
    }
  }), rI = function(t) {
    var r = {
      "": 0,
      px: 0,
      pt: 1,
      mm: 1,
      pc: 2,
      ex: 2,
      em: 2,
      ch: 2,
      rem: 2,
      cm: 3,
      in: 4,
      "%": 4
    }, o = function(v) {
      return v in r ? r[v] : 1;
    }, l = t.value.toFixed(o(t.unit));
    return l.indexOf(".") !== -1 && (l = l.replace(/\.?0*$/, "")), l + t.unit;
  }, TA = function(t) {
    var r = /^\s*(\d+(?:\.\d+)?)\s*(|cm|mm|in|px|pt|pc|em|ex|ch|rem|vw|vh|vmin|vmax|%)\s*$/, o = r.exec(t);
    if (o !== null) {
      var l = parseFloat(o[1]), v = o[2];
      return ea.value({
        value: l,
        unit: v
      });
    } else
      return ea.error(t);
  }, EA = function(t, r) {
    var o = {
      "": 96,
      px: 96,
      pt: 72,
      cm: 2.54,
      pc: 12,
      mm: 25.4,
      in: 1
    }, l = function(v) {
      return yn(o, v);
    };
    return t.unit === r ? _.some(t.value) : l(t.unit) && l(r) ? o[t.unit] === o[r] ? _.some(t.value) : _.some(t.value / o[t.unit] * o[r]) : _.none();
  }, _A = function(t) {
    return _.none();
  }, fC = function(t, r) {
    return function(o) {
      return EA(o, r).map(function(l) {
        return {
          value: l * t,
          unit: r
        };
      });
    };
  }, aI = function(t, r) {
    var o = TA(t).toOptional(), l = TA(r).toOptional();
    return Va(o, l, function(v, g) {
      return EA(v, g.unit).map(function(b) {
        return g.value / b;
      }).map(function(b) {
        return fC(b, g.unit);
      }).getOr(_A);
    }).getOr(_A);
  }, rD = function(t, r) {
    var o = _A, l = ur("ratio-event"), v = function(U) {
      return wv(U, {
        tag: "span",
        classes: [
          "tox-icon",
          "tox-lock-icon__" + U
        ]
      }, r.icons);
    }, g = xl.parts.lock({
      dom: {
        tag: "button",
        classes: [
          "tox-lock",
          "tox-button",
          "tox-button--naked",
          "tox-button--icon"
        ],
        attributes: { title: r.translate(t.label.getOr("Constrain proportions")) }
      },
      components: [
        v("lock"),
        v("unlock")
      ],
      buttonBehaviours: Fn([
        Cr.config({
          disabled: function() {
            return t.disabled || r.isDisabled();
          }
        }),
        Ui(),
        ci.config({})
      ])
    }), b = function(U) {
      return {
        dom: {
          tag: "div",
          classes: ["tox-form__group"]
        },
        components: U
      };
    }, T = function(U) {
      return Ma.parts.field({
        factory: qw,
        inputClasses: ["tox-textfield"],
        inputBehaviours: Fn([
          Cr.config({
            disabled: function() {
              return t.disabled || r.isDisabled();
            }
          }),
          Ui(),
          ci.config({}),
          Jr("size-input-events", [
            cn(Ol(), function(oe, de) {
              xr(oe, l, { isField1: U });
            }),
            cn(og(), function(oe, de) {
              xr(oe, cc, { name: t.name });
            })
          ])
        ]),
        selectOnFocus: !1
      });
    }, A = function(U) {
      return {
        dom: {
          tag: "label",
          classes: ["tox-label"],
          innerHtml: r.translate(U)
        }
      };
    }, R = xl.parts.field1(b([
      Ma.parts.label(A("Width")),
      T(!0)
    ])), z = xl.parts.field2(b([
      Ma.parts.label(A("Height")),
      T(!1)
    ]));
    return xl.sketch({
      dom: {
        tag: "div",
        classes: ["tox-form__group"]
      },
      components: [{
        dom: {
          tag: "div",
          classes: ["tox-form__controls-h-stack"]
        },
        components: [
          R,
          z,
          b([
            A("&nbsp;"),
            g
          ])
        ]
      }],
      field1Name: "width",
      field2Name: "height",
      locked: !0,
      markers: { lockClass: "tox-locked" },
      onLockedChange: function(U, oe, de) {
        TA(jn.getValue(U)).each(function(Se) {
          o(Se).each(function($e) {
            jn.setValue(oe, rI($e));
          });
        });
      },
      coupledFieldBehaviours: Fn([
        Cr.config({
          disabled: function() {
            return t.disabled || r.isDisabled();
          },
          onDisabled: function(U) {
            xl.getField1(U).bind(Ma.getField).each(Cr.disable), xl.getField2(U).bind(Ma.getField).each(Cr.disable), xl.getLock(U).each(Cr.disable);
          },
          onEnabled: function(U) {
            xl.getField1(U).bind(Ma.getField).each(Cr.enable), xl.getField2(U).bind(Ma.getField).each(Cr.enable), xl.getLock(U).each(Cr.enable);
          }
        }),
        Ui(),
        Jr("size-input-events2", [cn(l, function(U, oe) {
          var de = oe.event.isField1, Se = de ? xl.getField1(U) : xl.getField2(U), $e = de ? xl.getField2(U) : xl.getField1(U), ut = Se.map(jn.getValue).getOr(""), Ne = $e.map(jn.getValue).getOr("");
          o = aI(ut, Ne);
        })])
      ])
    });
  }, oI = ie(ur("undo")), iI = ie(ur("redo")), aD = ie(ur("zoom")), uI = ie(ur("back")), sI = ie(ur("apply")), lI = ie(ur("swap")), cI = ie(ur("transform")), fI = ie(ur("temp-transform")), oD = ie(ur("transform-apply")), gs = {
    undo: oI,
    redo: iI,
    zoom: aD,
    back: uI,
    apply: sI,
    swap: lI,
    transform: cI,
    tempTransform: fI,
    transformApply: oD
  }, vI = ie("save-state"), dI = ie("disable"), iD = ie("enable"), el = {
    formActionEvent: Cv,
    saveState: vI,
    disable: dI,
    enable: iD
  }, mI = function(t, r) {
    var o = function(Jn, ia, Za, di) {
      return La(xA({
        name: Jn,
        text: Jn,
        disabled: Za,
        primary: di,
        icon: _.none(),
        borderless: !1
      }, ia, r));
    }, l = function(Jn, ia, Za, di) {
      return La(CA({
        name: Jn,
        icon: _.some(Jn),
        tooltip: _.some(ia),
        disabled: di,
        primary: !1,
        borderless: !1
      }, Za, r));
    }, v = function(Jn, ia) {
      Jn.map(function(Za) {
        var di = Za.get(ia);
        di.hasConfigured(Cr) && Cr.disable(di);
      });
    }, g = function(Jn, ia) {
      Jn.map(function(Za) {
        var di = Za.get(ia);
        di.hasConfigured(Cr) && Cr.enable(di);
      });
    }, b = {
      tag: "div",
      classes: [
        "tox-image-tools__toolbar",
        "tox-image-tools-edit-panel"
      ]
    }, T = ee, A = function(Jn, ia, Za) {
      xr(Jn, ia, Za);
    }, R = function(Jn) {
      return Ta(Jn, el.disable());
    }, z = function(Jn) {
      return Ta(Jn, el.enable());
    }, U = function(Jn, ia) {
      R(Jn), A(Jn, gs.transform(), { transform: ia }), z(Jn);
    }, oe = function(Jn, ia) {
      R(Jn), A(Jn, gs.tempTransform(), { transform: ia }), z(Jn);
    }, de = function(Jn) {
      return function() {
        J3.getOpt(Jn).each(function(ia) {
          qr.set(ia, [Z3]);
        });
      };
    }, Se = function(Jn, ia) {
      R(Jn), A(Jn, gs.transformApply(), {
        transform: ia,
        swap: de(Jn)
      }), z(Jn);
    }, $e = function() {
      return o("Back", function(Jn) {
        return A(Jn, gs.back(), { swap: de(Jn) });
      }, !1, !1);
    }, ut = function() {
      return La({
        dom: {
          tag: "div",
          classes: ["tox-spacer"]
        },
        behaviours: Fn([Cr.config({})])
      });
    }, Ne = function() {
      return o("Apply", function(Jn) {
        return A(Jn, gs.apply(), { swap: de(Jn) });
      }, !0, !0);
    }, ft = function() {
      return function(Jn) {
        var ia = t.getRect();
        return jN(Jn, ia.x, ia.y, ia.w, ia.h);
      };
    }, Ht = [
      $e(),
      ut(),
      o("Apply", function(Jn) {
        var ia = ft();
        Se(Jn, ia), t.hideCrop();
      }, !1, !0)
    ], Kt = ms.sketch({
      dom: b,
      components: Ht.map(function(Jn) {
        return Jn.asSpec();
      }),
      containerBehaviours: Fn([Jr("image-tools-crop-buttons-events", [
        cn(el.disable(), function(Jn, ia) {
          v(Ht, Jn);
        }),
        cn(el.enable(), function(Jn, ia) {
          g(Ht, Jn);
        })
      ])])
    }), st = La(rD({
      name: "size",
      label: _.none(),
      constrain: !0,
      disabled: !1
    }, r)), Bt = function(Jn, ia) {
      return function(Za) {
        return WN(Za, Jn, ia);
      };
    }, an = [
      $e(),
      ut(),
      st,
      ut(),
      o("Apply", function(Jn) {
        st.getOpt(Jn).each(function(ia) {
          var Za = jn.getValue(ia), di = parseInt(Za.width, 10), mc = parseInt(Za.height, 10), gc = Bt(di, mc);
          Se(Jn, gc);
        });
      }, !1, !0)
    ], qn = ms.sketch({
      dom: b,
      components: an.map(function(Jn) {
        return Jn.asSpec();
      }),
      containerBehaviours: Fn([Jr("image-tools-resize-buttons-events", [
        cn(el.disable(), function(Jn, ia) {
          v(an, Jn);
        }),
        cn(el.enable(), function(Jn, ia) {
          g(an, Jn);
        })
      ])])
    }), vn = function(Jn, ia) {
      return function(Za) {
        return Jn(Za, ia);
      };
    }, Gn = vn(q8, "h"), pn = vn(q8, "v"), nn = vn(pA, -90), Wn = vn(pA, 90), cr = function(Jn, ia) {
      oe(Jn, ia);
    }, dn = [
      $e(),
      ut(),
      l("flip-horizontally", "Flip horizontally", function(Jn) {
        cr(Jn, Gn);
      }, !1),
      l("flip-vertically", "Flip vertically", function(Jn) {
        cr(Jn, pn);
      }, !1),
      l("rotate-left", "Rotate counterclockwise", function(Jn) {
        cr(Jn, nn);
      }, !1),
      l("rotate-right", "Rotate clockwise", function(Jn) {
        cr(Jn, Wn);
      }, !1),
      ut(),
      Ne()
    ], ar = ms.sketch({
      dom: b,
      components: dn.map(function(Jn) {
        return Jn.asSpec();
      }),
      containerBehaviours: Fn([Jr("image-tools-fliprotate-buttons-events", [
        cn(el.disable(), function(Jn, ia) {
          v(dn, Jn);
        }),
        cn(el.enable(), function(Jn, ia) {
          g(dn, Jn);
        })
      ])])
    }), pr = function(Jn, ia, Za, di, mc) {
      var gc = Pf.parts.label({
        dom: {
          tag: "label",
          classes: ["tox-label"],
          innerHtml: r.translate(Jn)
        }
      }), Bv = Pf.parts.spectrum({
        dom: {
          tag: "div",
          classes: ["tox-slider__rail"],
          attributes: { role: "presentation" }
        }
      }), Q3 = Pf.parts.thumb({
        dom: {
          tag: "div",
          classes: ["tox-slider__handle"],
          attributes: { role: "presentation" }
        }
      });
      return La(Pf.sketch({
        dom: {
          tag: "div",
          classes: ["tox-slider"],
          attributes: { role: "presentation" }
        },
        model: {
          mode: "x",
          minX: Za,
          maxX: mc,
          getInitialValue: ie({ x: di })
        },
        components: [
          gc,
          Bv,
          Q3
        ],
        sliderBehaviours: Fn([zr.config({})]),
        onChoose: ia
      }));
    }, ha = function(Jn, ia, Za, di, mc) {
      var gc = function(Bv, Q3, o9) {
        var i9 = vn(ia, o9.x / 100);
        U(Bv, i9);
      };
      return pr(Jn, gc, Za, di, mc);
    }, Ka = function(Jn, ia, Za, di, mc) {
      return [
        $e(),
        ha(Jn, ia, Za, di, mc),
        Ne()
      ];
    }, qo = function(Jn, ia, Za, di, mc) {
      var gc = Ka(Jn, ia, Za, di, mc);
      return ms.sketch({
        dom: b,
        components: gc.map(function(Bv) {
          return Bv.asSpec();
        }),
        containerBehaviours: Fn([Jr("image-tools-filter-panel-buttons-events", [
          cn(el.disable(), function(Bv, Q3) {
            v(gc, Bv);
          }),
          cn(el.enable(), function(Bv, Q3) {
            g(gc, Bv);
          })
        ])])
      });
    }, Dv = [
      $e(),
      ut(),
      Ne()
    ], $f = ms.sketch({
      dom: b,
      components: Dv.map(function(Jn) {
        return Jn.asSpec();
      })
    }), Z$ = qo("Brightness", VN, -100, 0, 100), J$ = qo("Contrast", UN, -100, 0, 100), PB = qo("Gamma", zN, -100, 0, 100), Q$ = function(Jn, ia, Za) {
      return function(di) {
        return HN(di, Jn, ia, Za);
      };
    }, i5 = function(Jn) {
      var ia = function(Za, di, mc) {
        var gc = NB.getOpt(Za), Bv = IB.getOpt(Za), Q3 = u5.getOpt(Za);
        gc.each(function(o9) {
          Bv.each(function(i9) {
            Q3.each(function($X) {
              var LX = jn.getValue(o9).x / 100, zX = jn.getValue($X).x / 100, HX = jn.getValue(i9).x / 100, VX = Q$(LX, zX, HX);
              U(Za, VX);
            });
          });
        });
      };
      return pr(Jn, ia, 0, 100, 200);
    }, NB = i5("R"), u5 = i5("G"), IB = i5("B"), Ad = [
      $e(),
      NB,
      u5,
      IB,
      Ne()
    ], s5 = ms.sketch({
      dom: b,
      components: Ad.map(function(Jn) {
        return Jn.asSpec();
      })
    }), dc = function(Jn, ia, Za) {
      return function(di) {
        var mc = function() {
          J3.getOpt(di).each(function(gc) {
            qr.set(gc, [Jn]), Za(gc);
          });
        };
        A(di, gs.swap(), {
          transform: ia,
          swap: mc
        });
      };
    }, e9 = function(Jn) {
      t.showCrop();
    }, t9 = function(Jn) {
      st.getOpt(Jn).each(function(ia) {
        var Za = t.getMeasurements(), di = Za.width, mc = Za.height;
        jn.setValue(ia, {
          width: di,
          height: mc
        });
      });
    }, n9 = _.some(LN), Ns = _.some($N), Kb = [
      l("crop", "Crop", dc(Kt, _.none(), e9), !1),
      l("resize", "Resize", dc(qn, _.none(), t9), !1),
      l("orientation", "Orientation", dc(ar, _.none(), T), !1),
      l("brightness", "Brightness", dc(Z$, _.none(), T), !1),
      l("sharpen", "Sharpen", dc($f, n9, T), !1),
      l("contrast", "Contrast", dc(J$, _.none(), T), !1),
      l("color-levels", "Color levels", dc(s5, _.none(), T), !1),
      l("gamma", "Gamma", dc(PB, _.none(), T), !1),
      l("invert", "Invert", dc($f, Ns, T), !1)
    ], Z3 = ms.sketch({
      dom: b,
      components: Kb.map(function(Jn) {
        return Jn.asSpec();
      })
    }), r9 = ms.sketch({
      dom: { tag: "div" },
      components: [Z3],
      containerBehaviours: Fn([qr.config({})])
    }), J3 = La(r9), a9 = function(Jn) {
      return J3.getOpt(Jn).map(function(ia) {
        var Za = ia.components()[0];
        return Za.components()[Za.components().length - 1];
      });
    };
    return {
      memContainer: J3,
      getApplyButton: a9
    };
  }, uD = tinymce.util.Tools.resolve("tinymce.geom.Rect"), fc = tinymce.util.Tools.resolve("tinymce.util.Observable"), Vb = tinymce.util.Tools.resolve("tinymce.util.VK"), AA = function(t) {
    var r = Math.max, o = t.documentElement, l = t.body, v = r(o.scrollWidth, l.scrollWidth), g = r(o.clientWidth, l.clientWidth), b = r(o.offsetWidth, l.offsetWidth), T = r(o.scrollHeight, l.scrollHeight), A = r(o.clientHeight, l.clientHeight), R = r(o.offsetHeight, l.offsetHeight);
    return {
      width: v < b ? g : v,
      height: T < R ? A : T
    };
  }, sD = function(t) {
    return Y(t.changedTouches);
  }, C3 = function(t) {
    if (sD(t))
      for (var r = "screenX screenY pageX pageY clientX clientY".split(" "), o = 0; o < r.length; o++)
        t[r[o]] = t.changedTouches[0][r[o]];
  };
  function S3(t, r) {
    var o, l, v, g, b = [], T = [], A = (o = r.document) !== null && o !== void 0 ? o : document, R = (l = r.root) !== null && l !== void 0 ? l : A, z = Bn.fromDom(A), U, oe, de, Se = Bn.fromDom(R.getElementById((v = r.handle) !== null && v !== void 0 ? v : t)), $e = function(Ht) {
      var Kt = Ht.raw, st = AA(A);
      C3(Kt), Ht.prevent(), U = Kt.button, oe = Kt.screenX, de = Kt.screenY;
      var Bt = Ho(Se, "cursor");
      g = Bn.fromTag("div", A), Hs(g, {
        position: "absolute",
        top: "0",
        left: "0",
        width: st.width + "px",
        height: st.height + "px",
        "z-index": 2147483647 + "",
        opacity: "0.0001",
        cursor: Bt
      }), Ou(Oa(z), g), T.push(ai(z, "mousemove", ut), ai(z, "touchmove", ut), ai(z, "mouseup", Ne), ai(z, "touchend", Ne)), r.start(Kt);
    }, ut = function(Ht) {
      var Kt = Ht.raw;
      if (C3(Kt), Kt.button !== U)
        return Ne(Ht);
      Kt.deltaX = Kt.screenX - oe, Kt.deltaY = Kt.screenY - de, Ht.prevent(), r.drag(Kt);
    }, Ne = function(Ht) {
      C3(Ht.raw), Pe(T, function(Kt) {
        return Kt.unbind();
      }), T = [], ws(g), r.stop && r.stop(Ht.raw);
    }, ft = function() {
      Pe(T.concat(b), function(Ht) {
        return Ht.unbind();
      }), T = [], b = [], Y(g) && ws(g);
    };
    return b.push(ai(Se, "mousedown", $e), ai(Se, "touchstart", $e)), { destroy: ft };
  }
  var gI = 0, x3 = function(t, r, o, l, v) {
    var g, b = [], T = "tox-", A = T + "crid-" + gI++, R = Bn.fromDom(l), z = [
      {
        name: "move",
        xMul: 0,
        yMul: 0,
        deltaX: 1,
        deltaY: 1,
        deltaW: 0,
        deltaH: 0,
        label: "Crop Mask"
      },
      {
        name: "nw",
        xMul: 0,
        yMul: 0,
        deltaX: 1,
        deltaY: 1,
        deltaW: -1,
        deltaH: -1,
        label: "Top Left Crop Handle"
      },
      {
        name: "ne",
        xMul: 1,
        yMul: 0,
        deltaX: 0,
        deltaY: 1,
        deltaW: 1,
        deltaH: -1,
        label: "Top Right Crop Handle"
      },
      {
        name: "sw",
        xMul: 0,
        yMul: 1,
        deltaX: 1,
        deltaY: 0,
        deltaW: -1,
        deltaH: 1,
        label: "Bottom Left Crop Handle"
      },
      {
        name: "se",
        xMul: 1,
        yMul: 1,
        deltaX: 0,
        deltaY: 0,
        deltaW: 1,
        deltaH: 1,
        label: "Bottom Right Crop Handle"
      }
    ], U = [
      "top",
      "right",
      "bottom",
      "left"
    ], oe = function(vn, Gn) {
      return {
        x: Gn.x + vn.x,
        y: Gn.y + vn.y,
        w: Gn.w,
        h: Gn.h
      };
    }, de = function(vn, Gn) {
      return {
        x: Gn.x - vn.x,
        y: Gn.y - vn.y,
        w: Gn.w,
        h: Gn.h
      };
    }, Se = function() {
      return de(o, t);
    }, $e = function(vn, Gn, pn, nn) {
      var Wn = Gn.x + pn * vn.deltaX, cr = Gn.y + nn * vn.deltaY, dn = Math.max(20, Gn.w + pn * vn.deltaW), ar = Math.max(20, Gn.h + nn * vn.deltaH), pr = t = uD.clamp({
        x: Wn,
        y: cr,
        w: dn,
        h: ar
      }, o, vn.name === "move");
      pr = de(o, pr), qn.fire("updateRect", { rect: pr }), st(pr);
    }, ut = function() {
      var vn = function(Wn) {
        var cr;
        return S3(A, {
          document: l.ownerDocument,
          root: wr(R).dom,
          handle: A + "-" + Wn.name,
          start: function() {
            cr = t;
          },
          drag: function(dn) {
            $e(Wn, cr, dn.deltaX, dn.deltaY);
          }
        });
      }, Gn = Bn.fromTag("div");
      zs(Gn, {
        id: A,
        class: T + "croprect-container",
        role: "grid",
        "aria-dropeffect": "execute"
      }), Ou(R, Gn), Pe(U, function(Wn) {
        Bi(R, "#" + A).each(function(cr) {
          var dn = Bn.fromTag("div");
          zs(dn, {
            id: A + "-" + Wn,
            class: T + "croprect-block",
            "data-mce-bogus": "all"
          }), Pr(dn, "display", "none"), Ou(cr, dn);
        });
      }), Pe(z, function(Wn) {
        Bi(R, "#" + A).each(function(cr) {
          var dn = Bn.fromTag("div");
          zs(dn, {
            id: A + "-" + Wn.name,
            "aria-label": Wn.label,
            "aria-grabbed": "false",
            "data-mce-bogus": "all",
            role: "gridcell",
            tabindex: "-1",
            title: Wn.label
          }), Kd(dn, [
            T + "croprect-handle",
            T + "croprect-handle-" + Wn.name
          ]), Pr(dn, "display", "none"), Ou(cr, dn);
        });
      }), g = _t(z, vn), ft(t);
      var pn = function(Wn) {
        Qr(Wn.target, "aria-grabbed", Wn.raw.type === "focus" ? "true" : "false");
      }, nn = function(Wn) {
        var cr;
        Pe(z, function(ar) {
          if (So(Wn.target, "id") === A + "-" + ar.name)
            return cr = ar, !1;
        });
        var dn = function(ar, pr, ha, Ka, qo) {
          ar.stopPropagation(), ar.preventDefault(), $e(cr, ha, Ka, qo);
        };
        switch (Wn.raw.keyCode) {
          case Vb.LEFT:
            dn(Wn, cr, t, -10, 0);
            break;
          case Vb.RIGHT:
            dn(Wn, cr, t, 10, 0);
            break;
          case Vb.UP:
            dn(Wn, cr, t, 0, -10);
            break;
          case Vb.DOWN:
            dn(Wn, cr, t, 0, 10);
            break;
          case Vb.ENTER:
          case Vb.SPACEBAR:
            Wn.prevent(), v();
            break;
        }
      };
      b.push(ai(R, "focusin", pn), ai(R, "focusout", pn), ai(R, "keydown", nn));
    }, Ne = function(vn) {
      var Gn = ae(ae([], _t(z, function(nn) {
        return "#" + A + "-" + nn.name;
      }), !0), _t(U, function(nn) {
        return "#" + A + "-" + nn;
      }), !0).join(","), pn = qu(R, Gn);
      vn ? Pe(pn, function(nn) {
        return Da(nn, "display");
      }) : Pe(pn, function(nn) {
        return Pr(nn, "display", "none");
      });
    }, ft = function(vn) {
      var Gn = function(pn, nn) {
        Bi(R, "#" + A + "-" + pn).each(function(Wn) {
          Hs(Wn, {
            left: nn.x + "px",
            top: nn.y + "px",
            width: Math.max(0, nn.w) + "px",
            height: Math.max(0, nn.h) + "px"
          });
        });
      };
      Pe(z, function(pn) {
        Bi(R, "#" + A + "-" + pn.name).each(function(nn) {
          Hs(nn, {
            left: vn.w * pn.xMul + vn.x + "px",
            top: vn.h * pn.yMul + vn.y + "px"
          });
        });
      }), Gn("top", {
        x: r.x,
        y: r.y,
        w: r.w,
        h: vn.y - r.y
      }), Gn("right", {
        x: vn.x + vn.w,
        y: vn.y,
        w: r.w - vn.x - vn.w + r.x,
        h: vn.h
      }), Gn("bottom", {
        x: r.x,
        y: vn.y + vn.h,
        w: r.w,
        h: r.h - vn.y - vn.h + r.y
      }), Gn("left", {
        x: r.x,
        y: vn.y,
        w: vn.x - r.x,
        h: vn.h
      }), Gn("move", vn);
    }, Ht = function(vn) {
      t = vn, ft(t);
    }, Kt = function(vn) {
      r = vn, ft(t);
    }, st = function(vn) {
      Ht(oe(o, vn));
    }, Bt = function(vn) {
      o = vn, ft(t);
    }, an = function() {
      Pe(g, function(vn) {
        return vn.destroy();
      }), g = [], Pe(b, function(vn) {
        return vn.unbind();
      }), b = [];
    };
    ut();
    var qn = $($({}, fc), {
      toggleVisibility: Ne,
      setClampRect: Bt,
      setRect: Ht,
      getInnerRect: Se,
      setInnerRect: st,
      setViewPortRect: Kt,
      destroy: an
    });
    return qn;
  }, pI = { create: x3 }, vC = function(t) {
    return new Ew(function(r) {
      var o = function() {
        t.removeEventListener("load", o), r(t);
      };
      t.complete ? r(t) : t.addEventListener("load", o);
    });
  }, lD = function(t) {
    var r = La({
      dom: {
        tag: "div",
        classes: ["tox-image-tools__image-bg"],
        attributes: { role: "presentation" }
      }
    }), o = Sr(1), l = Zy(), v = Sr({
      x: 0,
      y: 0,
      w: 1,
      h: 1
    }), g = Sr({
      x: 0,
      y: 0,
      w: 1,
      h: 1
    }), b = function(ut, Ne) {
      Se.getOpt(ut).each(function(ft) {
        var Ht = o.get(), Kt = Au(ft.element), st = hi(ft.element), Bt = Ne.dom.naturalWidth * Ht, an = Ne.dom.naturalHeight * Ht, qn = Math.max(0, Kt / 2 - Bt / 2), vn = Math.max(0, st / 2 - an / 2), Gn = {
          left: qn.toString() + "px",
          top: vn.toString() + "px",
          width: Bt.toString() + "px",
          height: an.toString() + "px",
          position: "absolute"
        };
        Hs(Ne, Gn), r.getOpt(ft).each(function(pn) {
          Hs(pn.element, Gn);
        }), l.run(function(pn) {
          var nn = v.get();
          pn.setRect({
            x: nn.x * Ht + qn,
            y: nn.y * Ht + vn,
            w: nn.w * Ht,
            h: nn.h * Ht
          }), pn.setClampRect({
            x: qn,
            y: vn,
            w: Bt,
            h: an
          }), pn.setViewPortRect({
            x: 0,
            y: 0,
            w: Kt,
            h: st
          });
        });
      });
    }, T = function(ut, Ne) {
      Se.getOpt(ut).each(function(ft) {
        var Ht = Au(ft.element), Kt = hi(ft.element), st = Ne.dom.naturalWidth, Bt = Ne.dom.naturalHeight, an = Math.min(Ht / st, Kt / Bt);
        an >= 1 ? o.set(1) : o.set(an);
      });
    }, A = function(ut, Ne) {
      var ft = Bn.fromTag("img");
      return Qr(ft, "src", Ne), vC(ft.dom).then(function() {
        ut.getSystem().isConnected() && Se.getOpt(ut).map(function(Ht) {
          var Kt = K1({ element: ft });
          qr.replaceAt(Ht, 1, _.some(Kt));
          var st = g.get(), Bt = {
            x: 0,
            y: 0,
            w: ft.dom.naturalWidth,
            h: ft.dom.naturalHeight
          };
          g.set(Bt);
          var an = uD.inflate(Bt, -20, -20);
          v.set(an), (st.w !== Bt.w || st.h !== Bt.h) && T(Ht, ft), b(Ht, ft);
        });
      });
    }, R = function(ut, Ne) {
      var ft = o.get(), Ht = Ne > 0 ? Math.min(2, ft + 0.1) : Math.max(0.1, ft - 0.1);
      o.set(Ht), Se.getOpt(ut).each(function(Kt) {
        var st = Kt.components()[1].element;
        b(Kt, st);
      });
    }, z = function() {
      l.run(function(ut) {
        ut.toggleVisibility(!0);
      });
    }, U = function() {
      l.run(function(ut) {
        ut.toggleVisibility(!1);
      });
    }, oe = function() {
      return v.get();
    }, de = ms.sketch({
      dom: {
        tag: "div",
        classes: ["tox-image-tools__image"]
      },
      components: [
        r.asSpec(),
        {
          dom: {
            tag: "img",
            attributes: { src: t }
          }
        },
        {
          dom: { tag: "div" },
          behaviours: Fn([Jr("image-panel-crop-events", [
            Zr(function(ut) {
              Se.getOpt(ut).each(function(Ne) {
                var ft = Ne.element.dom, Ht = pI.create({
                  x: 10,
                  y: 10,
                  w: 100,
                  h: 100
                }, {
                  x: 0,
                  y: 0,
                  w: 200,
                  h: 200
                }, {
                  x: 0,
                  y: 0,
                  w: 200,
                  h: 200
                }, ft, ee);
                Ht.toggleVisibility(!1), Ht.on("updateRect", function(Kt) {
                  var st = Kt.rect, Bt = o.get(), an = {
                    x: Math.round(st.x / Bt),
                    y: Math.round(st.y / Bt),
                    w: Math.round(st.w / Bt),
                    h: Math.round(st.h / Bt)
                  };
                  v.set(an);
                }), l.set(Ht);
              });
            }),
            gl(function() {
              l.clear();
            })
          ])])
        }
      ],
      containerBehaviours: Fn([
        qr.config({}),
        Jr("image-panel-events", [Zr(function(ut) {
          A(ut, t);
        })])
      ])
    }), Se = La(de), $e = function() {
      var ut = g.get();
      return {
        width: ut.w,
        height: ut.h
      };
    };
    return {
      memContainer: Se,
      updateSrc: A,
      zoom: R,
      showCrop: z,
      hideCrop: U,
      getRect: oe,
      getMeasurements: $e
    };
  }, kl = function(t, r, o, l, v) {
    return CA({
      name: t,
      icon: _.some(r),
      disabled: o,
      tooltip: _.some(t),
      primary: !1,
      borderless: !1
    }, l, v);
  }, cD = function(t, r) {
    r ? Cr.enable(t) : Cr.disable(t);
  }, fD = function(t) {
    var r = function(g, b, T) {
      o.getOpt(g).each(function(A) {
        cD(A, b);
      }), l.getOpt(g).each(function(A) {
        cD(A, T);
      });
    }, o = La(kl("Undo", "undo", !0, function(g) {
      xr(g, gs.undo(), { direction: 1 });
    }, t)), l = La(kl("Redo", "redo", !0, function(g) {
      xr(g, gs.redo(), { direction: 1 });
    }, t)), v = ms.sketch({
      dom: {
        tag: "div",
        classes: [
          "tox-image-tools__toolbar",
          "tox-image-tools__sidebar"
        ]
      },
      components: [
        o.asSpec(),
        l.asSpec(),
        kl("Zoom in", "zoom-in", !1, function(g) {
          xr(g, gs.zoom(), { direction: 1 });
        }, t),
        kl("Zoom out", "zoom-out", !1, function(g) {
          xr(g, gs.zoom(), { direction: -1 });
        }, t)
      ]
    });
    return {
      container: v,
      updateButtonUndoStates: r
    };
  };
  function hI() {
    var t = [], r = -1, o = function(T) {
      var A = t.splice(++r);
      return t.push(T), {
        state: T,
        removed: A
      };
    }, l = function() {
      if (g())
        return t[--r];
    }, v = function() {
      if (b())
        return t[++r];
    }, g = function() {
      return r > 0;
    }, b = function() {
      return r !== -1 && r < t.length - 1;
    };
    return {
      data: t,
      add: o,
      undo: l,
      redo: v,
      canUndo: g,
      canRedo: b
    };
  }
  var bI = function(t) {
    var r = Sr(t), o = Zo(), l = hI();
    l.add(t);
    var v = function() {
      return r.get();
    }, g = function(ft) {
      r.set(ft);
    }, b = function() {
      return o.get().getOrThunk(r.get);
    }, T = function(ft) {
      var Ht = A(ft);
      return U(), o.set(Ht), Ht.url;
    }, A = function(ft) {
      return {
        blob: ft,
        url: URL.createObjectURL(ft)
      };
    }, R = function(ft) {
      URL.revokeObjectURL(ft.url);
    }, z = function(ft) {
      Tp.each(ft, R);
    }, U = function() {
      o.on(R), o.clear();
    }, oe = function(ft) {
      var Ht = A(ft);
      g(Ht);
      var Kt = l.add(Ht).removed;
      return z(Kt), Ht.url;
    }, de = function(ft) {
      var Ht = A(ft);
      return o.set(Ht), Ht.url;
    }, Se = function(ft) {
      return o.get().fold(ee, function(Ht) {
        oe(Ht.blob), ft();
      });
    }, $e = function() {
      var ft = l.undo();
      return g(ft), ft.url;
    }, ut = function() {
      var ft = l.redo();
      return g(ft), ft.url;
    }, Ne = function() {
      var ft = l.canUndo(), Ht = l.canRedo();
      return {
        undoEnabled: ft,
        redoEnabled: Ht
      };
    };
    return {
      getBlobState: v,
      setBlobState: g,
      addBlobState: oe,
      getTempState: b,
      updateTempState: T,
      addTempState: de,
      applyTempState: Se,
      destroyTempState: U,
      undo: $e,
      redo: ut,
      getHistoryStates: Ne
    };
  }, yI = function(t, r) {
    var o = bI(t.currentState), l = function(pn, nn) {
      var Wn = nn.event.direction;
      an.zoom(pn, Wn);
    }, v = function(pn) {
      var nn = o.getHistoryStates();
      qn.updateButtonUndoStates(pn, nn.undoEnabled, nn.redoEnabled), xr(pn, el.formActionEvent, {
        name: el.saveState(),
        value: nn.undoEnabled
      });
    }, g = function(pn) {
      qn.updateButtonUndoStates(pn, !1, !1);
    }, b = function(pn, nn) {
      var Wn = o.undo();
      U(pn, Wn).then(function(cr) {
        z(pn), v(pn);
      });
    }, T = function(pn, nn) {
      var Wn = o.redo();
      U(pn, Wn).then(function(cr) {
        z(pn), v(pn);
      });
    }, A = function(pn) {
      return pn.toBlob();
    }, R = function(pn) {
      xr(pn, el.formActionEvent, {
        name: el.disable(),
        value: {}
      });
    }, z = function(pn) {
      vn.getApplyButton(pn).each(function(nn) {
        Cr.enable(nn);
      }), xr(pn, el.formActionEvent, {
        name: el.enable(),
        value: {}
      });
    }, U = function(pn, nn) {
      return R(pn), an.updateSrc(pn, nn);
    }, oe = function(pn, nn, Wn, cr, dn) {
      R(pn), kN(nn).then(Wn).then(A).then(cr).then(function(ar) {
        return U(pn, ar);
      }).then(function() {
        v(pn), dn(), z(pn);
      }).catch(function(ar) {
        console.log(ar), pn.getSystem().isConnected() && z(pn);
      });
    }, de = function(pn, nn, Wn) {
      var cr = o.getBlobState().blob, dn = function(ar) {
        return o.updateTempState(ar);
      };
      oe(pn, cr, nn, dn, Wn);
    }, Se = function(pn, nn) {
      var Wn = o.getTempState().blob, cr = function(dn) {
        return o.addTempState(dn);
      };
      oe(pn, Wn, nn, cr, ee);
    }, $e = function(pn, nn, Wn) {
      var cr = o.getBlobState().blob, dn = function(ar) {
        var pr = o.addBlobState(ar);
        return Ne(pn), pr;
      };
      oe(pn, cr, nn, dn, Wn);
    }, ut = function(pn, nn) {
      var Wn = function() {
        Ne(pn);
        var cr = nn.event.swap;
        cr();
      };
      o.applyTempState(Wn);
    }, Ne = function(pn) {
      var nn = o.getBlobState().url;
      return o.destroyTempState(), v(pn), nn;
    }, ft = function(pn) {
      var nn = Ne(pn);
      U(pn, nn).then(function(Wn) {
        z(pn);
      });
    }, Ht = function(pn, nn) {
      ft(pn);
      var Wn = nn.event.swap;
      Wn(), an.hideCrop();
    }, Kt = function(pn, nn) {
      return de(pn, nn.event.transform, ee);
    }, st = function(pn, nn) {
      return Se(pn, nn.event.transform);
    }, Bt = function(pn, nn) {
      return $e(pn, nn.event.transform, nn.event.swap);
    }, an = lD(t.currentState.url), qn = fD(r), vn = mI(an, r), Gn = function(pn, nn) {
      g(pn);
      var Wn = nn.event.transform, cr = nn.event.swap;
      Wn.fold(function() {
        cr();
      }, function(dn) {
        de(pn, dn, cr);
      });
    };
    return {
      dom: {
        tag: "div",
        attributes: { role: "presentation" }
      },
      components: [
        vn.memContainer.asSpec(),
        an.memContainer.asSpec(),
        qn.container
      ],
      behaviours: Fn([
        jn.config({
          store: {
            mode: "manual",
            getValue: function() {
              return o.getBlobState();
            }
          }
        }),
        Jr("image-tools-events", [
          cn(gs.undo(), b),
          cn(gs.redo(), T),
          cn(gs.zoom(), l),
          cn(gs.back(), Ht),
          cn(gs.apply(), ut),
          cn(gs.transform(), Kt),
          cn(gs.tempTransform(), st),
          cn(gs.transformApply(), Bt),
          cn(gs.swap(), Gn)
        ]),
        kv.self()
      ])
    };
  }, wI = function(t, r) {
    var o = {
      dom: {
        tag: "label",
        innerHtml: r.providers.translate(t.label),
        classes: ["tox-label"]
      }
    }, l = _t(t.items, r.interpreter);
    return {
      dom: {
        tag: "div",
        classes: ["tox-form__group"]
      },
      components: [o].concat(l),
      behaviours: Fn([
        kv.self(),
        qr.config({}),
        Bm.domHtml(_.none()),
        Er.config({ mode: "acyclic" })
      ])
    };
  }, OA = function(t) {
    return !yn(t, "items");
  }, vD = "data-value", dD = function(t, r, o, l) {
    return _t(o, function(v) {
      return OA(v) ? {
        type: "togglemenuitem",
        text: v.text,
        value: v.value,
        active: v.value === l,
        onAction: function() {
          jn.setValue(t, v.value), xr(t, cc, { name: r }), zr.focus(t);
        }
      } : {
        type: "nestedmenuitem",
        text: v.text,
        getSubmenuItems: function() {
          return dD(t, r, v.items, l);
        }
      };
    });
  }, mD = function(t, r) {
    return Xt(t, function(o) {
      return OA(o) ? so(o.value === r, o) : mD(o.items, r);
    });
  }, CI = function(t, r) {
    var o = r.shared.providers, l = It(t.items).filter(OA), v = t.label.map(function(T) {
      return _m(T, o);
    }), g = Ma.parts.field({
      dom: {},
      factory: {
        sketch: function(T) {
          return p3({
            uid: T.uid,
            text: l.map(function(A) {
              return A.text;
            }),
            icon: _.none(),
            tooltip: t.label,
            role: _.none(),
            fetch: function(A, R) {
              var z = dD(A, t.name, t.items, jn.getValue(A));
              R(Hb(z, Xu.CLOSE_ON_EXECUTE, r, !1));
            },
            onSetup: ie(ee),
            getApi: ie({}),
            columns: 1,
            presets: "normal",
            classes: [],
            dropdownBehaviours: [
              ci.config({}),
              jn.config({
                store: {
                  mode: "manual",
                  initialValue: l.map(function(A) {
                    return A.value;
                  }).getOr(""),
                  getValue: function(A) {
                    return So(A.element, vD);
                  },
                  setValue: function(A, R) {
                    mD(t.items, R).each(function(z) {
                      Qr(A.element, vD, z.value), xr(A, i1, { text: z.text });
                    });
                  }
                }
              })
            ]
          }, "tox-listbox", r.shared);
        }
      }
    }), b = {
      dom: {
        tag: "div",
        classes: ["tox-listboxfield"]
      },
      components: [g]
    };
    return Ma.sketch({
      dom: {
        tag: "div",
        classes: ["tox-form__group"]
      },
      components: Ie([
        v.toArray(),
        [b]
      ]),
      fieldBehaviours: Fn([Cr.config({
        disabled: ie(t.disabled),
        onDisabled: function(T) {
          Ma.getField(T).each(Cr.disable);
        },
        onEnabled: function(T) {
          Ma.getField(T).each(Cr.enable);
        }
      })])
    });
  }, gD = function(t, r) {
    return {
      dom: {
        tag: "div",
        classes: t.classes
      },
      components: _t(t.items, r.shared.interpreter)
    };
  }, pD = function(t, r) {
    var o = _t(t.options, function(v) {
      return {
        dom: {
          tag: "option",
          value: v.value,
          innerHtml: v.text
        }
      };
    }), l = t.data.map(function(v) {
      return rf("initialValue", v);
    }).getOr({});
    return {
      uid: t.uid,
      dom: {
        tag: "select",
        classes: t.selectClasses,
        attributes: t.selectAttributes
      },
      components: o,
      behaviours: Zi(t.selectBehaviours, [
        zr.config({}),
        jn.config({
          store: $({
            mode: "manual",
            getValue: function(v) {
              return ff(v.element);
            },
            setValue: function(v, g) {
              var b = pt(t.options, function(T) {
                return T.value === g;
              });
              b.isSome() && mg(v.element, g);
            }
          }, l)
        })
      ])
    };
  }, hD = Cl({
    name: "HtmlSelect",
    configFields: [
      un("options"),
      Ni("selectBehaviours", [
        zr,
        jn
      ]),
      ct("selectClasses", []),
      ct("selectAttributes", {}),
      Ba("data")
    ],
    factory: pD
  }), SI = function(t, r) {
    var o = _t(t.items, function(T) {
      return {
        text: r.translate(T.text),
        value: T.value
      };
    }), l = t.label.map(function(T) {
      return _m(T, r);
    }), v = Ma.parts.field({
      dom: {},
      selectAttributes: { size: t.size },
      options: o,
      factory: hD,
      selectBehaviours: Fn([
        Cr.config({
          disabled: function() {
            return t.disabled || r.isDisabled();
          }
        }),
        ci.config({}),
        Jr("selectbox-change", [cn(og(), function(T, A) {
          xr(T, cc, { name: t.name });
        })])
      ])
    }), g = t.size > 1 ? _.none() : _.some(wv("chevron-down", {
      tag: "div",
      classes: ["tox-selectfield__icon-js"]
    }, r.icons)), b = {
      dom: {
        tag: "div",
        classes: ["tox-selectfield"]
      },
      components: Ie([
        [v],
        g.toArray()
      ])
    };
    return Ma.sketch({
      dom: {
        tag: "div",
        classes: ["tox-form__group"]
      },
      components: Ie([
        l.toArray(),
        [b]
      ]),
      fieldBehaviours: Fn([
        Cr.config({
          disabled: function() {
            return t.disabled || r.isDisabled();
          },
          onDisabled: function(T) {
            Ma.getField(T).each(Cr.disable);
          },
          onEnabled: function(T) {
            Ma.getField(T).each(Cr.enable);
          }
        }),
        Ui()
      ])
    });
  }, bD = function(t, r) {
    var o = function(T) {
      return {
        dom: {
          tag: "th",
          innerHtml: r.translate(T)
        }
      };
    }, l = function(T) {
      return {
        dom: { tag: "thead" },
        components: [{
          dom: { tag: "tr" },
          components: _t(T, o)
        }]
      };
    }, v = function(T) {
      return {
        dom: {
          tag: "td",
          innerHtml: r.translate(T)
        }
      };
    }, g = function(T) {
      return {
        dom: { tag: "tr" },
        components: _t(T, v)
      };
    }, b = function(T) {
      return {
        dom: { tag: "tbody" },
        components: _t(T, g)
      };
    };
    return {
      dom: {
        tag: "table",
        classes: ["tox-dialog__table"]
      },
      components: [
        l(t.header),
        b(t.cells)
      ],
      behaviours: Fn([
        ci.config({}),
        zr.config({})
      ])
    };
  }, yD = function(t, r) {
    var o = t.label.map(function(oe) {
      return _m(oe, r);
    }), l = [
      Cr.config({
        disabled: function() {
          return t.disabled || r.isDisabled();
        }
      }),
      Ui(),
      Er.config({
        mode: "execution",
        useEnter: t.multiline !== !0,
        useControlEnter: t.multiline === !0,
        execute: function(oe) {
          return Ta(oe, $l), _.some(!0);
        }
      }),
      Jr("textfield-change", [
        cn(Ld(), function(oe, de) {
          xr(oe, cc, { name: t.name });
        }),
        cn(py(), function(oe, de) {
          xr(oe, cc, { name: t.name });
        })
      ]),
      ci.config({})
    ], v = t.validation.map(function(oe) {
      return Sv.config({
        getRoot: function(de) {
          return Co(de.element);
        },
        invalidClass: "tox-invalid",
        validator: {
          validate: function(de) {
            var Se = jn.getValue(de), $e = oe.validator(Se);
            return Fu.pure($e === !0 ? ea.value(Se) : ea.error($e));
          },
          validateOnLoad: oe.validateOnLoad
        }
      });
    }).toArray(), g = t.placeholder.fold(ie({}), function(oe) {
      return { placeholder: r.translate(oe) };
    }), b = t.inputMode.fold(ie({}), function(oe) {
      return { inputmode: oe };
    }), T = $($({}, g), b), A = Ma.parts.field({
      tag: t.multiline === !0 ? "textarea" : "input",
      inputAttributes: T,
      inputClasses: [t.classname],
      inputBehaviours: Fn(Ie([
        l,
        v
      ])),
      selectOnFocus: !1,
      factory: qw
    }), R = t.flex ? ["tox-form__group--stretched"] : [], z = R.concat(t.maximized ? ["tox-form-group--maximize"] : []), U = [
      Cr.config({
        disabled: function() {
          return t.disabled || r.isDisabled();
        },
        onDisabled: function(oe) {
          Ma.getField(oe).each(Cr.disable);
        },
        onEnabled: function(oe) {
          Ma.getField(oe).each(Cr.enable);
        }
      }),
      Ui()
    ];
    return jw(o, A, z, U);
  }, xI = function(t, r) {
    return yD({
      name: t.name,
      multiline: !1,
      label: t.label,
      inputMode: t.inputMode,
      placeholder: t.placeholder,
      flex: !1,
      disabled: t.disabled,
      classname: "tox-textfield",
      validation: _.none(),
      maximized: t.maximized
    }, r);
  }, kI = function(t, r) {
    return yD({
      name: t.name,
      multiline: !0,
      label: t.label,
      inputMode: _.none(),
      placeholder: t.placeholder,
      flex: !0,
      disabled: t.disabled,
      classname: "tox-textarea",
      validation: _.none(),
      maximized: t.maximized
    }, r);
  }, TI = function(t, r) {
    var o = t.stream.streams, l = o.setup(t, r);
    return ro([
      cn(t.event, l),
      gl(function() {
        return r.cancel();
      })
    ].concat(t.cancelEvent.map(function(v) {
      return [cn(v, function() {
        return r.cancel();
      })];
    }).getOr([])));
  }, EI = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    events: TI
  }), wD = function(t) {
    var r = Sr(null), o = function() {
      return { timer: r.get() !== null ? "set" : "unset" };
    }, l = function(g) {
      r.set(g);
    }, v = function() {
      var g = r.get();
      g !== null && g.cancel();
    };
    return Pu({
      readState: o,
      setTimer: l,
      cancel: v
    });
  }, _I = function(t) {
    return t.stream.streams.state(t);
  }, AI = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    throttle: wD,
    init: _I
  }), OI = function(t, r) {
    var o = t.stream, l = ME(t.onStream, o.delay);
    return r.setTimer(l), function(v, g) {
      l.throttle(v, g), o.stopEvent && g.stop();
    };
  }, DI = [
    xs("stream", Al("mode", {
      throttle: [
        un("delay"),
        ct("stopEvent", !0),
        io("streams", {
          setup: OI,
          state: wD
        })
      ]
    })),
    ct("event", "input"),
    Ba("cancelEvent"),
    ls("onStream")
  ], CD = Pi({
    fields: DI,
    name: "streaming",
    active: EI,
    state: AI
  }), k3 = function(t, r, o) {
    var l = jn.getValue(o);
    jn.setValue(r, l), xD(r);
  }, SD = function(t, r) {
    var o = t.element, l = ff(o), v = o.dom;
    So(o, "type") !== "number" && r(v, l);
  }, xD = function(t) {
    SD(t, function(r, o) {
      return r.setSelectionRange(o.length, o.length);
    });
  }, kD = function(t, r) {
    SD(t, function(o, l) {
      return o.setSelectionRange(r, l.length);
    });
  }, BI = function(t, r, o) {
    if (t.selectsOver) {
      var l = jn.getValue(r), v = t.getDisplayText(l), g = jn.getValue(o), b = t.getDisplayText(g);
      return b.indexOf(v) === 0 ? _.some(function() {
        k3(t, r, o), kD(r, v.length);
      }) : _.none();
    } else
      return _.none();
  }, DA = ie("alloy.typeahead.itemexecute"), TD = function(t, r, o, l) {
    var v = function(A, R, z) {
      t.previewing.set(!1);
      var U = fi.getCoupled(A, "sandbox");
      if (ga.isOpen(U))
        la.getCurrent(U).each(function(de) {
          Na.getHighlighted(de).fold(function() {
            z(de);
          }, function() {
            QC(U, de.element, "keydown", R);
          });
        });
      else {
        var oe = function(de) {
          la.getCurrent(de).each(z);
        };
        G4(t, b(A), A, U, l, oe, Df.HighlightFirst).get(ee);
      }
    }, g = j4(t), b = function(A) {
      return function(R) {
        return R.map(function(z) {
          var U = Yt(z.menus), oe = St(U, function(Se) {
            return We(Se.items, function($e) {
              return $e.type === "item";
            });
          }), de = jn.getState(A);
          return de.update(_t(oe, function(Se) {
            return Se.data;
          })), z;
        });
      };
    }, T = [
      zr.config({}),
      jn.config({
        onSetValue: t.onSetValue,
        store: $({
          mode: "dataset",
          getDataKey: function(A) {
            return ff(A.element);
          },
          getFallbackEntry: function(A) {
            return {
              value: A,
              meta: {}
            };
          },
          setValue: function(A, R) {
            mg(A.element, t.model.getDisplayText(R));
          }
        }, t.initialData.map(function(A) {
          return rf("initialValue", A);
        }).getOr({}))
      }),
      CD.config({
        stream: {
          mode: "throttle",
          delay: t.responseTime,
          stopEvent: !1
        },
        onStream: function(A, R) {
          var z = fi.getCoupled(A, "sandbox"), U = zr.isFocused(A);
          if (U && ff(A.element).length >= t.minChars) {
            var oe = la.getCurrent(z).bind(function(Se) {
              return Na.getHighlighted(Se).map(jn.getValue);
            });
            t.previewing.set(!0);
            var de = function(Se) {
              la.getCurrent(z).each(function($e) {
                oe.fold(function() {
                  t.model.selectsOver && Na.highlightFirst($e);
                }, function(ut) {
                  Na.highlightBy($e, function(Ne) {
                    var ft = jn.getValue(Ne);
                    return ft.value === ut.value;
                  }), Na.getHighlighted($e).orThunk(function() {
                    return Na.highlightFirst($e), _.none();
                  });
                });
              });
            };
            G4(t, b(A), A, z, l, de, Df.HighlightFirst).get(ee);
          }
        },
        cancelEvent: hy()
      }),
      Er.config({
        mode: "special",
        onDown: function(A, R) {
          return v(A, R, Na.highlightFirst), _.some(!0);
        },
        onEscape: function(A) {
          var R = fi.getCoupled(A, "sandbox");
          return ga.isOpen(R) ? (ga.close(R), _.some(!0)) : _.none();
        },
        onUp: function(A, R) {
          return v(A, R, Na.highlightLast), _.some(!0);
        },
        onEnter: function(A) {
          var R = fi.getCoupled(A, "sandbox"), z = ga.isOpen(R);
          if (z && !t.previewing.get())
            return la.getCurrent(R).bind(function(oe) {
              return Na.getHighlighted(oe);
            }).map(function(oe) {
              return xr(A, DA(), { item: oe }), !0;
            });
          var U = jn.getValue(A);
          return Ta(A, hy()), t.onExecute(R, A, U), z && ga.close(R), _.some(!0);
        }
      }),
      wa.config({
        toggleClass: t.markers.openClass,
        aria: { mode: "expanded" }
      }),
      fi.config({
        others: {
          sandbox: function(A) {
            return P_(t, A, {
              onOpen: function() {
                return wa.on(A);
              },
              onClose: function() {
                return wa.off(A);
              }
            });
          }
        }
      }),
      Jr("typeaheadevents", [
        Ks(function(A) {
          var R = ee;
          Nb(t, b(A), A, l, R, Df.HighlightFirst).get(ee);
        }),
        cn(DA(), function(A, R) {
          var z = fi.getCoupled(A, "sandbox");
          k3(t.model, A, R.event.item), Ta(A, hy()), t.onItemExecute(A, z, R.event.item, jn.getValue(A)), ga.close(z), xD(A);
        })
      ].concat(t.dismissOnBlur ? [cn(gy(), function(A) {
        var R = fi.getCoupled(A, "sandbox");
        Pc(R.element).isNone() && ga.close(R);
      })] : []))
    ];
    return {
      uid: t.uid,
      dom: W4(Gt(t, {
        inputAttributes: {
          role: "combobox",
          "aria-autocomplete": "list",
          "aria-haspopup": "true"
        }
      })),
      behaviours: $($({}, g), Zi(t.typeaheadBehaviours, T)),
      eventOrder: t.eventOrder
    };
  }, RI = ie([
    Ba("lazySink"),
    un("fetch"),
    ct("minChars", 5),
    ct("responseTime", 1e3),
    Ra("onOpen"),
    ct("getHotspot", _.some),
    ct("getAnchorOverrides", ie({})),
    ct("layouts", _.none()),
    ct("eventOrder", {}),
    iy("model", {}, [
      ct("getDisplayText", function(t) {
        return t.meta !== void 0 && t.meta.text !== void 0 ? t.meta.text : t.value;
      }),
      ct("selectsOver", !0),
      ct("populateFromBrowse", !0)
    ]),
    Ra("onSetValue"),
    Ri("onExecute"),
    Ra("onItemExecute"),
    ct("inputClasses", []),
    ct("inputAttributes", {}),
    ct("inputStyles", {}),
    ct("matchWidth", !0),
    ct("useMinWidth", !1),
    ct("dismissOnBlur", !0),
    Jd(["openClass"]),
    Ba("initialData"),
    Ni("typeaheadBehaviours", [
      zr,
      jn,
      CD,
      Er,
      wa,
      fi
    ]),
    as("previewing", function() {
      return Sr(!0);
    })
  ].concat(k6()).concat(N_())), MI = ie([wl({
    schema: [Zd()],
    name: "menu",
    overrides: function(t) {
      return {
        fakeFocus: !0,
        onHighlight: function(r, o) {
          t.previewing.get() ? r.getSystem().getByUid(t.uid).each(function(l) {
            BI(t.model, l, o).fold(function() {
              return Na.dehighlight(r, o);
            }, function(v) {
              return v();
            });
          }) : r.getSystem().getByUid(t.uid).each(function(l) {
            t.model.populateFromBrowse && k3(t.model, l, o);
          }), t.previewing.set(!1);
        },
        onExecute: function(r, o) {
          return r.getSystem().getByUid(t.uid).toOptional().map(function(l) {
            return xr(l, DA(), { item: o }), !0;
          });
        },
        onHover: function(r, o) {
          t.previewing.set(!1), r.getSystem().getByUid(t.uid).each(function(l) {
            t.model.populateFromBrowse && k3(t.model, l, o);
          });
        }
      };
    }
  })]), PI = ds({
    name: "Typeahead",
    configFields: RI(),
    partFields: MI(),
    factory: TD
  }), Nf = function(t) {
    var r = function() {
      return Nf(t.toCached());
    }, o = function(A) {
      return Nf(t.bind(function(R) {
        return R.fold(function(z) {
          return Fu.pure(ea.error(z));
        }, function(z) {
          return A(z);
        });
      }));
    }, l = function(A) {
      return Nf(t.map(function(R) {
        return R.bind(A);
      }));
    }, v = function(A) {
      return Nf(t.map(function(R) {
        return R.map(A);
      }));
    }, g = function(A) {
      return Nf(t.map(function(R) {
        return R.mapError(A);
      }));
    }, b = function(A, R) {
      return t.map(function(z) {
        return z.fold(A, R);
      });
    }, T = function(A, R) {
      return Nf(Fu.nu(function(z) {
        var U = !1, oe = setTimeout(function() {
          U = !0, z(ea.error(R()));
        }, A);
        t.get(function(de) {
          U || (clearTimeout(oe), z(de));
        });
      }));
    };
    return $($({}, t), {
      toCached: r,
      bindFuture: o,
      bindResult: l,
      mapResult: v,
      mapError: g,
      foldResult: b,
      withTimeout: T
    });
  }, ED = function(t) {
    return Nf(Fu.nu(t));
  }, _D = function(t) {
    return Nf(Fu.pure(ea.value(t)));
  }, T3 = function(t) {
    return Nf(Fu.pure(ea.error(t)));
  }, NI = function(t) {
    return Nf(Fu.pure(t));
  }, II = function(t) {
    return Nf(t.map(ea.value));
  }, FI = function(t) {
    return ED(function(r) {
      t.then(function(o) {
        r(ea.value(o));
      }, function(o) {
        r(ea.error(o));
      });
    });
  }, $I = {
    nu: ED,
    wrap: Nf,
    pure: _D,
    value: _D,
    error: T3,
    fromResult: NI,
    fromFuture: II,
    fromPromise: FI
  }, LI = { type: "separator" }, zI = function(t) {
    return {
      type: "menuitem",
      value: t.url,
      text: t.title,
      meta: { attach: t.attach },
      onAction: ee
    };
  }, BA = function(t, r) {
    return {
      type: "menuitem",
      value: r,
      text: t,
      meta: { attach: void 0 },
      onAction: ee
    };
  }, AD = function(t) {
    return _t(t, zI);
  }, HI = function(t, r) {
    return We(r, function(o) {
      return o.type === t;
    });
  }, OD = function(t, r) {
    return AD(HI(t, r));
  }, VI = function(t) {
    return OD("header", t.targets);
  }, UI = function(t) {
    return OD("anchor", t.targets);
  }, jI = function(t) {
    return _.from(t.anchorTop).map(function(r) {
      return BA("<top>", r);
    }).toArray();
  }, WI = function(t) {
    return _.from(t.anchorBottom).map(function(r) {
      return BA("<bottom>", r);
    }).toArray();
  }, qI = function(t) {
    return _t(t, function(r) {
      return BA(r, r);
    });
  }, DD = function(t) {
    return Ke(t, function(r, o) {
      var l = r.length === 0 || o.length === 0;
      return l ? r.concat(o) : r.concat(LI, o);
    }, []);
  }, RA = function(t, r) {
    var o = t.toLowerCase();
    return We(r, function(l) {
      var v = l.meta !== void 0 && l.meta.text !== void 0 ? l.meta.text : l.text;
      return na(v.toLowerCase(), o) || na(l.value.toLowerCase(), o);
    });
  }, GI = function(t, r, o) {
    var l = jn.getValue(r), v = l.meta.text !== void 0 ? l.meta.text : l.value, g = o.getLinkInformation();
    return g.fold(function() {
      return [];
    }, function(b) {
      var T = RA(v, qI(o.getHistory(t)));
      return t === "file" ? DD([
        T,
        RA(v, VI(b)),
        RA(v, Ie([
          jI(b),
          UI(b),
          WI(b)
        ]))
      ]) : T;
    });
  }, BD = ur("aria-invalid"), KI = function(t, r, o) {
    var l, v = r.shared.providers, g = function(Ne) {
      var ft = jn.getValue(Ne);
      o.addToHistory(ft.value, t.filetype);
    }, b = Ma.parts.field({
      factory: PI,
      dismissOnBlur: !0,
      inputClasses: ["tox-textfield"],
      sandboxClasses: ["tox-dialog__popups"],
      inputAttributes: {
        "aria-errormessage": BD,
        type: "url"
      },
      minChars: 0,
      responseTime: 0,
      fetch: function(Ne) {
        var ft = GI(t.filetype, Ne, o), Ht = Hb(ft, Xu.BUBBLE_TO_SANDBOX, r, !1);
        return Fu.pure(Ht);
      },
      getHotspot: function(Ne) {
        return de.getOpt(Ne);
      },
      onSetValue: function(Ne, ft) {
        Ne.hasConfigured(Sv) && Sv.run(Ne).get(ee);
      },
      typeaheadBehaviours: Fn(Ie([
        o.getValidationHandler().map(function(Ne) {
          return Sv.config({
            getRoot: function(ft) {
              return Co(ft.element);
            },
            invalidClass: "tox-control-wrap--status-invalid",
            notify: {
              onInvalid: function(ft, Ht) {
                R.getOpt(ft).each(function(Kt) {
                  Qr(Kt.element, "title", v.translate(Ht));
                });
              }
            },
            validator: {
              validate: function(ft) {
                var Ht = jn.getValue(ft);
                return $I.nu(function(Kt) {
                  Ne({
                    type: t.filetype,
                    url: Ht.value
                  }, function(st) {
                    if (st.status === "invalid") {
                      var Bt = ea.error(st.message);
                      Kt(Bt);
                    } else {
                      var an = ea.value(st.message);
                      Kt(an);
                    }
                  });
                });
              },
              validateOnLoad: !1
            }
          });
        }).toArray(),
        [
          Cr.config({
            disabled: function() {
              return t.disabled || v.isDisabled();
            }
          }),
          ci.config({}),
          Jr("urlinput-events", Ie([
            t.filetype === "file" ? [cn(Ld(), function(Ne) {
              xr(Ne, cc, { name: t.name });
            })] : [],
            [
              cn(og(), function(Ne) {
                xr(Ne, cc, { name: t.name }), g(Ne);
              }),
              cn(py(), function(Ne) {
                xr(Ne, cc, { name: t.name }), g(Ne);
              })
            ]
          ]))
        ]
      ])),
      eventOrder: (l = {}, l[Ld()] = [
        "streaming",
        "urlinput-events",
        "invalidating"
      ], l),
      model: {
        getDisplayText: function(Ne) {
          return Ne.value;
        },
        selectsOver: !1,
        populateFromBrowse: !1
      },
      markers: { openClass: "tox-textfield--popup-open" },
      lazySink: r.shared.getSink,
      parts: { menu: jh(!1, 1, "normal") },
      onExecute: function(Ne, ft, Ht) {
        xr(ft, $l, {});
      },
      onItemExecute: function(Ne, ft, Ht, Kt) {
        g(Ne), xr(Ne, cc, { name: t.name });
      }
    }), T = t.label.map(function(Ne) {
      return _m(Ne, v);
    }), A = function(Ne, ft, Ht, Kt) {
      return Ht === void 0 && (Ht = Ne), Kt === void 0 && (Kt = Ne), wv(Ht, {
        tag: "div",
        classes: [
          "tox-icon",
          "tox-control-wrap__status-icon-" + Ne
        ],
        attributes: $({
          title: v.translate(Kt),
          "aria-live": "polite"
        }, ft.fold(function() {
          return {};
        }, function(st) {
          return { id: st };
        }))
      }, v.icons);
    }, R = La(A("invalid", _.some(BD), "warning")), z = La({
      dom: {
        tag: "div",
        classes: ["tox-control-wrap__status-icon-wrap"]
      },
      components: [R.asSpec()]
    }), U = o.getUrlPicker(t.filetype), oe = ur("browser.url.event"), de = La({
      dom: {
        tag: "div",
        classes: ["tox-control-wrap"]
      },
      components: [
        b,
        z.asSpec()
      ],
      behaviours: Fn([Cr.config({
        disabled: function() {
          return t.disabled || v.isDisabled();
        }
      })])
    }), Se = La(xA({
      name: t.name,
      icon: _.some("browse"),
      text: t.label.getOr(""),
      disabled: t.disabled,
      primary: !1,
      borderless: !0
    }, function(Ne) {
      return Ta(Ne, oe);
    }, v, [], ["tox-browse-url"])), $e = function() {
      return {
        dom: {
          tag: "div",
          classes: ["tox-form__controls-h-stack"]
        },
        components: Ie([
          [de.asSpec()],
          U.map(function() {
            return Se.asSpec();
          }).toArray()
        ])
      };
    }, ut = function(Ne) {
      la.getCurrent(Ne).each(function(ft) {
        var Ht = jn.getValue(ft), Kt = $({ fieldname: t.name }, Ht);
        U.each(function(st) {
          st(Kt).get(function(Bt) {
            jn.setValue(ft, Bt), xr(Ne, cc, { name: t.name });
          });
        });
      });
    };
    return Ma.sketch({
      dom: K7(),
      components: T.toArray().concat([$e()]),
      fieldBehaviours: Fn([
        Cr.config({
          disabled: function() {
            return t.disabled || v.isDisabled();
          },
          onDisabled: function(Ne) {
            Ma.getField(Ne).each(Cr.disable), Se.getOpt(Ne).each(Cr.disable);
          },
          onEnabled: function(Ne) {
            Ma.getField(Ne).each(Cr.enable), Se.getOpt(Ne).each(Cr.enable);
          }
        }),
        Ui(),
        Jr("url-input-events", [cn(oe, ut)])
      ])
    });
  }, XI = function(t, r) {
    return ms.sketch({
      dom: {
        tag: "div",
        attributes: { role: "alert" },
        classes: [
          "tox-notification",
          "tox-notification--in",
          "tox-notification--" + t.level
        ]
      },
      components: [
        {
          dom: {
            tag: "div",
            classes: ["tox-notification__icon"]
          },
          components: [Js.sketch({
            dom: {
              tag: "button",
              classes: [
                "tox-button",
                "tox-button--naked",
                "tox-button--icon"
              ],
              innerHtml: _5(t.icon, r.icons),
              attributes: { title: r.translate(t.iconTooltip) }
            },
            action: function(o) {
              xr(o, Cv, {
                name: "alert-banner",
                value: t.url
              });
            },
            buttonBehaviours: Fn([OE()])
          })]
        },
        {
          dom: {
            tag: "div",
            classes: ["tox-notification__body"],
            innerHtml: r.translate(t.text)
          }
        }
      ]
    });
  }, YI = function(t, r) {
    var o = jn.config({
      store: {
        mode: "manual",
        getValue: function(A) {
          var R = A.element.dom;
          return R.checked;
        },
        setValue: function(A, R) {
          var z = A.element.dom;
          z.checked = R;
        }
      }
    }), l = function(A) {
      return A.element.dom.click(), _.some(!0);
    }, v = Ma.parts.field({
      factory: { sketch: Ze },
      dom: {
        tag: "input",
        classes: ["tox-checkbox__input"],
        attributes: { type: "checkbox" }
      },
      behaviours: Fn([
        kv.self(),
        Cr.config({
          disabled: function() {
            return t.disabled || r.isDisabled();
          }
        }),
        ci.config({}),
        zr.config({}),
        o,
        Er.config({
          mode: "special",
          onEnter: l,
          onSpace: l,
          stopSpaceKeyup: !0
        }),
        Jr("checkbox-events", [cn(og(), function(A, R) {
          xr(A, cc, { name: t.name });
        })])
      ])
    }), g = Ma.parts.label({
      dom: {
        tag: "span",
        classes: ["tox-checkbox__label"],
        innerHtml: r.translate(t.label)
      },
      behaviours: Fn([Kw.config({})])
    }), b = function(A) {
      var R = A === "checked" ? "selected" : "unselected";
      return wv(R, {
        tag: "span",
        classes: [
          "tox-icon",
          "tox-checkbox-icon__" + A
        ]
      }, r.icons);
    }, T = La({
      dom: {
        tag: "div",
        classes: ["tox-checkbox__icons"]
      },
      components: [
        b("checked"),
        b("unchecked")
      ]
    });
    return Ma.sketch({
      dom: {
        tag: "label",
        classes: ["tox-checkbox"]
      },
      components: [
        v,
        T.asSpec(),
        g
      ],
      fieldBehaviours: Fn([
        Cr.config({
          disabled: function() {
            return t.disabled || r.isDisabled();
          },
          disableClass: "tox-checkbox--disabled",
          onDisabled: function(A) {
            Ma.getField(A).each(Cr.disable);
          },
          onEnabled: function(A) {
            Ma.getField(A).each(Cr.enable);
          }
        }),
        Ui()
      ])
    });
  }, RD = function(t) {
    return t.presets === "presentation" ? ms.sketch({
      dom: {
        tag: "div",
        classes: ["tox-form__group"],
        innerHtml: t.html
      }
    }) : ms.sketch({
      dom: {
        tag: "div",
        classes: ["tox-form__group"],
        innerHtml: t.html,
        attributes: { role: "document" }
      },
      containerBehaviours: Fn([
        ci.config({}),
        zr.config({})
      ])
    });
  }, ii = function(t) {
    return function(r, o, l) {
      return Ft(o, "name").fold(function() {
        return t(o, l);
      }, function(v) {
        return r.field(v, t(o, l));
      });
    };
  }, E3 = function(t) {
    return function(r, o, l) {
      var v = Gt(o, { source: "dynamic" });
      return ii(t)(r, v, l);
    };
  }, ZI = {
    bar: ii(function(t, r) {
      return Kh(t, r.shared);
    }),
    collection: ii(function(t, r) {
      return U4(t, r.shared.providers);
    }),
    alertbanner: ii(function(t, r) {
      return XI(t, r.shared.providers);
    }),
    input: ii(function(t, r) {
      return xI(t, r.shared.providers);
    }),
    textarea: ii(function(t, r) {
      return kI(t, r.shared.providers);
    }),
    label: ii(function(t, r) {
      return wI(t, r.shared);
    }),
    iframe: E3(function(t, r) {
      return D8(t, r.shared.providers);
    }),
    button: ii(function(t, r) {
      return eI(t, r.shared.providers);
    }),
    checkbox: ii(function(t, r) {
      return YI(t, r.shared.providers);
    }),
    colorinput: ii(function(t, r) {
      return dP(t, r.shared, r.colorinput);
    }),
    colorpicker: ii(uN),
    dropzone: ii(function(t, r) {
      return mN(t, r.shared.providers);
    }),
    grid: ii(function(t, r) {
      return A8(t, r.shared);
    }),
    listbox: ii(function(t, r) {
      return CI(t, r);
    }),
    selectbox: ii(function(t, r) {
      return SI(t, r.shared.providers);
    }),
    sizeinput: ii(function(t, r) {
      return rD(t, r.shared.providers);
    }),
    urlinput: ii(function(t, r) {
      return KI(t, r, r.urlinput);
    }),
    customeditor: ii(lN),
    htmlpanel: ii(RD),
    imagetools: ii(function(t, r) {
      return yI(t, r.shared.providers);
    }),
    table: ii(function(t, r) {
      return bD(t, r.shared.providers);
    }),
    panel: ii(function(t, r) {
      return gD(t, r);
    })
  }, JI = {
    field: function(t, r) {
      return r;
    }
  }, _3 = function(t, r, o) {
    var l = Gt(o, {
      shared: {
        interpreter: function(v) {
          return MA(t, v, l);
        }
      }
    });
    return MA(t, r, l);
  }, MA = function(t, r, o) {
    return Ft(ZI, r.type).fold(function() {
      return console.error('Unknown factory type "' + r.type + '", defaulting to container: ', r), r;
    }, function(l) {
      return l(t, r, o);
    });
  }, QI = function(t, r) {
    var o = JI;
    return MA(o, t, r);
  }, A3 = {
    valignCentre: [],
    alignCentre: [],
    alignLeft: [],
    alignRight: [],
    right: [],
    left: [],
    bottom: [],
    top: []
  }, MD = function(t, r, o) {
    var l = 12, v = { maxHeightFunction: Eg() }, g = function() {
      return {
        type: "node",
        root: Nn(t()),
        node: _.from(t()),
        bubble: om(l, l, A3),
        layouts: {
          onRtl: function() {
            return [vp];
          },
          onLtr: function() {
            return [fp];
          }
        },
        overrides: v
      };
    }, b = function() {
      return {
        type: "hotspot",
        hotspot: r(),
        bubble: om(-l, l, A3),
        layouts: {
          onRtl: function() {
            return [Nu];
          },
          onLtr: function() {
            return [Vi];
          }
        },
        overrides: v
      };
    };
    return function() {
      return o() ? g() : b();
    };
  }, PD = function(t, r, o) {
    var l = function() {
      return {
        type: "node",
        root: Nn(t()),
        node: _.from(t()),
        layouts: {
          onRtl: function() {
            return [Vc];
          },
          onLtr: function() {
            return [Vc];
          }
        }
      };
    }, v = function() {
      return {
        type: "hotspot",
        hotspot: r(),
        layouts: {
          onRtl: function() {
            return [wi];
          },
          onLtr: function() {
            return [wi];
          }
        }
      };
    };
    return function() {
      return o() ? l() : v();
    };
  }, eF = function(t, r) {
    return function() {
      return {
        type: "selection",
        root: r(),
        getSelection: function() {
          var o = t.selection.getRng();
          return _.some(Og.range(Bn.fromDom(o.startContainer), o.startOffset, Bn.fromDom(o.endContainer), o.endOffset));
        }
      };
    };
  }, tF = function(t) {
    return function(r) {
      return {
        type: "node",
        root: t(),
        node: r
      };
    };
  }, nF = function(t, r, o) {
    var l = D4(t), v = function() {
      return Bn.fromDom(t.getBody());
    }, g = function() {
      return Bn.fromDom(t.getContentAreaContainer());
    }, b = function() {
      return l || !o();
    };
    return {
      inlineDialog: MD(g, r, b),
      banner: PD(g, r, b),
      cursor: eF(t, v),
      node: tF(v)
    };
  }, rF = function(t) {
    return function(r, o) {
      var l = n6(t);
      l(r, o);
    };
  }, aF = function(t) {
    return function() {
      return XO(t);
    };
  }, ND = function(t) {
    return function() {
      return p_(t);
    };
  }, oF = function(t) {
    return function() {
      return ZO(t);
    };
  }, ID = function(t) {
    return {
      colorPicker: rF(t),
      hasCustomColors: aF(t),
      getColors: ND(t),
      getColorCols: oF(t)
    };
  }, iF = function(t) {
    return function() {
      return bO(t);
    };
  }, uF = function(t) {
    return { isDraggableModal: iF(t) };
  }, PA = function(t) {
    var r = Sr(dO(t) ? "bottom" : "top");
    return {
      isPositionedAtTop: function() {
        return r.get() === "top";
      },
      getDockingMode: r.get,
      setDockingMode: r.set
    };
  }, O3 = [
    {
      title: "Headings",
      items: [
        {
          title: "Heading 1",
          format: "h1"
        },
        {
          title: "Heading 2",
          format: "h2"
        },
        {
          title: "Heading 3",
          format: "h3"
        },
        {
          title: "Heading 4",
          format: "h4"
        },
        {
          title: "Heading 5",
          format: "h5"
        },
        {
          title: "Heading 6",
          format: "h6"
        }
      ]
    },
    {
      title: "Inline",
      items: [
        {
          title: "Bold",
          format: "bold"
        },
        {
          title: "Italic",
          format: "italic"
        },
        {
          title: "Underline",
          format: "underline"
        },
        {
          title: "Strikethrough",
          format: "strikethrough"
        },
        {
          title: "Superscript",
          format: "superscript"
        },
        {
          title: "Subscript",
          format: "subscript"
        },
        {
          title: "Code",
          format: "code"
        }
      ]
    },
    {
      title: "Blocks",
      items: [
        {
          title: "Paragraph",
          format: "p"
        },
        {
          title: "Blockquote",
          format: "blockquote"
        },
        {
          title: "Div",
          format: "div"
        },
        {
          title: "Pre",
          format: "pre"
        }
      ]
    },
    {
      title: "Align",
      items: [
        {
          title: "Left",
          format: "alignleft"
        },
        {
          title: "Center",
          format: "aligncenter"
        },
        {
          title: "Right",
          format: "alignright"
        },
        {
          title: "Justify",
          format: "alignjustify"
        }
      ]
    }
  ], dC = function(t) {
    return yn(t, "items");
  }, sF = function(t) {
    return yn(t, "block");
  }, lF = function(t) {
    return yn(t, "inline");
  }, cF = function(t) {
    return yn(t, "selector");
  }, FD = function(t) {
    return Ke(t, function(r, o) {
      if (dC(o)) {
        var l = FD(o.items);
        return {
          customFormats: r.customFormats.concat(l.customFormats),
          formats: r.formats.concat([{
            title: o.title,
            items: l.formats
          }])
        };
      } else if (lF(o) || sF(o) || cF(o)) {
        var v = P(o.name) ? o.name : o.title.toLowerCase(), g = "custom-" + v;
        return {
          customFormats: r.customFormats.concat([{
            name: g,
            format: o
          }]),
          formats: r.formats.concat([{
            title: o.title,
            format: g,
            icon: o.icon
          }])
        };
      } else
        return $($({}, r), { formats: r.formats.concat(o) });
    }, {
      customFormats: [],
      formats: []
    });
  }, fF = function(t, r) {
    var o = FD(r), l = function(v) {
      Pe(v, function(g) {
        t.formatter.has(g.name) || t.formatter.register(g.name, g.format);
      });
    };
    return t.formatter ? l(o.customFormats) : t.on("init", function() {
      l(o.customFormats);
    }), o.formats;
  }, NA = function(t) {
    return yM(t).map(function(r) {
      var o = fF(t, r);
      return wM(t) ? O3.concat(o) : o;
    }).getOr(O3);
  }, IA = function(t, r, o) {
    var l = {
      type: "formatter",
      isSelected: r(t.format),
      getStylePreview: o(t.format)
    };
    return Gt(t, l);
  }, FA = function(t, r, o, l) {
    var v = function(A) {
      return IA(A, o, l);
    }, g = function(A) {
      var R = { type: "submenu" };
      return Gt(A, R);
    }, b = function(A) {
      var R = P(A.name) ? A.name : ur(A.title), z = "custom-" + R, U = {
        type: "formatter",
        format: z,
        isSelected: o(z),
        getStylePreview: l(z)
      }, oe = Gt(A, U);
      return t.formatter.register(R, oe), oe;
    }, T = function(A) {
      return _t(A, function(R) {
        var z = on(R);
        if (Yn(R, "items")) {
          var U = T(R.items);
          return Gt(g(R), { getStyleItems: ie(U) });
        } else
          return Yn(R, "format") ? v(R) : z.length === 1 && Tt(z, "title") ? Gt(R, { type: "separator" }) : b(R);
      });
    };
    return T(r);
  }, vF = function(t) {
    var r = function(U) {
      return function() {
        return t.formatter.match(U);
      };
    }, o = function(U) {
      return function() {
        var oe = t.formatter.get(U);
        return oe !== void 0 ? _.some({
          tag: oe.length > 0 && (oe[0].inline || oe[0].block) || "div",
          styles: t.dom.parseStyle(t.formatter.getCssText(U))
        }) : _.none();
      };
    }, l = function(U) {
      var oe = U.items;
      return oe !== void 0 && oe.length > 0 ? St(oe, l) : [U.format];
    }, v = Sr([]), g = Sr([]), b = Sr([]), T = Sr([]), A = Sr(!1);
    t.on("PreInit", function(U) {
      var oe = NA(t), de = FA(t, oe, r, o);
      v.set(de), g.set(St(de, l));
    }), t.on("addStyleModifications", function(U) {
      var oe = FA(t, U.items, r, o);
      b.set(oe), A.set(U.replace), T.set(St(oe, l));
    });
    var R = function() {
      var U = A.get() ? [] : v.get(), oe = b.get();
      return U.concat(oe);
    }, z = function() {
      var U = A.get() ? [] : g.get(), oe = T.get();
      return U.concat(oe);
    };
    return {
      getData: R,
      getFlattenedKeys: z
    };
  }, dF = function(t) {
    return Y(t) && t.nodeType === 1;
  }, mF = Tp.trim, $D = function(t) {
    return function(r) {
      return !!(dF(r) && (r.contentEditable === t || r.getAttribute("data-mce-contenteditable") === t));
    };
  }, gF = $D("true"), LD = $D("false"), zD = function(t, r, o, l, v) {
    return {
      type: t,
      title: r,
      url: o,
      level: l,
      attach: v
    };
  }, pF = function(t) {
    for (; t = t.parentNode; ) {
      var r = t.contentEditable;
      if (r && r !== "inherit")
        return gF(t);
    }
    return !1;
  }, hF = function(t, r) {
    return _t(qu(Bn.fromDom(r), t), function(o) {
      return o.dom;
    });
  }, HD = function(t) {
    return t.innerText || t.textContent;
  }, VD = function(t) {
    return t.id ? t.id : ur("h");
  }, u1 = function(t) {
    return t && t.nodeName === "A" && (t.id || t.name) !== void 0;
  }, UD = function(t) {
    return u1(t) && WD(t);
  }, jD = function(t) {
    return t && /^(H[1-6])$/.test(t.nodeName);
  }, WD = function(t) {
    return pF(t) && !LD(t);
  }, bF = function(t) {
    return jD(t) && WD(t);
  }, qD = function(t) {
    return jD(t) ? parseInt(t.nodeName.substr(1), 10) : 0;
  }, yF = function(t) {
    var r = VD(t), o = function() {
      t.id = r;
    };
    return zD("header", HD(t), "#" + r, qD(t), o);
  }, wF = function(t) {
    var r = t.id || t.name, o = HD(t);
    return zD("anchor", o || "#" + r, "#" + r, 0, ee);
  }, CF = function(t) {
    return _t(We(t, bF), yF);
  }, SF = function(t) {
    return _t(We(t, UD), wF);
  }, xF = function(t) {
    var r = hF("h1,h2,h3,h4,h5,h6,a:not([href])", t);
    return r;
  }, kF = function(t) {
    return mF(t.title).length > 0;
  }, TF = function(t) {
    var r = xF(t);
    return We(CF(r).concat(SF(r)), kF);
  }, EF = { find: TF }, D3 = "tinymce-url-history", GD = 5, $A = function(t) {
    return P(t) && /^https?/.test(t);
  }, _F = function(t) {
    return X(t) && t.length <= GD && Xe(t, $A);
  }, KD = function(t) {
    return H(t) && ot(t, function(r) {
      return !_F(r);
    }).isNone();
  }, XD = function() {
    var t = F4.getItem(D3);
    if (t === null)
      return {};
    var r;
    try {
      r = JSON.parse(t);
    } catch (o) {
      if (o instanceof SyntaxError)
        return console.log("Local storage " + D3 + " was not valid JSON", o), {};
      throw o;
    }
    return KD(r) ? r : (console.log("Local storage " + D3 + " was not valid format", r), {});
  }, AF = function(t) {
    if (!KD(t))
      throw new Error(`Bad format for history:
` + JSON.stringify(t));
    F4.setItem(D3, JSON.stringify(t));
  }, OF = function(t) {
    var r = XD();
    return Ft(r, t).getOr([]);
  }, LA = function(t, r) {
    if (!!$A(t)) {
      var o = XD(), l = Ft(o, r).getOr([]), v = We(l, function(g) {
        return g !== t;
      });
      o[r] = [t].concat(v).slice(0, GD), AF(o);
    }
  }, B3 = function(t) {
    return !!t;
  }, DF = function(t) {
    return Tn(Tp.makeMap(t, /[, ]/), B3);
  }, zA = function(t) {
    return _.from(_M(t)).filter(D);
  }, BF = function(t) {
    var r = _.some(AM(t)).filter(B3), o = _.some(s_(t)).filter(B3), l = r.or(o).map(DF);
    return zA(t).fold(ge, function(v) {
      return l.fold(xe, function(g) {
        return on(g).length > 0 ? g : !1;
      });
    });
  }, RF = function(t, r) {
    var o = BF(t);
    return le(o) ? o ? zA(t) : _.none() : o[r] ? zA(t) : _.none();
  }, MF = function(t, r) {
    return RF(t, r).map(function(o) {
      return function(l) {
        return Fu.nu(function(v) {
          var g = function(T, A) {
            if (!P(T))
              throw new Error("Expected value to be string");
            if (A !== void 0 && !H(A))
              throw new Error("Expected meta to be a object");
            var R = {
              value: T,
              meta: A
            };
            v(R);
          }, b = $({
            filetype: r,
            fieldname: l.fieldname
          }, _.from(l.meta).getOr({}));
          o.call(t, g, l.value, b);
        });
      };
    });
  }, YD = function(t) {
    return _.from(t).filter(P).getOrUndefined();
  }, PF = function(t) {
    return yO(t) ? _.none() : _.some({
      targets: EF.find(t.getBody()),
      anchorTop: YD(wO(t)),
      anchorBottom: YD(OM(t))
    });
  }, NF = function(t) {
    return _.from(CO(t));
  }, IF = function(t) {
    return {
      getHistory: OF,
      addToHistory: LA,
      getLinkInformation: function() {
        return PF(t);
      },
      getValidationHandler: function() {
        return NF(t);
      },
      getUrlPicker: function(r) {
        return MF(t, r);
      }
    };
  }, R3 = function(t, r, o) {
    var l = Sr(!1), v = PA(r), g = {
      shared: {
        providers: {
          icons: function() {
            return r.ui.registry.getAll().icons;
          },
          menuItems: function() {
            return r.ui.registry.getAll().menuItems;
          },
          translate: Af.translate,
          isDisabled: function() {
            return r.mode.isReadOnly() || r.ui.isDisabled();
          },
          getSetting: r.getParam.bind(r)
        },
        interpreter: function(b) {
          return QI(b, g);
        },
        anchors: nF(r, o, v.isPositionedAtTop),
        header: v,
        getSink: function() {
          return ea.value(t);
        }
      },
      urlinput: IF(r),
      styleselect: vF(r),
      colorinput: ID(r),
      dialog: uF(r),
      isContextMenuOpen: function() {
        return l.get();
      },
      setContextMenuState: function(b) {
        return l.set(b);
      }
    };
    return g;
  }, FF = function(t, r, o) {
    var l = function(Kt, st) {
      Pe([
        r,
        o
      ], function(Bt) {
        Bt.broadcastEvent(Kt, st);
      });
    }, v = function(Kt, st) {
      Pe([
        r,
        o
      ], function(Bt) {
        Bt.broadcastOn([Kt], st);
      });
    }, g = function(Kt) {
      return v(fm(), { target: Kt.target });
    }, b = uh(), T = ai(b, "touchstart", g), A = ai(b, "touchmove", function(Kt) {
      return l(B1(), Kt);
    }), R = ai(b, "touchend", function(Kt) {
      return l(Ok(), Kt);
    }), z = ai(b, "mousedown", g), U = ai(b, "mouseup", function(Kt) {
      Kt.raw.button === 0 && v(S2(), { target: Kt.target });
    }), oe = function(Kt) {
      return v(fm(), { target: Bn.fromDom(Kt.target) });
    }, de = function(Kt) {
      Kt.button === 0 && v(S2(), { target: Bn.fromDom(Kt.target) });
    }, Se = function() {
      Pe(t.editorManager.get(), function(Kt) {
        t !== Kt && Kt.fire("DismissPopups", { relatedTarget: t });
      });
    }, $e = function(Kt) {
      return l(by(), am(Kt));
    }, ut = function(Kt) {
      v(Ug(), {}), l(dl(), am(Kt));
    }, Ne = function() {
      return v(Ug(), {});
    }, ft = function(Kt) {
      Kt.state && v(fm(), { target: Bn.fromDom(t.getContainer()) });
    }, Ht = function(Kt) {
      v(fm(), { target: Bn.fromDom(Kt.relatedTarget.getContainer()) });
    };
    t.on("PostRender", function() {
      t.on("click", oe), t.on("tap", oe), t.on("mouseup", de), t.on("mousedown", Se), t.on("ScrollWindow", $e), t.on("ResizeWindow", ut), t.on("ResizeEditor", Ne), t.on("AfterProgressState", ft), t.on("DismissPopups", Ht);
    }), t.on("remove", function() {
      t.off("click", oe), t.off("tap", oe), t.off("mouseup", de), t.off("mousedown", Se), t.off("ScrollWindow", $e), t.off("ResizeWindow", ut), t.off("ResizeEditor", Ne), t.off("AfterProgressState", ft), t.off("DismissPopups", Ht), z.unbind(), T.unbind(), A.unbind(), R.unbind(), U.unbind();
    }), t.on("detach", function() {
      Gu(r), Gu(o), r.destroy(), o.destroy();
    });
  }, Tl = Br, Ep = q0, s1 = ie([
    ct("shell", !1),
    un("makeItem"),
    ct("setupItem", ee),
    Pl.field("listBehaviours", [qr])
  ]), $F = function() {
    return { behaviours: Fn([qr.config({})]) };
  }, HA = Nl({
    name: "items",
    overrides: $F
  }), M3 = ie([HA]), LF = ie("CustomList"), zF = function(t, r, o, l) {
    var v = function(T, A) {
      b(T).fold(function() {
        throw console.error("Custom List was defined to not be a shell, but no item container was specified in components"), new Error("Custom List was defined to not be a shell, but no item container was specified in components");
      }, function(R) {
        var z = qr.contents(R), U = A.length, oe = U - z.length, de = oe > 0 ? se(oe, function() {
          return t.makeItem();
        }) : [], Se = z.slice(U);
        Pe(Se, function(ut) {
          return qr.remove(R, ut);
        }), Pe(de, function(ut) {
          return qr.append(R, ut);
        });
        var $e = qr.contents(R);
        Pe($e, function(ut, Ne) {
          t.setupItem(T, ut, A[Ne], Ne);
        });
      });
    }, g = t.shell ? {
      behaviours: [qr.config({})],
      components: []
    } : {
      behaviours: [],
      components: r
    }, b = function(T) {
      return t.shell ? _.some(T) : Ya(T, t, "items");
    };
    return {
      uid: t.uid,
      dom: t.dom,
      components: g.components,
      behaviours: Zi(t.listBehaviours, g.behaviours),
      apis: { setItems: v }
    };
  }, ZD = ds({
    name: LF(),
    configFields: s1(),
    partFields: M3(),
    factory: zF,
    apis: {
      setItems: function(t, r, o) {
        t.setItems(r, o);
      }
    }
  }), Ub = ie([
    un("dom"),
    ct("shell", !0),
    Ni("toolbarBehaviours", [qr])
  ]), HF = function() {
    return { behaviours: Fn([qr.config({})]) };
  }, l1 = ie([Nl({
    name: "groups",
    overrides: HF
  })]), JD = function(t, r, o, l) {
    var v = function(T, A) {
      g(T).fold(function() {
        throw console.error("Toolbar was defined to not be a shell, but no groups container was specified in components"), new Error("Toolbar was defined to not be a shell, but no groups container was specified in components");
      }, function(R) {
        qr.set(R, A);
      });
    }, g = function(T) {
      return t.shell ? _.some(T) : Ya(T, t, "groups");
    }, b = t.shell ? {
      behaviours: [qr.config({})],
      components: []
    } : {
      behaviours: [],
      components: r
    };
    return {
      uid: t.uid,
      dom: t.dom,
      components: b.components,
      behaviours: Zi(t.toolbarBehaviours, b.behaviours),
      apis: { setGroups: v },
      domModification: { attributes: { role: "group" } }
    };
  }, Tv = ds({
    name: "Toolbar",
    configFields: Ub(),
    partFields: l1(),
    factory: JD,
    apis: {
      setGroups: function(t, r, o) {
        t.setGroups(r, o);
      }
    }
  }), VF = ee, UF = ge, QD = ie([]), jF = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    setup: VF,
    isDocked: UF,
    getBehaviours: QD
  }), eB = function(t) {
    var r = Ir(ui(t, "position"), "fixed"), o = r ? _.none() : ys(t);
    return o.orThunk(function() {
      var l = Bn.fromTag("span");
      return Co(t).bind(function(v) {
        Ou(v, l);
        var g = ys(l);
        return ws(l), g;
      });
    });
  }, P3 = function(t) {
    return eB(t).map(ts).getOrThunk(function() {
      return eo(0, 0);
    });
  }, c1 = fl.generate([
    { static: [] },
    { absolute: ["positionCss"] },
    { fixed: ["positionCss"] }
  ]), N3 = function(t, r) {
    var o = t.element;
    Di(o, r.transitionClass), yi(o, r.fadeOutClass), Di(o, r.fadeInClass), r.onShow(t);
  }, I3 = function(t, r) {
    var o = t.element;
    Di(o, r.transitionClass), yi(o, r.fadeInClass), Di(o, r.fadeOutClass), r.onHide(t);
  }, f1 = function(t, r) {
    return t.y < r.bottom && t.bottom > r.y;
  }, F3 = function(t, r) {
    return t.y >= r.y;
  }, WF = function(t, r) {
    return t.bottom <= r.bottom;
  }, VA = function(t, r, o) {
    return Xe(t, function(l) {
      switch (l) {
        case "bottom":
          return WF(r, o);
        case "top":
          return F3(r, o);
      }
    });
  }, UA = function(t, r) {
    return r.getInitialPos().map(function(o) {
      return Ai(o.bounds.x, o.bounds.y, Au(t), hi(t));
    });
  }, tB = function(t, r, o) {
    o.setInitialPos({
      style: Uf(t),
      position: Ho(t, "position") || "static",
      bounds: r
    });
  }, nB = function(t, r, o) {
    return o.getInitialPos().bind(function(l) {
      switch (o.clearInitialPos(), l.position) {
        case "static":
          return _.some(c1.static());
        case "absolute":
          var v = eB(t).map(si).getOrThunk(function() {
            return si($a());
          });
          return _.some(c1.absolute(Wu("absolute", Ft(l.style, "left").map(function(g) {
            return r.x - v.x;
          }), Ft(l.style, "top").map(function(g) {
            return r.y - v.y;
          }), Ft(l.style, "right").map(function(g) {
            return v.right - r.right;
          }), Ft(l.style, "bottom").map(function(g) {
            return v.bottom - r.bottom;
          }))));
        default:
          return _.none();
      }
    });
  }, rB = function(t, r, o) {
    return UA(t, o).filter(function(l) {
      return VA(o.getModes(), l, r);
    }).bind(function(l) {
      return nB(t, l, o);
    });
  }, qF = function(t, r, o) {
    var l = si(t);
    if (VA(o.getModes(), l, r))
      return _.none();
    tB(t, l, o);
    var v = uu(), g = l.x - v.x, b = r.y - v.y, T = v.bottom - r.bottom, A = l.y <= r.y;
    return _.some(c1.fixed(Wu("fixed", _.some(g), A ? _.some(b) : _.none(), _.none(), A ? _.none() : _.some(T))));
  }, GF = function(t, r, o) {
    var l = t.element, v = Ir(ui(l, "position"), "fixed");
    return v ? rB(l, r, o) : qF(l, r, o);
  }, KF = function(t, r) {
    var o = t.element;
    return UA(o, r).bind(function(l) {
      return nB(o, l, r);
    });
  }, $3 = function(t, r, o) {
    o.setDocked(!1), Pe([
      "left",
      "right",
      "top",
      "bottom",
      "position"
    ], function(l) {
      return Da(t.element, l);
    }), r.onUndocked(t);
  }, mC = function(t, r, o, l) {
    var v = l.position === "fixed";
    o.setDocked(v), nd(t.element, l);
    var g = v ? r.onDocked : r.onUndocked;
    g(t);
  }, aB = function(t, r, o, l, v) {
    v === void 0 && (v = !1), r.contextual.each(function(g) {
      g.lazyContext(t).each(function(b) {
        var T = f1(b, l);
        if (T !== o.isVisible())
          if (o.setVisible(T), v && !T)
            Kd(t.element, [g.fadeOutClass]), g.onHide(t);
          else {
            var A = T ? N3 : I3;
            A(t, g);
          }
      });
    });
  }, oB = function(t, r, o) {
    var l = r.lazyViewport(t), v = o.isDocked();
    v && aB(t, r, o, l), GF(t, l, o).each(function(g) {
      g.fold(function() {
        return $3(t, r, o);
      }, function(b) {
        return mC(t, r, o, b);
      }, function(b) {
        aB(t, r, o, l, !0), mC(t, r, o, b);
      });
    });
  }, XF = function(t, r, o) {
    var l = t.element;
    o.setDocked(!1), KF(t, o).each(function(v) {
      v.fold(function() {
        return $3(t, r, o);
      }, function(g) {
        return mC(t, r, o, g);
      }, ee);
    }), o.setVisible(!0), r.contextual.each(function(v) {
      bl(l, [
        v.fadeInClass,
        v.fadeOutClass,
        v.transitionClass
      ]), v.onShow(t);
    }), L3(t, r, o);
  }, L3 = function(t, r, o) {
    t.getSystem().isConnected() && oB(t, r, o);
  }, iB = function(t, r, o) {
    o.isDocked() && XF(t, r, o);
  }, YF = function(t, r, o) {
    return o.isDocked();
  }, v1 = function(t, r, o, l) {
    return o.setModes(l);
  }, uB = function(t, r, o) {
    return o.getModes();
  }, ZF = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    refresh: L3,
    reset: iB,
    isDocked: YF,
    getModes: uB,
    setModes: v1
  }), sB = function(t, r) {
    return ro([
      li(ug(), function(o, l) {
        t.contextual.each(function(v) {
          if (us(o.element, v.transitionClass)) {
            bl(o.element, [
              v.transitionClass,
              v.fadeInClass
            ]);
            var g = r.isVisible() ? v.onShown : v.onHidden;
            g(o);
          }
          l.stop();
        });
      }),
      cn(by(), function(o, l) {
        L3(o, t, r);
      }),
      cn(dl(), function(o, l) {
        iB(o, t, r);
      })
    ]);
  }, JF = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    events: sB
  }), z3 = [
    qs("contextual", [
      Lr("fadeInClass"),
      Lr("fadeOutClass"),
      Lr("transitionClass"),
      Uu("lazyContext"),
      Ra("onShow"),
      Ra("onShown"),
      Ra("onHide"),
      Ra("onHidden")
    ]),
    co("lazyViewport", uu),
    tv("modes", [
      "top",
      "bottom"
    ], ri),
    Ra("onDocked"),
    Ra("onUndocked")
  ], If = function(t) {
    var r = Sr(!1), o = Sr(!0), l = Zo(), v = Sr(t.modes), g = function() {
      return "docked:  " + r.get() + ", visible: " + o.get() + ", modes: " + v.get().join(",");
    };
    return Pu({
      isDocked: r.get,
      setDocked: r.set,
      getInitialPos: l.get,
      setInitialPos: l.set,
      clearInitialPos: l.clear,
      isVisible: o.get,
      setVisible: o.set,
      getModes: v.get,
      setModes: v.set,
      readState: g
    });
  }, QF = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    init: If
  }), vi = Pi({
    fields: z3,
    name: "docking",
    active: JF,
    apis: ZF,
    state: QF
  }), jA = ie(ur("toolbar-height-change")), Ed = {
    fadeInClass: "tox-editor-dock-fadein",
    fadeOutClass: "tox-editor-dock-fadeout",
    transitionClass: "tox-editor-dock-transition"
  }, WA = "tox-tinymce--toolbar-sticky-on", gC = "tox-tinymce--toolbar-sticky-off", _p = function(t, r) {
    var o = wo(r), l = o.dom.defaultView.innerHeight, v = Us(o), g = Bn.fromDom(t.elm), b = ef(g), T = hi(g), A = b.y, R = A + T, z = ts(r), U = hi(r), oe = z.top, de = oe + U, Se = Math.abs(oe - v.top) < 2, $e = Math.abs(de - (v.top + l)) < 2;
    if (Se && A < de)
      qm(v.left, A - U, o);
    else if ($e && R > oe) {
      var ut = A - l + T + U;
      qm(v.left, ut, o);
    }
  }, Bs = function(t, r) {
    return Tt(vi.getModes(t), r);
  }, qA = function(t) {
    var r = function(l) {
      return Vs(l) + (parseInt(Ho(l, "margin-top"), 10) || 0) + (parseInt(Ho(l, "margin-bottom"), 10) || 0);
    }, o = t.element;
    Co(o).each(function(l) {
      var v = "padding-" + vi.getModes(t)[0];
      if (vi.isDocked(t)) {
        var g = Au(l);
        Pr(o, "width", g + "px"), Pr(l, v, r(o) + "px");
      } else
        Da(o, "width"), Da(l, v);
    });
  }, GA = function(t, r) {
    r ? (yi(t, Ed.fadeOutClass), Kd(t, [
      Ed.transitionClass,
      Ed.fadeInClass
    ])) : (yi(t, Ed.fadeInClass), Kd(t, [
      Ed.fadeOutClass,
      Ed.transitionClass
    ]));
  }, KA = function(t, r) {
    var o = Bn.fromDom(t.getContainer());
    r ? (Di(o, WA), yi(o, gC)) : (Di(o, gC), yi(o, WA));
  }, lB = function(t, r) {
    var o = wo(r);
    vs(o).filter(function(l) {
      return !Fa(r, l);
    }).filter(function(l) {
      return Fa(l, Bn.fromDom(o.dom.body)) || _u(t, l);
    }).each(function() {
      return Mc(r);
    });
  }, e$ = function(t, r) {
    return Pc(t).orThunk(function() {
      return r().toOptional().bind(function(o) {
        return Pc(o.element);
      });
    });
  }, t$ = function(t, r, o) {
    t.inline || (r.header.isPositionedAtTop() || t.on("ResizeEditor", function() {
      o().each(vi.reset);
    }), t.on("ResizeWindow ResizeEditor", function() {
      o().each(qA);
    }), t.on("SkinLoaded", function() {
      o().each(function(l) {
        vi.isDocked(l) ? vi.reset(l) : vi.refresh(l);
      });
    }), t.on("FullscreenStateChanged", function() {
      o().each(vi.reset);
    })), t.on("AfterScrollIntoView", function(l) {
      o().each(function(v) {
        vi.refresh(v);
        var g = v.element;
        Ox(g) && _p(l, g);
      });
    }), t.on("PostRender", function() {
      KA(t, !1);
    });
  }, Ap = function(t) {
    return t().map(vi.isDocked).getOr(!1);
  }, cB = function() {
    var t;
    return [ju.config({ channels: (t = {}, t[jA()] = { onReceive: qA }, t) })];
  }, d1 = function(t, r) {
    var o = Zo(), l = r.getSink, v = function(T) {
      l().each(function(A) {
        return T(A.element);
      });
    }, g = function(T) {
      t.inline || qA(T), KA(t, vi.isDocked(T)), T.getSystem().broadcastOn([Ug()], {}), l().each(function(A) {
        return A.getSystem().broadcastOn([Ug()], {});
      });
    }, b = t.inline ? [] : cB();
    return ae([
      zr.config({}),
      vi.config({
        contextual: $({
          lazyContext: function(T) {
            var A = Vs(T.element), R = t.inline ? t.getContentAreaContainer() : t.getContainer(), z = si(Bn.fromDom(R)), U = z.height - A, oe = z.y + (Bs(T, "top") ? 0 : A);
            return _.some(Ai(z.x, oe, z.width, U));
          },
          onShow: function() {
            v(function(T) {
              return GA(T, !0);
            });
          },
          onShown: function(T) {
            v(function(A) {
              return bl(A, [
                Ed.transitionClass,
                Ed.fadeInClass
              ]);
            }), o.get().each(function(A) {
              lB(T.element, A), o.clear();
            });
          },
          onHide: function(T) {
            e$(T.element, l).fold(o.clear, o.set), v(function(A) {
              return GA(A, !1);
            });
          },
          onHidden: function() {
            v(function(T) {
              return bl(T, [Ed.transitionClass]);
            });
          }
        }, Ed),
        lazyViewport: function(T) {
          var A = uu(), R = R4(t), z = A.y + (Bs(T, "top") ? R : 0), U = A.height - (Bs(T, "bottom") ? R : 0);
          return Ai(A.x, z, A.width, U);
        },
        modes: [r.header.getDockingMode()],
        onDocked: g,
        onUndocked: g
      })
    ], b, !0);
  }, H3 = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    setup: t$,
    isDocked: Ap,
    getBehaviours: d1
  }), fB = function(t) {
    var r = t.editor, o = t.sticky ? d1 : QD;
    return {
      uid: t.uid,
      dom: t.dom,
      components: t.components,
      behaviours: Fn(o(r, t.sharedBackstage))
    };
  }, n$ = hr([
    Lr("type"),
    xs("items", Up([
      oy([
        Lr("name"),
        Ru("items", ri)
      ]),
      ri
    ]))
  ].concat(_w)), r$ = function(t) {
    return Io("GroupToolbarButton", n$, t);
  }, a$ = [
    lo("text"),
    lo("tooltip"),
    lo("icon"),
    Uu("fetch"),
    co("onSetup", function() {
      return ee;
    })
  ], o$ = hr(ae([Lr("type")], a$, !0)), m1 = function(t) {
    return Io("menubutton", o$, t);
  }, i$ = hr([
    Lr("type"),
    lo("tooltip"),
    lo("icon"),
    lo("text"),
    $v("select"),
    Uu("fetch"),
    co("onSetup", function() {
      return ee;
    }),
    cl("presets", "normal", [
      "normal",
      "color",
      "listpreview"
    ]),
    ct("columns", 1),
    Uu("onAction"),
    Uu("onItemAction")
  ]), u$ = function(t) {
    return Io("SplitButton", i$, t);
  }, s$ = function(t, r) {
    var o = function(v, g) {
      var b = _t(g, function(T) {
        var A = {
          type: "menubutton",
          text: T.text,
          fetch: function(z) {
            z(T.getItems());
          }
        }, R = m1(A).mapError(function(z) {
          return Fv(z);
        }).getOrDie();
        return wA(R, "tox-mbtn", r.backstage, _.some("menuitem"));
      });
      qr.set(v, b);
    }, l = {
      focus: Er.focusIn,
      setMenus: o
    };
    return {
      uid: t.uid,
      dom: t.dom,
      components: [],
      behaviours: Fn([
        qr.config({}),
        Jr("menubar-events", [
          Zr(function(v) {
            t.onSetup(v);
          }),
          cn(rv(), function(v, g) {
            Bi(v.element, ".tox-mbtn--active").each(function(b) {
              Rl(g.event.target, ".tox-mbtn").each(function(T) {
                Fa(b, T) || v.getSystem().getByDom(b).each(function(A) {
                  v.getSystem().getByDom(T).each(function(R) {
                    Bf.expand(R), Bf.close(A), zr.focus(R);
                  });
                });
              });
            });
          }),
          cn(R1(), function(v, g) {
            g.event.prevFocus.bind(function(b) {
              return v.getSystem().getByDom(b).toOptional();
            }).each(function(b) {
              g.event.newFocus.bind(function(T) {
                return v.getSystem().getByDom(T).toOptional();
              }).each(function(T) {
                Bf.isOpen(b) && (Bf.expand(T), Bf.close(b));
              });
            });
          })
        ]),
        Er.config({
          mode: "flow",
          selector: ".tox-mbtn",
          onEscape: function(v) {
            return t.onEscape(v), _.some(!0);
          }
        }),
        ci.config({})
      ]),
      apis: l,
      domModification: { attributes: { role: "menubar" } }
    };
  }, XA = Cl({
    factory: s$,
    name: "silver.Menubar",
    configFields: [
      un("dom"),
      un("uid"),
      un("onEscape"),
      un("backstage"),
      ct("onSetup", ee)
    ],
    apis: {
      focus: function(t, r) {
        t.focus(r);
      },
      setMenus: function(t, r, o) {
        t.setMenus(r, o);
      }
    }
  }), pC = function(t, r) {
    return r.getAnimationRoot.fold(function() {
      return t.element;
    }, function(o) {
      return o(t);
    });
  }, Ev = function(t) {
    return t.dimension.property;
  }, jb = function(t, r) {
    return t.dimension.getDimension(r);
  }, V3 = function(t, r) {
    var o = pC(t, r);
    bl(o, [
      r.shrinkingClass,
      r.growingClass
    ]);
  }, hC = function(t, r) {
    yi(t.element, r.openClass), Di(t.element, r.closedClass), Pr(t.element, Ev(r), "0px"), mo(t.element);
  }, YA = function(t, r) {
    yi(t.element, r.closedClass), Di(t.element, r.openClass), Da(t.element, Ev(r));
  }, bC = function(t, r, o, l) {
    o.setCollapsed(), Pr(t.element, Ev(r), jb(r, t.element)), mo(t.element), V3(t, r), hC(t, r), r.onStartShrink(t), r.onShrunk(t);
  }, U3 = function(t, r, o, l) {
    var v = l.getOrThunk(function() {
      return jb(r, t.element);
    });
    o.setCollapsed(), Pr(t.element, Ev(r), v), mo(t.element);
    var g = pC(t, r);
    yi(g, r.growingClass), Di(g, r.shrinkingClass), hC(t, r), r.onStartShrink(t);
  }, Op = function(t, r, o) {
    var l = jb(r, t.element), v = l === "0px" ? bC : U3;
    v(t, r, o, _.some(l));
  }, vB = function(t, r, o) {
    var l = pC(t, r), v = us(l, r.shrinkingClass), g = jb(r, t.element);
    YA(t, r);
    var b = jb(r, t.element), T = function() {
      Pr(t.element, Ev(r), g), mo(t.element);
    }, A = function() {
      hC(t, r);
    }, R = v ? T : A;
    R(), yi(l, r.shrinkingClass), Di(l, r.growingClass), YA(t, r), Pr(t.element, Ev(r), b), o.setExpanded(), r.onStartGrow(t);
  }, l$ = function(t, r, o) {
    if (o.isExpanded()) {
      Da(t.element, Ev(r));
      var l = jb(r, t.element);
      Pr(t.element, Ev(r), l);
    }
  }, ZA = function(t, r, o) {
    o.isExpanded() || vB(t, r, o);
  }, c$ = function(t, r, o) {
    o.isExpanded() && Op(t, r, o);
  }, j3 = function(t, r, o) {
    o.isExpanded() && bC(t, r, o);
  }, dB = function(t, r, o) {
    return o.isExpanded();
  }, f$ = function(t, r, o) {
    return o.isCollapsed();
  }, mB = function(t, r, o) {
    var l = pC(t, r);
    return us(l, r.growingClass) === !0;
  }, Wb = function(t, r, o) {
    var l = pC(t, r);
    return us(l, r.shrinkingClass) === !0;
  }, JA = function(t, r, o) {
    return mB(t, r) || Wb(t, r);
  }, v$ = function(t, r, o) {
    var l = o.isExpanded() ? Op : vB;
    l(t, r, o);
  }, d$ = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    refresh: l$,
    grow: ZA,
    shrink: c$,
    immediateShrink: j3,
    hasGrown: dB,
    hasShrunk: f$,
    isGrowing: mB,
    isShrinking: Wb,
    isTransitioning: JA,
    toggleGrow: v$,
    disableTransitions: V3
  }), gB = function(t, r, o) {
    var l = r.expanded;
    return nc(l ? {
      classes: [r.openClass],
      styles: {}
    } : {
      classes: [r.closedClass],
      styles: rf(r.dimension.property, "0px")
    });
  }, m$ = function(t, r) {
    return ro([li(ug(), function(o, l) {
      var v = l.event.raw;
      if (v.propertyName === t.dimension.property) {
        V3(o, t), r.isExpanded() && Da(o.element, t.dimension.property);
        var g = r.isExpanded() ? t.onGrown : t.onShrunk;
        g(o);
      }
    })]);
  }, g$ = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    exhibit: gB,
    events: m$
  }), e = [
    un("closedClass"),
    un("openClass"),
    un("shrinkingClass"),
    un("growingClass"),
    Ba("getAnimationRoot"),
    Ra("onShrunk"),
    Ra("onStartShrink"),
    Ra("onGrown"),
    Ra("onStartGrow"),
    ct("expanded", !1),
    xs("dimension", Al("property", {
      width: [
        io("property", "width"),
        io("getDimension", function(t) {
          return Au(t) + "px";
        })
      ],
      height: [
        io("property", "height"),
        io("getDimension", function(t) {
          return hi(t) + "px";
        })
      ]
    }))
  ], n = function(t) {
    var r = Sr(t.expanded), o = function() {
      return "expanded: " + r.get();
    };
    return Pu({
      isExpanded: function() {
        return r.get() === !0;
      },
      isCollapsed: function() {
        return r.get() === !1;
      },
      setCollapsed: Pt(r.set, !1),
      setExpanded: Pt(r.set, !0),
      readState: o
    });
  }, a = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    init: n
  }), i = Pi({
    fields: e,
    name: "sliding",
    active: g$,
    apis: d$,
    state: a
  }), s = "container", f = [Ni("slotBehaviours", [])], p = function(t) {
    return "<alloy.field." + t + ">";
  }, C = function(t) {
    var r = function() {
      var g = [], b = function(T, A) {
        return g.push(T), $2(s, p(T), A);
      };
      return {
        slot: b,
        record: ie(g)
      };
    }(), o = t(r), l = r.record(), v = _t(l, function(g) {
      return hu({
        name: g,
        pname: p(g)
      });
    });
    return U2(s, f, v, k, o);
  }, k = function(t, r) {
    var o = function($e) {
      return ux(t);
    }, l = function($e, ut) {
      return Ya($e, t, ut);
    }, v = function($e, ut) {
      return function(Ne, ft) {
        return Ya(Ne, t, ft).map(function(Ht) {
          return $e(Ht, ft);
        }).getOr(ut);
      };
    }, g = function($e) {
      return function(ut, Ne) {
        Pe(Ne, function(ft) {
          return $e(ut, ft);
        });
      };
    }, b = function($e, ut) {
      return So($e.element, "aria-hidden") !== "true";
    }, T = function($e, ut) {
      if (!b($e)) {
        var Ne = $e.element;
        Da(Ne, "display"), Gi(Ne, "aria-hidden"), xr($e, av(), {
          name: ut,
          visible: !0
        });
      }
    }, A = function($e, ut) {
      if (b($e)) {
        var Ne = $e.element;
        Pr(Ne, "display", "none"), Qr(Ne, "aria-hidden", "true"), xr($e, av(), {
          name: ut,
          visible: !1
        });
      }
    }, R = v(b, !1), z = v(A), U = g(z), oe = function($e) {
      return U($e, o());
    }, de = v(T), Se = {
      getSlotNames: o,
      getSlot: l,
      isShowing: R,
      hideSlot: z,
      hideAllSlots: oe,
      showSlot: de
    };
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      behaviours: Gg(t.slotBehaviours),
      apis: Se
    };
  }, F = Tn({
    getSlotNames: function(t, r) {
      return t.getSlotNames(r);
    },
    getSlot: function(t, r, o) {
      return t.getSlot(r, o);
    },
    isShowing: function(t, r, o) {
      return t.isShowing(r, o);
    },
    hideSlot: function(t, r, o) {
      return t.hideSlot(r, o);
    },
    hideAllSlots: function(t, r) {
      return t.hideAllSlots(r);
    },
    showSlot: function(t, r, o) {
      return t.showSlot(r, o);
    }
  }, function(t) {
    return Fo(t);
  }), q = $($({}, F), { sketch: C }), K = hr([
    lo("icon"),
    lo("tooltip"),
    co("onShow", ee),
    co("onHide", ee),
    co("onSetup", function() {
      return ee;
    })
  ]), te = function(t) {
    return Io("sidebar", K, t);
  }, be = function(t) {
    var r = t.ui.registry.getAll().sidebars;
    Pe(on(r), function(o) {
      var l = r[o], v = function() {
        return Ir(_.from(t.queryCommandValue("ToggleSidebar")), o);
      };
      t.ui.registry.addToggleButton(o, {
        icon: l.icon,
        tooltip: l.tooltip,
        onAction: function(g) {
          t.execCommand("ToggleSidebar", !1, o), g.setActive(v());
        },
        onSetup: function(g) {
          var b = function() {
            return g.setActive(v());
          };
          return t.on("ToggleSidebar", b), function() {
            t.off("ToggleSidebar", b);
          };
        }
      });
    });
  }, we = function(t) {
    return {
      element: function() {
        return t.element.dom;
      }
    };
  }, ke = function(t, r) {
    var o = _t(on(r), function(l) {
      var v = r[l], g = Yl(te(v));
      return {
        name: l,
        getApi: we,
        onSetup: g.onSetup,
        onShow: g.onShow,
        onHide: g.onHide
      };
    });
    return _t(o, function(l) {
      var v = Sr(ee);
      return t.slot(l.name, {
        dom: {
          tag: "div",
          classes: ["tox-sidebar__pane"]
        },
        behaviours: k4.unnamedEvents([
          qh(l, v),
          Gh(l, v),
          cn(av(), function(g, b) {
            var T = b.event, A = pt(o, function(R) {
              return R.name === T.name;
            });
            A.each(function(R) {
              var z = T.visible ? R.onShow : R.onHide;
              z(R.getApi(g));
            });
          })
        ])
      });
    });
  }, Ee = function(t) {
    return q.sketch(function(r) {
      return {
        dom: {
          tag: "div",
          classes: ["tox-sidebar__pane-container"]
        },
        components: ke(r, t),
        slotBehaviours: k4.unnamedEvents([Zr(function(o) {
          return q.hideAllSlots(o);
        })])
      };
    });
  }, qe = function(t, r) {
    var o = la.getCurrent(t);
    o.each(function(l) {
      return qr.set(l, [Ee(r)]);
    });
  }, Le = function(t, r) {
    var o = la.getCurrent(t);
    o.each(function(l) {
      var v = la.getCurrent(l);
      v.each(function(g) {
        i.hasGrown(l) ? q.isShowing(g, r) ? i.shrink(l) : (q.hideAllSlots(g), q.showSlot(g, r)) : (q.hideAllSlots(g), q.showSlot(g, r), i.grow(l));
      });
    });
  }, xt = function(t) {
    var r = la.getCurrent(t);
    return r.bind(function(o) {
      var l = i.isGrowing(o) || i.hasGrown(o);
      if (l) {
        var v = la.getCurrent(o);
        return v.bind(function(g) {
          return pt(q.getSlotNames(g), function(b) {
            return q.isShowing(g, b);
          });
        });
      } else
        return _.none();
    });
  }, mt = ur("FixSizeEvent"), Qe = ur("AutoSizeEvent"), At = function(t) {
    return {
      uid: t.uid,
      dom: {
        tag: "div",
        classes: ["tox-sidebar"],
        attributes: { role: "complementary" }
      },
      components: [{
        dom: {
          tag: "div",
          classes: ["tox-sidebar__slider"]
        },
        components: [],
        behaviours: Fn([
          ci.config({}),
          zr.config({}),
          i.config({
            dimension: { property: "width" },
            closedClass: "tox-sidebar--sliding-closed",
            openClass: "tox-sidebar--sliding-open",
            shrinkingClass: "tox-sidebar--sliding-shrinking",
            growingClass: "tox-sidebar--sliding-growing",
            onShrunk: function(r) {
              var o = la.getCurrent(r);
              o.each(q.hideAllSlots), Ta(r, Qe);
            },
            onGrown: function(r) {
              Ta(r, Qe);
            },
            onStartGrow: function(r) {
              xr(r, mt, { width: ui(r.element, "width").getOr("") });
            },
            onStartShrink: function(r) {
              xr(r, mt, { width: Au(r.element) + "px" });
            }
          }),
          qr.config({}),
          la.config({
            find: function(r) {
              var o = qr.contents(r);
              return It(o);
            }
          })
        ])
      }],
      behaviours: Fn([
        kv.childAt(0),
        Jr("sidebar-sliding-events", [
          cn(mt, function(r, o) {
            Pr(r.element, "width", o.event.width);
          }),
          cn(Qe, function(r, o) {
            Da(r.element, "width");
          })
        ])
      ])
    };
  }, tn = function(t, r, o, l) {
    Qr(t.element, "aria-busy", !0);
    var v = r.getRoot(t).getOr(t), g = Fn([
      Er.config({
        mode: "special",
        onTab: function() {
          return _.some(!0);
        },
        onShiftTab: function() {
          return _.some(!0);
        }
      }),
      zr.config({})
    ]), b = l(v, g), T = v.getSystem().build(b);
    qr.append(v, yl(T)), T.hasConfigured(Er) && r.focus && Er.focusIn(T), o.isBlocked() || r.onBlock(t), o.blockWith(function() {
      return qr.remove(v, T);
    });
  }, Cn = function(t, r, o) {
    Gi(t.element, "aria-busy"), o.isBlocked() && r.onUnblock(t), o.clear();
  }, Ar = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    block: tn,
    unblock: Cn
  }), Xn = [
    co("getRoot", _.none),
    no("focus", !0),
    Ra("onBlock"),
    Ra("onUnblock")
  ], fn = function() {
    var t = Yy(), r = function(o) {
      t.set({ destroy: o });
    };
    return Pu({
      readState: t.isSet,
      blockWith: r,
      clear: t.clear,
      isBlocked: t.isSet
    });
  }, _r = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    init: fn
  }), kn = Pi({
    fields: Xn,
    name: "blocking",
    apis: Ar,
    state: _r
  }), Kn = function(t) {
    var r = t.dom.attributes !== void 0 ? t.dom.attributes : [];
    return Ke(r, function(o, l) {
      var v;
      return l.name === "class" ? o : $($({}, o), (v = {}, v[l.name] = l.value, v));
    }, {});
  }, On = function(t) {
    return Array.prototype.slice.call(t.dom.classList, 0);
  }, $n = function(t) {
    var r = Bn.fromHtml(t), o = O(r), l = Kn(r), v = On(r), g = o.length === 0 ? {} : { innerHtml: uf(r) };
    return $({
      tag: et(r),
      classes: v,
      attributes: l
    }, g);
  }, rr = function(t) {
    return function(r, o) {
      return {
        dom: {
          tag: "div",
          attributes: {
            "aria-label": t.translate("Loading..."),
            tabindex: "0"
          },
          classes: ["tox-throbber__busy-spinner"]
        },
        components: [{ dom: $n('<div class="tox-spinner"><div></div><div></div><div></div></div>') }]
      };
    };
  }, hn = function(t) {
    return la.getCurrent(t).each(function(r) {
      return Mc(r.element);
    });
  }, Zn = function(t, r) {
    var o = "tabindex", l = "data-mce-" + o;
    _.from(t.iframeElement).map(Bn.fromDom).each(function(v) {
      r ? (No(v, o).each(function(g) {
        return Qr(v, l, g);
      }), Qr(v, o, -1)) : (Gi(v, o), No(v, l).each(function(g) {
        Qr(v, o, g), Gi(v, l);
      }));
    });
  }, fa = function(t, r, o, l) {
    var v = r.element;
    if (Zn(t, o), o)
      kn.block(r, rr(l)), Da(v, "display"), Gi(v, "aria-hidden"), t.hasFocus() && hn(r);
    else {
      var g = la.getCurrent(r).exists(function(b) {
        return lh(b.element);
      });
      kn.unblock(r), Pr(v, "display", "none"), Qr(v, "aria-hidden", "true"), g && t.focus();
    }
  }, Ia = function(t) {
    return {
      uid: t.uid,
      dom: {
        tag: "div",
        attributes: { "aria-hidden": "true" },
        classes: ["tox-throbber"],
        styles: { display: "none" }
      },
      behaviours: Fn([
        qr.config({}),
        kn.config({ focus: !1 }),
        la.config({
          find: function(r) {
            return It(r.components());
          }
        })
      ]),
      components: []
    };
  }, Pa = function(t) {
    return t.type === "focusin";
  }, yu = function(t) {
    if (Pa(t)) {
      var r = t.composed ? It(t.composedPath()) : _.from(t.target);
      return r.map(Bn.fromDom).filter(Z).exists(function(o) {
        return us(o, "mce-pastebin");
      });
    } else
      return !1;
  }, Wo = function(t, r, o) {
    var l = Sr(!1), v = Zo(), g = function(T) {
      l.get() && !yu(T) && (T.preventDefault(), hn(r()), t.editorManager.setActive(t));
    };
    t.inline || t.on("PreInit", function() {
      t.dom.bind(t.getWin(), "focusin", g), t.on("BeforeExecCommand", function(T) {
        T.command.toLowerCase() === "mcefocus" && T.value !== !0 && g(T);
      });
    });
    var b = function(T) {
      T !== l.get() && (l.set(T), fa(t, r(), T, o.providers), t.fire("AfterProgressState", { state: T }));
    };
    t.on("ProgressState", function(T) {
      if (v.on(pp.clearTimeout), J(T.time)) {
        var A = pp.setEditorTimeout(t, function() {
          return b(T.state);
        }, T.time);
        v.set(A);
      } else
        b(T.state), v.clear();
    });
  }, Rs = function(t, r) {
    var o = {
      len: 0,
      list: []
    }, l = Ke(t, function(v, g) {
      var b = r(g, v.len);
      return b.fold(ie(v), function(T) {
        return {
          len: T.finish,
          list: v.list.concat([T])
        };
      });
    }, o);
    return l.list;
  }, tl = function(t, r, o) {
    return {
      within: t,
      extra: r,
      withinWidth: o
    };
  }, bn = function(t, r, o) {
    var l = Rs(t, function(T, A) {
      var R = o(T);
      return _.some({
        element: T,
        start: A,
        finish: A + R,
        width: R
      });
    }), v = We(l, function(T) {
      return T.finish <= r;
    }), g = Ae(v, function(T, A) {
      return T + A.width;
    }, 0), b = l.slice(v.length);
    return {
      within: v,
      extra: b,
      withinWidth: g
    };
  }, Mn = function(t) {
    return _t(t, function(r) {
      return r.element;
    });
  }, gr = function(t, r, o) {
    var l = Mn(t.concat(r));
    return tl(l, [], o);
  }, Dt = function(t, r, o, l) {
    var v = Mn(t).concat([o]);
    return tl(v, Mn(r), l);
  }, xn = function(t, r, o) {
    return tl(Mn(t), [], o);
  }, wn = function(t, r, o) {
    var l = bn(r, t, o);
    return l.extra.length === 0 ? _.some(l) : _.none();
  }, yr = function(t, r, o, l) {
    var v = wn(t, r, o).getOrThunk(function() {
      return bn(r, t - o(l), o);
    }), g = v.within, b = v.extra, T = v.withinWidth;
    return b.length === 1 && b[0].width <= o(l) ? gr(g, b, T) : b.length >= 1 ? Dt(g, b, l, T) : xn(g, b, T);
  }, kr = function(t, r) {
    var o = _t(r, function(l) {
      return yl(l);
    });
    Tv.setGroups(t, o);
  }, uo = function(t) {
    return Xt(t, function(r) {
      return Pc(r.element).bind(function(o) {
        return r.getSystem().getByDom(o).toOptional();
      });
    });
  }, ji = function(t, r, o) {
    var l = r.builtGroups.get();
    if (l.length !== 0) {
      var v = xf(t, r, "primary"), g = fi.getCoupled(t, "overflowGroup");
      Pr(v.element, "visibility", "hidden");
      var b = l.concat([g]), T = uo(b);
      o([]), kr(v, b);
      var A = Au(v.element), R = yr(A, r.builtGroups.get(), function(z) {
        return Au(z.element);
      }, g);
      R.extra.length === 0 ? (qr.remove(v, g), o([])) : (kr(v, R.within), o(R.extra)), Da(v.element, "visibility"), mo(v.element), T.each(zr.focus);
    }
  }, Ii = ie([
    Ni("splitToolbarBehaviours", [fi]),
    as("builtGroups", function() {
      return Sr([]);
    })
  ]), Mm = ie([
    Jd(["overflowToggledClass"]),
    $v("getOverflowBounds"),
    un("lazySink"),
    as("overflowGroups", function() {
      return Sr([]);
    })
  ].concat(Ii())), Ms = ie([
    hu({
      factory: Tv,
      schema: Ub(),
      name: "primary"
    }),
    wl({
      schema: Ub(),
      name: "overflow"
    }),
    wl({ name: "overflow-button" }),
    wl({ name: "overflow-group" })
  ]), ps = ie(function(t, r) {
    iu(t, Math.floor(r));
  }), nu = ie([
    Jd(["toggledClass"]),
    un("lazySink"),
    Uu("fetch"),
    $v("getBounds"),
    qs("fireDismissalEventInstead", [ct("event", ec())]),
    rd()
  ]), vc = ie([
    wl({
      name: "button",
      overrides: function(t) {
        return {
          dom: { attributes: { "aria-haspopup": "true" } },
          buttonBehaviours: Fn([wa.config({
            toggleClass: t.markers.toggledClass,
            aria: { mode: "expanded" },
            toggleOnExecute: !1
          })])
        };
      }
    }),
    wl({
      factory: Tv,
      schema: Ub(),
      name: "toolbar",
      overrides: function(t) {
        return {
          toolbarBehaviours: Fn([Er.config({
            mode: "cyclic",
            onEscape: function(r) {
              return Ya(r, t, "button").each(zr.focus), _.none();
            }
          })])
        };
      }
    })
  ]), Ps = function(t, r) {
    var o = fi.getCoupled(t, "toolbarSandbox");
    ga.isOpen(o) ? ga.close(o) : ga.open(o, r.toolbar());
  }, Ff = function(t, r, o, l) {
    var v = o.getBounds.map(function(b) {
      return b();
    }), g = o.lazySink(t).getOrDie();
    Jo.positionWithinBounds(g, r, {
      anchor: {
        type: "hotspot",
        hotspot: t,
        layouts: l,
        overrides: { maxWidthFunction: ps() }
      }
    }, v);
  }, fo = function(t, r, o, l, v) {
    Tv.setGroups(r, v), Ff(t, r, o, l), wa.on(t);
  }, To = function(t, r, o) {
    var l = Xd(), v = function(b, T) {
      o.fetch().get(function(A) {
        fo(t, T, o, r.layouts, A), l.link(t.element), Er.focusIn(T);
      });
    }, g = function() {
      wa.off(t), zr.focus(t), l.unlink(t.element);
    };
    return {
      dom: {
        tag: "div",
        attributes: { id: l.id }
      },
      behaviours: Fn([
        Er.config({
          mode: "special",
          onEscape: function(b) {
            return ga.close(b), _.some(!0);
          }
        }),
        ga.config({
          onOpen: v,
          onClose: g,
          isPartOf: function(b, T, A) {
            return Yd(T, A) || Yd(t, A);
          },
          getAttachPoint: function() {
            return o.lazySink(t).getOrDie();
          }
        }),
        ju.config({
          channels: $($({}, Os($({ isExtraPart: ge }, o.fireDismissalEventInstead.map(function(b) {
            return { fireEventInstead: { event: b.event } };
          }).getOr({})))), vm({
            doReposition: function() {
              ga.getState(fi.getCoupled(t, "toolbarSandbox")).each(function(b) {
                Ff(t, b, o, r.layouts);
              });
            }
          }))
        })
      ])
    };
  }, ru = function(t, r, o, l) {
    return $($({}, Js.sketch($($({}, l.button()), {
      action: function(v) {
        Ps(v, l);
      },
      buttonBehaviours: Pl.augment({ dump: l.button().buttonBehaviours }, [fi.config({
        others: {
          toolbarSandbox: function(v) {
            return To(v, o, t);
          }
        }
      })])
    }))), {
      apis: {
        setGroups: function(v, g) {
          ga.getState(fi.getCoupled(v, "toolbarSandbox")).each(function(b) {
            fo(v, b, t, o.layouts, g);
          });
        },
        reposition: function(v) {
          ga.getState(fi.getCoupled(v, "toolbarSandbox")).each(function(g) {
            Ff(v, g, t, o.layouts);
          });
        },
        toggle: function(v) {
          Ps(v, l);
        },
        getToolbar: function(v) {
          return ga.getState(fi.getCoupled(v, "toolbarSandbox"));
        },
        isOpen: function(v) {
          return ga.isOpen(fi.getCoupled(v, "toolbarSandbox"));
        }
      }
    });
  }, nl = ds({
    name: "FloatingToolbarButton",
    factory: ru,
    configFields: nu(),
    partFields: vc(),
    apis: {
      setGroups: function(t, r, o) {
        t.setGroups(r, o);
      },
      reposition: function(t, r) {
        t.reposition(r);
      },
      toggle: function(t, r) {
        t.toggle(r);
      },
      getToolbar: function(t, r) {
        return t.getToolbar(r);
      },
      isOpen: function(t, r) {
        return t.isOpen(r);
      }
    }
  }), _v = ie([
    un("items"),
    Jd(["itemSelector"]),
    Ni("tgroupBehaviours", [Er])
  ]), Av = ie([Sf({
    name: "items",
    unit: "item"
  })]), Dp = function(t, r, o, l) {
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      behaviours: Zi(t.tgroupBehaviours, [Er.config({
        mode: "flow",
        selector: t.markers.itemSelector
      })]),
      domModification: { attributes: { role: "toolbar" } }
    };
  }, qb = ds({
    name: "ToolbarGroup",
    configFields: _v(),
    partFields: Av(),
    factory: Dp
  }), W3 = function(t) {
    return _t(t, function(r) {
      return yl(r);
    });
  }, pB = function(t, r, o) {
    ji(t, o, function(l) {
      o.overflowGroups.set(l), r.getOpt(t).each(function(v) {
        nl.setGroups(v, W3(l));
      });
    });
  }, hB = function(t, r, o, l) {
    var v = La(nl.sketch({
      fetch: function() {
        return Fu.nu(function(g) {
          g(W3(t.overflowGroups.get()));
        });
      },
      layouts: {
        onLtr: function() {
          return [
            Vi,
            Nu
          ];
        },
        onRtl: function() {
          return [
            Nu,
            Vi
          ];
        },
        onBottomLtr: function() {
          return [
            fs,
            cs
          ];
        },
        onBottomRtl: function() {
          return [
            cs,
            fs
          ];
        }
      },
      getBounds: o.getOverflowBounds,
      lazySink: t.lazySink,
      fireDismissalEventInstead: {},
      markers: { toggledClass: t.markers.overflowToggledClass },
      parts: {
        button: l["overflow-button"](),
        toolbar: l.overflow()
      }
    }));
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      behaviours: Zi(t.splitToolbarBehaviours, [fi.config({
        others: {
          overflowGroup: function() {
            return qb.sketch($($({}, l["overflow-group"]()), { items: [v.asSpec()] }));
          }
        }
      })]),
      apis: {
        setGroups: function(g, b) {
          t.builtGroups.set(_t(b, g.getSystem().build)), pB(g, v, t);
        },
        refresh: function(g) {
          return pB(g, v, t);
        },
        toggle: function(g) {
          v.getOpt(g).each(function(b) {
            nl.toggle(b);
          });
        },
        isOpen: function(g) {
          return v.getOpt(g).map(nl.isOpen).getOr(!1);
        },
        reposition: function(g) {
          v.getOpt(g).each(function(b) {
            nl.reposition(b);
          });
        },
        getOverflow: function(g) {
          return v.getOpt(g).bind(nl.getToolbar);
        }
      },
      domModification: { attributes: { role: "group" } }
    };
  }, QA = ds({
    name: "SplitFloatingToolbar",
    configFields: Mm(),
    partFields: Ms(),
    factory: hB,
    apis: {
      setGroups: function(t, r, o) {
        t.setGroups(r, o);
      },
      refresh: function(t, r) {
        t.refresh(r);
      },
      reposition: function(t, r) {
        t.reposition(r);
      },
      toggle: function(t, r) {
        t.toggle(r);
      },
      isOpen: function(t, r) {
        return t.isOpen(r);
      },
      getOverflow: function(t, r) {
        return t.getOverflow(r);
      }
    }
  }), p$ = ie([
    Jd([
      "closedClass",
      "openClass",
      "shrinkingClass",
      "growingClass",
      "overflowToggledClass"
    ]),
    Ra("onOpened"),
    Ra("onClosed")
  ].concat(Ii())), bB = ie([
    hu({
      factory: Tv,
      schema: Ub(),
      name: "primary"
    }),
    hu({
      factory: Tv,
      schema: Ub(),
      name: "overflow",
      overrides: function(t) {
        return {
          toolbarBehaviours: Fn([
            i.config({
              dimension: { property: "height" },
              closedClass: t.markers.closedClass,
              openClass: t.markers.openClass,
              shrinkingClass: t.markers.shrinkingClass,
              growingClass: t.markers.growingClass,
              onShrunk: function(r) {
                Ya(r, t, "overflow-button").each(function(o) {
                  wa.off(o), zr.focus(o);
                }), t.onClosed(r);
              },
              onGrown: function(r) {
                Er.focusIn(r), t.onOpened(r);
              },
              onStartGrow: function(r) {
                Ya(r, t, "overflow-button").each(wa.on);
              }
            }),
            Er.config({
              mode: "acyclic",
              onEscape: function(r) {
                return Ya(r, t, "overflow-button").each(zr.focus), _.some(!0);
              }
            })
          ])
        };
      }
    }),
    wl({
      name: "overflow-button",
      overrides: function(t) {
        return {
          buttonBehaviours: Fn([wa.config({
            toggleClass: t.markers.overflowToggledClass,
            aria: { mode: "pressed" },
            toggleOnExecute: !1
          })])
        };
      }
    }),
    wl({ name: "overflow-group" })
  ]), h$ = function(t, r) {
    return Ya(t, r, "overflow").map(i.hasGrown).getOr(!1);
  }, yB = function(t, r) {
    Ya(t, r, "overflow-button").bind(function() {
      return Ya(t, r, "overflow");
    }).each(function(o) {
      e5(t, r), i.toggleGrow(o);
    });
  }, e5 = function(t, r) {
    Ya(t, r, "overflow").each(function(o) {
      ji(t, r, function(l) {
        var v = _t(l, function(g) {
          return yl(g);
        });
        Tv.setGroups(o, v);
      }), Ya(t, r, "overflow-button").each(function(l) {
        i.hasGrown(o) && wa.on(l);
      }), i.refresh(o);
    });
  }, b$ = function(t, r, o, l) {
    var v = "alloy.toolbar.toggle", g = function(b, T) {
      var A = _t(T, b.getSystem().build);
      t.builtGroups.set(A);
    };
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      behaviours: Zi(t.splitToolbarBehaviours, [
        fi.config({
          others: {
            overflowGroup: function(b) {
              return qb.sketch($($({}, l["overflow-group"]()), {
                items: [Js.sketch($($({}, l["overflow-button"]()), {
                  action: function(T) {
                    Ta(b, v);
                  }
                }))]
              }));
            }
          }
        }),
        Jr("toolbar-toggle-events", [cn(v, function(b) {
          yB(b, t);
        })])
      ]),
      apis: {
        setGroups: function(b, T) {
          g(b, T), e5(b, t);
        },
        refresh: function(b) {
          return e5(b, t);
        },
        toggle: function(b) {
          return yB(b, t);
        },
        isOpen: function(b) {
          return h$(b, t);
        }
      },
      domModification: { attributes: { role: "group" } }
    };
  }, Pm = ds({
    name: "SplitSlidingToolbar",
    configFields: p$(),
    partFields: bB(),
    factory: b$,
    apis: {
      setGroups: function(t, r, o) {
        t.setGroups(r, o);
      },
      refresh: function(t, r) {
        t.refresh(r);
      },
      toggle: function(t, r) {
        t.toggle(r);
      },
      isOpen: function(t, r) {
        return t.isOpen(r);
      }
    }
  }), t5 = function(t) {
    var r = t.title.fold(function() {
      return {};
    }, function(o) {
      return { attributes: { title: o } };
    });
    return {
      dom: $({
        tag: "div",
        classes: ["tox-toolbar__group"]
      }, r),
      components: [qb.parts.items({})],
      items: t.items,
      markers: { itemSelector: "*:not(.tox-split-button) > .tox-tbtn:not([disabled]), .tox-split-button:not([disabled]), .tox-toolbar-nav-js:not([disabled])" },
      tgroupBehaviours: Fn([
        ci.config({}),
        zr.config({})
      ])
    };
  }, it = function(t) {
    return qb.sketch(t5(t));
  }, $t = function(t, r) {
    var o = Zr(function(l) {
      var v = _t(t.initGroups, it);
      Tv.setGroups(l, v);
    });
    return Fn([
      Of.toolbarButton(t.providers.isDisabled),
      Ui(),
      Er.config({
        mode: r,
        onEscape: t.onEscape,
        selector: ".tox-toolbar__group"
      }),
      Jr("toolbar-events", [o])
    ]);
  }, An = function(t) {
    var r = t.cyclicKeying ? "cyclic" : "acyclic";
    return {
      uid: t.uid,
      dom: {
        tag: "div",
        classes: ["tox-toolbar-overlord"]
      },
      parts: {
        "overflow-group": t5({
          title: _.none(),
          items: []
        }),
        "overflow-button": tD({
          name: "more",
          icon: _.some("more-drawer"),
          disabled: !1,
          tooltip: _.some("More..."),
          primary: !1,
          borderless: !1
        }, _.none(), t.providers)
      },
      splitToolbarBehaviours: $t(t, r)
    };
  }, Hn = function(t) {
    var r = An(t), o = 4, l = QA.parts.primary({
      dom: {
        tag: "div",
        classes: ["tox-toolbar__primary"]
      }
    });
    return QA.sketch($($({}, r), {
      lazySink: t.getSink,
      getOverflowBounds: function() {
        var v = t.moreDrawerData.lazyHeader().element, g = ef(v), b = Ut(v), T = ef(b), A = Math.max(b.dom.scrollHeight, T.height);
        return Ai(g.x + o, T.y, g.width - o * 2, A);
      },
      parts: $($({}, r.parts), {
        overflow: {
          dom: {
            tag: "div",
            classes: ["tox-toolbar__overflow"],
            attributes: t.attributes
          }
        }
      }),
      components: [l],
      markers: { overflowToggledClass: "tox-tbtn--enabled" }
    }));
  }, oa = function(t) {
    var r = Pm.parts.primary({
      dom: {
        tag: "div",
        classes: ["tox-toolbar__primary"]
      }
    }), o = Pm.parts.overflow({
      dom: {
        tag: "div",
        classes: ["tox-toolbar__overflow"]
      }
    }), l = An(t);
    return Pm.sketch($($({}, l), {
      components: [
        r,
        o
      ],
      markers: {
        openClass: "tox-toolbar__overflow--open",
        closedClass: "tox-toolbar__overflow--closed",
        growingClass: "tox-toolbar__overflow--growing",
        shrinkingClass: "tox-toolbar__overflow--shrinking",
        overflowToggledClass: "tox-tbtn--enabled"
      },
      onOpened: function(v) {
        v.getSystem().broadcastOn([jA()], { type: "opened" });
      },
      onClosed: function(v) {
        v.getSystem().broadcastOn([jA()], { type: "closed" });
      }
    }));
  }, _a = function(t) {
    var r = t.cyclicKeying ? "cyclic" : "acyclic";
    return Tv.sketch({
      uid: t.uid,
      dom: {
        tag: "div",
        classes: ["tox-toolbar"].concat(t.type === lc.scrolling ? ["tox-toolbar--scrolling"] : [])
      },
      components: [Tv.parts.groups({})],
      toolbarBehaviours: $t(t, r)
    });
  }, $o = function(t, r, o) {
    var l = {
      getSocket: function(v) {
        return Tl.getPart(v, t, "socket");
      },
      setSidebar: function(v, g) {
        Tl.getPart(v, t, "sidebar").each(function(b) {
          return qe(b, g);
        });
      },
      toggleSidebar: function(v, g) {
        Tl.getPart(v, t, "sidebar").each(function(b) {
          return Le(b, g);
        });
      },
      whichSidebar: function(v) {
        return Tl.getPart(v, t, "sidebar").bind(xt).getOrNull();
      },
      getHeader: function(v) {
        return Tl.getPart(v, t, "header");
      },
      getToolbar: function(v) {
        return Tl.getPart(v, t, "toolbar");
      },
      setToolbar: function(v, g) {
        Tl.getPart(v, t, "toolbar").each(function(b) {
          b.getApis().setGroups(b, g);
        });
      },
      setToolbars: function(v, g) {
        Tl.getPart(v, t, "multiple-toolbar").each(function(b) {
          ZD.setItems(b, g);
        });
      },
      refreshToolbar: function(v) {
        var g = Tl.getPart(v, t, "toolbar");
        g.each(function(b) {
          return b.getApis().refresh(b);
        });
      },
      toggleToolbarDrawer: function(v) {
        Tl.getPart(v, t, "toolbar").each(function(g) {
          Go(g.getApis().toggle, function(b) {
            return b(g);
          });
        });
      },
      isToolbarDrawerToggled: function(v) {
        return Tl.getPart(v, t, "toolbar").bind(function(g) {
          return _.from(g.getApis().isOpen).map(function(b) {
            return b(g);
          });
        }).getOr(!1);
      },
      getThrobber: function(v) {
        return Tl.getPart(v, t, "throbber");
      },
      focusToolbar: function(v) {
        var g = Tl.getPart(v, t, "toolbar").orThunk(function() {
          return Tl.getPart(v, t, "multiple-toolbar");
        });
        g.each(function(b) {
          Er.focusIn(b);
        });
      },
      setMenubar: function(v, g) {
        Tl.getPart(v, t, "menubar").each(function(b) {
          XA.setMenus(b, g);
        });
      },
      focusMenubar: function(v) {
        Tl.getPart(v, t, "menubar").each(function(g) {
          XA.focus(g);
        });
      }
    };
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      apis: l,
      behaviours: t.behaviours
    };
  }, Bp = Ep.optional({
    factory: XA,
    name: "menubar",
    schema: [un("backstage")]
  }), NU = function(t) {
    return t.type === lc.sliding ? oa : t.type === lc.floating ? Hn : _a;
  }, IU = Ep.optional({
    factory: {
      sketch: function(t) {
        return ZD.sketch({
          uid: t.uid,
          dom: t.dom,
          listBehaviours: Fn([Er.config({
            mode: "acyclic",
            selector: ".tox-toolbar"
          })]),
          makeItem: function() {
            return _a({
              type: t.type,
              uid: ur("multiple-toolbar-item"),
              cyclicKeying: !1,
              initGroups: [],
              providers: t.providers,
              onEscape: function() {
                return t.onEscape(), _.some(!0);
              }
            });
          },
          setupItem: function(r, o, l, v) {
            Tv.setGroups(o, l);
          },
          shell: !0
        });
      }
    },
    name: "multiple-toolbar",
    schema: [
      un("dom"),
      un("onEscape")
    ]
  }), FU = Ep.optional({
    factory: {
      sketch: function(t) {
        var r = NU(t), o = {
          type: t.type,
          uid: t.uid,
          onEscape: function() {
            return t.onEscape(), _.some(!0);
          },
          cyclicKeying: !1,
          initGroups: [],
          getSink: t.getSink,
          providers: t.providers,
          moreDrawerData: {
            lazyToolbar: t.lazyToolbar,
            lazyMoreButton: t.lazyMoreButton,
            lazyHeader: t.lazyHeader
          },
          attributes: t.attributes
        };
        return r(o);
      }
    },
    name: "toolbar",
    schema: [
      un("dom"),
      un("onEscape"),
      un("getSink")
    ]
  }), $U = Ep.optional({
    factory: { sketch: fB },
    name: "header",
    schema: [un("dom")]
  }), LU = Ep.optional({
    name: "socket",
    schema: [un("dom")]
  }), zU = Ep.optional({
    factory: { sketch: At },
    name: "sidebar",
    schema: [un("dom")]
  }), HU = Ep.optional({
    factory: { sketch: Ia },
    name: "throbber",
    schema: [un("dom")]
  }), Ci = ds({
    name: "OuterContainer",
    factory: $o,
    configFields: [
      un("dom"),
      un("behaviours")
    ],
    partFields: [
      $U,
      Bp,
      FU,
      IU,
      LU,
      zU,
      HU
    ],
    apis: {
      getSocket: function(t, r) {
        return t.getSocket(r);
      },
      setSidebar: function(t, r, o) {
        t.setSidebar(r, o);
      },
      toggleSidebar: function(t, r, o) {
        t.toggleSidebar(r, o);
      },
      whichSidebar: function(t, r) {
        return t.whichSidebar(r);
      },
      getHeader: function(t, r) {
        return t.getHeader(r);
      },
      getToolbar: function(t, r) {
        return t.getToolbar(r);
      },
      setToolbar: function(t, r, o) {
        var l = _t(o, function(v) {
          return it(v);
        });
        t.setToolbar(r, l);
      },
      setToolbars: function(t, r, o) {
        var l = _t(o, function(v) {
          return _t(v, it);
        });
        t.setToolbars(r, l);
      },
      refreshToolbar: function(t, r) {
        return t.refreshToolbar(r);
      },
      toggleToolbarDrawer: function(t, r) {
        t.toggleToolbarDrawer(r);
      },
      isToolbarDrawerToggled: function(t, r) {
        return t.isToolbarDrawerToggled(r);
      },
      getThrobber: function(t, r) {
        return t.getThrobber(r);
      },
      setMenubar: function(t, r, o) {
        t.setMenubar(r, o);
      },
      focusMenubar: function(t, r) {
        t.focusMenubar(r);
      },
      focusToolbar: function(t, r) {
        t.focusToolbar(r);
      }
    }
  }), VU = "file edit view insert format tools table help", mL = {
    file: {
      title: "File",
      items: "newdocument restoredraft | preview | export print | deleteallconversations"
    },
    edit: {
      title: "Edit",
      items: "undo redo | cut copy paste pastetext | selectall | searchreplace"
    },
    view: {
      title: "View",
      items: "code | visualaid visualchars visualblocks | spellchecker | preview fullscreen | showcomments"
    },
    insert: {
      title: "Insert",
      items: "image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime"
    },
    format: {
      title: "Format",
      items: "bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | language | removeformat"
    },
    tools: {
      title: "Tools",
      items: "spellchecker spellcheckerlanguage | a11ycheck code wordcount"
    },
    table: {
      title: "Table",
      items: "inserttable | cell row column | advtablesort | tableprops deletetable"
    },
    help: {
      title: "Help",
      items: "help"
    }
  }, UU = function(t, r, o) {
    var l = cO(o).split(/[ ,]/);
    return {
      text: t.title,
      getItems: function() {
        return St(t.items, function(v) {
          var g = v.toLowerCase();
          return g.trim().length === 0 ? [] : Jt(l, function(b) {
            return b === g;
          }) ? [] : g === "separator" || g === "|" ? [{ type: "separator" }] : r.menuItems[g] ? [r.menuItems[g]] : [];
        });
      }
    };
  }, y$ = function(t) {
    return typeof t == "string" ? t.split(" ") : t;
  }, gL = function(t, r) {
    var o = $($({}, mL), r.menus), l = on(r.menus).length > 0, v = r.menubar === void 0 || r.menubar === !0 ? y$(VU) : y$(r.menubar === !1 ? "" : r.menubar), g = We(v, function(T) {
      var A = yn(mL, T);
      return l ? A || Ft(r.menus, T).exists(function(R) {
        return yn(R, "items");
      }) : A;
    }), b = _t(g, function(T) {
      var A = o[T];
      return UU({
        title: A.title,
        items: y$(A.items)
      }, r, t);
    });
    return We(b, function(T) {
      var A = function(R) {
        return R.type !== "separator";
      };
      return T.getItems().length > 0 && Jt(T.getItems(), A);
    });
  }, pL = function(t) {
    var r = function() {
      t._skinLoaded = !0, QM(t);
    };
    return function() {
      t.initialized ? r() : t.on("init", r);
    };
  }, jU = function(t, r) {
    return function() {
      return VO(t, { message: r });
    };
  }, hL = function(t, r, o) {
    return new Ew(function(l, v) {
      o.load(r, l, v), t.on("remove", function() {
        return o.unload(r);
      });
    });
  }, WU = function(t, r) {
    var o = r + "/skin.min.css";
    return hL(t, o, t.ui.styleSheetLoader);
  }, qU = function(t, r) {
    var o = nr(Bn.fromDom(t.getElement()));
    if (o) {
      var l = r + "/skin.shadowdom.min.css";
      return hL(t, l, Db.DOM.styleSheetLoader);
    } else
      return Ew.resolve();
  }, bL = function(t, r) {
    var o = pM(r);
    o && r.contentCSS.push(o + (t ? "/content.inline" : "/content") + ".min.css"), bM(r) === !1 && P(o) ? Ew.all([
      WU(r, o),
      qU(r, o)
    ]).then(pL(r), jU(r, "Skin could not be loaded")) : pL(r)();
  }, GU = Pt(bL, !1), KU = Pt(bL, !0), wB = function(t, r) {
    return function(o) {
      var l = kg(), v = function() {
        o.setActive(t.formatter.match(r));
        var g = t.formatter.formatChanged(r, o.setActive);
        l.set(g);
      };
      return t.initialized ? v() : t.once("init", v), function() {
        t.off("init", v), l.clear();
      };
    };
  }, CB = function(t, r, o) {
    return function(l) {
      var v = function() {
        return o(l);
      }, g = function() {
        o(l), t.on(r, v);
      };
      return t.initialized ? g() : t.once("init", g), function() {
        t.off("init", g), t.off(r, v);
      };
    };
  }, yL = function(t) {
    return function(r) {
      return function() {
        t.undoManager.transact(function() {
          t.focus(), t.execCommand("mceToggleFormat", !1, r.format);
        });
      };
    };
  }, Ov = function(t, r) {
    return function() {
      return t.execCommand(r);
    };
  }, XU = function(t, r, o) {
    var l = function(T, A, R, z) {
      var U = r.shared.providers.translate(T.title);
      if (T.type === "separator")
        return _.some({
          type: "separator",
          text: U
        });
      if (T.type === "submenu") {
        var oe = St(T.getStyleItems(), function(de) {
          return v(de, A, z);
        });
        return A === 0 && oe.length <= 0 ? _.none() : _.some({
          type: "nestedmenuitem",
          text: U,
          disabled: oe.length <= 0,
          getSubmenuItems: function() {
            return St(T.getStyleItems(), function(de) {
              return v(de, A, z);
            });
          }
        });
      } else
        return _.some($({
          type: "togglemenuitem",
          text: U,
          icon: T.icon,
          active: T.isSelected(z),
          disabled: R,
          onAction: o.onAction(T)
        }, T.getStylePreview().fold(function() {
          return {};
        }, function(de) {
          return { meta: { style: de } };
        })));
    }, v = function(T, A, R) {
      var z = T.type === "formatter" && o.isInvalid(T);
      return A === 0 ? z ? [] : l(T, A, !1, R).toArray() : l(T, A, z, R).toArray();
    }, g = function(T) {
      var A = o.getCurrentValue(), R = o.shouldHide ? 0 : 1;
      return St(T, function(z) {
        return v(z, R, A);
      });
    }, b = function(T, A) {
      return function(R, z) {
        var U = A(), oe = g(U), de = Hb(oe, Xu.CLOSE_ON_EXECUTE, T, !1);
        z(de);
      };
    };
    return {
      validateItems: g,
      getFetch: b
    };
  }, q3 = function(t, r, o) {
    var l = o.dataset, v = l.type === "basic" ? function() {
      return _t(l.data, function(g) {
        return IA(g, o.isSelectedFor, o.getPreviewFor);
      });
    } : l.getData;
    return {
      items: XU(t, r, o),
      getStyleItems: v
    };
  }, n5 = function(t, r, o) {
    var l = q3(t, r, o), v = l.items, g = l.getStyleItems, b = function(A) {
      return { getComponent: ie(A) };
    }, T = CB(t, "NodeChange", function(A) {
      var R = A.getComponent();
      o.updateText(R);
    });
    return p3({
      text: o.icon.isSome() ? _.none() : o.text,
      icon: o.icon,
      tooltip: _.from(o.tooltip),
      role: _.none(),
      fetch: v.getFetch(r, g),
      onSetup: T,
      getApi: b,
      columns: 1,
      presets: "normal",
      classes: o.icon.isSome() ? [] : ["bespoke"],
      dropdownBehaviours: []
    }, "tox-tbtn", r.shared);
  }, YU = function(t) {
    return _t(t, function(r) {
      var o = r, l = r, v = r.split("=");
      return v.length > 1 && (o = v[0], l = v[1]), {
        title: o,
        format: l
      };
    });
  }, ZU = function(t) {
    return {
      type: "basic",
      data: t
    };
  }, G3;
  (function(t) {
    t[t.SemiColon = 0] = "SemiColon", t[t.Space = 1] = "Space";
  })(G3 || (G3 = {}));
  var JU = function(t, r) {
    return r === G3.SemiColon ? t.replace(/;$/, "").split(";") : t.split(" ");
  }, w$ = function(t, r, o, l) {
    var v = t.getParam(r, o, "string"), g = YU(JU(v, l));
    return {
      type: "basic",
      data: g
    };
  }, C$ = [
    {
      title: "Left",
      icon: "align-left",
      format: "alignleft",
      command: "JustifyLeft"
    },
    {
      title: "Center",
      icon: "align-center",
      format: "aligncenter",
      command: "JustifyCenter"
    },
    {
      title: "Right",
      icon: "align-right",
      format: "alignright",
      command: "JustifyRight"
    },
    {
      title: "Justify",
      icon: "align-justify",
      format: "alignjustify",
      command: "JustifyFull"
    }
  ], wL = function(t) {
    var r = function() {
      return pt(C$, function(T) {
        return t.formatter.match(T.format);
      });
    }, o = function(T) {
      return function() {
        return t.formatter.match(T);
      };
    }, l = function(T) {
      return _.none;
    }, v = function(T) {
      var A = r(), R = A.fold(ie("left"), function(z) {
        return z.title.toLowerCase();
      });
      xr(T, J8, { icon: "align-" + R });
    }, g = ZU(C$), b = function(T) {
      return function() {
        return pt(C$, function(A) {
          return A.format === T.format;
        }).each(function(A) {
          return t.execCommand(A.command);
        });
      };
    };
    return {
      tooltip: "Align",
      text: _.none(),
      icon: _.some("align-left"),
      isSelectedFor: o,
      getCurrentValue: _.none,
      getPreviewFor: l,
      onAction: b,
      updateText: v,
      dataset: g,
      shouldHide: !1,
      isInvalid: function(T) {
        return !t.formatter.canApply(T.format);
      }
    };
  }, QU = function(t, r) {
    return n5(t, r, wL(t));
  }, ej = function(t, r) {
    var o = q3(t, r, wL(t));
    t.ui.registry.addNestedMenuItem("align", {
      text: r.shared.providers.translate("Align"),
      getSubmenuItems: function() {
        return o.items.validateItems(o.getStyleItems());
      }
    });
  }, tj = "Andale Mono=andale mono,monospace;Arial=arial,helvetica,sans-serif;Arial Black=arial black,sans-serif;Book Antiqua=book antiqua,palatino,serif;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier,monospace;Georgia=georgia,palatino,serif;Helvetica=helvetica,arial,sans-serif;Impact=impact,sans-serif;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco,monospace;Times New Roman=times new roman,times,serif;Trebuchet MS=trebuchet ms,geneva,sans-serif;Verdana=verdana,geneva,sans-serif;Webdings=webdings;Wingdings=wingdings,zapf dingbats", nj = [
    "-apple-system",
    "Segoe UI",
    "Roboto",
    "Helvetica Neue",
    "sans-serif"
  ], CL = function(t) {
    var r = t.split(/\s*,\s*/);
    return _t(r, function(o) {
      return o.replace(/^['"]+|['"]+$/g, "");
    });
  }, rj = function(t) {
    var r = function() {
      var o = CL(t.toLowerCase());
      return Xe(nj, function(l) {
        return o.indexOf(l.toLowerCase()) > -1;
      });
    };
    return t.indexOf("-apple-system") === 0 && r();
  }, SL = function(t) {
    var r = "System Font", o = function() {
      var R = function(Se) {
        return Se ? CL(Se)[0] : "";
      }, z = t.queryCommandValue("FontName"), U = A.data, oe = z ? z.toLowerCase() : "", de = pt(U, function(Se) {
        var $e = Se.format;
        return $e.toLowerCase() === oe || R($e).toLowerCase() === R(oe).toLowerCase();
      }).orThunk(function() {
        return so(rj(oe), {
          title: r,
          format: oe
        });
      });
      return {
        matchOpt: de,
        font: z
      };
    }, l = function(R) {
      return function(z) {
        return z.exists(function(U) {
          return U.format === R;
        });
      };
    }, v = function() {
      var R = o().matchOpt;
      return R;
    }, g = function(R) {
      return function() {
        return _.some({
          tag: "div",
          styles: R.indexOf("dings") === -1 ? { "font-family": R } : {}
        });
      };
    }, b = function(R) {
      return function() {
        t.undoManager.transact(function() {
          t.focus(), t.execCommand("FontName", !1, R.format);
        });
      };
    }, T = function(R) {
      var z = o(), U = z.matchOpt, oe = z.font, de = U.fold(ie(oe), function(Se) {
        return Se.title;
      });
      xr(R, i1, { text: de });
    }, A = w$(t, "font_formats", tj, G3.SemiColon);
    return {
      tooltip: "Fonts",
      text: _.some(r),
      icon: _.none(),
      isSelectedFor: l,
      getCurrentValue: v,
      getPreviewFor: g,
      onAction: b,
      updateText: T,
      dataset: A,
      shouldHide: !1,
      isInvalid: ge
    };
  }, aj = function(t, r) {
    return n5(t, r, SL(t));
  }, oj = function(t, r) {
    var o = q3(t, r, SL(t));
    t.ui.registry.addNestedMenuItem("fontformats", {
      text: r.shared.providers.translate("Fonts"),
      getSubmenuItems: function() {
        return o.items.validateItems(o.getStyleItems());
      }
    });
  }, ij = "8pt 10pt 12pt 14pt 18pt 24pt 36pt", uj = {
    "8pt": "1",
    "10pt": "2",
    "12pt": "3",
    "14pt": "4",
    "18pt": "5",
    "24pt": "6",
    "36pt": "7"
  }, sj = {
    "xx-small": "7pt",
    "x-small": "8pt",
    small: "10pt",
    medium: "12pt",
    large: "14pt",
    "x-large": "18pt",
    "xx-large": "24pt"
  }, lj = function(t, r) {
    var o = Math.pow(10, r);
    return Math.round(t * o) / o;
  }, cj = function(t, r) {
    return /[0-9.]+px$/.test(t) ? lj(parseInt(t, 10) * 72 / 96, r || 0) + "pt" : Ft(sj, t).getOr(t);
  }, fj = function(t) {
    return Ft(uj, t).getOr("");
  }, xL = function(t) {
    var r = function() {
      var A = _.none(), R = T.data, z = t.queryCommandValue("FontSize");
      if (z)
        for (var U = function(de) {
          var Se = cj(z, de), $e = fj(Se);
          A = pt(R, function(ut) {
            return ut.format === z || ut.format === Se || ut.format === $e;
          });
        }, oe = 3; A.isNone() && oe >= 0; oe--)
          U(oe);
      return {
        matchOpt: A,
        size: z
      };
    }, o = function(A) {
      return function(R) {
        return R.exists(function(z) {
          return z.format === A;
        });
      };
    }, l = function() {
      var A = r().matchOpt;
      return A;
    }, v = ie(_.none), g = function(A) {
      return function() {
        t.undoManager.transact(function() {
          t.focus(), t.execCommand("FontSize", !1, A.format);
        });
      };
    }, b = function(A) {
      var R = r(), z = R.matchOpt, U = R.size, oe = z.fold(ie(U), function(de) {
        return de.title;
      });
      xr(A, i1, { text: oe });
    }, T = w$(t, "fontsize_formats", ij, G3.Space);
    return {
      tooltip: "Font sizes",
      text: _.some("12pt"),
      icon: _.none(),
      isSelectedFor: o,
      getPreviewFor: v,
      getCurrentValue: l,
      onAction: g,
      updateText: b,
      dataset: T,
      shouldHide: !1,
      isInvalid: ge
    };
  }, vj = function(t, r) {
    return n5(t, r, xL(t));
  }, dj = function(t, r) {
    var o = q3(t, r, xL(t));
    t.ui.registry.addNestedMenuItem("fontsizes", {
      text: "Font sizes",
      getSubmenuItems: function() {
        return o.items.validateItems(o.getStyleItems());
      }
    });
  }, kL = function(t, r) {
    var o = r(), l = _t(o, function(v) {
      return v.format;
    });
    return _.from(t.formatter.closest(l)).bind(function(v) {
      return pt(o, function(g) {
        return g.format === v;
      });
    }).orThunk(function() {
      return so(t.formatter.match("p"), {
        title: "Paragraph",
        format: "p"
      });
    });
  }, mj = "Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5;Heading 6=h6;Preformatted=pre", TL = function(t) {
    var r = "Paragraph", o = function(b) {
      return function() {
        return t.formatter.match(b);
      };
    }, l = function(b) {
      return function() {
        var T = t.formatter.get(b);
        return _.some({
          tag: T.length > 0 && (T[0].inline || T[0].block) || "div",
          styles: t.dom.parseStyle(t.formatter.getCssText(b))
        });
      };
    }, v = function(b) {
      var T = kL(t, function() {
        return g.data;
      }), A = T.fold(ie(r), function(R) {
        return R.title;
      });
      xr(b, i1, { text: A });
    }, g = w$(t, "block_formats", mj, G3.SemiColon);
    return {
      tooltip: "Blocks",
      text: _.some(r),
      icon: _.none(),
      isSelectedFor: o,
      getCurrentValue: _.none,
      getPreviewFor: l,
      onAction: yL(t),
      updateText: v,
      dataset: g,
      shouldHide: !1,
      isInvalid: function(b) {
        return !t.formatter.canApply(b.format);
      }
    };
  }, gj = function(t, r) {
    return n5(t, r, TL(t));
  }, pj = function(t, r) {
    var o = q3(t, r, TL(t));
    t.ui.registry.addNestedMenuItem("blockformats", {
      text: "Blocks",
      getSubmenuItems: function() {
        return o.items.validateItems(o.getStyleItems());
      }
    });
  }, EL = function(t, r) {
    var o = "Paragraph", l = function(b) {
      return function() {
        return t.formatter.match(b);
      };
    }, v = function(b) {
      return function() {
        var T = t.formatter.get(b);
        return T !== void 0 ? _.some({
          tag: T.length > 0 && (T[0].inline || T[0].block) || "div",
          styles: t.dom.parseStyle(t.formatter.getCssText(b))
        }) : _.none();
      };
    }, g = function(b) {
      var T = function(U) {
        var oe = U.items;
        return oe !== void 0 && oe.length > 0 ? St(oe, T) : [{
          title: U.title,
          format: U.format
        }];
      }, A = St(NA(t), T), R = kL(t, ie(A)), z = R.fold(ie(o), function(U) {
        return U.title;
      });
      xr(b, i1, { text: z });
    };
    return {
      tooltip: "Formats",
      text: _.some(o),
      icon: _.none(),
      isSelectedFor: l,
      getCurrentValue: _.none,
      getPreviewFor: v,
      onAction: yL(t),
      updateText: g,
      shouldHide: t.getParam("style_formats_autohide", !1, "boolean"),
      isInvalid: function(b) {
        return !t.formatter.canApply(b.format);
      },
      dataset: r
    };
  }, hj = function(t, r) {
    var o = $({ type: "advanced" }, r.styleselect);
    return n5(t, r, EL(t, o));
  }, bj = function(t, r) {
    var o = $({ type: "advanced" }, r.styleselect), l = q3(t, r, EL(t, o));
    t.ui.registry.addNestedMenuItem("formats", {
      text: "Formats",
      getSubmenuItems: function() {
        return l.items.validateItems(l.getStyleItems());
      }
    });
  }, yj = function(t, r) {
    var o = function(l, v) {
      t.updateState.each(function(g) {
        var b = g(l, v);
        r.set(b);
      }), t.renderComponents.each(function(g) {
        var b = g(v, r.get()), T = _t(b, l.getSystem().build);
        w2(l, T);
      });
    };
    return ro([
      cn(Dl(), function(l, v) {
        var g = v;
        if (!g.universal) {
          var b = t.channel;
          Tt(g.channels, b) && o(l, g.data);
        }
      }),
      Zr(function(l, v) {
        t.initialData.each(function(g) {
          o(l, g);
        });
      })
    ]);
  }, wj = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    events: yj
  }), Cj = function(t, r, o) {
    return o;
  }, Sj = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    getState: Cj
  }), xj = [
    un("channel"),
    Ba("renderComponents"),
    Ba("updateState"),
    Ba("initialData")
  ], kj = function() {
    var t = Sr(_.none()), r = function() {
      return t.set(_.none());
    }, o = function() {
      return t.get().getOr("none");
    };
    return {
      readState: o,
      get: t.get,
      set: t.set,
      clear: r
    };
  }, Tj = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    init: kj
  }), qc = Pi({
    fields: xj,
    name: "reflecting",
    active: wj,
    apis: Sj,
    state: Tj
  }), Ej = ie([
    un("toggleClass"),
    un("fetch"),
    ls("onExecute"),
    ct("getHotspot", _.some),
    ct("getAnchorOverrides", ie({})),
    rd(),
    ls("onItemExecute"),
    Ba("lazySink"),
    un("dom"),
    Ra("onOpen"),
    Ni("splitDropdownBehaviours", [
      fi,
      Er,
      zr
    ]),
    ct("matchWidth", !1),
    ct("useMinWidth", !1),
    ct("eventOrder", {}),
    Ba("role")
  ].concat(N_())), _j = hu({
    factory: Js,
    schema: [un("dom")],
    name: "arrow",
    defaults: function() {
      return { buttonBehaviours: Fn([zr.revoke()]) };
    },
    overrides: function(t) {
      return {
        dom: {
          tag: "span",
          attributes: { role: "presentation" }
        },
        action: function(r) {
          r.getSystem().getByUid(t.uid).each(ml);
        },
        buttonBehaviours: Fn([wa.config({
          toggleOnExecute: !1,
          toggleClass: t.toggleClass
        })])
      };
    }
  }), Aj = hu({
    factory: Js,
    schema: [un("dom")],
    name: "button",
    defaults: function() {
      return { buttonBehaviours: Fn([zr.revoke()]) };
    },
    overrides: function(t) {
      return {
        dom: {
          tag: "span",
          attributes: { role: "presentation" }
        },
        action: function(r) {
          r.getSystem().getByUid(t.uid).each(function(o) {
            t.onExecute(o, r);
          });
        }
      };
    }
  }), Oj = ie([
    _j,
    Aj,
    Nl({
      factory: {
        sketch: function(t) {
          return {
            uid: t.uid,
            dom: {
              tag: "span",
              styles: { display: "none" },
              attributes: { "aria-hidden": "true" },
              innerHtml: t.text
            }
          };
        }
      },
      schema: [un("text")],
      name: "aria-descriptor"
    }),
    wl({
      schema: [Zd()],
      name: "menu",
      defaults: function(t) {
        return {
          onExecute: function(r, o) {
            r.getSystem().getByUid(t.uid).each(function(l) {
              t.onItemExecute(l, r, o);
            });
          }
        };
      }
    }),
    B6()
  ]), Dj = function(t, r, o, l) {
    var v, g = function(U) {
      la.getCurrent(U).each(function(oe) {
        Na.highlightFirst(oe), Er.focusIn(oe);
      });
    }, b = function(U) {
      var oe = g;
      Nb(t, Ze, U, l, oe, Df.HighlightFirst).get(ee);
    }, T = function(U) {
      return b(U), _.some(!0);
    }, A = function(U) {
      var oe = xf(U, t, "button");
      return ml(oe), _.some(!0);
    }, R = $($({}, ro([Zr(function(U, oe) {
      var de = Ya(U, t, "aria-descriptor");
      de.each(function(Se) {
        var $e = ur("aria");
        Qr(Se.element, "id", $e), Qr(U.element, "aria-describedby", $e);
      });
    })])), Cb(_.some(b))), z = {
      repositionMenus: function(U) {
        wa.isOn(U) && wp(U);
      }
    };
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      apis: z,
      eventOrder: $($({}, t.eventOrder), (v = {}, v[vl()] = [
        "disabling",
        "toggling",
        "alloy.base.behaviour"
      ], v)),
      events: R,
      behaviours: Zi(t.splitDropdownBehaviours, [
        fi.config({
          others: {
            sandbox: function(U) {
              var oe = xf(U, t, "arrow"), de = {
                onOpen: function() {
                  wa.on(oe), wa.on(U);
                },
                onClose: function() {
                  wa.off(oe), wa.off(U);
                }
              };
              return P_(t, U, de);
            }
          }
        }),
        Er.config({
          mode: "special",
          onSpace: A,
          onEnter: A,
          onDown: T
        }),
        zr.config({}),
        wa.config({
          toggleOnExecute: !1,
          aria: { mode: "expanded" }
        })
      ]),
      domModification: {
        attributes: {
          role: t.role.getOr("button"),
          "aria-haspopup": !0
        }
      }
    };
  }, SB = ds({
    name: "SplitDropdown",
    configFields: Ej(),
    partFields: Oj(),
    factory: Dj,
    apis: {
      repositionMenus: function(t, r) {
        return t.repositionMenus(r);
      }
    }
  }), Bj = function(t) {
    return {
      isDisabled: function() {
        return Cr.isDisabled(t);
      },
      setDisabled: function(r) {
        return Cr.set(t, r);
      }
    };
  }, Rj = function(t) {
    return {
      setActive: function(r) {
        wa.set(t, r);
      },
      isActive: function() {
        return wa.isOn(t);
      },
      isDisabled: function() {
        return Cr.isDisabled(t);
      },
      setDisabled: function(r) {
        return Cr.set(t, r);
      }
    };
  }, _L = function(t, r) {
    return t.map(function(o) {
      return {
        "aria-label": r.translate(o),
        title: r.translate(o)
      };
    }).getOr({});
  }, AL = ur("focus-button"), S$ = function(t, r, o, l, v, g) {
    var b;
    return {
      dom: {
        tag: "button",
        classes: ["tox-tbtn"].concat(r.isSome() ? ["tox-tbtn--select"] : []),
        attributes: _L(o, g)
      },
      components: km([
        t.map(function(T) {
          return g3(T, g.icons);
        }),
        r.map(function(T) {
          return hA(T, "tox-tbtn", g);
        })
      ]),
      eventOrder: (b = {}, b[Ql()] = [
        "focusing",
        "alloy.base.behaviour",
        "common-button-display-events"
      ], b),
      buttonBehaviours: Fn([
        Of.toolbarButton(g.isDisabled),
        Ui(),
        Jr("common-button-display-events", [cn(Ql(), function(T, A) {
          A.event.prevent(), Ta(T, AL);
        })])
      ].concat(l.map(function(T) {
        return qc.config({
          channel: T,
          initialData: {
            icon: t,
            text: r
          },
          renderComponents: function(A, R) {
            return km([
              A.icon.map(function(z) {
                return g3(z, g.icons);
              }),
              A.text.map(function(z) {
                return hA(z, "tox-tbtn", g);
              })
            ]);
          }
        });
      }).toArray()).concat(v.getOr([])))
    };
  }, Mj = function(t, r, o, l) {
    var v = r.shared;
    return nl.sketch({
      lazySink: v.getSink,
      fetch: function() {
        return Fu.nu(function(g) {
          g(_t(o(t.items), it));
        });
      },
      markers: { toggledClass: "tox-tbtn--enabled" },
      parts: {
        button: S$(t.icon, t.text, t.tooltip, _.none(), _.none(), v.providers),
        toolbar: {
          dom: {
            tag: "div",
            classes: ["tox-toolbar__overflow"],
            attributes: l
          }
        }
      }
    });
  }, OL = function(t, r, o) {
    var l = Sr(ee), v = S$(t.icon, t.text, t.tooltip, _.none(), _.none(), o);
    return Js.sketch({
      dom: v.dom,
      components: v.components,
      eventOrder: Z8,
      buttonBehaviours: Fn([
        Jr("toolbar-button-events", [
          Y8({
            onAction: t.onAction,
            getApi: r.getApi
          }),
          qh(r, l),
          Gh(r, l)
        ]),
        Of.toolbarButton(function() {
          return t.disabled || o.isDisabled();
        }),
        Ui()
      ].concat(r.toolbarButtonBehaviours))
    });
  }, Pj = function(t, r) {
    return DL(t, r, []);
  }, DL = function(t, r, o) {
    return OL(t, {
      toolbarButtonBehaviours: [].concat(o.length > 0 ? [Jr("toolbarButtonWith", o)] : []),
      getApi: Bj,
      onSetup: t.onSetup
    }, r);
  }, Nj = function(t, r) {
    return BL(t, r, []);
  }, BL = function(t, r, o) {
    return Gt(OL(t, {
      toolbarButtonBehaviours: [
        qr.config({}),
        wa.config({
          toggleClass: "tox-tbtn--enabled",
          aria: { mode: "pressed" },
          toggleOnExecute: !1
        })
      ].concat(o.length > 0 ? [Jr("toolbarToggleButtonWith", o)] : []),
      getApi: Rj,
      onSetup: t.onSetup
    }, r));
  }, Ij = function(t, r, o) {
    return function(l) {
      return Fu.nu(function(v) {
        return r.fetch(v);
      }).map(function(v) {
        return _.from(f6(Gt(S_(ur("menu-value"), v, function(g) {
          r.onItemAction(t(l), g);
        }, r.columns, r.presets, Xu.CLOSE_ON_EXECUTE, r.select.getOr(ge), o), {
          movement: $4(r.columns, r.presets),
          menuBehaviours: k4.unnamedEvents(r.columns !== "auto" ? [] : [Zr(function(g, b) {
            t_(g, 4, j5(r.presets)).each(function(T) {
              var A = T.numRows, R = T.numColumns;
              Er.setGridSize(g, A, R);
            });
          })])
        })));
      });
    };
  }, Fj = function(t, r) {
    var o, l = ur("channel-update-split-dropdown-display"), v = function(T) {
      return {
        isDisabled: function() {
          return Cr.isDisabled(T);
        },
        setDisabled: function(A) {
          return Cr.set(T, A);
        },
        setIconFill: function(A, R) {
          Bi(T.element, 'svg path[id="' + A + '"], rect[id="' + A + '"]').each(function(z) {
            Qr(z, "fill", R);
          });
        },
        setIconStroke: function(A, R) {
          Bi(T.element, 'svg path[id="' + A + '"], rect[id="' + A + '"]').each(function(z) {
            Qr(z, "stroke", R);
          });
        },
        setActive: function(A) {
          Qr(T.element, "aria-pressed", A), Bi(T.element, "span").each(function(R) {
            T.getSystem().getByDom(R).each(function(z) {
              return wa.set(z, A);
            });
          });
        },
        isActive: function() {
          return Bi(T.element, "span").exists(function(A) {
            return T.getSystem().getByDom(A).exists(wa.isOn);
          });
        }
      };
    }, g = Sr(ee), b = {
      getApi: v,
      onSetup: t.onSetup
    };
    return SB.sketch({
      dom: {
        tag: "div",
        classes: ["tox-split-button"],
        attributes: $({ "aria-pressed": !1 }, _L(t.tooltip, r.providers))
      },
      onExecute: function(T) {
        t.onAction(v(T));
      },
      onItemExecute: function(T, A, R) {
      },
      splitDropdownBehaviours: Fn([
        Of.splitButton(r.providers.isDisabled),
        Ui(),
        Jr("split-dropdown-events", [
          cn(AL, zr.focus),
          qh(b, g),
          Gh(b, g)
        ]),
        Kw.config({})
      ]),
      eventOrder: (o = {}, o[Gs()] = [
        "alloy.base.behaviour",
        "split-dropdown-events"
      ], o),
      toggleClass: "tox-tbtn--enabled",
      lazySink: r.getSink,
      fetch: Ij(v, t, r.providers),
      parts: { menu: jh(!1, t.columns, t.presets) },
      components: [
        SB.parts.button(S$(t.icon, t.text, _.none(), _.some(l), _.some([wa.config({
          toggleClass: "tox-tbtn--enabled",
          toggleOnExecute: !1
        })]), r.providers)),
        SB.parts.arrow({
          dom: {
            tag: "button",
            classes: [
              "tox-tbtn",
              "tox-split-button__chevron"
            ],
            innerHtml: _5("chevron-down", r.providers.icons)
          },
          buttonBehaviours: Fn([
            Of.splitButton(r.providers.isDisabled),
            Ui(),
            OE()
          ])
        }),
        SB.parts["aria-descriptor"]({ text: r.providers.translate("To open the popup, press Shift+Enter") })
      ]
    });
  }, $j = [
    {
      name: "history",
      items: [
        "undo",
        "redo"
      ]
    },
    {
      name: "styles",
      items: ["styleselect"]
    },
    {
      name: "formatting",
      items: [
        "bold",
        "italic"
      ]
    },
    {
      name: "alignment",
      items: [
        "alignleft",
        "aligncenter",
        "alignright",
        "alignjustify"
      ]
    },
    {
      name: "indentation",
      items: [
        "outdent",
        "indent"
      ]
    },
    {
      name: "permanent pen",
      items: ["permanentpen"]
    },
    {
      name: "comments",
      items: ["addcomment"]
    }
  ], r5 = function(t, r) {
    return function(o, l, v) {
      var g = t(o).mapError(function(b) {
        return Fv(b);
      }).getOrDie();
      return r(g, l, v);
    };
  }, K3 = {
    button: r5(N5, function(t, r) {
      return Pj(t, r.backstage.shared.providers);
    }),
    togglebutton: r5(y4, function(t, r) {
      return Nj(t, r.backstage.shared.providers);
    }),
    menubutton: r5(m1, function(t, r) {
      return wA(t, "tox-tbtn", r.backstage, _.none());
    }),
    splitbutton: r5(u$, function(t, r) {
      return Fj(t, r.backstage.shared);
    }),
    grouptoolbarbutton: r5(r$, function(t, r, o) {
      var l, v = o.ui.registry.getAll().buttons, g = function(T) {
        return xB(o, {
          buttons: v,
          toolbar: T,
          allowToolbarGroups: !1
        }, r, _.none());
      }, b = (l = {}, l[w0] = r.backstage.shared.header.isPositionedAtTop() ? gf.TopToBottom : gf.BottomToTop, l);
      switch (Pw(o)) {
        case lc.floating:
          return Mj(t, r.backstage, g, b);
        default:
          throw new Error("Toolbar groups are only supported when using floating toolbar mode");
      }
    }),
    styleSelectButton: function(t, r) {
      return hj(t, r.backstage);
    },
    fontsizeSelectButton: function(t, r) {
      return vj(t, r.backstage);
    },
    fontSelectButton: function(t, r) {
      return aj(t, r.backstage);
    },
    formatButton: function(t, r) {
      return gj(t, r.backstage);
    },
    alignMenuButton: function(t, r) {
      return QU(t, r.backstage);
    }
  }, Lj = function(t, r, o) {
    return Ft(K3, t.type).fold(function() {
      return console.error("skipping button defined by", t), _.none();
    }, function(l) {
      return _.some(l(t, r, o));
    });
  }, RL = {
    styleselect: K3.styleSelectButton,
    fontsizeselect: K3.fontsizeSelectButton,
    fontselect: K3.fontSelectButton,
    formatselect: K3.formatButton,
    align: K3.alignMenuButton
  }, zj = function(t) {
    var r = _t($j, function(o) {
      var l = We(o.items, function(v) {
        return yn(t, v) || yn(RL, v);
      });
      return {
        name: o.name,
        items: l
      };
    });
    return We(r, function(o) {
      return o.items.length > 0;
    });
  }, Hj = function(t) {
    var r = t.split("|");
    return _t(r, function(o) {
      return { items: o.trim().split(" ") };
    });
  }, Vj = function(t) {
    return ue(t, function(r) {
      return yn(r, "name") && yn(r, "items");
    });
  }, Uj = function(t) {
    var r = t.toolbar, o = t.buttons;
    return r === !1 ? [] : r === void 0 || r === !0 ? zj(o) : P(r) ? Hj(r) : Vj(r) ? r : (console.error("Toolbar type should be string, string[], boolean or ToolbarGroup[]"), []);
  }, jj = function(t, r, o, l, v, g) {
    return Ft(r, o.toLowerCase()).orThunk(function() {
      return g.bind(function(b) {
        return Xt(b, function(T) {
          return Ft(r, T + o.toLowerCase());
        });
      });
    }).fold(function() {
      return Ft(RL, o.toLowerCase()).map(function(b) {
        return b(t, v);
      }).orThunk(function() {
        return _.none();
      });
    }, function(b) {
      return b.type === "grouptoolbarbutton" && !l ? (console.warn("Ignoring the '" + o + "' toolbar button. Group toolbar buttons are only supported when using floating toolbar mode and cannot be nested."), _.none()) : Lj(b, v, t);
    });
  }, xB = function(t, r, o, l) {
    var v = Uj(r), g = _t(v, function(b) {
      var T = St(b.items, function(A) {
        return A.trim().length === 0 ? [] : jj(t, r.buttons, A, r.allowToolbarGroups, o, l).toArray();
      });
      return {
        title: _.from(t.translate(b.name)),
        items: T
      };
    });
    return We(g, function(b) {
      return b.items.length > 0;
    });
  }, ML = function(t, r, o, l) {
    var v = r.outerContainer, g = o.toolbar, b = o.buttons;
    if (ue(g, P)) {
      var T = g.map(function(A) {
        var R = {
          toolbar: A,
          buttons: b,
          allowToolbarGroups: o.allowToolbarGroups
        };
        return xB(t, R, { backstage: l }, _.none());
      });
      Ci.setToolbars(v, T);
    } else
      Ci.setToolbar(v, xB(t, o, { backstage: l }, _.none()));
  }, PL = br(), Wj = PL.os.isiOS() && PL.os.version.major <= 12, qj = function(t, r) {
    var o = t.dom, l = t.getWin(), v = t.getDoc().documentElement, g = Sr(eo(l.innerWidth, l.innerHeight)), b = Sr(eo(v.offsetWidth, v.offsetHeight)), T = function() {
      var oe = g.get();
      (oe.left !== l.innerWidth || oe.top !== l.innerHeight) && (g.set(eo(l.innerWidth, l.innerHeight)), d_(t));
    }, A = function() {
      var oe = t.getDoc().documentElement, de = b.get();
      (de.left !== oe.offsetWidth || de.top !== oe.offsetHeight) && (b.set(eo(oe.offsetWidth, oe.offsetHeight)), d_(t));
    }, R = function(oe) {
      return t7(t, oe);
    };
    o.bind(l, "resize", T), o.bind(l, "scroll", R);
    var z = p0(Bn.fromDom(t.getBody()), "load", A), U = r.uiMothership.element;
    t.on("hide", function() {
      Pr(U, "display", "none");
    }), t.on("show", function() {
      Da(U, "display");
    }), t.on("NodeChange", A), t.on("remove", function() {
      z.unbind(), o.unbind(l, "resize", T), o.unbind(l, "scroll", R), l = null;
    });
  }, Gj = function(t, r, o, l, v) {
    var g = Sr(0), b = r.outerContainer;
    GU(t);
    var T = Bn.fromDom(v.targetNode), A = Nn(wr(T));
    ac(T, r.mothership), vv(A, r.uiMothership), t.on("PostRender", function() {
      ML(t, r, o, l), g.set(t.getWin().innerWidth), Ci.setMenubar(b, gL(t, o)), Ci.setSidebar(b, o.sidebar), qj(t, r);
    });
    var R = Ci.getSocket(b).getOrDie("Could not find expected socket element");
    if (Wj) {
      Hs(R.element, {
        overflow: "scroll",
        "-webkit-overflow-scrolling": "touch"
      });
      var z = xR(function() {
        t.fire("ScrollContent");
      }, 20), U = ai(R.element, "scroll", z.throttle);
      t.on("remove", U.unbind);
    }
    SO(t, r), t.addCommand("ToggleSidebar", function($e, ut) {
      Ci.toggleSidebar(b, ut), t.fire("ToggleSidebar");
    }), t.addQueryValueHandler("ToggleSidebar", function() {
      return Ci.whichSidebar(b);
    });
    var oe = Pw(t), de = function() {
      Ci.refreshToolbar(r.outerContainer);
    };
    (oe === lc.sliding || oe === lc.floating) && t.on("ResizeWindow ResizeEditor ResizeContent", function() {
      var $e = t.getWin().innerWidth;
      $e !== g.get() && (de(), g.set($e));
    });
    var Se = {
      enable: function() {
        Bb(r, !1);
      },
      disable: function() {
        Bb(r, !0);
      },
      isDisabled: function() {
        return Cr.isDisabled(b);
      }
    };
    return {
      iframeContainer: R.element.dom,
      editorContainer: b.element.dom,
      api: Se
    };
  }, Kj = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    render: Gj
  }), x$ = function(t) {
    var r = /^[0-9\.]+(|px)$/i;
    return r.test("" + t) ? _.some(parseInt("" + t, 10)) : _.none();
  }, k$ = function(t) {
    return J(t) ? t + "px" : t;
  }, kB = function(t, r, o) {
    var l = r.filter(function(g) {
      return t < g;
    }), v = o.filter(function(g) {
      return t > g;
    });
    return l.or(v).getOr(t);
  }, Xj = function(t) {
    var r = E4(t), o = iO(t), l = uO(t);
    return x$(r).map(function(v) {
      return kB(v, o, l);
    });
  }, Yj = function(t) {
    var r = Xj(t);
    return r.getOr(E4(t));
  }, NL = function(t) {
    var r = _4(t), o = o_(t), l = A4(t);
    return x$(r).map(function(v) {
      return kB(v, o, l);
    });
  }, Zj = function(t) {
    var r = NL(t);
    return r.getOr(_4(t));
  }, Jj = function(t, r, o, l, v) {
    var g = o.uiMothership, b = o.outerContainer, T = Db.DOM, A = D4(t), R = B4(t), z = A4(t).or(NL(t)), U = l.shared.header, oe = U.isPositionedAtTop, de = Pw(t), Se = de === lc.sliding || de === lc.floating, $e = Sr(!1), ut = function() {
      return $e.get() && !t.removed;
    }, Ne = function(pn) {
      return Se ? pn.fold(ie(0), function(nn) {
        return nn.components().length > 1 ? hi(nn.components()[1].element) : 0;
      }) : 0;
    }, ft = function(pn) {
      switch (vO(t)) {
        case Wh.auto:
          var nn = Ci.getToolbar(b), Wn = Ne(nn), cr = hi(pn.element) - Wn, dn = si(r), ar = dn.y > cr;
          if (ar)
            return "top";
          var pr = Ut(r), ha = Math.max(pr.dom.scrollHeight, hi(pr)), Ka = dn.bottom < ha - cr;
          if (Ka)
            return "bottom";
          var qo = uu(), Dv = qo.bottom < dn.bottom - cr;
          return Dv ? "bottom" : "top";
        case Wh.bottom:
          return "bottom";
        case Wh.top:
        default:
          return "top";
      }
    }, Ht = function(pn) {
      var nn = v.get();
      vi.setModes(nn, [pn]), U.setDockingMode(pn);
      var Wn = oe() ? gf.TopToBottom : gf.BottomToTop;
      Qr(nn.element, w0, Wn);
    }, Kt = function() {
      var pn = z.getOrThunk(function() {
        var nn = x$(Ho($a(), "margin-left")).getOr(0);
        return Au($a()) - ts(r).left + nn;
      });
      Pr(v.get().element, "max-width", pn + "px");
    }, st = function() {
      var pn = Ci.getToolbar(b), nn = Ne(pn), Wn = si(r), cr = oe() ? Math.max(Wn.y - hi(v.get().element) + nn, 0) : Wn.bottom;
      Hs(b.element, {
        position: "absolute",
        top: Math.round(cr) + "px",
        left: Math.round(Wn.x) + "px"
      });
    }, Bt = function() {
      g.broadcastOn([Ug()], {});
    }, an = function(pn) {
      if (pn === void 0 && (pn = !1), !!ut()) {
        if (A || Kt(), Se && Ci.refreshToolbar(b), A || st(), R) {
          var nn = v.get();
          pn ? vi.reset(nn) : vi.refresh(nn);
        }
        Bt();
      }
    }, qn = function(pn) {
      if (pn === void 0 && (pn = !0), !(A || !R || !ut())) {
        var nn = U.getDockingMode(), Wn = ft(v.get());
        Wn !== nn && (Ht(Wn), pn && an(!0));
      }
    }, vn = function() {
      $e.set(!0), Pr(b.element, "display", "flex"), T.addClass(t.getBody(), "mce-edit-focus"), Da(g.element, "display"), qn(!1), an();
    }, Gn = function() {
      $e.set(!1), o.outerContainer && (Pr(b.element, "display", "none"), T.removeClass(t.getBody(), "mce-edit-focus")), Pr(g.element, "display", "none");
    };
    return {
      isVisible: ut,
      isPositionedAtTop: oe,
      show: vn,
      hide: Gn,
      update: an,
      updateMode: qn,
      repositionPopups: Bt
    };
  }, IL = function(t, r) {
    var o = si(t);
    return {
      pos: r ? o.y : o.bottom,
      bounds: o
    };
  }, Qj = function(t, r, o, l) {
    var v = Sr(IL(r, o.isPositionedAtTop())), g = function(T) {
      var A = IL(r, o.isPositionedAtTop()), R = A.pos, z = A.bounds, U = v.get(), oe = U.pos, de = U.bounds, Se = z.height !== de.height || z.width !== de.width;
      v.set({
        pos: R,
        bounds: z
      }), Se && d_(t, T), o.isVisible() && (oe !== R ? o.update(!0) : Se && (o.updateMode(), o.repositionPopups()));
    };
    l || (t.on("activate", o.show), t.on("deactivate", o.hide)), t.on("SkinLoaded ResizeWindow", function() {
      return o.update(!0);
    }), t.on("NodeChange keydown", function(T) {
      pp.requestAnimationFrame(function() {
        return g(T);
      });
    }), t.on("ScrollWindow", function() {
      return o.updateMode();
    });
    var b = kg();
    b.set(p0(Bn.fromDom(t.getBody()), "load", g)), t.on("remove", function() {
      b.clear();
    });
  }, eW = function(t, r, o, l, v) {
    var g = r.mothership, b = r.uiMothership, T = r.outerContainer, A = Sr(null), R = Bn.fromDom(v.targetNode), z = Jj(t, R, r, l, A), U = xM(t);
    KU(t);
    var oe = function() {
      if (A.get()) {
        z.show();
        return;
      }
      A.set(Ci.getHeader(T).getOrDie());
      var Se = pO(t);
      vv(Se, g), vv(Se, b), ML(t, r, o, l), Ci.setMenubar(T, gL(t, o)), z.show(), Qj(t, R, z, U), t.nodeChanged();
    };
    t.on("show", oe), t.on("hide", z.hide), U || (t.on("focus", oe), t.on("blur", z.hide)), t.on("init", function() {
      (t.hasFocus() || U) && oe();
    }), SO(t, r);
    var de = {
      show: function() {
        z.show();
      },
      hide: function() {
        z.hide();
      },
      enable: function() {
        Bb(r, !1);
      },
      disable: function() {
        Bb(r, !0);
      },
      isDisabled: function() {
        return Cr.isDisabled(T);
      }
    };
    return {
      editorContainer: T.element.dom,
      api: de
    };
  }, tW = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    render: eW
  }), nW = "contexttoolbar-show", FL = "contexttoolbar-hide", rW = function(t) {
    return {
      hide: function() {
        return Ta(t, Xp());
      },
      getValue: function() {
        return jn.getValue(t);
      }
    };
  }, $L = function(t, r) {
    return cn(X8, function(o, l) {
      var v = t.get(o), g = rW(v);
      r.onAction(g, l.event.buttonApi);
    });
  }, aW = function(t, r, o) {
    var l = r.original;
    l.primary;
    var v = N(l, ["primary"]), g = Yl(N5($($({}, v), {
      type: "button",
      onAction: ee
    })));
    return DL(g, o.backstage.shared.providers, [$L(t, r)]);
  }, oW = function(t, r, o) {
    var l = r.original;
    l.primary;
    var v = N(l, ["primary"]), g = Yl(y4($($({}, v), {
      type: "togglebutton",
      onAction: ee
    })));
    return BL(g, o.backstage.shared.providers, [$L(t, r)]);
  }, iW = function(t, r, o) {
    var l = { backstage: { shared: { providers: o } } };
    return r.type === "contextformtogglebutton" ? oW(t, r, l) : aW(t, r, l);
  }, uW = function(t, r, o) {
    var l = _t(r, function(b) {
      return La(iW(t, b, o));
    }), v = function() {
      return _t(l, function(b) {
        return b.asSpec();
      });
    }, g = function(b) {
      return Xt(r, function(T, A) {
        return T.primary ? _.from(l[A]).bind(function(R) {
          return R.getOpt(b);
        }).filter(Ct(Cr.isDisabled)) : _.none();
      });
    };
    return {
      asSpecs: v,
      findPrimary: g
    };
  }, LL = function(t, r) {
    var o = t.label.fold(function() {
      return {};
    }, function(g) {
      return { "aria-label": g };
    }), l = La(qw.sketch({
      inputClasses: [
        "tox-toolbar-textfield",
        "tox-toolbar-nav-js"
      ],
      data: t.initValue(),
      inputAttributes: o,
      selectOnFocus: !0,
      inputBehaviours: Fn([Er.config({
        mode: "special",
        onEnter: function(g) {
          return v.findPrimary(g).map(function(b) {
            return ml(b), !0;
          });
        },
        onLeft: function(g, b) {
          return b.cut(), _.none();
        },
        onRight: function(g, b) {
          return b.cut(), _.none();
        }
      })])
    })), v = uW(l, t.commands, r);
    return [
      {
        title: _.none(),
        items: [l.asSpec()]
      },
      {
        title: _.none(),
        items: v.asSpecs()
      }
    ];
  }, sW = function(t, r, o) {
    return _a({
      type: t,
      uid: ur("context-toolbar"),
      initGroups: LL(r, o),
      onEscape: _.none,
      cyclicKeying: !0,
      providers: o
    });
  }, lW = {
    renderContextForm: sW,
    buildInitGroups: LL
  }, zL = function(t, r, o) {
    return o === void 0 && (o = 0.01), r.bottom - t.y >= o && t.bottom - r.y >= o;
  }, cW = function(t) {
    var r = t.getBoundingClientRect();
    if (r.height <= 0 && r.width <= 0) {
      var o = Oe(Bn.fromDom(t.startContainer), t.startOffset).element, l = ye(o) ? Co(o) : _.some(o);
      return l.filter(Z).map(function(v) {
        return v.dom.getBoundingClientRect();
      }).getOr(r);
    } else
      return r;
  }, T$ = function(t) {
    var r = t.selection.getRng(), o = cW(r);
    if (t.inline) {
      var l = Us();
      return Ai(l.left + o.left, l.top + o.top, o.width, o.height);
    } else {
      var v = ef(Bn.fromDom(t.getBody()));
      return Ai(v.x + o.left, v.y + o.top, o.width, o.height);
    }
  }, fW = function(t, r) {
    return r.filter(Tr).map(ef).getOrThunk(function() {
      return T$(t);
    });
  }, vW = function(t, r, o) {
    var l = Math.max(t.x + o, r.x), v = Math.min(t.right - o, r.right);
    return {
      x: l,
      width: v - l
    };
  }, dW = function(t, r, o, l, v, g) {
    var b = Bn.fromDom(t.getContainer()), T = Bi(b, ".tox-editor-header").getOr(b), A = si(T), R = A.y >= r.bottom, z = l && !R;
    if (t.inline && z)
      return {
        y: Math.max(A.bottom + g, o.y),
        bottom: o.bottom
      };
    if (t.inline && !z)
      return {
        y: o.y,
        bottom: Math.min(A.y - g, o.bottom)
      };
    var U = v === "line" ? si(b) : r;
    return z ? {
      y: Math.max(A.bottom + g, o.y),
      bottom: Math.min(U.bottom - g, o.bottom)
    } : {
      y: Math.max(U.y + g, o.y),
      bottom: Math.min(A.y - g, o.bottom)
    };
  }, HL = function(t, r, o, l) {
    l === void 0 && (l = 0);
    var v = Yf(window), g = si(Bn.fromDom(t.getContentAreaContainer())), b = i_(t) || u_(t) || O4(t), T = vW(g, v, l), A = T.x, R = T.width;
    if (t.inline && !b)
      return Ai(A, v.y, R, v.height);
    var z = r.header.isPositionedAtTop(), U = dW(t, g, v, z, o, l), oe = U.y, de = U.bottom;
    return Ai(A, oe, R, de - oe);
  }, TB = 12, VL = {
    valignCentre: [],
    alignCentre: [],
    alignLeft: ["tox-pop--align-left"],
    alignRight: ["tox-pop--align-right"],
    right: ["tox-pop--right"],
    left: ["tox-pop--left"],
    bottom: ["tox-pop--bottom"],
    top: ["tox-pop--top"],
    inset: ["tox-pop--inset"]
  }, UL = {
    maxHeightFunction: Eg(),
    maxWidthFunction: ps()
  }, mW = function(t, r) {
    var o = t.selection.getRng(), l = Oe(Bn.fromDom(o.startContainer), o.startOffset);
    return o.startContainer === o.endContainer && o.startOffset === o.endOffset - 1 && Fa(l.element, r);
  }, gW = function(t, r, o) {
    var l = ui(t, "position");
    Pr(t, "position", r);
    var v = o(t);
    return l.each(function(g) {
      return Pr(t, "position", g);
    }), v;
  }, jL = function(t) {
    return t === "node";
  }, pW = function(t, r, o, l, v) {
    var g = T$(t), b = l.lastElement().exists(function(R) {
      return Fa(o, R);
    });
    if (mW(t, o))
      return b ? k5 : Vc;
    if (b)
      return gW(r, l.getMode(), function() {
        var R = zL(g, si(r));
        return R && !l.isReposition() ? hR : k5;
      });
    var T = l.getMode() === "fixed" ? v.y + Us().top : v.y, A = hi(r) + TB;
    return T + A <= g.y ? Vc : dp;
  }, hW = function(t, r, o, l) {
    var v = function(A) {
      return function(R, z, U, oe, de) {
        var Se = pW(t, oe, A, o, de), $e = $($({}, R), {
          y: de.y,
          height: de.height
        });
        return $($({}, Se($e, z, U, oe, de)), { alwaysFit: !0 });
      };
    }, g = function(A) {
      return jL(l) ? [v(A)] : [];
    }, b = {
      onLtr: function(A) {
        return [
          Es,
          wi,
          cs,
          Nu,
          fs,
          Vi
        ].concat(g(A));
      },
      onRtl: function(A) {
        return [
          Es,
          wi,
          fs,
          Vi,
          cs,
          Nu
        ].concat(g(A));
      }
    }, T = {
      onLtr: function(A) {
        return [
          wi,
          Nu,
          Vi,
          cs,
          fs,
          Es
        ].concat(g(A));
      },
      onRtl: function(A) {
        return [
          wi,
          Vi,
          Nu,
          fs,
          cs,
          Es
        ].concat(g(A));
      }
    };
    return r ? T : b;
  }, bW = function(t, r, o, l) {
    return r === "line" ? {
      bubble: om(TB, 0, VL),
      layouts: {
        onLtr: function() {
          return [o0];
        },
        onRtl: function() {
          return [i0];
        }
      },
      overrides: UL
    } : {
      bubble: om(0, TB, VL, 1 / TB),
      layouts: hW(t, o, l, r),
      overrides: UL
    };
  }, E$ = function(t, r) {
    var o = We(r, function(b) {
      return b.predicate(t.dom);
    }), l = He(o, function(b) {
      return b.type === "contexttoolbar";
    }), v = l.pass, g = l.fail;
    return {
      contextToolbars: v,
      contextForms: g
    };
  }, yW = function(t) {
    if (t.length <= 1)
      return t;
    var r = function(T) {
      return Jt(t, function(A) {
        return A.position === T;
      });
    }, o = function(T) {
      return We(t, function(A) {
        return A.position === T;
      });
    }, l = r("selection"), v = r("node");
    if (l || v)
      if (v && l) {
        var g = o("node"), b = _t(o("selection"), function(T) {
          return $($({}, T), { position: "node" });
        });
        return g.concat(b);
      } else
        return o(l ? "selection" : "node");
    else
      return o("line");
  }, wW = function(t) {
    if (t.length <= 1)
      return t;
    var r = function(l) {
      return pt(t, function(v) {
        return v.position === l;
      });
    }, o = r("selection").orThunk(function() {
      return r("node");
    }).orThunk(function() {
      return r("line");
    }).map(function(l) {
      return l.position;
    });
    return o.fold(function() {
      return [];
    }, function(l) {
      return We(t, function(v) {
        return v.position === l;
      });
    });
  }, CW = function(t, r, o) {
    var l = E$(t, r);
    if (l.contextForms.length > 0)
      return _.some({
        elem: t,
        toolbars: [l.contextForms[0]]
      });
    var v = E$(t, o);
    if (v.contextForms.length > 0)
      return _.some({
        elem: t,
        toolbars: [v.contextForms[0]]
      });
    if (l.contextToolbars.length > 0 || v.contextToolbars.length > 0) {
      var g = yW(l.contextToolbars.concat(v.contextToolbars));
      return _.some({
        elem: t,
        toolbars: g
      });
    } else
      return _.none();
  }, SW = function(t, r, o) {
    return t(r) ? _.none() : Kp(r, function(l) {
      if (Z(l)) {
        var v = E$(l, o.inNodeScope), g = v.contextToolbars, b = v.contextForms, T = b.length > 0 ? b : wW(g);
        return T.length > 0 ? _.some({
          elem: l,
          toolbars: T
        }) : _.none();
      } else
        return _.none();
    }, t);
  }, xW = function(t, r) {
    var o = Bn.fromDom(r.getBody()), l = function(b) {
      return Fa(b, o);
    }, v = function(b) {
      return !l(b) && !_u(o, b);
    }, g = Bn.fromDom(r.selection.getNode());
    return v(g) ? _.none() : CW(g, t.inNodeScope, t.inEditorScope).orThunk(function() {
      return SW(l, g, t);
    });
  }, kW = function(t, r) {
    var o = {}, l = [], v = [], g = {}, b = {}, T = function(z, U) {
      var oe = Yl(LE(U));
      o[z] = oe, oe.launch.map(function(de) {
        g["form:" + z] = $($({}, U.launch), {
          type: de.type === "contextformtogglebutton" ? "togglebutton" : "button",
          onAction: function() {
            r(oe);
          }
        });
      }), oe.scope === "editor" ? v.push(oe) : l.push(oe), b[z] = oe;
    }, A = function(z, U) {
      $5(U).each(function(oe) {
        U.scope === "editor" ? v.push(oe) : l.push(oe), b[z] = oe;
      });
    }, R = on(t);
    return Pe(R, function(z) {
      var U = t[z];
      U.type === "contextform" ? T(z, U) : U.type === "contexttoolbar" && A(z, U);
    }), {
      forms: o,
      inNodeScope: l,
      inEditorScope: v,
      lookupTable: b,
      formNavigators: g
    };
  }, WL = ur("forward-slide"), qL = ur("backward-slide"), _$ = ur("change-slide-event"), A$ = "tox-pop--resizing", TW = function(t) {
    var r = Sr([]);
    return Ua.sketch({
      dom: {
        tag: "div",
        classes: ["tox-pop"]
      },
      fireDismissalEventInstead: { event: "doNotDismissYet" },
      onShow: function(o) {
        r.set([]), Ua.getContent(o).each(function(l) {
          Da(l.element, "visibility");
        }), yi(o.element, A$), Da(o.element, "width");
      },
      inlineBehaviours: Fn([
        Jr("context-toolbar-events", [
          li(ug(), function(o, l) {
            l.event.raw.propertyName === "width" && (yi(o.element, A$), Da(o.element, "width"));
          }),
          cn(_$, function(o, l) {
            var v = o.element;
            Da(v, "width");
            var g = Au(v);
            Ua.setContent(o, l.event.contents), Di(v, A$);
            var b = Au(v);
            Pr(v, "width", g + "px"), Ua.getContent(o).each(function(T) {
              l.event.focus.bind(function(A) {
                return Mc(A), Pc(v);
              }).orThunk(function() {
                return Er.focusIn(T), vs(wr(v));
              });
            }), pp.setTimeout(function() {
              Pr(o.element, "width", b + "px");
            }, 0);
          }),
          cn(WL, function(o, l) {
            Ua.getContent(o).each(function(v) {
              r.set(r.get().concat([{
                bar: v,
                focus: vs(wr(o.element))
              }]));
            }), xr(o, _$, {
              contents: l.event.forwardContents,
              focus: _.none()
            });
          }),
          cn(qL, function(o, l) {
            qt(r.get()).each(function(v) {
              r.set(r.get().slice(0, r.get().length - 1)), xr(o, _$, {
                contents: yl(v.bar),
                focus: v.focus
              });
            });
          })
        ]),
        Er.config({
          mode: "special",
          onEscape: function(o) {
            return qt(r.get()).fold(function() {
              return t.onEscape();
            }, function(l) {
              return Ta(o, qL), _.some(!0);
            });
          }
        })
      ]),
      lazySink: function() {
        return ea.value(t.sink);
      }
    });
  }, O$ = "tox-pop--transition", EW = function(t, r, o, l) {
    var v = l.backstage, g = v.shared, b = br().deviceType.isTouch, T = Zo(), A = Zo(), R = Zo(), z = ko(TW({
      sink: o,
      onEscape: function() {
        return t.focus(), _.some(!0);
      }
    })), U = function() {
      var vn = R.get().getOr("node"), Gn = jL(vn) ? 1 : 0;
      return HL(t, g, vn, Gn);
    }, oe = function() {
      return !t.removed && !(b() && v.isContextMenuOpen());
    }, de = function(vn) {
      return Ir(Va(vn, T.get(), Fa), !0);
    }, Se = function() {
      if (oe()) {
        var vn = U(), Gn = Ir(R.get(), "node") ? fW(t, T.get()) : T$(t);
        return vn.height <= 0 || !zL(Gn, vn);
      } else
        return !0;
    }, $e = function() {
      T.clear(), A.clear(), R.clear(), Ua.hide(z);
    }, ut = function() {
      if (Ua.isOpen(z)) {
        var vn = z.element;
        Da(vn, "display"), Se() ? Pr(vn, "display", "none") : (A.set(0), Ua.reposition(z));
      }
    }, Ne = function(vn) {
      return {
        dom: {
          tag: "div",
          classes: ["tox-pop__dialog"]
        },
        components: [vn],
        behaviours: Fn([
          Er.config({ mode: "acyclic" }),
          Jr("pop-dialog-wrap-events", [
            Zr(function(Gn) {
              t.shortcuts.add("ctrl+F9", "focus statusbar", function() {
                return Er.focusIn(Gn);
              });
            }),
            gl(function(Gn) {
              t.shortcuts.remove("ctrl+F9");
            })
          ])
        ])
      };
    }, ft = Et(function() {
      return kW(r, function(vn) {
        var Gn = st([vn]);
        xr(z, WL, { forwardContents: Ne(Gn) });
      });
    }), Ht = function(vn, Gn) {
      return xB(t, {
        buttons: vn,
        toolbar: Gn.items,
        allowToolbarGroups: !1
      }, l, _.some(["form:"]));
    }, Kt = function(vn, Gn) {
      return lW.buildInitGroups(vn, Gn);
    }, st = function(vn) {
      var Gn = t.ui.registry.getAll().buttons, pn = ft(), nn = $($({}, Gn), pn.formNavigators), Wn = Pw(t) === lc.scrolling ? lc.scrolling : lc.default, cr = Ie(_t(vn, function(dn) {
        return dn.type === "contexttoolbar" ? Ht(nn, dn) : Kt(dn, g.providers);
      }));
      return _a({
        type: Wn,
        uid: ur("context-toolbar"),
        initGroups: cr,
        onEscape: _.none,
        cyclicKeying: !0,
        providers: g.providers
      });
    }, Bt = function(vn, Gn) {
      var pn = vn === "node" ? g.anchors.node(Gn) : g.anchors.cursor(), nn = bW(t, vn, b(), {
        lastElement: T.get,
        isReposition: function() {
          return Ir(A.get(), 0);
        },
        getMode: function() {
          return Jo.getMode(o);
        }
      });
      return Gt(pn, nn);
    }, an = function(vn, Gn) {
      if (qn.cancel(), !!oe()) {
        var pn = st(vn), nn = vn[0].position, Wn = Bt(nn, Gn);
        R.set(nn), A.set(1);
        var cr = z.element;
        Da(cr, "display"), de(Gn) || (yi(cr, O$), Jo.reset(o, z)), Ua.showWithinBounds(z, Ne(pn), {
          anchor: Wn,
          transition: {
            classes: [O$],
            mode: "placement"
          }
        }, function() {
          return _.some(U());
        }), Gn.fold(T.clear, T.set), Se() && Pr(cr, "display", "none");
      }
    }, qn = ME(function() {
      if (!(!t.hasFocus() || t.removed))
        if (us(z.element, O$))
          qn.throttle();
        else {
          var vn = ft();
          xW(vn, t).fold($e, function(Gn) {
            an(Gn.toolbars, _.some(Gn.elem));
          });
        }
    }, 17);
    t.on("init", function() {
      t.on("remove", $e), t.on("ScrollContent ScrollWindow ObjectResized ResizeEditor longpress", ut), t.on("click keyup focus SetContent", qn.throttle), t.on(FL, $e), t.on(nW, function(vn) {
        var Gn = ft();
        Ft(Gn.lookupTable, vn.toolbarKey).each(function(pn) {
          an([pn], so(vn.target !== t, vn.target)), Ua.getContent(z).each(Er.focusIn);
        });
      }), t.on("focusout", function(vn) {
        pp.setEditorTimeout(t, function() {
          Pc(o.element).isNone() && Pc(z.element).isNone() && $e();
        }, 0);
      }), t.on("SwitchMode", function() {
        t.mode.isReadOnly() && $e();
      }), t.on("AfterProgressState", function(vn) {
        vn.state ? $e() : t.hasFocus() && qn.throttle();
      }), t.on("NodeChange", function(vn) {
        Pc(z.element).fold(qn.throttle, ee);
      });
    });
  }, _W = function(t) {
    var r = [
      {
        name: "alignleft",
        text: "Align left",
        cmd: "JustifyLeft",
        icon: "align-left"
      },
      {
        name: "aligncenter",
        text: "Align center",
        cmd: "JustifyCenter",
        icon: "align-center"
      },
      {
        name: "alignright",
        text: "Align right",
        cmd: "JustifyRight",
        icon: "align-right"
      },
      {
        name: "alignjustify",
        text: "Justify",
        cmd: "JustifyFull",
        icon: "align-justify"
      }
    ];
    Pe(r, function(o) {
      t.ui.registry.addToggleButton(o.name, {
        tooltip: o.text,
        icon: o.icon,
        onAction: Ov(t, o.cmd),
        onSetup: wB(t, o.name)
      });
    }), t.ui.registry.addButton("alignnone", {
      tooltip: "No alignment",
      icon: "align-none",
      onAction: Ov(t, "JustifyNone")
    });
  }, AW = {
    unsupportedLength: [
      "em",
      "ex",
      "cap",
      "ch",
      "ic",
      "rem",
      "lh",
      "rlh",
      "vw",
      "vh",
      "vi",
      "vb",
      "vmin",
      "vmax",
      "cm",
      "mm",
      "Q",
      "in",
      "pc",
      "pt",
      "px"
    ],
    fixed: [
      "px",
      "pt"
    ],
    relative: ["%"],
    empty: [""]
  }, OW = function() {
    var t = "[0-9]+", r = "[+-]?" + t, o = "[eE]" + r, l = "\\.", v = function(T) {
      return "(?:" + T + ")?";
    }, g = [
      "Infinity",
      t + l + v(t) + v(o),
      l + t + v(o),
      t + v(o)
    ].join("|"), b = "[+-]?(?:" + g + ")";
    return new RegExp("^(" + b + ")(.*)$");
  }(), DW = function(t, r) {
    return Jt(r, function(o) {
      return Jt(AW[o], function(l) {
        return t === l;
      });
    });
  }, BW = function(t, r) {
    var o = _.from(OW.exec(t));
    return o.bind(function(l) {
      var v = Number(l[1]), g = l[2];
      return DW(g, r) ? _.some({
        value: v,
        unit: g
      }) : _.none();
    });
  }, RW = function(t, r) {
    return BW(t, r).map(function(o) {
      var l = o.value, v = o.unit;
      return l + v;
    });
  }, GL = function(t, r) {
    var o = function() {
      var l = r.getOptions(t), v = r.getCurrent(t).map(r.hash), g = Zo();
      return _t(l, function(b) {
        return {
          type: "togglemenuitem",
          text: r.display(b),
          onSetup: function(T) {
            var A = function(z) {
              z && (g.on(function(U) {
                return U.setActive(!1);
              }), g.set(T)), T.setActive(z);
            };
            A(Ir(v, r.hash(b)));
            var R = r.watcher(t, b, A);
            return function() {
              g.clear(), R();
            };
          },
          onAction: function() {
            return r.setCurrent(t, b);
          }
        };
      });
    };
    t.ui.registry.addMenuButton(r.name, {
      tooltip: r.text,
      icon: r.icon,
      fetch: function(l) {
        return l(o());
      },
      onSetup: r.onToolbarSetup
    }), t.ui.registry.addNestedMenuItem(r.name, {
      type: "nestedmenuitem",
      text: r.text,
      getSubmenuItems: o,
      onSetup: r.onMenuSetup
    });
  }, MW = {
    name: "lineheight",
    text: "Line height",
    icon: "line-height",
    getOptions: sO,
    hash: function(t) {
      return RW(t, [
        "fixed",
        "relative",
        "empty"
      ]).getOr(t);
    },
    display: Ze,
    watcher: function(t, r, o) {
      return t.formatter.formatChanged("lineheight", o, !1, { value: r }).unbind;
    },
    getCurrent: function(t) {
      return _.from(t.queryCommandValue("LineHeight"));
    },
    setCurrent: function(t, r) {
      return t.execCommand("LineHeight", !1, r);
    }
  }, PW = function(t) {
    var r = _.from(lO(t));
    return r.map(function(o) {
      return {
        name: "language",
        text: "Language",
        icon: "language",
        getOptions: ie(o),
        hash: function(l) {
          return Q(l.customCode) ? l.code : l.code + "/" + l.customCode;
        },
        display: function(l) {
          return l.title;
        },
        watcher: function(l, v, g) {
          return l.formatter.formatChanged("lang", g, !1, {
            value: v.code,
            customValue: v.customCode
          }).unbind;
        },
        getCurrent: function(l) {
          var v = Bn.fromDom(l.selection.getNode());
          return rg(v, function(g) {
            return _.some(g).filter(Z).bind(function(b) {
              var T = No(b, "lang");
              return T.map(function(A) {
                var R = No(b, "data-mce-lang").getOrUndefined();
                return {
                  code: A,
                  customCode: R,
                  title: ""
                };
              });
            });
          });
        },
        setCurrent: function(l, v) {
          return l.execCommand("Lang", !1, v);
        },
        onToolbarSetup: function(l) {
          var v = kg();
          return l.setActive(t.formatter.match("lang", {}, void 0, !0)), v.set(t.formatter.formatChanged("lang", l.setActive, !0)), v.clear;
        }
      };
    });
  }, NW = function(t) {
    GL(t, MW), PW(t).each(function(r) {
      return GL(t, r);
    });
  }, IW = function(t, r) {
    ej(t, r), oj(t, r), bj(t, r), pj(t, r), dj(t, r);
  }, FW = function(t) {
    return CB(t, "NodeChange", function(r) {
      r.setDisabled(!t.queryCommandState("outdent"));
    });
  }, $W = function(t) {
    t.ui.registry.addButton("outdent", {
      tooltip: "Decrease indent",
      icon: "outdent",
      onSetup: FW(t),
      onAction: Ov(t, "outdent")
    }), t.ui.registry.addButton("indent", {
      tooltip: "Increase indent",
      icon: "indent",
      onAction: Ov(t, "indent")
    });
  }, LW = function(t) {
    $W(t);
  }, D$ = function(t, r) {
    return function() {
      t.execCommand("mceToggleFormat", !1, r);
    };
  }, zW = function(t) {
    Tp.each([
      {
        name: "bold",
        text: "Bold",
        icon: "bold"
      },
      {
        name: "italic",
        text: "Italic",
        icon: "italic"
      },
      {
        name: "underline",
        text: "Underline",
        icon: "underline"
      },
      {
        name: "strikethrough",
        text: "Strikethrough",
        icon: "strike-through"
      },
      {
        name: "subscript",
        text: "Subscript",
        icon: "subscript"
      },
      {
        name: "superscript",
        text: "Superscript",
        icon: "superscript"
      }
    ], function(l, v) {
      t.ui.registry.addToggleButton(l.name, {
        tooltip: l.text,
        icon: l.icon,
        onSetup: wB(t, l.name),
        onAction: D$(t, l.name)
      });
    });
    for (var r = 1; r <= 6; r++) {
      var o = "h" + r;
      t.ui.registry.addToggleButton(o, {
        text: o.toUpperCase(),
        tooltip: "Heading " + r,
        onSetup: wB(t, o),
        onAction: D$(t, o)
      });
    }
  }, HW = function(t) {
    Tp.each([
      {
        name: "cut",
        text: "Cut",
        action: "Cut",
        icon: "cut"
      },
      {
        name: "copy",
        text: "Copy",
        action: "Copy",
        icon: "copy"
      },
      {
        name: "paste",
        text: "Paste",
        action: "Paste",
        icon: "paste"
      },
      {
        name: "help",
        text: "Help",
        action: "mceHelp",
        icon: "help"
      },
      {
        name: "selectall",
        text: "Select all",
        action: "SelectAll",
        icon: "select-all"
      },
      {
        name: "newdocument",
        text: "New document",
        action: "mceNewDocument",
        icon: "new-document"
      },
      {
        name: "removeformat",
        text: "Clear formatting",
        action: "RemoveFormat",
        icon: "remove-formatting"
      },
      {
        name: "remove",
        text: "Remove",
        action: "Delete",
        icon: "remove"
      }
    ], function(r) {
      t.ui.registry.addButton(r.name, {
        tooltip: r.text,
        icon: r.icon,
        onAction: Ov(t, r.action)
      });
    });
  }, VW = function(t) {
    Tp.each([{
      name: "blockquote",
      text: "Blockquote",
      action: "mceBlockQuote",
      icon: "quote"
    }], function(r) {
      t.ui.registry.addToggleButton(r.name, {
        tooltip: r.text,
        icon: r.icon,
        onAction: Ov(t, r.action),
        onSetup: wB(t, r.name)
      });
    });
  }, UW = function(t) {
    zW(t), HW(t), VW(t);
  }, jW = function(t) {
    Tp.each([
      {
        name: "bold",
        text: "Bold",
        action: "Bold",
        icon: "bold",
        shortcut: "Meta+B"
      },
      {
        name: "italic",
        text: "Italic",
        action: "Italic",
        icon: "italic",
        shortcut: "Meta+I"
      },
      {
        name: "underline",
        text: "Underline",
        action: "Underline",
        icon: "underline",
        shortcut: "Meta+U"
      },
      {
        name: "strikethrough",
        text: "Strikethrough",
        action: "Strikethrough",
        icon: "strike-through",
        shortcut: ""
      },
      {
        name: "subscript",
        text: "Subscript",
        action: "Subscript",
        icon: "subscript",
        shortcut: ""
      },
      {
        name: "superscript",
        text: "Superscript",
        action: "Superscript",
        icon: "superscript",
        shortcut: ""
      },
      {
        name: "removeformat",
        text: "Clear formatting",
        action: "RemoveFormat",
        icon: "remove-formatting",
        shortcut: ""
      },
      {
        name: "newdocument",
        text: "New document",
        action: "mceNewDocument",
        icon: "new-document",
        shortcut: ""
      },
      {
        name: "cut",
        text: "Cut",
        action: "Cut",
        icon: "cut",
        shortcut: "Meta+X"
      },
      {
        name: "copy",
        text: "Copy",
        action: "Copy",
        icon: "copy",
        shortcut: "Meta+C"
      },
      {
        name: "paste",
        text: "Paste",
        action: "Paste",
        icon: "paste",
        shortcut: "Meta+V"
      },
      {
        name: "selectall",
        text: "Select all",
        action: "SelectAll",
        icon: "select-all",
        shortcut: "Meta+A"
      }
    ], function(r) {
      t.ui.registry.addMenuItem(r.name, {
        text: r.text,
        icon: r.icon,
        shortcut: r.shortcut,
        onAction: Ov(t, r.action)
      });
    }), t.ui.registry.addMenuItem("codeformat", {
      text: "Code",
      icon: "sourcecode",
      onAction: D$(t, "code")
    });
  }, WW = function(t) {
    UW(t), jW(t);
  }, EB = function(t, r) {
    return CB(t, "Undo Redo AddUndo TypingUndo ClearUndos SwitchMode", function(o) {
      o.setDisabled(t.mode.isReadOnly() || !t.undoManager[r]());
    });
  }, qW = function(t) {
    t.ui.registry.addMenuItem("undo", {
      text: "Undo",
      icon: "undo",
      shortcut: "Meta+Z",
      onSetup: EB(t, "hasUndo"),
      onAction: Ov(t, "undo")
    }), t.ui.registry.addMenuItem("redo", {
      text: "Redo",
      icon: "redo",
      shortcut: "Meta+Y",
      onSetup: EB(t, "hasRedo"),
      onAction: Ov(t, "redo")
    });
  }, GW = function(t) {
    t.ui.registry.addButton("undo", {
      tooltip: "Undo",
      icon: "undo",
      disabled: !0,
      onSetup: EB(t, "hasUndo"),
      onAction: Ov(t, "undo")
    }), t.ui.registry.addButton("redo", {
      tooltip: "Redo",
      icon: "redo",
      disabled: !0,
      onSetup: EB(t, "hasRedo"),
      onAction: Ov(t, "redo")
    });
  }, KW = function(t) {
    qW(t), GW(t);
  }, XW = function(t) {
    return CB(t, "VisualAid", function(r) {
      r.setActive(t.hasVisual);
    });
  }, YW = function(t) {
    t.ui.registry.addToggleMenuItem("visualaid", {
      text: "Visual aids",
      onSetup: XW(t),
      onAction: Ov(t, "mceToggleVisualAid")
    });
  }, ZW = function(t) {
    t.ui.registry.addButton("visualaid", {
      tooltip: "Visual aids",
      text: "Visual aids",
      onAction: Ov(t, "mceToggleVisualAid")
    });
  }, JW = function(t) {
    ZW(t), YW(t);
  }, QW = function(t, r) {
    _W(t), WW(t), IW(t, r), KW(t), l7(t), JW(t), LW(t), NW(t);
  }, a5 = function(t, r) {
    return {
      type: "makeshift",
      x: t,
      y: r
    };
  }, eq = function(t, r, o) {
    return a5(t.x + r, t.y + o);
  }, KL = function(t) {
    return t.type === "longpress" || t.type.indexOf("touch") === 0;
  }, tq = function(t) {
    if (KL(t)) {
      var r = t.touches[0];
      return a5(r.pageX, r.pageY);
    } else
      return a5(t.pageX, t.pageY);
  }, nq = function(t) {
    if (KL(t)) {
      var r = t.touches[0];
      return a5(r.clientX, r.clientY);
    } else
      return a5(t.clientX, t.clientY);
  }, rq = function(t, r) {
    var o = Db.DOM.getPos(t);
    return eq(r, o.x, o.y);
  }, aq = function(t, r) {
    return r.type === "contextmenu" || r.type === "longpress" ? t.inline ? tq(r) : rq(t.getContentAreaContainer(), nq(r)) : XL(t);
  }, XL = function(t) {
    return {
      type: "selection",
      root: Bn.fromDom(t.selection.getNode())
    };
  }, oq = function(t) {
    return {
      type: "node",
      node: _.some(Bn.fromDom(t.selection.getNode())),
      root: Bn.fromDom(t.getBody())
    };
  }, YL = function(t, r, o) {
    switch (o) {
      case "node":
        return oq(t);
      case "point":
        return aq(t, r);
      case "selection":
        return XL(t);
    }
  }, iq = function(t, r, o, l, v, g) {
    var b = o(), T = YL(t, r, g);
    Hb(b, Xu.CLOSE_ON_EXECUTE, l, !1).map(function(A) {
      r.preventDefault(), Ua.showMenuAt(v, { anchor: T }, {
        menu: { markers: Eb("normal") },
        data: A
      });
    });
  }, uq = {
    onLtr: function() {
      return [
        wi,
        Nu,
        Vi,
        cs,
        fs,
        Es,
        Vc,
        dp,
        vp,
        cp,
        fp,
        xb
      ];
    },
    onRtl: function() {
      return [
        wi,
        Vi,
        Nu,
        fs,
        cs,
        Es,
        Vc,
        dp,
        fp,
        xb,
        vp,
        cp
      ];
    }
  }, sq = 12, lq = {
    valignCentre: [],
    alignCentre: [],
    alignLeft: ["tox-pop--align-left"],
    alignRight: ["tox-pop--align-right"],
    right: ["tox-pop--right"],
    left: ["tox-pop--left"],
    bottom: ["tox-pop--bottom"],
    top: ["tox-pop--top"]
  }, cq = function(t, r) {
    var o = t.selection;
    if (o.isCollapsed() || r.touches.length < 1)
      return !1;
    var l = r.touches[0], v = o.getRng(), g = m2(t.getWin(), Og.domRange(v));
    return g.exists(function(b) {
      return b.left <= l.clientX && b.right >= l.clientX && b.top <= l.clientY && b.bottom >= l.clientY;
    });
  }, fq = function(t) {
    var r = t.selection.getRng(), o = function() {
      pp.setEditorTimeout(t, function() {
        t.selection.setRng(r);
      }, 10), g();
    };
    t.once("touchend", o);
    var l = function(b) {
      b.preventDefault(), b.stopImmediatePropagation();
    };
    t.on("mousedown", l, !0);
    var v = function() {
      return g();
    };
    t.once("longpresscancel", v);
    var g = function() {
      t.off("touchend", o), t.off("longpresscancel", v), t.off("mousedown", l);
    };
  }, vq = function(t, r, o) {
    var l = YL(t, r, o), v = o === "point" ? sq : 0;
    return $({
      bubble: om(0, v, lq),
      layouts: uq,
      overrides: {
        maxWidthFunction: ps(),
        maxHeightFunction: Eg()
      }
    }, l);
  }, dq = function(t, r, o, l, v, g, b) {
    var T = vq(t, r, g);
    Hb(o, Xu.CLOSE_ON_EXECUTE, l, !0).map(function(A) {
      r.preventDefault(), Ua.showMenuWithinBounds(v, { anchor: T }, {
        menu: {
          markers: Eb("normal"),
          highlightImmediately: b
        },
        data: A,
        type: "horizontal"
      }, function() {
        return _.some(HL(t, l.shared, g === "node" ? "node" : "selection"));
      }), t.fire(FL);
    });
  }, mq = function(t, r, o, l, v, g) {
    var b = br(), T = b.os.isiOS(), A = b.os.isOSX(), R = b.os.isAndroid(), z = b.deviceType.isTouch(), U = function() {
      return !(R || T || A && z);
    }, oe = function() {
      var Se = o();
      dq(t, r, Se, l, v, g, U());
    };
    if ((A || T) && g !== "node") {
      var de = function() {
        fq(t), oe();
      };
      cq(t, r) ? de() : (t.once("selectionchange", de), t.once("touchend", function() {
        return t.off("selectionchange", de);
      }));
    } else
      oe();
  }, ZL = function(t) {
    return typeof t == "string" ? t.split(/[ ,]/) : t;
  }, JL = function(t) {
    return t.getParam("contextmenu_never_use_native", !1, "boolean");
  }, gq = function(t, r, o) {
    var l = t.ui.registry.getAll().contextMenus;
    return _.from(t.getParam(r)).map(ZL).getOrThunk(function() {
      return We(ZL(o), function(v) {
        return yn(l, v);
      });
    });
  }, pq = function(t) {
    return t.getParam("contextmenu") === !1;
  }, hq = function(t) {
    return gq(t, "contextmenu", "link linkchecker image imagetools table spellchecker configurepermanentpen");
  }, bq = function(t) {
    return t.getParam("contextmenu_avoid_overlap", "", "string");
  }, QL = function(t) {
    return P(t) ? t === "|" : t.type === "separator";
  }, B$ = { type: "separator" }, ez = function(t) {
    var r = function(o) {
      return {
        text: o.text,
        icon: o.icon,
        disabled: o.disabled,
        shortcut: o.shortcut
      };
    };
    if (P(t))
      return t;
    switch (t.type) {
      case "separator":
        return B$;
      case "submenu":
        return $($({ type: "nestedmenuitem" }, r(t)), {
          getSubmenuItems: function() {
            var o = t.getSubmenuItems();
            return P(o) ? o : _t(o, ez);
          }
        });
      default:
        return $($({ type: "menuitem" }, r(t)), { onAction: Ge(t.onAction) });
    }
  }, tz = function(t, r) {
    if (r.length === 0)
      return t;
    var o = qt(t).filter(function(v) {
      return !QL(v);
    }), l = o.fold(function() {
      return [];
    }, function(v) {
      return [B$];
    });
    return t.concat(l).concat(r).concat([B$]);
  }, yq = function(t, r, o) {
    var l = Ke(r, function(v, g) {
      return Ft(t, g.toLowerCase()).map(function(b) {
        var T = b.update(o);
        if (P(T))
          return tz(v, T.split(" "));
        if (T.length > 0) {
          var A = _t(T, ez);
          return tz(v, A);
        } else
          return v;
      }).getOrThunk(function() {
        return v.concat([g]);
      });
    }, []);
    return l.length > 0 && QL(l[l.length - 1]) && l.pop(), l;
  }, wq = function(t, r) {
    return r.ctrlKey && !JL(t);
  }, nz = function(t, r) {
    return r.type !== "longpress" && (r.button !== 2 || r.target === t.getBody() && r.pointerType === "");
  }, rz = function(t, r) {
    return nz(t, r) ? t.selection.getStart(!0) : r.target;
  }, Cq = function(t, r) {
    var o = bq(t), l = nz(t, r) ? "selection" : "point";
    if (pi(o)) {
      var v = rz(t, r), g = Hw(Bn.fromDom(v), o);
      return g ? "node" : l;
    } else
      return l;
  }, Sq = function(t, r, o) {
    var l = br(), v = l.deviceType.isTouch, g = ko(Ua.sketch({
      dom: { tag: "div" },
      lazySink: r,
      onEscape: function() {
        return t.focus();
      },
      onShow: function() {
        return o.setContextMenuState(!0);
      },
      onHide: function() {
        return o.setContextMenuState(!1);
      },
      fireDismissalEventInstead: {},
      inlineBehaviours: Fn([Jr("dismissContextMenu", [cn(ec(), function(A, R) {
        ga.close(A), t.focus();
      })])])
    })), b = function(A) {
      return Ua.hide(g);
    }, T = function(A) {
      if (JL(t) && A.preventDefault(), !(wq(t, A) || pq(t))) {
        var R = Cq(t, A), z = function() {
          var oe = rz(t, A), de = t.ui.registry.getAll(), Se = hq(t);
          return yq(de.contextMenus, Se, oe);
        }, U = v() ? mq : iq;
        U(t, A, z, o, g, R);
      }
    };
    t.on("init", function() {
      var A = "ResizeEditor ScrollContent ScrollWindow longpresscancel" + (v() ? "" : " ResizeWindow");
      t.on(A, b), t.on("longpress contextmenu", T);
    });
  }, R$ = fl.generate([
    {
      offset: [
        "x",
        "y"
      ]
    },
    {
      absolute: [
        "x",
        "y"
      ]
    },
    {
      fixed: [
        "x",
        "y"
      ]
    }
  ]), _B = function(t) {
    return function(r) {
      return r.translate(-t.left, -t.top);
    };
  }, AB = function(t) {
    return function(r) {
      return r.translate(t.left, t.top);
    };
  }, g1 = function(t) {
    return function(r, o) {
      return Ke(t, function(l, v) {
        return v(l);
      }, eo(r, o));
    };
  }, OB = function(t, r, o) {
    return t.fold(g1([
      AB(o),
      _B(r)
    ]), g1([_B(r)]), g1([]));
  }, X3 = function(t, r, o) {
    return t.fold(g1([AB(o)]), g1([]), g1([AB(r)]));
  }, az = function(t, r, o) {
    return t.fold(g1([]), g1([_B(o)]), g1([
      AB(r),
      _B(o)
    ]));
  }, xq = function(t, r, o, l, v, g) {
    var b = X3(t, v, g), T = X3(r, v, g);
    return Math.abs(b.left - T.left) <= o && Math.abs(b.top - T.top) <= l;
  }, kq = function(t, r, o, l, v, g) {
    var b = X3(t, v, g), T = X3(r, v, g), A = Math.abs(b.left - T.left), R = Math.abs(b.top - T.top);
    return eo(A, R);
  }, oz = function(t, r, o) {
    var l = t.fold(function(v, g) {
      return {
        position: _.some("absolute"),
        left: _.some(v + "px"),
        top: _.some(g + "px")
      };
    }, function(v, g) {
      return {
        position: _.some("absolute"),
        left: _.some(v - o.left + "px"),
        top: _.some(g - o.top + "px")
      };
    }, function(v, g) {
      return {
        position: _.some("fixed"),
        left: _.some(v + "px"),
        top: _.some(g + "px")
      };
    });
    return $({
      right: _.none(),
      bottom: _.none()
    }, l);
  }, Tq = function(t, r, o) {
    return t.fold(function(l, v) {
      return DB(l + r, v + o);
    }, function(l, v) {
      return Gb(l + r, v + o);
    }, function(l, v) {
      return yC(l + r, v + o);
    });
  }, M$ = function(t, r, o, l) {
    var v = function(g, b) {
      return function(T, A) {
        var R = g(r, o, l);
        return b(T.getOr(R.left), A.getOr(R.top));
      };
    };
    return t.fold(v(az, DB), v(X3, Gb), v(OB, yC));
  }, DB = R$.offset, Gb = R$.absolute, yC = R$.fixed, iz = function(t, r) {
    var o = So(t, r);
    return Q(o) ? NaN : parseInt(o, 10);
  }, Eq = function(t, r) {
    var o = t.element, l = iz(o, r.leftAttr), v = iz(o, r.topAttr);
    return isNaN(l) || isNaN(v) ? _.none() : _.some(eo(l, v));
  }, _q = function(t, r, o) {
    var l = t.element;
    Qr(l, r.leftAttr, o.left + "px"), Qr(l, r.topAttr, o.top + "px");
  }, Aq = function(t, r) {
    var o = t.element;
    Gi(o, r.leftAttr), Gi(o, r.topAttr);
  }, Oq = function(t, r, o, l) {
    return Eq(t, r).fold(function() {
      return o;
    }, function(v) {
      return yC(v.left + l.left, v.top + l.top);
    });
  }, Dq = function(t, r, o, l, v, g) {
    var b = Oq(t, r, o, l), T = r.mustSnap ? Rq(t, r, b, v, g) : Mq(t, r, b, v, g), A = OB(b, v, g);
    return _q(t, r, A), T.fold(function() {
      return {
        coord: yC(A.left, A.top),
        extra: _.none()
      };
    }, function(R) {
      return {
        coord: R.output,
        extra: R.extra
      };
    });
  }, Bq = function(t, r) {
    Aq(t, r);
  }, uz = function(t, r, o, l) {
    return Xt(t, function(v) {
      var g = v.sensor, b = xq(r, g, v.range.left, v.range.top, o, l);
      return b ? _.some({
        output: M$(v.output, r, o, l),
        extra: v.extra
      }) : _.none();
    });
  }, Rq = function(t, r, o, l, v) {
    var g = r.getSnapPoints(t), b = uz(g, o, l, v);
    return b.orThunk(function() {
      var T = Ke(g, function(A, R) {
        var z = R.sensor, U = kq(o, z, R.range.left, R.range.top, l, v);
        return A.deltas.fold(function() {
          return {
            deltas: _.some(U),
            snap: _.some(R)
          };
        }, function(oe) {
          var de = (U.left + U.top) / 2, Se = (oe.left + oe.top) / 2;
          return de <= Se ? {
            deltas: _.some(U),
            snap: _.some(R)
          } : A;
        });
      }, {
        deltas: _.none(),
        snap: _.none()
      });
      return T.snap.map(function(A) {
        return {
          output: M$(A.output, o, l, v),
          extra: A.extra
        };
      });
    });
  }, Mq = function(t, r, o, l, v) {
    var g = r.getSnapPoints(t);
    return uz(g, o, l, v);
  }, Pq = function(t, r, o) {
    return {
      coord: M$(t.output, t.output, r, o),
      extra: t.extra
    };
  }, Nq = function(t, r, o, l) {
    var v = r.getTarget(t.element);
    if (r.repositionTarget) {
      var g = wo(t.element), b = Us(g), T = P3(v), A = Pq(l, b, T), R = oz(A.coord, b, T);
      zo(v, R);
    }
  }, Iq = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    snapTo: Nq
  }), P$ = "data-initial-z-index", Fq = function(t) {
    Co(t.element).filter(Z).each(function(r) {
      No(r, P$).fold(function() {
        return Da(r, "z-index");
      }, function(o) {
        return Pr(r, "z-index", o);
      }), Gi(r, P$);
    });
  }, $q = function(t) {
    Co(t.element).filter(Z).each(function(r) {
      ui(r, "z-index").each(function(o) {
        Qr(r, P$, o);
      }), Pr(r, "z-index", Ho(t.element, "z-index"));
    });
  }, sz = function(t, r) {
    t.getSystem().addToGui(r), $q(r);
  }, Lq = function(t) {
    Fq(t), t.getSystem().removeFromGui(t);
  }, lz = function(t, r, o) {
    return t.getSystem().build(ms.sketch({
      dom: {
        styles: {
          left: "0px",
          top: "0px",
          width: "100%",
          height: "100%",
          position: "fixed",
          "z-index": "1000000000000000"
        },
        classes: [r]
      },
      events: o
    }));
  }, zq = qs("snaps", [
    un("getSnapPoints"),
    Ra("onSensor"),
    un("leftAttr"),
    un("topAttr"),
    ct("lazyViewport", uu),
    ct("mustSnap", !1)
  ]), N$ = [
    ct("useFixed", ge),
    un("blockerClass"),
    ct("getTarget", Ze),
    ct("onDrag", ee),
    ct("repositionTarget", !0),
    ct("onDrop", ee),
    co("getBounds", uu),
    zq
  ], Hq = function(t) {
    return Qo(ui(t, "left"), ui(t, "top"), ui(t, "position"), function(r, o, l) {
      var v = l === "fixed" ? yC : DB;
      return v(parseInt(r, 10), parseInt(o, 10));
    }).getOrThunk(function() {
      var r = ts(t);
      return Gb(r.left, r.top);
    });
  }, Vq = function(t, r, o, l, v) {
    var g = v.bounds, b = X3(r, o, l), T = Xs(b.left, g.x, g.x + g.width - v.width), A = Xs(b.top, g.y, g.y + g.height - v.height), R = Gb(T, A);
    return r.fold(function() {
      var z = az(R, o, l);
      return DB(z.left, z.top);
    }, ie(R), function() {
      var z = OB(R, o, l);
      return yC(z.left, z.top);
    });
  }, Uq = function(t, r, o, l, v, g, b) {
    var T = r.fold(function() {
      var A = Tq(o, g.left, g.top), R = OB(A, l, v);
      return yC(R.left, R.top);
    }, function(A) {
      var R = Dq(t, A, o, g, l, v);
      return R.extra.each(function(z) {
        A.onSensor(t, z);
      }), R.coord;
    });
    return Vq(t, T, l, v, b);
  }, jq = function(t, r, o, l) {
    var v = r.getTarget(t.element);
    if (r.repositionTarget) {
      var g = wo(t.element), b = Us(g), T = P3(v), A = Hq(v), R = Uq(t, r.snaps, A, b, T, l, o), z = oz(R, b, T);
      zo(v, z);
    }
    r.onDrag(t, v, l);
  }, cz = function(t, r) {
    return {
      bounds: t.getBounds(),
      height: Vs(r.element),
      width: ns(r.element)
    };
  }, I$ = function(t, r, o, l, v) {
    var g = o.update(l, v), b = o.getStartData().getOrThunk(function() {
      return cz(r, t);
    });
    g.each(function(T) {
      jq(t, r, b, T);
    });
  }, fz = function(t, r, o, l) {
    r.each(Lq), o.snaps.each(function(g) {
      Bq(t, g);
    });
    var v = o.getTarget(t.element);
    l.reset(), o.onDrop(t, v);
  }, F$ = function(t) {
    return function(r, o) {
      var l = function(v) {
        o.setStartData(cz(r, v));
      };
      return ro(ae([cn(by(), function(v) {
        o.getStartData().each(function() {
          return l(v);
        });
      })], t(r, o, l), !0));
    };
  }, Wq = function(t) {
    return ro([
      cn(Ql(), t.forceDrop),
      cn(vy(), t.drop),
      cn($d(), function(r, o) {
        t.move(o.event);
      }),
      cn(fy(), t.delayDrop)
    ]);
  }, Gq = function(t) {
    return _.from(eo(t.x, t.y));
  }, Kq = function(t, r) {
    return eo(r.left - t.left, r.top - t.top);
  }, Xq = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    getData: Gq,
    getDelta: Kq
  }), vz = function(t, r, o) {
    return [cn(Ql(), function(l, v) {
      var g = v.event.raw;
      if (g.button === 0) {
        v.stop();
        var b = function() {
          return fz(l, _.some(R), t, r);
        }, T = d6(b, 200), A = {
          drop: b,
          delayDrop: T.schedule,
          forceDrop: b,
          move: function(U) {
            T.cancel(), I$(l, t, r, Xq, U);
          }
        }, R = lz(l, t.blockerClass, Wq(A)), z = function() {
          o(l), sz(l, R);
        };
        z();
      }
    })];
  }, Yq = ae(ae([], N$, !0), [io("dragger", { handlers: F$(vz) })], !1), Zq = function(t) {
    return ro([
      cn(of(), t.forceDrop),
      cn(Lv(), t.drop),
      cn(ZC(), t.drop),
      cn(Jl(), function(r, o) {
        t.move(o.event);
      })
    ]);
  }, Jq = function(t) {
    var r = t[0];
    return _.some(eo(r.clientX, r.clientY));
  }, Qq = function(t) {
    var r = t.raw, o = r.touches;
    return o.length === 1 ? Jq(o) : _.none();
  }, eG = function(t, r) {
    return eo(r.left - t.left, r.top - t.top);
  }, dz = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    getData: Qq,
    getDelta: eG
  }), mz = function(t, r, o) {
    var l = Zo(), v = function(g) {
      fz(g, l.get(), t, r), l.clear();
    };
    return [
      cn(of(), function(g, b) {
        b.stop();
        var T = function() {
          return v(g);
        }, A = {
          drop: T,
          delayDrop: ee,
          forceDrop: T,
          move: function(U) {
            I$(g, t, r, dz, U);
          }
        }, R = lz(g, t.blockerClass, Zq(A));
        l.set(R);
        var z = function() {
          o(g), sz(g, R);
        };
        z();
      }),
      cn(Jl(), function(g, b) {
        b.stop(), I$(g, t, r, dz, b.event);
      }),
      cn(Lv(), function(g, b) {
        b.stop(), v(g);
      }),
      cn(ZC(), v)
    ];
  }, tG = ae(ae([], N$, !0), [io("dragger", { handlers: F$(mz) })], !1), nG = function(t, r, o) {
    return ae(ae([], vz(t, r, o), !0), mz(t, r, o), !0);
  }, rG = ae(ae([], N$, !0), [io("dragger", { handlers: F$(nG) })], !1), aG = Yq, oG = tG, iG = rG, uG = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    mouse: aG,
    touch: oG,
    mouseOrTouch: iG
  }), sG = function() {
    var t = _.none(), r = _.none(), o = function() {
      t = _.none(), r = _.none();
    }, l = function(A, R) {
      var z = t.map(function(U) {
        return A.getDelta(U, R);
      });
      return t = _.some(R), z;
    }, v = function(A, R) {
      return A.getData(R).bind(function(z) {
        return l(A, z);
      });
    }, g = function(A) {
      r = _.some(A);
    }, b = function() {
      return r;
    }, T = ie({});
    return Pu({
      readState: T,
      reset: o,
      update: v,
      getStartData: b,
      setStartData: g
    });
  }, lG = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    init: sG
  }), wC = nm({
    branchKey: "mode",
    branches: uG,
    name: "dragging",
    active: {
      events: function(t, r) {
        var o = t.dragger;
        return o.handlers(t, r);
      }
    },
    extra: {
      snap: function(t) {
        return {
          sensor: t.sensor,
          range: t.range,
          output: t.output,
          extra: _.from(t.extra)
        };
      }
    },
    state: lG,
    apis: Iq
  }), $$ = 40, BB = $$ / 2, gz = function(t, r, o, l, v, g) {
    return t.fold(function() {
      return wC.snap({
        sensor: Gb(o - BB, l - BB),
        range: eo(v, g),
        output: Gb(_.some(o), _.some(l)),
        extra: { td: r }
      });
    }, function(b) {
      var T = o - BB, A = l - BB, R = $$, z = $$, U = b.element.dom.getBoundingClientRect();
      return wC.snap({
        sensor: Gb(T, A),
        range: eo(R, z),
        output: Gb(_.some(o - U.width / 2), _.some(l - U.height / 2)),
        extra: { td: r }
      });
    });
  }, pz = function(t, r, o) {
    var l = function(v, g) {
      return v.exists(function(b) {
        return Fa(b, g);
      });
    };
    return {
      getSnapPoints: t,
      leftAttr: "data-drag-left",
      topAttr: "data-drag-top",
      onSensor: function(v, g) {
        var b = g.td;
        l(r.get(), b) || (r.set(b), o(b));
      },
      mustSnap: !0
    };
  }, hz = function(t) {
    return La(Js.sketch({
      dom: {
        tag: "div",
        classes: ["tox-selector"]
      },
      buttonBehaviours: Fn([
        wC.config({
          mode: "mouseOrTouch",
          blockerClass: "blocker",
          snaps: t
        }),
        Kw.config({})
      ]),
      eventOrder: {
        mousedown: [
          "dragging",
          "alloy.base.behaviour"
        ],
        touchstart: [
          "dragging",
          "alloy.base.behaviour"
        ]
      }
    }));
  }, cG = function(t, r) {
    var o = Sr([]), l = Sr([]), v = Sr(!1), g = Zo(), b = Zo(), T = function(an) {
      var qn = ef(an);
      return gz(de.getOpt(r), an, qn.x, qn.y, qn.width, qn.height);
    }, A = function() {
      return _t(o.get(), function(an) {
        return T(an);
      });
    }, R = function(an) {
      var qn = ef(an);
      return gz(Se.getOpt(r), an, qn.right, qn.bottom, qn.width, qn.height);
    }, z = function() {
      return _t(l.get(), function(an) {
        return R(an);
      });
    }, U = pz(A, g, function(an) {
      b.get().each(function(qn) {
        t.fire("TableSelectorChange", {
          start: an,
          finish: qn
        });
      });
    }), oe = pz(z, b, function(an) {
      g.get().each(function(qn) {
        t.fire("TableSelectorChange", {
          start: qn,
          finish: an
        });
      });
    }), de = hz(U), Se = hz(oe), $e = ko(de.asSpec()), ut = ko(Se.asSpec()), Ne = function(an, qn, vn, Gn) {
      var pn = qn.dom.getBoundingClientRect();
      Da(an.element, "display");
      var nn = ol(Bn.fromDom(t.getBody())).dom.innerHeight, Wn = vn(pn), cr = Gn(pn, nn);
      (Wn || cr) && Pr(an.element, "display", "none");
    }, ft = function(an, qn, vn, Gn) {
      var pn = vn(qn);
      wC.snapTo(an, pn);
      var nn = function(cr) {
        return cr[Gn] < 0;
      }, Wn = function(cr, dn) {
        return cr[Gn] > dn;
      };
      Ne(an, qn, nn, Wn);
    }, Ht = function(an) {
      return ft($e, an, T, "top");
    }, Kt = function() {
      return g.get().each(Ht);
    }, st = function(an) {
      return ft(ut, an, R, "bottom");
    }, Bt = function() {
      return b.get().each(st);
    };
    br().deviceType.isTouch() && (t.on("TableSelectionChange", function(an) {
      v.get() || (lm(r, $e), lm(r, ut), v.set(!0)), g.set(an.start), b.set(an.finish), an.otherCells.each(function(qn) {
        o.set(qn.upOrLeftCells), l.set(qn.downOrRightCells), Ht(an.start), st(an.finish);
      });
    }), t.on("ResizeEditor ResizeWindow ScrollContent", function() {
      Kt(), Bt();
    }), t.on("TableSelectionClear", function() {
      v.get() && ($c($e), $c(ut), v.set(!1)), g.clear(), b.clear();
    }));
  }, fG = function(t) {
    return t.nodeType === 1 && (t.nodeName === "BR" || !!t.getAttribute("data-mce-bogus") || t.getAttribute("data-mce-type") === "bookmark");
  }, vG = function(t, r, o) {
    r.delimiter || (r.delimiter = "\xBB");
    var l = function(g) {
      var b = g || [], T = _t(b, function(R, z) {
        return Js.sketch({
          dom: {
            tag: "div",
            classes: ["tox-statusbar__path-item"],
            attributes: {
              role: "button",
              "data-index": z,
              "tab-index": -1,
              "aria-level": z + 1
            },
            innerHtml: R.name
          },
          action: function(U) {
            t.focus(), t.selection.select(R.element), t.nodeChanged();
          },
          buttonBehaviours: Fn([
            Of.button(o.isDisabled),
            Ui()
          ])
        });
      }), A = {
        dom: {
          tag: "div",
          classes: ["tox-statusbar__path-divider"],
          attributes: { "aria-hidden": !0 },
          innerHtml: " " + r.delimiter + " "
        }
      };
      return Ke(T.slice(1), function(R, z) {
        var U = R;
        return U.push(A), U.push(z), U;
      }, [T[0]]);
    }, v = function(g) {
      for (var b = [], T = g.length; T-- > 0; ) {
        var A = g[T];
        if (A.nodeType === 1 && !fG(A)) {
          var R = t.fire("ResolveName", {
            name: A.nodeName.toLowerCase(),
            target: A
          });
          if (R.isDefaultPrevented() || b.push({
            name: R.name,
            element: A
          }), R.isPropagationStopped())
            break;
        }
      }
      return b;
    };
    return {
      dom: {
        tag: "div",
        classes: ["tox-statusbar__path"],
        attributes: { role: "navigation" }
      },
      behaviours: Fn([
        Er.config({
          mode: "flow",
          selector: "div[role=button]"
        }),
        Cr.config({ disabled: o.isDisabled }),
        Ui(),
        ci.config({}),
        qr.config({}),
        Jr("elementPathEvents", [Zr(function(g, b) {
          t.shortcuts.add("alt+F11", "focus statusbar elementpath", function() {
            return Er.focusIn(g);
          }), t.on("NodeChange", function(T) {
            var A = v(T.parents);
            A.length > 0 ? qr.set(g, l(A)) : qr.set(g, []);
          });
        })])
      ]),
      components: []
    };
  }, CC;
  (function(t) {
    t[t.None = 0] = "None", t[t.Both = 1] = "Both", t[t.Vertical = 2] = "Vertical";
  })(CC || (CC = {}));
  var dG = function(t, r, o, l, v) {
    var g = {};
    return g.height = kB(l + r.top, iO(t), uO(t)), o === CC.Both && (g.width = kB(v + r.left, o_(t), A4(t))), g;
  }, bz = function(t, r, o) {
    var l = Bn.fromDom(t.getContainer()), v = dG(t, r, o, hi(l), Au(l));
    Un(v, function(g, b) {
      return Pr(l, b, k$(g));
    }), e7(t);
  }, mG = function(t) {
    var r = !t.hasPlugin("autoresize"), o = t.getParam("resize", r);
    return o === !1 ? CC.None : o === "both" ? CC.Both : CC.Vertical;
  }, RB = function(t, r, o, l) {
    var v = 20, g = eo(o * v, l * v);
    return bz(t, g, r), _.some(!0);
  }, gG = function(t, r) {
    var o = mG(t);
    return o === CC.None ? _.none() : _.some(wv("resize-handle", {
      tag: "div",
      classes: ["tox-statusbar__resize-handle"],
      attributes: { title: r.translate("Resize") },
      behaviours: [
        wC.config({
          mode: "mouse",
          repositionTarget: !1,
          onDrag: function(l, v, g) {
            return bz(t, g, o);
          },
          blockerClass: "tox-blocker"
        }),
        Er.config({
          mode: "special",
          onLeft: function() {
            return RB(t, o, -1, 0);
          },
          onRight: function() {
            return RB(t, o, 1, 0);
          },
          onUp: function() {
            return RB(t, o, 0, -1);
          },
          onDown: function() {
            return RB(t, o, 0, 1);
          }
        }),
        ci.config({}),
        zr.config({})
      ]
    }, r.icons));
  }, pG = function(t, r) {
    var o, l = function(v, g, b) {
      return qr.set(v, [vu(r.translate([
        "{0} " + b,
        g[b]
      ]))]);
    };
    return Js.sketch({
      dom: {
        tag: "button",
        classes: ["tox-statusbar__wordcount"]
      },
      components: [],
      buttonBehaviours: Fn([
        Of.button(r.isDisabled),
        Ui(),
        ci.config({}),
        qr.config({}),
        jn.config({
          store: {
            mode: "memory",
            initialValue: {
              mode: "words",
              count: {
                words: 0,
                characters: 0
              }
            }
          }
        }),
        Jr("wordcount-events", [
          Ks(function(v) {
            var g = jn.getValue(v), b = g.mode === "words" ? "characters" : "words";
            jn.setValue(v, {
              mode: b,
              count: g.count
            }), l(v, g.count, b);
          }),
          Zr(function(v) {
            t.on("wordCountUpdate", function(g) {
              var b = jn.getValue(v).mode;
              jn.setValue(v, {
                mode: b,
                count: g.wordCount
              }), l(v, g.wordCount, b);
            });
          })
        ])
      ]),
      eventOrder: (o = {}, o[vl()] = [
        "disabling",
        "alloy.base.behaviour",
        "wordcount-events"
      ], o)
    });
  }, hG = function(t, r) {
    var o = function() {
      var g = Af.translate([
        "Powered by {0}",
        "Tiny"
      ]), b = '<a href="https://www.tiny.cloud/?utm_campaign=editor_referral&amp;utm_medium=poweredby&amp;utm_source=tinymce&amp;utm_content=v5" rel="noopener" target="_blank" tabindex="-1" aria-label="' + g + '">' + g + "</a>";
      return {
        dom: {
          tag: "span",
          classes: ["tox-statusbar__branding"],
          innerHtml: b
        }
      };
    }, l = function() {
      var g = [];
      return t.getParam("elementpath", !0, "boolean") && g.push(vG(t, {}, r)), t.hasPlugin("wordcount") && g.push(pG(t, r)), t.getParam("branding", !0, "boolean") && g.push(o()), g.length > 0 ? [{
        dom: {
          tag: "div",
          classes: ["tox-statusbar__text-container"]
        },
        components: g
      }] : [];
    }, v = function() {
      var g = l(), b = gG(t, r);
      return g.concat(b.toArray());
    };
    return {
      dom: {
        tag: "div",
        classes: ["tox-statusbar"]
      },
      components: v()
    };
  }, bG = function(t) {
    var r, o = t.inline, l = o ? tW : Kj, v = B4(t) ? H3 : jF, g = _.none(), b = br(), T = b.browser.isIE(), A = T ? ["tox-platform-ie"] : [], R = b.deviceType.isTouch(), z = "tox-platform-touch", U = R ? [z] : [], oe = dO(t), de = pO(t), Se = Af.isRtl() ? { attributes: { dir: "rtl" } } : {}, $e = { attributes: (r = {}, r[w0] = oe ? gf.BottomToTop : gf.TopToBottom, r) }, ut = function() {
      return g.bind(Ci.getHeader);
    }, Ne = function() {
      return v.isDocked(ut);
    }, ft = function() {
      Pr(dc.element, "width", document.body.clientWidth + "px");
    }, Ht = function() {
      var Ns = Fa($a(), de) && Ho(de, "display") === "grid", Kb = {
        dom: $({
          tag: "div",
          classes: [
            "tox",
            "tox-silver-sink",
            "tox-tinymce-aux"
          ].concat(A).concat(U)
        }, Se),
        behaviours: Fn([Jo.config({
          useFixed: function() {
            return Ne();
          }
        })])
      }, Z3 = {
        dom: { styles: { width: document.body.clientWidth + "px" } },
        events: ro([cn(dl(), ft)])
      };
      return Gt(Kb, Ns ? Z3 : {});
    }, Kt = ko(Ht()), st = function() {
      return ea.value(Kt);
    }, Bt = La({
      dom: {
        tag: "div",
        classes: ["tox-anchorbar"]
      }
    }), an = function() {
      return g.bind(function(Ns) {
        return Bt.getOpt(Ns);
      }).getOrDie("Could not find a anchor bar element");
    }, qn = function() {
      return g.bind(function(Ns) {
        return Ci.getToolbar(Ns);
      }).getOrDie("Could not find more toolbar element");
    }, vn = function() {
      return g.bind(function(Ns) {
        return Ci.getThrobber(Ns);
      }).getOrDie("Could not find throbber element");
    }, Gn = R3(Kt, t, an), pn = Ci.parts.menubar({
      dom: {
        tag: "div",
        classes: ["tox-menubar"]
      },
      backstage: Gn,
      onEscape: function() {
        t.focus();
      }
    }), nn = Pw(t), Wn = Ci.parts.toolbar($({
      dom: {
        tag: "div",
        classes: ["tox-toolbar"]
      },
      getSink: st,
      providers: Gn.shared.providers,
      onEscape: function() {
        t.focus();
      },
      type: nn,
      lazyToolbar: qn,
      lazyHeader: function() {
        return ut().getOrDie("Could not find header element");
      }
    }, $e)), cr = Ci.parts["multiple-toolbar"]({
      dom: {
        tag: "div",
        classes: ["tox-toolbar-overlord"]
      },
      providers: Gn.shared.providers,
      onEscape: function() {
        t.focus();
      },
      type: nn
    }), dn = Ci.parts.socket({
      dom: {
        tag: "div",
        classes: ["tox-edit-area"]
      }
    }), ar = Ci.parts.sidebar({
      dom: {
        tag: "div",
        classes: ["tox-sidebar"]
      }
    }), pr = Ci.parts.throbber({
      dom: {
        tag: "div",
        classes: ["tox-throbber"]
      },
      backstage: Gn
    }), ha = t.getParam("statusbar", !0, "boolean"), Ka = ha && !o ? _.some(hG(t, Gn.shared.providers)) : _.none(), qo = {
      dom: {
        tag: "div",
        classes: ["tox-sidebar-wrap"]
      },
      components: [
        dn,
        ar
      ]
    }, Dv = O4(t), $f = u_(t), Z$ = i_(t), J$ = function() {
      return Dv ? [cr] : $f ? [Wn] : [];
    }, PB = Ci.parts.header({
      dom: $({
        tag: "div",
        classes: ["tox-editor-header"]
      }, $e),
      components: Ie([
        Z$ ? [pn] : [],
        J$(),
        D4(t) ? [] : [Bt.asSpec()]
      ]),
      sticky: B4(t),
      editor: t,
      sharedBackstage: Gn.shared
    }), Q$ = Ie([
      oe ? [] : [PB],
      o ? [] : [qo],
      oe ? [PB] : []
    ]), i5 = {
      dom: {
        tag: "div",
        classes: ["tox-editor-container"]
      },
      components: Q$
    }, NB = Ie([
      [i5],
      o ? [] : Ka.toArray(),
      [pr]
    ]), u5 = hO(t), IB = $($({ role: "application" }, Af.isRtl() ? { dir: "rtl" } : {}), u5 ? { "aria-hidden": "true" } : {}), Ad = ko(Ci.sketch({
      dom: {
        tag: "div",
        classes: [
          "tox",
          "tox-tinymce"
        ].concat(o ? ["tox-tinymce-inline"] : []).concat(oe ? ["tox-tinymce--toolbar-bottom"] : []).concat(U).concat(A),
        styles: $({ visibility: "hidden" }, u5 ? {
          opacity: "0",
          border: "0"
        } : {}),
        attributes: IB
      },
      components: NB,
      behaviours: Fn([
        Ui(),
        Cr.config({ disableClass: "tox-tinymce--disabled" }),
        Er.config({
          mode: "cyclic",
          selector: ".tox-menubar, .tox-toolbar, .tox-toolbar__primary, .tox-toolbar__overflow--open, .tox-sidebar__overflow--open, .tox-statusbar__path, .tox-statusbar__wordcount, .tox-statusbar__branding a, .tox-statusbar__resize-handle"
        })
      ])
    }));
    g = _.some(Ad), t.shortcuts.add("alt+F9", "focus menubar", function() {
      Ci.focusMenubar(Ad);
    }), t.shortcuts.add("alt+F10", "focus toolbar", function() {
      Ci.focusToolbar(Ad);
    }), t.addCommand("ToggleToolbarDrawer", function() {
      Ci.toggleToolbarDrawer(Ad);
    }), t.addQueryStateHandler("ToggleToolbarDrawer", function() {
      return Ci.isToolbarDrawerToggled(Ad);
    });
    var s5 = w6(Ad), dc = w6(Kt);
    FF(t, s5, dc);
    var e9 = function() {
      var Ns = {
        broadcastAll: dc.broadcast,
        broadcastOn: dc.broadcastOn,
        register: ee
      };
      return { channels: Ns };
    }, t9 = function() {
      var Ns = k$(Yj(t)), Kb = k$(Zj(t));
      return t.inline || (il("div", "width", Kb) && Pr(Ad.element, "width", Kb), il("div", "height", Ns) ? Pr(Ad.element, "height", Ns) : Pr(Ad.element, "height", "200px")), Ns;
    }, n9 = function() {
      v.setup(t, Gn.shared, ut), QW(t, Gn), Sq(t, st, Gn), be(t), Wo(t, vn, Gn.shared), Tn(CM(t), function(gc, Bv) {
        t.ui.registry.addGroupToolbarButton(Bv, gc);
      });
      var Ns = t.ui.registry.getAll(), Kb = Ns.buttons, Z3 = Ns.menuItems, r9 = Ns.contextToolbars, J3 = Ns.sidebars, a9 = fO(t), Jn = {
        menuItems: Z3,
        menus: kM(t),
        menubar: TM(t),
        toolbar: a9.getOrThunk(function() {
          return EM(t);
        }),
        allowToolbarGroups: nn === lc.floating,
        buttons: Kb,
        sidebar: J3
      };
      EW(t, r9, Kt, { backstage: Gn }), cG(t, Kt);
      var ia = t.getElement(), Za = t9(), di = {
        mothership: s5,
        uiMothership: dc,
        outerContainer: Ad
      }, mc = {
        targetNode: ia,
        height: Za
      };
      return l.render(t, di, Jn, Gn, mc);
    };
    return {
      mothership: s5,
      uiMothership: dc,
      backstage: Gn,
      renderUI: n9,
      getUi: e9
    };
  }, yG = function(t, r) {
    var o = _.from(So(t, "id")).fold(function() {
      var l = ur("dialog-describe");
      return Qr(r, "id", l), l;
    }, Ze);
    Qr(t, "aria-describedby", o);
  }, wG = function(t, r) {
    var o = No(t, "id").fold(function() {
      var l = ur("dialog-label");
      return Qr(r, "id", l), l;
    }, Ze);
    Qr(t, "aria-labelledby", o);
  }, CG = ie([
    un("lazySink"),
    Ba("dragBlockClass"),
    co("getBounds", uu),
    ct("useTabstopAt", xe),
    ct("eventOrder", {}),
    Ni("modalBehaviours", [Er]),
    Ri("onExecute"),
    Ts("onEscape")
  ]), L$ = { sketch: Ze }, SG = ie([
    Nl({
      name: "draghandle",
      overrides: function(t, r) {
        return {
          behaviours: Fn([wC.config({
            mode: "mouse",
            getTarget: function(o) {
              return Y1(o, '[role="dialog"]').getOr(o);
            },
            blockerClass: t.dragBlockClass.getOrDie(new Error(`The drag blocker class was not specified for a dialog with a drag handle: 
` + JSON.stringify(r, null, 2)).message),
            getBounds: t.getDragBounds
          })])
        };
      }
    }),
    hu({
      schema: [un("dom")],
      name: "title"
    }),
    hu({
      factory: L$,
      schema: [un("dom")],
      name: "close"
    }),
    hu({
      factory: L$,
      schema: [un("dom")],
      name: "body"
    }),
    Nl({
      factory: L$,
      schema: [un("dom")],
      name: "footer"
    }),
    wl({
      factory: {
        sketch: function(t, r) {
          return $($({}, t), {
            dom: r.dom,
            components: r.components
          });
        }
      },
      schema: [
        ct("dom", {
          tag: "div",
          styles: {
            position: "fixed",
            left: "0px",
            top: "0px",
            right: "0px",
            bottom: "0px"
          }
        }),
        ct("components", [])
      ],
      name: "blocker"
    })
  ]), xG = function(t, r, o, l) {
    var v, g = Zo(), b = function(Se) {
      g.set(Se);
      var $e = t.lazySink(Se).getOrDie(), ut = l.blocker(), Ne = $e.getSystem().build($($({}, ut), {
        components: ut.components.concat([yl(Se)]),
        behaviours: Fn([
          zr.config({}),
          Jr("dialog-blocker-events", [li(Ol(), function() {
            Er.focusIn(Se);
          })])
        ])
      }));
      lm($e, Ne), Er.focusIn(Se);
    }, T = function(Se) {
      g.clear(), Co(Se.element).each(function($e) {
        Se.getSystem().getByDom($e).each(function(ut) {
          $c(ut);
        });
      });
    }, A = function(Se) {
      return xf(Se, t, "body");
    }, R = function(Se) {
      return xf(Se, t, "footer");
    }, z = function(Se, $e) {
      kn.block(Se, $e);
    }, U = function(Se) {
      kn.unblock(Se);
    }, oe = ur("modal-events"), de = $($({}, t.eventOrder), (v = {}, v[Gs()] = [oe].concat(t.eventOrder["alloy.system.attached"] || []), v));
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      apis: {
        show: b,
        hide: T,
        getBody: A,
        getFooter: R,
        setIdle: U,
        setBusy: z
      },
      eventOrder: de,
      domModification: {
        attributes: {
          role: "dialog",
          "aria-modal": "true"
        }
      },
      behaviours: Zi(t.modalBehaviours, [
        qr.config({}),
        Er.config({
          mode: "cyclic",
          onEnter: t.onExecute,
          onEscape: t.onEscape,
          useTabstopAt: t.useTabstopAt
        }),
        kn.config({ getRoot: g.get }),
        Jr(oe, [Zr(function(Se) {
          wG(Se.element, xf(Se, t, "title").element), yG(Se.element, xf(Se, t, "body").element);
        })])
      ])
    };
  }, wu = ds({
    name: "ModalDialog",
    configFields: CG(),
    partFields: SG(),
    factory: xG,
    apis: {
      show: function(t, r) {
        t.show(r);
      },
      hide: function(t, r) {
        t.hide(r);
      },
      getBody: function(t, r) {
        return t.getBody(r);
      },
      getFooter: function(t, r) {
        return t.getFooter(r);
      },
      setBusy: function(t, r, o) {
        t.setBusy(r, o);
      },
      setIdle: function(t, r) {
        t.setIdle(r);
      }
    }
  }), kG = hr([
    Lr("type"),
    Lr("name")
  ].concat(hp)), TG = Ki, yz = [
    Oi("name", "name", da(function() {
      return ur("button-name");
    }), ri),
    lo("icon"),
    cl("align", "end", [
      "start",
      "end"
    ]),
    no("primary", !1),
    no("disabled", !1)
  ], wz = ae(ae([], yz, !0), [Lr("text")], !1), z$ = ae([ll("type", [
    "submit",
    "cancel",
    "custom"
  ])], wz, !0), EG = ae([
    ll("type", ["menu"]),
    lo("text"),
    lo("tooltip"),
    lo("icon"),
    Ru("items", kG)
  ], yz, !0), _G = Al("type", {
    submit: z$,
    cancel: z$,
    custom: z$,
    menu: EG
  }), AG = [
    Lr("type"),
    Lr("text"),
    ll("level", [
      "info",
      "warn",
      "error",
      "success"
    ]),
    Lr("icon"),
    ct("url", "")
  ], OG = hr(AG), DG = function(t) {
    return [
      Lr("type"),
      t
    ];
  }, BG = [
    Lr("type"),
    Lr("text"),
    no("disabled", !1),
    no("primary", !1),
    Oi("name", "name", da(function() {
      return ur("button-name");
    }), ri),
    lo("icon"),
    no("borderless", !1)
  ], RG = hr(BG), MG = [
    Lr("type"),
    Lr("name"),
    Lr("label"),
    no("disabled", !1)
  ], PG = hr(MG), NG = Ki, H$ = [
    Lr("type"),
    Lr("name")
  ], _d = H$.concat([lo("label")]), IG = _d.concat([ct("columns", "auto")]), FG = hr(IG), $G = oy([
    Lr("value"),
    Lr("text"),
    Lr("icon")
  ]), LG = _d, zG = hr(LG), HG = ri, VG = _d, UG = hr(VG), jG = ri, WG = H$.concat([
    ng("tag", "textarea"),
    Lr("scriptId"),
    Lr("scriptUrl"),
    ks("settings", void 0)
  ]), qG = H$.concat([
    ng("tag", "textarea"),
    Uu("init")
  ]), GG = eg(function(t) {
    return Io("customeditor.old", js(qG), t).orThunk(function() {
      return Io("customeditor.new", js(WG), t);
    });
  }), KG = ri, XG = _d, YG = hr(XG), ZG = yk(), JG = function(t) {
    return [
      Lr("type"),
      ev("columns"),
      t
    ];
  }, QG = [
    Lr("type"),
    Lr("html"),
    cl("presets", "presentation", [
      "presentation",
      "document"
    ])
  ], eK = hr(QG), tK = _d.concat([no("sandboxed", !0)]), nK = hr(tK), rK = ri, aK = _d.concat([xs("currentState", hr([
    un("blob"),
    Lr("url")
  ]))]), oK = hr(aK), iK = _d.concat([
    lo("inputMode"),
    lo("placeholder"),
    no("maximized", !1),
    no("disabled", !1)
  ]), uK = hr(iK), sK = ri, lK = function(t) {
    return [
      Lr("type"),
      Lr("label"),
      t
    ];
  }, cK = [
    Lr("text"),
    Lr("value")
  ], fK = [
    Lr("text"),
    Ru("items", wk("items", function() {
      return Cz;
    }))
  ], Cz = Up([
    hr(cK),
    hr(fK)
  ]), vK = _d.concat([
    Ru("items", Cz),
    no("disabled", !1)
  ]), dK = hr(vK), mK = ri, gK = _d.concat([
    Zl("items", [
      Lr("text"),
      Lr("value")
    ]),
    Ac("size", 1),
    no("disabled", !1)
  ]), pK = hr(gK), hK = ri, bK = _d.concat([
    no("constrain", !0),
    no("disabled", !1)
  ]), yK = hr(bK), Sz = hr([
    Lr("width"),
    Lr("height")
  ]), wK = [
    Lr("type"),
    Ru("header", ri),
    Ru("cells", Qf(ri))
  ], CK = hr(wK), SK = _d.concat([
    lo("placeholder"),
    no("maximized", !1),
    no("disabled", !1)
  ]), xK = hr(SK), kK = ri, TK = _d.concat([
    cl("filetype", "file", [
      "image",
      "media",
      "file"
    ]),
    ct("disabled", !1)
  ]), EK = hr(TK), _K = hr([
    Lr("value"),
    ct("meta", {})
  ]), V$ = function(t) {
    return Oi("items", "items", Wr(), Qf(eg(function(r) {
      return Io("Checking item of " + t, U$, r).fold(function(o) {
        return ea.error(Fv(o));
      }, function(o) {
        return ea.value(o);
      });
    })));
  }, U$ = UC(function() {
    return E1("type", {
      alertbanner: OG,
      bar: hr(DG(V$("bar"))),
      button: RG,
      checkbox: PG,
      colorinput: zG,
      colorpicker: UG,
      dropzone: YG,
      grid: hr(JG(V$("grid"))),
      iframe: nK,
      input: uK,
      listbox: dK,
      selectbox: pK,
      sizeinput: yK,
      textarea: xK,
      urlinput: EK,
      customeditor: GG,
      htmlpanel: eK,
      imagetools: oK,
      collection: FG,
      label: hr(lK(V$("label"))),
      table: CK,
      panel: xz
    });
  }), AK = [
    Lr("type"),
    ct("classes", []),
    Ru("items", U$)
  ], xz = hr(AK), OK = [
    Oi("name", "name", da(function() {
      return ur("tab-name");
    }), ri),
    Lr("title"),
    Ru("items", U$)
  ], DK = [
    Lr("type"),
    Zl("tabs", OK)
  ], BK = hr(DK), RK = wz, MK = _G, PK = hr([
    Lr("title"),
    xs("body", E1("type", {
      panel: xz,
      tabpanel: BK
    })),
    ng("size", "normal"),
    Ru("buttons", MK),
    ct("initialData", {}),
    co("onAction", ee),
    co("onChange", ee),
    co("onSubmit", ee),
    co("onClose", ee),
    co("onCancel", ee),
    ct("onTabChange", ee)
  ]), NK = function(t) {
    return Io("dialog", PK, t);
  }, IK = hr(ae([ll("type", [
    "cancel",
    "custom"
  ])], RK, !0)), FK = hr([
    Lr("title"),
    Lr("url"),
    Fd("height"),
    Fd("width"),
    Ws("buttons", IK),
    co("onAction", ee),
    co("onCancel", ee),
    co("onClose", ee),
    co("onMessage", ee)
  ]), $K = function(t) {
    return Io("dialog", FK, t);
  }, j$ = function(t) {
    return H(t) ? [t].concat(St(Yt(t), j$)) : X(t) ? St(t, j$) : [];
  }, LK = function(t) {
    return P(t.type) && P(t.name);
  }, zK = {
    checkbox: NG,
    colorinput: HG,
    colorpicker: jG,
    dropzone: ZG,
    input: sK,
    iframe: rK,
    sizeinput: Sz,
    selectbox: hK,
    listbox: mK,
    size: Sz,
    textarea: kK,
    urlinput: _K,
    customeditor: KG,
    collection: $G,
    togglemenuitem: TG
  }, HK = function(t) {
    return _.from(zK[t.type]);
  }, VK = function(t) {
    return We(j$(t), LK);
  }, UK = function(t) {
    var r = VK(t), o = St(r, function(l) {
      return HK(l).fold(function() {
        return [];
      }, function(v) {
        return [xs(l.name, v)];
      });
    });
    return hr(o);
  }, kz = function(t) {
    var r = Yl(NK(t)), o = UK(t), l = t.initialData;
    return {
      internalDialog: r,
      dataValidator: o,
      initialData: l
    };
  }, o5 = {
    open: function(t, r) {
      var o = kz(r);
      return t(o.internalDialog, o.initialData, o.dataValidator);
    },
    openUrl: function(t, r) {
      var o = Yl($K(r));
      return t(o);
    },
    redial: function(t) {
      return kz(t);
    }
  }, Tz = function(t) {
    var r = [], o = {};
    return Un(t, function(l, v) {
      l.fold(function() {
        r.push(v);
      }, function(g) {
        o[v] = g;
      });
    }), r.length > 0 ? ea.error(r) : ea.value(o);
  }, jK = function(t, r) {
    var o = La($b.sketch(function(l) {
      return {
        dom: {
          tag: "div",
          classes: ["tox-form"].concat(t.classes)
        },
        components: _t(t.items, function(v) {
          return _3(l, v, r);
        })
      };
    }));
    return {
      dom: {
        tag: "div",
        classes: ["tox-dialog__body"]
      },
      components: [{
        dom: {
          tag: "div",
          classes: ["tox-dialog__body-content"]
        },
        components: [o.asSpec()]
      }],
      behaviours: Fn([
        Er.config({
          mode: "acyclic",
          useTabstopAt: Ct(uC)
        }),
        kv.memento(o),
        Bm.memento(o, {
          postprocess: function(l) {
            return Tz(l).fold(function(v) {
              return console.error(v), {};
            }, Ze);
          }
        })
      ])
    };
  }, WK = function(t, r) {
    return {
      uid: t.uid,
      dom: t.dom,
      components: t.components,
      events: Cb(t.action),
      behaviours: Zi(t.tabButtonBehaviours, [
        zr.config({}),
        Er.config({
          mode: "execution",
          useSpace: !0,
          useEnter: !0
        }),
        jn.config({
          store: {
            mode: "memory",
            initialValue: t.value
          }
        })
      ]),
      domModification: t.domModification
    };
  }, qK = Cl({
    name: "TabButton",
    configFields: [
      ct("uid", void 0),
      un("value"),
      Oi("dom", "dom", su(function() {
        return {
          attributes: {
            role: "tab",
            id: ur("aria"),
            "aria-selected": "false"
          }
        };
      }), Xl()),
      Ba("action"),
      ct("domModification", {}),
      Ni("tabButtonBehaviours", [
        zr,
        Er,
        jn
      ]),
      un("view")
    ],
    factory: WK
  }), GK = ie([
    un("tabs"),
    un("dom"),
    ct("clickToDismiss", !1),
    Ni("tabbarBehaviours", [
      Na,
      Er
    ]),
    Jd([
      "tabClass",
      "selectedClass"
    ])
  ]), KK = Sf({
    factory: qK,
    name: "tabs",
    unit: "tab",
    overrides: function(t) {
      var r = function(l, v) {
        Na.dehighlight(l, v), xr(l, cu(), {
          tabbar: l,
          button: v
        });
      }, o = function(l, v) {
        Na.highlight(l, v), xr(l, JC(), {
          tabbar: l,
          button: v
        });
      };
      return {
        action: function(l) {
          var v = l.getSystem().getByUid(t.uid).getOrDie(), g = Na.isHighlighted(v, l), b = function() {
            return g && t.clickToDismiss ? r : g ? ee : o;
          }();
          b(v, l);
        },
        domModification: { classes: [t.markers.tabClass] }
      };
    }
  }), XK = ie([KK]), YK = function(t, r, o, l) {
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      "debug.sketcher": "Tabbar",
      domModification: { attributes: { role: "tablist" } },
      behaviours: Zi(t.tabbarBehaviours, [
        Na.config({
          highlightClass: t.markers.selectedClass,
          itemClass: t.markers.tabClass,
          onHighlight: function(v, g) {
            Qr(g.element, "aria-selected", "true");
          },
          onDehighlight: function(v, g) {
            Qr(g.element, "aria-selected", "false");
          }
        }),
        Er.config({
          mode: "flow",
          getInitial: function(v) {
            return Na.getHighlighted(v).map(function(g) {
              return g.element;
            });
          },
          selector: "." + t.markers.tabClass,
          executeOnMove: !0
        })
      ])
    };
  }, Ez = ds({
    name: "Tabbar",
    configFields: GK(),
    partFields: XK(),
    factory: YK
  }), ZK = function(t, r) {
    return {
      uid: t.uid,
      dom: t.dom,
      behaviours: Zi(t.tabviewBehaviours, [qr.config({})]),
      domModification: { attributes: { role: "tabpanel" } }
    };
  }, JK = Cl({
    name: "Tabview",
    configFields: [Ni("tabviewBehaviours", [qr])],
    factory: ZK
  }), QK = ie([
    ct("selectFirst", !0),
    Ra("onChangeTab"),
    Ra("onDismissTab"),
    ct("tabs", []),
    Ni("tabSectionBehaviours", [])
  ]), eX = hu({
    factory: Ez,
    schema: [
      un("dom"),
      nf("markers", [
        un("tabClass"),
        un("selectedClass")
      ])
    ],
    name: "tabbar",
    defaults: function(t) {
      return { tabs: t.tabs };
    }
  }), tX = hu({
    factory: JK,
    name: "tabview"
  }), nX = ie([
    eX,
    tX
  ]), rX = function(t, r, o, l) {
    var v = function(b) {
      var T = jn.getValue(b);
      Ya(b, t, "tabview").each(function(A) {
        var R = pt(t.tabs, function(z) {
          return z.value === T;
        });
        R.each(function(z) {
          var U = z.view();
          No(b.element, "id").each(function(oe) {
            Qr(A.element, "aria-labelledby", oe);
          }), qr.set(A, U), t.onChangeTab(A, b, U);
        });
      });
    }, g = function(b, T) {
      Ya(b, t, "tabbar").each(function(A) {
        T(A).each(ml);
      });
    };
    return {
      uid: t.uid,
      dom: t.dom,
      components: r,
      behaviours: Gg(t.tabSectionBehaviours),
      events: ro(Ie([
        t.selectFirst ? [Zr(function(b, T) {
          g(b, Na.getFirst);
        })] : [],
        [
          cn(JC(), function(b, T) {
            var A = T.event.button;
            v(A);
          }),
          cn(cu(), function(b, T) {
            var A = T.event.button;
            t.onDismissTab(b, A);
          })
        ]
      ])),
      apis: {
        getViewItems: function(b) {
          return Ya(b, t, "tabview").map(function(T) {
            return qr.contents(T);
          }).getOr([]);
        },
        showTab: function(b, T) {
          var A = function(R) {
            var z = Na.getCandidates(R), U = pt(z, function(oe) {
              return jn.getValue(oe) === T;
            });
            return U.filter(function(oe) {
              return !Na.isHighlighted(R, oe);
            });
          };
          g(b, A);
        }
      }
    };
  }, Y3 = ds({
    name: "TabSection",
    configFields: QK(),
    partFields: nX(),
    factory: rX,
    apis: {
      getViewItems: function(t, r) {
        return t.getViewItems(r);
      },
      showTab: function(t, r, o) {
        t.showTab(r, o);
      }
    }
  }), aX = function(t, r, o) {
    return _t(t, function(l, v) {
      qr.set(o, t[v].view());
      var g = r.dom.getBoundingClientRect();
      return qr.set(o, []), g.height;
    });
  }, oX = function(t) {
    return It(Qt(t, function(r, o) {
      return r > o ? -1 : r < o ? 1 : 0;
    }));
  }, iX = function(t, r, o) {
    var l = Ut(t).dom, v = Y1(t, ".tox-dialog-wrap").getOr(t), g = Ho(v, "position") === "fixed", b;
    g ? b = Math.max(l.clientHeight, window.innerHeight) : b = Math.max(l.offsetHeight, l.scrollHeight);
    var T = hi(r), A = r.dom.offsetLeft >= o.dom.offsetLeft + Au(o), R = A ? Math.max(hi(o), T) : T, z = parseInt(Ho(t, "margin-top"), 10) || 0, U = parseInt(Ho(t, "margin-bottom"), 10) || 0, oe = hi(t) + z + U, de = oe - R;
    return b - de;
  }, uX = function(t, r) {
    It(t).each(function(o) {
      return Y3.showTab(r, o.value);
    });
  }, _z = function(t, r) {
    Pr(t, "height", r + "px"), br().browser.isIE() ? Da(t, "flex-basis") : Pr(t, "flex-basis", r + "px");
  }, MB = function(t, r, o) {
    Y1(t, '[role="dialog"]').each(function(l) {
      Bi(l, '[role="tablist"]').each(function(v) {
        o.get().map(function(g) {
          return Pr(r, "height", "0"), Pr(r, "flex-basis", "0"), Math.min(g, iX(l, r, v));
        }).each(function(g) {
          _z(r, g);
        });
      });
    });
  }, W$ = function(t) {
    return Bi(t, '[role="tabpanel"]');
  }, sX = function(t) {
    var r = function() {
      var l = Zo(), v = [
        Zr(function(b) {
          var T = b.element;
          W$(T).each(function(A) {
            Pr(A, "visibility", "hidden"), b.getSystem().getByDom(A).toOptional().each(function(R) {
              var z = aX(t, A, R), U = oX(z);
              U.fold(l.clear, l.set);
            }), MB(T, A, l), Da(A, "visibility"), uX(t, b), pp.requestAnimationFrame(function() {
              MB(T, A, l);
            });
          });
        }),
        cn(dl(), function(b) {
          var T = b.element;
          W$(T).each(function(A) {
            MB(T, A, l);
          });
        }),
        cn(A_, function(b, T) {
          var A = b.element;
          W$(A).each(function(R) {
            var z = vs(wr(R));
            Pr(R, "visibility", "hidden");
            var U = ui(R, "height").map(function(Se) {
              return parseInt(Se, 10);
            });
            Da(R, "height"), Da(R, "flex-basis");
            var oe = R.dom.getBoundingClientRect().height, de = U.forall(function(Se) {
              return oe > Se;
            });
            de ? (l.set(oe), MB(A, R, l)) : U.each(function(Se) {
              _z(R, Se);
            }), Da(R, "visibility"), z.each(Mc);
          });
        })
      ], g = !1;
      return {
        extraEvents: v,
        selectFirst: g
      };
    }(), o = function() {
      var l = [], v = !0;
      return {
        extraEvents: l,
        selectFirst: v
      };
    }();
    return {
      smartTabHeight: r,
      naiveTabHeight: o
    };
  }, Az = "send-data-to-section", Oz = "send-data-to-view", lX = function(t, r) {
    var o = Sr({}), l = function(A) {
      var R = jn.getValue(A), z = Tz(R).getOr({}), U = o.get(), oe = Gt(U, z);
      o.set(oe);
    }, v = function(A) {
      var R = o.get();
      jn.setValue(A, R);
    }, g = Sr(null), b = _t(t.tabs, function(A) {
      return {
        value: A.name,
        dom: {
          tag: "div",
          classes: ["tox-dialog__body-nav-item"],
          innerHtml: r.shared.providers.translate(A.title)
        },
        view: function() {
          return [$b.sketch(function(R) {
            return {
              dom: {
                tag: "div",
                classes: ["tox-form"]
              },
              components: _t(A.items, function(z) {
                return _3(R, z, r);
              }),
              formBehaviours: Fn([
                Er.config({
                  mode: "acyclic",
                  useTabstopAt: Ct(uC)
                }),
                Jr("TabView.form.events", [
                  Zr(v),
                  gl(l)
                ]),
                ju.config({
                  channels: nv([
                    {
                      key: Az,
                      value: { onReceive: l }
                    },
                    {
                      key: Oz,
                      value: { onReceive: v }
                    }
                  ])
                })
              ])
            };
          })];
        }
      };
    }), T = sX(b).smartTabHeight;
    return Y3.sketch({
      dom: {
        tag: "div",
        classes: ["tox-dialog__body"]
      },
      onChangeTab: function(A, R, z) {
        var U = jn.getValue(R);
        xr(A, __, {
          name: U,
          oldName: g.get()
        }), g.set(U);
      },
      tabs: b,
      components: [
        Y3.parts.tabbar({
          dom: {
            tag: "div",
            classes: ["tox-dialog__body-nav"]
          },
          components: [Ez.parts.tabs({})],
          markers: {
            tabClass: "tox-tab",
            selectedClass: "tox-dialog__body-nav-item--active"
          },
          tabbarBehaviours: Fn([ci.config({})])
        }),
        Y3.parts.tabview({
          dom: {
            tag: "div",
            classes: ["tox-dialog__body-content"]
          }
        })
      ],
      selectFirst: T.selectFirst,
      tabSectionBehaviours: Fn([
        Jr("tabpanel", T.extraEvents),
        Er.config({ mode: "acyclic" }),
        la.config({
          find: function(A) {
            return It(Y3.getViewItems(A));
          }
        }),
        jn.config({
          store: {
            mode: "manual",
            getValue: function(A) {
              return A.getSystem().broadcastOn([Az], {}), o.get();
            },
            setValue: function(A, R) {
              o.set(R), A.getSystem().broadcastOn([Oz], {});
            }
          }
        })
      ])
    });
  }, q$ = ur("update-dialog"), Dz = ur("update-title"), Bz = ur("update-body"), Rz = ur("update-footer"), Mz = ur("body-send-message"), Pz = function(t, r, o, l) {
    var v = function(T) {
      switch (T.body.type) {
        case "tabpanel":
          return [lX(T.body, o)];
        default:
          return [jK(T.body, o)];
      }
    }, g = function(T, A) {
      return _.some({
        isTabPanel: function() {
          return A.body.type === "tabpanel";
        }
      });
    }, b = { "aria-live": "polite" };
    return {
      dom: {
        tag: "div",
        classes: ["tox-dialog__content-js"],
        attributes: $($({}, r.map(function(T) {
          return { id: T };
        }).getOr({})), l ? b : {})
      },
      components: [],
      behaviours: Fn([
        kv.childAt(0),
        qc.config({
          channel: Bz,
          updateState: g,
          renderComponents: v,
          initialData: t
        })
      ])
    };
  }, cX = function(t, r, o, l) {
    return Pz(t, _.some(r), o, l);
  }, fX = function(t, r) {
    var o = Pz(t, _.none(), r, !1);
    return wu.parts.body(o);
  }, vX = function(t) {
    var r = {
      dom: {
        tag: "div",
        classes: ["tox-dialog__content-js"]
      },
      components: [{
        dom: {
          tag: "div",
          classes: ["tox-dialog__body-iframe"]
        },
        components: [sA({
          dom: {
            tag: "iframe",
            attributes: { src: t.url }
          },
          behaviours: Fn([
            ci.config({}),
            zr.config({})
          ])
        })]
      }],
      behaviours: Fn([Er.config({
        mode: "acyclic",
        useTabstopAt: Ct(uC)
      })])
    };
    return wu.parts.body(r);
  }, dX = P4.deviceType.isTouch(), Nz = function(t, r) {
    return {
      dom: {
        tag: "div",
        styles: { display: "none" },
        classes: ["tox-dialog__header"]
      },
      components: [
        t,
        r
      ]
    };
  }, Iz = function(t, r) {
    return wu.parts.close(Js.sketch({
      dom: {
        tag: "button",
        classes: [
          "tox-button",
          "tox-button--icon",
          "tox-button--naked"
        ],
        attributes: {
          type: "button",
          "aria-label": r.translate("Close")
        }
      },
      action: t,
      buttonBehaviours: Fn([ci.config({})])
    }));
  }, Fz = function() {
    return wu.parts.title({
      dom: {
        tag: "div",
        classes: ["tox-dialog__title"],
        innerHtml: "",
        styles: { display: "none" }
      }
    });
  }, $z = function(t, r) {
    return wu.parts.body({
      dom: {
        tag: "div",
        classes: ["tox-dialog__body"]
      },
      components: [{
        dom: {
          tag: "div",
          classes: ["tox-dialog__body-content"]
        },
        components: [{ dom: $n("<p>" + r.translate(t) + "</p>") }]
      }]
    });
  }, Lz = function(t) {
    return wu.parts.footer({
      dom: {
        tag: "div",
        classes: ["tox-dialog__footer"]
      },
      components: t
    });
  }, zz = function(t, r) {
    return [
      ms.sketch({
        dom: {
          tag: "div",
          classes: ["tox-dialog__footer-start"]
        },
        components: t
      }),
      ms.sketch({
        dom: {
          tag: "div",
          classes: ["tox-dialog__footer-end"]
        },
        components: r
      })
    ];
  }, G$ = function(t) {
    var r, o = "tox-dialog", l = o + "-wrap", v = l + "__backdrop", g = o + "__disable-scroll";
    return wu.sketch({
      lazySink: t.lazySink,
      onEscape: function(b) {
        return t.onEscape(b), _.some(!0);
      },
      useTabstopAt: function(b) {
        return !uC(b);
      },
      dom: {
        tag: "div",
        classes: [o].concat(t.extraClasses),
        styles: $({ position: "relative" }, t.extraStyles)
      },
      components: ae([
        t.header,
        t.body
      ], t.footer.toArray(), !0),
      parts: {
        blocker: {
          dom: $n('<div class="' + l + '"></div>'),
          components: [{
            dom: {
              tag: "div",
              classes: dX ? [
                v,
                v + "--opaque"
              ] : [v]
            }
          }]
        }
      },
      dragBlockClass: l,
      modalBehaviours: Fn(ae([
        zr.config({}),
        Jr("dialog-events", t.dialogEvents.concat([li(Ol(), function(b, T) {
          Er.focusIn(b);
        })])),
        Jr("scroll-lock", [
          Zr(function() {
            Di($a(), g);
          }),
          gl(function() {
            yi($a(), g);
          })
        ])
      ], t.extraBehaviours, !0)),
      eventOrder: $((r = {}, r[vl()] = ["dialog-events"], r[Gs()] = [
        "scroll-lock",
        "dialog-events",
        "alloy.base.behaviour"
      ], r[sg()] = [
        "alloy.base.behaviour",
        "dialog-events",
        "scroll-lock"
      ], r), t.eventOrder)
    });
  }, Hz = function(t) {
    return Js.sketch({
      dom: {
        tag: "button",
        classes: [
          "tox-button",
          "tox-button--icon",
          "tox-button--naked"
        ],
        attributes: {
          type: "button",
          "aria-label": t.translate("Close"),
          title: t.translate("Close")
        }
      },
      components: [wv("close", {
        tag: "div",
        classes: ["tox-icon"]
      }, t.icons)],
      action: function(r) {
        Ta(r, Xh);
      }
    });
  }, Vz = function(t, r, o) {
    var l = function(v) {
      return [vu(o.translate(v.title))];
    };
    return {
      dom: {
        tag: "div",
        classes: ["tox-dialog__title"],
        attributes: $({}, r.map(function(v) {
          return { id: v };
        }).getOr({}))
      },
      components: l(t),
      behaviours: Fn([qc.config({
        channel: Dz,
        renderComponents: l
      })])
    };
  }, Uz = function() {
    return { dom: $n('<div class="tox-dialog__draghandle"></div>') };
  }, mX = function(t, r, o) {
    return ms.sketch({
      dom: $n('<div class="tox-dialog__header"></div>'),
      components: [
        Vz(t, _.some(r), o),
        Uz(),
        Hz(o)
      ],
      containerBehaviours: Fn([wC.config({
        mode: "mouse",
        blockerClass: "blocker",
        getTarget: function(l) {
          return Rl(l, '[role="dialog"]').getOrDie();
        },
        snaps: {
          getSnapPoints: function() {
            return [];
          },
          leftAttr: "data-drag-left",
          topAttr: "data-drag-top"
        }
      })])
    });
  }, gX = function(t, r) {
    var o = wu.parts.title(Vz(t, _.none(), r)), l = wu.parts.draghandle(Uz()), v = wu.parts.close(Hz(r)), g = [o].concat(t.draggable ? [l] : []).concat([v]);
    return ms.sketch({
      dom: $n('<div class="tox-dialog__header"></div>'),
      components: g
    });
  }, jz = function(t, r) {
    return gX({
      title: r.shared.providers.translate(t),
      draggable: r.dialog.isDraggableModal()
    }, r.shared.providers);
  }, Wz = function(t, r, o) {
    return {
      dom: {
        tag: "div",
        classes: ["tox-dialog__busy-spinner"],
        attributes: { "aria-label": o.translate(t) },
        styles: {
          left: "0px",
          right: "0px",
          bottom: "0px",
          top: "0px",
          position: "absolute"
        }
      },
      behaviours: r,
      components: [{ dom: $n('<div class="tox-spinner"><div></div><div></div><div></div></div>') }]
    };
  }, qz = function(t, r, o) {
    return {
      onClose: function() {
        return o.closeWindow();
      },
      onBlock: function(l) {
        wu.setBusy(t(), function(v, g) {
          return Wz(l.message, g, r);
        });
      },
      onUnblock: function() {
        wu.setIdle(t());
      }
    };
  }, Gz = function(t, r, o, l) {
    var v, g = function(b, T) {
      return _.some(T);
    };
    return ko(G$($($({}, t), {
      lazySink: l.shared.getSink,
      extraBehaviours: ae([
        qc.config({
          channel: q$,
          updateState: g,
          initialData: r
        }),
        Bm.memory({})
      ], t.extraBehaviours, !0),
      onEscape: function(b) {
        Ta(b, Xh);
      },
      dialogEvents: o,
      eventOrder: (v = {}, v[Dl()] = [
        qc.name(),
        ju.name()
      ], v[Gs()] = [
        "scroll-lock",
        qc.name(),
        "messages",
        "dialog-events",
        "alloy.base.behaviour"
      ], v[sg()] = [
        "alloy.base.behaviour",
        "dialog-events",
        "messages",
        qc.name(),
        "scroll-lock"
      ], v)
    })));
  }, Kz = function(t) {
    var r = function(o) {
      var l = _t(o.items, function(v) {
        var g = Sr(!1);
        return $($({}, v), { storage: g });
      });
      return $($({}, o), { items: l });
    };
    return _t(t, function(o) {
      return o.type === "menu" ? r(o) : o;
    });
  }, Xz = function(t) {
    return Ke(t, function(r, o) {
      if (o.type === "menu") {
        var l = o;
        return Ke(l.items, function(v, g) {
          return v[g.name] = g.storage, v;
        }, r);
      }
      return r;
    }, {});
  }, Yz = function(t, r) {
    return [
      Uv(Ol(), O8),
      t(Ww, function(o, l) {
        r.onClose(), l.onClose();
      }),
      t(Xh, function(o, l, v, g) {
        l.onCancel(o), Ta(g, Ww);
      }),
      cn(E_, function(o, l) {
        return r.onUnblock();
      }),
      cn(xd, function(o, l) {
        return r.onBlock(l.event);
      })
    ];
  }, pX = function(t, r) {
    var o = function(v, g) {
      return cn(v, function(b, T) {
        l(b, function(A, R) {
          g(t(), A, T.event, b);
        });
      });
    }, l = function(v, g) {
      qc.getState(v).get().each(function(b) {
        g(b, v);
      });
    };
    return ae(ae([], Yz(o, r), !0), [o(Cv, function(v, g, b) {
      g.onAction(v, { name: b.name });
    })], !1);
  }, hX = function(t, r, o) {
    var l = function(g, b) {
      return cn(g, function(T, A) {
        v(T, function(R, z) {
          b(t(), R, A.event, T);
        });
      });
    }, v = function(g, b) {
      qc.getState(g).get().each(function(T) {
        b(T.internalDialog, g);
      });
    };
    return ae(ae([], Yz(l, r), !0), [
      l($l, function(g, b) {
        return b.onSubmit(g);
      }),
      l(cc, function(g, b, T) {
        b.onChange(g, { name: T.name });
      }),
      l(Cv, function(g, b, T, A) {
        var R = function() {
          return Er.focusIn(A);
        }, z = function(de) {
          return w1(de, "disabled") || No(de, "aria-disabled").exists(function(Se) {
            return Se === "true";
          });
        }, U = wr(A.element), oe = vs(U);
        b.onAction(g, {
          name: T.name,
          value: T.value
        }), vs(U).fold(R, function(de) {
          z(de) || oe.exists(function(Se) {
            return _u(de, Se) && z(Se);
          }) ? R() : o().toOptional().filter(function(Se) {
            return !_u(Se.element, de);
          }).each(R);
        });
      }),
      l(__, function(g, b, T) {
        b.onTabChange(g, {
          newTabName: T.name,
          oldTabName: T.oldName
        });
      }),
      gl(function(g) {
        var b = t();
        jn.setValue(g, b.getData());
      })
    ], !1);
  }, K$ = {
    initUrlDialog: pX,
    initDialog: hX
  }, bX = function(t, r) {
    return y3(t, t.type, r);
  }, yX = function(t, r, o) {
    return pt(r, function(l) {
      return l.name === o;
    }).bind(function(l) {
      return l.memento.getOpt(t);
    });
  }, wX = function(t, r) {
    var o = r.map(function(T) {
      return T.footerButtons;
    }).getOr([]), l = He(o, function(T) {
      return T.align === "start";
    }), v = function(T, A) {
      return ms.sketch({
        dom: {
          tag: "div",
          classes: ["tox-dialog__footer-" + T]
        },
        components: _t(A, function(R) {
          return R.memento.asSpec();
        })
      });
    }, g = v("start", l.pass), b = v("end", l.fail);
    return [
      g,
      b
    ];
  }, Zz = function(t, r) {
    var o = function(l, v) {
      var g = _t(v.buttons, function(T) {
        var A = La(bX(T, r));
        return {
          name: T.name,
          align: T.align,
          memento: A
        };
      }), b = function(T, A) {
        return yX(T, g, A);
      };
      return _.some({
        lookupByName: b,
        footerButtons: g
      });
    };
    return {
      dom: $n('<div class="tox-dialog__footer"></div>'),
      components: [],
      behaviours: Fn([qc.config({
        channel: Rz,
        initialData: t,
        updateState: o,
        renderComponents: wX
      })])
    };
  }, CX = function(t, r) {
    return Zz(t, r);
  }, Jz = function(t, r) {
    return wu.parts.footer(Zz(t, r));
  }, X$ = function(t, r) {
    var o = t.getRoot();
    if (o.getSystem().isConnected()) {
      var l = la.getCurrent(t.getFormWrapper()).getOr(t.getFormWrapper());
      return $b.getField(l, r).fold(function() {
        var v = t.getFooter(), g = qc.getState(v);
        return g.get().bind(function(b) {
          return b.lookupByName(l, r);
        });
      }, function(v) {
        return _.some(v);
      });
    } else
      return _.none();
  }, SX = function(t, r) {
    var o = t.getRoot();
    return qc.getState(o).get().map(function(l) {
      return Yl(Io("data", l.dataValidator, r));
    }).getOr(r);
  }, Qz = function(t, r, o) {
    var l = function($e) {
      var ut = t.getRoot();
      ut.getSystem().isConnected() && $e(ut);
    }, v = function() {
      var $e = t.getRoot(), ut = $e.getSystem().isConnected() ? t.getFormWrapper() : $e, Ne = jn.getValue(ut), ft = Tn(o, function(Ht) {
        return Ht.get();
      });
      return $($({}, Ne), ft);
    }, g = function($e) {
      l(function(ut) {
        var Ne = Se.getData(), ft = $($({}, Ne), $e), Ht = SX(t, ft), Kt = t.getFormWrapper();
        jn.setValue(Kt, Ht), Un(o, function(st, Bt) {
          yn(ft, Bt) && st.set(ft[Bt]);
        });
      });
    }, b = function($e) {
      X$(t, $e).each(Cr.disable);
    }, T = function($e) {
      X$(t, $e).each(Cr.enable);
    }, A = function($e) {
      X$(t, $e).each(zr.focus);
    }, R = function($e) {
      if (!P($e))
        throw new Error("The dialogInstanceAPI.block function should be passed a blocking message of type string as an argument");
      l(function(ut) {
        xr(ut, xd, { message: $e });
      });
    }, z = function() {
      l(function($e) {
        Ta($e, E_);
      });
    }, U = function($e) {
      l(function(ut) {
        var Ne = t.getBody(), ft = qc.getState(Ne);
        ft.get().exists(function(Ht) {
          return Ht.isTabPanel();
        }) && la.getCurrent(Ne).each(function(Ht) {
          Y3.showTab(Ht, $e);
        });
      });
    }, oe = function($e) {
      l(function(ut) {
        var Ne = r($e);
        ut.getSystem().broadcastOn([q$], Ne), ut.getSystem().broadcastOn([Dz], Ne.internalDialog), ut.getSystem().broadcastOn([Bz], Ne.internalDialog), ut.getSystem().broadcastOn([Rz], Ne.internalDialog), Se.setData(Ne.initialData);
      });
    }, de = function() {
      l(function($e) {
        Ta($e, Ww);
      });
    }, Se = {
      getData: v,
      setData: g,
      disable: b,
      enable: T,
      focus: A,
      block: R,
      unblock: z,
      showTab: U,
      redial: oe,
      close: de
    };
    return Se;
  }, xX = function(t) {
    switch (t) {
      case "large":
        return ["tox-dialog--width-lg"];
      case "medium":
        return ["tox-dialog--width-md"];
      default:
        return [];
    }
  }, kX = function(t, r, o) {
    var l = jz(t.internalDialog.title, o), v = fX({ body: t.internalDialog.body }, o), g = Kz(t.internalDialog.buttons), b = Xz(g), T = Jz({ buttons: g }, o), A = K$.initDialog(function() {
      return de;
    }, qz(function() {
      return U;
    }, o.shared.providers, r), o.shared.getSink), R = xX(t.internalDialog.size), z = {
      header: l,
      body: v,
      footer: _.some(T),
      extraClasses: R,
      extraBehaviours: [],
      extraStyles: {}
    }, U = Gz(z, t, A, o), oe = function() {
      var Se = function() {
        var $e = wu.getBody(U);
        return la.getCurrent($e).getOr($e);
      };
      return {
        getRoot: ie(U),
        getBody: function() {
          return wu.getBody(U);
        },
        getFooter: function() {
          return wu.getFooter(U);
        },
        getFormWrapper: Se
      };
    }(), de = Qz(oe, r.redial, b);
    return {
      dialog: U,
      instanceApi: de
    };
  }, TX = function(t, r, o, l) {
    var v, g, b = ur("dialog-label"), T = ur("dialog-content"), A = function(Ne, ft) {
      return _.some(ft);
    }, R = La(mX({
      title: t.internalDialog.title,
      draggable: !0
    }, b, o.shared.providers)), z = La(cX({ body: t.internalDialog.body }, T, o, l)), U = Kz(t.internalDialog.buttons), oe = Xz(U), de = La(CX({ buttons: U }, o)), Se = K$.initDialog(function() {
      return ut;
    }, {
      onBlock: function(Ne) {
        kn.block($e, function(ft, Ht) {
          return Wz(Ne.message, Ht, o.shared.providers);
        });
      },
      onUnblock: function() {
        kn.unblock($e);
      },
      onClose: function() {
        return r.closeWindow();
      }
    }, o.shared.getSink), $e = ko({
      dom: {
        tag: "div",
        classes: [
          "tox-dialog",
          "tox-dialog-inline"
        ],
        attributes: (v = { role: "dialog" }, v["aria-labelledby"] = b, v["aria-describedby"] = T, v)
      },
      eventOrder: (g = {}, g[Dl()] = [
        qc.name(),
        ju.name()
      ], g[vl()] = ["execute-on-form"], g[Gs()] = [
        "reflecting",
        "execute-on-form"
      ], g),
      behaviours: Fn([
        Er.config({
          mode: "cyclic",
          onEscape: function(Ne) {
            return Ta(Ne, Ww), _.some(!0);
          },
          useTabstopAt: function(Ne) {
            return !uC(Ne) && (et(Ne) !== "button" || So(Ne, "disabled") !== "disabled");
          }
        }),
        qc.config({
          channel: q$,
          updateState: A,
          initialData: t
        }),
        zr.config({}),
        Jr("execute-on-form", Se.concat([li(Ol(), function(Ne, ft) {
          Er.focusIn(Ne);
        })])),
        kn.config({
          getRoot: function() {
            return _.some($e);
          }
        }),
        qr.config({}),
        Bm.memory({})
      ]),
      components: [
        R.asSpec(),
        z.asSpec(),
        de.asSpec()
      ]
    }), ut = Qz({
      getRoot: ie($e),
      getFooter: function() {
        return de.get($e);
      },
      getBody: function() {
        return z.get($e);
      },
      getFormWrapper: function() {
        var Ne = z.get($e);
        return la.getCurrent(Ne).getOr(Ne);
      }
    }, r.redial, oe);
    return {
      dialog: $e,
      instanceApi: ut
    };
  }, Y$ = tinymce.util.Tools.resolve("tinymce.util.URI"), EX = function(t) {
    var r = function(b) {
      t.getSystem().isConnected() && b(t);
    }, o = function(b) {
      if (!P(b))
        throw new Error("The urlDialogInstanceAPI.block function should be passed a blocking message of type string as an argument");
      r(function(T) {
        xr(T, xd, { message: b });
      });
    }, l = function() {
      r(function(b) {
        Ta(b, E_);
      });
    }, v = function() {
      r(function(b) {
        Ta(b, Ww);
      });
    }, g = function(b) {
      r(function(T) {
        T.getSystem().broadcastOn([Mz], b);
      });
    };
    return {
      block: o,
      unblock: l,
      close: v,
      sendMessage: g
    };
  }, _X = [
    "insertContent",
    "setContent",
    "execCommand",
    "close",
    "block",
    "unblock"
  ], eH = function(t) {
    return H(t) && _X.indexOf(t.mceAction) !== -1;
  }, AX = function(t) {
    return !eH(t) && H(t) && yn(t, "mceAction");
  }, OX = function(t, r, o) {
    switch (o.mceAction) {
      case "insertContent":
        t.insertContent(o.content);
        break;
      case "setContent":
        t.setContent(o.content);
        break;
      case "execCommand":
        var l = le(o.ui) ? o.ui : !1;
        t.execCommand(o.cmd, l, o.value);
        break;
      case "close":
        r.close();
        break;
      case "block":
        r.block(o.message);
        break;
      case "unblock":
        r.unblock();
        break;
    }
  }, DX = function(t, r, o, l) {
    var v, g = jz(t.title, l), b = vX(t), T = t.buttons.bind(function(ft) {
      return ft.length === 0 ? _.none() : _.some(Jz({ buttons: ft }, l));
    }), A = K$.initUrlDialog(function() {
      return Ne;
    }, qz(function() {
      return ut;
    }, l.shared.providers, r)), R = $($({}, t.height.fold(function() {
      return {};
    }, function(ft) {
      return {
        height: ft + "px",
        "max-height": ft + "px"
      };
    })), t.width.fold(function() {
      return {};
    }, function(ft) {
      return {
        width: ft + "px",
        "max-width": ft + "px"
      };
    })), z = t.width.isNone() && t.height.isNone() ? ["tox-dialog--width-lg"] : [], U = new Y$(t.url, { base_uri: new Y$(window.location.href) }), oe = U.protocol + "://" + U.host + (U.port ? ":" + U.port : ""), de = kg(), Se = [
      Jr("messages", [
        Zr(function() {
          var ft = ai(Bn.fromDom(window), "message", function(Ht) {
            if (U.isSameOrigin(new Y$(Ht.raw.origin))) {
              var Kt = Ht.raw.data;
              eH(Kt) ? OX(o, Ne, Kt) : AX(Kt) && t.onMessage(Ne, Kt);
            }
          });
          de.set(ft);
        }),
        gl(de.clear)
      ]),
      ju.config({
        channels: (v = {}, v[Mz] = {
          onReceive: function(ft, Ht) {
            Bi(ft.element, "iframe").each(function(Kt) {
              var st = Kt.dom.contentWindow;
              st.postMessage(Ht, oe);
            });
          }
        }, v)
      })
    ], $e = {
      header: g,
      body: b,
      footer: T,
      extraClasses: z,
      extraBehaviours: Se,
      extraStyles: R
    }, ut = Gz($e, t, A, l), Ne = EX(ut);
    return {
      dialog: ut,
      instanceApi: Ne
    };
  }, BX = function(t) {
    var r = t.backstage.shared, o = function(l, v) {
      var g = function() {
        wu.hide(R), v();
      }, b = La(y3({
        name: "close-alert",
        text: "OK",
        primary: !0,
        align: "end",
        disabled: !1,
        icon: _.none()
      }, "cancel", t.backstage)), T = Fz(), A = Iz(g, r.providers), R = ko(G$({
        lazySink: function() {
          return r.getSink();
        },
        header: Nz(T, A),
        body: $z(l, r.providers),
        footer: _.some(Lz(zz([], [b.asSpec()]))),
        onEscape: g,
        extraClasses: ["tox-alert-dialog"],
        extraBehaviours: [],
        extraStyles: {},
        dialogEvents: [cn(Xh, g)],
        eventOrder: {}
      }));
      wu.show(R);
      var z = b.get(R);
      zr.focus(z);
    };
    return { open: o };
  }, RX = function(t) {
    var r = t.backstage.shared, o = function(l, v) {
      var g = function(oe) {
        wu.hide(z), v(oe);
      }, b = La(y3({
        name: "yes",
        text: "Yes",
        primary: !0,
        align: "end",
        disabled: !1,
        icon: _.none()
      }, "submit", t.backstage)), T = y3({
        name: "no",
        text: "No",
        primary: !1,
        align: "end",
        disabled: !1,
        icon: _.none()
      }, "cancel", t.backstage), A = Fz(), R = Iz(function() {
        return g(!1);
      }, r.providers), z = ko(G$({
        lazySink: function() {
          return r.getSink();
        },
        header: Nz(A, R),
        body: $z(l, r.providers),
        footer: _.some(Lz(zz([], [
          T,
          b.asSpec()
        ]))),
        onEscape: function() {
          return g(!1);
        },
        extraClasses: ["tox-confirm-dialog"],
        extraBehaviours: [],
        extraStyles: {},
        dialogEvents: [
          cn(Xh, function() {
            return g(!1);
          }),
          cn($l, function() {
            return g(!0);
          })
        ],
        eventOrder: {}
      }));
      wu.show(z);
      var U = b.get(z);
      zr.focus(U);
    };
    return { open: o };
  }, MX = function(t, r) {
    return Yl(Io("data", r, t));
  }, PX = function(t) {
    return Hw(t, ".tox-alert-dialog") || Hw(t, ".tox-confirm-dialog");
  }, NX = function(t, r, o) {
    return r && o ? [] : [vi.config({
      contextual: {
        lazyContext: function() {
          return _.some(si(Bn.fromDom(t.getContentAreaContainer())));
        },
        fadeInClass: "tox-dialog-dock-fadein",
        fadeOutClass: "tox-dialog-dock-fadeout",
        transitionClass: "tox-dialog-dock-transition"
      },
      modes: ["top"]
    })];
  }, IX = function(t) {
    var r = t.backstage, o = t.editor, l = B4(o), v = BX(t), g = RX(t), b = function(Se, $e, ut) {
      return $e !== void 0 && $e.inline === "toolbar" ? z(Se, r.shared.anchors.inlineDialog(), ut, $e.ariaAttrs) : $e !== void 0 && $e.inline === "cursor" ? z(Se, r.shared.anchors.cursor(), ut, $e.ariaAttrs) : R(Se, ut);
    }, T = function(Se, $e) {
      return A(Se, $e);
    }, A = function(Se, $e) {
      var ut = function(Ne) {
        var ft = DX(Ne, {
          closeWindow: function() {
            wu.hide(ft.dialog), $e(ft.instanceApi);
          }
        }, o, r);
        return wu.show(ft.dialog), ft.instanceApi;
      };
      return o5.openUrl(ut, Se);
    }, R = function(Se, $e) {
      var ut = function(Ne, ft, Ht) {
        var Kt = ft, st = {
          dataValidator: Ht,
          initialData: Kt,
          internalDialog: Ne
        }, Bt = kX(st, {
          redial: o5.redial,
          closeWindow: function() {
            wu.hide(Bt.dialog), $e(Bt.instanceApi);
          }
        }, r);
        return wu.show(Bt.dialog), Bt.instanceApi.setData(Kt), Bt.instanceApi;
      };
      return o5.open(ut, Se);
    }, z = function(Se, $e, ut, Ne) {
      var ft = function(Ht, Kt, st) {
        var Bt = MX(Kt, st), an = Zo(), qn = r.shared.header.isPositionedAtTop(), vn = {
          dataValidator: st,
          initialData: Bt,
          internalDialog: Ht
        }, Gn = function() {
          return an.on(function(Wn) {
            Ua.reposition(Wn), vi.refresh(Wn);
          });
        }, pn = TX(vn, {
          redial: o5.redial,
          closeWindow: function() {
            an.on(Ua.hide), o.off("ResizeEditor", Gn), an.clear(), ut(pn.instanceApi);
          }
        }, r, Ne), nn = ko(Ua.sketch($($({
          lazySink: r.shared.getSink,
          dom: {
            tag: "div",
            classes: []
          },
          fireDismissalEventInstead: {}
        }, qn ? {} : { fireRepositionEventInstead: {} }), {
          inlineBehaviours: Fn(ae([Jr("window-manager-inline-events", [cn(ec(), function(Wn, cr) {
            Ta(pn.dialog, Xh);
          })])], NX(o, l, qn), !0)),
          isExtraPart: function(Wn, cr) {
            return PX(cr);
          }
        })));
        return an.set(nn), Ua.showWithin(nn, yl(pn.dialog), { anchor: $e }, _.some($a())), (!l || !qn) && (vi.refresh(nn), o.on("ResizeEditor", Gn)), pn.instanceApi.setData(Bt), Er.focusIn(pn.dialog), pn.instanceApi;
      };
      return o5.open(ft, Se);
    }, U = function(Se, $e) {
      g.open(Se, function(ut) {
        $e(ut);
      });
    }, oe = function(Se, $e) {
      v.open(Se, function() {
        $e();
      });
    }, de = function(Se) {
      Se.close();
    };
    return {
      open: b,
      openUrl: T,
      alert: oe,
      close: de,
      confirm: U
    };
  };
  function FX() {
    _e.add("silver", function(t) {
      var r = bG(t), o = r.uiMothership, l = r.backstage, v = r.renderUI, g = r.getUi;
      _7.register(t, l.shared);
      var b = IX({
        editor: t,
        backstage: l
      });
      return {
        renderUI: v,
        getWindowManagerImpl: ie(b),
        getNotificationManagerImpl: function() {
          return RE(t, { backstage: l }, o);
        },
        ui: g()
      };
    });
  }
  FX();
})();
tinymce.IconManager.add("default", {
  icons: {
    "accessibility-check": '<svg width="24" height="24"><path d="M12 2a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2c0-1.1.9-2 2-2zm8 7h-5v12c0 .6-.4 1-1 1a1 1 0 01-1-1v-5c0-.6-.4-1-1-1a1 1 0 00-1 1v5c0 .6-.4 1-1 1a1 1 0 01-1-1V9H4a1 1 0 110-2h16c.6 0 1 .4 1 1s-.4 1-1 1z" fill-rule="nonzero"/></svg>',
    "action-next": '<svg width="24" height="24"><path fill-rule="nonzero" d="M5.7 7.3a1 1 0 00-1.4 1.4l7.7 7.7 7.7-7.7a1 1 0 10-1.4-1.4L12 13.6 5.7 7.3z"/></svg>',
    "action-prev": '<svg width="24" height="24"><path fill-rule="nonzero" d="M18.3 15.7a1 1 0 001.4-1.4L12 6.6l-7.7 7.7a1 1 0 001.4 1.4L12 9.4l6.3 6.3z"/></svg>',
    "align-center": '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm3 4h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 110-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2zm-3-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
    "align-justify": '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0 4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
    "align-left": '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 4h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
    "align-none": '<svg width="24" height="24"><path d="M14.2 5L13 7H5a1 1 0 110-2h9.2zm4 0h.8a1 1 0 010 2h-2l1.2-2zm-6.4 4l-1.2 2H5a1 1 0 010-2h6.8zm4 0H19a1 1 0 010 2h-4.4l1.2-2zm-6.4 4l-1.2 2H5a1 1 0 010-2h4.4zm4 0H19a1 1 0 010 2h-6.8l1.2-2zM7 17l-1.2 2H5a1 1 0 010-2h2zm4 0h8a1 1 0 010 2H9.8l1.2-2zm5.2-13.5l1.3.7-9.7 16.3-1.3-.7 9.7-16.3z" fill-rule="evenodd"/></svg>',
    "align-right": '<svg width="24" height="24"><path d="M5 5h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm6 4h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0 8h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm-6-4h14c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
    "arrow-left": '<svg width="24" height="24"><path d="M5.6 13l12 6a1 1 0 001.4-1V6a1 1 0 00-1.4-.9l-12 6a1 1 0 000 1.8z" fill-rule="evenodd"/></svg>',
    "arrow-right": '<svg width="24" height="24"><path d="M18.5 13l-12 6A1 1 0 015 18V6a1 1 0 011.4-.9l12 6a1 1 0 010 1.8z" fill-rule="evenodd"/></svg>',
    bold: '<svg width="24" height="24"><path d="M7.8 19c-.3 0-.5 0-.6-.2l-.2-.5V5.7c0-.2 0-.4.2-.5l.6-.2h5c1.5 0 2.7.3 3.5 1 .7.6 1.1 1.4 1.1 2.5a3 3 0 01-.6 1.9c-.4.6-1 1-1.6 1.2.4.1.9.3 1.3.6s.8.7 1 1.2c.4.4.5 1 .5 1.6 0 1.3-.4 2.3-1.3 3-.8.7-2.1 1-3.8 1H7.8zm5-8.3c.6 0 1.2-.1 1.6-.5.4-.3.6-.7.6-1.3 0-1.1-.8-1.7-2.3-1.7H9.3v3.5h3.4zm.5 6c.7 0 1.3-.1 1.7-.4.4-.4.6-.9.6-1.5s-.2-1-.7-1.4c-.4-.3-1-.4-2-.4H9.4v3.8h4z" fill-rule="evenodd"/></svg>',
    bookmark: '<svg width="24" height="24"><path d="M6 4v17l6-4 6 4V4c0-.6-.4-1-1-1H7a1 1 0 00-1 1z" fill-rule="nonzero"/></svg>',
    "border-style": '<svg width="24" height="24"><g fill-rule="evenodd"><rect width="18" height="2" x="3" y="6" rx="1"/><rect width="2.8" height="2" x="3" y="16" rx="1"/><rect width="2.8" height="2" x="6.8" y="16" rx="1"/><rect width="2.8" height="2" x="10.6" y="16" rx="1"/><rect width="2.8" height="2" x="14.4" y="16" rx="1"/><rect width="2.8" height="2" x="18.2" y="16" rx="1"/><rect width="8" height="2" x="3" y="11" rx="1"/><rect width="8" height="2" x="13" y="11" rx="1"/></g></svg>',
    "border-width": '<svg width="24" height="24"><g fill-rule="evenodd"><rect width="18" height="5" x="3" y="5" rx="1"/><rect width="18" height="3.5" x="3" y="11.5" rx="1"/><rect width="18" height="2" x="3" y="17" rx="1"/></g></svg>',
    brightness: '<svg width="24" height="24"><path d="M12 17c.3 0 .5.1.7.3.2.2.3.4.3.7v1c0 .3-.1.5-.3.7a1 1 0 01-.7.3 1 1 0 01-.7-.3 1 1 0 01-.3-.7v-1c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3zm0-10a1 1 0 01-.7-.3A1 1 0 0111 6V5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3.3 0 .5.1.7.3.2.2.3.4.3.7v1c0 .3-.1.5-.3.7a1 1 0 01-.7.3zm7 4c.3 0 .5.1.7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 01-.7.3h-1a1 1 0 01-.7-.3 1 1 0 01-.3-.7c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h1zM7 12c0 .3-.1.5-.3.7a1 1 0 01-.7.3H5a1 1 0 01-.7-.3A1 1 0 014 12c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h1c.3 0 .5.1.7.3.2.2.3.4.3.7zm10 3.5l.7.8c.2.1.3.4.3.6 0 .3-.1.6-.3.8a1 1 0 01-.8.3 1 1 0 01-.6-.3l-.8-.7a1 1 0 01-.3-.8c0-.2.1-.5.3-.7a1 1 0 011.4 0zm-10-7l-.7-.8a1 1 0 01-.3-.6c0-.3.1-.6.3-.8.2-.2.5-.3.8-.3.2 0 .5.1.7.3l.7.7c.2.2.3.5.3.8 0 .2-.1.5-.3.7a1 1 0 01-.7.3 1 1 0 01-.8-.3zm10 0a1 1 0 01-.8.3 1 1 0 01-.7-.3 1 1 0 01-.3-.7c0-.3.1-.6.3-.8l.8-.7c.1-.2.4-.3.6-.3.3 0 .6.1.8.3.2.2.3.5.3.8 0 .2-.1.5-.3.7l-.7.7zm-10 7c.2-.2.5-.3.8-.3.2 0 .5.1.7.3a1 1 0 010 1.4l-.8.8a1 1 0 01-.6.3 1 1 0 01-.8-.3 1 1 0 01-.3-.8c0-.2.1-.5.3-.6l.7-.8zM12 8a4 4 0 013.7 2.4 4 4 0 010 3.2A4 4 0 0112 16a4 4 0 01-3.7-2.4 4 4 0 010-3.2A4 4 0 0112 8zm0 6.5c.7 0 1.3-.2 1.8-.7.5-.5.7-1.1.7-1.8s-.2-1.3-.7-1.8c-.5-.5-1.1-.7-1.8-.7s-1.3.2-1.8.7c-.5.5-.7 1.1-.7 1.8s.2 1.3.7 1.8c.5.5 1.1.7 1.8.7z" fill-rule="evenodd"/></svg>',
    browse: '<svg width="24" height="24"><path d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2h-4v-2h4V8H5v10h4v2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-8 9.4l-2.3 2.3a1 1 0 11-1.4-1.4l4-4a1 1 0 011.4 0l4 4a1 1 0 01-1.4 1.4L13 13.4V20a1 1 0 01-2 0v-6.6z" fill-rule="nonzero"/></svg>',
    cancel: '<svg width="24" height="24"><path d="M12 4.6a7.4 7.4 0 110 14.8 7.4 7.4 0 010-14.8zM12 3a9 9 0 100 18 9 9 0 000-18zm0 8L14.8 8l1 1.1-2.7 2.8 2.7 2.7-1.1 1.1-2.7-2.7-2.7 2.7-1-1.1 2.6-2.7-2.7-2.7 1-1.1 2.8 2.7z" fill-rule="nonzero"/></svg>',
    "cell-background-color": '<svg width="24" height="24"><path d="M15.7 2l1.6 1.6-2.7 2.6 5.9 5.8c.7.7.7 1.7 0 2.4l-6.3 6.1a1.7 1.7 0 01-2.4 0l-6.3-6.1c-.7-.7-.7-1.7 0-2.4L15.7 2zM18 12l-4.5-4L9 12h9zM4 16s2 2.4 2 3.8C6 21 5.1 22 4 22s-2-1-2-2.2C2 18.4 4 16 4 16z"/></svg>',
    "cell-border-color": '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M5 13v5h2v2H5a2 2 0 01-2-2v-5h2zm8-7V4h6a2 2 0 012 2h-8z" opacity=".2"/><path fill-rule="nonzero" d="M13 4v2H5v7H3V6c0-1.1.9-2 2-2h8zm-2.6 14.1l.1-.1.1.1.2.3.2.2.2.2c.4.6.8 1.2.8 1.7 0 .8-.7 1.5-1.5 1.5S9 21.3 9 20.5c0-.5.4-1.1.8-1.7l.2-.2.2-.2.2-.3z"/><path d="M13 11l-2 2H5v-2h6V6h2z"/><path fill-rule="nonzero" d="M18.4 8l1 1-1.8 1.9 4 4c.5.4.5 1.1 0 1.6l-4.3 4.2a1.2 1.2 0 01-1.6 0l-4.4-4.2c-.4-.5-.4-1.2 0-1.7l7-6.8zm1.6 7l-3-3-3 3h6z"/></g></svg>',
    "change-case": '<svg width="24" height="24"><path d="M18.4 18.2v-.6c-.5.8-1.3 1.2-2.4 1.2-2.2 0-3.3-1.6-3.3-4.8 0-3.1 1-4.7 3.3-4.7 1.1 0 1.8.3 2.4 1.1v-.6c0-.5.4-.8.8-.8s.8.3.8.8v8.4c0 .5-.4.8-.8.8a.8.8 0 01-.8-.8zm-2-7.4c-1.3 0-1.8.9-1.8 3.2 0 2.4.5 3.3 1.7 3.3 1.3 0 1.8-.9 1.8-3.2 0-2.4-.5-3.3-1.7-3.3zM10 15.7H5.5l-.8 2.6a1 1 0 01-1 .7h-.2a.7.7 0 01-.7-1l4-12a1 1 0 012 0l4 12a.7.7 0 01-.8 1h-.2a1 1 0 01-1-.7l-.8-2.6zm-.3-1.5l-2-6.5-1.9 6.5h3.9z" fill-rule="evenodd"/></svg>',
    "character-count": '<svg width="24" height="24"><path d="M4 11.5h16v1H4v-1zm4.8-6.8V10H7.7V5.8h-1v-1h2zM11 8.3V9h2v1h-3V7.7l2-1v-.9h-2v-1h3v2.4l-2 1zm6.3-3.4V10h-3.1V9h2.1V8h-2.1V6.8h2.1v-1h-2.1v-1h3.1zM5.8 16.4c0-.5.2-.8.5-1 .2-.2.6-.3 1.2-.3l.8.1c.2 0 .4.2.5.3l.4.4v2.8l.2.3H8.2v-.1-.2l-.6.3H7c-.4 0-.7 0-1-.2a1 1 0 01-.3-.9c0-.3 0-.6.3-.8.3-.2.7-.4 1.2-.4l.6-.2h.3v-.2l-.1-.2a.8.8 0 00-.5-.1 1 1 0 00-.4 0l-.3.4h-1zm2.3.8h-.2l-.2.1-.4.1a1 1 0 00-.4.2l-.2.2.1.3.5.1h.4l.4-.4v-.6zm2-3.4h1.2v1.7l.5-.3h.5c.5 0 .9.1 1.2.5.3.4.5.8.5 1.4 0 .6-.2 1.1-.5 1.5-.3.4-.7.6-1.3.6l-.6-.1-.4-.4v.4h-1.1v-5.4zm1.1 3.3c0 .3 0 .6.2.8a.7.7 0 001.2 0l.2-.8c0-.4 0-.6-.2-.8a.7.7 0 00-.6-.3l-.6.3-.2.8zm6.1-.5c0-.2 0-.3-.2-.4a.8.8 0 00-.5-.2c-.3 0-.5.1-.6.3l-.2.9c0 .3 0 .6.2.8.1.2.3.3.6.3.2 0 .4 0 .5-.2l.2-.4h1.1c0 .5-.3.8-.6 1.1a2 2 0 01-1.3.4c-.5 0-1-.2-1.3-.6a2 2 0 01-.5-1.4c0-.6.1-1.1.5-1.5.3-.4.8-.5 1.4-.5.5 0 1 0 1.2.3.4.3.5.7.5 1.2h-1v-.1z" fill-rule="evenodd"/></svg>',
    "checklist-rtl": '<svg width="24" height="24"><path d="M5 17h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1H5a1 1 0 110-2zm14.2 11c.2-.4.6-.5.9-.3.3.2.4.6.2 1L18 20c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8zm0-6c.2-.4.6-.5.9-.3.3.2.4.6.2 1L18 14c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8zm0-6c.2-.4.6-.5.9-.3.3.2.4.6.2 1L18 8c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8z" fill-rule="evenodd"/></svg>',
    checklist: '<svg width="24" height="24"><path d="M11 17h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8a1 1 0 010 2h-8a1 1 0 010-2zM7.2 16c.2-.4.6-.5.9-.3.3.2.4.6.2 1L6 20c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8zm0-6c.2-.4.6-.5.9-.3.3.2.4.6.2 1L6 14c-.2.3-.7.4-1 0l-1.3-1.3a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8zm0-6c.2-.4.6-.5.9-.3.3.2.4.6.2 1L6 8c-.2.3-.7.4-1 0L3.8 6.9a.7.7 0 010-1c.3-.2.7-.2 1 0l.7.9 1.7-2.8z" fill-rule="evenodd"/></svg>',
    checkmark: '<svg width="24" height="24"><path d="M18.2 5.4a1 1 0 011.6 1.2l-8 12a1 1 0 01-1.5.1l-5-5a1 1 0 111.4-1.4l4.1 4.1 7.4-11z" fill-rule="nonzero"/></svg>',
    "chevron-down": '<svg width="10" height="10"><path d="M8.7 2.2c.3-.3.8-.3 1 0 .4.4.4.9 0 1.2L5.7 7.8c-.3.3-.9.3-1.2 0L.2 3.4a.8.8 0 010-1.2c.3-.3.8-.3 1.1 0L5 6l3.7-3.8z" fill-rule="nonzero"/></svg>',
    "chevron-left": '<svg width="10" height="10"><path d="M7.8 1.3L4 5l3.8 3.7c.3.3.3.8 0 1-.4.4-.9.4-1.2 0L2.2 5.7a.8.8 0 010-1.2L6.6.2C7 0 7.4 0 7.8.2c.3.3.3.8 0 1.1z" fill-rule="nonzero"/></svg>',
    "chevron-right": '<svg width="10" height="10"><path d="M2.2 1.3a.8.8 0 010-1c.4-.4.9-.4 1.2 0l4.4 4.1c.3.4.3.9 0 1.2L3.4 9.8c-.3.3-.8.3-1.2 0a.8.8 0 010-1.1L6 5 2.2 1.3z" fill-rule="nonzero"/></svg>',
    "chevron-up": '<svg width="10" height="10"><path d="M8.7 7.8L5 4 1.3 7.8c-.3.3-.8.3-1 0a.8.8 0 010-1.2l4.1-4.4c.3-.3.9-.3 1.2 0l4.2 4.4c.3.3.3.9 0 1.2-.3.3-.8.3-1.1 0z" fill-rule="nonzero"/></svg>',
    close: '<svg width="24" height="24"><path d="M17.3 8.2L13.4 12l3.9 3.8a1 1 0 01-1.5 1.5L12 13.4l-3.8 3.9a1 1 0 01-1.5-1.5l3.9-3.8-3.9-3.8a1 1 0 011.5-1.5l3.8 3.9 3.8-3.9a1 1 0 011.5 1.5z" fill-rule="evenodd"/></svg>',
    "code-sample": '<svg width="24" height="26"><path d="M7.1 11a2.8 2.8 0 01-.8 2 2.8 2.8 0 01.8 2v1.7c0 .3.1.6.4.8.2.3.5.4.8.4.3 0 .4.2.4.4v.8c0 .2-.1.4-.4.4-.7 0-1.4-.3-2-.8-.5-.6-.8-1.3-.8-2V15c0-.3-.1-.6-.4-.8-.2-.3-.5-.4-.8-.4a.4.4 0 01-.4-.4v-.8c0-.2.2-.4.4-.4.3 0 .6-.1.8-.4.3-.2.4-.5.4-.8V9.3c0-.7.3-1.4.8-2 .6-.5 1.3-.8 2-.8.3 0 .4.2.4.4v.8c0 .2-.1.4-.4.4-.3 0-.6.1-.8.4-.3.2-.4.5-.4.8V11zm9.8 0V9.3c0-.3-.1-.6-.4-.8-.2-.3-.5-.4-.8-.4a.4.4 0 01-.4-.4V7c0-.2.1-.4.4-.4.7 0 1.4.3 2 .8.5.6.8 1.3.8 2V11c0 .3.1.6.4.8.2.3.5.4.8.4.2 0 .4.2.4.4v.8c0 .2-.2.4-.4.4-.3 0-.6.1-.8.4-.3.2-.4.5-.4.8v1.7c0 .7-.3 1.4-.8 2-.6.5-1.3.8-2 .8a.4.4 0 01-.4-.4v-.8c0-.2.1-.4.4-.4.3 0 .6-.1.8-.4.3-.2.4-.5.4-.8V15a2.8 2.8 0 01.8-2 2.8 2.8 0 01-.8-2zm-3.3-.4c0 .4-.1.8-.5 1.1-.3.3-.7.5-1.1.5-.4 0-.8-.2-1.1-.5-.4-.3-.5-.7-.5-1.1 0-.5.1-.9.5-1.2.3-.3.7-.4 1.1-.4.4 0 .8.1 1.1.4.4.3.5.7.5 1.2zM12 13c.4 0 .8.1 1.1.5.4.3.5.7.5 1.1 0 1-.1 1.6-.5 2a3 3 0 01-1.1 1c-.4.3-.8.4-1.1.4a.5.5 0 01-.5-.5V17a3 3 0 001-.2l.6-.6c-.6 0-1-.2-1.3-.5-.2-.3-.3-.7-.3-1 0-.5.1-1 .5-1.2.3-.4.7-.5 1.1-.5z" fill-rule="evenodd"/></svg>',
    "color-levels": '<svg width="24" height="24"><path d="M17.5 11.4A9 9 0 0118 14c0 .5 0 1-.2 1.4 0 .4-.3.9-.5 1.3a6.2 6.2 0 01-3.7 3 5.7 5.7 0 01-3.2 0A5.9 5.9 0 017.6 18a6.2 6.2 0 01-1.4-2.6 6.7 6.7 0 010-2.8c0-.4.1-.9.3-1.3a13.6 13.6 0 012.3-4A20 20 0 0112 4a26.4 26.4 0 013.2 3.4 18.2 18.2 0 012.3 4zm-2 4.5c.4-.7.5-1.4.5-2a7.3 7.3 0 00-1-3.2c.2.6.2 1.2.2 1.9a4.5 4.5 0 01-1.3 3 5.3 5.3 0 01-2.3 1.5 4.9 4.9 0 01-2 .1 4.3 4.3 0 002.4.8 4 4 0 002-.6 4 4 0 001.5-1.5z" fill-rule="evenodd"/></svg>',
    "color-picker": '<svg width="24" height="24"><path d="M12 3a9 9 0 000 18 1.5 1.5 0 001.1-2.5c-.2-.3-.4-.6-.4-1 0-.8.7-1.5 1.5-1.5H16a5 5 0 005-5c0-4.4-4-8-9-8zm-5.5 9a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3-4a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm3 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" fill-rule="nonzero"/></svg>',
    "color-swatch-remove-color": '<svg width="24" height="24"><path stroke="#000" stroke-width="2" d="M21 3L3 21" fill-rule="evenodd"/></svg>',
    "color-swatch": '<svg width="24" height="24"><rect x="3" y="3" width="18" height="18" rx="1" fill-rule="evenodd"/></svg>',
    "comment-add": '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M9 19l3-2h7c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1H5a1 1 0 00-1 1v10c0 .6.4 1 1 1h4v2zm-2 4v-4H5a3 3 0 01-3-3V6a3 3 0 013-3h14a3 3 0 013 3v10a3 3 0 01-3 3h-6.4L7 23z"/><path d="M13 10h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2H9a1 1 0 010-2h2V8a1 1 0 012 0v2z"/></g></svg>',
    comment: '<svg width="24" height="24"><path fill-rule="nonzero" d="M9 19l3-2h7c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1H5a1 1 0 00-1 1v10c0 .6.4 1 1 1h4v2zm-2 4v-4H5a3 3 0 01-3-3V6a3 3 0 013-3h14a3 3 0 013 3v10a3 3 0 01-3 3h-6.4L7 23z"/></svg>',
    contrast: '<svg width="24" height="24"><path d="M12 4a7.8 7.8 0 015.7 2.3A8 8 0 1112 4zm-6 8a6 6 0 006 6V6a6 6 0 00-6 6z" fill-rule="evenodd"/></svg>',
    copy: '<svg width="24" height="24"><path d="M16 3H6a2 2 0 00-2 2v11h2V5h10V3zm1 4a2 2 0 012 2v10a2 2 0 01-2 2h-7a2 2 0 01-2-2V9c0-1.2.9-2 2-2h7zm0 12V9h-7v10h7z" fill-rule="nonzero"/></svg>',
    crop: '<svg width="24" height="24"><path d="M17 8v7h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v2c0 .6-.4 1-1 1a1 1 0 01-1-1v-2H7V9H5a1 1 0 110-2h2V5c0-.6.4-1 1-1s1 .4 1 1v2h7l3-3 1 1-3 3zM9 9v5l5-5H9zm1 6h5v-5l-5 5z" fill-rule="evenodd"/></svg>',
    "cut-column": '<svg width="24" height="24"><path fill-rule="evenodd" d="M7.2 4.5c.9 0 1.6.4 2.2 1A3.7 3.7 0 0110.5 8v.5l1 1 4-4 1-.5a3.3 3.3 0 012 0c.4 0 .7.3 1 .5L17 8h4v13h-6V10l-1.5 1.5.5.5v4l-2.5-2.5-1 1v.5c0 .4 0 .8-.3 1.2-.2.5-.4.9-.8 1.2-.6.7-1.3 1-2.2 1-.8.2-1.5 0-2-.6l-.5-.8-.2-1c0-.4 0-.8.3-1.2A3.9 3.9 0 017 12.7c.5-.2 1-.3 1.5-.2l1-1-1-1c-.5 0-1 0-1.5-.2-.5-.1-1-.4-1.4-.9-.4-.3-.6-.7-.8-1.2L4.5 7c0-.4 0-.7.2-1 0-.3.3-.6.5-.8.5-.5 1.2-.8 2-.7zm12.3 5h-3v10h3v-10zM8 13.8h-.3l-.4.2a2.8 2.8 0 00-.7.4v.1a2.8 2.8 0 00-.6.8l-.1.4v.7l.2.5.5.2h.7a2.6 2.6 0 00.8-.3 2.4 2.4 0 00.7-.7 2.5 2.5 0 00.3-.8 1.5 1.5 0 000-.8 1 1 0 00-.2-.4 1 1 0 00-.5-.2H8zm3.5-3.7c-.4 0-.7.1-1 .4-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4s.7-.1 1-.4c.3-.3.4-.6.4-1s-.1-.7-.4-1c-.3-.3-.6-.4-1-.4zM7 5.8h-.4a1 1 0 00-.5.3 1 1 0 00-.2.5v.7a2.5 2.5 0 00.3.8l.2.3h.1l.4.4.4.2.4.1h.7L9 9l.2-.4a1.6 1.6 0 000-.8 2.6 2.6 0 00-.3-.8A2.5 2.5 0 007.7 6l-.4-.1H7z"/></svg>',
    "cut-row": '<svg width="24" height="24"><path fill-rule="evenodd" d="M22 3v5H9l3 3 2-2h4l-4 4 1 1h.5c.4 0 .8 0 1.2.3.5.2.9.4 1.2.8.7.6 1 1.3 1 2.2.2.8 0 1.5-.6 2l-.8.5-1 .2c-.4 0-.8 0-1.2-.3a3.9 3.9 0 01-2.1-2.2c-.2-.5-.3-1-.2-1.5l-1-1-1 1c0 .5 0 1-.2 1.5-.1.5-.4 1-.9 1.4-.3.4-.7.6-1.2.8l-1.2.3c-.4 0-.7 0-1-.2-.3 0-.6-.3-.8-.5-.5-.5-.8-1.2-.7-2 0-.9.4-1.6 1-2.2A3.7 3.7 0 018.6 14H9l1-1-4-4-.5-1a3.3 3.3 0 010-2c0-.4.3-.7.5-1l2 2V3h14zM8.5 15.3h-.3a2.6 2.6 0 00-.8.4 2.5 2.5 0 00-.9 1.1l-.1.4v.7l.2.5.5.2h.7a2.5 2.5 0 00.8-.3L9 18V18l.4-.4.2-.4.1-.4v-.3-.4a1 1 0 00-.2-.5 1 1 0 00-.4-.2h-.5zm7 0H15a1 1 0 00-.4.3 1 1 0 00-.2.5 1.5 1.5 0 000 .7v.4a2.8 2.8 0 00.5.7h.1a2.8 2.8 0 00.8.6l.4.1h.7l.5-.2.2-.5v-.4-.3a2.6 2.6 0 00-.3-.8 2.4 2.4 0 00-.7-.7 2.5 2.5 0 00-.8-.3h-.3zM12 11.6c-.4 0-.7.1-1 .4-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4s.7-.1 1-.4c.3-.3.4-.6.4-1s-.1-.7-.4-1c-.3-.3-.6-.4-1-.4zm8.5-7.1h-11v2h11v-2z"/></svg>',
    cut: '<svg width="24" height="24"><path d="M18 15c.6.7 1 1.4 1 2.3 0 .8-.2 1.5-.7 2l-.8.5-1 .2c-.4 0-.8 0-1.2-.3a3.9 3.9 0 01-2.1-2.2c-.2-.5-.3-1-.2-1.5l-1-1-1 1c0 .5 0 1-.2 1.5-.1.5-.4 1-.9 1.4-.3.4-.7.6-1.2.8l-1.2.3c-.4 0-.7 0-1-.2-.3 0-.6-.3-.8-.5-.5-.5-.8-1.2-.7-2 0-.9.4-1.6 1-2.2A3.7 3.7 0 018.6 14H9l1-1-4-4-.5-1a3.3 3.3 0 010-2c0-.4.3-.7.5-1l6 6 6-6 .5 1a3.3 3.3 0 010 2c0 .4-.3.7-.5 1l-4 4 1 1h.5c.4 0 .8 0 1.2.3.5.2.9.4 1.2.8zm-8.5 2.2l.1-.4v-.3-.4a1 1 0 00-.2-.5 1 1 0 00-.4-.2 1.6 1.6 0 00-.8 0 2.6 2.6 0 00-.8.3 2.5 2.5 0 00-.9 1.1l-.1.4v.7l.2.5.5.2h.7a2.5 2.5 0 00.8-.3 2.8 2.8 0 001-1zm2.5-2.8c.4 0 .7-.1 1-.4.3-.3.4-.6.4-1s-.1-.7-.4-1c-.3-.3-.6-.4-1-.4s-.7.1-1 .4c-.3.3-.4.6-.4 1s.1.7.4 1c.3.3.6.4 1 .4zm5.4 4l.2-.5v-.4-.3a2.6 2.6 0 00-.3-.8 2.4 2.4 0 00-.7-.7 2.5 2.5 0 00-.8-.3 1.5 1.5 0 00-.8 0 1 1 0 00-.4.2 1 1 0 00-.2.5 1.5 1.5 0 000 .7v.4l.3.4.3.4a2.8 2.8 0 00.8.5l.4.1h.7l.5-.2z" fill-rule="evenodd"/></svg>',
    "document-properties": '<svg width="24" height="24"><path d="M14.4 3H7a2 2 0 00-2 2v14c0 1.1.9 2 2 2h10a2 2 0 002-2V7.6L14.4 3zM17 19H7V5h6v4h4v10z" fill-rule="nonzero"/></svg>',
    drag: '<svg width="24" height="24"><path d="M13 5h2v2h-2V5zm0 4h2v2h-2V9zM9 9h2v2H9V9zm4 4h2v2h-2v-2zm-4 0h2v2H9v-2zm0 4h2v2H9v-2zm4 0h2v2h-2v-2zM9 5h2v2H9V5z" fill-rule="evenodd"/></svg>',
    "duplicate-column": '<svg width="24" height="24"><path d="M17 6v16h-7V6h7zm-2 2h-3v12h3V8zm-2-6v2H8v15H6V2h7z"/></svg>',
    "duplicate-row": '<svg width="24" height="24"><path d="M22 11v7H6v-7h16zm-2 2H8v3h12v-3zm-1-6v2H4v5H2V7h17z"/></svg>',
    duplicate: '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M16 3v2H6v11H4V5c0-1.1.9-2 2-2h10zm3 8h-2V9h-7v10h9a2 2 0 01-2 2h-7a2 2 0 01-2-2V9c0-1.2.9-2 2-2h7a2 2 0 012 2v2z"/><path d="M17 14h1a1 1 0 010 2h-1v1a1 1 0 01-2 0v-1h-1a1 1 0 010-2h1v-1a1 1 0 012 0v1z"/></g></svg>',
    "edit-block": '<svg width="24" height="24"><path fill-rule="nonzero" d="M19.8 8.8l-9.4 9.4c-.2.2-.5.4-.9.4l-5.4 1.2 1.2-5.4.5-.8 9.4-9.4c.7-.7 1.8-.7 2.5 0l2.1 2.1c.7.7.7 1.8 0 2.5zm-2-.2l1-.9v-.3l-2.2-2.2a.3.3 0 00-.3 0l-1 1L18 8.5zm-1 1l-2.5-2.4-6 6 2.5 2.5 6-6zm-7 7.1l-2.6-2.4-.3.3-.1.2-.7 3 3.1-.6h.1l.4-.5z"/></svg>',
    "edit-image": '<svg width="24" height="24"><path d="M18 16h2V7a2 2 0 00-2-2H7v2h11v9zM6 17h15a1 1 0 010 2h-1v1a1 1 0 01-2 0v-1H6a2 2 0 01-2-2V7H3a1 1 0 110-2h1V4a1 1 0 112 0v13zm3-5.3l1.3 2 3-4.7 3.7 6H7l2-3.3z" fill-rule="nonzero"/></svg>',
    "embed-page": '<svg width="24" height="24"><path d="M19 6V5H5v14h2A13 13 0 0119 6zm0 1.4c-.8.8-1.6 2.4-2.2 4.6H19V7.4zm0 5.6h-2.4c-.4 1.8-.6 3.8-.6 6h3v-6zm-4 6c0-2.2.2-4.2.6-6H13c-.7 1.8-1.1 3.8-1.1 6h3zm-4 0c0-2.2.4-4.2 1-6H9.6A12 12 0 008 19h3zM4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm11.8 9c.4-1.9 1-3.4 1.8-4.5a9.2 9.2 0 00-4 4.5h2.2zm-3.4 0a12 12 0 012.8-4 12 12 0 00-5 4h2.2z" fill-rule="nonzero"/></svg>',
    embed: '<svg width="24" height="24"><path d="M4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm1 2v14h14V5H5zm4.8 2.6l5.6 4a.5.5 0 010 .8l-5.6 4A.5.5 0 019 16V8a.5.5 0 01.8-.4z" fill-rule="nonzero"/></svg>',
    emoji: '<svg width="24" height="24"><path d="M9 11c.6 0 1-.4 1-1s-.4-1-1-1a1 1 0 00-1 1c0 .6.4 1 1 1zm6 0c.6 0 1-.4 1-1s-.4-1-1-1a1 1 0 00-1 1c0 .6.4 1 1 1zm-3 5.5c2.1 0 4-1.5 4.4-3.5H7.6c.5 2 2.3 3.5 4.4 3.5zM12 4a8 8 0 100 16 8 8 0 000-16zm0 14.5a6.5 6.5 0 110-13 6.5 6.5 0 010 13z" fill-rule="nonzero"/></svg>',
    export: '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M14.4 3L18 7v1h-5V5H7v14h9a1 1 0 012 0c0 1-.8 2-1.9 2H7c-1 0-2-.8-2-1.9V5c0-1 .8-2 1.9-2h7.5z"/><path d="M18.1 12c.5 0 .9.4.9 1 0 .5-.3 1-.8 1h-7.3c-.5 0-.9-.4-.9-1 0-.5.3-1 .8-1h7.3z"/><path d="M16.4 9.2a1 1 0 011.4.2l2.4 3.6-2.4 3.6a1 1 0 01-1.7-1v-.2l1.7-2.4-1.6-2.4a1 1 0 01.2-1.4z"/></g></svg>',
    fill: '<svg width="24" height="26"><path d="M16.6 12l-9-9-1.4 1.4 2.4 2.4-5.2 5.1c-.5.6-.5 1.6 0 2.2L9 19.6a1.5 1.5 0 002.2 0l5.5-5.5c.5-.6.5-1.6 0-2.2zM5.2 13L10 8.2l4.8 4.8H5.2zM19 14.5s-2 2.2-2 3.5c0 1.1.9 2 2 2a2 2 0 002-2c0-1.3-2-3.5-2-3.5z" fill-rule="nonzero"/></svg>',
    "flip-horizontally": '<svg width="24" height="24"><path d="M14 19h2v-2h-2v2zm4-8h2V9h-2v2zM4 7v10c0 1.1.9 2 2 2h3v-2H6V7h3V5H6a2 2 0 00-2 2zm14-2v2h2a2 2 0 00-2-2zm-7 16h2V3h-2v18zm7-6h2v-2h-2v2zm-4-8h2V5h-2v2zm4 12a2 2 0 002-2h-2v2z" fill-rule="nonzero"/></svg>',
    "flip-vertically": '<svg width="24" height="24"><path d="M5 14v2h2v-2H5zm8 4v2h2v-2h-2zm4-14H7a2 2 0 00-2 2v3h2V6h10v3h2V6a2 2 0 00-2-2zm2 14h-2v2a2 2 0 002-2zM3 11v2h18v-2H3zm6 7v2h2v-2H9zm8-4v2h2v-2h-2zM5 18c0 1.1.9 2 2 2v-2H5z" fill-rule="nonzero"/></svg>',
    "format-painter": '<svg width="24" height="24"><path d="M18 5V4c0-.5-.4-1-1-1H5a1 1 0 00-1 1v4c0 .6.5 1 1 1h12c.6 0 1-.4 1-1V7h1v4H9v9c0 .6.4 1 1 1h2c.6 0 1-.4 1-1v-7h8V5h-3z" fill-rule="nonzero"/></svg>',
    format: '<svg width="24" height="24"><path fill-rule="evenodd" d="M17 5a1 1 0 010 2h-4v11a1 1 0 01-2 0V7H7a1 1 0 110-2h10z"/></svg>',
    fullscreen: '<svg width="24" height="24"><path d="M15.3 10l-1.2-1.3 2.9-3h-2.3a.9.9 0 110-1.7H19c.5 0 .9.4.9.9v4.4a.9.9 0 11-1.8 0V7l-2.9 3zm0 4l3 3v-2.3a.9.9 0 111.7 0V19c0 .5-.4.9-.9.9h-4.4a.9.9 0 110-1.8H17l-3-2.9 1.3-1.2zM10 15.4l-2.9 3h2.3a.9.9 0 110 1.7H5a.9.9 0 01-.9-.9v-4.4a.9.9 0 111.8 0V17l2.9-3 1.2 1.3zM8.7 10L5.7 7v2.3a.9.9 0 01-1.7 0V5c0-.5.4-.9.9-.9h4.4a.9.9 0 010 1.8H7l3 2.9-1.3 1.2z" fill-rule="nonzero"/></svg>',
    gallery: '<svg width="24" height="24"><path fill-rule="nonzero" d="M5 15.7l2.3-2.2c.3-.3.7-.3 1 0L11 16l5.1-5c.3-.4.8-.4 1 0l2 1.9V8H5v7.7zM5 18V19h3l1.8-1.9-2-2L5 17.9zm14-3l-2.5-2.4-6.4 6.5H19v-4zM4 6h16c.6 0 1 .4 1 1v13c0 .6-.4 1-1 1H4a1 1 0 01-1-1V7c0-.6.4-1 1-1zm6 7a2 2 0 110-4 2 2 0 010 4zM4.5 4h15a.5.5 0 110 1h-15a.5.5 0 010-1zm2-2h11a.5.5 0 110 1h-11a.5.5 0 010-1z"/></svg>',
    gamma: '<svg width="24" height="24"><path d="M4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm1 2v14h14V5H5zm6.5 11.8V14L9.2 8.7a5.1 5.1 0 00-.4-.8l-.1-.2H8 8v-1l.3-.1.3-.1h.7a1 1 0 01.6.5l.1.3a8.5 8.5 0 01.3.6l1.9 4.6 2-5.2a1 1 0 011-.6.5.5 0 01.5.6L13 14v2.8a.7.7 0 01-1.4 0z" fill-rule="nonzero"/></svg>',
    help: '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M12 5.5a6.5 6.5 0 00-6 9 6.3 6.3 0 001.4 2l1 1a6.3 6.3 0 003.6 1 6.5 6.5 0 006-9 6.3 6.3 0 00-1.4-2l-1-1a6.3 6.3 0 00-3.6-1zM12 4a7.8 7.8 0 015.7 2.3A8 8 0 1112 4z"/><path d="M9.6 9.7a.7.7 0 01-.7-.8c0-1.1 1.5-1.8 3.2-1.8 1.8 0 3.2.8 3.2 2.4 0 1.4-.4 2.1-1.5 2.8-.2 0-.3.1-.3.2a2 2 0 00-.8.8.8.8 0 01-1.4-.6c.3-.7.8-1 1.3-1.5l.4-.2c.7-.4.8-.6.8-1.5 0-.5-.6-.9-1.7-.9-.5 0-1 .1-1.4.3-.2 0-.3.1-.3.2v-.2c0 .4-.4.8-.8.8z" fill-rule="nonzero"/><circle cx="12" cy="16" r="1"/></g></svg>',
    "highlight-bg-color": '<svg width="24" height="24"><g fill-rule="evenodd"><path id="tox-icon-highlight-bg-color__color" d="M3 18h18v3H3z"/><path fill-rule="nonzero" d="M7.7 16.7H3l3.3-3.3-.7-.8L10.2 8l4 4.1-4 4.2c-.2.2-.6.2-.8 0l-.6-.7-1.1 1.1zm5-7.5L11 7.4l3-2.9a2 2 0 012.6 0L18 6c.7.7.7 2 0 2.7l-2.9 2.9-1.8-1.8-.5-.6"/></g></svg>',
    home: '<svg width="24" height="24"><path fill-rule="nonzero" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>',
    "horizontal-rule": '<svg width="24" height="24"><path d="M4 11h16v2H4z" fill-rule="evenodd"/></svg>',
    "image-options": '<svg width="24" height="24"><path d="M6 10a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2zm12 0a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2zm-6 0a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2z" fill-rule="nonzero"/></svg>',
    image: '<svg width="24" height="24"><path d="M5 15.7l3.3-3.2c.3-.3.7-.3 1 0L12 15l4.1-4c.3-.4.8-.4 1 0l2 1.9V5H5v10.7zM5 18V19h3l2.8-2.9-2-2L5 17.9zm14-3l-2.5-2.4-6.4 6.5H19v-4zM4 3h16c.6 0 1 .4 1 1v16c0 .6-.4 1-1 1H4a1 1 0 01-1-1V4c0-.6.4-1 1-1zm6 8a2 2 0 100-4 2 2 0 000 4z" fill-rule="nonzero"/></svg>',
    indent: '<svg width="24" height="24"><path d="M7 5h12c.6 0 1 .4 1 1s-.4 1-1 1H7a1 1 0 110-2zm5 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm0 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm-5 4h12a1 1 0 010 2H7a1 1 0 010-2zm-2.6-3.8L6.2 12l-1.8-1.2a1 1 0 011.2-1.6l3 2a1 1 0 010 1.6l-3 2a1 1 0 11-1.2-1.6z" fill-rule="evenodd"/></svg>',
    info: '<svg width="24" height="24"><path d="M12 4a7.8 7.8 0 015.7 2.3A8 8 0 1112 4zm-1 3v2h2V7h-2zm3 10v-1h-1v-5h-3v1h1v4h-1v1h4z" fill-rule="evenodd"/></svg>',
    "insert-character": '<svg width="24" height="24"><path d="M15 18h4l1-2v4h-6v-3.3l1.4-1a6 6 0 001.8-2.9 6.3 6.3 0 00-.1-4.1 5.8 5.8 0 00-3-3.2c-.6-.3-1.3-.5-2.1-.5a5.1 5.1 0 00-3.9 1.8 6.3 6.3 0 00-1.3 6 6.2 6.2 0 001.8 3l1.4.9V20H4v-4l1 2h4v-.5l-2-1L5.4 15A6.5 6.5 0 014 11c0-1 .2-1.9.6-2.7A7 7 0 016.3 6C7.1 5.4 8 5 9 4.5c1-.3 2-.5 3.1-.5a8.8 8.8 0 015.7 2 7 7 0 011.7 2.3 6 6 0 01.2 4.8c-.2.7-.6 1.3-1 1.9a7.6 7.6 0 01-3.6 2.5v.5z" fill-rule="evenodd"/></svg>',
    "insert-time": '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M12 19a7 7 0 100-14 7 7 0 000 14zm0 2a9 9 0 110-18 9 9 0 010 18z"/><path d="M16 12h-3V7c0-.6-.4-1-1-1a1 1 0 00-1 1v7h5c.6 0 1-.4 1-1s-.4-1-1-1z"/></g></svg>',
    invert: '<svg width="24" height="24"><path d="M18 19.3L16.5 18a5.8 5.8 0 01-3.1 1.9 6.1 6.1 0 01-5.5-1.6A5.8 5.8 0 016 14v-.3l.1-1.2A13.9 13.9 0 017.7 9l-3-3 .7-.8 2.8 2.9 9 8.9 1.5 1.6-.7.6zm0-5.5v.3l-.1 1.1-.4 1-1.2-1.2a4.3 4.3 0 00.2-1v-.2c0-.4 0-.8-.2-1.3l-.5-1.4a14.8 14.8 0 00-3-4.2L12 6a26.1 26.1 0 00-2.2 2.5l-1-1a20.9 20.9 0 012.9-3.3L12 4l1 .8a22.2 22.2 0 014 5.4c.6 1.2 1 2.4 1 3.6z" fill-rule="evenodd"/></svg>',
    italic: '<svg width="24" height="24"><path d="M16.7 4.7l-.1.9h-.3c-.6 0-1 0-1.4.3-.3.3-.4.6-.5 1.1l-2.1 9.8v.6c0 .5.4.8 1.4.8h.2l-.2.8H8l.2-.8h.2c1.1 0 1.8-.5 2-1.5l2-9.8.1-.5c0-.6-.4-.8-1.4-.8h-.3l.2-.9h5.8z" fill-rule="evenodd"/></svg>',
    language: '<svg width="24" height="24"><path d="M12 3a9 9 0 110 18 9 9 0 010-18zm4.3 13.3c-.5 1-1.2 2-2 2.9a7.5 7.5 0 003.2-2.1l-.2-.2a6 6 0 00-1-.6zm-8.6 0c-.5.2-.9.5-1.2.8.9 1 2 1.7 3.2 2a10 10 0 01-2-2.8zm3.6-.8c-.8 0-1.6.1-2.2.3.5 1 1.2 1.9 2.1 2.7zm1.5 0v3c.9-.8 1.6-1.7 2.1-2.7-.6-.2-1.4-.3-2.1-.3zm-6-2.7H4.5c.2 1 .5 2.1 1 3h.3l1.3-1a10 10 0 01-.3-2zm12.7 0h-2.3c0 .7-.1 1.4-.3 2l1.6 1.1c.5-1 .9-2 1-3.1zm-3.8 0h-3V14c1 0 2 .1 2.7.4.2-.5.3-1 .3-1.6zm-4.4 0h-3l.3 1.6c.8-.3 1.7-.4 2.7-.4v-1.3zm-5.5-5c-.7 1-1.1 2.2-1.3 3.5h2.3c0-1 .2-1.8.5-2.6l-1.5-1zm2.9 1.4v.1c-.2.6-.4 1.3-.4 2h3V9.4c-1 0-1.8-.1-2.6-.3zm6.6 0h-.1l-2.4.3v1.8h3l-.5-2.1zm3-1.4l-.3.1-1.3.8c.3.8.5 1.6.5 2.6h2.3a7.5 7.5 0 00-1.3-3.5zm-9 0l2 .2V5.5a9 9 0 00-2 2.2zm3.5-2.3V8c.6 0 1.3 0 1.9-.2a9 9 0 00-2-2.3zm-3-.7h-.1c-1.1.4-2.1 1-3 1.8l1.2.7a10 10 0 011.9-2.5zm4.4 0l.1.1a10 10 0 011.8 2.4l1.1-.7a7.5 7.5 0 00-3-1.8z"/></svg>',
    "line-height": '<svg width="24" height="24"><path d="M21 5a1 1 0 01.1 2H13a1 1 0 01-.1-2H21zm0 4a1 1 0 01.1 2H13a1 1 0 01-.1-2H21zm0 4a1 1 0 01.1 2H13a1 1 0 01-.1-2H21zm0 4a1 1 0 01.1 2H13a1 1 0 01-.1-2H21zM7 3.6l3.7 3.7a1 1 0 01-1.3 1.5h-.1L8 7.3v9.2l1.3-1.3a1 1 0 011.3 0h.1c.4.4.4 1 0 1.3v.1L7 20.4l-3.7-3.7a1 1 0 011.3-1.5h.1L6 16.7V7.4L4.7 8.7a1 1 0 01-1.3 0h-.1a1 1 0 010-1.3v-.1L7 3.6z"/></svg>',
    line: '<svg width="24" height="24"><path d="M15 9l-8 8H4v-3l8-8 3 3zm1-1l-3-3 1-1h1c-.2 0 0 0 0 0l2 2s0 .2 0 0v1l-1 1zM4 18h16v2H4v-2z" fill-rule="evenodd"/></svg>',
    link: '<svg width="24" height="24"><path d="M6.2 12.3a1 1 0 011.4 1.4l-2.1 2a2 2 0 102.7 2.8l4.8-4.8a1 1 0 000-1.4 1 1 0 111.4-1.3 2.9 2.9 0 010 4L9.6 20a3.9 3.9 0 01-5.5-5.5l2-2zm11.6-.6a1 1 0 01-1.4-1.4l2-2a2 2 0 10-2.6-2.8L11 10.3a1 1 0 000 1.4A1 1 0 119.6 13a2.9 2.9 0 010-4L14.4 4a3.9 3.9 0 015.5 5.5l-2 2z" fill-rule="nonzero"/></svg>',
    "list-bull-circle": '<svg width="48" height="48"><g fill-rule="evenodd"><path d="M11 16a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6zM11 26a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6zM11 36a2 2 0 100-4 2 2 0 000 4zm0 1a3 3 0 110-6 3 3 0 010 6z" fill-rule="nonzero"/><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/></g></svg>',
    "list-bull-default": '<svg width="48" height="48"><g fill-rule="evenodd"><circle cx="11" cy="14" r="3"/><circle cx="11" cy="24" r="3"/><circle cx="11" cy="34" r="3"/><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/></g></svg>',
    "list-bull-square": '<svg width="48" height="48"><g fill-rule="evenodd"><path d="M8 11h6v6H8zM8 21h6v6H8zM8 31h6v6H8z"/><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/></g></svg>',
    "list-num-default-rtl": '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M37.4 17v-4.8l-1.6 1v-1.1l1.6-1h1.2V17zM33.3 17.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm1.7 5.7c0-1.2 1-2 2.2-2 1.3 0 2.1.8 2.1 1.8 0 .7-.3 1.2-1.3 2.2l-1.2 1v.2h2.6v1h-4.3v-.9l2-1.9c.8-.8 1-1.1 1-1.5 0-.5-.4-.8-1-.8-.5 0-.9.3-.9.9H35zm-1.7 4.3c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm3.2 7.3v-1h.7c.6 0 1-.3 1-.8 0-.4-.4-.7-1-.7s-1 .3-1 .8H35c0-1.1 1-1.8 2.2-1.8 1.2 0 2.1.6 2.1 1.6 0 .7-.4 1.2-1 1.3v.1c.7.1 1.3.7 1.3 1.4 0 1-1 1.9-2.4 1.9-1.3 0-2.2-.8-2.3-2h1.2c0 .6.5 1 1.1 1 .6 0 1-.4 1-1 0-.5-.3-.8-1-.8h-.7zm-3.3 2.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7z"/></g></svg>',
    "list-num-default": '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M10 17v-4.8l-1.5 1v-1.1l1.6-1h1.2V17h-1.2zm3.6.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .7.3.7.7 0 .4-.2.7-.7.7zm-5 5.7c0-1.2.8-2 2.1-2s2.1.8 2.1 1.8c0 .7-.3 1.2-1.4 2.2l-1.1 1v.2h2.6v1H8.6v-.9l2-1.9c.8-.8 1-1.1 1-1.5 0-.5-.4-.8-1-.8-.5 0-.9.3-.9.9H8.5zm6.3 4.3c-.5 0-.7-.3-.7-.7 0-.4.2-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zM10 34.4v-1h.7c.6 0 1-.3 1-.8 0-.4-.4-.7-1-.7s-1 .3-1 .8H8.6c0-1.1 1-1.8 2.2-1.8 1.3 0 2.1.6 2.1 1.6 0 .7-.4 1.2-1 1.3v.1c.8.1 1.3.7 1.3 1.4 0 1-1 1.9-2.4 1.9-1.3 0-2.2-.8-2.3-2h1.2c0 .6.5 1 1.1 1 .7 0 1-.4 1-1 0-.5-.3-.8-1-.8h-.7zm4.7 2.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7z"/></g></svg>',
    "list-num-lower-alpha-rtl": '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M36.5 16c-.9 0-1.5-.5-1.5-1.3s.6-1.3 1.8-1.4h1v-.4c0-.4-.2-.6-.7-.6-.4 0-.7.1-.8.4h-1.1c0-.8.8-1.4 2-1.4S39 12 39 13V16h-1.2v-.6c-.3.4-.8.7-1.4.7zm.4-.8c.6 0 1-.4 1-.9V14h-1c-.5.1-.7.3-.7.6 0 .4.3.6.7.6zM33.1 16.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7zM37.7 26c-.7 0-1.2-.2-1.5-.7v.7H35v-6.3h1.2v2.5c.3-.5.8-.9 1.5-.9 1.1 0 1.8 1 1.8 2.4 0 1.5-.7 2.4-1.8 2.4zm-.5-3.6c-.6 0-1 .5-1 1.3s.4 1.4 1 1.4c.7 0 1-.6 1-1.4 0-.8-.3-1.3-1-1.3zM33.2 26.1c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7zm6 7h-1c-.1-.5-.4-.8-1-.8s-1 .5-1 1.4c0 1 .4 1.4 1 1.4.5 0 .9-.2 1-.7h1c0 1-.8 1.7-2 1.7-1.4 0-2.2-.9-2.2-2.4s.8-2.4 2.2-2.4c1.2 0 2 .7 2 1.7zm-6.1 3c-.5 0-.7-.3-.7-.7 0-.4.2-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
    "list-num-lower-alpha": '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M10.3 15.2c.5 0 1-.4 1-.9V14h-1c-.5.1-.8.3-.8.6 0 .4.3.6.8.6zm-.4.9c-1 0-1.5-.6-1.5-1.4 0-.8.6-1.3 1.7-1.4h1.1v-.4c0-.4-.2-.6-.7-.6-.5 0-.8.1-.9.4h-1c0-.8.8-1.4 2-1.4 1.1 0 1.8.6 1.8 1.6V16h-1.1v-.6h-.1c-.2.4-.7.7-1.3.7zm4.6 0c-.5 0-.7-.3-.7-.7 0-.4.2-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm-3.2 10c-.6 0-1.2-.3-1.4-.8v.7H8.5v-6.3H10v2.5c.3-.5.8-.9 1.4-.9 1.2 0 1.9 1 1.9 2.4 0 1.5-.7 2.4-1.9 2.4zm-.4-3.7c-.7 0-1 .5-1 1.3s.3 1.4 1 1.4c.6 0 1-.6 1-1.4 0-.8-.4-1.3-1-1.3zm4 3.7c-.5 0-.7-.3-.7-.7 0-.4.2-.7.7-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm-2.2 7h-1.2c0-.5-.4-.8-.9-.8-.6 0-1 .5-1 1.4 0 1 .4 1.4 1 1.4.5 0 .8-.2 1-.7h1c0 1-.8 1.7-2 1.7-1.4 0-2.2-.9-2.2-2.4s.8-2.4 2.2-2.4c1.2 0 2 .7 2 1.7zm1.8 3c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
    "list-num-lower-greek-rtl": '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M37.4 16c-1.2 0-2-.8-2-2.3 0-1.5.8-2.4 2-2.4.6 0 1 .4 1.3 1v-.9H40v3.2c0 .4.1.5.4.5h.2v.9h-.6c-.6 0-1-.2-1-.7h-.2c-.2.4-.7.8-1.3.8zm.3-1c.6 0 1-.5 1-1.3s-.4-1.3-1-1.3-1 .5-1 1.3.4 1.4 1 1.4zM33.3 16.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zM36 21.9c0-1.5.8-2.3 2.1-2.3 1.2 0 2 .6 2 1.6 0 .6-.3 1-.9 1.3.9.3 1.3.8 1.3 1.7 0 1.2-.7 1.9-1.8 1.9-.6 0-1.1-.3-1.4-.8v2.2H36V22zm1.8 1.2v-1h.3c.5 0 .9-.2.9-.7 0-.5-.3-.8-.9-.8-.5 0-.8.3-.8 1v2.2c0 .8.4 1.3 1 1.3s1-.4 1-1-.4-1-1.2-1h-.3zM33.3 26.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zM37.1 34.6L34.8 30h1.4l1.7 3.5 1.7-3.5h1.1l-2.2 4.6v.1c.5.8.7 1.4.7 1.8 0 .4-.2.8-.4 1-.2.2-.6.3-1 .3-.9 0-1.3-.4-1.3-1.2 0-.5.2-1 .5-1.7l.1-.2zm.7 1a2 2 0 00-.4.9c0 .3.1.4.4.4.3 0 .4-.1.4-.4 0-.2-.1-.6-.4-1zM33.3 36.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
    "list-num-lower-greek": '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M10.5 15c.7 0 1-.5 1-1.3s-.3-1.3-1-1.3c-.5 0-.9.5-.9 1.3s.4 1.4 1 1.4zm-.3 1c-1.1 0-1.8-.8-1.8-2.3 0-1.5.7-2.4 1.8-2.4.7 0 1.1.4 1.3 1h.1v-.9h1.2v3.2c0 .4.1.5.4.5h.2v.9h-.6c-.6 0-1-.2-1.1-.7h-.1c-.2.4-.7.8-1.4.8zm5 .1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.7-.7.5 0 .8.3.8.7 0 .4-.3.7-.8.7zm-4.9 7v-1h.3c.6 0 1-.2 1-.7 0-.5-.4-.8-1-.8-.5 0-.8.3-.8 1v2.2c0 .8.4 1.3 1.1 1.3.6 0 1-.4 1-1s-.5-1-1.3-1h-.3zM8.6 22c0-1.5.7-2.3 2-2.3 1.2 0 2 .6 2 1.6 0 .6-.3 1-.8 1.3.8.3 1.3.8 1.3 1.7 0 1.2-.8 1.9-1.9 1.9-.6 0-1.1-.3-1.3-.8v2.2H8.5V22zm6.2 4.2c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .7.3.7.7 0 .4-.2.7-.7.7zm-4.5 8.5L8 30h1.4l1.7 3.5 1.7-3.5h1.1l-2.2 4.6v.1c.5.8.7 1.4.7 1.8 0 .4-.1.8-.4 1-.2.2-.6.3-1 .3-.9 0-1.3-.4-1.3-1.2 0-.5.2-1 .5-1.7l.1-.2zm.7 1a2 2 0 00-.4.9c0 .3.1.4.4.4.3 0 .4-.1.4-.4 0-.2-.1-.6-.4-1zm4.5.5c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
    "list-num-lower-roman-rtl": '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M32.9 16v-1.2h-1.3V16H33zm0 10v-1.2h-1.3V26H33zm0 10v-1.2h-1.3V36H33z"/><path fill-rule="nonzero" d="M36 21h-1.5v5H36zM36 31h-1.5v5H36zM39 21h-1.5v5H39zM39 31h-1.5v5H39zM42 31h-1.5v5H42zM36 11h-1.5v5H36zM36 19h-1.5v1H36zM36 29h-1.5v1H36zM39 19h-1.5v1H39zM39 29h-1.5v1H39zM42 29h-1.5v1H42zM36 9h-1.5v1H36z"/></g></svg>',
    "list-num-lower-roman": '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M15.1 16v-1.2h1.3V16H15zm0 10v-1.2h1.3V26H15zm0 10v-1.2h1.3V36H15z"/><path fill-rule="nonzero" d="M12 21h1.5v5H12zM12 31h1.5v5H12zM9 21h1.5v5H9zM9 31h1.5v5H9zM6 31h1.5v5H6zM12 11h1.5v5H12zM12 19h1.5v1H12zM12 29h1.5v1H12zM9 19h1.5v1H9zM9 29h1.5v1H9zM6 29h1.5v1H6zM12 9h1.5v1H12z"/></g></svg>',
    "list-num-upper-alpha-rtl": '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M39.3 17l-.5-1.4h-2l-.5 1.4H35l2-6h1.6l2 6h-1.3zm-1.6-4.7l-.7 2.3h1.6l-.8-2.3zM33.4 17c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .7.3.7.7 0 .4-.2.7-.7.7zm4.7 9.9h-2.7v-6H38c1.2 0 1.9.6 1.9 1.5 0 .6-.5 1.2-1 1.3.7.1 1.3.7 1.3 1.5 0 1-.8 1.7-2 1.7zm-1.4-5v1.5h1c.6 0 1-.3 1-.8 0-.4-.4-.7-1-.7h-1zm0 4h1.1c.7 0 1.1-.3 1.1-.8 0-.6-.4-.9-1.1-.9h-1.1V26zM33 27.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm4.9 10c-1.8 0-2.8-1.1-2.8-3.1s1-3.1 2.8-3.1c1.4 0 2.5.9 2.6 2.2h-1.3c0-.7-.6-1.1-1.3-1.1-1 0-1.6.7-1.6 2s.6 2 1.6 2c.7 0 1.2-.4 1.4-1h1.2c-.1 1.3-1.2 2.2-2.6 2.2zm-4.5 0c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
    "list-num-upper-alpha": '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M12.6 17l-.5-1.4h-2L9.5 17H8.3l2-6H12l2 6h-1.3zM11 12.3l-.7 2.3h1.6l-.8-2.3zm4.7 4.8c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7.5 0 .7.3.7.7 0 .4-.2.7-.7.7zM11.4 27H8.7v-6h2.6c1.2 0 1.9.6 1.9 1.5 0 .6-.5 1.2-1 1.3.7.1 1.3.7 1.3 1.5 0 1-.8 1.7-2 1.7zM10 22v1.5h1c.6 0 1-.3 1-.8 0-.4-.4-.7-1-.7h-1zm0 4H11c.7 0 1.1-.3 1.1-.8 0-.6-.4-.9-1.1-.9H10V26zm5.4 1.1c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7zm-4.1 10c-1.8 0-2.8-1.1-2.8-3.1s1-3.1 2.8-3.1c1.4 0 2.5.9 2.6 2.2h-1.3c0-.7-.6-1.1-1.3-1.1-1 0-1.6.7-1.6 2s.6 2 1.6 2c.7 0 1.2-.4 1.4-1h1.2c-.1 1.3-1.2 2.2-2.6 2.2zm4.5 0c-.5 0-.8-.3-.8-.7 0-.4.3-.7.8-.7.4 0 .7.3.7.7 0 .4-.3.7-.7.7z"/></g></svg>',
    "list-num-upper-roman-rtl": '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M8 12h22v4H8zM8 22h22v4H8zM8 32h22v4H8z"/><path d="M31.6 17v-1.2H33V17h-1.3zm0 10v-1.2H33V27h-1.3zm0 10v-1.2H33V37h-1.3z"/><path fill-rule="nonzero" d="M34.5 20H36v7h-1.5zM34.5 30H36v7h-1.5zM37.5 20H39v7h-1.5zM37.5 30H39v7h-1.5zM40.5 30H42v7h-1.5zM34.5 10H36v7h-1.5z"/></g></svg>',
    "list-num-upper-roman": '<svg width="48" height="48"><g fill-rule="evenodd"><path opacity=".2" d="M18 12h22v4H18zM18 22h22v4H18zM18 32h22v4H18z"/><path d="M15.1 17v-1.2h1.3V17H15zm0 10v-1.2h1.3V27H15zm0 10v-1.2h1.3V37H15z"/><path fill-rule="nonzero" d="M12 20h1.5v7H12zM12 30h1.5v7H12zM9 20h1.5v7H9zM9 30h1.5v7H9zM6 30h1.5v7H6zM12 10h1.5v7H12z"/></g></svg>',
    lock: '<svg width="24" height="24"><path d="M16.3 11c.2 0 .3 0 .5.2l.2.6v7.4c0 .3 0 .4-.2.6l-.6.2H7.8c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6v-7.4c0-.3 0-.4.2-.6l.5-.2H8V8c0-.8.3-1.5.9-2.1.6-.6 1.3-.9 2.1-.9h2c.8 0 1.5.3 2.1.9.6.6.9 1.3.9 2.1v3h.3zM10 8v3h4V8a1 1 0 00-.3-.7A1 1 0 0013 7h-2a1 1 0 00-.7.3 1 1 0 00-.3.7z" fill-rule="evenodd"/></svg>',
    ltr: '<svg width="24" height="24"><path d="M11 5h7a1 1 0 010 2h-1v11a1 1 0 01-2 0V7h-2v11a1 1 0 01-2 0v-6c-.5 0-1 0-1.4-.3A3.4 3.4 0 017.8 10a3.3 3.3 0 010-2.8 3.4 3.4 0 011.8-1.8L11 5zM4.4 16.2L6.2 15l-1.8-1.2a1 1 0 011.2-1.6l3 2a1 1 0 010 1.6l-3 2a1 1 0 11-1.2-1.6z" fill-rule="evenodd"/></svg>',
    "more-drawer": '<svg width="24" height="24"><path d="M6 10a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2zm12 0a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2zm-6 0a2 2 0 00-2 2c0 1.1.9 2 2 2a2 2 0 002-2 2 2 0 00-2-2z" fill-rule="nonzero"/></svg>',
    "new-document": '<svg width="24" height="24"><path d="M14.4 3H7a2 2 0 00-2 2v14c0 1.1.9 2 2 2h10a2 2 0 002-2V7.6L14.4 3zM17 19H7V5h6v4h4v10z" fill-rule="nonzero"/></svg>',
    "new-tab": '<svg width="24" height="24"><path d="M15 13l2-2v8H5V7h8l-2 2H7v8h8v-4zm4-8v5.5l-2-2-5.6 5.5H10v-1.4L15.5 7l-2-2H19z" fill-rule="evenodd"/></svg>',
    "non-breaking": '<svg width="24" height="24"><path d="M11 11H8a1 1 0 110-2h3V6c0-.6.4-1 1-1s1 .4 1 1v3h3c.6 0 1 .4 1 1s-.4 1-1 1h-3v3c0 .6-.4 1-1 1a1 1 0 01-1-1v-3zm10 4v5H3v-5c0-.6.4-1 1-1s1 .4 1 1v3h14v-3c0-.6.4-1 1-1s1 .4 1 1z" fill-rule="evenodd"/></svg>',
    notice: '<svg width="24" height="24"><path d="M17.8 9.8L15.4 4 20 8.5v7L15.5 20h-7L4 15.5v-7L8.5 4h7l2.3 5.8zm0 0l2.2 5.7-2.3-5.8zM13 17v-2h-2v2h2zm0-4V7h-2v6h2z" fill-rule="evenodd"/></svg>',
    "ordered-list-rtl": '<svg width="24" height="24"><path d="M6 17h8a1 1 0 010 2H6a1 1 0 010-2zm0-6h8a1 1 0 010 2H6a1 1 0 010-2zm0-6h8a1 1 0 010 2H6a1 1 0 110-2zm13-1v3.5a.5.5 0 11-1 0V5h-.5a.5.5 0 110-1H19zm-1 8.8l.2.2h1.3a.5.5 0 110 1h-1.6a1 1 0 01-.9-1V13c0-.4.3-.8.6-1l1.2-.4.2-.3a.2.2 0 00-.2-.2h-1.3a.5.5 0 01-.5-.5c0-.3.2-.5.5-.5h1.6c.5 0 .9.4.9 1v.1c0 .4-.3.8-.6 1l-1.2.4-.2.3zm2 4.2v2c0 .6-.4 1-1 1h-1.5a.5.5 0 010-1h1.2a.3.3 0 100-.6h-1.3a.4.4 0 110-.8h1.3a.3.3 0 000-.6h-1.2a.5.5 0 110-1H19c.6 0 1 .4 1 1z" fill-rule="evenodd"/></svg>',
    "ordered-list": '<svg width="24" height="24"><path d="M10 17h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0-6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 110-2zM6 4v3.5c0 .3-.2.5-.5.5a.5.5 0 01-.5-.5V5h-.5a.5.5 0 010-1H6zm-1 8.8l.2.2h1.3c.3 0 .5.2.5.5s-.2.5-.5.5H4.9a1 1 0 01-.9-1V13c0-.4.3-.8.6-1l1.2-.4.2-.3a.2.2 0 00-.2-.2H4.5a.5.5 0 01-.5-.5c0-.3.2-.5.5-.5h1.6c.5 0 .9.4.9 1v.1c0 .4-.3.8-.6 1l-1.2.4-.2.3zM7 17v2c0 .6-.4 1-1 1H4.5a.5.5 0 010-1h1.2c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H4.4a.4.4 0 110-.8h1.3c.2 0 .3-.1.3-.3 0-.2-.1-.3-.3-.3H4.5a.5.5 0 110-1H6c.6 0 1 .4 1 1z" fill-rule="evenodd"/></svg>',
    orientation: '<svg width="24" height="24"><path d="M7.3 6.4L1 13l6.4 6.5 6.5-6.5-6.5-6.5zM3.7 13l3.6-3.7L11 13l-3.7 3.7-3.6-3.7zM12 6l2.8 2.7c.3.3.3.8 0 1-.3.4-.9.4-1.2 0L9.2 5.7a.8.8 0 010-1.2L13.6.2c.3-.3.9-.3 1.2 0 .3.3.3.8 0 1.1L12 4h1a9 9 0 11-4.3 16.9l1.5-1.5A7 7 0 1013 6h-1z" fill-rule="nonzero"/></svg>',
    outdent: '<svg width="24" height="24"><path d="M7 5h12c.6 0 1 .4 1 1s-.4 1-1 1H7a1 1 0 110-2zm5 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm0 4h7c.6 0 1 .4 1 1s-.4 1-1 1h-7a1 1 0 010-2zm-5 4h12a1 1 0 010 2H7a1 1 0 010-2zm1.6-3.8a1 1 0 01-1.2 1.6l-3-2a1 1 0 010-1.6l3-2a1 1 0 011.2 1.6L6.8 12l1.8 1.2z" fill-rule="evenodd"/></svg>',
    "page-break": '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M5 11c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zm3 0h1c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2zm4 0c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zm3 0h1c.6 0 1 .4 1 1s-.4 1-1 1h-1a1 1 0 010-2zm4 0c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zM7 3v5h10V3c0-.6.4-1 1-1s1 .4 1 1v7H5V3c0-.6.4-1 1-1s1 .4 1 1zM6 22a1 1 0 01-1-1v-7h14v7c0 .6-.4 1-1 1a1 1 0 01-1-1v-5H7v5c0 .6-.4 1-1 1z"/></g></svg>',
    paragraph: '<svg width="24" height="24"><path fill-rule="evenodd" d="M10 5h7a1 1 0 010 2h-1v11a1 1 0 01-2 0V7h-2v11a1 1 0 01-2 0v-6c-.5 0-1 0-1.4-.3A3.4 3.4 0 016.8 10a3.3 3.3 0 010-2.8 3.4 3.4 0 011.8-1.8L10 5z"/></svg>',
    "paste-column-after": '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3 3 0 012.8 2H18c1 0 2 .8 2 1.9V7h-2V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h7v2H6c-1 0-2-.8-2-1.9V5c0-1 .8-2 1.9-2H9.2A3 3 0 0112 1zm8 7v12h-6V8h6zm-1.5 1.5h-3v9h3v-9zM12 3a1 1 0 100 2 1 1 0 000-2z"/></svg>',
    "paste-column-before": '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3 3 0 012.8 2H18c1 0 2 .8 2 1.9V18c0 1-.8 2-1.9 2H11v-2h7V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v2H4V5c0-1 .8-2 1.9-2H9.2A3 3 0 0112 1zm-2 7v12H4V8h6zM8.5 9.5h-3v9h3v-9zM12 3a1 1 0 100 2 1 1 0 000-2z"/></svg>',
    "paste-row-after": '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3 3 0 012.8 2H18c1 0 2 .8 2 1.9V11h-2V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h14c0 1-.8 2-1.9 2H6c-1 0-2-.8-2-1.9V5c0-1 .8-2 1.9-2H9.2A3 3 0 0112 1zm10 11v5H8v-5h14zm-1.5 1.5h-11v2h11v-2zM12 3a1 1 0 100 2 1 1 0 000-2z"/></svg>',
    "paste-row-before": '<svg width="24" height="24"><path fill-rule="evenodd" d="M12 1a3 3 0 012.8 2H18c1 0 2 .8 2 1.9V7h-2V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h12v-4h2v4c0 1-.8 2-1.9 2H6c-1 0-2-.8-2-1.9V5c0-1 .8-2 1.9-2H9.2A3 3 0 0112 1zm10 7v5H8V8h14zm-1.5 1.5h-11v2h11v-2zM12 3a1 1 0 100 2 1 1 0 000-2z"/></svg>',
    "paste-text": '<svg width="24" height="24"><path d="M18 9V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h3V9h9zM9 20H6a2 2 0 01-2-2V5c0-1.1.9-2 2-2h3.2A3 3 0 0112 1a3 3 0 012.8 2H18a2 2 0 012 2v4h1v12H9v-1zm1.5-9.5v9h9v-9h-9zM12 3a1 1 0 00-1 1c0 .5.4 1 1 1s1-.5 1-1-.4-1-1-1zm0 9h6v2h-.5l-.5-1h-1v4h.8v1h-3.6v-1h.8v-4h-1l-.5 1H12v-2z" fill-rule="nonzero"/></svg>',
    paste: '<svg width="24" height="24"><path d="M18 9V5h-2v1c0 .6-.4 1-1 1H9a1 1 0 01-1-1V5H6v13h3V9h9zM9 20H6a2 2 0 01-2-2V5c0-1.1.9-2 2-2h3.2A3 3 0 0112 1a3 3 0 012.8 2H18a2 2 0 012 2v4h1v12H9v-1zm1.5-9.5v9h9v-9h-9zM12 3a1 1 0 00-1 1c0 .5.4 1 1 1s1-.5 1-1-.4-1-1-1z" fill-rule="nonzero"/></svg>',
    "permanent-pen": '<svg width="24" height="24"><path d="M10.5 17.5L8 20H3v-3l3.5-3.5a2 2 0 010-3L14 3l1 1-7.3 7.3a1 1 0 000 1.4l3.6 3.6c.4.4 1 .4 1.4 0L20 9l1 1-7.6 7.6a2 2 0 01-2.8 0l-.1-.1z" fill-rule="nonzero"/></svg>',
    plus: '<svg width="24" height="24"><path d="M12 4c.5 0 1 .4 1 .9V11h6a1 1 0 01.1 2H13v6a1 1 0 01-2 .1V13H5a1 1 0 01-.1-2H11V5c0-.6.4-1 1-1z"/></svg>',
    preferences: '<svg width="24" height="24"><path d="M20.1 13.5l-1.9.2a5.8 5.8 0 01-.6 1.5l1.2 1.5c.4.4.3 1 0 1.4l-.7.7a1 1 0 01-1.4 0l-1.5-1.2a6.2 6.2 0 01-1.5.6l-.2 1.9c0 .5-.5.9-1 .9h-1a1 1 0 01-1-.9l-.2-1.9a5.8 5.8 0 01-1.5-.6l-1.5 1.2a1 1 0 01-1.4 0l-.7-.7a1 1 0 010-1.4l1.2-1.5a6.2 6.2 0 01-.6-1.5l-1.9-.2a1 1 0 01-.9-1v-1c0-.5.4-1 .9-1l1.9-.2a5.8 5.8 0 01.6-1.5L5.2 7.3a1 1 0 010-1.4l.7-.7a1 1 0 011.4 0l1.5 1.2a6.2 6.2 0 011.5-.6l.2-1.9c0-.5.5-.9 1-.9h1c.5 0 1 .4 1 .9l.2 1.9a5.8 5.8 0 011.5.6l1.5-1.2a1 1 0 011.4 0l.7.7c.3.4.4 1 0 1.4l-1.2 1.5a6.2 6.2 0 01.6 1.5l1.9.2c.5 0 .9.5.9 1v1c0 .5-.4 1-.9 1zM12 15a3 3 0 100-6 3 3 0 000 6z" fill-rule="evenodd"/></svg>',
    preview: '<svg width="24" height="24"><path d="M3.5 12.5c.5.8 1.1 1.6 1.8 2.3 2 2 4.2 3.2 6.7 3.2s4.7-1.2 6.7-3.2a16.2 16.2 0 002.1-2.8 15.7 15.7 0 00-2.1-2.8c-2-2-4.2-3.2-6.7-3.2a9.3 9.3 0 00-6.7 3.2A16.2 16.2 0 003.2 12c0 .2.2.3.3.5zm-2.4-1l.7-1.2L4 7.8C6.2 5.4 8.9 4 12 4c3 0 5.8 1.4 8.1 3.8a18.2 18.2 0 012.8 3.7v1l-.7 1.2-2.1 2.5c-2.3 2.4-5 3.8-8.1 3.8-3 0-5.8-1.4-8.1-3.8a18.2 18.2 0 01-2.8-3.7 1 1 0 010-1zm12-3.3a2 2 0 102.7 2.6 4 4 0 11-2.6-2.6z" fill-rule="nonzero"/></svg>',
    print: '<svg width="24" height="24"><path d="M18 8H6a3 3 0 00-3 3v6h2v3h14v-3h2v-6a3 3 0 00-3-3zm-1 10H7v-4h10v4zm.5-5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5 1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm.5-8H6v2h12V5z" fill-rule="nonzero"/></svg>',
    quote: '<svg width="24" height="24"><path d="M7.5 17h.9c.4 0 .7-.2.9-.6L11 13V8c0-.6-.4-1-1-1H6a1 1 0 00-1 1v4c0 .6.4 1 1 1h2l-1.3 2.7a1 1 0 00.8 1.3zm8 0h.9c.4 0 .7-.2.9-.6L19 13V8c0-.6-.4-1-1-1h-4a1 1 0 00-1 1v4c0 .6.4 1 1 1h2l-1.3 2.7a1 1 0 00.8 1.3z" fill-rule="nonzero"/></svg>',
    redo: '<svg width="24" height="24"><path d="M17.6 10H12c-2.8 0-4.4 1.4-4.9 3.5-.4 2 .3 4 1.4 4.6a1 1 0 11-1 1.8c-2-1.2-2.9-4.1-2.3-6.8.6-3 3-5.1 6.8-5.1h5.6l-3.3-3.3a1 1 0 111.4-1.4l5 5a1 1 0 010 1.4l-5 5a1 1 0 01-1.4-1.4l3.3-3.3z" fill-rule="nonzero"/></svg>',
    reload: '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M5 22.1l-1.2-4.7v-.2a1 1 0 011-1l5 .4a1 1 0 11-.2 2l-2.2-.2a7.8 7.8 0 008.4.2 7.5 7.5 0 003.5-6.4 1 1 0 112 0 9.5 9.5 0 01-4.5 8 9.9 9.9 0 01-10.2 0l.4 1.4a1 1 0 11-2 .5zM13.6 7.4c0-.5.5-1 1-.9l2.8.2a8 8 0 00-9.5-1 7.5 7.5 0 00-3.6 7 1 1 0 01-2 0 9.5 9.5 0 014.5-8.6 10 10 0 0110.9.3l-.3-1a1 1 0 012-.5l1.1 4.8a1 1 0 01-1 1.2l-5-.4a1 1 0 01-.9-1z"/></g></svg>',
    "remove-formatting": '<svg width="24" height="24"><path d="M13.2 6a1 1 0 010 .2l-2.6 10a1 1 0 01-1 .8h-.2a.8.8 0 01-.8-1l2.6-10H8a1 1 0 110-2h9a1 1 0 010 2h-3.8zM5 18h7a1 1 0 010 2H5a1 1 0 010-2zm13 1.5L16.5 18 15 19.5a.7.7 0 01-1-1l1.5-1.5-1.5-1.5a.7.7 0 011-1l1.5 1.5 1.5-1.5a.7.7 0 011 1L17.5 17l1.5 1.5a.7.7 0 01-1 1z" fill-rule="evenodd"/></svg>',
    remove: '<svg width="24" height="24"><path d="M16 7h3a1 1 0 010 2h-1v9a3 3 0 01-3 3H9a3 3 0 01-3-3V9H5a1 1 0 110-2h3V6a3 3 0 013-3h2a3 3 0 013 3v1zm-2 0V6c0-.6-.4-1-1-1h-2a1 1 0 00-1 1v1h4zm2 2H8v9c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V9zm-7 3a1 1 0 012 0v4a1 1 0 01-2 0v-4zm4 0a1 1 0 012 0v4a1 1 0 01-2 0v-4z" fill-rule="nonzero"/></svg>',
    "resize-handle": '<svg width="10" height="10"><g fill-rule="nonzero"><path d="M8.1 1.1A.5.5 0 119 2l-7 7A.5.5 0 111 8l7-7zM8.1 5.1A.5.5 0 119 6l-3 3A.5.5 0 115 8l3-3z"/></g></svg>',
    resize: '<svg width="24" height="24"><path d="M4 5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h6c.3 0 .5.1.7.3.2.2.3.4.3.7 0 .3-.1.5-.3.7a1 1 0 01-.7.3H7.4L18 16.6V13c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3.3 0 .5.1.7.3.2.2.3.4.3.7v6c0 .3-.1.5-.3.7a1 1 0 01-.7.3h-6a1 1 0 01-.7-.3 1 1 0 01-.3-.7c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h3.6L6 7.4V11c0 .3-.1.5-.3.7a1 1 0 01-.7.3 1 1 0 01-.7-.3A1 1 0 014 11V5z" fill-rule="evenodd"/></svg>',
    "restore-draft": '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M17 13c0 .6-.4 1-1 1h-4V8c0-.6.4-1 1-1s1 .4 1 1v4h2c.6 0 1 .4 1 1z"/><path d="M4.7 10H9a1 1 0 010 2H3a1 1 0 01-1-1V5a1 1 0 112 0v3l2.5-2.4a9.2 9.2 0 0110.8-1.5A9 9 0 0113.4 21c-2.4.1-4.7-.7-6.5-2.2a1 1 0 111.3-1.5 7.2 7.2 0 0011.6-3.7 7 7 0 00-3.5-7.7A7.2 7.2 0 008 7L4.7 10z" fill-rule="nonzero"/></g></svg>',
    "rotate-left": '<svg width="24" height="24"><path d="M4.7 10H9a1 1 0 010 2H3a1 1 0 01-1-1V5a1 1 0 112 0v3l2.5-2.4a9.2 9.2 0 0110.8-1.5A9 9 0 0113.4 21c-2.4.1-4.7-.7-6.5-2.2a1 1 0 111.3-1.5 7.2 7.2 0 0011.6-3.7 7 7 0 00-3.5-7.7A7.2 7.2 0 008 7L4.7 10z" fill-rule="nonzero"/></svg>',
    "rotate-right": '<svg width="24" height="24"><path d="M20 8V5a1 1 0 012 0v6c0 .6-.4 1-1 1h-6a1 1 0 010-2h4.3L16 7A7.2 7.2 0 007.7 6a7 7 0 003 13.1c1.9.1 3.7-.5 5-1.7a1 1 0 011.4 1.5A9.2 9.2 0 012.2 14c-.9-3.9 1-8 4.5-9.9 3.5-1.9 8-1.3 10.8 1.5L20 8z" fill-rule="nonzero"/></svg>',
    rtl: '<svg width="24" height="24"><path d="M8 5h8v2h-2v12h-2V7h-2v12H8v-7c-.5 0-1 0-1.4-.3A3.4 3.4 0 014.8 10a3.3 3.3 0 010-2.8 3.4 3.4 0 011.8-1.8L8 5zm12 11.2a1 1 0 11-1 1.6l-3-2a1 1 0 010-1.6l3-2a1 1 0 111 1.6L18.4 15l1.8 1.2z" fill-rule="evenodd"/></svg>',
    save: '<svg width="24" height="24"><path d="M5 16h14a2 2 0 012 2v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2c0-1.1.9-2 2-2zm0 2v2h14v-2H5zm10 0h2v2h-2v-2zm-4-6.4L8.7 9.3a1 1 0 10-1.4 1.4l4 4c.4.4 1 .4 1.4 0l4-4a1 1 0 10-1.4-1.4L13 11.6V4a1 1 0 00-2 0v7.6z" fill-rule="nonzero"/></svg>',
    search: '<svg width="24" height="24"><path d="M16 17.3a8 8 0 111.4-1.4l4.3 4.4a1 1 0 01-1.4 1.4l-4.4-4.3zm-5-.3a6 6 0 100-12 6 6 0 000 12z" fill-rule="nonzero"/></svg>',
    "select-all": '<svg width="24" height="24"><path d="M3 5h2V3a2 2 0 00-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2a2 2 0 00-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8a2 2 0 002-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z" fill-rule="nonzero"/></svg>',
    selected: '<svg width="24" height="24"><path fill-rule="nonzero" d="M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2zm3.6 10.9L7 12.3a.7.7 0 00-1 1L9.6 17 18 8.6a.7.7 0 000-1 .7.7 0 00-1 0l-7.4 7.3z"/></svg>',
    settings: '<svg width="24" height="24"><path d="M11 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8v.3c0 .2 0 .3-.2.5l-.6.2H7.8c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6V8H5a1 1 0 110-2h2v-.3c0-.2 0-.3.2-.5l.5-.2h2.5c.3 0 .4 0 .6.2l.2.5V6zM8 8h2V6H8v2zm9 2.8v.2h2c.6 0 1 .4 1 1s-.4 1-1 1h-2v.3c0 .2 0 .3-.2.5l-.6.2h-2.4c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6V13H5a1 1 0 010-2h8v-.3c0-.2 0-.3.2-.5l.6-.2h2.4c.3 0 .4 0 .6.2l.2.6zM14 13h2v-2h-2v2zm-3 2.8v.2h8c.6 0 1 .4 1 1s-.4 1-1 1h-8v.3c0 .2 0 .3-.2.5l-.6.2H7.8c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6V18H5a1 1 0 010-2h2v-.3c0-.2 0-.3.2-.5l.5-.2h2.5c.3 0 .4 0 .6.2l.2.6zM8 18h2v-2H8v2z" fill-rule="evenodd"/></svg>',
    sharpen: '<svg width="24" height="24"><path d="M16 6l4 4-8 9-8-9 4-4h8zm-4 10.2l5.5-6.2-.1-.1H12v-.3h5.1l-.2-.2H12V9h4.6l-.2-.2H12v-.3h4.1l-.2-.2H12V8h3.6l-.2-.2H8.7L6.5 10l.1.1H12v.3H6.9l.2.2H12v.3H7.3l.2.2H12v.3H7.7l.3.2h4v.3H8.2l.2.2H12v.3H8.6l.3.2H12v.3H9l.3.2H12v.3H9.5l.2.2H12v.3h-2l.2.2H12v.3h-1.6l.2.2H12v.3h-1.1l.2.2h.9v.3h-.7l.2.2h.5v.3h-.3l.3.2z" fill-rule="evenodd"/></svg>',
    sourcecode: '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M9.8 15.7c.3.3.3.8 0 1-.3.4-.9.4-1.2 0l-4.4-4.1a.8.8 0 010-1.2l4.4-4.2c.3-.3.9-.3 1.2 0 .3.3.3.8 0 1.1L6 12l3.8 3.7zM14.2 15.7c-.3.3-.3.8 0 1 .4.4.9.4 1.2 0l4.4-4.1c.3-.3.3-.9 0-1.2l-4.4-4.2a.8.8 0 00-1.2 0c-.3.3-.3.8 0 1.1L18 12l-3.8 3.7z"/></g></svg>',
    "spell-check": '<svg width="24" height="24"><path d="M6 8v3H5V5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h2c.3 0 .5.1.7.3.2.2.3.4.3.7v6H8V8H6zm0-3v2h2V5H6zm13 0h-3v5h3v1h-3a1 1 0 01-.7-.3 1 1 0 01-.3-.7V5c0-.3.1-.5.3-.7.2-.2.4-.3.7-.3h3v1zm-5 1.5l-.1.7c-.1.2-.3.3-.6.3.3 0 .5.1.6.3l.1.7V10c0 .3-.1.5-.3.7a1 1 0 01-.7.3h-3V4h3c.3 0 .5.1.7.3.2.2.3.4.3.7v1.5zM13 10V8h-2v2h2zm0-3V5h-2v2h2zm3 5l1 1-6.5 7L7 15.5l1.3-1 2.2 2.2L16 12z" fill-rule="evenodd"/></svg>',
    "strike-through": '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M15.6 8.5c-.5-.7-1-1.1-1.3-1.3-.6-.4-1.3-.6-2-.6-2.7 0-2.8 1.7-2.8 2.1 0 1.6 1.8 2 3.2 2.3 4.4.9 4.6 2.8 4.6 3.9 0 1.4-.7 4.1-5 4.1A6.2 6.2 0 017 16.4l1.5-1.1c.4.6 1.6 2 3.7 2 1.6 0 2.5-.4 3-1.2.4-.8.3-2-.8-2.6-.7-.4-1.6-.7-2.9-1-1-.2-3.9-.8-3.9-3.6C7.6 6 10.3 5 12.4 5c2.9 0 4.2 1.6 4.7 2.4l-1.5 1.1z"/><path d="M5 11h14a1 1 0 010 2H5a1 1 0 010-2z" fill-rule="nonzero"/></g></svg>',
    subscript: '<svg width="24" height="24"><path d="M10.4 10l4.6 4.6-1.4 1.4L9 11.4 4.4 16 3 14.6 7.6 10 3 5.4 4.4 4 9 8.6 13.6 4 15 5.4 10.4 10zM21 19h-5v-1l1-.8 1.7-1.6c.3-.4.5-.8.5-1.2 0-.3 0-.6-.2-.7-.2-.2-.5-.3-.9-.3a2 2 0 00-.8.2l-.7.3-.4-1.1 1-.6 1.2-.2c.8 0 1.4.3 1.8.7.4.4.6.9.6 1.5s-.2 1.1-.5 1.6a8 8 0 01-1.3 1.3l-.6.6h2.6V19z" fill-rule="nonzero"/></svg>',
    superscript: '<svg width="24" height="24"><path d="M15 9.4L10.4 14l4.6 4.6-1.4 1.4L9 15.4 4.4 20 3 18.6 7.6 14 3 9.4 4.4 8 9 12.6 13.6 8 15 9.4zm5.9 1.6h-5v-1l1-.8 1.7-1.6c.3-.5.5-.9.5-1.3 0-.3 0-.5-.2-.7-.2-.2-.5-.3-.9-.3l-.8.2-.7.4-.4-1.2c.2-.2.5-.4 1-.5.3-.2.8-.2 1.2-.2.8 0 1.4.2 1.8.6.4.4.6 1 .6 1.6 0 .5-.2 1-.5 1.5l-1.3 1.4-.6.5h2.6V11z" fill-rule="nonzero"/></svg>',
    "table-caption": '<svg width="24" height="24"><g fill-rule="nonzero"><rect width="12" height="2" x="3" y="4" rx="1"/><path d="M19 8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2v-8c0-1.1.9-2 2-2h14zM5 15v3h6v-3H5zm14 0h-6v3h6v-3zm0-5h-6v3h6v-3zM5 13h6v-3H5v3z"/></g></svg>',
    "table-cell-classes": '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M13 4v9H3V6c0-1.1.9-2 2-2h8zm-2 2H5v5h6V6z"/><path fill-rule="nonzero" d="M13 4h6a2 2 0 012 2v7h-8v-2h6V6h-6V4z" opacity=".2"/><path d="M18 20l-2.6 1.6.7-3-2.4-2 3.1-.2 1.2-2.9 1.2 2.9 3 .2-2.3 2 .7 3z"/><path fill-rule="nonzero" d="M3 13v5c0 1.1.9 2 2 2h8v-7h-2v5H5v-5H3z" opacity=".2"/></g></svg>',
    "table-cell-properties": '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-8 9H5v5h6v-5zm8 0h-6v5h6v-5zm-8-7H5v5h6V6z"/></svg>',
    "table-cell-select-all": '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm0 2H5v12h14V6z"/><path d="M13 6v5h6v2h-6v5h-2v-5H5v-2h6V6h2z" opacity=".2"/></g></svg>',
    "table-cell-select-inner": '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm0 2H5v12h14V6z" opacity=".2"/><path d="M13 6v5h6v2h-6v5h-2v-5H5v-2h6V6h2z"/></g></svg>',
    "table-classes": '<svg width="24" height="24"><g fill-rule="evenodd"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v7h-8v7H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-8 9H5v5h6v-5zm8-7h-6v5h6V6zm-8 0H5v5h6V6z"/><path d="M18 20l-2.6 1.6.7-3-2.4-2 3.1-.2 1.2-2.9 1.2 2.9 3 .2-2.3 2 .7 3z"/></g></svg>',
    "table-delete-column": '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-4 4h-2V6h-2v2H9V6H5v12h4v-2h2v2h2v-2h2v2h4V6h-4v2zm.3.5l1 1.2-3 2.3 3 2.3-1 1.2L12 13l-3.3 2.6-1-1.2 3-2.3-3-2.3 1-1.2L12 11l3.3-2.5z"/></svg>',
    "table-delete-row": '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm0 2H5v3h2.5v2H5v2h2.5v2H5v3h14v-3h-2.5v-2H19v-2h-2.5V9H19V6zm-4.7 1.8l1.2 1L13 12l2.6 3.3-1.2 1-2.3-3-2.3 3-1.2-1L11 12 8.5 8.7l1.2-1 2.3 3 2.3-3z"/></svg>',
    "table-delete-table": '<svg width="24" height="24"><g fill-rule="nonzero"><path d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM5 6v12h14V6H5z"/><path d="M14.4 8.6l1 1-2.3 2.4 2.3 2.4-1 1-2.4-2.3-2.4 2.3-1-1 2.3-2.4-2.3-2.4 1-1 2.4 2.3z"/></g></svg>',
    "table-insert-column-after": '<svg width="24" height="24"><path fill-rule="nonzero" d="M20 4c.6 0 1 .4 1 1v2a1 1 0 01-2 0V6h-8v12h8v-1a1 1 0 012 0v2c0 .5-.4 1-.9 1H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h15zM9 13H5v5h4v-5zm7-5c.5 0 1 .4 1 .9V11h2a1 1 0 01.1 2H17v2a1 1 0 01-2 .1V13h-2a1 1 0 01-.1-2H15V9c0-.6.4-1 1-1zM9 6H5v5h4V6z"/></svg>',
    "table-insert-column-before": '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H4a1 1 0 01-1-1v-2a1 1 0 012 0v1h8V6H5v1a1 1 0 11-2 0V5c0-.6.4-1 1-1h15zm0 9h-4v5h4v-5zM8 8c.5 0 1 .4 1 .9V11h2a1 1 0 01.1 2H9v2a1 1 0 01-2 .1V13H5a1 1 0 01-.1-2H7V9c0-.6.4-1 1-1zm11-2h-4v5h4V6z"/></svg>',
    "table-insert-row-above": '<svg width="24" height="24"><path fill-rule="nonzero" d="M6 4a1 1 0 110 2H5v6h14V6h-1a1 1 0 010-2h2c.6 0 1 .4 1 1v13a2 2 0 01-2 2H5a2 2 0 01-2-2V5c0-.6.4-1 1-1h2zm5 10H5v4h6v-4zm8 0h-6v4h6v-4zM12 3c.5 0 1 .4 1 .9V6h2a1 1 0 010 2h-2v2a1 1 0 01-2 .1V8H9a1 1 0 010-2h2V4c0-.6.4-1 1-1z"/></svg>',
    "table-insert-row-after": '<svg width="24" height="24"><path fill-rule="nonzero" d="M12 13c.5 0 1 .4 1 .9V16h2a1 1 0 01.1 2H13v2a1 1 0 01-2 .1V18H9a1 1 0 01-.1-2H11v-2c0-.6.4-1 1-1zm6 7a1 1 0 010-2h1v-6H5v6h1a1 1 0 010 2H4a1 1 0 01-1-1V6c0-1.1.9-2 2-2h14a2 2 0 012 2v13c0 .5-.4 1-.9 1H18zM11 6H5v4h6V6zm8 0h-6v4h6V6z"/></svg>',
    "table-left-header": '<svg width="24" height="24"><path d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm0 9h-4v5h4v-5zm-6 0H9v5h4v-5zm0-7H9v5h4V6zm6 0h-4v5h4V6z"/></svg>',
    "table-merge-cells": '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM5 15.5V18h3v-2.5H5zm14-5h-9V18h9v-7.5zM19 6h-4v2.5h4V6zM8 6H5v2.5h3V6zm5 0h-3v2.5h3V6zm-8 7.5h3v-3H5v3z"/></svg>',
    "table-row-numbering-rtl": '<svg width="24" height="24"><path d="M6 4a2 2 0 00-2 2v13c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H6zm0 12h8v3H6v-3zm11 0c.6 0 1 .4 1 1v1a1 1 0 01-2 0v-1c0-.6.4-1 1-1zM6 11h8v3H6v-3zm11 0c.6 0 1 .4 1 1v1a1 1 0 01-2 0v-1c0-.6.4-1 1-1zM6 6h8v3H6V6zm11 0c.6 0 1 .4 1 1v1a1 1 0 11-2 0V7c0-.6.4-1 1-1z"/></svg>',
    "table-row-numbering": '<svg width="24" height="24"><path d="M18 4a2 2 0 012 2v13a2 2 0 01-2 2H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h12zm0 12h-8v3h8v-3zM7 16a1 1 0 00-1 1v1a1 1 0 002 0v-1c0-.6-.4-1-1-1zm11-5h-8v3h8v-3zM7 11a1 1 0 00-1 1v1a1 1 0 002 0v-1c0-.6-.4-1-1-1zm11-5h-8v3h8V6zM7 6a1 1 0 00-1 1v1a1 1 0 102 0V7c0-.6-.4-1-1-1z"/></svg>',
    "table-row-properties": '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM5 15v3h6v-3H5zm14 0h-6v3h6v-3zm0-9h-6v3h6V6zM5 9h6V6H5v3z"/></svg>',
    "table-split-cells": '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM8 15.5H5V18h3v-2.5zm11-5h-9V18h9v-7.5zm-2.5 1l1 1-2 2 2 2-1 1-2-2-2 2-1-1 2-2-2-2 1-1 2 2 2-2zm-8.5-1H5v3h3v-3zM19 6h-4v2.5h4V6zM8 6H5v2.5h3V6zm5 0h-3v2.5h3V6z"/></svg>',
    "table-top-header": '<svg width="24" height="24"><path d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zm-8 11H5v3h6v-3zm8 0h-6v3h6v-3zm0-5h-6v3h6v-3zM5 13h6v-3H5v3z"/></svg>',
    table: '<svg width="24" height="24"><path fill-rule="nonzero" d="M19 4a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V6c0-1.1.9-2 2-2h14zM5 14v4h6v-4H5zm14 0h-6v4h6v-4zm0-6h-6v4h6V8zM5 12h6V8H5v4z"/></svg>',
    template: '<svg width="24" height="24"><path d="M19 19v-1H5v1h14zM9 16v-4a5 5 0 116 0v4h4a2 2 0 012 2v3H3v-3c0-1.1.9-2 2-2h4zm4 0v-5l.8-.6a3 3 0 10-3.6 0l.8.6v5h2z" fill-rule="nonzero"/></svg>',
    "temporary-placeholder": '<svg width="24" height="24"><g fill-rule="evenodd"><path d="M9 7.6V6h2.5V4.5a.5.5 0 111 0V6H15v1.6a8 8 0 11-6 0zm-2.6 5.3a.5.5 0 00.3.6c.3 0 .6 0 .6-.3l.1-.2a5 5 0 013.3-2.8c.3-.1.4-.4.4-.6-.1-.3-.4-.5-.6-.4a6 6 0 00-4.1 3.7z"/><circle cx="14" cy="4" r="1"/><circle cx="12" cy="2" r="1"/><circle cx="10" cy="4" r="1"/></g></svg>',
    "text-color": '<svg width="24" height="24"><g fill-rule="evenodd"><path id="tox-icon-text-color__color" d="M3 18h18v3H3z"/><path d="M8.7 16h-.8a.5.5 0 01-.5-.6l2.7-9c.1-.3.3-.4.5-.4h2.8c.2 0 .4.1.5.4l2.7 9a.5.5 0 01-.5.6h-.8a.5.5 0 01-.4-.4l-.7-2.2c0-.3-.3-.4-.5-.4h-3.4c-.2 0-.4.1-.5.4l-.7 2.2c0 .3-.2.4-.4.4zm2.6-7.6l-.6 2a.5.5 0 00.5.6h1.6a.5.5 0 00.5-.6l-.6-2c0-.3-.3-.4-.5-.4h-.4c-.2 0-.4.1-.5.4z"/></g></svg>',
    toc: '<svg width="24" height="24"><path d="M5 5c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 110-2zm3 0h11c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 110-2zm-3 8c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zm3 0h11c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2zm0-4c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 110-2zm3 0h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm-3 8c.6 0 1 .4 1 1s-.4 1-1 1a1 1 0 010-2zm3 0h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
    translate: '<svg width="24" height="24"><path d="M12.7 14.3l-.3.7-.4.7-2.2-2.2-3.1 3c-.3.4-.8.4-1 0a.7.7 0 010-1l3.1-3A12.4 12.4 0 016.7 9H8a10.1 10.1 0 001.7 2.4c.5-.5 1-1.1 1.4-1.8l.9-2H4.7a.7.7 0 110-1.5h4.4v-.7c0-.4.3-.8.7-.8.4 0 .7.4.7.8v.7H15c.4 0 .8.3.8.7 0 .4-.4.8-.8.8h-1.4a12.3 12.3 0 01-1 2.4 13.5 13.5 0 01-1.7 2.3l1.9 1.8zm4.3-3l2.7 7.3a.5.5 0 01-.4.7 1 1 0 01-1-.7l-.6-1.5h-3.4l-.6 1.5a1 1 0 01-1 .7.5.5 0 01-.4-.7l2.7-7.4a1 1 0 012 0zm-2.2 4.4h2.4L16 12.5l-1.2 3.2z" fill-rule="evenodd"/></svg>',
    underline: '<svg width="24" height="24"><path d="M16 5c.6 0 1 .4 1 1v5.5a4 4 0 01-.4 1.8l-1 1.4a5.3 5.3 0 01-5.5 1 5 5 0 01-1.6-1c-.5-.4-.8-.9-1.1-1.4a4 4 0 01-.4-1.8V6c0-.6.4-1 1-1s1 .4 1 1v5.5c0 .3 0 .6.2 1l.6.7a3.3 3.3 0 002.2.8 3.4 3.4 0 002.2-.8c.3-.2.4-.5.6-.8l.2-.9V6c0-.6.4-1 1-1zM8 17h8c.6 0 1 .4 1 1s-.4 1-1 1H8a1 1 0 010-2z" fill-rule="evenodd"/></svg>',
    undo: '<svg width="24" height="24"><path d="M6.4 8H12c3.7 0 6.2 2 6.8 5.1.6 2.7-.4 5.6-2.3 6.8a1 1 0 01-1-1.8c1.1-.6 1.8-2.7 1.4-4.6-.5-2.1-2.1-3.5-4.9-3.5H6.4l3.3 3.3a1 1 0 11-1.4 1.4l-5-5a1 1 0 010-1.4l5-5a1 1 0 011.4 1.4L6.4 8z" fill-rule="nonzero"/></svg>',
    unlink: '<svg width="24" height="24"><path d="M6.2 12.3a1 1 0 011.4 1.4l-2 2a2 2 0 102.6 2.8l4.8-4.8a1 1 0 000-1.4 1 1 0 111.4-1.3 2.9 2.9 0 010 4L9.6 20a3.9 3.9 0 01-5.5-5.5l2-2zm11.6-.6a1 1 0 01-1.4-1.4l2.1-2a2 2 0 10-2.7-2.8L11 10.3a1 1 0 000 1.4A1 1 0 119.6 13a2.9 2.9 0 010-4L14.4 4a3.9 3.9 0 015.5 5.5l-2 2zM7.6 6.3a.8.8 0 01-1 1.1L3.3 4.2a.7.7 0 111-1l3.2 3.1zM5.1 8.6a.8.8 0 010 1.5H3a.8.8 0 010-1.5H5zm5-3.5a.8.8 0 01-1.5 0V3a.8.8 0 011.5 0V5zm6 11.8a.8.8 0 011-1l3.2 3.2a.8.8 0 01-1 1L16 17zm-2.2 2a.8.8 0 011.5 0V21a.8.8 0 01-1.5 0V19zm5-3.5a.7.7 0 110-1.5H21a.8.8 0 010 1.5H19z" fill-rule="nonzero"/></svg>',
    unlock: '<svg width="24" height="24"><path d="M16 5c.8 0 1.5.3 2.1.9.6.6.9 1.3.9 2.1v3h-2V8a1 1 0 00-.3-.7A1 1 0 0016 7h-2a1 1 0 00-.7.3 1 1 0 00-.3.7v3h.3c.2 0 .3 0 .5.2l.2.6v7.4c0 .3 0 .4-.2.6l-.6.2H4.8c-.3 0-.4 0-.6-.2a.7.7 0 01-.2-.6v-7.4c0-.3 0-.4.2-.6l.5-.2H11V8c0-.8.3-1.5.9-2.1.6-.6 1.3-.9 2.1-.9h2z" fill-rule="evenodd"/></svg>',
    "unordered-list": '<svg width="24" height="24"><path d="M11 5h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zm0 6h8c.6 0 1 .4 1 1s-.4 1-1 1h-8a1 1 0 010-2zM4.5 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1zm0 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1zm0 6c0-.4.1-.8.4-1 .3-.4.7-.5 1.1-.5.4 0 .8.1 1 .4.4.3.5.7.5 1.1 0 .4-.1.8-.4 1-.3.4-.7.5-1.1.5-.4 0-.8-.1-1-.4-.4-.3-.5-.7-.5-1.1z" fill-rule="evenodd"/></svg>',
    unselected: '<svg width="24" height="24"><path fill-rule="nonzero" d="M6 4h12a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2zm0 1a1 1 0 00-1 1v12c0 .6.4 1 1 1h12c.6 0 1-.4 1-1V6c0-.6-.4-1-1-1H6z"/></svg>',
    upload: '<svg width="24" height="24"><path d="M18 19v-2a1 1 0 012 0v3c0 .6-.4 1-1 1H5a1 1 0 01-1-1v-3a1 1 0 012 0v2h12zM11 6.4L8.7 8.7a1 1 0 01-1.4-1.4l4-4a1 1 0 011.4 0l4 4a1 1 0 11-1.4 1.4L13 6.4V16a1 1 0 01-2 0V6.4z" fill-rule="nonzero"/></svg>',
    user: '<svg width="24" height="24"><path d="M12 24a12 12 0 110-24 12 12 0 010 24zm-8.7-5.3a11 11 0 0017.4 0C19.4 16.3 14.6 15 12 15c-2.6 0-7.4 1.3-8.7 3.7zM12 13c2.2 0 4-2 4-4.5S14.2 4 12 4 8 6 8 8.5 9.8 13 12 13z" fill-rule="nonzero"/></svg>',
    "vertical-align": '<svg width="24" height="24"><g fill-rule="nonzero"><rect width="18" height="2" x="3" y="11" rx="1"/><path d="M12 2c.6 0 1 .4 1 1v4l2-1.3a1 1 0 011.2 1.5l-.1.1-4.1 3-4-3a1 1 0 011-1.7l2 1.5V3c0-.6.4-1 1-1zm0 11.8l4 2.9a1 1 0 01-1 1.7l-2-1.5V21c0 .5-.4 1-.9 1H12a1 1 0 01-1-1v-4l-2 1.3a1 1 0 01-1.2-.1l-.1-.1a1 1 0 01.1-1.3l.1-.1 4.1-3z"/></g></svg>',
    visualblocks: '<svg width="24" height="24"><path d="M9 19v2H7v-2h2zm-4 0v2a2 2 0 01-2-2h2zm8 0v2h-2v-2h2zm8 0a2 2 0 01-2 2v-2h2zm-4 0v2h-2v-2h2zM15 7a1 1 0 010 2v7a1 1 0 01-2 0V9h-1v7a1 1 0 01-2 0v-4a2.5 2.5 0 01-.2-5H15zM5 15v2H3v-2h2zm16 0v2h-2v-2h2zM5 11v2H3v-2h2zm16 0v2h-2v-2h2zM5 7v2H3V7h2zm16 0v2h-2V7h2zM5 3v2H3c0-1.1.9-2 2-2zm8 0v2h-2V3h2zm6 0a2 2 0 012 2h-2V3zM9 3v2H7V3h2zm8 0v2h-2V3h2z" fill-rule="evenodd"/></svg>',
    visualchars: '<svg width="24" height="24"><path d="M10 5h7a1 1 0 010 2h-1v11a1 1 0 01-2 0V7h-2v11a1 1 0 01-2 0v-6c-.5 0-1 0-1.4-.3A3.4 3.4 0 016.8 10a3.3 3.3 0 010-2.8 3.4 3.4 0 011.8-1.8L10 5z" fill-rule="evenodd"/></svg>',
    warning: '<svg width="24" height="24"><path d="M19.8 18.3c.2.5.3.9 0 1.2-.1.3-.5.5-1 .5H5.2c-.5 0-.9-.2-1-.5-.3-.3-.2-.7 0-1.2L11 4.7l.5-.5.5-.2c.2 0 .3 0 .5.2.2 0 .3.3.5.5l6.8 13.6zM12 18c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7a1 1 0 00-.3-.7 1 1 0 00-.7-.3 1 1 0 00-.7.3 1 1 0 00-.3.7c0 .3.1.5.3.7.2.2.4.3.7.3zm.7-3l.3-4a1 1 0 00-.3-.7 1 1 0 00-.7-.3 1 1 0 00-.7.3 1 1 0 00-.3.7l.3 4h1.4z" fill-rule="evenodd"/></svg>',
    "zoom-in": '<svg width="24" height="24"><path d="M16 17.3a8 8 0 111.4-1.4l4.3 4.4a1 1 0 01-1.4 1.4l-4.4-4.3zm-5-.3a6 6 0 100-12 6 6 0 000 12zm-1-9a1 1 0 012 0v6a1 1 0 01-2 0V8zm-2 4a1 1 0 010-2h6a1 1 0 010 2H8z" fill-rule="nonzero"/></svg>',
    "zoom-out": '<svg width="24" height="24"><path d="M16 17.3a8 8 0 111.4-1.4l4.3 4.4a1 1 0 01-1.4 1.4l-4.4-4.3zm-5-.3a6 6 0 100-12 6 6 0 000 12zm-3-5a1 1 0 010-2h6a1 1 0 010 2H8z" fill-rule="nonzero"/></svg>'
  }
});
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(N, ae, ce) {
    var ne = ae === "UL" ? "InsertUnorderedList" : "InsertOrderedList";
    N.execCommand(ne, !1, ce === !1 ? null : { "list-style-type": ce });
  }, w = function(N) {
    N.addCommand("ApplyUnorderedListStyle", function(ae, ce) {
      y(N, "UL", ce["list-style-type"]);
    }), N.addCommand("ApplyOrderedListStyle", function(ae, ce) {
      y(N, "OL", ce["list-style-type"]);
    });
  }, E = tinymce.util.Tools.resolve("tinymce.util.Tools"), P = function(N) {
    var ae = N.getParam("advlist_number_styles", "default,lower-alpha,lower-greek,lower-roman,upper-alpha,upper-roman");
    return ae ? ae.split(/[ ,]/) : [];
  }, H = function(N) {
    var ae = N.getParam("advlist_bullet_styles", "default,circle,square");
    return ae ? ae.split(/[ ,]/) : [];
  }, X = function() {
  }, j = function(N) {
    return function() {
      return N;
    };
  }, le = function(N) {
    return N;
  }, Q = j(!1), pe = j(!0), Y = function() {
    return D;
  }, D = function() {
    var N = function(ne) {
      return ne();
    }, ae = le, ce = {
      fold: function(ne, Ce) {
        return ne();
      },
      isSome: Q,
      isNone: pe,
      getOr: ae,
      getOrThunk: N,
      getOrDie: function(ne) {
        throw new Error(ne || "error: getOrDie called on none.");
      },
      getOrNull: j(null),
      getOrUndefined: j(void 0),
      or: ae,
      orThunk: N,
      map: Y,
      each: X,
      bind: Y,
      exists: Q,
      forall: pe,
      filter: function() {
        return Y();
      },
      toArray: function() {
        return [];
      },
      toString: j("none()")
    };
    return ce;
  }(), J = function(N) {
    var ae = j(N), ce = function() {
      return Ce;
    }, ne = function(Te) {
      return Te(N);
    }, Ce = {
      fold: function(Te, _) {
        return _(N);
      },
      isSome: pe,
      isNone: Q,
      getOr: ae,
      getOrThunk: ae,
      getOrDie: ae,
      getOrNull: ae,
      getOrUndefined: ae,
      or: ce,
      orThunk: ce,
      map: function(Te) {
        return J(Te(N));
      },
      each: function(Te) {
        Te(N);
      },
      bind: ne,
      exists: ne,
      forall: ne,
      filter: function(Te) {
        return Te(N) ? Ce : D;
      },
      toArray: function() {
        return [N];
      },
      toString: function() {
        return "some(" + N + ")";
      }
    };
    return Ce;
  }, ue = function(N) {
    return N == null ? D : J(N);
  }, ee = {
    some: J,
    none: Y,
    from: ue
  }, Ge = function(N, ae) {
    return N.$.contains(N.getBody(), ae);
  }, ze = function(N) {
    return N && /^(TH|TD)$/.test(N.nodeName);
  }, ht = function(N) {
    return function(ae) {
      return ae && /^(OL|UL|DL)$/.test(ae.nodeName) && Ge(N, ae);
    };
  }, ie = function(N) {
    var ae = N.dom.getParent(N.selection.getNode(), "ol,ul"), ce = N.dom.getStyle(ae, "listStyleType");
    return ee.from(ce);
  }, Ze = function(N, ae) {
    for (var ce = 0; ce < N.length; ce++) {
      var ne = N[ce];
      if (ae(ne))
        return ce;
    }
    return -1;
  }, De = function(N) {
    return N.replace(/\-/g, " ").replace(/\b\w/g, function(ae) {
      return ae.toUpperCase();
    });
  }, Pt = function(N, ae, ce) {
    var ne = Ze(ae.parents, ze), Ce = ne !== -1 ? ae.parents.slice(0, ne) : ae.parents, Te = E.grep(Ce, ht(N));
    return Te.length > 0 && Te[0].nodeName === ce;
  }, Ct = function(N, ae) {
    return function(ce) {
      var ne = function(Ce) {
        ce.setActive(Pt(N, Ce, ae));
      };
      return N.on("NodeChange", ne), function() {
        return N.off("NodeChange", ne);
      };
    };
  }, Be = function(N, ae, ce, ne, Ce, Te) {
    N.ui.registry.addSplitButton(ae, {
      tooltip: ce,
      icon: Ce === "OL" ? "ordered-list" : "unordered-list",
      presets: "listpreview",
      columns: 3,
      fetch: function(_) {
        var je = E.map(Te, function(Me) {
          var Je = Ce === "OL" ? "num" : "bull", Lt = Me === "disc" || Me === "decimal" ? "default" : Me, dt = Me === "default" ? "" : Me, Tt = De(Me);
          return {
            type: "choiceitem",
            value: dt,
            icon: "list-" + Je + "-" + Lt,
            text: Tt
          };
        });
        _(je);
      },
      onAction: function() {
        return N.execCommand(ne);
      },
      onItemAction: function(_, je) {
        y(N, Ce, je);
      },
      select: function(_) {
        var je = ie(N);
        return je.map(function(Me) {
          return _ === Me;
        }).getOr(!1);
      },
      onSetup: Ct(N, Ce)
    });
  }, ge = function(N, ae, ce, ne, Ce, Te) {
    N.ui.registry.addToggleButton(ae, {
      active: !1,
      tooltip: ce,
      icon: Ce === "OL" ? "ordered-list" : "unordered-list",
      onSetup: Ct(N, Ce),
      onAction: function() {
        return N.execCommand(ne);
      }
    });
  }, xe = function(N, ae, ce, ne, Ce, Te) {
    Te.length > 1 ? Be(N, ae, ce, ne, Ce, Te) : ge(N, ae, ce, ne, Ce);
  }, _e = function(N) {
    xe(N, "numlist", "Numbered list", "InsertOrderedList", "OL", P(N)), xe(N, "bullist", "Bullet list", "InsertUnorderedList", "UL", H(N));
  };
  function $() {
    m.add("advlist", function(N) {
      N.hasPlugin("lists") ? (_e(N), w(N)) : console.error("Please use the Lists plugin together with the Advanced List plugin.");
    });
  }
  $();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = tinymce.util.Tools.resolve("tinymce.dom.RangeUtils"), w = tinymce.util.Tools.resolve("tinymce.util.Tools"), E = function(_e) {
    return _e.getParam("allow_html_in_named_anchor", !1, "boolean");
  }, P = "a:not([href])", H = function(_e) {
    return !_e;
  }, X = function(_e) {
    var $ = _e.getAttribute("id") || _e.getAttribute("name");
    return $ || "";
  }, j = function(_e) {
    return _e && _e.nodeName.toLowerCase() === "a";
  }, le = function(_e) {
    return j(_e) && !_e.getAttribute("href") && X(_e) !== "";
  }, Q = function(_e) {
    return le(_e) && !_e.firstChild;
  }, pe = function(_e) {
    var $ = _e.dom;
    y($).walk(_e.selection.getRng(), function(N) {
      w.each(N, function(ae) {
        Q(ae) && $.remove(ae, !1);
      });
    });
  }, Y = function(_e) {
    return /^[A-Za-z][A-Za-z0-9\-:._]*$/.test(_e);
  }, D = function(_e) {
    return _e.dom.getParent(_e.selection.getStart(), P);
  }, J = function(_e) {
    var $ = D(_e);
    return $ ? X($) : "";
  }, ue = function(_e, $) {
    _e.undoManager.transact(function() {
      E(_e) || _e.selection.collapse(!0), _e.selection.isCollapsed() ? _e.insertContent(_e.dom.createHTML("a", { id: $ })) : (pe(_e), _e.formatter.remove("namedAnchor", null, null, !0), _e.formatter.apply("namedAnchor", { value: $ }), _e.addVisual());
    });
  }, ee = function(_e, $, N) {
    N.removeAttribute("name"), N.id = $, _e.addVisual(), _e.undoManager.add();
  }, Ge = function(_e, $) {
    var N = D(_e);
    N ? ee(_e, $, N) : ue(_e, $), _e.focus();
  }, ze = function(_e, $) {
    return Y($) ? (Ge(_e, $), !0) : (_e.windowManager.alert("Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores."), !1);
  }, ht = function(_e) {
    var $ = J(_e);
    _e.windowManager.open({
      title: "Anchor",
      size: "normal",
      body: {
        type: "panel",
        items: [{
          name: "id",
          type: "input",
          label: "ID",
          placeholder: "example"
        }]
      },
      buttons: [
        {
          type: "cancel",
          name: "cancel",
          text: "Cancel"
        },
        {
          type: "submit",
          name: "save",
          text: "Save",
          primary: !0
        }
      ],
      initialData: { id: $ },
      onSubmit: function(N) {
        ze(_e, N.getData().id) && N.close();
      }
    });
  }, ie = function(_e) {
    _e.addCommand("mceAnchor", function() {
      ht(_e);
    });
  }, Ze = function(_e) {
    return _e && H(_e.attr("href")) && !H(_e.attr("id") || _e.attr("name"));
  }, De = function(_e) {
    return Ze(_e) && !_e.firstChild;
  }, Pt = function(_e) {
    return function($) {
      for (var N = 0; N < $.length; N++) {
        var ae = $[N];
        De(ae) && ae.attr("contenteditable", _e);
      }
    };
  }, Ct = function(_e) {
    _e.on("PreInit", function() {
      _e.parser.addNodeFilter("a", Pt("false")), _e.serializer.addNodeFilter("a", Pt(null));
    });
  }, Be = function(_e) {
    _e.formatter.register("namedAnchor", {
      inline: "a",
      selector: P,
      remove: "all",
      split: !0,
      deep: !0,
      attributes: { id: "%value" },
      onmatch: function($, N, ae) {
        return le($);
      }
    });
  }, ge = function(_e) {
    _e.ui.registry.addToggleButton("anchor", {
      icon: "bookmark",
      tooltip: "Anchor",
      onAction: function() {
        return _e.execCommand("mceAnchor");
      },
      onSetup: function($) {
        return _e.selection.selectorChangedWithUnbind("a:not([href])", $.setActive).unbind;
      }
    }), _e.ui.registry.addMenuItem("anchor", {
      icon: "bookmark",
      text: "Anchor...",
      onAction: function() {
        return _e.execCommand("mceAnchor");
      }
    });
  };
  function xe() {
    m.add("anchor", function(_e) {
      Ct(_e), ie(_e), ge(_e), _e.on("PreInit", function() {
        Be(_e);
      });
    });
  }
  xe();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(Be, ge, xe) {
    return ge === "" || Be.length >= ge.length && Be.substr(xe, xe + ge.length) === ge;
  }, w = function(Be, ge) {
    return Be.indexOf(ge) !== -1;
  }, E = function(Be, ge) {
    return y(Be, ge, 0);
  }, P = tinymce.util.Tools.resolve("tinymce.Env"), H = function() {
    return /(?:[A-Za-z][A-Za-z\d.+-]{0,14}:\/\/(?:[-.~*+=!&;:'%@?^${}(),\w]+@)?|www\.|[-;:&=+$,.\w]+@)[A-Za-z\d-]+(?:\.[A-Za-z\d-]+)*(?::\d+)?(?:\/(?:[-.~*+=!;:'%@$(),\/\w]*[-~*+=%@$()\/\w])?)?(?:\?(?:[-.~*+=!&;:'%@?^${}(),\/\w]+))?(?:#(?:[-.~*+=!&;:'%@?^${}(),\/\w]+))?/g;
  }, X = new RegExp("^" + H().source + "$", "i"), j = function(Be) {
    return Be.getParam("autolink_pattern", X);
  }, le = function(Be) {
    return Be.getParam("default_link_target", !1);
  }, Q = function(Be) {
    return Be.getParam("link_default_protocol", "http", "string");
  }, pe = function(Be) {
    return /^[(\[{ \u00a0]$/.test(Be);
  }, Y = function(Be) {
    return Be.nodeType === 3;
  }, D = function(Be) {
    return Be.nodeType === 1;
  }, J = function(Be) {
    return De(Be, -1);
  }, ue = function(Be) {
    return De(Be, 0);
  }, ee = function(Be) {
    return De(Be, -1);
  }, Ge = function(Be, ge) {
    if (ge < 0 && (ge = 0), Y(Be)) {
      var xe = Be.data.length;
      ge > xe && (ge = xe);
    }
    return ge;
  }, ze = function(Be, ge, xe) {
    !D(ge) || ge.hasChildNodes() ? Be.setStart(ge, Ge(ge, xe)) : Be.setStartBefore(ge);
  }, ht = function(Be, ge, xe) {
    !D(ge) || ge.hasChildNodes() ? Be.setEnd(ge, Ge(ge, xe)) : Be.setEndAfter(ge);
  }, ie = function(Be) {
    return /^([A-Za-z][A-Za-z\d.+-]*:\/\/)|mailto:/.test(Be);
  }, Ze = function(Be) {
    return /[?!,.;:]/.test(Be);
  }, De = function(Be, ge) {
    var xe, _e, $, N, ae, ce, ne, Ce = j(Be), Te = le(Be);
    if (Be.dom.getParent(Be.selection.getNode(), "a[href]") === null) {
      var _ = Be.selection.getRng().cloneRange();
      if (_.startOffset < 5) {
        if (ae = _.endContainer.previousSibling, !ae) {
          if (!_.endContainer.firstChild || !_.endContainer.firstChild.nextSibling)
            return;
          ae = _.endContainer.firstChild.nextSibling;
        }
        if (ce = ae.length, ze(_, ae, ce), ht(_, ae, ce), _.endOffset < 5)
          return;
        xe = _.endOffset, _e = ae;
      } else {
        if (_e = _.endContainer, !Y(_e) && _e.firstChild) {
          for (; !Y(_e) && _e.firstChild; )
            _e = _e.firstChild;
          Y(_e) && (ze(_, _e, 0), ht(_, _e, _e.nodeValue.length));
        }
        _.endOffset === 1 ? xe = 2 : xe = _.endOffset - 1 - ge;
      }
      var je = xe;
      do
        ze(_, _e, xe >= 2 ? xe - 2 : 0), ht(_, _e, xe >= 1 ? xe - 1 : 0), xe -= 1, ne = _.toString();
      while (!pe(ne) && xe - 2 >= 0);
      pe(_.toString()) ? (ze(_, _e, xe), ht(_, _e, je), xe += 1) : _.startOffset === 0 ? (ze(_, _e, 0), ht(_, _e, je)) : (ze(_, _e, xe), ht(_, _e, je)), N = _.toString(), Ze(N.charAt(N.length - 1)) && ht(_, _e, je - 1), N = _.toString().trim();
      var Me = N.match(Ce), Je = Q(Be);
      if (Me) {
        var Lt = Me[0];
        E(Lt, "www.") ? Lt = Je + "://" + Lt : w(Lt, "@") && !ie(Lt) && (Lt = "mailto:" + Lt), $ = Be.selection.getBookmark(), Be.selection.setRng(_), Be.execCommand("createlink", !1, Lt), Te !== !1 && Be.dom.setAttrib(Be.selection.getNode(), "target", Te), Be.selection.moveToBookmark($), Be.nodeChanged();
      }
    }
  }, Pt = function(Be) {
    var ge;
    if (Be.on("keydown", function(xe) {
      if (xe.keyCode === 13)
        return ee(Be);
    }), P.browser.isIE()) {
      Be.on("focus", function() {
        if (!ge) {
          ge = !0;
          try {
            Be.execCommand("AutoUrlDetect", !1, !0);
          } catch {
          }
        }
      });
      return;
    }
    Be.on("keypress", function(xe) {
      if (xe.keyCode === 41 || xe.keyCode === 93 || xe.keyCode === 125)
        return J(Be);
    }), Be.on("keyup", function(xe) {
      if (xe.keyCode === 32)
        return ue(Be);
    });
  };
  function Ct() {
    m.add("autolink", function(Be) {
      Pt(Be);
    });
  }
  Ct();
})();
(function() {
  var m = function(De) {
    var Pt = De, Ct = function() {
      return Pt;
    }, Be = function(ge) {
      Pt = ge;
    };
    return {
      get: Ct,
      set: Be
    };
  }, y = Object.hasOwnProperty, w = function(De, Pt) {
    return y.call(De, Pt);
  }, E = tinymce.util.Tools.resolve("tinymce.PluginManager"), P = tinymce.util.Tools.resolve("tinymce.Env"), H = tinymce.util.Tools.resolve("tinymce.util.Delay"), X = function(De) {
    return De.fire("ResizeEditor");
  }, j = function(De) {
    return De.getParam("min_height", De.getElement().offsetHeight, "number");
  }, le = function(De) {
    return De.getParam("max_height", 0, "number");
  }, Q = function(De) {
    return De.getParam("autoresize_overflow_padding", 1, "number");
  }, pe = function(De) {
    return De.getParam("autoresize_bottom_margin", 50, "number");
  }, Y = function(De) {
    return De.getParam("autoresize_on_init", !0, "boolean");
  }, D = function(De) {
    return De.plugins.fullscreen && De.plugins.fullscreen.isFullscreen();
  }, J = function(De, Pt, Ct, Be, ge) {
    H.setEditorTimeout(De, function() {
      ze(De, Pt), Ct-- ? J(De, Pt, Ct, Be, ge) : ge && ge();
    }, Be);
  }, ue = function(De, Pt) {
    var Ct = De.getBody();
    Ct && (Ct.style.overflowY = Pt ? "" : "hidden", Pt || (Ct.scrollTop = 0));
  }, ee = function(De, Pt, Ct, Be) {
    var ge = parseInt(De.getStyle(Pt, Ct, Be), 10);
    return isNaN(ge) ? 0 : ge;
  }, Ge = function(De) {
    if ((De == null ? void 0 : De.type.toLowerCase()) === "setcontent") {
      var Pt = De;
      return Pt.selection === !0 || Pt.paste === !0;
    } else
      return !1;
  }, ze = function(De, Pt, Ct) {
    var Be = De.dom, ge = De.getDoc();
    if (!!ge) {
      if (D(De)) {
        ue(De, !0);
        return;
      }
      var xe = ge.documentElement, _e = pe(De), $ = j(De), N = ee(Be, xe, "margin-top", !0), ae = ee(Be, xe, "margin-bottom", !0), ce = xe.offsetHeight + N + ae + _e;
      ce < 0 && (ce = 0);
      var ne = De.getContainer().offsetHeight, Ce = De.getContentAreaContainer().offsetHeight, Te = ne - Ce;
      ce + Te > j(De) && ($ = ce + Te);
      var _ = le(De);
      if (_ && $ > _ ? ($ = _, ue(De, !0)) : ue(De, !1), $ !== Pt.get()) {
        var je = $ - Pt.get();
        if (Be.setStyle(De.getContainer(), "height", $ + "px"), Pt.set($), X(De), P.browser.isSafari() && P.mac) {
          var Me = De.getWin();
          Me.scrollTo(Me.pageXOffset, Me.pageYOffset);
        }
        De.hasFocus() && Ge(Ct) && De.selection.scrollIntoView(), P.webkit && je < 0 && ze(De, Pt, Ct);
      }
    }
  }, ht = function(De, Pt) {
    De.on("init", function() {
      var Ct = Q(De), Be = De.dom;
      Be.setStyles(De.getDoc().documentElement, { height: "auto" }), Be.setStyles(De.getBody(), {
        paddingLeft: Ct,
        paddingRight: Ct,
        "min-height": 0
      });
    }), De.on("NodeChange SetContent keyup FullscreenStateChanged ResizeContent", function(Ct) {
      ze(De, Pt, Ct);
    }), Y(De) && De.on("init", function() {
      J(De, Pt, 20, 100, function() {
        J(De, Pt, 5, 1e3);
      });
    });
  }, ie = function(De, Pt) {
    De.addCommand("mceAutoResize", function() {
      ze(De, Pt);
    });
  };
  function Ze() {
    E.add("autoresize", function(De) {
      if (w(De.settings, "resize") || (De.settings.resize = !1), !De.inline) {
        var Pt = m(0);
        ie(De, Pt), ht(De, Pt);
      }
    });
  }
  Ze();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function($) {
    return function(N) {
      return $ === N;
    };
  }, w = y(void 0), E = tinymce.util.Tools.resolve("tinymce.util.Delay"), P = tinymce.util.Tools.resolve("tinymce.util.LocalStorage"), H = tinymce.util.Tools.resolve("tinymce.util.Tools"), X = function($) {
    return $.fire("RestoreDraft");
  }, j = function($) {
    return $.fire("StoreDraft");
  }, le = function($) {
    return $.fire("RemoveDraft");
  }, Q = function($, N) {
    var ae = {
      s: 1e3,
      m: 6e4
    }, ce = $ || N, ne = /^(\d+)([ms]?)$/.exec("" + ce);
    return (ne[2] ? ae[ne[2]] : 1) * parseInt(ce, 10);
  }, pe = function($) {
    return $.getParam("autosave_ask_before_unload", !0);
  }, Y = function($) {
    var N = document.location;
    return $.getParam("autosave_prefix", "tinymce-autosave-{path}{query}{hash}-{id}-").replace(/{path}/g, N.pathname).replace(/{query}/g, N.search).replace(/{hash}/g, N.hash).replace(/{id}/g, $.id);
  }, D = function($) {
    return $.getParam("autosave_restore_when_empty", !1);
  }, J = function($) {
    return Q($.getParam("autosave_interval"), "30s");
  }, ue = function($) {
    return Q($.getParam("autosave_retention"), "20m");
  }, ee = function($, N) {
    if (w(N))
      return $.dom.isEmpty($.getBody());
    var ae = H.trim(N);
    if (ae === "")
      return !0;
    var ce = new DOMParser().parseFromString(ae, "text/html");
    return $.dom.isEmpty(ce);
  }, Ge = function($) {
    var N = parseInt(P.getItem(Y($) + "time"), 10) || 0;
    return new Date().getTime() - N > ue($) ? (ze($, !1), !1) : !0;
  }, ze = function($, N) {
    var ae = Y($);
    P.removeItem(ae + "draft"), P.removeItem(ae + "time"), N !== !1 && le($);
  }, ht = function($) {
    var N = Y($);
    !ee($) && $.isDirty() && (P.setItem(N + "draft", $.getContent({
      format: "raw",
      no_events: !0
    })), P.setItem(N + "time", new Date().getTime().toString()), j($));
  }, ie = function($) {
    var N = Y($);
    Ge($) && ($.setContent(P.getItem(N + "draft"), { format: "raw" }), X($));
  }, Ze = function($) {
    var N = J($);
    E.setEditorInterval($, function() {
      ht($);
    }, N);
  }, De = function($) {
    $.undoManager.transact(function() {
      ie($), ze($);
    }), $.focus();
  }, Pt = function($) {
    return {
      hasDraft: function() {
        return Ge($);
      },
      storeDraft: function() {
        return ht($);
      },
      restoreDraft: function() {
        return ie($);
      },
      removeDraft: function(N) {
        return ze($, N);
      },
      isEmpty: function(N) {
        return ee($, N);
      }
    };
  }, Ct = tinymce.util.Tools.resolve("tinymce.EditorManager"), Be = function($) {
    $.editorManager.on("BeforeUnload", function(N) {
      var ae;
      H.each(Ct.get(), function(ce) {
        ce.plugins.autosave && ce.plugins.autosave.storeDraft(), !ae && ce.isDirty() && pe(ce) && (ae = ce.translate("You have unsaved changes are you sure you want to navigate away?"));
      }), ae && (N.preventDefault(), N.returnValue = ae);
    });
  }, ge = function($) {
    return function(N) {
      N.setDisabled(!Ge($));
      var ae = function() {
        return N.setDisabled(!Ge($));
      };
      return $.on("StoreDraft RestoreDraft RemoveDraft", ae), function() {
        return $.off("StoreDraft RestoreDraft RemoveDraft", ae);
      };
    };
  }, xe = function($) {
    Ze($), $.ui.registry.addButton("restoredraft", {
      tooltip: "Restore last draft",
      icon: "restore-draft",
      onAction: function() {
        De($);
      },
      onSetup: ge($)
    }), $.ui.registry.addMenuItem("restoredraft", {
      text: "Restore last draft",
      icon: "restore-draft",
      onAction: function() {
        De($);
      },
      onSetup: ge($)
    });
  };
  function _e() {
    m.add("autosave", function($) {
      return Be($), xe($), $.on("init", function() {
        D($) && $.dom.isEmpty($.getBody()) && ie($);
      }), Pt($);
    });
  }
  _e();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(Ae, Ke) {
    return Ae.fire("insertCustomChar", { chr: Ke });
  }, w = function(Ae, Ke) {
    var at = y(Ae, Ke).chr;
    Ae.execCommand("mceInsertContent", !1, at);
  }, E = function(Ae) {
    var Ke = typeof Ae;
    return Ae === null ? "null" : Ke === "object" && (Array.prototype.isPrototypeOf(Ae) || Ae.constructor && Ae.constructor.name === "Array") ? "array" : Ke === "object" && (String.prototype.isPrototypeOf(Ae) || Ae.constructor && Ae.constructor.name === "String") ? "string" : Ke;
  }, P = function(Ae) {
    return function(Ke) {
      return E(Ke) === Ae;
    };
  }, H = function(Ae) {
    return function(Ke) {
      return Ae === Ke;
    };
  }, X = P("array"), j = H(null), le = function() {
  }, Q = function(Ae) {
    return function() {
      return Ae;
    };
  }, pe = function(Ae) {
    return Ae;
  }, Y = Q(!1), D = Q(!0), J = function() {
    return ue;
  }, ue = function() {
    var Ae = function(pt) {
      return pt();
    }, Ke = pe, at = {
      fold: function(pt, sn) {
        return pt();
      },
      isSome: Y,
      isNone: D,
      getOr: Ke,
      getOrThunk: Ae,
      getOrDie: function(pt) {
        throw new Error(pt || "error: getOrDie called on none.");
      },
      getOrNull: Q(null),
      getOrUndefined: Q(void 0),
      or: Ke,
      orThunk: Ae,
      map: J,
      each: le,
      bind: J,
      exists: Y,
      forall: D,
      filter: function() {
        return J();
      },
      toArray: function() {
        return [];
      },
      toString: Q("none()")
    };
    return at;
  }(), ee = function(Ae) {
    var Ke = Q(Ae), at = function() {
      return sn;
    }, pt = function(Ie) {
      return Ie(Ae);
    }, sn = {
      fold: function(Ie, St) {
        return St(Ae);
      },
      isSome: D,
      isNone: Y,
      getOr: Ke,
      getOrThunk: Ke,
      getOrDie: Ke,
      getOrNull: Ke,
      getOrUndefined: Ke,
      or: at,
      orThunk: at,
      map: function(Ie) {
        return ee(Ie(Ae));
      },
      each: function(Ie) {
        Ie(Ae);
      },
      bind: pt,
      exists: pt,
      forall: pt,
      filter: function(Ie) {
        return Ie(Ae) ? sn : ue;
      },
      toArray: function() {
        return [Ae];
      },
      toString: function() {
        return "some(" + Ae + ")";
      }
    };
    return sn;
  }, Ge = function(Ae) {
    return Ae == null ? ue : ee(Ae);
  }, ze = {
    some: ee,
    none: J,
    from: Ge
  }, ht = Array.prototype.push, ie = function(Ae, Ke) {
    for (var at = Ae.length, pt = new Array(at), sn = 0; sn < at; sn++) {
      var Ie = Ae[sn];
      pt[sn] = Ke(Ie, sn);
    }
    return pt;
  }, Ze = function(Ae, Ke) {
    for (var at = 0, pt = Ae.length; at < pt; at++) {
      var sn = Ae[at];
      Ke(sn, at);
    }
  }, De = function(Ae, Ke, at) {
    for (var pt = 0, sn = Ae.length; pt < sn; pt++) {
      var Ie = Ae[pt];
      if (Ke(Ie, pt))
        return ze.some(Ie);
      if (at(Ie, pt))
        break;
    }
    return ze.none();
  }, Pt = function(Ae, Ke) {
    return De(Ae, Ke, Y);
  }, Ct = function(Ae) {
    for (var Ke = [], at = 0, pt = Ae.length; at < pt; ++at) {
      if (!X(Ae[at]))
        throw new Error("Arr.flatten item " + at + " was not an array, input: " + Ae);
      ht.apply(Ke, Ae[at]);
    }
    return Ke;
  }, Be = function(Ae, Ke) {
    return Ct(ie(Ae, Ke));
  }, ge = tinymce.util.Tools.resolve("tinymce.util.Tools"), xe = function(Ae) {
    return Ae.getParam("charmap");
  }, _e = function(Ae) {
    return Ae.getParam("charmap_append");
  }, $ = ge.isArray, N = "User Defined", ae = function() {
    return [
      {
        name: "Currency",
        characters: [
          [
            36,
            "dollar sign"
          ],
          [
            162,
            "cent sign"
          ],
          [
            8364,
            "euro sign"
          ],
          [
            163,
            "pound sign"
          ],
          [
            165,
            "yen sign"
          ],
          [
            164,
            "currency sign"
          ],
          [
            8352,
            "euro-currency sign"
          ],
          [
            8353,
            "colon sign"
          ],
          [
            8354,
            "cruzeiro sign"
          ],
          [
            8355,
            "french franc sign"
          ],
          [
            8356,
            "lira sign"
          ],
          [
            8357,
            "mill sign"
          ],
          [
            8358,
            "naira sign"
          ],
          [
            8359,
            "peseta sign"
          ],
          [
            8360,
            "rupee sign"
          ],
          [
            8361,
            "won sign"
          ],
          [
            8362,
            "new sheqel sign"
          ],
          [
            8363,
            "dong sign"
          ],
          [
            8365,
            "kip sign"
          ],
          [
            8366,
            "tugrik sign"
          ],
          [
            8367,
            "drachma sign"
          ],
          [
            8368,
            "german penny symbol"
          ],
          [
            8369,
            "peso sign"
          ],
          [
            8370,
            "guarani sign"
          ],
          [
            8371,
            "austral sign"
          ],
          [
            8372,
            "hryvnia sign"
          ],
          [
            8373,
            "cedi sign"
          ],
          [
            8374,
            "livre tournois sign"
          ],
          [
            8375,
            "spesmilo sign"
          ],
          [
            8376,
            "tenge sign"
          ],
          [
            8377,
            "indian rupee sign"
          ],
          [
            8378,
            "turkish lira sign"
          ],
          [
            8379,
            "nordic mark sign"
          ],
          [
            8380,
            "manat sign"
          ],
          [
            8381,
            "ruble sign"
          ],
          [
            20870,
            "yen character"
          ],
          [
            20803,
            "yuan character"
          ],
          [
            22291,
            "yuan character, in hong kong and taiwan"
          ],
          [
            22278,
            "yen/yuan character variant one"
          ]
        ]
      },
      {
        name: "Text",
        characters: [
          [
            169,
            "copyright sign"
          ],
          [
            174,
            "registered sign"
          ],
          [
            8482,
            "trade mark sign"
          ],
          [
            8240,
            "per mille sign"
          ],
          [
            181,
            "micro sign"
          ],
          [
            183,
            "middle dot"
          ],
          [
            8226,
            "bullet"
          ],
          [
            8230,
            "three dot leader"
          ],
          [
            8242,
            "minutes / feet"
          ],
          [
            8243,
            "seconds / inches"
          ],
          [
            167,
            "section sign"
          ],
          [
            182,
            "paragraph sign"
          ],
          [
            223,
            "sharp s / ess-zed"
          ]
        ]
      },
      {
        name: "Quotations",
        characters: [
          [
            8249,
            "single left-pointing angle quotation mark"
          ],
          [
            8250,
            "single right-pointing angle quotation mark"
          ],
          [
            171,
            "left pointing guillemet"
          ],
          [
            187,
            "right pointing guillemet"
          ],
          [
            8216,
            "left single quotation mark"
          ],
          [
            8217,
            "right single quotation mark"
          ],
          [
            8220,
            "left double quotation mark"
          ],
          [
            8221,
            "right double quotation mark"
          ],
          [
            8218,
            "single low-9 quotation mark"
          ],
          [
            8222,
            "double low-9 quotation mark"
          ],
          [
            60,
            "less-than sign"
          ],
          [
            62,
            "greater-than sign"
          ],
          [
            8804,
            "less-than or equal to"
          ],
          [
            8805,
            "greater-than or equal to"
          ],
          [
            8211,
            "en dash"
          ],
          [
            8212,
            "em dash"
          ],
          [
            175,
            "macron"
          ],
          [
            8254,
            "overline"
          ],
          [
            164,
            "currency sign"
          ],
          [
            166,
            "broken bar"
          ],
          [
            168,
            "diaeresis"
          ],
          [
            161,
            "inverted exclamation mark"
          ],
          [
            191,
            "turned question mark"
          ],
          [
            710,
            "circumflex accent"
          ],
          [
            732,
            "small tilde"
          ],
          [
            176,
            "degree sign"
          ],
          [
            8722,
            "minus sign"
          ],
          [
            177,
            "plus-minus sign"
          ],
          [
            247,
            "division sign"
          ],
          [
            8260,
            "fraction slash"
          ],
          [
            215,
            "multiplication sign"
          ],
          [
            185,
            "superscript one"
          ],
          [
            178,
            "superscript two"
          ],
          [
            179,
            "superscript three"
          ],
          [
            188,
            "fraction one quarter"
          ],
          [
            189,
            "fraction one half"
          ],
          [
            190,
            "fraction three quarters"
          ]
        ]
      },
      {
        name: "Mathematical",
        characters: [
          [
            402,
            "function / florin"
          ],
          [
            8747,
            "integral"
          ],
          [
            8721,
            "n-ary sumation"
          ],
          [
            8734,
            "infinity"
          ],
          [
            8730,
            "square root"
          ],
          [
            8764,
            "similar to"
          ],
          [
            8773,
            "approximately equal to"
          ],
          [
            8776,
            "almost equal to"
          ],
          [
            8800,
            "not equal to"
          ],
          [
            8801,
            "identical to"
          ],
          [
            8712,
            "element of"
          ],
          [
            8713,
            "not an element of"
          ],
          [
            8715,
            "contains as member"
          ],
          [
            8719,
            "n-ary product"
          ],
          [
            8743,
            "logical and"
          ],
          [
            8744,
            "logical or"
          ],
          [
            172,
            "not sign"
          ],
          [
            8745,
            "intersection"
          ],
          [
            8746,
            "union"
          ],
          [
            8706,
            "partial differential"
          ],
          [
            8704,
            "for all"
          ],
          [
            8707,
            "there exists"
          ],
          [
            8709,
            "diameter"
          ],
          [
            8711,
            "backward difference"
          ],
          [
            8727,
            "asterisk operator"
          ],
          [
            8733,
            "proportional to"
          ],
          [
            8736,
            "angle"
          ]
        ]
      },
      {
        name: "Extended Latin",
        characters: [
          [
            192,
            "A - grave"
          ],
          [
            193,
            "A - acute"
          ],
          [
            194,
            "A - circumflex"
          ],
          [
            195,
            "A - tilde"
          ],
          [
            196,
            "A - diaeresis"
          ],
          [
            197,
            "A - ring above"
          ],
          [
            256,
            "A - macron"
          ],
          [
            198,
            "ligature AE"
          ],
          [
            199,
            "C - cedilla"
          ],
          [
            200,
            "E - grave"
          ],
          [
            201,
            "E - acute"
          ],
          [
            202,
            "E - circumflex"
          ],
          [
            203,
            "E - diaeresis"
          ],
          [
            274,
            "E - macron"
          ],
          [
            204,
            "I - grave"
          ],
          [
            205,
            "I - acute"
          ],
          [
            206,
            "I - circumflex"
          ],
          [
            207,
            "I - diaeresis"
          ],
          [
            298,
            "I - macron"
          ],
          [
            208,
            "ETH"
          ],
          [
            209,
            "N - tilde"
          ],
          [
            210,
            "O - grave"
          ],
          [
            211,
            "O - acute"
          ],
          [
            212,
            "O - circumflex"
          ],
          [
            213,
            "O - tilde"
          ],
          [
            214,
            "O - diaeresis"
          ],
          [
            216,
            "O - slash"
          ],
          [
            332,
            "O - macron"
          ],
          [
            338,
            "ligature OE"
          ],
          [
            352,
            "S - caron"
          ],
          [
            217,
            "U - grave"
          ],
          [
            218,
            "U - acute"
          ],
          [
            219,
            "U - circumflex"
          ],
          [
            220,
            "U - diaeresis"
          ],
          [
            362,
            "U - macron"
          ],
          [
            221,
            "Y - acute"
          ],
          [
            376,
            "Y - diaeresis"
          ],
          [
            562,
            "Y - macron"
          ],
          [
            222,
            "THORN"
          ],
          [
            224,
            "a - grave"
          ],
          [
            225,
            "a - acute"
          ],
          [
            226,
            "a - circumflex"
          ],
          [
            227,
            "a - tilde"
          ],
          [
            228,
            "a - diaeresis"
          ],
          [
            229,
            "a - ring above"
          ],
          [
            257,
            "a - macron"
          ],
          [
            230,
            "ligature ae"
          ],
          [
            231,
            "c - cedilla"
          ],
          [
            232,
            "e - grave"
          ],
          [
            233,
            "e - acute"
          ],
          [
            234,
            "e - circumflex"
          ],
          [
            235,
            "e - diaeresis"
          ],
          [
            275,
            "e - macron"
          ],
          [
            236,
            "i - grave"
          ],
          [
            237,
            "i - acute"
          ],
          [
            238,
            "i - circumflex"
          ],
          [
            239,
            "i - diaeresis"
          ],
          [
            299,
            "i - macron"
          ],
          [
            240,
            "eth"
          ],
          [
            241,
            "n - tilde"
          ],
          [
            242,
            "o - grave"
          ],
          [
            243,
            "o - acute"
          ],
          [
            244,
            "o - circumflex"
          ],
          [
            245,
            "o - tilde"
          ],
          [
            246,
            "o - diaeresis"
          ],
          [
            248,
            "o slash"
          ],
          [
            333,
            "o macron"
          ],
          [
            339,
            "ligature oe"
          ],
          [
            353,
            "s - caron"
          ],
          [
            249,
            "u - grave"
          ],
          [
            250,
            "u - acute"
          ],
          [
            251,
            "u - circumflex"
          ],
          [
            252,
            "u - diaeresis"
          ],
          [
            363,
            "u - macron"
          ],
          [
            253,
            "y - acute"
          ],
          [
            254,
            "thorn"
          ],
          [
            255,
            "y - diaeresis"
          ],
          [
            563,
            "y - macron"
          ],
          [
            913,
            "Alpha"
          ],
          [
            914,
            "Beta"
          ],
          [
            915,
            "Gamma"
          ],
          [
            916,
            "Delta"
          ],
          [
            917,
            "Epsilon"
          ],
          [
            918,
            "Zeta"
          ],
          [
            919,
            "Eta"
          ],
          [
            920,
            "Theta"
          ],
          [
            921,
            "Iota"
          ],
          [
            922,
            "Kappa"
          ],
          [
            923,
            "Lambda"
          ],
          [
            924,
            "Mu"
          ],
          [
            925,
            "Nu"
          ],
          [
            926,
            "Xi"
          ],
          [
            927,
            "Omicron"
          ],
          [
            928,
            "Pi"
          ],
          [
            929,
            "Rho"
          ],
          [
            931,
            "Sigma"
          ],
          [
            932,
            "Tau"
          ],
          [
            933,
            "Upsilon"
          ],
          [
            934,
            "Phi"
          ],
          [
            935,
            "Chi"
          ],
          [
            936,
            "Psi"
          ],
          [
            937,
            "Omega"
          ],
          [
            945,
            "alpha"
          ],
          [
            946,
            "beta"
          ],
          [
            947,
            "gamma"
          ],
          [
            948,
            "delta"
          ],
          [
            949,
            "epsilon"
          ],
          [
            950,
            "zeta"
          ],
          [
            951,
            "eta"
          ],
          [
            952,
            "theta"
          ],
          [
            953,
            "iota"
          ],
          [
            954,
            "kappa"
          ],
          [
            955,
            "lambda"
          ],
          [
            956,
            "mu"
          ],
          [
            957,
            "nu"
          ],
          [
            958,
            "xi"
          ],
          [
            959,
            "omicron"
          ],
          [
            960,
            "pi"
          ],
          [
            961,
            "rho"
          ],
          [
            962,
            "final sigma"
          ],
          [
            963,
            "sigma"
          ],
          [
            964,
            "tau"
          ],
          [
            965,
            "upsilon"
          ],
          [
            966,
            "phi"
          ],
          [
            967,
            "chi"
          ],
          [
            968,
            "psi"
          ],
          [
            969,
            "omega"
          ]
        ]
      },
      {
        name: "Symbols",
        characters: [
          [
            8501,
            "alef symbol"
          ],
          [
            982,
            "pi symbol"
          ],
          [
            8476,
            "real part symbol"
          ],
          [
            978,
            "upsilon - hook symbol"
          ],
          [
            8472,
            "Weierstrass p"
          ],
          [
            8465,
            "imaginary part"
          ]
        ]
      },
      {
        name: "Arrows",
        characters: [
          [
            8592,
            "leftwards arrow"
          ],
          [
            8593,
            "upwards arrow"
          ],
          [
            8594,
            "rightwards arrow"
          ],
          [
            8595,
            "downwards arrow"
          ],
          [
            8596,
            "left right arrow"
          ],
          [
            8629,
            "carriage return"
          ],
          [
            8656,
            "leftwards double arrow"
          ],
          [
            8657,
            "upwards double arrow"
          ],
          [
            8658,
            "rightwards double arrow"
          ],
          [
            8659,
            "downwards double arrow"
          ],
          [
            8660,
            "left right double arrow"
          ],
          [
            8756,
            "therefore"
          ],
          [
            8834,
            "subset of"
          ],
          [
            8835,
            "superset of"
          ],
          [
            8836,
            "not a subset of"
          ],
          [
            8838,
            "subset of or equal to"
          ],
          [
            8839,
            "superset of or equal to"
          ],
          [
            8853,
            "circled plus"
          ],
          [
            8855,
            "circled times"
          ],
          [
            8869,
            "perpendicular"
          ],
          [
            8901,
            "dot operator"
          ],
          [
            8968,
            "left ceiling"
          ],
          [
            8969,
            "right ceiling"
          ],
          [
            8970,
            "left floor"
          ],
          [
            8971,
            "right floor"
          ],
          [
            9001,
            "left-pointing angle bracket"
          ],
          [
            9002,
            "right-pointing angle bracket"
          ],
          [
            9674,
            "lozenge"
          ],
          [
            9824,
            "black spade suit"
          ],
          [
            9827,
            "black club suit"
          ],
          [
            9829,
            "black heart suit"
          ],
          [
            9830,
            "black diamond suit"
          ],
          [
            8194,
            "en space"
          ],
          [
            8195,
            "em space"
          ],
          [
            8201,
            "thin space"
          ],
          [
            8204,
            "zero width non-joiner"
          ],
          [
            8205,
            "zero width joiner"
          ],
          [
            8206,
            "left-to-right mark"
          ],
          [
            8207,
            "right-to-left mark"
          ]
        ]
      }
    ];
  }, ce = function(Ae) {
    return ge.grep(Ae, function(Ke) {
      return $(Ke) && Ke.length === 2;
    });
  }, ne = function(Ae) {
    return $(Ae) ? ce(Ae) : typeof Ae == "function" ? Ae() : [];
  }, Ce = function(Ae, Ke) {
    var at = xe(Ae);
    at && (Ke = [{
      name: N,
      characters: ne(at)
    }]);
    var pt = _e(Ae);
    if (pt) {
      var sn = ge.grep(Ke, function(Ie) {
        return Ie.name === N;
      });
      return sn.length ? (sn[0].characters = [].concat(sn[0].characters).concat(ne(pt)), Ke) : Ke.concat({
        name: N,
        characters: ne(pt)
      });
    }
    return Ke;
  }, Te = function(Ae) {
    var Ke = Ce(Ae, ae());
    return Ke.length > 1 ? [{
      name: "All",
      characters: Be(Ke, function(at) {
        return at.characters;
      })
    }].concat(Ke) : Ke;
  }, _ = function(Ae) {
    var Ke = function() {
      return Te(Ae);
    }, at = function(pt) {
      w(Ae, pt);
    };
    return {
      getCharMap: Ke,
      insertChar: at
    };
  }, je = function(Ae) {
    var Ke = Ae, at = function() {
      return Ke;
    }, pt = function(sn) {
      Ke = sn;
    };
    return {
      get: at,
      set: pt
    };
  }, Me = function(Ae, Ke) {
    var at = null, pt = function() {
      j(at) || (clearTimeout(at), at = null);
    }, sn = function() {
      for (var Ie = [], St = 0; St < arguments.length; St++)
        Ie[St] = arguments[St];
      pt(), at = setTimeout(function() {
        at = null, Ae.apply(null, Ie);
      }, Ke);
    };
    return {
      cancel: pt,
      throttle: sn
    };
  }, Je = String.fromCodePoint, Lt = function(Ae, Ke) {
    return Ae.indexOf(Ke) !== -1;
  }, dt = function() {
    for (var Ae = [], Ke = 0; Ke < arguments.length; Ke++)
      Ae[Ke] = arguments[Ke];
    if (Je)
      return Je.apply(void 0, Ae);
    for (var at = [], pt = 0, sn = "", Ie = 0, St = Ae.length; Ie !== St; ++Ie) {
      var Xe = +Ae[Ie];
      if (!(Xe < 1114111 && Xe >>> 0 === Xe))
        throw RangeError("Invalid code point: " + Xe);
      Xe <= 65535 ? pt = at.push(Xe) : (Xe -= 65536, pt = at.push((Xe >> 10) + 55296, Xe % 1024 + 56320)), pt >= 16383 && (sn += String.fromCharCode.apply(null, at), at.length = 0);
    }
    return sn + String.fromCharCode.apply(null, at);
  }, Tt = function(Ae, Ke, at) {
    return Lt(dt(Ae).toLowerCase(), at) ? !0 : Lt(Ke.toLowerCase(), at) || Lt(Ke.toLowerCase().replace(/\s+/g, ""), at);
  }, Jt = function(Ae, Ke) {
    var at = [], pt = Ke.toLowerCase();
    return Ze(Ae.characters, function(sn) {
      Tt(sn[0], sn[1], pt) && at.push(sn);
    }), ie(at, function(sn) {
      return {
        text: sn[1],
        value: dt(sn[0]),
        icon: dt(sn[0])
      };
    });
  }, se = "pattern", tr = function(Ae, Ke) {
    var at = function() {
      return [
        {
          label: "Search",
          type: "input",
          name: se
        },
        {
          type: "collection",
          name: "results"
        }
      ];
    }, pt = function() {
      return ie(Ke, function(It) {
        return {
          title: It.name,
          name: It.name,
          items: at()
        };
      });
    }, sn = function() {
      return {
        type: "panel",
        items: at()
      };
    }, Ie = function() {
      return {
        type: "tabpanel",
        tabs: pt()
      };
    }, St = Ke.length === 1 ? je(N) : je("All"), Xe = function(It, qt) {
      Pt(Ke, function(Vt) {
        return Vt.name === St.get();
      }).each(function(Vt) {
        var Xt = Jt(Vt, qt);
        It.setData({ results: Xt });
      });
    }, he = 40, tt = Me(function(It) {
      var qt = It.getData().pattern;
      Xe(It, qt);
    }, he), gt = Ke.length === 1 ? sn() : Ie(), Ye = {
      pattern: "",
      results: Jt(Ke[0], "")
    }, Qt = {
      title: "Special Character",
      size: "normal",
      body: gt,
      buttons: [{
        type: "cancel",
        name: "close",
        text: "Close",
        primary: !0
      }],
      initialData: Ye,
      onAction: function(It, qt) {
        qt.name === "results" && (w(Ae, qt.value), It.close());
      },
      onTabChange: function(It, qt) {
        St.set(qt.newTabName), tt.throttle(It);
      },
      onChange: function(It, qt) {
        qt.name === se && tt.throttle(It);
      }
    }, In = Ae.windowManager.open(Qt);
    In.focus(se);
  }, _t = function(Ae, Ke) {
    Ae.addCommand("mceShowCharmap", function() {
      tr(Ae, Ke);
    });
  }, Pe = tinymce.util.Tools.resolve("tinymce.util.Promise"), kt = function(Ae, Ke) {
    Ae.ui.registry.addAutocompleter("charmap", {
      ch: ":",
      columns: "auto",
      minChars: 2,
      fetch: function(at, pt) {
        return new Pe(function(sn, Ie) {
          sn(Jt(Ke, at));
        });
      },
      onAction: function(at, pt, sn) {
        Ae.selection.setRng(pt), Ae.insertContent(sn), at.hide();
      }
    });
  }, He = function(Ae) {
    Ae.ui.registry.addButton("charmap", {
      icon: "insert-character",
      tooltip: "Special character",
      onAction: function() {
        return Ae.execCommand("mceShowCharmap");
      }
    }), Ae.ui.registry.addMenuItem("charmap", {
      icon: "insert-character",
      text: "Special character...",
      onAction: function() {
        return Ae.execCommand("mceShowCharmap");
      }
    });
  };
  function We() {
    m.add("charmap", function(Ae) {
      var Ke = Te(Ae);
      return _t(Ae, Ke), He(Ae), kt(Ae, Ke[0]), _(Ae);
    });
  }
  We();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(j, le) {
    j.focus(), j.undoManager.transact(function() {
      j.setContent(le);
    }), j.selection.setCursorLocation(), j.nodeChanged();
  }, w = function(j) {
    return j.getContent({ source_view: !0 });
  }, E = function(j) {
    var le = w(j);
    j.windowManager.open({
      title: "Source Code",
      size: "large",
      body: {
        type: "panel",
        items: [{
          type: "textarea",
          name: "code"
        }]
      },
      buttons: [
        {
          type: "cancel",
          name: "cancel",
          text: "Cancel"
        },
        {
          type: "submit",
          name: "save",
          text: "Save",
          primary: !0
        }
      ],
      initialData: { code: le },
      onSubmit: function(Q) {
        y(j, Q.getData().code), Q.close();
      }
    });
  }, P = function(j) {
    j.addCommand("mceCodeEditor", function() {
      E(j);
    });
  }, H = function(j) {
    var le = function() {
      return j.execCommand("mceCodeEditor");
    };
    j.ui.registry.addButton("code", {
      icon: "sourcecode",
      tooltip: "Source code",
      onAction: le
    }), j.ui.registry.addMenuItem("code", {
      icon: "sourcecode",
      text: "Source code",
      onAction: le
    });
  };
  function X() {
    m.add("code", function(j) {
      return P(j), H(j), {};
    });
  }
  X();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function() {
  }, w = function(je) {
    return function() {
      return je;
    };
  }, E = function(je) {
    return je;
  }, P = w(!1), H = w(!0), X = function() {
    return j;
  }, j = function() {
    var je = function(Lt) {
      return Lt();
    }, Me = E, Je = {
      fold: function(Lt, dt) {
        return Lt();
      },
      isSome: P,
      isNone: H,
      getOr: Me,
      getOrThunk: je,
      getOrDie: function(Lt) {
        throw new Error(Lt || "error: getOrDie called on none.");
      },
      getOrNull: w(null),
      getOrUndefined: w(void 0),
      or: Me,
      orThunk: je,
      map: X,
      each: y,
      bind: X,
      exists: P,
      forall: H,
      filter: function() {
        return X();
      },
      toArray: function() {
        return [];
      },
      toString: w("none()")
    };
    return Je;
  }(), le = function(je) {
    var Me = w(je), Je = function() {
      return dt;
    }, Lt = function(Tt) {
      return Tt(je);
    }, dt = {
      fold: function(Tt, Jt) {
        return Jt(je);
      },
      isSome: H,
      isNone: P,
      getOr: Me,
      getOrThunk: Me,
      getOrDie: Me,
      getOrNull: Me,
      getOrUndefined: Me,
      or: Je,
      orThunk: Je,
      map: function(Tt) {
        return le(Tt(je));
      },
      each: function(Tt) {
        Tt(je);
      },
      bind: Lt,
      exists: Lt,
      forall: Lt,
      filter: function(Tt) {
        return Tt(je) ? dt : j;
      },
      toArray: function() {
        return [je];
      },
      toString: function() {
        return "some(" + je + ")";
      }
    };
    return dt;
  }, Q = function(je) {
    return je == null ? j : le(je);
  }, pe = {
    some: le,
    none: X,
    from: Q
  }, Y = function(je, Me) {
    return Me >= 0 && Me < je.length ? pe.some(je[Me]) : pe.none();
  }, D = function(je) {
    return Y(je, 0);
  }, J = function(je, Me) {
    return je ? pe.some(Me) : pe.none();
  }, ue = tinymce.util.Tools.resolve("tinymce.dom.DOMUtils"), ee = function(je) {
    return je && je.nodeName === "PRE" && je.className.indexOf("language-") !== -1;
  }, Ge = function(je) {
    return function(Me, Je) {
      return je(Je);
    };
  }, ze = typeof window < "u" ? window : Function("return this;")(), ht = {}, ie = { exports: ht }, Ze = {};
  (function(je, Me, Je, Lt) {
    var dt = window.Prism;
    window.Prism = { manual: !0 }, function(Jt, se) {
      typeof Me == "object" && typeof Je < "u" ? Je.exports = se() : typeof je == "function" && je.amd ? je(se) : (Jt = typeof globalThis < "u" ? globalThis : Jt || self, Jt.EphoxContactWrapper = se());
    }(this, function() {
      var Jt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof Ze < "u" ? Ze : typeof self < "u" ? self : {}, se = { exports: {} };
      (function(Pe) {
        var kt = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {}, He = function(We) {
          var Ae = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, Ke = 0, at = {}, pt = {
            manual: We.Prism && We.Prism.manual,
            disableWorkerMessageHandler: We.Prism && We.Prism.disableWorkerMessageHandler,
            util: {
              encode: function It(qt) {
                return qt instanceof sn ? new sn(qt.type, It(qt.content), qt.alias) : Array.isArray(qt) ? qt.map(It) : qt.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
              },
              type: function(It) {
                return Object.prototype.toString.call(It).slice(8, -1);
              },
              objId: function(It) {
                return It.__id || Object.defineProperty(It, "__id", { value: ++Ke }), It.__id;
              },
              clone: function It(qt, Vt) {
                Vt = Vt || {};
                var Xt, on;
                switch (pt.util.type(qt)) {
                  case "Object":
                    if (on = pt.util.objId(qt), Vt[on])
                      return Vt[on];
                    Xt = {}, Vt[on] = Xt;
                    for (var Vn in qt)
                      qt.hasOwnProperty(Vn) && (Xt[Vn] = It(qt[Vn], Vt));
                    return Xt;
                  case "Array":
                    return on = pt.util.objId(qt), Vt[on] ? Vt[on] : (Xt = [], Vt[on] = Xt, qt.forEach(function(Un, Tn) {
                      Xt[Tn] = It(Un, Vt);
                    }), Xt);
                  default:
                    return qt;
                }
              },
              getLanguage: function(It) {
                for (; It; ) {
                  var qt = Ae.exec(It.className);
                  if (qt)
                    return qt[1].toLowerCase();
                  It = It.parentElement;
                }
                return "none";
              },
              setLanguage: function(It, qt) {
                It.className = It.className.replace(RegExp(Ae.source, "gi"), ""), It.classList.add("language-" + qt);
              },
              currentScript: function() {
                if (typeof document > "u")
                  return null;
                if ("currentScript" in document && 1 < 2)
                  return document.currentScript;
                try {
                  throw new Error();
                } catch (Xt) {
                  var It = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(Xt.stack) || [])[1];
                  if (It) {
                    var qt = document.getElementsByTagName("script");
                    for (var Vt in qt)
                      if (qt[Vt].src == It)
                        return qt[Vt];
                  }
                  return null;
                }
              },
              isActive: function(It, qt, Vt) {
                for (var Xt = "no-" + qt; It; ) {
                  var on = It.classList;
                  if (on.contains(qt))
                    return !0;
                  if (on.contains(Xt))
                    return !1;
                  It = It.parentElement;
                }
                return !!Vt;
              }
            },
            languages: {
              plain: at,
              plaintext: at,
              text: at,
              txt: at,
              extend: function(It, qt) {
                var Vt = pt.util.clone(pt.languages[It]);
                for (var Xt in qt)
                  Vt[Xt] = qt[Xt];
                return Vt;
              },
              insertBefore: function(It, qt, Vt, Xt) {
                Xt = Xt || pt.languages;
                var on = Xt[It], Vn = {};
                for (var Un in on)
                  if (on.hasOwnProperty(Un)) {
                    if (Un == qt)
                      for (var Tn in Vt)
                        Vt.hasOwnProperty(Tn) && (Vn[Tn] = Vt[Tn]);
                    Vt.hasOwnProperty(Un) || (Vn[Un] = on[Un]);
                  }
                var yt = Xt[It];
                return Xt[It] = Vn, pt.languages.DFS(pt.languages, function(mn, zn) {
                  zn === yt && mn != It && (this[mn] = Vn);
                }), Vn;
              },
              DFS: function It(qt, Vt, Xt, on) {
                on = on || {};
                var Vn = pt.util.objId;
                for (var Un in qt)
                  if (qt.hasOwnProperty(Un)) {
                    Vt.call(qt, Un, qt[Un], Xt || Un);
                    var Tn = qt[Un], yt = pt.util.type(Tn);
                    yt === "Object" && !on[Vn(Tn)] ? (on[Vn(Tn)] = !0, It(Tn, Vt, null, on)) : yt === "Array" && !on[Vn(Tn)] && (on[Vn(Tn)] = !0, It(Tn, Vt, Un, on));
                  }
              }
            },
            plugins: {},
            highlightAll: function(It, qt) {
              pt.highlightAllUnder(document, It, qt);
            },
            highlightAllUnder: function(It, qt, Vt) {
              var Xt = {
                callback: Vt,
                container: It,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
              };
              pt.hooks.run("before-highlightall", Xt), Xt.elements = Array.prototype.slice.apply(Xt.container.querySelectorAll(Xt.selector)), pt.hooks.run("before-all-elements-highlight", Xt);
              for (var on = 0, Vn; Vn = Xt.elements[on++]; )
                pt.highlightElement(Vn, qt === !0, Xt.callback);
            },
            highlightElement: function(It, qt, Vt) {
              var Xt = pt.util.getLanguage(It), on = pt.languages[Xt];
              pt.util.setLanguage(It, Xt);
              var Vn = It.parentElement;
              Vn && Vn.nodeName.toLowerCase() === "pre" && pt.util.setLanguage(Vn, Xt);
              var Un = It.textContent, Tn = {
                element: It,
                language: Xt,
                grammar: on,
                code: Un
              };
              function yt(zn) {
                Tn.highlightedCode = zn, pt.hooks.run("before-insert", Tn), Tn.element.innerHTML = Tn.highlightedCode, pt.hooks.run("after-highlight", Tn), pt.hooks.run("complete", Tn), Vt && Vt.call(Tn.element);
              }
              if (pt.hooks.run("before-sanity-check", Tn), Vn = Tn.element.parentElement, Vn && Vn.nodeName.toLowerCase() === "pre" && !Vn.hasAttribute("tabindex") && Vn.setAttribute("tabindex", "0"), !Tn.code) {
                pt.hooks.run("complete", Tn), Vt && Vt.call(Tn.element);
                return;
              }
              if (pt.hooks.run("before-highlight", Tn), !Tn.grammar) {
                yt(pt.util.encode(Tn.code));
                return;
              }
              if (qt && We.Worker) {
                var mn = new Worker(pt.filename);
                mn.onmessage = function(zn) {
                  yt(zn.data);
                }, mn.postMessage(JSON.stringify({
                  language: Tn.language,
                  code: Tn.code,
                  immediateClose: !0
                }));
              } else
                yt(pt.highlight(Tn.code, Tn.grammar, Tn.language));
            },
            highlight: function(It, qt, Vt) {
              var Xt = {
                code: It,
                grammar: qt,
                language: Vt
              };
              if (pt.hooks.run("before-tokenize", Xt), !Xt.grammar)
                throw new Error('The language "' + Xt.language + '" has no grammar.');
              return Xt.tokens = pt.tokenize(Xt.code, Xt.grammar), pt.hooks.run("after-tokenize", Xt), sn.stringify(pt.util.encode(Xt.tokens), Xt.language);
            },
            tokenize: function(It, qt) {
              var Vt = qt.rest;
              if (Vt) {
                for (var Xt in Vt)
                  qt[Xt] = Vt[Xt];
                delete qt.rest;
              }
              var on = new Xe();
              return he(on, on.head, It), St(It, on, qt, on.head, 0), gt(on);
            },
            hooks: {
              all: {},
              add: function(It, qt) {
                var Vt = pt.hooks.all;
                Vt[It] = Vt[It] || [], Vt[It].push(qt);
              },
              run: function(It, qt) {
                var Vt = pt.hooks.all[It];
                if (!(!Vt || !Vt.length))
                  for (var Xt = 0, on; on = Vt[Xt++]; )
                    on(qt);
              }
            },
            Token: sn
          };
          We.Prism = pt;
          function sn(It, qt, Vt, Xt) {
            this.type = It, this.content = qt, this.alias = Vt, this.length = (Xt || "").length | 0;
          }
          sn.stringify = function It(qt, Vt) {
            if (typeof qt == "string")
              return qt;
            if (Array.isArray(qt)) {
              var Xt = "";
              return qt.forEach(function(yt) {
                Xt += It(yt, Vt);
              }), Xt;
            }
            var on = {
              type: qt.type,
              content: It(qt.content, Vt),
              tag: "span",
              classes: [
                "token",
                qt.type
              ],
              attributes: {},
              language: Vt
            }, Vn = qt.alias;
            Vn && (Array.isArray(Vn) ? Array.prototype.push.apply(on.classes, Vn) : on.classes.push(Vn)), pt.hooks.run("wrap", on);
            var Un = "";
            for (var Tn in on.attributes)
              Un += " " + Tn + '="' + (on.attributes[Tn] || "").replace(/"/g, "&quot;") + '"';
            return "<" + on.tag + ' class="' + on.classes.join(" ") + '"' + Un + ">" + on.content + "</" + on.tag + ">";
          };
          function Ie(It, qt, Vt, Xt) {
            It.lastIndex = qt;
            var on = It.exec(Vt);
            if (on && Xt && on[1]) {
              var Vn = on[1].length;
              on.index += Vn, on[0] = on[0].slice(Vn);
            }
            return on;
          }
          function St(It, qt, Vt, Xt, on, Vn) {
            for (var Un in Vt)
              if (!(!Vt.hasOwnProperty(Un) || !Vt[Un])) {
                var Tn = Vt[Un];
                Tn = Array.isArray(Tn) ? Tn : [Tn];
                for (var yt = 0; yt < Tn.length; ++yt) {
                  if (Vn && Vn.cause == Un + "," + yt)
                    return;
                  var mn = Tn[yt], zn = mn.inside, _n = !!mn.lookbehind, Kr = !!mn.greedy, ot = mn.alias;
                  if (Kr && !mn.pattern.global) {
                    var Yt = mn.pattern.toString().match(/[imsuy]*$/)[0];
                    mn.pattern = RegExp(mn.pattern.source, Yt + "g");
                  }
                  for (var Ft = mn.pattern || mn, yn = Xt.next, Yn = on; yn !== qt.tail && !(Vn && Yn >= Vn.reach); Yn += yn.value.length, yn = yn.next) {
                    var Ir = yn.value;
                    if (qt.length > It.length)
                      return;
                    if (!(Ir instanceof sn)) {
                      var Wa = 1, Mr;
                      if (Kr) {
                        if (Mr = Ie(Ft, Yn, It, _n), !Mr || Mr.index >= It.length)
                          break;
                        var Go = Mr.index, Fr = Mr.index + Mr[0].length, Va = Yn;
                        for (Va += yn.value.length; Go >= Va; )
                          yn = yn.next, Va += yn.value.length;
                        if (Va -= yn.value.length, Yn = Va, yn.value instanceof sn)
                          continue;
                        for (var Qo = yn; Qo !== qt.tail && (Va < Fr || typeof Qo.value == "string"); Qo = Qo.next)
                          Wa++, Va += Qo.value.length;
                        Wa--, Ir = It.slice(Yn, Va), Mr.index -= Yn;
                      } else if (Mr = Ie(Ft, 0, Ir, _n), !Mr)
                        continue;
                      var Go = Mr.index, so = Mr[0], bo = Ir.slice(0, Go), mi = Ir.slice(Go + so.length), Ao = Yn + Ir.length;
                      Vn && Ao > Vn.reach && (Vn.reach = Ao);
                      var go = yn.prev;
                      bo && (go = he(qt, go, bo), Yn += bo.length), tt(qt, go, Wa);
                      var gi = new sn(Un, zn ? pt.tokenize(so, zn) : so, ot, so);
                      if (yn = he(qt, go, gi), mi && he(qt, yn, mi), Wa > 1) {
                        var na = {
                          cause: Un + "," + yt,
                          reach: Ao
                        };
                        St(It, qt, Vt, yn.prev, Yn, na), Vn && na.reach > Vn.reach && (Vn.reach = na.reach);
                      }
                    }
                  }
                }
              }
          }
          function Xe() {
            var It = {
              value: null,
              prev: null,
              next: null
            }, qt = {
              value: null,
              prev: It,
              next: null
            };
            It.next = qt, this.head = It, this.tail = qt, this.length = 0;
          }
          function he(It, qt, Vt) {
            var Xt = qt.next, on = {
              value: Vt,
              prev: qt,
              next: Xt
            };
            return qt.next = on, Xt.prev = on, It.length++, on;
          }
          function tt(It, qt, Vt) {
            for (var Xt = qt.next, on = 0; on < Vt && Xt !== It.tail; on++)
              Xt = Xt.next;
            qt.next = Xt, Xt.prev = qt, It.length -= on;
          }
          function gt(It) {
            for (var qt = [], Vt = It.head.next; Vt !== It.tail; )
              qt.push(Vt.value), Vt = Vt.next;
            return qt;
          }
          if (!We.document)
            return We.addEventListener && (pt.disableWorkerMessageHandler || We.addEventListener("message", function(It) {
              var qt = JSON.parse(It.data), Vt = qt.language, Xt = qt.code, on = qt.immediateClose;
              We.postMessage(pt.highlight(Xt, pt.languages[Vt], Vt)), on && We.close();
            }, !1)), pt;
          var Ye = pt.util.currentScript();
          Ye && (pt.filename = Ye.src, Ye.hasAttribute("data-manual") && (pt.manual = !0));
          function Qt() {
            pt.manual || pt.highlightAll();
          }
          if (!pt.manual) {
            var In = document.readyState;
            In === "loading" || In === "interactive" && Ye && Ye.defer ? document.addEventListener("DOMContentLoaded", Qt) : window.requestAnimationFrame ? window.requestAnimationFrame(Qt) : window.setTimeout(Qt, 16);
          }
          return pt;
        }(kt);
        Pe.exports && (Pe.exports = He), typeof Jt < "u" && (Jt.Prism = He);
      })(se), Prism.languages.clike = {
        comment: [
          {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: !0,
            greedy: !0
          },
          {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: !0,
            greedy: !0
          }
        ],
        string: {
          pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
          greedy: !0
        },
        "class-name": {
          pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
          lookbehind: !0,
          inside: { punctuation: /[.\\]/ }
        },
        keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
        boolean: /\b(?:false|true)\b/,
        function: /\b\w+(?=\()/,
        number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
        operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
        punctuation: /[{}[\];(),.:]/
      }, function(Pe) {
        function kt(He, We) {
          return "___" + He.toUpperCase() + We + "___";
        }
        Object.defineProperties(Pe.languages["markup-templating"] = {}, {
          buildPlaceholders: {
            value: function(He, We, Ae, Ke) {
              if (He.language === We) {
                var at = He.tokenStack = [];
                He.code = He.code.replace(Ae, function(pt) {
                  if (typeof Ke == "function" && !Ke(pt))
                    return pt;
                  for (var sn = at.length, Ie; He.code.indexOf(Ie = kt(We, sn)) !== -1; )
                    ++sn;
                  return at[sn] = pt, Ie;
                }), He.grammar = Pe.languages.markup;
              }
            }
          },
          tokenizePlaceholders: {
            value: function(He, We) {
              if (He.language !== We || !He.tokenStack)
                return;
              He.grammar = Pe.languages[We];
              var Ae = 0, Ke = Object.keys(He.tokenStack);
              function at(pt) {
                for (var sn = 0; sn < pt.length && !(Ae >= Ke.length); sn++) {
                  var Ie = pt[sn];
                  if (typeof Ie == "string" || Ie.content && typeof Ie.content == "string") {
                    var St = Ke[Ae], Xe = He.tokenStack[St], he = typeof Ie == "string" ? Ie : Ie.content, tt = kt(We, St), gt = he.indexOf(tt);
                    if (gt > -1) {
                      ++Ae;
                      var Ye = he.substring(0, gt), Qt = new Pe.Token(We, Pe.tokenize(Xe, He.grammar), "language-" + We, Xe), In = he.substring(gt + tt.length), It = [];
                      Ye && It.push.apply(It, at([Ye])), It.push(Qt), In && It.push.apply(It, at([In])), typeof Ie == "string" ? pt.splice.apply(pt, [
                        sn,
                        1
                      ].concat(It)) : Ie.content = It;
                    }
                  } else
                    Ie.content && at(Ie.content);
                }
                return pt;
              }
              at(He.tokens);
            }
          }
        });
      }(Prism), Prism.languages.c = Prism.languages.extend("clike", {
        comment: {
          pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
          greedy: !0
        },
        string: {
          pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
          greedy: !0
        },
        "class-name": {
          pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
          lookbehind: !0
        },
        keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
        function: /\b[a-z_]\w*(?=\s*\()/i,
        number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
        operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
      }), Prism.languages.insertBefore("c", "string", {
        char: {
          pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
          greedy: !0
        }
      }), Prism.languages.insertBefore("c", "string", {
        macro: {
          pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
          lookbehind: !0,
          greedy: !0,
          alias: "property",
          inside: {
            string: [
              {
                pattern: /^(#\s*include\s*)<[^>]+>/,
                lookbehind: !0
              },
              Prism.languages.c.string
            ],
            char: Prism.languages.c.char,
            comment: Prism.languages.c.comment,
            "macro-name": [
              {
                pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                lookbehind: !0
              },
              {
                pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                lookbehind: !0,
                alias: "function"
              }
            ],
            directive: {
              pattern: /^(#\s*)[a-z]+/,
              lookbehind: !0,
              alias: "keyword"
            },
            "directive-hash": /^#/,
            punctuation: /##|\\(?=[\r\n])/,
            expression: {
              pattern: /\S[\s\S]*/,
              inside: Prism.languages.c
            }
          }
        }
      }), Prism.languages.insertBefore("c", "function", { constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/ }), delete Prism.languages.c.boolean, function(Pe) {
        var kt = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, He = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
          return kt.source;
        });
        Pe.languages.cpp = Pe.languages.extend("c", {
          "class-name": [
            {
              pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                return kt.source;
              })),
              lookbehind: !0
            },
            /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
            /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
            /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
          ],
          keyword: kt,
          number: {
            pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
            greedy: !0
          },
          operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
          boolean: /\b(?:false|true)\b/
        }), Pe.languages.insertBefore("cpp", "string", {
          module: {
            pattern: RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
              return He;
            }) + ")"),
            lookbehind: !0,
            greedy: !0,
            inside: {
              string: /^[<"][\s\S]+/,
              operator: /:/,
              punctuation: /\./
            }
          },
          "raw-string": {
            pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
            alias: "string",
            greedy: !0
          }
        }), Pe.languages.insertBefore("cpp", "keyword", {
          "generic-function": {
            pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
            inside: {
              function: /^\w+/,
              generic: {
                pattern: /<[\s\S]+/,
                alias: "class-name",
                inside: Pe.languages.cpp
              }
            }
          }
        }), Pe.languages.insertBefore("cpp", "operator", {
          "double-colon": {
            pattern: /::/,
            alias: "punctuation"
          }
        }), Pe.languages.insertBefore("cpp", "class-name", {
          "base-clause": {
            pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
            lookbehind: !0,
            greedy: !0,
            inside: Pe.languages.extend("cpp", {})
          }
        }), Pe.languages.insertBefore("inside", "double-colon", { "class-name": /\b[a-z_]\w*\b(?!\s*::)/i }, Pe.languages.cpp["base-clause"]);
      }(Prism), function(Pe) {
        function kt(Yn, Ir) {
          return Yn.replace(/<<(\d+)>>/g, function(Wa, Mr) {
            return "(?:" + Ir[+Mr] + ")";
          });
        }
        function He(Yn, Ir, Wa) {
          return RegExp(kt(Yn, Ir), Wa || "");
        }
        function We(Yn, Ir) {
          for (var Wa = 0; Wa < Ir; Wa++)
            Yn = Yn.replace(/<<self>>/g, function() {
              return "(?:" + Yn + ")";
            });
          return Yn.replace(/<<self>>/g, "[^\\s\\S]");
        }
        var Ae = {
          type: "bool byte char decimal double dynamic float int long object sbyte short string uint ulong ushort var void",
          typeDeclaration: "class enum interface record struct",
          contextual: "add alias and ascending async await by descending from(?=\\s*(?:\\w|$)) get global group into init(?=\\s*;) join let nameof not notnull on or orderby partial remove select set unmanaged value when where with(?=\\s*{)",
          other: "abstract as base break case catch checked const continue default delegate do else event explicit extern finally fixed for foreach goto if implicit in internal is lock namespace new null operator out override params private protected public readonly ref return sealed sizeof stackalloc static switch this throw try typeof unchecked unsafe using virtual volatile while yield"
        };
        function Ke(Yn) {
          return "\\b(?:" + Yn.trim().replace(/ /g, "|") + ")\\b";
        }
        var at = Ke(Ae.typeDeclaration), pt = RegExp(Ke(Ae.type + " " + Ae.typeDeclaration + " " + Ae.contextual + " " + Ae.other)), sn = Ke(Ae.typeDeclaration + " " + Ae.contextual + " " + Ae.other), Ie = Ke(Ae.type + " " + Ae.typeDeclaration + " " + Ae.other), St = We(/<(?:[^<>;=+\-*/%&|^]|<<self>>)*>/.source, 2), Xe = We(/\((?:[^()]|<<self>>)*\)/.source, 2), he = /@?\b[A-Za-z_]\w*\b/.source, tt = kt(/<<0>>(?:\s*<<1>>)?/.source, [
          he,
          St
        ]), gt = kt(/(?!<<0>>)<<1>>(?:\s*\.\s*<<1>>)*/.source, [
          sn,
          tt
        ]), Ye = /\[\s*(?:,\s*)*\]/.source, Qt = kt(/<<0>>(?:\s*(?:\?\s*)?<<1>>)*(?:\s*\?)?/.source, [
          gt,
          Ye
        ]), In = kt(/[^,()<>[\];=+\-*/%&|^]|<<0>>|<<1>>|<<2>>/.source, [
          St,
          Xe,
          Ye
        ]), It = kt(/\(<<0>>+(?:,<<0>>+)+\)/.source, [In]), qt = kt(/(?:<<0>>|<<1>>)(?:\s*(?:\?\s*)?<<2>>)*(?:\s*\?)?/.source, [
          It,
          gt,
          Ye
        ]), Vt = {
          keyword: pt,
          punctuation: /[<>()?,.:[\]]/
        }, Xt = /'(?:[^\r\n'\\]|\\.|\\[Uux][\da-fA-F]{1,8})'/.source, on = /"(?:\\.|[^\\"\r\n])*"/.source, Vn = /@"(?:""|\\[\s\S]|[^\\"])*"(?!")/.source;
        Pe.languages.csharp = Pe.languages.extend("clike", {
          string: [
            {
              pattern: He(/(^|[^$\\])<<0>>/.source, [Vn]),
              lookbehind: !0,
              greedy: !0
            },
            {
              pattern: He(/(^|[^@$\\])<<0>>/.source, [on]),
              lookbehind: !0,
              greedy: !0
            }
          ],
          "class-name": [
            {
              pattern: He(/(\busing\s+static\s+)<<0>>(?=\s*;)/.source, [gt]),
              lookbehind: !0,
              inside: Vt
            },
            {
              pattern: He(/(\busing\s+<<0>>\s*=\s*)<<1>>(?=\s*;)/.source, [
                he,
                qt
              ]),
              lookbehind: !0,
              inside: Vt
            },
            {
              pattern: He(/(\busing\s+)<<0>>(?=\s*=)/.source, [he]),
              lookbehind: !0
            },
            {
              pattern: He(/(\b<<0>>\s+)<<1>>/.source, [
                at,
                tt
              ]),
              lookbehind: !0,
              inside: Vt
            },
            {
              pattern: He(/(\bcatch\s*\(\s*)<<0>>/.source, [gt]),
              lookbehind: !0,
              inside: Vt
            },
            {
              pattern: He(/(\bwhere\s+)<<0>>/.source, [he]),
              lookbehind: !0
            },
            {
              pattern: He(/(\b(?:is(?:\s+not)?|as)\s+)<<0>>/.source, [Qt]),
              lookbehind: !0,
              inside: Vt
            },
            {
              pattern: He(/\b<<0>>(?=\s+(?!<<1>>|with\s*\{)<<2>>(?:\s*[=,;:{)\]]|\s+(?:in|when)\b))/.source, [
                qt,
                Ie,
                he
              ]),
              inside: Vt
            }
          ],
          keyword: pt,
          number: /(?:\b0(?:x[\da-f_]*[\da-f]|b[01_]*[01])|(?:\B\.\d+(?:_+\d+)*|\b\d+(?:_+\d+)*(?:\.\d+(?:_+\d+)*)?)(?:e[-+]?\d+(?:_+\d+)*)?)(?:[dflmu]|lu|ul)?\b/i,
          operator: />>=?|<<=?|[-=]>|([-+&|])\1|~|\?\?=?|[-+*/%&|^!=<>]=?/,
          punctuation: /\?\.?|::|[{}[\];(),.:]/
        }), Pe.languages.insertBefore("csharp", "number", {
          range: {
            pattern: /\.\./,
            alias: "operator"
          }
        }), Pe.languages.insertBefore("csharp", "punctuation", {
          "named-parameter": {
            pattern: He(/([(,]\s*)<<0>>(?=\s*:)/.source, [he]),
            lookbehind: !0,
            alias: "punctuation"
          }
        }), Pe.languages.insertBefore("csharp", "class-name", {
          namespace: {
            pattern: He(/(\b(?:namespace|using)\s+)<<0>>(?:\s*\.\s*<<0>>)*(?=\s*[;{])/.source, [he]),
            lookbehind: !0,
            inside: { punctuation: /\./ }
          },
          "type-expression": {
            pattern: He(/(\b(?:default|sizeof|typeof)\s*\(\s*(?!\s))(?:[^()\s]|\s(?!\s)|<<0>>)*(?=\s*\))/.source, [Xe]),
            lookbehind: !0,
            alias: "class-name",
            inside: Vt
          },
          "return-type": {
            pattern: He(/<<0>>(?=\s+(?:<<1>>\s*(?:=>|[({]|\.\s*this\s*\[)|this\s*\[))/.source, [
              qt,
              gt
            ]),
            inside: Vt,
            alias: "class-name"
          },
          "constructor-invocation": {
            pattern: He(/(\bnew\s+)<<0>>(?=\s*[[({])/.source, [qt]),
            lookbehind: !0,
            inside: Vt,
            alias: "class-name"
          },
          "generic-method": {
            pattern: He(/<<0>>\s*<<1>>(?=\s*\()/.source, [
              he,
              St
            ]),
            inside: {
              function: He(/^<<0>>/.source, [he]),
              generic: {
                pattern: RegExp(St),
                alias: "class-name",
                inside: Vt
              }
            }
          },
          "type-list": {
            pattern: He(/\b((?:<<0>>\s+<<1>>|record\s+<<1>>\s*<<5>>|where\s+<<2>>)\s*:\s*)(?:<<3>>|<<4>>|<<1>>\s*<<5>>|<<6>>)(?:\s*,\s*(?:<<3>>|<<4>>|<<6>>))*(?=\s*(?:where|[{;]|=>|$))/.source, [
              at,
              tt,
              he,
              qt,
              pt.source,
              Xe,
              /\bnew\s*\(\s*\)/.source
            ]),
            lookbehind: !0,
            inside: {
              "record-arguments": {
                pattern: He(/(^(?!new\s*\()<<0>>\s*)<<1>>/.source, [
                  tt,
                  Xe
                ]),
                lookbehind: !0,
                greedy: !0,
                inside: Pe.languages.csharp
              },
              keyword: pt,
              "class-name": {
                pattern: RegExp(qt),
                greedy: !0,
                inside: Vt
              },
              punctuation: /[,()]/
            }
          },
          preprocessor: {
            pattern: /(^[\t ]*)#.*/m,
            lookbehind: !0,
            alias: "property",
            inside: {
              directive: {
                pattern: /(#)\b(?:define|elif|else|endif|endregion|error|if|line|nullable|pragma|region|undef|warning)\b/,
                lookbehind: !0,
                alias: "keyword"
              }
            }
          }
        });
        var Un = on + "|" + Xt, Tn = kt(/\/(?![*/])|\/\/[^\r\n]*[\r\n]|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>/.source, [Un]), yt = We(kt(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [Tn]), 2), mn = /\b(?:assembly|event|field|method|module|param|property|return|type)\b/.source, zn = kt(/<<0>>(?:\s*\(<<1>>*\))?/.source, [
          gt,
          yt
        ]);
        Pe.languages.insertBefore("csharp", "class-name", {
          attribute: {
            pattern: He(/((?:^|[^\s\w>)?])\s*\[\s*)(?:<<0>>\s*:\s*)?<<1>>(?:\s*,\s*<<1>>)*(?=\s*\])/.source, [
              mn,
              zn
            ]),
            lookbehind: !0,
            greedy: !0,
            inside: {
              target: {
                pattern: He(/^<<0>>(?=\s*:)/.source, [mn]),
                alias: "keyword"
              },
              "attribute-arguments": {
                pattern: He(/\(<<0>>*\)/.source, [yt]),
                inside: Pe.languages.csharp
              },
              "class-name": {
                pattern: RegExp(gt),
                inside: { punctuation: /\./ }
              },
              punctuation: /[:,]/
            }
          }
        });
        var _n = /:[^}\r\n]+/.source, Kr = We(kt(/[^"'/()]|<<0>>|\(<<self>>*\)/.source, [Tn]), 2), ot = kt(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
          Kr,
          _n
        ]), Yt = We(kt(/[^"'/()]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|<<0>>|\(<<self>>*\)/.source, [Un]), 2), Ft = kt(/\{(?!\{)(?:(?![}:])<<0>>)*<<1>>?\}/.source, [
          Yt,
          _n
        ]);
        function yn(Yn, Ir) {
          return {
            interpolation: {
              pattern: He(/((?:^|[^{])(?:\{\{)*)<<0>>/.source, [Yn]),
              lookbehind: !0,
              inside: {
                "format-string": {
                  pattern: He(/(^\{(?:(?![}:])<<0>>)*)<<1>>(?=\}$)/.source, [
                    Ir,
                    _n
                  ]),
                  lookbehind: !0,
                  inside: { punctuation: /^:/ }
                },
                punctuation: /^\{|\}$/,
                expression: {
                  pattern: /[\s\S]+/,
                  alias: "language-csharp",
                  inside: Pe.languages.csharp
                }
              }
            },
            string: /[\s\S]+/
          };
        }
        Pe.languages.insertBefore("csharp", "string", {
          "interpolation-string": [
            {
              pattern: He(/(^|[^\\])(?:\$@|@\$)"(?:""|\\[\s\S]|\{\{|<<0>>|[^\\{"])*"/.source, [ot]),
              lookbehind: !0,
              greedy: !0,
              inside: yn(ot, Kr)
            },
            {
              pattern: He(/(^|[^@\\])\$"(?:\\.|\{\{|<<0>>|[^\\"{])*"/.source, [Ft]),
              lookbehind: !0,
              greedy: !0,
              inside: yn(Ft, Yt)
            }
          ],
          char: {
            pattern: RegExp(Xt),
            greedy: !0
          }
        }), Pe.languages.dotnet = Pe.languages.cs = Pe.languages.csharp;
      }(Prism), function(Pe) {
        var kt = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
        Pe.languages.css = {
          comment: /\/\*[\s\S]*?\*\//,
          atrule: {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + kt.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
              rule: /^@[\w-]+/,
              "selector-function-argument": {
                pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                lookbehind: !0,
                alias: "selector"
              },
              keyword: {
                pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                lookbehind: !0
              }
            }
          },
          url: {
            pattern: RegExp("\\burl\\((?:" + kt.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: !0,
            inside: {
              function: /^url/i,
              punctuation: /^\(|\)$/,
              string: {
                pattern: RegExp("^" + kt.source + "$"),
                alias: "url"
              }
            }
          },
          selector: {
            pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + kt.source + ")*(?=\\s*\\{)"),
            lookbehind: !0
          },
          string: {
            pattern: kt,
            greedy: !0
          },
          property: {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: !0
          },
          important: /!important\b/i,
          function: {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: !0
          },
          punctuation: /[(){};:,]/
        }, Pe.languages.css.atrule.inside.rest = Pe.languages.css;
        var He = Pe.languages.markup;
        He && (He.tag.addInlined("style", "css"), He.tag.addAttribute("style", "css"));
      }(Prism), function(Pe) {
        var kt = /\b(?:abstract|assert|boolean|break|byte|case|catch|char|class|const|continue|default|do|double|else|enum|exports|extends|final|finally|float|for|goto|if|implements|import|instanceof|int|interface|long|module|native|new|non-sealed|null|open|opens|package|permits|private|protected|provides|public|record(?!\s*[(){}[\]<>=%~.:,;?+\-*/&|^])|requires|return|sealed|short|static|strictfp|super|switch|synchronized|this|throw|throws|to|transient|transitive|try|uses|var|void|volatile|while|with|yield)\b/, He = /(?:[a-z]\w*\s*\.\s*)*(?:[A-Z]\w*\s*\.\s*)*/.source, We = {
          pattern: RegExp(/(^|[^\w.])/.source + He + /[A-Z](?:[\d_A-Z]*[a-z]\w*)?\b/.source),
          lookbehind: !0,
          inside: {
            namespace: {
              pattern: /^[a-z]\w*(?:\s*\.\s*[a-z]\w*)*(?:\s*\.)?/,
              inside: { punctuation: /\./ }
            },
            punctuation: /\./
          }
        };
        Pe.languages.java = Pe.languages.extend("clike", {
          string: {
            pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"/,
            lookbehind: !0,
            greedy: !0
          },
          "class-name": [
            We,
            {
              pattern: RegExp(/(^|[^\w.])/.source + He + /[A-Z]\w*(?=\s+\w+\s*[;,=()]|\s*(?:\[[\s,]*\]\s*)?::\s*new\b)/.source),
              lookbehind: !0,
              inside: We.inside
            },
            {
              pattern: RegExp(/(\b(?:class|enum|extends|implements|instanceof|interface|new|record|throws)\s+)/.source + He + /[A-Z]\w*\b/.source),
              lookbehind: !0,
              inside: We.inside
            }
          ],
          keyword: kt,
          function: [
            Pe.languages.clike.function,
            {
              pattern: /(::\s*)[a-z_]\w*/,
              lookbehind: !0
            }
          ],
          number: /\b0b[01][01_]*L?\b|\b0x(?:\.[\da-f_p+-]+|[\da-f_]+(?:\.[\da-f_p+-]+)?)\b|(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?\d[\d_]*)?[dfl]?/i,
          operator: {
            pattern: /(^|[^.])(?:<<=?|>>>?=?|->|--|\+\+|&&|\|\||::|[?:~]|[-+*/%&|^!=<>]=?)/m,
            lookbehind: !0
          },
          constant: /\b[A-Z][A-Z_\d]+\b/
        }), Pe.languages.insertBefore("java", "string", {
          "triple-quoted-string": {
            pattern: /"""[ \t]*[\r\n](?:(?:"|"")?(?:\\.|[^"\\]))*"""/,
            greedy: !0,
            alias: "string"
          },
          char: {
            pattern: /'(?:\\.|[^'\\\r\n]){1,6}'/,
            greedy: !0
          }
        }), Pe.languages.insertBefore("java", "class-name", {
          annotation: {
            pattern: /(^|[^.])@\w+(?:\s*\.\s*\w+)*/,
            lookbehind: !0,
            alias: "punctuation"
          },
          generics: {
            pattern: /<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&)|<(?:[\w\s,.?]|&(?!&))*>)*>)*>)*>/,
            inside: {
              "class-name": We,
              keyword: kt,
              punctuation: /[<>(),.:]/,
              operator: /[?&|]/
            }
          },
          import: [
            {
              pattern: RegExp(/(\bimport\s+)/.source + He + /(?:[A-Z]\w*|\*)(?=\s*;)/.source),
              lookbehind: !0,
              inside: {
                namespace: We.inside.namespace,
                punctuation: /\./,
                operator: /\*/,
                "class-name": /\w+/
              }
            },
            {
              pattern: RegExp(/(\bimport\s+static\s+)/.source + He + /(?:\w+|\*)(?=\s*;)/.source),
              lookbehind: !0,
              alias: "static",
              inside: {
                namespace: We.inside.namespace,
                static: /\b\w+$/,
                punctuation: /\./,
                operator: /\*/,
                "class-name": /\w+/
              }
            }
          ],
          namespace: {
            pattern: RegExp(/(\b(?:exports|import(?:\s+static)?|module|open|opens|package|provides|requires|to|transitive|uses|with)\s+)(?!<keyword>)[a-z]\w*(?:\.[a-z]\w*)*\.?/.source.replace(/<keyword>/g, function() {
              return kt.source;
            })),
            lookbehind: !0,
            inside: { punctuation: /\./ }
          }
        });
      }(Prism), Prism.languages.javascript = Prism.languages.extend("clike", {
        "class-name": [
          Prism.languages.clike["class-name"],
          {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: !0
          }
        ],
        keyword: [
          {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: !0
          },
          {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: !0
          }
        ],
        function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
        number: {
          pattern: RegExp(/(^|[^\w$])/.source + "(?:" + (/NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source),
          lookbehind: !0
        },
        operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
      }), Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, Prism.languages.insertBefore("javascript", "keyword", {
        regex: {
          pattern: RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
          lookbehind: !0,
          greedy: !0,
          inside: {
            "regex-source": {
              pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
              lookbehind: !0,
              alias: "language-regex",
              inside: Prism.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
          }
        },
        "function-variable": {
          pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
          alias: "function"
        },
        parameter: [
          {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: !0,
            inside: Prism.languages.javascript
          },
          {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: !0,
            inside: Prism.languages.javascript
          },
          {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: !0,
            inside: Prism.languages.javascript
          },
          {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: !0,
            inside: Prism.languages.javascript
          }
        ],
        constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
      }), Prism.languages.insertBefore("javascript", "string", {
        hashbang: {
          pattern: /^#!.*/,
          greedy: !0,
          alias: "comment"
        },
        "template-string": {
          pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
          greedy: !0,
          inside: {
            "template-punctuation": {
              pattern: /^`|`$/,
              alias: "string"
            },
            interpolation: {
              pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
              lookbehind: !0,
              inside: {
                "interpolation-punctuation": {
                  pattern: /^\$\{|\}$/,
                  alias: "punctuation"
                },
                rest: Prism.languages.javascript
              }
            },
            string: /[\s\S]+/
          }
        },
        "string-property": {
          pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
          lookbehind: !0,
          greedy: !0,
          alias: "property"
        }
      }), Prism.languages.insertBefore("javascript", "operator", {
        "literal-property": {
          pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
          lookbehind: !0,
          alias: "property"
        }
      }), Prism.languages.markup && (Prism.languages.markup.tag.addInlined("script", "javascript"), Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), Prism.languages.js = Prism.languages.javascript, Prism.languages.markup = {
        comment: {
          pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
          greedy: !0
        },
        prolog: {
          pattern: /<\?[\s\S]+?\?>/,
          greedy: !0
        },
        doctype: {
          pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
          greedy: !0,
          inside: {
            "internal-subset": {
              pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
              lookbehind: !0,
              greedy: !0,
              inside: null
            },
            string: {
              pattern: /"[^"]*"|'[^']*'/,
              greedy: !0
            },
            punctuation: /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            name: /[^\s<>'"]+/
          }
        },
        cdata: {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          greedy: !0
        },
        tag: {
          pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
          greedy: !0,
          inside: {
            tag: {
              pattern: /^<\/?[^\s>\/]+/,
              inside: {
                punctuation: /^<\/?/,
                namespace: /^[^\s>\/:]+:/
              }
            },
            "special-attr": [],
            "attr-value": {
              pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
              inside: {
                punctuation: [
                  {
                    pattern: /^=/,
                    alias: "attr-equals"
                  },
                  {
                    pattern: /^(\s*)["']|["']$/,
                    lookbehind: !0
                  }
                ]
              }
            },
            punctuation: /\/?>/,
            "attr-name": {
              pattern: /[^\s>\/]+/,
              inside: { namespace: /^[^\s>\/:]+:/ }
            }
          }
        },
        entity: [
          {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
          },
          /&#x?[\da-f]{1,8};/i
        ]
      }, Prism.languages.markup.tag.inside["attr-value"].inside.entity = Prism.languages.markup.entity, Prism.languages.markup.doctype.inside["internal-subset"].inside = Prism.languages.markup, Prism.hooks.add("wrap", function(Pe) {
        Pe.type === "entity" && (Pe.attributes.title = Pe.content.replace(/&amp;/, "&"));
      }), Object.defineProperty(Prism.languages.markup.tag, "addInlined", {
        value: function(kt, He) {
          var We = {};
          We["language-" + He] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: !0,
            inside: Prism.languages[He]
          }, We.cdata = /^<!\[CDATA\[|\]\]>$/i;
          var Ae = {
            "included-cdata": {
              pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
              inside: We
            }
          };
          Ae["language-" + He] = {
            pattern: /[\s\S]+/,
            inside: Prism.languages[He]
          };
          var Ke = {};
          Ke[kt] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
              return kt;
            }), "i"),
            lookbehind: !0,
            greedy: !0,
            inside: Ae
          }, Prism.languages.insertBefore("markup", "cdata", Ke);
        }
      }), Object.defineProperty(Prism.languages.markup.tag, "addAttribute", {
        value: function(Pe, kt) {
          Prism.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + Pe + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: !0,
            inside: {
              "attr-name": /^[^\s=]+/,
              "attr-value": {
                pattern: /=[\s\S]+/,
                inside: {
                  value: {
                    pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                    lookbehind: !0,
                    alias: [
                      kt,
                      "language-" + kt
                    ],
                    inside: Prism.languages[kt]
                  },
                  punctuation: [
                    {
                      pattern: /^=/,
                      alias: "attr-equals"
                    },
                    /"|'/
                  ]
                }
              }
            }
          });
        }
      }), Prism.languages.html = Prism.languages.markup, Prism.languages.mathml = Prism.languages.markup, Prism.languages.svg = Prism.languages.markup, Prism.languages.xml = Prism.languages.extend("markup", {}), Prism.languages.ssml = Prism.languages.xml, Prism.languages.atom = Prism.languages.xml, Prism.languages.rss = Prism.languages.xml, function(Pe) {
        var kt = /\/\*[\s\S]*?\*\/|\/\/.*|#(?!\[).*/, He = [
          {
            pattern: /\b(?:false|true)\b/i,
            alias: "boolean"
          },
          {
            pattern: /(::\s*)\b[a-z_]\w*\b(?!\s*\()/i,
            greedy: !0,
            lookbehind: !0
          },
          {
            pattern: /(\b(?:case|const)\s+)\b[a-z_]\w*(?=\s*[;=])/i,
            greedy: !0,
            lookbehind: !0
          },
          /\b(?:null)\b/i,
          /\b[A-Z_][A-Z0-9_]*\b(?!\s*\()/
        ], We = /\b0b[01]+(?:_[01]+)*\b|\b0o[0-7]+(?:_[0-7]+)*\b|\b0x[\da-f]+(?:_[\da-f]+)*\b|(?:\b\d+(?:_\d+)*\.?(?:\d+(?:_\d+)*)?|\B\.\d+)(?:e[+-]?\d+)?/i, Ae = /<?=>|\?\?=?|\.{3}|\??->|[!=]=?=?|::|\*\*=?|--|\+\+|&&|\|\||<<|>>|[?~]|[/^|%*&<>.+-]=?/, Ke = /[{}\[\](),:;]/;
        Pe.languages.php = {
          delimiter: {
            pattern: /\?>$|^<\?(?:php(?=\s)|=)?/i,
            alias: "important"
          },
          comment: kt,
          variable: /\$+(?:\w+\b|(?=\{))/,
          package: {
            pattern: /(namespace\s+|use\s+(?:function\s+)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
            lookbehind: !0,
            inside: { punctuation: /\\/ }
          },
          "class-name-definition": {
            pattern: /(\b(?:class|enum|interface|trait)\s+)\b[a-z_]\w*(?!\\)\b/i,
            lookbehind: !0,
            alias: "class-name"
          },
          "function-definition": {
            pattern: /(\bfunction\s+)[a-z_]\w*(?=\s*\()/i,
            lookbehind: !0,
            alias: "function"
          },
          keyword: [
            {
              pattern: /(\(\s*)\b(?:array|bool|boolean|float|int|integer|object|string)\b(?=\s*\))/i,
              alias: "type-casting",
              greedy: !0,
              lookbehind: !0
            },
            {
              pattern: /([(,?]\s*)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|object|self|static|string)\b(?=\s*\$)/i,
              alias: "type-hint",
              greedy: !0,
              lookbehind: !0
            },
            {
              pattern: /(\)\s*:\s*(?:\?\s*)?)\b(?:array(?!\s*\()|bool|callable|(?:false|null)(?=\s*\|)|float|int|iterable|mixed|never|object|self|static|string|void)\b/i,
              alias: "return-type",
              greedy: !0,
              lookbehind: !0
            },
            {
              pattern: /\b(?:array(?!\s*\()|bool|float|int|iterable|mixed|object|string|void)\b/i,
              alias: "type-declaration",
              greedy: !0
            },
            {
              pattern: /(\|\s*)(?:false|null)\b|\b(?:false|null)(?=\s*\|)/i,
              alias: "type-declaration",
              greedy: !0,
              lookbehind: !0
            },
            {
              pattern: /\b(?:parent|self|static)(?=\s*::)/i,
              alias: "static-context",
              greedy: !0
            },
            {
              pattern: /(\byield\s+)from\b/i,
              lookbehind: !0
            },
            /\bclass\b/i,
            {
              pattern: /((?:^|[^\s>:]|(?:^|[^-])>|(?:^|[^:]):)\s*)\b(?:abstract|and|array|as|break|callable|case|catch|clone|const|continue|declare|default|die|do|echo|else|elseif|empty|enddeclare|endfor|endforeach|endif|endswitch|endwhile|enum|eval|exit|extends|final|finally|fn|for|foreach|function|global|goto|if|implements|include|include_once|instanceof|insteadof|interface|isset|list|match|namespace|never|new|or|parent|print|private|protected|public|readonly|require|require_once|return|self|static|switch|throw|trait|try|unset|use|var|while|xor|yield|__halt_compiler)\b/i,
              lookbehind: !0
            }
          ],
          "argument-name": {
            pattern: /([(,]\s*)\b[a-z_]\w*(?=\s*:(?!:))/i,
            lookbehind: !0
          },
          "class-name": [
            {
              pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self|\s+static))\s+|\bcatch\s*\()\b[a-z_]\w*(?!\\)\b/i,
              greedy: !0,
              lookbehind: !0
            },
            {
              pattern: /(\|\s*)\b[a-z_]\w*(?!\\)\b/i,
              greedy: !0,
              lookbehind: !0
            },
            {
              pattern: /\b[a-z_]\w*(?!\\)\b(?=\s*\|)/i,
              greedy: !0
            },
            {
              pattern: /(\|\s*)(?:\\?\b[a-z_]\w*)+\b/i,
              alias: "class-name-fully-qualified",
              greedy: !0,
              lookbehind: !0,
              inside: { punctuation: /\\/ }
            },
            {
              pattern: /(?:\\?\b[a-z_]\w*)+\b(?=\s*\|)/i,
              alias: "class-name-fully-qualified",
              greedy: !0,
              inside: { punctuation: /\\/ }
            },
            {
              pattern: /(\b(?:extends|implements|instanceof|new(?!\s+self\b|\s+static\b))\s+|\bcatch\s*\()(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
              alias: "class-name-fully-qualified",
              greedy: !0,
              lookbehind: !0,
              inside: { punctuation: /\\/ }
            },
            {
              pattern: /\b[a-z_]\w*(?=\s*\$)/i,
              alias: "type-declaration",
              greedy: !0
            },
            {
              pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
              alias: [
                "class-name-fully-qualified",
                "type-declaration"
              ],
              greedy: !0,
              inside: { punctuation: /\\/ }
            },
            {
              pattern: /\b[a-z_]\w*(?=\s*::)/i,
              alias: "static-context",
              greedy: !0
            },
            {
              pattern: /(?:\\?\b[a-z_]\w*)+(?=\s*::)/i,
              alias: [
                "class-name-fully-qualified",
                "static-context"
              ],
              greedy: !0,
              inside: { punctuation: /\\/ }
            },
            {
              pattern: /([(,?]\s*)[a-z_]\w*(?=\s*\$)/i,
              alias: "type-hint",
              greedy: !0,
              lookbehind: !0
            },
            {
              pattern: /([(,?]\s*)(?:\\?\b[a-z_]\w*)+(?=\s*\$)/i,
              alias: [
                "class-name-fully-qualified",
                "type-hint"
              ],
              greedy: !0,
              lookbehind: !0,
              inside: { punctuation: /\\/ }
            },
            {
              pattern: /(\)\s*:\s*(?:\?\s*)?)\b[a-z_]\w*(?!\\)\b/i,
              alias: "return-type",
              greedy: !0,
              lookbehind: !0
            },
            {
              pattern: /(\)\s*:\s*(?:\?\s*)?)(?:\\?\b[a-z_]\w*)+\b(?!\\)/i,
              alias: [
                "class-name-fully-qualified",
                "return-type"
              ],
              greedy: !0,
              lookbehind: !0,
              inside: { punctuation: /\\/ }
            }
          ],
          constant: He,
          function: {
            pattern: /(^|[^\\\w])\\?[a-z_](?:[\w\\]*\w)?(?=\s*\()/i,
            lookbehind: !0,
            inside: { punctuation: /\\/ }
          },
          property: {
            pattern: /(->\s*)\w+/,
            lookbehind: !0
          },
          number: We,
          operator: Ae,
          punctuation: Ke
        };
        var at = {
          pattern: /\{\$(?:\{(?:\{[^{}]+\}|[^{}]+)\}|[^{}])+\}|(^|[^\\{])\$+(?:\w+(?:\[[^\r\n\[\]]+\]|->\w+)?)/,
          lookbehind: !0,
          inside: Pe.languages.php
        }, pt = [
          {
            pattern: /<<<'([^']+)'[\r\n](?:.*[\r\n])*?\1;/,
            alias: "nowdoc-string",
            greedy: !0,
            inside: {
              delimiter: {
                pattern: /^<<<'[^']+'|[a-z_]\w*;$/i,
                alias: "symbol",
                inside: { punctuation: /^<<<'?|[';]$/ }
              }
            }
          },
          {
            pattern: /<<<(?:"([^"]+)"[\r\n](?:.*[\r\n])*?\1;|([a-z_]\w*)[\r\n](?:.*[\r\n])*?\2;)/i,
            alias: "heredoc-string",
            greedy: !0,
            inside: {
              delimiter: {
                pattern: /^<<<(?:"[^"]+"|[a-z_]\w*)|[a-z_]\w*;$/i,
                alias: "symbol",
                inside: { punctuation: /^<<<"?|[";]$/ }
              },
              interpolation: at
            }
          },
          {
            pattern: /`(?:\\[\s\S]|[^\\`])*`/,
            alias: "backtick-quoted-string",
            greedy: !0
          },
          {
            pattern: /'(?:\\[\s\S]|[^\\'])*'/,
            alias: "single-quoted-string",
            greedy: !0
          },
          {
            pattern: /"(?:\\[\s\S]|[^\\"])*"/,
            alias: "double-quoted-string",
            greedy: !0,
            inside: { interpolation: at }
          }
        ];
        Pe.languages.insertBefore("php", "variable", {
          string: pt,
          attribute: {
            pattern: /#\[(?:[^"'\/#]|\/(?![*/])|\/\/.*$|#(?!\[).*$|\/\*(?:[^*]|\*(?!\/))*\*\/|"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*')+\](?=\s*[a-z$#])/im,
            greedy: !0,
            inside: {
              "attribute-content": {
                pattern: /^(#\[)[\s\S]+(?=\]$)/,
                lookbehind: !0,
                inside: {
                  comment: kt,
                  string: pt,
                  "attribute-class-name": [
                    {
                      pattern: /([^:]|^)\b[a-z_]\w*(?!\\)\b/i,
                      alias: "class-name",
                      greedy: !0,
                      lookbehind: !0
                    },
                    {
                      pattern: /([^:]|^)(?:\\?\b[a-z_]\w*)+/i,
                      alias: [
                        "class-name",
                        "class-name-fully-qualified"
                      ],
                      greedy: !0,
                      lookbehind: !0,
                      inside: { punctuation: /\\/ }
                    }
                  ],
                  constant: He,
                  number: We,
                  operator: Ae,
                  punctuation: Ke
                }
              },
              delimiter: {
                pattern: /^#\[|\]$/,
                alias: "punctuation"
              }
            }
          }
        }), Pe.hooks.add("before-tokenize", function(sn) {
          if (!!/<\?/.test(sn.code)) {
            var Ie = /<\?(?:[^"'/#]|\/(?![*/])|("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|(?:\/\/|#(?!\[))(?:[^?\n\r]|\?(?!>))*(?=$|\?>|[\r\n])|#\[|\/\*(?:[^*]|\*(?!\/))*(?:\*\/|$))*?(?:\?>|$)/g;
            Pe.languages["markup-templating"].buildPlaceholders(sn, "php", Ie);
          }
        }), Pe.hooks.add("after-tokenize", function(sn) {
          Pe.languages["markup-templating"].tokenizePlaceholders(sn, "php");
        });
      }(Prism), Prism.languages.python = {
        comment: {
          pattern: /(^|[^\\])#.*/,
          lookbehind: !0,
          greedy: !0
        },
        "string-interpolation": {
          pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
          greedy: !0,
          inside: {
            interpolation: {
              pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
              lookbehind: !0,
              inside: {
                "format-spec": {
                  pattern: /(:)[^:(){}]+(?=\}$)/,
                  lookbehind: !0
                },
                "conversion-option": {
                  pattern: /![sra](?=[:}]$)/,
                  alias: "punctuation"
                },
                rest: null
              }
            },
            string: /[\s\S]+/
          }
        },
        "triple-quoted-string": {
          pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
          greedy: !0,
          alias: "string"
        },
        string: {
          pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
          greedy: !0
        },
        function: {
          pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
          lookbehind: !0
        },
        "class-name": {
          pattern: /(\bclass\s+)\w+/i,
          lookbehind: !0
        },
        decorator: {
          pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
          lookbehind: !0,
          alias: [
            "annotation",
            "punctuation"
          ],
          inside: { punctuation: /\./ }
        },
        keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
        builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
        boolean: /\b(?:False|None|True)\b/,
        number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
        operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
        punctuation: /[{}[\];(),.:]/
      }, Prism.languages.python["string-interpolation"].inside.interpolation.inside.rest = Prism.languages.python, Prism.languages.py = Prism.languages.python, function(Pe) {
        Pe.languages.ruby = Pe.languages.extend("clike", {
          comment: {
            pattern: /#.*|^=begin\s[\s\S]*?^=end/m,
            greedy: !0
          },
          "class-name": {
            pattern: /(\b(?:class|module)\s+|\bcatch\s+\()[\w.\\]+|\b[A-Z_]\w*(?=\s*\.\s*new\b)/,
            lookbehind: !0,
            inside: { punctuation: /[.\\]/ }
          },
          keyword: /\b(?:BEGIN|END|alias|and|begin|break|case|class|def|define_method|defined|do|each|else|elsif|end|ensure|extend|for|if|in|include|module|new|next|nil|not|or|prepend|private|protected|public|raise|redo|require|rescue|retry|return|self|super|then|throw|undef|unless|until|when|while|yield)\b/,
          operator: /\.{2,3}|&\.|===|<?=>|[!=]?~|(?:&&|\|\||<<|>>|\*\*|[+\-*/%<>!^&|=])=?|[?:]/,
          punctuation: /[(){}[\].,;]/
        }), Pe.languages.insertBefore("ruby", "operator", {
          "double-colon": {
            pattern: /::/,
            alias: "punctuation"
          }
        });
        var kt = {
          pattern: /((?:^|[^\\])(?:\\{2})*)#\{(?:[^{}]|\{[^{}]*\})*\}/,
          lookbehind: !0,
          inside: {
            content: {
              pattern: /^(#\{)[\s\S]+(?=\}$)/,
              lookbehind: !0,
              inside: Pe.languages.ruby
            },
            delimiter: {
              pattern: /^#\{|\}$/,
              alias: "punctuation"
            }
          }
        };
        delete Pe.languages.ruby.function;
        var He = "(?:" + [
          /([^a-zA-Z0-9\s{(\[<=])(?:(?!\1)[^\\]|\\[\s\S])*\1/.source,
          /\((?:[^()\\]|\\[\s\S]|\((?:[^()\\]|\\[\s\S])*\))*\)/.source,
          /\{(?:[^{}\\]|\\[\s\S]|\{(?:[^{}\\]|\\[\s\S])*\})*\}/.source,
          /\[(?:[^\[\]\\]|\\[\s\S]|\[(?:[^\[\]\\]|\\[\s\S])*\])*\]/.source,
          /<(?:[^<>\\]|\\[\s\S]|<(?:[^<>\\]|\\[\s\S])*>)*>/.source
        ].join("|") + ")", We = /(?:"(?:\\.|[^"\\\r\n])*"|(?:\b[a-zA-Z_]\w*|[^\s\0-\x7F]+)[?!]?|\$.)/.source;
        Pe.languages.insertBefore("ruby", "keyword", {
          "regex-literal": [
            {
              pattern: RegExp(/%r/.source + He + /[egimnosux]{0,6}/.source),
              greedy: !0,
              inside: {
                interpolation: kt,
                regex: /[\s\S]+/
              }
            },
            {
              pattern: /(^|[^/])\/(?!\/)(?:\[[^\r\n\]]+\]|\\.|[^[/\\\r\n])+\/[egimnosux]{0,6}(?=\s*(?:$|[\r\n,.;})#]))/,
              lookbehind: !0,
              greedy: !0,
              inside: {
                interpolation: kt,
                regex: /[\s\S]+/
              }
            }
          ],
          variable: /[@$]+[a-zA-Z_]\w*(?:[?!]|\b)/,
          symbol: [
            {
              pattern: RegExp(/(^|[^:]):/.source + We),
              lookbehind: !0,
              greedy: !0
            },
            {
              pattern: RegExp(/([\r\n{(,][ \t]*)/.source + We + /(?=:(?!:))/.source),
              lookbehind: !0,
              greedy: !0
            }
          ],
          "method-definition": {
            pattern: /(\bdef\s+)\w+(?:\s*\.\s*\w+)?/,
            lookbehind: !0,
            inside: {
              function: /\b\w+$/,
              keyword: /^self\b/,
              "class-name": /^\w+/,
              punctuation: /\./
            }
          }
        }), Pe.languages.insertBefore("ruby", "string", {
          "string-literal": [
            {
              pattern: RegExp(/%[qQiIwWs]?/.source + He),
              greedy: !0,
              inside: {
                interpolation: kt,
                string: /[\s\S]+/
              }
            },
            {
              pattern: /("|')(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|(?!\1)[^\\#\r\n])*\1/,
              greedy: !0,
              inside: {
                interpolation: kt,
                string: /[\s\S]+/
              }
            },
            {
              pattern: /<<[-~]?([a-z_]\w*)[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
              alias: "heredoc-string",
              greedy: !0,
              inside: {
                delimiter: {
                  pattern: /^<<[-~]?[a-z_]\w*|\b[a-z_]\w*$/i,
                  inside: {
                    symbol: /\b\w+/,
                    punctuation: /^<<[-~]?/
                  }
                },
                interpolation: kt,
                string: /[\s\S]+/
              }
            },
            {
              pattern: /<<[-~]?'([a-z_]\w*)'[\r\n](?:.*[\r\n])*?[\t ]*\1/i,
              alias: "heredoc-string",
              greedy: !0,
              inside: {
                delimiter: {
                  pattern: /^<<[-~]?'[a-z_]\w*'|\b[a-z_]\w*$/i,
                  inside: {
                    symbol: /\b\w+/,
                    punctuation: /^<<[-~]?'|'$/
                  }
                },
                string: /[\s\S]+/
              }
            }
          ],
          "command-literal": [
            {
              pattern: RegExp(/%x/.source + He),
              greedy: !0,
              inside: {
                interpolation: kt,
                command: {
                  pattern: /[\s\S]+/,
                  alias: "string"
                }
              }
            },
            {
              pattern: /`(?:#\{[^}]+\}|#(?!\{)|\\(?:\r\n|[\s\S])|[^\\`#\r\n])*`/,
              greedy: !0,
              inside: {
                interpolation: kt,
                command: {
                  pattern: /[\s\S]+/,
                  alias: "string"
                }
              }
            }
          ]
        }), delete Pe.languages.ruby.string, Pe.languages.insertBefore("ruby", "number", {
          builtin: /\b(?:Array|Bignum|Binding|Class|Continuation|Dir|Exception|FalseClass|File|Fixnum|Float|Hash|IO|Integer|MatchData|Method|Module|NilClass|Numeric|Object|Proc|Range|Regexp|Stat|String|Struct|Symbol|TMS|Thread|ThreadGroup|Time|TrueClass)\b/,
          constant: /\b[A-Z][A-Z0-9_]*(?:[?!]|\b)/
        }), Pe.languages.rb = Pe.languages.ruby;
      }(Prism);
      var tr = se.exports, _t = { boltExport: tr };
      return _t;
    });
    var Tt = window.Prism;
    return window.Prism = dt, Tt;
  })(void 0, ht, ie);
  var De = ie.exports.boltExport, Pt = function(je) {
    return je.getParam("codesample_languages");
  }, Ct = function(je) {
    return je.getParam("codesample_global_prismjs", !1, "boolean");
  }, Be = function(je) {
    return ze.Prism && Ct(je) ? ze.Prism : De;
  }, ge = function(je) {
    var Me = je.selection ? je.selection.getNode() : null;
    return J(ee(Me), Me);
  }, xe = function(je, Me, Je) {
    je.undoManager.transact(function() {
      var Lt = ge(je);
      return Je = ue.DOM.encode(Je), Lt.fold(function() {
        je.insertContent('<pre id="__new" class="language-' + Me + '">' + Je + "</pre>"), je.selection.select(je.$("#__new").removeAttr("id")[0]);
      }, function(dt) {
        je.dom.setAttrib(dt, "class", "language-" + Me), dt.innerHTML = Je, Be(je).highlightElement(dt), je.selection.select(dt);
      });
    });
  }, _e = function(je) {
    var Me = ge(je);
    return Me.fold(w(""), function(Je) {
      return Je.textContent;
    });
  }, $ = function(je) {
    var Me = [
      {
        text: "HTML/XML",
        value: "markup"
      },
      {
        text: "JavaScript",
        value: "javascript"
      },
      {
        text: "CSS",
        value: "css"
      },
      {
        text: "PHP",
        value: "php"
      },
      {
        text: "Ruby",
        value: "ruby"
      },
      {
        text: "Python",
        value: "python"
      },
      {
        text: "Java",
        value: "java"
      },
      {
        text: "C",
        value: "c"
      },
      {
        text: "C#",
        value: "csharp"
      },
      {
        text: "C++",
        value: "cpp"
      }
    ], Je = Pt(je);
    return Je || Me;
  }, N = function(je, Me) {
    var Je = ge(je);
    return Je.fold(function() {
      return Me;
    }, function(Lt) {
      var dt = Lt.className.match(/language-(\w+)/);
      return dt ? dt[1] : Me;
    });
  }, ae = function(je) {
    var Me = $(je), Je = D(Me).fold(w(""), function(Tt) {
      return Tt.value;
    }), Lt = N(je, Je), dt = _e(je);
    je.windowManager.open({
      title: "Insert/Edit Code Sample",
      size: "large",
      body: {
        type: "panel",
        items: [
          {
            type: "selectbox",
            name: "language",
            label: "Language",
            items: Me
          },
          {
            type: "textarea",
            name: "code",
            label: "Code view"
          }
        ]
      },
      buttons: [
        {
          type: "cancel",
          name: "cancel",
          text: "Cancel"
        },
        {
          type: "submit",
          name: "save",
          text: "Save",
          primary: !0
        }
      ],
      initialData: {
        language: Lt,
        code: dt
      },
      onSubmit: function(Tt) {
        var Jt = Tt.getData();
        xe(je, Jt.language, Jt.code), Tt.close();
      }
    });
  }, ce = function(je) {
    je.addCommand("codesample", function() {
      var Me = je.selection.getNode();
      je.selection.isCollapsed() || ee(Me) ? ae(je) : je.formatter.toggle("code");
    });
  }, ne = function(je) {
    var Me = je.$;
    je.on("PreProcess", function(Je) {
      Me("pre[contenteditable=false]", Je.node).filter(Ge(ee)).each(function(Lt, dt) {
        var Tt = Me(dt), Jt = dt.textContent;
        Tt.attr("class", Me.trim(Tt.attr("class"))), Tt.removeAttr("contentEditable"), Tt.empty().append(Me("<code></code>").each(function() {
          this.textContent = Jt;
        }));
      });
    }), je.on("SetContent", function() {
      var Je = Me("pre").filter(Ge(ee)).filter(function(Lt, dt) {
        return dt.contentEditable !== "false";
      });
      Je.length && je.undoManager.transact(function() {
        Je.each(function(Lt, dt) {
          Me(dt).find("br").each(function(Tt, Jt) {
            Jt.parentNode.replaceChild(je.getDoc().createTextNode(`
`), Jt);
          }), dt.contentEditable = "false", dt.innerHTML = je.dom.encode(dt.textContent), Be(je).highlightElement(dt), dt.className = Me.trim(dt.className);
        });
      });
    });
  }, Ce = function(je) {
    var Me = je.selection.getStart();
    return je.dom.is(Me, 'pre[class*="language-"]');
  }, Te = function(je) {
    var Me = function() {
      return je.execCommand("codesample");
    };
    je.ui.registry.addToggleButton("codesample", {
      icon: "code-sample",
      tooltip: "Insert/edit code sample",
      onAction: Me,
      onSetup: function(Je) {
        var Lt = function() {
          Je.setActive(Ce(je));
        };
        return je.on("NodeChange", Lt), function() {
          return je.off("NodeChange", Lt);
        };
      }
    }), je.ui.registry.addMenuItem("codesample", {
      text: "Code sample...",
      icon: "code-sample",
      onAction: Me
    });
  };
  function _() {
    m.add("codesample", function(je) {
      ne(je), Te(je), ce(je), je.on("dblclick", function(Me) {
        ee(Me.target) && ae(je);
      });
    });
  }
  _();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(yt) {
    var mn = typeof yt;
    return yt === null ? "null" : mn === "object" && (Array.prototype.isPrototypeOf(yt) || yt.constructor && yt.constructor.name === "Array") ? "array" : mn === "object" && (String.prototype.isPrototypeOf(yt) || yt.constructor && yt.constructor.name === "String") ? "string" : mn;
  }, w = function(yt) {
    return function(mn) {
      return y(mn) === yt;
    };
  }, E = function(yt) {
    return function(mn) {
      return typeof mn === yt;
    };
  }, P = w("string"), H = E("boolean"), X = function(yt) {
    return yt == null;
  }, j = function(yt) {
    return !X(yt);
  }, le = E("function"), Q = E("number"), pe = function() {
  }, Y = function(yt, mn) {
    return function(zn) {
      return yt(mn(zn));
    };
  }, D = function(yt) {
    return function() {
      return yt;
    };
  }, J = function(yt) {
    return yt;
  }, ue = D(!1), ee = D(!0), Ge = function() {
    return ze;
  }, ze = function() {
    var yt = function(_n) {
      return _n();
    }, mn = J, zn = {
      fold: function(_n, Kr) {
        return _n();
      },
      isSome: ue,
      isNone: ee,
      getOr: mn,
      getOrThunk: yt,
      getOrDie: function(_n) {
        throw new Error(_n || "error: getOrDie called on none.");
      },
      getOrNull: D(null),
      getOrUndefined: D(void 0),
      or: mn,
      orThunk: yt,
      map: Ge,
      each: pe,
      bind: Ge,
      exists: ue,
      forall: ee,
      filter: function() {
        return Ge();
      },
      toArray: function() {
        return [];
      },
      toString: D("none()")
    };
    return zn;
  }(), ht = function(yt) {
    var mn = D(yt), zn = function() {
      return Kr;
    }, _n = function(ot) {
      return ot(yt);
    }, Kr = {
      fold: function(ot, Yt) {
        return Yt(yt);
      },
      isSome: ee,
      isNone: ue,
      getOr: mn,
      getOrThunk: mn,
      getOrDie: mn,
      getOrNull: mn,
      getOrUndefined: mn,
      or: zn,
      orThunk: zn,
      map: function(ot) {
        return ht(ot(yt));
      },
      each: function(ot) {
        ot(yt);
      },
      bind: _n,
      exists: _n,
      forall: _n,
      filter: function(ot) {
        return ot(yt) ? Kr : ze;
      },
      toArray: function() {
        return [yt];
      },
      toString: function() {
        return "some(" + yt + ")";
      }
    };
    return Kr;
  }, ie = function(yt) {
    return yt == null ? ze : ht(yt);
  }, Ze = {
    some: ht,
    none: Ge,
    from: ie
  }, De = function(yt, mn) {
    for (var zn = yt.length, _n = new Array(zn), Kr = 0; Kr < zn; Kr++) {
      var ot = yt[Kr];
      _n[Kr] = mn(ot, Kr);
    }
    return _n;
  }, Pt = function(yt, mn) {
    for (var zn = 0, _n = yt.length; zn < _n; zn++) {
      var Kr = yt[zn];
      mn(Kr, zn);
    }
  }, Ct = function(yt, mn) {
    for (var zn = [], _n = 0, Kr = yt.length; _n < Kr; _n++) {
      var ot = yt[_n];
      mn(ot, _n) && zn.push(ot);
    }
    return zn;
  }, Be = 9, ge = 11, xe = 1, _e = 3, $ = function(yt, mn) {
    var zn = mn || document, _n = zn.createElement("div");
    if (_n.innerHTML = yt, !_n.hasChildNodes() || _n.childNodes.length > 1)
      throw console.error("HTML does not have a single root node", yt), new Error("HTML must have a single root node");
    return ce(_n.childNodes[0]);
  }, N = function(yt, mn) {
    var zn = mn || document, _n = zn.createElement(yt);
    return ce(_n);
  }, ae = function(yt, mn) {
    var zn = mn || document, _n = zn.createTextNode(yt);
    return ce(_n);
  }, ce = function(yt) {
    if (yt == null)
      throw new Error("Node cannot be null or undefined");
    return { dom: yt };
  }, ne = function(yt, mn, zn) {
    return Ze.from(yt.dom.elementFromPoint(mn, zn)).map(ce);
  }, Ce = {
    fromHtml: $,
    fromTag: N,
    fromText: ae,
    fromDom: ce,
    fromPoint: ne
  }, Te = function(yt, mn) {
    var zn = yt.dom;
    if (zn.nodeType !== xe)
      return !1;
    var _n = zn;
    if (_n.matches !== void 0)
      return _n.matches(mn);
    if (_n.msMatchesSelector !== void 0)
      return _n.msMatchesSelector(mn);
    if (_n.webkitMatchesSelector !== void 0)
      return _n.webkitMatchesSelector(mn);
    if (_n.mozMatchesSelector !== void 0)
      return _n.mozMatchesSelector(mn);
    throw new Error("Browser lacks native selectors");
  };
  typeof window < "u" || Function("return this;")();
  var _ = function(yt) {
    var mn = yt.dom.nodeName;
    return mn.toLowerCase();
  }, je = function(yt) {
    return yt.dom.nodeType;
  }, Me = function(yt) {
    return function(mn) {
      return je(mn) === yt;
    };
  }, Je = Me(xe), Lt = Me(_e), dt = Me(Be), Tt = Me(ge), Jt = function(yt) {
    return function(mn) {
      return Je(mn) && _(mn) === yt;
    };
  }, se = function(yt) {
    return Ce.fromDom(yt.dom.ownerDocument);
  }, tr = function(yt) {
    return dt(yt) ? yt : se(yt);
  }, _t = function(yt) {
    return Ze.from(yt.dom.parentNode).map(Ce.fromDom);
  }, Pe = function(yt) {
    return De(yt.dom.childNodes, Ce.fromDom);
  }, kt = function(yt, mn, zn) {
    if (P(zn) || H(zn) || Q(zn))
      yt.setAttribute(mn, zn + "");
    else
      throw console.error("Invalid call to Attribute.set. Key ", mn, ":: Value ", zn, ":: Element ", yt), new Error("Attribute value was not simple");
  }, He = function(yt, mn, zn) {
    kt(yt.dom, mn, zn);
  }, We = function(yt, mn) {
    yt.dom.removeAttribute(mn);
  }, Ae = function(yt) {
    return Tt(yt) && j(yt.dom.host);
  }, Ke = le(Element.prototype.attachShadow) && le(Node.prototype.getRootNode), at = Ke ? function(yt) {
    return Ce.fromDom(yt.dom.getRootNode());
  } : tr, pt = function(yt) {
    var mn = at(yt);
    return Ae(mn) ? Ze.some(mn) : Ze.none();
  }, sn = function(yt) {
    return Ce.fromDom(yt.dom.host);
  }, Ie = function(yt) {
    var mn = Lt(yt) ? yt.dom.parentNode : yt.dom;
    if (mn == null || mn.ownerDocument === null)
      return !1;
    var zn = mn.ownerDocument;
    return pt(Ce.fromDom(mn)).fold(function() {
      return zn.body.contains(mn);
    }, Y(Ie, sn));
  }, St = function(yt, mn, zn) {
    for (var _n = yt.dom, Kr = le(zn) ? zn : ue; _n.parentNode; ) {
      _n = _n.parentNode;
      var ot = Ce.fromDom(_n);
      if (mn(ot))
        return Ze.some(ot);
      if (Kr(ot))
        break;
    }
    return Ze.none();
  }, Xe = function(yt, mn, zn) {
    return St(yt, function(_n) {
      return Te(_n, mn);
    }, zn);
  }, he = function(yt) {
    return yt.style !== void 0 && le(yt.style.getPropertyValue);
  }, tt = function(yt, mn) {
    var zn = yt.dom, _n = window.getComputedStyle(zn), Kr = _n.getPropertyValue(mn);
    return Kr === "" && !Ie(yt) ? gt(zn, mn) : Kr;
  }, gt = function(yt, mn) {
    return he(yt) ? yt.style.getPropertyValue(mn) : "";
  }, Ye = function(yt) {
    return tt(yt, "direction") === "rtl" ? "rtl" : "ltr";
  }, Qt = function(yt, mn) {
    return Ct(Pe(yt), mn);
  }, In = function(yt, mn) {
    return Qt(yt, function(zn) {
      return Te(zn, mn);
    });
  }, It = function(yt) {
    return _t(yt).filter(Je);
  }, qt = function(yt, mn) {
    var zn = mn ? Xe(yt, "ol,ul") : Ze.some(yt);
    return zn.getOr(yt);
  }, Vt = Jt("li"), Xt = function(yt, mn) {
    var zn = yt.selection.getSelectedBlocks();
    zn.length > 0 && (Pt(zn, function(_n) {
      var Kr = Ce.fromDom(_n), ot = Vt(Kr), Yt = qt(Kr, ot), Ft = It(Yt);
      Ft.each(function(yn) {
        var Yn = Ye(yn);
        if (Yn !== mn ? He(Yt, "dir", mn) : Ye(Yt) !== mn && We(Yt, "dir"), ot) {
          var Ir = In(Yt, "li[dir]");
          Pt(Ir, function(Wa) {
            return We(Wa, "dir");
          });
        }
      });
    }), yt.nodeChanged());
  }, on = function(yt) {
    yt.addCommand("mceDirectionLTR", function() {
      Xt(yt, "ltr");
    }), yt.addCommand("mceDirectionRTL", function() {
      Xt(yt, "rtl");
    });
  }, Vn = function(yt, mn) {
    return function(zn) {
      var _n = function(Kr) {
        var ot = Ce.fromDom(Kr.element);
        zn.setActive(Ye(ot) === mn);
      };
      return yt.on("NodeChange", _n), function() {
        return yt.off("NodeChange", _n);
      };
    };
  }, Un = function(yt) {
    yt.ui.registry.addToggleButton("ltr", {
      tooltip: "Left to right",
      icon: "ltr",
      onAction: function() {
        return yt.execCommand("mceDirectionLTR");
      },
      onSetup: Vn(yt, "ltr")
    }), yt.ui.registry.addToggleButton("rtl", {
      tooltip: "Right to left",
      icon: "rtl",
      onAction: function() {
        return yt.execCommand("mceDirectionRTL");
      },
      onSetup: Vn(yt, "rtl")
    });
  };
  function Tn() {
    m.add("directionality", function(yt) {
      on(yt), Un(yt);
    });
  }
  Tn();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(Xe) {
    return function(he) {
      return Xe === he;
    };
  }, w = y(null), E = function() {
  }, P = function(Xe) {
    return function() {
      return Xe;
    };
  }, H = function(Xe) {
    return Xe;
  }, X = P(!1), j = P(!0), le = function() {
    return Q;
  }, Q = function() {
    var Xe = function(gt) {
      return gt();
    }, he = H, tt = {
      fold: function(gt, Ye) {
        return gt();
      },
      isSome: X,
      isNone: j,
      getOr: he,
      getOrThunk: Xe,
      getOrDie: function(gt) {
        throw new Error(gt || "error: getOrDie called on none.");
      },
      getOrNull: P(null),
      getOrUndefined: P(void 0),
      or: he,
      orThunk: Xe,
      map: le,
      each: E,
      bind: le,
      exists: X,
      forall: j,
      filter: function() {
        return le();
      },
      toArray: function() {
        return [];
      },
      toString: P("none()")
    };
    return tt;
  }(), pe = function(Xe) {
    var he = P(Xe), tt = function() {
      return Ye;
    }, gt = function(Qt) {
      return Qt(Xe);
    }, Ye = {
      fold: function(Qt, In) {
        return In(Xe);
      },
      isSome: j,
      isNone: X,
      getOr: he,
      getOrThunk: he,
      getOrDie: he,
      getOrNull: he,
      getOrUndefined: he,
      or: tt,
      orThunk: tt,
      map: function(Qt) {
        return pe(Qt(Xe));
      },
      each: function(Qt) {
        Qt(Xe);
      },
      bind: gt,
      exists: gt,
      forall: gt,
      filter: function(Qt) {
        return Qt(Xe) ? Ye : Q;
      },
      toArray: function() {
        return [Xe];
      },
      toString: function() {
        return "some(" + Xe + ")";
      }
    };
    return Ye;
  }, Y = function(Xe) {
    return Xe == null ? Q : pe(Xe);
  }, D = {
    some: pe,
    none: le,
    from: Y
  }, J = function(Xe, he) {
    for (var tt = 0, gt = Xe.length; tt < gt; tt++) {
      var Ye = Xe[tt];
      if (he(Ye, tt))
        return !0;
    }
    return !1;
  }, ue = function(Xe, he) {
    for (var tt = Xe.length, gt = new Array(tt), Ye = 0; Ye < tt; Ye++) {
      var Qt = Xe[Ye];
      gt[Ye] = he(Qt, Ye);
    }
    return gt;
  }, ee = function(Xe, he) {
    for (var tt = 0, gt = Xe.length; tt < gt; tt++) {
      var Ye = Xe[tt];
      he(Ye, tt);
    }
  }, Ge = function(Xe) {
    var he = Xe, tt = function() {
      return he;
    }, gt = function(Ye) {
      he = Ye;
    };
    return {
      get: tt,
      set: gt
    };
  }, ze = function(Xe, he) {
    var tt = null, gt = function() {
      w(tt) || (clearTimeout(tt), tt = null);
    }, Ye = function() {
      for (var Qt = [], In = 0; In < arguments.length; In++)
        Qt[In] = arguments[In];
      gt(), tt = setTimeout(function() {
        tt = null, Xe.apply(null, Qt);
      }, he);
    };
    return {
      cancel: gt,
      throttle: Ye
    };
  }, ht = function(Xe, he) {
    Xe.insertContent(he);
  }, ie = function() {
    return ie = Object.assign || function(he) {
      for (var tt, gt = 1, Ye = arguments.length; gt < Ye; gt++) {
        tt = arguments[gt];
        for (var Qt in tt)
          Object.prototype.hasOwnProperty.call(tt, Qt) && (he[Qt] = tt[Qt]);
      }
      return he;
    }, ie.apply(this, arguments);
  }, Ze = Object.keys, De = Object.hasOwnProperty, Pt = function(Xe, he) {
    for (var tt = Ze(Xe), gt = 0, Ye = tt.length; gt < Ye; gt++) {
      var Qt = tt[gt], In = Xe[Qt];
      he(In, Qt);
    }
  }, Ct = function(Xe, he) {
    return Be(Xe, function(tt, gt) {
      return {
        k: gt,
        v: he(tt, gt)
      };
    });
  }, Be = function(Xe, he) {
    var tt = {};
    return Pt(Xe, function(gt, Ye) {
      var Qt = he(gt, Ye);
      tt[Qt.k] = Qt.v;
    }), tt;
  }, ge = function(Xe, he) {
    return De.call(Xe, he);
  }, xe = function(Xe, he) {
    return he;
  }, _e = function(Xe) {
    return function() {
      for (var he = [], tt = 0; tt < arguments.length; tt++)
        he[tt] = arguments[tt];
      if (he.length === 0)
        throw new Error("Can't merge zero objects");
      for (var gt = {}, Ye = 0; Ye < he.length; Ye++) {
        var Qt = he[Ye];
        for (var In in Qt)
          ge(Qt, In) && (gt[In] = Xe(gt[In], Qt[In]));
      }
      return gt;
    };
  }, $ = _e(xe), N = function(Xe) {
    var he = Ge(D.none()), tt = function() {
      return he.get().each(Xe);
    }, gt = function() {
      tt(), he.set(D.none());
    }, Ye = function() {
      return he.get().isSome();
    }, Qt = function() {
      return he.get();
    }, In = function(It) {
      tt(), he.set(D.some(It));
    };
    return {
      clear: gt,
      isSet: Ye,
      get: Qt,
      set: In
    };
  }, ae = function() {
    var Xe = N(E), he = function(tt) {
      return Xe.get().each(tt);
    };
    return ie(ie({}, Xe), { on: he });
  }, ce = function(Xe, he, tt) {
    return he === "" || Xe.length >= he.length && Xe.substr(tt, tt + he.length) === he;
  }, ne = function(Xe, he) {
    return Xe.indexOf(he) !== -1;
  }, Ce = function(Xe, he) {
    return ce(Xe, he, 0);
  }, Te = tinymce.util.Tools.resolve("tinymce.Resource"), _ = tinymce.util.Tools.resolve("tinymce.util.Delay"), je = tinymce.util.Tools.resolve("tinymce.util.Promise"), Me = "tinymce.plugins.emoticons", Je = function(Xe) {
    return Xe.getParam("emoticons_database", "emojis", "string");
  }, Lt = function(Xe, he) {
    var tt = Je(Xe);
    return Xe.getParam("emoticons_database_url", he + "/js/" + tt + Xe.suffix + ".js", "string");
  }, dt = function(Xe) {
    return Xe.getParam("emoticons_database_id", Me, "string");
  }, Tt = function(Xe) {
    return Xe.getParam("emoticons_append", {}, "object");
  }, Jt = function(Xe) {
    return Xe.getParam("emoticons_images_url", "https://twemoji.maxcdn.com/v/13.0.1/72x72/", "string");
  }, se = "All", tr = {
    symbols: "Symbols",
    people: "People",
    animals_and_nature: "Animals and Nature",
    food_and_drink: "Food and Drink",
    activity: "Activity",
    travel_and_places: "Travel and Places",
    objects: "Objects",
    flags: "Flags",
    user: "User Defined"
  }, _t = function(Xe, he) {
    return ge(Xe, he) ? Xe[he] : he;
  }, Pe = function(Xe) {
    var he = Tt(Xe);
    return Ct(he, function(tt) {
      return ie({
        keywords: [],
        category: "user"
      }, tt);
    });
  }, kt = function(Xe, he, tt) {
    var gt = ae(), Ye = ae(), Qt = Jt(Xe), In = function(Un) {
      return Ce(Un.char, "<img") ? Un.char.replace(/src="([^"]+)"/, function(Tn, yt) {
        return 'src="' + Qt + yt + '"';
      }) : Un.char;
    }, It = function(Un) {
      var Tn = {}, yt = [];
      Pt(Un, function(mn, zn) {
        var _n = {
          title: zn,
          keywords: mn.keywords,
          char: In(mn),
          category: _t(tr, mn.category)
        }, Kr = Tn[_n.category] !== void 0 ? Tn[_n.category] : [];
        Tn[_n.category] = Kr.concat([_n]), yt.push(_n);
      }), gt.set(Tn), Ye.set(yt);
    };
    Xe.on("init", function() {
      Te.load(tt, he).then(function(Un) {
        var Tn = Pe(Xe);
        It($(Un, Tn));
      }, function(Un) {
        console.log("Failed to load emoticons: " + Un), gt.set({}), Ye.set([]);
      });
    });
    var qt = function(Un) {
      return Un === se ? Vt() : gt.get().bind(function(Tn) {
        return D.from(Tn[Un]);
      }).getOr([]);
    }, Vt = function() {
      return Ye.get().getOr([]);
    }, Xt = function() {
      return [se].concat(Ze(gt.get().getOr({})));
    }, on = function() {
      return Vn() ? je.resolve(!0) : new je(function(Un, Tn) {
        var yt = 15, mn = _.setInterval(function() {
          Vn() ? (_.clearInterval(mn), Un(!0)) : (yt--, yt < 0 && (console.log("Could not load emojis from url: " + he), _.clearInterval(mn), Tn(!1)));
        }, 100);
      });
    }, Vn = function() {
      return gt.isSet() && Ye.isSet();
    };
    return {
      listCategories: Xt,
      hasLoaded: Vn,
      waitForLoad: on,
      listAll: Vt,
      listCategory: qt
    };
  }, He = function(Xe, he) {
    return ne(Xe.title.toLowerCase(), he) || J(Xe.keywords, function(tt) {
      return ne(tt.toLowerCase(), he);
    });
  }, We = function(Xe, he, tt) {
    for (var gt = [], Ye = he.toLowerCase(), Qt = tt.fold(function() {
      return X;
    }, function(It) {
      return function(qt) {
        return qt >= It;
      };
    }), In = 0; In < Xe.length && !((he.length === 0 || He(Xe[In], Ye)) && (gt.push({
      value: Xe[In].char,
      text: Xe[In].title,
      icon: Xe[In].char
    }), Qt(gt.length))); In++)
      ;
    return gt;
  }, Ae = "pattern", Ke = function(Xe, he) {
    var tt = {
      pattern: "",
      results: We(he.listAll(), "", D.some(300))
    }, gt = Ge(se), Ye = function(Xt) {
      var on = Xt.getData(), Vn = gt.get(), Un = he.listCategory(Vn), Tn = We(Un, on[Ae], Vn === se ? D.some(300) : D.none());
      Xt.setData({ results: Tn });
    }, Qt = ze(function(Xt) {
      Ye(Xt);
    }, 200), In = {
      label: "Search",
      type: "input",
      name: Ae
    }, It = {
      type: "collection",
      name: "results"
    }, qt = function() {
      var Xt = {
        type: "tabpanel",
        tabs: ue(he.listCategories(), function(on) {
          return {
            title: on,
            name: on,
            items: [
              In,
              It
            ]
          };
        })
      };
      return {
        title: "Emoticons",
        size: "normal",
        body: Xt,
        initialData: tt,
        onTabChange: function(on, Vn) {
          gt.set(Vn.newTabName), Qt.throttle(on);
        },
        onChange: Qt.throttle,
        onAction: function(on, Vn) {
          Vn.name === "results" && (ht(Xe, Vn.value), on.close());
        },
        buttons: [{
          type: "cancel",
          text: "Close",
          primary: !0
        }]
      };
    }, Vt = Xe.windowManager.open(qt());
    Vt.focus(Ae), he.hasLoaded() || (Vt.block("Loading emoticons..."), he.waitForLoad().then(function() {
      Vt.redial(qt()), Qt.throttle(Vt), Vt.focus(Ae), Vt.unblock();
    }).catch(function(Xt) {
      Vt.redial({
        title: "Emoticons",
        body: {
          type: "panel",
          items: [{
            type: "alertbanner",
            level: "error",
            icon: "warning",
            text: "<p>Could not load emoticons</p>"
          }]
        },
        buttons: [{
          type: "cancel",
          text: "Close",
          primary: !0
        }],
        initialData: {
          pattern: "",
          results: []
        }
      }), Vt.focus(Ae), Vt.unblock();
    }));
  }, at = function(Xe, he) {
    Xe.addCommand("mceEmoticons", function() {
      return Ke(Xe, he);
    });
  }, pt = function(Xe) {
    Xe.on("PreInit", function() {
      Xe.parser.addAttributeFilter("data-emoticon", function(he) {
        ee(he, function(tt) {
          tt.attr("data-mce-resize", "false"), tt.attr("data-mce-placeholder", "1");
        });
      });
    });
  }, sn = function(Xe, he) {
    Xe.ui.registry.addAutocompleter("emoticons", {
      ch: ":",
      columns: "auto",
      minChars: 2,
      fetch: function(tt, gt) {
        return he.waitForLoad().then(function() {
          var Ye = he.listAll();
          return We(Ye, tt, D.some(gt));
        });
      },
      onAction: function(tt, gt, Ye) {
        Xe.selection.setRng(gt), Xe.insertContent(Ye), tt.hide();
      }
    });
  }, Ie = function(Xe) {
    var he = function() {
      return Xe.execCommand("mceEmoticons");
    };
    Xe.ui.registry.addButton("emoticons", {
      tooltip: "Emoticons",
      icon: "emoji",
      onAction: he
    }), Xe.ui.registry.addMenuItem("emoticons", {
      text: "Emoticons...",
      icon: "emoji",
      onAction: he
    });
  };
  function St() {
    m.add("emoticons", function(Xe, he) {
      var tt = Lt(Xe, he), gt = dt(Xe), Ye = kt(Xe, tt, gt);
      at(Xe, Ye), Ie(Xe), sn(Xe, Ye), pt(Xe);
    });
  }
  St();
})();
(function() {
  var m = function(ce) {
    var ne = ce, Ce = function() {
      return ne;
    }, Te = function(_) {
      ne = _;
    };
    return {
      get: Ce,
      set: Te
    };
  }, y = tinymce.util.Tools.resolve("tinymce.PluginManager"), w = function() {
    return w = Object.assign || function(ne) {
      for (var Ce, Te = 1, _ = arguments.length; Te < _; Te++) {
        Ce = arguments[Te];
        for (var je in Ce)
          Object.prototype.hasOwnProperty.call(Ce, je) && (ne[je] = Ce[je]);
      }
      return ne;
    }, w.apply(this, arguments);
  }, E = tinymce.util.Tools.resolve("tinymce.util.Tools"), P = tinymce.util.Tools.resolve("tinymce.html.DomParser"), H = tinymce.util.Tools.resolve("tinymce.html.Node"), X = tinymce.util.Tools.resolve("tinymce.html.Serializer"), j = function(ce) {
    return ce.getParam("fullpage_hide_in_source_view");
  }, le = function(ce) {
    return ce.getParam("fullpage_default_xml_pi");
  }, Q = function(ce) {
    return ce.getParam("fullpage_default_encoding");
  }, pe = function(ce) {
    return ce.getParam("fullpage_default_font_family");
  }, Y = function(ce) {
    return ce.getParam("fullpage_default_font_size");
  }, D = function(ce) {
    return ce.getParam("fullpage_default_text_color");
  }, J = function(ce) {
    return ce.getParam("fullpage_default_title");
  }, ue = function(ce) {
    return ce.getParam("fullpage_default_doctype", "<!DOCTYPE html>");
  }, ee = function(ce) {
    return ce.getParam("protect");
  }, Ge = function(ce, ne) {
    return P({
      validate: !1,
      root_name: "#document"
    }, ce.schema).parse(ne, { format: "xhtml" });
  }, ze = function(ce, ne) {
    var Ce = Ge(ce, ne), Te = {}, _, je, Me = function(Je, Lt) {
      var dt = Je.attr(Lt);
      return dt || "";
    };
    return Te.fontface = pe(ce), Te.fontsize = Y(ce), _ = Ce.firstChild, _.type === 7 && (Te.xml_pi = !0, je = /encoding="([^"]+)"/.exec(_.value), je && (Te.docencoding = je[1])), _ = Ce.getAll("#doctype")[0], _ && (Te.doctype = "<!DOCTYPE" + _.value + ">"), _ = Ce.getAll("title")[0], _ && _.firstChild && (Te.title = _.firstChild.value), E.each(Ce.getAll("meta"), function(Je) {
      var Lt = Je.attr("name"), dt = Je.attr("http-equiv"), Tt;
      Lt ? Te[Lt.toLowerCase()] = Je.attr("content") : dt === "Content-Type" && (Tt = /charset\s*=\s*(.*)\s*/gi.exec(Je.attr("content")), Tt && (Te.docencoding = Tt[1]));
    }), _ = Ce.getAll("html")[0], _ && (Te.langcode = Me(_, "lang") || Me(_, "xml:lang")), Te.stylesheets = [], E.each(Ce.getAll("link"), function(Je) {
      Je.attr("rel") === "stylesheet" && Te.stylesheets.push(Je.attr("href"));
    }), _ = Ce.getAll("body")[0], _ && (Te.langdir = Me(_, "dir"), Te.style = Me(_, "style"), Te.visited_color = Me(_, "vlink"), Te.link_color = Me(_, "link"), Te.active_color = Me(_, "alink")), Te;
  }, ht = function(ce, ne, Ce) {
    var Te, _, je = ce.dom, Me = function(se, tr, _t) {
      se.attr(tr, _t || void 0);
    }, Je = function(se) {
      Te.firstChild ? Te.insert(se, Te.firstChild) : Te.append(se);
    }, Lt = Ge(ce, Ce);
    if (Te = Lt.getAll("head")[0], Te || (_ = Lt.getAll("html")[0], Te = new H("head", 1), _.firstChild ? _.insert(Te, _.firstChild, !0) : _.append(Te)), _ = Lt.firstChild, ne.xml_pi) {
      var dt = 'version="1.0"';
      ne.docencoding && (dt += ' encoding="' + ne.docencoding + '"'), _.type !== 7 && (_ = new H("xml", 7), Lt.insert(_, Lt.firstChild, !0)), _.value = dt;
    } else
      _ && _.type === 7 && _.remove();
    _ = Lt.getAll("#doctype")[0], ne.doctype ? (_ || (_ = new H("#doctype", 10), ne.xml_pi ? Lt.insert(_, Lt.firstChild) : Je(_)), _.value = ne.doctype.substring(9, ne.doctype.length - 1)) : _ && _.remove(), _ = null, E.each(Lt.getAll("meta"), function(se) {
      se.attr("http-equiv") === "Content-Type" && (_ = se);
    }), ne.docencoding ? (_ || (_ = new H("meta", 1), _.attr("http-equiv", "Content-Type"), _.shortEnded = !0, Je(_)), _.attr("content", "text/html; charset=" + ne.docencoding)) : _ && _.remove(), _ = Lt.getAll("title")[0], ne.title ? (_ ? _.empty() : (_ = new H("title", 1), Je(_)), _.append(new H("#text", 3)).value = ne.title) : _ && _.remove(), E.each("keywords,description,author,copyright,robots".split(","), function(se) {
      var tr = Lt.getAll("meta"), _t, Pe, kt = ne[se];
      for (_t = 0; _t < tr.length; _t++)
        if (Pe = tr[_t], Pe.attr("name") === se) {
          kt ? Pe.attr("content", kt) : Pe.remove();
          return;
        }
      kt && (_ = new H("meta", 1), _.attr("name", se), _.attr("content", kt), _.shortEnded = !0, Je(_));
    });
    var Tt = {};
    E.each(Lt.getAll("link"), function(se) {
      se.attr("rel") === "stylesheet" && (Tt[se.attr("href")] = se);
    }), E.each(ne.stylesheets, function(se) {
      Tt[se] || (_ = new H("link", 1), _.attr({
        rel: "stylesheet",
        text: "text/css",
        href: se
      }), _.shortEnded = !0, Je(_)), delete Tt[se];
    }), E.each(Tt, function(se) {
      se.remove();
    }), _ = Lt.getAll("body")[0], _ && (Me(_, "dir", ne.langdir), Me(_, "style", ne.style), Me(_, "vlink", ne.visited_color), Me(_, "link", ne.link_color), Me(_, "alink", ne.active_color), je.setAttribs(ce.getBody(), {
      style: ne.style,
      dir: ne.dir,
      vLink: ne.visited_color,
      link: ne.link_color,
      aLink: ne.active_color
    })), _ = Lt.getAll("html")[0], _ && (Me(_, "lang", ne.langcode), Me(_, "xml:lang", ne.langcode)), Te.firstChild || Te.remove();
    var Jt = X({
      validate: !1,
      indent: !0,
      indent_before: "head,html,body,meta,title,script,link,style",
      indent_after: "head,html,body,meta,title,script,link,style"
    }).serialize(Lt);
    return Jt.substring(0, Jt.indexOf("</body>"));
  }, ie = function(ce, ne) {
    var Ce = ze(ce, ne.get()), Te = {
      title: "",
      keywords: "",
      description: "",
      robots: "",
      author: "",
      docencoding: ""
    }, _ = w(w({}, Te), Ce);
    ce.windowManager.open({
      title: "Metadata and Document Properties",
      size: "normal",
      body: {
        type: "panel",
        items: [
          {
            name: "title",
            type: "input",
            label: "Title"
          },
          {
            name: "keywords",
            type: "input",
            label: "Keywords"
          },
          {
            name: "description",
            type: "input",
            label: "Description"
          },
          {
            name: "robots",
            type: "input",
            label: "Robots"
          },
          {
            name: "author",
            type: "input",
            label: "Author"
          },
          {
            name: "docencoding",
            type: "input",
            label: "Encoding"
          }
        ]
      },
      buttons: [
        {
          type: "cancel",
          name: "cancel",
          text: "Cancel"
        },
        {
          type: "submit",
          name: "save",
          text: "Save",
          primary: !0
        }
      ],
      initialData: _,
      onSubmit: function(je) {
        var Me = je.getData(), Je = ht(ce, E.extend(Ce, Me), ne.get());
        ne.set(Je), je.close();
      }
    });
  }, Ze = function(ce, ne) {
    ce.addCommand("mceFullPageProperties", function() {
      ie(ce, ne);
    });
  }, De = function(ce, ne) {
    return E.each(ce, function(Ce) {
      ne = ne.replace(Ce, function(Te) {
        return "<!--mce:protected " + escape(Te) + "-->";
      });
    }), ne;
  }, Pt = function(ce) {
    return ce.replace(/<!--mce:protected ([\s\S]*?)-->/g, function(ne, Ce) {
      return unescape(Ce);
    });
  }, Ct = E.each, Be = function(ce) {
    return ce.replace(/<\/?[A-Z]+/g, function(ne) {
      return ne.toLowerCase();
    });
  }, ge = function(ce, ne, Ce, Te) {
    var _, je, Me, Je = "", Lt = ce.dom;
    if (!Te.selection && (Me = De(ee(ce), Te.content), !(Te.format === "raw" && ne.get()) && !(Te.source_view && j(ce)))) {
      Me.length === 0 && !Te.source_view && (Me = E.trim(ne.get()) + `
` + E.trim(Me) + `
` + E.trim(Ce.get())), Me = Me.replace(/<(\/?)BODY/gi, "<$1body"), _ = Me.indexOf("<body"), _ !== -1 ? (_ = Me.indexOf(">", _), ne.set(Be(Me.substring(0, _ + 1))), je = Me.indexOf("</body", _), je === -1 && (je = Me.length), Te.content = E.trim(Me.substring(_ + 1, je)), Ce.set(Be(Me.substring(je)))) : (ne.set(xe(ce)), Ce.set(`
</body>
</html>`));
      var dt = Ge(ce, ne.get());
      Ct(dt.getAll("style"), function(_t) {
        _t.firstChild && (Je += _t.firstChild.value);
      });
      var Tt = dt.getAll("body")[0];
      Tt && Lt.setAttribs(ce.getBody(), {
        style: Tt.attr("style") || "",
        dir: Tt.attr("dir") || "",
        vLink: Tt.attr("vlink") || "",
        link: Tt.attr("link") || "",
        aLink: Tt.attr("alink") || ""
      }), Lt.remove("fullpage_styles");
      var Jt = ce.getDoc().getElementsByTagName("head")[0];
      if (Je) {
        var se = Lt.add(Jt, "style", { id: "fullpage_styles" });
        se.appendChild(document.createTextNode(Je));
      }
      var tr = {};
      E.each(Jt.getElementsByTagName("link"), function(_t) {
        _t.rel === "stylesheet" && _t.getAttribute("data-mce-fullpage") && (tr[_t.href] = _t);
      }), E.each(dt.getAll("link"), function(_t) {
        var Pe = _t.attr("href");
        if (!Pe)
          return !0;
        !tr[Pe] && _t.attr("rel") === "stylesheet" && Lt.add(Jt, "link", {
          rel: "stylesheet",
          text: "text/css",
          href: Pe,
          "data-mce-fullpage": "1"
        }), delete tr[Pe];
      }), E.each(tr, function(_t) {
        _t.parentNode.removeChild(_t);
      });
    }
  }, xe = function(ce) {
    var ne = "", Ce, Te = "";
    if (le(ce)) {
      var _ = Q(ce);
      ne += '<?xml version="1.0" encoding="' + (_ || "ISO-8859-1") + `" ?>
`;
    }
    return ne += ue(ce), ne += `
<html>
<head>
`, (Ce = J(ce)) && (ne += "<title>" + Ce + `</title>
`), (Ce = Q(ce)) && (ne += '<meta http-equiv="Content-Type" content="text/html; charset=' + Ce + `" />
`), (Ce = pe(ce)) && (Te += "font-family: " + Ce + ";"), (Ce = Y(ce)) && (Te += "font-size: " + Ce + ";"), (Ce = D(ce)) && (Te += "color: " + Ce + ";"), ne += `</head>
<body` + (Te ? ' style="' + Te + '"' : "") + `>
`, ne;
  }, _e = function(ce, ne, Ce, Te) {
    Te.format === "html" && !Te.selection && (!Te.source_view || !j(ce)) && (Te.content = Pt(E.trim(ne) + `
` + E.trim(Te.content) + `
` + E.trim(Ce)));
  }, $ = function(ce, ne, Ce) {
    ce.on("BeforeSetContent", function(Te) {
      ge(ce, ne, Ce, Te);
    }), ce.on("GetContent", function(Te) {
      _e(ce, ne.get(), Ce.get(), Te);
    });
  }, N = function(ce) {
    ce.ui.registry.addButton("fullpage", {
      tooltip: "Metadata and document properties",
      icon: "document-properties",
      onAction: function() {
        ce.execCommand("mceFullPageProperties");
      }
    }), ce.ui.registry.addMenuItem("fullpage", {
      text: "Metadata and document properties",
      icon: "document-properties",
      onAction: function() {
        ce.execCommand("mceFullPageProperties");
      }
    });
  };
  function ae() {
    y.add("fullpage", function(ce) {
      var ne = m(""), Ce = m("");
      Ze(ce, ne), N(ce), $(ce, ne, Ce);
    });
  }
  ae();
})();
(function() {
  var m = function(O) {
    var x = O, I = function() {
      return x;
    }, re = function(Oe) {
      x = Oe;
    };
    return {
      get: I,
      set: re
    };
  }, y = tinymce.util.Tools.resolve("tinymce.PluginManager"), w = function(O) {
    return {
      isFullscreen: function() {
        return O.get() !== null;
      }
    };
  }, E = function(O) {
    var x = typeof O;
    return O === null ? "null" : x === "object" && (Array.prototype.isPrototypeOf(O) || O.constructor && O.constructor.name === "Array") ? "array" : x === "object" && (String.prototype.isPrototypeOf(O) || O.constructor && O.constructor.name === "String") ? "string" : x;
  }, P = function(O) {
    return function(x) {
      return E(x) === O;
    };
  }, H = function(O) {
    return function(x) {
      return typeof x === O;
    };
  }, X = P("string"), j = P("array"), le = H("boolean"), Q = function(O) {
    return O == null;
  }, pe = function(O) {
    return !Q(O);
  }, Y = H("function"), D = H("number"), J = function() {
  }, ue = function(O, x) {
    return function() {
      for (var I = [], re = 0; re < arguments.length; re++)
        I[re] = arguments[re];
      return O(x.apply(null, I));
    };
  }, ee = function(O, x) {
    return function(I) {
      return O(x(I));
    };
  }, Ge = function(O) {
    return function() {
      return O;
    };
  }, ze = function(O) {
    return O;
  };
  function ht(O) {
    for (var x = [], I = 1; I < arguments.length; I++)
      x[I - 1] = arguments[I];
    return function() {
      for (var re = [], Oe = 0; Oe < arguments.length; Oe++)
        re[Oe] = arguments[Oe];
      var vt = x.concat(re);
      return O.apply(null, vt);
    };
  }
  var ie = Ge(!1), Ze = Ge(!0), De = function() {
    return Pt;
  }, Pt = function() {
    var O = function(re) {
      return re();
    }, x = ze, I = {
      fold: function(re, Oe) {
        return re();
      },
      isSome: ie,
      isNone: Ze,
      getOr: x,
      getOrThunk: O,
      getOrDie: function(re) {
        throw new Error(re || "error: getOrDie called on none.");
      },
      getOrNull: Ge(null),
      getOrUndefined: Ge(void 0),
      or: x,
      orThunk: O,
      map: De,
      each: J,
      bind: De,
      exists: ie,
      forall: Ze,
      filter: function() {
        return De();
      },
      toArray: function() {
        return [];
      },
      toString: Ge("none()")
    };
    return I;
  }(), Ct = function(O) {
    var x = Ge(O), I = function() {
      return Oe;
    }, re = function(vt) {
      return vt(O);
    }, Oe = {
      fold: function(vt, rn) {
        return rn(O);
      },
      isSome: Ze,
      isNone: ie,
      getOr: x,
      getOrThunk: x,
      getOrDie: x,
      getOrNull: x,
      getOrUndefined: x,
      or: I,
      orThunk: I,
      map: function(vt) {
        return Ct(vt(O));
      },
      each: function(vt) {
        vt(O);
      },
      bind: re,
      exists: re,
      forall: re,
      filter: function(vt) {
        return vt(O) ? Oe : Pt;
      },
      toArray: function() {
        return [O];
      },
      toString: function() {
        return "some(" + O + ")";
      }
    };
    return Oe;
  }, Be = function(O) {
    return O == null ? Pt : Ct(O);
  }, ge = {
    some: Ct,
    none: De,
    from: Be
  }, xe = function() {
    return xe = Object.assign || function(x) {
      for (var I, re = 1, Oe = arguments.length; re < Oe; re++) {
        I = arguments[re];
        for (var vt in I)
          Object.prototype.hasOwnProperty.call(I, vt) && (x[vt] = I[vt]);
      }
      return x;
    }, xe.apply(this, arguments);
  }, _e = function(O) {
    var x = m(ge.none()), I = function() {
      return x.get().each(O);
    }, re = function() {
      I(), x.set(ge.none());
    }, Oe = function() {
      return x.get().isSome();
    }, vt = function() {
      return x.get();
    }, rn = function(or) {
      I(), x.set(ge.some(or));
    };
    return {
      clear: re,
      isSet: Oe,
      get: vt,
      set: rn
    };
  }, $ = function() {
    return _e(function(O) {
      return O.unbind();
    });
  }, N = function() {
    var O = _e(J), x = function(I) {
      return O.get().each(I);
    };
    return xe(xe({}, O), { on: x });
  }, ae = Array.prototype.push, ce = function(O, x) {
    for (var I = O.length, re = new Array(I), Oe = 0; Oe < I; Oe++) {
      var vt = O[Oe];
      re[Oe] = x(vt, Oe);
    }
    return re;
  }, ne = function(O, x) {
    for (var I = 0, re = O.length; I < re; I++) {
      var Oe = O[I];
      x(Oe, I);
    }
  }, Ce = function(O, x) {
    for (var I = [], re = 0, Oe = O.length; re < Oe; re++) {
      var vt = O[re];
      x(vt, re) && I.push(vt);
    }
    return I;
  }, Te = function(O, x, I) {
    for (var re = 0, Oe = O.length; re < Oe; re++) {
      var vt = O[re];
      if (x(vt, re))
        return ge.some(vt);
      if (I(vt, re))
        break;
    }
    return ge.none();
  }, _ = function(O, x) {
    return Te(O, x, ie);
  }, je = function(O) {
    for (var x = [], I = 0, re = O.length; I < re; ++I) {
      if (!j(O[I]))
        throw new Error("Arr.flatten item " + I + " was not an array, input: " + O);
      ae.apply(x, O[I]);
    }
    return x;
  }, Me = function(O, x) {
    return je(ce(O, x));
  }, Je = function(O, x) {
    return x >= 0 && x < O.length ? ge.some(O[x]) : ge.none();
  }, Lt = function(O) {
    return Je(O, 0);
  }, dt = function(O, x) {
    for (var I = 0; I < O.length; I++) {
      var re = x(O[I], I);
      if (re.isSome())
        return re;
    }
    return ge.none();
  }, Tt = Object.keys, Jt = function(O, x) {
    for (var I = Tt(O), re = 0, Oe = I.length; re < Oe; re++) {
      var vt = I[re], rn = O[vt];
      x(rn, vt);
    }
  }, se = function(O, x) {
    return O.indexOf(x) !== -1;
  }, tr = function(O) {
    return O.style !== void 0 && Y(O.style.getPropertyValue);
  }, _t = function(O, x) {
    var I = x || document, re = I.createElement("div");
    if (re.innerHTML = O, !re.hasChildNodes() || re.childNodes.length > 1)
      throw console.error("HTML does not have a single root node", O), new Error("HTML must have a single root node");
    return He(re.childNodes[0]);
  }, Pe = function(O, x) {
    var I = x || document, re = I.createElement(O);
    return He(re);
  }, kt = function(O, x) {
    var I = x || document, re = I.createTextNode(O);
    return He(re);
  }, He = function(O) {
    if (O == null)
      throw new Error("Node cannot be null or undefined");
    return { dom: O };
  }, We = function(O, x, I) {
    return ge.from(O.dom.elementFromPoint(x, I)).map(He);
  }, Ae = {
    fromHtml: _t,
    fromTag: Pe,
    fromText: kt,
    fromDom: He,
    fromPoint: We
  };
  typeof window < "u" || Function("return this;")();
  var Ke = 9, at = 11, pt = 1, sn = 3, Ie = function(O) {
    return O.dom.nodeType;
  }, St = function(O) {
    return function(x) {
      return Ie(x) === O;
    };
  }, Xe = St(pt), he = St(sn), tt = St(Ke), gt = St(at), Ye = function(O) {
    var x = !1, I;
    return function() {
      for (var re = [], Oe = 0; Oe < arguments.length; Oe++)
        re[Oe] = arguments[Oe];
      return x || (x = !0, I = O.apply(null, re)), I;
    };
  }, Qt = function(O, x, I, re) {
    var Oe = O.isiOS() && /ipad/i.test(I) === !0, vt = O.isiOS() && !Oe, rn = O.isiOS() || O.isAndroid(), or = rn || re("(pointer:coarse)"), wr = Oe || !vt && rn && re("(min-device-width:768px)"), Nn = vt || rn && !wr, nr = x.isSafari() && O.isiOS() && /safari/i.test(I) === !1, jr = !Nn && !wr && !nr;
    return {
      isiPad: Ge(Oe),
      isiPhone: Ge(vt),
      isTablet: Ge(wr),
      isPhone: Ge(Nn),
      isTouch: Ge(or),
      isAndroid: O.isAndroid,
      isiOS: O.isiOS,
      isWebView: Ge(nr),
      isDesktop: Ge(jr)
    };
  }, In = function(O, x) {
    for (var I = 0; I < O.length; I++) {
      var re = O[I];
      if (re.test(x))
        return re;
    }
  }, It = function(O, x) {
    var I = In(O, x);
    if (!I)
      return {
        major: 0,
        minor: 0
      };
    var re = function(Oe) {
      return Number(x.replace(I, "$" + Oe));
    };
    return Xt(re(1), re(2));
  }, qt = function(O, x) {
    var I = String(x).toLowerCase();
    return O.length === 0 ? Vt() : It(O, I);
  }, Vt = function() {
    return Xt(0, 0);
  }, Xt = function(O, x) {
    return {
      major: O,
      minor: x
    };
  }, on = {
    nu: Xt,
    detect: qt,
    unknown: Vt
  }, Vn = function(O, x) {
    return dt(x.brands, function(I) {
      var re = I.brand.toLowerCase();
      return _(O, function(Oe) {
        var vt;
        return re === ((vt = Oe.brand) === null || vt === void 0 ? void 0 : vt.toLowerCase());
      }).map(function(Oe) {
        return {
          current: Oe.name,
          version: on.nu(parseInt(I.version, 10), 0)
        };
      });
    });
  }, Un = function(O, x) {
    var I = String(x).toLowerCase();
    return _(O, function(re) {
      return re.search(I);
    });
  }, Tn = function(O, x) {
    return Un(O, x).map(function(I) {
      var re = on.detect(I.versionRegexes, x);
      return {
        current: I.name,
        version: re
      };
    });
  }, yt = function(O, x) {
    return Un(O, x).map(function(I) {
      var re = on.detect(I.versionRegexes, x);
      return {
        current: I.name,
        version: re
      };
    });
  }, mn = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/, zn = function(O) {
    return function(x) {
      return se(x, O);
    };
  }, _n = [
    {
      name: "Edge",
      versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
      search: function(O) {
        return se(O, "edge/") && se(O, "chrome") && se(O, "safari") && se(O, "applewebkit");
      }
    },
    {
      name: "Chrome",
      brand: "Chromium",
      versionRegexes: [
        /.*?chrome\/([0-9]+)\.([0-9]+).*/,
        mn
      ],
      search: function(O) {
        return se(O, "chrome") && !se(O, "chromeframe");
      }
    },
    {
      name: "IE",
      versionRegexes: [
        /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
        /.*?rv:([0-9]+)\.([0-9]+).*/
      ],
      search: function(O) {
        return se(O, "msie") || se(O, "trident");
      }
    },
    {
      name: "Opera",
      versionRegexes: [
        mn,
        /.*?opera\/([0-9]+)\.([0-9]+).*/
      ],
      search: zn("opera")
    },
    {
      name: "Firefox",
      versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
      search: zn("firefox")
    },
    {
      name: "Safari",
      versionRegexes: [
        mn,
        /.*?cpu os ([0-9]+)_([0-9]+).*/
      ],
      search: function(O) {
        return (se(O, "safari") || se(O, "mobile/")) && se(O, "applewebkit");
      }
    }
  ], Kr = [
    {
      name: "Windows",
      search: zn("win"),
      versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
    },
    {
      name: "iOS",
      search: function(O) {
        return se(O, "iphone") || se(O, "ipad");
      },
      versionRegexes: [
        /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
        /.*cpu os ([0-9]+)_([0-9]+).*/,
        /.*cpu iphone os ([0-9]+)_([0-9]+).*/
      ]
    },
    {
      name: "Android",
      search: zn("android"),
      versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
    },
    {
      name: "OSX",
      search: zn("mac os x"),
      versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
    },
    {
      name: "Linux",
      search: zn("linux"),
      versionRegexes: []
    },
    {
      name: "Solaris",
      search: zn("sunos"),
      versionRegexes: []
    },
    {
      name: "FreeBSD",
      search: zn("freebsd"),
      versionRegexes: []
    },
    {
      name: "ChromeOS",
      search: zn("cros"),
      versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
    }
  ], ot = {
    browsers: Ge(_n),
    oses: Ge(Kr)
  }, Yt = "Edge", Ft = "Chrome", yn = "IE", Yn = "Opera", Ir = "Firefox", Wa = "Safari", Mr = function() {
    return Fr({
      current: void 0,
      version: on.unknown()
    });
  }, Fr = function(O) {
    var x = O.current, I = O.version, re = function(Oe) {
      return function() {
        return x === Oe;
      };
    };
    return {
      current: x,
      version: I,
      isEdge: re(Yt),
      isChrome: re(Ft),
      isIE: re(yn),
      isOpera: re(Yn),
      isFirefox: re(Ir),
      isSafari: re(Wa)
    };
  }, Va = {
    unknown: Mr,
    nu: Fr,
    edge: Ge(Yt),
    chrome: Ge(Ft),
    ie: Ge(yn),
    opera: Ge(Yn),
    firefox: Ge(Ir),
    safari: Ge(Wa)
  }, Qo = "Windows", Go = "iOS", so = "Android", bo = "Linux", mi = "OSX", Ao = "Solaris", go = "FreeBSD", gi = "ChromeOS", na = function() {
    return ei({
      current: void 0,
      version: on.unknown()
    });
  }, ei = function(O) {
    var x = O.current, I = O.version, re = function(Oe) {
      return function() {
        return x === Oe;
      };
    };
    return {
      current: x,
      version: I,
      isWindows: re(Qo),
      isiOS: re(Go),
      isAndroid: re(so),
      isOSX: re(mi),
      isLinux: re(bo),
      isSolaris: re(Ao),
      isFreeBSD: re(go),
      isChromeOS: re(gi)
    };
  }, sr = {
    unknown: na,
    nu: ei,
    windows: Ge(Qo),
    ios: Ge(Go),
    android: Ge(so),
    linux: Ge(bo),
    osx: Ge(mi),
    solaris: Ge(Ao),
    freebsd: Ge(go),
    chromeos: Ge(gi)
  }, $u = function(O, x, I) {
    var re = ot.browsers(), Oe = ot.oses(), vt = x.bind(function(wr) {
      return Vn(re, wr);
    }).orThunk(function() {
      return Tn(re, O);
    }).fold(Va.unknown, Va.nu), rn = yt(Oe, O).fold(sr.unknown, sr.nu), or = Qt(rn, vt, O, I);
    return {
      browser: vt,
      os: rn,
      deviceType: or
    };
  }, Ko = { detect: $u }, pi = function(O) {
    return window.matchMedia(O).matches;
  }, Po = Ye(function() {
    return Ko.detect(navigator.userAgent, ge.from(navigator.userAgentData), pi);
  }), Si = function() {
    return Po();
  }, Su = function(O, x) {
    var I = O.dom;
    if (I.nodeType !== pt)
      return !1;
    var re = I;
    if (re.matches !== void 0)
      return re.matches(x);
    if (re.msMatchesSelector !== void 0)
      return re.msMatchesSelector(x);
    if (re.webkitMatchesSelector !== void 0)
      return re.webkitMatchesSelector(x);
    if (re.mozMatchesSelector !== void 0)
      return re.mozMatchesSelector(x);
    throw new Error("Browser lacks native selectors");
  }, xi = function(O) {
    return O.nodeType !== pt && O.nodeType !== Ke && O.nodeType !== at || O.childElementCount === 0;
  }, Ju = function(O, x) {
    var I = x === void 0 ? document : x.dom;
    return xi(I) ? [] : ce(I.querySelectorAll(O), Ae.fromDom);
  }, Lo = function(O, x) {
    return O.dom === x.dom;
  }, yo = function(O) {
    return Ae.fromDom(O.dom.ownerDocument);
  }, Bn = function(O) {
    return tt(O) ? O : yo(O);
  }, xu = function(O) {
    return ge.from(O.dom.parentNode).map(Ae.fromDom);
  }, ku = function(O, x) {
    for (var I = Y(x) ? x : ie, re = O.dom, Oe = []; re.parentNode !== null && re.parentNode !== void 0; ) {
      var vt = re.parentNode, rn = Ae.fromDom(vt);
      if (Oe.push(rn), I(rn) === !0)
        break;
      re = vt;
    }
    return Oe;
  }, Tu = function(O) {
    var x = function(I) {
      return Ce(I, function(re) {
        return !Lo(O, re);
      });
    };
    return xu(O).map(Ue).map(x).getOr([]);
  }, Ue = function(O) {
    return ce(O.dom.childNodes, Ae.fromDom);
  }, et = function(O) {
    return gt(O) && pe(O.dom.host);
  }, en = Y(Element.prototype.attachShadow) && Y(Node.prototype.getRootNode), gn = Ge(en), Z = en ? function(O) {
    return Ae.fromDom(O.dom.getRootNode());
  } : Bn, ye = function(O) {
    var x = Z(O);
    return et(x) ? ge.some(x) : ge.none();
  }, Ve = function(O) {
    return Ae.fromDom(O.dom.host);
  }, lt = function(O) {
    if (gn() && pe(O.target)) {
      var x = Ae.fromDom(O.target);
      if (Xe(x) && Et(x) && O.composed && O.composedPath) {
        var I = O.composedPath();
        if (I)
          return Lt(I);
      }
    }
    return ge.from(O.target);
  }, Et = function(O) {
    return pe(O.dom.shadowRoot);
  }, Ot = function(O) {
    var x = he(O) ? O.dom.parentNode : O.dom;
    if (x == null || x.ownerDocument === null)
      return !1;
    var I = x.ownerDocument;
    return ye(Ae.fromDom(x)).fold(function() {
      return I.body.contains(x);
    }, ee(Ot, Ve));
  }, Rn = function(O) {
    var x = O.dom.body;
    if (x == null)
      throw new Error("Body is not available yet");
    return Ae.fromDom(x);
  }, er = function(O, x, I) {
    if (X(I) || le(I) || D(I))
      O.setAttribute(x, I + "");
    else
      throw console.error("Invalid call to Attribute.set. Key ", x, ":: Value ", I, ":: Element ", O), new Error("Attribute value was not simple");
  }, Rr = function(O, x, I) {
    er(O.dom, x, I);
  }, Nt = function(O, x) {
    var I = O.dom.getAttribute(x);
    return I === null ? void 0 : I;
  }, vr = function(O, x) {
    O.dom.removeAttribute(x);
  }, Nr = function(O, x, I) {
    if (!X(I))
      throw console.error("Invalid call to CSS.set. Property ", x, ":: Value ", I, ":: Element ", O), new Error("CSS value must be a string: " + I);
    tr(O) && O.style.setProperty(x, I);
  }, Sa = function(O, x) {
    var I = O.dom;
    Jt(x, function(re, Oe) {
      Nr(I, Oe, re);
    });
  }, po = function(O, x) {
    var I = O.dom, re = window.getComputedStyle(I), Oe = re.getPropertyValue(x);
    return Oe === "" && !Ot(O) ? Xr(I, x) : Oe;
  }, Xr = function(O, x) {
    return tr(O) ? O.style.getPropertyValue(x) : "";
  }, Lu = function(O, x, I, re, Oe, vt, rn) {
    return {
      target: O,
      x,
      y: I,
      stop: re,
      prevent: Oe,
      kill: vt,
      raw: rn
    };
  }, Eu = function(O) {
    var x = Ae.fromDom(lt(O).getOr(O.target)), I = function() {
      return O.stopPropagation();
    }, re = function() {
      return O.preventDefault();
    }, Oe = ue(re, I);
    return Lu(x, O.clientX, O.clientY, I, re, Oe, O);
  }, vo = function(O, x) {
    return function(I) {
      O(I) && x(Eu(I));
    };
  }, Fs = function(O, x, I, re, Oe) {
    var vt = vo(I, re);
    return O.dom.addEventListener(x, vt, Oe), { unbind: ht(Fi, O, x, vt, Oe) };
  }, ki = function(O, x, I, re) {
    return Fs(O, x, I, re, !1);
  }, Fi = function(O, x, I, re) {
    O.dom.removeEventListener(x, I, re);
  }, za = Ze, $s = function(O, x, I) {
    return ki(O, x, za, I);
  }, Qu = function(O, x) {
    var I = function(re, Oe) {
      return Qu(O + re, x + Oe);
    };
    return {
      left: O,
      top: x,
      translate: I
    };
  }, hs = Qu, rl = function(O) {
    var x = O !== void 0 ? O.dom : document, I = x.body.scrollLeft || x.documentElement.scrollLeft, re = x.body.scrollTop || x.documentElement.scrollTop;
    return hs(I, re);
  }, $i = function(O) {
    var x = O === void 0 ? window : O;
    return Si().browser.isFirefox() ? ge.none() : ge.from(x.visualViewport);
  }, au = function(O, x, I, re) {
    return {
      x: O,
      y: x,
      width: I,
      height: re,
      right: O + I,
      bottom: x + re
    };
  }, al = function(O) {
    var x = O === void 0 ? window : O, I = x.document, re = rl(Ae.fromDom(I));
    return $i(x).fold(function() {
      var Oe = x.document.documentElement, vt = Oe.clientWidth, rn = Oe.clientHeight;
      return au(re.left, re.top, vt, rn);
    }, function(Oe) {
      return au(Math.max(Oe.pageLeft, re.left), Math.max(Oe.pageTop, re.top), Oe.width, Oe.height);
    });
  }, qi = function(O, x, I) {
    return $i(I).map(function(re) {
      var Oe = function(vt) {
        return x(Eu(vt));
      };
      return re.addEventListener(O, Oe), {
        unbind: function() {
          return re.removeEventListener(O, Oe);
        }
      };
    }).getOrThunk(function() {
      return { unbind: J };
    });
  }, Li = tinymce.util.Tools.resolve("tinymce.dom.DOMUtils"), ve = tinymce.util.Tools.resolve("tinymce.Env"), nt = tinymce.util.Tools.resolve("tinymce.util.Delay"), wt = function(O, x) {
    O.fire("FullscreenStateChanged", { state: x }), O.fire("ResizeEditor");
  }, Zt = function(O) {
    return O.getParam("fullscreen_native", !1, "boolean");
  }, En = function(O) {
    var x = Ae.fromDom(O.getElement());
    return ye(x).map(Ve).getOrThunk(function() {
      return Rn(yo(x));
    });
  }, lr = function(O) {
    return O.fullscreenElement !== void 0 ? O.fullscreenElement : O.msFullscreenElement !== void 0 ? O.msFullscreenElement : O.webkitFullscreenElement !== void 0 ? O.webkitFullscreenElement : null;
  }, ya = function() {
    return document.fullscreenElement !== void 0 ? "fullscreenchange" : document.msFullscreenElement !== void 0 ? "MSFullscreenChange" : document.webkitFullscreenElement !== void 0 ? "webkitfullscreenchange" : "fullscreenchange";
  }, Aa = function(O) {
    var x = O.dom;
    x.requestFullscreen ? x.requestFullscreen() : x.msRequestFullscreen ? x.msRequestFullscreen() : x.webkitRequestFullScreen && x.webkitRequestFullScreen();
  }, Yr = function(O) {
    var x = O.dom;
    x.exitFullscreen ? x.exitFullscreen() : x.msExitFullscreen ? x.msExitFullscreen() : x.webkitCancelFullScreen && x.webkitCancelFullScreen();
  }, qa = function(O) {
    return O.dom === lr(yo(O).dom);
  }, ao = function(O, x, I) {
    return Ce(ku(O, I), x);
  }, es = function(O, x) {
    return Ce(Tu(O), x);
  }, ti = function(O) {
    return Ju(O);
  }, zu = function(O, x, I) {
    return ao(O, function(re) {
      return Su(re, x);
    }, I);
  }, br = function(O, x) {
    return es(O, function(I) {
      return Su(I, x);
    });
  }, bs = "data-ephox-mobile-fullscreen-style", yc = "display:none!important;", va = "position:absolute!important;", Wl = "top:0!important;left:0!important;margin:0!important;padding:0!important;width:100%!important;height:100%!important;overflow:visible!important;", ql = "background-color:rgb(255,255,255)!important;", Yc = ve.os.isAndroid(), Fa = function(O) {
    var x = po(O, "background-color");
    return x !== void 0 && x !== "" ? "background-color:" + x + "!important" : ql;
  }, ou = function(O, x, I) {
    var re = function(Nn) {
      return br(Nn, "*:not(.tox-silver-sink)");
    }, Oe = function(Nn) {
      return function(nr) {
        var jr = Nt(nr, "style"), Vr = jr === void 0 ? "no-styles" : jr.trim();
        Vr !== Nn && (Rr(nr, bs, Vr), Sa(nr, O.parseStyle(Nn)));
      };
    }, vt = zu(x, "*"), rn = Me(vt, re), or = Fa(I);
    ne(rn, Oe(yc)), ne(vt, Oe(va + Wl + or));
    var wr = Yc === !0 ? "" : va;
    Oe(wr + Wl + or)(x);
  }, Vf = function(O) {
    var x = ti("[" + bs + "]");
    ne(x, function(I) {
      var re = Nt(I, bs);
      re !== "no-styles" ? Sa(I, O.parseStyle(re)) : vr(I, "style"), vr(I, bs);
    });
  }, _u = Li.DOM, wo = function() {
    return al(window);
  }, Ls = function(O) {
    return window.scrollTo(O.x, O.y);
  }, Ut = $i().fold(function() {
    return {
      bind: J,
      unbind: J
    };
  }, function(O) {
    var x = N(), I = $(), re = $(), Oe = function() {
      document.body.scrollTop = 0, document.documentElement.scrollTop = 0;
    }, vt = function() {
      window.requestAnimationFrame(function() {
        x.on(function(Nn) {
          return Sa(Nn, {
            top: O.offsetTop + "px",
            left: O.offsetLeft + "px",
            height: O.height + "px",
            width: O.width + "px"
          });
        });
      });
    }, rn = nt.throttle(function() {
      Oe(), vt();
    }, 50), or = function(Nn) {
      x.set(Nn), rn(), I.set(qi("resize", rn)), re.set(qi("scroll", rn));
    }, wr = function() {
      x.on(function() {
        I.clear(), re.clear();
      }), x.clear();
    };
    return {
      bind: or,
      unbind: wr
    };
  }), ol = function(O, x) {
    var I = document.body, re = document.documentElement, Oe = O.getContainer(), vt = Ae.fromDom(Oe), rn = En(O), or = x.get(), wr = Ae.fromDom(O.getBody()), Nn = ve.deviceType.isTouch(), nr = Oe.style, jr = O.iframeElement, Vr = jr.style, Dr = function(Oa) {
      Oa(I, "tox-fullscreen"), Oa(re, "tox-fullscreen"), Oa(Oe, "tox-fullscreen"), ye(vt).map(function(Ti) {
        return Ve(Ti).dom;
      }).each(function(Ti) {
        Oa(Ti, "tox-fullscreen"), Oa(Ti, "tox-shadowhost");
      });
    }, Qa = function() {
      Nn && Vf(O.dom), Dr(_u.removeClass), Ut.unbind(), ge.from(x.get()).each(function(Oa) {
        return Oa.fullscreenChangeHandler.unbind();
      });
    };
    if (or)
      or.fullscreenChangeHandler.unbind(), Zt(O) && qa(rn) && Yr(yo(rn)), Vr.width = or.iframeWidth, Vr.height = or.iframeHeight, nr.width = or.containerWidth, nr.height = or.containerHeight, nr.top = or.containerTop, nr.left = or.containerLeft, Qa(), Ls(or.scrollPos), x.set(null), wt(O, !1), O.off("remove", Qa);
    else {
      var Tr = $s(yo(rn), ya(), function(Oa) {
        Zt(O) && !qa(rn) && x.get() !== null && ol(O, x);
      }), $a = {
        scrollPos: wo(),
        containerWidth: nr.width,
        containerHeight: nr.height,
        containerTop: nr.top,
        containerLeft: nr.left,
        iframeWidth: Vr.width,
        iframeHeight: Vr.height,
        fullscreenChangeHandler: Tr
      };
      Nn && ou(O.dom, vt, wr), Vr.width = Vr.height = "100%", nr.width = nr.height = "", Dr(_u.addClass), Ut.bind(vt), O.on("remove", Qa), x.set($a), Zt(O) && Aa(rn), wt(O, !0);
    }
  }, Co = function(O, x) {
    O.addCommand("mceFullScreen", function() {
      ol(O, x);
    });
  }, wc = function(O, x) {
    return function(I) {
      I.setActive(x.get() !== null);
      var re = function(Oe) {
        return I.setActive(Oe.state);
      };
      return O.on("FullscreenStateChanged", re), function() {
        return O.off("FullscreenStateChanged", re);
      };
    };
  }, ys = function(O, x) {
    var I = function() {
      return O.execCommand("mceFullScreen");
    };
    O.ui.registry.addToggleMenuItem("fullscreen", {
      text: "Fullscreen",
      icon: "fullscreen",
      shortcut: "Meta+Shift+F",
      onAction: I,
      onSetup: wc(O, x)
    }), O.ui.registry.addToggleButton("fullscreen", {
      tooltip: "Fullscreen",
      icon: "fullscreen",
      onAction: I,
      onSetup: wc(O, x)
    });
  };
  function V() {
    y.add("fullscreen", function(O) {
      var x = m(null);
      return O.inline || (Co(O, x), ys(O, x), O.addShortcut("Meta+Shift+F", "", "mceFullScreen")), w(x);
    });
  }
  V();
})();
(function() {
  var m = function(Pe) {
    var kt = Pe, He = function() {
      return kt;
    }, We = function(Ae) {
      kt = Ae;
    };
    return {
      get: He,
      set: We
    };
  }, y = tinymce.util.Tools.resolve("tinymce.PluginManager"), w = function(Pe) {
    var kt = function(He) {
      var We = Pe.get();
      We[He.name] = He, Pe.set(We);
    };
    return { addTab: kt };
  }, E = function(Pe, kt) {
    Pe.addCommand("mceHelp", kt);
  }, P = function(Pe, kt) {
    Pe.ui.registry.addButton("help", {
      icon: "help",
      tooltip: "Help",
      onAction: kt
    }), Pe.ui.registry.addMenuItem("help", {
      text: "Help",
      icon: "help",
      shortcut: "Alt+0",
      onAction: kt
    });
  }, H = function() {
    return H = Object.assign || function(kt) {
      for (var He, We = 1, Ae = arguments.length; We < Ae; We++) {
        He = arguments[We];
        for (var Ke in He)
          Object.prototype.hasOwnProperty.call(He, Ke) && (kt[Ke] = He[Ke]);
      }
      return kt;
    }, H.apply(this, arguments);
  }, X = function() {
  }, j = function(Pe) {
    return function() {
      return Pe;
    };
  }, le = function(Pe) {
    return Pe;
  }, Q = j(!1), pe = j(!0), Y = function() {
    return D;
  }, D = function() {
    var Pe = function(We) {
      return We();
    }, kt = le, He = {
      fold: function(We, Ae) {
        return We();
      },
      isSome: Q,
      isNone: pe,
      getOr: kt,
      getOrThunk: Pe,
      getOrDie: function(We) {
        throw new Error(We || "error: getOrDie called on none.");
      },
      getOrNull: j(null),
      getOrUndefined: j(void 0),
      or: kt,
      orThunk: Pe,
      map: Y,
      each: X,
      bind: Y,
      exists: Q,
      forall: pe,
      filter: function() {
        return Y();
      },
      toArray: function() {
        return [];
      },
      toString: j("none()")
    };
    return He;
  }(), J = function(Pe) {
    var kt = j(Pe), He = function() {
      return Ae;
    }, We = function(Ke) {
      return Ke(Pe);
    }, Ae = {
      fold: function(Ke, at) {
        return at(Pe);
      },
      isSome: pe,
      isNone: Q,
      getOr: kt,
      getOrThunk: kt,
      getOrDie: kt,
      getOrNull: kt,
      getOrUndefined: kt,
      or: He,
      orThunk: He,
      map: function(Ke) {
        return J(Ke(Pe));
      },
      each: function(Ke) {
        Ke(Pe);
      },
      bind: We,
      exists: We,
      forall: We,
      filter: function(Ke) {
        return Ke(Pe) ? Ae : D;
      },
      toArray: function() {
        return [Pe];
      },
      toString: function() {
        return "some(" + Pe + ")";
      }
    };
    return Ae;
  }, ue = function(Pe) {
    return Pe == null ? D : J(Pe);
  }, ee = {
    some: J,
    none: Y,
    from: ue
  }, Ge = Array.prototype.indexOf, ze = function(Pe, kt) {
    return Ge.call(Pe, kt);
  }, ht = function(Pe, kt) {
    return ze(Pe, kt) > -1;
  }, ie = function(Pe, kt) {
    for (var He = Pe.length, We = new Array(He), Ae = 0; Ae < He; Ae++) {
      var Ke = Pe[Ae];
      We[Ae] = kt(Ke, Ae);
    }
    return We;
  }, Ze = function(Pe, kt) {
    for (var He = [], We = 0, Ae = Pe.length; We < Ae; We++) {
      var Ke = Pe[We];
      kt(Ke, We) && He.push(Ke);
    }
    return He;
  }, De = function(Pe, kt, He) {
    for (var We = 0, Ae = Pe.length; We < Ae; We++) {
      var Ke = Pe[We];
      if (kt(Ke, We))
        return ee.some(Ke);
      if (He(Ke, We))
        break;
    }
    return ee.none();
  }, Pt = function(Pe, kt) {
    return De(Pe, kt, Q);
  }, Ct = Object.keys, Be = Object.hasOwnProperty, ge = function(Pe, kt) {
    return xe(Pe, kt) ? ee.from(Pe[kt]) : ee.none();
  }, xe = function(Pe, kt) {
    return Be.call(Pe, kt);
  }, _e = function(Pe) {
    for (var kt = [], He = function(Ae) {
      kt.push(Ae);
    }, We = 0; We < Pe.length; We++)
      Pe[We].each(He);
    return kt;
  }, $ = function(Pe) {
    return ee.from(Pe.getParam("help_tabs"));
  }, N = function(Pe) {
    return Pe.getParam("forced_plugins");
  }, ae = `<h1>Editor UI keyboard navigation</h1>

<h2>Activating keyboard navigation</h2>

<p>The sections of the outer UI of the editor - the menubar, toolbar, sidebar and footer - are all keyboard navigable. As such, there are multiple ways to activate keyboard navigation:</p>
<ul>
  <li>Focus the menubar: Alt + F9 (Windows) or &#x2325;F9 (MacOS)</li>
  <li>Focus the toolbar: Alt + F10 (Windows) or &#x2325;F10 (MacOS)</li>
  <li>Focus the footer: Alt + F11 (Windows) or &#x2325;F11 (MacOS)</li>
</ul>

<p>Focusing the menubar or toolbar will start keyboard navigation at the first item in the menubar or toolbar, which will be highlighted with a gray background. Focusing the footer will start keyboard navigation at the first item in the element path, which will be highlighted with an underline. </p>

<h2>Moving between UI sections</h2>

<p>When keyboard navigation is active, pressing tab will move the focus to the next major section of the UI, where applicable. These sections are:</p>
<ul>
  <li>the menubar</li>
  <li>each group of the toolbar </li>
  <li>the sidebar</li>
  <li>the element path in the footer </li>
  <li>the wordcount toggle button in the footer </li>
  <li>the branding link in the footer </li>
  <li>the editor resize handle in the footer</li>
</ul>

<p>Pressing shift + tab will move backwards through the same sections, except when moving from the footer to the toolbar. Focusing the element path then pressing shift + tab will move focus to the first toolbar group, not the last.</p>

<h2>Moving within UI sections</h2>

<p>Keyboard navigation within UI sections can usually be achieved using the left and right arrow keys. This includes:</p>
<ul>
  <li>moving between menus in the menubar</li>
  <li>moving between buttons in a toolbar group</li>
  <li>moving between items in the element path</li>
</ul>

<p>In all these UI sections, keyboard navigation will cycle within the section. For example, focusing the last button in a toolbar group then pressing right arrow will move focus to the first item in the same toolbar group. </p>

<h1>Executing buttons</h1>

<p>To execute a button, navigate the selection to the desired button and hit space or enter.</p>

<h1>Opening, navigating and closing menus</h1>

<p>When focusing a menubar button or a toolbar button with a menu, pressing space, enter or down arrow will open the menu. When the menu opens the first item will be selected. To move up or down the menu, press the up or down arrow key respectively. This is the same for submenus, which can also be opened and closed using the left and right arrow keys.</p>

<p>To close any active menu, hit the escape key. When a menu is closed the selection will be restored to its previous selection. This also works for closing submenus.</p>

<h1>Context toolbars and menus</h1>

<p>To focus an open context toolbar such as the table context toolbar, press Ctrl + F9 (Windows) or &#x2303;F9 (MacOS).</p>

<p>Context toolbar navigation is the same as toolbar navigation, and context menu navigation is the same as standard menu navigation.</p>

<h1>Dialog navigation</h1>

<p>There are two types of dialog UIs in TinyMCE: tabbed dialogs and non-tabbed dialogs.</p>

<p>When a non-tabbed dialog is opened, the first interactive component in the dialog will be focused. Users can navigate between interactive components by pressing tab. This includes any footer buttons. Navigation will cycle back to the first dialog component if tab is pressed while focusing the last component in the dialog. Pressing shift + tab will navigate backwards.</p>

<p>When a tabbed dialog is opened, the first button in the tab menu is focused. Pressing tab will navigate to the first interactive component in that tab, and will cycle through the tab\u2019s components, the footer buttons, then back to the tab button. To switch to another tab, focus the tab button for the current tab, then use the arrow keys to cycle through the tab buttons.</p>`, ce = function() {
    var Pe = {
      type: "htmlpanel",
      presets: "document",
      html: ae
    };
    return {
      name: "keyboardnav",
      title: "Keyboard Navigation",
      items: [Pe]
    };
  }, ne = tinymce.util.Tools.resolve("tinymce.Env"), Ce = function(Pe) {
    var kt = {
      alt: "&#x2325;",
      ctrl: "&#x2303;",
      shift: "&#x21E7;",
      meta: "&#x2318;",
      access: "&#x2303;&#x2325;"
    }, He = {
      meta: "Ctrl ",
      access: "Shift + Alt "
    }, We = ne.mac ? kt : He, Ae = Pe.split("+"), Ke = ie(Ae, function(at) {
      var pt = at.toLowerCase().trim();
      return xe(We, pt) ? We[pt] : at;
    });
    return ne.mac ? Ke.join("").replace(/\s/, "") : Ke.join("+");
  }, Te = [
    {
      shortcuts: ["Meta + B"],
      action: "Bold"
    },
    {
      shortcuts: ["Meta + I"],
      action: "Italic"
    },
    {
      shortcuts: ["Meta + U"],
      action: "Underline"
    },
    {
      shortcuts: ["Meta + A"],
      action: "Select all"
    },
    {
      shortcuts: [
        "Meta + Y",
        "Meta + Shift + Z"
      ],
      action: "Redo"
    },
    {
      shortcuts: ["Meta + Z"],
      action: "Undo"
    },
    {
      shortcuts: ["Access + 1"],
      action: "Heading 1"
    },
    {
      shortcuts: ["Access + 2"],
      action: "Heading 2"
    },
    {
      shortcuts: ["Access + 3"],
      action: "Heading 3"
    },
    {
      shortcuts: ["Access + 4"],
      action: "Heading 4"
    },
    {
      shortcuts: ["Access + 5"],
      action: "Heading 5"
    },
    {
      shortcuts: ["Access + 6"],
      action: "Heading 6"
    },
    {
      shortcuts: ["Access + 7"],
      action: "Paragraph"
    },
    {
      shortcuts: ["Access + 8"],
      action: "Div"
    },
    {
      shortcuts: ["Access + 9"],
      action: "Address"
    },
    {
      shortcuts: ["Alt + 0"],
      action: "Open help dialog"
    },
    {
      shortcuts: ["Alt + F9"],
      action: "Focus to menubar"
    },
    {
      shortcuts: ["Alt + F10"],
      action: "Focus to toolbar"
    },
    {
      shortcuts: ["Alt + F11"],
      action: "Focus to element path"
    },
    {
      shortcuts: ["Ctrl + F9"],
      action: "Focus to contextual toolbar"
    },
    {
      shortcuts: ["Shift + Enter"],
      action: "Open popup menu for split buttons"
    },
    {
      shortcuts: ["Meta + K"],
      action: "Insert link (if link plugin activated)"
    },
    {
      shortcuts: ["Meta + S"],
      action: "Save (if save plugin activated)"
    },
    {
      shortcuts: ["Meta + F"],
      action: "Find (if searchreplace plugin activated)"
    },
    {
      shortcuts: ["Meta + Shift + F"],
      action: "Switch to or from fullscreen mode"
    }
  ], _ = function() {
    var Pe = ie(Te, function(He) {
      var We = ie(He.shortcuts, Ce).join(" or ");
      return [
        He.action,
        We
      ];
    }), kt = {
      type: "table",
      header: [
        "Action",
        "Shortcut"
      ],
      cells: Pe
    };
    return {
      name: "shortcuts",
      title: "Handy Shortcuts",
      items: [kt]
    };
  }, je = tinymce.util.Tools.resolve("tinymce.util.I18n"), Me = ie([
    {
      key: "advlist",
      name: "Advanced List"
    },
    {
      key: "anchor",
      name: "Anchor"
    },
    {
      key: "autolink",
      name: "Autolink"
    },
    {
      key: "autoresize",
      name: "Autoresize"
    },
    {
      key: "autosave",
      name: "Autosave"
    },
    {
      key: "bbcode",
      name: "BBCode"
    },
    {
      key: "charmap",
      name: "Character Map"
    },
    {
      key: "code",
      name: "Code"
    },
    {
      key: "codesample",
      name: "Code Sample"
    },
    {
      key: "colorpicker",
      name: "Color Picker"
    },
    {
      key: "directionality",
      name: "Directionality"
    },
    {
      key: "emoticons",
      name: "Emoticons"
    },
    {
      key: "fullpage",
      name: "Full Page"
    },
    {
      key: "fullscreen",
      name: "Full Screen"
    },
    {
      key: "help",
      name: "Help"
    },
    {
      key: "hr",
      name: "Horizontal Rule"
    },
    {
      key: "image",
      name: "Image"
    },
    {
      key: "imagetools",
      name: "Image Tools"
    },
    {
      key: "importcss",
      name: "Import CSS"
    },
    {
      key: "insertdatetime",
      name: "Insert Date/Time"
    },
    {
      key: "legacyoutput",
      name: "Legacy Output"
    },
    {
      key: "link",
      name: "Link"
    },
    {
      key: "lists",
      name: "Lists"
    },
    {
      key: "media",
      name: "Media"
    },
    {
      key: "nonbreaking",
      name: "Nonbreaking"
    },
    {
      key: "noneditable",
      name: "Noneditable"
    },
    {
      key: "pagebreak",
      name: "Page Break"
    },
    {
      key: "paste",
      name: "Paste"
    },
    {
      key: "preview",
      name: "Preview"
    },
    {
      key: "print",
      name: "Print"
    },
    {
      key: "quickbars",
      name: "Quick Toolbars"
    },
    {
      key: "save",
      name: "Save"
    },
    {
      key: "searchreplace",
      name: "Search and Replace"
    },
    {
      key: "spellchecker",
      name: "Spell Checker"
    },
    {
      key: "tabfocus",
      name: "Tab Focus"
    },
    {
      key: "table",
      name: "Table"
    },
    {
      key: "template",
      name: "Template"
    },
    {
      key: "textcolor",
      name: "Text Color"
    },
    {
      key: "textpattern",
      name: "Text Pattern"
    },
    {
      key: "toc",
      name: "Table of Contents"
    },
    {
      key: "visualblocks",
      name: "Visual Blocks"
    },
    {
      key: "visualchars",
      name: "Visual Characters"
    },
    {
      key: "wordcount",
      name: "Word Count"
    },
    {
      key: "a11ychecker",
      name: "Accessibility Checker",
      type: "premium"
    },
    {
      key: "advcode",
      name: "Advanced Code Editor",
      type: "premium"
    },
    {
      key: "advtable",
      name: "Advanced Tables",
      type: "premium"
    },
    {
      key: "autocorrect",
      name: "Autocorrect",
      type: "premium"
    },
    {
      key: "casechange",
      name: "Case Change",
      type: "premium"
    },
    {
      key: "checklist",
      name: "Checklist",
      type: "premium"
    },
    {
      key: "export",
      name: "Export",
      type: "premium"
    },
    {
      key: "mediaembed",
      name: "Enhanced Media Embed",
      type: "premium"
    },
    {
      key: "formatpainter",
      name: "Format Painter",
      type: "premium"
    },
    {
      key: "linkchecker",
      name: "Link Checker",
      type: "premium"
    },
    {
      key: "mentions",
      name: "Mentions",
      type: "premium"
    },
    {
      key: "pageembed",
      name: "Page Embed",
      type: "premium"
    },
    {
      key: "permanentpen",
      name: "Permanent Pen",
      type: "premium"
    },
    {
      key: "powerpaste",
      name: "PowerPaste",
      type: "premium"
    },
    {
      key: "rtc",
      name: "Real-Time Collaboration",
      type: "premium"
    },
    {
      key: "tinymcespellchecker",
      name: "Spell Checker Pro",
      type: "premium"
    },
    {
      key: "tinycomments",
      name: "Tiny Comments",
      type: "premium",
      slug: "comments"
    },
    {
      key: "tinydrive",
      name: "Tiny Drive",
      type: "premium"
    }
  ], function(Pe) {
    return H(H({}, Pe), {
      type: Pe.type || "opensource",
      slug: Pe.slug || Pe.key
    });
  }), Je = function(Pe) {
    var kt = function() {
      var sn = Ze(Me, function(St) {
        var Xe = St.key, he = St.type;
        return Xe !== "autocorrect" && he === "premium";
      }), Ie = ie(sn, function(St) {
        return "<li>" + je.translate(St.name) + "</li>";
      }).join("");
      return '<div data-mce-tabstop="1" tabindex="-1"><p><b>' + je.translate("Premium plugins:") + "</b></p><ul>" + Ie + '<li class="tox-help__more-link" "><a href="https://www.tiny.cloud/pricing/?utm_campaign=editor_referral&utm_medium=help_dialog&utm_source=tinymce" target="_blank">' + je.translate("Learn more...") + "</a></li></ul></div>";
    }, He = function(sn) {
      return '<a href="' + sn.url + '" target="_blank" rel="noopener">' + sn.name + "</a>";
    }, We = function(sn, Ie) {
      return Pt(Me, function(St) {
        return St.key === Ie;
      }).fold(function() {
        var St = sn.plugins[Ie].getMetadata;
        return typeof St == "function" ? He(St()) : Ie;
      }, function(St) {
        var Xe = St.type === "premium" ? St.name + "*" : St.name;
        return He({
          name: Xe,
          url: "https://www.tiny.cloud/docs/plugins/" + St.type + "/" + St.slug
        });
      });
    }, Ae = function(sn) {
      var Ie = Ct(sn.plugins), St = N(sn);
      return St === void 0 ? Ie : Ze(Ie, function(Xe) {
        return !ht(St, Xe);
      });
    }, Ke = function(sn) {
      var Ie = Ae(sn), St = ie(Ie, function(gt) {
        return "<li>" + We(sn, gt) + "</li>";
      }), Xe = St.length, he = St.join(""), tt = "<p><b>" + je.translate([
        "Plugins installed ({0}):",
        Xe
      ]) + "</b></p><ul>" + he + "</ul>";
      return tt;
    }, at = function(sn) {
      return sn == null ? "" : '<div data-mce-tabstop="1" tabindex="-1">' + Ke(sn) + "</div>";
    }, pt = {
      type: "htmlpanel",
      presets: "document",
      html: [
        at(Pe),
        kt()
      ].join("")
    };
    return {
      name: "plugins",
      title: "Plugins",
      items: [pt]
    };
  }, Lt = tinymce.util.Tools.resolve("tinymce.EditorManager"), dt = function() {
    var Pe = function(Ae, Ke) {
      return Ae.indexOf("@") === 0 ? "X.X.X" : Ae + "." + Ke;
    }, kt = Pe(Lt.majorVersion, Lt.minorVersion), He = '<a href="https://www.tiny.cloud/docs/changelog/?utm_campaign=editor_referral&utm_medium=help_dialog&utm_source=tinymce" target="_blank">TinyMCE ' + kt + "</a>", We = {
      type: "htmlpanel",
      html: "<p>" + je.translate([
        "You are using {0}",
        He
      ]) + "</p>",
      presets: "document"
    };
    return {
      name: "versions",
      title: "Version",
      items: [We]
    };
  }, Tt = function(Pe, kt) {
    var He = {}, We = ie(Pe, function(Ae) {
      return typeof Ae == "string" ? (xe(kt, Ae) && (He[Ae] = kt[Ae]), Ae) : (He[Ae.name] = Ae, Ae.name);
    });
    return {
      tabs: He,
      names: We
    };
  }, Jt = function(Pe) {
    var kt = Ct(Pe), He = kt.indexOf("versions");
    return He !== -1 && (kt.splice(He, 1), kt.push("versions")), {
      tabs: Pe,
      names: kt
    };
  }, se = function(Pe, kt) {
    var He, We = _(), Ae = ce(), Ke = Je(Pe), at = dt(), pt = H((He = {}, He[We.name] = We, He[Ae.name] = Ae, He[Ke.name] = Ke, He[at.name] = at, He), kt.get());
    return $(Pe).fold(function() {
      return Jt(pt);
    }, function(sn) {
      return Tt(sn, pt);
    });
  }, tr = function(Pe, kt) {
    return function() {
      var He = se(Pe, kt), We = He.tabs, Ae = He.names, Ke = ie(Ae, function(sn) {
        return ge(We, sn);
      }), at = _e(Ke), pt = {
        type: "tabpanel",
        tabs: at
      };
      Pe.windowManager.open({
        title: "Help",
        size: "medium",
        body: pt,
        buttons: [{
          type: "cancel",
          name: "close",
          text: "Close",
          primary: !0
        }],
        initialData: {}
      });
    };
  };
  function _t() {
    y.add("help", function(Pe) {
      var kt = m({}), He = w(kt), We = tr(Pe, kt);
      return P(Pe, We), E(Pe, We), Pe.shortcuts.add("Alt+0", "Open help dialog", "mceHelp"), He;
    });
  }
  _t();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(P) {
    P.addCommand("InsertHorizontalRule", function() {
      P.execCommand("mceInsertContent", !1, "<hr />");
    });
  }, w = function(P) {
    var H = function() {
      return P.execCommand("InsertHorizontalRule");
    };
    P.ui.registry.addButton("hr", {
      icon: "horizontal-rule",
      tooltip: "Horizontal line",
      onAction: H
    }), P.ui.registry.addMenuItem("hr", {
      icon: "horizontal-rule",
      text: "Horizontal line",
      onAction: H
    });
  };
  function E() {
    m.add("hr", function(P) {
      y(P), w(P);
    });
  }
  E();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function() {
    return y = Object.assign || function(O) {
      for (var x, I = 1, re = arguments.length; I < re; I++) {
        x = arguments[I];
        for (var Oe in x)
          Object.prototype.hasOwnProperty.call(x, Oe) && (O[Oe] = x[Oe]);
      }
      return O;
    }, y.apply(this, arguments);
  }, w = function(V) {
    var O = typeof V;
    return V === null ? "null" : O === "object" && (Array.prototype.isPrototypeOf(V) || V.constructor && V.constructor.name === "Array") ? "array" : O === "object" && (String.prototype.isPrototypeOf(V) || V.constructor && V.constructor.name === "String") ? "string" : O;
  }, E = function(V) {
    return function(O) {
      return w(O) === V;
    };
  }, P = function(V) {
    return function(O) {
      return typeof O === V;
    };
  }, H = function(V) {
    return function(O) {
      return V === O;
    };
  }, X = E("string"), j = E("object"), le = E("array"), Q = H(null), pe = P("boolean"), Y = function(V) {
    return V == null;
  }, D = function(V) {
    return !Y(V);
  }, J = P("function"), ue = P("number"), ee = function() {
  }, Ge = function(V) {
    return function() {
      return V;
    };
  }, ze = function(V) {
    return V;
  }, ht = Ge(!1), ie = Ge(!0), Ze = function() {
    return De;
  }, De = function() {
    var V = function(I) {
      return I();
    }, O = ze, x = {
      fold: function(I, re) {
        return I();
      },
      isSome: ht,
      isNone: ie,
      getOr: O,
      getOrThunk: V,
      getOrDie: function(I) {
        throw new Error(I || "error: getOrDie called on none.");
      },
      getOrNull: Ge(null),
      getOrUndefined: Ge(void 0),
      or: O,
      orThunk: V,
      map: Ze,
      each: ee,
      bind: Ze,
      exists: ht,
      forall: ie,
      filter: function() {
        return Ze();
      },
      toArray: function() {
        return [];
      },
      toString: Ge("none()")
    };
    return x;
  }(), Pt = function(V) {
    var O = Ge(V), x = function() {
      return re;
    }, I = function(Oe) {
      return Oe(V);
    }, re = {
      fold: function(Oe, vt) {
        return vt(V);
      },
      isSome: ie,
      isNone: ht,
      getOr: O,
      getOrThunk: O,
      getOrDie: O,
      getOrNull: O,
      getOrUndefined: O,
      or: x,
      orThunk: x,
      map: function(Oe) {
        return Pt(Oe(V));
      },
      each: function(Oe) {
        Oe(V);
      },
      bind: I,
      exists: I,
      forall: I,
      filter: function(Oe) {
        return Oe(V) ? re : De;
      },
      toArray: function() {
        return [V];
      },
      toString: function() {
        return "some(" + V + ")";
      }
    };
    return re;
  }, Ct = function(V) {
    return V == null ? De : Pt(V);
  }, Be = {
    some: Pt,
    none: Ze,
    from: Ct
  }, ge = Object.keys, xe = Object.hasOwnProperty, _e = function(V, O) {
    for (var x = ge(V), I = 0, re = x.length; I < re; I++) {
      var Oe = x[I], vt = V[Oe];
      O(vt, Oe);
    }
  }, $ = function(V) {
    return function(O, x) {
      V[x] = O;
    };
  }, N = function(V, O, x, I) {
    var re = {};
    return _e(V, function(Oe, vt) {
      (O(Oe, vt) ? x : I)(Oe, vt);
    }), re;
  }, ae = function(V, O) {
    var x = {};
    return N(V, O, $(x), ee), x;
  }, ce = function(V, O) {
    return xe.call(V, O);
  }, ne = function(V, O) {
    return ce(V, O) && V[O] !== void 0 && V[O] !== null;
  }, Ce = Array.prototype.push, Te = function(V) {
    for (var O = [], x = 0, I = V.length; x < I; ++x) {
      if (!le(V[x]))
        throw new Error("Arr.flatten item " + x + " was not an array, input: " + V);
      Ce.apply(O, V[x]);
    }
    return O;
  }, _ = function(V, O) {
    return O >= 0 && O < V.length ? Be.some(V[O]) : Be.none();
  }, je = function(V) {
    return _(V, 0);
  }, Me = function(V, O) {
    for (var x = 0; x < V.length; x++) {
      var I = O(V[x], x);
      if (I.isSome())
        return I;
    }
    return Be.none();
  };
  typeof window < "u" || Function("return this;")();
  var Je = function(V, O, x) {
    if (X(x) || pe(x) || ue(x))
      V.setAttribute(O, x + "");
    else
      throw console.error("Invalid call to Attribute.set. Key ", O, ":: Value ", x, ":: Element ", V), new Error("Attribute value was not simple");
  }, Lt = function(V, O, x) {
    Je(V.dom, O, x);
  }, dt = function(V, O) {
    V.dom.removeAttribute(O);
  }, Tt = function(V, O) {
    var x = O || document, I = x.createElement("div");
    if (I.innerHTML = V, !I.hasChildNodes() || I.childNodes.length > 1)
      throw console.error("HTML does not have a single root node", V), new Error("HTML must have a single root node");
    return tr(I.childNodes[0]);
  }, Jt = function(V, O) {
    var x = O || document, I = x.createElement(V);
    return tr(I);
  }, se = function(V, O) {
    var x = O || document, I = x.createTextNode(V);
    return tr(I);
  }, tr = function(V) {
    if (V == null)
      throw new Error("Node cannot be null or undefined");
    return { dom: V };
  }, _t = function(V, O, x) {
    return Be.from(V.dom.elementFromPoint(O, x)).map(tr);
  }, Pe = {
    fromHtml: Tt,
    fromTag: Jt,
    fromText: se,
    fromDom: tr,
    fromPoint: _t
  }, kt = tinymce.util.Tools.resolve("tinymce.dom.DOMUtils"), He = tinymce.util.Tools.resolve("tinymce.util.Promise"), We = tinymce.util.Tools.resolve("tinymce.util.URI"), Ae = tinymce.util.Tools.resolve("tinymce.util.XHR"), Ke = function(V) {
    return V.getParam("image_dimensions", !0, "boolean");
  }, at = function(V) {
    return V.getParam("image_advtab", !1, "boolean");
  }, pt = function(V) {
    return V.getParam("image_uploadtab", !0, "boolean");
  }, sn = function(V) {
    return V.getParam("image_prepend_url", "", "string");
  }, Ie = function(V) {
    return V.getParam("image_class_list");
  }, St = function(V) {
    return V.getParam("image_description", !0, "boolean");
  }, Xe = function(V) {
    return V.getParam("image_title", !1, "boolean");
  }, he = function(V) {
    return V.getParam("image_caption", !1, "boolean");
  }, tt = function(V) {
    return V.getParam("image_list", !1);
  }, gt = function(V) {
    return D(V.getParam("images_upload_url"));
  }, Ye = function(V) {
    return D(V.getParam("images_upload_handler"));
  }, Qt = function(V) {
    return V.getParam("a11y_advanced_options", !1, "boolean");
  }, In = function(V) {
    return V.getParam("automatic_uploads", !0, "boolean");
  }, It = function(V, O) {
    return Math.max(parseInt(V, 10), parseInt(O, 10));
  }, qt = function(V) {
    return new He(function(O) {
      var x = document.createElement("img"), I = function(Oe) {
        x.onload = x.onerror = null, x.parentNode && x.parentNode.removeChild(x), O(Oe);
      };
      x.onload = function() {
        var Oe = It(x.width, x.clientWidth), vt = It(x.height, x.clientHeight), rn = {
          width: Oe,
          height: vt
        };
        I(He.resolve(rn));
      }, x.onerror = function() {
        I(He.reject("Failed to get image dimensions for: " + V));
      };
      var re = x.style;
      re.visibility = "hidden", re.position = "fixed", re.bottom = re.left = "0px", re.width = re.height = "auto", document.body.appendChild(x), x.src = V;
    });
  }, Vt = function(V) {
    return V && (V = V.replace(/px$/, "")), V;
  }, Xt = function(V) {
    return V.length > 0 && /^[0-9]+$/.test(V) && (V += "px"), V;
  }, on = function(V) {
    if (V.margin) {
      var O = String(V.margin).split(" ");
      switch (O.length) {
        case 1:
          V["margin-top"] = V["margin-top"] || O[0], V["margin-right"] = V["margin-right"] || O[0], V["margin-bottom"] = V["margin-bottom"] || O[0], V["margin-left"] = V["margin-left"] || O[0];
          break;
        case 2:
          V["margin-top"] = V["margin-top"] || O[0], V["margin-right"] = V["margin-right"] || O[1], V["margin-bottom"] = V["margin-bottom"] || O[0], V["margin-left"] = V["margin-left"] || O[1];
          break;
        case 3:
          V["margin-top"] = V["margin-top"] || O[0], V["margin-right"] = V["margin-right"] || O[1], V["margin-bottom"] = V["margin-bottom"] || O[2], V["margin-left"] = V["margin-left"] || O[1];
          break;
        case 4:
          V["margin-top"] = V["margin-top"] || O[0], V["margin-right"] = V["margin-right"] || O[1], V["margin-bottom"] = V["margin-bottom"] || O[2], V["margin-left"] = V["margin-left"] || O[3];
      }
      delete V.margin;
    }
    return V;
  }, Vn = function(V, O) {
    var x = tt(V);
    X(x) ? Ae.send({
      url: x,
      success: function(I) {
        O(JSON.parse(I));
      }
    }) : J(x) ? x(O) : O(x);
  }, Un = function(V, O, x) {
    var I = function() {
      x.onload = x.onerror = null, V.selection && (V.selection.select(x), V.nodeChanged());
    };
    x.onload = function() {
      !O.width && !O.height && Ke(V) && V.dom.setAttribs(x, {
        width: String(x.clientWidth),
        height: String(x.clientHeight)
      }), I();
    }, x.onerror = I;
  }, Tn = function(V) {
    return new He(function(O, x) {
      var I = new FileReader();
      I.onload = function() {
        O(I.result);
      }, I.onerror = function() {
        x(I.error.message);
      }, I.readAsDataURL(V);
    });
  }, yt = function(V) {
    return V.nodeName === "IMG" && (V.hasAttribute("data-mce-object") || V.hasAttribute("data-mce-placeholder"));
  }, mn = function(V, O) {
    return We.isDomSafe(O, "img", V.settings);
  }, zn = kt.DOM, _n = function(V) {
    return V.style.marginLeft && V.style.marginRight && V.style.marginLeft === V.style.marginRight ? Vt(V.style.marginLeft) : "";
  }, Kr = function(V) {
    return V.style.marginTop && V.style.marginBottom && V.style.marginTop === V.style.marginBottom ? Vt(V.style.marginTop) : "";
  }, ot = function(V) {
    return V.style.borderWidth ? Vt(V.style.borderWidth) : "";
  }, Yt = function(V, O) {
    return V.hasAttribute(O) ? V.getAttribute(O) : "";
  }, Ft = function(V, O) {
    return V.style[O] ? V.style[O] : "";
  }, yn = function(V) {
    return V.parentNode !== null && V.parentNode.nodeName === "FIGURE";
  }, Yn = function(V, O, x) {
    x === "" ? V.removeAttribute(O) : V.setAttribute(O, x);
  }, Ir = function(V) {
    var O = zn.create("figure", { class: "image" });
    zn.insertAfter(O, V), O.appendChild(V), O.appendChild(zn.create("figcaption", { contentEditable: "true" }, "Caption")), O.contentEditable = "false";
  }, Wa = function(V) {
    var O = V.parentNode;
    zn.insertAfter(V, O), zn.remove(O);
  }, Mr = function(V) {
    yn(V) ? Wa(V) : Ir(V);
  }, Fr = function(V, O) {
    var x = V.getAttribute("style"), I = O(x !== null ? x : "");
    I.length > 0 ? (V.setAttribute("style", I), V.setAttribute("data-mce-style", I)) : V.removeAttribute("style");
  }, Va = function(V, O) {
    return function(x, I, re) {
      x.style[I] ? (x.style[I] = Xt(re), Fr(x, O)) : Yn(x, I, re);
    };
  }, Qo = function(V, O) {
    return V.style[O] ? Vt(V.style[O]) : Yt(V, O);
  }, Go = function(V, O) {
    var x = Xt(O);
    V.style.marginLeft = x, V.style.marginRight = x;
  }, so = function(V, O) {
    var x = Xt(O);
    V.style.marginTop = x, V.style.marginBottom = x;
  }, bo = function(V, O) {
    var x = Xt(O);
    V.style.borderWidth = x;
  }, mi = function(V, O) {
    V.style.borderStyle = O;
  }, Ao = function(V) {
    return Ft(V, "borderStyle");
  }, go = function(V) {
    return V.nodeName === "FIGURE";
  }, gi = function(V) {
    return V.nodeName === "IMG";
  }, na = function(V) {
    return zn.getAttrib(V, "alt").length === 0 && zn.getAttrib(V, "role") === "presentation";
  }, ei = function(V) {
    return na(V) ? "" : Yt(V, "alt");
  }, sr = function() {
    return {
      src: "",
      alt: "",
      title: "",
      width: "",
      height: "",
      class: "",
      style: "",
      caption: !1,
      hspace: "",
      vspace: "",
      border: "",
      borderStyle: "",
      isDecorative: !1
    };
  }, $u = function(V, O) {
    var x = document.createElement("img");
    return Yn(x, "style", O.style), (_n(x) || O.hspace !== "") && Go(x, O.hspace), (Kr(x) || O.vspace !== "") && so(x, O.vspace), (ot(x) || O.border !== "") && bo(x, O.border), (Ao(x) || O.borderStyle !== "") && mi(x, O.borderStyle), V(x.getAttribute("style"));
  }, Ko = function(V, O) {
    var x = document.createElement("img");
    if (Ju(V, y(y({}, O), { caption: !1 }), x), Si(x, O.alt, O.isDecorative), O.caption) {
      var I = zn.create("figure", { class: "image" });
      return I.appendChild(x), I.appendChild(zn.create("figcaption", { contentEditable: "true" }, "Caption")), I.contentEditable = "false", I;
    } else
      return x;
  }, pi = function(V, O) {
    return {
      src: Yt(O, "src"),
      alt: ei(O),
      title: Yt(O, "title"),
      width: Qo(O, "width"),
      height: Qo(O, "height"),
      class: Yt(O, "class"),
      style: V(Yt(O, "style")),
      caption: yn(O),
      hspace: _n(O),
      vspace: Kr(O),
      border: ot(O),
      borderStyle: Ft(O, "borderStyle"),
      isDecorative: na(O)
    };
  }, Po = function(V, O, x, I, re) {
    x[I] !== O[I] && re(V, I, x[I]);
  }, Si = function(V, O, x) {
    if (x) {
      zn.setAttrib(V, "role", "presentation");
      var I = Pe.fromDom(V);
      Lt(I, "alt", "");
    } else {
      if (Q(O)) {
        var I = Pe.fromDom(V);
        dt(I, "alt");
      } else {
        var I = Pe.fromDom(V);
        Lt(I, "alt", O);
      }
      zn.getAttrib(V, "role") === "presentation" && zn.setAttrib(V, "role", "");
    }
  }, Su = function(V, O, x) {
    (x.alt !== O.alt || x.isDecorative !== O.isDecorative) && Si(V, x.alt, x.isDecorative);
  }, xi = function(V, O) {
    return function(x, I, re) {
      V(x, re), Fr(x, O);
    };
  }, Ju = function(V, O, x) {
    var I = pi(V, x);
    Po(x, I, O, "caption", function(re, Oe, vt) {
      return Mr(re);
    }), Po(x, I, O, "src", Yn), Po(x, I, O, "title", Yn), Po(x, I, O, "width", Va("width", V)), Po(x, I, O, "height", Va("height", V)), Po(x, I, O, "class", Yn), Po(x, I, O, "style", xi(function(re, Oe) {
      return Yn(re, "style", Oe);
    }, V)), Po(x, I, O, "hspace", xi(Go, V)), Po(x, I, O, "vspace", xi(so, V)), Po(x, I, O, "border", xi(bo, V)), Po(x, I, O, "borderStyle", xi(mi, V)), Su(x, I, O);
  }, Lo = function(V, O) {
    var x = V.dom.styles.parse(O), I = on(x), re = V.dom.styles.parse(V.dom.styles.serialize(I));
    return V.dom.styles.serialize(re);
  }, yo = function(V) {
    var O = V.selection.getNode(), x = V.dom.getParent(O, "figure.image");
    return x ? V.dom.select("img", x)[0] : O && (O.nodeName !== "IMG" || yt(O)) ? null : O;
  }, Bn = function(V, O) {
    var x = V.dom, I = ae(V.schema.getTextBlockElements(), function(Oe, vt) {
      return !V.schema.isValidChild(vt, "figure");
    }), re = x.getParent(O.parentNode, function(Oe) {
      return ne(I, Oe.nodeName);
    }, V.getBody());
    return re ? x.split(re, O) : O;
  }, xu = function(V) {
    var O = yo(V);
    return O ? pi(function(x) {
      return Lo(V, x);
    }, O) : sr();
  }, ku = function(V, O) {
    var x = Ko(function(Oe) {
      return Lo(V, Oe);
    }, O);
    V.dom.setAttrib(x, "data-mce-id", "__mcenew"), V.focus(), V.selection.setContent(x.outerHTML);
    var I = V.dom.select('*[data-mce-id="__mcenew"]')[0];
    if (V.dom.setAttrib(I, "data-mce-id", null), go(I)) {
      var re = Bn(V, I);
      V.selection.select(re);
    } else
      V.selection.select(I);
  }, Tu = function(V, O) {
    V.dom.setAttrib(O, "src", O.getAttribute("src"));
  }, Ue = function(V, O) {
    if (O) {
      var x = V.dom.is(O.parentNode, "figure.image") ? O.parentNode : O;
      V.dom.remove(x), V.focus(), V.nodeChanged(), V.dom.isEmpty(V.getBody()) && (V.setContent(""), V.selection.setCursorLocation());
    }
  }, et = function(V, O) {
    var x = yo(V);
    if (Ju(function(re) {
      return Lo(V, re);
    }, O, x), Tu(V, x), go(x.parentNode)) {
      var I = x.parentNode;
      Bn(V, I), V.selection.select(x.parentNode);
    } else
      V.selection.select(x), Un(V, O, x);
  }, en = function(V, O) {
    var x = O.src;
    return y(y({}, O), { src: mn(V, x) ? x : "" });
  }, gn = function(V, O) {
    var x = yo(V);
    if (x) {
      var I = pi(function(vt) {
        return Lo(V, vt);
      }, x), re = y(y({}, I), O), Oe = en(V, re);
      re.src ? et(V, Oe) : Ue(V, x);
    } else
      O.src && ku(V, y(y({}, sr()), O));
  }, Z = function(V, O) {
    var x = j(V) && j(O);
    return x ? Ve(V, O) : O;
  }, ye = function(V) {
    return function() {
      for (var O = [], x = 0; x < arguments.length; x++)
        O[x] = arguments[x];
      if (O.length === 0)
        throw new Error("Can't merge zero objects");
      for (var I = {}, re = 0; re < O.length; re++) {
        var Oe = O[re];
        for (var vt in Oe)
          ce(Oe, vt) && (I[vt] = V(I[vt], Oe[vt]));
      }
      return I;
    };
  }, Ve = ye(Z), lt = function(V) {
    return V.length > 0;
  }, Et = tinymce.util.Tools.resolve("tinymce.util.ImageUploader"), Ot = tinymce.util.Tools.resolve("tinymce.util.Tools"), Rn = function(V) {
    return X(V.value) ? V.value : "";
  }, er = function(V) {
    return X(V.text) ? V.text : X(V.title) ? V.title : "";
  }, Rr = function(V, O) {
    var x = [];
    return Ot.each(V, function(I) {
      var re = er(I);
      if (I.menu !== void 0) {
        var Oe = Rr(I.menu, O);
        x.push({
          text: re,
          items: Oe
        });
      } else {
        var vt = O(I);
        x.push({
          text: re,
          value: vt
        });
      }
    }), x;
  }, Nt = function(V) {
    return V === void 0 && (V = Rn), function(O) {
      return O ? Be.from(O).map(function(x) {
        return Rr(x, V);
      }) : Be.none();
    };
  }, vr = function(V) {
    return Nt(Rn)(V);
  }, Nr = function(V) {
    return ce(V, "items");
  }, Sa = function(V, O) {
    return Me(V, function(x) {
      return Nr(x) ? Sa(x.items, O) : x.value === O ? Be.some(x) : Be.none();
    });
  }, po = function(V, O) {
    return V.bind(function(x) {
      return Sa(x, O);
    });
  }, Xr = {
    sanitizer: Nt,
    sanitize: vr,
    findEntry: po
  }, Lu = function(V) {
    return {
      title: "Advanced",
      name: "advanced",
      items: [
        {
          type: "input",
          label: "Style",
          name: "style"
        },
        {
          type: "grid",
          columns: 2,
          items: [
            {
              type: "input",
              label: "Vertical space",
              name: "vspace",
              inputMode: "numeric"
            },
            {
              type: "input",
              label: "Horizontal space",
              name: "hspace",
              inputMode: "numeric"
            },
            {
              type: "input",
              label: "Border width",
              name: "border",
              inputMode: "numeric"
            },
            {
              type: "listbox",
              name: "borderstyle",
              label: "Border style",
              items: [
                {
                  text: "Select...",
                  value: ""
                },
                {
                  text: "Solid",
                  value: "solid"
                },
                {
                  text: "Dotted",
                  value: "dotted"
                },
                {
                  text: "Dashed",
                  value: "dashed"
                },
                {
                  text: "Double",
                  value: "double"
                },
                {
                  text: "Groove",
                  value: "groove"
                },
                {
                  text: "Ridge",
                  value: "ridge"
                },
                {
                  text: "Inset",
                  value: "inset"
                },
                {
                  text: "Outset",
                  value: "outset"
                },
                {
                  text: "None",
                  value: "none"
                },
                {
                  text: "Hidden",
                  value: "hidden"
                }
              ]
            }
          ]
        }
      ]
    };
  }, Eu = { makeTab: Lu }, vo = function(V) {
    var O = Xr.sanitizer(function(Tr) {
      return V.convertURL(Tr.value || Tr.url, "src");
    }), x = new He(function(Tr) {
      Vn(V, function($a) {
        Tr(O($a).map(function(Oa) {
          return Te([
            [{
              text: "None",
              value: ""
            }],
            Oa
          ]);
        }));
      });
    }), I = Xr.sanitize(Ie(V)), re = at(V), Oe = pt(V), vt = gt(V), rn = Ye(V), or = xu(V), wr = St(V), Nn = Xe(V), nr = Ke(V), jr = he(V), Vr = Qt(V), Dr = In(V), Qa = Be.some(sn(V)).filter(function(Tr) {
      return X(Tr) && Tr.length > 0;
    });
    return x.then(function(Tr) {
      return {
        image: or,
        imageList: Tr,
        classList: I,
        hasAdvTab: re,
        hasUploadTab: Oe,
        hasUploadUrl: vt,
        hasUploadHandler: rn,
        hasDescription: wr,
        hasImageTitle: Nn,
        hasDimensions: nr,
        hasImageCaption: jr,
        prependURL: Qa,
        hasAccessibilityOptions: Vr,
        automaticUploads: Dr
      };
    });
  }, Fs = function(V) {
    var O = {
      name: "src",
      type: "urlinput",
      filetype: "image",
      label: "Source"
    }, x = V.imageList.map(function(Nn) {
      return {
        name: "images",
        type: "listbox",
        label: "Image list",
        items: Nn
      };
    }), I = {
      name: "alt",
      type: "input",
      label: "Alternative description",
      disabled: V.hasAccessibilityOptions && V.image.isDecorative
    }, re = {
      name: "title",
      type: "input",
      label: "Image title"
    }, Oe = {
      name: "dimensions",
      type: "sizeinput"
    }, vt = {
      type: "label",
      label: "Accessibility",
      items: [{
        name: "isDecorative",
        type: "checkbox",
        label: "Image is decorative"
      }]
    }, rn = V.classList.map(function(Nn) {
      return {
        name: "classes",
        type: "listbox",
        label: "Class",
        items: Nn
      };
    }), or = {
      type: "label",
      label: "Caption",
      items: [{
        type: "checkbox",
        name: "caption",
        label: "Show caption"
      }]
    }, wr = function(Nn) {
      return Nn ? {
        type: "grid",
        columns: 2
      } : { type: "panel" };
    };
    return Te([
      [O],
      x.toArray(),
      V.hasAccessibilityOptions && V.hasDescription ? [vt] : [],
      V.hasDescription ? [I] : [],
      V.hasImageTitle ? [re] : [],
      V.hasDimensions ? [Oe] : [],
      [y(y({}, wr(V.classList.isSome() && V.hasImageCaption)), {
        items: Te([
          rn.toArray(),
          V.hasImageCaption ? [or] : []
        ])
      })]
    ]);
  }, ki = function(V) {
    return {
      title: "General",
      name: "general",
      items: Fs(V)
    };
  }, Fi = {
    makeTab: ki,
    makeItems: Fs
  }, za = function(V) {
    var O = [{
      type: "dropzone",
      name: "fileinput"
    }];
    return {
      title: "Upload",
      name: "upload",
      items: O
    };
  }, $s = { makeTab: za }, Qu = function(V) {
    return {
      prevImage: Xr.findEntry(V.imageList, V.image.src),
      prevAlt: V.image.alt,
      open: !0
    };
  }, hs = function(V) {
    return {
      src: {
        value: V.src,
        meta: {}
      },
      images: V.src,
      alt: V.alt,
      title: V.title,
      dimensions: {
        width: V.width,
        height: V.height
      },
      classes: V.class,
      caption: V.caption,
      style: V.style,
      vspace: V.vspace,
      border: V.border,
      hspace: V.hspace,
      borderstyle: V.borderStyle,
      fileinput: [],
      isDecorative: V.isDecorative
    };
  }, rl = function(V, O) {
    return {
      src: V.src.value,
      alt: V.alt.length === 0 && O ? null : V.alt,
      title: V.title,
      width: V.dimensions.width,
      height: V.dimensions.height,
      class: V.classes,
      style: V.style,
      caption: V.caption,
      hspace: V.hspace,
      vspace: V.vspace,
      border: V.border,
      borderStyle: V.borderstyle,
      isDecorative: V.isDecorative
    };
  }, $i = function(V, O) {
    return /^(?:[a-zA-Z]+:)?\/\//.test(O) ? Be.none() : V.prependURL.bind(function(x) {
      return O.substring(0, x.length) !== x ? Be.some(x + O) : Be.none();
    });
  }, au = function(V, O) {
    var x = O.getData();
    $i(V, x.src.value).each(function(I) {
      O.setData({
        src: {
          value: I,
          meta: x.src.meta
        }
      });
    });
  }, al = function(V, O, x) {
    V.hasDescription && X(x.alt) && (O.alt = x.alt), V.hasAccessibilityOptions && (O.isDecorative = x.isDecorative || O.isDecorative || !1), V.hasImageTitle && X(x.title) && (O.title = x.title), V.hasDimensions && (X(x.width) && (O.dimensions.width = x.width), X(x.height) && (O.dimensions.height = x.height)), X(x.class) && Xr.findEntry(V.classList, x.class).each(function(I) {
      O.classes = I.value;
    }), V.hasImageCaption && pe(x.caption) && (O.caption = x.caption), V.hasAdvTab && (X(x.style) && (O.style = x.style), X(x.vspace) && (O.vspace = x.vspace), X(x.border) && (O.border = x.border), X(x.hspace) && (O.hspace = x.hspace), X(x.borderstyle) && (O.borderstyle = x.borderstyle));
  }, qi = function(V, O) {
    var x = O.getData(), I = x.src.meta;
    if (I !== void 0) {
      var re = Ve({}, x);
      al(V, re, I), O.setData(re);
    }
  }, Li = function(V, O, x, I) {
    var re = I.getData(), Oe = re.src.value, vt = re.src.meta || {};
    !vt.width && !vt.height && O.hasDimensions && (lt(Oe) ? V.imageSize(Oe).then(function(rn) {
      x.open && I.setData({ dimensions: rn });
    }).catch(function(rn) {
      return console.error(rn);
    }) : I.setData({
      dimensions: {
        width: "",
        height: ""
      }
    }));
  }, ve = function(V, O, x) {
    var I = x.getData(), re = Xr.findEntry(V.imageList, I.src.value);
    O.prevImage = re, x.setData({
      images: re.map(function(Oe) {
        return Oe.value;
      }).getOr("")
    });
  }, nt = function(V, O, x, I) {
    au(O, I), qi(O, I), Li(V, O, x, I), ve(O, x, I);
  }, wt = function(V, O, x, I) {
    var re = I.getData(), Oe = Xr.findEntry(O.imageList, re.images);
    Oe.each(function(vt) {
      var rn = re.alt === "" || x.prevImage.map(function(or) {
        return or.text === re.alt;
      }).getOr(!1);
      rn ? vt.value === "" ? I.setData({
        src: vt,
        alt: x.prevAlt
      }) : I.setData({
        src: vt,
        alt: vt.text
      }) : I.setData({ src: vt });
    }), x.prevImage = Oe, nt(V, O, x, I);
  }, Zt = function(V) {
    var O = V["margin-top"] && V["margin-bottom"] && V["margin-top"] === V["margin-bottom"];
    return O ? Vt(String(V["margin-top"])) : "";
  }, En = function(V) {
    var O = V["margin-right"] && V["margin-left"] && V["margin-right"] === V["margin-left"];
    return O ? Vt(String(V["margin-right"])) : "";
  }, lr = function(V) {
    return V["border-width"] ? Vt(String(V["border-width"])) : "";
  }, ya = function(V) {
    return V["border-style"] ? String(V["border-style"]) : "";
  }, Aa = function(V, O, x) {
    return O(V(O(x)));
  }, Yr = function(V, O, x) {
    var I = on(V(x.style)), re = Ve({}, x);
    return re.vspace = Zt(I), re.hspace = En(I), re.border = lr(I), re.borderstyle = ya(I), re.style = Aa(V, O, I), re;
  }, qa = function(V, O) {
    var x = O.getData(), I = Yr(V.parseStyle, V.serializeStyle, x);
    O.setData(I);
  }, ao = function(V, O, x) {
    var I = Ve(hs(O.image), x.getData()), re = $u(V.normalizeCss, rl(I, !1));
    x.setData({ style: re });
  }, es = function(V, O, x, I) {
    var re = I.getData();
    I.block("Uploading image"), je(re.fileinput).fold(function() {
      I.unblock();
    }, function(Oe) {
      var vt = URL.createObjectURL(Oe), rn = function() {
        I.unblock(), URL.revokeObjectURL(vt);
      }, or = function(wr) {
        I.setData({
          src: {
            value: wr,
            meta: {}
          }
        }), I.showTab("general"), nt(V, O, x, I);
      };
      Tn(Oe).then(function(wr) {
        var Nn = V.createBlobCache(Oe, vt, wr);
        O.automaticUploads ? V.uploadImage(Nn).then(function(nr) {
          or(nr.url), rn();
        }).catch(function(nr) {
          rn(), V.alertErr(nr);
        }) : (V.addToBlobCache(Nn), or(Nn.blobUri()), I.unblock());
      });
    });
  }, ti = function(V, O, x) {
    return function(I, re) {
      re.name === "src" ? nt(V, O, x, I) : re.name === "images" ? wt(V, O, x, I) : re.name === "alt" ? x.prevAlt = I.getData().alt : re.name === "style" ? qa(V, I) : re.name === "vspace" || re.name === "hspace" || re.name === "border" || re.name === "borderstyle" ? ao(V, O, I) : re.name === "fileinput" ? es(V, O, x, I) : re.name === "isDecorative" && (I.getData().isDecorative ? I.disable("alt") : I.enable("alt"));
    };
  }, zu = function(V) {
    return function() {
      V.open = !1;
    };
  }, br = function(V) {
    if (V.hasAdvTab || V.hasUploadUrl || V.hasUploadHandler) {
      var O = {
        type: "tabpanel",
        tabs: Te([
          [Fi.makeTab(V)],
          V.hasAdvTab ? [Eu.makeTab(V)] : [],
          V.hasUploadTab && (V.hasUploadUrl || V.hasUploadHandler) ? [$s.makeTab(V)] : []
        ])
      };
      return O;
    } else {
      var x = {
        type: "panel",
        items: Fi.makeItems(V)
      };
      return x;
    }
  }, bs = function(V) {
    return function(O) {
      var x = Qu(O);
      return {
        title: "Insert/Edit Image",
        size: "normal",
        body: br(O),
        buttons: [
          {
            type: "cancel",
            name: "cancel",
            text: "Cancel"
          },
          {
            type: "submit",
            name: "save",
            text: "Save",
            primary: !0
          }
        ],
        initialData: hs(O.image),
        onSubmit: V.onSubmit(O),
        onChange: ti(V, O, x),
        onClose: zu(x)
      };
    };
  }, yc = function(V) {
    return function(O) {
      return function(x) {
        var I = Ve(hs(O.image), x.getData());
        V.execCommand("mceUpdateImage", !1, rl(I, O.hasAccessibilityOptions)), V.editorUpload.uploadImagesAuto(), x.close();
      };
    };
  }, va = function(V) {
    return function(O) {
      return mn(V, O) ? qt(V.documentBaseURI.toAbsolute(O)).then(function(x) {
        return {
          width: String(x.width),
          height: String(x.height)
        };
      }) : He.resolve({
        width: "",
        height: ""
      });
    };
  }, Wl = function(V) {
    return function(O, x, I) {
      return V.editorUpload.blobCache.create({
        blob: O,
        blobUri: x,
        name: O.name ? O.name.replace(/\.[^\.]+$/, "") : null,
        filename: O.name,
        base64: I.split(",")[1]
      });
    };
  }, ql = function(V) {
    return function(O) {
      V.editorUpload.blobCache.add(O);
    };
  }, Yc = function(V) {
    return function(O) {
      V.windowManager.alert(O);
    };
  }, Fa = function(V) {
    return function(O) {
      return Lo(V, O);
    };
  }, ou = function(V) {
    return function(O) {
      return V.dom.parseStyle(O);
    };
  }, Vf = function(V) {
    return function(O, x) {
      return V.dom.serializeStyle(O, x);
    };
  }, _u = function(V) {
    return function(O) {
      return Et(V).upload([O], !1).then(function(x) {
        return x.length === 0 ? He.reject("Failed to upload image") : x[0].status === !1 ? He.reject(x[0].error.message) : x[0];
      });
    };
  }, wo = function(V) {
    var O = {
      onSubmit: yc(V),
      imageSize: va(V),
      addToBlobCache: ql(V),
      createBlobCache: Wl(V),
      alertErr: Yc(V),
      normalizeCss: Fa(V),
      parseStyle: ou(V),
      serializeStyle: Vf(V),
      uploadImage: _u(V)
    }, x = function() {
      vo(V).then(bs(O)).then(V.windowManager.open);
    };
    return { open: x };
  }, Ls = function(V) {
    V.addCommand("mceImage", wo(V).open), V.addCommand("mceUpdateImage", function(O, x) {
      V.undoManager.transact(function() {
        return gn(V, x);
      });
    });
  }, Ut = function(V) {
    var O = V.attr("class");
    return O && /\bimage\b/.test(O);
  }, ol = function(V) {
    return function(O) {
      for (var x = O.length, I = function(Oe) {
        Oe.attr("contenteditable", V ? "true" : null);
      }; x--; ) {
        var re = O[x];
        Ut(re) && (re.attr("contenteditable", V ? "false" : null), Ot.each(re.getAll("figcaption"), I));
      }
    };
  }, Co = function(V) {
    V.on("PreInit", function() {
      V.parser.addNodeFilter("figure", ol(!0)), V.serializer.addNodeFilter("figure", ol(!1));
    });
  }, wc = function(V) {
    V.ui.registry.addToggleButton("image", {
      icon: "image",
      tooltip: "Insert/edit image",
      onAction: wo(V).open,
      onSetup: function(O) {
        return O.setActive(D(yo(V))), V.selection.selectorChangedWithUnbind("img:not([data-mce-object],[data-mce-placeholder]),figure.image", O.setActive).unbind;
      }
    }), V.ui.registry.addMenuItem("image", {
      icon: "image",
      text: "Image...",
      onAction: wo(V).open
    }), V.ui.registry.addContextMenu("image", {
      update: function(O) {
        return go(O) || gi(O) && !yt(O) ? ["image"] : [];
      }
    });
  };
  function ys() {
    m.add("image", function(V) {
      Co(V), wc(V), Ls(V);
    });
  }
  ys();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(dt) {
    var Tt = typeof dt;
    return dt === null ? "null" : Tt === "object" && (Array.prototype.isPrototypeOf(dt) || dt.constructor && dt.constructor.name === "Array") ? "array" : Tt === "object" && (String.prototype.isPrototypeOf(dt) || dt.constructor && dt.constructor.name === "String") ? "string" : Tt;
  }, w = function(dt) {
    return function(Tt) {
      return y(Tt) === dt;
    };
  }, E = w("string"), P = w("array"), H = tinymce.util.Tools.resolve("tinymce.dom.DOMUtils"), X = tinymce.util.Tools.resolve("tinymce.EditorManager"), j = tinymce.util.Tools.resolve("tinymce.Env"), le = tinymce.util.Tools.resolve("tinymce.util.Tools"), Q = function(dt) {
    return dt.getParam("importcss_merge_classes");
  }, pe = function(dt) {
    return dt.getParam("importcss_exclusive");
  }, Y = function(dt) {
    return dt.getParam("importcss_selector_converter");
  }, D = function(dt) {
    return dt.getParam("importcss_selector_filter");
  }, J = function(dt) {
    return dt.getParam("importcss_groups");
  }, ue = function(dt) {
    return dt.getParam("importcss_append");
  }, ee = function(dt) {
    return dt.getParam("importcss_file_filter");
  }, Ge = function(dt) {
    var Tt = dt.getParam("skin");
    return Tt !== !1 ? Tt || "oxide" : !1;
  }, ze = function(dt) {
    return dt.getParam("skin_url");
  }, ht = Array.prototype.push, ie = function(dt, Tt) {
    for (var Jt = dt.length, se = new Array(Jt), tr = 0; tr < Jt; tr++) {
      var _t = dt[tr];
      se[tr] = Tt(_t, tr);
    }
    return se;
  }, Ze = function(dt) {
    for (var Tt = [], Jt = 0, se = dt.length; Jt < se; ++Jt) {
      if (!P(dt[Jt]))
        throw new Error("Arr.flatten item " + Jt + " was not an array, input: " + dt);
      ht.apply(Tt, dt[Jt]);
    }
    return Tt;
  }, De = function(dt, Tt) {
    return Ze(ie(dt, Tt));
  }, Pt = function() {
    var dt = [], Tt = [], Jt = {}, se = function(Pe, kt) {
      Jt[Pe] ? Jt[Pe].push(kt) : (Tt.push(Pe), Jt[Pe] = [kt]);
    }, tr = function(Pe) {
      dt.push(Pe);
    }, _t = function() {
      var Pe = De(Tt, function(kt) {
        var He = Jt[kt];
        return He.length === 0 ? [] : [{
          title: kt,
          items: He
        }];
      });
      return Pe.concat(dt);
    };
    return {
      addItemToGroup: se,
      addItem: tr,
      toFormats: _t
    };
  }, Ct = /^\.(?:ephox|tiny-pageembed|mce)(?:[.-]+\w+)+$/, Be = function(dt) {
    var Tt = j.cacheSuffix;
    return E(dt) && (dt = dt.replace("?" + Tt, "").replace("&" + Tt, "")), dt;
  }, ge = function(dt, Tt) {
    var Jt = Ge(dt);
    if (Jt) {
      var se = ze(dt), tr = se ? dt.documentBaseURI.toAbsolute(se) : X.baseURL + "/skins/ui/" + Jt, _t = X.baseURL + "/skins/content/";
      return Tt === tr + "/content" + (dt.inline ? ".inline" : "") + ".min.css" || Tt.indexOf(_t) !== -1;
    }
    return !1;
  }, xe = function(dt) {
    return E(dt) ? function(Tt) {
      return Tt.indexOf(dt) !== -1;
    } : dt instanceof RegExp ? function(Tt) {
      return dt.test(Tt);
    } : dt;
  }, _e = function(dt) {
    return dt.styleSheet;
  }, $ = function(dt) {
    return dt.selectorText;
  }, N = function(dt, Tt, Jt) {
    var se = [], tr = {}, _t = function(Pe, kt) {
      var He = Pe.href, We;
      if (He = Be(He), !(!He || !Jt(He, kt) || ge(dt, He))) {
        le.each(Pe.imports, function(Ae) {
          _t(Ae, !0);
        });
        try {
          We = Pe.cssRules || Pe.rules;
        } catch {
        }
        le.each(We, function(Ae) {
          _e(Ae) ? _t(Ae.styleSheet, !0) : $(Ae) && le.each(Ae.selectorText.split(","), function(Ke) {
            se.push(le.trim(Ke));
          });
        });
      }
    };
    le.each(dt.contentCSS, function(Pe) {
      tr[Pe] = !0;
    }), Jt || (Jt = function(Pe, kt) {
      return kt || tr[Pe];
    });
    try {
      le.each(Tt.styleSheets, function(Pe) {
        _t(Pe);
      });
    } catch {
    }
    return se;
  }, ae = function(dt, Tt) {
    var Jt, se = /^(?:([a-z0-9\-_]+))?(\.[a-z0-9_\-\.]+)$/i.exec(Tt);
    if (!!se) {
      var tr = se[1], _t = se[2].substr(1).split(".").join(" "), Pe = le.makeMap("a,img");
      return se[1] ? (Jt = { title: Tt }, dt.schema.getTextBlockElements()[tr] ? Jt.block = tr : dt.schema.getBlockElements()[tr] || Pe[tr.toLowerCase()] ? Jt.selector = tr : Jt.inline = tr) : se[2] && (Jt = {
        inline: "span",
        title: Tt.substr(1),
        classes: _t
      }), Q(dt) !== !1 ? Jt.classes = _t : Jt.attributes = { class: _t }, Jt;
    }
  }, ce = function(dt, Tt) {
    return le.grep(dt, function(Jt) {
      return !Jt.filter || Jt.filter(Tt);
    });
  }, ne = function(dt) {
    return le.map(dt, function(Tt) {
      return le.extend({}, Tt, {
        original: Tt,
        selectors: {},
        filter: xe(Tt.filter)
      });
    });
  }, Ce = function(dt, Tt) {
    return Tt === null || pe(dt) !== !1;
  }, Te = function(dt, Tt, Jt, se) {
    return !(Ce(dt, Jt) ? Tt in se : Tt in Jt.selectors);
  }, _ = function(dt, Tt, Jt, se) {
    Ce(dt, Jt) ? se[Tt] = !0 : Jt.selectors[Tt] = !0;
  }, je = function(dt, Tt, Jt, se) {
    var tr;
    return se && se.selector_converter ? tr = se.selector_converter : Y(dt) ? tr = Y(dt) : tr = function() {
      return ae(dt, Jt);
    }, tr.call(Tt, Jt, se);
  }, Me = function(dt) {
    dt.on("init", function() {
      var Tt = Pt(), Jt = {}, se = xe(D(dt)), tr = ne(J(dt)), _t = function(kt, He) {
        if (Te(dt, kt, He, Jt)) {
          _(dt, kt, He, Jt);
          var We = je(dt, dt.plugins.importcss, kt, He);
          if (We) {
            var Ae = We.name || H.DOM.uniqueId();
            return dt.formatter.register(Ae, We), {
              title: We.title,
              format: Ae
            };
          }
        }
        return null;
      };
      le.each(N(dt, dt.getDoc(), xe(ee(dt))), function(kt) {
        if (!Ct.test(kt) && (!se || se(kt))) {
          var He = ce(tr, kt);
          if (He.length > 0)
            le.each(He, function(Ae) {
              var Ke = _t(kt, Ae);
              Ke && Tt.addItemToGroup(Ae.title, Ke);
            });
          else {
            var We = _t(kt, null);
            We && Tt.addItem(We);
          }
        }
      });
      var Pe = Tt.toFormats();
      dt.fire("addStyleModifications", {
        items: Pe,
        replace: !ue(dt)
      });
    });
  }, Je = function(dt) {
    var Tt = function(Jt) {
      return ae(dt, Jt);
    };
    return { convertSelectorToFormat: Tt };
  };
  function Lt() {
    m.add("importcss", function(dt) {
      return Me(dt), Je(dt);
    });
  }
  Lt();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(ie) {
    return ie.getParam("insertdatetime_dateformat", ie.translate("%Y-%m-%d"));
  }, w = function(ie) {
    return ie.getParam("insertdatetime_timeformat", ie.translate("%H:%M:%S"));
  }, E = function(ie) {
    return ie.getParam("insertdatetime_formats", [
      "%H:%M:%S",
      "%Y-%m-%d",
      "%I:%M:%S %p",
      "%D"
    ]);
  }, P = function(ie) {
    var Ze = E(ie);
    return Ze.length > 0 ? Ze[0] : w(ie);
  }, H = function(ie) {
    return ie.getParam("insertdatetime_element", !1);
  }, X = "Sun Mon Tue Wed Thu Fri Sat Sun".split(" "), j = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday Sunday".split(" "), le = "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "), Q = "January February March April May June July August September October November December".split(" "), pe = function(ie, Ze) {
    if (ie = "" + ie, ie.length < Ze)
      for (var De = 0; De < Ze - ie.length; De++)
        ie = "0" + ie;
    return ie;
  }, Y = function(ie, Ze, De) {
    return De === void 0 && (De = new Date()), Ze = Ze.replace("%D", "%m/%d/%Y"), Ze = Ze.replace("%r", "%I:%M:%S %p"), Ze = Ze.replace("%Y", "" + De.getFullYear()), Ze = Ze.replace("%y", "" + De.getYear()), Ze = Ze.replace("%m", pe(De.getMonth() + 1, 2)), Ze = Ze.replace("%d", pe(De.getDate(), 2)), Ze = Ze.replace("%H", "" + pe(De.getHours(), 2)), Ze = Ze.replace("%M", "" + pe(De.getMinutes(), 2)), Ze = Ze.replace("%S", "" + pe(De.getSeconds(), 2)), Ze = Ze.replace("%I", "" + ((De.getHours() + 11) % 12 + 1)), Ze = Ze.replace("%p", De.getHours() < 12 ? "AM" : "PM"), Ze = Ze.replace("%B", "" + ie.translate(Q[De.getMonth()])), Ze = Ze.replace("%b", "" + ie.translate(le[De.getMonth()])), Ze = Ze.replace("%A", "" + ie.translate(j[De.getDay()])), Ze = Ze.replace("%a", "" + ie.translate(X[De.getDay()])), Ze = Ze.replace("%%", "%"), Ze;
  }, D = function(ie, Ze, De, Pt) {
    var Ct = ie.dom.create("time", { datetime: De }, Pt);
    Ze.parentNode.insertBefore(Ct, Ze), ie.dom.remove(Ze), ie.selection.select(Ct, !0), ie.selection.collapse(!1);
  }, J = function(ie, Ze) {
    if (H(ie)) {
      var De = Y(ie, Ze), Pt = void 0;
      /%[HMSIp]/.test(Ze) ? Pt = Y(ie, "%Y-%m-%dT%H:%M") : Pt = Y(ie, "%Y-%m-%d");
      var Ct = ie.dom.getParent(ie.selection.getStart(), "time");
      Ct ? D(ie, Ct, Pt, De) : ie.insertContent('<time datetime="' + Pt + '">' + De + "</time>");
    } else
      ie.insertContent(Y(ie, Ze));
  }, ue = function(ie) {
    ie.addCommand("mceInsertDate", function(Ze, De) {
      J(ie, De != null ? De : y(ie));
    }), ie.addCommand("mceInsertTime", function(Ze, De) {
      J(ie, De != null ? De : w(ie));
    });
  }, ee = function(ie) {
    var Ze = ie, De = function() {
      return Ze;
    }, Pt = function(Ct) {
      Ze = Ct;
    };
    return {
      get: De,
      set: Pt
    };
  }, Ge = tinymce.util.Tools.resolve("tinymce.util.Tools"), ze = function(ie) {
    var Ze = E(ie), De = ee(P(ie)), Pt = function(Be) {
      return ie.execCommand("mceInsertDate", !1, Be);
    };
    ie.ui.registry.addSplitButton("insertdatetime", {
      icon: "insert-time",
      tooltip: "Insert date/time",
      select: function(Be) {
        return Be === De.get();
      },
      fetch: function(Be) {
        Be(Ge.map(Ze, function(ge) {
          return {
            type: "choiceitem",
            text: Y(ie, ge),
            value: ge
          };
        }));
      },
      onAction: function(Be) {
        Pt(De.get());
      },
      onItemAction: function(Be, ge) {
        De.set(ge), Pt(ge);
      }
    });
    var Ct = function(Be) {
      return function() {
        De.set(Be), Pt(Be);
      };
    };
    ie.ui.registry.addNestedMenuItem("insertdatetime", {
      icon: "insert-time",
      text: "Date/time",
      getSubmenuItems: function() {
        return Ge.map(Ze, function(Be) {
          return {
            type: "menuitem",
            text: Y(ie, Be),
            onAction: Ct(Be)
          };
        });
      }
    });
  };
  function ht() {
    m.add("insertdatetime", function(ie) {
      ue(ie), ze(ie);
    });
  }
  ht();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = tinymce.util.Tools.resolve("tinymce.util.VK"), w = function(ve) {
    var nt = typeof ve;
    return ve === null ? "null" : nt === "object" && (Array.prototype.isPrototypeOf(ve) || ve.constructor && ve.constructor.name === "Array") ? "array" : nt === "object" && (String.prototype.isPrototypeOf(ve) || ve.constructor && ve.constructor.name === "String") ? "string" : nt;
  }, E = function(ve) {
    return function(nt) {
      return w(nt) === ve;
    };
  }, P = function(ve) {
    return function(nt) {
      return typeof nt === ve;
    };
  }, H = function(ve) {
    return function(nt) {
      return ve === nt;
    };
  }, X = E("string"), j = E("array"), le = H(null), Q = P("boolean"), pe = P("function"), Y = function() {
  }, D = function(ve) {
    return function() {
      return ve;
    };
  }, J = function(ve) {
    return ve;
  }, ue = function(ve, nt) {
    return ve === nt;
  }, ee = D(!1), Ge = D(!0), ze = function() {
    return ht;
  }, ht = function() {
    var ve = function(Zt) {
      return Zt();
    }, nt = J, wt = {
      fold: function(Zt, En) {
        return Zt();
      },
      isSome: ee,
      isNone: Ge,
      getOr: nt,
      getOrThunk: ve,
      getOrDie: function(Zt) {
        throw new Error(Zt || "error: getOrDie called on none.");
      },
      getOrNull: D(null),
      getOrUndefined: D(void 0),
      or: nt,
      orThunk: ve,
      map: ze,
      each: Y,
      bind: ze,
      exists: ee,
      forall: Ge,
      filter: function() {
        return ze();
      },
      toArray: function() {
        return [];
      },
      toString: D("none()")
    };
    return wt;
  }(), ie = function(ve) {
    var nt = D(ve), wt = function() {
      return En;
    }, Zt = function(lr) {
      return lr(ve);
    }, En = {
      fold: function(lr, ya) {
        return ya(ve);
      },
      isSome: Ge,
      isNone: ee,
      getOr: nt,
      getOrThunk: nt,
      getOrDie: nt,
      getOrNull: nt,
      getOrUndefined: nt,
      or: wt,
      orThunk: wt,
      map: function(lr) {
        return ie(lr(ve));
      },
      each: function(lr) {
        lr(ve);
      },
      bind: Zt,
      exists: Zt,
      forall: Zt,
      filter: function(lr) {
        return lr(ve) ? En : ht;
      },
      toArray: function() {
        return [ve];
      },
      toString: function() {
        return "some(" + ve + ")";
      }
    };
    return En;
  }, Ze = function(ve) {
    return ve == null ? ht : ie(ve);
  }, De = {
    some: ie,
    none: ze,
    from: Ze
  }, Pt = Array.prototype.indexOf, Ct = Array.prototype.push, Be = function(ve, nt) {
    return Pt.call(ve, nt);
  }, ge = function(ve, nt) {
    return Be(ve, nt) > -1;
  }, xe = function(ve, nt) {
    for (var wt = ve.length, Zt = new Array(wt), En = 0; En < wt; En++) {
      var lr = ve[En];
      Zt[En] = nt(lr, En);
    }
    return Zt;
  }, _e = function(ve, nt) {
    for (var wt = 0, Zt = ve.length; wt < Zt; wt++) {
      var En = ve[wt];
      nt(En, wt);
    }
  }, $ = function(ve, nt, wt) {
    return _e(ve, function(Zt, En) {
      wt = nt(wt, Zt, En);
    }), wt;
  }, N = function(ve) {
    for (var nt = [], wt = 0, Zt = ve.length; wt < Zt; ++wt) {
      if (!j(ve[wt]))
        throw new Error("Arr.flatten item " + wt + " was not an array, input: " + ve);
      Ct.apply(nt, ve[wt]);
    }
    return nt;
  }, ae = function(ve, nt) {
    return N(xe(ve, nt));
  }, ce = function(ve, nt) {
    for (var wt = 0; wt < ve.length; wt++) {
      var Zt = nt(ve[wt], wt);
      if (Zt.isSome())
        return Zt;
    }
    return De.none();
  }, ne = function(ve, nt, wt) {
    return wt === void 0 && (wt = ue), ve.exists(function(Zt) {
      return wt(Zt, nt);
    });
  }, Ce = function(ve) {
    for (var nt = [], wt = function(En) {
      nt.push(En);
    }, Zt = 0; Zt < ve.length; Zt++)
      ve[Zt].each(wt);
    return nt;
  }, Te = function(ve, nt) {
    return ve ? De.some(nt) : De.none();
  }, _ = function(ve) {
    var nt = ve.getParam("link_assume_external_targets", !1);
    return Q(nt) && nt ? 1 : X(nt) && (nt === "http" || nt === "https") ? nt : 0;
  }, je = function(ve) {
    return ve.getParam("link_context_toolbar", !1, "boolean");
  }, Me = function(ve) {
    return ve.getParam("link_list");
  }, Je = function(ve) {
    return ve.getParam("default_link_target");
  }, Lt = function(ve) {
    return ve.getParam("target_list", !0);
  }, dt = function(ve) {
    return ve.getParam("rel_list", [], "array");
  }, Tt = function(ve) {
    return ve.getParam("link_class_list", [], "array");
  }, Jt = function(ve) {
    return ve.getParam("link_title", !0, "boolean");
  }, se = function(ve) {
    return ve.getParam("allow_unsafe_link_target", !1, "boolean");
  }, tr = function(ve) {
    return ve.getParam("link_quicklink", !1, "boolean");
  }, _t = function(ve) {
    return ve.getParam("link_default_protocol", "http", "string");
  }, Pe = tinymce.util.Tools.resolve("tinymce.util.Tools"), kt = function(ve) {
    return X(ve.value) ? ve.value : "";
  }, He = function(ve) {
    return X(ve.text) ? ve.text : X(ve.title) ? ve.title : "";
  }, We = function(ve, nt) {
    var wt = [];
    return Pe.each(ve, function(Zt) {
      var En = He(Zt);
      if (Zt.menu !== void 0) {
        var lr = We(Zt.menu, nt);
        wt.push({
          text: En,
          items: lr
        });
      } else {
        var ya = nt(Zt);
        wt.push({
          text: En,
          value: ya
        });
      }
    }), wt;
  }, Ae = function(ve) {
    return ve === void 0 && (ve = kt), function(nt) {
      return De.from(nt).map(function(wt) {
        return We(wt, ve);
      });
    };
  }, Ke = function(ve) {
    return Ae(kt)(ve);
  }, at = function(ve, nt) {
    return function(wt) {
      return {
        name: ve,
        type: "listbox",
        label: nt,
        items: wt
      };
    };
  }, pt = {
    sanitize: Ke,
    sanitizeWith: Ae,
    createUi: at,
    getValue: kt
  }, sn = function() {
    return sn = Object.assign || function(nt) {
      for (var wt, Zt = 1, En = arguments.length; Zt < En; Zt++) {
        wt = arguments[Zt];
        for (var lr in wt)
          Object.prototype.hasOwnProperty.call(wt, lr) && (nt[lr] = wt[lr]);
      }
      return nt;
    }, sn.apply(this, arguments);
  }, Ie = Object.keys, St = Object.hasOwnProperty, Xe = function(ve, nt) {
    for (var wt = Ie(ve), Zt = 0, En = wt.length; Zt < En; Zt++) {
      var lr = wt[Zt], ya = ve[lr];
      nt(ya, lr);
    }
  }, he = function(ve) {
    return function(nt, wt) {
      ve[wt] = nt;
    };
  }, tt = function(ve, nt, wt, Zt) {
    var En = {};
    return Xe(ve, function(lr, ya) {
      (nt(lr, ya) ? wt : Zt)(lr, ya);
    }), En;
  }, gt = function(ve, nt) {
    var wt = {};
    return tt(ve, nt, he(wt), Y), wt;
  }, Ye = function(ve, nt) {
    return St.call(ve, nt);
  }, Qt = function(ve, nt) {
    return Ye(ve, nt) && ve[nt] !== void 0 && ve[nt] !== null;
  }, In = tinymce.util.Tools.resolve("tinymce.dom.TreeWalker"), It = tinymce.util.Tools.resolve("tinymce.util.URI"), qt = function(ve) {
    return ve && ve.nodeName.toLowerCase() === "a";
  }, Vt = function(ve) {
    return qt(ve) && !!Vn(ve);
  }, Xt = function(ve, nt) {
    if (ve.collapsed)
      return [];
    var wt = ve.cloneContents(), Zt = new In(wt.firstChild, wt), En = [], lr = wt.firstChild;
    do
      nt(lr) && En.push(lr);
    while (lr = Zt.next());
    return En;
  }, on = function(ve) {
    return /^\w+:/i.test(ve);
  }, Vn = function(ve) {
    var nt = ve.getAttribute("data-mce-href");
    return nt || ve.getAttribute("href");
  }, Un = function(ve, nt) {
    var wt = ["noopener"], Zt = ve ? ve.split(/\s+/) : [], En = function(Yr) {
      return Pe.trim(Yr.sort().join(" "));
    }, lr = function(Yr) {
      return Yr = ya(Yr), Yr.length > 0 ? Yr.concat(wt) : wt;
    }, ya = function(Yr) {
      return Yr.filter(function(qa) {
        return Pe.inArray(wt, qa) === -1;
      });
    }, Aa = nt ? lr(Zt) : ya(Zt);
    return Aa.length > 0 ? En(Aa) : "";
  }, Tn = function(ve) {
    return ve.replace(/\uFEFF/g, "");
  }, yt = function(ve, nt) {
    return nt = nt || ve.selection.getNode(), ot(nt) ? ve.dom.select("a[href]", nt)[0] : ve.dom.getParent(nt, "a[href]");
  }, mn = function(ve, nt) {
    var wt = nt ? nt.innerText || nt.textContent : ve.getContent({ format: "text" });
    return Tn(wt);
  }, zn = function(ve) {
    return Pe.grep(ve, Vt).length > 0;
  }, _n = function(ve) {
    return Xt(ve, Vt).length > 0;
  }, Kr = function(ve) {
    var nt = ve.schema.getTextInlineElements(), wt = function(En) {
      return En.nodeType === 1 && !qt(En) && !Ye(nt, En.nodeName.toLowerCase());
    }, Zt = Xt(ve.selection.getRng(), wt);
    return Zt.length === 0;
  }, ot = function(ve) {
    return ve && ve.nodeName === "FIGURE" && /\bimage\b/i.test(ve.className);
  }, Yt = function(ve) {
    var nt = [
      "title",
      "rel",
      "class",
      "target"
    ];
    return $(nt, function(wt, Zt) {
      return ve[Zt].each(function(En) {
        wt[Zt] = En.length > 0 ? En : null;
      }), wt;
    }, { href: ve.href });
  }, Ft = function(ve, nt) {
    return (nt === "http" || nt === "https") && !on(ve) ? nt + "://" + ve : ve;
  }, yn = function(ve, nt) {
    var wt = sn({}, nt);
    if (!(dt(ve).length > 0) && se(ve) === !1) {
      var Zt = Un(wt.rel, wt.target === "_blank");
      wt.rel = Zt || null;
    }
    return De.from(wt.target).isNone() && Lt(ve) === !1 && (wt.target = Je(ve)), wt.href = Ft(wt.href, _(ve)), wt;
  }, Yn = function(ve, nt, wt, Zt) {
    wt.each(function(En) {
      Ye(nt, "innerText") ? nt.innerText = En : nt.textContent = En;
    }), ve.dom.setAttribs(nt, Zt), ve.selection.select(nt);
  }, Ir = function(ve, nt, wt, Zt) {
    ot(nt) ? mi(ve, nt, Zt) : wt.fold(function() {
      ve.execCommand("mceInsertLink", !1, Zt);
    }, function(En) {
      ve.insertContent(ve.dom.createHTML("a", Zt, ve.dom.encode(En)));
    });
  }, Wa = function(ve, nt, wt) {
    var Zt = ve.selection.getNode(), En = yt(ve, Zt), lr = yn(ve, Yt(wt));
    ve.undoManager.transact(function() {
      wt.href === nt.href && nt.attach(), En ? (ve.focus(), Yn(ve, En, wt.text, lr)) : Ir(ve, Zt, wt.text, lr);
    });
  }, Mr = function(ve) {
    var nt = ve.dom, wt = ve.selection, Zt = wt.getBookmark(), En = wt.getRng().cloneRange(), lr = nt.getParent(En.startContainer, "a[href]", ve.getBody()), ya = nt.getParent(En.endContainer, "a[href]", ve.getBody());
    lr && En.setStartBefore(lr), ya && En.setEndAfter(ya), wt.setRng(En), ve.execCommand("unlink"), wt.moveToBookmark(Zt);
  }, Fr = function(ve) {
    ve.undoManager.transact(function() {
      var nt = ve.selection.getNode();
      ot(nt) ? bo(ve, nt) : Mr(ve), ve.focus();
    });
  }, Va = function(ve) {
    var nt = ve.class, wt = ve.href, Zt = ve.rel, En = ve.target, lr = ve.text, ya = ve.title;
    return gt({
      class: nt.getOrNull(),
      href: wt,
      rel: Zt.getOrNull(),
      target: En.getOrNull(),
      text: lr.getOrNull(),
      title: ya.getOrNull()
    }, function(Aa, Yr) {
      return le(Aa) === !1;
    });
  }, Qo = function(ve, nt) {
    var wt = nt.href;
    return sn(sn({}, nt), { href: It.isDomSafe(wt, "a", ve.settings) ? wt : "" });
  }, Go = function(ve, nt, wt) {
    var Zt = Qo(ve, wt);
    ve.hasPlugin("rtc", !0) ? ve.execCommand("createlink", !1, Va(Zt)) : Wa(ve, nt, Zt);
  }, so = function(ve) {
    ve.hasPlugin("rtc", !0) ? ve.execCommand("unlink") : Fr(ve);
  }, bo = function(ve, nt) {
    var wt = ve.dom.select("img", nt)[0];
    if (wt) {
      var Zt = ve.dom.getParents(wt, "a[href]", nt)[0];
      Zt && (Zt.parentNode.insertBefore(wt, Zt), ve.dom.remove(Zt));
    }
  }, mi = function(ve, nt, wt) {
    var Zt = ve.dom.select("img", nt)[0];
    if (Zt) {
      var En = ve.dom.create("a", wt);
      Zt.parentNode.insertBefore(En, Zt), En.appendChild(Zt);
    }
  }, Ao = function(ve) {
    return Qt(ve, "items");
  }, go = function(ve, nt) {
    return ce(nt, function(wt) {
      return Ao(wt) ? go(ve, wt.items) : Te(wt.value === ve, wt);
    });
  }, gi = function(ve, nt, wt, Zt) {
    var En = Zt[nt], lr = ve.length > 0;
    return En !== void 0 ? go(En, wt).map(function(ya) {
      return {
        url: {
          value: ya.value,
          meta: {
            text: lr ? ve : ya.text,
            attach: Y
          }
        },
        text: lr ? ve : ya.text
      };
    }) : De.none();
  }, na = function(ve, nt) {
    return nt === "link" ? ve.link : nt === "anchor" ? ve.anchor : De.none();
  }, ei = function(ve, nt) {
    var wt = {
      text: ve.text,
      title: ve.title
    }, Zt = function(Yr) {
      return Te(wt.title.length <= 0, De.from(Yr.meta.title).getOr(""));
    }, En = function(Yr) {
      return Te(wt.text.length <= 0, De.from(Yr.meta.text).getOr(Yr.value));
    }, lr = function(Yr) {
      var qa = En(Yr.url), ao = Zt(Yr.url);
      return qa.isSome() || ao.isSome() ? De.some(sn(sn({}, qa.map(function(es) {
        return { text: es };
      }).getOr({})), ao.map(function(es) {
        return { title: es };
      }).getOr({}))) : De.none();
    }, ya = function(Yr, qa) {
      var ao = na(nt, qa.name).getOr([]);
      return gi(wt.text, qa.name, ao, Yr);
    }, Aa = function(Yr, qa) {
      var ao = qa.name;
      return ao === "url" ? lr(Yr()) : ge([
        "anchor",
        "link"
      ], ao) ? ya(Yr(), qa) : ((ao === "text" || ao === "title") && (wt[ao] = Yr()[ao]), De.none());
    };
    return { onChange: Aa };
  }, sr = {
    init: ei,
    getDelta: gi
  }, $u = tinymce.util.Tools.resolve("tinymce.util.Delay"), Ko = tinymce.util.Tools.resolve("tinymce.util.Promise"), pi = function(ve, nt, wt) {
    var Zt = ve.selection.getRng();
    $u.setEditorTimeout(ve, function() {
      ve.windowManager.confirm(nt, function(En) {
        ve.selection.setRng(Zt), wt(En);
      });
    });
  }, Po = function(ve) {
    var nt = ve.href, wt = nt.indexOf("@") > 0 && nt.indexOf("/") === -1 && nt.indexOf("mailto:") === -1;
    return wt ? De.some({
      message: "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?",
      preprocess: function(Zt) {
        return sn(sn({}, Zt), { href: "mailto:" + nt });
      }
    }) : De.none();
  }, Si = function(ve, nt) {
    return function(wt) {
      var Zt = wt.href, En = ve === 1 && !on(Zt) || ve === 0 && /^\s*www(\.|\d\.)/i.test(Zt);
      return En ? De.some({
        message: "The URL you entered seems to be an external link. Do you want to add the required " + nt + ":// prefix?",
        preprocess: function(lr) {
          return sn(sn({}, lr), { href: nt + "://" + Zt });
        }
      }) : De.none();
    };
  }, Su = function(ve, nt) {
    return ce([
      Po,
      Si(_(ve), _t(ve))
    ], function(wt) {
      return wt(nt);
    }).fold(function() {
      return Ko.resolve(nt);
    }, function(wt) {
      return new Ko(function(Zt) {
        pi(ve, wt.message, function(En) {
          Zt(En ? wt.preprocess(nt) : nt);
        });
      });
    });
  }, xi = { preprocess: Su }, Ju = function(ve) {
    var nt = ve.dom.select("a:not([href])"), wt = ae(nt, function(Zt) {
      var En = Zt.name || Zt.id;
      return En ? [{
        text: En,
        value: "#" + En
      }] : [];
    });
    return wt.length > 0 ? De.some([{
      text: "None",
      value: ""
    }].concat(wt)) : De.none();
  }, Lo = { getAnchors: Ju }, yo = function(ve) {
    var nt = Tt(ve);
    return nt.length > 0 ? pt.sanitize(nt) : De.none();
  }, Bn = { getClasses: yo }, xu = tinymce.util.Tools.resolve("tinymce.util.XHR"), ku = function(ve) {
    try {
      return De.some(JSON.parse(ve));
    } catch {
      return De.none();
    }
  }, Tu = function(ve) {
    var nt = function(Zt) {
      return ve.convertURL(Zt.value || Zt.url, "href");
    }, wt = Me(ve);
    return new Ko(function(Zt) {
      X(wt) ? xu.send({
        url: wt,
        success: function(En) {
          return Zt(ku(En));
        },
        error: function(En) {
          return Zt(De.none());
        }
      }) : pe(wt) ? wt(function(En) {
        return Zt(De.some(En));
      }) : Zt(De.from(wt));
    }).then(function(Zt) {
      return Zt.bind(pt.sanitizeWith(nt)).map(function(En) {
        if (En.length > 0) {
          var lr = [{
            text: "None",
            value: ""
          }];
          return lr.concat(En);
        } else
          return En;
      });
    });
  }, Ue = { getLinks: Tu }, et = function(ve, nt) {
    var wt = dt(ve);
    if (wt.length > 0) {
      var Zt = ne(nt, "_blank"), En = se(ve) === !1, lr = function(Aa) {
        return Un(pt.getValue(Aa), Zt);
      }, ya = En ? pt.sanitizeWith(lr) : pt.sanitize;
      return ya(wt);
    }
    return De.none();
  }, en = { getRels: et }, gn = [
    {
      text: "Current window",
      value: ""
    },
    {
      text: "New window",
      value: "_blank"
    }
  ], Z = function(ve) {
    var nt = Lt(ve);
    return j(nt) ? pt.sanitize(nt).orThunk(function() {
      return De.some(gn);
    }) : nt === !1 ? De.none() : De.some(gn);
  }, ye = { getTargets: Z }, Ve = function(ve, nt, wt) {
    var Zt = ve.getAttrib(nt, wt);
    return Zt !== null && Zt.length > 0 ? De.some(Zt) : De.none();
  }, lt = function(ve, nt) {
    var wt = ve.dom, Zt = Kr(ve), En = Zt ? De.some(mn(ve.selection, nt)) : De.none(), lr = nt ? De.some(wt.getAttrib(nt, "href")) : De.none(), ya = nt ? De.from(wt.getAttrib(nt, "target")) : De.none(), Aa = Ve(wt, nt, "rel"), Yr = Ve(wt, nt, "class"), qa = Ve(wt, nt, "title");
    return {
      url: lr,
      text: En,
      title: qa,
      target: ya,
      rel: Aa,
      linkClass: Yr
    };
  }, Et = function(ve, nt) {
    return Ue.getLinks(ve).then(function(wt) {
      var Zt = lt(ve, nt);
      return {
        anchor: Zt,
        catalogs: {
          targets: ye.getTargets(ve),
          rels: en.getRels(ve, Zt.target),
          classes: Bn.getClasses(ve),
          anchor: Lo.getAnchors(ve),
          link: wt
        },
        optNode: De.from(nt),
        flags: { titleEnabled: Jt(ve) }
      };
    });
  }, Ot = { collect: Et }, Rn = function(ve, nt) {
    return function(wt) {
      var Zt = wt.getData();
      if (!Zt.url.value) {
        so(ve), wt.close();
        return;
      }
      var En = function(Aa) {
        return De.from(Zt[Aa]).filter(function(Yr) {
          return !ne(nt.anchor[Aa], Yr);
        });
      }, lr = {
        href: Zt.url.value,
        text: En("text"),
        target: En("target"),
        rel: En("rel"),
        class: En("linkClass"),
        title: En("title")
      }, ya = {
        href: Zt.url.value,
        attach: Zt.url.meta !== void 0 && Zt.url.meta.attach ? Zt.url.meta.attach : Y
      };
      xi.preprocess(ve, lr).then(function(Aa) {
        Go(ve, ya, Aa);
      }), wt.close();
    };
  }, er = function(ve) {
    var nt = yt(ve);
    return Ot.collect(ve, nt);
  }, Rr = function(ve, nt) {
    var wt = ve.anchor, Zt = wt.url.getOr("");
    return {
      url: {
        value: Zt,
        meta: { original: { value: Zt } }
      },
      text: wt.text.getOr(""),
      title: wt.title.getOr(""),
      anchor: Zt,
      link: Zt,
      rel: wt.rel.getOr(""),
      target: wt.target.or(nt).getOr(""),
      linkClass: wt.linkClass.getOr("")
    };
  }, Nt = function(ve, nt, wt) {
    var Zt = [{
      name: "url",
      type: "urlinput",
      filetype: "file",
      label: "URL"
    }], En = ve.anchor.text.map(function() {
      return {
        name: "text",
        type: "input",
        label: "Text to display"
      };
    }).toArray(), lr = ve.flags.titleEnabled ? [{
      name: "title",
      type: "input",
      label: "Title"
    }] : [], ya = De.from(Je(wt)), Aa = Rr(ve, ya), Yr = ve.catalogs, qa = sr.init(Aa, Yr), ao = {
      type: "panel",
      items: N([
        Zt,
        En,
        lr,
        Ce([
          Yr.anchor.map(pt.createUi("anchor", "Anchors")),
          Yr.rels.map(pt.createUi("rel", "Rel")),
          Yr.targets.map(pt.createUi("target", "Open link in...")),
          Yr.link.map(pt.createUi("link", "Link list")),
          Yr.classes.map(pt.createUi("linkClass", "Class"))
        ])
      ])
    };
    return {
      title: "Insert/Edit Link",
      size: "normal",
      body: ao,
      buttons: [
        {
          type: "cancel",
          name: "cancel",
          text: "Cancel"
        },
        {
          type: "submit",
          name: "save",
          text: "Save",
          primary: !0
        }
      ],
      initialData: Aa,
      onChange: function(es, ti) {
        var zu = ti.name;
        qa.onChange(es.getData, { name: zu }).each(function(br) {
          es.setData(br);
        });
      },
      onSubmit: nt
    };
  }, vr = function(ve) {
    var nt = er(ve);
    nt.then(function(wt) {
      var Zt = Rn(ve, wt);
      return Nt(wt, Zt, ve);
    }).then(function(wt) {
      ve.windowManager.open(wt);
    });
  }, Nr = function(ve, nt) {
    document.body.appendChild(ve), ve.dispatchEvent(nt), document.body.removeChild(ve);
  }, Sa = function(ve) {
    var nt = document.createElement("a");
    nt.target = "_blank", nt.href = ve, nt.rel = "noreferrer noopener";
    var wt = document.createEvent("MouseEvents");
    wt.initMouseEvent("click", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), Nr(nt, wt);
  }, po = function(ve, nt) {
    return ve.dom.getParent(nt, "a[href]");
  }, Xr = function(ve) {
    return po(ve, ve.selection.getStart());
  }, Lu = function(ve) {
    return ve.altKey === !0 && ve.shiftKey === !1 && ve.ctrlKey === !1 && ve.metaKey === !1;
  }, Eu = function(ve, nt) {
    if (nt) {
      var wt = Vn(nt);
      if (/^#/.test(wt)) {
        var Zt = ve.$(wt);
        Zt.length && ve.selection.scrollIntoView(Zt[0], !0);
      } else
        Sa(nt.href);
    }
  }, vo = function(ve) {
    return function() {
      vr(ve);
    };
  }, Fs = function(ve) {
    return function() {
      Eu(ve, Xr(ve));
    };
  }, ki = function(ve) {
    ve.on("click", function(nt) {
      var wt = po(ve, nt.target);
      wt && y.metaKeyPressed(nt) && (nt.preventDefault(), Eu(ve, wt));
    }), ve.on("keydown", function(nt) {
      var wt = Xr(ve);
      wt && nt.keyCode === 13 && Lu(nt) && (nt.preventDefault(), Eu(ve, wt));
    });
  }, Fi = function(ve, nt) {
    return ve.on("NodeChange", nt), function() {
      return ve.off("NodeChange", nt);
    };
  }, za = function(ve) {
    return function(nt) {
      var wt = function() {
        return nt.setActive(!ve.mode.isReadOnly() && yt(ve, ve.selection.getNode()) !== null);
      };
      return wt(), Fi(ve, wt);
    };
  }, $s = function(ve) {
    return function(nt) {
      var wt = function() {
        return nt.setDisabled(yt(ve, ve.selection.getNode()) === null);
      };
      return wt(), Fi(ve, wt);
    };
  }, Qu = function(ve) {
    return function(nt) {
      var wt = function(En) {
        return zn(En) || _n(ve.selection.getRng());
      }, Zt = ve.dom.getParents(ve.selection.getStart());
      return nt.setDisabled(!wt(Zt)), Fi(ve, function(En) {
        return nt.setDisabled(!wt(En.parents));
      });
    };
  }, hs = function(ve) {
    ve.addCommand("mceLink", function() {
      tr(ve) ? ve.fire("contexttoolbar-show", { toolbarKey: "quicklink" }) : vo(ve)();
    });
  }, rl = function(ve) {
    ve.addShortcut("Meta+K", "", function() {
      ve.execCommand("mceLink");
    });
  }, $i = function(ve) {
    ve.ui.registry.addToggleButton("link", {
      icon: "link",
      tooltip: "Insert/edit link",
      onAction: vo(ve),
      onSetup: za(ve)
    }), ve.ui.registry.addButton("openlink", {
      icon: "new-tab",
      tooltip: "Open link",
      onAction: Fs(ve),
      onSetup: $s(ve)
    }), ve.ui.registry.addButton("unlink", {
      icon: "unlink",
      tooltip: "Remove link",
      onAction: function() {
        return so(ve);
      },
      onSetup: Qu(ve)
    });
  }, au = function(ve) {
    ve.ui.registry.addMenuItem("openlink", {
      text: "Open link",
      icon: "new-tab",
      onAction: Fs(ve),
      onSetup: $s(ve)
    }), ve.ui.registry.addMenuItem("link", {
      icon: "link",
      text: "Link...",
      shortcut: "Meta+K",
      onAction: vo(ve)
    }), ve.ui.registry.addMenuItem("unlink", {
      icon: "unlink",
      text: "Remove link",
      onAction: function() {
        return so(ve);
      },
      onSetup: Qu(ve)
    });
  }, al = function(ve) {
    var nt = "link unlink openlink", wt = "link";
    ve.ui.registry.addContextMenu("link", {
      update: function(Zt) {
        return zn(ve.dom.getParents(Zt, "a")) ? nt : wt;
      }
    });
  }, qi = function(ve) {
    var nt = function(En) {
      En.selection.collapse(!1);
    }, wt = function(En) {
      var lr = ve.selection.getNode();
      return En.setDisabled(!yt(ve, lr)), Y;
    }, Zt = function(En) {
      var lr = yt(ve), ya = Kr(ve);
      if (!lr && ya) {
        var Aa = mn(ve.selection, lr);
        return De.some(Aa.length > 0 ? Aa : En);
      } else
        return De.none();
    };
    ve.ui.registry.addContextForm("quicklink", {
      launch: {
        type: "contextformtogglebutton",
        icon: "link",
        tooltip: "Link",
        onSetup: za(ve)
      },
      label: "Link",
      predicate: function(En) {
        return !!yt(ve, En) && je(ve);
      },
      initValue: function() {
        var En = yt(ve);
        return En ? Vn(En) : "";
      },
      commands: [
        {
          type: "contextformtogglebutton",
          icon: "link",
          tooltip: "Link",
          primary: !0,
          onSetup: function(En) {
            var lr = ve.selection.getNode();
            return En.setActive(!!yt(ve, lr)), za(ve)(En);
          },
          onAction: function(En) {
            var lr = En.getValue(), ya = Zt(lr), Aa = {
              href: lr,
              attach: Y
            };
            Go(ve, Aa, {
              href: lr,
              text: ya,
              title: De.none(),
              rel: De.none(),
              target: De.none(),
              class: De.none()
            }), nt(ve), En.hide();
          }
        },
        {
          type: "contextformbutton",
          icon: "unlink",
          tooltip: "Remove link",
          onSetup: wt,
          onAction: function(En) {
            so(ve), En.hide();
          }
        },
        {
          type: "contextformbutton",
          icon: "new-tab",
          tooltip: "Open link",
          onSetup: wt,
          onAction: function(En) {
            Fs(ve)(), En.hide();
          }
        }
      ]
    });
  };
  function Li() {
    m.add("link", function(ve) {
      $i(ve), au(ve), al(ve), qi(ve), ki(ve), hs(ve), rl(ve);
    });
  }
  Li();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(M) {
    var G = typeof M;
    return M === null ? "null" : G === "object" && (Array.prototype.isPrototypeOf(M) || M.constructor && M.constructor.name === "Array") ? "array" : G === "object" && (String.prototype.isPrototypeOf(M) || M.constructor && M.constructor.name === "String") ? "string" : G;
  }, w = function(M) {
    return function(G) {
      return y(G) === M;
    };
  }, E = function(M) {
    return function(G) {
      return typeof G === M;
    };
  }, P = w("string"), H = w("object"), X = w("array"), j = E("boolean"), le = E("function"), Q = E("number"), pe = function() {
  }, Y = function(M) {
    return function() {
      return M;
    };
  }, D = function(M) {
    return M;
  }, J = function(M, G) {
    return M === G;
  }, ue = function(M) {
    return function(G) {
      return !M(G);
    };
  }, ee = Y(!1), Ge = Y(!0), ze = function() {
    return ht;
  }, ht = function() {
    var M = function(Fe) {
      return Fe();
    }, G = D, fe = {
      fold: function(Fe, bt) {
        return Fe();
      },
      isSome: ee,
      isNone: Ge,
      getOr: G,
      getOrThunk: M,
      getOrDie: function(Fe) {
        throw new Error(Fe || "error: getOrDie called on none.");
      },
      getOrNull: Y(null),
      getOrUndefined: Y(void 0),
      or: G,
      orThunk: M,
      map: ze,
      each: pe,
      bind: ze,
      exists: ee,
      forall: Ge,
      filter: function() {
        return ze();
      },
      toArray: function() {
        return [];
      },
      toString: Y("none()")
    };
    return fe;
  }(), ie = function(M) {
    var G = Y(M), fe = function() {
      return bt;
    }, Fe = function(Gt) {
      return Gt(M);
    }, bt = {
      fold: function(Gt, fr) {
        return fr(M);
      },
      isSome: Ge,
      isNone: ee,
      getOr: G,
      getOrThunk: G,
      getOrDie: G,
      getOrNull: G,
      getOrUndefined: G,
      or: fe,
      orThunk: fe,
      map: function(Gt) {
        return ie(Gt(M));
      },
      each: function(Gt) {
        Gt(M);
      },
      bind: Fe,
      exists: Fe,
      forall: Fe,
      filter: function(Gt) {
        return Gt(M) ? bt : ht;
      },
      toArray: function() {
        return [M];
      },
      toString: function() {
        return "some(" + M + ")";
      }
    };
    return bt;
  }, Ze = function(M) {
    return M == null ? ht : ie(M);
  }, De = {
    some: ie,
    none: ze,
    from: Ze
  }, Pt = Array.prototype.slice, Ct = Array.prototype.push, Be = function(M, G) {
    for (var fe = M.length, Fe = new Array(fe), bt = 0; bt < fe; bt++) {
      var Gt = M[bt];
      Fe[bt] = G(Gt, bt);
    }
    return Fe;
  }, ge = function(M, G) {
    for (var fe = 0, Fe = M.length; fe < Fe; fe++) {
      var bt = M[fe];
      G(bt, fe);
    }
  }, xe = function(M, G) {
    for (var fe = [], Fe = 0, bt = M.length; Fe < bt; Fe++) {
      var Gt = M[Fe];
      G(Gt, Fe) && fe.push(Gt);
    }
    return fe;
  }, _e = function(M, G) {
    if (M.length === 0)
      return [];
    for (var fe = G(M[0]), Fe = [], bt = [], Gt = 0, fr = M.length; Gt < fr; Gt++) {
      var Wr = M[Gt], da = G(Wr);
      da !== fe && (Fe.push(bt), bt = []), fe = da, bt.push(Wr);
    }
    return bt.length !== 0 && Fe.push(bt), Fe;
  }, $ = function(M, G, fe) {
    return ge(M, function(Fe, bt) {
      fe = G(fe, Fe, bt);
    }), fe;
  }, N = function(M, G, fe) {
    for (var Fe = 0, bt = M.length; Fe < bt; Fe++) {
      var Gt = M[Fe];
      if (G(Gt, Fe))
        return De.some(Gt);
      if (fe(Gt, Fe))
        break;
    }
    return De.none();
  }, ae = function(M, G) {
    return N(M, G, ee);
  }, ce = function(M) {
    for (var G = [], fe = 0, Fe = M.length; fe < Fe; ++fe) {
      if (!X(M[fe]))
        throw new Error("Arr.flatten item " + fe + " was not an array, input: " + M);
      Ct.apply(G, M[fe]);
    }
    return G;
  }, ne = function(M, G) {
    return ce(Be(M, G));
  }, Ce = function(M) {
    var G = Pt.call(M, 0);
    return G.reverse(), G;
  }, Te = function(M, G) {
    return G >= 0 && G < M.length ? De.some(M[G]) : De.none();
  }, _ = function(M) {
    return Te(M, 0);
  }, je = function(M) {
    return Te(M, M.length - 1);
  }, Me = function(M, G) {
    for (var fe = 0; fe < M.length; fe++) {
      var Fe = G(M[fe], fe);
      if (Fe.isSome())
        return Fe;
    }
    return De.none();
  }, Je = function() {
    return Je = Object.assign || function(G) {
      for (var fe, Fe = 1, bt = arguments.length; Fe < bt; Fe++) {
        fe = arguments[Fe];
        for (var Gt in fe)
          Object.prototype.hasOwnProperty.call(fe, Gt) && (G[Gt] = fe[Gt]);
      }
      return G;
    }, Je.apply(this, arguments);
  };
  function Lt(M, G, fe) {
    if (fe || arguments.length === 2)
      for (var Fe = 0, bt = G.length, Gt; Fe < bt; Fe++)
        (Gt || !(Fe in G)) && (Gt || (Gt = Array.prototype.slice.call(G, 0, Fe)), Gt[Fe] = G[Fe]);
    return M.concat(Gt || Array.prototype.slice.call(G));
  }
  var dt = function(M) {
    var G = !1, fe;
    return function() {
      for (var Fe = [], bt = 0; bt < arguments.length; bt++)
        Fe[bt] = arguments[bt];
      return G || (G = !0, fe = M.apply(null, Fe)), fe;
    };
  }, Tt = function(M, G, fe, Fe) {
    var bt = M.isiOS() && /ipad/i.test(fe) === !0, Gt = M.isiOS() && !bt, fr = M.isiOS() || M.isAndroid(), Wr = fr || Fe("(pointer:coarse)"), da = bt || !Gt && fr && Fe("(min-device-width:768px)"), aa = Gt || fr && !da, oo = G.isSafari() && M.isiOS() && /safari/i.test(fe) === !1, su = !aa && !da && !oo;
    return {
      isiPad: Y(bt),
      isiPhone: Y(Gt),
      isTablet: Y(da),
      isPhone: Y(aa),
      isTouch: Y(Wr),
      isAndroid: M.isAndroid,
      isiOS: M.isiOS,
      isWebView: Y(oo),
      isDesktop: Y(su)
    };
  }, Jt = function(M, G) {
    for (var fe = 0; fe < M.length; fe++) {
      var Fe = M[fe];
      if (Fe.test(G))
        return Fe;
    }
  }, se = function(M, G) {
    var fe = Jt(M, G);
    if (!fe)
      return {
        major: 0,
        minor: 0
      };
    var Fe = function(bt) {
      return Number(G.replace(fe, "$" + bt));
    };
    return Pe(Fe(1), Fe(2));
  }, tr = function(M, G) {
    var fe = String(G).toLowerCase();
    return M.length === 0 ? _t() : se(M, fe);
  }, _t = function() {
    return Pe(0, 0);
  }, Pe = function(M, G) {
    return {
      major: M,
      minor: G
    };
  }, kt = {
    nu: Pe,
    detect: tr,
    unknown: _t
  }, He = function(M, G) {
    return Me(G.brands, function(fe) {
      var Fe = fe.brand.toLowerCase();
      return ae(M, function(bt) {
        var Gt;
        return Fe === ((Gt = bt.brand) === null || Gt === void 0 ? void 0 : Gt.toLowerCase());
      }).map(function(bt) {
        return {
          current: bt.name,
          version: kt.nu(parseInt(fe.version, 10), 0)
        };
      });
    });
  }, We = function(M, G) {
    var fe = String(G).toLowerCase();
    return ae(M, function(Fe) {
      return Fe.search(fe);
    });
  }, Ae = function(M, G) {
    return We(M, G).map(function(fe) {
      var Fe = kt.detect(fe.versionRegexes, G);
      return {
        current: fe.name,
        version: Fe
      };
    });
  }, Ke = function(M, G) {
    return We(M, G).map(function(fe) {
      var Fe = kt.detect(fe.versionRegexes, G);
      return {
        current: fe.name,
        version: Fe
      };
    });
  }, at = function(M, G) {
    return M.indexOf(G) !== -1;
  }, pt = function(M) {
    return function(G) {
      return G.replace(M, "");
    };
  }, sn = pt(/^\s+|\s+$/g), Ie = function(M) {
    return M.length > 0;
  }, St = function(M) {
    return !Ie(M);
  }, Xe = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/, he = function(M) {
    return function(G) {
      return at(G, M);
    };
  }, tt = [
    {
      name: "Edge",
      versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
      search: function(M) {
        return at(M, "edge/") && at(M, "chrome") && at(M, "safari") && at(M, "applewebkit");
      }
    },
    {
      name: "Chrome",
      brand: "Chromium",
      versionRegexes: [
        /.*?chrome\/([0-9]+)\.([0-9]+).*/,
        Xe
      ],
      search: function(M) {
        return at(M, "chrome") && !at(M, "chromeframe");
      }
    },
    {
      name: "IE",
      versionRegexes: [
        /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
        /.*?rv:([0-9]+)\.([0-9]+).*/
      ],
      search: function(M) {
        return at(M, "msie") || at(M, "trident");
      }
    },
    {
      name: "Opera",
      versionRegexes: [
        Xe,
        /.*?opera\/([0-9]+)\.([0-9]+).*/
      ],
      search: he("opera")
    },
    {
      name: "Firefox",
      versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
      search: he("firefox")
    },
    {
      name: "Safari",
      versionRegexes: [
        Xe,
        /.*?cpu os ([0-9]+)_([0-9]+).*/
      ],
      search: function(M) {
        return (at(M, "safari") || at(M, "mobile/")) && at(M, "applewebkit");
      }
    }
  ], gt = [
    {
      name: "Windows",
      search: he("win"),
      versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
    },
    {
      name: "iOS",
      search: function(M) {
        return at(M, "iphone") || at(M, "ipad");
      },
      versionRegexes: [
        /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
        /.*cpu os ([0-9]+)_([0-9]+).*/,
        /.*cpu iphone os ([0-9]+)_([0-9]+).*/
      ]
    },
    {
      name: "Android",
      search: he("android"),
      versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
    },
    {
      name: "OSX",
      search: he("mac os x"),
      versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
    },
    {
      name: "Linux",
      search: he("linux"),
      versionRegexes: []
    },
    {
      name: "Solaris",
      search: he("sunos"),
      versionRegexes: []
    },
    {
      name: "FreeBSD",
      search: he("freebsd"),
      versionRegexes: []
    },
    {
      name: "ChromeOS",
      search: he("cros"),
      versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
    }
  ], Ye = {
    browsers: Y(tt),
    oses: Y(gt)
  }, Qt = "Edge", In = "Chrome", It = "IE", qt = "Opera", Vt = "Firefox", Xt = "Safari", on = function() {
    return Vn({
      current: void 0,
      version: kt.unknown()
    });
  }, Vn = function(M) {
    var G = M.current, fe = M.version, Fe = function(bt) {
      return function() {
        return G === bt;
      };
    };
    return {
      current: G,
      version: fe,
      isEdge: Fe(Qt),
      isChrome: Fe(In),
      isIE: Fe(It),
      isOpera: Fe(qt),
      isFirefox: Fe(Vt),
      isSafari: Fe(Xt)
    };
  }, Un = {
    unknown: on,
    nu: Vn,
    edge: Y(Qt),
    chrome: Y(In),
    ie: Y(It),
    opera: Y(qt),
    firefox: Y(Vt),
    safari: Y(Xt)
  }, Tn = "Windows", yt = "iOS", mn = "Android", zn = "Linux", _n = "OSX", Kr = "Solaris", ot = "FreeBSD", Yt = "ChromeOS", Ft = function() {
    return yn({
      current: void 0,
      version: kt.unknown()
    });
  }, yn = function(M) {
    var G = M.current, fe = M.version, Fe = function(bt) {
      return function() {
        return G === bt;
      };
    };
    return {
      current: G,
      version: fe,
      isWindows: Fe(Tn),
      isiOS: Fe(yt),
      isAndroid: Fe(mn),
      isOSX: Fe(_n),
      isLinux: Fe(zn),
      isSolaris: Fe(Kr),
      isFreeBSD: Fe(ot),
      isChromeOS: Fe(Yt)
    };
  }, Yn = {
    unknown: Ft,
    nu: yn,
    windows: Y(Tn),
    ios: Y(yt),
    android: Y(mn),
    linux: Y(zn),
    osx: Y(_n),
    solaris: Y(Kr),
    freebsd: Y(ot),
    chromeos: Y(Yt)
  }, Ir = function(M, G, fe) {
    var Fe = Ye.browsers(), bt = Ye.oses(), Gt = G.bind(function(da) {
      return He(Fe, da);
    }).orThunk(function() {
      return Ae(Fe, M);
    }).fold(Un.unknown, Un.nu), fr = Ke(bt, M).fold(Yn.unknown, Yn.nu), Wr = Tt(fr, Gt, M, fe);
    return {
      browser: Gt,
      os: fr,
      deviceType: Wr
    };
  }, Wa = { detect: Ir }, Mr = function(M) {
    return window.matchMedia(M).matches;
  }, Fr = dt(function() {
    return Wa.detect(navigator.userAgent, De.from(navigator.userAgentData), Mr);
  }), Va = function() {
    return Fr();
  }, Qo = function(M, G, fe) {
    return (M.compareDocumentPosition(G) & fe) !== 0;
  }, Go = function(M, G) {
    return Qo(M, G, Node.DOCUMENT_POSITION_CONTAINED_BY);
  }, so = 1, bo = function(M, G) {
    var fe = G || document, Fe = fe.createElement("div");
    if (Fe.innerHTML = M, !Fe.hasChildNodes() || Fe.childNodes.length > 1)
      throw console.error("HTML does not have a single root node", M), new Error("HTML must have a single root node");
    return go(Fe.childNodes[0]);
  }, mi = function(M, G) {
    var fe = G || document, Fe = fe.createElement(M);
    return go(Fe);
  }, Ao = function(M, G) {
    var fe = G || document, Fe = fe.createTextNode(M);
    return go(Fe);
  }, go = function(M) {
    if (M == null)
      throw new Error("Node cannot be null or undefined");
    return { dom: M };
  }, gi = function(M, G, fe) {
    return De.from(M.dom.elementFromPoint(G, fe)).map(go);
  }, na = {
    fromHtml: bo,
    fromTag: mi,
    fromText: Ao,
    fromDom: go,
    fromPoint: gi
  }, ei = function(M, G) {
    var fe = M.dom;
    if (fe.nodeType !== so)
      return !1;
    var Fe = fe;
    if (Fe.matches !== void 0)
      return Fe.matches(G);
    if (Fe.msMatchesSelector !== void 0)
      return Fe.msMatchesSelector(G);
    if (Fe.webkitMatchesSelector !== void 0)
      return Fe.webkitMatchesSelector(G);
    if (Fe.mozMatchesSelector !== void 0)
      return Fe.mozMatchesSelector(G);
    throw new Error("Browser lacks native selectors");
  }, sr = function(M, G) {
    return M.dom === G.dom;
  }, $u = function(M, G) {
    var fe = M.dom, Fe = G.dom;
    return fe === Fe ? !1 : fe.contains(Fe);
  }, Ko = function(M, G) {
    return Go(M.dom, G.dom);
  }, pi = function(M, G) {
    return Va().browser.isIE() ? Ko(M, G) : $u(M, G);
  }, Po = ei, Si = tinymce.util.Tools.resolve("tinymce.dom.RangeUtils"), Su = tinymce.util.Tools.resolve("tinymce.dom.TreeWalker"), xi = tinymce.util.Tools.resolve("tinymce.util.VK"), Ju = Object.keys, Lo = function(M, G) {
    for (var fe = Ju(M), Fe = 0, bt = fe.length; Fe < bt; Fe++) {
      var Gt = fe[Fe], fr = M[Gt];
      G(fr, Gt);
    }
  }, yo = function(M) {
    return function(G, fe) {
      M[fe] = G;
    };
  }, Bn = function(M, G, fe, Fe) {
    var bt = {};
    return Lo(M, function(Gt, fr) {
      (G(Gt, fr) ? fe : Fe)(Gt, fr);
    }), bt;
  }, xu = function(M, G) {
    var fe = {};
    return Bn(M, G, yo(fe), pe), fe;
  };
  typeof window < "u" || Function("return this;")();
  var ku = function(M) {
    var G = M.dom.nodeName;
    return G.toLowerCase();
  }, Tu = function(M) {
    return M.dom.nodeType;
  }, Ue = function(M) {
    return function(G) {
      return Tu(G) === M;
    };
  }, et = Ue(so), en = function(M) {
    return function(G) {
      return et(G) && ku(G) === M;
    };
  }, gn = function(M, G, fe) {
    if (P(fe) || j(fe) || Q(fe))
      M.setAttribute(G, fe + "");
    else
      throw console.error("Invalid call to Attribute.set. Key ", G, ":: Value ", fe, ":: Element ", M), new Error("Attribute value was not simple");
  }, Z = function(M, G) {
    var fe = M.dom;
    Lo(G, function(Fe, bt) {
      gn(fe, bt, Fe);
    });
  }, ye = function(M) {
    return $(M.dom.attributes, function(G, fe) {
      return G[fe.name] = fe.value, G;
    }, {});
  }, Ve = function(M) {
    return De.from(M.dom.parentNode).map(na.fromDom);
  }, lt = function(M) {
    return Be(M.dom.childNodes, na.fromDom);
  }, Et = function(M, G) {
    var fe = M.dom.childNodes;
    return De.from(fe[G]).map(na.fromDom);
  }, Ot = function(M) {
    return Et(M, 0);
  }, Rn = function(M) {
    return Et(M, M.dom.childNodes.length - 1);
  }, er = function(M, G) {
    var fe = Ve(M);
    fe.each(function(Fe) {
      Fe.dom.insertBefore(G.dom, M.dom);
    });
  }, Rr = function(M, G) {
    M.dom.appendChild(G.dom);
  }, Nt = function(M, G) {
    ge(G, function(fe) {
      er(M, fe);
    });
  }, vr = function(M, G) {
    ge(G, function(fe) {
      Rr(M, fe);
    });
  }, Nr = function(M) {
    var G = M.dom;
    G.parentNode !== null && G.parentNode.removeChild(G);
  }, Sa = function(M, G) {
    return na.fromDom(M.dom.cloneNode(G));
  }, po = function(M) {
    return Sa(M, !0);
  }, Xr = function(M, G) {
    var fe = na.fromTag(G), Fe = ye(M);
    return Z(fe, Fe), fe;
  }, Lu = function(M, G) {
    var fe = Xr(M, G);
    er(M, fe);
    var Fe = lt(M);
    return vr(fe, Fe), Nr(M), fe;
  }, Eu = tinymce.util.Tools.resolve("tinymce.dom.DOMUtils"), vo = tinymce.util.Tools.resolve("tinymce.util.Tools"), Fs = function(M) {
    return function(G) {
      return G && G.nodeName.toLowerCase() === M;
    };
  }, ki = function(M) {
    return function(G) {
      return G && M.test(G.nodeName);
    };
  }, Fi = function(M) {
    return M && M.nodeType === 3;
  }, za = ki(/^(OL|UL|DL)$/), $s = ki(/^(OL|UL)$/), Qu = Fs("ol"), hs = ki(/^(LI|DT|DD)$/), rl = ki(/^(DT|DD)$/), $i = ki(/^(TH|TD)$/), au = Fs("br"), al = function(M) {
    return M.parentNode.firstChild === M;
  }, qi = function(M, G) {
    return G && !!M.schema.getTextBlockElements()[G.nodeName];
  }, Li = function(M, G) {
    return M && M.nodeName in G;
  }, ve = function(M, G) {
    return au(G) ? M.isBlock(G.nextSibling) && !au(G.previousSibling) : !1;
  }, nt = function(M, G, fe) {
    var Fe = M.isEmpty(G);
    return fe && M.select("span[data-mce-type=bookmark]", G).length > 0 ? !1 : Fe;
  }, wt = function(M, G) {
    return M.isChildOf(G, M.getRoot());
  }, Zt = function(M) {
    return M.getParam("lists_indent_on_tab", !0);
  }, En = function(M) {
    var G = M.getParam("forced_root_block", "p");
    return G === !1 ? "" : G === !0 ? "p" : G;
  }, lr = function(M) {
    return M.getParam("forced_root_block_attrs", {});
  }, ya = function(M, G) {
    var fe = M.dom, Fe = M.schema.getBlockElements(), bt = fe.createFragment(), Gt = En(M), fr, Wr, da;
    if (Gt && (Wr = fe.create(Gt), Wr.tagName === Gt.toUpperCase() && fe.setAttribs(Wr, lr(M)), Li(G.firstChild, Fe) || bt.appendChild(Wr)), G)
      for (; fr = G.firstChild; ) {
        var aa = fr.nodeName;
        !da && (aa !== "SPAN" || fr.getAttribute("data-mce-type") !== "bookmark") && (da = !0), Li(fr, Fe) ? (bt.appendChild(fr), Wr = null) : Gt ? (Wr || (Wr = fe.create(Gt), bt.appendChild(Wr)), Wr.appendChild(fr)) : bt.appendChild(fr);
      }
    return Gt ? da || Wr.appendChild(fe.create("br", { "data-mce-bogus": "1" })) : bt.appendChild(fe.create("br")), bt;
  }, Aa = Eu.DOM, Yr = function(M, G, fe) {
    var Fe = function(aa) {
      vo.each(bt, function(oo) {
        aa.parentNode.insertBefore(oo, fe.parentNode);
      }), Aa.remove(aa);
    }, bt = Aa.select('span[data-mce-type="bookmark"]', G), Gt = ya(M, fe), fr = Aa.createRng();
    fr.setStartAfter(fe), fr.setEndAfter(G);
    for (var Wr = fr.extractContents(), da = Wr.firstChild; da; da = da.firstChild)
      if (da.nodeName === "LI" && M.dom.isEmpty(da)) {
        Aa.remove(da);
        break;
      }
    M.dom.isEmpty(Wr) || Aa.insertAfter(Wr, G), Aa.insertAfter(Gt, G), nt(M.dom, fe.parentNode) && Fe(fe.parentNode), Aa.remove(fe), nt(M.dom, G) && Aa.remove(G);
  }, qa = en("dd"), ao = en("dt"), es = function(M, G) {
    qa(G) ? Lu(G, "dt") : ao(G) && Ve(G).each(function(fe) {
      return Yr(M, fe.dom, G.dom);
    });
  }, ti = function(M) {
    ao(M) && Lu(M, "dd");
  }, zu = function(M, G, fe) {
    G === "Indent" ? ge(fe, ti) : ge(fe, function(Fe) {
      return es(M, Fe);
    });
  }, br = function(M, G) {
    if (Fi(M))
      return {
        container: M,
        offset: G
      };
    var fe = Si.getNode(M, G);
    return Fi(fe) ? {
      container: fe,
      offset: G >= M.childNodes.length ? fe.data.length : 0
    } : fe.previousSibling && Fi(fe.previousSibling) ? {
      container: fe.previousSibling,
      offset: fe.previousSibling.data.length
    } : fe.nextSibling && Fi(fe.nextSibling) ? {
      container: fe.nextSibling,
      offset: 0
    } : {
      container: M,
      offset: G
    };
  }, bs = function(M) {
    var G = M.cloneRange(), fe = br(M.startContainer, M.startOffset);
    G.setStart(fe.container, fe.offset);
    var Fe = br(M.endContainer, M.endOffset);
    return G.setEnd(Fe.container, Fe.offset), G;
  }, yc = tinymce.util.Tools.resolve("tinymce.dom.DomQuery"), va = function(M, G) {
    var fe = G || M.selection.getStart(!0);
    return M.dom.getParent(fe, "OL,UL,DL", _u(M, fe));
  }, Wl = function(M, G) {
    return M && G.length === 1 && G[0] === M;
  }, ql = function(M) {
    return xe(M.querySelectorAll("ol,ul,dl"), za);
  }, Yc = function(M) {
    var G = va(M), fe = M.selection.getSelectedBlocks();
    return Wl(G, fe) ? ql(G) : xe(fe, function(Fe) {
      return za(Fe) && G !== Fe;
    });
  }, Fa = function(M, G) {
    var fe = vo.map(G, function(Fe) {
      var bt = M.dom.getParent(Fe, "li,dd,dt", _u(M, Fe));
      return bt || Fe;
    });
    return yc.unique(fe);
  }, ou = function(M) {
    var G = M.selection.getSelectedBlocks();
    return xe(Fa(M, G), hs);
  }, Vf = function(M) {
    return xe(ou(M), rl);
  }, _u = function(M, G) {
    var fe = M.dom.getParents(G, "TD,TH");
    return fe.length > 0 ? fe[0] : M.getBody();
  }, wo = function(M, G) {
    var fe = M.dom.getParents(G, "ol,ul", _u(M, G));
    return je(fe);
  }, Ls = function(M) {
    var G = wo(M, M.selection.getStart()), fe = xe(M.selection.getSelectedBlocks(), $s);
    return G.toArray().concat(fe);
  }, Ut = function(M) {
    var G = Ls(M);
    return ol(M, G);
  }, ol = function(M, G) {
    var fe = Be(G, function(Fe) {
      return wo(M, Fe).getOr(Fe);
    });
    return yc.unique(fe);
  }, Co = function(M, G, fe) {
    return fe === void 0 && (fe = J), M.exists(function(Fe) {
      return fe(Fe, G);
    });
  }, wc = function(M, G, fe) {
    return M.isSome() && G.isSome() ? De.some(fe(M.getOrDie(), G.getOrDie())) : De.none();
  }, ys = function(M, G) {
    var fe = G || document, Fe = fe.createDocumentFragment();
    return ge(M, function(bt) {
      Fe.appendChild(bt.dom);
    }), na.fromDom(Fe);
  }, V = function(M, G, fe) {
    return M.fire("ListMutation", {
      action: G,
      element: fe
    });
  }, O = function(M) {
    return M.style !== void 0 && le(M.style.getPropertyValue);
  }, x = function(M, G, fe) {
    if (!P(fe))
      throw console.error("Invalid call to CSS.set. Property ", G, ":: Value ", fe, ":: Element ", M), new Error("CSS value must be a string: " + fe);
    O(M) && M.style.setProperty(G, fe);
  }, I = function(M, G, fe) {
    var Fe = M.dom;
    x(Fe, G, fe);
  }, re = function(M, G) {
    Rr(M.item, G.list);
  }, Oe = function(M) {
    for (var G = 1; G < M.length; G++)
      re(M[G - 1], M[G]);
  }, vt = function(M, G) {
    wc(je(M), _(G), re);
  }, rn = function(M, G) {
    var fe = {
      list: na.fromTag(G, M),
      item: na.fromTag("li", M)
    };
    return Rr(fe.list, fe.item), fe;
  }, or = function(M, G, fe) {
    for (var Fe = [], bt = 0; bt < fe; bt++)
      Fe.push(rn(M, G.listType));
    return Fe;
  }, wr = function(M, G) {
    for (var fe = 0; fe < M.length - 1; fe++)
      I(M[fe].item, "list-style-type", "none");
    je(M).each(function(Fe) {
      Z(Fe.list, G.listAttributes), Z(Fe.item, G.itemAttributes), vr(Fe.item, G.content);
    });
  }, Nn = function(M, G) {
    ku(M.list) !== G.listType && (M.list = Lu(M.list, G.listType)), Z(M.list, G.listAttributes);
  }, nr = function(M, G, fe) {
    var Fe = na.fromTag("li", M);
    return Z(Fe, G), vr(Fe, fe), Fe;
  }, jr = function(M, G) {
    Rr(M.list, G), M.item = G;
  }, Vr = function(M, G, fe) {
    var Fe = G.slice(0, fe.depth);
    return je(Fe).each(function(bt) {
      var Gt = nr(M, fe.itemAttributes, fe.content);
      jr(bt, Gt), Nn(bt, fe);
    }), Fe;
  }, Dr = function(M, G, fe) {
    var Fe = or(M, fe, fe.depth - G.length);
    return Oe(Fe), wr(Fe, fe), vt(G, Fe), G.concat(Fe);
  }, Qa = function(M, G) {
    var fe = $(G, function(Fe, bt) {
      return bt.depth > Fe.length ? Dr(M, Fe, bt) : Vr(M, Fe, bt);
    }, []);
    return _(fe).map(function(Fe) {
      return Fe.list;
    });
  }, Tr = function(M) {
    return Po(M, "OL,UL");
  }, $a = function(M) {
    return Ot(M).exists(Tr);
  }, Oa = function(M) {
    return Rn(M).exists(Tr);
  }, Ti = function(M) {
    return M.depth > 0;
  }, Qr = function(M) {
    return M.isSelected;
  }, zs = function(M) {
    var G = lt(M), fe = Oa(M) ? G.slice(0, -1) : G;
    return Be(fe, po);
  }, So = function(M, G, fe) {
    return Ve(M).filter(et).map(function(Fe) {
      return {
        depth: G,
        dirty: !1,
        isSelected: fe,
        content: zs(M),
        itemAttributes: ye(M),
        listAttributes: ye(Fe),
        listType: ku(Fe)
      };
    });
  }, No = function(M, G) {
    switch (M) {
      case "Indent":
        G.depth++;
        break;
      case "Outdent":
        G.depth--;
        break;
      case "Flatten":
        G.depth = 0;
    }
    G.dirty = !0;
  }, w1 = function(M, G) {
    M.listType = G.listType, M.listAttributes = Je({}, G.listAttributes);
  }, Gi = function(M) {
    M.listAttributes = xu(M.listAttributes, function(G, fe) {
      return fe !== "start";
    });
  }, Ip = function(M, G) {
    var fe = M[G].depth, Fe = function(Gt) {
      return Gt.depth === fe && !Gt.dirty;
    }, bt = function(Gt) {
      return Gt.depth < fe;
    };
    return N(Ce(M.slice(0, G)), Fe, bt).orThunk(function() {
      return N(M.slice(G + 1), Fe, bt);
    });
  }, Gl = function(M) {
    return ge(M, function(G, fe) {
      Ip(M, fe).fold(function() {
        G.dirty && Gi(G);
      }, function(Fe) {
        return w1(G, Fe);
      });
    }), M;
  }, Pr = function(M) {
    var G = M, fe = function() {
      return G;
    }, Fe = function(bt) {
      G = bt;
    };
    return {
      get: fe,
      set: Fe
    };
  }, Hs = function(M, G, fe, Fe) {
    return Ot(Fe).filter(Tr).fold(function() {
      G.each(function(fr) {
        sr(fr.start, Fe) && fe.set(!0);
      });
      var bt = So(Fe, M, fe.get());
      G.each(function(fr) {
        sr(fr.end, Fe) && fe.set(!1);
      });
      var Gt = Rn(Fe).filter(Tr).map(function(fr) {
        return zo(M, G, fe, fr);
      }).getOr([]);
      return bt.toArray().concat(Gt);
    }, function(bt) {
      return zo(M, G, fe, bt);
    });
  }, zo = function(M, G, fe, Fe) {
    return ne(lt(Fe), function(bt) {
      var Gt = Tr(bt) ? zo : Hs, fr = M + 1;
      return Gt(fr, G, fe, bt);
    });
  }, Ho = function(M, G) {
    var fe = Pr(!1), Fe = 0;
    return Be(M, function(bt) {
      return {
        sourceList: bt,
        entries: zo(Fe, G, fe, bt)
      };
    });
  }, Ei = function(M, G) {
    var fe = Gl(G);
    return Be(fe, function(Fe) {
      var bt = ys(Fe.content);
      return na.fromDom(ya(M, bt.dom));
    });
  }, ui = function(M, G) {
    var fe = Gl(G);
    return Qa(M.contentDocument, fe).toArray();
  }, Uf = function(M, G) {
    return ne(_e(G, Ti), function(fe) {
      var Fe = _(fe).exists(Ti);
      return Fe ? ui(M, fe) : Ei(M, fe);
    });
  }, il = function(M, G) {
    ge(xe(M, Qr), function(fe) {
      return No(G, fe);
    });
  }, Da = function(M) {
    var G = Be(ou(M), na.fromDom);
    return wc(ae(G, ue($a)), ae(Ce(G), ue($a)), function(fe, Fe) {
      return {
        start: fe,
        end: Fe
      };
    });
  }, mo = function(M, G, fe) {
    var Fe = Ho(G, Da(M));
    ge(Fe, function(bt) {
      il(bt.entries, fe);
      var Gt = Uf(M, bt.entries);
      ge(Gt, function(fr) {
        V(M, fe === "Indent" ? "IndentList" : "OutdentList", fr.dom);
      }), Nt(bt.sourceList, Gt), Nr(bt.sourceList);
    });
  }, Hu = function(M, G) {
    var fe = Be(Ut(M), na.fromDom), Fe = Be(Vf(M), na.fromDom), bt = !1;
    if (fe.length || Fe.length) {
      var Gt = M.selection.getBookmark();
      mo(M, fe, G), zu(M, G, Fe), M.selection.moveToBookmark(Gt), M.selection.setRng(bs(M.selection.getRng())), M.nodeChanged(), bt = !0;
    }
    return bt;
  }, Cc = function(M) {
    return Hu(M, "Indent");
  }, hi = function(M) {
    return Hu(M, "Outdent");
  }, Vs = function(M) {
    return Hu(M, "Flatten");
  }, C1 = tinymce.util.Tools.resolve("tinymce.dom.BookmarkManager"), jf = Eu.DOM, eo = function(M) {
    var G = {}, fe = function(Fe) {
      var bt = M[Fe ? "startContainer" : "endContainer"], Gt = M[Fe ? "startOffset" : "endOffset"];
      if (bt.nodeType === 1) {
        var fr = jf.create("span", { "data-mce-type": "bookmark" });
        bt.hasChildNodes() ? (Gt = Math.min(Gt, bt.childNodes.length - 1), Fe ? bt.insertBefore(fr, bt.childNodes[Gt]) : jf.insertAfter(fr, bt.childNodes[Gt])) : bt.appendChild(fr), bt = fr, Gt = 0;
      }
      G[Fe ? "startContainer" : "endContainer"] = bt, G[Fe ? "startOffset" : "endOffset"] = Gt;
    };
    return fe(!0), M.collapsed || fe(), G;
  }, El = function(M) {
    var G = function(Fe) {
      var bt, Gt = function(da) {
        for (var aa = da.parentNode.firstChild, oo = 0; aa; ) {
          if (aa === da)
            return oo;
          (aa.nodeType !== 1 || aa.getAttribute("data-mce-type") !== "bookmark") && oo++, aa = aa.nextSibling;
        }
        return -1;
      }, fr = bt = M[Fe ? "startContainer" : "endContainer"], Wr = M[Fe ? "startOffset" : "endOffset"];
      !fr || (fr.nodeType === 1 && (Wr = Gt(fr), fr = fr.parentNode, jf.remove(bt), !fr.hasChildNodes() && jf.isBlock(fr) && fr.appendChild(jf.create("br"))), M[Fe ? "startContainer" : "endContainer"] = fr, M[Fe ? "startOffset" : "endOffset"] = Wr);
    };
    G(!0), G();
    var fe = jf.createRng();
    return fe.setStart(M.startContainer, M.startOffset), M.endContainer && fe.setEnd(M.endContainer, M.endOffset), bs(fe);
  }, Zc = function(M) {
    switch (M) {
      case "UL":
        return "ToggleUlList";
      case "OL":
        return "ToggleOlList";
      case "DL":
        return "ToggleDLList";
    }
  }, ts = function(M) {
    return /\btox\-/.test(M.className);
  }, Xo = function(M, G, fe) {
    var Fe = function(Gt) {
      var fr = N(Gt.parents, za, $i).filter(function(Wr) {
        return Wr.nodeName === G && !ts(Wr);
      }).isSome();
      fe(fr);
    }, bt = M.dom.getParents(M.selection.getNode());
    return Fe({ parents: bt }), M.on("NodeChange", Fe), function() {
      return M.off("NodeChange", Fe);
    };
  }, Jc = function(M, G, fe) {
    var Fe = fe["list-style-type"] ? fe["list-style-type"] : null;
    M.setStyle(G, "list-style-type", Fe);
  }, Sc = function(M, G) {
    vo.each(G, function(fe, Fe) {
      M.setAttribute(Fe, fe);
    });
  }, Au = function(M, G, fe) {
    Sc(G, fe["list-attributes"]), vo.each(M.select("li", G), function(Fe) {
      Sc(Fe, fe["list-item-attributes"]);
    });
  }, ns = function(M, G, fe) {
    Jc(M, G, fe), Au(M, G, fe);
  }, iu = function(M, G, fe) {
    vo.each(fe, function(Fe) {
      var bt;
      return M.setStyle(G, (bt = {}, bt[Fe] = "", bt));
    });
  }, Nv = function(M, G, fe, Fe) {
    var bt = G[fe ? "startContainer" : "endContainer"], Gt = G[fe ? "startOffset" : "endOffset"];
    for (bt.nodeType === 1 && (bt = bt.childNodes[Math.min(Gt, bt.childNodes.length - 1)] || bt), !fe && au(bt.nextSibling) && (bt = bt.nextSibling); bt.parentNode !== Fe; ) {
      if (qi(M, bt) || /^(TD|TH)$/.test(bt.parentNode.nodeName))
        return bt;
      bt = bt.parentNode;
    }
    return bt;
  }, _l = function(M, G, fe) {
    for (var Fe = [], bt = M.dom, Gt = Nv(M, G, !0, fe), fr = Nv(M, G, !1, fe), Wr, da = [], aa = Gt; aa && (da.push(aa), aa !== fr); aa = aa.nextSibling)
      ;
    return vo.each(da, function(oo) {
      if (qi(M, oo)) {
        Fe.push(oo), Wr = null;
        return;
      }
      if (bt.isBlock(oo) || au(oo)) {
        au(oo) && bt.remove(oo), Wr = null;
        return;
      }
      var su = oo.nextSibling;
      if (C1.isBookmarkNode(oo) && (za(su) || qi(M, su) || !su && oo.parentNode === fe)) {
        Wr = null;
        return;
      }
      Wr || (Wr = bt.create("p"), oo.parentNode.insertBefore(Wr, oo), Fe.push(Wr)), Wr.appendChild(oo);
    }), Fe;
  }, _i = function(M, G, fe) {
    var Fe = M.getStyle(G, "list-style-type"), bt = fe ? fe["list-style-type"] : "";
    return bt = bt === null ? "" : bt, Fe === bt;
  }, Pd = function(M, G, fe) {
    var Fe = M.selection.getRng(), bt = "LI", Gt = _u(M, M.selection.getStart(!0)), fr = M.dom;
    if (fr.getContentEditable(M.selection.getNode()) !== "false") {
      G = G.toUpperCase(), G === "DL" && (bt = "DT");
      var Wr = eo(Fe), da = _l(M, Fe, Gt);
      vo.each(da, function(aa) {
        var oo, su = aa.previousSibling, Vo = aa.parentNode;
        hs(Vo) || (su && za(su) && su.nodeName === G && _i(fr, su, fe) ? (oo = su, aa = fr.rename(aa, bt), su.appendChild(aa)) : (oo = fr.create(G), aa.parentNode.insertBefore(oo, aa), oo.appendChild(aa), aa = fr.rename(aa, bt)), iu(fr, aa, [
          "margin",
          "margin-right",
          "margin-bottom",
          "margin-left",
          "margin-top",
          "padding",
          "padding-right",
          "padding-bottom",
          "padding-left",
          "padding-top"
        ]), ns(fr, oo, fe), Gf(M.dom, oo));
      }), M.selection.setRng(El(Wr));
    }
  }, S1 = function(M, G) {
    return M && G && za(M) && M.nodeName === G.nodeName;
  }, Wf = function(M, G, fe) {
    var Fe = M.getStyle(G, "list-style-type", !0), bt = M.getStyle(fe, "list-style-type", !0);
    return Fe === bt;
  }, qf = function(M, G) {
    return M.className === G.className;
  }, Yo = function(M, G, fe) {
    return S1(G, fe) && Wf(M, G, fe) && qf(G, fe);
  }, Gf = function(M, G) {
    var fe, Fe;
    if (fe = G.nextSibling, Yo(M, G, fe)) {
      for (; Fe = fe.firstChild; )
        G.appendChild(Fe);
      M.remove(fe);
    }
    if (fe = G.previousSibling, Yo(M, G, fe)) {
      for (; Fe = fe.lastChild; )
        G.insertBefore(Fe, G.firstChild);
      M.remove(fe);
    }
  }, Kf = function(M, G, fe, Fe) {
    if (G.nodeName !== fe) {
      var bt = M.dom.rename(G, fe);
      ns(M.dom, bt, Fe), V(M, Zc(fe), bt);
    } else
      ns(M.dom, G, Fe), V(M, Zc(fe), G);
  }, Ou = function(M, G, fe, Fe, bt) {
    var Gt = za(G);
    if (Gt && G.nodeName === Fe && !xc(bt))
      Vs(M);
    else {
      Pd(M, Fe, bt);
      var fr = eo(M.selection.getRng()), Wr = Gt ? Lt([G], fe, !0) : fe;
      vo.each(Wr, function(da) {
        Kf(M, da, Fe, bt);
      }), M.selection.setRng(El(fr));
    }
  }, xc = function(M) {
    return "list-style-type" in M;
  }, Xf = function(M, G, fe, Fe) {
    if (G !== M.getBody())
      if (G)
        if (G.nodeName === fe && !xc(Fe) && !ts(G))
          Vs(M);
        else {
          var bt = eo(M.selection.getRng());
          ns(M.dom, G, Fe);
          var Gt = M.dom.rename(G, fe);
          Gf(M.dom, Gt), M.selection.setRng(El(bt)), Pd(M, fe, Fe), V(M, Zc(fe), Gt);
        }
      else
        Pd(M, fe, Fe), V(M, Zc(fe), G);
  }, kc = function(M, G, fe) {
    var Fe = va(M), bt = Yc(M), Gt = H(fe) ? fe : {};
    bt.length > 0 ? Ou(M, Fe, bt, G, Gt) : Xf(M, Fe, G, Gt);
  }, Oo = Eu.DOM, ws = function(M, G) {
    var fe = G.parentNode;
    if (fe.nodeName === "LI" && fe.firstChild === G) {
      var Fe = fe.previousSibling;
      Fe && Fe.nodeName === "LI" ? (Fe.appendChild(G), nt(M, fe) && Oo.remove(fe)) : Oo.setStyle(fe, "listStyleType", "none");
    }
    if (za(fe)) {
      var Fe = fe.previousSibling;
      Fe && Fe.nodeName === "LI" && Fe.appendChild(G);
    }
  }, Wm = function(M, G) {
    var fe = vo.grep(M.select("ol,ul", G));
    vo.each(fe, function(Fe) {
      ws(M, Fe);
    });
  }, Us = function(M, G, fe, Fe) {
    var bt = G.startContainer, Gt = G.startOffset;
    if (Fi(bt) && (fe ? Gt < bt.data.length : Gt > 0))
      return bt;
    var fr = M.schema.getNonEmptyElements();
    bt.nodeType === 1 && (bt = Si.getNode(bt, Gt));
    var Wr = new Su(bt, Fe);
    for (fe && ve(M.dom, bt) && Wr.next(); bt = Wr[fe ? "next" : "prev2"](); )
      if (bt.nodeName === "LI" && !bt.hasChildNodes() || fr[bt.nodeName] || Fi(bt) && bt.data.length > 0)
        return bt;
  }, qm = function(M, G) {
    var fe = G.childNodes;
    return fe.length === 1 && !za(fe[0]) && M.isBlock(fe[0]);
  }, x1 = function(M, G) {
    qm(M, G) && M.remove(G.firstChild, !0);
  }, Fp = function(M, G, fe) {
    var Fe, bt = qm(M, fe) ? fe.firstChild : fe;
    if (x1(M, G), !nt(M, G, !0))
      for (; Fe = G.firstChild; )
        bt.appendChild(Fe);
  }, Yf = function(M, G, fe) {
    var Fe, bt = G.parentNode;
    if (!(!wt(M, G) || !wt(M, fe))) {
      za(fe.lastChild) && (Fe = fe.lastChild), bt === fe.lastChild && au(bt.previousSibling) && M.remove(bt.previousSibling);
      var Gt = fe.lastChild;
      Gt && au(Gt) && G.hasChildNodes() && M.remove(Gt), nt(M, fe, !0) && M.$(fe).empty(), Fp(M, G, fe), Fe && fe.appendChild(Fe);
      var fr = pi(na.fromDom(fe), na.fromDom(G)), Wr = fr ? M.getParents(G, za, fe) : [];
      M.remove(G), ge(Wr, function(da) {
        nt(M, da) && da !== M.getRoot() && M.remove(da);
      });
    }
  }, Zf = function(M, G, fe) {
    M.dom.$(fe).empty(), Yf(M.dom, G, fe), M.selection.setCursorLocation(fe, 0);
  }, Qc = function(M, G, fe, Fe) {
    var bt = M.dom;
    if (bt.isEmpty(Fe))
      Zf(M, fe, Fe);
    else {
      var Gt = eo(G);
      Yf(bt, fe, Fe), M.selection.setRng(El(Gt));
    }
  }, $r = function(M, G, fe, Fe) {
    var bt = eo(G);
    Yf(M.dom, fe, Fe);
    var Gt = El(bt);
    M.selection.setRng(Gt);
  }, ul = function(M, G) {
    var fe = M.dom, Fe = M.selection, bt = Fe.getStart(), Gt = _u(M, bt), fr = fe.getParent(Fe.getStart(), "LI", Gt);
    if (fr) {
      var Wr = fr.parentNode;
      if (Wr === M.getBody() && nt(fe, Wr))
        return !0;
      var da = bs(Fe.getRng()), aa = fe.getParent(Us(M, da, G, Gt), "LI", Gt);
      if (aa && aa !== fr)
        return M.undoManager.transact(function() {
          G ? Qc(M, da, aa, fr) : al(fr) ? hi(M) : $r(M, da, fr, aa);
        }), !0;
      if (!aa && !G && da.startOffset === 0 && da.endOffset === 0)
        return M.undoManager.transact(function() {
          Vs(M);
        }), !0;
    }
    return !1;
  }, rs = function(M, G, fe) {
    var Fe = M.getParent(G.parentNode, M.isBlock, fe);
    M.remove(G), Fe && M.isEmpty(Fe) && M.remove(Fe);
  }, Du = function(M, G) {
    var fe = M.dom, Fe = M.selection.getStart(), bt = _u(M, Fe), Gt = fe.getParent(Fe, fe.isBlock, bt);
    if (Gt && fe.isEmpty(Gt)) {
      var fr = bs(M.selection.getRng()), Wr = fe.getParent(Us(M, fr, G, bt), "LI", bt);
      if (Wr)
        return M.undoManager.transact(function() {
          rs(fe, Gt, bt), Gf(fe, Wr.parentNode), M.selection.select(Wr, !0), M.selection.collapse(G);
        }), !0;
    }
    return !1;
  }, sl = function(M, G) {
    return ul(M, G) || Du(M, G);
  }, ni = function(M) {
    var G = M.selection.getStart(), fe = _u(M, G), Fe = M.dom.getParent(G, "LI,DT,DD", fe);
    return Fe || ou(M).length > 0 ? (M.undoManager.transact(function() {
      M.execCommand("Delete"), Wm(M.dom, M.getBody());
    }), !0) : !1;
  }, Ai = function(M, G) {
    return M.selection.isCollapsed() ? sl(M, G) : ni(M);
  }, si = function(M) {
    M.on("keydown", function(G) {
      G.keyCode === xi.BACKSPACE ? Ai(M, !1) && G.preventDefault() : G.keyCode === xi.DELETE && Ai(M, !0) && G.preventDefault();
    });
  }, ef = function(M) {
    return {
      backspaceDelete: function(G) {
        Ai(M, G);
      }
    };
  }, uu = function(M, G) {
    var fe = va(M);
    M.undoManager.transact(function() {
      H(G.styles) && M.dom.setStyles(fe, G.styles), H(G.attrs) && Lo(G.attrs, function(Fe, bt) {
        return M.dom.setAttrib(fe, bt, Fe);
      });
    });
  }, Qn = function(M) {
    var G = Ce(sn(M).split("")), fe = Be(G, function(Fe, bt) {
      var Gt = Fe.toUpperCase().charCodeAt(0) - "A".charCodeAt(0) + 1;
      return Math.pow(26, bt) * Gt;
    });
    return $(fe, function(Fe, bt) {
      return Fe + bt;
    }, 0);
  }, Jf = function(M) {
    if (M--, M < 0)
      return "";
    var G = M % 26, fe = Math.floor(M / 26), Fe = Jf(fe), bt = String.fromCharCode("A".charCodeAt(0) + G);
    return Fe + bt;
  }, $p = function(M) {
    return /^[A-Z]+$/.test(M);
  }, ea = function(M) {
    return /^[a-z]+$/.test(M);
  }, to = function(M) {
    return /^[0-9]+$/.test(M);
  }, Gm = function(M) {
    return to(M) ? 2 : $p(M) ? 0 : ea(M) ? 1 : St(M) ? 3 : 4;
  }, Kl = function(M) {
    switch (Gm(M)) {
      case 2:
        return De.some({
          listStyleType: De.none(),
          start: M
        });
      case 0:
        return De.some({
          listStyleType: De.some("upper-alpha"),
          start: Qn(M).toString()
        });
      case 1:
        return De.some({
          listStyleType: De.some("lower-alpha"),
          start: Qn(M).toString()
        });
      case 3:
        return De.some({
          listStyleType: De.none(),
          start: ""
        });
      case 4:
        return De.none();
    }
  }, xo = function(M) {
    var G = parseInt(M.start, 10);
    return Co(M.listStyleType, "upper-alpha") ? Jf(G) : Co(M.listStyleType, "lower-alpha") ? Jf(G).toLowerCase() : M.start;
  }, Km = function(M) {
    var G = va(M);
    !Qu(G) || M.windowManager.open({
      title: "List Properties",
      body: {
        type: "panel",
        items: [{
          type: "input",
          name: "start",
          label: "Start list at number",
          inputMode: "numeric"
        }]
      },
      initialData: {
        start: xo({
          start: M.dom.getAttrib(G, "start", "1"),
          listStyleType: De.some(M.dom.getStyle(G, "list-style-type"))
        })
      },
      buttons: [
        {
          type: "cancel",
          name: "cancel",
          text: "Cancel"
        },
        {
          type: "submit",
          name: "save",
          text: "Save",
          primary: !0
        }
      ],
      onSubmit: function(fe) {
        var Fe = fe.getData();
        Kl(Fe.start).each(function(bt) {
          M.execCommand("mceListUpdate", !1, {
            attrs: { start: bt.start === "1" ? "" : bt.start },
            styles: { "list-style-type": bt.listStyleType.getOr("") }
          });
        }), fe.close();
      }
    });
  }, Cs = function(M, G) {
    return function() {
      var fe = va(M);
      return fe && fe.nodeName === G;
    };
  }, Nd = function(M) {
    M.addCommand("mceListProps", function() {
      Km(M);
    });
  }, ra = function(M) {
    M.on("BeforeExecCommand", function(G) {
      var fe = G.command.toLowerCase();
      fe === "indent" ? Cc(M) : fe === "outdent" && hi(M);
    }), M.addCommand("InsertUnorderedList", function(G, fe) {
      kc(M, "UL", fe);
    }), M.addCommand("InsertOrderedList", function(G, fe) {
      kc(M, "OL", fe);
    }), M.addCommand("InsertDefinitionList", function(G, fe) {
      kc(M, "DL", fe);
    }), M.addCommand("RemoveList", function() {
      Vs(M);
    }), Nd(M), M.addCommand("mceListUpdate", function(G, fe) {
      H(fe) && uu(M, fe);
    }), M.addQueryStateHandler("InsertUnorderedList", Cs(M, "UL")), M.addQueryStateHandler("InsertOrderedList", Cs(M, "OL")), M.addQueryStateHandler("InsertDefinitionList", Cs(M, "DL"));
  }, Vu = function(M) {
    M.on("keydown", function(G) {
      G.keyCode !== xi.TAB || xi.metaKeyPressed(G) || M.undoManager.transact(function() {
        (G.shiftKey ? hi(M) : Cc(M)) && G.preventDefault();
      });
    });
  }, ty = function(M) {
    Zt(M) && Vu(M), si(M);
  }, ny = function(M) {
    var G = function(fe) {
      return function() {
        return M.execCommand(fe);
      };
    };
    M.hasPlugin("advlist") || (M.ui.registry.addToggleButton("numlist", {
      icon: "ordered-list",
      active: !1,
      tooltip: "Numbered list",
      onAction: G("InsertOrderedList"),
      onSetup: function(fe) {
        return Xo(M, "OL", fe.setActive);
      }
    }), M.ui.registry.addToggleButton("bullist", {
      icon: "unordered-list",
      active: !1,
      tooltip: "Bullet list",
      onAction: G("InsertUnorderedList"),
      onSetup: function(fe) {
        return Xo(M, "UL", fe.setActive);
      }
    }));
  }, Do = function(M) {
    var G = {
      text: "List properties...",
      icon: "ordered-list",
      onAction: function() {
        return M.execCommand("mceListProps");
      },
      onSetup: function(fe) {
        return Xo(M, "OL", function(Fe) {
          return fe.setDisabled(!Fe);
        });
      }
    };
    M.ui.registry.addMenuItem("listprops", G), M.ui.registry.addContextMenu("lists", {
      update: function(fe) {
        var Fe = va(M, fe);
        return Qu(Fe) ? ["listprops"] : [];
      }
    });
  };
  function Xm() {
    m.add("lists", function(M) {
      return M.hasPlugin("rtc", !0) === !1 ? (ty(M), ra(M)) : Nd(M), ny(M), Do(M), ef(M);
    });
  }
  Xm();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(Y) {
    var D = Y.getParam("nonbreaking_force_tab", 0);
    return typeof D == "boolean" ? D === !0 ? 3 : 0 : D;
  }, w = function(Y) {
    return Y.getParam("nonbreaking_wrap", !0, "boolean");
  }, E = function(Y, D) {
    for (var J = "", ue = 0; ue < D; ue++)
      J += Y;
    return J;
  }, P = function(Y) {
    return Y.plugins.visualchars ? Y.plugins.visualchars.isEnabled() : !1;
  }, H = function(Y, D) {
    var J = function() {
      return P(Y) ? "mce-nbsp-wrap mce-nbsp" : "mce-nbsp-wrap";
    }, ue = function() {
      return '<span class="' + J() + '" contenteditable="false">' + E("&nbsp;", D) + "</span>";
    }, ee = w(Y), Ge = ee || Y.plugins.visualchars ? ue() : E("&nbsp;", D);
    Y.undoManager.transact(function() {
      return Y.insertContent(Ge);
    });
  }, X = function(Y) {
    Y.addCommand("mceNonBreaking", function() {
      H(Y, 1);
    });
  }, j = tinymce.util.Tools.resolve("tinymce.util.VK"), le = function(Y) {
    var D = y(Y);
    D > 0 && Y.on("keydown", function(J) {
      if (J.keyCode === j.TAB && !J.isDefaultPrevented()) {
        if (J.shiftKey)
          return;
        J.preventDefault(), J.stopImmediatePropagation(), H(Y, D);
      }
    });
  }, Q = function(Y) {
    var D = function() {
      return Y.execCommand("mceNonBreaking");
    };
    Y.ui.registry.addButton("nonbreaking", {
      icon: "non-breaking",
      tooltip: "Nonbreaking space",
      onAction: D
    }), Y.ui.registry.addMenuItem("nonbreaking", {
      icon: "non-breaking",
      text: "Nonbreaking space",
      onAction: D
    });
  };
  function pe() {
    m.add("nonbreaking", function(Y) {
      X(Y), Q(Y), le(Y);
    });
  }
  pe();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = tinymce.util.Tools.resolve("tinymce.Env"), w = function(Y) {
    return Y.getParam("pagebreak_separator", "<!-- pagebreak -->");
  }, E = function(Y) {
    return Y.getParam("pagebreak_split_block", !1);
  }, P = "mce-pagebreak", H = function(Y) {
    var D = '<img src="' + y.transparentSrc + '" class="' + P + '" data-mce-resize="false" data-mce-placeholder />';
    return Y ? "<p>" + D + "</p>" : D;
  }, X = function(Y) {
    var D = w(Y), J = function() {
      return E(Y);
    }, ue = new RegExp(D.replace(/[\?\.\*\[\]\(\)\{\}\+\^\$\:]/g, function(ee) {
      return "\\" + ee;
    }), "gi");
    Y.on("BeforeSetContent", function(ee) {
      ee.content = ee.content.replace(ue, H(J()));
    }), Y.on("PreInit", function() {
      Y.serializer.addNodeFilter("img", function(ee) {
        for (var Ge = ee.length, ze, ht; Ge--; )
          if (ze = ee[Ge], ht = ze.attr("class"), ht && ht.indexOf(P) !== -1) {
            var ie = ze.parent;
            if (Y.schema.getBlockElements()[ie.name] && J()) {
              ie.type = 3, ie.value = D, ie.raw = !0, ze.remove();
              continue;
            }
            ze.type = 3, ze.value = D, ze.raw = !0;
          }
      });
    });
  }, j = function(Y) {
    Y.addCommand("mcePageBreak", function() {
      Y.insertContent(H(E(Y)));
    });
  }, le = function(Y) {
    Y.on("ResolveName", function(D) {
      D.target.nodeName === "IMG" && Y.dom.hasClass(D.target, P) && (D.name = "pagebreak");
    });
  }, Q = function(Y) {
    var D = function() {
      return Y.execCommand("mcePageBreak");
    };
    Y.ui.registry.addButton("pagebreak", {
      icon: "page-break",
      tooltip: "Page break",
      onAction: D
    }), Y.ui.registry.addMenuItem("pagebreak", {
      text: "Page break",
      icon: "page-break",
      onAction: D
    });
  };
  function pe() {
    m.add("pagebreak", function(Y) {
      j(Y), Q(Y), X(Y), le(Y);
    });
  }
  pe();
})();
(function() {
  var m = function(x) {
    var I = x, re = function() {
      return I;
    }, Oe = function(vt) {
      I = vt;
    };
    return {
      get: re,
      set: Oe
    };
  }, y = tinymce.util.Tools.resolve("tinymce.PluginManager"), w = function(x) {
    return x.hasPlugin("powerpaste", !0) ? (typeof window.console < "u" && window.console.log && window.console.log("PowerPaste is incompatible with Paste plugin! Remove 'paste' from the 'plugins' option."), !0) : !1;
  }, E = function(x) {
    return { clipboard: x };
  }, P = function(x) {
    var I = typeof x;
    return x === null ? "null" : I === "object" && (Array.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === "Array") ? "array" : I === "object" && (String.prototype.isPrototypeOf(x) || x.constructor && x.constructor.name === "String") ? "string" : I;
  }, H = function(x) {
    return function(I) {
      return P(I) === x;
    };
  }, X = function(x) {
    return function(I) {
      return typeof I === x;
    };
  }, j = H("array"), le = function(x) {
    return x == null;
  }, Q = function(x) {
    return !le(x);
  }, pe = X("function"), Y = function() {
  }, D = function(x) {
    return function() {
      return x;
    };
  }, J = function(x) {
    return x;
  }, ue = D(!1), ee = D(!0), Ge = function() {
    return ze;
  }, ze = function() {
    var x = function(Oe) {
      return Oe();
    }, I = J, re = {
      fold: function(Oe, vt) {
        return Oe();
      },
      isSome: ue,
      isNone: ee,
      getOr: I,
      getOrThunk: x,
      getOrDie: function(Oe) {
        throw new Error(Oe || "error: getOrDie called on none.");
      },
      getOrNull: D(null),
      getOrUndefined: D(void 0),
      or: I,
      orThunk: x,
      map: Ge,
      each: Y,
      bind: Ge,
      exists: ue,
      forall: ee,
      filter: function() {
        return Ge();
      },
      toArray: function() {
        return [];
      },
      toString: D("none()")
    };
    return re;
  }(), ht = function(x) {
    var I = D(x), re = function() {
      return vt;
    }, Oe = function(rn) {
      return rn(x);
    }, vt = {
      fold: function(rn, or) {
        return or(x);
      },
      isSome: ee,
      isNone: ue,
      getOr: I,
      getOrThunk: I,
      getOrDie: I,
      getOrNull: I,
      getOrUndefined: I,
      or: re,
      orThunk: re,
      map: function(rn) {
        return ht(rn(x));
      },
      each: function(rn) {
        rn(x);
      },
      bind: Oe,
      exists: Oe,
      forall: Oe,
      filter: function(rn) {
        return rn(x) ? vt : ze;
      },
      toArray: function() {
        return [x];
      },
      toString: function() {
        return "some(" + x + ")";
      }
    };
    return vt;
  }, ie = function(x) {
    return x == null ? ze : ht(x);
  }, Ze = {
    some: ht,
    none: Ge,
    from: ie
  }, De = Array.prototype.slice, Pt = Array.prototype.push, Ct = function(x, I) {
    for (var re = 0, Oe = x.length; re < Oe; re++) {
      var vt = x[re];
      if (I(vt, re))
        return !0;
    }
    return !1;
  }, Be = function(x, I) {
    for (var re = x.length, Oe = new Array(re), vt = 0; vt < re; vt++) {
      var rn = x[vt];
      Oe[vt] = I(rn, vt);
    }
    return Oe;
  }, ge = function(x, I) {
    for (var re = 0, Oe = x.length; re < Oe; re++) {
      var vt = x[re];
      I(vt, re);
    }
  }, xe = function(x, I) {
    for (var re = [], Oe = 0, vt = x.length; Oe < vt; Oe++) {
      var rn = x[Oe];
      I(rn, Oe) && re.push(rn);
    }
    return re;
  }, _e = function(x, I, re) {
    return ge(x, function(Oe, vt) {
      re = I(re, Oe, vt);
    }), re;
  }, $ = function(x) {
    for (var I = [], re = 0, Oe = x.length; re < Oe; ++re) {
      if (!j(x[re]))
        throw new Error("Arr.flatten item " + re + " was not an array, input: " + x);
      Pt.apply(I, x[re]);
    }
    return I;
  }, N = function(x, I) {
    return $(Be(x, I));
  }, ae = pe(Array.from) ? Array.from : function(x) {
    return De.call(x);
  }, ce = function() {
    return ce = Object.assign || function(I) {
      for (var re, Oe = 1, vt = arguments.length; Oe < vt; Oe++) {
        re = arguments[Oe];
        for (var rn in re)
          Object.prototype.hasOwnProperty.call(re, rn) && (I[rn] = re[rn]);
      }
      return I;
    }, ce.apply(this, arguments);
  }, ne = function(x) {
    var I = m(Ze.none()), re = function() {
      return I.get().each(x);
    }, Oe = function() {
      re(), I.set(Ze.none());
    }, vt = function() {
      return I.get().isSome();
    }, rn = function() {
      return I.get();
    }, or = function(wr) {
      re(), I.set(Ze.some(wr));
    };
    return {
      clear: Oe,
      isSet: vt,
      get: rn,
      set: or
    };
  }, Ce = function() {
    var x = ne(Y), I = function(re) {
      return x.get().each(re);
    };
    return ce(ce({}, x), { on: I });
  }, Te = function(x, I, re) {
    return I === "" || x.length >= I.length && x.substr(re, re + I.length) === I;
  }, _ = function(x, I) {
    return Te(x, I, 0);
  }, je = function(x, I) {
    return Te(x, I, x.length - I.length);
  }, Me = function(x, I) {
    return I <= 0 ? "" : new Array(I + 1).join(x);
  }, Je = tinymce.util.Tools.resolve("tinymce.Env"), Lt = tinymce.util.Tools.resolve("tinymce.util.Delay"), dt = tinymce.util.Tools.resolve("tinymce.util.Promise"), Tt = tinymce.util.Tools.resolve("tinymce.util.VK"), Jt = function(x, I, re, Oe) {
    return x.fire("PastePreProcess", {
      content: I,
      internal: re,
      wordContent: Oe
    });
  }, se = function(x, I, re, Oe) {
    return x.fire("PastePostProcess", {
      node: I,
      internal: re,
      wordContent: Oe
    });
  }, tr = function(x, I) {
    return x.fire("PastePlainTextToggle", { state: I });
  }, _t = function(x, I) {
    return x.fire("paste", { ieFake: I });
  }, Pe = tinymce.util.Tools.resolve("tinymce.util.Tools"), kt = function(x) {
    return x.getParam("paste_block_drop", !1);
  }, He = function(x) {
    return x.getParam("paste_data_images", !1);
  }, We = function(x) {
    return x.getParam("paste_filter_drop", !0);
  }, Ae = function(x) {
    return x.getParam("paste_preprocess");
  }, Ke = function(x) {
    return x.getParam("paste_postprocess");
  }, at = function(x) {
    return x.getParam("paste_webkit_styles");
  }, pt = function(x) {
    return x.getParam("paste_remove_styles_if_webkit", !0);
  }, sn = function(x) {
    return x.getParam("paste_merge_formats", !0);
  }, Ie = function(x) {
    return x.getParam("smart_paste", !0);
  }, St = function(x) {
    return x.getParam("paste_as_text", !1);
  }, Xe = function(x) {
    return x.getParam("paste_retain_style_properties");
  }, he = function(x) {
    var I = "-strong/b,-em/i,-u,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6,-p/div,-a[href|name],sub,sup,strike,br,del,table[width],tr,td[colspan|rowspan|width],th[colspan|rowspan|width],thead,tfoot,tbody";
    return x.getParam("paste_word_valid_elements", I);
  }, tt = function(x) {
    return x.getParam("paste_convert_word_fake_lists", !0);
  }, gt = function(x) {
    return x.getParam("paste_enable_default_filters", !0);
  }, Ye = function(x) {
    return x.getParam("validate");
  }, Qt = function(x) {
    return x.getParam("allow_html_data_urls", !1, "boolean");
  }, In = function(x) {
    return x.getParam("paste_data_images", !1, "boolean");
  }, It = function(x) {
    return x.getParam("images_dataimg_filter");
  }, qt = function(x) {
    return x.getParam("images_reuse_filename");
  }, Vt = function(x) {
    return x.getParam("forced_root_block");
  }, Xt = function(x) {
    return x.getParam("forced_root_block_attrs");
  }, on = function(x) {
    return x.getParam("paste_tab_spaces", 4, "number");
  }, Vn = function(x) {
    var I = "jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp";
    return Pe.explode(x.getParam("images_file_types", I, "string"));
  }, Un = "x-tinymce/html", Tn = "<!-- " + Un + " -->", yt = function(x) {
    return Tn + x;
  }, mn = function(x) {
    return x.replace(Tn, "");
  }, zn = function(x) {
    return x.indexOf(Tn) !== -1;
  }, _n = D(Un), Kr = Object.hasOwnProperty, ot = function(x, I) {
    return Kr.call(x, I);
  }, Yt = tinymce.util.Tools.resolve("tinymce.html.Entities"), Ft = function(x) {
    return !/<(?:\/?(?!(?:div|p|br|span)>)\w+|(?:(?!(?:span style="white-space:\s?pre;?">)|br\s?\/>))\w+\s[^>]+)>/i.test(x);
  }, yn = function(x) {
    return x.replace(/\r?\n/g, "<br>");
  }, Yn = function(x, I) {
    var re = [], Oe = "<" + x;
    if (typeof I == "object") {
      for (var vt in I)
        ot(I, vt) && re.push(vt + '="' + Yt.encodeAllRaw(I[vt]) + '"');
      re.length && (Oe += " " + re.join(" "));
    }
    return Oe + ">";
  }, Ir = function(x, I, re) {
    var Oe = x.split(/\n\n/), vt = Yn(I, re), rn = "</" + I + ">", or = Pe.map(Oe, function(Nn) {
      return Nn.split(/\n/).join("<br />");
    }), wr = function(Nn) {
      return vt + Nn + rn;
    };
    return or.length === 1 ? or[0] : Pe.map(or, wr).join("");
  }, Wa = function(x, I, re) {
    return I ? Ir(x, I === !0 ? "p" : I, re) : yn(x);
  }, Mr = tinymce.util.Tools.resolve("tinymce.html.DomParser"), Fr = tinymce.util.Tools.resolve("tinymce.html.Serializer"), Va = "\xA0", Qo = tinymce.util.Tools.resolve("tinymce.html.Node"), Go = tinymce.util.Tools.resolve("tinymce.html.Schema"), so = function(x) {
    return x.constructor === RegExp;
  }, bo = function(x, I) {
    return Pe.each(I, function(re) {
      so(re) ? x = x.replace(re, "") : x = x.replace(re[0], re[1]);
    }), x;
  }, mi = function(x) {
    var I = Go(), re = Mr({}, I), Oe = "", vt = I.getShortEndedElements(), rn = Pe.makeMap("script noscript style textarea video audio iframe object", " "), or = I.getBlockElements(), wr = function(Nn) {
      var nr = Nn.name, jr = Nn;
      if (nr === "br") {
        Oe += `
`;
        return;
      }
      if (nr !== "wbr") {
        if (vt[nr] && (Oe += " "), rn[nr]) {
          Oe += " ";
          return;
        }
        if (Nn.type === 3 && (Oe += Nn.value), !Nn.shortEnded && (Nn = Nn.firstChild))
          do
            wr(Nn);
          while (Nn = Nn.next);
        or[nr] && jr.next && (Oe += `
`, nr === "p" && (Oe += `
`));
      }
    };
    return x = bo(x, [/<!\[[^\]]+\]>/g]), wr(re.parse(x)), Oe;
  }, Ao = function(x) {
    var I = function(re, Oe, vt) {
      return !Oe && !vt ? " " : Va;
    };
    return x = bo(x, [
      /^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/ig,
      /<!--StartFragment-->|<!--EndFragment-->/g,
      [
        /( ?)<span class="Apple-converted-space">\u00a0<\/span>( ?)/g,
        I
      ],
      /<br class="Apple-interchange-newline">/g,
      /<br>$/i
    ]), x;
  }, go = function(x) {
    var I = 0;
    return function() {
      return x + I++;
    };
  }, gi = function(x) {
    var I = x.toLowerCase(), re = {
      jpg: "jpeg",
      jpe: "jpeg",
      jfi: "jpeg",
      jif: "jpeg",
      jfif: "jpeg",
      pjpeg: "jpeg",
      pjp: "jpeg",
      svg: "svg+xml"
    };
    return Pe.hasOwn(re, I) ? "image/" + re[I] : "image/" + I;
  }, na = function(x) {
    return /<font face="Times New Roman"|class="?Mso|style="[^"]*\bmso-|style='[^']*\bmso-|w:WordDocument/i.test(x) || /class="OutlineElement/.test(x) || /id="?docs\-internal\-guid\-/.test(x);
  }, ei = function(x) {
    var I = !1, re = [
      /^[IVXLMCD]+\.[ \u00a0]/,
      /^[ivxlmcd]+\.[ \u00a0]/,
      /^[a-z]{1,2}[\.\)][ \u00a0]/,
      /^[A-Z]{1,2}[\.\)][ \u00a0]/,
      /^[0-9]+\.[ \u00a0]/,
      /^[\u3007\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]+\.[ \u00a0]/,
      /^[\u58f1\u5f10\u53c2\u56db\u4f0d\u516d\u4e03\u516b\u4e5d\u62fe]+\.[ \u00a0]/
    ];
    return x = x.replace(/^[\u00a0 ]+/, ""), Pe.each(re, function(Oe) {
      if (Oe.test(x))
        return I = !0, !1;
    }), I;
  }, sr = function(x) {
    return /^[\s\u00a0]*[\u2022\u00b7\u00a7\u25CF]\s*/.test(x);
  }, $u = function(x) {
    for (var I, re, Oe = 1, vt = function(Tr) {
      var $a = "";
      if (Tr.type === 3)
        return Tr.value;
      if (Tr = Tr.firstChild)
        do
          $a += vt(Tr);
        while (Tr = Tr.next);
      return $a;
    }, rn = function(Tr, $a) {
      if (Tr.type === 3 && $a.test(Tr.value))
        return Tr.value = Tr.value.replace($a, ""), !1;
      if (Tr = Tr.firstChild)
        do
          if (!rn(Tr, $a))
            return !1;
        while (Tr = Tr.next);
      return !0;
    }, or = function(Tr) {
      if (Tr._listIgnore) {
        Tr.remove();
        return;
      }
      if (Tr = Tr.firstChild)
        do
          or(Tr);
        while (Tr = Tr.next);
    }, wr = function(Tr, $a, Oa) {
      var Ti = Tr._listLevel || Oe;
      Ti !== Oe && (Ti < Oe ? I && (I = I.parent.parent) : (re = I, I = null)), !I || I.name !== $a ? (re = re || I, I = new Qo($a, 1), Oa > 1 && I.attr("start", "" + Oa), Tr.wrap(I)) : I.append(Tr), Tr.name = "li", Ti > Oe && re && re.lastChild.append(I), Oe = Ti, or(Tr), rn(Tr, /^\u00a0+/), rn(Tr, /^\s*([\u2022\u00b7\u00a7\u25CF]|\w+\.)/), rn(Tr, /^\u00a0+/);
    }, Nn = [], nr = x.firstChild; typeof nr < "u" && nr !== null; )
      if (Nn.push(nr), nr = nr.walk(), nr !== null)
        for (; typeof nr < "u" && nr.parent !== x; )
          nr = nr.walk();
    for (var jr = 0; jr < Nn.length; jr++)
      if (x = Nn[jr], x.name === "p" && x.firstChild) {
        var Vr = vt(x);
        if (sr(Vr)) {
          wr(x, "ul");
          continue;
        }
        if (ei(Vr)) {
          var Dr = /([0-9]+)\./.exec(Vr), Qa = 1;
          Dr && (Qa = parseInt(Dr[1], 10)), wr(x, "ol", Qa);
          continue;
        }
        if (x._listLevel) {
          wr(x, "ul", 1);
          continue;
        }
        I = null;
      } else
        re = I, I = null;
  }, Ko = function(x, I, re, Oe) {
    var vt = {}, rn = x.dom.parseStyle(Oe);
    Pe.each(rn, function(wr, Nn) {
      switch (Nn) {
        case "mso-list":
          var nr = /\w+ \w+([0-9]+)/i.exec(Oe);
          nr && (re._listLevel = parseInt(nr[1], 10)), /Ignore/i.test(wr) && re.firstChild && (re._listIgnore = !0, re.firstChild._listIgnore = !0);
          break;
        case "horiz-align":
          Nn = "text-align";
          break;
        case "vert-align":
          Nn = "vertical-align";
          break;
        case "font-color":
        case "mso-foreground":
          Nn = "color";
          break;
        case "mso-background":
        case "mso-highlight":
          Nn = "background";
          break;
        case "font-weight":
        case "font-style":
          wr !== "normal" && (vt[Nn] = wr);
          return;
        case "mso-element":
          if (/^(comment|comment-list)$/i.test(wr)) {
            re.remove();
            return;
          }
          break;
      }
      if (Nn.indexOf("mso-comment") === 0) {
        re.remove();
        return;
      }
      Nn.indexOf("mso-") !== 0 && (Xe(x) === "all" || I && I[Nn]) && (vt[Nn] = wr);
    }), /(bold)/i.test(vt["font-weight"]) && (delete vt["font-weight"], re.wrap(new Qo("b", 1))), /(italic)/i.test(vt["font-style"]) && (delete vt["font-style"], re.wrap(new Qo("i", 1)));
    var or = x.dom.serializeStyle(vt, re.name);
    return or || null;
  }, pi = function(x, I) {
    var re, Oe = Xe(x);
    Oe && (re = Pe.makeMap(Oe.split(/[, ]/))), I = bo(I, [
      /<br class="?Apple-interchange-newline"?>/gi,
      /<b[^>]+id="?docs-internal-[^>]*>/gi,
      /<!--[\s\S]+?-->/gi,
      /<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|img|meta|link|style|\w:\w+)(?=[\s\/>]))[^>]*>/gi,
      [
        /<(\/?)s>/gi,
        "<$1strike>"
      ],
      [
        /&nbsp;/gi,
        Va
      ],
      [
        /<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi,
        function(Nn, nr) {
          return nr.length > 0 ? nr.replace(/./, " ").slice(Math.floor(nr.length / 2)).split("").join(Va) : "";
        }
      ]
    ]);
    var vt = he(x), rn = Go({
      valid_elements: vt,
      valid_children: "-li[p]"
    });
    Pe.each(rn.elements, function(Nn) {
      Nn.attributes.class || (Nn.attributes.class = {}, Nn.attributesOrder.push("class")), Nn.attributes.style || (Nn.attributes.style = {}, Nn.attributesOrder.push("style"));
    });
    var or = Mr({}, rn);
    or.addAttributeFilter("style", function(Nn) {
      for (var nr = Nn.length, jr; nr--; )
        jr = Nn[nr], jr.attr("style", Ko(x, re, jr, jr.attr("style"))), jr.name === "span" && jr.parent && !jr.attributes.length && jr.unwrap();
    }), or.addAttributeFilter("class", function(Nn) {
      for (var nr = Nn.length, jr, Vr; nr--; )
        jr = Nn[nr], Vr = jr.attr("class"), /^(MsoCommentReference|MsoCommentText|msoDel)$/i.test(Vr) && jr.remove(), jr.attr("class", null);
    }), or.addNodeFilter("del", function(Nn) {
      for (var nr = Nn.length; nr--; )
        Nn[nr].remove();
    }), or.addNodeFilter("a", function(Nn) {
      for (var nr = Nn.length, jr, Vr, Dr; nr--; ) {
        if (jr = Nn[nr], Vr = jr.attr("href"), Dr = jr.attr("name"), Vr && Vr.indexOf("#_msocom_") !== -1) {
          jr.remove();
          continue;
        }
        if (Vr && Vr.indexOf("file://") === 0 && (Vr = Vr.split("#")[1], Vr && (Vr = "#" + Vr)), !Vr && !Dr)
          jr.unwrap();
        else {
          if (Dr && !/^_?(?:toc|edn|ftn)/i.test(Dr)) {
            jr.unwrap();
            continue;
          }
          jr.attr({
            href: Vr,
            name: Dr
          });
        }
      }
    });
    var wr = or.parse(I);
    return tt(x) && $u(wr), I = Fr({ validate: Ye(x) }, rn).serialize(wr), I;
  }, Po = function(x, I) {
    return gt(x) ? pi(x, I) : I;
  }, Si = function(x, I) {
    var re = Mr({}, x.schema);
    re.addNodeFilter("meta", function(vt) {
      Pe.each(vt, function(rn) {
        rn.remove();
      });
    });
    var Oe = re.parse(I, {
      forced_root_block: !1,
      isRootContent: !0
    });
    return Fr({ validate: Ye(x) }, x.schema).serialize(Oe);
  }, Su = function(x, I) {
    return {
      content: x,
      cancelled: I
    };
  }, xi = function(x, I, re, Oe) {
    var vt = x.dom.create("div", { style: "display:none" }, I), rn = se(x, vt, re, Oe);
    return Su(rn.node.innerHTML, rn.isDefaultPrevented());
  }, Ju = function(x, I, re, Oe) {
    var vt = Jt(x, I, re, Oe), rn = Si(x, vt.content);
    return x.hasEventListeners("PastePostProcess") && !vt.isDefaultPrevented() ? xi(x, rn, re, Oe) : Su(rn, vt.isDefaultPrevented());
  }, Lo = function(x, I, re) {
    var Oe = na(I), vt = Oe ? Po(x, I) : I;
    return Ju(x, vt, re, Oe);
  }, yo = function(x, I) {
    return x.insertContent(I, {
      merge: sn(x),
      paste: !0
    }), !0;
  }, Bn = function(x) {
    return /^https?:\/\/[\w\-\/+=.,!;:&%@^~(){}?#]+$/i.test(x);
  }, xu = function(x, I) {
    return Bn(I) && Ct(Vn(x), function(re) {
      return je(I.toLowerCase(), "." + re.toLowerCase());
    });
  }, ku = function(x, I, re) {
    return x.undoManager.extra(function() {
      re(x, I);
    }, function() {
      x.insertContent('<img src="' + I + '">');
    }), !0;
  }, Tu = function(x, I, re) {
    return x.undoManager.extra(function() {
      re(x, I);
    }, function() {
      x.execCommand("mceInsertLink", !1, I);
    }), !0;
  }, Ue = function(x, I, re) {
    return x.selection.isCollapsed() === !1 && Bn(I) ? Tu(x, I, re) : !1;
  }, et = function(x, I, re) {
    return xu(x, I) ? ku(x, I, re) : !1;
  }, en = function(x, I) {
    Pe.each([
      Ue,
      et,
      yo
    ], function(re) {
      return re(x, I, yo) !== !0;
    });
  }, gn = function(x, I, re) {
    re || Ie(x) === !1 ? yo(x, I) : en(x, I);
  }, Z = function(x) {
    return " \f	\v".indexOf(x) !== -1;
  }, ye = function(x) {
    return x === `
` || x === "\r";
  }, Ve = function(x, I) {
    return I < x.length && I >= 0 ? ye(x[I]) : !1;
  }, lt = function(x, I) {
    var re = Me(" ", on(x)), Oe = I.replace(/\t/g, re), vt = _e(Oe, function(rn, or) {
      return Z(or) || or === Va ? rn.pcIsSpace || rn.str === "" || rn.str.length === Oe.length - 1 || Ve(Oe, rn.str.length + 1) ? {
        pcIsSpace: !1,
        str: rn.str + Va
      } : {
        pcIsSpace: !0,
        str: rn.str + " "
      } : {
        pcIsSpace: ye(or),
        str: rn.str + or
      };
    }, {
      pcIsSpace: !1,
      str: ""
    });
    return vt.str;
  }, Et = function(x, I, re, Oe) {
    var vt = Lo(x, I, re);
    vt.cancelled === !1 && gn(x, vt.content, Oe);
  }, Ot = function(x, I, re) {
    var Oe = re || zn(I);
    Et(x, mn(I), Oe, !1);
  }, Rn = function(x, I) {
    var re = x.dom.encode(I).replace(/\r\n/g, `
`), Oe = lt(x, re), vt = Wa(Oe, Vt(x), Xt(x));
    Et(x, vt, !1, !0);
  }, er = function(x) {
    var I = {}, re = "data:text/mce-internal,";
    if (x) {
      if (x.getData) {
        var Oe = x.getData("Text");
        Oe && Oe.length > 0 && Oe.indexOf(re) === -1 && (I["text/plain"] = Oe);
      }
      if (x.types)
        for (var vt = 0; vt < x.types.length; vt++) {
          var rn = x.types[vt];
          try {
            I[rn] = x.getData(rn);
          } catch {
            I[rn] = "";
          }
        }
    }
    return I;
  }, Rr = function(x, I) {
    return er(I.clipboardData || x.getDoc().dataTransfer);
  }, Nt = function(x, I) {
    return I in x && x[I].length > 0;
  }, vr = function(x) {
    return Nt(x, "text/html") || Nt(x, "text/plain");
  }, Nr = function(x) {
    var I = /data:([^;]+);base64,([a-z0-9\+\/=]+)/i.exec(x);
    return I ? {
      type: I[1],
      data: decodeURIComponent(I[2])
    } : {
      type: null,
      data: null
    };
  }, Sa = function(x, I) {
    var re = It(x);
    return re ? re(I) : !0;
  }, po = function(x, I) {
    var re = I.match(/([\s\S]+?)(?:\.[a-z0-9.]+)$/i);
    return Q(re) ? x.dom.encode(re[1]) : null;
  }, Xr = go("mceclip"), Lu = function(x, I) {
    var re = Nr(I.uri), Oe = re.data, vt = re.type, rn = Xr(), or = I.blob, wr = new Image();
    if (wr.src = I.uri, Sa(x, wr)) {
      var Nn = x.editorUpload.blobCache, nr = void 0, jr = Nn.getByData(Oe, vt);
      if (jr)
        nr = jr;
      else {
        var Vr = qt(x) && Q(or.name), Dr = Vr ? po(x, or.name) : rn, Qa = Vr ? or.name : void 0;
        nr = Nn.create(rn, or, Oe, Dr, Qa), Nn.add(nr);
      }
      Ot(x, '<img src="' + nr.blobUri() + '">', !1);
    } else
      Ot(x, '<img src="' + I.uri + '">', !1);
  }, Eu = function(x) {
    return x.type === "paste";
  }, vo = function(x) {
    return Q(x.getAsFile);
  }, Fs = function(x) {
    return dt.all(Be(x, function(I) {
      return new dt(function(re) {
        var Oe = vo(I) ? I.getAsFile() : I, vt = new window.FileReader();
        vt.onload = function() {
          re({
            blob: Oe,
            uri: vt.result
          });
        }, vt.readAsDataURL(Oe);
      });
    }));
  }, ki = function(x) {
    var I = Vn(x);
    return function(re) {
      return _(re.type, "image/") && Ct(I, function(Oe) {
        return gi(Oe) === re.type;
      });
    };
  }, Fi = function(x, I) {
    var re = I.items ? N(ae(I.items), function(vt) {
      return vt.kind === "file" ? [vt.getAsFile()] : [];
    }) : [], Oe = I.files ? ae(I.files) : [];
    return xe(re.length > 0 ? re : Oe, ki(x));
  }, za = function(x, I, re) {
    var Oe = Eu(I) ? I.clipboardData : I.dataTransfer;
    if (In(x) && Oe) {
      var vt = Fi(x, Oe);
      if (vt.length > 0)
        return I.preventDefault(), Fs(vt).then(function(rn) {
          re && x.selection.setRng(re), ge(rn, function(or) {
            Lu(x, or);
          });
        }), !0;
    }
    return !1;
  }, $s = function(x) {
    var I = x.clipboardData;
    return navigator.userAgent.indexOf("Android") !== -1 && I && I.items && I.items.length === 0;
  }, Qu = function(x) {
    return Tt.metaKeyPressed(x) && x.keyCode === 86 || x.shiftKey && x.keyCode === 45;
  }, hs = function(x, I, re) {
    var Oe = Ce(), vt = Ce(), rn;
    x.on("keyup", vt.clear), x.on("keydown", function(Nn) {
      var nr = function(jr) {
        Qu(jr) && !jr.isDefaultPrevented() && I.remove();
      };
      if (Qu(Nn) && !Nn.isDefaultPrevented()) {
        if (rn = Nn.shiftKey && Nn.keyCode === 86, rn && Je.webkit && navigator.userAgent.indexOf("Version/") !== -1)
          return;
        if (Nn.stopImmediatePropagation(), Oe.set(Nn), vt.set(!0), Je.ie && rn) {
          Nn.preventDefault(), _t(x, !0);
          return;
        }
        I.remove(), I.create(), x.once("keyup", nr), x.once("paste", function() {
          x.off("keyup", nr);
        });
      }
    });
    var or = function(Nn, nr, jr, Vr, Dr) {
      var Qa;
      Nt(nr, "text/html") ? Qa = nr["text/html"] : (Qa = I.getHtml(), Dr = Dr || zn(Qa), I.isDefaultContent(Qa) && (Vr = !0)), Qa = Ao(Qa), I.remove();
      var Tr = Dr === !1 && Ft(Qa), $a = Bn(Qa);
      if ((!Qa.length || Tr && !$a) && (Vr = !0), (Vr || $a) && (Nt(nr, "text/plain") && Tr ? Qa = nr["text/plain"] : Qa = mi(Qa)), I.isDefaultContent(Qa)) {
        jr || Nn.windowManager.alert("Please use Ctrl+V/Cmd+V keyboard shortcuts to paste contents.");
        return;
      }
      Vr ? Rn(Nn, Qa) : Ot(Nn, Qa, Dr);
    }, wr = function() {
      return I.getLastRng() || x.selection.getRng();
    };
    x.on("paste", function(Nn) {
      var nr = Oe.isSet() || vt.isSet();
      nr && Oe.clear();
      var jr = Rr(x, Nn), Vr = re.get() === "text" || rn, Dr = Nt(jr, _n());
      if (rn = !1, Nn.isDefaultPrevented() || $s(Nn)) {
        I.remove();
        return;
      }
      if (!vr(jr) && za(x, Nn, wr())) {
        I.remove();
        return;
      }
      nr || Nn.preventDefault(), Je.ie && (!nr || Nn.ieFake) && !Nt(jr, "text/html") && (I.create(), x.dom.bind(I.getEl(), "paste", function(Qa) {
        Qa.stopPropagation();
      }), x.getDoc().execCommand("Paste", !1, null), jr["text/html"] = I.getHtml()), Nt(jr, "text/html") ? (Nn.preventDefault(), Dr || (Dr = zn(jr["text/html"])), or(x, jr, nr, Vr, Dr)) : Lt.setEditorTimeout(x, function() {
        or(x, jr, nr, Vr, Dr);
      }, 0);
    });
  }, rl = function(x, I, re) {
    hs(x, I, re);
    var Oe;
    x.parser.addNodeFilter("img", function(vt, rn, or) {
      var wr = function(Dr) {
        return Dr.data && Dr.data.paste === !0;
      }, Nn = function(Dr) {
        !Dr.attr("data-mce-object") && Oe !== Je.transparentSrc && Dr.remove();
      }, nr = function(Dr) {
        return Dr.indexOf("webkit-fake-url") === 0;
      }, jr = function(Dr) {
        return Dr.indexOf("data:") === 0;
      };
      if (!In(x) && wr(or))
        for (var Vr = vt.length; Vr--; )
          Oe = vt[Vr].attr("src"), !!Oe && (nr(Oe) || !Qt(x) && jr(Oe)) && Nn(vt[Vr]);
    });
  }, $i = function(x) {
    return Je.ie && x.inline ? document.body : x.getBody();
  }, au = function(x) {
    return $i(x) !== x.getBody();
  }, al = function(x, I, re) {
    au(x) && x.dom.bind(I, "paste keyup", function(Oe) {
      En(x, re) || x.fire("paste");
    });
  }, qi = function(x, I, re) {
    var Oe = x.dom, vt = x.getBody();
    I.set(x.selection.getRng());
    var rn = x.dom.add($i(x), "div", {
      id: "mcepastebin",
      class: "mce-pastebin",
      contentEditable: !0,
      "data-mce-bogus": "all",
      style: "position: fixed; top: 50%; width: 10px; height: 10px; overflow: hidden; opacity: 0"
    }, re);
    (Je.ie || Je.gecko) && Oe.setStyle(rn, "left", Oe.getStyle(vt, "direction", !0) === "rtl" ? 65535 : -65535), Oe.bind(rn, "beforedeactivate focusin focusout", function(or) {
      or.stopPropagation();
    }), al(x, rn, re), rn.focus(), x.selection.select(rn, !0);
  }, Li = function(x, I) {
    if (ve(x)) {
      for (var re = void 0, Oe = I.get(); re = x.dom.get("mcepastebin"); )
        x.dom.remove(re), x.dom.unbind(re);
      Oe && x.selection.setRng(Oe);
    }
    I.set(null);
  }, ve = function(x) {
    return x.dom.get("mcepastebin");
  }, nt = function(x) {
    var I = function(wr, Nn) {
      wr.appendChild(Nn), x.dom.remove(Nn, !0);
    }, re = Pe.grep($i(x).childNodes, function(wr) {
      return wr.id === "mcepastebin";
    }), Oe = re.shift();
    Pe.each(re, function(wr) {
      I(Oe, wr);
    });
    for (var vt = x.dom.select("div[id=mcepastebin]", Oe), rn = vt.length - 1; rn >= 0; rn--) {
      var or = x.dom.create("div");
      Oe.insertBefore(or, vt[rn]), I(or, vt[rn]);
    }
    return Oe ? Oe.innerHTML : "";
  }, wt = function(x, I) {
    return I === x;
  }, Zt = function(x) {
    return x && x.id === "mcepastebin";
  }, En = function(x, I) {
    var re = ve(x);
    return Zt(re) && wt(I, re.innerHTML);
  }, lr = function(x) {
    var I = m(null), re = "%MCEPASTEBIN%";
    return {
      create: function() {
        return qi(x, I, re);
      },
      remove: function() {
        return Li(x, I);
      },
      getEl: function() {
        return ve(x);
      },
      getHtml: function() {
        return nt(x);
      },
      getLastRng: I.get,
      isDefault: function() {
        return En(x, re);
      },
      isDefaultContent: function(Oe) {
        return wt(re, Oe);
      }
    };
  }, ya = function(x, I) {
    var re = lr(x);
    return x.on("PreInit", function() {
      return rl(x, re, I);
    }), {
      pasteFormat: I,
      pasteHtml: function(Oe, vt) {
        return Ot(x, Oe, vt);
      },
      pasteText: function(Oe) {
        return Rn(x, Oe);
      },
      pasteImageData: function(Oe, vt) {
        return za(x, Oe, vt);
      },
      getDataTransferItems: er,
      hasHtmlOrText: vr,
      hasContentType: Nt
    };
  }, Aa = function(x, I) {
    I.pasteFormat.get() === "text" ? (I.pasteFormat.set("html"), tr(x, !1)) : (I.pasteFormat.set("text"), tr(x, !0)), x.focus();
  }, Yr = function(x, I) {
    x.addCommand("mceTogglePlainTextPaste", function() {
      Aa(x, I);
    }), x.addCommand("mceInsertClipboardContent", function(re, Oe) {
      Oe.content && I.pasteHtml(Oe.content, Oe.internal), Oe.text && I.pasteText(Oe.text);
    });
  }, qa = function(x) {
    return Je.iOS === !1 && typeof (x == null ? void 0 : x.setData) == "function";
  }, ao = function(x, I, re) {
    if (qa(x))
      try {
        return x.clearData(), x.setData("text/html", I), x.setData("text/plain", re), x.setData(_n(), I), !0;
      } catch {
        return !1;
      }
    else
      return !1;
  }, es = function(x, I, re, Oe) {
    ao(x.clipboardData, I.html, I.text) ? (x.preventDefault(), Oe()) : re(I.html, Oe);
  }, ti = function(x) {
    return function(I, re) {
      var Oe = yt(I), vt = x.dom.create("div", {
        contenteditable: "false",
        "data-mce-bogus": "all"
      }), rn = x.dom.create("div", { contenteditable: "true" }, Oe);
      x.dom.setStyles(vt, {
        position: "fixed",
        top: "0",
        left: "-3000px",
        width: "1000px",
        overflow: "hidden"
      }), vt.appendChild(rn), x.dom.add(x.getBody(), vt);
      var or = x.selection.getRng();
      rn.focus();
      var wr = x.dom.createRng();
      wr.selectNodeContents(rn), x.selection.setRng(wr), Lt.setTimeout(function() {
        x.selection.setRng(or), vt.parentNode.removeChild(vt), re();
      }, 0);
    };
  }, zu = function(x) {
    return {
      html: x.selection.getContent({ contextual: !0 }),
      text: x.selection.getContent({ format: "text" })
    };
  }, br = function(x) {
    return !!x.dom.getParent(x.selection.getStart(), "td[data-mce-selected],th[data-mce-selected]", x.getBody());
  }, bs = function(x) {
    return !x.selection.isCollapsed() || br(x);
  }, yc = function(x) {
    return function(I) {
      bs(x) && es(I, zu(x), ti(x), function() {
        if (Je.browser.isChrome() || Je.browser.isFirefox()) {
          var re = x.selection.getRng();
          Lt.setEditorTimeout(x, function() {
            x.selection.setRng(re), x.execCommand("Delete");
          }, 0);
        } else
          x.execCommand("Delete");
      });
    };
  }, va = function(x) {
    return function(I) {
      bs(x) && es(I, zu(x), ti(x), Y);
    };
  }, Wl = function(x) {
    x.on("cut", yc(x)), x.on("copy", va(x));
  }, ql = tinymce.util.Tools.resolve("tinymce.dom.RangeUtils"), Yc = function(x, I) {
    return ql.getCaretRangeFromPoint(I.clientX, I.clientY, x.getDoc());
  }, Fa = function(x) {
    var I = x["text/plain"];
    return I ? I.indexOf("file://") === 0 : !1;
  }, ou = function(x, I) {
    x.focus(), x.selection.setRng(I);
  }, Vf = function(x, I, re) {
    kt(x) && x.on("dragend dragover draggesture dragdrop drop drag", function(Oe) {
      Oe.preventDefault(), Oe.stopPropagation();
    }), He(x) || x.on("drop", function(Oe) {
      var vt = Oe.dataTransfer;
      vt && vt.files && vt.files.length > 0 && Oe.preventDefault();
    }), x.on("drop", function(Oe) {
      var vt = Yc(x, Oe);
      if (!(Oe.isDefaultPrevented() || re.get())) {
        var rn = I.getDataTransferItems(Oe.dataTransfer), or = I.hasContentType(rn, _n());
        if (!((!I.hasHtmlOrText(rn) || Fa(rn)) && I.pasteImageData(Oe, vt)) && vt && We(x)) {
          var wr = rn["mce-internal"] || rn["text/html"] || rn["text/plain"];
          wr && (Oe.preventDefault(), Lt.setEditorTimeout(x, function() {
            x.undoManager.transact(function() {
              rn["mce-internal"] && x.execCommand("Delete"), ou(x, vt), wr = Ao(wr), rn["text/html"] ? I.pasteHtml(wr, or) : I.pasteText(wr);
            });
          }));
        }
      }
    }), x.on("dragstart", function(Oe) {
      re.set(!0);
    }), x.on("dragover dragend", function(Oe) {
      He(x) && re.get() === !1 && (Oe.preventDefault(), ou(x, Yc(x, Oe))), Oe.type === "dragend" && re.set(!1);
    });
  }, _u = function(x) {
    var I = x.plugins.paste, re = Ae(x);
    re && x.on("PastePreProcess", function(vt) {
      re.call(I, I, vt);
    });
    var Oe = Ke(x);
    Oe && x.on("PastePostProcess", function(vt) {
      Oe.call(I, I, vt);
    });
  }, wo = function(x, I) {
    x.on("PastePreProcess", function(re) {
      re.content = I(x, re.content, re.internal, re.wordContent);
    });
  }, Ls = function(x, I) {
    x.on("PastePostProcess", function(re) {
      I(x, re.node);
    });
  }, Ut = function(x, I) {
    if (!na(I))
      return I;
    var re = [];
    Pe.each(x.schema.getBlockElements(), function(vt, rn) {
      re.push(rn);
    });
    var Oe = new RegExp("(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*(<\\/?(" + re.join("|") + ")[^>]*>)(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*", "g");
    return I = bo(I, [[
      Oe,
      "$1"
    ]]), I = bo(I, [
      [
        /<br><br>/g,
        "<BR><BR>"
      ],
      [
        /<br>/g,
        " "
      ],
      [
        /<BR><BR>/g,
        "<br>"
      ]
    ]), I;
  }, ol = function(x, I, re, Oe) {
    if (Oe || re)
      return I;
    var vt = at(x), rn;
    if (pt(x) === !1 || vt === "all")
      return I;
    if (vt && (rn = vt.split(/[, ]/)), rn) {
      var or = x.dom, wr = x.selection.getNode();
      I = I.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, function(Nn, nr, jr, Vr) {
        var Dr = or.parseStyle(or.decode(jr)), Qa = {};
        if (rn === "none")
          return nr + Vr;
        for (var Tr = 0; Tr < rn.length; Tr++) {
          var $a = Dr[rn[Tr]], Oa = or.getStyle(wr, rn[Tr], !0);
          /color/.test(rn[Tr]) && ($a = or.toHex($a), Oa = or.toHex(Oa)), Oa !== $a && (Qa[rn[Tr]] = $a);
        }
        var Ti = or.serializeStyle(Qa, "span");
        return Ti ? nr + ' style="' + Ti + '"' + Vr : nr + Vr;
      });
    } else
      I = I.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, "$1$3");
    return I = I.replace(/(<[^>]+) data-mce-style="([^"]+)"([^>]*>)/gi, function(Nn, nr, jr, Vr) {
      return nr + ' style="' + jr + '"' + Vr;
    }), I;
  }, Co = function(x, I) {
    x.$("a", I).find("font,u").each(function(re, Oe) {
      x.dom.remove(Oe, !0);
    });
  }, wc = function(x) {
    Je.webkit && wo(x, ol), Je.ie && (wo(x, Ut), Ls(x, Co));
  }, ys = function(x, I) {
    return function(re) {
      re.setActive(I.pasteFormat.get() === "text");
      var Oe = function(vt) {
        return re.setActive(vt.state);
      };
      return x.on("PastePlainTextToggle", Oe), function() {
        return x.off("PastePlainTextToggle", Oe);
      };
    };
  }, V = function(x, I) {
    var re = function() {
      return x.execCommand("mceTogglePlainTextPaste");
    };
    x.ui.registry.addToggleButton("pastetext", {
      active: !1,
      icon: "paste-text",
      tooltip: "Paste as text",
      onAction: re,
      onSetup: ys(x, I)
    }), x.ui.registry.addToggleMenuItem("pastetext", {
      text: "Paste as text",
      icon: "paste-text",
      onAction: re,
      onSetup: ys(x, I)
    });
  };
  function O() {
    y.add("paste", function(x) {
      if (w(x) === !1) {
        var I = m(!1), re = m(St(x) ? "text" : "html"), Oe = ya(x, re);
        return wc(x), V(x, Oe), Yr(x, Oe), _u(x), Wl(x), Vf(x, Oe, I), E(Oe);
      }
    });
  }
  O();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = tinymce.util.Tools.resolve("tinymce.Env"), w = tinymce.util.Tools.resolve("tinymce.util.Tools"), E = function(ue) {
    return ue.getParam("content_style", "", "string");
  }, P = function(ue) {
    return ue.getParam("content_css_cors", !1, "boolean");
  }, H = function(ue) {
    var ee = ue.getParam("body_class", "", "hash");
    return ee[ue.id] || "";
  }, X = function(ue) {
    var ee = ue.getParam("body_class", "", "string");
    return ee.indexOf("=") === -1 ? ee : H(ue);
  }, j = function(ue) {
    var ee = ue.getParam("body_id", "", "hash");
    return ee[ue.id] || ee;
  }, le = function(ue) {
    var ee = ue.getParam("body_id", "tinymce", "string");
    return ee.indexOf("=") === -1 ? ee : j(ue);
  }, Q = function(ue) {
    var ee = "", Ge = ue.dom.encode, ze = E(ue);
    ee += '<base href="' + Ge(ue.documentBaseURI.getURI()) + '">';
    var ht = P(ue) ? ' crossorigin="anonymous"' : "";
    w.each(ue.contentCSS, function(xe) {
      ee += '<link type="text/css" rel="stylesheet" href="' + Ge(ue.documentBaseURI.toAbsolute(xe)) + '"' + ht + ">";
    }), ze && (ee += '<style type="text/css">' + ze + "</style>");
    var ie = le(ue), Ze = X(ue), De = y.mac ? "e.metaKey" : "e.ctrlKey && !e.altKey", Pt = '<script>document.addEventListener && document.addEventListener("click", function(e) {for (var elm = e.target; elm; elm = elm.parentNode) {if (elm.nodeName === "A" && !(' + De + ")) {e.preventDefault();}}}, false);<\/script> ", Ct = ue.getBody().dir, Be = Ct ? ' dir="' + Ge(Ct) + '"' : "", ge = "<!DOCTYPE html><html><head>" + ee + '</head><body id="' + Ge(ie) + '" class="mce-content-body ' + Ge(Ze) + '"' + Be + ">" + ue.getContent() + Pt + "</body></html>";
    return ge;
  }, pe = function(ue) {
    var ee = Q(ue), Ge = ue.windowManager.open({
      title: "Preview",
      size: "large",
      body: {
        type: "panel",
        items: [{
          name: "preview",
          type: "iframe",
          sandboxed: !0
        }]
      },
      buttons: [{
        type: "cancel",
        name: "close",
        text: "Close",
        primary: !0
      }],
      initialData: { preview: ee }
    });
    Ge.focus("close");
  }, Y = function(ue) {
    ue.addCommand("mcePreview", function() {
      pe(ue);
    });
  }, D = function(ue) {
    var ee = function() {
      return ue.execCommand("mcePreview");
    };
    ue.ui.registry.addButton("preview", {
      icon: "preview",
      tooltip: "Preview",
      onAction: ee
    }), ue.ui.registry.addMenuItem("preview", {
      icon: "preview",
      text: "Preview",
      onAction: ee
    });
  };
  function J() {
    m.add("preview", function(ue) {
      Y(ue), D(ue);
    });
  }
  J();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = tinymce.util.Tools.resolve("tinymce.Env"), w = function(H) {
    H.addCommand("mcePrint", function() {
      y.browser.isIE() ? H.getDoc().execCommand("print", !1, null) : H.getWin().print();
    });
  }, E = function(H) {
    var X = function() {
      return H.execCommand("mcePrint");
    };
    H.ui.registry.addButton("print", {
      icon: "print",
      tooltip: "Print",
      onAction: X
    }), H.ui.registry.addMenuItem("print", {
      text: "Print...",
      icon: "print",
      onAction: X
    });
  };
  function P() {
    m.add("print", function(H) {
      w(H), E(H), H.addShortcut("Meta+P", "", "mcePrint");
    });
  }
  P();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = 0, w = function(he) {
    var tt = new Date(), gt = tt.getTime(), Ye = Math.floor(Math.random() * 1e9);
    return y++, he + "_" + Ye + y + String(gt);
  }, E = function(he, tt) {
    var gt = '<table data-mce-id="mce" style="width: 100%">';
    gt += "<tbody>";
    for (var Ye = 0; Ye < tt; Ye++) {
      gt += "<tr>";
      for (var Qt = 0; Qt < he; Qt++)
        gt += "<td><br></td>";
      gt += "</tr>";
    }
    return gt += "</tbody>", gt += "</table>", gt;
  }, P = function(he) {
    var tt = he.dom.select("*[data-mce-id]");
    return tt[0];
  }, H = function(he, tt, gt) {
    he.undoManager.transact(function() {
      he.insertContent(E(tt, gt));
      var Ye = P(he);
      Ye.removeAttribute("data-mce-id");
      var Qt = he.dom.select("td,th", Ye);
      he.selection.setCursorLocation(Qt[0], 0);
    });
  }, X = function(he, tt, gt) {
    he.plugins.table ? he.plugins.table.insertTable(tt, gt) : H(he, tt, gt);
  }, j = function(he, tt, gt) {
    var Ye = he.editorUpload.blobCache, Qt = Ye.create(w("mceu"), gt, tt);
    Ye.add(Qt), he.insertContent(he.dom.createHTML("img", { src: Qt.blobUri() }));
  }, le = tinymce.util.Tools.resolve("tinymce.util.Promise"), Q = function(he) {
    return new le(function(tt) {
      var gt = new FileReader();
      gt.onloadend = function() {
        tt(gt.result.split(",")[1]);
      }, gt.readAsDataURL(he);
    });
  }, pe = tinymce.util.Tools.resolve("tinymce.Env"), Y = tinymce.util.Tools.resolve("tinymce.util.Delay"), D = function(he) {
    return new le(function(tt) {
      var gt = document.createElement("input");
      gt.type = "file", gt.accept = "image/*", gt.style.position = "fixed", gt.style.left = "0", gt.style.top = "0", gt.style.opacity = "0.001", document.body.appendChild(gt);
      var Ye = function(In) {
        tt(Array.prototype.slice.call(In.target.files));
      };
      gt.addEventListener("change", Ye);
      var Qt = function(In) {
        var It = function() {
          tt([]), gt.parentNode.removeChild(gt);
        };
        pe.os.isAndroid() && In.type !== "remove" ? Y.setEditorTimeout(he, It, 0) : It(), he.off("focusin remove", Qt);
      };
      he.on("focusin remove", Qt), gt.click();
    });
  }, J = function(he) {
    he.ui.registry.addButton("quickimage", {
      icon: "image",
      tooltip: "Insert image",
      onAction: function() {
        D(he).then(function(tt) {
          if (tt.length > 0) {
            var gt = tt[0];
            Q(gt).then(function(Ye) {
              j(he, Ye, gt);
            });
          }
        });
      }
    }), he.ui.registry.addButton("quicktable", {
      icon: "table",
      tooltip: "Insert table",
      onAction: function() {
        X(he, 2, 2);
      }
    });
  }, ue = function(he) {
    var tt = typeof he;
    return he === null ? "null" : tt === "object" && (Array.prototype.isPrototypeOf(he) || he.constructor && he.constructor.name === "Array") ? "array" : tt === "object" && (String.prototype.isPrototypeOf(he) || he.constructor && he.constructor.name === "String") ? "string" : tt;
  }, ee = function(he) {
    return function(tt) {
      return ue(tt) === he;
    };
  }, Ge = function(he) {
    return function(tt) {
      return typeof tt === he;
    };
  }, ze = function(he) {
    return function(tt) {
      return he === tt;
    };
  }, ht = ee("string"), ie = ee("object"), Ze = ee("array"), De = Ge("boolean"), Pt = ze(void 0), Ct = Ge("function"), Be = function() {
  }, ge = function(he) {
    return function() {
      return he;
    };
  }, xe = function(he) {
    return he;
  }, _e = ge(!1), $ = ge(!0), N = function() {
    return ae;
  }, ae = function() {
    var he = function(Ye) {
      return Ye();
    }, tt = xe, gt = {
      fold: function(Ye, Qt) {
        return Ye();
      },
      isSome: _e,
      isNone: $,
      getOr: tt,
      getOrThunk: he,
      getOrDie: function(Ye) {
        throw new Error(Ye || "error: getOrDie called on none.");
      },
      getOrNull: ge(null),
      getOrUndefined: ge(void 0),
      or: tt,
      orThunk: he,
      map: N,
      each: Be,
      bind: N,
      exists: _e,
      forall: $,
      filter: function() {
        return N();
      },
      toArray: function() {
        return [];
      },
      toString: ge("none()")
    };
    return gt;
  }(), ce = function(he) {
    var tt = ge(he), gt = function() {
      return Qt;
    }, Ye = function(In) {
      return In(he);
    }, Qt = {
      fold: function(In, It) {
        return It(he);
      },
      isSome: $,
      isNone: _e,
      getOr: tt,
      getOrThunk: tt,
      getOrDie: tt,
      getOrNull: tt,
      getOrUndefined: tt,
      or: gt,
      orThunk: gt,
      map: function(In) {
        return ce(In(he));
      },
      each: function(In) {
        In(he);
      },
      bind: Ye,
      exists: Ye,
      forall: Ye,
      filter: function(In) {
        return In(he) ? Qt : ae;
      },
      toArray: function() {
        return [he];
      },
      toString: function() {
        return "some(" + he + ")";
      }
    };
    return Qt;
  }, ne = function(he) {
    return he == null ? ae : ce(he);
  }, Ce = {
    some: ce,
    none: N,
    from: ne
  };
  function Te(he, tt, gt, Ye, Qt) {
    return he(gt, Ye) ? Ce.some(gt) : Ct(Qt) && Qt(gt) ? Ce.none() : tt(gt, Ye, Qt);
  }
  var _ = 1, je = function(he, tt) {
    var gt = tt || document, Ye = gt.createElement("div");
    if (Ye.innerHTML = he, !Ye.hasChildNodes() || Ye.childNodes.length > 1)
      throw console.error("HTML does not have a single root node", he), new Error("HTML must have a single root node");
    return Lt(Ye.childNodes[0]);
  }, Me = function(he, tt) {
    var gt = tt || document, Ye = gt.createElement(he);
    return Lt(Ye);
  }, Je = function(he, tt) {
    var gt = tt || document, Ye = gt.createTextNode(he);
    return Lt(Ye);
  }, Lt = function(he) {
    if (he == null)
      throw new Error("Node cannot be null or undefined");
    return { dom: he };
  }, dt = function(he, tt, gt) {
    return Ce.from(he.dom.elementFromPoint(tt, gt)).map(Lt);
  }, Tt = {
    fromHtml: je,
    fromTag: Me,
    fromText: Je,
    fromDom: Lt,
    fromPoint: dt
  }, Jt = function(he, tt) {
    var gt = he.dom;
    if (gt.nodeType !== _)
      return !1;
    var Ye = gt;
    if (Ye.matches !== void 0)
      return Ye.matches(tt);
    if (Ye.msMatchesSelector !== void 0)
      return Ye.msMatchesSelector(tt);
    if (Ye.webkitMatchesSelector !== void 0)
      return Ye.webkitMatchesSelector(tt);
    if (Ye.mozMatchesSelector !== void 0)
      return Ye.mozMatchesSelector(tt);
    throw new Error("Browser lacks native selectors");
  };
  typeof window < "u" || Function("return this;")();
  var se = function(he) {
    var tt = he.dom.nodeName;
    return tt.toLowerCase();
  }, tr = function(he, tt, gt) {
    for (var Ye = he.dom, Qt = Ct(gt) ? gt : _e; Ye.parentNode; ) {
      Ye = Ye.parentNode;
      var In = Tt.fromDom(Ye);
      if (tt(In))
        return Ce.some(In);
      if (Qt(In))
        break;
    }
    return Ce.none();
  }, _t = function(he, tt, gt) {
    var Ye = function(Qt, In) {
      return In(Qt);
    };
    return Te(Ye, tr, he, tt, gt);
  }, Pe = function(he, tt, gt) {
    return tr(he, function(Ye) {
      return Jt(Ye, tt);
    }, gt);
  }, kt = function(he, tt, gt) {
    var Ye = function(Qt, In) {
      return Jt(Qt, In);
    };
    return Te(Ye, Pe, he, tt, gt);
  }, He = function(he, tt) {
    if (tt(he))
      return !0;
    throw new Error("Default value doesn't match requested type.");
  }, We = function(he, tt) {
    if (Ze(he) || ie(he))
      throw new Error("expected a string but found: " + he);
    return Pt(he) ? tt : De(he) ? he === !1 ? "" : tt : he;
  }, Ae = function(he) {
    return function(tt, gt, Ye) {
      He(Ye, he);
      var Qt = tt.getParam(gt, Ye);
      return We(Qt, Ye);
    };
  }, Ke = Ae(ht), at = function(he) {
    return Ke(he, "quickbars_selection_toolbar", "bold italic | quicklink h2 h3 blockquote");
  }, pt = function(he) {
    return Ke(he, "quickbars_insert_toolbar", "quickimage quicktable");
  }, sn = function(he) {
    return Ke(he, "quickbars_image_toolbar", "alignleft aligncenter alignright");
  }, Ie = function(he) {
    var tt = pt(he);
    tt.trim().length > 0 && he.ui.registry.addContextToolbar("quickblock", {
      predicate: function(gt) {
        var Ye = Tt.fromDom(gt), Qt = he.schema.getTextBlockElements(), In = function(It) {
          return It.dom === he.getBody();
        };
        return kt(Ye, "table", In).fold(function() {
          return _t(Ye, function(It) {
            return se(It) in Qt && he.dom.isEmpty(It.dom);
          }, In).isSome();
        }, _e);
      },
      items: tt,
      position: "line",
      scope: "editor"
    });
  }, St = function(he) {
    var tt = function(In) {
      return he.dom.getContentEditableParent(In) !== "false";
    }, gt = function(In) {
      return In.nodeName === "IMG" || In.nodeName === "FIGURE" && /image/i.test(In.className);
    }, Ye = sn(he);
    Ye.trim().length > 0 && he.ui.registry.addContextToolbar("imageselection", {
      predicate: gt,
      items: Ye,
      position: "node"
    });
    var Qt = at(he);
    Qt.trim().length > 0 && he.ui.registry.addContextToolbar("textselection", {
      predicate: function(In) {
        return !gt(In) && !he.selection.isCollapsed() && tt(In);
      },
      items: Qt,
      position: "selection",
      scope: "editor"
    });
  };
  function Xe() {
    m.add("quickbars", function(he) {
      J(he), Ie(he), St(he);
    });
  }
  Xe();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = tinymce.util.Tools.resolve("tinymce.dom.DOMUtils"), w = tinymce.util.Tools.resolve("tinymce.util.Tools"), E = function(J) {
    return J.getParam("save_enablewhendirty", !0);
  }, P = function(J) {
    return !!J.getParam("save_onsavecallback");
  }, H = function(J) {
    return !!J.getParam("save_oncancelcallback");
  }, X = function(J, ue) {
    J.notificationManager.open({
      text: ue,
      type: "error"
    });
  }, j = function(J) {
    var ue = y.DOM.getParent(J.id, "form");
    if (!(E(J) && !J.isDirty())) {
      if (J.save(), P(J)) {
        J.execCallback("save_onsavecallback", J), J.nodeChanged();
        return;
      }
      ue ? (J.setDirty(!1), (!ue.onsubmit || ue.onsubmit()) && (typeof ue.submit == "function" ? ue.submit() : X(J, "Error: Form submit field collision.")), J.nodeChanged()) : X(J, "Error: No form element found.");
    }
  }, le = function(J) {
    var ue = w.trim(J.startContent);
    if (H(J)) {
      J.execCallback("save_oncancelcallback", J);
      return;
    }
    J.resetContent(ue);
  }, Q = function(J) {
    J.addCommand("mceSave", function() {
      j(J);
    }), J.addCommand("mceCancel", function() {
      le(J);
    });
  }, pe = function(J) {
    return function(ue) {
      var ee = function() {
        ue.setDisabled(E(J) && !J.isDirty());
      };
      return ee(), J.on("NodeChange dirty", ee), function() {
        return J.off("NodeChange dirty", ee);
      };
    };
  }, Y = function(J) {
    J.ui.registry.addButton("save", {
      icon: "save",
      tooltip: "Save",
      disabled: !0,
      onAction: function() {
        return J.execCommand("mceSave");
      },
      onSetup: pe(J)
    }), J.ui.registry.addButton("cancel", {
      icon: "cancel",
      tooltip: "Cancel",
      disabled: !0,
      onAction: function() {
        return J.execCommand("mceCancel");
      },
      onSetup: pe(J)
    }), J.addShortcut("Meta+S", "", "mceSave");
  };
  function D() {
    m.add("save", function(J) {
      Y(J), Q(J);
    });
  }
  D();
})();
(function() {
  var m = function(Ue) {
    var et = Ue, en = function() {
      return et;
    }, gn = function(Z) {
      et = Z;
    };
    return {
      get: en,
      set: gn
    };
  }, y = tinymce.util.Tools.resolve("tinymce.PluginManager"), w = function() {
    return w = Object.assign || function(et) {
      for (var en, gn = 1, Z = arguments.length; gn < Z; gn++) {
        en = arguments[gn];
        for (var ye in en)
          Object.prototype.hasOwnProperty.call(en, ye) && (et[ye] = en[ye]);
      }
      return et;
    }, w.apply(this, arguments);
  }, E = function(Ue) {
    var et = typeof Ue;
    return Ue === null ? "null" : et === "object" && (Array.prototype.isPrototypeOf(Ue) || Ue.constructor && Ue.constructor.name === "Array") ? "array" : et === "object" && (String.prototype.isPrototypeOf(Ue) || Ue.constructor && Ue.constructor.name === "String") ? "string" : et;
  }, P = function(Ue) {
    return function(et) {
      return E(et) === Ue;
    };
  }, H = function(Ue) {
    return function(et) {
      return typeof et === Ue;
    };
  }, X = P("string"), j = P("array"), le = H("boolean"), Q = H("number"), pe = function() {
  }, Y = function(Ue) {
    return function() {
      return Ue;
    };
  }, D = function(Ue) {
    return Ue;
  }, J = Y(!1), ue = Y(!0), ee = "[!-#%-*,-\\/:;?@\\[-\\]_{}\xA1\xAB\xB7\xBB\xBF;\xB7\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1361-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u3008\u3009\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30\u2E31\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]", Ge = Y(ee), ze = function() {
    return ht;
  }, ht = function() {
    var Ue = function(gn) {
      return gn();
    }, et = D, en = {
      fold: function(gn, Z) {
        return gn();
      },
      isSome: J,
      isNone: ue,
      getOr: et,
      getOrThunk: Ue,
      getOrDie: function(gn) {
        throw new Error(gn || "error: getOrDie called on none.");
      },
      getOrNull: Y(null),
      getOrUndefined: Y(void 0),
      or: et,
      orThunk: Ue,
      map: ze,
      each: pe,
      bind: ze,
      exists: J,
      forall: ue,
      filter: function() {
        return ze();
      },
      toArray: function() {
        return [];
      },
      toString: Y("none()")
    };
    return en;
  }(), ie = function(Ue) {
    var et = Y(Ue), en = function() {
      return Z;
    }, gn = function(ye) {
      return ye(Ue);
    }, Z = {
      fold: function(ye, Ve) {
        return Ve(Ue);
      },
      isSome: ue,
      isNone: J,
      getOr: et,
      getOrThunk: et,
      getOrDie: et,
      getOrNull: et,
      getOrUndefined: et,
      or: en,
      orThunk: en,
      map: function(ye) {
        return ie(ye(Ue));
      },
      each: function(ye) {
        ye(Ue);
      },
      bind: gn,
      exists: gn,
      forall: gn,
      filter: function(ye) {
        return ye(Ue) ? Z : ht;
      },
      toArray: function() {
        return [Ue];
      },
      toString: function() {
        return "some(" + Ue + ")";
      }
    };
    return Z;
  }, Ze = function(Ue) {
    return Ue == null ? ht : ie(Ue);
  }, De = {
    some: ie,
    none: ze,
    from: Ze
  }, Pt = Ge, Ct = tinymce.util.Tools.resolve("tinymce.Env"), Be = tinymce.util.Tools.resolve("tinymce.util.Tools"), ge = Array.prototype.slice, xe = Array.prototype.push, _e = function(Ue, et) {
    for (var en = Ue.length, gn = new Array(en), Z = 0; Z < en; Z++) {
      var ye = Ue[Z];
      gn[Z] = et(ye, Z);
    }
    return gn;
  }, $ = function(Ue, et) {
    for (var en = 0, gn = Ue.length; en < gn; en++) {
      var Z = Ue[en];
      et(Z, en);
    }
  }, N = function(Ue, et) {
    for (var en = Ue.length - 1; en >= 0; en--) {
      var gn = Ue[en];
      et(gn, en);
    }
  }, ae = function(Ue, et) {
    if (Ue.length === 0)
      return [];
    for (var en = et(Ue[0]), gn = [], Z = [], ye = 0, Ve = Ue.length; ye < Ve; ye++) {
      var lt = Ue[ye], Et = et(lt);
      Et !== en && (gn.push(Z), Z = []), en = Et, Z.push(lt);
    }
    return Z.length !== 0 && gn.push(Z), gn;
  }, ce = function(Ue, et, en) {
    return $(Ue, function(gn, Z) {
      en = et(en, gn, Z);
    }), en;
  }, ne = function(Ue) {
    for (var et = [], en = 0, gn = Ue.length; en < gn; ++en) {
      if (!j(Ue[en]))
        throw new Error("Arr.flatten item " + en + " was not an array, input: " + Ue);
      xe.apply(et, Ue[en]);
    }
    return et;
  }, Ce = function(Ue, et) {
    return ne(_e(Ue, et));
  }, Te = function(Ue, et) {
    var en = ge.call(Ue, 0);
    return en.sort(et), en;
  }, _ = Object.hasOwnProperty, je = function(Ue, et) {
    return _.call(Ue, et);
  };
  typeof window < "u" || Function("return this;")();
  var Me = 9, Je = 11, Lt = 1, dt = 3, Tt = function(Ue) {
    return Ue.dom.nodeType;
  }, Jt = function(Ue) {
    return function(et) {
      return Tt(et) === Ue;
    };
  }, se = Jt(dt), tr = function(Ue, et, en) {
    if (X(en) || le(en) || Q(en))
      Ue.setAttribute(et, en + "");
    else
      throw console.error("Invalid call to Attribute.set. Key ", et, ":: Value ", en, ":: Element ", Ue), new Error("Attribute value was not simple");
  }, _t = function(Ue, et, en) {
    tr(Ue.dom, et, en);
  }, Pe = function(Ue, et, en) {
    return (Ue.compareDocumentPosition(et) & en) !== 0;
  }, kt = function(Ue, et) {
    return Pe(Ue, et, Node.DOCUMENT_POSITION_PRECEDING);
  }, He = function(Ue, et) {
    var en = et || document, gn = en.createElement("div");
    if (gn.innerHTML = Ue, !gn.hasChildNodes() || gn.childNodes.length > 1)
      throw console.error("HTML does not have a single root node", Ue), new Error("HTML must have a single root node");
    return Ke(gn.childNodes[0]);
  }, We = function(Ue, et) {
    var en = et || document, gn = en.createElement(Ue);
    return Ke(gn);
  }, Ae = function(Ue, et) {
    var en = et || document, gn = en.createTextNode(Ue);
    return Ke(gn);
  }, Ke = function(Ue) {
    if (Ue == null)
      throw new Error("Node cannot be null or undefined");
    return { dom: Ue };
  }, at = function(Ue, et, en) {
    return De.from(Ue.dom.elementFromPoint(et, en)).map(Ke);
  }, pt = {
    fromHtml: He,
    fromTag: We,
    fromText: Ae,
    fromDom: Ke,
    fromPoint: at
  }, sn = function(Ue) {
    return Ue.nodeType !== Lt && Ue.nodeType !== Me && Ue.nodeType !== Je || Ue.childElementCount === 0;
  }, Ie = function(Ue, et) {
    var en = et === void 0 ? document : et.dom;
    return sn(en) ? [] : _e(en.querySelectorAll(Ue), pt.fromDom);
  }, St = function(Ue) {
    return De.from(Ue.dom.parentNode).map(pt.fromDom);
  }, Xe = function(Ue) {
    return _e(Ue.dom.childNodes, pt.fromDom);
  }, he = function(Ue, et) {
    return {
      element: Ue,
      offset: et
    };
  }, tt = function(Ue, et) {
    var en = Xe(Ue);
    return en.length > 0 && et < en.length ? he(en[et], 0) : he(Ue, et);
  }, gt = function(Ue, et) {
    var en = St(Ue);
    en.each(function(gn) {
      gn.dom.insertBefore(et.dom, Ue.dom);
    });
  }, Ye = function(Ue, et) {
    Ue.dom.appendChild(et.dom);
  }, Qt = function(Ue, et) {
    gt(Ue, et), Ye(et, Ue);
  }, In = function(Ue, et) {
    var en = function(ye) {
      if (!Ue(ye))
        throw new Error("Can only get " + et + " value of a " + et + " node");
      return gn(ye).getOr("");
    }, gn = function(ye) {
      return Ue(ye) ? De.from(ye.dom.nodeValue) : De.none();
    }, Z = function(ye, Ve) {
      if (!Ue(ye))
        throw new Error("Can only set raw " + et + " value of a " + et + " node");
      ye.dom.nodeValue = Ve;
    };
    return {
      get: en,
      getOption: gn,
      set: Z
    };
  }, It = In(se, "text"), qt = function(Ue) {
    return It.get(Ue);
  }, Vt = function(Ue, et) {
    return Ie(et, Ue);
  }, Xt = tinymce.util.Tools.resolve("tinymce.dom.TreeWalker"), on = function(Ue, et) {
    return Ue.isBlock(et) || je(Ue.schema.getShortEndedElements(), et.nodeName);
  }, Vn = function(Ue, et) {
    return Ue.getContentEditable(et) === "false";
  }, Un = function(Ue, et) {
    return Ue.getContentEditable(et) === "true" && Ue.getContentEditableParent(et.parentNode) === "false";
  }, Tn = function(Ue, et) {
    return !Ue.isBlock(et) && je(Ue.schema.getWhiteSpaceElements(), et.nodeName);
  }, yt = function(Ue, et) {
    return on(Ue, et) || Vn(Ue, et) || Tn(Ue, et) || Un(Ue, et);
  }, mn = function(Ue) {
    return Ue.nodeType === 3;
  }, zn = function() {
    return {
      sOffset: 0,
      fOffset: 0,
      elements: []
    };
  }, _n = function(Ue, et) {
    return tt(pt.fromDom(Ue), et);
  }, Kr = function(Ue, et, en, gn, Z, ye) {
    ye === void 0 && (ye = !0);
    for (var Ve = ye ? et(!1) : en; Ve; ) {
      var lt = Vn(Ue, Ve);
      if (lt || Tn(Ue, Ve)) {
        var Et = lt ? gn.cef(Ve) : gn.boundary(Ve);
        if (Et)
          break;
        Ve = et(!0);
        continue;
      } else if (on(Ue, Ve)) {
        if (gn.boundary(Ve))
          break;
      } else
        mn(Ve) && gn.text(Ve);
      if (Ve === Z)
        break;
      Ve = et(!1);
    }
  }, ot = function(Ue, et, en, gn, Z) {
    if (!yt(Ue, en)) {
      var ye = Ue.getParent(gn, Ue.isBlock), Ve = new Xt(en, ye), lt = Z ? Ve.next.bind(Ve) : Ve.prev.bind(Ve);
      Kr(Ue, lt, en, {
        boundary: ue,
        cef: ue,
        text: function(Et) {
          Z ? et.fOffset += Et.length : et.sOffset += Et.length, et.elements.push(pt.fromDom(Et));
        }
      });
    }
  }, Yt = function(Ue, et, en, gn, Z, ye) {
    ye === void 0 && (ye = !0);
    var Ve = new Xt(en, et), lt = [], Et = zn();
    ot(Ue, Et, en, et, !1);
    var Ot = function() {
      return Et.elements.length > 0 && (lt.push(Et), Et = zn()), !1;
    };
    return Kr(Ue, Ve.next.bind(Ve), en, {
      boundary: Ot,
      cef: function(Rn) {
        return Ot(), Z && lt.push.apply(lt, Z.cef(Rn)), !1;
      },
      text: function(Rn) {
        Et.elements.push(pt.fromDom(Rn)), Z && Z.text(Rn, Et);
      }
    }, gn, ye), gn && ot(Ue, Et, gn, et, !0), Ot(), lt;
  }, Ft = function(Ue, et) {
    var en = _n(et.startContainer, et.startOffset), gn = en.element.dom, Z = _n(et.endContainer, et.endOffset), ye = Z.element.dom;
    return Yt(Ue, et.commonAncestorContainer, gn, ye, {
      text: function(Ve, lt) {
        Ve === ye ? lt.fOffset += Ve.length - Z.offset : Ve === gn && (lt.sOffset += en.offset);
      },
      cef: function(Ve) {
        var lt = Ce(Vt(pt.fromDom(Ve), "*[contenteditable=true]"), function(Et) {
          var Ot = Et.dom;
          return Yt(Ue, Ot, Ot);
        });
        return Te(lt, function(Et, Ot) {
          return kt(Et.elements[0].dom, Ot.elements[0].dom) ? 1 : -1;
        });
      }
    }, !1);
  }, yn = function(Ue, et) {
    return et.collapsed ? [] : Ft(Ue, et);
  }, Yn = function(Ue, et) {
    var en = Ue.createRng();
    return en.selectNode(et), yn(Ue, en);
  }, Ir = function(Ue, et) {
    return Ce(et, function(en) {
      return Yn(Ue, en);
    });
  }, Wa = function(Ue, et, en, gn) {
    en === void 0 && (en = 0), gn === void 0 && (gn = Ue.length);
    var Z = et.regex;
    Z.lastIndex = en;
    for (var ye = [], Ve; Ve = Z.exec(Ue); ) {
      var lt = Ve[et.matchIndex], Et = Ve.index + Ve[0].indexOf(lt), Ot = Et + lt.length;
      if (Ot > gn)
        break;
      ye.push({
        start: Et,
        finish: Ot
      }), Z.lastIndex = Ot;
    }
    return ye;
  }, Mr = function(Ue, et) {
    var en = ce(Ue, function(gn, Z) {
      var ye = qt(Z), Ve = gn.last, lt = Ve + ye.length, Et = Ce(et, function(Ot, Rn) {
        return Ot.start < lt && Ot.finish > Ve ? [{
          element: Z,
          start: Math.max(Ve, Ot.start) - Ve,
          finish: Math.min(lt, Ot.finish) - Ve,
          matchId: Rn
        }] : [];
      });
      return {
        results: gn.results.concat(Et),
        last: lt
      };
    }, {
      results: [],
      last: 0
    }).results;
    return ae(en, function(gn) {
      return gn.matchId;
    });
  }, Fr = function(Ue, et) {
    return Ce(et, function(en) {
      var gn = en.elements, Z = _e(gn, qt).join(""), ye = Wa(Z, Ue, en.sOffset, Z.length - en.fOffset);
      return Mr(gn, ye);
    });
  }, Va = function(Ue, et) {
    N(Ue, function(en, gn) {
      N(en, function(Z) {
        var ye = pt.fromDom(et.cloneNode(!1));
        _t(ye, "data-mce-index", gn);
        var Ve = Z.element.dom;
        if (Ve.length === Z.finish && Z.start === 0)
          Qt(Z.element, ye);
        else {
          Ve.length !== Z.finish && Ve.splitText(Z.finish);
          var lt = Ve.splitText(Z.start);
          Qt(pt.fromDom(lt), ye);
        }
      });
    });
  }, Qo = function(Ue, et, en, gn) {
    var Z = Yn(Ue, en), ye = Fr(et, Z);
    return Va(ye, gn), ye.length;
  }, Go = function(Ue, et, en, gn) {
    var Z = en.getBookmark(), ye = Ue.select("td[data-mce-selected],th[data-mce-selected]"), Ve = ye.length > 0 ? Ir(Ue, ye) : yn(Ue, en.getRng()), lt = Fr(et, Ve);
    return Va(lt, gn), en.moveToBookmark(Z), lt.length;
  }, so = function(Ue) {
    var et = Ue.getAttribute("data-mce-index");
    return typeof et == "number" ? "" + et : et;
  }, bo = function(Ue, et, en, gn) {
    var Z = Ue.dom.create("span", { "data-mce-bogus": 1 });
    Z.className = "mce-match-marker";
    var ye = Ue.getBody();
    return Po(Ue, et, !1), gn ? Go(Ue.dom, en, Ue.selection, Z) : Qo(Ue.dom, en, ye, Z);
  }, mi = function(Ue) {
    var et = Ue.parentNode;
    Ue.firstChild && et.insertBefore(Ue.firstChild, Ue), Ue.parentNode.removeChild(Ue);
  }, Ao = function(Ue, et) {
    var en = [], gn = Be.toArray(Ue.getBody().getElementsByTagName("span"));
    if (gn.length)
      for (var Z = 0; Z < gn.length; Z++) {
        var ye = so(gn[Z]);
        ye === null || !ye.length || ye === et.toString() && en.push(gn[Z]);
      }
    return en;
  }, go = function(Ue, et, en) {
    var gn = et.get(), Z = gn.index, ye = Ue.dom;
    en = en !== !1, en ? Z + 1 === gn.count ? Z = 0 : Z++ : Z - 1 === -1 ? Z = gn.count - 1 : Z--, ye.removeClass(Ao(Ue, gn.index), "mce-match-marker-selected");
    var Ve = Ao(Ue, Z);
    return Ve.length ? (ye.addClass(Ao(Ue, Z), "mce-match-marker-selected"), Ue.selection.scrollIntoView(Ve[0]), Z) : -1;
  }, gi = function(Ue, et) {
    var en = et.parentNode;
    Ue.remove(et), Ue.isEmpty(en) && Ue.remove(en);
  }, na = function(Ue, et) {
    var en = Ue.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&").replace(/\s/g, "[^\\S\\r\\n\\uFEFF]"), gn = "(" + en + ")";
    return et ? "(?:^|\\s|" + Pt() + ")" + gn + ("(?=$|\\s|" + Pt() + ")") : gn;
  }, ei = function(Ue, et, en, gn, Z, ye) {
    var Ve = Ue.selection, lt = na(en, Z), Et = Ve.isForward(), Ot = {
      regex: new RegExp(lt, gn ? "g" : "gi"),
      matchIndex: 1
    }, Rn = bo(Ue, et, Ot, ye);
    if (Ct.browser.isSafari() && Ve.setRng(Ve.getRng(), Et), Rn) {
      var er = go(Ue, et, !0);
      et.set({
        index: er,
        count: Rn,
        text: en,
        matchCase: gn,
        wholeWord: Z,
        inSelection: ye
      });
    }
    return Rn;
  }, sr = function(Ue, et) {
    var en = go(Ue, et, !0);
    et.set(w(w({}, et.get()), { index: en }));
  }, $u = function(Ue, et) {
    var en = go(Ue, et, !1);
    et.set(w(w({}, et.get()), { index: en }));
  }, Ko = function(Ue) {
    var et = so(Ue);
    return et !== null && et.length > 0;
  }, pi = function(Ue, et, en, gn, Z) {
    var ye = et.get(), Ve = ye.index, lt, Et = Ve;
    gn = gn !== !1;
    for (var Ot = Ue.getBody(), Rn = Be.grep(Be.toArray(Ot.getElementsByTagName("span")), Ko), er = 0; er < Rn.length; er++) {
      var Rr = so(Rn[er]), Nt = lt = parseInt(Rr, 10);
      if (Z || Nt === ye.index) {
        for (en.length ? (Rn[er].firstChild.nodeValue = en, mi(Rn[er])) : gi(Ue.dom, Rn[er]); Rn[++er]; )
          if (Nt = parseInt(so(Rn[er]), 10), Nt === lt)
            gi(Ue.dom, Rn[er]);
          else {
            er--;
            break;
          }
        gn && Et--;
      } else
        lt > Ve && Rn[er].setAttribute("data-mce-index", String(lt - 1));
    }
    return et.set(w(w({}, ye), {
      count: Z ? 0 : ye.count - 1,
      index: Et
    })), gn ? sr(Ue, et) : $u(Ue, et), !Z && et.get().count > 0;
  }, Po = function(Ue, et, en) {
    for (var gn, Z, ye = et.get(), Ve = Be.toArray(Ue.getBody().getElementsByTagName("span")), lt = 0; lt < Ve.length; lt++) {
      var Et = so(Ve[lt]);
      Et !== null && Et.length && (Et === ye.index.toString() && (gn || (gn = Ve[lt].firstChild), Z = Ve[lt].firstChild), mi(Ve[lt]));
    }
    if (et.set(w(w({}, ye), {
      index: -1,
      count: 0,
      text: ""
    })), gn && Z) {
      var Ot = Ue.dom.createRng();
      return Ot.setStart(gn, 0), Ot.setEnd(Z, Z.data.length), en !== !1 && Ue.selection.setRng(Ot), Ot;
    }
  }, Si = function(Ue, et) {
    return et.get().count > 1;
  }, Su = function(Ue, et) {
    return et.get().count > 1;
  }, xi = function(Ue, et) {
    var en = function(lt) {
      return Po(Ue, et, lt);
    }, gn = function(lt, Et, Ot, Rn) {
      return Rn === void 0 && (Rn = !1), ei(Ue, et, lt, Et, Ot, Rn);
    }, Z = function() {
      return sr(Ue, et);
    }, ye = function() {
      return $u(Ue, et);
    }, Ve = function(lt, Et, Ot) {
      return pi(Ue, et, lt, Et, Ot);
    };
    return {
      done: en,
      find: gn,
      next: Z,
      prev: ye,
      replace: Ve
    };
  }, Ju = function(Ue) {
    var et = m(De.none()), en = function() {
      return et.get().each(Ue);
    }, gn = function() {
      en(), et.set(De.none());
    }, Z = function() {
      return et.get().isSome();
    }, ye = function() {
      return et.get();
    }, Ve = function(lt) {
      en(), et.set(De.some(lt));
    };
    return {
      clear: gn,
      isSet: Z,
      get: ye,
      set: Ve
    };
  }, Lo = function() {
    var Ue = Ju(pe), et = function(en) {
      return Ue.get().each(en);
    };
    return w(w({}, Ue), { on: et });
  }, yo = function(Ue, et) {
    var en = Lo();
    Ue.undoManager.add();
    var gn = Be.trim(Ue.selection.getContent({ format: "text" })), Z = function(vr) {
      var Nr = Si(Ue, et) ? vr.enable : vr.disable;
      Nr("next");
      var Sa = Su(Ue, et) ? vr.enable : vr.disable;
      Sa("prev");
    }, ye = function(vr) {
      var Nr = vr.getData(), Sa = et.get();
      et.set(w(w({}, Sa), {
        matchCase: Nr.matchcase,
        wholeWord: Nr.wholewords,
        inSelection: Nr.inselection
      }));
    }, Ve = function(vr, Nr) {
      var Sa = [
        "replace",
        "replaceall",
        "prev",
        "next"
      ], po = Nr ? vr.disable : vr.enable;
      $(Sa, po);
    }, lt = function(vr) {
      Ue.windowManager.alert("Could not find the specified string.", function() {
        vr.focus("findtext");
      });
    }, Et = function(vr, Nr) {
      Ct.browser.isSafari() && Ct.deviceType.isTouch() && (Nr === "find" || Nr === "replace" || Nr === "replaceall") && vr.focus(Nr);
    }, Ot = function(vr) {
      Po(Ue, et, !1), Ve(vr, !0), Z(vr);
    }, Rn = function(vr) {
      var Nr = vr.getData(), Sa = et.get();
      if (!Nr.findtext.length) {
        Ot(vr);
        return;
      }
      if (Sa.text === Nr.findtext && Sa.matchCase === Nr.matchcase && Sa.wholeWord === Nr.wholewords)
        sr(Ue, et);
      else {
        var po = ei(Ue, et, Nr.findtext, Nr.matchcase, Nr.wholewords, Nr.inselection);
        po <= 0 && lt(vr), Ve(vr, po === 0);
      }
      Z(vr);
    }, er = et.get(), Rr = {
      findtext: gn,
      replacetext: "",
      wholewords: er.wholeWord,
      matchcase: er.matchCase,
      inselection: er.inSelection
    }, Nt = {
      title: "Find and Replace",
      size: "normal",
      body: {
        type: "panel",
        items: [
          {
            type: "bar",
            items: [
              {
                type: "input",
                name: "findtext",
                placeholder: "Find",
                maximized: !0,
                inputMode: "search"
              },
              {
                type: "button",
                name: "prev",
                text: "Previous",
                icon: "action-prev",
                disabled: !0,
                borderless: !0
              },
              {
                type: "button",
                name: "next",
                text: "Next",
                icon: "action-next",
                disabled: !0,
                borderless: !0
              }
            ]
          },
          {
            type: "input",
            name: "replacetext",
            placeholder: "Replace with",
            inputMode: "search"
          }
        ]
      },
      buttons: [
        {
          type: "menu",
          name: "options",
          icon: "preferences",
          tooltip: "Preferences",
          align: "start",
          items: [
            {
              type: "togglemenuitem",
              name: "matchcase",
              text: "Match case"
            },
            {
              type: "togglemenuitem",
              name: "wholewords",
              text: "Find whole words only"
            },
            {
              type: "togglemenuitem",
              name: "inselection",
              text: "Find in selection"
            }
          ]
        },
        {
          type: "custom",
          name: "find",
          text: "Find",
          primary: !0
        },
        {
          type: "custom",
          name: "replace",
          text: "Replace",
          disabled: !0
        },
        {
          type: "custom",
          name: "replaceall",
          text: "Replace all",
          disabled: !0
        }
      ],
      initialData: Rr,
      onChange: function(vr, Nr) {
        Nr.name === "findtext" && et.get().count > 0 && Ot(vr);
      },
      onAction: function(vr, Nr) {
        var Sa = vr.getData();
        switch (Nr.name) {
          case "find":
            Rn(vr);
            break;
          case "replace":
            pi(Ue, et, Sa.replacetext) ? Z(vr) : Ot(vr);
            break;
          case "replaceall":
            pi(Ue, et, Sa.replacetext, !0, !0), Ot(vr);
            break;
          case "prev":
            $u(Ue, et), Z(vr);
            break;
          case "next":
            sr(Ue, et), Z(vr);
            break;
          case "matchcase":
          case "wholewords":
          case "inselection":
            ye(vr), Ot(vr);
            break;
        }
        Et(vr, Nr.name);
      },
      onSubmit: function(vr) {
        Rn(vr), Et(vr, "find");
      },
      onClose: function() {
        Ue.focus(), Po(Ue, et), Ue.undoManager.add();
      }
    };
    en.set(Ue.windowManager.open(Nt, { inline: "toolbar" }));
  }, Bn = function(Ue, et) {
    Ue.addCommand("SearchReplace", function() {
      yo(Ue, et);
    });
  }, xu = function(Ue, et) {
    return function() {
      yo(Ue, et);
    };
  }, ku = function(Ue, et) {
    Ue.ui.registry.addMenuItem("searchreplace", {
      text: "Find and replace...",
      shortcut: "Meta+F",
      onAction: xu(Ue, et),
      icon: "search"
    }), Ue.ui.registry.addButton("searchreplace", {
      tooltip: "Find and replace",
      onAction: xu(Ue, et),
      icon: "search"
    }), Ue.shortcuts.add("Meta+F", "", xu(Ue, et));
  };
  function Tu() {
    y.add("searchreplace", function(Ue) {
      var et = m({
        index: -1,
        count: 0,
        text: "",
        matchCase: !1,
        wholeWord: !1,
        inSelection: !1
      });
      return Bn(Ue, et), ku(Ue, et), xi(Ue, et);
    });
  }
  Tu();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = tinymce.util.Tools.resolve("tinymce.dom.DOMUtils"), w = tinymce.util.Tools.resolve("tinymce.EditorManager"), E = tinymce.util.Tools.resolve("tinymce.Env"), P = tinymce.util.Tools.resolve("tinymce.util.Delay"), H = tinymce.util.Tools.resolve("tinymce.util.Tools"), X = tinymce.util.Tools.resolve("tinymce.util.VK"), j = function(J) {
    return J.getParam("tabfocus_elements", ":prev,:next");
  }, le = function(J) {
    return J.getParam("tab_focus", j(J));
  }, Q = y.DOM, pe = function(J) {
    J.keyCode === X.TAB && !J.ctrlKey && !J.altKey && !J.metaKey && J.preventDefault();
  }, Y = function(J) {
    var ue = function(ee) {
      var Ge;
      if (!(ee.keyCode !== X.TAB || ee.ctrlKey || ee.altKey || ee.metaKey || ee.isDefaultPrevented())) {
        var ze = function(De) {
          var Pt = Q.select(":input:enabled,*[tabindex]:not(iframe)"), Ct = function(xe) {
            var _e = xe;
            return xe.nodeName === "BODY" || _e.type !== "hidden" && _e.style.display !== "none" && _e.style.visibility !== "hidden" && Ct(xe.parentNode);
          }, Be = function(xe) {
            return /INPUT|TEXTAREA|BUTTON/.test(xe.tagName) && w.get(ee.id) && xe.tabIndex !== -1 && Ct(xe);
          };
          if (H.each(Pt, function(xe, _e) {
            if (xe.id === J.id)
              return Ge = _e, !1;
          }), De > 0) {
            for (var ge = Ge + 1; ge < Pt.length; ge++)
              if (Be(Pt[ge]))
                return Pt[ge];
          } else
            for (var ge = Ge - 1; ge >= 0; ge--)
              if (Be(Pt[ge]))
                return Pt[ge];
          return null;
        }, ht = H.explode(le(J));
        ht.length === 1 && (ht[1] = ht[0], ht[0] = ":prev");
        var ie;
        if (ee.shiftKey ? ht[0] === ":prev" ? ie = ze(-1) : ie = Q.get(ht[0]) : ht[1] === ":next" ? ie = ze(1) : ie = Q.get(ht[1]), ie) {
          var Ze = w.get(ie.id || ie.name);
          ie.id && Ze ? Ze.focus() : P.setTimeout(function() {
            E.webkit || window.focus(), ie.focus();
          }, 10), ee.preventDefault();
        }
      }
    };
    J.on("init", function() {
      J.inline && Q.setAttrib(J.getBody(), "tabIndex", null), J.on("keyup", pe), E.gecko ? J.on("keypress keydown", ue) : J.on("keydown", ue);
    });
  };
  function D() {
    m.add("tabfocus", function(J) {
      Y(J);
    });
  }
  D();
})();
(function() {
  var m = function(u) {
    var c = typeof u;
    return u === null ? "null" : c === "object" && (Array.prototype.isPrototypeOf(u) || u.constructor && u.constructor.name === "Array") ? "array" : c === "object" && (String.prototype.isPrototypeOf(u) || u.constructor && u.constructor.name === "String") ? "string" : c;
  }, y = function(u) {
    return function(c) {
      return m(c) === u;
    };
  }, w = function(u) {
    return function(c) {
      return typeof c === u;
    };
  }, E = function(u) {
    return function(c) {
      return u === c;
    };
  }, P = y("string"), H = y("object"), X = y("array"), j = E(null), le = w("boolean"), Q = E(void 0), pe = function(u) {
    return u == null;
  }, Y = function(u) {
    return !pe(u);
  }, D = w("function"), J = w("number"), ue = function() {
  }, ee = function(u, c) {
    return function() {
      for (var d = [], h = 0; h < arguments.length; h++)
        d[h] = arguments[h];
      return u(c.apply(null, d));
    };
  }, Ge = function(u, c) {
    return function(d) {
      return u(c(d));
    };
  }, ze = function(u) {
    return function() {
      return u;
    };
  }, ht = function(u) {
    return u;
  }, ie = function(u, c) {
    return u === c;
  };
  function Ze(u) {
    for (var c = [], d = 1; d < arguments.length; d++)
      c[d - 1] = arguments[d];
    return function() {
      for (var h = [], S = 0; S < arguments.length; S++)
        h[S] = arguments[S];
      var B = c.concat(h);
      return u.apply(null, B);
    };
  }
  var De = function(u) {
    return function(c) {
      return !u(c);
    };
  }, Pt = function(u) {
    return function() {
      throw new Error(u);
    };
  }, Ct = ze(!1), Be = ze(!0), ge = function() {
    return xe;
  }, xe = function() {
    var u = function(h) {
      return h();
    }, c = ht, d = {
      fold: function(h, S) {
        return h();
      },
      isSome: Ct,
      isNone: Be,
      getOr: c,
      getOrThunk: u,
      getOrDie: function(h) {
        throw new Error(h || "error: getOrDie called on none.");
      },
      getOrNull: ze(null),
      getOrUndefined: ze(void 0),
      or: c,
      orThunk: u,
      map: ge,
      each: ue,
      bind: ge,
      exists: Ct,
      forall: Be,
      filter: function() {
        return ge();
      },
      toArray: function() {
        return [];
      },
      toString: ze("none()")
    };
    return d;
  }(), _e = function(u) {
    var c = ze(u), d = function() {
      return S;
    }, h = function(B) {
      return B(u);
    }, S = {
      fold: function(B, L) {
        return L(u);
      },
      isSome: Be,
      isNone: Ct,
      getOr: c,
      getOrThunk: c,
      getOrDie: c,
      getOrNull: c,
      getOrUndefined: c,
      or: d,
      orThunk: d,
      map: function(B) {
        return _e(B(u));
      },
      each: function(B) {
        B(u);
      },
      bind: h,
      exists: h,
      forall: h,
      filter: function(B) {
        return B(u) ? S : xe;
      },
      toArray: function() {
        return [u];
      },
      toString: function() {
        return "some(" + u + ")";
      }
    };
    return S;
  }, $ = function(u) {
    return u == null ? xe : _e(u);
  }, N = {
    some: _e,
    none: ge,
    from: $
  }, ae = Array.prototype.slice, ce = Array.prototype.indexOf, ne = Array.prototype.push, Ce = function(u, c) {
    return ce.call(u, c);
  }, Te = function(u, c) {
    return Ce(u, c) > -1;
  }, _ = function(u, c) {
    for (var d = 0, h = u.length; d < h; d++) {
      var S = u[d];
      if (c(S, d))
        return !0;
    }
    return !1;
  }, je = function(u, c) {
    for (var d = [], h = 0; h < u; h++)
      d.push(c(h));
    return d;
  }, Me = function(u, c) {
    for (var d = u.length, h = new Array(d), S = 0; S < d; S++) {
      var B = u[S];
      h[S] = c(B, S);
    }
    return h;
  }, Je = function(u, c) {
    for (var d = 0, h = u.length; d < h; d++) {
      var S = u[d];
      c(S, d);
    }
  }, Lt = function(u, c) {
    for (var d = u.length - 1; d >= 0; d--) {
      var h = u[d];
      c(h, d);
    }
  }, dt = function(u, c) {
    for (var d = [], h = [], S = 0, B = u.length; S < B; S++) {
      var L = u[S], W = c(L, S) ? d : h;
      W.push(L);
    }
    return {
      pass: d,
      fail: h
    };
  }, Tt = function(u, c) {
    for (var d = [], h = 0, S = u.length; h < S; h++) {
      var B = u[h];
      c(B, h) && d.push(B);
    }
    return d;
  }, Jt = function(u, c, d) {
    return Lt(u, function(h, S) {
      d = c(d, h, S);
    }), d;
  }, se = function(u, c, d) {
    return Je(u, function(h, S) {
      d = c(d, h, S);
    }), d;
  }, tr = function(u, c, d) {
    for (var h = 0, S = u.length; h < S; h++) {
      var B = u[h];
      if (c(B, h))
        return N.some(B);
      if (d(B, h))
        break;
    }
    return N.none();
  }, _t = function(u, c) {
    return tr(u, c, Ct);
  }, Pe = function(u, c) {
    for (var d = 0, h = u.length; d < h; d++) {
      var S = u[d];
      if (c(S, d))
        return N.some(d);
    }
    return N.none();
  }, kt = function(u) {
    for (var c = [], d = 0, h = u.length; d < h; ++d) {
      if (!X(u[d]))
        throw new Error("Arr.flatten item " + d + " was not an array, input: " + u);
      ne.apply(c, u[d]);
    }
    return c;
  }, He = function(u, c) {
    return kt(Me(u, c));
  }, We = function(u, c) {
    for (var d = 0, h = u.length; d < h; ++d) {
      var S = u[d];
      if (c(S, d) !== !0)
        return !1;
    }
    return !0;
  }, Ae = function(u) {
    var c = ae.call(u, 0);
    return c.reverse(), c;
  }, Ke = function(u, c) {
    for (var d = {}, h = 0, S = u.length; h < S; h++) {
      var B = u[h];
      d[String(B)] = c(B, h);
    }
    return d;
  }, at = function(u) {
    return [u];
  }, pt = function(u, c) {
    var d = ae.call(u, 0);
    return d.sort(c), d;
  }, sn = function(u, c) {
    return c >= 0 && c < u.length ? N.some(u[c]) : N.none();
  }, Ie = function(u) {
    return sn(u, 0);
  }, St = function(u) {
    return sn(u, u.length - 1);
  }, Xe = function(u, c) {
    for (var d = 0; d < u.length; d++) {
      var h = c(u[d], d);
      if (h.isSome())
        return h;
    }
    return N.none();
  }, he = function() {
    return he = Object.assign || function(c) {
      for (var d, h = 1, S = arguments.length; h < S; h++) {
        d = arguments[h];
        for (var B in d)
          Object.prototype.hasOwnProperty.call(d, B) && (c[B] = d[B]);
      }
      return c;
    }, he.apply(this, arguments);
  };
  function tt(u, c, d) {
    if (d || arguments.length === 2)
      for (var h = 0, S = c.length, B; h < S; h++)
        (B || !(h in c)) && (B || (B = Array.prototype.slice.call(c, 0, h)), B[h] = c[h]);
    return u.concat(B || Array.prototype.slice.call(c));
  }
  var gt = function(u) {
    var c = !1, d;
    return function() {
      for (var h = [], S = 0; S < arguments.length; S++)
        h[S] = arguments[S];
      return c || (c = !0, d = u.apply(null, h)), d;
    };
  }, Ye = function(u, c, d, h) {
    var S = u.isiOS() && /ipad/i.test(d) === !0, B = u.isiOS() && !S, L = u.isiOS() || u.isAndroid(), W = L || h("(pointer:coarse)"), me = S || !B && L && h("(min-device-width:768px)"), Re = B || L && !me, rt = c.isSafari() && u.isiOS() && /safari/i.test(d) === !1, jt = !Re && !me && !rt;
    return {
      isiPad: ze(S),
      isiPhone: ze(B),
      isTablet: ze(me),
      isPhone: ze(Re),
      isTouch: ze(W),
      isAndroid: u.isAndroid,
      isiOS: u.isiOS,
      isWebView: ze(rt),
      isDesktop: ze(jt)
    };
  }, Qt = function(u, c) {
    for (var d = 0; d < u.length; d++) {
      var h = u[d];
      if (h.test(c))
        return h;
    }
  }, In = function(u, c) {
    var d = Qt(u, c);
    if (!d)
      return {
        major: 0,
        minor: 0
      };
    var h = function(S) {
      return Number(c.replace(d, "$" + S));
    };
    return Vt(h(1), h(2));
  }, It = function(u, c) {
    var d = String(c).toLowerCase();
    return u.length === 0 ? qt() : In(u, d);
  }, qt = function() {
    return Vt(0, 0);
  }, Vt = function(u, c) {
    return {
      major: u,
      minor: c
    };
  }, Xt = {
    nu: Vt,
    detect: It,
    unknown: qt
  }, on = function(u, c) {
    return Xe(c.brands, function(d) {
      var h = d.brand.toLowerCase();
      return _t(u, function(S) {
        var B;
        return h === ((B = S.brand) === null || B === void 0 ? void 0 : B.toLowerCase());
      }).map(function(S) {
        return {
          current: S.name,
          version: Xt.nu(parseInt(d.version, 10), 0)
        };
      });
    });
  }, Vn = function(u, c) {
    var d = String(c).toLowerCase();
    return _t(u, function(h) {
      return h.search(d);
    });
  }, Un = function(u, c) {
    return Vn(u, c).map(function(d) {
      var h = Xt.detect(d.versionRegexes, c);
      return {
        current: d.name,
        version: h
      };
    });
  }, Tn = function(u, c) {
    return Vn(u, c).map(function(d) {
      var h = Xt.detect(d.versionRegexes, c);
      return {
        current: d.name,
        version: h
      };
    });
  }, yt = function(u, c) {
    return u.substring(c);
  }, mn = function(u, c, d) {
    return c === "" || u.length >= c.length && u.substr(d, d + c.length) === c;
  }, zn = function(u, c) {
    return Kr(u, c) ? yt(u, c.length) : u;
  }, _n = function(u, c) {
    return u.indexOf(c) !== -1;
  }, Kr = function(u, c) {
    return mn(u, c, 0);
  }, ot = function(u, c) {
    return mn(u, c, u.length - c.length);
  }, Yt = function(u) {
    return function(c) {
      return c.replace(u, "");
    };
  }, Ft = Yt(/^\s+|\s+$/g), yn = function(u) {
    return u.length > 0;
  }, Yn = function(u) {
    return !yn(u);
  }, Ir = function(u) {
    var c = parseFloat(u);
    return isNaN(c) ? N.none() : N.some(c);
  }, Wa = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/, Mr = function(u) {
    return function(c) {
      return _n(c, u);
    };
  }, Fr = [
    {
      name: "Edge",
      versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
      search: function(u) {
        return _n(u, "edge/") && _n(u, "chrome") && _n(u, "safari") && _n(u, "applewebkit");
      }
    },
    {
      name: "Chrome",
      brand: "Chromium",
      versionRegexes: [
        /.*?chrome\/([0-9]+)\.([0-9]+).*/,
        Wa
      ],
      search: function(u) {
        return _n(u, "chrome") && !_n(u, "chromeframe");
      }
    },
    {
      name: "IE",
      versionRegexes: [
        /.*?msie\ ?([0-9]+)\.([0-9]+).*/,
        /.*?rv:([0-9]+)\.([0-9]+).*/
      ],
      search: function(u) {
        return _n(u, "msie") || _n(u, "trident");
      }
    },
    {
      name: "Opera",
      versionRegexes: [
        Wa,
        /.*?opera\/([0-9]+)\.([0-9]+).*/
      ],
      search: Mr("opera")
    },
    {
      name: "Firefox",
      versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
      search: Mr("firefox")
    },
    {
      name: "Safari",
      versionRegexes: [
        Wa,
        /.*?cpu os ([0-9]+)_([0-9]+).*/
      ],
      search: function(u) {
        return (_n(u, "safari") || _n(u, "mobile/")) && _n(u, "applewebkit");
      }
    }
  ], Va = [
    {
      name: "Windows",
      search: Mr("win"),
      versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
    },
    {
      name: "iOS",
      search: function(u) {
        return _n(u, "iphone") || _n(u, "ipad");
      },
      versionRegexes: [
        /.*?version\/\ ?([0-9]+)\.([0-9]+).*/,
        /.*cpu os ([0-9]+)_([0-9]+).*/,
        /.*cpu iphone os ([0-9]+)_([0-9]+).*/
      ]
    },
    {
      name: "Android",
      search: Mr("android"),
      versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
    },
    {
      name: "OSX",
      search: Mr("mac os x"),
      versionRegexes: [/.*?mac\ os\ x\ ?([0-9]+)_([0-9]+).*/]
    },
    {
      name: "Linux",
      search: Mr("linux"),
      versionRegexes: []
    },
    {
      name: "Solaris",
      search: Mr("sunos"),
      versionRegexes: []
    },
    {
      name: "FreeBSD",
      search: Mr("freebsd"),
      versionRegexes: []
    },
    {
      name: "ChromeOS",
      search: Mr("cros"),
      versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/]
    }
  ], Qo = {
    browsers: ze(Fr),
    oses: ze(Va)
  }, Go = "Edge", so = "Chrome", bo = "IE", mi = "Opera", Ao = "Firefox", go = "Safari", gi = function() {
    return na({
      current: void 0,
      version: Xt.unknown()
    });
  }, na = function(u) {
    var c = u.current, d = u.version, h = function(S) {
      return function() {
        return c === S;
      };
    };
    return {
      current: c,
      version: d,
      isEdge: h(Go),
      isChrome: h(so),
      isIE: h(bo),
      isOpera: h(mi),
      isFirefox: h(Ao),
      isSafari: h(go)
    };
  }, ei = {
    unknown: gi,
    nu: na,
    edge: ze(Go),
    chrome: ze(so),
    ie: ze(bo),
    opera: ze(mi),
    firefox: ze(Ao),
    safari: ze(go)
  }, sr = "Windows", $u = "iOS", Ko = "Android", pi = "Linux", Po = "OSX", Si = "Solaris", Su = "FreeBSD", xi = "ChromeOS", Ju = function() {
    return Lo({
      current: void 0,
      version: Xt.unknown()
    });
  }, Lo = function(u) {
    var c = u.current, d = u.version, h = function(S) {
      return function() {
        return c === S;
      };
    };
    return {
      current: c,
      version: d,
      isWindows: h(sr),
      isiOS: h($u),
      isAndroid: h(Ko),
      isOSX: h(Po),
      isLinux: h(pi),
      isSolaris: h(Si),
      isFreeBSD: h(Su),
      isChromeOS: h(xi)
    };
  }, yo = {
    unknown: Ju,
    nu: Lo,
    windows: ze(sr),
    ios: ze($u),
    android: ze(Ko),
    linux: ze(pi),
    osx: ze(Po),
    solaris: ze(Si),
    freebsd: ze(Su),
    chromeos: ze(xi)
  }, Bn = function(u, c, d) {
    var h = Qo.browsers(), S = Qo.oses(), B = c.bind(function(me) {
      return on(h, me);
    }).orThunk(function() {
      return Un(h, u);
    }).fold(ei.unknown, ei.nu), L = Tn(S, u).fold(yo.unknown, yo.nu), W = Ye(L, B, u, d);
    return {
      browser: B,
      os: L,
      deviceType: W
    };
  }, xu = { detect: Bn }, ku = function(u) {
    return window.matchMedia(u).matches;
  }, Tu = gt(function() {
    return xu.detect(navigator.userAgent, N.from(navigator.userAgentData), ku);
  }), Ue = function() {
    return Tu();
  }, et = function(u, c, d) {
    return (u.compareDocumentPosition(c) & d) !== 0;
  }, en = function(u, c) {
    return et(u, c, Node.DOCUMENT_POSITION_CONTAINED_BY);
  }, gn = 8, Z = 9, ye = 11, Ve = 1, lt = 3, Et = function(u, c) {
    var d = c || document, h = d.createElement("div");
    if (h.innerHTML = u, !h.hasChildNodes() || h.childNodes.length > 1)
      throw console.error("HTML does not have a single root node", u), new Error("HTML must have a single root node");
    return er(h.childNodes[0]);
  }, Ot = function(u, c) {
    var d = c || document, h = d.createElement(u);
    return er(h);
  }, Rn = function(u, c) {
    var d = c || document, h = d.createTextNode(u);
    return er(h);
  }, er = function(u) {
    if (u == null)
      throw new Error("Node cannot be null or undefined");
    return { dom: u };
  }, Rr = function(u, c, d) {
    return N.from(u.dom.elementFromPoint(c, d)).map(er);
  }, Nt = {
    fromHtml: Et,
    fromTag: Ot,
    fromText: Rn,
    fromDom: er,
    fromPoint: Rr
  }, vr = function(u, c) {
    var d = u.dom;
    if (d.nodeType !== Ve)
      return !1;
    var h = d;
    if (h.matches !== void 0)
      return h.matches(c);
    if (h.msMatchesSelector !== void 0)
      return h.msMatchesSelector(c);
    if (h.webkitMatchesSelector !== void 0)
      return h.webkitMatchesSelector(c);
    if (h.mozMatchesSelector !== void 0)
      return h.mozMatchesSelector(c);
    throw new Error("Browser lacks native selectors");
  }, Nr = function(u) {
    return u.nodeType !== Ve && u.nodeType !== Z && u.nodeType !== ye || u.childElementCount === 0;
  }, Sa = function(u, c) {
    var d = c === void 0 ? document : c.dom;
    return Nr(d) ? [] : Me(d.querySelectorAll(u), Nt.fromDom);
  }, po = function(u, c) {
    var d = c === void 0 ? document : c.dom;
    return Nr(d) ? N.none() : N.from(d.querySelector(u)).map(Nt.fromDom);
  }, Xr = function(u, c) {
    return u.dom === c.dom;
  }, Lu = function(u, c) {
    var d = u.dom, h = c.dom;
    return d === h ? !1 : d.contains(h);
  }, Eu = function(u, c) {
    return en(u.dom, c.dom);
  }, vo = function(u, c) {
    return Ue().browser.isIE() ? Eu(u, c) : Lu(u, c);
  }, Fs = vr, ki = Object.keys, Fi = Object.hasOwnProperty, za = function(u, c) {
    for (var d = ki(u), h = 0, S = d.length; h < S; h++) {
      var B = d[h], L = u[B];
      c(L, B);
    }
  }, $s = function(u, c) {
    return Qu(u, function(d, h) {
      return {
        k: h,
        v: c(d, h)
      };
    });
  }, Qu = function(u, c) {
    var d = {};
    return za(u, function(h, S) {
      var B = c(h, S);
      d[B.k] = B.v;
    }), d;
  }, hs = function(u) {
    return function(c, d) {
      u[d] = c;
    };
  }, rl = function(u, c, d, h) {
    var S = {};
    return za(u, function(B, L) {
      (c(B, L) ? d : h)(B, L);
    }), S;
  }, $i = function(u, c) {
    var d = {};
    return rl(u, c, hs(d), ue), d;
  }, au = function(u, c) {
    var d = [];
    return za(u, function(h, S) {
      d.push(c(h, S));
    }), d;
  }, al = function(u) {
    return au(u, ht);
  }, qi = function(u) {
    return ki(u).length;
  }, Li = function(u, c) {
    return ve(u, c) ? N.from(u[c]) : N.none();
  }, ve = function(u, c) {
    return Fi.call(u, c);
  }, nt = function(u, c) {
    return ve(u, c) && u[c] !== void 0 && u[c] !== null;
  }, wt = function(u) {
    for (var c in u)
      if (Fi.call(u, c))
        return !1;
    return !0;
  }, Zt = [
    "tfoot",
    "thead",
    "tbody",
    "colgroup"
  ], En = function(u) {
    return Te(Zt, u);
  }, lr = function(u, c) {
    return {
      rows: u,
      columns: c
    };
  }, ya = function(u, c) {
    return {
      row: u,
      column: c
    };
  }, Aa = function(u, c, d) {
    return {
      element: u,
      rowspan: c,
      colspan: d
    };
  }, Yr = function(u, c, d, h) {
    return {
      element: u,
      rowspan: c,
      colspan: d,
      isNew: h
    };
  }, qa = function(u, c, d, h, S, B) {
    return {
      element: u,
      rowspan: c,
      colspan: d,
      row: h,
      column: S,
      isLocked: B
    };
  }, ao = function(u, c, d) {
    return {
      element: u,
      cells: c,
      section: d
    };
  }, es = function(u, c, d, h) {
    return {
      element: u,
      cells: c,
      section: d,
      isNew: h
    };
  }, ti = function(u, c, d) {
    return {
      element: u,
      isNew: c,
      isLocked: d
    };
  }, zu = function(u, c, d, h) {
    return {
      element: u,
      cells: c,
      section: d,
      isNew: h
    };
  }, br = function(u, c, d, h) {
    return {
      startRow: u,
      startCol: c,
      finishRow: d,
      finishCol: h
    };
  }, bs = function(u, c, d) {
    return {
      element: u,
      colspan: c,
      column: d
    };
  }, yc = function(u, c) {
    return {
      element: u,
      columns: c
    };
  };
  typeof window < "u" || Function("return this;")();
  var va = function(u) {
    var c = u.dom.nodeName;
    return c.toLowerCase();
  }, Wl = function(u) {
    return u.dom.nodeType;
  }, ql = function(u) {
    return function(c) {
      return Wl(c) === u;
    };
  }, Yc = function(u) {
    return Wl(u) === gn || va(u) === "#comment";
  }, Fa = ql(Ve), ou = ql(lt), Vf = ql(Z), _u = ql(ye), wo = function(u) {
    return function(c) {
      return Fa(c) && va(c) === u;
    };
  }, Ls = function(u) {
    return Nt.fromDom(u.dom.ownerDocument);
  }, Ut = function(u) {
    return Vf(u) ? u : Ls(u);
  }, ol = function(u) {
    return Nt.fromDom(Ut(u).dom.defaultView);
  }, Co = function(u) {
    return N.from(u.dom.parentNode).map(Nt.fromDom);
  }, wc = function(u) {
    return N.from(u.dom.parentElement).map(Nt.fromDom);
  }, ys = function(u, c) {
    for (var d = D(c) ? c : Ct, h = u.dom, S = []; h.parentNode !== null && h.parentNode !== void 0; ) {
      var B = h.parentNode, L = Nt.fromDom(B);
      if (S.push(L), d(L) === !0)
        break;
      h = B;
    }
    return S;
  }, V = function(u) {
    return N.from(u.dom.previousSibling).map(Nt.fromDom);
  }, O = function(u) {
    return N.from(u.dom.nextSibling).map(Nt.fromDom);
  }, x = function(u) {
    return Me(u.dom.childNodes, Nt.fromDom);
  }, I = function(u, c) {
    var d = u.dom.childNodes;
    return N.from(d[c]).map(Nt.fromDom);
  }, re = function(u) {
    return I(u, 0);
  }, Oe = function(u) {
    return _u(u) && Y(u.dom.host);
  }, vt = D(Element.prototype.attachShadow) && D(Node.prototype.getRootNode), rn = ze(vt), or = vt ? function(u) {
    return Nt.fromDom(u.dom.getRootNode());
  } : Ut, wr = function(u) {
    var c = or(u);
    return Oe(c) ? N.some(c) : N.none();
  }, Nn = function(u) {
    return Nt.fromDom(u.dom.host);
  }, nr = function(u) {
    if (rn() && Y(u.target)) {
      var c = Nt.fromDom(u.target);
      if (Fa(c) && jr(c) && u.composed && u.composedPath) {
        var d = u.composedPath();
        if (d)
          return Ie(d);
      }
    }
    return N.from(u.target);
  }, jr = function(u) {
    return Y(u.dom.shadowRoot);
  }, Vr = function(u) {
    var c = ou(u) ? u.dom.parentNode : u.dom;
    if (c == null || c.ownerDocument === null)
      return !1;
    var d = c.ownerDocument;
    return wr(Nt.fromDom(c)).fold(function() {
      return d.body.contains(c);
    }, Ge(Vr, Nn));
  }, Dr = function() {
    return Qa(Nt.fromDom(document));
  }, Qa = function(u) {
    var c = u.dom.body;
    if (c == null)
      throw new Error("Body is not available yet");
    return Nt.fromDom(c);
  }, Tr = function(u, c, d) {
    return Tt(ys(u, d), c);
  }, $a = function(u, c) {
    return Tt(x(u), c);
  }, Oa = function(u, c) {
    var d = [];
    return Je(x(u), function(h) {
      c(h) && (d = d.concat([h])), d = d.concat(Oa(h, c));
    }), d;
  }, Ti = function(u, c, d) {
    return Tr(u, function(h) {
      return vr(h, c);
    }, d);
  }, Qr = function(u, c) {
    return $a(u, function(d) {
      return vr(d, c);
    });
  }, zs = function(u, c) {
    return Sa(c, u);
  };
  function So(u, c, d, h, S) {
    return u(d, h) ? N.some(d) : D(S) && S(d) ? N.none() : c(d, h, S);
  }
  var No = function(u, c, d) {
    for (var h = u.dom, S = D(d) ? d : Ct; h.parentNode; ) {
      h = h.parentNode;
      var B = Nt.fromDom(h);
      if (c(B))
        return N.some(B);
      if (S(B))
        break;
    }
    return N.none();
  }, w1 = function(u, c, d) {
    var h = function(S, B) {
      return B(S);
    };
    return So(h, No, u, c, d);
  }, Gi = function(u, c) {
    var d = function(S) {
      return c(Nt.fromDom(S));
    }, h = _t(u.dom.childNodes, d);
    return h.map(Nt.fromDom);
  }, Ip = function(u, c) {
    var d = function(h) {
      for (var S = 0; S < h.childNodes.length; S++) {
        var B = Nt.fromDom(h.childNodes[S]);
        if (c(B))
          return N.some(B);
        var L = d(h.childNodes[S]);
        if (L.isSome())
          return L;
      }
      return N.none();
    };
    return d(u.dom);
  }, Gl = function(u, c, d) {
    return No(u, function(h) {
      return vr(h, c);
    }, d);
  }, Pr = function(u, c) {
    return Gi(u, function(d) {
      return vr(d, c);
    });
  }, Hs = function(u, c) {
    return po(c, u);
  }, zo = function(u, c, d) {
    var h = function(S, B) {
      return vr(S, B);
    };
    return So(h, Gl, u, c, d);
  }, Ho = function(u, c, d) {
    if (P(d) || le(d) || J(d))
      u.setAttribute(c, d + "");
    else
      throw console.error("Invalid call to Attribute.set. Key ", c, ":: Value ", d, ":: Element ", u), new Error("Attribute value was not simple");
  }, Ei = function(u, c, d) {
    Ho(u.dom, c, d);
  }, ui = function(u, c) {
    var d = u.dom;
    za(c, function(h, S) {
      Ho(d, S, h);
    });
  }, Uf = function(u, c) {
    za(c, function(d, h) {
      d.fold(function() {
        mo(u, h);
      }, function(S) {
        Ho(u.dom, h, S);
      });
    });
  }, il = function(u, c) {
    var d = u.dom.getAttribute(c);
    return d === null ? void 0 : d;
  }, Da = function(u, c) {
    return N.from(il(u, c));
  }, mo = function(u, c) {
    u.dom.removeAttribute(c);
  }, Hu = function(u) {
    return se(u.dom.attributes, function(c, d) {
      return c[d.name] = d.value, c;
    }, {});
  }, Cc = function(u, c, d) {
    return d === void 0 && (d = ie), u.exists(function(h) {
      return d(h, c);
    });
  }, hi = function(u) {
    for (var c = [], d = function(S) {
      c.push(S);
    }, h = 0; h < u.length; h++)
      u[h].each(d);
    return c;
  }, Vs = function(u, c, d) {
    return u.isSome() && c.isSome() ? N.some(d(u.getOrDie(), c.getOrDie())) : N.none();
  }, C1 = function(u, c) {
    return u != null ? c(u) : N.none();
  }, jf = function(u) {
    return u.bind(ht);
  }, eo = function(u, c) {
    return u ? N.some(c) : N.none();
  }, El = function(u) {
    return u.style !== void 0 && D(u.style.getPropertyValue);
  }, Zc = function(u, c, d) {
    if (!P(d))
      throw console.error("Invalid call to CSS.set. Property ", c, ":: Value ", d, ":: Element ", u), new Error("CSS value must be a string: " + d);
    El(u) && u.style.setProperty(c, d);
  }, ts = function(u, c) {
    El(u) && u.style.removeProperty(c);
  }, Xo = function(u, c, d) {
    var h = u.dom;
    Zc(h, c, d);
  }, Jc = function(u, c) {
    var d = u.dom;
    za(c, function(h, S) {
      Zc(d, S, h);
    });
  }, Sc = function(u, c) {
    var d = u.dom, h = window.getComputedStyle(d), S = h.getPropertyValue(c);
    return S === "" && !Vr(u) ? Au(d, c) : S;
  }, Au = function(u, c) {
    return El(u) ? u.style.getPropertyValue(c) : "";
  }, ns = function(u, c) {
    var d = u.dom, h = Au(d, c);
    return N.from(h).filter(function(S) {
      return S.length > 0;
    });
  }, iu = function(u, c) {
    var d = u.dom;
    ts(d, c), Cc(Da(u, "style").map(Ft), "") && mo(u, "style");
  }, Nv = function(u, c) {
    var d = u.dom, h = c.dom;
    El(d) && El(h) && (h.style.cssText = d.style.cssText);
  }, _l = function(u, c, d) {
    return d === void 0 && (d = 0), Da(u, c).map(function(h) {
      return parseInt(h, 10);
    }).getOr(d);
  }, _i = function(u, c) {
    return _l(u, c, 1);
  }, Pd = function(u) {
    return wo("col")(u) ? _l(u, "span", 1) > 1 : _i(u, "colspan") > 1;
  }, S1 = function(u) {
    return _i(u, "rowspan") > 1;
  }, Wf = function(u, c) {
    return parseInt(Sc(u, c), 10);
  }, qf = ze(10), Yo = ze(10), Gf = function(u, c) {
    return Kf(u, c, Be);
  }, Kf = function(u, c, d) {
    return He(x(u), function(h) {
      return vr(h, c) ? d(h) ? [h] : [] : Kf(h, c, d);
    });
  }, Ou = function(u, c, d) {
    if (d === void 0 && (d = Ct), d(c))
      return N.none();
    if (Te(u, va(c)))
      return N.some(c);
    var h = function(S) {
      return vr(S, "table") || d(S);
    };
    return Gl(c, u.join(","), h);
  }, xc = function(u, c) {
    return Ou([
      "td",
      "th"
    ], u, c);
  }, Xf = function(u) {
    return Gf(u, "th,td");
  }, kc = function(u) {
    return vr(u, "colgroup") ? Qr(u, "col") : He(Wm(u), function(c) {
      return Qr(c, "col");
    });
  }, Oo = function(u, c) {
    return zo(u, "table", c);
  }, ws = function(u) {
    return Gf(u, "tr");
  }, Wm = function(u) {
    return Oo(u).fold(ze([]), function(c) {
      return Qr(c, "colgroup");
    });
  }, Us = function(u, c) {
    return Me(u, function(d) {
      if (va(d) === "colgroup") {
        var h = Me(kc(d), function(S) {
          var B = _l(S, "span", 1);
          return Aa(S, 1, B);
        });
        return ao(d, h, "colgroup");
      } else {
        var h = Me(Xf(d), function(B) {
          var L = _l(B, "rowspan", 1), W = _l(B, "colspan", 1);
          return Aa(B, L, W);
        });
        return ao(d, h, c(d));
      }
    });
  }, qm = function(u) {
    return Co(u).map(function(c) {
      var d = va(c);
      return En(d) ? d : "tbody";
    }).getOr("tbody");
  }, x1 = function(u) {
    var c = ws(u), d = Wm(u), h = tt(tt([], d, !0), c, !0);
    return Us(h, qm);
  }, Fp = function(u, c) {
    return Us(u, function() {
      return c;
    });
  }, Yf = function(u, c, d) {
    var h = u.cells, S = h.slice(0, c), B = h.slice(c), L = S.concat(d).concat(B);
    return $r(u, L);
  }, Zf = function(u, c, d) {
    return Yf(u, c, [d]);
  }, Qc = function(u, c, d) {
    var h = u.cells;
    h[c] = d;
  }, $r = function(u, c) {
    return zu(u.element, c, u.section, u.isNew);
  }, ul = function(u, c) {
    var d = u.cells, h = Me(d, c);
    return zu(u.element, h, u.section, u.isNew);
  }, rs = function(u, c) {
    return u.cells[c];
  }, Du = function(u, c) {
    return rs(u, c).element;
  }, sl = function(u) {
    return u.cells.length;
  }, ni = function(u) {
    var c = dt(u, function(d) {
      return d.section === "colgroup";
    });
    return {
      rows: c.fail,
      cols: c.pass
    };
  }, Ai = function(u, c, d) {
    var h = Me(u.cells, d);
    return zu(c(u.element), h, u.section, !0);
  }, si = "data-snooker-locked-cols", ef = function(u) {
    return Da(u, si).bind(function(c) {
      return N.from(c.match(/\d+/g));
    }).map(function(c) {
      return Ke(c, Be);
    });
  }, uu = function(u) {
    var c = se(ni(u).rows, function(h, S) {
      return Je(S.cells, function(B, L) {
        B.isLocked && (h[L] = !0);
      }), h;
    }, {}), d = au(c, function(h, S) {
      return parseInt(S, 10);
    });
    return pt(d);
  }, Qn = function(u, c) {
    return u + "," + c;
  }, Jf = function(u, c, d) {
    return N.from(u.access[Qn(c, d)]);
  }, $p = function(u, c, d) {
    var h = ea(u, function(S) {
      return d(c, S.element);
    });
    return h.length > 0 ? N.some(h[0]) : N.none();
  }, ea = function(u, c) {
    var d = He(u.all, function(h) {
      return h.cells;
    });
    return Tt(d, c);
  }, to = function(u) {
    var c = {}, d = 0;
    return Je(u.cells, function(h) {
      var S = h.colspan;
      je(S, function(B) {
        var L = d + B;
        c[L] = bs(h.element, S, L);
      }), d += S;
    }), c;
  }, Gm = function(u) {
    var c = {}, d = [], h = Ie(u).map(function(Pn) {
      return Pn.element;
    }).bind(Oo), S = h.bind(ef).getOr({}), B = 0, L = 0, W = 0, me = dt(u, function(Pn) {
      return Pn.section === "colgroup";
    }), Re = me.pass, rt = me.fail;
    Je(rt, function(Pn) {
      var Ln = [];
      Je(Pn.cells, function(mr) {
        for (var Ea = 0; c[Qn(W, Ea)] !== void 0; )
          Ea++;
        for (var dr = nt(S, Ea.toString()), Ur = qa(mr.element, mr.rowspan, mr.colspan, W, Ea, dr), ca = 0; ca < mr.colspan; ca++)
          for (var sa = 0; sa < mr.rowspan; sa++) {
            var oi = W + sa, Ji = Ea + ca, Qi = Qn(oi, Ji);
            c[Qi] = Ur, L = Math.max(L, Ji + 1);
          }
        Ln.push(Ur);
      }), B++, d.push(ao(Pn.element, Ln, Pn.section)), W++;
    });
    var jt = St(Re).map(function(Pn) {
      var Ln = to(Pn), mr = yc(Pn.element, al(Ln));
      return {
        colgroups: [mr],
        columns: Ln
      };
    }).getOrThunk(function() {
      return {
        colgroups: [],
        columns: {}
      };
    }), Sn = jt.columns, ln = jt.colgroups, Wt = lr(B, L);
    return {
      grid: Wt,
      access: c,
      all: d,
      columns: Sn,
      colgroups: ln
    };
  }, Kl = function(u) {
    var c = x1(u);
    return Gm(c);
  }, xo = function(u) {
    return He(u.all, function(c) {
      return c.cells;
    });
  }, Km = function(u) {
    return al(u.columns);
  }, Cs = function(u) {
    return ki(u.columns).length > 0;
  }, Nd = function(u, c) {
    return N.from(u.columns[c]);
  }, ra = {
    fromTable: Kl,
    generate: Gm,
    getAt: Jf,
    findItem: $p,
    filterItems: ea,
    justCells: xo,
    justColumns: Km,
    hasColumns: Cs,
    getColumnAt: Nd
  }, Vu = function(u, c) {
    var d = c.column, h = c.column + c.colspan - 1, S = c.row, B = c.row + c.rowspan - 1;
    return d <= u.finishCol && h >= u.startCol && S <= u.finishRow && B >= u.startRow;
  }, ty = function(u, c) {
    return c.column >= u.startCol && c.column + c.colspan - 1 <= u.finishCol && c.row >= u.startRow && c.row + c.rowspan - 1 <= u.finishRow;
  }, ny = function(u, c) {
    for (var d = !0, h = Ze(ty, c), S = c.startRow; S <= c.finishRow; S++)
      for (var B = c.startCol; B <= c.finishCol; B++)
        d = d && ra.getAt(u, S, B).exists(h);
    return d ? N.some(c) : N.none();
  }, Do = function(u, c) {
    return br(Math.min(u.row, c.row), Math.min(u.column, c.column), Math.max(u.row + u.rowspan - 1, c.row + c.rowspan - 1), Math.max(u.column + u.colspan - 1, c.column + c.colspan - 1));
  }, Xm = function(u, c, d) {
    var h = ra.findItem(u, c, Xr), S = ra.findItem(u, d, Xr);
    return h.bind(function(B) {
      return S.map(function(L) {
        return Do(B, L);
      });
    });
  }, M = function(u, c, d) {
    return Xm(u, c, d).bind(function(h) {
      return ny(u, h);
    });
  }, G = function(u, c, d, h) {
    return ra.findItem(u, c, Xr).bind(function(S) {
      var B = d > 0 ? S.row + S.rowspan - 1 : S.row, L = h > 0 ? S.column + S.colspan - 1 : S.column, W = ra.getAt(u, B + d, L + h);
      return W.map(function(me) {
        return me.element;
      });
    });
  }, fe = function(u, c, d) {
    return Xm(u, c, d).map(function(h) {
      var S = ra.filterItems(u, Ze(Vu, h));
      return Me(S, function(B) {
        return B.element;
      });
    });
  }, Fe = function(u, c) {
    var d = function(h, S) {
      return vo(S, h);
    };
    return ra.findItem(u, c, d).map(function(h) {
      return h.element;
    });
  }, bt = function(u, c, d) {
    return Oo(u).bind(function(h) {
      var S = da(h);
      return G(S, u, c, d);
    });
  }, Gt = function(u, c, d) {
    var h = da(u);
    return fe(h, c, d);
  }, fr = function(u, c, d, h, S) {
    var B = da(u), L = Xr(u, d) ? N.some(c) : Fe(B, c), W = Xr(u, S) ? N.some(h) : Fe(B, h);
    return L.bind(function(me) {
      return W.bind(function(Re) {
        return fe(B, me, Re);
      });
    });
  }, Wr = function(u, c, d) {
    var h = da(u);
    return M(h, c, d);
  }, da = ra.fromTable, aa = function(u, c) {
    var d = Co(u);
    d.each(function(h) {
      h.dom.insertBefore(c.dom, u.dom);
    });
  }, oo = function(u, c) {
    var d = O(u);
    d.fold(function() {
      var h = Co(u);
      h.each(function(S) {
        Vo(S, c);
      });
    }, function(h) {
      aa(h, c);
    });
  }, su = function(u, c) {
    var d = re(u);
    d.fold(function() {
      Vo(u, c);
    }, function(h) {
      u.dom.insertBefore(c.dom, h.dom);
    });
  }, Vo = function(u, c) {
    u.dom.appendChild(c.dom);
  }, dk = function(u, c, d) {
    I(u, d).fold(function() {
      Vo(u, c);
    }, function(h) {
      aa(h, c);
    });
  }, zC = function(u, c) {
    aa(u, c), Vo(c, u);
  }, HC = function(u, c) {
    Je(c, function(d) {
      aa(u, d);
    });
  }, mk = function(u, c) {
    Je(c, function(d, h) {
      var S = h === 0 ? u : c[h - 1];
      oo(S, d);
    });
  }, Tc = function(u, c) {
    Je(c, function(d) {
      Vo(u, d);
    });
  }, Lp = function(u) {
    u.dom.textContent = "", Je(x(u), function(c) {
      Ss(c);
    });
  }, Ss = function(u) {
    var c = u.dom;
    c.parentNode !== null && c.parentNode.removeChild(c);
  }, Ym = function(u) {
    var c = x(u);
    c.length > 0 && HC(u, c), Ss(u);
  }, ry = function(u, c) {
    var d = function(B) {
      if (!u(B))
        throw new Error("Can only get " + c + " value of a " + c + " node");
      return h(B).getOr("");
    }, h = function(B) {
      return u(B) ? N.from(B.dom.nodeValue) : N.none();
    }, S = function(B, L) {
      if (!u(B))
        throw new Error("Can only set raw " + c + " value of a " + c + " node");
      B.dom.nodeValue = L;
    };
    return {
      get: d,
      getOption: h,
      set: S
    };
  }, zp = ry(ou, "text"), k1 = function(u) {
    return zp.get(u);
  }, VC = function(u) {
    return zp.getOption(u);
  }, gk = function(u, c) {
    return zp.set(u, c);
  }, Ec = [
    "body",
    "p",
    "div",
    "article",
    "aside",
    "figcaption",
    "figure",
    "footer",
    "header",
    "nav",
    "section",
    "ol",
    "ul",
    "li",
    "table",
    "thead",
    "tbody",
    "tfoot",
    "caption",
    "tr",
    "td",
    "th",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "blockquote",
    "pre",
    "address"
  ];
  function Hp() {
    var u = function(Re) {
      return Nt.fromDom(Re.dom.cloneNode(!1));
    }, c = function(Re) {
      return Ut(Re).dom;
    }, d = function(Re) {
      return Fa(Re) ? va(Re) === "body" ? !0 : Te(Ec, va(Re)) : !1;
    }, h = function(Re) {
      return Fa(Re) ? Te([
        "br",
        "img",
        "hr",
        "input"
      ], va(Re)) : !1;
    }, S = function(Re) {
      return Fa(Re) && il(Re, "contenteditable") === "false";
    }, B = function(Re, rt) {
      return Re.dom.compareDocumentPosition(rt.dom);
    }, L = function(Re, rt) {
      var jt = Hu(Re);
      ui(rt, jt);
    }, W = function(Re) {
      var rt = va(Re);
      return Te([
        "script",
        "noscript",
        "iframe",
        "noframes",
        "noembed",
        "title",
        "style",
        "textarea",
        "xmp"
      ], rt);
    }, me = function(Re) {
      return Fa(Re) ? Da(Re, "lang") : N.none();
    };
    return {
      up: ze({
        selector: Gl,
        closest: zo,
        predicate: No,
        all: ys
      }),
      down: ze({
        selector: zs,
        predicate: Oa
      }),
      styles: ze({
        get: Sc,
        getRaw: ns,
        set: Xo,
        remove: iu
      }),
      attrs: ze({
        get: il,
        set: Ei,
        remove: mo,
        copyTo: L
      }),
      insert: ze({
        before: aa,
        after: oo,
        afterAll: mk,
        append: Vo,
        appendAll: Tc,
        prepend: su,
        wrap: zC
      }),
      remove: ze({
        unwrap: Ym,
        remove: Ss
      }),
      create: ze({
        nu: Nt.fromTag,
        clone: u,
        text: Nt.fromText
      }),
      query: ze({
        comparePosition: B,
        prevSibling: V,
        nextSibling: O
      }),
      property: ze({
        children: x,
        name: va,
        parent: Co,
        document: c,
        isText: ou,
        isComment: Yc,
        isElement: Fa,
        isSpecial: W,
        getLanguage: me,
        getText: k1,
        setText: gk,
        isBoundary: d,
        isEmptyTag: h,
        isNonEditable: S
      }),
      eq: Xr,
      is: Fs
    };
  }
  var pk = function(u, c, d, h) {
    var S = d[0], B = d.slice(1);
    return h(u, c, S, B);
  }, ay = function(u, c, d) {
    return d.length > 0 ? pk(u, c, d, hk) : N.none();
  }, hk = function(u, c, d, h) {
    var S = c(u, d);
    return Jt(h, function(B, L) {
      var W = c(u, L);
      return bk(u, B, W);
    }, S);
  }, bk = function(u, c, d) {
    return c.bind(function(h) {
      return d.filter(Ze(u.eq, h));
    });
  }, Zm = function(u, c) {
    return Ze(u.eq, c);
  }, Vp = function(u, c, d, h) {
    h === void 0 && (h = Ct);
    var S = [c].concat(u.up().all(c)), B = [d].concat(u.up().all(d)), L = function(rt) {
      var jt = Pe(rt, h);
      return jt.fold(function() {
        return rt;
      }, function(Sn) {
        return rt.slice(0, Sn + 1);
      });
    }, W = L(S), me = L(B), Re = _t(W, function(rt) {
      return _(me, Zm(u, rt));
    });
    return {
      firstpath: W,
      secondpath: me,
      shared: Re
    };
  }, UC = ay, jC = Vp, js = Hp(), hr = function(u, c) {
    return UC(js, function(d, h) {
      return u(h);
    }, c);
  }, Qf = function(u, c, d) {
    return jC(js, u, c, d);
  }, Up = function(u) {
    return Gl(u, "table");
  }, Iv = function(u, c, d) {
    var h = function(S) {
      return function(B) {
        return d !== void 0 && d(B) || Xr(B, S);
      };
    };
    return Xr(u, c) ? N.some({
      boxes: N.some([u]),
      start: u,
      finish: c
    }) : Up(u).bind(function(S) {
      return Up(c).bind(function(B) {
        if (Xr(S, B))
          return N.some({
            boxes: Gt(S, u, c),
            start: u,
            finish: c
          });
        if (vo(S, B)) {
          var L = Ti(c, "td,th", h(S)), W = L.length > 0 ? L[L.length - 1] : c;
          return N.some({
            boxes: fr(S, u, S, c, B),
            start: u,
            finish: W
          });
        } else if (vo(B, S)) {
          var L = Ti(u, "td,th", h(B)), me = L.length > 0 ? L[L.length - 1] : u;
          return N.some({
            boxes: fr(B, u, S, c, B),
            start: u,
            finish: me
          });
        } else
          return Qf(u, c).shared.bind(function(Re) {
            return zo(Re, "table", d).bind(function(rt) {
              var jt = Ti(c, "td,th", h(rt)), Sn = jt.length > 0 ? jt[jt.length - 1] : c, ln = Ti(u, "td,th", h(rt)), Wt = ln.length > 0 ? ln[ln.length - 1] : u;
              return N.some({
                boxes: fr(rt, u, S, c, B),
                start: Wt,
                finish: Sn
              });
            });
          });
      });
    });
  }, Jm = function(u, c) {
    var d = zs(u, c);
    return d.length > 0 ? N.some(d) : N.none();
  }, oy = function(u, c) {
    return _t(u, function(d) {
      return vr(d, c);
    });
  }, Xl = function(u, c, d) {
    return Hs(u, c).bind(function(h) {
      return Hs(u, d).bind(function(S) {
        return hr(Up, [
          h,
          S
        ]).map(function(B) {
          return {
            first: h,
            last: S,
            table: B
          };
        });
      });
    });
  }, Id = function(u, c) {
    return Gl(u, "table").bind(function(d) {
      return Hs(d, c).bind(function(h) {
        return Iv(h, u).bind(function(S) {
          return S.boxes.map(function(B) {
            return {
              boxes: B,
              start: S.start,
              finish: S.finish
            };
          });
        });
      });
    });
  }, Qm = function(u, c, d, h, S) {
    return oy(u, S).bind(function(B) {
      return bt(B, c, d).bind(function(L) {
        return Id(L, h);
      });
    });
  }, ri = function(u, c) {
    return Jm(u, c);
  }, Ki = function(u, c, d) {
    return Xl(u, c, d).bind(function(h) {
      var S = function(me) {
        return Xr(u, me);
      }, B = "thead,tfoot,tbody,table", L = Gl(h.first, B, S), W = Gl(h.last, B, S);
      return L.bind(function(me) {
        return W.bind(function(Re) {
          return Xr(me, Re) ? Wr(h.table, h.first, h.last) : N.none();
        });
      });
    });
  }, jp = function(u) {
    if (!X(u))
      throw new Error("cases must be an array");
    if (u.length === 0)
      throw new Error("there must be at least one case");
    var c = [], d = {};
    return Je(u, function(h, S) {
      var B = ki(h);
      if (B.length !== 1)
        throw new Error("one and only one name per case");
      var L = B[0], W = h[L];
      if (d[L] !== void 0)
        throw new Error("duplicate key detected:" + L);
      if (L === "cata")
        throw new Error("cannot have a case named cata (sorry)");
      if (!X(W))
        throw new Error("case arguments must be an array");
      c.push(L), d[L] = function() {
        for (var me = [], Re = 0; Re < arguments.length; Re++)
          me[Re] = arguments[Re];
        var rt = me.length;
        if (rt !== W.length)
          throw new Error("Wrong number of arguments to case " + L + ". Expected " + W.length + " (" + W + "), got " + rt);
        var jt = function(Sn) {
          var ln = ki(Sn);
          if (c.length !== ln.length)
            throw new Error("Wrong number of arguments to match. Expected: " + c.join(",") + `
Actual: ` + ln.join(","));
          var Wt = We(c, function(Pn) {
            return Te(ln, Pn);
          });
          if (!Wt)
            throw new Error("Not all branches were specified when using match. Specified: " + ln.join(", ") + `
Required: ` + c.join(", "));
          return Sn[L].apply(null, me);
        };
        return {
          fold: function() {
            for (var Sn = [], ln = 0; ln < arguments.length; ln++)
              Sn[ln] = arguments[ln];
            if (Sn.length !== u.length)
              throw new Error("Wrong number of arguments to fold. Expected " + u.length + ", got " + Sn.length);
            var Wt = Sn[S];
            return Wt.apply(null, me);
          },
          match: jt,
          log: function(Sn) {
            console.log(Sn, {
              constructors: c,
              constructor: L,
              params: me
            });
          }
        };
      };
    }), d;
  }, tf = { generate: jp }, Wp = tf.generate([
    { none: [] },
    { multiple: ["elements"] },
    { single: ["element"] }
  ]), T1 = function(u, c, d, h) {
    return u.fold(c, d, h);
  }, E1 = Wp.none, yk = Wp.multiple, eg = Wp.single, Bu = function(u, c, d) {
    var h = function() {
      return ri(u(), d).fold(function() {
        return c().fold(E1, eg);
      }, function(S) {
        return yk(S);
      });
    };
    return { get: h };
  }, WC = tinymce.util.Tools.resolve("tinymce.PluginManager"), Io = function(u, c) {
    return Nt.fromDom(u.dom.cloneNode(c));
  }, Yl = function(u) {
    return Io(u, !1);
  }, Ha = function(u) {
    return Io(u, !0);
  }, Fv = function(u, c) {
    var d = Nt.fromTag(c), h = Hu(u);
    return ui(d, h), d;
  }, Al = function(u, c) {
    var d = Fv(u, c), h = x(Ha(u));
    return Tc(d, h), d;
  }, wk = function(u, c) {
    var d = Fv(u, c);
    aa(u, d);
    var h = x(u);
    return Tc(d, h), Ss(u), d;
  }, Oi = function(u, c) {
    var d = function(W, me) {
      if (!J(me) && !me.match(/^[0-9]+$/))
        throw new Error(u + ".set accepts only positive integer values. Value was " + me);
      var Re = W.dom;
      El(Re) && (Re.style[u] = me + "px");
    }, h = function(W) {
      var me = c(W);
      if (me <= 0 || me === null) {
        var Re = Sc(W, u);
        return parseFloat(Re) || 0;
      }
      return me;
    }, S = h, B = function(W, me) {
      return se(me, function(Re, rt) {
        var jt = Sc(W, rt), Sn = jt === void 0 ? 0 : parseInt(jt, 10);
        return isNaN(Sn) ? Re : Re + Sn;
      }, 0);
    }, L = function(W, me, Re) {
      var rt = B(W, Re), jt = me > rt ? me - rt : 0;
      return jt;
    };
    return {
      set: d,
      get: h,
      getOuter: S,
      aggregate: B,
      max: L
    };
  }, as = function() {
    var u = Ue().browser;
    return u.isIE() || u.isEdge();
  }, qC = function(u, c) {
    return Ir(u).getOr(c);
  }, un = function(u, c, d) {
    return qC(Sc(u, c), d);
  }, xs = function(u) {
    return Sc(u, "box-sizing");
  }, ev = function(u, c, d, h) {
    var S = un(u, "padding-" + d, 0), B = un(u, "padding-" + h, 0), L = un(u, "border-" + d + "-width", 0), W = un(u, "border-" + h + "-width", 0);
    return c - S - B - L - W;
  }, Lr = function(u, c) {
    var d = u.dom, h = d.getBoundingClientRect().height || d.offsetHeight;
    return c === "border-box" ? h : ev(u, h, "top", "bottom");
  }, ll = function(u, c) {
    var d = u.dom, h = d.getBoundingClientRect().width || d.offsetWidth;
    return c === "border-box" ? h : ev(u, h, "left", "right");
  }, Ck = function(u) {
    return as() ? Lr(u, xs(u)) : un(u, "height", u.dom.offsetHeight);
  }, Uu = function(u) {
    return as() ? ll(u, xs(u)) : un(u, "width", u.dom.offsetWidth);
  }, tg = function(u) {
    return ll(u, "content-box");
  }, nf = Oi("width", function(u) {
    return u.dom.offsetWidth;
  }), Zl = function(u) {
    return nf.get(u);
  }, Ru = function(u) {
    return nf.getOuter(u);
  }, Ba = tg, _c = Uu, Fd = function(u, c) {
    c === void 0 && (c = Be);
    var d = u.grid, h = je(d.columns, ht), S = je(d.rows, ht);
    return Me(h, function(B) {
      var L = function() {
        return He(S, function(Re) {
          return ra.getAt(u, Re, B).filter(function(rt) {
            return rt.column === B;
          }).toArray();
        });
      }, W = function(Re) {
        return Re.colspan === 1 && c(Re.element);
      }, me = function() {
        return ra.getAt(u, 0, B);
      };
      return lo(L, W, me);
    });
  }, lo = function(u, c, d) {
    var h = u(), S = _t(h, c), B = S.orThunk(function() {
      return N.from(h[0]).orThunk(d);
    });
    return B.map(function(L) {
      return L.element;
    });
  }, $v = function(u) {
    var c = u.grid, d = je(c.rows, ht), h = je(c.columns, ht);
    return Me(d, function(S) {
      var B = function() {
        return He(h, function(me) {
          return ra.getAt(u, S, me).filter(function(Re) {
            return Re.row === S;
          }).fold(ze([]), function(Re) {
            return [Re];
          });
        });
      }, L = function(me) {
        return me.rowspan === 1;
      }, W = function() {
        return ra.getAt(u, S, 0);
      };
      return lo(B, L, W);
    });
  }, Ws = function(u, c) {
    if (c < 0 || c >= u.length - 1)
      return N.none();
    var d = u[c].fold(function() {
      var S = Ae(u.slice(0, c));
      return Xe(S, function(B, L) {
        return B.map(function(W) {
          return {
            value: W,
            delta: L + 1
          };
        });
      });
    }, function(S) {
      return N.some({
        value: S,
        delta: 0
      });
    }), h = u[c + 1].fold(function() {
      var S = u.slice(c + 1);
      return Xe(S, function(B, L) {
        return B.map(function(W) {
          return {
            value: W,
            delta: L + 1
          };
        });
      });
    }, function(S) {
      return N.some({
        value: S,
        delta: 1
      });
    });
    return d.bind(function(S) {
      return h.map(function(B) {
        var L = B.delta + S.delta;
        return Math.abs(B.value - S.value) / L;
      });
    });
  }, qs = function(u, c) {
    return function(d) {
      return Sk(d) === "rtl" ? c : u;
    };
  }, Sk = function(u) {
    return Sc(u, "direction") === "rtl" ? "rtl" : "ltr";
  }, ct = Oi("height", function(u) {
    var c = u.dom;
    return Vr(u) ? c.getBoundingClientRect().height : c.offsetHeight;
  }), os = function(u) {
    return ct.get(u);
  }, Ac = function(u) {
    return ct.getOuter(u);
  }, ng = Ck, cl = function(u, c) {
    var d = function(h, S) {
      return cl(u + h, c + S);
    };
    return {
      left: u,
      top: c,
      translate: d
    };
  }, no = cl, co = function(u) {
    var c = u.getBoundingClientRect();
    return no(c.left, c.top);
  }, ks = function(u, c) {
    return u !== void 0 ? u : c !== void 0 ? c : 0;
  }, tv = function(u) {
    var c = u.dom.ownerDocument, d = c.body, h = c.defaultView, S = c.documentElement;
    if (d === u.dom)
      return no(d.offsetLeft, d.offsetTop);
    var B = ks(h == null ? void 0 : h.pageYOffset, S.scrollTop), L = ks(h == null ? void 0 : h.pageXOffset, S.scrollLeft), W = ks(S.clientTop, d.clientTop), me = ks(S.clientLeft, d.clientLeft);
    return iy(u).translate(L - me, B - W);
  }, iy = function(u) {
    var c = u.dom, d = c.ownerDocument, h = d.body;
    return h === c ? no(h.offsetLeft, h.offsetTop) : Vr(u) ? co(c) : no(0, 0);
  }, Sr = function(u, c) {
    return {
      row: u,
      y: c
    };
  }, _1 = function(u, c) {
    return {
      col: u,
      x: c
    };
  }, fl = function(u) {
    var c = tv(u);
    return c.left + Ru(u);
  }, GC = function(u) {
    return tv(u).left;
  }, qp = function(u, c) {
    return _1(u, GC(c));
  }, Gp = function(u, c) {
    return _1(u, fl(c));
  }, uy = function(u) {
    return tv(u).top;
  }, sy = function(u, c) {
    return Sr(u, uy(c));
  }, rf = function(u, c) {
    return Sr(u, uy(c) + Ac(c));
  }, nv = function(u, c, d) {
    if (d.length === 0)
      return [];
    var h = Me(d.slice(1), function(B, L) {
      return B.map(function(W) {
        return u(L, W);
      });
    }), S = d[d.length - 1].map(function(B) {
      return c(d.length - 1, B);
    });
    return h.concat([S]);
  }, xk = function(u) {
    return -u;
  }, ly = {
    delta: ht,
    positions: function(u) {
      return nv(sy, rf, u);
    },
    edge: uy
  }, kk = {
    delta: ht,
    edge: GC,
    positions: function(u) {
      return nv(qp, Gp, u);
    }
  }, KC = {
    delta: xk,
    edge: fl,
    positions: function(u) {
      return nv(Gp, qp, u);
    }
  }, Kp = qs(kk, KC), rg = {
    delta: function(u, c) {
      return Kp(c).delta(u, c);
    },
    positions: function(u, c) {
      return Kp(c).positions(u, c);
    },
    edge: function(u) {
      return Kp(u).edge(u);
    }
  }, XC = {
    unsupportedLength: [
      "em",
      "ex",
      "cap",
      "ch",
      "ic",
      "rem",
      "lh",
      "rlh",
      "vw",
      "vh",
      "vi",
      "vb",
      "vmin",
      "vmax",
      "cm",
      "mm",
      "Q",
      "in",
      "pc",
      "pt",
      "px"
    ],
    fixed: [
      "px",
      "pt"
    ],
    relative: ["%"],
    empty: [""]
  }, af = function() {
    var u = "[0-9]+", c = "[+-]?" + u, d = "[eE]" + c, h = "\\.", S = function(W) {
      return "(?:" + W + ")?";
    }, B = [
      "Infinity",
      u + h + S(u) + S(d),
      h + u + S(d),
      u + S(d)
    ].join("|"), L = "[+-]?(?:" + B + ")";
    return new RegExp("^(" + L + ")(.*)$");
  }(), ag = function(u, c) {
    return _(c, function(d) {
      return _(XC[d], function(h) {
        return u === h;
      });
    });
  }, cy = function(u, c) {
    var d = N.from(af.exec(u));
    return d.bind(function(h) {
      var S = Number(h[1]), B = h[2];
      return ag(B, c) ? N.some({
        value: S,
        unit: B
      }) : N.none();
    });
  }, YC = /(\d+(\.\d+)?)%/, Tk = /(\d+(\.\d+)?)px|em/, Ek = wo("col"), bi = function(u, c, d) {
    var h = wc(u).getOrThunk(function() {
      return Qa(Ls(u));
    });
    return c(u) / d(h) * 100;
  }, of = function(u, c) {
    Xo(u, "width", c + "px");
  }, Jl = function(u, c) {
    Xo(u, "width", c + "%");
  }, Lv = function(u, c) {
    Xo(u, "height", c + "px");
  }, ZC = function(u) {
    return ng(u) + "px";
  }, Ql = function(u, c, d, h) {
    var S = Oo(u).map(function(B) {
      var L = d(B);
      return Math.floor(c / 100 * L);
    }).getOr(c);
    return h(u, S), S;
  }, $d = function(u, c, d, h) {
    var S = parseFloat(u);
    return ot(u, "%") && va(c) !== "table" ? Ql(c, S, d, h) : S;
  }, fy = function(u) {
    var c = ZC(u);
    return c ? $d(c, u, os, Lv) : os(u);
  }, vy = function(u, c, d) {
    var h = d(u), S = _i(u, c);
    return h / S;
  }, rv = function(u, c) {
    return ns(u, c).orThunk(function() {
      return Da(u, c).map(function(d) {
        return d + "px";
      });
    });
  }, Ol = function(u) {
    return rv(u, "width");
  }, lu = function(u) {
    return rv(u, "height");
  }, A1 = function(u) {
    return bi(u, Zl, Ba);
  }, dy = function(u) {
    return Ek(u) ? Zl(u) : _c(u);
  }, Ld = function(u) {
    return vy(u, "rowspan", fy);
  }, og = function(u) {
    var c = Ol(u);
    return c.bind(function(d) {
      return cy(d, [
        "fixed",
        "relative",
        "empty"
      ]);
    });
  }, ig = function(u, c, d) {
    Xo(u, "width", c + d);
  }, _k = function(u) {
    return Zl(u) + "px";
  }, ug = function(u) {
    return bi(u, Zl, Ba) + "%";
  }, my = function(u) {
    return Ol(u).exists(function(c) {
      return YC.test(c);
    });
  }, Ak = function(u) {
    return Ol(u).exists(function(c) {
      return Tk.test(c);
    });
  }, Uo = function(u) {
    return Ol(u).isNone();
  }, O1 = ze(YC), zv = wo("col"), gy = function(u) {
    return Ol(u).getOrThunk(function() {
      return dy(u) + "px";
    });
  }, py = function(u) {
    return lu(u).getOrThunk(function() {
      return Ld(u) + "px";
    });
  }, Dl = function(u) {
    return Me(ra.justColumns(u), function(c) {
      return N.from(c.element);
    });
  }, vl = function(u) {
    var c = Ue().browser, d = c.isChrome() || c.isFirefox();
    return zv(u) ? d : !0;
  }, zd = function(u, c, d, h, S, B) {
    return u.filter(h).fold(function() {
      return B(Ws(d, c));
    }, function(L) {
      return S(L);
    });
  }, Hv = function(u, c, d, h) {
    var S = Fd(u), B = ra.hasColumns(u) ? Dl(u) : S, L = [N.some(rg.edge(c))].concat(Me(rg.positions(S, c), function(me) {
      return me.map(function(Re) {
        return Re.x;
      });
    })), W = De(Pd);
    return Me(B, function(me, Re) {
      return zd(me, Re, L, W, function(rt) {
        if (vl(rt))
          return d(rt);
        var jt = C1(S[Re], ht);
        return zd(jt, Re, L, W, function(Sn) {
          return h(N.some(Zl(Sn)));
        }, h);
      }, h);
    });
  }, D1 = function(u) {
    return u.map(function(c) {
      return c + "px";
    }).getOr("");
  }, Xp = function(u, c) {
    return Hv(u, c, gy, D1);
  }, hy = function(u, c, d) {
    return Hv(u, c, A1, function(h) {
      return h.fold(function() {
        return d.minCellWidth();
      }, function(S) {
        return S / d.pixelWidth() * 100;
      });
    });
  }, Hd = function(u, c, d) {
    return Hv(u, c, dy, function(h) {
      return h.getOrThunk(d.minCellWidth);
    });
  }, B1 = function(u, c, d, h, S) {
    var B = $v(u), L = [N.some(d.edge(c))].concat(Me(d.positions(B, c), function(W) {
      return W.map(function(me) {
        return me.y;
      });
    }));
    return Me(B, function(W, me) {
      return zd(W, me, L, De(S1), h, S);
    });
  }, Ok = function(u, c, d) {
    return B1(u, c, d, Ld, function(h) {
      return h.getOrThunk(Yo);
    });
  }, by = function(u, c, d) {
    return B1(u, c, d, py, D1);
  }, dl = function(u, c) {
    return function() {
      return Vr(u) ? c(u) : parseFloat(ns(u, "width").getOr("0"));
    };
  }, Gs = function(u) {
    var c = dl(u, Zl), d = ze(0), h = function(S, B) {
      return Hd(S, u, B);
    };
    return {
      width: c,
      pixelWidth: c,
      getWidths: h,
      getCellDelta: d,
      singleColumnWidth: ze([0]),
      minCellWidth: d,
      setElementWidth: ue,
      adjustTableWidth: ue,
      isRelative: !0,
      label: "none"
    };
  }, sg = function(u) {
    var c = dl(u, function(me) {
      return parseFloat(ug(me));
    }), d = dl(u, Zl), h = function(me) {
      return me / d() * 100;
    }, S = function(me, Re) {
      return [100 - me];
    }, B = function() {
      return qf() / d() * 100;
    }, L = function(me) {
      var Re = c(), rt = me / 100 * Re, jt = Re + rt;
      Jl(u, jt);
    }, W = function(me, Re) {
      return hy(me, u, Re);
    };
    return {
      width: c,
      pixelWidth: d,
      getWidths: W,
      getCellDelta: h,
      singleColumnWidth: S,
      minCellWidth: B,
      setElementWidth: Jl,
      adjustTableWidth: L,
      isRelative: !0,
      label: "percent"
    };
  }, ec = function(u) {
    var c = dl(u, Zl), d = ht, h = function(L, W) {
      var me = Math.max(qf(), L + W);
      return [me - L];
    }, S = function(L) {
      var W = c() + L;
      of(u, W);
    }, B = function(L, W) {
      return Hd(L, u, W);
    };
    return {
      width: c,
      pixelWidth: c,
      getWidths: B,
      getCellDelta: d,
      singleColumnWidth: h,
      minCellWidth: qf,
      setElementWidth: of,
      adjustTableWidth: S,
      isRelative: !1,
      label: "pixel"
    };
  }, Mu = function(u, c) {
    var d = O1().exec(c);
    return d !== null ? sg(u) : ec(u);
  }, R1 = function(u) {
    var c = Ol(u);
    return c.fold(function() {
      return Gs(u);
    }, function(d) {
      return Mu(u, d);
    });
  }, av = {
    getTableSize: R1,
    pixelSize: ec,
    percentageSize: sg,
    noneSize: Gs
  }, JC = function(u, c, d, h, S, B) {
    return {
      minRow: u,
      minCol: c,
      maxRow: d,
      maxCol: h,
      allCells: S,
      selectedCells: B
    };
  }, cu = function(u, c) {
    var d = u.grid.columns, h = u.grid.rows, S = h, B = d, L = 0, W = 0, me = [], Re = [];
    return za(u.access, function(rt) {
      if (me.push(rt), c(rt)) {
        Re.push(rt);
        var jt = rt.row, Sn = jt + rt.rowspan - 1, ln = rt.column, Wt = ln + rt.colspan - 1;
        jt < S ? S = jt : Sn > L && (L = Sn), ln < B ? B = ln : Wt > W && (W = Wt);
      }
    }), JC(S, B, L, W, me, Re);
  }, yy = function(u, c, d) {
    var h = u[d].element, S = Nt.fromTag("td");
    Vo(S, Nt.fromTag("br"));
    var B = c ? Vo : su;
    B(h, S);
  }, M1 = function(u, c, d, h) {
    for (var S = c.grid.columns, B = c.grid.rows, L = 0; L < B; L++)
      for (var W = !1, me = 0; me < S; me++)
        if (!(L < d.minRow || L > d.maxRow || me < d.minCol || me > d.maxCol)) {
          var Re = ra.getAt(c, L, me).filter(h).isNone();
          Re ? yy(u, W, L) : W = !0;
        }
  }, Ta = function(u, c, d, h) {
    za(d.columns, function(L) {
      (L.column < c.minCol || L.column > c.maxCol) && Ss(L.element);
    });
    var S = Tt(Gf(u, "tr"), function(L) {
      return L.dom.childElementCount === 0;
    });
    Je(S, Ss), (c.minCol === c.maxCol || c.minRow === c.maxRow) && Je(Gf(u, "th,td"), function(L) {
      mo(L, "rowspan"), mo(L, "colspan");
    }), mo(u, si), mo(u, "data-snooker-col-series");
    var B = av.getTableSize(u);
    B.adjustTableWidth(h);
  }, xr = function(u, c, d, h) {
    if (h.minCol === 0 && c.grid.columns === h.maxCol + 1)
      return 0;
    var S = Hd(c, u, d), B = se(S, function(Re, rt) {
      return Re + rt;
    }, 0), L = se(S.slice(h.minCol, h.maxCol + 1), function(Re, rt) {
      return Re + rt;
    }, 0), W = L / B * d.pixelWidth(), me = W - d.pixelWidth();
    return d.getCellDelta(me);
  }, ml = function(u, c) {
    var d = function(Sn) {
      return vr(Sn.element, c);
    }, h = Ha(u), S = x1(h), B = av.getTableSize(u), L = ra.generate(S), W = cu(L, d), me = "th:not(" + c + "),td:not(" + c + ")", Re = Kf(h, "th,td", function(Sn) {
      return vr(Sn, me);
    });
    Je(Re, Ss), M1(S, L, W, d);
    var rt = ra.fromTable(u), jt = xr(u, rt, B, W);
    return Ta(h, W, L, jt), h;
  }, P1 = "\xA0", tc = function(u) {
    return va(u) === "img" ? 1 : VC(u).fold(function() {
      return x(u).length;
    }, function(c) {
      return c.length;
    });
  }, QC = function(u) {
    return VC(u).filter(function(c) {
      return c.trim().length !== 0 || c.indexOf(P1) > -1;
    }).isSome();
  }, ro = [
    "img",
    "br"
  ], wy = function(u) {
    var c = QC(u);
    return c || Te(ro, va(u));
  }, N1 = function(u) {
    return Ip(u, wy);
  }, I1 = function(u) {
    return cn(u, wy);
  }, cn = function(u, c) {
    var d = function(h) {
      for (var S = x(h), B = S.length - 1; B >= 0; B--) {
        var L = S[B];
        if (c(L))
          return N.some(L);
        var W = d(L);
        if (W.isSome())
          return W;
      }
      return N.none();
    };
    return d(u);
  }, Cy = {
    scope: [
      "row",
      "col"
    ]
  }, Sy = function(u) {
    return function() {
      var c = Nt.fromTag("td", u.dom);
      return Vo(c, Nt.fromTag("br", u.dom)), c;
    };
  }, Vv = function(u) {
    return function() {
      return Nt.fromTag("col", u.dom);
    };
  }, Yp = function(u) {
    return function() {
      return Nt.fromTag("colgroup", u.dom);
    };
  }, Vd = function(u) {
    return function() {
      return Nt.fromTag("tr", u.dom);
    };
  }, Uv = function(u, c, d) {
    var h = Al(u, c);
    return za(d, function(S, B) {
      S === null ? mo(h, B) : Ei(h, B, S);
    }), h;
  }, Ud = function(u) {
    return u;
  }, lg = function(u, c, d) {
    var h = N1(u);
    return h.map(function(S) {
      var B = d.join(","), L = Ti(S, B, function(W) {
        return Xr(W, u);
      });
      return Jt(L, function(W, me) {
        var Re = Yl(me);
        return mo(Re, "contenteditable"), Vo(W, Re), Re;
      }, c);
    }).getOr(c);
  }, li = function(u, c) {
    za(Cy, function(d, h) {
      return Da(u, h).filter(function(S) {
        return Te(d, S);
      }).each(function(S) {
        return Ei(c, h, S);
      });
    });
  }, Zr = function(u, c, d) {
    var h = function(L, W) {
      Nv(L.element, W), iu(W, "height"), L.colspan !== 1 && iu(W, "width");
    }, S = function(L) {
      var W = Nt.fromTag(va(L.element), c.dom), me = d.getOr([
        "strong",
        "em",
        "b",
        "i",
        "span",
        "font",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "p",
        "div"
      ]), Re = me.length > 0 ? lg(L.element, W, me) : W;
      return Vo(Re, Nt.fromTag("br")), h(L, W), li(L.element, W), u(L.element, W), W;
    }, B = function(L) {
      var W = Nt.fromTag(va(L.element), c.dom);
      return h(L, W), u(L.element, W), W;
    };
    return {
      col: B,
      colgroup: Yp(c),
      row: Vd(c),
      cell: S,
      replace: Uv,
      colGap: Vv(c),
      gap: Sy(c)
    };
  }, gl = function(u) {
    return {
      col: Vv(u),
      colgroup: Yp(u),
      row: Vd(u),
      cell: Sy(u),
      replace: Ud,
      colGap: Vv(u),
      gap: Sy(u)
    };
  }, eS = function(u, c) {
    var d = c || document, h = d.createElement("div");
    return h.innerHTML = u, x(Nt.fromDom(h));
  }, Ks = function(u) {
    return Me(u, Nt.fromDom);
  }, xy = function(u) {
    return u.nodeName.toLowerCase();
  }, uf = function(u) {
    return Nt.fromDom(u.getBody());
  }, ov = function(u) {
    return u.getBoundingClientRect().width;
  }, iv = function(u) {
    return u.getBoundingClientRect().height;
  }, pl = function(u) {
    return function(c) {
      return Xr(c, uf(u));
    };
  }, jv = function(u) {
    return u ? u.replace(/px$/, "") : "";
  }, zi = function(u) {
    return /^\d+(\.\d+)?$/.test(u) ? u + "px" : u;
  }, is = function(u) {
    mo(u, "data-mce-style");
    var c = function(d) {
      return mo(d, "data-mce-style");
    };
    Je(Xf(u), c), Je(kc(u), c), Je(ws(u), c);
  }, sf = function(u, c) {
    var d = u.dom.getStyle(c, "width") || u.dom.getAttrib(c, "width");
    return N.from(d).filter(yn);
  }, Wv = function(u) {
    return /^(\d+(\.\d+)?)%$/.test(u);
  }, cg = function(u) {
    return /^(\d+(\.\d+)?)px$/.test(u);
  }, jd = function(u) {
    return Nt.fromDom(u.selection.getStart());
  }, ur = function(u) {
    return Nt.fromDom(u.selection.getEnd());
  }, Xi = function(u) {
    return T1(u.get(), ze([]), ht, at);
  }, Oc = function(u) {
    var c = function(S, B) {
      return Da(S, B).exists(function(L) {
        return parseInt(L, 10) > 1;
      });
    }, d = function(S) {
      return c(S, "rowspan") || c(S, "colspan");
    }, h = Xi(u);
    return h.length > 0 && We(h, d) ? N.some(h) : N.none();
  }, lf = function(u, c, d) {
    return T1(c.get(), N.none, function(h) {
      return h.length <= 1 ? N.none() : Ki(u, d.firstSelectedSelector, d.lastSelectedSelector).map(function(S) {
        return {
          bounds: S,
          cells: h
        };
      });
    }, N.none);
  }, Zp = "data-mce-selected", tS = "td[" + Zp + "],th[" + Zp + "]", F1 = "[" + Zp + "]", qv = "data-mce-first-selected", Gv = "td[" + qv + "],th[" + qv + "]", fg = "data-mce-last-selected", Jp = "td[" + fg + "],th[" + fg + "]", Dk = F1, hl = {
    selected: Zp,
    selectedSelector: tS,
    firstSelected: qv,
    firstSelectedSelector: Gv,
    lastSelected: fg,
    lastSelectedSelector: Jp
  }, ky = function(u) {
    return {
      element: u,
      mergable: N.none(),
      unmergable: N.none(),
      selection: [u]
    };
  }, Wd = function(u, c, d) {
    return {
      element: d,
      mergable: lf(c, u, hl),
      unmergable: Oc(u),
      selection: Xi(u)
    };
  }, Kv = function(u, c, d) {
    return {
      element: u,
      clipboard: c,
      generators: d
    };
  }, Ty = function(u, c, d, h) {
    return {
      selection: Xi(u),
      clipboard: d,
      generators: h
    };
  }, Xv = function(u) {
    return Oo(u).bind(function(c) {
      return ri(c, hl.firstSelectedSelector);
    }).fold(ze(u), function(c) {
      return c[0];
    });
  }, nS = function(u) {
    return function(c, d) {
      var h = va(c), S = h === "col" || h === "colgroup" ? Xv(c) : c;
      return zo(S, u, d);
    };
  }, Fo = nS("th,td,caption"), fu = nS("th,td"), Pu = function(u) {
    return Xi(u);
  }, rS = function(u, c) {
    var d = fu(u), h = d.bind(function(S) {
      return Oo(S);
    }).map(function(S) {
      return ws(S);
    });
    return Vs(d, h, function(S, B) {
      return Tt(B, function(L) {
        return _(Ks(L.dom.cells), function(W) {
          return il(W, c) === "1" || Xr(W, S);
        });
      });
    }).getOr([]);
  }, $1 = function(u) {
    return Oo(u[0]).map(function(c) {
      var d = ml(c, Dk);
      return is(d), [d];
    });
  }, Bk = function(u, c) {
    return Me(c, function(d) {
      return u.selection.serializer.serialize(d.dom, {});
    }).join("");
  }, aS = function(u) {
    return Me(u, function(c) {
      return c.dom.innerText;
    }).join("");
  }, nc = function(u, c, d) {
    u.on("BeforeGetContent", function(h) {
      var S = function(B) {
        h.preventDefault(), $1(B).each(function(L) {
          h.content = h.format === "text" ? aS(L) : Bk(u, L);
        });
      };
      h.selection === !0 && T1(c.get(), ue, S, ue);
    }), u.on("BeforeSetContent", function(h) {
      if (h.selection === !0 && h.paste === !0) {
        var S = Pu(c);
        Ie(S).each(function(B) {
          Oo(B).each(function(L) {
            var W = Tt(eS(h.content), function(Sn) {
              return va(Sn) !== "meta";
            }), me = wo("table");
            if (W.length === 1 && me(W[0])) {
              h.preventDefault();
              var Re = Nt.fromDom(u.getDoc()), rt = gl(Re), jt = Kv(B, W[0], rt);
              d.pasteCells(L, jt).each(function() {
                u.focus();
              });
            }
          });
        });
      }
    });
  }, Rk = tf.generate([
    { none: [] },
    { only: ["index"] },
    {
      left: [
        "index",
        "next"
      ]
    },
    {
      middle: [
        "prev",
        "index",
        "next"
      ]
    },
    {
      right: [
        "prev",
        "index"
      ]
    }
  ]), vg = he({}, Rk), L1 = function(u, c) {
    return u.length === 0 ? vg.none() : u.length === 1 ? vg.only(0) : c === 0 ? vg.left(0, 1) : c === u.length - 1 ? vg.right(c - 1, c) : c > 0 && c < u.length - 1 ? vg.middle(c - 1, c, c + 1) : vg.none();
  }, Mk = function(u, c, d, h, S) {
    var B = u.slice(0), L = L1(u, c), W = ze(Me(B, ze(0))), me = function(Sn) {
      return h.singleColumnWidth(B[Sn], d);
    }, Re = function(Sn, ln) {
      return S.calcLeftEdgeDeltas(B, Sn, ln, d, h.minCellWidth(), h.isRelative);
    }, rt = function(Sn, ln, Wt) {
      return S.calcMiddleDeltas(B, Sn, ln, Wt, d, h.minCellWidth(), h.isRelative);
    }, jt = function(Sn, ln) {
      return S.calcRightEdgeDeltas(B, Sn, ln, d, h.minCellWidth(), h.isRelative);
    };
    return L.fold(W, me, Re, rt, jt);
  }, oS = function(u, c, d) {
    for (var h = 0, S = u; S < c; S++)
      h += d[S] !== void 0 ? d[S] : 0;
    return h;
  }, Ey = function(u, c) {
    var d = ra.justCells(u);
    return Me(d, function(h) {
      var S = oS(h.column, h.column + h.colspan, c);
      return {
        element: h.element,
        width: S,
        colspan: h.colspan
      };
    });
  }, _y = function(u, c) {
    var d = ra.justColumns(u);
    return Me(d, function(h, S) {
      return {
        element: h.element,
        width: c[S],
        colspan: h.colspan
      };
    });
  }, Ay = function(u, c) {
    var d = ra.justCells(u);
    return Me(d, function(h) {
      var S = oS(h.row, h.row + h.rowspan, c);
      return {
        element: h.element,
        height: S,
        rowspan: h.rowspan
      };
    });
  }, Pk = function(u, c) {
    return Me(u.all, function(d, h) {
      return {
        element: d.element,
        height: c[h]
      };
    });
  }, Yv = function(u) {
    return Jt(u, function(c, d) {
      return c + d;
    }, 0);
  }, Zv = function(u, c) {
    return ra.hasColumns(u) ? _y(u, c) : Ey(u, c);
  }, Xa = function(u, c, d) {
    var h = Zv(u, c);
    Je(h, function(S) {
      d.setElementWidth(S.element, S.width);
    });
  }, z1 = function(u, c, d, h, S) {
    var B = ra.fromTable(u), L = S.getCellDelta(c), W = S.getWidths(B, S), me = d === B.grid.columns - 1, Re = h.clampTableDelta(W, d, L, S.minCellWidth(), me), rt = Mk(W, d, Re, S, h), jt = Me(rt, function(Sn, ln) {
      return Sn + W[ln];
    });
    Xa(B, jt, S), h.resizeTable(S.adjustTableWidth, Re, me);
  }, Dc = function(u, c, d, h) {
    var S = ra.fromTable(u), B = Ok(S, u, h), L = Me(B, function(rt, jt) {
      return d === jt ? Math.max(c + rt, Yo()) : rt;
    }), W = Ay(S, L), me = Pk(S, L);
    Je(me, function(rt) {
      Lv(rt.element, rt.height);
    }), Je(W, function(rt) {
      Lv(rt.element, rt.height);
    });
    var Re = Yv(L);
    Lv(u, Re);
  }, iS = function(u, c, d, h, S) {
    var B = ra.generate(c), L = h.getWidths(B, h), W = h.pixelWidth(), me = S.calcRedestributedWidths(L, W, d.pixelDelta, h.isRelative), Re = me.newSizes, rt = me.delta;
    Xa(B, Re, h), h.adjustTableWidth(rt);
  }, Bc = function(u, c, d, h) {
    var S = ra.generate(c), B = h.getWidths(S, h);
    Xa(S, B, h);
  }, cf = function(u) {
    return Me(u, ze(0));
  }, Jv = function(u, c, d, h, S) {
    return S(u.slice(0, c)).concat(h).concat(S(u.slice(d)));
  }, H1 = function(u) {
    return function(c, d, h, S) {
      if (u(h)) {
        var B = Math.max(S, c[d] - Math.abs(h)), L = Math.abs(B - c[d]);
        return h >= 0 ? L : -L;
      } else
        return h;
    };
  }, Qp = H1(function(u) {
    return u < 0;
  }), V1 = H1(Be), U1 = function() {
    var u = function(W, me, Re, rt, jt) {
      var Sn = Qp(W, me, rt, jt);
      return Jv(W, me, Re + 1, [
        Sn,
        0
      ], cf);
    }, c = function(W, me, Re, rt) {
      var jt = (100 + Re) / 100, Sn = Math.max(rt, (W[me] + Re) / jt);
      return Me(W, function(ln, Wt) {
        var Pn = Wt === me ? Sn : ln / jt;
        return Pn - ln;
      });
    }, d = function(W, me, Re, rt, jt, Sn) {
      return Sn ? c(W, me, rt, jt) : u(W, me, Re, rt, jt);
    }, h = function(W, me, Re, rt, jt, Sn, ln) {
      return d(W, Re, rt, jt, Sn, ln);
    }, S = function(W, me) {
      return W(me);
    }, B = function(W, me, Re, rt, jt, Sn) {
      if (Sn)
        return c(W, Re, rt, jt);
      var ln = Qp(W, Re, rt, jt);
      return cf(W.slice(0, Re)).concat([ln]);
    }, L = function(W, me, Re, rt) {
      if (rt) {
        var jt = me + Re, Sn = jt / me, ln = Me(W, function(Wt) {
          return Wt / Sn;
        });
        return {
          delta: Sn * 100 - 100,
          newSizes: ln
        };
      } else
        return {
          delta: Re,
          newSizes: W
        };
    };
    return {
      resizeTable: S,
      clampTableDelta: Qp,
      calcLeftEdgeDeltas: d,
      calcMiddleDeltas: h,
      calcRightEdgeDeltas: B,
      calcRedestributedWidths: L
    };
  }, qd = function() {
    var u = function(L, W, me, Re, rt) {
      var jt = Re >= 0 ? me : W, Sn = V1(L, jt, Re, rt);
      return Jv(L, W, me + 1, [
        Sn,
        -Sn
      ], cf);
    }, c = function(L, W, me, Re, rt, jt) {
      return u(L, me, Re, rt, jt);
    }, d = function(L, W, me) {
      me && L(W);
    }, h = function(L, W, me, Re, rt, jt) {
      if (jt)
        return cf(L);
      var Sn = Re / L.length;
      return Me(L, ze(Sn));
    }, S = function(L, W, me, Re, rt) {
      if (rt) {
        if (me >= 0)
          return me;
        var jt = se(L, function(Sn, ln) {
          return Sn + ln - Re;
        }, 0);
        return Math.max(-jt, me);
      } else
        return Qp(L, W, me, Re);
    }, B = function(L, W, me, Re) {
      return {
        delta: 0,
        newSizes: L
      };
    };
    return {
      resizeTable: d,
      clampTableDelta: S,
      calcLeftEdgeDeltas: u,
      calcMiddleDeltas: c,
      calcRightEdgeDeltas: h,
      calcRedestributedWidths: B
    };
  }, Nk = function(u, c) {
    var d = N.from(u.dom.documentElement).map(Nt.fromDom).getOr(u);
    return {
      parent: ze(d),
      view: ze(u),
      origin: ze(no(0, 0)),
      isResizable: c
    };
  }, j1 = function(u, c, d) {
    var h = function() {
      return tv(c);
    };
    return {
      parent: ze(c),
      view: ze(u),
      origin: h,
      isResizable: d
    };
  }, dg = function(u, c, d) {
    return {
      parent: ze(c),
      view: ze(u),
      origin: ze(no(0, 0)),
      isResizable: d
    };
  }, eh = {
    only: Nk,
    detached: j1,
    body: dg
  }, th = tf.generate([
    { invalid: ["raw"] },
    { pixels: ["value"] },
    { percent: ["value"] }
  ]), Oy = function(u, c, d) {
    var h = d.substring(0, d.length - u.length), S = parseFloat(h);
    return h === S.toString() ? c(S) : th.invalid(d);
  }, Di = function(u) {
    return ot(u, "%") ? Oy("%", th.percent, u) : ot(u, "px") ? Oy("px", th.pixels, u) : th.invalid(u);
  }, Gd = he(he({}, th), { from: Di }), yi = function(u, c) {
    return Me(u, function(d) {
      var h = Gd.from(d);
      return h.fold(function() {
        return d;
      }, function(S) {
        var B = S / c * 100;
        return B + "%";
      }, function(S) {
        return S + "%";
      });
    });
  }, us = function(u, c, d) {
    var h = d / c;
    return Me(u, function(S) {
      var B = Gd.from(S);
      return B.fold(function() {
        return S;
      }, function(L) {
        return L * h + "px";
      }, function(L) {
        return L / 100 * d + "px";
      });
    });
  }, Kd = function(u, c) {
    var d = u.fold(function() {
      return ze("");
    }, function(h) {
      var S = h / c;
      return ze(S + "px");
    }, function() {
      var h = 100 / c;
      return ze(h + "%");
    });
    return je(c, d);
  }, bl = function(u, c, d) {
    return u.fold(function() {
      return c;
    }, function(h) {
      return us(c, d, h);
    }, function(h) {
      return yi(c, d);
    });
  }, W1 = function(u, c, d) {
    var h = Gd.from(d), S = We(u, function(B) {
      return B === "0px";
    }) ? Kd(h, u.length) : bl(h, u, c);
    return uS(S);
  }, ff = function(u, c) {
    return u.length === 0 ? c : Jt(u, function(d, h) {
      return Gd.from(h).fold(ze(0), ht, ht) + d;
    }, 0);
  }, mg = function(u, c) {
    var d = Math.floor(u);
    return {
      value: d + c,
      remainder: u - d
    };
  }, gg = function(u, c) {
    return Gd.from(u).fold(ze(u), function(d) {
      return d + c + "px";
    }, function(d) {
      return d + c + "%";
    });
  }, uS = function(u) {
    if (u.length === 0)
      return u;
    var c = Jt(u, function(h, S) {
      var B = Gd.from(S).fold(function() {
        return {
          value: S,
          remainder: 0
        };
      }, function(L) {
        return mg(L, "px");
      }, function(L) {
        return {
          value: L + "%",
          remainder: 0
        };
      });
      return {
        output: [B.value].concat(h.output),
        remainder: h.remainder + B.remainder
      };
    }, {
      output: [],
      remainder: 0
    }), d = c.output;
    return d.slice(0, d.length - 1).concat([gg(d[d.length - 1], Math.round(c.remainder))]);
  }, sS = Gd.from, Ik = function(u, c, d) {
    Je(c, function(h) {
      var S = u.slice(h.column, h.colspan + h.column), B = ff(S, qf());
      Xo(h.element, "width", B + d);
    });
  }, Fk = function(u, c, d) {
    Je(c, function(h, S) {
      var B = ff([u[S]], qf());
      Xo(h.element, "width", B + d);
    });
  }, $k = function(u, c, d, h) {
    Je(d, function(S) {
      var B = u.slice(S.row, S.rowspan + S.row), L = ff(B, Yo());
      Xo(S.element, "height", L + h);
    }), Je(c, function(S, B) {
      Xo(S.element, "height", u[B]);
    });
  }, lS = function(u) {
    return sS(u).fold(ze("px"), ze("px"), ze("%"));
  }, q1 = function(u, c, d) {
    var h = ra.fromTable(u), S = h.all, B = ra.justCells(h), L = ra.justColumns(h);
    c.each(function(W) {
      var me = lS(W), Re = Zl(u), rt = Xp(h, u), jt = W1(rt, Re, W);
      ra.hasColumns(h) ? Fk(jt, L, me) : Ik(jt, B, me), Xo(u, "width", W);
    }), d.each(function(W) {
      var me = lS(W), Re = os(u), rt = by(h, u, ly), jt = W1(rt, Re, W);
      $k(jt, S, B, me), Xo(u, "height", W);
    });
  }, G1 = my, vu = Ak, K1 = Uo, Dy = function(u) {
    var c = ra.fromTable(u);
    return c.grid;
  }, Bl = function(u) {
    var c = [], d = function(B) {
      if (B === void 0)
        throw new Error("Event bind error: undefined handler");
      c.push(B);
    }, h = function(B) {
      c = Tt(c, function(L) {
        return L !== B;
      });
    }, S = function() {
      for (var B = [], L = 0; L < arguments.length; L++)
        B[L] = arguments[L];
      var W = {};
      Je(u, function(me, Re) {
        W[me] = B[Re];
      }), Je(c, function(me) {
        me(W);
      });
    };
    return {
      bind: d,
      unbind: h,
      trigger: S
    };
  }, ko = function(u) {
    var c = $s(u, function(h) {
      return {
        bind: h.bind,
        unbind: h.unbind
      };
    }), d = $s(u, function(h) {
      return h.trigger;
    });
    return {
      registry: c,
      trigger: d
    };
  }, yl = function(u, c) {
    var d = null, h = function() {
      j(d) || (clearTimeout(d), d = null);
    }, S = function() {
      for (var B = [], L = 0; L < arguments.length; L++)
        B[L] = arguments[L];
      h(), d = setTimeout(function() {
        d = null, u.apply(null, B);
      }, c);
    };
    return {
      cancel: h,
      throttle: S
    };
  }, Qv = function(u) {
    return u.slice(0).sort();
  }, By = function(u, c) {
    throw new Error("All required keys (" + Qv(u).join(", ") + ") were not specified. Specified keys were: " + Qv(c).join(", ") + ".");
  }, X1 = function(u) {
    throw new Error("Unsupported keys for object: " + Qv(u).join(", "));
  }, cS = function(u, c) {
    if (!X(c))
      throw new Error("The " + u + " fields must be an array. Was: " + c + ".");
    Je(c, function(d) {
      if (!P(d))
        throw new Error("The value " + d + " in the " + u + " fields was not a string.");
    });
  }, ta = function(u, c) {
    throw new Error("All values need to be of type: " + c + ". Keys (" + Qv(u).join(", ") + ") were not.");
  }, pg = function(u) {
    var c = Qv(u), d = _t(c, function(h, S) {
      return S < c.length - 1 && h === c[S + 1];
    });
    d.each(function(h) {
      throw new Error("The field: " + h + " occurs more than once in the combined fields: [" + c.join(", ") + "].");
    });
  }, Y1 = function(u, c) {
    return Ry(u, c, {
      validate: D,
      label: "function"
    });
  }, Ry = function(u, c, d) {
    if (c.length === 0)
      throw new Error("You must specify at least one required field.");
    return cS("required", c), pg(c), function(h) {
      var S = ki(h), B = We(c, function(W) {
        return Te(S, W);
      });
      B || By(c, S), u(c, S);
      var L = Tt(c, function(W) {
        return !d.validate(h[W], W);
      });
      return L.length > 0 && ta(L, d.label), h;
    };
  }, Bi = function(u, c) {
    var d = Tt(c, function(h) {
      return !Te(u, h);
    });
    d.length > 0 && X1(d);
  }, Rl = function(u) {
    return Y1(Bi, u);
  }, fS = Rl([
    "compare",
    "extract",
    "mutate",
    "sink"
  ]), Xd = Rl([
    "element",
    "start",
    "stop",
    "destroy"
  ]), ho = Rl([
    "forceDrop",
    "drop",
    "move",
    "delayDrop"
  ]), Yd = function() {
    var u = N.none(), c = function() {
      u = N.none();
    }, d = function(B, L) {
      var W = u.map(function(me) {
        return B.compare(me, L);
      });
      return u = N.some(L), W;
    }, h = function(B, L) {
      var W = L.extract(B);
      W.each(function(me) {
        var Re = d(L, me);
        Re.each(function(rt) {
          S.trigger.move(rt);
        });
      });
    }, S = ko({ move: Bl(["info"]) });
    return {
      onEvent: h,
      reset: c,
      events: S.registry
    };
  }, Z1 = function() {
    var u = ko({ move: Bl(["info"]) });
    return {
      onEvent: ue,
      reset: ue,
      events: u.registry
    };
  }, hg = function() {
    var u = Z1(), c = Yd(), d = u, h = function() {
      d.reset(), d = c;
    }, S = function() {
      d.reset(), d = u;
    }, B = function(W, me) {
      d.onEvent(W, me);
    }, L = function() {
      return d === c;
    };
    return {
      on: h,
      off: S,
      isOn: L,
      onEvent: B,
      events: c.events
    };
  }, My = function(u, c, d) {
    var h = !1, S = ko({
      start: Bl([]),
      stop: Bl([])
    }), B = hg(), L = function() {
      ln.stop(), B.isOn() && (B.off(), S.trigger.stop());
    }, W = yl(L, 200), me = function(Pn) {
      ln.start(Pn), B.on(), S.trigger.start();
    }, Re = function(Pn) {
      W.cancel(), B.onEvent(Pn, c);
    };
    B.events.move.bind(function(Pn) {
      c.mutate(u, Pn.info);
    });
    var rt = function() {
      h = !0;
    }, jt = function() {
      h = !1;
    }, Sn = function(Pn) {
      return function() {
        for (var Ln = [], mr = 0; mr < arguments.length; mr++)
          Ln[mr] = arguments[mr];
        h && Pn.apply(null, Ln);
      };
    }, ln = c.sink(ho({
      forceDrop: L,
      drop: Sn(L),
      move: Sn(Re),
      delayDrop: Sn(W.throttle)
    }), d), Wt = function() {
      ln.destroy();
    };
    return {
      element: ln.element,
      go: me,
      on: rt,
      off: jt,
      destroy: Wt,
      events: S.registry
    };
  }, vS = function(u, c, d, h, S, B, L) {
    return {
      target: u,
      x: c,
      y: d,
      stop: h,
      prevent: S,
      kill: B,
      raw: L
    };
  }, nh = function(u) {
    var c = Nt.fromDom(nr(u).getOr(u.target)), d = function() {
      return u.stopPropagation();
    }, h = function() {
      return u.preventDefault();
    }, S = ee(h, d);
    return vS(c, u.clientX, u.clientY, d, h, S, u);
  }, dS = function(u, c) {
    return function(d) {
      u(d) && c(nh(d));
    };
  }, uv = function(u, c, d, h, S) {
    var B = dS(d, h);
    return u.dom.addEventListener(c, B, S), { unbind: Ze(Py, u, c, B, S) };
  }, ss = function(u, c, d, h) {
    return uv(u, c, d, h, !1);
  }, Py = function(u, c, d, h) {
    u.dom.removeEventListener(c, d, h);
  }, Lk = Be, Rc = function(u, c, d) {
    return ss(u, c, Lk, d);
  }, sv = nh, J1 = function(u, c) {
    var d = il(u, c);
    return d === void 0 || d === "" ? [] : d.split(" ");
  }, zk = function(u, c, d) {
    var h = J1(u, c), S = h.concat([d]);
    return Ei(u, c, S.join(" ")), !0;
  }, Hk = function(u, c, d) {
    var h = Tt(J1(u, c), function(S) {
      return S !== d;
    });
    return h.length > 0 ? Ei(u, c, h.join(" ")) : mo(u, c), !1;
  }, Zd = function(u) {
    return u.dom.classList !== void 0;
  }, Jd = function(u) {
    return J1(u, "class");
  }, Q1 = function(u, c) {
    return zk(u, "class", c);
  }, Ra = function(u, c) {
    return Hk(u, "class", c);
  }, Ri = function(u, c) {
    Zd(u) ? u.dom.classList.add(c) : Q1(u, c);
  }, ls = function(u) {
    var c = Zd(u) ? u.dom.classList : Jd(u);
    c.length === 0 && mo(u, "class");
  }, Ts = function(u, c) {
    if (Zd(u)) {
      var d = u.dom.classList;
      d.remove(c);
    } else
      Ra(u, c);
    ls(u);
  }, io = function(u, c) {
    return Zd(u) && u.dom.classList.contains(c);
  }, ed = function(u) {
    var c = u.replace(/\./g, "-"), d = function(h) {
      return c + "-" + h;
    };
    return { resolve: d };
  }, e0 = ed("ephox-dragster"), Hi = e0.resolve, vf = function(u) {
    var c = he({ layerClass: Hi("blocker") }, u), d = Nt.fromTag("div");
    Ei(d, "role", "presentation"), Jc(d, {
      position: "fixed",
      left: "0px",
      top: "0px",
      width: "100%",
      height: "100%"
    }), Ri(d, Hi("blocker")), Ri(d, c.layerClass);
    var h = ze(d), S = function() {
      Ss(d);
    };
    return {
      element: h,
      destroy: S
    };
  }, Vk = function(u, c) {
    return no(c.left - u.left, c.top - u.top);
  }, Uk = function(u) {
    return N.some(no(u.x, u.y));
  }, t0 = function(u, c) {
    u.mutate(c.left, c.top);
  }, n0 = function(u, c) {
    var d = vf(c), h = Rc(d.element(), "mousedown", u.forceDrop), S = Rc(d.element(), "mouseup", u.drop), B = Rc(d.element(), "mousemove", u.move), L = Rc(d.element(), "mouseout", u.delayDrop), W = function() {
      d.destroy(), S.unbind(), B.unbind(), L.unbind(), h.unbind();
    }, me = function(rt) {
      Vo(rt, d.element());
    }, Re = function() {
      Ss(d.element());
    };
    return Xd({
      element: d.element,
      start: me,
      stop: Re,
      destroy: W
    });
  }, Ny = fS({
    compare: Vk,
    extract: Uk,
    sink: n0,
    mutate: t0
  }), Iy = function(u, c) {
    c === void 0 && (c = {});
    var d = c.mode !== void 0 ? c.mode : Ny;
    return My(u, d, c);
  }, Qd = function(u) {
    return zo(u, "[contenteditable]");
  }, rh = function(u, c) {
    return c === void 0 && (c = !1), !Ue().browser.isIE() && Vr(u) ? u.dom.isContentEditable : Qd(u).fold(ze(c), function(d) {
      return Fy(d) === "true";
    });
  }, Fy = function(u) {
    return u.dom.contentEditable;
  }, $y = ed("ephox-snooker"), bg = $y.resolve, du = function() {
    var u = ko({
      drag: Bl([
        "xDelta",
        "yDelta"
      ])
    }), c = function(d, h) {
      u.trigger.drag(d, h);
    };
    return {
      mutate: c,
      events: u.registry
    };
  }, Xs = function() {
    var u = ko({
      drag: Bl([
        "xDelta",
        "yDelta",
        "target"
      ])
    }), c = N.none(), d = du();
    d.events.drag.bind(function(B) {
      c.each(function(L) {
        u.trigger.drag(B.xDelta, B.yDelta, L);
      });
    });
    var h = function(B) {
      c = N.some(B);
    }, S = function() {
      return c;
    };
    return {
      assign: h,
      get: S,
      mutate: d.mutate,
      events: u.registry
    };
  }, ah = function(u, c, d, h, S) {
    var B = Nt.fromTag("div");
    return Jc(B, {
      position: "absolute",
      left: c - h / 2 + "px",
      top: d + "px",
      height: S + "px",
      width: h + "px"
    }), ui(B, {
      "data-column": u,
      role: "presentation"
    }), B;
  }, Mi = function(u, c, d, h, S) {
    var B = Nt.fromTag("div");
    return Jc(B, {
      position: "absolute",
      left: c + "px",
      top: d - S / 2 + "px",
      height: S + "px",
      width: h + "px"
    }), ui(B, {
      "data-row": u,
      role: "presentation"
    }), B;
  }, r0 = bg("resizer-bar"), lv = bg("resizer-rows"), Ly = bg("resizer-cols"), zy = 7, mS = function(u, c) {
    return He(u.all, function(d, h) {
      return c(d.element) ? [h] : [];
    });
  }, Hy = function(u, c) {
    var d = [];
    return je(u.grid.columns, function(h) {
      var S = ra.getColumnAt(u, h).map(function(B) {
        return B.element;
      });
      S.forall(c) && d.push(h);
    }), Tt(d, function(h) {
      var S = ra.filterItems(u, function(B) {
        return B.column === h;
      });
      return We(S, function(B) {
        return c(B.element);
      });
    });
  }, oh = function(u) {
    var c = zs(u.parent(), "." + r0);
    Je(c, Ss);
  }, a0 = function(u, c, d) {
    var h = u.origin();
    Je(c, function(S) {
      S.each(function(B) {
        var L = d(h, B);
        Ri(L, r0), Vo(u.parent(), L);
      });
    });
  }, gS = function(u, c, d, h) {
    a0(u, c, function(S, B) {
      var L = ah(B.col, B.x - S.left, d.top - S.top, zy, h);
      return Ri(L, Ly), L;
    });
  }, jk = function(u, c, d, h) {
    a0(u, c, function(S, B) {
      var L = Mi(B.row, d.left - S.left, B.y - S.top, h, zy);
      return Ri(L, lv), L;
    });
  }, Nu = function(u, c, d, h, S) {
    var B = tv(d), L = c.isResizable, W = h.length > 0 ? ly.positions(h, d) : [], me = W.length > 0 ? mS(u, L) : [], Re = Tt(W, function(ln, Wt) {
      return _(me, function(Pn) {
        return Wt === Pn;
      });
    });
    jk(c, Re, B, Ru(d));
    var rt = S.length > 0 ? rg.positions(S, d) : [], jt = rt.length > 0 ? Hy(u, L) : [], Sn = Tt(rt, function(ln, Wt) {
      return _(jt, function(Pn) {
        return Wt === Pn;
      });
    });
    gS(c, Sn, B, Ac(d));
  }, Vi = function(u, c) {
    if (oh(u), u.isResizable(c)) {
      var d = ra.fromTable(c), h = $v(d), S = Fd(d);
      Nu(d, u, c, h, S);
    }
  }, cs = function(u, c) {
    var d = zs(u.parent(), "." + r0);
    Je(d, c);
  }, fs = function(u) {
    cs(u, function(c) {
      Xo(c, "display", "none");
    });
  }, Es = function(u) {
    cs(u, function(c) {
      Xo(c, "display", "block");
    });
  }, wi = function(u) {
    return io(u, lv);
  }, o0 = function(u) {
    return io(u, Ly);
  }, i0 = bg("resizer-bar-dragging"), Vy = function(u) {
    var c = Xs(), d = Iy(c, {}), h = N.none(), S = function(Wt, Pn) {
      return N.from(il(Wt, Pn));
    };
    c.events.drag.bind(function(Wt) {
      S(Wt.target, "data-row").each(function(Pn) {
        var Ln = Wf(Wt.target, "top");
        Xo(Wt.target, "top", Ln + Wt.yDelta + "px");
      }), S(Wt.target, "data-column").each(function(Pn) {
        var Ln = Wf(Wt.target, "left");
        Xo(Wt.target, "left", Ln + Wt.xDelta + "px");
      });
    });
    var B = function(Wt, Pn) {
      var Ln = Wf(Wt, Pn), mr = _l(Wt, "data-initial-" + Pn, 0);
      return Ln - mr;
    };
    d.events.stop.bind(function() {
      c.get().each(function(Wt) {
        h.each(function(Pn) {
          S(Wt, "data-row").each(function(Ln) {
            var mr = B(Wt, "top");
            mo(Wt, "data-initial-top"), ln.trigger.adjustHeight(Pn, mr, parseInt(Ln, 10));
          }), S(Wt, "data-column").each(function(Ln) {
            var mr = B(Wt, "left");
            mo(Wt, "data-initial-left"), ln.trigger.adjustWidth(Pn, mr, parseInt(Ln, 10));
          }), Vi(u, Pn);
        });
      });
    });
    var L = function(Wt, Pn) {
      ln.trigger.startAdjust(), c.assign(Wt), Ei(Wt, "data-initial-" + Pn, Wf(Wt, Pn)), Ri(Wt, i0), Xo(Wt, "opacity", "0.2"), d.go(u.parent());
    }, W = Rc(u.parent(), "mousedown", function(Wt) {
      wi(Wt.target) && L(Wt.target, "top"), o0(Wt.target) && L(Wt.target, "left");
    }), me = function(Wt) {
      return Xr(Wt, u.view());
    }, Re = function(Wt) {
      return zo(Wt, "table", me).filter(rh);
    }, rt = Rc(u.view(), "mouseover", function(Wt) {
      Re(Wt.target).fold(function() {
        Vr(Wt.target) && oh(u);
      }, function(Pn) {
        h = N.some(Pn), Vi(u, Pn);
      });
    }), jt = function() {
      W.unbind(), rt.unbind(), d.destroy(), oh(u);
    }, Sn = function(Wt) {
      Vi(u, Wt);
    }, ln = ko({
      adjustHeight: Bl([
        "table",
        "delta",
        "row"
      ]),
      adjustWidth: Bl([
        "table",
        "delta",
        "column"
      ]),
      startAdjust: Bl([])
    });
    return {
      destroy: jt,
      refresh: Sn,
      on: d.on,
      off: d.off,
      hideBars: Ze(fs, u),
      showBars: Ze(Es, u),
      events: ln.registry
    };
  }, em = function(u, c, d) {
    var h = ly, S = rg, B = Vy(u), L = ko({
      beforeResize: Bl([
        "table",
        "type"
      ]),
      afterResize: Bl([
        "table",
        "type"
      ]),
      startDrag: Bl([])
    });
    return B.events.adjustHeight.bind(function(W) {
      var me = W.table;
      L.trigger.beforeResize(me, "row");
      var Re = h.delta(W.delta, me);
      Dc(me, Re, W.row, h), L.trigger.afterResize(me, "row");
    }), B.events.startAdjust.bind(function(W) {
      L.trigger.startDrag();
    }), B.events.adjustWidth.bind(function(W) {
      var me = W.table;
      L.trigger.beforeResize(me, "col");
      var Re = S.delta(W.delta, me), rt = d(me);
      z1(me, Re, W.column, c, rt), L.trigger.afterResize(me, "col");
    }), {
      on: B.on,
      off: B.off,
      hideBars: B.hideBars,
      showBars: B.showBars,
      destroy: B.destroy,
      events: L.registry
    };
  }, td = { create: em }, u0 = function(u, c) {
    return u.fire("newrow", { node: c });
  }, s0 = function(u, c) {
    return u.fire("newcell", { node: c });
  }, l0 = function(u, c, d, h, S) {
    u.fire("ObjectResizeStart", {
      target: c,
      width: d,
      height: h,
      origin: S
    });
  }, yg = function(u, c, d, h, S) {
    u.fire("ObjectResized", {
      target: c,
      width: d,
      height: h,
      origin: S
    });
  }, wg = function(u, c, d, h, S) {
    u.fire("TableSelectionChange", {
      cells: c,
      start: d,
      finish: h,
      otherCells: S
    });
  }, pS = function(u) {
    u.fire("TableSelectionClear");
  }, df = function(u, c, d) {
    u.fire("TableModified", he(he({}, d), { table: c }));
  }, tm = {
    structure: !1,
    style: !0
  }, Bo = {
    structure: !0,
    style: !1
  }, Wk = {
    structure: !0,
    style: !0
  }, qk = "tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol", c0 = {
    "border-collapse": "collapse",
    width: "100%"
  }, Gk = je(5, function(u) {
    var c = u + 1 + "px";
    return {
      title: c,
      value: c
    };
  }), hS = Me([
    "Solid",
    "Dotted",
    "Dashed",
    "Double",
    "Groove",
    "Ridge",
    "Inset",
    "Outset",
    "None",
    "Hidden"
  ], function(u) {
    return {
      title: u,
      value: u.toLowerCase()
    };
  }), Fn = function(u) {
    var c;
    if (cv(u)) {
      var d = u.dom, h = (c = d.getParent(u.selection.getStart(), d.isBlock)) !== null && c !== void 0 ? c : u.getBody(), S = Ba(Nt.fromDom(h));
      return he(he({}, c0), { width: S + "px" });
    } else
      return Cg(u) ? $i(c0, function(B, L) {
        return L !== "width";
      }) : c0;
  }, Kk = { border: "1" }, Pi = "preservetable", Uy = function(u) {
    return u.getParam("table_sizing_mode", "auto");
  }, nm = function(u) {
    return u.getParam("table_responsive_width");
  }, bS = function(u) {
    return u.getParam("table_border_widths", Gk, "array");
  }, ju = function(u) {
    return u.getParam("table_border_styles", hS, "array");
  }, ih = function(u) {
    return u.getParam("table_default_attributes", Kk, "object");
  }, f0 = function(u) {
    return u.getParam("table_default_styles", Fn(u), "object");
  }, uh = function(u) {
    return u.getParam("table_resize_bars", !0, "boolean");
  }, Mc = function(u) {
    return u.getParam("table_tab_navigation", !0, "boolean");
  }, sh = function(u) {
    return u.getParam("table_cell_advtab", !0, "boolean");
  }, lh = function(u) {
    return u.getParam("table_row_advtab", !0, "boolean");
  }, vs = function(u) {
    return u.getParam("table_advtab", !0, "boolean");
  }, Pc = function(u) {
    return u.getParam("table_appearance_options", !0, "boolean");
  }, yS = function(u) {
    return u.getParam("table_grid", !0, "boolean");
  }, Wu = function(u) {
    return u.getParam("table_style_by_css", !1, "boolean");
  }, mf = function(u) {
    return u.getParam("table_cell_class_list", [], "array");
  }, nd = function(u) {
    return u.getParam("table_row_class_list", [], "array");
  }, ch = function(u) {
    return u.getParam("table_class_list", [], "array");
  }, zt = function(u) {
    return Uy(u) === "relative" || nm(u) === !0;
  }, cv = function(u) {
    return Uy(u) === "fixed" || nm(u) === !1;
  }, Cg = function(u) {
    return Uy(u) === "responsive";
  }, Xk = function(u) {
    return u.getParam("table_toolbar", qk);
  }, v0 = function(u) {
    return u.getParam("table_use_colgroups", !1, "boolean");
  }, rc = function(u) {
    var c = "section", d = u.getParam("table_header_type", c, "string"), h = [
      "section",
      "cells",
      "sectionCells",
      "auto"
    ];
    return Te(h, d) ? d : c;
  }, d0 = function(u) {
    var c = [
      "preservetable",
      "resizetable"
    ], d = u.getParam("table_column_resizing", Pi, "string");
    return _t(c, function(h) {
      return h === d;
    }).getOr(Pi);
  }, jy = function(u) {
    return d0(u) === "preservetable";
  }, Wy = function(u) {
    return d0(u) === "resizetable";
  }, m0 = function(u) {
    var c = u.getParam("table_clone_elements");
    return P(c) ? N.some(c.split(/[ ,]/)) : Array.isArray(c) ? N.some(c) : N.none();
  }, qy = function(u) {
    var c = u.getParam("object_resizing", !0);
    return P(c) ? c === "table" : c;
  }, Gy = function(u) {
    return u.getParam("table_background_color_map", [], "array");
  }, Ky = function(u) {
    return u.getParam("table_border_color_map", [], "array");
  }, Xy = function(u, c) {
    return zt(u) ? av.percentageSize(c) : cv(u) ? av.pixelSize(c) : av.getTableSize(c);
  }, rm = function(u) {
    mo(u, "width");
  }, wS = function(u) {
    var c = ug(u);
    q1(u, N.some(c), N.none()), rm(u);
  }, Yk = function(u) {
    var c = _k(u);
    q1(u, N.some(c), N.none()), rm(u);
  }, Zk = function(u) {
    iu(u, "width");
    var c = kc(u), d = c.length > 0 ? c : Xf(u);
    Je(d, function(h) {
      iu(h, "width"), rm(h);
    }), rm(u);
  }, Sg = wS, xg = Yk, g0 = Zk, Yy = function(u) {
    var c = ra.fromTable(u);
    ra.hasColumns(c) || Je(Xf(u), function(d) {
      var h = Sc(d, "width");
      Xo(d, "width", h), mo(d, "width");
    });
  }, kg = function() {
    var u = Nt.fromTag("div");
    return Jc(u, {
      position: "static",
      height: "0",
      width: "0",
      padding: "0",
      margin: "0",
      border: "0"
    }), Vo(Dr(), u), u;
  }, Zy = function(u, c) {
    return u.inline ? eh.body(uf(u), kg(), c) : eh.only(Nt.fromDom(u.getDoc()), c);
  }, Zo = function(u, c) {
    u.inline && Ss(c.parent());
  }, fh = "bar-", ai = function(u) {
    return il(u, "data-mce-resize") !== "false";
  }, p0 = function(u) {
    var c = N.none(), d = N.none(), h = N.none(), S, B, L = function(Wt) {
      return Wt.nodeName === "TABLE";
    }, W = function() {
      return d;
    }, me = function() {
      return h.getOr(eh.only(Nt.fromDom(u.getBody()), ai));
    }, Re = function(Wt) {
      return Xy(u, Wt);
    }, rt = function() {
      return jy(u) ? qd() : U1();
    }, jt = function(Wt) {
      return Dy(Wt).columns;
    }, Sn = function(Wt, Pn, Ln) {
      var mr = ot(Pn, "e");
      if (B === "" && Sg(Wt), Ln !== S && B !== "") {
        Xo(Wt, "width", B);
        var Ea = rt(), dr = Re(Wt), Ur = jy(u) || mr ? jt(Wt) - 1 : 0;
        z1(Wt, Ln - S, Ur, Ea, dr);
      } else if (Wv(B)) {
        var ca = parseFloat(B.replace("%", "")), sa = Ln * ca / S;
        Xo(Wt, "width", sa + "%");
      }
      cg(B) && Yy(Wt);
    }, ln = function() {
      d.each(function(Wt) {
        Wt.destroy();
      }), h.each(function(Wt) {
        Zo(u, Wt);
      });
    };
    return u.on("init", function() {
      var Wt = Zy(u, ai);
      if (h = N.some(Wt), qy(u) && uh(u)) {
        var Pn = rt(), Ln = td.create(Wt, Pn, Re);
        Ln.on(), Ln.events.startDrag.bind(function(mr) {
          c = N.some(u.selection.getRng());
        }), Ln.events.beforeResize.bind(function(mr) {
          var Ea = mr.table.dom;
          l0(u, Ea, ov(Ea), iv(Ea), fh + mr.type);
        }), Ln.events.afterResize.bind(function(mr) {
          var Ea = mr.table, dr = Ea.dom;
          is(Ea), c.each(function(Ur) {
            u.selection.setRng(Ur), u.focus();
          }), yg(u, dr, ov(dr), iv(dr), fh + mr.type), u.undoManager.add();
        }), d = N.some(Ln);
      }
    }), u.on("ObjectResizeStart", function(Wt) {
      var Pn = Wt.target;
      if (L(Pn)) {
        var Ln = Nt.fromDom(Pn);
        Je(u.dom.select(".mce-clonedresizable"), function(mr) {
          u.dom.addClass(mr, "mce-" + d0(u) + "-columns");
        }), !vu(Ln) && cv(u) ? xg(Ln) : !G1(Ln) && zt(u) && Sg(Ln), K1(Ln) && Kr(Wt.origin, fh) && Sg(Ln), S = Wt.width, B = Cg(u) ? "" : sf(u, Pn).getOr("");
      }
    }), u.on("ObjectResized", function(Wt) {
      var Pn = Wt.target;
      if (L(Pn)) {
        var Ln = Nt.fromDom(Pn), mr = Wt.origin;
        Kr(mr, "corner-") && Sn(Ln, mr, Wt.width), is(Ln), df(u, Ln.dom, tm);
      }
    }), u.on("SwitchMode", function() {
      W().each(function(Wt) {
        u.mode.isReadOnly() ? Wt.hideBars() : Wt.showBars();
      });
    }), {
      lazyResize: W,
      lazyWire: me,
      destroy: ln
    };
  }, am = function(u, c) {
    return {
      element: u,
      offset: c
    };
  }, Jy = function(u, c, d) {
    return u.property().isText(c) && u.property().getText(c).trim().length === 0 || u.property().isComment(c) ? d(c).bind(function(h) {
      return Jy(u, h, d).orThunk(function() {
        return N.some(h);
      });
    }) : N.none();
  }, vh = function(u, c) {
    if (u.property().isText(c))
      return u.property().getText(c).length;
    var d = u.property().children(c);
    return d.length;
  }, Qy = function(u, c) {
    var d = Jy(u, c, u.query().prevSibling).getOr(c);
    if (u.property().isText(d))
      return am(d, vh(u, d));
    var h = u.property().children(d);
    return h.length > 0 ? Qy(u, h[h.length - 1]) : am(d, vh(u, d));
  }, CS = Qy, Jk = Hp(), SS = function(u) {
    return CS(Jk, u);
  }, Qk = function(u, c) {
    var d = _i(u, "colspan");
    if (d === 1) {
      var h = og(u);
      h.each(function(S) {
        var B = S.value / 2;
        ig(u, B, S.unit), ig(c, B, S.unit);
      });
    }
  }, h0 = wo("th"), dh = function(u) {
    return We(u, function(c) {
      return h0(c.element);
    });
  }, eT = function(u, c) {
    return u && c ? "sectionCells" : u ? "section" : "cells";
  }, xS = function(u) {
    var c = u.section === "thead", d = Cc(e2(u.cells), "th");
    return c || d ? {
      type: "header",
      subType: eT(c, d)
    } : u.section === "tfoot" ? { type: "footer" } : { type: "body" };
  }, e2 = function(u) {
    var c = Tt(u, function(d) {
      return h0(d.element);
    });
    return c.length === 0 ? N.some("td") : c.length === u.length ? N.some("th") : N.none();
  }, tT = function(u) {
    var c = Me(u, function(B) {
      return xS(B).type;
    }), d = Te(c, "header"), h = Te(c, "footer");
    if (!d && !h)
      return N.some("body");
    var S = Te(c, "body");
    return d && !S && !h ? N.some("header") : !d && !S && h ? N.some("footer") : N.none();
  }, nT = function(u) {
    return Xe(u.all, function(c) {
      var d = xS(c);
      return d.type === "header" ? N.from(d.subType) : N.none();
    });
  }, b0 = function(u, c, d) {
    return ti(d(u.element, c), !0, u.isLocked);
  }, t2 = function(u, c) {
    return u.section !== c ? zu(u.element, u.cells, c, u.isNew) : u;
  }, mu = function() {
    return {
      transformRow: t2,
      transformCell: function(u, c, d) {
        var h = d(u.element, c), S = va(h) !== "td" ? wk(h, "td") : h;
        return ti(S, u.isNew, u.isLocked);
      }
    };
  }, Tg = function() {
    return {
      transformRow: t2,
      transformCell: b0
    };
  }, Eg = function() {
    return {
      transformRow: function(u, c) {
        var d = c === "thead" ? "tbody" : c;
        return t2(u, d);
      },
      transformCell: b0
    };
  }, kS = function() {
    return {
      transformRow: ht,
      transformCell: b0
    };
  }, rT = function(u, c) {
    var d = ra.fromTable(u), h = nT(d).getOr(c);
    switch (h) {
      case "section":
        return mu();
      case "sectionCells":
        return Tg();
      case "cells":
        return Eg();
    }
  }, mh = {
    getTableSectionType: rT,
    section: mu,
    sectionCells: Tg,
    cells: Eg,
    fallback: kS
  }, gh = function(u, c, d, h) {
    d === h ? mo(u, c) : Ei(u, c, d);
  }, om = function(u, c, d) {
    St(Qr(u, c)).fold(function() {
      return su(u, d);
    }, function(h) {
      return oo(h, d);
    });
  }, y0 = function(u, c) {
    var d = Pr(u, c).getOrThunk(function() {
      var h = Nt.fromTag(c, Ls(u).dom);
      return c === "thead" ? om(u, "caption,colgroup", h) : c === "colgroup" ? om(u, "caption", h) : Vo(u, h), h;
    });
    return Lp(d), d;
  }, ph = function(u, c) {
    var d = [], h = [], S = function(ln) {
      return Me(ln, function(Wt) {
        Wt.isNew && d.push(Wt.element);
        var Pn = Wt.element;
        return Lp(Pn), Je(Wt.cells, function(Ln) {
          Ln.isNew && h.push(Ln.element), gh(Ln.element, "colspan", Ln.colspan, 1), gh(Ln.element, "rowspan", Ln.rowspan, 1), Vo(Pn, Ln.element);
        }), Pn;
      });
    }, B = function(ln) {
      return He(ln, function(Wt) {
        return Me(Wt.cells, function(Pn) {
          return gh(Pn.element, "span", Pn.colspan, 1), Pn.element;
        });
      });
    }, L = function(ln, Wt) {
      var Pn = y0(u, Wt), Ln = Wt === "colgroup" ? B : S, mr = Ln(ln);
      Tc(Pn, mr);
    }, W = function(ln) {
      Pr(u, ln).each(Ss);
    }, me = function(ln, Wt) {
      ln.length > 0 ? L(ln, Wt) : W(Wt);
    }, Re = [], rt = [], jt = [], Sn = [];
    return Je(c, function(ln) {
      switch (ln.section) {
        case "thead":
          Re.push(ln);
          break;
        case "tbody":
          rt.push(ln);
          break;
        case "tfoot":
          jt.push(ln);
          break;
        case "colgroup":
          Sn.push(ln);
          break;
      }
    }), me(Sn, "colgroup"), me(Re, "thead"), me(rt, "tbody"), me(jt, "tfoot"), {
      newRows: d,
      newCells: h
    };
  }, n2 = function(u) {
    return Me(u, function(c) {
      var d = Yl(c.element);
      return Je(c.cells, function(h) {
        var S = Ha(h.element);
        gh(S, "colspan", h.colspan, 1), gh(S, "rowspan", h.rowspan, 1), Vo(d, S);
      }), d;
    });
  }, aT = function(u, c) {
    return Me(u, function(d) {
      return rs(d, c);
    });
  }, gf = function(u, c) {
    return u[c];
  }, w0 = function(u, c) {
    if (u.length === 0)
      return 0;
    var d = u[0], h = Pe(u, function(S) {
      return !c(d.element, S.element);
    });
    return h.getOr(u.length);
  }, oT = function(u, c, d, h) {
    var S = gf(u, c), B = S.section === "colgroup", L = w0(S.cells.slice(d), h), W = B ? 1 : w0(aT(u.slice(c), d), h);
    return {
      colspan: L,
      rowspan: W
    };
  }, rd = function(u, c) {
    var d = Me(u, function(S) {
      return Me(S.cells, Ct);
    }), h = function(S, B, L, W) {
      for (var me = S; me < S + L; me++)
        for (var Re = B; Re < B + W; Re++)
          d[me][Re] = !0;
    };
    return Me(u, function(S, B) {
      var L = He(S.cells, function(W, me) {
        if (d[B][me] === !1) {
          var Re = oT(u, B, me, c);
          return h(B, me, Re.rowspan, Re.colspan), [Yr(W.element, Re.rowspan, Re.colspan, W.isNew)];
        } else
          return [];
      });
      return es(S.element, L, S.section, S.isNew);
    });
  }, ad = function(u, c, d) {
    var h = [];
    Je(u.colgroups, function(rt) {
      for (var jt = [], Sn = 0; Sn < u.grid.columns; Sn++) {
        var ln = ra.getColumnAt(u, Sn).map(function(Wt) {
          return ti(Wt.element, d, !1);
        }).getOrThunk(function() {
          return ti(c.colGap(), !0, !1);
        });
        jt.push(ln);
      }
      h.push(zu(rt.element, jt, "colgroup", d));
    });
    for (var S = 0; S < u.grid.rows; S++) {
      for (var B = [], L = 0; L < u.grid.columns; L++) {
        var W = ra.getAt(u, S, L).map(function(rt) {
          return ti(rt.element, d, rt.isLocked);
        }).getOrThunk(function() {
          return ti(c.gap(), !0, !1);
        });
        B.push(W);
      }
      var me = u.all[S], Re = zu(me.element, B, me.section, d);
      h.push(Re);
    }
    return h;
  }, iT = function(u, c) {
    return ad(u, c, !1);
  }, C0 = function(u) {
    return rd(u, Xr);
  }, S0 = function(u, c) {
    return Xe(u.all, function(d) {
      return _t(d.cells, function(h) {
        return Xr(c, h.element);
      });
    });
  }, x0 = function(u, c, d) {
    var h = Me(c.selection, function(B) {
      return xc(B).bind(function(L) {
        return S0(u, L);
      }).filter(d);
    }), S = hi(h);
    return eo(S.length > 0, S);
  }, Yi = function(u, c, d, h, S) {
    return function(B, L, W, me, Re) {
      var rt = ra.fromTable(L), jt = N.from(Re == null ? void 0 : Re.section).getOrThunk(mh.fallback), Sn = c(rt, W).map(function(ln) {
        var Wt = iT(rt, me), Pn = u(Wt, ln, Xr, S(me), jt), Ln = uu(Pn.grid), mr = C0(Pn.grid);
        return {
          info: ln,
          grid: mr,
          cursor: Pn.cursor,
          lockedColumns: Ln
        };
      });
      return Sn.bind(function(ln) {
        var Wt = ph(L, ln.grid), Pn = N.from(Re == null ? void 0 : Re.sizing).getOrThunk(function() {
          return av.getTableSize(L);
        }), Ln = N.from(Re == null ? void 0 : Re.resize).getOrThunk(qd);
        return d(L, ln.grid, ln.info, {
          sizing: Pn,
          resize: Ln,
          section: jt
        }), h(L), Vi(B, L), mo(L, si), ln.lockedColumns.length > 0 && Ei(L, si, ln.lockedColumns.join(",")), N.some({
          cursor: ln.cursor,
          newRows: Wt.newRows,
          newCells: Wt.newCells
        });
      });
    };
  }, TS = function(u, c) {
    return xc(c.element).bind(function(d) {
      return S0(u, d).map(function(h) {
        var S = he(he({}, h), {
          generators: c.generators,
          clipboard: c.clipboard
        });
        return S;
      });
    });
  }, r2 = function(u, c) {
    return x0(u, c, Be).map(function(d) {
      return {
        cells: d,
        generators: c.generators,
        clipboard: c.clipboard
      };
    });
  }, ES = function(u, c) {
    return c.mergable;
  }, _S = function(u, c) {
    return c.unmergable;
  }, Nc = function(u, c) {
    return x0(u, c, Be);
  }, fv = function(u, c) {
    return x0(u, c, function(d) {
      return !d.isLocked;
    });
  }, AS = function(u, c) {
    return S0(u, c).exists(function(d) {
      return !d.isLocked;
    });
  }, OS = function(u, c) {
    return We(c, function(d) {
      return AS(u, d);
    });
  }, a2 = function(u, c) {
    return ES(u, c).filter(function(d) {
      return OS(u, d.cells);
    });
  }, k0 = function(u, c) {
    return _S(u, c).filter(function(d) {
      return OS(u, d);
    });
  }, DS = function(u, c, d, h) {
    var S = ni(u).rows;
    if (S.length === 0)
      return u;
    for (var B = c.startRow; B <= c.finishRow; B++)
      for (var L = c.startCol; L <= c.finishCol; L++) {
        var W = S[B], me = rs(W, L).isLocked;
        Qc(W, L, ti(h(), !1, me));
      }
    return u;
  }, _g = function(u, c, d, h) {
    for (var S = ni(u).rows, B = !0, L = 0; L < S.length; L++)
      for (var W = 0; W < sl(S[0]); W++) {
        var me = S[L], Re = rs(me, W), rt = Re.element, jt = d(rt, c);
        jt === !0 && B === !1 ? Qc(me, W, ti(h(), !0, Re.isLocked)) : jt === !0 && (B = !1);
      }
    return u;
  }, uT = function(u, c) {
    return se(u, function(d, h) {
      return _(d, function(S) {
        return c(S.element, h.element);
      }) ? d : d.concat([h]);
    }, []);
  }, hh = function(u, c, d, h) {
    return c > 0 && c < u[0].cells.length && Je(u, function(S) {
      var B = S.cells[c - 1], L = S.cells[c], W = d(L.element, B.element);
      W && Qc(S, c, ti(h(), !0, L.isLocked));
    }), u;
  }, sT = function(u, c, d, h) {
    var S = ni(u).rows;
    if (c > 0 && c < S.length) {
      var B = S[c - 1].cells, L = uT(B, d);
      Je(L, function(W) {
        for (var me = N.none(), Re = c; Re < S.length; Re++)
          for (var rt = function(Sn) {
            var ln = S[Re], Wt = rs(ln, Sn), Pn = d(Wt.element, W.element);
            Pn && (me.isNone() && (me = N.some(h())), me.each(function(Ln) {
              Qc(ln, Sn, ti(Ln, !0, Wt.isLocked));
            }));
          }, jt = 0; jt < sl(S[0]); jt++)
            rt(jt);
      });
    }
    return u;
  }, Ag = function(u) {
    var c = function(jt) {
      return Ag(u);
    }, d = function(jt) {
      return Ag(u);
    }, h = function(jt) {
      return Ag(jt(u));
    }, S = function(jt) {
      return Ag(u);
    }, B = function(jt) {
      jt(u);
    }, L = function(jt) {
      return jt(u);
    }, W = function(jt, Sn) {
      return Sn(u);
    }, me = function(jt) {
      return jt(u);
    }, Re = function(jt) {
      return jt(u);
    }, rt = function() {
      return N.some(u);
    };
    return {
      isValue: Be,
      isError: Ct,
      getOr: ze(u),
      getOrThunk: ze(u),
      getOrDie: ze(u),
      or: c,
      orThunk: d,
      fold: W,
      map: h,
      mapError: S,
      each: B,
      bind: L,
      exists: me,
      forall: Re,
      toOptional: rt
    };
  }, im = function(u) {
    var c = function(Re) {
      return Re();
    }, d = function() {
      return Pt(String(u))();
    }, h = ht, S = function(Re) {
      return Re();
    }, B = function(Re) {
      return im(u);
    }, L = function(Re) {
      return im(Re(u));
    }, W = function(Re) {
      return im(u);
    }, me = function(Re, rt) {
      return Re(u);
    };
    return {
      isValue: Ct,
      isError: Be,
      getOr: ht,
      getOrThunk: c,
      getOrDie: d,
      or: h,
      orThunk: S,
      fold: me,
      map: B,
      mapError: L,
      each: ue,
      bind: W,
      exists: Ct,
      forall: Be,
      toOptional: N.none
    };
  }, o2 = function(u, c) {
    return u.fold(function() {
      return im(c);
    }, Ag);
  }, BS = {
    value: Ag,
    error: im,
    fromOption: o2
  }, lT = function(u, c, d) {
    if (u.row >= c.length || u.column > sl(c[0]))
      return BS.error("invalid start address out of table bounds, row: " + u.row + ", column: " + u.column);
    var h = c.slice(u.row), S = h[0].cells.slice(u.column), B = sl(d[0]), L = d.length;
    return BS.value({
      rowDelta: h.length - L,
      colDelta: S.length - B
    });
  }, RS = function(u, c) {
    var d = sl(u[0]), h = sl(c[0]);
    return {
      rowDelta: 0,
      colDelta: d - h
    };
  }, MS = function(u, c) {
    var d = u.length, h = c.length;
    return {
      rowDelta: d - h,
      colDelta: 0
    };
  }, i2 = function(u, c, d, h) {
    var S = c.section === "colgroup" ? d.col : d.cell;
    return je(u, function(B) {
      return ti(S(), !0, h(B));
    });
  }, cT = function(u, c, d, h) {
    var S = u[u.length - 1];
    return u.concat(je(c, function() {
      var B = S.section === "colgroup" ? d.colgroup : d.row, L = Ai(S, B, ht), W = i2(L.cells.length, L, d, function(me) {
        return ve(h, me.toString());
      });
      return $r(L, W);
    }));
  }, T0 = function(u, c, d, h) {
    return Me(u, function(S) {
      var B = i2(c, S, d, Ct);
      return Yf(S, h, B);
    });
  }, fT = function(u, c, d) {
    return Me(u, function(h) {
      return se(d, function(S, B) {
        var L = i2(1, h, c, Be)[0];
        return Zf(S, B, L);
      }, h);
    });
  }, bh = function(u, c, d) {
    var h = c.colDelta < 0 ? T0 : ht, S = c.rowDelta < 0 ? cT : ht, B = uu(u), L = sl(u[0]), W = _(B, function(rt) {
      return rt === L - 1;
    }), me = h(u, Math.abs(c.colDelta), d, W ? L - 1 : L), Re = uu(me);
    return S(me, Math.abs(c.rowDelta), d, Ke(Re, Be));
  }, vT = function(u, c, d, h) {
    var S = rs(u[c], d), B = Ze(h, S.element), L = u[c];
    return u.length > 1 && sl(L) > 1 && (d > 0 && B(Du(L, d - 1)) || d < L.cells.length - 1 && B(Du(L, d + 1)) || c > 0 && B(Du(u[c - 1], d)) || c < u.length - 1 && B(Du(u[c + 1], d)));
  }, dT = function(u, c, d, h, S, B) {
    for (var L = u.row, W = u.column, me = d.length, Re = sl(d[0]), rt = L + me, jt = W + Re + B.length, Sn = Ke(B, Be), ln = L; ln < rt; ln++)
      for (var Wt = 0, Pn = W; Pn < jt; Pn++) {
        if (Sn[Pn]) {
          Wt++;
          continue;
        }
        vT(c, ln, Pn, S) && _g(c, Du(c[ln], Pn), S, h.cell);
        var Ln = Pn - W - Wt, mr = rs(d[ln - L], Ln), Ea = mr.element, dr = h.replace(Ea);
        Qc(c[ln], Pn, ti(dr, !0, mr.isLocked));
      }
    return c;
  }, mT = function(u, c, d) {
    var h = sl(c[0]), S = ni(c).cols.length + u.row, B = je(h - u.column, function(W) {
      return W + u.column;
    }), L = _t(B, function(W) {
      return We(d, function(me) {
        return me !== W;
      });
    }).getOr(h - 1);
    return {
      row: S,
      column: L
    };
  }, E0 = function(u, c, d) {
    return Tt(d, function(h) {
      return h >= u.column && h <= sl(c[0]) + u.column;
    });
  }, gT = function(u, c, d, h, S) {
    var B = uu(c), L = mT(u, c, B), W = ni(d).rows, me = E0(L, W, B), Re = lT(L, c, W);
    return Re.map(function(rt) {
      var jt = he(he({}, rt), { colDelta: rt.colDelta - me.length }), Sn = bh(c, jt, h), ln = uu(Sn), Wt = E0(L, W, ln);
      return dT(L, Sn, W, h, S, Wt);
    });
  }, Og = function(u, c, d, h, S) {
    hh(c, u, S, h.cell);
    var B = MS(d, c), L = bh(d, B, h), W = MS(c, L), me = bh(c, W, h);
    return Me(me, function(Re, rt) {
      return Yf(Re, u, L[rt].cells);
    });
  }, PS = function(u, c, d, h, S) {
    sT(c, u, S, h.cell);
    var B = uu(c), L = RS(c, d), W = he(he({}, L), { colDelta: L.colDelta - B.length }), me = bh(c, W, h), Re = ni(me), rt = Re.cols, jt = Re.rows, Sn = uu(me), ln = RS(d, c), Wt = he(he({}, ln), { colDelta: ln.colDelta + Sn.length }), Pn = fT(d, h, Sn), Ln = bh(Pn, Wt, h);
    return rt.concat(jt.slice(0, u)).concat(Ln).concat(jt.slice(u, jt.length));
  }, pT = function(u, c, d, h) {
    return Ai(u, function(S) {
      return h(S, d);
    }, c);
  }, u2 = function(u, c, d, h, S) {
    var B = ni(u), L = B.rows, W = B.cols, me = L.slice(0, c), Re = L.slice(c), rt = pT(L[d], function(jt, Sn) {
      var ln = c > 0 && c < L.length && h(Du(L[c - 1], Sn), Du(L[c], Sn)), Wt = ln ? rs(L[c], Sn) : ti(S(jt.element, h), !0, jt.isLocked);
      return Wt;
    }, h, S);
    return W.concat(me).concat([rt]).concat(Re);
  }, NS = function(u, c, d, h, S, B, L) {
    if (d === "colgroup" || !h) {
      var W = rs(u, S);
      return ti(L(W.element, B), !0, !1);
    } else
      return rs(u, c);
  }, s2 = function(u, c, d, h, S) {
    return Me(u, function(B) {
      var L = c > 0 && c < sl(B) && h(Du(B, c - 1), Du(B, c)), W = NS(B, c, B.section, L, d, h, S);
      return Zf(B, c, W);
    });
  }, IS = function(u, c) {
    return He(u, function(d) {
      var h = d.cells, S = Jt(c, function(B, L) {
        return L >= 0 && L < B.length ? B.slice(0, L).concat(B.slice(L + 1)) : B;
      }, h);
      return S.length > 0 ? [zu(d.element, S, d.section, d.isNew)] : [];
    });
  }, FS = function(u, c, d) {
    var h = ni(u), S = h.rows, B = h.cols;
    return B.concat(S.slice(0, c)).concat(S.slice(d + 1));
  }, Dg = function(u, c, d, h) {
    return Du(u[c], d) !== void 0 && c > 0 && h(Du(u[c - 1], d), Du(u[c], d));
  }, l2 = function(u, c, d) {
    return c > 0 && d(Du(u, c - 1), Du(u, c));
  }, c2 = function(u, c, d, h) {
    return Dg(u, c, d, h) || l2(u[c], d, h);
  }, hT = function(u, c) {
    var d = We(c, ht) && dh(u.cells);
    return d ? Be : function(h, S, B) {
      var L = va(h.element);
      return !(L === "th" && c[B]);
    };
  }, bT = function(u, c) {
    var d = We(c, ht) && dh(u);
    return d ? Be : function(h, S, B) {
      var L = va(h.element);
      return !(L === "th" && c[S]);
    };
  }, f2 = function(u, c, d, h) {
    var S = function(W) {
      return W === "row" ? S1(c) : Pd(c);
    }, B = function(W) {
      return S(W) ? W + "group" : W;
    };
    if (u)
      return h0(c) ? B(d) : null;
    if (h && h0(c)) {
      var L = d === "row" ? "col" : "row";
      return B(L);
    } else
      return null;
  }, yT = function(u, c) {
    return function(d, h, S) {
      return N.some(f2(u, d.element, "col", c[S]));
    };
  }, $S = function(u, c) {
    return function(d, h) {
      return N.some(f2(u, d.element, "row", c[h]));
    };
  }, od = function(u, c, d) {
    return ti(d(u.element, c), !0, u.isLocked);
  }, Bg = function(u, c, d, h, S, B, L) {
    var W = function(me) {
      return _(c, function(Re) {
        return d(me.element, Re.element);
      });
    };
    return Me(u, function(me, Re) {
      return ul(me, function(rt, jt) {
        if (W(rt)) {
          var Sn = L(rt, Re, jt) ? S(rt, d, h) : rt;
          return B(Sn, Re, jt).each(function(ln) {
            Uf(Sn.element, { scope: N.from(ln) });
          }), Sn;
        } else
          return rt;
      });
    });
  }, LS = function(u, c, d) {
    return He(u, function(h, S) {
      return c2(u, S, c, d) ? [] : [rs(h, c)];
    });
  }, wT = function(u, c, d) {
    var h = u[c];
    return He(h.cells, function(S, B) {
      return c2(u, c, B, d) ? [] : [S];
    });
  }, zS = function(u, c, d, h, S) {
    var B = ni(u).rows, L = He(c, function(rt) {
      return LS(B, rt, h);
    }), W = Me(u, function(rt) {
      return dh(rt.cells);
    }), me = bT(L, W), Re = $S(d, W);
    return Bg(u, L, h, S, od, Re, me);
  }, CT = function(u, c, d, h, S, B, L) {
    var W = ni(u), me = W.cols, Re = W.rows, rt = Re[c[0]], jt = He(c, function(mr) {
      return wT(Re, mr, S);
    }), Sn = Me(rt.cells, function(mr, Ea) {
      return dh(LS(Re, Ea, S));
    }), ln = tt([], Re, !0);
    Je(c, function(mr) {
      ln[mr] = L.transformRow(Re[mr], d);
    });
    var Wt = me.concat(ln), Pn = hT(rt, Sn), Ln = yT(h, Sn);
    return Bg(Wt, jt, S, B, L.transformCell, Ln, Pn);
  }, v2 = function(u, c, d, h) {
    var S = ni(u).rows, B = Me(c, function(L) {
      return rs(S[L.row], L.column);
    });
    return Bg(u, B, d, h, od, N.none, Be);
  }, Rg = function(u) {
    var c = function(d, h) {
      var S = _(d, function(B) {
        return B.column === h.column;
      });
      return S ? d : d.concat([h]);
    };
    return se(u, c, []).sort(function(d, h) {
      return d.column - h.column;
    });
  }, qu = wo("col"), d2 = wo("colgroup"), Mg = function(u) {
    return va(u) === "tr" || d2(u);
  }, um = function(u) {
    var c = _l(u, "colspan", 1), d = _l(u, "rowspan", 1);
    return {
      element: u,
      colspan: c,
      rowspan: d
    };
  }, _0 = function(u, c) {
    c === void 0 && (c = um);
    var d = function(W) {
      return qu(W.element) ? u.col(W) : u.cell(W);
    }, h = function(W) {
      return d2(W.element) ? u.colgroup(W) : u.row(W);
    }, S = function(W) {
      if (Mg(W))
        return h({ element: W });
      var me = d(c(W));
      return B = N.some({
        item: W,
        replacement: me
      }), me;
    }, B = N.none(), L = function(W, me) {
      return B.fold(function() {
        return S(W);
      }, function(Re) {
        return me(W, Re.item) ? Re.replacement : S(W);
      });
    };
    return { getOrInit: L };
  }, ST = function(u) {
    return function(c) {
      var d = [], h = function(L, W) {
        return _t(d, function(me) {
          return W(me.item, L);
        });
      }, S = function(L) {
        var W = u === "td" ? { scope: null } : {}, me = c.replace(L, u, W);
        return d.push({
          item: L,
          sub: me
        }), me;
      }, B = function(L, W) {
        return Mg(L) || qu(L) ? L : h(L, W).fold(function() {
          return S(L);
        }, function(me) {
          return W(L, me.item) ? me.sub : S(L);
        });
      };
      return { replaceOrInit: B };
    };
  }, HS = function(u) {
    return Da(u, "scope").map(function(c) {
      return c.substr(0, 3);
    });
  }, m2 = function(u) {
    var c = function(h) {
      var S = HS(h);
      return S.each(function(B) {
        return Ei(h, "scope", B);
      }), function() {
        var B = u.cell({
          element: h,
          colspan: 1,
          rowspan: 1
        });
        return iu(B, "width"), iu(h, "width"), S.each(function(L) {
          return Ei(B, "scope", L);
        }), B;
      };
    }, d = function(h) {
      var S = function() {
        var B = hi(Me(h, HS));
        if (B.length === 0)
          return N.none();
        var L = B[0], W = [
          "row",
          "col"
        ], me = _(B, function(Re) {
          return Re !== L && Te(W, Re);
        });
        return me ? N.none() : N.from(L);
      };
      return iu(h[0], "width"), S().fold(function() {
        return mo(h[0], "scope");
      }, function(B) {
        return Ei(h[0], "scope", B + "group");
      }), ze(h[0]);
    };
    return {
      unmerge: c,
      merge: d
    };
  }, _s = {
    modification: _0,
    transform: ST,
    merging: m2
  }, yh = [
    "body",
    "p",
    "div",
    "article",
    "aside",
    "figcaption",
    "figure",
    "footer",
    "header",
    "nav",
    "section",
    "ol",
    "ul",
    "table",
    "thead",
    "tfoot",
    "tbody",
    "caption",
    "tr",
    "td",
    "th",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "blockquote",
    "pre",
    "address"
  ], xT = function(u, c) {
    var d = u.property().name(c);
    return Te([
      "ol",
      "ul"
    ], d);
  }, sm = function(u, c) {
    var d = u.property().name(c);
    return Te(yh, d);
  }, id = function(u, c) {
    return Te([
      "br",
      "img",
      "hr",
      "input"
    ], u.property().name(c));
  }, Pg = Hp(), ud = function(u) {
    return sm(Pg, u);
  }, Ic = function(u) {
    return xT(Pg, u);
  }, Fc = function(u) {
    return id(Pg, u);
  }, A0 = function(u) {
    var c = function(me) {
      return va(me) === "br";
    }, d = function(me) {
      return We(me, function(Re) {
        return c(Re) || ou(Re) && k1(Re).trim().length === 0;
      });
    }, h = function(me) {
      return va(me) === "li" || No(me, Ic).isSome();
    }, S = function(me) {
      return O(me).map(function(Re) {
        return ud(Re) ? !0 : Fc(Re) ? va(Re) !== "img" : !1;
      }).getOr(!1);
    }, B = function(me) {
      return I1(me).bind(function(Re) {
        var rt = S(Re);
        return Co(Re).map(function(jt) {
          return rt === !0 || h(jt) || c(Re) || ud(jt) && !Xr(me, jt) ? [] : [Nt.fromTag("br")];
        });
      }).getOr([]);
    }, L = function() {
      var me = He(u, function(Re) {
        var rt = x(Re);
        return d(rt) ? [] : rt.concat(B(Re));
      });
      return me.length === 0 ? [Nt.fromTag("br")] : me;
    }, W = L();
    Lp(u[0]), Tc(u[0], W);
  }, O0 = function(u) {
    return rh(u, !0);
  }, g2 = function(u) {
    var c = Xf(u);
    c.length === 0 && Ss(u);
  }, Ng = function(u, c) {
    return {
      grid: u,
      cursor: c
    };
  }, Ig = function(u) {
    return Xe(u, function(c) {
      return Xe(c.cells, function(d) {
        var h = d.element;
        return eo(O0(h), h);
      });
    });
  }, Fg = function(u, c, d) {
    var h, S, B = ni(u).rows;
    return N.from((S = (h = B[c]) === null || h === void 0 ? void 0 : h.cells[d]) === null || S === void 0 ? void 0 : S.element).filter(O0).orThunk(function() {
      return Ig(B);
    });
  }, Iu = function(u, c, d) {
    var h = Fg(u, c, d);
    return Ng(u, h);
  }, $g = function(u) {
    var c = function(d, h) {
      var S = _(d, function(B) {
        return B.row === h.row;
      });
      return S ? d : d.concat([h]);
    };
    return se(u, c, []).sort(function(d, h) {
      return d.row - h.row;
    });
  }, Lg = function(u, c, d, h) {
    var S = c[0].row, B = $g(c), L = Jt(B, function(W, me) {
      var Re = u2(W.grid, S, me.row + W.delta, d, h.getOrInit);
      return {
        grid: Re,
        delta: W.delta + 1
      };
    }, {
      grid: u,
      delta: 0
    }).grid;
    return Iu(L, S, c[0].column);
  }, D0 = function(u, c, d, h) {
    var S = $g(c), B = S[S.length - 1], L = B.row + B.rowspan, W = Jt(S, function(me, Re) {
      return u2(me, L, Re.row, d, h.getOrInit);
    }, u);
    return Iu(W, L, c[0].column);
  }, kT = function(u, c, d, h) {
    var S = c.details, B = Rg(S), L = B[0].column, W = Jt(B, function(me, Re) {
      var rt = s2(me.grid, L, Re.column + me.delta, d, h.getOrInit);
      return {
        grid: rt,
        delta: me.delta + 1
      };
    }, {
      grid: u,
      delta: 0
    }).grid;
    return Iu(W, S[0].row, L);
  }, p2 = function(u, c, d, h) {
    var S = c.details, B = S[S.length - 1], L = B.column + B.colspan, W = Rg(S), me = Jt(W, function(Re, rt) {
      return s2(Re, L, rt.column, d, h.getOrInit);
    }, u);
    return Iu(me, S[0].row, L);
  }, B0 = function(u, c, d, h) {
    var S = Rg(c), B = Me(S, function(W) {
      return W.column;
    }), L = zS(u, B, !0, d, h.replaceOrInit);
    return Iu(L, c[0].row, c[0].column);
  }, gu = function(u, c, d, h) {
    var S = v2(u, c, d, h.replaceOrInit);
    return Iu(S, c[0].row, c[0].column);
  }, TT = function(u, c, d, h) {
    var S = Rg(c), B = Me(S, function(W) {
      return W.column;
    }), L = zS(u, B, !1, d, h.replaceOrInit);
    return Iu(L, c[0].row, c[0].column);
  }, pf = function(u, c, d, h) {
    var S = v2(u, c, d, h.replaceOrInit);
    return Iu(S, c[0].row, c[0].column);
  }, R0 = function(u, c) {
    return function(d, h, S, B, L) {
      var W = $g(h), me = Me(W, function(rt) {
        return rt.row;
      }), Re = CT(d, me, u, c, S, B.replaceOrInit, L);
      return Iu(Re, h[0].row, h[0].column);
    };
  }, h2 = R0("thead", !0), zg = R0("tbody", !1), b2 = R0("tfoot", !1), wh = function(u, c, d, h) {
    var S = Rg(c.details), B = IS(u, Me(S, function(W) {
      return W.column;
    })), L = B.length > 0 ? B[0].cells.length - 1 : 0;
    return Iu(B, S[0].row, Math.min(S[0].column, L));
  }, ET = function(u, c, d, h) {
    var S = $g(c), B = FS(u, S[0].row, S[S.length - 1].row), L = B.length > 0 ? B.length - 1 : 0;
    return Iu(B, Math.min(c[0].row, L), c[0].column);
  }, VS = function(u, c, d, h) {
    var S = c.cells;
    A0(S);
    var B = DS(u, c.bounds, d, h.merge(S));
    return Ng(B, N.from(S[0]));
  }, US = function(u, c, d, h) {
    var S = function(L, W) {
      return _g(L, W, d, h.unmerge(W));
    }, B = Jt(c, S, u);
    return Ng(B, N.from(c[0]));
  }, _T = function(u, c, d, h) {
    var S = function(me, Re) {
      var rt = ra.fromTable(me);
      return ad(rt, Re, !0);
    }, B = S(c.clipboard, c.generators), L = ya(c.row, c.column), W = gT(L, u, B, c.generators, d);
    return W.fold(function() {
      return Ng(u, N.some(c.element));
    }, function(me) {
      return Iu(me, c.row, c.column);
    });
  }, Hg = function(u, c, d) {
    var h = Fp(u, d.section), S = ra.generate(h);
    return ad(S, c, !0);
  }, Jo = function(u, c, d, h) {
    var S = ni(u).rows, B = c.cells[0].column, L = S[c.cells[0].row], W = Hg(c.clipboard, c.generators, L), me = Og(B, u, W, c.generators, d);
    return Iu(me, c.cells[0].row, c.cells[0].column);
  }, M0 = function(u, c, d, h) {
    var S = ni(u).rows, B = c.cells[c.cells.length - 1].column + c.cells[c.cells.length - 1].colspan, L = S[c.cells[0].row], W = Hg(c.clipboard, c.generators, L), me = Og(B, u, W, c.generators, d);
    return Iu(me, c.cells[0].row, c.cells[0].column);
  }, P0 = function(u, c, d, h) {
    var S = ni(u).rows, B = c.cells[0].row, L = S[B], W = Hg(c.clipboard, c.generators, L), me = PS(B, u, W, c.generators, d);
    return Iu(me, c.cells[0].row, c.cells[0].column);
  }, y2 = function(u, c, d, h) {
    var S = ni(u).rows, B = c.cells[c.cells.length - 1].row + c.cells[c.cells.length - 1].rowspan, L = S[c.cells[0].row], W = Hg(c.clipboard, c.generators, L), me = PS(B, u, W, c.generators, d);
    return Iu(me, c.cells[0].row, c.cells[0].column);
  }, jS = function(u, c) {
    var d = ra.fromTable(u), h = Nc(d, c);
    return h.bind(function(S) {
      var B = S[S.length - 1], L = S[0].column, W = B.column + B.colspan, me = kt(Me(d.all, function(Re) {
        return Tt(Re.cells, function(rt) {
          return rt.column >= L && rt.column < W;
        });
      }));
      return e2(me);
    }).getOr("");
  }, w2 = function(u, c) {
    var d = ra.fromTable(u), h = Nc(d, c);
    return h.bind(e2).getOr("");
  }, lm = function(u, c) {
    var d = ra.fromTable(u), h = Nc(d, c);
    return h.bind(function(S) {
      var B = S[S.length - 1], L = S[0].row, W = B.row + B.rowspan, me = d.all.slice(L, W);
      return tT(me);
    }).getOr("");
  }, N0 = function(u, c, d, h) {
    return Bc(u, c, d, h.sizing);
  }, As = function(u, c, d, h) {
    return iS(u, c, d, h.sizing, h.resize);
  }, $c = function(u, c) {
    return _(c, function(d) {
      return d.column === 0 && d.isLocked;
    });
  }, I0 = function(u, c) {
    return _(c, function(d) {
      return d.column + d.colspan >= u.grid.columns && d.isLocked;
    });
  }, vv = function(u, c) {
    var d = Fd(u), h = Rg(c);
    return se(h, function(S, B) {
      var L = d[B.column], W = L.map(Ru).getOr(0);
      return S + W;
    }, 0);
  }, ac = function(u) {
    return function(c, d) {
      return Nc(c, d).filter(function(h) {
        var S = u ? $c : I0;
        return !S(c, h);
      }).map(function(h) {
        return {
          details: h,
          pixelDelta: vv(c, h)
        };
      });
    };
  }, Lc = function(u, c) {
    return fv(u, c).map(function(d) {
      return {
        details: d,
        pixelDelta: -vv(u, d)
      };
    });
  }, Gu = function(u) {
    return function(c, d) {
      return r2(c, d).filter(function(h) {
        var S = u ? $c : I0;
        return !S(c, h.cells);
      });
    };
  }, Ml = _s.transform("th"), Vg = _s.transform("td"), hf = Yi(Lg, Nc, ue, ue, _s.modification), cm = Yi(D0, Nc, ue, ue, _s.modification), WS = Yi(kT, ac(!0), As, ue, _s.modification), qS = Yi(p2, ac(!1), As, ue, _s.modification), AT = Yi(wh, Lc, As, g2, _s.modification), OT = Yi(ET, Nc, ue, g2, _s.modification), GS = Yi(B0, fv, ue, ue, Ml), KS = Yi(TT, fv, ue, ue, Vg), XS = Yi(h2, fv, ue, ue, Ml), DT = Yi(zg, fv, ue, ue, Vg), YS = Yi(b2, fv, ue, ue, Vg), BT = Yi(gu, fv, ue, ue, Ml), ZS = Yi(pf, fv, ue, ue, Vg), JS = Yi(VS, a2, N0, ue, _s.merging), C2 = Yi(US, k0, N0, ue, _s.merging), QS = Yi(_T, TS, N0, ue, _s.modification), RT = Yi(Jo, Gu(!0), ue, ue, _s.modification), ga = Yi(M0, Gu(!1), ue, ue, _s.modification), fm = Yi(P0, r2, ue, ue, _s.modification), Ug = Yi(y2, r2, ue, ue, _s.modification), S2 = jS, MT = w2, Os = lm, PT = function(u, c, d) {
    var h = function(eu) {
      return va(uf(eu)) === "table";
    }, S = function(eu) {
      return h(u) === !1 || Dy(eu).rows > 1;
    }, B = function(eu) {
      return h(u) === !1 || Dy(eu).columns > 1;
    }, L = m0(u), W = Wy(u) ? ue : Qk, me = function(eu) {
      switch (rc(u)) {
        case "section":
          return mh.section();
        case "sectionCells":
          return mh.sectionCells();
        case "cells":
          return mh.cells();
        default:
          return mh.getTableSectionType(eu, "section");
      }
    }, Re = function(eu, Vh) {
      return Vh.cursor.fold(function() {
        var yv = Xf(eu);
        return Ie(yv).filter(Vr).map(function(Hc) {
          c.clear(eu);
          var Sl = u.dom.createRng();
          return Sl.selectNode(Hc.dom), u.selection.setRng(Sl), Ei(Hc, "data-mce-selected", "1"), Sl;
        });
      }, function(yv) {
        var Hc = SS(yv), Sl = u.dom.createRng();
        return Sl.setStart(Hc.element.dom, Hc.offset), Sl.setEnd(Hc.element.dom, Hc.offset), u.selection.setRng(Sl), c.clear(eu), N.some(Sl);
      });
    }, rt = function(eu, Vh, yv, Hc, Sl) {
      return function(_f, xb, cp) {
        cp === void 0 && (cp = !1), is(_f);
        var fp = Hc(), vp = Nt.fromDom(u.getDoc()), Vc = Zr(yv, vp, L), dp = {
          sizing: Xy(u, _f),
          resize: Wy(u) ? U1() : qd(),
          section: me(_f)
        };
        return Vh(_f) ? eu(fp, _f, xb, Vc, dp).bind(function(mp) {
          Je(mp.newRows, function(gp) {
            u0(u, gp.dom);
          }), Je(mp.newCells, function(gp) {
            s0(u, gp.dom);
          });
          var Tw = Re(_f, mp);
          return Vr(_f) && (is(_f), cp || df(u, _f.dom, Sl)), Tw.map(function(gp) {
            return {
              rng: gp,
              effect: Sl
            };
          });
        }) : N.none();
      };
    }, jt = rt(OT, S, ue, d, Bo), Sn = rt(AT, B, ue, d, Bo), ln = rt(hf, Be, ue, d, Bo), Wt = rt(cm, Be, ue, d, Bo), Pn = rt(WS, Be, W, d, Bo), Ln = rt(qS, Be, W, d, Bo), mr = rt(JS, Be, ue, d, Bo), Ea = rt(C2, Be, ue, d, Bo), dr = rt(RT, Be, ue, d, Bo), Ur = rt(ga, Be, ue, d, Bo), ca = rt(fm, Be, ue, d, Bo), sa = rt(Ug, Be, ue, d, Bo), oi = rt(QS, Be, ue, d, Wk), Ji = rt(BT, Be, ue, d, Bo), Qi = rt(ZS, Be, ue, d, Bo), Ca = rt(GS, Be, ue, d, Bo), Gr = rt(KS, Be, ue, d, Bo), ma = rt(XS, Be, ue, d, Bo), Ga = rt(DT, Be, ue, d, Bo), jo = rt(YS, Be, ue, d, Bo), bv = MT, Ua = S2, Zs = Os;
    return {
      deleteRow: jt,
      deleteColumn: Sn,
      insertRowsBefore: ln,
      insertRowsAfter: Wt,
      insertColumnsBefore: Pn,
      insertColumnsAfter: Ln,
      mergeCells: mr,
      unmergeCells: Ea,
      pasteColsBefore: dr,
      pasteColsAfter: Ur,
      pasteRowsBefore: ca,
      pasteRowsAfter: sa,
      pasteCells: oi,
      makeCellsHeader: Ji,
      unmakeCellsHeader: Qi,
      makeColumnsHeader: Ca,
      unmakeColumnsHeader: Gr,
      makeRowsHeader: ma,
      makeRowsBody: Ga,
      makeRowsFooter: jo,
      getTableRowType: Zs,
      getTableCellType: bv,
      getTableColType: Ua
    };
  }, vm = {
    styles: {
      "border-collapse": "collapse",
      width: "100%"
    },
    attributes: { border: "1" },
    colGroups: !1
  }, sd = function() {
    return Nt.fromTag("th");
  }, F0 = function() {
    return Nt.fromTag("td");
  }, $0 = function() {
    return Nt.fromTag("col");
  }, NT = function(u, c, d, h) {
    for (var S = Nt.fromTag("tr"), B = 0; B < u; B++) {
      var L = h < c || B < d ? sd() : F0();
      B < d && Ei(L, "scope", "row"), h < c && Ei(L, "scope", "col"), Vo(L, Nt.fromTag("br")), Vo(S, L);
    }
    return S;
  }, ex = function(u) {
    var c = Nt.fromTag("colgroup");
    return je(u, function() {
      return Vo(c, $0());
    }), c;
  }, L0 = function(u, c, d, h) {
    return je(u, function(S) {
      return NT(c, d, h, S);
    });
  }, x2 = function(u, c, d, h, S, B) {
    B === void 0 && (B = vm);
    var L = Nt.fromTag("table"), W = S !== "cells";
    Jc(L, B.styles), ui(L, B.attributes), B.colGroups && Vo(L, ex(c));
    var me = Math.min(u, d);
    if (W && d > 0) {
      var Re = Nt.fromTag("thead");
      Vo(L, Re);
      var rt = S === "sectionCells" ? me : 0, jt = L0(d, c, rt, h);
      Tc(Re, jt);
    }
    var Sn = Nt.fromTag("tbody");
    Vo(L, Sn);
    var ln = W ? u - me : u, Wt = W ? 0 : d, Pn = L0(ln, c, Wt, h);
    return Tc(Sn, Pn), L;
  }, jg = function(u) {
    return u.dom.innerHTML;
  }, z0 = function(u) {
    var c = Nt.fromTag("div"), d = Nt.fromDom(u.dom.cloneNode(!0));
    return Vo(c, d), jg(c);
  }, IT = function(u, c) {
    u.selection.select(c.dom, !0), u.selection.collapse(!0);
  }, bf = function(u, c) {
    Hs(c, "td,th").each(Ze(IT, u));
  }, k2 = function(u, c) {
    Je(zs(c, "tr"), function(d) {
      u0(u, d.dom), Je(zs(d, "th,td"), function(h) {
        s0(u, h.dom);
      });
    });
  }, T2 = function(u) {
    return P(u) && u.indexOf("%") !== -1;
  }, Wg = function(u, c, d, h, S) {
    var B = f0(u), L = {
      styles: B,
      attributes: ih(u),
      colGroups: v0(u)
    };
    return u.undoManager.ignore(function() {
      var W = x2(d, c, S, h, rc(u), L);
      Ei(W, "data-mce-id", "__mce");
      var me = z0(W);
      u.insertContent(me), u.addVisual();
    }), Hs(uf(u), 'table[data-mce-id="__mce"]').map(function(W) {
      return cv(u) ? xg(W) : Cg(u) ? g0(W) : (zt(u) || T2(B.width)) && Sg(W), is(W), mo(W, "data-mce-id"), k2(u, W), bf(u, W), W.dom;
    }).getOr(null);
  }, E2 = function(u, c, d, h, S) {
    h === void 0 && (h = {});
    var B = function(me) {
      return J(me) && me > 0;
    };
    if (B(c) && B(d)) {
      var L = h.headerRows || 0, W = h.headerColumns || 0;
      return Wg(u, d, c, W, L);
    } else
      return console.error(S), null;
  }, Ch = function(u) {
    return function() {
      return u().fold(function() {
        return [];
      }, function(c) {
        return Me(c, function(d) {
          return d.dom;
        });
      });
    };
  }, tx = function(u) {
    return function(c) {
      var d = c.length > 0 ? N.some(Ks(c)) : N.none();
      u(d);
    };
  }, FT = function(u) {
    return function(c, d, h) {
      h === void 0 && (h = {});
      var S = E2(u, d, c, h, "Invalid values for insertTable - rows and columns values are required to insert a table.");
      return u.undoManager.add(), S;
    };
  }, yf = function(u, c, d, h) {
    return {
      insertTable: FT(u),
      setClipboardRows: tx(c.setRows),
      getClipboardRows: Ch(c.getRows),
      setClipboardCols: tx(c.setColumns),
      getClipboardCols: Ch(c.getColumns),
      resizeHandler: d,
      selectionTargets: h
    };
  }, Ys = function(u, c, d) {
    var h = _l(u, c, 1);
    d === 1 || h <= 1 ? mo(u, c) : Ei(u, c, Math.min(d, h));
  }, pu = function(u, c, d) {
    if (ra.hasColumns(u)) {
      var h = Tt(ra.justColumns(u), function(L) {
        return L.column >= c && L.column < d;
      }), S = Me(h, function(L) {
        var W = Ha(L.element);
        return Ys(W, "span", d - c), W;
      }), B = Nt.fromTag("colgroup");
      return Tc(B, S), [B];
    } else
      return [];
  }, $T = function(u, c, d) {
    return Me(u.all, function(h) {
      var S = Tt(h.cells, function(W) {
        return W.column >= c && W.column < d;
      }), B = Me(S, function(W) {
        var me = Ha(W.element);
        return Ys(me, "colspan", d - c), me;
      }), L = Nt.fromTag("tr");
      return Tc(L, B), L;
    });
  }, _2 = function(u, c) {
    var d = ra.fromTable(u), h = fv(d, c);
    return h.map(function(S) {
      var B = S[S.length - 1], L = S[0].column, W = B.column + B.colspan, me = pu(d, L, W), Re = $T(d, L, W);
      return tt(tt([], me, !0), Re, !0);
    });
  }, qg = function(u, c, d) {
    var h = ra.fromTable(u), S = Nc(h, c);
    return S.bind(function(B) {
      var L = ad(h, d, !1), W = ni(L).rows, me = W.slice(B[0].row, B[B.length - 1].row + B[B.length - 1].rowspan), Re = He(me, function(jt) {
        var Sn = Tt(jt.cells, function(ln) {
          return !ln.isLocked;
        });
        return Sn.length > 0 ? [he(he({}, jt), { cells: Sn })] : [];
      }), rt = C0(Re);
      return eo(rt.length > 0, rt);
    }).map(function(B) {
      return n2(B);
    });
  }, A2 = tinymce.util.Tools.resolve("tinymce.util.Tools"), Sh = function(u, c, d) {
    var h = u.select("td,th", c), S, B = function(L, W) {
      for (var me = 0; me < W.length; me++) {
        var Re = u.getStyle(W[me], d);
        if (typeof L > "u" && (L = Re), L !== Re)
          return "";
      }
      return L;
    };
    return B(S, h);
  }, O2 = function(u, c, d) {
    d && u.formatter.apply("align" + d, {}, c);
  }, LT = function(u, c, d) {
    d && u.formatter.apply("valign" + d, {}, c);
  }, jn = function(u, c) {
    A2.each("left center right".split(" "), function(d) {
      u.formatter.remove("align" + d, {}, c);
    });
  }, Ni = function(u, c) {
    A2.each("top middle bottom".split(" "), function(d) {
      u.formatter.remove("valign" + d, {}, c);
    });
  }, Gg = [
    {
      text: "None",
      value: ""
    },
    {
      text: "Top",
      value: "top"
    },
    {
      text: "Middle",
      value: "middle"
    },
    {
      text: "Bottom",
      value: "bottom"
    }
  ], Zi = function(u) {
    return { value: u };
  }, Pl = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, D2 = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, xh = function(u) {
    return Pl.test(u) || D2.test(u);
  }, H0 = function(u) {
    return zn(u, "#").toUpperCase();
  }, V0 = function(u) {
    return xh(u) ? N.some({ value: H0(u) }) : N.none();
  }, U0 = function(u) {
    var c = u.toString(16);
    return (c.length === 1 ? "0" + c : c).toUpperCase();
  }, ld = function(u) {
    var c = U0(u.red) + U0(u.green) + U0(u.blue);
    return Zi(c);
  }, kh = /^rgb\((\d+),\s*(\d+),\s*(\d+)\)/, B2 = /^rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d?(?:\.\d+)?)\)/, R2 = function(u, c, d, h) {
    return {
      red: u,
      green: c,
      blue: d,
      alpha: h
    };
  }, M2 = function(u, c, d, h) {
    var S = parseInt(u, 10), B = parseInt(c, 10), L = parseInt(d, 10), W = parseFloat(h);
    return R2(S, B, L, W);
  }, zT = function(u) {
    if (u === "transparent")
      return N.some(R2(0, 0, 0, 0));
    var c = kh.exec(u);
    if (c !== null)
      return N.some(M2(c[1], c[2], c[3], "1"));
    var d = B2.exec(u);
    return d !== null ? N.some(M2(d[1], d[2], d[3], d[4])) : N.none();
  }, nx = function(u) {
    return V0(u).orThunk(function() {
      return zT(u).map(ld);
    }).getOrThunk(function() {
      var c = document.createElement("canvas");
      c.height = 1, c.width = 1;
      var d = c.getContext("2d");
      d.clearRect(0, 0, c.width, c.height), d.fillStyle = "#FFFFFF", d.fillStyle = u, d.fillRect(0, 0, 1, 1);
      var h = d.getImageData(0, 0, 1, 1).data, S = h[0], B = h[1], L = h[2], W = h[3];
      return ld(R2(S, B, L, W));
    });
  }, dv = function(u) {
    var c = u, d = function() {
      return c;
    }, h = function(S) {
      c = S;
    };
    return {
      get: d,
      set: h
    };
  }, wf = function(u) {
    var c = dv(N.none()), d = function() {
      return c.get().each(u);
    }, h = function() {
      d(), c.set(N.none());
    }, S = function() {
      return c.get().isSome();
    }, B = function() {
      return c.get();
    }, L = function(W) {
      d(), c.set(N.some(W));
    };
    return {
      clear: h,
      isSet: S,
      get: B,
      set: L
    };
  }, dm = function() {
    return wf(function(u) {
      return u.unbind();
    });
  }, Kg = function() {
    var u = wf(ue), c = function(d) {
      return u.get().each(d);
    };
    return he(he({}, u), { on: c });
  }, P2 = function(u, c, d, h) {
    return function(S) {
      var B = dm(), L = Yn(h), W = function() {
        var me = Pu(c), Re = function(rt) {
          return u.formatter.match(d, { value: h }, rt.dom, L);
        };
        L ? (S.setActive(!_(me, Re)), B.set(u.formatter.formatChanged(d, function(rt) {
          return S.setActive(!rt);
        }, !0))) : (S.setActive(We(me, Re)), B.set(u.formatter.formatChanged(d, S.setActive, !1, { value: h })));
      };
      return u.initialized ? W() : u.on("init", W), B.clear;
    };
  }, j0 = function(u) {
    return nt(u, "menu");
  }, Cf = function(u) {
    return Me(u, function(c) {
      var d = c.text || c.title;
      return j0(c) ? {
        text: d,
        items: Cf(c.menu)
      } : {
        text: d,
        value: c.value
      };
    });
  }, oc = function(u, c, d, h, S) {
    return Me(d, function(B) {
      var L = B.text || B.title;
      return j0(B) ? {
        type: "nestedmenuitem",
        text: L,
        getSubmenuItems: function() {
          return oc(u, c, B.menu, h, S);
        }
      } : {
        text: L,
        type: "togglemenuitem",
        onAction: function() {
          return S(B.value);
        },
        onSetup: P2(u, c, h, B.value)
      };
    });
  }, cd = function(u, c) {
    return function(d) {
      var h;
      u.execCommand("mceTableApplyCellStyle", !1, (h = {}, h[c] = d, h));
    };
  }, fd = function(u) {
    return He(u, function(c) {
      return j0(c) ? [he(he({}, c), { menu: fd(c.menu) })] : yn(c.value) ? [c] : [];
    });
  }, mm = function(u, c, d, h, S) {
    return function(B) {
      return B(oc(u, c, d, h, S));
    };
  }, Xg = function(u, c, d) {
    var h = Me(c, function(S) {
      return {
        text: S.title,
        value: "#" + nx(S.value).value,
        type: "choiceitem"
      };
    });
    return [{
      type: "fancymenuitem",
      fancytype: "colorswatch",
      initData: {
        colors: h.length > 0 ? h : void 0,
        allowCustomColors: !1
      },
      onAction: function(S) {
        var B, L = S.value === "remove" ? "" : S.value;
        u.execCommand("mceTableApplyCellStyle", !1, (B = {}, B[d] = L, B));
      }
    }];
  }, N2 = function(u) {
    return function() {
      var c = u.queryCommandValue("mceTableRowType"), d = c === "header" ? "body" : "header";
      u.execCommand("mceTableRowType", !1, { type: d });
    };
  }, I2 = function(u) {
    return function() {
      var c = u.queryCommandValue("mceTableColType"), d = c === "th" ? "td" : "th";
      u.execCommand("mceTableColType", !1, { type: d });
    };
  }, F2 = function(u) {
    var c = Cf(mf(u));
    return c.length > 0 ? N.some({
      name: "class",
      type: "listbox",
      label: "Class",
      items: c
    }) : N.none();
  }, W0 = [
    {
      name: "width",
      type: "input",
      label: "Width"
    },
    {
      name: "height",
      type: "input",
      label: "Height"
    },
    {
      name: "celltype",
      type: "listbox",
      label: "Cell type",
      items: [
        {
          text: "Cell",
          value: "td"
        },
        {
          text: "Header cell",
          value: "th"
        }
      ]
    },
    {
      name: "scope",
      type: "listbox",
      label: "Scope",
      items: [
        {
          text: "None",
          value: ""
        },
        {
          text: "Row",
          value: "row"
        },
        {
          text: "Column",
          value: "col"
        },
        {
          text: "Row group",
          value: "rowgroup"
        },
        {
          text: "Column group",
          value: "colgroup"
        }
      ]
    },
    {
      name: "halign",
      type: "listbox",
      label: "Horizontal align",
      items: [
        {
          text: "None",
          value: ""
        },
        {
          text: "Left",
          value: "left"
        },
        {
          text: "Center",
          value: "center"
        },
        {
          text: "Right",
          value: "right"
        }
      ]
    },
    {
      name: "valign",
      type: "listbox",
      label: "Vertical align",
      items: Gg
    }
  ], hu = function(u) {
    return W0.concat(F2(u).toArray());
  }, wl = function(u, c) {
    var d = [{
      text: "Select...",
      value: ""
    }], h = [
      {
        name: "borderstyle",
        type: "listbox",
        label: "Border style",
        items: d.concat(Cf(ju(u)))
      },
      {
        name: "bordercolor",
        type: "colorinput",
        label: "Border color"
      },
      {
        name: "backgroundcolor",
        type: "colorinput",
        label: "Background color"
      }
    ], S = {
      name: "borderwidth",
      type: "input",
      label: "Border width"
    }, B = c === "cell" ? [S].concat(h) : h;
    return {
      title: "Advanced",
      name: "advanced",
      items: B
    };
  }, Nl = function(u) {
    return function(c, d) {
      var h = c.dom, S = function(W, me) {
        (!u || me) && h.setAttrib(d, W, me);
      }, B = function(W, me) {
        (!u || me) && h.setStyle(d, W, me);
      }, L = function(W, me) {
        (!u || me) && (me === "" ? c.formatter.remove(W, { value: null }, d, !0) : c.formatter.apply(W, { value: me }, d));
      };
      return {
        setAttrib: S,
        setStyle: B,
        setFormat: L
      };
    };
  }, Sf = {
    normal: Nl(!1),
    ifTruthy: Nl(!0)
  }, Yg = function(u) {
    return function(c) {
      return Kr(c, "rgb") ? u.toHex(c) : c;
    };
  }, q0 = function(u, c) {
    var d = Nt.fromDom(c);
    return {
      borderwidth: ns(d, "border-width").getOr(""),
      borderstyle: ns(d, "border-style").getOr(""),
      bordercolor: ns(d, "border-color").map(Yg(u)).getOr(""),
      backgroundcolor: ns(d, "background-color").map(Yg(u)).getOr("")
    };
  }, vd = function(u) {
    var c = u[0], d = u.slice(1);
    return Je(d, function(h) {
      Je(ki(c), function(S) {
        za(h, function(B, L) {
          var W = c[S];
          W !== "" && S === L && W !== B && (c[S] = "");
        });
      });
    }), c;
  }, gm = function(u, c, d, h) {
    return _t(u, function(S) {
      return !Q(d.formatter.matchNode(h, c + S));
    }).getOr("");
  }, pm = Ze(gm, [
    "left",
    "center",
    "right"
  ], "align"), HT = Ze(gm, [
    "top",
    "middle",
    "bottom"
  ], "valign"), $2 = function(u, c) {
    var d = f0(u), h = ih(u), S = function(rt) {
      return {
        borderstyle: Li(d, "border-style").getOr(""),
        bordercolor: Yg(rt)(Li(d, "border-color").getOr("")),
        backgroundcolor: Yg(rt)(Li(d, "background-color").getOr(""))
      };
    }, B = {
      height: "",
      width: "100%",
      cellspacing: "",
      cellpadding: "",
      caption: !1,
      class: "",
      align: "",
      border: ""
    }, L = function() {
      var rt = d["border-width"];
      return Wu(u) && rt ? { border: rt } : Li(h, "border").fold(function() {
        return {};
      }, function(jt) {
        return { border: jt };
      });
    }, W = c ? S(u.dom) : {}, me = function() {
      var rt = Li(d, "border-spacing").or(Li(h, "cellspacing")).fold(function() {
        return {};
      }, function(Sn) {
        return { cellspacing: Sn };
      }), jt = Li(d, "border-padding").or(Li(h, "cellpadding")).fold(function() {
        return {};
      }, function(Sn) {
        return { cellpadding: Sn };
      });
      return he(he({}, rt), jt);
    }, Re = he(he(he(he(he(he({}, B), d), h), W), L()), me());
    return Re;
  }, rx = function(u) {
    return Oo(Nt.fromDom(u)).map(function(c) {
      var d = { selection: Ks(u.cells) };
      return Os(c, d);
    }).getOr("");
  }, ax = function(u, c, d) {
    var h = function(W, me) {
      var Re = ns(Nt.fromDom(me), "border-width");
      return Wu(u) && Re.isSome() ? Re.getOr("") : W.getAttrib(me, "border") || Sh(u.dom, me, "border-width") || Sh(u.dom, me, "border");
    }, S = u.dom, B = Wu(u) ? S.getStyle(c, "border-spacing") || S.getAttrib(c, "cellspacing") : S.getAttrib(c, "cellspacing") || S.getStyle(c, "border-spacing"), L = Wu(u) ? Sh(S, c, "padding") || S.getAttrib(c, "cellpadding") : S.getAttrib(c, "cellpadding") || Sh(S, c, "padding");
    return he({
      width: S.getStyle(c, "width") || S.getAttrib(c, "width"),
      height: S.getStyle(c, "height") || S.getAttrib(c, "height"),
      cellspacing: B,
      cellpadding: L,
      border: h(S, c),
      caption: !!S.select("caption", c)[0],
      class: S.getAttrib(c, "class", ""),
      align: pm(u, c)
    }, d ? q0(S, c) : {});
  }, L2 = function(u, c, d) {
    var h = u.dom;
    return he({
      height: h.getStyle(c, "height") || h.getAttrib(c, "height"),
      class: h.getAttrib(c, "class", ""),
      type: rx(c),
      align: pm(u, c)
    }, d ? q0(h, c) : {});
  }, z2 = function(u, c, d, h) {
    var S = u.dom, B = h.getOr(c), L = function(W, me) {
      return S.getStyle(W, me) || S.getAttrib(W, me);
    };
    return he({
      width: L(B, "width"),
      height: L(c, "height"),
      scope: S.getAttrib(c, "scope"),
      celltype: xy(c),
      class: S.getAttrib(c, "class", ""),
      halign: pm(u, c),
      valign: HT(u, c)
    }, d ? q0(S, c) : {});
  }, Ya = function(u, c) {
    var d = ra.fromTable(u), h = ra.justCells(d), S = Tt(h, function(B) {
      return _(c, function(L) {
        return Xr(B.element, L);
      });
    });
    return Me(S, function(B) {
      return {
        element: B.element.dom,
        column: ra.getColumnAt(d, B.column).map(function(L) {
          return L.element.dom;
        })
      };
    });
  }, xf = function(u, c, d) {
    u.setAttrib("scope", d.scope), u.setAttrib("class", d.class), u.setStyle("height", zi(d.height)), c.setStyle("width", zi(d.width));
  }, ox = function(u, c) {
    u.setFormat("tablecellbackgroundcolor", c.backgroundcolor), u.setFormat("tablecellbordercolor", c.bordercolor), u.setFormat("tablecellborderstyle", c.borderstyle), u.setFormat("tablecellborderwidth", zi(c.borderwidth));
  }, ix = function(u, c, d) {
    var h = c.length === 1;
    Je(c, function(S) {
      var B = S.element, L = h ? Sf.normal(u, B) : Sf.ifTruthy(u, B), W = S.column.map(function(me) {
        return h ? Sf.normal(u, me) : Sf.ifTruthy(u, me);
      }).getOr(L);
      xf(L, W, d), sh(u) && ox(L, d), h && (jn(u, B), Ni(u, B)), d.halign && O2(u, B, d.halign), d.valign && LT(u, B, d.valign);
    });
  }, ux = function(u, c) {
    u.execCommand("mceTableCellType", !1, {
      type: c.celltype,
      no_events: !0
    });
  }, G0 = function(u, c, d, h) {
    var S = $i(h, function(B, L) {
      return d[L] !== B;
    });
    qi(S) > 0 && c.length >= 1 && Oo(c[0]).each(function(B) {
      var L = Ya(B, c), W = qi($i(S, function(Re, rt) {
        return rt !== "scope" && rt !== "celltype";
      })) > 0, me = ve(S, "celltype");
      (W || ve(S, "scope")) && ix(u, L, h), me && ux(u, h), df(u, B.dom, {
        structure: me,
        style: W
      });
    });
  }, H2 = function(u, c, d, h) {
    var S = h.getData();
    h.close(), u.undoManager.transact(function() {
      G0(u, c, d, S), u.focus();
    });
  }, Th = function(u, c) {
    var d = Oo(c[0]).map(function(h) {
      return Me(Ya(h, c), function(S) {
        return z2(u, S.element, sh(u), S.column);
      });
    });
    return vd(d.getOrDie());
  }, Br = function(u, c) {
    var d = Pu(c);
    if (d.length !== 0) {
      var h = Th(u, d), S = {
        type: "tabpanel",
        tabs: [
          {
            title: "General",
            name: "general",
            items: hu(u)
          },
          wl(u, "cell")
        ]
      }, B = {
        type: "panel",
        items: [{
          type: "grid",
          columns: 2,
          items: hu(u)
        }]
      };
      u.windowManager.open({
        title: "Cell Properties",
        size: "normal",
        body: sh(u) ? S : B,
        buttons: [
          {
            type: "cancel",
            name: "cancel",
            text: "Cancel"
          },
          {
            type: "submit",
            name: "save",
            text: "Save",
            primary: !0
          }
        ],
        initialData: h,
        onSubmit: Ze(H2, u, d, h)
      });
    }
  }, VT = function(u) {
    var c = Cf(nd(u));
    return c.length > 0 ? N.some({
      name: "class",
      type: "listbox",
      label: "Class",
      items: c
    }) : N.none();
  }, V2 = [
    {
      type: "listbox",
      name: "type",
      label: "Row type",
      items: [
        {
          text: "Header",
          value: "header"
        },
        {
          text: "Body",
          value: "body"
        },
        {
          text: "Footer",
          value: "footer"
        }
      ]
    },
    {
      type: "listbox",
      name: "align",
      label: "Alignment",
      items: [
        {
          text: "None",
          value: ""
        },
        {
          text: "Left",
          value: "left"
        },
        {
          text: "Center",
          value: "center"
        },
        {
          text: "Right",
          value: "right"
        }
      ]
    },
    {
      label: "Height",
      name: "height",
      type: "input"
    }
  ], sx = function(u) {
    return V2.concat(VT(u).toArray());
  }, U2 = function(u, c) {
    u.setAttrib("class", c.class), u.setStyle("height", zi(c.height));
  }, UT = function(u, c) {
    u.setStyle("background-color", c.backgroundcolor), u.setStyle("border-color", c.bordercolor), u.setStyle("border-style", c.borderstyle);
  }, lx = function(u, c, d, h) {
    var S = c.length === 1;
    Je(c, function(B) {
      var L = S ? Sf.normal(u, B) : Sf.ifTruthy(u, B);
      U2(L, d), lh(u) && UT(L, d), d.align !== h.align && (jn(u, B), O2(u, B, d.align));
    });
  }, j2 = function(u, c) {
    u.execCommand("mceTableRowType", !1, {
      type: c.type,
      no_events: !0
    });
  }, W2 = function(u, c, d, h) {
    var S = $i(h, function(W, me) {
      return d[me] !== W;
    });
    if (qi(S) > 0) {
      var B = ve(S, "type"), L = B ? qi(S) > 1 : !0;
      L && lx(u, c, h, d), B && j2(u, h), Oo(Nt.fromDom(c[0])).each(function(W) {
        return df(u, W.dom, {
          structure: B,
          style: L
        });
      });
    }
  }, jT = function(u, c, d, h) {
    var S = h.getData();
    h.close(), u.undoManager.transact(function() {
      W2(u, c, d, S), u.focus();
    });
  }, Cl = function(u) {
    var c = rS(jd(u), hl.selected);
    if (c.length !== 0) {
      var d = Me(c, function(L) {
        return L2(u, L.dom, lh(u));
      }), h = vd(d), S = {
        type: "tabpanel",
        tabs: [
          {
            title: "General",
            name: "general",
            items: sx(u)
          },
          wl(u, "row")
        ]
      }, B = {
        type: "panel",
        items: [{
          type: "grid",
          columns: 2,
          items: sx(u)
        }]
      };
      u.windowManager.open({
        title: "Row Properties",
        size: "normal",
        body: lh(u) ? S : B,
        buttons: [
          {
            type: "cancel",
            name: "cancel",
            text: "Cancel"
          },
          {
            type: "submit",
            name: "save",
            text: "Save",
            primary: !0
          }
        ],
        initialData: h,
        onSubmit: Ze(jT, u, Me(c, function(L) {
          return L.dom;
        }), h)
      });
    }
  }, ds = function(u, c, d) {
    var h = d ? [
      {
        type: "input",
        name: "cols",
        label: "Cols",
        inputMode: "numeric"
      },
      {
        type: "input",
        name: "rows",
        label: "Rows",
        inputMode: "numeric"
      }
    ] : [], S = [
      {
        type: "input",
        name: "width",
        label: "Width"
      },
      {
        type: "input",
        name: "height",
        label: "Height"
      }
    ], B = Pc(u) ? [
      {
        type: "input",
        name: "cellspacing",
        label: "Cell spacing",
        inputMode: "numeric"
      },
      {
        type: "input",
        name: "cellpadding",
        label: "Cell padding",
        inputMode: "numeric"
      },
      {
        type: "input",
        name: "border",
        label: "Border width"
      },
      {
        type: "label",
        label: "Caption",
        items: [{
          type: "checkbox",
          name: "caption",
          label: "Show caption"
        }]
      }
    ] : [], L = [{
      type: "listbox",
      name: "align",
      label: "Alignment",
      items: [
        {
          text: "None",
          value: ""
        },
        {
          text: "Left",
          value: "left"
        },
        {
          text: "Center",
          value: "center"
        },
        {
          text: "Right",
          value: "right"
        }
      ]
    }], W = c.length > 0 ? [{
      type: "listbox",
      name: "class",
      label: "Class",
      items: c
    }] : [];
    return h.concat(S).concat(B).concat(L).concat(W);
  }, kf = function(u, c, d, h) {
    if (c.tagName === "TD" || c.tagName === "TH")
      P(d) ? u.setStyle(c, d, h) : u.setStyle(c, d);
    else if (c.children)
      for (var S = 0; S < c.children.length; S++)
        kf(u, c.children[S], d, h);
  }, WT = function(u, c, d) {
    var h = u.dom, S = {}, B = {};
    if (S.class = d.class, B.height = zi(d.height), h.getAttrib(c, "width") && !Wu(u) ? S.width = jv(d.width) : B.width = zi(d.width), Wu(u) ? (B["border-width"] = zi(d.border), B["border-spacing"] = zi(d.cellspacing)) : (S.border = d.border, S.cellpadding = d.cellpadding, S.cellspacing = d.cellspacing), Wu(u) && c.children)
      for (var L = 0; L < c.children.length; L++)
        kf(h, c.children[L], {
          "border-width": zi(d.border),
          padding: zi(d.cellpadding)
        }), vs(u) && kf(h, c.children[L], { "border-color": d.bordercolor });
    vs(u) && (B["background-color"] = d.backgroundcolor, B["border-color"] = d.bordercolor, B["border-style"] = d.borderstyle), S.style = h.serializeStyle(he(he({}, f0(u)), B)), h.setAttribs(c, he(he({}, ih(u)), S));
  }, qT = function(u, c, d, h) {
    var S = u.dom, B = h.getData(), L = $i(B, function(W, me) {
      return d[me] !== W;
    });
    h.close(), B.class === "" && delete B.class, u.undoManager.transact(function() {
      if (!c) {
        var W = parseInt(B.cols, 10) || 1, me = parseInt(B.rows, 10) || 1;
        c = Wg(u, W, me, 0, 0);
      }
      if (qi(L) > 0) {
        WT(u, c, B);
        var Re = S.select("caption", c)[0];
        (Re && !B.caption || !Re && B.caption) && u.execCommand("mceTableToggleCaption"), B.align === "" ? jn(u, c) : O2(u, c, B.align);
      }
      if (u.focus(), u.addVisual(), qi(L) > 0) {
        var rt = ve(L, "caption"), jt = rt ? qi(L) > 1 : !0;
        df(u, c, {
          structure: rt,
          style: jt
        });
      }
    });
  }, q2 = function(u, c) {
    var d = u.dom, h, S = $2(u, vs(u));
    c === !1 ? (h = d.getParent(u.selection.getStart(), "table", u.getBody()), h ? S = ax(u, h, vs(u)) : vs(u) && (S.borderstyle = "", S.bordercolor = "", S.backgroundcolor = "")) : (S.cols = "1", S.rows = "1", vs(u) && (S.borderstyle = "", S.bordercolor = "", S.backgroundcolor = ""));
    var B = Cf(ch(u));
    B.length > 0 && S.class && (S.class = S.class.replace(/\s*mce\-item\-table\s*/g, ""));
    var L = {
      type: "grid",
      columns: 2,
      items: ds(u, B, c)
    }, W = function() {
      return {
        type: "panel",
        items: [L]
      };
    }, me = function() {
      return {
        type: "tabpanel",
        tabs: [
          {
            title: "General",
            name: "general",
            items: [L]
          },
          wl(u, "table")
        ]
      };
    }, Re = vs(u) ? me() : W();
    u.windowManager.open({
      title: "Table Properties",
      size: "normal",
      body: Re,
      onSubmit: Ze(qT, u, h, S),
      buttons: [
        {
          type: "cancel",
          name: "cancel",
          text: "Cancel"
        },
        {
          type: "submit",
          name: "save",
          text: "Save",
          primary: !0
        }
      ],
      initialData: S
    });
  }, la = function(u) {
    return Fo(jd(u), pl(u));
  }, GT = function(u) {
    return fu(jd(u), pl(u));
  }, K0 = function(u, c, d, h, S) {
    var B = pl(u), L = function() {
      return la(u).each(function(dr) {
        Oo(dr, B).filter(De(B)).each(function(Ur) {
          var ca = Nt.fromText("");
          if (oo(Ur, ca), Ss(Ur), u.dom.isEmpty(u.getBody()))
            u.setContent(""), u.selection.setCursorLocation();
          else {
            var sa = u.dom.createRng();
            sa.setStart(ca.dom, 0), sa.setEnd(ca.dom, 0), u.selection.setRng(sa), u.nodeChanged();
          }
        });
      });
    }, W = function(dr) {
      return la(u).each(function(Ur) {
        var ca = Cg(u) || cv(u) || zt(u);
        ca || Oo(Ur, B).each(function(sa) {
          dr === "relative" && !G1(sa) ? Sg(sa) : dr === "fixed" && !vu(sa) ? xg(sa) : dr === "responsive" && !K1(sa) && g0(sa), is(sa), df(u, sa.dom, Bo);
        });
      });
    }, me = function(dr) {
      return Oo(dr, B);
    }, Re = function(dr) {
      return GT(u).bind(function(Ur) {
        return me(Ur).map(function(ca) {
          return dr(ca, Ur);
        });
      });
    }, rt = function(dr, Ur) {
      Re(function(ca) {
        u.formatter.toggle("tableclass", { value: Ur }, ca.dom), df(u, ca.dom, tm);
      });
    }, jt = function(dr, Ur) {
      Re(function(ca) {
        var sa = Pu(h), oi = We(sa, function(Qi) {
          return u.formatter.match("tablecellclass", { value: Ur }, Qi.dom);
        }), Ji = oi ? u.formatter.remove : u.formatter.apply;
        Je(sa, function(Qi) {
          return Ji("tablecellclass", { value: Ur }, Qi.dom);
        }), df(u, ca.dom, tm);
      });
    }, Sn = function() {
      la(u).each(function(dr) {
        Oo(dr, B).each(function(Ur) {
          Pr(Ur, "caption").fold(function() {
            var ca = Nt.fromTag("caption");
            Vo(ca, Nt.fromText("Caption")), dk(Ur, ca, 0), u.selection.setCursorLocation(ca.dom, 0);
          }, function(ca) {
            wo("caption")(dr) && po("td", Ur).each(function(sa) {
              return u.selection.setCursorLocation(sa.dom, 0);
            }), Ss(ca);
          }), df(u, Ur.dom, Bo);
        });
      });
    }, ln = function(dr) {
      u.focus();
    }, Wt = function(dr, Ur) {
      return Ur === void 0 && (Ur = !1), Re(function(ca, sa) {
        var oi = Wd(h, ca, sa);
        dr(ca, oi, Ur).each(ln);
      });
    }, Pn = function() {
      return Re(function(dr, Ur) {
        var ca = Wd(h, dr, Ur), sa = Zr(ue, Nt.fromDom(u.getDoc()), N.none());
        return qg(dr, ca, sa);
      });
    }, Ln = function() {
      return Re(function(dr, Ur) {
        var ca = Wd(h, dr, Ur);
        return _2(dr, ca);
      });
    }, mr = function(dr, Ur) {
      return Ur().each(function(ca) {
        var sa = Me(ca, function(oi) {
          return Ha(oi);
        });
        Re(function(oi, Ji) {
          var Qi = gl(Nt.fromDom(u.getDoc())), Ca = Ty(h, Ji, sa, Qi);
          dr(oi, Ca).each(ln);
        });
      });
    }, Ea = function(dr) {
      return function(Ur, ca) {
        return Li(ca, "type").each(function(sa) {
          Wt(dr(sa), ca.no_events);
        });
      };
    };
    za({
      mceTableSplitCells: function() {
        return Wt(c.unmergeCells);
      },
      mceTableMergeCells: function() {
        return Wt(c.mergeCells);
      },
      mceTableInsertRowBefore: function() {
        return Wt(c.insertRowsBefore);
      },
      mceTableInsertRowAfter: function() {
        return Wt(c.insertRowsAfter);
      },
      mceTableInsertColBefore: function() {
        return Wt(c.insertColumnsBefore);
      },
      mceTableInsertColAfter: function() {
        return Wt(c.insertColumnsAfter);
      },
      mceTableDeleteCol: function() {
        return Wt(c.deleteColumn);
      },
      mceTableDeleteRow: function() {
        return Wt(c.deleteRow);
      },
      mceTableCutCol: function() {
        return Ln().each(function(dr) {
          S.setColumns(dr), Wt(c.deleteColumn);
        });
      },
      mceTableCutRow: function() {
        return Pn().each(function(dr) {
          S.setRows(dr), Wt(c.deleteRow);
        });
      },
      mceTableCopyCol: function() {
        return Ln().each(function(dr) {
          return S.setColumns(dr);
        });
      },
      mceTableCopyRow: function() {
        return Pn().each(function(dr) {
          return S.setRows(dr);
        });
      },
      mceTablePasteColBefore: function() {
        return mr(c.pasteColsBefore, S.getColumns);
      },
      mceTablePasteColAfter: function() {
        return mr(c.pasteColsAfter, S.getColumns);
      },
      mceTablePasteRowBefore: function() {
        return mr(c.pasteRowsBefore, S.getRows);
      },
      mceTablePasteRowAfter: function() {
        return mr(c.pasteRowsAfter, S.getRows);
      },
      mceTableDelete: L,
      mceTableCellToggleClass: jt,
      mceTableToggleClass: rt,
      mceTableToggleCaption: Sn,
      mceTableSizingMode: function(dr, Ur) {
        return W(Ur);
      },
      mceTableCellType: Ea(function(dr) {
        return dr === "th" ? c.makeCellsHeader : c.unmakeCellsHeader;
      }),
      mceTableColType: Ea(function(dr) {
        return dr === "th" ? c.makeColumnsHeader : c.unmakeColumnsHeader;
      }),
      mceTableRowType: Ea(function(dr) {
        switch (dr) {
          case "header":
            return c.makeRowsHeader;
          case "footer":
            return c.makeRowsFooter;
          default:
            return c.makeRowsBody;
        }
      })
    }, function(dr, Ur) {
      return u.addCommand(Ur, dr);
    }), za({
      mceTableProps: Ze(q2, u, !1),
      mceTableRowProps: Ze(Cl, u),
      mceTableCellProps: Ze(Br, u, h)
    }, function(dr, Ur) {
      return u.addCommand(Ur, function() {
        return dr();
      });
    }), u.addCommand("mceInsertTable", function(dr, Ur) {
      H(Ur) && ki(Ur).length > 0 ? E2(u, Ur.rows, Ur.columns, Ur.options, "Invalid values for mceInsertTable - rows and columns values are required to insert a table.") : q2(u, !0);
    }), u.addCommand("mceTableApplyCellStyle", function(dr, Ur) {
      var ca = function(Ji) {
        return "tablecell" + Ji.toLowerCase().replace("-", "");
      };
      if (!!H(Ur)) {
        var sa = Pu(h);
        if (sa.length !== 0) {
          var oi = $i(Ur, function(Ji, Qi) {
            return u.formatter.has(ca(Qi)) && P(Ji);
          });
          wt(oi) || (za(oi, function(Ji, Qi) {
            Je(sa, function(Ca) {
              Sf.normal(u, Ca.dom).setFormat(ca(Qi), Ji);
            });
          }), me(sa[0]).each(function(Ji) {
            return df(u, Ji.dom, tm);
          }));
        }
      }
    });
  }, X0 = function(u, c, d) {
    var h = pl(u), S = function(B) {
      return fu(jd(u)).bind(function(L) {
        return Oo(L, h).map(function(W) {
          var me = Wd(d, W, L);
          return B(W, me);
        });
      }).getOr("");
    };
    za({
      mceTableRowType: function() {
        return S(c.getTableRowType);
      },
      mceTableCellType: function() {
        return S(c.getTableCellType);
      },
      mceTableColType: function() {
        return S(c.getTableColType);
      }
    }, function(B, L) {
      return u.addQueryValueHandler(L, B);
    });
  }, Y0 = function() {
    var u = Kg(), c = Kg();
    return {
      getRows: u.get,
      setRows: function(d) {
        d.fold(u.clear, u.set), c.clear();
      },
      clearRows: u.clear,
      getColumns: c.get,
      setColumns: function(d) {
        d.fold(c.clear, c.set), u.clear();
      },
      clearColumns: c.clear
    };
  }, Eh = {
    remove_similar: !0,
    inherit: !1
  }, mv = he({ selector: "td,th" }, Eh), _h = {
    tablecellbackgroundcolor: he({ styles: { backgroundColor: "%value" } }, mv),
    tablecellverticalalign: he({ styles: { "vertical-align": "%value" } }, mv),
    tablecellbordercolor: he({ styles: { borderColor: "%value" } }, mv),
    tablecellclass: he({ classes: ["%value"] }, mv),
    tableclass: he({
      selector: "table",
      classes: ["%value"]
    }, Eh),
    tablecellborderstyle: he({ styles: { borderStyle: "%value" } }, mv),
    tablecellborderwidth: he({ styles: { borderWidth: "%value" } }, mv)
  }, KT = function(u) {
    u.formatter.register(_h);
  }, cx = tf.generate([
    { none: ["current"] },
    { first: ["current"] },
    {
      middle: [
        "current",
        "target"
      ]
    },
    { last: ["current"] }
  ]), G2 = function(u) {
    return u === void 0 && (u = void 0), cx.none(u);
  }, dd = he(he({}, cx), { none: G2 }), Z0 = function(u, c, d, h, S) {
    S === void 0 && (S = Be);
    var B = h === 1;
    if (!B && d <= 0)
      return dd.first(u[0]);
    if (B && d >= u.length - 1)
      return dd.last(u[u.length - 1]);
    var L = d + h, W = u[L];
    return S(W) ? dd.middle(c, W) : Z0(u, c, L, h, S);
  }, fx = function(u, c) {
    return Oo(u, c).bind(function(d) {
      var h = Xf(d), S = Pe(h, function(B) {
        return Xr(u, B);
      });
      return S.map(function(B) {
        return {
          index: B,
          all: h
        };
      });
    });
  }, XT = function(u, c, d) {
    var h = fx(u, d);
    return h.fold(function() {
      return dd.none(u);
    }, function(S) {
      return Z0(S.all, u, S.index, 1, c);
    });
  }, YT = function(u, c, d) {
    var h = fx(u, d);
    return h.fold(function() {
      return dd.none();
    }, function(S) {
      return Z0(S.all, u, S.index, -1, c);
    });
  }, ZT = function(u, c, d, h) {
    return {
      start: u,
      soffset: c,
      finish: d,
      foffset: h
    };
  }, hm = { create: ZT }, K2 = tf.generate([
    { before: ["element"] },
    {
      on: [
        "element",
        "offset"
      ]
    },
    { after: ["element"] }
  ]), Cr = function(u, c, d, h) {
    return u.fold(c, d, h);
  }, vx = function(u) {
    return u.fold(ht, ht, ht);
  }, dx = K2.before, JT = K2.on, Ah = K2.after, Ku = {
    before: dx,
    on: JT,
    after: Ah,
    cata: Cr,
    getStart: vx
  }, Oh = tf.generate([
    { domRange: ["rng"] },
    {
      relative: [
        "startSitu",
        "finishSitu"
      ]
    },
    {
      exact: [
        "start",
        "soffset",
        "finish",
        "foffset"
      ]
    }
  ]), QT = function(u) {
    return Oh.exact(u.start, u.soffset, u.finish, u.foffset);
  }, mx = function(u) {
    return u.match({
      domRange: function(c) {
        return Nt.fromDom(c.startContainer);
      },
      relative: function(c, d) {
        return Ku.getStart(c);
      },
      exact: function(c, d, h, S) {
        return c;
      }
    });
  }, X2 = Oh.domRange, Y2 = Oh.relative, gx = Oh.exact, Z2 = function(u) {
    var c = mx(u);
    return ol(c);
  }, J2 = hm.create, gv = {
    domRange: X2,
    relative: Y2,
    exact: gx,
    exactFromRange: QT,
    getWin: Z2,
    range: J2
  }, eE = function(u, c) {
    var d = u.document.createRange();
    return d.selectNode(c.dom), d;
  }, tE = function(u, c) {
    var d = u.document.createRange();
    return px(d, c), d;
  }, px = function(u, c) {
    return u.selectNodeContents(c.dom);
  }, nE = function(u, c) {
    c.fold(function(d) {
      u.setStartBefore(d.dom);
    }, function(d, h) {
      u.setStart(d.dom, h);
    }, function(d) {
      u.setStartAfter(d.dom);
    });
  }, Dh = function(u, c) {
    c.fold(function(d) {
      u.setEndBefore(d.dom);
    }, function(d, h) {
      u.setEnd(d.dom, h);
    }, function(d) {
      u.setEndAfter(d.dom);
    });
  }, Na = function(u, c, d) {
    var h = u.document.createRange();
    return nE(h, c), Dh(h, d), h;
  }, J0 = function(u, c, d, h, S) {
    var B = u.document.createRange();
    return B.setStart(c.dom, d), B.setEnd(h.dom, S), B;
  }, pv = function(u) {
    return {
      left: u.left,
      top: u.top,
      right: u.right,
      bottom: u.bottom,
      width: u.width,
      height: u.height
    };
  }, ic = function(u) {
    var c = u.getClientRects(), d = c.length > 0 ? c[0] : u.getBoundingClientRect();
    return d.width > 0 || d.height > 0 ? N.some(d).map(pv) : N.none();
  }, md = tf.generate([
    {
      ltr: [
        "start",
        "soffset",
        "finish",
        "foffset"
      ]
    },
    {
      rtl: [
        "start",
        "soffset",
        "finish",
        "foffset"
      ]
    }
  ]), Ds = function(u, c, d) {
    return c(Nt.fromDom(d.startContainer), d.startOffset, Nt.fromDom(d.endContainer), d.endOffset);
  }, Q0 = function(u, c) {
    return c.match({
      domRange: function(d) {
        return {
          ltr: ze(d),
          rtl: N.none
        };
      },
      relative: function(d, h) {
        return {
          ltr: gt(function() {
            return Na(u, d, h);
          }),
          rtl: gt(function() {
            return N.some(Na(u, h, d));
          })
        };
      },
      exact: function(d, h, S, B) {
        return {
          ltr: gt(function() {
            return J0(u, d, h, S, B);
          }),
          rtl: gt(function() {
            return N.some(J0(u, S, B, d, h));
          })
        };
      }
    });
  }, bm = function(u, c) {
    var d = c.ltr();
    if (d.collapsed) {
      var h = c.rtl().filter(function(S) {
        return S.collapsed === !1;
      });
      return h.map(function(S) {
        return md.rtl(Nt.fromDom(S.endContainer), S.endOffset, Nt.fromDom(S.startContainer), S.startOffset);
      }).getOrThunk(function() {
        return Ds(u, md.ltr, d);
      });
    } else
      return Ds(u, md.ltr, d);
  }, Zg = function(u, c) {
    var d = Q0(u, c);
    return bm(u, d);
  }, gd = function(u, c) {
    var d = Zg(u, c);
    return d.match({
      ltr: function(h, S, B, L) {
        var W = u.document.createRange();
        return W.setStart(h.dom, S), W.setEnd(B.dom, L), W;
      },
      rtl: function(h, S, B, L) {
        var W = u.document.createRange();
        return W.setStart(B.dom, L), W.setEnd(h.dom, S), W;
      }
    });
  };
  md.ltr, md.rtl;
  var rE = function(u, c, d, h, S) {
    if (S === 0)
      return 0;
    if (c === h)
      return S - 1;
    for (var B = h, L = 1; L < S; L++) {
      var W = u(L), me = Math.abs(c - W.left);
      if (d <= W.bottom) {
        if (d < W.top || me > B)
          return L - 1;
        B = me;
      }
    }
    return 0;
  }, hx = function(u, c, d) {
    return c >= u.left && c <= u.right && d >= u.top && d <= u.bottom;
  }, aE = function(u, c, d, h, S) {
    var B = function(Re) {
      var rt = u.dom.createRange();
      return rt.setStart(c.dom, Re), rt.collapse(!0), rt;
    }, L = function(Re) {
      var rt = B(Re);
      return rt.getBoundingClientRect();
    }, W = k1(c).length, me = rE(L, d, h, S.right, W);
    return B(me);
  }, oE = function(u, c, d, h) {
    var S = u.dom.createRange();
    S.selectNode(c.dom);
    var B = S.getClientRects(), L = Xe(B, function(W) {
      return hx(W, d, h) ? N.some(W) : N.none();
    });
    return L.map(function(W) {
      return aE(u, c, d, h, W);
    });
  }, ua = function(u, c, d, h) {
    var S = u.dom.createRange(), B = x(c);
    return Xe(B, function(L) {
      return S.selectNode(L.dom), hx(S.getBoundingClientRect(), d, h) ? uc(u, L, d, h) : N.none();
    });
  }, uc = function(u, c, d, h) {
    return ou(c) ? oE(u, c, d, h) : ua(u, c, d, h);
  }, Jg = function(u, c, d, h) {
    var S = u.dom.createRange();
    S.selectNode(c.dom);
    var B = S.getBoundingClientRect(), L = Math.max(B.left, Math.min(B.right, d)), W = Math.max(B.top, Math.min(B.bottom, h));
    return uc(u, c, L, W);
  }, bx = !0, Bh = !1, pa = function(u, c) {
    return c - u.left < u.right - c ? bx : Bh;
  }, yx = function(u, c, d) {
    var h = u.dom.createRange();
    return h.selectNode(c.dom), h.collapse(d), h;
  }, Cx = function(u, c, d) {
    var h = u.dom.createRange();
    h.selectNode(c.dom);
    var S = h.getBoundingClientRect(), B = pa(S, d), L = B === bx ? N1 : I1;
    return L(c).map(function(W) {
      return yx(u, W, B);
    });
  }, Rh = function(u, c, d) {
    var h = c.dom.getBoundingClientRect(), S = pa(h, d);
    return N.some(yx(u, c, S));
  }, Sx = function(u, c, d) {
    var h = x(c).length === 0 ? Rh : Cx;
    return h(u, c, d);
  }, Mh = function(u, c, d) {
    var h, S;
    return N.from((S = (h = u.dom).caretPositionFromPoint) === null || S === void 0 ? void 0 : S.call(h, c, d)).bind(function(B) {
      if (B.offsetNode === null)
        return N.none();
      var L = u.dom.createRange();
      return L.setStart(B.offsetNode, B.offset), L.collapse(), N.some(L);
    });
  }, ym = function(u, c, d) {
    var h, S;
    return N.from((S = (h = u.dom).caretRangeFromPoint) === null || S === void 0 ? void 0 : S.call(h, c, d));
  }, Q2 = function(u, c, d, h) {
    var S = u.dom.createRange();
    S.selectNode(c.dom);
    var B = S.getBoundingClientRect(), L = Math.max(B.left, Math.min(B.right, d)), W = Math.max(B.top, Math.min(B.bottom, h));
    return Jg(u, c, L, W);
  }, ew = function(u, c, d) {
    return Nt.fromPoint(u, c, d).bind(function(h) {
      var S = function() {
        return Sx(u, h, c);
      };
      return x(h).length === 0 ? S() : Q2(u, h, c, d).orThunk(S);
    });
  }, xx = function() {
    return document.caretPositionFromPoint ? Mh : document.caretRangeFromPoint ? ym : ew;
  }(), kx = function(u, c, d) {
    var h = Nt.fromDom(u.document);
    return xx(h, c, d).map(function(S) {
      return hm.create(Nt.fromDom(S.startContainer), S.startOffset, Nt.fromDom(S.endContainer), S.endOffset);
    });
  }, pd = function(u, c) {
    var d = va(u);
    return d === "input" ? Ku.after(u) : Te([
      "br",
      "img"
    ], d) ? c === 0 ? Ku.before(u) : Ku.after(u) : Ku.on(u, c);
  }, wm = function(u, c) {
    var d = u.fold(Ku.before, pd, Ku.after), h = c.fold(Ku.before, pd, Ku.after);
    return gv.relative(d, h);
  }, tw = function(u, c, d, h) {
    var S = pd(u, c), B = pd(d, h);
    return gv.relative(S, B);
  }, Tx = function(u) {
    return u.match({
      domRange: function(c) {
        var d = Nt.fromDom(c.startContainer), h = Nt.fromDom(c.endContainer);
        return tw(d, c.startOffset, h, c.endOffset);
      },
      relative: wm,
      exact: tw
    });
  }, eb = function(u, c, d, h) {
    var S = Ls(u), B = S.dom.createRange();
    return B.setStart(u.dom, c), B.setEnd(d.dom, h), B;
  }, iE = function(u, c, d, h) {
    var S = eb(u, c, d, h), B = Xr(u, d) && c === h;
    return S.collapsed && !B;
  }, Qg = function(u) {
    return N.from(u.getSelection());
  }, nw = function(u, c) {
    Qg(u).each(function(d) {
      d.removeAllRanges(), d.addRange(c);
    });
  }, rw = function(u, c, d, h, S) {
    var B = J0(u, c, d, h, S);
    nw(u, B);
  }, Ex = function(u, c, d, h, S, B) {
    c.collapse(d.dom, h), c.extend(S.dom, B);
  }, aw = function(u, c) {
    return Zg(u, c).match({
      ltr: function(d, h, S, B) {
        rw(u, d, h, S, B);
      },
      rtl: function(d, h, S, B) {
        Qg(u).each(function(L) {
          if (L.setBaseAndExtent)
            L.setBaseAndExtent(d.dom, h, S.dom, B);
          else if (L.extend)
            try {
              Ex(u, L, d, h, S, B);
            } catch {
              rw(u, S, B, d, h);
            }
          else
            rw(u, S, B, d, h);
        });
      }
    });
  }, tb = function(u, c, d, h, S) {
    var B = tw(c, d, h, S);
    aw(u, B);
  }, nb = function(u, c, d) {
    var h = wm(c, d);
    aw(u, h);
  }, ow = function(u) {
    var c = gv.getWin(u).dom, d = function(S, B, L, W) {
      return J0(c, S, B, L, W);
    }, h = Tx(u);
    return Zg(c, h).match({
      ltr: d,
      rtl: d
    });
  }, iw = function(u) {
    if (u.rangeCount > 0) {
      var c = u.getRangeAt(0), d = u.getRangeAt(u.rangeCount - 1);
      return N.some(hm.create(Nt.fromDom(c.startContainer), c.startOffset, Nt.fromDom(d.endContainer), d.endOffset));
    } else
      return N.none();
  }, _x = function(u) {
    if (u.anchorNode === null || u.focusNode === null)
      return iw(u);
    var c = Nt.fromDom(u.anchorNode), d = Nt.fromDom(u.focusNode);
    return iE(c, u.anchorOffset, d, u.focusOffset) ? N.some(hm.create(c, u.anchorOffset, d, u.focusOffset)) : iw(u);
  }, Cm = function(u, c, d) {
    d === void 0 && (d = !0);
    var h = d ? tE : eE, S = h(u, c);
    nw(u, S);
  }, ep = function(u) {
    return Qg(u).filter(function(c) {
      return c.rangeCount > 0;
    }).bind(_x);
  }, Ax = function(u) {
    return ep(u).map(function(c) {
      return gv.exact(c.start, c.soffset, c.finish, c.foffset);
    });
  }, Ox = function(u, c) {
    var d = gd(u, c);
    return ic(d);
  }, rb = function(u, c, d) {
    return kx(u, c, d);
  }, Dx = function(u) {
    Qg(u).each(function(c) {
      return c.removeAllRanges();
    });
  }, Bx = tinymce.util.Tools.resolve("tinymce.util.VK"), uw = function(u, c, d) {
    return Px(u, c, XT(d, rh));
  }, Rx = function(u, c, d) {
    return Px(u, c, YT(d, rh));
  }, Mx = function(u, c) {
    var d = gv.exact(c, 0, c, 0);
    return ow(d);
  }, Px = function(u, c, d) {
    return d.fold(N.none, N.none, function(h, S) {
      return N1(S).map(function(B) {
        return Mx(u, B);
      });
    }, function(h) {
      return u.execCommand("mceTableInsertRowAfter"), uw(u, c, h);
    });
  }, uE = [
    "table",
    "li",
    "dl"
  ], Nx = function(u, c, d) {
    if (u.keyCode === Bx.TAB) {
      var h = uf(c), S = function(W) {
        var me = va(W);
        return Xr(W, h) || Te(uE, me);
      }, B = c.selection.getRng(), L = Nt.fromDom(u.shiftKey ? B.startContainer : B.endContainer);
      xc(L, S).each(function(W) {
        u.preventDefault(), Oo(W, S).each(d.clear), c.selection.collapse(u.shiftKey);
        var me = u.shiftKey ? Rx : uw, Re = me(c, S, W);
        Re.each(function(rt) {
          c.selection.setRng(rt);
        });
      });
    }
  }, sw = function(u, c) {
    return {
      selection: u,
      kill: c
    };
  }, tp = { create: sw }, sE = function(u, c, d, h) {
    return {
      start: Ku.on(u, c),
      finish: Ku.on(d, h)
    };
  }, Ix = { create: sE }, Fx = function(u, c) {
    var d = gd(u, c);
    return hm.create(Nt.fromDom(d.startContainer), d.startOffset, Nt.fromDom(d.endContainer), d.endOffset);
  }, Il = Ix.create, $x = function(u, c, d, h, S, B, L) {
    return Xr(d, S) && h === B ? N.none() : zo(d, "td,th", c).bind(function(W) {
      return zo(S, "td,th", c).bind(function(me) {
        return Lx(u, c, W, me, L);
      });
    });
  }, Lx = function(u, c, d, h, S) {
    return Xr(d, h) ? N.none() : Iv(d, h, c).bind(function(B) {
      var L = B.boxes.getOr([]);
      return L.length > 1 ? (S(u, L, B.start, B.finish), N.some(tp.create(N.some(Il(d, 0, d, tc(d))), !0))) : N.none();
    });
  }, ab = function(u, c, d, h, S) {
    var B = function(L) {
      return S.clearBeforeUpdate(d), S.selectRange(d, L.boxes, L.start, L.finish), L.boxes;
    };
    return Qm(h, u, c, S.firstSelectedSelector, S.lastSelectedSelector).map(B);
  }, ob = function(u, c) {
    return {
      item: u,
      mode: c
    };
  }, lw = function(u, c, d, h) {
    return h === void 0 && (h = Sm), u.property().parent(c).map(function(S) {
      return ob(S, h);
    });
  }, Sm = function(u, c, d, h) {
    return h === void 0 && (h = np), d.sibling(u, c).map(function(S) {
      return ob(S, h);
    });
  }, np = function(u, c, d, h) {
    h === void 0 && (h = np);
    var S = u.property().children(c), B = d.first(S);
    return B.map(function(L) {
      return ob(L, h);
    });
  }, zx = [
    {
      current: lw,
      next: Sm,
      fallback: N.none()
    },
    {
      current: Sm,
      next: np,
      fallback: N.some(lw)
    },
    {
      current: np,
      next: np,
      fallback: N.some(Sm)
    }
  ], Hx = function(u, c, d, h, S) {
    S === void 0 && (S = zx);
    var B = _t(S, function(L) {
      return L.current === d;
    });
    return B.bind(function(L) {
      return L.current(u, c, h, L.next).orThunk(function() {
        return L.fallback.bind(function(W) {
          return Hx(u, c, W, h);
        });
      });
    });
  }, ib = function() {
    var u = function(d, h) {
      return d.query().prevSibling(h);
    }, c = function(d) {
      return d.length > 0 ? N.some(d[d.length - 1]) : N.none();
    };
    return {
      sibling: u,
      first: c
    };
  }, lE = function() {
    var u = function(d, h) {
      return d.query().nextSibling(h);
    }, c = function(d) {
      return d.length > 0 ? N.some(d[0]) : N.none();
    };
    return {
      sibling: u,
      first: c
    };
  }, ub = {
    left: ib,
    right: lE
  }, Ph = function(u, c, d, h, S, B) {
    var L = Hx(u, c, h, S);
    return L.bind(function(W) {
      return B(W.item) ? N.none() : d(W.item) ? N.some(W.item) : Ph(u, W.item, d, W.mode, S, B);
    });
  }, sb = function(u, c, d, h) {
    return Ph(u, c, d, Sm, ub.left(), h);
  }, Vx = function(u, c, d, h) {
    return Ph(u, c, d, Sm, ub.right(), h);
  }, lb = function(u) {
    return function(c) {
      return u.property().children(c).length === 0;
    };
  }, Fl = function(u, c, d) {
    return cb(u, c, lb(u), d);
  }, cE = function(u, c, d) {
    return Ux(u, c, lb(u), d);
  }, cb = sb, Ux = Vx, Nh = Hp(), Ih = function(u, c) {
    return Fl(Nh, u, c);
  }, cw = function(u, c) {
    return cE(Nh, u, c);
  }, jx = function(u, c, d) {
    return cb(Nh, u, c, d);
  }, Wx = function(u, c, d) {
    return Ux(Nh, u, c, d);
  }, qx = function(u, c, d) {
    return No(u, c, d).isSome();
  }, fb = tf.generate([
    { none: ["message"] },
    { success: [] },
    { failedUp: ["cell"] },
    { failedDown: ["cell"] }
  ]), hd = function(u, c, d) {
    var h = u.getRect(c), S = u.getRect(d);
    return S.right > h.left && S.left < h.right;
  }, fE = function(u) {
    return zo(u, "tr");
  }, vE = function(u, c, d, h, S, B, L) {
    return zo(h, "td,th", L).bind(function(W) {
      return zo(c, "td,th", L).map(function(me) {
        return Xr(W, me) ? Xr(h, W) && tc(W) === S ? B(me) : fb.none("in same cell") : hr(fE, [
          W,
          me
        ]).fold(function() {
          return hd(u, me, W) ? fb.success() : B(me);
        }, function(Re) {
          return B(me);
        });
      });
    }).getOr(fb.none("default"));
  }, dE = function(u, c, d, h, S) {
    return u.fold(c, d, h, S);
  }, bd = he(he({}, fb), {
    verify: vE,
    cata: dE
  }), mE = function(u, c, d, h) {
    return {
      parent: u,
      children: c,
      element: d,
      index: h
    };
  }, fw = function(u) {
    return Co(u).bind(function(c) {
      var d = x(c);
      return gE(d, u).map(function(h) {
        return mE(c, d, u, h);
      });
    });
  }, gE = function(u, c) {
    return Pe(u, Ze(Xr, c));
  }, rp = function(u) {
    return va(u) === "br";
  }, vw = function(u, c, d) {
    return c(u, d).bind(function(h) {
      return ou(h) && k1(h).trim().length === 0 ? vw(h, c, d) : N.some(h);
    });
  }, Gx = function(u, c, d) {
    return d.traverse(c).orThunk(function() {
      return vw(c, d.gather, u);
    }).map(d.relative);
  }, vb = function(u, c) {
    return I(u, c).filter(rp).orThunk(function() {
      return I(u, c - 1).filter(rp);
    });
  }, Kx = function(u, c, d, h) {
    return vb(c, d).bind(function(S) {
      return h.traverse(S).fold(function() {
        return vw(S, h.gather, u).map(h.relative);
      }, function(B) {
        return fw(B).map(function(L) {
          return Ku.on(L.parent, L.index);
        });
      });
    });
  }, Xx = function(u, c, d, h) {
    var S = rp(c) ? Gx(u, c, h) : Kx(u, c, d, h);
    return S.map(function(B) {
      return {
        start: B,
        finish: B
      };
    });
  }, pE = function(u) {
    return bd.cata(u, function(c) {
      return N.none();
    }, function() {
      return N.none();
    }, function(c) {
      return N.some(am(c, 0));
    }, function(c) {
      return N.some(am(c, tc(c)));
    });
  }, db = function(u, c) {
    return {
      left: u.left,
      top: u.top + c,
      right: u.right,
      bottom: u.bottom + c
    };
  }, mb = function(u, c) {
    return {
      left: u.left,
      top: u.top - c,
      right: u.right,
      bottom: u.bottom - c
    };
  }, dw = function(u, c, d) {
    return {
      left: u.left + c,
      top: u.top + d,
      right: u.right + c,
      bottom: u.bottom + d
    };
  }, Yx = function(u) {
    return u.top;
  }, Zx = function(u) {
    return u.bottom;
  }, xm = function(u, c, d) {
    return d >= 0 && d < tc(c) ? u.getRangedRect(c, d, c, d + 1) : d > 0 ? u.getRangedRect(c, d - 1, c, d) : N.none();
  }, Fh = function(u) {
    return {
      left: u.left,
      top: u.top,
      right: u.right,
      bottom: u.bottom
    };
  }, gb = function(u, c) {
    return N.some(u.getRect(c));
  }, $h = function(u, c, d) {
    return Fa(c) ? gb(u, c).map(Fh) : ou(c) ? xm(u, c, d).map(Fh) : N.none();
  }, Jx = function(u, c) {
    return Fa(c) ? gb(u, c).map(Fh) : ou(c) ? u.getRangedRect(c, 0, c, tc(c)).map(Fh) : N.none();
  }, hv = 5, hE = 100, Tf = tf.generate([
    { none: [] },
    { retry: ["caret"] }
  ]), Qx = function(u, c) {
    return u.left < c.left || Math.abs(c.right - u.left) < 1 || u.left > c.right;
  }, pb = function(u, c, d) {
    return w1(c, ud).fold(Ct, function(h) {
      return Jx(u, h).exists(function(S) {
        return Qx(d, S);
      });
    });
  }, mw = function(u, c, d, h, S) {
    var B = db(S, hv);
    return Math.abs(d.bottom - h.bottom) < 1 || d.top > S.bottom ? Tf.retry(B) : d.top === S.bottom ? Tf.retry(db(S, 1)) : pb(u, c, S) ? Tf.retry(dw(B, hv, 0)) : Tf.none();
  }, bE = function(u, c, d, h, S) {
    var B = mb(S, hv);
    return Math.abs(d.top - h.top) < 1 || d.bottom < S.top ? Tf.retry(B) : d.bottom === S.top ? Tf.retry(mb(S, 1)) : pb(u, c, S) ? Tf.retry(dw(B, hv, 0)) : Tf.none();
  }, yd = {
    point: Yx,
    adjuster: bE,
    move: mb,
    gather: Ih
  }, e4 = {
    point: Zx,
    adjuster: mw,
    move: db,
    gather: cw
  }, t4 = function(u, c, d) {
    return u.elementFromPoint(c, d).filter(function(h) {
      return va(h) === "table";
    }).isSome();
  }, yE = function(u, c, d, h, S) {
    return gw(u, c, d, c.move(h, hv), S);
  }, gw = function(u, c, d, h, S) {
    return S === 0 ? N.some(h) : t4(u, h.left, c.point(h)) ? yE(u, c, d, h, S - 1) : u.situsFromPoint(h.left, c.point(h)).bind(function(B) {
      return B.start.fold(N.none, function(L) {
        return Jx(u, L).bind(function(W) {
          return c.adjuster(u, L, W, d, h).fold(N.none, function(me) {
            return gw(u, c, d, me, S - 1);
          });
        }).orThunk(function() {
          return N.some(h);
        });
      }, N.none);
    });
  }, ap = function(u, c) {
    return u.situsFromPoint(c.left, c.bottom + hv);
  }, op = function(u, c) {
    return u.situsFromPoint(c.left, c.top - hv);
  }, n4 = function(u, c, d) {
    return u.point(c) > d.getInnerHeight() ? N.some(u.point(c) - d.getInnerHeight()) : u.point(c) < 0 ? N.some(-u.point(c)) : N.none();
  }, pw = function(u, c, d) {
    var h = u.move(d, hv), S = gw(c, u, d, h, hE).getOr(h);
    return n4(u, S, c).fold(function() {
      return c.situsFromPoint(S.left, u.point(S));
    }, function(B) {
      return c.scrollBy(0, B), c.situsFromPoint(S.left, u.point(S) - B);
    });
  }, sc = {
    tryUp: Ze(pw, yd),
    tryDown: Ze(pw, e4),
    ieTryUp: op,
    ieTryDown: ap,
    getJumpSize: ze(hv)
  }, wd = 20, Er = function(u, c, d) {
    return u.getSelection().bind(function(h) {
      return Xx(c, h.finish, h.foffset, d).fold(function() {
        return N.some(am(h.finish, h.foffset));
      }, function(S) {
        var B = u.fromSitus(S), L = bd.verify(u, h.finish, h.foffset, B.finish, B.foffset, d.failure, c);
        return pE(L);
      });
    });
  }, hw = function(u, c, d, h, S, B) {
    return B === 0 ? N.none() : wE(u, c, d, h, S).bind(function(L) {
      var W = u.fromSitus(L), me = bd.verify(u, d, h, W.finish, W.foffset, S.failure, c);
      return bd.cata(me, function() {
        return N.none();
      }, function() {
        return N.some(L);
      }, function(Re) {
        return Xr(d, Re) && h === 0 ? Ef(u, d, h, mb, S) : hw(u, c, Re, 0, S, B - 1);
      }, function(Re) {
        return Xr(d, Re) && h === tc(Re) ? Ef(u, d, h, db, S) : hw(u, c, Re, tc(Re), S, B - 1);
      });
    });
  }, Ef = function(u, c, d, h, S) {
    return $h(u, c, d).bind(function(B) {
      return r4(u, S, h(B, sc.getJumpSize()));
    });
  }, r4 = function(u, c, d) {
    var h = Ue().browser;
    return h.isChrome() || h.isSafari() || h.isFirefox() || h.isEdge() ? c.otherRetry(u, d) : h.isIE() ? c.ieRetry(u, d) : N.none();
  }, wE = function(u, c, d, h, S) {
    return $h(u, d, h).bind(function(B) {
      return r4(u, S, B);
    });
  }, a4 = function(u, c, d) {
    return Er(u, c, d).bind(function(h) {
      return hw(u, c, h.element, h.offset, d, wd).map(u.fromSitus);
    });
  }, Lh = function(u, c) {
    return qx(u, function(d) {
      return Co(d).exists(function(h) {
        return Xr(h, c);
      });
    });
  }, zc = function(u, c, d, h, S) {
    return zo(h, "td,th", c).bind(function(B) {
      return zo(B, "table", c).bind(function(L) {
        return Lh(S, L) ? a4(u, c, d).bind(function(W) {
          return zo(W.finish, "td,th", c).map(function(me) {
            return {
              start: B,
              finish: me,
              range: W
            };
          });
        }) : N.none();
      });
    });
  }, hb = function(u, c, d, h, S, B) {
    return Ue().browser.isIE() ? N.none() : B(h, c).orThunk(function() {
      return zc(u, c, d, h, S).map(function(L) {
        var W = L.range;
        return tp.create(N.some(Il(W.start, W.soffset, W.finish, W.foffset)), !0);
      });
    });
  }, o4 = function(u, c) {
    return zo(u, "tr", c).bind(function(d) {
      return zo(d, "table", c).bind(function(h) {
        var S = zs(h, "tr");
        return Xr(d, S[0]) ? jx(h, function(B) {
          return I1(B).isSome();
        }, c).map(function(B) {
          var L = tc(B);
          return tp.create(N.some(Il(B, L, B, L)), !0);
        }) : N.none();
      });
    });
  }, qr = function(u, c) {
    return zo(u, "tr", c).bind(function(d) {
      return zo(d, "table", c).bind(function(h) {
        var S = zs(h, "tr");
        return Xr(d, S[S.length - 1]) ? Wx(h, function(B) {
          return N1(B).isSome();
        }, c).map(function(B) {
          return tp.create(N.some(Il(B, 0, B, 0)), !0);
        }) : N.none();
      });
    });
  }, bw = function(u, c, d, h, S, B, L) {
    return zc(u, d, h, S, B).bind(function(W) {
      return Lx(c, d, W.start, W.finish, L);
    });
  }, Jr = function(u, c) {
    return zo(u, "td,th", c);
  }, yw = function(u, c, d, h) {
    var S = Kg(), B = S.clear, L = function(rt) {
      S.on(function(jt) {
        h.clearBeforeUpdate(c), Jr(rt.target, d).each(function(Sn) {
          Iv(jt, Sn, d).each(function(ln) {
            var Wt = ln.boxes.getOr([]);
            if (Wt.length === 1) {
              var Pn = Wt[0], Ln = Fy(Pn) === "false", mr = Cc(Qd(rt.target), Pn, Xr);
              Ln && mr && (h.selectRange(c, Wt, Pn, Pn), u.selectContents(Pn));
            } else
              Wt.length > 1 && (h.selectRange(c, Wt, ln.start, ln.finish), u.selectContents(Sn));
          });
        });
      });
    }, W = function(rt) {
      h.clear(c), Jr(rt.target, d).each(S.set);
    }, me = function(rt) {
      L(rt);
    }, Re = function(rt) {
      L(rt), B();
    };
    return {
      clearstate: B,
      mousedown: W,
      mouseover: me,
      mouseup: Re
    };
  }, i4 = {
    traverse: O,
    gather: cw,
    relative: Ku.before,
    otherRetry: sc.tryDown,
    ieRetry: sc.ieTryDown,
    failure: bd.failedDown
  }, u4 = {
    traverse: V,
    gather: Ih,
    relative: Ku.before,
    otherRetry: sc.tryUp,
    ieRetry: sc.ieTryUp,
    failure: bd.failedUp
  }, ip = function(u) {
    return function(c) {
      return c === u;
    };
  }, up = ip(38), sp = ip(40), lp = function(u) {
    return u >= 37 && u <= 40;
  }, CE = {
    isBackward: ip(37),
    isForward: ip(39)
  }, zr = {
    isBackward: ip(39),
    isForward: ip(37)
  }, s4 = function(u) {
    var c = u !== void 0 ? u.dom : document, d = c.body.scrollLeft || c.documentElement.scrollLeft, h = c.body.scrollTop || c.documentElement.scrollTop;
    return no(d, h);
  }, ww = function(u, c, d) {
    var h = d !== void 0 ? d.dom : document, S = h.defaultView;
    S && S.scrollBy(u, c);
  }, zh = function(u) {
    var c = function(Ln, mr) {
      return Nt.fromPoint(Nt.fromDom(u.document), Ln, mr);
    }, d = function(Ln) {
      return Ln.dom.getBoundingClientRect();
    }, h = function(Ln, mr, Ea, dr) {
      var Ur = gv.exact(Ln, mr, Ea, dr);
      return Ox(u, Ur);
    }, S = function() {
      return Ax(u).map(function(Ln) {
        return Fx(u, Ln);
      });
    }, B = function(Ln) {
      var mr = gv.relative(Ln.start, Ln.finish);
      return Fx(u, mr);
    }, L = function(Ln, mr) {
      return rb(u, Ln, mr).map(function(Ea) {
        return Ix.create(Ea.start, Ea.soffset, Ea.finish, Ea.foffset);
      });
    }, W = function() {
      Dx(u);
    }, me = function(Ln) {
      Ln === void 0 && (Ln = !1), Ax(u).each(function(mr) {
        return mr.fold(function(Ea) {
          return Ea.collapse(Ln);
        }, function(Ea, dr) {
          var Ur = Ln ? Ea : dr;
          nb(u, Ur, Ur);
        }, function(Ea, dr, Ur, ca) {
          var sa = Ln ? Ea : Ur, oi = Ln ? dr : ca;
          tb(u, sa, oi, sa, oi);
        });
      });
    }, Re = function(Ln) {
      Cm(u, Ln, !1);
    }, rt = function(Ln) {
      Cm(u, Ln);
    }, jt = function(Ln) {
      tb(u, Ln.start, Ln.soffset, Ln.finish, Ln.foffset);
    }, Sn = function(Ln, mr) {
      nb(u, Ln, mr);
    }, ln = function() {
      return u.innerHeight;
    }, Wt = function() {
      var Ln = s4(Nt.fromDom(u.document));
      return Ln.top;
    }, Pn = function(Ln, mr) {
      ww(Ln, mr, Nt.fromDom(u.document));
    };
    return {
      elementFromPoint: c,
      getRect: d,
      getRangedRect: h,
      getSelection: S,
      fromSitus: B,
      situsFromPoint: L,
      clearSelection: W,
      collapseSelection: me,
      setSelection: jt,
      setRelativeSelection: Sn,
      selectNode: Re,
      selectContents: rt,
      getInnerHeight: ln,
      getScrollY: Wt,
      scrollBy: Pn
    };
  }, Cd = function(u, c) {
    return {
      rows: u,
      cols: c
    };
  }, l4 = function(u, c, d, h) {
    var S = zh(u), B = yw(S, c, d, h);
    return {
      clearstate: B.clearstate,
      mousedown: B.mousedown,
      mouseover: B.mouseover,
      mouseup: B.mouseup
    };
  }, bb = function(u, c, d, h) {
    var S = zh(u), B = function() {
      return h.clear(c), N.none();
    }, L = function(me, Re, rt, jt, Sn, ln) {
      var Wt = me.raw, Pn = Wt.which, Ln = Wt.shiftKey === !0, mr = Jm(c, h.selectedSelector).fold(function() {
        return lp(Pn) && !Ln && h.clearBeforeUpdate(c), sp(Pn) && Ln ? Ze(bw, S, c, d, i4, jt, Re, h.selectRange) : up(Pn) && Ln ? Ze(bw, S, c, d, u4, jt, Re, h.selectRange) : sp(Pn) ? Ze(hb, S, d, i4, jt, Re, qr) : up(Pn) ? Ze(hb, S, d, u4, jt, Re, o4) : N.none;
      }, function(Ea) {
        var dr = function(Ur) {
          return function() {
            var ca = Xe(Ur, function(sa) {
              return ab(sa.rows, sa.cols, c, Ea, h);
            });
            return ca.fold(function() {
              return Xl(c, h.firstSelectedSelector, h.lastSelectedSelector).map(function(sa) {
                var oi = sp(Pn) || ln.isForward(Pn) ? Ku.after : Ku.before;
                return S.setRelativeSelection(Ku.on(sa.first, 0), oi(sa.table)), h.clear(c), tp.create(N.none(), !0);
              });
            }, function(sa) {
              return N.some(tp.create(N.none(), !0));
            });
          };
        };
        return sp(Pn) && Ln ? dr([Cd(1, 0)]) : up(Pn) && Ln ? dr([Cd(-1, 0)]) : ln.isBackward(Pn) && Ln ? dr([
          Cd(0, -1),
          Cd(-1, 0)
        ]) : ln.isForward(Pn) && Ln ? dr([
          Cd(0, 1),
          Cd(1, 0)
        ]) : lp(Pn) && !Ln ? B : N.none;
      });
      return mr();
    }, W = function(me, Re, rt, jt, Sn) {
      return Jm(c, h.selectedSelector).fold(function() {
        var ln = me.raw, Wt = ln.which, Pn = ln.shiftKey === !0;
        return Pn && lp(Wt) ? $x(c, d, Re, rt, jt, Sn, h.selectRange) : N.none();
      }, N.none);
    };
    return {
      keydown: L,
      keyup: W
    };
  }, Cw = function(u, c, d, h) {
    var S = zh(u);
    return function(B, L) {
      h.clearBeforeUpdate(c), Iv(B, L, d).each(function(W) {
        var me = W.boxes.getOr([]);
        h.selectRange(c, me, W.start, W.finish), S.selectContents(L), S.collapseSelection();
      });
    };
  }, SE = function(u, c) {
    Je(c, function(d) {
      Ts(u, d);
    });
  }, c4 = function(u) {
    return function(c) {
      Ri(c, u);
    };
  }, xE = function(u) {
    return function(c) {
      SE(c, u);
    };
  }, yb = function(u) {
    var c = c4(u.selected), d = xE([
      u.selected,
      u.lastSelected,
      u.firstSelected
    ]), h = function(B) {
      var L = zs(B, u.selectedSelector);
      Je(L, d);
    }, S = function(B, L, W, me) {
      h(B), Je(L, c), Ri(W, u.firstSelected), Ri(me, u.lastSelected);
    };
    return {
      clearBeforeUpdate: h,
      clear: h,
      selectRange: S,
      selectedSelector: u.selectedSelector,
      firstSelectedSelector: u.firstSelectedSelector,
      lastSelectedSelector: u.lastSelectedSelector
    };
  }, kE = function(u, c, d) {
    var h = function(me) {
      mo(me, u.selected), mo(me, u.firstSelected), mo(me, u.lastSelected);
    }, S = function(me) {
      Ei(me, u.selected, "1");
    }, B = function(me) {
      L(me), d();
    }, L = function(me) {
      var Re = zs(me, u.selectedSelector + "," + u.firstSelectedSelector + "," + u.lastSelectedSelector);
      Je(Re, h);
    }, W = function(me, Re, rt, jt) {
      B(me), Je(Re, S), Ei(rt, u.firstSelected, "1"), Ei(jt, u.lastSelected, "1"), c(Re, rt, jt);
    };
    return {
      clearBeforeUpdate: L,
      clear: B,
      selectRange: W,
      selectedSelector: u.selectedSelector,
      firstSelectedSelector: u.firstSelectedSelector,
      lastSelectedSelector: u.lastSelectedSelector
    };
  }, wb = {
    byClass: yb,
    byAttr: kE
  }, f4 = function(u, c) {
    var d = u.slice(0, c[c.length - 1].row + 1), h = C0(d);
    return He(h, function(S) {
      var B = S.cells.slice(0, c[c.length - 1].column + 1);
      return Me(B, function(L) {
        return L.element;
      });
    });
  }, v4 = function(u, c) {
    var d = u.slice(c[0].row + c[0].rowspan - 1, u.length), h = C0(d);
    return He(h, function(S) {
      var B = S.cells.slice(c[0].column + c[0].colspan - 1, S.cells.length);
      return Me(B, function(L) {
        return L.element;
      });
    });
  }, TE = function(u, c, d) {
    var h = ra.fromTable(u), S = Nc(h, c);
    return S.map(function(B) {
      var L = ad(h, d, !1), W = f4(L, B), me = v4(L, B);
      return {
        upOrLeftCells: W,
        downOrRightCells: me
      };
    });
  }, d4 = tinymce.util.Tools.resolve("tinymce.Env"), Sw = function(u) {
    return io(Nt.fromDom(u.target), "ephox-snooker-resizer-bar") === !1;
  };
  function wa(u, c, d) {
    var h = function(L, W, me) {
      d.targets().each(function(Re) {
        var rt = Oo(W);
        rt.each(function(jt) {
          var Sn = m0(u), ln = Zr(ue, Nt.fromDom(u.getDoc()), Sn), Wt = TE(jt, Re, ln);
          wg(u, L, W, me, Wt);
        });
      });
    }, S = function() {
      return pS(u);
    }, B = wb.byAttr(hl, h, S);
    return u.on("init", function(L) {
      var W = u.getWin(), me = uf(u), Re = pl(u), rt = function() {
        var Ca = u.selection, Gr = Nt.fromDom(Ca.getStart()), ma = Nt.fromDom(Ca.getEnd()), Ga = hr(Oo, [
          Gr,
          ma
        ]);
        Ga.fold(function() {
          return B.clear(me);
        }, ue);
      }, jt = l4(W, me, Re, B), Sn = bb(W, me, Re, B), ln = Cw(W, me, Re, B), Wt = function(Ca) {
        return Ca.raw.shiftKey === !0;
      };
      u.on("TableSelectorChange", function(Ca) {
        return ln(Ca.start, Ca.finish);
      });
      var Pn = function(Ca, Gr) {
        !Wt(Ca) || (Gr.kill && Ca.kill(), Gr.selection.each(function(ma) {
          var Ga = gv.relative(ma.start, ma.finish), jo = gd(W, Ga);
          u.selection.setRng(jo);
        }));
      }, Ln = function(Ca) {
        var Gr = sv(Ca);
        if (Gr.raw.shiftKey && lp(Gr.raw.which)) {
          var ma = u.selection.getRng(), Ga = Nt.fromDom(ma.startContainer), jo = Nt.fromDom(ma.endContainer);
          Sn.keyup(Gr, Ga, ma.startOffset, jo, ma.endOffset).each(function(bv) {
            Pn(Gr, bv);
          });
        }
      }, mr = function(Ca) {
        var Gr = sv(Ca);
        c().each(function(Ua) {
          return Ua.hideBars();
        });
        var ma = u.selection.getRng(), Ga = Nt.fromDom(ma.startContainer), jo = Nt.fromDom(ma.endContainer), bv = qs(CE, zr)(Nt.fromDom(u.selection.getStart()));
        Sn.keydown(Gr, Ga, ma.startOffset, jo, ma.endOffset, bv).each(function(Ua) {
          Pn(Gr, Ua);
        }), c().each(function(Ua) {
          return Ua.showBars();
        });
      }, Ea = function(Ca) {
        return Ca.button === 0;
      }, dr = function(Ca) {
        return Ca.buttons === void 0 || d4.browser.isEdge() && Ca.buttons === 0 ? !0 : (Ca.buttons & 1) !== 0;
      }, Ur = function(Ca) {
        jt.clearstate();
      }, ca = function(Ca) {
        Ea(Ca) && Sw(Ca) && jt.mousedown(sv(Ca));
      }, sa = function(Ca) {
        dr(Ca) && Sw(Ca) && jt.mouseover(sv(Ca));
      }, oi = function(Ca) {
        Ea(Ca) && Sw(Ca) && jt.mouseup(sv(Ca));
      }, Ji = function() {
        var Ca = dv(Nt.fromDom(me)), Gr = dv(0), ma = function(Ga) {
          var jo = Nt.fromDom(Ga.target);
          if (va(jo) === "td" || va(jo) === "th") {
            var bv = Ca.get(), Ua = Gr.get();
            Xr(bv, jo) && Ga.timeStamp - Ua < 300 && (Ga.preventDefault(), ln(jo, jo));
          }
          Ca.set(jo), Gr.set(Ga.timeStamp);
        };
        return { touchEnd: ma };
      }, Qi = Ji();
      u.on("dragstart", Ur), u.on("mousedown", ca), u.on("mouseover", sa), u.on("mouseup", oi), u.on("touchend", Qi.touchEnd), u.on("keyup", Ln), u.on("keydown", mr), u.on("NodeChange", rt);
    }), { clear: B.clear };
  }
  var m4 = function(u, c) {
    return Pr(u, c).isSome();
  }, Cb = function(u, c) {
    var d = dv(N.none()), h = dv([]), S = N.none(), B = wo("caption"), L = function(Gr) {
      return S.forall(function(ma) {
        return !ma[Gr];
      });
    }, W = function() {
      return Fo(jd(u), pl(u));
    }, me = function() {
      return Fo(ur(u), pl(u));
    }, Re = function() {
      return W().bind(function(Gr) {
        return jf(Vs(Oo(Gr), me().bind(Oo), function(ma, Ga) {
          return Xr(ma, Ga) ? B(Gr) ? N.some(ky(Gr)) : N.some(Wd(c, ma, Gr)) : N.none();
        }));
      });
    }, rt = function(Gr) {
      var ma = Oo(Gr.element);
      return ma.map(function(Ga) {
        var jo = ra.fromTable(Ga), bv = Nc(jo, Gr).getOr([]), Ua = se(bv, function(Zs, eu) {
          return eu.isLocked && (Zs.onAny = !0, eu.column === 0 ? Zs.onFirst = !0 : eu.column + eu.colspan >= jo.grid.columns && (Zs.onLast = !0)), Zs;
        }, {
          onAny: !1,
          onFirst: !1,
          onLast: !1
        });
        return {
          mergeable: a2(jo, Gr).isSome(),
          unmergeable: k0(jo, Gr).isSome(),
          locked: Ua
        };
      });
    }, jt = function() {
      d.set(gt(Re)()), S = d.get().bind(rt), Je(h.get(), function(Gr) {
        return Gr();
      });
    }, Sn = function(Gr) {
      return Gr(), h.set(h.get().concat([Gr])), function() {
        h.set(Tt(h.get(), function(ma) {
          return ma !== Gr;
        }));
      };
    }, ln = function(Gr, ma) {
      return Sn(function() {
        return d.get().fold(function() {
          Gr.setDisabled(!0);
        }, function(Ga) {
          Gr.setDisabled(ma(Ga));
        });
      });
    }, Wt = function(Gr, ma, Ga) {
      return Sn(function() {
        return d.get().fold(function() {
          Gr.setDisabled(!0), Gr.setActive(!1);
        }, function(jo) {
          Gr.setDisabled(ma(jo)), Gr.setActive(Ga(jo));
        });
      });
    }, Pn = function(Gr) {
      return S.exists(function(ma) {
        return ma.locked[Gr];
      });
    }, Ln = function(Gr) {
      return ln(Gr, function(ma) {
        return !1;
      });
    }, mr = function(Gr) {
      return ln(Gr, function(ma) {
        return B(ma.element);
      });
    }, Ea = function(Gr) {
      return function(ma) {
        return ln(ma, function(Ga) {
          return B(Ga.element) || Pn(Gr);
        });
      };
    }, dr = function(Gr) {
      return function(ma) {
        return ln(ma, function(Ga) {
          return B(Ga.element) || Gr().isNone();
        });
      };
    }, Ur = function(Gr, ma) {
      return function(Ga) {
        return ln(Ga, function(jo) {
          return B(jo.element) || Gr().isNone() || Pn(ma);
        });
      };
    }, ca = function(Gr) {
      return ln(Gr, function(ma) {
        return L("mergeable");
      });
    }, sa = function(Gr) {
      return ln(Gr, function(ma) {
        return L("unmergeable");
      });
    }, oi = function(Gr) {
      return Wt(Gr, Ct, function(ma) {
        var Ga = Oo(ma.element, pl(u));
        return Ga.exists(function(jo) {
          return m4(jo, "caption");
        });
      });
    }, Ji = function(Gr, ma) {
      return function(Ga) {
        return Wt(Ga, function(jo) {
          return B(jo.element);
        }, function() {
          return u.queryCommandValue(Gr) === ma;
        });
      };
    }, Qi = Ji("mceTableRowType", "header"), Ca = Ji("mceTableColType", "th");
    return u.on("NodeChange ExecCommand TableSelectorChange", jt), {
      onSetupTable: Ln,
      onSetupCellOrRow: mr,
      onSetupColumn: Ea,
      onSetupPasteable: dr,
      onSetupPasteableColumn: Ur,
      onSetupMergeable: ca,
      onSetupUnmergeable: sa,
      resetTargets: jt,
      onSetupTableWithCaption: oi,
      onSetupTableRowHeaders: Qi,
      onSetupTableColumnHeaders: Ca,
      targets: d.get
    };
  }, xw = function(u, c, d, h) {
    u.ui.registry.addMenuButton("table", {
      tooltip: "Table",
      icon: "table",
      fetch: function(W) {
        return W("inserttable | cell row column | advtablesort | tableprops deletetable");
      }
    });
    var S = function(W) {
      return function() {
        return u.execCommand(W);
      };
    };
    u.ui.registry.addButton("tableprops", {
      tooltip: "Table properties",
      onAction: S("mceTableProps"),
      icon: "table",
      onSetup: d.onSetupTable
    }), u.ui.registry.addButton("tabledelete", {
      tooltip: "Delete table",
      onAction: S("mceTableDelete"),
      icon: "table-delete-table",
      onSetup: d.onSetupTable
    }), u.ui.registry.addButton("tablecellprops", {
      tooltip: "Cell properties",
      onAction: S("mceTableCellProps"),
      icon: "table-cell-properties",
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addButton("tablemergecells", {
      tooltip: "Merge cells",
      onAction: S("mceTableMergeCells"),
      icon: "table-merge-cells",
      onSetup: d.onSetupMergeable
    }), u.ui.registry.addButton("tablesplitcells", {
      tooltip: "Split cell",
      onAction: S("mceTableSplitCells"),
      icon: "table-split-cells",
      onSetup: d.onSetupUnmergeable
    }), u.ui.registry.addButton("tableinsertrowbefore", {
      tooltip: "Insert row before",
      onAction: S("mceTableInsertRowBefore"),
      icon: "table-insert-row-above",
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addButton("tableinsertrowafter", {
      tooltip: "Insert row after",
      onAction: S("mceTableInsertRowAfter"),
      icon: "table-insert-row-after",
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addButton("tabledeleterow", {
      tooltip: "Delete row",
      onAction: S("mceTableDeleteRow"),
      icon: "table-delete-row",
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addButton("tablerowprops", {
      tooltip: "Row properties",
      onAction: S("mceTableRowProps"),
      icon: "table-row-properties",
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addButton("tableinsertcolbefore", {
      tooltip: "Insert column before",
      onAction: S("mceTableInsertColBefore"),
      icon: "table-insert-column-before",
      onSetup: d.onSetupColumn("onFirst")
    }), u.ui.registry.addButton("tableinsertcolafter", {
      tooltip: "Insert column after",
      onAction: S("mceTableInsertColAfter"),
      icon: "table-insert-column-after",
      onSetup: d.onSetupColumn("onLast")
    }), u.ui.registry.addButton("tabledeletecol", {
      tooltip: "Delete column",
      onAction: S("mceTableDeleteCol"),
      icon: "table-delete-column",
      onSetup: d.onSetupColumn("onAny")
    }), u.ui.registry.addButton("tablecutrow", {
      tooltip: "Cut row",
      icon: "cut-row",
      onAction: S("mceTableCutRow"),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addButton("tablecopyrow", {
      tooltip: "Copy row",
      icon: "duplicate-row",
      onAction: S("mceTableCopyRow"),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addButton("tablepasterowbefore", {
      tooltip: "Paste row before",
      icon: "paste-row-before",
      onAction: S("mceTablePasteRowBefore"),
      onSetup: d.onSetupPasteable(h.getRows)
    }), u.ui.registry.addButton("tablepasterowafter", {
      tooltip: "Paste row after",
      icon: "paste-row-after",
      onAction: S("mceTablePasteRowAfter"),
      onSetup: d.onSetupPasteable(h.getRows)
    }), u.ui.registry.addButton("tablecutcol", {
      tooltip: "Cut column",
      icon: "cut-column",
      onAction: S("mceTableCutCol"),
      onSetup: d.onSetupColumn("onAny")
    }), u.ui.registry.addButton("tablecopycol", {
      tooltip: "Copy column",
      icon: "duplicate-column",
      onAction: S("mceTableCopyCol"),
      onSetup: d.onSetupColumn("onAny")
    }), u.ui.registry.addButton("tablepastecolbefore", {
      tooltip: "Paste column before",
      icon: "paste-column-before",
      onAction: S("mceTablePasteColBefore"),
      onSetup: d.onSetupPasteableColumn(h.getColumns, "onFirst")
    }), u.ui.registry.addButton("tablepastecolafter", {
      tooltip: "Paste column after",
      icon: "paste-column-after",
      onAction: S("mceTablePasteColAfter"),
      onSetup: d.onSetupPasteableColumn(h.getColumns, "onLast")
    }), u.ui.registry.addButton("tableinsertdialog", {
      tooltip: "Insert table",
      onAction: S("mceInsertTable"),
      icon: "table"
    });
    var B = fd(ch(u));
    B.length !== 0 && u.ui.registry.addMenuButton("tableclass", {
      icon: "table-classes",
      tooltip: "Table styles",
      fetch: mm(u, c, B, "tableclass", function(W) {
        return u.execCommand("mceTableToggleClass", !1, W);
      }),
      onSetup: d.onSetupTable
    });
    var L = fd(mf(u));
    L.length !== 0 && u.ui.registry.addMenuButton("tablecellclass", {
      icon: "table-cell-classes",
      tooltip: "Cell styles",
      fetch: mm(u, c, L, "tablecellclass", function(W) {
        return u.execCommand("mceTableCellToggleClass", !1, W);
      }),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addMenuButton("tablecellvalign", {
      icon: "vertical-align",
      tooltip: "Vertical align",
      fetch: mm(u, c, Gg, "tablecellverticalalign", cd(u, "vertical-align")),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addMenuButton("tablecellborderwidth", {
      icon: "border-width",
      tooltip: "Border width",
      fetch: mm(u, c, bS(u), "tablecellborderwidth", cd(u, "border-width")),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addMenuButton("tablecellborderstyle", {
      icon: "border-style",
      tooltip: "Border style",
      fetch: mm(u, c, ju(u), "tablecellborderstyle", cd(u, "border-style")),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addToggleButton("tablecaption", {
      tooltip: "Table caption",
      onAction: S("mceTableToggleCaption"),
      icon: "table-caption",
      onSetup: d.onSetupTableWithCaption
    }), u.ui.registry.addMenuButton("tablecellbackgroundcolor", {
      icon: "cell-background-color",
      tooltip: "Background color",
      fetch: function(W) {
        return W(Xg(u, Gy(u), "background-color"));
      },
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addMenuButton("tablecellbordercolor", {
      icon: "cell-border-color",
      tooltip: "Border color",
      fetch: function(W) {
        return W(Xg(u, Ky(u), "border-color"));
      },
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addToggleButton("tablerowheader", {
      tooltip: "Row header",
      icon: "table-top-header",
      onAction: N2(u),
      onSetup: d.onSetupTableRowHeaders
    }), u.ui.registry.addToggleButton("tablecolheader", {
      tooltip: "Column header",
      icon: "table-left-header",
      onAction: I2(u),
      onSetup: d.onSetupTableColumnHeaders
    });
  }, g4 = function(u) {
    var c = function(h) {
      return u.dom.is(h, "table") && u.getBody().contains(h);
    }, d = Xk(u);
    d.length > 0 && u.ui.registry.addContextToolbar("table", {
      predicate: c,
      items: d,
      scope: "node",
      position: "node"
    });
  }, kw = function(u, c, d, h) {
    var S = function(ln) {
      return function() {
        return u.execCommand(ln);
      };
    }, B = function(ln) {
      u.execCommand("mceInsertTable", !1, {
        rows: ln.numRows,
        columns: ln.numColumns
      });
    }, L = {
      text: "Table properties",
      onSetup: d.onSetupTable,
      onAction: S("mceTableProps")
    }, W = {
      text: "Delete table",
      icon: "table-delete-table",
      onSetup: d.onSetupTable,
      onAction: S("mceTableDelete")
    };
    u.ui.registry.addMenuItem("tableinsertrowbefore", {
      text: "Insert row before",
      icon: "table-insert-row-above",
      onAction: S("mceTableInsertRowBefore"),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addMenuItem("tableinsertrowafter", {
      text: "Insert row after",
      icon: "table-insert-row-after",
      onAction: S("mceTableInsertRowAfter"),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addMenuItem("tabledeleterow", {
      text: "Delete row",
      icon: "table-delete-row",
      onAction: S("mceTableDeleteRow"),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addMenuItem("tablerowprops", {
      text: "Row properties",
      icon: "table-row-properties",
      onAction: S("mceTableRowProps"),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addMenuItem("tablecutrow", {
      text: "Cut row",
      icon: "cut-row",
      onAction: S("mceTableCutRow"),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addMenuItem("tablecopyrow", {
      text: "Copy row",
      icon: "duplicate-row",
      onAction: S("mceTableCopyRow"),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addMenuItem("tablepasterowbefore", {
      text: "Paste row before",
      icon: "paste-row-before",
      onAction: S("mceTablePasteRowBefore"),
      onSetup: d.onSetupPasteable(h.getRows)
    }), u.ui.registry.addMenuItem("tablepasterowafter", {
      text: "Paste row after",
      icon: "paste-row-after",
      onAction: S("mceTablePasteRowAfter"),
      onSetup: d.onSetupPasteable(h.getRows)
    });
    var me = {
      type: "nestedmenuitem",
      text: "Row",
      getSubmenuItems: ze("tableinsertrowbefore tableinsertrowafter tabledeleterow tablerowprops | tablecutrow tablecopyrow tablepasterowbefore tablepasterowafter")
    };
    u.ui.registry.addMenuItem("tableinsertcolumnbefore", {
      text: "Insert column before",
      icon: "table-insert-column-before",
      onAction: S("mceTableInsertColBefore"),
      onSetup: d.onSetupColumn("onFirst")
    }), u.ui.registry.addMenuItem("tableinsertcolumnafter", {
      text: "Insert column after",
      icon: "table-insert-column-after",
      onAction: S("mceTableInsertColAfter"),
      onSetup: d.onSetupColumn("onLast")
    }), u.ui.registry.addMenuItem("tabledeletecolumn", {
      text: "Delete column",
      icon: "table-delete-column",
      onAction: S("mceTableDeleteCol"),
      onSetup: d.onSetupColumn("onAny")
    }), u.ui.registry.addMenuItem("tablecutcolumn", {
      text: "Cut column",
      icon: "cut-column",
      onAction: S("mceTableCutCol"),
      onSetup: d.onSetupColumn("onAny")
    }), u.ui.registry.addMenuItem("tablecopycolumn", {
      text: "Copy column",
      icon: "duplicate-column",
      onAction: S("mceTableCopyCol"),
      onSetup: d.onSetupColumn("onAny")
    }), u.ui.registry.addMenuItem("tablepastecolumnbefore", {
      text: "Paste column before",
      icon: "paste-column-before",
      onAction: S("mceTablePasteColBefore"),
      onSetup: d.onSetupPasteableColumn(h.getColumns, "onFirst")
    }), u.ui.registry.addMenuItem("tablepastecolumnafter", {
      text: "Paste column after",
      icon: "paste-column-after",
      onAction: S("mceTablePasteColAfter"),
      onSetup: d.onSetupPasteableColumn(h.getColumns, "onLast")
    });
    var Re = {
      type: "nestedmenuitem",
      text: "Column",
      getSubmenuItems: ze("tableinsertcolumnbefore tableinsertcolumnafter tabledeletecolumn | tablecutcolumn tablecopycolumn tablepastecolumnbefore tablepastecolumnafter")
    };
    u.ui.registry.addMenuItem("tablecellprops", {
      text: "Cell properties",
      icon: "table-cell-properties",
      onAction: S("mceTableCellProps"),
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addMenuItem("tablemergecells", {
      text: "Merge cells",
      icon: "table-merge-cells",
      onAction: S("mceTableMergeCells"),
      onSetup: d.onSetupMergeable
    }), u.ui.registry.addMenuItem("tablesplitcells", {
      text: "Split cell",
      icon: "table-split-cells",
      onAction: S("mceTableSplitCells"),
      onSetup: d.onSetupUnmergeable
    });
    var rt = {
      type: "nestedmenuitem",
      text: "Cell",
      getSubmenuItems: ze("tablecellprops tablemergecells tablesplitcells")
    };
    yS(u) === !1 ? u.ui.registry.addMenuItem("inserttable", {
      text: "Table",
      icon: "table",
      onAction: S("mceInsertTable")
    }) : u.ui.registry.addNestedMenuItem("inserttable", {
      text: "Table",
      icon: "table",
      getSubmenuItems: function() {
        return [{
          type: "fancymenuitem",
          fancytype: "inserttable",
          onAction: B
        }];
      }
    }), u.ui.registry.addMenuItem("inserttabledialog", {
      text: "Insert table",
      icon: "table",
      onAction: S("mceInsertTable")
    }), u.ui.registry.addMenuItem("tableprops", L), u.ui.registry.addMenuItem("deletetable", W), u.ui.registry.addNestedMenuItem("row", me), u.ui.registry.addNestedMenuItem("column", Re), u.ui.registry.addNestedMenuItem("cell", rt), u.ui.registry.addContextMenu("table", {
      update: function() {
        return d.resetTargets(), d.targets().fold(ze(""), function(ln) {
          return va(ln.element) === "caption" ? "tableprops deletetable" : "cell row column | advtablesort | tableprops deletetable";
        });
      }
    });
    var jt = fd(ch(u));
    jt.length !== 0 && u.ui.registry.addNestedMenuItem("tableclass", {
      icon: "table-classes",
      text: "Table styles",
      getSubmenuItems: function() {
        return oc(u, c, jt, "tableclass", function(ln) {
          return u.execCommand("mceTableToggleClass", !1, ln);
        });
      },
      onSetup: d.onSetupTable
    });
    var Sn = fd(mf(u));
    Sn.length !== 0 && u.ui.registry.addNestedMenuItem("tablecellclass", {
      icon: "table-cell-classes",
      text: "Cell styles",
      getSubmenuItems: function() {
        return oc(u, c, Sn, "tablecellclass", function(ln) {
          return u.execCommand("mceTableCellToggleClass", !1, ln);
        });
      },
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addNestedMenuItem("tablecellvalign", {
      icon: "vertical-align",
      text: "Vertical align",
      getSubmenuItems: function() {
        return oc(u, c, Gg, "tablecellverticalalign", cd(u, "vertical-align"));
      },
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addNestedMenuItem("tablecellborderwidth", {
      icon: "border-width",
      text: "Border width",
      getSubmenuItems: function() {
        return oc(u, c, bS(u), "tablecellborderwidth", cd(u, "border-width"));
      },
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addNestedMenuItem("tablecellborderstyle", {
      icon: "border-style",
      text: "Border style",
      getSubmenuItems: function() {
        return oc(u, c, ju(u), "tablecellborderstyle", cd(u, "border-style"));
      },
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addToggleMenuItem("tablecaption", {
      icon: "table-caption",
      text: "Table caption",
      onAction: S("mceTableToggleCaption"),
      onSetup: d.onSetupTableWithCaption
    }), u.ui.registry.addNestedMenuItem("tablecellbackgroundcolor", {
      icon: "cell-background-color",
      text: "Background color",
      getSubmenuItems: function() {
        return Xg(u, Gy(u), "background-color");
      },
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addNestedMenuItem("tablecellbordercolor", {
      icon: "cell-border-color",
      text: "Border color",
      getSubmenuItems: function() {
        return Xg(u, Ky(u), "border-color");
      },
      onSetup: d.onSetupCellOrRow
    }), u.ui.registry.addToggleMenuItem("tablerowheader", {
      text: "Row header",
      icon: "table-top-header",
      onAction: N2(u),
      onSetup: d.onSetupTableRowHeaders
    }), u.ui.registry.addToggleMenuItem("tablecolheader", {
      text: "Column header",
      icon: "table-left-header",
      onAction: I2(u),
      onSetup: d.onSetupTableColumnHeaders
    });
  }, Hh = function(u) {
    var c = Bu(function() {
      return uf(u);
    }, function() {
      return fu(jd(u), pl(u));
    }, hl.selectedSelector), d = Cb(u, c), h = p0(u), S = wa(u, h.lazyResize, d), B = PT(u, S, h.lazyWire), L = Y0();
    return K0(u, B, S, c, L), X0(u, B, c), nc(u, c, B), kw(u, c, d, L), xw(u, c, d, L), g4(u), u.on("PreInit", function() {
      u.serializer.addTempAttr(hl.firstSelected), u.serializer.addTempAttr(hl.lastSelected), KT(u);
    }), Mc(u) && u.on("keydown", function(W) {
      Nx(W, u, S);
    }), u.on("remove", function() {
      h.destroy();
    }), yf(u, L, h, d);
  };
  function Sb() {
    WC.add("table", Hh);
  }
  Sb();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(Ie) {
    var St = typeof Ie;
    return Ie === null ? "null" : St === "object" && (Array.prototype.isPrototypeOf(Ie) || Ie.constructor && Ie.constructor.name === "Array") ? "array" : St === "object" && (String.prototype.isPrototypeOf(Ie) || Ie.constructor && Ie.constructor.name === "String") ? "string" : St;
  }, w = function(Ie) {
    return function(St) {
      return y(St) === Ie;
    };
  }, E = function(Ie) {
    return function(St) {
      return typeof St === Ie;
    };
  }, P = w("string"), H = E("function"), X = function() {
  }, j = function(Ie) {
    return function() {
      return Ie;
    };
  }, le = function(Ie) {
    return Ie;
  };
  function Q(Ie) {
    for (var St = [], Xe = 1; Xe < arguments.length; Xe++)
      St[Xe - 1] = arguments[Xe];
    return function() {
      for (var he = [], tt = 0; tt < arguments.length; tt++)
        he[tt] = arguments[tt];
      var gt = St.concat(he);
      return Ie.apply(null, gt);
    };
  }
  var pe = j(!1), Y = j(!0), D = tinymce.util.Tools.resolve("tinymce.util.Tools"), J = tinymce.util.Tools.resolve("tinymce.util.XHR"), ue = function(Ie) {
    return Ie.getParam("template_cdate_classes", "cdate");
  }, ee = function(Ie) {
    return Ie.getParam("template_mdate_classes", "mdate");
  }, Ge = function(Ie) {
    return Ie.getParam("template_selected_content_classes", "selcontent");
  }, ze = function(Ie) {
    return Ie.getParam("template_preview_replace_values");
  }, ht = function(Ie) {
    return Ie.getParam("content_style", "", "string");
  }, ie = function(Ie) {
    return Ie.getParam("content_css_cors", !1, "boolean");
  }, Ze = function(Ie) {
    return Ie.getParam("template_replace_values");
  }, De = function(Ie) {
    return Ie.getParam("templates");
  }, Pt = function(Ie) {
    return Ie.getParam("template_cdate_format", Ie.translate("%Y-%m-%d"));
  }, Ct = function(Ie) {
    return Ie.getParam("template_mdate_format", Ie.translate("%Y-%m-%d"));
  }, Be = function(Ie) {
    var St = Ie.getParam("body_class", "", "hash");
    return St[Ie.id] || "";
  }, ge = function(Ie) {
    var St = Ie.getParam("body_class", "", "string");
    return St.indexOf("=") === -1 ? St : Be(Ie);
  }, xe = function(Ie, St) {
    if (Ie = "" + Ie, Ie.length < St)
      for (var Xe = 0; Xe < St - Ie.length; Xe++)
        Ie = "0" + Ie;
    return Ie;
  }, _e = function(Ie, St, Xe) {
    Xe === void 0 && (Xe = new Date());
    var he = "Sun Mon Tue Wed Thu Fri Sat Sun".split(" "), tt = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday Sunday".split(" "), gt = "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "), Ye = "January February March April May June July August September October November December".split(" ");
    return St = St.replace("%D", "%m/%d/%Y"), St = St.replace("%r", "%I:%M:%S %p"), St = St.replace("%Y", "" + Xe.getFullYear()), St = St.replace("%y", "" + Xe.getYear()), St = St.replace("%m", xe(Xe.getMonth() + 1, 2)), St = St.replace("%d", xe(Xe.getDate(), 2)), St = St.replace("%H", "" + xe(Xe.getHours(), 2)), St = St.replace("%M", "" + xe(Xe.getMinutes(), 2)), St = St.replace("%S", "" + xe(Xe.getSeconds(), 2)), St = St.replace("%I", "" + ((Xe.getHours() + 11) % 12 + 1)), St = St.replace("%p", Xe.getHours() < 12 ? "AM" : "PM"), St = St.replace("%B", "" + Ie.translate(Ye[Xe.getMonth()])), St = St.replace("%b", "" + Ie.translate(gt[Xe.getMonth()])), St = St.replace("%A", "" + Ie.translate(tt[Xe.getDay()])), St = St.replace("%a", "" + Ie.translate(he[Xe.getDay()])), St = St.replace("%%", "%"), St;
  }, $ = function(Ie, St) {
    return function() {
      var Xe = De(Ie);
      H(Xe) ? Xe(St) : P(Xe) ? J.send({
        url: Xe,
        success: function(he) {
          St(JSON.parse(he));
        }
      }) : St(Xe);
    };
  }, N = function(Ie, St) {
    return D.each(St, function(Xe, he) {
      H(Xe) && (Xe = Xe(he)), Ie = Ie.replace(new RegExp("\\{\\$" + he + "\\}", "g"), Xe);
    }), Ie;
  }, ae = function(Ie, St) {
    var Xe = Ie.dom, he = Ze(Ie);
    D.each(Xe.select("*", St), function(tt) {
      D.each(he, function(gt, Ye) {
        Xe.hasClass(tt, Ye) && H(gt) && gt(tt);
      });
    });
  }, ce = function(Ie, St) {
    return new RegExp("\\b" + St + "\\b", "g").test(Ie.className);
  }, ne = function(Ie, St, Xe) {
    var he = Ie.dom, tt = Ie.selection.getContent();
    Xe = N(Xe, Ze(Ie));
    var gt = he.create("div", null, Xe), Ye = he.select(".mceTmpl", gt);
    Ye && Ye.length > 0 && (gt = he.create("div", null), gt.appendChild(Ye[0].cloneNode(!0))), D.each(he.select("*", gt), function(Qt) {
      ce(Qt, ue(Ie).replace(/\s+/g, "|")) && (Qt.innerHTML = _e(Ie, Pt(Ie))), ce(Qt, ee(Ie).replace(/\s+/g, "|")) && (Qt.innerHTML = _e(Ie, Ct(Ie))), ce(Qt, Ge(Ie).replace(/\s+/g, "|")) && (Qt.innerHTML = tt);
    }), ae(Ie, gt), Ie.execCommand("mceInsertContent", !1, gt.innerHTML), Ie.addVisual();
  }, Ce = function() {
    return Te;
  }, Te = function() {
    var Ie = function(he) {
      return he();
    }, St = le, Xe = {
      fold: function(he, tt) {
        return he();
      },
      isSome: pe,
      isNone: Y,
      getOr: St,
      getOrThunk: Ie,
      getOrDie: function(he) {
        throw new Error(he || "error: getOrDie called on none.");
      },
      getOrNull: j(null),
      getOrUndefined: j(void 0),
      or: St,
      orThunk: Ie,
      map: Ce,
      each: X,
      bind: Ce,
      exists: pe,
      forall: Y,
      filter: function() {
        return Ce();
      },
      toArray: function() {
        return [];
      },
      toString: j("none()")
    };
    return Xe;
  }(), _ = function(Ie) {
    var St = j(Ie), Xe = function() {
      return tt;
    }, he = function(gt) {
      return gt(Ie);
    }, tt = {
      fold: function(gt, Ye) {
        return Ye(Ie);
      },
      isSome: Y,
      isNone: pe,
      getOr: St,
      getOrThunk: St,
      getOrDie: St,
      getOrNull: St,
      getOrUndefined: St,
      or: Xe,
      orThunk: Xe,
      map: function(gt) {
        return _(gt(Ie));
      },
      each: function(gt) {
        gt(Ie);
      },
      bind: he,
      exists: he,
      forall: he,
      filter: function(gt) {
        return gt(Ie) ? tt : Te;
      },
      toArray: function() {
        return [Ie];
      },
      toString: function() {
        return "some(" + Ie + ")";
      }
    };
    return tt;
  }, je = function(Ie) {
    return Ie == null ? Te : _(Ie);
  }, Me = {
    some: _,
    none: Ce,
    from: je
  }, Je = function(Ie, St) {
    for (var Xe = Ie.length, he = new Array(Xe), tt = 0; tt < Xe; tt++) {
      var gt = Ie[tt];
      he[tt] = St(gt, tt);
    }
    return he;
  }, Lt = function(Ie, St, Xe) {
    for (var he = 0, tt = Ie.length; he < tt; he++) {
      var gt = Ie[he];
      if (St(gt, he))
        return Me.some(gt);
      if (Xe(gt, he))
        break;
    }
    return Me.none();
  }, dt = function(Ie, St) {
    return Lt(Ie, St, pe);
  }, Tt = tinymce.util.Tools.resolve("tinymce.Env"), Jt = tinymce.util.Tools.resolve("tinymce.util.Promise"), se = Object.hasOwnProperty, tr = function(Ie, St) {
    return _t(Ie, St) ? Me.from(Ie[St]) : Me.none();
  }, _t = function(Ie, St) {
    return se.call(Ie, St);
  }, Pe = {
    '"': "&quot;",
    "<": "&lt;",
    ">": "&gt;",
    "&": "&amp;",
    "'": "&#039;"
  }, kt = function(Ie) {
    return Ie.replace(/["'<>&]/g, function(St) {
      return tr(Pe, St).getOr(St);
    });
  }, He = function(Ie, St) {
    if (St.indexOf("<html>") === -1) {
      var Xe = "", he = ht(Ie), tt = ie(Ie) ? ' crossorigin="anonymous"' : "";
      D.each(Ie.contentCSS, function(Vt) {
        Xe += '<link type="text/css" rel="stylesheet" href="' + Ie.documentBaseURI.toAbsolute(Vt) + '"' + tt + ">";
      }), he && (Xe += '<style type="text/css">' + he + "</style>");
      var gt = ge(Ie), Ye = Ie.dom.encode, Qt = Tt.mac ? "e.metaKey" : "e.ctrlKey && !e.altKey", In = '<script>document.addEventListener && document.addEventListener("click", function(e) {for (var elm = e.target; elm; elm = elm.parentNode) {if (elm.nodeName === "A" && !(' + Qt + ")) {e.preventDefault();}}}, false);<\/script> ", It = Ie.getBody().dir, qt = It ? ' dir="' + Ye(It) + '"' : "";
      St = '<!DOCTYPE html><html><head><base href="' + Ye(Ie.documentBaseURI.getURI()) + '">' + Xe + In + '</head><body class="' + Ye(gt) + '"' + qt + ">" + St + "</body></html>";
    }
    return N(St, ze(Ie));
  }, We = function(Ie, St) {
    var Xe = function() {
      if (!St || St.length === 0) {
        var Vt = Ie.translate("No templates defined.");
        return Ie.notificationManager.open({
          text: Vt,
          type: "info"
        }), Me.none();
      }
      return Me.from(D.map(St, function(Xt, on) {
        var Vn = function(Un) {
          return Un.url !== void 0;
        };
        return {
          selected: on === 0,
          text: Xt.title,
          value: {
            url: Vn(Xt) ? Me.from(Xt.url) : Me.none(),
            content: Vn(Xt) ? Me.none() : Me.from(Xt.content),
            description: Xt.description
          }
        };
      }));
    }, he = function(Vt) {
      return Je(Vt, function(Xt) {
        return {
          text: Xt.text,
          value: Xt.text
        };
      });
    }, tt = function(Vt, Xt) {
      return dt(Vt, function(on) {
        return on.text === Xt;
      });
    }, gt = function(Vt) {
      Ie.windowManager.alert("Could not load the specified template.", function() {
        return Vt.focus("template");
      });
    }, Ye = function(Vt) {
      return new Jt(function(Xt, on) {
        Vt.value.url.fold(function() {
          return Xt(Vt.value.content.getOr(""));
        }, function(Vn) {
          return J.send({
            url: Vn,
            success: function(Un) {
              Xt(Un);
            },
            error: function(Un) {
              on(Un);
            }
          });
        });
      });
    }, Qt = function(Vt, Xt) {
      return function(on, Vn) {
        if (Vn.name === "template") {
          var Un = on.getData().template;
          tt(Vt, Un).each(function(Tn) {
            on.block("Loading..."), Ye(Tn).then(function(yt) {
              Xt(on, Tn, yt);
            }).catch(function() {
              Xt(on, Tn, ""), on.disable("save"), gt(on);
            });
          });
        }
      };
    }, In = function(Vt) {
      return function(Xt) {
        var on = Xt.getData();
        tt(Vt, on.template).each(function(Vn) {
          Ye(Vn).then(function(Un) {
            Ie.execCommand("mceInsertTemplate", !1, Un), Xt.close();
          }).catch(function() {
            Xt.disable("save"), gt(Xt);
          });
        });
      };
    }, It = function(Vt) {
      var Xt = he(Vt), on = function(Tn, yt) {
        return {
          title: "Insert Template",
          size: "large",
          body: {
            type: "panel",
            items: Tn
          },
          initialData: yt,
          buttons: [
            {
              type: "cancel",
              name: "cancel",
              text: "Cancel"
            },
            {
              type: "submit",
              name: "save",
              text: "Save",
              primary: !0
            }
          ],
          onSubmit: In(Vt),
          onChange: Qt(Vt, Vn)
        };
      }, Vn = function(Tn, yt, mn) {
        var zn = He(Ie, mn), _n = [
          {
            type: "selectbox",
            name: "template",
            label: "Templates",
            items: Xt
          },
          {
            type: "htmlpanel",
            html: '<p aria-live="polite">' + kt(yt.value.description) + "</p>"
          },
          {
            label: "Preview",
            type: "iframe",
            name: "preview",
            sandboxed: !1
          }
        ], Kr = {
          template: yt.text,
          preview: zn
        };
        Tn.unblock(), Tn.redial(on(_n, Kr)), Tn.focus("template");
      }, Un = Ie.windowManager.open(on([], {
        template: "",
        preview: ""
      }));
      Un.block("Loading..."), Ye(Vt[0]).then(function(Tn) {
        Vn(Un, Vt[0], Tn);
      }).catch(function() {
        Vn(Un, Vt[0], ""), Un.disable("save"), gt(Un);
      });
    }, qt = Xe();
    qt.each(It);
  }, Ae = function(Ie) {
    return function(St) {
      We(Ie, St);
    };
  }, Ke = function(Ie) {
    Ie.addCommand("mceInsertTemplate", Q(ne, Ie)), Ie.addCommand("mceTemplate", $(Ie, Ae(Ie)));
  }, at = function(Ie) {
    Ie.on("PreProcess", function(St) {
      var Xe = Ie.dom, he = Ct(Ie);
      D.each(Xe.select("div", St.node), function(tt) {
        Xe.hasClass(tt, "mceTmpl") && (D.each(Xe.select("*", tt), function(gt) {
          Xe.hasClass(gt, ee(Ie).replace(/\s+/g, "|")) && (gt.innerHTML = _e(Ie, he));
        }), ae(Ie, tt));
      });
    });
  }, pt = function(Ie) {
    var St = function() {
      return Ie.execCommand("mceTemplate");
    };
    Ie.ui.registry.addButton("template", {
      icon: "template",
      tooltip: "Insert template",
      onAction: St
    }), Ie.ui.registry.addMenuItem("template", {
      icon: "template",
      text: "Insert template...",
      onAction: St
    });
  };
  function sn() {
    m.add("template", function(Ie) {
      pt(Ie), Ke(Ie), at(Ie);
    });
  }
  sn();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager");
  function y() {
    m.add("textcolor", function() {
    });
  }
  y();
})();
(function() {
  var m = function(Z) {
    var ye = Z, Ve = function() {
      return ye;
    }, lt = function(Et) {
      ye = Et;
    };
    return {
      get: Ve,
      set: lt
    };
  }, y = tinymce.util.Tools.resolve("tinymce.PluginManager"), w = function() {
    return w = Object.assign || function(ye) {
      for (var Ve, lt = 1, Et = arguments.length; lt < Et; lt++) {
        Ve = arguments[lt];
        for (var Ot in Ve)
          Object.prototype.hasOwnProperty.call(Ve, Ot) && (ye[Ot] = Ve[Ot]);
      }
      return ye;
    }, w.apply(this, arguments);
  };
  function E(Z, ye, Ve) {
    if (Ve || arguments.length === 2)
      for (var lt = 0, Et = ye.length, Ot; lt < Et; lt++)
        (Ot || !(lt in ye)) && (Ot || (Ot = Array.prototype.slice.call(ye, 0, lt)), Ot[lt] = ye[lt]);
    return Z.concat(Ot || Array.prototype.slice.call(ye));
  }
  var P = function(Z) {
    var ye = typeof Z;
    return Z === null ? "null" : ye === "object" && (Array.prototype.isPrototypeOf(Z) || Z.constructor && Z.constructor.name === "Array") ? "array" : ye === "object" && (String.prototype.isPrototypeOf(Z) || Z.constructor && Z.constructor.name === "String") ? "string" : ye;
  }, H = function(Z) {
    return function(ye) {
      return P(ye) === Z;
    };
  }, X = H("string"), j = H("object"), le = H("array"), Q = function() {
  }, pe = function(Z) {
    return function() {
      return Z;
    };
  }, Y = function(Z) {
    return Z;
  }, D = function(Z) {
    return function() {
      throw new Error(Z);
    };
  }, J = pe(!1), ue = pe(!0), ee = function() {
    return Ge;
  }, Ge = function() {
    var Z = function(lt) {
      return lt();
    }, ye = Y, Ve = {
      fold: function(lt, Et) {
        return lt();
      },
      isSome: J,
      isNone: ue,
      getOr: ye,
      getOrThunk: Z,
      getOrDie: function(lt) {
        throw new Error(lt || "error: getOrDie called on none.");
      },
      getOrNull: pe(null),
      getOrUndefined: pe(void 0),
      or: ye,
      orThunk: Z,
      map: ee,
      each: Q,
      bind: ee,
      exists: J,
      forall: ue,
      filter: function() {
        return ee();
      },
      toArray: function() {
        return [];
      },
      toString: pe("none()")
    };
    return Ve;
  }(), ze = function(Z) {
    var ye = pe(Z), Ve = function() {
      return Et;
    }, lt = function(Ot) {
      return Ot(Z);
    }, Et = {
      fold: function(Ot, Rn) {
        return Rn(Z);
      },
      isSome: ue,
      isNone: J,
      getOr: ye,
      getOrThunk: ye,
      getOrDie: ye,
      getOrNull: ye,
      getOrUndefined: ye,
      or: Ve,
      orThunk: Ve,
      map: function(Ot) {
        return ze(Ot(Z));
      },
      each: function(Ot) {
        Ot(Z);
      },
      bind: lt,
      exists: lt,
      forall: lt,
      filter: function(Ot) {
        return Ot(Z) ? Et : Ge;
      },
      toArray: function() {
        return [Z];
      },
      toString: function() {
        return "some(" + Z + ")";
      }
    };
    return Et;
  }, ht = function(Z) {
    return Z == null ? Ge : ze(Z);
  }, ie = {
    some: ze,
    none: ee,
    from: ht
  }, Ze = Array.prototype.slice, De = Array.prototype.indexOf, Pt = function(Z, ye) {
    return De.call(Z, ye);
  }, Ct = function(Z, ye) {
    return Pt(Z, ye) > -1;
  }, Be = function(Z, ye) {
    for (var Ve = Z.length, lt = new Array(Ve), Et = 0; Et < Ve; Et++) {
      var Ot = Z[Et];
      lt[Et] = ye(Ot, Et);
    }
    return lt;
  }, ge = function(Z, ye) {
    for (var Ve = 0, lt = Z.length; Ve < lt; Ve++) {
      var Et = Z[Ve];
      ye(Et, Ve);
    }
  }, xe = function(Z, ye) {
    for (var Ve = Z.length - 1; Ve >= 0; Ve--) {
      var lt = Z[Ve];
      ye(lt, Ve);
    }
  }, _e = function(Z, ye) {
    for (var Ve = [], lt = 0, Et = Z.length; lt < Et; lt++) {
      var Ot = Z[lt];
      ye(Ot, lt) && Ve.push(Ot);
    }
    return Ve;
  }, $ = function(Z, ye, Ve) {
    return xe(Z, function(lt, Et) {
      Ve = ye(Ve, lt, Et);
    }), Ve;
  }, N = function(Z, ye, Ve) {
    return ge(Z, function(lt, Et) {
      Ve = ye(Ve, lt, Et);
    }), Ve;
  }, ae = function(Z, ye, Ve) {
    for (var lt = 0, Et = Z.length; lt < Et; lt++) {
      var Ot = Z[lt];
      if (ye(Ot, lt))
        return ie.some(Ot);
      if (Ve(Ot, lt))
        break;
    }
    return ie.none();
  }, ce = function(Z, ye) {
    return ae(Z, ye, J);
  }, ne = function(Z, ye) {
    for (var Ve = 0, lt = Z.length; Ve < lt; ++Ve) {
      var Et = Z[Ve];
      if (ye(Et, Ve) !== !0)
        return !1;
    }
    return !0;
  }, Ce = function(Z, ye) {
    var Ve = Ze.call(Z, 0);
    return Ve.sort(ye), Ve;
  }, Te = function(Z, ye) {
    return ye >= 0 && ye < Z.length ? ie.some(Z[ye]) : ie.none();
  }, _ = function(Z) {
    return Te(Z, 0);
  }, je = Object.keys, Me = Object.hasOwnProperty, Je = function(Z, ye) {
    return Me.call(Z, ye);
  }, Lt = function(Z) {
    if (!le(Z))
      throw new Error("cases must be an array");
    if (Z.length === 0)
      throw new Error("there must be at least one case");
    var ye = [], Ve = {};
    return ge(Z, function(lt, Et) {
      var Ot = je(lt);
      if (Ot.length !== 1)
        throw new Error("one and only one name per case");
      var Rn = Ot[0], er = lt[Rn];
      if (Ve[Rn] !== void 0)
        throw new Error("duplicate key detected:" + Rn);
      if (Rn === "cata")
        throw new Error("cannot have a case named cata (sorry)");
      if (!le(er))
        throw new Error("case arguments must be an array");
      ye.push(Rn), Ve[Rn] = function() {
        for (var Rr = [], Nt = 0; Nt < arguments.length; Nt++)
          Rr[Nt] = arguments[Nt];
        var vr = Rr.length;
        if (vr !== er.length)
          throw new Error("Wrong number of arguments to case " + Rn + ". Expected " + er.length + " (" + er + "), got " + vr);
        var Nr = function(Sa) {
          var po = je(Sa);
          if (ye.length !== po.length)
            throw new Error("Wrong number of arguments to match. Expected: " + ye.join(",") + `
Actual: ` + po.join(","));
          var Xr = ne(ye, function(Lu) {
            return Ct(po, Lu);
          });
          if (!Xr)
            throw new Error("Not all branches were specified when using match. Specified: " + po.join(", ") + `
Required: ` + ye.join(", "));
          return Sa[Rn].apply(null, Rr);
        };
        return {
          fold: function() {
            for (var Sa = [], po = 0; po < arguments.length; po++)
              Sa[po] = arguments[po];
            if (Sa.length !== Z.length)
              throw new Error("Wrong number of arguments to fold. Expected " + Z.length + ", got " + Sa.length);
            var Xr = Sa[Et];
            return Xr.apply(null, Rr);
          },
          match: Nr,
          log: function(Sa) {
            console.log(Sa, {
              constructors: ye,
              constructor: Rn,
              params: Rr
            });
          }
        };
      };
    }), Ve;
  }, dt = { generate: Lt };
  dt.generate([
    {
      bothErrors: [
        "error1",
        "error2"
      ]
    },
    {
      firstError: [
        "error1",
        "value2"
      ]
    },
    {
      secondError: [
        "value1",
        "error2"
      ]
    },
    {
      bothValues: [
        "value1",
        "value2"
      ]
    }
  ]);
  var Tt = function(Z) {
    var ye = [], Ve = [];
    return ge(Z, function(lt) {
      lt.fold(function(Et) {
        ye.push(Et);
      }, function(Et) {
        Ve.push(Et);
      });
    }), {
      errors: ye,
      values: Ve
    };
  }, Jt = function(Z) {
    var ye = function(Nr) {
      return Jt(Z);
    }, Ve = function(Nr) {
      return Jt(Z);
    }, lt = function(Nr) {
      return Jt(Nr(Z));
    }, Et = function(Nr) {
      return Jt(Z);
    }, Ot = function(Nr) {
      Nr(Z);
    }, Rn = function(Nr) {
      return Nr(Z);
    }, er = function(Nr, Sa) {
      return Sa(Z);
    }, Rr = function(Nr) {
      return Nr(Z);
    }, Nt = function(Nr) {
      return Nr(Z);
    }, vr = function() {
      return ie.some(Z);
    };
    return {
      isValue: ue,
      isError: J,
      getOr: pe(Z),
      getOrThunk: pe(Z),
      getOrDie: pe(Z),
      or: ye,
      orThunk: Ve,
      fold: er,
      map: lt,
      mapError: Et,
      each: Ot,
      bind: Rn,
      exists: Rr,
      forall: Nt,
      toOptional: vr
    };
  }, se = function(Z) {
    var ye = function(Nt) {
      return Nt();
    }, Ve = function() {
      return D(String(Z))();
    }, lt = Y, Et = function(Nt) {
      return Nt();
    }, Ot = function(Nt) {
      return se(Z);
    }, Rn = function(Nt) {
      return se(Nt(Z));
    }, er = function(Nt) {
      return se(Z);
    }, Rr = function(Nt, vr) {
      return Nt(Z);
    };
    return {
      isValue: J,
      isError: ue,
      getOr: Y,
      getOrThunk: ye,
      getOrDie: Ve,
      or: lt,
      orThunk: Et,
      fold: Rr,
      map: Ot,
      mapError: Rn,
      each: Q,
      bind: er,
      exists: J,
      forall: ue,
      toOptional: ie.none
    };
  }, tr = function(Z, ye) {
    return Z.fold(function() {
      return se(ye);
    }, Jt);
  }, _t = {
    value: Jt,
    error: se,
    fromOption: tr
  }, Pe = function(Z) {
    return Z.type === "inline-command" || Z.type === "inline-format";
  }, kt = function(Z) {
    return Z.type === "block-command" || Z.type === "block-format";
  }, He = function(Z) {
    return Ce(Z, function(ye, Ve) {
      return ye.start.length === Ve.start.length ? 0 : ye.start.length > Ve.start.length ? -1 : 1;
    });
  }, We = function(Z) {
    var ye = function(Ot) {
      return _t.error({
        message: Ot,
        pattern: Z
      });
    }, Ve = function(Ot, Rn, er) {
      if (Z.format !== void 0) {
        var Rr = void 0;
        if (le(Z.format)) {
          if (!ne(Z.format, X))
            return ye(Ot + " pattern has non-string items in the `format` array");
          Rr = Z.format;
        } else if (X(Z.format))
          Rr = [Z.format];
        else
          return ye(Ot + " pattern has non-string `format` parameter");
        return _t.value(Rn(Rr));
      } else
        return Z.cmd !== void 0 ? X(Z.cmd) ? _t.value(er(Z.cmd, Z.value)) : ye(Ot + " pattern has non-string `cmd` parameter") : ye(Ot + " pattern is missing both `format` and `cmd` parameters");
    };
    if (!j(Z))
      return ye("Raw pattern is not an object");
    if (!X(Z.start))
      return ye("Raw pattern is missing `start` parameter");
    if (Z.end !== void 0) {
      if (!X(Z.end))
        return ye("Inline pattern has non-string `end` parameter");
      if (Z.start.length === 0 && Z.end.length === 0)
        return ye("Inline pattern has empty `start` and `end` parameters");
      var lt = Z.start, Et = Z.end;
      return Et.length === 0 && (Et = lt, lt = ""), Ve("Inline", function(Ot) {
        return {
          type: "inline-format",
          start: lt,
          end: Et,
          format: Ot
        };
      }, function(Ot, Rn) {
        return {
          type: "inline-command",
          start: lt,
          end: Et,
          cmd: Ot,
          value: Rn
        };
      });
    } else
      return Z.replacement !== void 0 ? X(Z.replacement) ? Z.start.length === 0 ? ye("Replacement pattern has empty `start` parameter") : _t.value({
        type: "inline-command",
        start: "",
        end: Z.start,
        cmd: "mceInsertContent",
        value: Z.replacement
      }) : ye("Replacement pattern has non-string `replacement` parameter") : Z.start.length === 0 ? ye("Block pattern has empty `start` parameter") : Ve("Block", function(Ot) {
        return {
          type: "block-format",
          start: Z.start,
          format: Ot[0]
        };
      }, function(Ot, Rn) {
        return {
          type: "block-command",
          start: Z.start,
          cmd: Ot,
          value: Rn
        };
      });
  }, Ae = function(Z) {
    if (Z.type === "block-command")
      return {
        start: Z.start,
        cmd: Z.cmd,
        value: Z.value
      };
    if (Z.type === "block-format")
      return {
        start: Z.start,
        format: Z.format
      };
    if (Z.type === "inline-command")
      return Z.cmd === "mceInsertContent" && Z.start === "" ? {
        start: Z.end,
        replacement: Z.value
      } : {
        start: Z.start,
        end: Z.end,
        cmd: Z.cmd,
        value: Z.value
      };
    if (Z.type === "inline-format")
      return {
        start: Z.start,
        end: Z.end,
        format: Z.format.length === 1 ? Z.format[0] : Z.format
      };
  }, Ke = function(Z) {
    return {
      inlinePatterns: _e(Z, Pe),
      blockPatterns: He(_e(Z, kt))
    };
  }, at = function(Z) {
    var ye = function(lt) {
      var Et = Tt(Be(lt, We));
      if (Et.errors.length > 0) {
        var Ot = Et.errors[0];
        throw new Error(Ot.message + `:
` + JSON.stringify(Ot.pattern, null, 2));
      }
      Z.set(Ke(Et.values));
    }, Ve = function() {
      return E(E([], Be(Z.get().inlinePatterns, Ae), !0), Be(Z.get().blockPatterns, Ae), !0);
    };
    return {
      setPatterns: ye,
      getPatterns: Ve
    };
  }, pt = typeof window < "u" ? window : Function("return this;")(), sn = function() {
    for (var Z = [], ye = 0; ye < arguments.length; ye++)
      Z[ye] = arguments[ye];
    var Ve = pt.console;
    Ve && (Ve.error ? Ve.error.apply(Ve, Z) : Ve.log.apply(Ve, Z));
  }, Ie = [
    {
      start: "*",
      end: "*",
      format: "italic"
    },
    {
      start: "**",
      end: "**",
      format: "bold"
    },
    {
      start: "#",
      format: "h1"
    },
    {
      start: "##",
      format: "h2"
    },
    {
      start: "###",
      format: "h3"
    },
    {
      start: "####",
      format: "h4"
    },
    {
      start: "#####",
      format: "h5"
    },
    {
      start: "######",
      format: "h6"
    },
    {
      start: "1. ",
      cmd: "InsertOrderedList"
    },
    {
      start: "* ",
      cmd: "InsertUnorderedList"
    },
    {
      start: "- ",
      cmd: "InsertUnorderedList"
    }
  ], St = function(Z) {
    var ye = Z.getParam("textpattern_patterns", Ie, "array");
    if (!le(ye))
      return sn("The setting textpattern_patterns should be an array"), {
        inlinePatterns: [],
        blockPatterns: []
      };
    var Ve = Tt(Be(ye, We));
    return ge(Ve.errors, function(lt) {
      return sn(lt.message, lt.pattern);
    }), Ke(Ve.values);
  }, Xe = function(Z) {
    var ye = Z.getParam("forced_root_block", "p");
    return ye === !1 ? "" : ye === !0 ? "p" : ye;
  }, he = tinymce.util.Tools.resolve("tinymce.util.Delay"), tt = tinymce.util.Tools.resolve("tinymce.util.VK"), gt = "\uFEFF", Ye = "\xA0", Qt = tinymce.util.Tools.resolve("tinymce.util.Tools"), In = tinymce.util.Tools.resolve("tinymce.dom.DOMUtils"), It = tinymce.util.Tools.resolve("tinymce.dom.TextSeeker"), qt = function(Z, ye) {
    return {
      container: Z,
      offset: ye
    };
  }, Vt = function(Z) {
    return Z.nodeType === Node.TEXT_NODE;
  }, Xt = function(Z, ye, Ve) {
    if (ye && Z.isEmpty(ye) && !Ve(ye)) {
      var lt = ye.parentNode;
      Z.remove(ye), Xt(Z, lt, Ve);
    }
  }, on = function(Z, ye, Ve, lt) {
    lt === void 0 && (lt = !0);
    var Et = ye.startContainer.parentNode, Ot = ye.endContainer.parentNode;
    ye.deleteContents(), lt && !Ve(ye.startContainer) && (Vt(ye.startContainer) && ye.startContainer.data.length === 0 && Z.remove(ye.startContainer), Vt(ye.endContainer) && ye.endContainer.data.length === 0 && Z.remove(ye.endContainer), Xt(Z, Et, Ve), Et !== Ot && Xt(Z, Ot, Ve));
  }, Vn = function(Z, ye) {
    var Ve = ye.get(Z);
    return le(Ve) && _(Ve).exists(function(lt) {
      return Je(lt, "block");
    });
  }, Un = function(Z) {
    return Z.start.length === 0;
  }, Tn = function(Z, ye) {
    var Ve = ie.from(Z.dom.getParent(ye.startContainer, Z.dom.isBlock));
    return Xe(Z) === "" ? Ve.orThunk(function() {
      return ie.some(Z.getBody());
    }) : Ve;
  }, yt = In.DOM, mn = function(Z) {
    return function(ye) {
      return Z === ye ? -1 : 0;
    };
  }, zn = function(Z) {
    return function(ye) {
      return Z.isBlock(ye) || Ct([
        "BR",
        "IMG",
        "HR",
        "INPUT"
      ], ye.nodeName) || Z.getContentEditable(ye) === "false";
    };
  }, _n = function(Z, ye, Ve) {
    if (Vt(Z) && ye >= 0)
      return ie.some(qt(Z, ye));
    var lt = It(yt);
    return ie.from(lt.backwards(Z, ye, mn(Z), Ve)).map(function(Et) {
      return qt(Et.container, Et.container.data.length);
    });
  }, Kr = function(Z, ye, Ve) {
    if (Vt(Z) && ye >= Z.length)
      return ie.some(qt(Z, ye));
    var lt = It(yt);
    return ie.from(lt.forwards(Z, ye, mn(Z), Ve)).map(function(Et) {
      return qt(Et.container, 0);
    });
  }, ot = function(Z, ye, Ve) {
    if (!Vt(Z))
      return ie.none();
    var lt = Z.textContent;
    if (ye >= 0 && ye <= lt.length)
      return ie.some(qt(Z, ye));
    var Et = It(yt);
    return ie.from(Et.backwards(Z, ye, mn(Z), Ve)).bind(function(Ot) {
      var Rn = Ot.container.data;
      return ot(Ot.container, ye + Rn.length, Ve);
    });
  }, Yt = function(Z, ye, Ve) {
    if (!Vt(Z))
      return ie.none();
    var lt = Z.textContent;
    if (ye <= lt.length)
      return ie.some(qt(Z, ye));
    var Et = It(yt);
    return ie.from(Et.forwards(Z, ye, mn(Z), Ve)).bind(function(Ot) {
      return Yt(Ot.container, ye - lt.length, Ve);
    });
  }, Ft = function(Z, ye, Ve, lt, Et) {
    var Ot = It(Z, zn(Z));
    return ie.from(Ot.backwards(ye, Ve, lt, Et));
  }, yn = function(Z, ye, Ve) {
    if (Vt(ye) && (Ve < 0 || Ve > ye.data.length))
      return [];
    for (var lt = [Ve], Et = ye; Et !== Z && Et.parentNode; ) {
      for (var Ot = Et.parentNode, Rn = 0; Rn < Ot.childNodes.length; Rn++)
        if (Ot.childNodes[Rn] === Et) {
          lt.push(Rn);
          break;
        }
      Et = Ot;
    }
    return Et === Z ? lt.reverse() : [];
  }, Yn = function(Z, ye, Ve, lt, Et) {
    var Ot = yn(Z, ye, Ve), Rn = yn(Z, lt, Et);
    return {
      start: Ot,
      end: Rn
    };
  }, Ir = function(Z, ye) {
    var Ve = ye.slice(), lt = Ve.pop(), Et = N(Ve, function(Ot, Rn) {
      return Ot.bind(function(er) {
        return ie.from(er.childNodes[Rn]);
      });
    }, ie.some(Z));
    return Et.bind(function(Ot) {
      return Vt(Ot) && (lt < 0 || lt > Ot.data.length) ? ie.none() : ie.some({
        node: Ot,
        offset: lt
      });
    });
  }, Wa = function(Z, ye) {
    return Ir(Z, ye.start).bind(function(Ve) {
      var lt = Ve.node, Et = Ve.offset;
      return Ir(Z, ye.end).map(function(Ot) {
        var Rn = Ot.node, er = Ot.offset, Rr = document.createRange();
        return Rr.setStart(lt, Et), Rr.setEnd(Rn, er), Rr;
      });
    });
  }, Mr = function(Z, ye) {
    return Yn(Z, ye.startContainer, ye.startOffset, ye.endContainer, ye.endOffset);
  }, Fr = function(Z, ye, Ve) {
    var lt = Kr(ye, 0, ye);
    lt.each(function(Et) {
      var Ot = Et.container;
      Yt(Ot, Ve.start.length, ye).each(function(Rn) {
        var er = Z.createRng();
        er.setStart(Ot, 0), er.setEnd(Rn.container, Rn.offset), on(Z, er, function(Rr) {
          return Rr === ye;
        });
      });
    });
  }, Va = function(Z, ye) {
    var Ve = Z.dom, lt = ye.pattern, Et = Wa(Ve.getRoot(), ye.range).getOrDie("Unable to resolve path range");
    return Tn(Z, Et).each(function(Ot) {
      lt.type === "block-format" ? Vn(lt.format, Z.formatter) && Z.undoManager.transact(function() {
        Fr(Z.dom, Ot, lt), Z.formatter.apply(lt.format);
      }) : lt.type === "block-command" && Z.undoManager.transact(function() {
        Fr(Z.dom, Ot, lt), Z.execCommand(lt.cmd, !1, lt.value);
      });
    }), !0;
  }, Qo = function(Z, ye) {
    var Ve = ye.replace(Ye, " ");
    return ce(Z, function(lt) {
      return ye.indexOf(lt.start) === 0 || Ve.indexOf(lt.start) === 0;
    });
  }, Go = function(Z, ye) {
    var Ve = Z.dom, lt = Z.selection.getRng();
    return Tn(Z, lt).filter(function(Et) {
      var Ot = Xe(Z), Rn = Ot === "" && Ve.is(Et, "body") || Ve.is(Et, Ot);
      return Et !== null && Rn;
    }).bind(function(Et) {
      var Ot = Et.textContent, Rn = Qo(ye, Ot);
      return Rn.map(function(er) {
        return Qt.trim(Ot).length === er.start.length ? [] : [{
          pattern: er,
          range: Yn(Ve.getRoot(), Et, 0, Et, 0)
        }];
      });
    }).getOr([]);
  }, so = function(Z, ye) {
    if (ye.length !== 0) {
      var Ve = Z.selection.getBookmark();
      ge(ye, function(lt) {
        return Va(Z, lt);
      }), Z.selection.moveToBookmark(Ve);
    }
  }, bo = 0, mi = function(Z) {
    var ye = new Date(), Ve = ye.getTime(), lt = Math.floor(Math.random() * 1e9);
    return bo++, Z + "_" + lt + bo + String(Ve);
  }, Ao = function(Z, ye, Ve) {
    return ye === "" || Z.length >= ye.length && Z.substr(Ve, Ve + ye.length) === ye;
  }, go = function(Z, ye) {
    return Ao(Z, ye, Z.length - ye.length);
  }, gi = function(Z, ye) {
    return Z.create("span", {
      "data-mce-type": "bookmark",
      id: ye
    });
  }, na = function(Z, ye) {
    var Ve = Z.createRng();
    return Ve.setStartAfter(ye.start), Ve.setEndBefore(ye.end), Ve;
  }, ei = function(Z, ye, Ve) {
    var lt = Wa(Z.getRoot(), Ve).getOrDie("Unable to resolve path range"), Et = lt.startContainer, Ot = lt.endContainer, Rn = lt.endOffset === 0 ? Ot : Ot.splitText(lt.endOffset), er = lt.startOffset === 0 ? Et : Et.splitText(lt.startOffset);
    return {
      prefix: ye,
      end: Rn.parentNode.insertBefore(gi(Z, ye + "-end"), Rn),
      start: er.parentNode.insertBefore(gi(Z, ye + "-start"), er)
    };
  }, sr = function(Z, ye, Ve) {
    Xt(Z, Z.get(ye.prefix + "-end"), Ve), Xt(Z, Z.get(ye.prefix + "-start"), Ve);
  }, $u = function(Z, ye, Ve) {
    return function(lt, Et) {
      var Ot = lt.data, Rn = Ot.substring(0, Et), er = Rn.lastIndexOf(Ve.charAt(Ve.length - 1)), Rr = Rn.lastIndexOf(Ve);
      return Rr !== -1 ? Rr + Ve.length : er !== -1 ? er + 1 : -1;
    };
  }, Ko = function(Z, ye, Ve, lt) {
    var Et = ye.start, Ot = Ft(Z, lt.container, lt.offset, $u(Z, Ve, Et), Ve);
    return Ot.bind(function(Rn) {
      if (Rn.offset >= Et.length) {
        var er = Z.createRng();
        return er.setStart(Rn.container, Rn.offset - Et.length), er.setEnd(Rn.container, Rn.offset), ie.some(er);
      } else {
        var Rr = Rn.offset - Et.length;
        return ot(Rn.container, Rr, Ve).map(function(Nt) {
          var vr = Z.createRng();
          return vr.setStart(Nt.container, Nt.offset), vr.setEnd(Rn.container, Rn.offset), vr;
        }).filter(function(Nt) {
          return Nt.toString() === Et;
        }).orThunk(function() {
          return Ko(Z, ye, Ve, qt(Rn.container, 0));
        });
      }
    });
  }, pi = function(Z, ye, Ve, lt, Et, Ot) {
    if (Ot === void 0 && (Ot = !1), ye.start.length === 0 && !Ot) {
      var Rn = Z.createRng();
      return Rn.setStart(Ve, lt), Rn.setEnd(Ve, lt), ie.some(Rn);
    }
    return _n(Ve, lt, Et).bind(function(er) {
      var Rr = Ko(Z, ye, Et, er);
      return Rr.bind(function(Nt) {
        if (Ot) {
          if (Nt.endContainer === er.container && Nt.endOffset === er.offset)
            return ie.none();
          if (er.offset === 0 && Nt.endContainer.textContent.length === Nt.endOffset)
            return ie.none();
        }
        return ie.some(Nt);
      });
    });
  }, Po = function(Z, ye, Ve) {
    var lt = Z.dom, Et = lt.getRoot(), Ot = Ve.pattern, Rn = Ve.position.container, er = Ve.position.offset;
    return ot(Rn, er - Ve.pattern.end.length, ye).bind(function(Rr) {
      var Nt = Yn(Et, Rr.container, Rr.offset, Rn, er);
      if (Un(Ot))
        return ie.some({
          matches: [{
            pattern: Ot,
            startRng: Nt,
            endRng: Nt
          }],
          position: Rr
        });
      var vr = Si(Z, Ve.remainingPatterns, Rr.container, Rr.offset, ye), Nr = vr.getOr({
        matches: [],
        position: Rr
      }), Sa = Nr.position, po = pi(lt, Ot, Sa.container, Sa.offset, ye, vr.isNone());
      return po.map(function(Xr) {
        var Lu = Mr(Et, Xr);
        return {
          matches: Nr.matches.concat([{
            pattern: Ot,
            startRng: Lu,
            endRng: Nt
          }]),
          position: qt(Xr.startContainer, Xr.startOffset)
        };
      });
    });
  }, Si = function(Z, ye, Ve, lt, Et) {
    var Ot = Z.dom;
    return _n(Ve, lt, Ot.getRoot()).bind(function(Rn) {
      var er = Ot.createRng();
      er.setStart(Et, 0), er.setEnd(Ve, lt);
      for (var Rr = er.toString(), Nt = 0; Nt < ye.length; Nt++) {
        var vr = ye[Nt];
        if (!!go(Rr, vr.end)) {
          var Nr = ye.slice();
          Nr.splice(Nt, 1);
          var Sa = Po(Z, Et, {
            pattern: vr,
            remainingPatterns: Nr,
            position: Rn
          });
          if (Sa.isSome())
            return Sa;
        }
      }
      return ie.none();
    });
  }, Su = function(Z, ye, Ve) {
    Z.selection.setRng(Ve), ye.type === "inline-format" ? ge(ye.format, function(lt) {
      Z.formatter.apply(lt);
    }) : Z.execCommand(ye.cmd, !1, ye.value);
  }, xi = function(Z, ye, Ve, lt) {
    var Et = na(Z.dom, Ve);
    on(Z.dom, Et, lt), Su(Z, ye, Et);
  }, Ju = function(Z, ye, Ve, lt, Et) {
    var Ot = Z.dom, Rn = na(Ot, lt), er = na(Ot, Ve);
    on(Ot, er, Et), on(Ot, Rn, Et);
    var Rr = {
      prefix: Ve.prefix,
      start: Ve.end,
      end: lt.start
    }, Nt = na(Ot, Rr);
    Su(Z, ye, Nt);
  }, Lo = function(Z, ye) {
    var Ve = mi("mce_textpattern"), lt = $(ye, function(Et, Ot) {
      var Rn = ei(Z, Ve + ("_end" + Et.length), Ot.endRng);
      return Et.concat([w(w({}, Ot), { endMarker: Rn })]);
    }, []);
    return $(lt, function(Et, Ot) {
      var Rn = lt.length - Et.length - 1, er = Un(Ot.pattern) ? Ot.endMarker : ei(Z, Ve + ("_start" + Rn), Ot.startRng);
      return Et.concat([w(w({}, Ot), { startMarker: er })]);
    }, []);
  }, yo = function(Z, ye, Ve) {
    var lt = Z.selection.getRng();
    return lt.collapsed === !1 ? [] : Tn(Z, lt).bind(function(Et) {
      var Ot = lt.startOffset - (Ve ? 1 : 0);
      return Si(Z, ye, lt.startContainer, Ot, Et);
    }).fold(function() {
      return [];
    }, function(Et) {
      return Et.matches;
    });
  }, Bn = function(Z, ye) {
    if (ye.length !== 0) {
      var Ve = Z.dom, lt = Z.selection.getBookmark(), Et = Lo(Ve, ye);
      ge(Et, function(Ot) {
        var Rn = Ve.getParent(Ot.startMarker.start, Ve.isBlock), er = function(Rr) {
          return Rr === Rn;
        };
        Un(Ot.pattern) ? xi(Z, Ot.pattern, Ot.endMarker, er) : Ju(Z, Ot.pattern, Ot.startMarker, Ot.endMarker, er), sr(Ve, Ot.endMarker, er), sr(Ve, Ot.startMarker, er);
      }), Z.selection.moveToBookmark(lt);
    }
  }, xu = function(Z, ye) {
    if (!Z.selection.isCollapsed())
      return !1;
    var Ve = yo(Z, ye.inlinePatterns, !1), lt = Go(Z, ye.blockPatterns);
    return lt.length > 0 || Ve.length > 0 ? (Z.undoManager.add(), Z.undoManager.extra(function() {
      Z.execCommand("mceInsertNewLine");
    }, function() {
      Z.insertContent(gt), Bn(Z, Ve), so(Z, lt);
      var Et = Z.selection.getRng(), Ot = _n(Et.startContainer, Et.startOffset, Z.dom.getRoot());
      Z.execCommand("mceInsertNewLine"), Ot.each(function(Rn) {
        var er = Rn.container;
        er.data.charAt(Rn.offset - 1) === gt && (er.deleteData(Rn.offset - 1, 1), Xt(Z.dom, er.parentNode, function(Rr) {
          return Rr === Z.dom.getRoot();
        }));
      });
    }), !0) : !1;
  }, ku = function(Z, ye) {
    var Ve = yo(Z, ye.inlinePatterns, !0);
    Ve.length > 0 && Z.undoManager.transact(function() {
      Bn(Z, Ve);
    });
  }, Tu = function(Z, ye, Ve) {
    for (var lt = 0; lt < Z.length; lt++)
      if (Ve(Z[lt], ye))
        return !0;
    return !1;
  }, Ue = function(Z, ye) {
    return Tu(Z, ye, function(Ve, lt) {
      return Ve === lt.keyCode && tt.modifierPressed(lt) === !1;
    });
  }, et = function(Z, ye) {
    return Tu(Z, ye, function(Ve, lt) {
      return Ve.charCodeAt(0) === lt.charCode;
    });
  }, en = function(Z, ye) {
    var Ve = [
      ",",
      ".",
      ";",
      ":",
      "!",
      "?"
    ], lt = [32];
    Z.on("keydown", function(Et) {
      Et.keyCode === 13 && !tt.modifierPressed(Et) && xu(Z, ye.get()) && Et.preventDefault();
    }, !0), Z.on("keyup", function(Et) {
      Ue(lt, Et) && ku(Z, ye.get());
    }), Z.on("keypress", function(Et) {
      et(Ve, Et) && he.setEditorTimeout(Z, function() {
        ku(Z, ye.get());
      });
    });
  };
  function gn() {
    y.add("textpattern", function(Z) {
      var ye = m(St(Z));
      return en(Z, ye), at(ye);
    });
  }
  gn();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = tinymce.util.Tools.resolve("tinymce.dom.DOMUtils"), w = tinymce.util.Tools.resolve("tinymce.util.I18n"), E = tinymce.util.Tools.resolve("tinymce.util.Tools"), P = function(ge) {
    return ge.getParam("toc_class", "mce-toc");
  }, H = function(ge) {
    var xe = ge.getParam("toc_header", "h2");
    return /^h[1-6]$/.test(xe) ? xe : "h2";
  }, X = function(ge) {
    var xe = parseInt(ge.getParam("toc_depth", "3"), 10);
    return xe >= 1 && xe <= 9 ? xe : 3;
  }, j = function(ge) {
    var xe = 0;
    return function() {
      var _e = new Date().getTime().toString(32);
      return ge + _e + (xe++).toString(32);
    };
  }, le = j("mcetoc_"), Q = function(ge) {
    var xe, _e = [];
    for (xe = 1; xe <= ge; xe++)
      _e.push("h" + xe);
    return _e.join(",");
  }, pe = function(ge) {
    return Y(ge).length > 0;
  }, Y = function(ge) {
    var xe = P(ge), _e = H(ge), $ = Q(X(ge)), N = ge.$($);
    return N.length && /^h[1-9]$/i.test(_e) && (N = N.filter(function(ae, ce) {
      return !ge.dom.hasClass(ce.parentNode, xe);
    })), E.map(N, function(ae) {
      var ce = ae.id;
      return {
        id: ce || le(),
        level: parseInt(ae.nodeName.replace(/^H/i, ""), 10),
        title: ge.$.text(ae),
        element: ae
      };
    });
  }, D = function(ge) {
    for (var xe = 9, _e = 0; _e < ge.length; _e++)
      if (ge[_e].level < xe && (xe = ge[_e].level), xe === 1)
        return xe;
    return xe;
  }, J = function(ge, xe) {
    var _e = "<" + ge + ' contenteditable="true">', $ = "</" + ge + ">";
    return _e + y.DOM.encode(xe) + $;
  }, ue = function(ge) {
    var xe = ee(ge);
    return '<div class="' + ge.dom.encode(P(ge)) + '" contenteditable="false">' + xe + "</div>";
  }, ee = function(ge) {
    var xe = "", _e = Y(ge), $ = D(_e) - 1;
    if (!_e.length)
      return "";
    xe += J(H(ge), w.translate("Table of Contents"));
    for (var N = 0; N < _e.length; N++) {
      var ae = _e[N];
      ae.element.id = ae.id;
      var ce = _e[N + 1] && _e[N + 1].level;
      if ($ === ae.level)
        xe += "<li>";
      else
        for (var ne = $; ne < ae.level; ne++)
          xe += "<ul><li>";
      if (xe += '<a href="#' + ae.id + '">' + ae.title + "</a>", ce === ae.level || !ce)
        xe += "</li>", ce || (xe += "</ul>");
      else
        for (var ne = ae.level; ne > ce; ne--)
          ne === ce + 1 ? xe += "</li></ul><li>" : xe += "</li></ul>";
      $ = ae.level;
    }
    return xe;
  }, Ge = function(ge, xe) {
    return !xe.length || ge.dom.getParents(xe[0], ".mce-offscreen-selection").length > 0;
  }, ze = function(ge) {
    var xe = P(ge), _e = ge.$("." + xe);
    Ge(ge, _e) ? ge.insertContent(ue(ge)) : ht(ge);
  }, ht = function(ge) {
    var xe = P(ge), _e = ge.$("." + xe);
    _e.length && ge.undoManager.transact(function() {
      _e.html(ee(ge));
    });
  }, ie = function(ge) {
    ge.addCommand("mceInsertToc", function() {
      ze(ge);
    }), ge.addCommand("mceUpdateToc", function() {
      ht(ge);
    });
  }, Ze = function(ge) {
    var xe = ge.$, _e = P(ge);
    ge.on("PreProcess", function($) {
      var N = xe("." + _e, $.node);
      N.length && (N.removeAttr("contentEditable"), N.find("[contenteditable]").removeAttr("contentEditable"));
    }), ge.on("SetContent", function() {
      var $ = xe("." + _e);
      $.length && ($.attr("contentEditable", !1), $.children(":first-child").attr("contentEditable", !0));
    });
  }, De = function(ge) {
    return function(xe) {
      var _e = function() {
        return xe.setDisabled(ge.mode.isReadOnly() || !pe(ge));
      };
      return _e(), ge.on("LoadContent SetContent change", _e), function() {
        return ge.on("LoadContent SetContent change", _e);
      };
    };
  }, Pt = function(ge) {
    return function(xe) {
      return xe && ge.dom.is(xe, "." + P(ge)) && ge.getBody().contains(xe);
    };
  }, Ct = function(ge) {
    var xe = function() {
      return ge.execCommand("mceInsertToc");
    };
    ge.ui.registry.addButton("toc", {
      icon: "toc",
      tooltip: "Table of contents",
      onAction: xe,
      onSetup: De(ge)
    }), ge.ui.registry.addButton("tocupdate", {
      icon: "reload",
      tooltip: "Update",
      onAction: function() {
        return ge.execCommand("mceUpdateToc");
      }
    }), ge.ui.registry.addMenuItem("toc", {
      icon: "toc",
      text: "Table of contents",
      onAction: xe,
      onSetup: De(ge)
    }), ge.ui.registry.addContextToolbar("toc", {
      items: "tocupdate",
      predicate: Pt(ge),
      scope: "node",
      position: "node"
    });
  };
  function Be() {
    m.add("toc", function(ge) {
      ie(ge), Ct(ge), Ze(ge);
    });
  }
  Be();
})();
(function() {
  var m = function(pe) {
    var Y = pe, D = function() {
      return Y;
    }, J = function(ue) {
      Y = ue;
    };
    return {
      get: D,
      set: J
    };
  }, y = tinymce.util.Tools.resolve("tinymce.PluginManager"), w = function(pe, Y) {
    pe.fire("VisualBlocks", { state: Y });
  }, E = function(pe, Y, D) {
    var J = pe.dom;
    J.toggleClass(pe.getBody(), "mce-visualblocks"), D.set(!D.get()), w(pe, D.get());
  }, P = function(pe, Y, D) {
    pe.addCommand("mceVisualBlocks", function() {
      E(pe, Y, D);
    });
  }, H = function(pe) {
    return pe.getParam("visualblocks_default_state", !1, "boolean");
  }, X = function(pe, Y, D) {
    pe.on("PreviewFormats AfterPreviewFormats", function(J) {
      D.get() && pe.dom.toggleClass(pe.getBody(), "mce-visualblocks", J.type === "afterpreviewformats");
    }), pe.on("init", function() {
      H(pe) && E(pe, Y, D);
    });
  }, j = function(pe, Y) {
    return function(D) {
      D.setActive(Y.get());
      var J = function(ue) {
        return D.setActive(ue.state);
      };
      return pe.on("VisualBlocks", J), function() {
        return pe.off("VisualBlocks", J);
      };
    };
  }, le = function(pe, Y) {
    var D = function() {
      return pe.execCommand("mceVisualBlocks");
    };
    pe.ui.registry.addToggleButton("visualblocks", {
      icon: "visualblocks",
      tooltip: "Show blocks",
      onAction: D,
      onSetup: j(pe, Y)
    }), pe.ui.registry.addToggleMenuItem("visualblocks", {
      text: "Show blocks",
      icon: "visualblocks",
      onAction: D,
      onSetup: j(pe, Y)
    });
  };
  function Q() {
    y.add("visualblocks", function(pe, Y) {
      var D = m(!1);
      P(pe, Y, D), le(pe, D), X(pe, Y, D);
    });
  }
  Q();
})();
(function() {
  var m = function(ot) {
    var Yt = ot, Ft = function() {
      return Yt;
    }, yn = function(Yn) {
      Yt = Yn;
    };
    return {
      get: Ft,
      set: yn
    };
  }, y = tinymce.util.Tools.resolve("tinymce.PluginManager"), w = function(ot) {
    var Yt = function() {
      return ot.get();
    };
    return { isEnabled: Yt };
  }, E = function(ot, Yt) {
    return ot.fire("VisualChars", { state: Yt });
  }, P = function(ot) {
    var Yt = typeof ot;
    return ot === null ? "null" : Yt === "object" && (Array.prototype.isPrototypeOf(ot) || ot.constructor && ot.constructor.name === "Array") ? "array" : Yt === "object" && (String.prototype.isPrototypeOf(ot) || ot.constructor && ot.constructor.name === "String") ? "string" : Yt;
  }, H = function(ot) {
    return function(Yt) {
      return P(Yt) === ot;
    };
  }, X = function(ot) {
    return function(Yt) {
      return typeof Yt === ot;
    };
  }, j = H("string"), le = X("boolean"), Q = X("number"), pe = function() {
  }, Y = function(ot) {
    return function() {
      return ot;
    };
  }, D = function(ot) {
    return ot;
  }, J = Y(!1), ue = Y(!0), ee = function() {
    return Ge;
  }, Ge = function() {
    var ot = function(yn) {
      return yn();
    }, Yt = D, Ft = {
      fold: function(yn, Yn) {
        return yn();
      },
      isSome: J,
      isNone: ue,
      getOr: Yt,
      getOrThunk: ot,
      getOrDie: function(yn) {
        throw new Error(yn || "error: getOrDie called on none.");
      },
      getOrNull: Y(null),
      getOrUndefined: Y(void 0),
      or: Yt,
      orThunk: ot,
      map: ee,
      each: pe,
      bind: ee,
      exists: J,
      forall: ue,
      filter: function() {
        return ee();
      },
      toArray: function() {
        return [];
      },
      toString: Y("none()")
    };
    return Ft;
  }(), ze = function(ot) {
    var Yt = Y(ot), Ft = function() {
      return Yn;
    }, yn = function(Ir) {
      return Ir(ot);
    }, Yn = {
      fold: function(Ir, Wa) {
        return Wa(ot);
      },
      isSome: ue,
      isNone: J,
      getOr: Yt,
      getOrThunk: Yt,
      getOrDie: Yt,
      getOrNull: Yt,
      getOrUndefined: Yt,
      or: Ft,
      orThunk: Ft,
      map: function(Ir) {
        return ze(Ir(ot));
      },
      each: function(Ir) {
        Ir(ot);
      },
      bind: yn,
      exists: yn,
      forall: yn,
      filter: function(Ir) {
        return Ir(ot) ? Yn : Ge;
      },
      toArray: function() {
        return [ot];
      },
      toString: function() {
        return "some(" + ot + ")";
      }
    };
    return Yn;
  }, ht = function(ot) {
    return ot == null ? Ge : ze(ot);
  }, ie = {
    some: ze,
    none: ee,
    from: ht
  }, Ze = function(ot, Yt) {
    for (var Ft = ot.length, yn = new Array(Ft), Yn = 0; Yn < Ft; Yn++) {
      var Ir = ot[Yn];
      yn[Yn] = Yt(Ir, Yn);
    }
    return yn;
  }, De = function(ot, Yt) {
    for (var Ft = 0, yn = ot.length; Ft < yn; Ft++) {
      var Yn = ot[Ft];
      Yt(Yn, Ft);
    }
  }, Pt = function(ot, Yt) {
    for (var Ft = [], yn = 0, Yn = ot.length; yn < Yn; yn++) {
      var Ir = ot[yn];
      Yt(Ir, yn) && Ft.push(Ir);
    }
    return Ft;
  }, Ct = Object.keys, Be = function(ot, Yt) {
    for (var Ft = Ct(ot), yn = 0, Yn = Ft.length; yn < Yn; yn++) {
      var Ir = Ft[yn], Wa = ot[Ir];
      Yt(Wa, Ir);
    }
  };
  typeof window < "u" || Function("return this;")();
  var ge = 3, xe = function(ot) {
    return ot.dom.nodeType;
  }, _e = function(ot) {
    return ot.dom.nodeValue;
  }, $ = function(ot) {
    return function(Yt) {
      return xe(Yt) === ot;
    };
  }, N = $(ge), ae = function(ot, Yt, Ft) {
    if (j(Ft) || le(Ft) || Q(Ft))
      ot.setAttribute(Yt, Ft + "");
    else
      throw console.error("Invalid call to Attribute.set. Key ", Yt, ":: Value ", Ft, ":: Element ", ot), new Error("Attribute value was not simple");
  }, ce = function(ot, Yt, Ft) {
    ae(ot.dom, Yt, Ft);
  }, ne = function(ot, Yt) {
    var Ft = ot.dom.getAttribute(Yt);
    return Ft === null ? void 0 : Ft;
  }, Ce = function(ot, Yt) {
    ot.dom.removeAttribute(Yt);
  }, Te = function(ot, Yt) {
    var Ft = ne(ot, Yt);
    return Ft === void 0 || Ft === "" ? [] : Ft.split(" ");
  }, _ = function(ot, Yt, Ft) {
    var yn = Te(ot, Yt), Yn = yn.concat([Ft]);
    return ce(ot, Yt, Yn.join(" ")), !0;
  }, je = function(ot, Yt, Ft) {
    var yn = Pt(Te(ot, Yt), function(Yn) {
      return Yn !== Ft;
    });
    return yn.length > 0 ? ce(ot, Yt, yn.join(" ")) : Ce(ot, Yt), !1;
  }, Me = function(ot) {
    return ot.dom.classList !== void 0;
  }, Je = function(ot) {
    return Te(ot, "class");
  }, Lt = function(ot, Yt) {
    return _(ot, "class", Yt);
  }, dt = function(ot, Yt) {
    return je(ot, "class", Yt);
  }, Tt = function(ot, Yt) {
    Me(ot) ? ot.dom.classList.add(Yt) : Lt(ot, Yt);
  }, Jt = function(ot) {
    var Yt = Me(ot) ? ot.dom.classList : Je(ot);
    Yt.length === 0 && Ce(ot, "class");
  }, se = function(ot, Yt) {
    if (Me(ot)) {
      var Ft = ot.dom.classList;
      Ft.remove(Yt);
    } else
      dt(ot, Yt);
    Jt(ot);
  }, tr = function(ot, Yt) {
    var Ft = Yt || document, yn = Ft.createElement("div");
    if (yn.innerHTML = ot, !yn.hasChildNodes() || yn.childNodes.length > 1)
      throw console.error("HTML does not have a single root node", ot), new Error("HTML must have a single root node");
    return kt(yn.childNodes[0]);
  }, _t = function(ot, Yt) {
    var Ft = Yt || document, yn = Ft.createElement(ot);
    return kt(yn);
  }, Pe = function(ot, Yt) {
    var Ft = Yt || document, yn = Ft.createTextNode(ot);
    return kt(yn);
  }, kt = function(ot) {
    if (ot == null)
      throw new Error("Node cannot be null or undefined");
    return { dom: ot };
  }, He = function(ot, Yt, Ft) {
    return ie.from(ot.dom.elementFromPoint(Yt, Ft)).map(kt);
  }, We = {
    fromHtml: tr,
    fromTag: _t,
    fromText: Pe,
    fromDom: kt,
    fromPoint: He
  }, Ae = {
    "\xA0": "nbsp",
    "\xAD": "shy"
  }, Ke = function(ot, Yt) {
    var Ft = "";
    return Be(ot, function(yn, Yn) {
      Ft += Yn;
    }), new RegExp("[" + Ft + "]", Yt ? "g" : "");
  }, at = function(ot) {
    var Yt = "";
    return Be(ot, function(Ft) {
      Yt && (Yt += ","), Yt += "span.mce-" + Ft;
    }), Yt;
  }, pt = Ke(Ae), sn = Ke(Ae, !0), Ie = at(Ae), St = "mce-nbsp", Xe = function(ot) {
    return '<span data-mce-bogus="1" class="mce-' + Ae[ot] + '">' + ot + "</span>";
  }, he = function(ot) {
    var Yt = _e(ot);
    return N(ot) && Yt !== void 0 && pt.test(Yt);
  }, tt = function(ot, Yt) {
    var Ft = [], yn = ot.dom, Yn = Ze(yn.childNodes, We.fromDom);
    return De(Yn, function(Ir) {
      Yt(Ir) && (Ft = Ft.concat([Ir])), Ft = Ft.concat(tt(Ir, Yt));
    }), Ft;
  }, gt = function(ot, Yt) {
    for (; ot.parentNode; ) {
      if (ot.parentNode === Yt)
        return ot;
      ot = ot.parentNode;
    }
  }, Ye = function(ot) {
    return ot.replace(sn, Xe);
  }, Qt = function(ot) {
    return ot.nodeName.toLowerCase() === "span" && ot.classList.contains("mce-nbsp-wrap");
  }, In = function(ot, Yt) {
    var Ft = tt(We.fromDom(Yt), he);
    De(Ft, function(yn) {
      var Yn = yn.dom.parentNode;
      if (Qt(Yn))
        Tt(We.fromDom(Yn), St);
      else {
        for (var Ir = Ye(ot.dom.encode(_e(yn))), Wa = ot.dom.create("div", null, Ir), Mr = void 0; Mr = Wa.lastChild; )
          ot.dom.insertAfter(Mr, yn.dom);
        ot.dom.remove(yn.dom);
      }
    });
  }, It = function(ot, Yt) {
    var Ft = ot.dom.select(Ie, Yt);
    De(Ft, function(yn) {
      Qt(yn) ? se(We.fromDom(yn), St) : ot.dom.remove(yn, !0);
    });
  }, qt = function(ot) {
    var Yt = ot.getBody(), Ft = ot.selection.getBookmark(), yn = gt(ot.selection.getNode(), Yt);
    yn = yn !== void 0 ? yn : Yt, It(ot, yn), In(ot, yn), ot.selection.moveToBookmark(Ft);
  }, Vt = function(ot, Yt) {
    E(ot, Yt.get());
    var Ft = ot.getBody();
    Yt.get() === !0 ? In(ot, Ft) : It(ot, Ft);
  }, Xt = function(ot, Yt) {
    Yt.set(!Yt.get());
    var Ft = ot.selection.getBookmark();
    Vt(ot, Yt), ot.selection.moveToBookmark(Ft);
  }, on = function(ot, Yt) {
    ot.addCommand("mceVisualChars", function() {
      Xt(ot, Yt);
    });
  }, Vn = function(ot) {
    return ot.getParam("visualchars_default_state", !1);
  }, Un = function(ot) {
    return ot.getParam("forced_root_block") !== !1;
  }, Tn = function(ot, Yt) {
    ot.on("init", function() {
      Vt(ot, Yt);
    });
  }, yt = tinymce.util.Tools.resolve("tinymce.util.Delay"), mn = function(ot, Yt) {
    var Ft = yt.debounce(function() {
      qt(ot);
    }, 300);
    Un(ot) && ot.on("keydown", function(yn) {
      Yt.get() === !0 && (yn.keyCode === 13 ? qt(ot) : Ft());
    }), ot.on("remove", Ft.stop);
  }, zn = function(ot, Yt) {
    return function(Ft) {
      Ft.setActive(Yt.get());
      var yn = function(Yn) {
        return Ft.setActive(Yn.state);
      };
      return ot.on("VisualChars", yn), function() {
        return ot.off("VisualChars", yn);
      };
    };
  }, _n = function(ot, Yt) {
    var Ft = function() {
      return ot.execCommand("mceVisualChars");
    };
    ot.ui.registry.addToggleButton("visualchars", {
      tooltip: "Show invisible characters",
      icon: "visualchars",
      onAction: Ft,
      onSetup: zn(ot, Yt)
    }), ot.ui.registry.addToggleMenuItem("visualchars", {
      text: "Show invisible characters",
      icon: "visualchars",
      onAction: Ft,
      onSetup: zn(ot, Yt)
    });
  };
  function Kr() {
    y.add("visualchars", function(ot) {
      var Yt = m(Vn(ot));
      return on(ot, Yt), _n(ot, Yt), mn(ot, Yt), Tn(ot, Yt), w(Yt);
    });
  }
  Kr();
})();
(function() {
  var m = tinymce.util.Tools.resolve("tinymce.PluginManager"), y = function(He) {
    return He;
  }, w = function() {
    return w = Object.assign || function(We) {
      for (var Ae, Ke = 1, at = arguments.length; Ke < at; Ke++) {
        Ae = arguments[Ke];
        for (var pt in Ae)
          Object.prototype.hasOwnProperty.call(Ae, pt) && (We[pt] = Ae[pt]);
      }
      return We;
    }, w.apply(this, arguments);
  }, E = "\uFEFF", P = function(He) {
    return He.replace(/\uFEFF/g, "");
  }, H = function(He, We) {
    for (var Ae = He.length, Ke = new Array(Ae), at = 0; at < Ae; at++) {
      var pt = He[at];
      Ke[at] = We(pt, at);
    }
    return Ke;
  }, X = "[!-#%-*,-\\/:;?@\\[-\\]_{}\xA1\xAB\xB7\xBB\xBF;\xB7\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1361-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u3008\u3009\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30\u2E31\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]", j = {
    aletter: "[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F3\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u10A0-\u10C5\u10D0-\u10FA\u10FC\u1100-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F0\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1A00-\u1A16\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BC0-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u24B6-\u24E9\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2D00-\u2D25\u2D30-\u2D65\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u303B\u303C\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790\uA791\uA7A0-\uA7A9\uA7FA-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]",
    midnumlet: "[-'\\.\u2018\u2019\u2024\uFE52\uFF07\uFF0E]",
    midletter: "[:\xB7\xB7\u05F4\u2027\uFE13\uFE55\uFF1A]",
    midnum: "[\xB1+*/,;;\u0589\u060C\u060D\u066C\u07F8\u2044\uFE10\uFE14\uFE50\uFE54\uFF0C\uFF1B]",
    numeric: "[0-9\u0660-\u0669\u066B\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9]",
    cr: "\\r",
    lf: "\\n",
    newline: "[\v\f\x85\u2028\u2029]",
    extend: "[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0900-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C01-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C82\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D02\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B6-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u192B\u1930-\u193B\u19B0-\u19C0\u19C8\u19C9\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAA\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2\u1DC0-\u1DE6\u1DFC-\u1DFF\u200C\u200D\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA67C\uA67D\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26\uFF9E\uFF9F]",
    format: "[\xAD\u0600-\u0603\u06DD\u070F\u17B4\u17B5\u200E\u200F\u202A-\u202E\u2060-\u2064\u206A-\u206F\uFEFF\uFFF9-\uFFFB]",
    katakana: "[\u3031-\u3035\u309B\u309C\u30A0-\u30FA\u30FC-\u30FF\u31F0-\u31FF\u32D0-\u32FE\u3300-\u3357\uFF66-\uFF9D]",
    extendnumlet: "[=_\u203F\u2040\u2054\uFE33\uFE34\uFE4D-\uFE4F\uFF3F\u2200-\u22FF<>]",
    punctuation: X
  }, le = {
    ALETTER: 0,
    MIDNUMLET: 1,
    MIDLETTER: 2,
    MIDNUM: 3,
    NUMERIC: 4,
    CR: 5,
    LF: 6,
    NEWLINE: 7,
    EXTEND: 8,
    FORMAT: 9,
    KATAKANA: 10,
    EXTENDNUMLET: 11,
    AT: 12,
    OTHER: 13
  }, Q = [
    new RegExp(j.aletter),
    new RegExp(j.midnumlet),
    new RegExp(j.midletter),
    new RegExp(j.midnum),
    new RegExp(j.numeric),
    new RegExp(j.cr),
    new RegExp(j.lf),
    new RegExp(j.newline),
    new RegExp(j.extend),
    new RegExp(j.format),
    new RegExp(j.katakana),
    new RegExp(j.extendnumlet),
    new RegExp("@")
  ], pe = "", Y = new RegExp("^" + j.punctuation + "$"), D = /^\s+$/, J = Q, ue = le.OTHER, ee = function(He) {
    for (var We = ue, Ae = J.length, Ke = 0; Ke < Ae; ++Ke) {
      var at = J[Ke];
      if (at && at.test(He)) {
        We = Ke;
        break;
      }
    }
    return We;
  }, Ge = function(He) {
    var We = {};
    return function(Ae) {
      if (We[Ae])
        return We[Ae];
      var Ke = He(Ae);
      return We[Ae] = Ke, Ke;
    };
  }, ze = function(He) {
    var We = Ge(ee);
    return H(He, We);
  }, ht = function(He, We) {
    var Ae = He[We], Ke = He[We + 1];
    if (We < 0 || We > He.length - 1 && We !== 0 || Ae === le.ALETTER && Ke === le.ALETTER)
      return !1;
    var at = He[We + 2];
    if (Ae === le.ALETTER && (Ke === le.MIDLETTER || Ke === le.MIDNUMLET || Ke === le.AT) && at === le.ALETTER)
      return !1;
    var pt = He[We - 1];
    return (Ae === le.MIDLETTER || Ae === le.MIDNUMLET || Ke === le.AT) && Ke === le.ALETTER && pt === le.ALETTER || (Ae === le.NUMERIC || Ae === le.ALETTER) && (Ke === le.NUMERIC || Ke === le.ALETTER) || (Ae === le.MIDNUM || Ae === le.MIDNUMLET) && Ke === le.NUMERIC && pt === le.NUMERIC || Ae === le.NUMERIC && (Ke === le.MIDNUM || Ke === le.MIDNUMLET) && at === le.NUMERIC || Ae === le.EXTEND || Ae === le.FORMAT || pt === le.EXTEND || pt === le.FORMAT || Ke === le.EXTEND || Ke === le.FORMAT || Ae === le.CR && Ke === le.LF ? !1 : Ae === le.NEWLINE || Ae === le.CR || Ae === le.LF || Ke === le.NEWLINE || Ke === le.CR || Ke === le.LF ? !0 : !(Ae === le.KATAKANA && Ke === le.KATAKANA || Ke === le.EXTENDNUMLET && (Ae === le.ALETTER || Ae === le.NUMERIC || Ae === le.KATAKANA || Ae === le.EXTENDNUMLET) || Ae === le.EXTENDNUMLET && (Ke === le.ALETTER || Ke === le.NUMERIC || Ke === le.KATAKANA) || Ae === le.AT);
  }, ie = pe, Ze = D, De = Y, Pt = function(He) {
    return He === "http" || He === "https";
  }, Ct = function(He, We) {
    var Ae;
    for (Ae = We; Ae < He.length && !Ze.test(He[Ae]); Ae++)
      ;
    return Ae;
  }, Be = function(He, We) {
    var Ae = Ct(He, We + 1), Ke = He.slice(We + 1, Ae).join(ie);
    return Ke.substr(0, 3) === "://" ? Ae : We;
  }, ge = function(He, We, Ae, Ke) {
    for (var at = [], pt = [], sn = 0; sn < Ae.length; ++sn)
      if (pt.push(He[sn]), ht(Ae, sn)) {
        var Ie = We[sn];
        if ((Ke.includeWhitespace || !Ze.test(Ie)) && (Ke.includePunctuation || !De.test(Ie))) {
          var St = sn - pt.length + 1, Xe = sn + 1, he = We.slice(St, Xe).join(ie);
          if (Pt(he)) {
            var tt = Be(We, sn), gt = He.slice(Xe, tt);
            Array.prototype.push.apply(pt, gt), sn = tt;
          }
          at.push(pt);
        }
        pt = [];
      }
    return at;
  }, xe = function() {
    return {
      includeWhitespace: !1,
      includePunctuation: !1
    };
  }, _e = function(He, We, Ae) {
    Ae = w(w({}, xe()), Ae);
    for (var Ke = [], at = [], pt = 0; pt < He.length; pt++) {
      var sn = We(He[pt]);
      sn !== E && (Ke.push(He[pt]), at.push(sn));
    }
    var Ie = ze(at);
    return ge(Ke, at, Ie, Ae);
  }, $ = _e, N = tinymce.util.Tools.resolve("tinymce.dom.TreeWalker"), ae = function(He, We) {
    for (var Ae = We.getBlockElements(), Ke = We.getShortEndedElements(), at = function(St) {
      return Ae[St.nodeName] || Ke[St.nodeName];
    }, pt = [], sn = "", Ie = new N(He, He); He = Ie.next(); )
      He.nodeType === 3 ? sn += P(He.data) : at(He) && sn.length && (pt.push(sn), sn = "");
    return sn.length && pt.push(sn), pt;
  }, ce = function(He) {
    return He.replace(/\u200B/g, "");
  }, ne = function(He) {
    return He.replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "_").length;
  }, Ce = function(He, We) {
    var Ae = ce(ae(He, We).join(`
`));
    return $(Ae.split(""), y).length;
  }, Te = function(He, We) {
    var Ae = ae(He, We).join("");
    return ne(Ae);
  }, _ = function(He, We) {
    var Ae = ae(He, We).join("").replace(/\s/g, "");
    return ne(Ae);
  }, je = function(He, We) {
    return function() {
      return We(He.getBody(), He.schema);
    };
  }, Me = function(He, We) {
    return function() {
      return We(He.selection.getRng().cloneContents(), He.schema);
    };
  }, Je = function(He) {
    return je(He, Ce);
  }, Lt = function(He) {
    return {
      body: {
        getWordCount: Je(He),
        getCharacterCount: je(He, Te),
        getCharacterCountWithoutSpaces: je(He, _)
      },
      selection: {
        getWordCount: Me(He, Ce),
        getCharacterCount: Me(He, Te),
        getCharacterCountWithoutSpaces: Me(He, _)
      },
      getCount: Je(He)
    };
  }, dt = function(He, We) {
    He.windowManager.open({
      title: "Word Count",
      body: {
        type: "panel",
        items: [{
          type: "table",
          header: [
            "Count",
            "Document",
            "Selection"
          ],
          cells: [
            [
              "Words",
              String(We.body.getWordCount()),
              String(We.selection.getWordCount())
            ],
            [
              "Characters (no spaces)",
              String(We.body.getCharacterCountWithoutSpaces()),
              String(We.selection.getCharacterCountWithoutSpaces())
            ],
            [
              "Characters",
              String(We.body.getCharacterCount()),
              String(We.selection.getCharacterCount())
            ]
          ]
        }]
      },
      buttons: [{
        type: "cancel",
        name: "close",
        text: "Close",
        primary: !0
      }]
    });
  }, Tt = function(He, We) {
    He.addCommand("mceWordCount", function() {
      return dt(He, We);
    });
  }, Jt = tinymce.util.Tools.resolve("tinymce.util.Delay"), se = function(He, We) {
    He.fire("wordCountUpdate", {
      wordCount: {
        words: We.body.getWordCount(),
        characters: We.body.getCharacterCount(),
        charactersWithoutSpaces: We.body.getCharacterCountWithoutSpaces()
      }
    });
  }, tr = function(He, We) {
    se(He, We);
  }, _t = function(He, We, Ae) {
    var Ke = Jt.debounce(function() {
      return tr(He, We);
    }, Ae);
    He.on("init", function() {
      tr(He, We), Jt.setEditorTimeout(He, function() {
        He.on("SetContent BeforeAddUndo Undo Redo ViewUpdate keyup", Ke);
      }, 0);
    });
  }, Pe = function(He) {
    var We = function() {
      return He.execCommand("mceWordCount");
    };
    He.ui.registry.addButton("wordcount", {
      tooltip: "Word count",
      icon: "character-count",
      onAction: We
    }), He.ui.registry.addMenuItem("wordcount", {
      text: "Word count",
      icon: "character-count",
      onAction: We
    });
  };
  function kt(He) {
    He === void 0 && (He = 300), m.add("wordcount", function(We) {
      var Ae = Lt(We);
      return Tt(We, Ae), Pe(We), _t(We, Ae, He), Ae;
    });
  }
  kt();
})();
tinymce.PluginManager.add("indent2em", function(m, y) {
  var w = "\u9996\u884C\u7F29\u8FDB", E = tinymce.util.Tools.resolve("tinymce.util.Tools"), P = m.getParam("indent2em_val", "2em"), H = function() {
    var j = m.dom, le = m.selection.getSelectedBlocks(), Q = "";
    E.each(le, function(pe) {
      if (Q == "" && (Q = j.getStyle(pe, "text-indent") == P ? "remove" : "add"), Q == "add")
        j.setStyle(pe, "text-indent", P);
      else {
        var Y = j.getAttrib(pe, "style"), D = new RegExp("text-indent:[\\s]*" + P + ";", "ig");
        Y = Y.replace(D, ""), j.setAttrib(pe, "style", Y);
      }
    });
  };
  m.ui.registry.getAll().icons.indent2em || m.ui.registry.addIcon("indent2em", '<svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M170.666667 563.2v-102.4H887.466667v102.4zM170.666667 836.266667v-102.4H887.466667v102.4zM512 290.133333v-102.4H887.466667v102.4zM238.933333 341.333333V136.533333l204.8 102.4z" fill="#2c2c2c" p-id="5210"></path></svg>');
  var X = function(j, le) {
    return function(Q) {
      return j.selection.selectorChangedWithUnbind(le.join(","), Q.setActive).unbind;
    };
  };
  return m.ui.registry.addToggleButton("indent2em", {
    icon: "indent2em",
    tooltip: w,
    onAction: function() {
      H();
    },
    onSetup: X(m, [
      '*[style*="text-indent"]',
      '*[data-mce-style*="text-indent"]'
    ])
  }), m.ui.registry.addMenuItem("indent2em", {
    text: w,
    onAction: function() {
      H();
    }
  }), m.addCommand("indent2em", H), {
    getMetadata: function() {
      return {
        name: w,
        url: "http://tinymce.ax-z.cn/more-plugins/indent2em.php"
      };
    }
  };
});
(function() {
  let m = tinymce.util.Tools.resolve("tinymce.PluginManager");
  typeof window < "u" || Function("return this;")();
  let y = {}, w = {}, E = !0, P = !1, H = null, X = 0, j = null;
  class le {
    constructor(Y) {
      if (P = Y.getParam("cfyun_toolbar_sticky", !1, "bool"), !P)
        return;
      E = Y.getParam("toolbar_sticky_type", !0, "bool"), H = Y.getParam("toolbar_sticky_elem", "", "string"), j = Y.getParam("toolbar_sticky_wrap", "", "string"), X = Y.getParam("toolbar_sticky_elem_height", 0, "number"), this.editor = Y, w.wrap = window, w.editor = Y.$(Y.container), w.header = w.editor.find(".tox-editor-header"), w.container = w.editor.find(".tox-editor-container"), w.elemHeight = X, j && typeof j == "string" && j != "body" && (w.wrap = document.querySelector(j) || window);
      let D = this;
      return E ? (Y.on("focus", () => {
        D.bind();
      }), Y.on("blur", () => {
        D.restore(), D.unBind();
      })) : this.bind(), this;
    }
    sticky() {
      if (w.editor.hasClass("tox-fullscreen"))
        return this.restore(), !1;
      if (this.position(), y.isSticky) {
        w.container.css("padding-top", w.header[0].clientHeight), w.editor.removeClass("tox-tinymce--toolbar-sticky-off").addClass("tox-tinymce--toolbar-sticky-on");
        let Y = document.getElementById("initiate_header") ? 70 : 0;
        return w.header.css({
          position: "fixed",
          width: y.width,
          left: y.left,
          top: w.elemHeight + Y || 0,
          borderTop: "1px solid #ccc"
        }), !1;
      }
      this.restore();
    }
    position() {
      let Y = w.elemHeight;
      if (H) {
        var D = document.querySelector(H);
        if (!D)
          return this.editor.notificationManager.open({
            text: "ToolbarSticky\u672A\u83B7\u53D6\u5230\uFF1A\u9884\u7559\u4F4D\u7F6EDOM\u8282\u70B9\uFF0C\u8BF7\u67E5\u770B\u914D\u7F6Etoolbar_sticky_elem\u3002",
            type: "info"
          }), !1;
        Y = D.offsetHeight, w.elemHeight = D.clientHeight;
      }
      y.width = this.editor.container.clientWidth || 726, y.left = w.editor.offset().left + 1, y.isSticky = this.scrollTop() >= this.editor.$(w.container).offset().top - Y;
    }
    bind() {
      w.wrap.addEventListener("scroll", this.throttle(this.sticky.bind(this), 60), !1), w.wrap.addEventListener("resize", this.throttle(this.sticky.bind(this), 60), !1), this.sticky();
    }
    unBind() {
      w.wrap.removeEventListener("scroll", this.throttle(this.sticky.bind(this), 60)), w.wrap.removeEventListener("resize", this.throttle(this.sticky.bind(this), 60));
    }
    restore() {
      w.header.attr("style", ""), w.container.css("padding-top", 0), w.editor.removeClass("tox-tinymce--toolbar-sticky-on").addClass("tox-tinymce--toolbar-sticky-off");
    }
    destroy() {
      y = w = {}, this.unBind(), this.restore();
    }
    scrollTop() {
      return document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;
    }
    now() {
      return Date.now() || new Date().getTime();
    }
    throttle(Y, D) {
      let J = this, ue, ee, Ge, ze = null, ht = 0;
      const ie = () => {
        ht = 0, ze = null, Ge = Y.apply(ue, ee), ze || (ue = ee = null);
      };
      return () => {
        let Ze = J.now();
        ht || (ht = Ze);
        let De = D - (Ze - ht);
        return ue = this, ee = arguments, De <= 0 || De > D ? (ze && (clearTimeout(ze), ze = null), ht = Ze, Ge = Y.apply(ue, ee), ze || (ue = ee = null)) : ze || (ze = setTimeout(ie, De)), Ge;
      };
    }
  }
  function Q() {
    m.add("toolbarsticky", function(pe) {
      pe.on("init", function(Y) {
        new le(pe);
      });
    });
  }
  Q();
})();
const foe = ["accept"], voe = _o({
  name: "ContentEditor"
}), doe = /* @__PURE__ */ Object.assign(voe, {
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    accept: {
      type: String,
      default: "image/jpg,image/jpeg,image/png,image/gif"
    },
    plugins: {
      type: [String, Array],
      default: "searchreplace autolink link code table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount textpattern emoticons indent2em autoresize paste toolbarsticky resize"
    },
    toolbar: {
      type: [String, Array],
      default: "undo redo | formatselect forecolor bold alignleft aligncenter alignright alignjustify outdent indent indent2em bullist numlist | blockquote hr emoticons mdlink image axupimgs scroImage media audio vote gift code potato"
    },
    tinymceId: {
      type: String,
      default: "tinymceId"
    },
    minHeight: {
      type: Number,
      default: 450
    },
    placeholder: {
      type: String,
      default: "\u4E0A\u4F20\u56FE\u7247\u5BBD\u5EA6\u4E3A1080px\uFF0C\u9AD8\u5EA6\u4E0D\u5927\u4E8E4500px\uFF0C\u5355\u56FE\u4E0D\u5927\u4E8E3mb"
    },
    sourceTop: {
      type: String,
      default: "m"
    },
    env: {
      type: String,
      default: ""
    },
    acpToken: {
      type: String,
      default: ""
    },
    channel: {
      type: String,
      default: "project"
    }
  },
  emits: ["update:modelValue", "onInit"],
  setup(m, { emit: y }) {
    const w = m, E = () => b1.get("MDUSERTOKEN"), P = function($) {
      console.log("err", $);
    }, H = !1, X = w.env, j = w.acpToken, le = {
      client: 4,
      user_id: E() ? E().split("#")[0] : "",
      userid: E() ? E().split("#")[0] : "",
      token: E() ? E().split("#")[1] : ""
    };
    let Q = {};
    w.sourceTop == "acp" ? Q = Ul({
      host: "acp",
      env: X,
      header: {
        client: 4,
        user_id: j ? j.split(":")[0] : "",
        userid: j ? j.split(":")[0] : "",
        token: j ? j.split(":")[1] : ""
      },
      needLogin: H,
      callback: P
    }) : Q = Ul({
      env: X,
      header: le,
      acpneedLogin: H,
      acpcallback: P
    });
    const pe = bc(Q, j ? j.split(":")[0] : ""), Y = bc(Q, E() ? E().split("#")[0] : ""), D = ja(null), J = ja(w.modelValue), ue = Um({
      cancelTxt: "\u53D6\u6D88",
      confirmTxt: "\u786E\u5B9A",
      color: "#7A8087",
      borderColor: "#BCBFC3",
      btnColor: "#fff",
      btnMargin: "0 20px 0 0",
      mediaType: 2,
      voteVisible: !1,
      dialogVisible: !1,
      axuImgVisible: !1,
      scrollImgVisible: !1,
      linkVisible: !1,
      linkHref: "",
      linkText: "",
      linkIsText: !0,
      linkHtml: "",
      fileProgressVisible: !1,
      fileUploadName: "",
      file_progress: 0,
      tinymceId: w.tinymceId || "tinymce",
      tinymceContent: "",
      resizeRate: "",
      init: {
        language_url: "https://s.moimg.net/tinymce/langs/zh_CN.js",
        language: "zh_CN",
        image_dimensions: !1,
        skin_url: "https://s.moimg.net/tinymce/skins/ui/oxide",
        emoticons_database_url: "https://s.moimg.net/tinymce/emoticons/js/emojis.js",
        plugins: w.plugins,
        toolbar: w.toolbar,
        toolbar_mode: "wrap",
        menubar: "false",
        fontsize_formats: "12px 14px 16px 18px 20px 22px 24px 28px 32px 36px 48px 56px 72px",
        font_formats: '"PingFang SC", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, "Hiragino Sans GB", "Heiti SC", "WenQuanYi Micro Hei", sans-serif',
        lineheight_formats: "0.5 0.8 1 1.2 1.5 1.75 2 2.5 3 4 5",
        height: 400,
        min_height: w.minHeight,
        placeholder: w.placeholder,
        branding: !1,
        resize: !1,
        elementpath: !1,
        cfyun_toolbar_sticky: 1,
        content_style: ".mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before{color: #7F7F7F;} body {margin:1rem;} .mce-content-body p { margin: 0;line-height:1.5; } .mce-content-body img { max-width: 100%; vertical-align: middle; } .mce-content-body audio { display:block !important;width:100% !important;}.mce-content-body img.long-img-box{height:478px;max-width: none;}.long-img-box.clearance{margin-right:5px;}.nav_img .clearance:last-child{margin:0;}.nav_img{overflow-x: auto;overflow-y: hidden;white-space: nowrap;}.nav_img.clearance{margin:10px;}",
        setup: function($) {
          $.on("click", (N) => {
            setTimeout(() => {
              const ae = N.target;
              console.log(ae.tagName), !["VIDEO", "AUDIO"].includes(ae.tagName) && !$.dom.getParent(ae, ".long-img-box, .nav_img, .vote-show") ? (ue.canLink = !0, $.selection.getContent().length == 0 && !ae.hasAttribute("data-mce-selected") ? ht() : $.dom.is(ae, "a") ? (ue.linkHref = ae.getAttribute("href"), ue.linkText = N.target.innerText, ue.linkIsText = !0, console.log(ae.getAttribute("href"))) : $.dom.getParent(ae, "a") ? (ue.linkHref = ae.parentNode.getAttribute("href"), ue.linkText = "", ue.linkIsText = !1, ue.linkHtml = $.selection.getContent()) : $.selection.getContent({ format: "text" }) ? (ue.linkText = $.selection.getContent({ format: "text" }), ue.linkIsText = !0) : (ue.linkHref = "", ue.linkText = "", ue.linkIsText = !1, ue.linkHtml = $.selection.getContent())) : ue.canLink = !1;
            }, 100);
          }), $.on("ObjectResizeStart", function(N) {
            ue.resizeRate = (N.width / N.height).toFixed(2);
          }), $.on("ObjectResized", function(N) {
            console.log("\u539F\u59CB\u5C3A\u5BF8\uFF1A", N.width, N.height);
            var ae = 690, ce = N.target;
            ce.clientWidth >= ae && (ce.width = ae, ce.height = ae / ue.resizeRate);
            let ne = (ce.width / 690).toFixed(2);
            ce.setAttribute("data-rate", ne);
          }), $.on("keydown", function(N) {
            if (N.keyCode == 8 || N.keyCode == 46) {
              var ae = $.selection.getNode(), ce = ae.parentNode;
              ce.classList.contains("nav_img") && ae.parentNode.remove(), ae.classList.contains("nav_img") && ae.remove();
            }
            if (N.keyCode == 13) {
              var ae = $.selection.getNode(), ce = ae.parentNode;
              ce.classList.contains("nav_img") && N.preventDefault(), ae.classList.contains("nav_img") && $.insertContent("<p>&nbsp;</p>");
            }
          }), $.ui.registry.addIcon("quote", '<svg id="\u5F15\u7528" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve"><path d="M224.6,832.3H281c24.2,0,46.3-13.7,57.1-35.3l110.1-220.1V257.6c0-35.3-28.6-63.9-63.9-63.9H128.9c-35.3,0-63.9,28.6-63.9,63.9V513c0,35.3,28.6,63.9,63.9,63.9h127.7l-84.9,169.8c-14.6,29.2-2.8,64.8,26.5,79.4C206.4,830.1,215.5,832.3,224.6,832.3z M735.5,832.3h56.3c24.2,0,46.3-13.7,57.1-35.3L959,576.9V257.6c0-35.3-28.6-63.9-63.9-63.9H639.7c-35.3,0-63.9,28.6-63.9,63.9V513c0,35.3,28.6,63.9,63.9,63.9h127.7l-84.9,169.8c-14.6,29.2-2.8,64.8,26.5,79.4C717.2,830.1,726.3,832.3,735.5,832.3z"/></svg>'), $.ui.registry.addIcon("horizontal-rule", '<svg id="\u6C34\u5E73\u5206\u5272\u7EBF" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve"><path d="M832,573.2H192c-34.1,0-61.7-27.6-61.7-61.7l0,0c0-34.1,27.6-61.7,61.7-61.7H832c34.1,0,61.7,27.6,61.7,61.7l0,0C893.5,545.6,866,573.2,832,573.2z"/></svg>'), $.ui.registry.addIcon("emoji", '<svg id="\u8868\u60C5" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve"><path d="M344.9,455.6c30.7,0,55.9-25.1,55.9-55.9s-25.1-55.9-55.9-55.9S289,369,289,399.8S314.1,455.6,344.9,455.6z M680.1,455.6c30.7,0,55.9-25.1,55.9-55.9s-25.1-55.9-55.9-55.9s-55.9,25.1-55.9,55.9S649.4,455.6,680.1,455.6z M512.5,762.9c119.6,0,219-83.8,244.7-195.6H267.8C293.5,679.1,392.9,762.9,512.5,762.9z M512.5,64.5c-247.5,0-447,200-447,447s199.5,447,447,447s447-200,447-447S759.5,64.5,512.5,64.5z M512.5,874.7c-200.6,0-363.2-162.6-363.2-363.2s162.6-363.2,363.2-363.2s363.2,162.6,363.2,363.2S713.1,874.7,512.5,874.7z"/></svg>'), $.ui.registry.addIcon("link", '<svg id="\u94FE\u63A5" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve"><path d="M223,525.6c18.8-18.7,49.2-18.7,68,0c9,9,14.1,21.2,14.1,33.9c0,12.7-5.1,24.9-14.1,33.9L189,695.4c-18,18-28.2,42.4-28.2,67.9c0,25.5,10.1,49.9,28.2,67.9c37.6,37.5,98.4,37.5,136,0l238-237.7c9-9,14.1-21.2,14.1-33.9c0-12.7-5.1-24.9-14.1-33.9c-9-9-14.1-21.2-14.1-34s5.1-25,14.1-34c18.8-18.7,49.2-18.7,68,0c27.1,27,42.3,63.6,42.3,101.8c0,38.2-15.2,74.9-42.3,101.8L393,899.1c-75.2,75-196.9,75-272.1,0c-36.1-36-56.3-84.8-56.3-135.8c0-50.9,20.3-99.8,56.3-135.8L223,525.6L223,525.6z M799.9,491.4c-18.8,18.7-49.2,18.7-68,0c-9-9-14.1-21.2-14.1-33.9c0-12.7,5.1-24.9,14.1-33.9l102-101.9c18-18,28.2-42.4,28.2-67.9s-10.1-49.9-28.2-67.9c-37.6-37.5-98.4-37.5-136,0l-238,237.7c-9,9-14.1,21.2-14.1,33.9c0,12.7,5.1,24.9,14.1,33.9c9,9,14.1,21.2,14.1,34c0,12.7-5.1,25-14.1,34c-18.8,18.7-49.2,18.7-68,0c-27.1-27-42.3-63.6-42.3-101.8s15.2-74.9,42.3-101.8L630,117.9c75.2-75,196.9-75,272.1,0c36.1,36,56.3,84.8,56.3,135.8s-20.3,99.8-56.3,135.8L799.9,491.4L799.9,491.4z"/></svg>'), $.ui.registry.addIcon("image", '<svg id="\u56FE\u7247" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve"><path d="M193.1,681.3l149-149c13.3-13.3,35-13.3,48.3,0l117.1,117.1l186.9-186.9c13.3-13.3,35-13.3,48.3,0l88.2,88.2V192.1H193.1V681.3z M193.1,778v51.9H327l132.1-132.1l-92.9-92.9L193.1,778z M830.9,647.4L718.5,535L423.7,829.9h407.2V647.4z M147.6,101h728.9c25.2,0,45.6,20.4,45.6,45.6v728.9c0,25.2-20.4,45.6-45.6,45.6H147.6c-25.2,0-45.6-20.4-45.6-45.6V146.6C102,121.4,122.4,101,147.6,101z M420.9,465.4c50.3,0,91.1-40.8,91.1-91.1s-40.8-91.1-91.1-91.1s-91.1,40.8-91.1,91.1S370.6,465.4,420.9,465.4z"/></svg>'), $.ui.registry.addIcon("sourcecode", '<svg id="HTML\u6E90\u7801" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve"><path d="M378,297.7L154.9,513L378,728.3c17.7,18.3,17.2,46.9-1.2,64.6c-18.4,17.7-48,18.2-67,1.1L52.6,545.9c-18.8-18.2-18.8-47.6,0-65.8L309.9,232c19-17.1,48.6-16.6,67,1.1C395.2,250.8,395.7,279.4,378,297.7z M971.4,480.1L714.1,232c-19-17.1-48.6-16.6-67,1.1c-18.4,17.7-18.9,46.3-1.2,64.6L869.1,513L646,728.3c-17.7,18.3-17.2,46.9,1.2,64.6c18.4,17.7,48,18.2,67,1.1l257.3-248.2C990.2,527.7,990.2,498.3,971.4,480.1z"/></svg>'), $.ui.registry.addIcon("axupimgs", '<svg id="\u89C6\u9891" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve"><path d="M182.1,710.2L289,603.4c13.8-13.8,36.1-13.8,49.9,0l121,121l240.2-240.2c13.8-13.8,36.1-13.8,49.9,0l91.1,91.1V345.9h-659V710.2z M182.1,810v53.6h138.4l89.4-89.4l-96-96L182.1,810z M841.1,675.1L725,559L420.3,863.7h420.8V675.1z M135.1,251.7h753.2c26,0,47.1,21.1,47.1,47.1v611.9c0,26-21.1,47.1-47.1,47.1H135.1c-26,0-47.1-21.1-47.1-47.1V298.8C88,272.8,109.1,251.7,135.1,251.7z M417.5,581.2c-52,0-94.1-42.2-94.1-94.1s42.2-94.1,94.1-94.1s94.1,42.2,94.1,94.1S469.5,581.2,417.5,581.2z M158.6,157.6h706.1c13,0,23.5,10.5,23.5,23.5s-10.5,23.5-23.5,23.5H158.6c-13,0-23.5-10.5-23.5-23.5S145.6,157.6,158.6,157.6z M252.7,63.4h517.8c13,0,23.5,10.5,23.5,23.5s-10.5,23.5-23.5,23.5H252.7c-13,0-23.5-10.5-23.5-23.5S239.7,63.4,252.7,63.4z"/></svg>'), $.ui.registry.addIcon("scroImage", '<svg id="\u6A2A\u6ED1" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve"><path d="M899.3,198.6c22.4,0,42.7,9.4,57,24.5v108.1c-14.3,15.1-34.6,24.5-57,24.5c-43.3,0-78.5-35.2-78.5-78.5S855.9,198.6,899.3,198.6z M452,705V90.5c0-25.2-20.4-45.5-45.5-45.5h-339v91H361v244.8l-88.1-88.1c-13.3-13.3-35-13.3-48.2,0L67.5,449.9v96.5l181.2-181.2L361,477.3v182.2H67.5v91h338.9C431.6,750.5,452,730.2,452,705z M956.2,45v91H662.8v375.3l148.8-115.9c16.1-11.1,32.9-9.8,48.2,0l96.5,67v134.1L893,659.7h63.2v91H617.3c-25.2,0-45.5-20.4-45.5-45.5V90.5c0-25.2,20.4-45.5,45.5-45.5H956.2z M662.8,607.8v51.8h133.7l131.9-131.9l-92.8-59.9L662.8,607.8z M789.7,825.8c-8.1-6.2-19.8-0.5-19.8,9.7V875H260.7v-39.5c0-10.2-11.7-15.9-19.8-9.7l-93.4,72.4c-6.3,4.9-6.3,14.5,0,19.4l93.4,72.4c8.1,6.2,19.8,0.5,19.8-9.7V943h509.2v37.3c0,10.2,11.7,15.9,19.8,9.7l93.4-72.4c6.3-4.9,6.3-14.5,0-19.4L789.7,825.8z"/></svg>'), $.ui.registry.addIcon("vote", '<svg id="\u6295\u7968" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve"><path d="M880.7,958.5H140.8c-34.1,0-61.7-27.6-61.7-61.7v0c0-34.1,27.6-61.7,61.7-61.7h739.9c34.1,0,61.7,27.6,61.7,61.7v0C942.3,930.9,914.7,958.5,880.7,958.5z M495.3,742.7h30.8c34.1,0,61.7-27.6,61.7-61.7V126.2c0-34.1-27.6-61.7-61.7-61.7h-30.8c-34.1,0-61.7,27.6-61.7,61.7v554.9C433.7,715.1,461.3,742.7,495.3,742.7z M217.9,742.7h30.8c34.1,0,61.7-27.6,61.7-61.7V388.2c0-34.1-27.6-61.7-61.7-61.7h-30.8c-34.1,0-61.7,27.6-61.7,61.7v292.9C156.2,715.1,183.8,742.7,217.9,742.7z M772.8,742.7h30.8c34.1,0,61.7-27.6,61.7-61.7V557.8c0-34.1-27.6-61.7-61.7-61.7h-30.8c-34.1,0-61.7,27.6-61.7,61.7v123.3C711.1,715.1,738.7,742.7,772.8,742.7z"/></svg>'), $.ui.registry.addIcon("audio", '<svg id="\u97F3\u9891" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve"><path d="M353.6,483.6V223.7c0-87.7,71.1-158.8,158.8-158.8h0c87.7,0,158.8,71.1,158.8,158.8v259.9c0,87.7-71.1,158.8-158.8,158.8h0C424.7,642.5,353.6,571.3,353.6,483.6z M783.5,469.2L783.5,469.2c-21.3,0-39.4,15.4-42.8,36.4c-17.5,110.3-113,194.6-228.2,194.6s-210.7-84.3-228.2-194.6c-3.3-21-21.5-36.4-42.8-36.4h0c-26.7,0-47,23.9-42.8,50.3c21.9,137.4,131.9,245.4,270.4,264.3v89.7H397c-23.9,0-43.3,19.4-43.3,43.3v0c0,23.9,19.4,43.3,43.3,43.3h231c23.9,0,43.3-19.4,43.3-43.3v0c0-23.9-19.4-43.3-43.3-43.3h-72.2v-89.6C694.2,765,804.3,656.9,826.2,519.5C830.4,493.1,810.2,469.2,783.5,469.2z"/></svg>'), $.ui.registry.addIcon("media", '<svg id="\u89C6\u9891" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve"><path d="M143.6,96.5h737.8c25.5,0,46.1,20.6,46.1,46.1v737.8c0,25.5-20.6,46.1-46.1,46.1H143.6c-25.5,0-46.1-20.6-46.1-46.1V142.6C97.5,117.1,118.1,96.5,143.6,96.5z M189.7,188.7v645.6h645.6V188.7H189.7z M410.6,307l260.1,185.8c10.4,7.4,12.8,21.8,5.4,32.2c-1.5,2.1-3.3,3.9-5.4,5.4L410.6,716c-10.4,7.4-24.8,5-32.2-5.4c-2.8-3.9-4.3-8.6-4.3-13.4V325.7c0-12.7,10.3-23.1,23.1-23.1C402,302.7,406.7,304.2,410.6,307z"/></svg>'), $.ui.registry.addIcon("axupimgs", '<svg id="\u591A\u56FE\u7247\u4E0A\u4F20" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve" focusable="false"><path d="M182.1,710.2L289,603.4c13.8-13.8,36.1-13.8,49.9,0l121,121l240.2-240.2c13.8-13.8,36.1-13.8,49.9,0l91.1,91.1V345.9h-659V710.2z M182.1,810v53.6h138.4l89.4-89.4l-96-96L182.1,810z M841.1,675.1L725,559L420.3,863.7h420.8V675.1z M135.1,251.7h753.2c26,0,47.1,21.1,47.1,47.1v611.9c0,26-21.1,47.1-47.1,47.1H135.1c-26,0-47.1-21.1-47.1-47.1V298.8C88,272.8,109.1,251.7,135.1,251.7z M417.5,581.2c-52,0-94.1-42.2-94.1-94.1s42.2-94.1,94.1-94.1s94.1,42.2,94.1,94.1S469.5,581.2,417.5,581.2z M158.6,157.6h706.1c13,0,23.5,10.5,23.5,23.5s-10.5,23.5-23.5,23.5H158.6c-13,0-23.5-10.5-23.5-23.5S145.6,157.6,158.6,157.6z M252.7,63.4h517.8c13,0,23.5,10.5,23.5,23.5s-10.5,23.5-23.5,23.5H252.7c-13,0-23.5-10.5-23.5-23.5S239.7,63.4,252.7,63.4z"></path></svg>'), $.ui.registry.addIcon("gift", '<svg id="\u62BD\u5956" width="22" height="22" viewBox="0 0 1024 1024" style="enable-background:new 0 0 1024 1024;" xml:space="preserve"><path d="M846.6,200.34H603.18l56.69-56.68c12.28-12.28,12.28-32.17,0-44.45c-12.28-12.28-32.17-12.27-44.44,0L514.28,200.34h-4.31L408.83,99.2c-12.28-12.27-32.18-12.27-44.44,0c-12.28,12.27-12.28,32.17,0,44.45l56.69,56.68H179.68c-44.81,0-81.27,36.45-81.27,81.27v195.04c0,35.36,22.74,65.43,54.33,76.58v299.51c0,44.81,36.45,81.27,81.27,81.27h558.26c44.81,0,81.27-36.45,81.27-81.27V553.23c31.59-11.15,54.33-41.22,54.33-76.58V281.6C927.86,236.79,891.41,200.34,846.6,200.34zM838.06,468.11h-6.12c-1.11-0.08-2.17-0.33-3.31-0.33c-1.13,0-2.19,0.25-3.31,0.33H542.49V290.14h295.58V468.11z M188.22,290.14h291.41v177.98H200.95c-1.11-0.08-2.17-0.33-3.31-0.33c-1.13,0-2.19,0.25-3.31,0.33h-6.12V290.14z M242.54,557.91h237.09V844.2H242.54V557.91z M542.49,844.2V557.91h241.25V844.2H542.49z"/></svg>'), $.ui.registry.addIcon("potato", '<svg id="\u5C0F\u7EA2\u4E66" x="0px" y="0px" width="43" height="20" viewBox="0 0 86 40" enable-background="new 0 0 86 40" xml:space="preserve"><image id="image0" width="43" height="20" x="0" y="0"href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAAAoCAYAAABkfg1GAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAA3jSURBVHgB7Vp5kBTVGf++7p7ZmdmL3eVa7iNcCwYDEk1BNChYsTAosZB4RFOVhEKK0lBJShOMolKhTKKlxhjP0hgtjygSYygSD4ygYmRxA4scyr1y7K577+zO0f3le+91T3fPzu7MLPlDIV9t70z3e+973/ve937f0YOQH6H9SQ+VnlX2Vd2cP2tI5YJgnKZxy3i+SoHgy0FiJV5ZCRr5Wb1VVLj9vYaO17c1n3h9ZXT3cfCsGfIgzKffi1AVmH/u0OUDWopvJys6AMECsCgzl3TBv8jklVV8ahaQVgBoBKONiejdq4pb1j5aXZ0QLXxZubLMRjpfZmLiJb8zDOOn1N1BKJ4Q5ropX3zq1QiIhN1oRgi7AF+I7N3wPchRuZit7di0eZMrrXBNMtYeMKQuTyOF5kFJsCyjoFCD7sI5uP/FdyHLmdR6eS4HmbMW3DGkAz6mWKduoIZnqlIFGaCxUrvMpN64xZx89ZOglKr31j+ToqSpJ2csWgetLZfrsseZq9BMlCSTjEjZv3Hn+vPAhsr0Ppjhnqxpl62zulpZqVr/FJqv4/oyOTpBLG/SskwjXPYx1r7yVciAuz2goHvqonus7lNQqqB8lUQ5PzwFIvt/P/min5WhaXoi2jzNmn3F86CUir1111qr5s4qjBlbdUzSKR1/ItcK82VjWWq8w0fXTx2JkqbNQwoktPI/27ekpUEiElwSqd3wEnisFj2fRNMWEnW3WwioQX/JNBU3U8SCaioMBnJbCI8xR1WCftYkljgJEImA9eEO0I6dAL9IBJ6d64MhyTibFs0HaG3nTTIAEknAf74DECqAHmYI/dlAsqAgrFWHTgbPqa4WWCuVm+LUNW3Bn/Vo59UBTeu/UtnCrCnjQPvb46lHyX99CMZ3lwKUl/c9VkjyyX4ORQ6CF4WobDrgoIEgnDIdPAo9EIrSDteYkSCVdKIRIB4HKOQNqt/rtovnlaNZsaPkRkJpMcs2wE10OrsAWlqVgYwZwZ/ZLcLicNcsGbAp+NEr85xnhljSYoBAKGFdC6egU4e0WNJ3b3R0QlarImV91pULWQS7LyuMNrzN2Y9t7Wy1GNsDFEt4uHmtjMcnLdAq2JfoATBrN4I+arjqIhSo22sbUgEQbVIbxcaFW7YDXbUcsKQMoL0TrBXXA966HIi/axNZTyWFSul9rRl5u1vbL9pY9Y3yb3/8frMQRs722Nh5a0yz69RRB4U+KF1tkDUPEc1HD4P24B0uvrIV4o9WKmsSSuZOUo0FrOjUFfR918QpFEvSdNC6E0qZAk91j8EI6w4XyDFYwJ8XcsRU/xFQNAoUDoDGSkWeTyuKAK1/BKCxGXIh0k26IFnxkLNkMSOVhiM36rngiw+SyObhXOoZSuzKNMTuR57+zqcIlqefDTCozD3WjK0QM5W12frILiE63iJ3tBQbKGSqfo3HdaWeSemS8b59g2cSjVP8kE5LUvePD5gymszOgpxcL3kYdkQB2jqB+IL21pQvoUioVylI4JeAhvYONYbsKevqgJ65x7VWwerGW4GCYdmX4gn3eXfM109as3B0DBFg6MySpD8hAWtRnq8zqiINp7s41rG4n49QbiXjOIQVr2g3WIzn2vzrAAaXQVZ9OLfxbnhn/DmzxXdjfMiYm1u9xkMHD7GX3cVeOyT1KYO4ITMBi0r8i7YXLqnuM6BjWwHLBrhNY+ZwxBAEmjARcMIYdwyHR/j+q6lbs2Y3GHOvAQhOAjTZu/+JT9y1l6tGYQ/LbwN48gVRLQEcN1quGGdeqpxXmBXeetCdc2s14OxLxCRspVsAZkx15y0qBAxPZp6cwAq4GDVCObEcCdGCmZFx1wNse9eYU1y5ECkJeRFP7MUtWZrp5kUUSdH9fZ3bUATw0yMAs1zFQmEE4DiXQZ+42+/dDX8Krl95A1sORxUWj21p43mK/FMwDuOIEWqcsDgxZ+Vg1ZZM+GFB4GrpMBCGLUIvH58QG8roUfaiMC+l2oMgYLVcJJdgUGJKfvEbHz3DECPdIJiPljg+DnP/XK6ysKnF3zR4CMC+w2BNr+q1GkTbdgLW1zP+DnUfan7FS4yUnpOvAHM68pn6Lv4Mv/JQPGznuJjPGbHcvgypkZ+38VrK+zj+mciTkutWQMaVrCFtZG7Ru4fCvLMei6XmVhUWQR9bJLxzo1+xNLoS8LPhoFVdDHTnSsCGZqAfXgE40I15ceUaDpGG2SGPLWdv4Y+YvK4BrH2bQBMwYI9Az2nA6VOAdr3H8qNrnbIj99m8HujIMYCHnwN8mZ2ZaE/mZ7XY1RWhxYtFKkKFeY0Ue57uoIQjsONPUjaRRix0MAT0nz2A1yx0n3JMiXFTYfXt97FT5uD95h9DaqFH+c1IdTXA8FFyXidTht7KGEKL7Mm1oQNVKgwZNlqcnMnje44Vih/JG80XzJ4J5i1LQZ/BOD06B7sjPxvYtUvvV0ZAxX6MgwYOuIMBl7G3r3PPFosnG/yNMuOxX+8wnuG9a+1jrRhZN/9WKTX1yE0eMpJs7m9q6ie9agLQDdfbOJtFs5h2Fw7LBKEb8iK2yYFpGNTalrKQvkSwRD8PaRVlSrGsMGpkHL1uUUpIEjn95k3SUVFpiQyhsi7Qgdp0e/E6IcrGw91YKc/nNnzluFciRbmj+jumwXz2M4+pkCsJ6xo7Qslgz4ef1rG3VfCAaYKj85+Pr9bgz2KICy4YiylvvuomX2QgMbyuRs0xY6EzkzsW0tdq48QwPsrjv8n7RdLzU7yVizg7XfGPnQScNRewfBSofM4mEbvesgy0pVe7LIdzZCHkk7sFmcnjuCSFCjpWw2pLQ13fntfJEcH116eneEpht25jhkG1vB5Y4Pn+yUF/24xpMj8H9vq4dIm/za5bUHUtwIFPPeky9cRYb6gmgn3k9NaQb1lBM0M+EYSyUewvp7zYzRGDuER9I8Ap7l0P+PnmUIBJV7hlavVS/M3NJ97K54UriRRz6CAfX+39j9RiZcaalm14a7MMBSQyNuc5b4aUq6wC6NHn1Hey22zPj0t/oaICcDZSS6W5KXL4U9q9rC/4nSn2uEGV4Yhqp8j0/MJDPiSXSPE3pJS7tOgGpNx9GHK1B5f90lYCKYs7cMhuFMcvnZedv4tFiKzr9S0ujq19iFPJwRI/cc3DvDA+nhG+wuyw+BPCHMi3diiR2zpUOtzNG9PV7T9kXXGVJnd0KLx3NjODvRA5MqETi6mKCX+SZaVJ7gBOjgpmPxNrb3pSfDVuOLm/flnF1E6Id0TAA4m98rItiVhBOI/T4sf4zYTIeuo4NOIsB8aPSZsM3bp6CUcTd/JxW3SxmmbtH2U4Q5ye0lWXgrbvENdbdYl9oqRHokq1bJUK1Z69lxOMNhnUw5yZfp19/3IZIsn6ANdXccVqj5PqbSGkagsNn3MGZoqjyPXXQf4usriee5SBRhiGH6/eLr7LemxbvP03vOTVWsolZ+HARWtccRvQ3rcAf34XO65CMA9tBp3DMBQ5tth5ByM/b2ZLtCteouq0j4vZB44Avf0BaJWceR0+yjP/hHNzxuivKR+aWsbPfi1eiQI8uhrwotkKPzMtaBbXYPlKVWYTMYmv6ibTCFtZ+w8Dte5QdQFU9ikjCBHhiOKOOBkyvc6uXIu9dpToLymZxPUiq2Hx5AVJSHbluD0kvShVDgJsaVfYeh4v7Nn7ek44ZwloJxvdB2zBMicXmREvgqZWAa77fc8p4kmgggm8UYzD0b35Jd1jz09lgtTWxvHzh25bHRfMJ1zIp2yoXKpV9RXQ/vpIGgPlDGnZrfwaZ0sqlOxzTnaWD9Z/UHpjU1O7uJW2fqX4HQHp9yVyLnPxMgvDSqmoQil4YZ0qxXkne+41BvE9/qHsaVE4MOGJD3K58KX7M85g3f8UYOkAsJ55IO9w3//GLi38E3BkJlJt2sY32cITfrmFUu99AvD59T0KQhlltciKBQIbWaltkHKbiuRrP5pyWQLi7eK8ZefmF0WyorISwIljGQdZaTtqAUX1fWBF77m9sNiyUu5TLkMpB+BR1BV27pZlQDpvBgfpXEMQub0dMZDndUx6NobircLe/eBmGozWZ02UmykWxjoAjSFAFJEcx0qRsKqGCQjjk4I1tSouLy3KLLvXB4kwKFSs4a5XETy/L/Aag940+fyqErNgh06mHxJydYwi1HL2K9efJaRiUEqDMjuaMCnDrx883tonlxvL+h55fxFpV716yOAZ7i44jQ/1FN5kbNMtcx4e2LQJPK+/vSKb5XveqSU9uCqZzibXcE6cQS0PpcoxqeKjG1d6najmjZuc75r7id4LATIlKF6+2IsM6XNDBj5plBSnrDTyNCv1TUj7JUz6NFKhybOveAram67TlZD5QtwZQaxUywiXbsPa9edCBntOP2TSRoyal38AxeVPW6ZKJOH/5CGipEVkFJdvsZXqxGM+ypRyCZOWyk0MLLzJMg2B+fm+ozgtSeRmbGuoDRl2P9a8fAEo/WXUTbZjjo0zvzWpIlpUY8U7gwo6EXtwON1tmoN/kacYwUiysys5q+jgP3bYLb2uPBf8lKprnXTx8pJA+A/U1UZ4xmCvCgKxIIwd3bE1xfvf+BX08nvYdMpVOY67tOonz1sxSAvfQmZ0OJry0eljtd6qmHiVHow0H++ov2vYoXe9KWVOK+2P1cnpby4bV3pOKHjuZSUjFwSSiZkMN+MZcYampv6yKNuNbzlrsnabIapZ39T096PRts0rWw61eHtAHvRfjEuVW6AwhkwAAAAASUVORK5CYII=" ></image></svg>'), $.ui.registry.addButton("scroImage", {
            tooltip: "\u63D2\u5165\u6A2A\u6ED1\u56FE\u7247",
            icon: "scroImage",
            onAction: () => {
              ue.scrollImgVisible = !0;
            }
          }), $.ui.registry.addButton("mdlink", {
            tooltip: "\u63D2\u5165\u94FE\u63A5",
            icon: "link",
            onAction: () => {
              if (!ue.canLink)
                return alert("\u89C6\u9891\u97F3\u9891\u56FE\u7247\u6A2A\u6ED1\u7B49\u7981\u6B62\u8F6C\u4E3A\u8D85\u94FE\u63A5\u683C\u5F0F"), !1;
              ue.linkVisible = !0;
            }
          }), $.ui.registry.addButton("image", {
            tooltip: "\u63D2\u5165\u56FE\u7247",
            icon: "image",
            onAction: () => {
              D.value.click();
            }
          }), $.ui.registry.addButton("media", {
            tooltip: "\u63D2\u5165\u89C6\u9891",
            icon: "embed",
            onAction: () => {
              ue.mediaType = 2, ue.dialogVisible = !0;
            }
          }), $.ui.registry.addButton("audio", {
            tooltip: "\u63D2\u5165\u97F3\u9891",
            icon: "audio",
            onAction: () => {
              ue.mediaType = 3, ue.dialogVisible = !0;
            }
          }), $.ui.registry.addButton("axupimgs", {
            icon: "axupimgs",
            tooltip: "\u591A\u56FE\u7247\u4E0A\u4F20",
            onAction: function() {
              ue.axuImgVisible = !0;
            }
          }), y("onInit", $);
        },
        autosave_ask_before_unload: !1,
        bdmap_width: 752,
        bdmap_height: 502,
        paste_data_images: !1,
        relative_urls: !1,
        remove_script_host: !1,
        paste_preprocess: function($, N) {
          if (N.content.indexOf("<article") != -1 && (N.content = N.content.replace(/<article([\s\S]*?)>/i, "<article>"), console.log("--------replace article--------"), console.log(N.content)), N.content.indexOf("data-font-family") != -1 && (N.content = N.content.replace(/data-font-family="[^>]*/g, ""), console.log("--------replace data-font-family--------"), console.log(N.content)), N.content.indexOf("<img") != -1) {
            let ae = "parseImg", ce = [], ne = 0, Ce = !1, Te = N.content, _ = Te.match(/src=[\'\"]?([^\'\"]*)[\'\"]?/gi), je = "";
            for (; Te.indexOf("<img") != -1; )
              Ce = !0, Te = Te.replace("<img", "<img id=" + ae + ne), je += Te.slice(0, Te.indexOf("<img id=" + ae + ne) + 8), Te = Te.slice(Te.indexOf("<img id=" + ae + ne) + 8), ne++;
            if (je && (je += Te), je = je.replace(/src=[\'\"]?([^\'\"]*)[\'\"]?/gi, ""), N.content = je, Ce) {
              let Me = [];
              _ = _.map((Je) => Je.slice(5, -1));
              for (let Je = 0; Je < _.length; Je++)
                Me.push(new Promise((Lt) => {
                  Pt(_[Je], (dt) => {
                    if (dt) {
                      let Tt = {
                        channel: w.channel,
                        success: function(se, tr, _t, Pe, kt) {
                          if (se) {
                            let He = kt.width, We = kt.height, Ae = 690;
                            He >= 690 && (He = 690, We = parseInt(kt.height / kt.width * 690));
                            let Ke = (He / Ae).toFixed(2);
                            ce.push({ src: se, id: ae + Je, width: He, height: We, rate: Ke }), Lt();
                          }
                        },
                        error: function() {
                          ce.push({ src: "https://p6.moimg.net/mdwxapp/image_load_failed.png", id: ae + Je, width: 690, height: 295, rate: 1 }), Lt();
                        }
                      }, Jt = [Ct(dt, new Date().getTime() + ".jpg")];
                      w.sourceTop == "acp" ? pe(Tt, Jt, 0) : Y(Tt, Jt, 0);
                    } else
                      ce.push({ src: "https://p6.moimg.net/mdwxapp/image_load_failed.png", id: ae + Je, width: 690, height: 295, rate: 1 }), Lt();
                  });
                }));
              Promise.all(Me).then(() => {
                let Je = tinyMCE.editors[ue.tinymceId].getContent(), Lt = "";
                ce.forEach((dt) => {
                  Lt = Je.replace(`id="${dt.id}"`, `src=${dt.src} data-mce-src=${dt.src} height=${dt.height} width=${dt.width} data-rate=${dt.rate}`), Je = Lt;
                }), tinyMCE.editors[ue.tinymceId].setContent(Lt), tinyMCE.editors[ue.tinymceId].save();
              });
            }
          }
        }
      }
    });
    Wi(
      () => w.modelValue,
      () => {
        J.value = w.modelValue;
      }
    ), Wi(
      () => J.value,
      () => {
        y("update:modelValue", J.value);
      }
    );
    const ee = () => {
      if (ue.linkVisible)
        return ue.linkVisible = !1, !1;
      if (ue.axuImgVisible)
        return ue.axuImgVisible = !1, !1;
      if (ue.voteVisible)
        return ue.voteVisible = !1, !1;
      ue.file_progress == 100 || !ue.fileProgressVisible ? (ue.fileProgressVisible = !1, ue.fileUploadName = "", ue.file_progress = 0, ue.dialogVisible = !1) : alert("\u8BF7\u7B49\u5F85\u89C6\u9891\u4E0A\u4F20\u6210\u529F\u540E\u518D\u8FDB\u884C\u64CD\u4F5C");
    }, Ge = ($) => {
      ue.tinymceContent = $, De(), ee();
    }, ze = ($) => {
      ue.tinymceContent = $;
      let N = tinyMCE.editors[ue.tinymceId];
      if (ue.linkText || ue.linkHtml) {
        const ae = N.dom.getParent(N.selection.getNode(), "a");
        ae && N.selection.select(ae), N.insertContent($);
      } else
        De();
      ee(), ht();
    }, ht = () => {
      ue.linkHref = "", ue.linkText = "", ue.linkHtml = "", ue.linkIsText = !0;
    }, ie = ($) => {
      ue.tinymceContent = $, De(), ee();
    }, Ze = async ($) => {
      let N = $.target.files[0], ae = N.size / 1024 / 1024;
      if (/(?:\.([^.]+))?$/.exec(N.name)[1].toLocaleLowerCase(), ae > 10) {
        alert("\u6587\u4EF6" + N.name + "\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC710M"), $.target.value = "";
        return;
      }
      let Ce = 0, Te = await ge(N);
      if (console.log(Te), !Te)
        return alert("\u62B1\u6B49\uFF0C\u4EC5\u652F\u6301\u4E0A\u4F20\u7279\u5B9A\u7684\u56FE\u7247\u683C\u5F0F\uFF0C\u8BF7\u9009\u62E9\u6B63\u786E\u7684\u56FE\u7247\u6587\u4EF6\u683C\u5F0F\u3002"), $.target.value = "", !1;
      if (Te && N.type.split("/")[1] != Te && !_e(w.accept).includes(Te))
        return alert("\u56FE\u7247\u683C\u5F0F\u5F02\u5E38\uFF0C\u62A5\u9519\u56FE\u7247\u540E\u7F00\u4E3A:." + N.type.split("/")[1] + " \u771F\u5B9E\u683C\u5F0F\u4E3A:." + Te), $.target.value = "", y("onError", null), !1;
      if (!await Be(N).catch((Je) => {
        alert(Je), $.target.value = "";
      }))
        return !1;
      ae > 3 && Te == "gif" && (Ce = 4);
      let je = {
        status: Ce,
        success: function(Je, Lt, dt, Tt, Jt) {
          let se = Jt.width, tr = Jt.height, _t = 690;
          se > 690 && (se = 690, tr = parseInt(Jt.height / Jt.width * _t));
          let Pe = (se / _t).toFixed(2), kt = '<img class="editor" src=' + Je + ' width="' + se + '" height="' + tr + '" data-rate="' + Pe + '">';
          Ce == 4 && (kt = '<img class="editor gif-video" src=' + Je + ' width="' + se + '" height="' + tr + '" data-video="' + Jt.video_url + '" data-cover="' + Jt.video_cover + '" data-rate="' + Pe + '">'), (se = 690) && (kt += "<p>&nbsp;</p>"), ue.tinymceContent = kt, De(), $.target.value = "";
        },
        error: function(Je, Lt) {
          console.log(Lt), alert(Lt), $.target.value = "";
        }
      }, Me = [];
      Me.push(N), w.sourceTop == "acp" ? pe(je, Me, 0) : Y(je, Me, 0);
    }, De = () => {
      tinyMCE.editors[ue.tinymceId].insertContent(ue.tinymceContent);
    }, Pt = ($, N) => {
      let ae = document.createElement("canvas"), ce = ae.getContext("2d"), ne = new Image();
      ne.crossOrigin = "Anonymous", ne.onload = function() {
        ae.height = ne.height, ae.width = ne.width, ce.drawImage(ne, 0, 0);
        var Te = ae.toDataURL("image/png"), _ = Ce(Te);
        console.log("\u56FE\u7247\u5927\u5C0F\uFF1A" + _.size / 1024 / 1024 + " M"), _.size / 1024 / 1024 > 5 ? N && N(null) : N && N(Te), ae = null;
      }, ne.src = $, ne.onerror = function(Te) {
        console.log(Te), N && N(null);
      };
      function Ce(Te) {
        for (var _ = atob(Te.split(",")[1]), je = Te.split(",")[0].split(":")[1].split(";")[0], Me = new ArrayBuffer(_.length), Je = new Uint8Array(Me), Lt = 0; Lt < _.length; Lt++)
          Je[Lt] = _.charCodeAt(Lt);
        return new Blob([Me], { type: je });
      }
    }, Ct = ($, N, ae) => {
      let ce = $.split(","), ne = ce[0].match(/:(.*?);/)[1], Ce = atob(ce[1]), Te = Ce.length, _ = new Uint8Array(Te);
      for (; Te--; )
        _[Te] = Ce.charCodeAt(Te);
      return new File([_], N, { type: ne });
    }, Be = ($) => new Promise((N, ae) => {
      const ce = new FileReader();
      let ne = "";
      ce.readAsDataURL($), ce.onload = () => {
        ne = ce.result;
      }, ce.onerror = (Ce) => {
        ae(Ce);
      }, ce.onloadend = () => {
        const Ce = new Image();
        Ce.onload = () => {
          event.target.width > 6e3 ? ae("\u5EFA\u8BAE\u56FE\u7247\u5BBD\u5EA6\u5C3A\u5BF8\u5C0F\u4E8E6000px") : event.target.height > 3e4 ? ae("\u5EFA\u8BAE\u56FE\u7247\u9AD8\u5EA6\u5C3A\u5BF8\u5C0F\u4E8E30000px") : N(ne);
        }, Ce.src = ne;
      };
    }), ge = async ($) => new Promise((N, ae) => {
      const ce = new FileReader();
      ce.onerror = (ne) => {
        ae(ne);
      }, ce.onload = () => {
        let ne = null;
        const Ce = ce.result, Te = new Uint8Array(Ce), _ = [
          { ext: "png", data: [137, 80, 78, 71, 13, 10, 26, 10] },
          { ext: "jpeg", data: [255, 216, 255] },
          { ext: "gif", data: [71, 73, 70] },
          { ext: "ico", data: [0, 0, 1, 0] },
          { ext: "bmp", data: [66, 77] },
          { ext: "pdf", data: [37, 80, 68, 70, 45, 49] },
          { ext: "webp", data: [87, 69, 66, 80], offset: 8 },
          { ext: "HEIF", data: [102, 116, 121, 112, 104, 101, 105], offset: 4 }
        ];
        for (let je = 0; je < _.length; je++) {
          const { data: Me, offset: Je, ext: Lt } = _[je];
          xe(Te, Me, Je) && (ne = Lt);
        }
        ne ? N(ne) : ae("\u672A\u77E5\u7684\u6587\u4EF6\u7C7B\u578B");
      }, ce.readAsArrayBuffer($);
    }).catch((N) => {
      console.log(N);
    }), xe = ($, N, ae) => {
      let ce = !0, ne = ae || 0;
      for (let Ce = 0; Ce < N.length; Ce++)
        $[Ce + ne] !== N[Ce] && (ce = !1);
      return ce;
    }, _e = ($) => $.split(",").map((ce) => ce.split("/")[1]);
    return ($, N) => (Dn(), ir(Is, null, [
      Rt("input", {
        type: "file",
        id: "auth_file",
        ref_key: "filElem",
        ref: D,
        accept: m.accept,
        onChange: Ze,
        style: { display: "none" }
      }, null, 40, foe),
      Ja(Mt(loe), {
        modelValue: J.value,
        "onUpdate:modelValue": N[0] || (N[0] = (ae) => J.value = ae),
        init: ue.init,
        disabled: m.disabled,
        id: m.tinymceId
      }, null, 8, ["modelValue", "init", "disabled", "id"]),
      Ja(CQ, {
        acpToken: w.acpToken,
        env: w.env,
        sourceTop: w.sourceTop,
        isShow: ue.scrollImgVisible,
        onClose: N[1] || (N[1] = (ae) => ue.scrollImgVisible = !1),
        onBtnCallback: ie
      }, null, 8, ["acpToken", "env", "sourceTop", "isShow"]),
      Ja(_J, {
        acpToken: w.acpToken,
        env: w.env,
        sourceTop: w.sourceTop,
        channel: w.channel,
        isShow: ue.dialogVisible,
        mediaType: ue.mediaType,
        onBtnCallback: Ge,
        onClose: ee
      }, null, 8, ["acpToken", "env", "sourceTop", "channel", "isShow", "mediaType"]),
      Ja($ae, {
        acpToken: w.acpToken,
        env: w.env,
        sourceTop: w.sourceTop,
        isShow: ue.axuImgVisible,
        onBtnCallback: Ge,
        onClose: ee
      }, null, 8, ["acpToken", "env", "sourceTop", "isShow"]),
      Ja(Kae, {
        isShow: ue.linkVisible,
        href: ue.linkHref,
        text: ue.linkText,
        isText: ue.linkIsText,
        html: ue.linkHtml,
        onBtnCallback: ze,
        onClose: ee
      }, null, 8, ["isShow", "href", "text", "isText", "html"])
    ], 64));
  }
}), moe = /* @__PURE__ */ Md(doe, [["__scopeId", "data-v-dababcf1"]]);
const goe = _o({
  name: "TestButton"
}), poe = /* @__PURE__ */ Object.assign(goe, {
  props: {
    btnWidth: {
      type: String,
      default: "160px"
    },
    txt: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      default: "#fff"
    },
    btnColor: {
      type: String,
      default: "#00C4A1"
    },
    borderWidth: {
      type: String,
      default: "1px"
    },
    borderStyle: {
      type: String,
      default: "solid"
    },
    borderColor: {
      type: String,
      default: "#00C4A1"
    },
    btnMargin: {
      type: String,
      default: "0"
    },
    btnPadding: {
      type: String,
      default: "0"
    }
  },
  emits: ["btnCallback"],
  setup(m, { emit: y }) {
    const w = m, E = () => {
      y("btnCallback");
    }, P = Or(() => ({
      width: w.btnWidth,
      color: w.color,
      backgroundColor: w.btnColor,
      borderWidth: w.borderWidth,
      borderStyle: w.borderStyle,
      borderColor: w.borderColor,
      margin: w.btnMargin,
      padding: w.btnPadding
    }));
    return (H, X) => (Dn(), ir("div", {
      class: "primary_btn",
      style: Bd(Mt(P)),
      onClick: E
    }, Eo(m.txt), 5));
  }
}), hoe = /* @__PURE__ */ Md(poe, [["__scopeId", "data-v-971d2c91"]]);
const boe = { class: "stepLeft" }, yoe = {
  key: 0,
  class: "step_icon"
}, woe = /* @__PURE__ */ Rt("i", { class: "select" }, null, -1), Coe = [
  woe
], Soe = {
  key: 1,
  class: "step_icon"
}, xoe = { class: "step_content" }, koe = /* @__PURE__ */ Rt("span", null, null, -1), Toe = _o({
  name: "MDSteps"
}), Eoe = /* @__PURE__ */ Object.assign(Toe, {
  props: {
    active: {
      type: Number,
      default: 0
    },
    list: {
      type: Array,
      default: []
    }
  },
  setup(m) {
    return (y, w) => (Dn(), ir("div", boe, [
      (Dn(!0), ir(Is, null, ak(m.list, (E, P) => (Dn(), ir("div", {
        key: P,
        class: Hr([{ active: m.active == P }, { finish: P < m.active }])
      }, [
        P < m.active ? (Dn(), ir("div", yoe, Coe)) : (Dn(), ir("div", Soe, [
          Rt("span", null, Eo(P + 1), 1)
        ])),
        Rt("div", xoe, [
          Zu(Eo(E.title) + " ", 1),
          koe,
          Rt("p", null, Eo(E.description), 1)
        ])
      ], 2))), 128))
    ]));
  }
}), _oe = ["accept"], Aoe = _o({
  name: "Uploader"
}), Ooe = /* @__PURE__ */ Object.assign(Aoe, {
  props: {
    acpToken: {
      type: String,
      default: ""
    },
    sourceTop: {
      type: String,
      default: "m"
    },
    channel: {
      type: String,
      default: "project"
    },
    maxSize: {
      type: Number,
      default: 10
    },
    accept: {
      type: String,
      default: "image/*"
    },
    isCrop: {
      type: Boolean,
      default: !1
    },
    fixedNumber: {
      type: Array,
      default: () => [1, 1]
    },
    autoCropWidth: {
      type: Number,
      default: 1080
    },
    autoCropHeight: {
      type: Number,
      default: 1080
    },
    minWidth: {
      type: Number,
      default: 1080
    },
    minHeight: {
      type: Number,
      default: 0
    },
    isIdea: {
      type: Boolean,
      default: !1
    },
    isZiZHi: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["onBeforeUpload", "onSuccess", "onCancel", "onError"],
  setup(m, { expose: y, emit: w }) {
    const E = m, P = ja(null);
    y({
      onClick: () => {
        P.value.value = "", P.value.click();
      }
    });
    const X = () => b1.get("MDUSERTOKEN"), j = () => b1.get("MDSALEUSERTOKEN"), le = function(ge) {
      console.log("err", ge);
    }, Q = !1, pe = /test/.test(location.host) ? "test" : "", Y = E.acpToken, D = {
      client: 4,
      user_id: X() ? X().split("#")[0] : "",
      userid: X() ? X().split("#")[0] : "",
      token: X() ? X().split("#")[1] : ""
    }, J = {
      client: 4,
      user_id: j() ? j().split("#")[0] : "",
      userid: j() ? j().split("#")[0] : "",
      token: j() ? j().split("#")[1] : ""
    };
    let ue = {};
    E.sourceTop == "acp" ? ue = Ul({
      host: "acp",
      env: pe,
      header: {
        client: 4,
        user_id: Y ? Y.split(":")[0] : "",
        userid: Y ? Y.split(":")[0] : "",
        token: Y ? Y.split(":")[1] : ""
      },
      needLogin: Q,
      callback: le
    }) : E.sourceTop == "sale" ? ue = Ul({
      env: pe,
      header: J,
      acpneedLogin: Q,
      acpcallback: le
    }) : ue = Ul({
      env: pe,
      header: D,
      acpneedLogin: Q,
      acpcallback: le
    });
    const ee = bc(ue, Y ? Y.split(":")[0] : ""), Ge = bc(ue, X() ? X().split("#")[0] : ""), ze = Um({
      autoCropWidth: 3e3,
      autoCropHeight: 0,
      cropperShow: !1,
      cropperUrl: ""
    }), ht = () => {
      w("onBeforeUpload", null);
    }, ie = (ge) => {
      ge ? (ze.cropperShow = !1, w("onSuccess", ge)) : w("onError", null);
    }, Ze = async (ge) => {
      const { files: xe } = ge.target;
      if (xe.length === 0)
        return w("onCancel", null), !1;
      let _e = ge.target.files[0], $ = await Pt(_e);
      if (!$)
        return alert("\u62B1\u6B49\uFF0C\u4EC5\u652F\u6301\u4E0A\u4F20\u7279\u5B9A\u7684\u56FE\u7247\u683C\u5F0F\uFF0C\u8BF7\u9009\u62E9\u6B63\u786E\u7684\u56FE\u7247\u6587\u4EF6\u683C\u5F0F\u3002"), ge.target.value = "", w("onError", null), !1;
      if (console.log("getImgType\uFF1A" + $), $ && _e.type.split("/")[1] != $ && !Be(E.accept).includes($))
        return alert("\u56FE\u7247\u683C\u5F0F\u5F02\u5E38\uFF0C\u62A5\u9519\u56FE\u7247\u540E\u7F00\u4E3A:." + _e.type.split("/")[1] + " \u771F\u5B9E\u683C\u5F0F\u4E3A:." + $), ge.target.value = "", w("onError", null), !1;
      if (_e.size / 1024 / 1024 > E.maxSize) {
        alert("\u6587\u4EF6" + _e.name + "\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7" + E.maxSize + "M"), ge.target.value = "", w("onError", null);
        return;
      }
      if (E.isCrop && $ != "pdf") {
        let ae = await De(_e).catch((ce) => (alert(ce), ge.target.value = "", w("onError", null), !1));
        if (ae == 1) {
          w("onBeforeUpload", null);
          let ce = {
            channel: E.channel,
            success: (Ce) => {
              w("onSuccess", Ce), ge.target.value = "";
            },
            error: (Ce, Te) => {
              alert(Te), ge.target.value = "", w("onError", null);
            }
          }, ne = [];
          ne.push(_e), E.sourceTop == "acp" ? ee(ce, ne, 0) : Ge(ce, ne, 0);
        } else
          ae && (ze.cropperUrl = ae, ze.cropperShow = !0);
      } else {
        let ae = null;
        if ($ != "pdf" && (ae = await De(_e).catch((ce) => (alert(ce), ge.target.value = "", w("onError", null), !1))), ae || $ == "pdf") {
          w("onBeforeUpload", null);
          let ce = {
            channel: E.channel,
            status: $ == "pdf" ? 2 : 0,
            success: (Ce) => {
              w("onSuccess", Ce, _e.name), ge.target.value = "";
            },
            error: (Ce, Te) => {
              alert(Te), ge.target.value = "", w("onError", null);
            }
          };
          console.log(ce);
          let ne = [];
          ne.push(_e), E.sourceTop == "acp" ? ee(ce, ne, 0) : Ge(ce, ne, 0);
        }
      }
    }, De = (ge) => new Promise((xe, _e) => {
      const $ = new FileReader();
      let N = "";
      $.readAsDataURL(ge), $.onload = () => {
        N = $.result;
      }, $.onerror = (ae) => {
        _e(ae);
      }, $.onloadend = () => {
        const ae = new Image();
        ae.onload = () => {
          if (E.minWidth && event.target.width < E.minWidth || E.minHeight && event.target.height < E.minHeight) {
            let ce = "";
            E.minWidth && (E.minHeight ? ce += E.minWidth : ce += "\u5BBD\u5EA6\u5C3A\u5BF8\u5927\u4E8E" + E.minWidth + "px"), E.minHeight && (E.minWidth ? ce += " * " + E.minHeight + "px" : ce += "\u9AD8\u5EA6\u5C3A\u5BF8\u5927\u4E8E" + E.minHeight + "px"), _e("\u5EFA\u8BAE\u56FE\u7247" + ce);
          } else
            !E.isZiZHi && event.target.width > 6e3 ? _e("\u5EFA\u8BAE\u56FE\u7247\u5BBD\u5EA6\u5C3A\u5BF8\u5C0F\u4E8E6000px") : E.isIdea && E.isCrop && event.target.width / event.target.height >= 4 / 5 && event.target.width / event.target.height <= 5 / 4 || E.isCrop && event.target.width / event.target.height == E.fixedNumber[0] / E.fixedNumber[1] ? xe(1) : (ze.autoCropWidth = event.target.width, xe(N));
        }, ae.src = N;
      };
    }), Pt = async (ge) => new Promise((xe, _e) => {
      const $ = new FileReader();
      $.onerror = (N) => {
        _e(N);
      }, $.onload = () => {
        let N = null;
        const ae = $.result, ce = new Uint8Array(ae), ne = [
          { ext: "png", data: [137, 80, 78, 71, 13, 10, 26, 10] },
          { ext: "jpeg", data: [255, 216, 255] },
          { ext: "gif", data: [71, 73, 70] },
          { ext: "ico", data: [0, 0, 1, 0] },
          { ext: "bmp", data: [66, 77] },
          { ext: "pdf", data: [37, 80, 68, 70, 45, 49] },
          { ext: "webp", data: [87, 69, 66, 80], offset: 8 },
          { ext: "HEIF", data: [102, 116, 121, 112, 104, 101, 105], offset: 4 }
        ];
        for (let Ce = 0; Ce < ne.length; Ce++) {
          const { data: Te, offset: _, ext: je } = ne[Ce];
          Ct(ce, Te, _) && (N = je);
        }
        N ? xe(N) : _e("\u672A\u77E5\u7684\u6587\u4EF6\u7C7B\u578B");
      }, $.readAsArrayBuffer(ge);
    }).catch((xe) => {
      console.log(xe);
    }), Ct = (ge, xe, _e) => {
      let $ = !0, N = _e || 0;
      for (let ae = 0; ae < xe.length; ae++)
        ge[ae + N] !== xe[ae] && ($ = !1);
      return $;
    }, Be = (ge) => ge.split(",").map(($) => $.split("/")[1]);
    return (ge, xe) => (Dn(), ir(Is, null, [
      Rt("input", {
        type: "file",
        ref_key: "uploader",
        ref: P,
        onChange: Ze,
        accept: m.accept,
        style: { display: "none" }
      }, null, 40, _oe),
      Ja(cR, {
        acpToken: E.acpToken,
        sourceTop: E.sourceTop,
        channel: E.channel,
        isShow: ze.cropperShow,
        cropUrl: ze.cropperUrl,
        autoCropWidth: ze.autoCropWidth,
        fixedNumber: E.fixedNumber,
        onClose: xe[0] || (xe[0] = (_e) => ze.cropperShow = !1),
        onShowLoading: ht,
        onConfirm: ie
      }, null, 8, ["acpToken", "sourceTop", "channel", "isShow", "cropUrl", "autoCropWidth", "fixedNumber"])
    ], 64));
  }
});
const x5 = (m) => (NC("data-v-f43b7aea"), m = m(), IC(), m), Doe = { class: "dialogContent" }, Boe = { class: "op" }, Roe = ["onClick"], Moe = /* @__PURE__ */ x5(() => /* @__PURE__ */ Rt("i", { class: "plus" }, null, -1)), Poe = /* @__PURE__ */ Zu("\u7EE7\u7EED\u6DFB\u52A0"), Noe = [
  Moe,
  Poe
], Ioe = ["onClick"], Foe = /* @__PURE__ */ x5(() => /* @__PURE__ */ Rt("i", { class: "trash" }, null, -1)), $oe = /* @__PURE__ */ x5(() => /* @__PURE__ */ Rt("span", null, "\u6E05\u7A7A\u6240\u6709\u56FE\u7247", -1)), Loe = [
  Foe,
  $oe
], zoe = {
  key: 0,
  class: "empty"
}, Hoe = /* @__PURE__ */ x5(() => /* @__PURE__ */ Rt("i", { class: "plus" }, null, -1)), Voe = [
  Hoe
], Uoe = /* @__PURE__ */ x5(() => /* @__PURE__ */ Rt("p", null, "\u6DFB\u52A0\u56FE\u7247\uFF0C\u53EF\u540C\u65F6\u9009\u62E9\u591A\u5F20", -1)), joe = { class: "picbox" }, Woe = ["src"], qoe = { class: "meng" }, Goe = { class: "tools" }, Koe = ["onClick"], Xoe = ["onClick"], Yoe = { class: "namebox" }, Zoe = /* @__PURE__ */ Zu("\u53D6\u6D88"), Joe = _o({
  name: "MultiUploader"
}), Qoe = /* @__PURE__ */ Object.assign(Joe, {
  props: {
    multiUploaderDrawerVisible: {
      type: Boolean,
      default: !1
    },
    cropUrl: {
      type: String,
      default: ""
    },
    isShow: {
      type: Boolean,
      default: !1
    },
    autoCropWidth: {
      type: Number,
      default: 1080
    },
    autoCropHeight: {
      type: Number,
      default: 1350
    },
    fixedNumber: {
      type: Array,
      default: [4, 5]
    },
    info: {
      type: Boolean,
      default: !0
    },
    env: {
      type: String,
      default: ""
    },
    acpToken: {
      type: String,
      default: ""
    },
    sourceTop: {
      type: String,
      default: "m"
    },
    maxSize: {
      type: Number,
      default: 3
    },
    accept: {
      type: String,
      default: "image/jpg,image/jpeg,image/png,image/gif"
    },
    minWidth: {
      type: Number,
      default: 0
    },
    minHeight: {
      type: Number,
      default: 0
    },
    channel: {
      type: String,
      default: "project"
    },
    isCrop: {
      type: Boolean,
      default: !1
    },
    isIdea: {
      type: Boolean,
      default: !1
    },
    maxLength: {
      type: Number,
      default: 20
    }
  },
  emits: ["close", "confirm", "update:multiUploaderDrawerVisible"],
  setup(m, { emit: y }) {
    const w = m, E = () => b1.get("MDUSERTOKEN"), P = function(ae) {
      console.log("err", ae);
    }, H = !1, X = /test/.test(location.host) ? "test" : "", j = w.acpToken, le = {
      client: 4,
      user_id: E() ? E().split("#")[0] : "",
      userid: E() ? E().split("#")[0] : "",
      token: E() ? E().split("#")[1] : ""
    };
    let Q = {};
    w.sourceTop == "acp" ? Q = Ul({
      host: "acp",
      env: X,
      header: {
        client: 4,
        user_id: j ? j.split(":")[0] : "",
        userid: j ? j.split(":")[0] : "",
        token: j ? j.split(":")[1] : ""
      },
      needLogin: H,
      callback: P
    }) : Q = Ul({
      env: X,
      header: le,
      acpneedLogin: H,
      acpcallback: P
    });
    const pe = bc(Q, j ? j.split(":")[0] : ""), Y = bc(Q, E() ? E().split("#")[0] : ""), D = Um({
      confirmTxt: "\u5168\u90E8\u4E0A\u4F20",
      axuimgsList: [],
      file_i: 0,
      isSingle: !1,
      cropperShow: !1,
      cropperUrl: "",
      isReplace: !1
    }), J = Or({
      get: () => w.multiUploaderDrawerVisible,
      set: (ae) => y("update:multiUploaderDrawerVisible", ae)
    }), ue = () => {
      y("close");
    }, ee = (ae) => {
      y("close"), ae();
    }, Ge = (ae) => {
      if (ae) {
        if (D.cropperShow = !1, D.isReplace)
          D.axuimgsList[D.file_i].url = ae, D.axuimgsList[D.file_i].blobUrl = ae, D.axuimgsList[D.file_i].status = "up-over", D.axuimgsList[D.file_i].classList = "up-over";
        else {
          let ce = [];
          ce.push({
            file: "",
            blobUrl: ae,
            url: ae,
            classList: "up-over",
            status: "up-over"
          }), D.axuimgsList.push(...ce);
        }
        document.getElementsByClassName("up-no").length == 0 ? D.confirmTxt = "\u4FDD\u5B58" : D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20";
      }
    }, ze = (ae) => typeof ae == "object" && ae === null, ht = () => {
      D.isReplace = !1;
      let ae = document.createElement("input");
      ae.setAttribute("type", "file"), ae.setAttribute("multiple", "multiple"), ae.setAttribute("accept", w.accept), ae.click(), ae.onchange = async function() {
        var ce = this.files;
        let ne = [];
        if (ce.length > w.maxLength - D.axuimgsList.length)
          return alert("\u6700\u591A\u53EF\u4E0A\u4F20" + w.maxLength + "\u5F20"), !1;
        if (ce.length == 1)
          if (D.isSingle = !0, w.isCrop) {
            let Ce = ce[0], Te = await _e(Ce);
            if (!Te)
              return alert("\u62B1\u6B49\uFF0C\u4EC5\u652F\u6301\u4E0A\u4F20\u7279\u5B9A\u7684\u56FE\u7247\u683C\u5F0F\uFF0C\u8BF7\u9009\u62E9\u6B63\u786E\u7684\u56FE\u7247\u6587\u4EF6\u683C\u5F0F\u3002"), !1;
            if (console.log(Te), Ce.type.split("/")[1] != Te) {
              let Me = N(w.accept);
              if (console.log(Me), !Me.includes(Te))
                return alert("\u56FE\u7247\u683C\u5F0F\u5F02\u5E38\uFF0C\u62A5\u9519\u56FE\u7247\u540E\u7F00\u4E3A:." + Ce.type.split("/")[1] + " \u771F\u5B9E\u683C\u5F0F\u4E3A:." + Te), !1;
            }
            if (Ce.size / 1024 / 1024 > w.maxSize)
              return alert("\u6587\u4EF6" + Ce.name + "\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7" + w.maxSize + "M"), !1;
            let je = await xe(Ce, w.minWidth, w.minHeight).catch((Me) => (alert(Me), console.log("err"), !1));
            if (console.log(je), je == 1) {
              let Me = window.URL.createObjectURL(Ce);
              ne.push({
                file: Ce,
                blobUrl: Me,
                url: "",
                classList: "up-no",
                status: ""
              }), D.axuimgsList.push(...ne), D.axuimgsList.length > 0 && (D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20");
            } else
              ze(je) || (D.cropperUrl = je, D.cropperShow = !0);
          } else {
            let Ce = ce[0], Te = window.URL.createObjectURL(Ce);
            ne.push({
              file: Ce,
              blobUrl: Te,
              url: "",
              classList: "up-no",
              status: ""
            }), D.axuimgsList.push(...ne), D.axuimgsList.length > 0 && (D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20"), D.file_i = D.axuimgsList.length, console.log(D.file_i);
          }
        else {
          D.isSingle = !1;
          for (let Ce = 0; Ce < ce.length; Ce++) {
            let Te = ce[Ce], _ = window.URL.createObjectURL(Te);
            ne.push({
              file: Te,
              blobUrl: _,
              url: "",
              classList: "up-no",
              status: ""
            }), console.log(ne);
          }
          D.axuimgsList.push(...ne), D.axuimgsList.length > 0 && (D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20");
        }
      };
    }, ie = (ae) => {
      D.axuimgsList.splice(ae, 1), D.axuimgsList.length == 0 && (D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20");
    }, Ze = (ae) => {
      D.file_i = ae, D.isReplace = !0;
      let ce = document.createElement("input");
      ce.setAttribute("type", "file"), ce.setAttribute("accept", w.accept), ce.click(), ce.onchange = async function() {
        var ne = this.files;
        D.isSingle = !0;
        let Ce = ne[0], Te = await _e(Ce);
        if (!Te)
          return alert("\u62B1\u6B49\uFF0C\u4EC5\u652F\u6301\u4E0A\u4F20\u7279\u5B9A\u7684\u56FE\u7247\u683C\u5F0F\uFF0C\u8BF7\u9009\u62E9\u6B63\u786E\u7684\u56FE\u7247\u6587\u4EF6\u683C\u5F0F\u3002"), !1;
        if (console.log(Te), Ce.type.split("/")[1] != Te) {
          let je = N(w.accept);
          if (console.log(je), !je.includes(Te))
            return alert("\u56FE\u7247\u683C\u5F0F\u5F02\u5E38\uFF0C\u62A5\u9519\u56FE\u7247\u540E\u7F00\u4E3A:." + Ce.type.split("/")[1] + " \u771F\u5B9E\u683C\u5F0F\u4E3A:." + Te), !1;
        }
        if (Ce.size / 1024 / 1024 > w.maxSize)
          return alert("\u6587\u4EF6" + Ce.name + "\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7" + w.maxSize + "M"), !1;
        if (w.isCrop && Te != "pdf") {
          let je = await xe(Ce, w.minWidth, w.minHeight).catch((Me) => (alert(Me), !1));
          if (console.log(je), je == 1) {
            let Me = {
              channel: w.channel,
              success: (Lt) => {
                D.axuimgsList[D.file_i].url = Lt, D.axuimgsList[D.file_i].blobUrl = Lt, D.axuimgsList[D.file_i].status = "up-over", D.axuimgsList[D.file_i].classList = "up-over", document.getElementsByClassName("up-no").length == 0 ? D.confirmTxt = "\u4FDD\u5B58" : D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20";
              },
              error: (Lt, dt) => {
                alert(dt);
              }
            }, Je = [];
            Je.push(Ce), w.sourceTop == "acp" ? pe(Me, Je, 0) : Y(Me, Je, 0);
          } else
            ze(je) || (D.cropperUrl = je, D.cropperShow = !0);
        } else if (await xe(Ce, w.minWidth, w.minHeight).catch((Me) => (alert(Me), !1))) {
          let Me = {
            channel: w.channel,
            status: Te == "pdf" ? 2 : 0,
            success: (Lt) => {
              D.axuimgsList[D.file_i].url = Lt, D.axuimgsList[D.file_i].blobUrl = Lt, D.axuimgsList[D.file_i].status = "up-over", D.axuimgsList[D.file_i].classList = "up-over", document.getElementsByClassName("up-no").length == 0 ? D.confirmTxt = "\u4FDD\u5B58" : D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20";
            },
            error: (Lt, dt) => {
              alert(dt);
            }
          }, Je = [];
          Je.push(Ce), w.sourceTop == "acp" ? pe(Me, Je, 0) : Y(Me, Je, 0);
        }
      };
    }, De = () => {
      if (D.confirmTxt == "\u4FDD\u5B58") {
        var ae = [], ce = D.axuimgsList, ne = ce.length;
        for (let Ce = 0; Ce < ne; Ce++)
          ce[Ce].url && ae.push(ce[Ce].url);
        console.log(ae), y("confirm", ae), y("close"), D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20", D.axuimgsList = [];
      } else {
        if (D.axuimgsList.length == 0)
          return alert("\u8BF7\u6279\u91CF\u4E0A\u4F20\u56FE\u7247"), !1;
        if (D.axuimgsList.forEach((Ce) => {
          Ce.status || (Ce.classList = "up-no up-now");
        }), D.loading)
          return console.log(111), !1;
        D.loading = !0, Pt(0);
      }
    }, Pt = async (ae) => {
      var ce = D.axuimgsList.length;
      if (D.file_i = ae, ce == ae)
        return D.loading = !1, D.file_i = 0, D.confirmTxt = "\u4FDD\u5B58", !0;
      if (D.axuimgsList[ae].url != "" || ["up-error", "up-over"].includes(D.axuimgsList[ae].status))
        ae++, Pt(ae);
      else {
        let ne = await ge(D.axuimgsList[ae].file), Ce = Be(ne, D.axuimgsList[ae].file.name), Te = Ce.size / 1024 / 1024, Me = /(?:\.([^.]+))?$/.exec(Ce.name)[1].toLocaleLowerCase(), Je = await _e(Ce);
        if (!Je)
          return alert("\u62B1\u6B49\uFF0C\u4EC5\u652F\u6301\u4E0A\u4F20\u7279\u5B9A\u7684\u56FE\u7247\u683C\u5F0F\uFF0C\u8BF7\u9009\u62E9\u6B63\u786E\u7684\u56FE\u7247\u6587\u4EF6\u683C\u5F0F\u3002"), !1;
        if (console.log(Je), Ce.type.split("/")[1] != Je && !N(w.accept).includes(Je)) {
          Gc.alert("\u56FE\u7247\u683C\u5F0F\u5F02\u5E38\uFF0C\u62A5\u9519\u56FE\u7247\u540E\u7F00\u4E3A:." + Ce.type.split("/")[1] + " \u771F\u5B9E\u683C\u5F0F\u4E3A:." + Je, "\u63D0\u793A", {
            confirmButtonText: "\u786E\u5B9A",
            callback: () => {
              D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error up-real", ae++, Pt(ae);
            }
          });
          return;
        }
        if (Te > w.maxSize) {
          Gc.alert("\u56FE\u7247" + Ce.name + "\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7" + w.maxSize + "M", "\u63D0\u793A", {
            confirmButtonText: "\u786E\u5B9A",
            callback: () => {
              D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error up-size", ae++, Pt(ae);
            }
          });
          return;
        } else if (!(Me == "jpg" || Me == "png" || Me == "jpeg" || Me == "gif")) {
          Gc.alert("\u56FE\u7247" + Ce.name + "\u683C\u5F0F\u4EC5\u652F\u6301jpg,png,jpeg,gif\u683C\u5F0F", "\u63D0\u793A", {
            confirmButtonText: "\u786E\u5B9A",
            callback: () => {
              D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error up-real", ae++, Pt(ae);
            }
          });
          return;
        }
        xe(Ce, w.minWidth, w.minHeight).then((Lt) => {
          if (w.isCrop && Lt == 2)
            D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error up-bili", ae++, Pt(ae);
          else if (Lt) {
            let dt = {
              channel: w.channel,
              success: function(Jt, se, tr, _t, Pe) {
                let kt = {
                  url: Jt,
                  width: Pe.width,
                  height: Pe.height
                };
                kt ? (typeof kt == "string" ? D.axuimgsList[D.file_i].url = kt : (D.axuimgsList[D.file_i].url = kt.url, D.axuimgsList[D.file_i].width = kt.width, D.axuimgsList[D.file_i].height = kt.height), D.axuimgsList[D.file_i].status = "up-over", D.axuimgsList[D.file_i].classList = "up-over") : (D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error"), ae++, Pt(ae);
              },
              error: async (Jt, se) => {
                Gc.alert(se, "\u63D0\u793A", {
                  confirmButtonText: "\u786E\u5B9A",
                  callback: () => {
                    D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error", ae++, Pt(ae);
                  }
                });
              }
            }, Tt = [];
            Tt.push(Ce), w.sourceTop == "acp" ? pe(dt, Tt, 0) : Y(dt, Tt, 0);
          } else
            D.axuimgsList[D.file_i].status = "up-error", D.axuimgsList[D.file_i].classList = "up-error up-base", ae++, Pt(ae);
        });
      }
    }, Ct = () => {
      D.axuimgsList = [], D.confirmTxt = "\u5168\u90E8\u4E0A\u4F20";
    }, Be = (ae, ce, ne) => {
      let Ce = ae.split(","), Te = Ce[0].match(/:(.*?);/)[1], _ = atob(Ce[1]), je = _.length, Me = new Uint8Array(je);
      for (; je--; )
        Me[je] = _.charCodeAt(je);
      return new File([Me], ce, { type: Te });
    }, ge = async (ae) => {
      let ce = "";
      return await new Promise(function(ne, Ce) {
        let Te = ae, _ = new FileReader();
        _.readAsDataURL(Te), _.onload = function(je) {
          ce = je.target.result, ne();
        };
      }), ce;
    }, xe = (ae, ce, ne) => new Promise((Ce, Te) => {
      const _ = new FileReader();
      let je = "";
      _.readAsDataURL(ae), _.onload = () => {
        je = _.result;
      }, _.onerror = (Me) => {
        Te(Me);
      }, _.onloadend = () => {
        const Me = new Image();
        Me.onload = () => {
          if (ce && event.target.width < ce || ne && event.target.height < ne) {
            let Je = "";
            ce && (Je += "\u5BBD" + ce + "px"), ne && (ce && (Je += "*"), Je += "\u9AD8" + ne + "px"), Gc.alert("\u56FE\u7247\u5C3A\u5BF8\u4E0D\u6B63\u786E,\u8981\u6C42\u5C3A\u5BF8 " + Je, "\u63D0\u793A", {
              confirmButtonText: "\u786E\u5B9A",
              callback: () => {
                Ce(null);
              }
            });
          } else
            event.target.width > 6e3 || event.target.height > 3e4 ? Gc.alert("\u56FE\u7247\u8981\u6C42\u5C3A\u5BF8\u5C0F\u4E8E6000px*30000px", "\u63D0\u793A", {
              confirmButtonText: "\u786E\u5B9A",
              callback: () => {
                Ce(null);
              }
            }) : w.isIdea && w.isCrop && D.isSingle && event.target.width / event.target.height >= 4 / 5 && event.target.width / event.target.height <= 5 / 4 || !w.isIdea && w.isCrop && D.isSingle && event.target.width / event.target.height == w.autoCropWidth / w.autoCropHeight ? Ce(1) : w.isIdea && w.isCrop && !D.isSingle && !(event.target.width / event.target.height >= 4 / 5 && event.target.width / event.target.height <= 5 / 4) ? (console.log(event.target.width / event.target.height), Gc.alert("\u56FE\u7247\u8981\u6C42\u5BBD\u9AD8\u6BD4\u4E3A" + w.fixedNumber.join(":"), "\u63D0\u793A", {
              confirmButtonText: "\u786E\u5B9A",
              callback: () => {
                Ce(2);
              }
            })) : !w.isIdea && w.isCrop && !D.isSingle && event.target.width / event.target.height != w.autoCropWidth / w.autoCropHeight ? Gc.alert("\u56FE\u7247\u8981\u6C42\u5BBD\u9AD8\u6BD4\u4E3A" + w.fixedNumber.join(":"), "\u63D0\u793A", {
              confirmButtonText: "\u786E\u5B9A",
              callback: () => {
                Ce(2);
              }
            }) : Ce(je);
        }, Me.src = je;
      };
    }).catch((Ce) => {
      console.log(Ce);
    }), _e = async (ae) => new Promise((ce, ne) => {
      const Ce = new FileReader();
      Ce.onerror = (Te) => {
        ne(Te);
      }, Ce.onload = () => {
        let Te = null;
        const _ = Ce.result, je = new Uint8Array(_), Me = [
          { ext: "png", data: [137, 80, 78, 71, 13, 10, 26, 10] },
          { ext: "jpeg", data: [255, 216, 255] },
          { ext: "gif", data: [71, 73, 70] },
          { ext: "ico", data: [0, 0, 1, 0] },
          { ext: "bmp", data: [66, 77] },
          { ext: "pdf", data: [37, 80, 68, 70, 45, 49] },
          { ext: "webp", data: [87, 69, 66, 80], offset: 8 },
          { ext: "HEIF", data: [102, 116, 121, 112, 104, 101, 105], offset: 4 }
        ];
        for (let Je = 0; Je < Me.length; Je++) {
          const { data: Lt, offset: dt, ext: Tt } = Me[Je];
          $(je, Lt, dt) && (Te = Tt);
        }
        Te ? ce(Te) : ne("\u672A\u77E5\u7684\u6587\u4EF6\u7C7B\u578B");
      }, Ce.readAsArrayBuffer(ae);
    }).catch((ce) => {
      console.log(ce);
    }), $ = (ae, ce, ne) => {
      let Ce = !0, Te = ne || 0;
      for (let _ = 0; _ < ce.length; _++)
        ae[_ + Te] !== ce[_] && (Ce = !1);
      return Ce;
    }, N = (ae) => ae.split(",").map((Ce) => Ce.split("/")[1]);
    return (ae, ce) => {
      const ne = h1("draggable");
      return Dn(), ir(Is, null, [
        Ja(Mt(BU), {
          modelValue: Mt(J),
          "onUpdate:modelValue": ce[1] || (ce[1] = (Ce) => aR(J) ? J.value = Ce : null),
          title: "\u591A\u56FE\u7247\u4E0A\u4F20",
          "z-index": 1992,
          class: "multiUploaderDrawer",
          size: 700,
          "before-close": ee
        }, {
          footer: ka(() => [
            Ja(Mt(rR), {
              onClick: Ro(ue, ["stop"])
            }, {
              default: ka(() => [
                Zoe
              ]),
              _: 1
            }, 8, ["onClick"]),
            Ja(Mt(rR), {
              type: "primary",
              onClick: Ro(De, ["stop"])
            }, {
              default: ka(() => [
                Zu(Eo(D.confirmTxt), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: ka(() => [
            Rt("div", Doe, [
              Rt("div", Boe, [
                D.axuimgsList.length > 0 ? (Dn(), ir("a", {
                  key: 0,
                  class: "plus",
                  onClick: Ro(ht, ["stop"])
                }, Noe, 8, Roe)) : ba("", !0),
                Rt("a", {
                  class: "flex",
                  onClick: Ro(Ct, ["stop"])
                }, Loe, 8, Ioe)
              ]),
              D.axuimgsList.length == 0 ? (Dn(), ir("div", zoe, [
                Rt("div", {
                  class: "upload",
                  onClick: ht
                }, Voe),
                Uoe
              ])) : (Dn(), Mo(ne, {
                key: 1,
                modelValue: D.axuimgsList,
                "onUpdate:modelValue": ce[0] || (ce[0] = (Ce) => D.axuimgsList = Ce),
                "item-key": "index",
                id: "file_list"
              }, {
                item: ka(({ element: Ce, index: Te }) => [
                  Rt("li", {
                    class: Hr(Ce.classList)
                  }, [
                    Rt("div", joe, [
                      Rt("img", {
                        src: Ce.blobUrl
                      }, null, 8, Woe),
                      Rt("div", qoe, [
                        Rt("div", Goe, [
                          Rt("a", {
                            class: "refresh",
                            onClick: (_) => Ze(Te)
                          }, null, 8, Koe),
                          Rt("a", {
                            class: "remove",
                            onClick: (_) => ie(Te)
                          }, null, 8, Xoe)
                        ])
                      ])
                    ]),
                    Rt("div", Yoe, [
                      Rt("span", null, Eo(Ce.file.name), 1)
                    ])
                  ], 2)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        Ja(cR, {
          acpToken: w.acpToken,
          sourceTop: w.sourceTop,
          channel: w.channel,
          isShow: D.cropperShow,
          cropUrl: D.cropperUrl,
          autoCropWidth: w.autoCropWidth,
          autoCropHeight: w.autoCropHeight,
          fixedNumber: w.fixedNumber,
          onClose: ce[2] || (ce[2] = (Ce) => D.cropperShow = !1),
          onConfirm: Ge
        }, null, 8, ["acpToken", "sourceTop", "channel", "isShow", "cropUrl", "autoCropWidth", "autoCropHeight", "fixedNumber"])
      ], 64);
    };
  }
}), eie = /* @__PURE__ */ Md(Qoe, [["__scopeId", "data-v-f43b7aea"]]);
const vk = (m) => (NC("data-v-101c5426"), m = m(), IC(), m), tie = /* @__PURE__ */ vk(() => /* @__PURE__ */ Rt("input", {
  type: "file",
  id: "media_editor_input",
  style: { display: "none" }
}, null, -1)), nie = { class: "mediaDialogContent" }, rie = ["onClick"], aie = {
  key: 0,
  class: "loading"
}, oie = { class: "cover" }, iie = ["src"], uie = { class: "video_info" }, sie = { class: "title" }, lie = {
  key: 0,
  class: "edit_cover"
}, cie = ["onClick"], fie = /* @__PURE__ */ vk(() => /* @__PURE__ */ Rt("i", { class: "edit" }, null, -1)), vie = /* @__PURE__ */ Zu("\u7F16\u8F91\u5C01\u9762"), die = [
  fie,
  vie
], mie = {
  key: 1,
  class: "line"
}, gie = { class: "title" }, pie = { class: "line" }, hie = { class: "tab" }, bie = ["onClick"], yie = { class: "video_preview" }, wie = ["src"], Cie = /* @__PURE__ */ vk(() => /* @__PURE__ */ Rt("div", { class: "cover_cutter" }, null, -1)), Sie = {
  key: 0,
  class: "cover_list"
}, xie = ["onClick"], kie = ["src"], Tie = ["src"], Eie = /* @__PURE__ */ vk(() => /* @__PURE__ */ Rt("p", { class: "cover_tips" }, "\u53EF\u5DE6\u53F3\u62D6\u52A8\u81EA\u5B9A\u4E49\u5C01\u9762", -1)), _ie = ["onClick"], Aie = ["src"], Oie = { key: 1 }, Die = /* @__PURE__ */ vk(() => /* @__PURE__ */ Rt("p", null, [
  /* @__PURE__ */ Rt("i", { class: "plus" }),
  /* @__PURE__ */ Zu("\u70B9\u51FB\u4E0A\u4F20\u5C01\u9762")
], -1)), Bie = /* @__PURE__ */ vk(() => /* @__PURE__ */ Rt("p", null, "\u5C01\u9762\u56FE\u652F\u6301jpg\u3001jpeg\u3001png\u3001gif", -1)), Rie = [
  Die,
  Bie
], Mie = _o({
  name: "MediaUploader"
}), Pie = /* @__PURE__ */ Object.assign(Mie, {
  props: {
    env: {
      type: String,
      default: ""
    },
    acpToken: {
      type: String,
      default: ""
    },
    sourceTop: {
      type: String,
      default: "m"
    },
    isShow: {
      type: Boolean,
      default: !1
    },
    mediaType: {
      type: Number,
      default: 2
    },
    channel: {
      type: String,
      default: "project"
    },
    videoTips: {
      type: String,
      default: "\u63A8\u8350\u6BD4\u4F8B 16\uFF1A9\uFF0C\u683C\u5F0F mp4\uFF0C\u4E0D\u5927\u4E8E 2GB"
    },
    maxSize: {
      type: Number,
      default: 2048
    }
  },
  emits: ["close", "btnCallback", "update:isShow"],
  setup(m, { emit: y }) {
    const w = m, E = () => b1.get("MDUSERTOKEN"), P = function($) {
      console.log("err", $);
    }, H = !1, X = /test/.test(location.host) ? "test" : "", j = w.acpToken, le = {
      client: 4,
      user_id: E() ? E().split("#")[0] : "",
      userid: E() ? E().split("#")[0] : "",
      token: E() ? E().split("#")[1] : ""
    };
    let Q = {};
    w.sourceTop == "acp" ? Q = Ul({
      host: "acp",
      env: X,
      header: {
        client: 4,
        user_id: j ? j.split(":")[0] : "",
        userid: j ? j.split(":")[0] : "",
        token: j ? j.split(":")[1] : ""
      },
      needLogin: H,
      callback: P
    }) : Q = Ul({
      env: X,
      header: le,
      acpneedLogin: H,
      acpcallback: P
    });
    const pe = bc(Q, j ? j.split(":")[0] : ""), Y = bc(Q, E() ? E().split("#")[0] : "");
    Xc(() => {
    });
    const D = Um({
      confirmTxt: "\u786E\u5B9A",
      fileProgressVisible: !1,
      fileUploadName: "",
      file_progress: 0,
      isEditVideoCover: !1,
      videoUrl: "",
      videoCover: [],
      videoObj: {
        width: 1,
        height: 1
      },
      tempVideoCover: "",
      editCoverIndex: 0,
      editVideoTab: ["\u622A\u53D6\u5C01\u9762", "\u4E0A\u4F20\u5C01\u9762"],
      canvansLoading: !1,
      uploadVideoCover: "",
      cropperShow: !1,
      cropperUrl: "",
      autoCropWidth: 336,
      autoCropHeight: 189,
      fixedNumber: [1, 1],
      tinymceContent: {}
    }), J = Or(
      () => D.file_progress == 100 ? "\u4E0A\u4F20\u5B8C\u6210 100%" : "\u4E0A\u4F20\u4E2D..." + D.file_progress + "%"
    ), ue = Or({
      get: () => w.isShow,
      set: ($) => y("update:isShow", $)
    }), ee = () => {
      if (D.file_progress == 100 || D.file_progress == 0)
        D.fileProgressVisible = !1, D.fileUploadName = "", D.file_progress = 0, D.videoCover = [], D.uploadVideoCover = "", D.editCoverIndex = 0, D.tempVideoCover = "", D.isEditVideoCover = !1, y("close");
      else
        return alert("\u6587\u4EF6\u4E0A\u4F20\u4E2D\uFF0C\u8BF7\u52FF\u64CD\u4F5C\u3002"), !1;
    }, Ge = ($) => {
      let N = 70;
      var ae = document.getElementById("dragPreview");
      let ce = ae.parentElement.clientWidth, ne = N * $;
      ae.style.left = ne + "px";
      let Ce = ne / ce;
      const Te = document.getElementById("video");
      Te.currentTime = Te.duration * Ce, document.getElementById("videoPreview").currentTime = Te.duration * Ce;
    }, ze = ($) => {
      $ && (D.uploadVideoCover = $, D.cropperShow = !1);
    }, ht = () => {
      let $ = document.createElement("input");
      $.setAttribute("type", "file"), $.setAttribute("accept", "image/*"), $.click(), $.onchange = function(N) {
        let ae = N.target.files[0];
        if (ae.size / 1024 / 1024 > 3) {
          alert("\u6587\u4EF6" + ae.name + "\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC73M");
          return;
        }
        Be(ae).then((ne) => {
          if (console.log(ne), ne)
            ne.type == 0 && (D.videoObj.width <= D.videoObj.height ? (D.autoCropWidth = D.videoObj.width, D.autoCropHeight = D.videoObj.width, D.fixedNumber = [1, 1]) : (D.autoCropWidth = D.videoObj.width, D.autoCropHeight = D.videoObj.height, D.fixedNumber = [D.videoObj.width, D.videoObj.height]), D.cropperUrl = ne.url, D.cropperShow = !0);
          else {
            let Ce = {
              success: function(_, je, Me, Je, Lt) {
                D.uploadVideoCover = _;
              },
              error: function(_, je) {
                alert(je);
              }
            }, Te = [];
            Te.push(ae), w.sourceTop == "acp" ? pe(Ce, Te, 0) : Y(Ce, Te, 0);
          }
        });
      };
    }, ie = () => {
      D.canvansLoading = !0;
      let $ = null;
      $ = setInterval(function() {
        if (D.videoCover.length > 6) {
          D.canvansLoading = !1, clearInterval($), D.isEditVideoCover = !D.isEditVideoCover;
          var N = document.getElementById("dragPreview"), ae = 0, ce = 0, ne = !1;
          N.onmousedown = function(Ce) {
            ne = !0, ae = N.offsetLeft, N.offsetTop, ce = Ce.clientX, Ce.clientY, N.style.cursor = "move";
          }, window.onmousemove = function(Ce) {
            if (ne) {
              let Te = N.parentElement.clientWidth - N.clientWidth, _ = Ce.clientX - (ce - ae);
              (_ < 0 || _ > Te) && (ne = !1, N.style.cursor = "default"), _ > Te && (_ = Te), N.style.left = _ < 0 ? 0 : _ + "px";
              const je = document.getElementById("video");
              let Me = _ / Te;
              je.currentTime = je.duration * Me, document.getElementById("videoPreview").currentTime = je.duration * Me;
            }
          }, N.onmouseup = function(Ce) {
            ne = !1, N.style.cursor = "default";
          };
        }
      }, 300);
    }, Ze = async () => {
      if (D.file_progress != 100 && D.file_progress != 0)
        return alert("\u6587\u4EF6\u4E0A\u4F20\u4E2D\uFF0C\u8BF7\u7A0D\u540E"), !1;
      if (D.videoCover.length == 0)
        return alert("\u5C01\u9762\u56FE\u751F\u6210\u4E2D\uFF0C\u8BF7\u7A0D\u540E"), !1;
      if (D.file_progress == 0)
        return ee(), !1;
      if (D.isEditVideoCover)
        if (D.editCoverIndex == 0) {
          let $ = document.getElementById("video").currentTime, N = await xe(D.videoUrl, D.videoObj.editorWidth, D.videoObj.editorHeight, $), ae = _e(N, "img.png"), ce = {
            success: function(Ce, Te, _, je, Me) {
              console.log(Ce), D.tempVideoCover = Ce, D.tinymceContent = {
                mediaType: 2,
                url: D.videoObj.src,
                cover: Ce,
                width: D.videoObj.editorWidth,
                height: D.videoObj.editorHeight
              }, D.isEditVideoCover = !1;
            },
            error: function(Ce, Te) {
              alert(Te);
            }
          }, ne = [];
          ne.push(ae), w.sourceTop == "acp" ? pe(ce, ne, 0) : Y(ce, ne, 0);
        } else {
          if (!D.uploadVideoCover)
            return alert("\u8BF7\u624B\u52A8\u4E0A\u4F20\u5C01\u9762"), !1;
          D.tempVideoCover = D.uploadVideoCover, D.tinymceContent = {
            mediaType: 2,
            url: D.videoObj.src,
            cover: D.uploadVideoCover,
            width: D.videoObj.editorWidth,
            height: D.videoObj.editorHeight
          }, D.isEditVideoCover = !1;
        }
      else
        y("btnCallback", D.tinymceContent), ee();
    }, De = () => {
      Pt(w.mediaType);
    }, Pt = ($) => {
      let N;
      switch ($) {
        case 3:
          N = ".mp3, .m4a";
          break;
        case 2:
          N = ".mp4";
          break;
      }
      var ae = document.getElementById("media_editor_input");
      ae.setAttribute("accept", N), ae.click(), ae.onchange = function(ce) {
        var ne = ce.target.files[0];
        if (/(mp3|m4a|audio)/gi.test(ne.type) && ne.size > 200 * Math.pow(1024, 2))
          return alert(\u4E0A\u4F20\u97F3\u9891\u5927\u5C0F\u4E0D\u8D85\u8FC7200M), !1;
        if (ne.type.match(/mp4/gi)) {
          let Ce = ne.size / 1024 / 1024;
          if (Ce > w.maxSize) {
            let Te = w.maxSize / 1024 + "GB";
            return Ce < 1023 && (Te = w.maxSize + "M"), alert("\u4E0A\u4F20\u89C6\u9891\u5927\u5C0F\u4E0D\u8D85\u8FC7" + Te), !1;
          }
        }
        if ($ == 3) {
          let Ce = {
            status: 3,
            channel: w.channel,
            success: function(_, je, Me, Je, Lt, dt) {
              D.tinymceContent = {
                mediaType: 3,
                url: _,
                name: dt.file_name,
                duration: dt.duration
              }, ce.target.value = "";
            },
            error: function(_, je) {
              alert(je);
            }
          };
          console.log(Ce);
          let Te = [];
          Te.push(ne), w.sourceTop == "acp" ? pe(Ce, Te, function(_) {
            console.log(_), D.fileUploadName = ne.name, D.fileProgressVisible = !0, D.file_progress = (_ * 100).toFixed(2);
          }) : Y(Ce, Te, function(_) {
            console.log(_), D.fileUploadName = ne.name, D.fileProgressVisible = !0, D.file_progress = (_ * 100).toFixed(2);
          });
        } else {
          let Ce = {
            status: 1,
            channel: w.channel,
            success: async function(_, je, Me, Je, Lt, dt) {
              console.log(dt);
              let Tt = dt.width, Jt = dt.height;
              D.tempVideoCover = await Ct(je) || "", console.log("tempVideoCover:" + D.tempVideoCover), D.videoObj = {
                src: _,
                width: dt.width,
                height: dt.height,
                cover: je
              }, ge(_, Tt, Jt, dt.realTime), Tt >= 690 && (Tt = 690, Jt = parseInt(dt.height / dt.width * 690)), Tt == 0 && (Tt = 690, Jt = 388), D.videoObj.editorWidth = Tt, D.videoObj.editorHeight = Jt, w.mediaType == 2 && (D.tinymceContent = {
                mediaType: 2,
                url: _,
                cover: je,
                width: Tt,
                height: Jt
              }), ce.target.value = "";
            },
            error: function(_, je) {
              alert(je);
            }
          };
          console.log(Ce);
          let Te = [];
          Te.push(ne), w.sourceTop == "acp" ? pe(Ce, Te, function(_) {
            console.log(_), D.fileUploadName = ne.name, D.fileProgressVisible = !0, D.file_progress = (_ * 100).toFixed(2);
          }) : Y(Ce, Te, function(_) {
            console.log(_), D.fileUploadName = ne.name, D.fileProgressVisible = !0, D.file_progress = (_ * 100).toFixed(2);
          });
        }
      };
    }, Ct = async ($) => new Promise(function(N, ae) {
      var ce = new Image();
      ce.src = $, ce.onload = function(ne) {
        this.complete == !0 && N($);
      }, ce.onerror = function(ne) {
        N("");
      };
    }), Be = ($) => new Promise((N, ae) => {
      const ce = new FileReader();
      let ne = "";
      ce.readAsDataURL($), ce.onload = () => {
        ne = ce.result;
      }, ce.onerror = (Ce) => {
        ae(Ce);
      }, ce.onloadend = () => {
        const Ce = new Image();
        Ce.onload = () => {
          event.target.width / event.target.height == D.videoObj.width / D.videoObj.height ? N(null) : event.target.width > 6e3 || event.target.height > 3e4 ? (alert("\u56FE\u7247\u5EFA\u8BAE\u5C3A\u5BF8\u5C0F\u4E8E6000px*30000px"), N({ type: 1 })) : N({
            type: 0,
            url: ne
          });
        }, Ce.src = ne;
      };
    }), ge = ($, N, ae, ce) => {
      w.sourceTop == "acp" ? Q({
        url: "/apis/upload/mdmedia/show_video_list",
        method: "post",
        props: { url: $ }
      }).then(async (ne) => {
        if (ne.data) {
          if (ne.data.list) {
            D.videoUrl = ne.data.list[ne.data.default];
            let Ce = ce / 8;
            for (let Te = 1, _ = ce; Te <= _; Te += Ce)
              D.videoCover.push(await xe(D.videoUrl, N, ae, Te, "small"));
          }
        } else
          alert(ne.message);
      }) : Q({
        url: "/api/v1/show_video_list",
        method: "post",
        props: { url: $ }
      }).then(async (ne) => {
        if (ne.data) {
          if (ne.data.list) {
            D.videoUrl = ne.data.list[ne.data.default], console.log(D.videoUrl);
            let Ce = ce / 8;
            for (let Te = 1, _ = ce; Te <= _; Te += Ce)
              D.videoCover.push(await xe(D.videoUrl, N, ae, Te, "small"));
          }
        } else
          alert(ne.message);
      });
    }, xe = async ($, N, ae, ce, ne) => new Promise(function(Ce, Te) {
      let _ = N, je = ae;
      ne == "small" && (_ = 140, je = 78, N < ae && (_ = 78, je = 140)), console.log(_ + je), console.log(ce);
      const Me = document.createElement("video");
      Me.setAttribute("crossOrigin", "anonymous"), Me.setAttribute("src", $), Me.setAttribute("muted", "muted"), Me.setAttribute("width", _), Me.setAttribute("height", je), Me.currentTime = ce == 0 ? 0.1 : ce, Me.addEventListener("loadeddata", async () => {
        const Je = document.createElement("canvas");
        Je.width = _, Je.height = je, Je.getContext("2d").drawImage(Me, 0, 0, _, je);
        let Lt = Je.toDataURL("image/jpeg");
        console.log(Lt), ce == 1 && !D.tempVideoCover && (D.tempVideoCover = Lt), Ce(Lt);
      });
    }), _e = ($, N, ae) => {
      let ce = $.split(","), ne = ce[0].match(/:(.*?);/)[1], Ce = atob(ce[1]), Te = Ce.length, _ = new Uint8Array(Te);
      for (; Te--; )
        _[Te] = Ce.charCodeAt(Te);
      return new File([_], N, { type: ne });
    };
    return ($, N) => (Dn(), ir(Is, null, [
      tie,
      Ja(Mt(BU), {
        modelValue: Mt(ue),
        "onUpdate:modelValue": N[0] || (N[0] = (ae) => aR(ue) ? ue.value = ae : null),
        title: "\u5A92\u4F53\u6587\u4EF6\u4E0A\u4F20",
        "z-index": 1992,
        class: "mediaUploaderDrawer",
        size: 690,
        "before-close": ee
      }, {
        footer: ka(() => [
          Ja(Mt(rR), {
            type: "primary",
            onClick: Ro(Ze, ["stop"])
          }, {
            default: ka(() => [
              Zu(Eo(D.confirmTxt), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: ka(() => [
          Rt("div", nie, [
            !D.fileProgressVisible && !D.isEditVideoCover ? (Dn(), ir("div", {
              key: 0,
              class: "upload-video",
              onClick: Ro(De, ["stop"])
            }, [
              Rt("p", null, [
                Rt("span", null, "\u672C\u5730" + Eo(m.mediaType == 2 ? "\u89C6\u9891" : "\u97F3\u9891"), 1),
                Rt("span", null, Eo(m.mediaType == 2 ? m.videoTips : "\u652F\u6301mp3,m4a\u683C\u5F0F\uFF0C\u5927\u5C0F\u4E0D\u8D85\u8FC7200MB\uFF0C\u8BF7\u5C3D\u91CF\u4E0A\u4F20\u9AD8\u97F3\u8D28\u97F3\u9891\u3002"), 1)
              ])
            ], 8, rie)) : ba("", !0),
            D.fileProgressVisible && !D.isEditVideoCover ? (Dn(), ir("div", {
              key: 1,
              class: Hr(["progress", { video: m.mediaType == 2 }])
            }, [
              m.mediaType == 2 ? (Dn(), ir(Is, { key: 0 }, [
                D.canvansLoading ? (Dn(), ir("div", aie)) : ba("", !0),
                Rt("div", oie, [
                  Rt("img", {
                    class: Hr([{ horizontal: D.videoObj.width >= D.videoObj.height }, { erect: D.videoObj.width < D.videoObj.height }]),
                    src: D.tempVideoCover
                  }, null, 10, iie)
                ]),
                Rt("div", uie, [
                  Rt("div", sie, Eo(D.fileUploadName), 1),
                  Rt("span", null, Eo(Mt(J)), 1),
                  D.file_progress == 100 ? (Dn(), ir("div", lie, [
                    Rt("p", {
                      onClick: Ro(ie, ["stop"])
                    }, die, 8, cie)
                  ])) : (Dn(), ir("div", mie, [
                    Rt("div", {
                      class: "line-inner",
                      style: Bd({ width: D.file_progress + "%" })
                    }, null, 4)
                  ]))
                ])
              ], 64)) : (Dn(), ir(Is, { key: 1 }, [
                Rt("div", gie, [
                  Zu(Eo(D.fileUploadName), 1),
                  Rt("span", null, Eo(Mt(J)), 1)
                ]),
                Rt("div", pie, [
                  Rt("div", {
                    class: "line-inner",
                    style: Bd({ width: D.file_progress + "%" })
                  }, null, 4)
                ])
              ], 64))
            ], 2)) : ba("", !0),
            Hf(Rt("div", {
              class: Hr(["isEditVideoCover", { horizontal: D.videoObj.width >= D.videoObj.height }, { erect: D.videoObj.width < D.videoObj.height }])
            }, [
              Rt("div", hie, [
                (Dn(!0), ir(Is, null, ak(D.editVideoTab, (ae, ce) => (Dn(), ir("div", {
                  class: Hr(["item", { active: D.editCoverIndex == ce }]),
                  key: ce,
                  onClick: Ro((ne) => D.editCoverIndex = ce, ["stop"])
                }, Eo(ae), 11, bie))), 128))
              ]),
              Hf(Rt("div", null, [
                Rt("div", yie, [
                  Rt("video", {
                    id: "video",
                    crossOrigin: "anonymous",
                    src: D.videoUrl
                  }, null, 8, wie),
                  Cie
                ]),
                D.videoCover.length > 0 ? (Dn(), ir("div", Sie, [
                  (Dn(!0), ir(Is, null, ak(D.videoCover, (ae, ce) => (Dn(), ir("div", {
                    key: ce,
                    onClick: Ro((ne) => Ge(ce), ["stop"])
                  }, [
                    Rt("img", { src: ae }, null, 8, kie)
                  ], 8, xie))), 128)),
                  Rt("div", {
                    id: "dragPreview",
                    class: Hr(["video_preview", { horizontal: D.videoObj.width >= D.videoObj.height }, { erect: D.videoObj.width < D.videoObj.height }])
                  }, [
                    Rt("video", {
                      id: "videoPreview",
                      crossOrigin: "anonymous",
                      src: D.videoUrl
                    }, null, 8, Tie)
                  ], 2)
                ])) : ba("", !0),
                Eie
              ], 512), [
                [Dd, D.editCoverIndex == 0]
              ]),
              D.editCoverIndex == 1 ? (Dn(), ir("div", {
                key: 0,
                class: "upload_video_cover",
                onClick: Ro(ht, ["stop"])
              }, [
                D.uploadVideoCover ? (Dn(), ir("img", {
                  key: 0,
                  class: Hr([{ horizontal: D.videoObj.width >= D.videoObj.height }, { erect: D.videoObj.width < D.videoObj.height }]),
                  src: D.uploadVideoCover
                }, null, 10, Aie)) : (Dn(), ir("div", Oie, Rie))
              ], 8, _ie)) : ba("", !0)
            ], 2), [
              [Dd, D.isEditVideoCover]
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      Ja(cR, {
        acpToken: w.acpToken,
        env: w.env,
        sourceTop: w.sourceTop,
        channel: w.channel,
        isShow: D.cropperShow,
        cropUrl: D.cropperUrl,
        autoCropWidth: D.autoCropWidth,
        autoCropHeight: D.autoCropHeight,
        fixedNumber: D.fixedNumber,
        onClose: N[1] || (N[1] = (ae) => D.cropperShow = !1),
        onConfirm: ze
      }, null, 8, ["acpToken", "env", "sourceTop", "channel", "isShow", "cropUrl", "autoCropWidth", "autoCropHeight", "fixedNumber"])
    ], 64));
  }
}), Nie = /* @__PURE__ */ Md(Pie, [["__scopeId", "data-v-101c5426"]]), Iie = {
  props: {
    width: {
      type: String,
      required: !0
    },
    auto: {
      type: Blob,
      default: !0
    },
    warp: {
      type: Blob,
      default: !0
    },
    row: { type: String },
    column: { type: String },
    height: {
      type: String
    }
  },
  data() {
    return {
      observer: null,
      style: {
        width: "100%"
      }
    };
  },
  computed: {},
  mounted() {
    this.observer = new ResizeObserver(() => {
      this.view();
    }), this.observer.observe(this.$refs.grid, {
      box: "border-box"
    });
  },
  beforeUnmount() {
    this.observer.unobserve(this.$refs.grid);
  },
  methods: {
    view() {
      let m = { width: "100%", display: "grid" }, y = parseInt(this.$refs.grid.offsetWidth / this.width);
      if (this.column && (m["grid-column-gap"] = `${this.column}px`, y = parseInt(
        (this.$refs.grid.offsetWidth - y * this.column) / this.width
      )), this.auto ? this.column ? m["grid-template-columns"] = `repeat(${y}, ${(100 - y * this.column / this.$refs.grid.offsetWidth) / y}%)` : m["grid-template-columns"] = `repeat(${y}, ${100 / y}%)` : m["grid-template-columns"] = `repeat(${y}, ${this.width}px)`, this.height && (m["grid-template-rows"] = `repeat(${y}, ${this.height}px)`), this.row && (m["grid-row-gap"] = `${this.row}px`), !this.warp) {
        const w = this.$refs.grid.children.length;
        for (let E = 0; E < w; E++)
          E >= y ? this.$refs.grid.children[E].style.display = "none" : this.$refs.grid.children[E].style.display = "block";
      }
      console.log(m), this.style = m;
    }
  }
};
function Fie(m, y, w, E, P, H) {
  return Dn(), ir("div", {
    class: "grid",
    ref: "grid",
    style: Bd(P.style)
  }, [
    Cu(m.$slots, "default")
  ], 4);
}
const $ie = /* @__PURE__ */ Md(Iie, [["render", Fie]]), Lie = [moe, hoe, Eoe, Ooe, eie, Nie, $ie], Hie = {
  install(m) {
    Lie.forEach((y) => {
      m.component(y.name, y);
    });
  }
};
export {
  moe as ContentEditor,
  $ie as MDGridList,
  Eoe as MDSteps,
  Nie as MediaUploader,
  eie as MultiUploader,
  hoe as TestButton,
  Ooe as Uploader,
  Hie as default
};
